import { defineComponent as H, createBlock as R, openBlock as k, unref as B, withCtx as j, renderSlot as I, computed as se, watch as Ir, h as tt, inject as ce, resolveDynamicComponent as ve, createVNode as z, normalizeClass as q, createElementVNode as O, provide as he, createElementBlock as N, createCommentVNode as K, mergeProps as Ve, Fragment as ye, createTextVNode as ne, resolveComponent as hh, version as qb, renderList as Oe, toDisplayString as _, createStaticVNode as Rr, withModifiers as _c, normalizeProps as $c, guardReactiveProps as Fh, createSlots as bh, mergeModels as yr, useModel as hr, ref as ue, withDirectives as co, vModelDynamic as vh, useId as fo, nextTick as Gb, readonly as cr, reactive as Bh, onMounted as Fr, normalizeStyle as qo, Transition as Co, vModelSelect as Ph, vModelText as Ju, useTemplateRef as wh, onUnmounted as Xb, shallowRef as Ub, vModelRadio as Zb, useSlots as Sd, useAttrs as Kb } from "vue";
import { Disclosure as kh, DisclosureButton as Dh, DisclosurePanel as Sh, DialogTitle as yi, TransitionRoot as Wa, Dialog as Na, TransitionChild as tr, DialogPanel as Va, DialogDescription as _u, Popover as $t, PopoverButton as rr, PopoverPanel as en, ComboboxLabel as Qb, Combobox as Jb, ComboboxInput as _b, ComboboxButton as $b, ComboboxOption as e2, ComboboxOptions as o2, Menu as Ah, MenuButton as eu, MenuItems as Eh, MenuItem as xh, RadioGroupLabel as hi, RadioGroup as Fi, RadioGroupDescription as Ch, RadioGroupOption as bi, ListboxLabel as r2, Listbox as t2, ListboxButton as n2, ListboxOption as a2, ListboxOptions as s2, PopoverGroup as Oh, Switch as i2, SwitchLabel as Th, SwitchGroup as Lh, Tab as jh, TabGroup as l2, TabList as Ad, TabPanel as c2, TabPanels as u2 } from "@headlessui/vue";
import { Link as yo } from "@inertiajs/vue3";
import { instantMeiliSearch as vi } from "@meilisearch/instant-meilisearch";
import { useToggle as Po, whenever as Bi, useDebounceFn as pt, promiseTimeout as $u, useResizeObserver as p2, useEventListener as Mh, useEyeDropper as d2, useStorage as g2, useClipboard as Wh, useElementHover as m2, useFocusWithin as f2, onClickOutside as za, useDropZone as y2, useFileDialog as Nh, useObjectUrl as h2, useTimeoutFn as Ed, watchDebounced as F2 } from "@vueuse/core";
import _r from "dayjs";
import { Float as Vh } from "@headlessui-float/vue";
import { OnClickOutside as b2, vInfiniteScroll as Ia, UseTimeAgo as v2 } from "@vueuse/components";
import { useTippy as B2 } from "vue-tippy";
import { groupBy as P2, isString as xd } from "lodash-es";
import { useEditor as ep, EditorContent as op } from "@tiptap/vue-3";
import rp from "@tiptap/extension-document";
import tp from "@tiptap/extension-text";
import np from "@tiptap/extension-paragraph";
import ap from "@tiptap/extension-bold";
import sp from "@tiptap/extension-italic";
import ip from "@tiptap/extension-underline";
import lp from "@tiptap/extension-strike";
import { TextStyle as w2, FontSize as k2, LineHeight as D2, Color as S2, FontFamily as A2 } from "@tiptap/extension-text-style";
import E2 from "@tiptap/extension-highlight";
import { z as ol } from "zod";
import { Line as x2 } from "vue-chartjs";
import { Chart as C2, Tooltip as O2, LineElement as T2, PointElement as L2, Filler as j2, CategoryScale as M2, LinearScale as W2 } from "chart.js";
import N2 from "@tailwindcss/forms";
import cp from "axios";
import V2 from "@tiptap/extension-placeholder";
const Jz = /* @__PURE__ */ H({
  __name: "Accordion",
  props: {
    defaultOpen: { type: Boolean }
  },
  setup(o) {
    return (e, r) => (k(), R(B(kh), {
      as: "div",
      "default-open": e.defaultOpen
    }, {
      default: j(({ open: t, close: n }) => [
        I(e.$slots, "default", {
          open: t,
          close: n
        })
      ]),
      _: 3
    }, 8, ["default-open"]));
  }
});
function Cd(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function ae(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Cd(Object(r), !0).forEach(function(t) {
      Ye(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : Cd(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function Xs(o) {
  "@babel/helpers - typeof";
  return Xs = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Xs(o);
}
function z2(o, e) {
  if (!(o instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function I2(o, e) {
  for (var r = 0; r < e.length; r++) {
    var t = e[r];
    t.enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(o, t.key, t);
  }
}
function R2(o, e, r) {
  return e && I2(o.prototype, e), Object.defineProperty(o, "prototype", {
    writable: !1
  }), o;
}
function Ye(o, e, r) {
  return e in o ? Object.defineProperty(o, e, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : o[e] = r, o;
}
function up(o, e) {
  return Y2(o) || G2(o, e) || zh(o, e) || U2();
}
function Ra(o) {
  return H2(o) || q2(o) || zh(o) || X2();
}
function H2(o) {
  if (Array.isArray(o)) return ou(o);
}
function Y2(o) {
  if (Array.isArray(o)) return o;
}
function q2(o) {
  if (typeof Symbol < "u" && o[Symbol.iterator] != null || o["@@iterator"] != null) return Array.from(o);
}
function G2(o, e) {
  var r = o == null ? null : typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (r != null) {
    var t = [], n = !0, a = !1, s, i;
    try {
      for (r = r.call(o); !(n = (s = r.next()).done) && (t.push(s.value), !(e && t.length === e)); n = !0)
        ;
    } catch (l) {
      a = !0, i = l;
    } finally {
      try {
        !n && r.return != null && r.return();
      } finally {
        if (a) throw i;
      }
    }
    return t;
  }
}
function zh(o, e) {
  if (o) {
    if (typeof o == "string") return ou(o, e);
    var r = Object.prototype.toString.call(o).slice(8, -1);
    if (r === "Object" && o.constructor && (r = o.constructor.name), r === "Map" || r === "Set") return Array.from(o);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return ou(o, e);
  }
}
function ou(o, e) {
  (e == null || e > o.length) && (e = o.length);
  for (var r = 0, t = new Array(e); r < e; r++) t[r] = o[r];
  return t;
}
function X2() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function U2() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var Od = function() {
}, pp = {}, Ih = {}, Rh = null, Hh = {
  mark: Od,
  measure: Od
};
try {
  typeof window < "u" && (pp = window), typeof document < "u" && (Ih = document), typeof MutationObserver < "u" && (Rh = MutationObserver), typeof performance < "u" && (Hh = performance);
} catch {
}
var Z2 = pp.navigator || {}, Td = Z2.userAgent, Ld = Td === void 0 ? "" : Td, Nr = pp, We = Ih, jd = Rh, rs = Hh;
Nr.document;
var br = !!We.documentElement && !!We.head && typeof We.addEventListener == "function" && typeof We.createElement == "function", Yh = ~Ld.indexOf("MSIE") || ~Ld.indexOf("Trident/"), ts, ns, as, ss, is, dr = "___FONT_AWESOME___", ru = 16, qh = "fa", Gh = "svg-inline--fa", dt = "data-fa-i2svg", tu = "data-fa-pseudo-element", K2 = "data-fa-pseudo-element-pending", dp = "data-prefix", gp = "data-icon", Md = "fontawesome-i2svg", Q2 = "async", J2 = ["HTML", "HEAD", "STYLE", "SCRIPT"], Xh = function() {
  try {
    return process.env.NODE_ENV === "production";
  } catch {
    return !1;
  }
}(), Me = "classic", ze = "sharp", mp = [Me, ze];
function Ha(o) {
  return new Proxy(o, {
    get: function(r, t) {
      return t in r ? r[t] : r[Me];
    }
  });
}
var Tn = Ha((ts = {}, Ye(ts, Me, {
  fa: "solid",
  fas: "solid",
  "fa-solid": "solid",
  far: "regular",
  "fa-regular": "regular",
  fal: "light",
  "fa-light": "light",
  fat: "thin",
  "fa-thin": "thin",
  fad: "duotone",
  "fa-duotone": "duotone",
  fab: "brands",
  "fa-brands": "brands",
  fak: "kit",
  fakd: "kit",
  "fa-kit": "kit",
  "fa-kit-duotone": "kit"
}), Ye(ts, ze, {
  fa: "solid",
  fass: "solid",
  "fa-solid": "solid",
  fasr: "regular",
  "fa-regular": "regular",
  fasl: "light",
  "fa-light": "light",
  fast: "thin",
  "fa-thin": "thin"
}), ts)), Ln = Ha((ns = {}, Ye(ns, Me, {
  solid: "fas",
  regular: "far",
  light: "fal",
  thin: "fat",
  duotone: "fad",
  brands: "fab",
  kit: "fak"
}), Ye(ns, ze, {
  solid: "fass",
  regular: "fasr",
  light: "fasl",
  thin: "fast"
}), ns)), jn = Ha((as = {}, Ye(as, Me, {
  fab: "fa-brands",
  fad: "fa-duotone",
  fak: "fa-kit",
  fal: "fa-light",
  far: "fa-regular",
  fas: "fa-solid",
  fat: "fa-thin"
}), Ye(as, ze, {
  fass: "fa-solid",
  fasr: "fa-regular",
  fasl: "fa-light",
  fast: "fa-thin"
}), as)), _2 = Ha((ss = {}, Ye(ss, Me, {
  "fa-brands": "fab",
  "fa-duotone": "fad",
  "fa-kit": "fak",
  "fa-light": "fal",
  "fa-regular": "far",
  "fa-solid": "fas",
  "fa-thin": "fat"
}), Ye(ss, ze, {
  "fa-solid": "fass",
  "fa-regular": "fasr",
  "fa-light": "fasl",
  "fa-thin": "fast"
}), ss)), $2 = /fa(s|r|l|t|d|b|k|ss|sr|sl|st)?[\-\ ]/, Uh = "fa-layers-text", ev = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Sharp|Kit)?.*/i, ov = Ha((is = {}, Ye(is, Me, {
  900: "fas",
  400: "far",
  normal: "far",
  300: "fal",
  100: "fat"
}), Ye(is, ze, {
  900: "fass",
  400: "fasr",
  300: "fasl",
  100: "fast"
}), is)), Zh = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10], rv = Zh.concat([11, 12, 13, 14, 15, 16, 17, 18, 19, 20]), tv = ["class", "data-prefix", "data-icon", "data-fa-transform", "data-fa-mask"], et = {
  GROUP: "duotone-group",
  SWAP_OPACITY: "swap-opacity",
  PRIMARY: "primary",
  SECONDARY: "secondary"
}, Mn = /* @__PURE__ */ new Set();
Object.keys(Ln[Me]).map(Mn.add.bind(Mn));
Object.keys(Ln[ze]).map(Mn.add.bind(Mn));
var nv = [].concat(mp, Ra(Mn), ["2xs", "xs", "sm", "lg", "xl", "2xl", "beat", "border", "fade", "beat-fade", "bounce", "flip-both", "flip-horizontal", "flip-vertical", "flip", "fw", "inverse", "layers-counter", "layers-text", "layers", "li", "pull-left", "pull-right", "pulse", "rotate-180", "rotate-270", "rotate-90", "rotate-by", "shake", "spin-pulse", "spin-reverse", "spin", "stack-1x", "stack-2x", "stack", "ul", et.GROUP, et.SWAP_OPACITY, et.PRIMARY, et.SECONDARY]).concat(Zh.map(function(o) {
  return "".concat(o, "x");
})).concat(rv.map(function(o) {
  return "w-".concat(o);
})), kn = Nr.FontAwesomeConfig || {};
function av(o) {
  var e = We.querySelector("script[" + o + "]");
  if (e)
    return e.getAttribute(o);
}
function sv(o) {
  return o === "" ? !0 : o === "false" ? !1 : o === "true" ? !0 : o;
}
if (We && typeof We.querySelector == "function") {
  var iv = [["data-family-prefix", "familyPrefix"], ["data-css-prefix", "cssPrefix"], ["data-family-default", "familyDefault"], ["data-style-default", "styleDefault"], ["data-replacement-class", "replacementClass"], ["data-auto-replace-svg", "autoReplaceSvg"], ["data-auto-add-css", "autoAddCss"], ["data-auto-a11y", "autoA11y"], ["data-search-pseudo-elements", "searchPseudoElements"], ["data-observe-mutations", "observeMutations"], ["data-mutate-approach", "mutateApproach"], ["data-keep-original-source", "keepOriginalSource"], ["data-measure-performance", "measurePerformance"], ["data-show-missing-icons", "showMissingIcons"]];
  iv.forEach(function(o) {
    var e = up(o, 2), r = e[0], t = e[1], n = sv(av(r));
    n != null && (kn[t] = n);
  });
}
var Kh = {
  styleDefault: "solid",
  familyDefault: "classic",
  cssPrefix: qh,
  replacementClass: Gh,
  autoReplaceSvg: !0,
  autoAddCss: !0,
  autoA11y: !0,
  searchPseudoElements: !1,
  observeMutations: !0,
  mutateApproach: "async",
  keepOriginalSource: !0,
  measurePerformance: !1,
  showMissingIcons: !0
};
kn.familyPrefix && (kn.cssPrefix = kn.familyPrefix);
var Ht = ae(ae({}, Kh), kn);
Ht.autoReplaceSvg || (Ht.observeMutations = !1);
var ie = {};
Object.keys(Kh).forEach(function(o) {
  Object.defineProperty(ie, o, {
    enumerable: !0,
    set: function(r) {
      Ht[o] = r, Dn.forEach(function(t) {
        return t(ie);
      });
    },
    get: function() {
      return Ht[o];
    }
  });
});
Object.defineProperty(ie, "familyPrefix", {
  enumerable: !0,
  set: function(e) {
    Ht.cssPrefix = e, Dn.forEach(function(r) {
      return r(ie);
    });
  },
  get: function() {
    return Ht.cssPrefix;
  }
});
Nr.FontAwesomeConfig = ie;
var Dn = [];
function lv(o) {
  return Dn.push(o), function() {
    Dn.splice(Dn.indexOf(o), 1);
  };
}
var kt = ru, er = {
  size: 16,
  x: 0,
  y: 0,
  rotate: 0,
  flipX: !1,
  flipY: !1
};
function cv(o) {
  if (!(!o || !br)) {
    var e = We.createElement("style");
    e.setAttribute("type", "text/css"), e.innerHTML = o;
    for (var r = We.head.childNodes, t = null, n = r.length - 1; n > -1; n--) {
      var a = r[n], s = (a.tagName || "").toUpperCase();
      ["STYLE", "LINK"].indexOf(s) > -1 && (t = a);
    }
    return We.head.insertBefore(e, t), o;
  }
}
var uv = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
function Wn() {
  for (var o = 12, e = ""; o-- > 0; )
    e += uv[Math.random() * 62 | 0];
  return e;
}
function on(o) {
  for (var e = [], r = (o || []).length >>> 0; r--; )
    e[r] = o[r];
  return e;
}
function fp(o) {
  return o.classList ? on(o.classList) : (o.getAttribute("class") || "").split(" ").filter(function(e) {
    return e;
  });
}
function Qh(o) {
  return "".concat(o).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function pv(o) {
  return Object.keys(o || {}).reduce(function(e, r) {
    return e + "".concat(r, '="').concat(Qh(o[r]), '" ');
  }, "").trim();
}
function Pi(o) {
  return Object.keys(o || {}).reduce(function(e, r) {
    return e + "".concat(r, ": ").concat(o[r].trim(), ";");
  }, "");
}
function yp(o) {
  return o.size !== er.size || o.x !== er.x || o.y !== er.y || o.rotate !== er.rotate || o.flipX || o.flipY;
}
function dv(o) {
  var e = o.transform, r = o.containerWidth, t = o.iconWidth, n = {
    transform: "translate(".concat(r / 2, " 256)")
  }, a = "translate(".concat(e.x * 32, ", ").concat(e.y * 32, ") "), s = "scale(".concat(e.size / 16 * (e.flipX ? -1 : 1), ", ").concat(e.size / 16 * (e.flipY ? -1 : 1), ") "), i = "rotate(".concat(e.rotate, " 0 0)"), l = {
    transform: "".concat(a, " ").concat(s, " ").concat(i)
  }, c = {
    transform: "translate(".concat(t / 2 * -1, " -256)")
  };
  return {
    outer: n,
    inner: l,
    path: c
  };
}
function gv(o) {
  var e = o.transform, r = o.width, t = r === void 0 ? ru : r, n = o.height, a = n === void 0 ? ru : n, s = "";
  return Yh ? s += "translate(".concat(e.x / kt - t / 2, "em, ").concat(e.y / kt - a / 2, "em) ") : s += "translate(calc(-50% + ".concat(e.x / kt, "em), calc(-50% + ").concat(e.y / kt, "em)) "), s += "scale(".concat(e.size / kt * (e.flipX ? -1 : 1), ", ").concat(e.size / kt * (e.flipY ? -1 : 1), ") "), s += "rotate(".concat(e.rotate, "deg) "), s;
}
var mv = `:root, :host {
  --fa-font-solid: normal 900 1em/1 "Font Awesome 6 Solid";
  --fa-font-regular: normal 400 1em/1 "Font Awesome 6 Regular";
  --fa-font-light: normal 300 1em/1 "Font Awesome 6 Light";
  --fa-font-thin: normal 100 1em/1 "Font Awesome 6 Thin";
  --fa-font-duotone: normal 900 1em/1 "Font Awesome 6 Duotone";
  --fa-font-sharp-solid: normal 900 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-regular: normal 400 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-light: normal 300 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-thin: normal 100 1em/1 "Font Awesome 6 Sharp";
  --fa-font-brands: normal 400 1em/1 "Font Awesome 6 Brands";
}

svg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {
  overflow: visible;
  box-sizing: content-box;
}

.svg-inline--fa {
  display: var(--fa-display, inline-block);
  height: 1em;
  overflow: visible;
  vertical-align: -0.125em;
}
.svg-inline--fa.fa-2xs {
  vertical-align: 0.1em;
}
.svg-inline--fa.fa-xs {
  vertical-align: 0em;
}
.svg-inline--fa.fa-sm {
  vertical-align: -0.0714285705em;
}
.svg-inline--fa.fa-lg {
  vertical-align: -0.2em;
}
.svg-inline--fa.fa-xl {
  vertical-align: -0.25em;
}
.svg-inline--fa.fa-2xl {
  vertical-align: -0.3125em;
}
.svg-inline--fa.fa-pull-left {
  margin-right: var(--fa-pull-margin, 0.3em);
  width: auto;
}
.svg-inline--fa.fa-pull-right {
  margin-left: var(--fa-pull-margin, 0.3em);
  width: auto;
}
.svg-inline--fa.fa-li {
  width: var(--fa-li-width, 2em);
  top: 0.25em;
}
.svg-inline--fa.fa-fw {
  width: var(--fa-fw-width, 1.25em);
}

.fa-layers svg.svg-inline--fa {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
}

.fa-layers-counter, .fa-layers-text {
  display: inline-block;
  position: absolute;
  text-align: center;
}

.fa-layers {
  display: inline-block;
  height: 1em;
  position: relative;
  text-align: center;
  vertical-align: -0.125em;
  width: 1em;
}
.fa-layers svg.svg-inline--fa {
  -webkit-transform-origin: center center;
          transform-origin: center center;
}

.fa-layers-text {
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
          transform: translate(-50%, -50%);
  -webkit-transform-origin: center center;
          transform-origin: center center;
}

.fa-layers-counter {
  background-color: var(--fa-counter-background-color, #ff253a);
  border-radius: var(--fa-counter-border-radius, 1em);
  box-sizing: border-box;
  color: var(--fa-inverse, #fff);
  line-height: var(--fa-counter-line-height, 1);
  max-width: var(--fa-counter-max-width, 5em);
  min-width: var(--fa-counter-min-width, 1.5em);
  overflow: hidden;
  padding: var(--fa-counter-padding, 0.25em 0.5em);
  right: var(--fa-right, 0);
  text-overflow: ellipsis;
  top: var(--fa-top, 0);
  -webkit-transform: scale(var(--fa-counter-scale, 0.25));
          transform: scale(var(--fa-counter-scale, 0.25));
  -webkit-transform-origin: top right;
          transform-origin: top right;
}

.fa-layers-bottom-right {
  bottom: var(--fa-bottom, 0);
  right: var(--fa-right, 0);
  top: auto;
  -webkit-transform: scale(var(--fa-layers-scale, 0.25));
          transform: scale(var(--fa-layers-scale, 0.25));
  -webkit-transform-origin: bottom right;
          transform-origin: bottom right;
}

.fa-layers-bottom-left {
  bottom: var(--fa-bottom, 0);
  left: var(--fa-left, 0);
  right: auto;
  top: auto;
  -webkit-transform: scale(var(--fa-layers-scale, 0.25));
          transform: scale(var(--fa-layers-scale, 0.25));
  -webkit-transform-origin: bottom left;
          transform-origin: bottom left;
}

.fa-layers-top-right {
  top: var(--fa-top, 0);
  right: var(--fa-right, 0);
  -webkit-transform: scale(var(--fa-layers-scale, 0.25));
          transform: scale(var(--fa-layers-scale, 0.25));
  -webkit-transform-origin: top right;
          transform-origin: top right;
}

.fa-layers-top-left {
  left: var(--fa-left, 0);
  right: auto;
  top: var(--fa-top, 0);
  -webkit-transform: scale(var(--fa-layers-scale, 0.25));
          transform: scale(var(--fa-layers-scale, 0.25));
  -webkit-transform-origin: top left;
          transform-origin: top left;
}

.fa-1x {
  font-size: 1em;
}

.fa-2x {
  font-size: 2em;
}

.fa-3x {
  font-size: 3em;
}

.fa-4x {
  font-size: 4em;
}

.fa-5x {
  font-size: 5em;
}

.fa-6x {
  font-size: 6em;
}

.fa-7x {
  font-size: 7em;
}

.fa-8x {
  font-size: 8em;
}

.fa-9x {
  font-size: 9em;
}

.fa-10x {
  font-size: 10em;
}

.fa-2xs {
  font-size: 0.625em;
  line-height: 0.1em;
  vertical-align: 0.225em;
}

.fa-xs {
  font-size: 0.75em;
  line-height: 0.0833333337em;
  vertical-align: 0.125em;
}

.fa-sm {
  font-size: 0.875em;
  line-height: 0.0714285718em;
  vertical-align: 0.0535714295em;
}

.fa-lg {
  font-size: 1.25em;
  line-height: 0.05em;
  vertical-align: -0.075em;
}

.fa-xl {
  font-size: 1.5em;
  line-height: 0.0416666682em;
  vertical-align: -0.125em;
}

.fa-2xl {
  font-size: 2em;
  line-height: 0.03125em;
  vertical-align: -0.1875em;
}

.fa-fw {
  text-align: center;
  width: 1.25em;
}

.fa-ul {
  list-style-type: none;
  margin-left: var(--fa-li-margin, 2.5em);
  padding-left: 0;
}
.fa-ul > li {
  position: relative;
}

.fa-li {
  left: calc(var(--fa-li-width, 2em) * -1);
  position: absolute;
  text-align: center;
  width: var(--fa-li-width, 2em);
  line-height: inherit;
}

.fa-border {
  border-color: var(--fa-border-color, #eee);
  border-radius: var(--fa-border-radius, 0.1em);
  border-style: var(--fa-border-style, solid);
  border-width: var(--fa-border-width, 0.08em);
  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);
}

.fa-pull-left {
  float: left;
  margin-right: var(--fa-pull-margin, 0.3em);
}

.fa-pull-right {
  float: right;
  margin-left: var(--fa-pull-margin, 0.3em);
}

.fa-beat {
  -webkit-animation-name: fa-beat;
          animation-name: fa-beat;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);
          animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-bounce {
  -webkit-animation-name: fa-bounce;
          animation-name: fa-bounce;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));
          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));
}

.fa-fade {
  -webkit-animation-name: fa-fade;
          animation-name: fa-fade;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-beat-fade {
  -webkit-animation-name: fa-beat-fade;
          animation-name: fa-beat-fade;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-flip {
  -webkit-animation-name: fa-flip;
          animation-name: fa-flip;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);
          animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-shake {
  -webkit-animation-name: fa-shake;
          animation-name: fa-shake;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, linear);
          animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin {
  -webkit-animation-name: fa-spin;
          animation-name: fa-spin;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 2s);
          animation-duration: var(--fa-animation-duration, 2s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, linear);
          animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin-reverse {
  --fa-animation-direction: reverse;
}

.fa-pulse,
.fa-spin-pulse {
  -webkit-animation-name: fa-spin;
          animation-name: fa-spin;
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, steps(8));
          animation-timing-function: var(--fa-animation-timing, steps(8));
}

@media (prefers-reduced-motion: reduce) {
  .fa-beat,
.fa-bounce,
.fa-fade,
.fa-beat-fade,
.fa-flip,
.fa-pulse,
.fa-shake,
.fa-spin,
.fa-spin-pulse {
    -webkit-animation-delay: -1ms;
            animation-delay: -1ms;
    -webkit-animation-duration: 1ms;
            animation-duration: 1ms;
    -webkit-animation-iteration-count: 1;
            animation-iteration-count: 1;
    -webkit-transition-delay: 0s;
            transition-delay: 0s;
    -webkit-transition-duration: 0s;
            transition-duration: 0s;
  }
}
@-webkit-keyframes fa-beat {
  0%, 90% {
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  45% {
    -webkit-transform: scale(var(--fa-beat-scale, 1.25));
            transform: scale(var(--fa-beat-scale, 1.25));
  }
}
@keyframes fa-beat {
  0%, 90% {
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  45% {
    -webkit-transform: scale(var(--fa-beat-scale, 1.25));
            transform: scale(var(--fa-beat-scale, 1.25));
  }
}
@-webkit-keyframes fa-bounce {
  0% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
  10% {
    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
  }
  30% {
    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
  }
  50% {
    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
  }
  57% {
    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
  }
  64% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
  100% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
}
@keyframes fa-bounce {
  0% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
  10% {
    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
  }
  30% {
    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
  }
  50% {
    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
  }
  57% {
    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
  }
  64% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
  100% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
}
@-webkit-keyframes fa-fade {
  50% {
    opacity: var(--fa-fade-opacity, 0.4);
  }
}
@keyframes fa-fade {
  50% {
    opacity: var(--fa-fade-opacity, 0.4);
  }
}
@-webkit-keyframes fa-beat-fade {
  0%, 100% {
    opacity: var(--fa-beat-fade-opacity, 0.4);
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  50% {
    opacity: 1;
    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));
            transform: scale(var(--fa-beat-fade-scale, 1.125));
  }
}
@keyframes fa-beat-fade {
  0%, 100% {
    opacity: var(--fa-beat-fade-opacity, 0.4);
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  50% {
    opacity: 1;
    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));
            transform: scale(var(--fa-beat-fade-scale, 1.125));
  }
}
@-webkit-keyframes fa-flip {
  50% {
    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
  }
}
@keyframes fa-flip {
  50% {
    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
  }
}
@-webkit-keyframes fa-shake {
  0% {
    -webkit-transform: rotate(-15deg);
            transform: rotate(-15deg);
  }
  4% {
    -webkit-transform: rotate(15deg);
            transform: rotate(15deg);
  }
  8%, 24% {
    -webkit-transform: rotate(-18deg);
            transform: rotate(-18deg);
  }
  12%, 28% {
    -webkit-transform: rotate(18deg);
            transform: rotate(18deg);
  }
  16% {
    -webkit-transform: rotate(-22deg);
            transform: rotate(-22deg);
  }
  20% {
    -webkit-transform: rotate(22deg);
            transform: rotate(22deg);
  }
  32% {
    -webkit-transform: rotate(-12deg);
            transform: rotate(-12deg);
  }
  36% {
    -webkit-transform: rotate(12deg);
            transform: rotate(12deg);
  }
  40%, 100% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
}
@keyframes fa-shake {
  0% {
    -webkit-transform: rotate(-15deg);
            transform: rotate(-15deg);
  }
  4% {
    -webkit-transform: rotate(15deg);
            transform: rotate(15deg);
  }
  8%, 24% {
    -webkit-transform: rotate(-18deg);
            transform: rotate(-18deg);
  }
  12%, 28% {
    -webkit-transform: rotate(18deg);
            transform: rotate(18deg);
  }
  16% {
    -webkit-transform: rotate(-22deg);
            transform: rotate(-22deg);
  }
  20% {
    -webkit-transform: rotate(22deg);
            transform: rotate(22deg);
  }
  32% {
    -webkit-transform: rotate(-12deg);
            transform: rotate(-12deg);
  }
  36% {
    -webkit-transform: rotate(12deg);
            transform: rotate(12deg);
  }
  40%, 100% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
}
@-webkit-keyframes fa-spin {
  0% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
  }
}
@keyframes fa-spin {
  0% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
  }
}
.fa-rotate-90 {
  -webkit-transform: rotate(90deg);
          transform: rotate(90deg);
}

.fa-rotate-180 {
  -webkit-transform: rotate(180deg);
          transform: rotate(180deg);
}

.fa-rotate-270 {
  -webkit-transform: rotate(270deg);
          transform: rotate(270deg);
}

.fa-flip-horizontal {
  -webkit-transform: scale(-1, 1);
          transform: scale(-1, 1);
}

.fa-flip-vertical {
  -webkit-transform: scale(1, -1);
          transform: scale(1, -1);
}

.fa-flip-both,
.fa-flip-horizontal.fa-flip-vertical {
  -webkit-transform: scale(-1, -1);
          transform: scale(-1, -1);
}

.fa-rotate-by {
  -webkit-transform: rotate(var(--fa-rotate-angle, none));
          transform: rotate(var(--fa-rotate-angle, none));
}

.fa-stack {
  display: inline-block;
  vertical-align: middle;
  height: 2em;
  position: relative;
  width: 2.5em;
}

.fa-stack-1x,
.fa-stack-2x {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
  z-index: var(--fa-stack-z-index, auto);
}

.svg-inline--fa.fa-stack-1x {
  height: 1em;
  width: 1.25em;
}
.svg-inline--fa.fa-stack-2x {
  height: 2em;
  width: 2.5em;
}

.fa-inverse {
  color: var(--fa-inverse, #fff);
}

.sr-only,
.fa-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.sr-only-focusable:not(:focus),
.fa-sr-only-focusable:not(:focus) {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.svg-inline--fa .fa-primary {
  fill: var(--fa-primary-color, currentColor);
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa .fa-secondary {
  fill: var(--fa-secondary-color, currentColor);
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-primary {
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-secondary {
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa mask .fa-primary,
.svg-inline--fa mask .fa-secondary {
  fill: black;
}

.fad.fa-inverse,
.fa-duotone.fa-inverse {
  color: var(--fa-inverse, #fff);
}`;
function Jh() {
  var o = qh, e = Gh, r = ie.cssPrefix, t = ie.replacementClass, n = mv;
  if (r !== o || t !== e) {
    var a = new RegExp("\\.".concat(o, "\\-"), "g"), s = new RegExp("\\--".concat(o, "\\-"), "g"), i = new RegExp("\\.".concat(e), "g");
    n = n.replace(a, ".".concat(r, "-")).replace(s, "--".concat(r, "-")).replace(i, ".".concat(t));
  }
  return n;
}
var Wd = !1;
function rl() {
  ie.autoAddCss && !Wd && (cv(Jh()), Wd = !0);
}
var fv = {
  mixout: function() {
    return {
      dom: {
        css: Jh,
        insertCss: rl
      }
    };
  },
  hooks: function() {
    return {
      beforeDOMElementCreation: function() {
        rl();
      },
      beforeI2svg: function() {
        rl();
      }
    };
  }
}, gr = Nr || {};
gr[dr] || (gr[dr] = {});
gr[dr].styles || (gr[dr].styles = {});
gr[dr].hooks || (gr[dr].hooks = {});
gr[dr].shims || (gr[dr].shims = []);
var Ho = gr[dr], _h = [], yv = function o() {
  We.removeEventListener("DOMContentLoaded", o), Us = 1, _h.map(function(e) {
    return e();
  });
}, Us = !1;
br && (Us = (We.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(We.readyState), Us || We.addEventListener("DOMContentLoaded", yv));
function hv(o) {
  br && (Us ? setTimeout(o, 0) : _h.push(o));
}
function Ya(o) {
  var e = o.tag, r = o.attributes, t = r === void 0 ? {} : r, n = o.children, a = n === void 0 ? [] : n;
  return typeof o == "string" ? Qh(o) : "<".concat(e, " ").concat(pv(t), ">").concat(a.map(Ya).join(""), "</").concat(e, ">");
}
function Nd(o, e, r) {
  if (o && o[e] && o[e][r])
    return {
      prefix: e,
      iconName: r,
      icon: o[e][r]
    };
}
var tl = function(e, r, t, n) {
  var a = Object.keys(e), s = a.length, i = r, l, c, u;
  for (t === void 0 ? (l = 1, u = e[a[0]]) : (l = 0, u = t); l < s; l++)
    c = a[l], u = i(u, e[c], c, e);
  return u;
};
function Fv(o) {
  for (var e = [], r = 0, t = o.length; r < t; ) {
    var n = o.charCodeAt(r++);
    if (n >= 55296 && n <= 56319 && r < t) {
      var a = o.charCodeAt(r++);
      (a & 64512) == 56320 ? e.push(((n & 1023) << 10) + (a & 1023) + 65536) : (e.push(n), r--);
    } else
      e.push(n);
  }
  return e;
}
function nu(o) {
  var e = Fv(o);
  return e.length === 1 ? e[0].toString(16) : null;
}
function bv(o, e) {
  var r = o.length, t = o.charCodeAt(e), n;
  return t >= 55296 && t <= 56319 && r > e + 1 && (n = o.charCodeAt(e + 1), n >= 56320 && n <= 57343) ? (t - 55296) * 1024 + n - 56320 + 65536 : t;
}
function Vd(o) {
  return Object.keys(o).reduce(function(e, r) {
    var t = o[r], n = !!t.icon;
    return n ? e[t.iconName] = t.icon : e[r] = t, e;
  }, {});
}
function au(o, e) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, t = r.skipHooks, n = t === void 0 ? !1 : t, a = Vd(e);
  typeof Ho.hooks.addPack == "function" && !n ? Ho.hooks.addPack(o, Vd(e)) : Ho.styles[o] = ae(ae({}, Ho.styles[o] || {}), a), o === "fas" && au("fa", e);
}
var ls, cs, us, jt = Ho.styles, vv = Ho.shims, Bv = (ls = {}, Ye(ls, Me, Object.values(jn[Me])), Ye(ls, ze, Object.values(jn[ze])), ls), hp = null, $h = {}, e1 = {}, o1 = {}, r1 = {}, t1 = {}, Pv = (cs = {}, Ye(cs, Me, Object.keys(Tn[Me])), Ye(cs, ze, Object.keys(Tn[ze])), cs);
function wv(o) {
  return ~nv.indexOf(o);
}
function kv(o, e) {
  var r = e.split("-"), t = r[0], n = r.slice(1).join("-");
  return t === o && n !== "" && !wv(n) ? n : null;
}
var n1 = function() {
  var e = function(a) {
    return tl(jt, function(s, i, l) {
      return s[l] = tl(i, a, {}), s;
    }, {});
  };
  $h = e(function(n, a, s) {
    if (a[3] && (n[a[3]] = s), a[2]) {
      var i = a[2].filter(function(l) {
        return typeof l == "number";
      });
      i.forEach(function(l) {
        n[l.toString(16)] = s;
      });
    }
    return n;
  }), e1 = e(function(n, a, s) {
    if (n[s] = s, a[2]) {
      var i = a[2].filter(function(l) {
        return typeof l == "string";
      });
      i.forEach(function(l) {
        n[l] = s;
      });
    }
    return n;
  }), t1 = e(function(n, a, s) {
    var i = a[2];
    return n[s] = s, i.forEach(function(l) {
      n[l] = s;
    }), n;
  });
  var r = "far" in jt || ie.autoFetchSvg, t = tl(vv, function(n, a) {
    var s = a[0], i = a[1], l = a[2];
    return i === "far" && !r && (i = "fas"), typeof s == "string" && (n.names[s] = {
      prefix: i,
      iconName: l
    }), typeof s == "number" && (n.unicodes[s.toString(16)] = {
      prefix: i,
      iconName: l
    }), n;
  }, {
    names: {},
    unicodes: {}
  });
  o1 = t.names, r1 = t.unicodes, hp = wi(ie.styleDefault, {
    family: ie.familyDefault
  });
};
lv(function(o) {
  hp = wi(o.styleDefault, {
    family: ie.familyDefault
  });
});
n1();
function Fp(o, e) {
  return ($h[o] || {})[e];
}
function Dv(o, e) {
  return (e1[o] || {})[e];
}
function ot(o, e) {
  return (t1[o] || {})[e];
}
function a1(o) {
  return o1[o] || {
    prefix: null,
    iconName: null
  };
}
function Sv(o) {
  var e = r1[o], r = Fp("fas", o);
  return e || (r ? {
    prefix: "fas",
    iconName: r
  } : null) || {
    prefix: null,
    iconName: null
  };
}
function Vr() {
  return hp;
}
var bp = function() {
  return {
    prefix: null,
    iconName: null,
    rest: []
  };
};
function wi(o) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = e.family, t = r === void 0 ? Me : r, n = Tn[t][o], a = Ln[t][o] || Ln[t][n], s = o in Ho.styles ? o : null;
  return a || s || null;
}
var zd = (us = {}, Ye(us, Me, Object.keys(jn[Me])), Ye(us, ze, Object.keys(jn[ze])), us);
function ki(o) {
  var e, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = r.skipLookups, n = t === void 0 ? !1 : t, a = (e = {}, Ye(e, Me, "".concat(ie.cssPrefix, "-").concat(Me)), Ye(e, ze, "".concat(ie.cssPrefix, "-").concat(ze)), e), s = null, i = Me;
  (o.includes(a[Me]) || o.some(function(c) {
    return zd[Me].includes(c);
  })) && (i = Me), (o.includes(a[ze]) || o.some(function(c) {
    return zd[ze].includes(c);
  })) && (i = ze);
  var l = o.reduce(function(c, u) {
    var f = kv(ie.cssPrefix, u);
    if (jt[u] ? (u = Bv[i].includes(u) ? _2[i][u] : u, s = u, c.prefix = u) : Pv[i].indexOf(u) > -1 ? (s = u, c.prefix = wi(u, {
      family: i
    })) : f ? c.iconName = f : u !== ie.replacementClass && u !== a[Me] && u !== a[ze] && c.rest.push(u), !n && c.prefix && c.iconName) {
      var g = s === "fa" ? a1(c.iconName) : {}, d = ot(c.prefix, c.iconName);
      g.prefix && (s = null), c.iconName = g.iconName || d || c.iconName, c.prefix = g.prefix || c.prefix, c.prefix === "far" && !jt.far && jt.fas && !ie.autoFetchSvg && (c.prefix = "fas");
    }
    return c;
  }, bp());
  return (o.includes("fa-brands") || o.includes("fab")) && (l.prefix = "fab"), (o.includes("fa-duotone") || o.includes("fad")) && (l.prefix = "fad"), !l.prefix && i === ze && (jt.fass || ie.autoFetchSvg) && (l.prefix = "fass", l.iconName = ot(l.prefix, l.iconName) || l.iconName), (l.prefix === "fa" || s === "fa") && (l.prefix = Vr() || "fas"), l;
}
var Av = /* @__PURE__ */ function() {
  function o() {
    z2(this, o), this.definitions = {};
  }
  return R2(o, [{
    key: "add",
    value: function() {
      for (var r = this, t = arguments.length, n = new Array(t), a = 0; a < t; a++)
        n[a] = arguments[a];
      var s = n.reduce(this._pullDefinitions, {});
      Object.keys(s).forEach(function(i) {
        r.definitions[i] = ae(ae({}, r.definitions[i] || {}), s[i]), au(i, s[i]);
        var l = jn[Me][i];
        l && au(l, s[i]), n1();
      });
    }
  }, {
    key: "reset",
    value: function() {
      this.definitions = {};
    }
  }, {
    key: "_pullDefinitions",
    value: function(r, t) {
      var n = t.prefix && t.iconName && t.icon ? {
        0: t
      } : t;
      return Object.keys(n).map(function(a) {
        var s = n[a], i = s.prefix, l = s.iconName, c = s.icon, u = c[2];
        r[i] || (r[i] = {}), u.length > 0 && u.forEach(function(f) {
          typeof f == "string" && (r[i][f] = c);
        }), r[i][l] = c;
      }), r;
    }
  }]), o;
}(), Id = [], Mt = {}, Vt = {}, Ev = Object.keys(Vt);
function xv(o, e) {
  var r = e.mixoutsTo;
  return Id = o, Mt = {}, Object.keys(Vt).forEach(function(t) {
    Ev.indexOf(t) === -1 && delete Vt[t];
  }), Id.forEach(function(t) {
    var n = t.mixout ? t.mixout() : {};
    if (Object.keys(n).forEach(function(s) {
      typeof n[s] == "function" && (r[s] = n[s]), Xs(n[s]) === "object" && Object.keys(n[s]).forEach(function(i) {
        r[s] || (r[s] = {}), r[s][i] = n[s][i];
      });
    }), t.hooks) {
      var a = t.hooks();
      Object.keys(a).forEach(function(s) {
        Mt[s] || (Mt[s] = []), Mt[s].push(a[s]);
      });
    }
    t.provides && t.provides(Vt);
  }), r;
}
function su(o, e) {
  for (var r = arguments.length, t = new Array(r > 2 ? r - 2 : 0), n = 2; n < r; n++)
    t[n - 2] = arguments[n];
  var a = Mt[o] || [];
  return a.forEach(function(s) {
    e = s.apply(null, [e].concat(t));
  }), e;
}
function gt(o) {
  for (var e = arguments.length, r = new Array(e > 1 ? e - 1 : 0), t = 1; t < e; t++)
    r[t - 1] = arguments[t];
  var n = Mt[o] || [];
  n.forEach(function(a) {
    a.apply(null, r);
  });
}
function mr() {
  var o = arguments[0], e = Array.prototype.slice.call(arguments, 1);
  return Vt[o] ? Vt[o].apply(null, e) : void 0;
}
function iu(o) {
  o.prefix === "fa" && (o.prefix = "fas");
  var e = o.iconName, r = o.prefix || Vr();
  if (e)
    return e = ot(r, e) || e, Nd(s1.definitions, r, e) || Nd(Ho.styles, r, e);
}
var s1 = new Av(), Cv = function() {
  ie.autoReplaceSvg = !1, ie.observeMutations = !1, gt("noAuto");
}, Ov = {
  i2svg: function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return br ? (gt("beforeI2svg", e), mr("pseudoElements2svg", e), mr("i2svg", e)) : Promise.reject("Operation requires a DOM of some kind.");
  },
  watch: function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = e.autoReplaceSvgRoot;
    ie.autoReplaceSvg === !1 && (ie.autoReplaceSvg = !0), ie.observeMutations = !0, hv(function() {
      Lv({
        autoReplaceSvgRoot: r
      }), gt("watch", e);
    });
  }
}, Tv = {
  icon: function(e) {
    if (e === null)
      return null;
    if (Xs(e) === "object" && e.prefix && e.iconName)
      return {
        prefix: e.prefix,
        iconName: ot(e.prefix, e.iconName) || e.iconName
      };
    if (Array.isArray(e) && e.length === 2) {
      var r = e[1].indexOf("fa-") === 0 ? e[1].slice(3) : e[1], t = wi(e[0]);
      return {
        prefix: t,
        iconName: ot(t, r) || r
      };
    }
    if (typeof e == "string" && (e.indexOf("".concat(ie.cssPrefix, "-")) > -1 || e.match($2))) {
      var n = ki(e.split(" "), {
        skipLookups: !0
      });
      return {
        prefix: n.prefix || Vr(),
        iconName: ot(n.prefix, n.iconName) || n.iconName
      };
    }
    if (typeof e == "string") {
      var a = Vr();
      return {
        prefix: a,
        iconName: ot(a, e) || e
      };
    }
  }
}, Oo = {
  noAuto: Cv,
  config: ie,
  dom: Ov,
  parse: Tv,
  library: s1,
  findIconDefinition: iu,
  toHtml: Ya
}, Lv = function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = e.autoReplaceSvgRoot, t = r === void 0 ? We : r;
  (Object.keys(Ho.styles).length > 0 || ie.autoFetchSvg) && br && ie.autoReplaceSvg && Oo.dom.i2svg({
    node: t
  });
};
function Di(o, e) {
  return Object.defineProperty(o, "abstract", {
    get: e
  }), Object.defineProperty(o, "html", {
    get: function() {
      return o.abstract.map(function(t) {
        return Ya(t);
      });
    }
  }), Object.defineProperty(o, "node", {
    get: function() {
      if (br) {
        var t = We.createElement("div");
        return t.innerHTML = o.html, t.children;
      }
    }
  }), o;
}
function jv(o) {
  var e = o.children, r = o.main, t = o.mask, n = o.attributes, a = o.styles, s = o.transform;
  if (yp(s) && r.found && !t.found) {
    var i = r.width, l = r.height, c = {
      x: i / l / 2,
      y: 0.5
    };
    n.style = Pi(ae(ae({}, a), {}, {
      "transform-origin": "".concat(c.x + s.x / 16, "em ").concat(c.y + s.y / 16, "em")
    }));
  }
  return [{
    tag: "svg",
    attributes: n,
    children: e
  }];
}
function Mv(o) {
  var e = o.prefix, r = o.iconName, t = o.children, n = o.attributes, a = o.symbol, s = a === !0 ? "".concat(e, "-").concat(ie.cssPrefix, "-").concat(r) : a;
  return [{
    tag: "svg",
    attributes: {
      style: "display: none;"
    },
    children: [{
      tag: "symbol",
      attributes: ae(ae({}, n), {}, {
        id: s
      }),
      children: t
    }]
  }];
}
function vp(o) {
  var e = o.icons, r = e.main, t = e.mask, n = o.prefix, a = o.iconName, s = o.transform, i = o.symbol, l = o.title, c = o.maskId, u = o.titleId, f = o.extra, g = o.watchable, d = g === void 0 ? !1 : g, p = t.found ? t : r, m = p.width, y = p.height, h = n === "fak", F = [ie.replacementClass, a ? "".concat(ie.cssPrefix, "-").concat(a) : ""].filter(function(w) {
    return f.classes.indexOf(w) === -1;
  }).filter(function(w) {
    return w !== "" || !!w;
  }).concat(f.classes).join(" "), b = {
    children: [],
    attributes: ae(ae({}, f.attributes), {}, {
      "data-prefix": n,
      "data-icon": a,
      class: F,
      role: f.attributes.role || "img",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 ".concat(m, " ").concat(y)
    })
  }, v = h && !~f.classes.indexOf("fa-fw") ? {
    width: "".concat(m / y * 16 * 0.0625, "em")
  } : {};
  d && (b.attributes[dt] = ""), l && (b.children.push({
    tag: "title",
    attributes: {
      id: b.attributes["aria-labelledby"] || "title-".concat(u || Wn())
    },
    children: [l]
  }), delete b.attributes.title);
  var P = ae(ae({}, b), {}, {
    prefix: n,
    iconName: a,
    main: r,
    mask: t,
    maskId: c,
    transform: s,
    symbol: i,
    styles: ae(ae({}, v), f.styles)
  }), E = t.found && r.found ? mr("generateAbstractMask", P) || {
    children: [],
    attributes: {}
  } : mr("generateAbstractIcon", P) || {
    children: [],
    attributes: {}
  }, S = E.children, D = E.attributes;
  return P.children = S, P.attributes = D, i ? Mv(P) : jv(P);
}
function Rd(o) {
  var e = o.content, r = o.width, t = o.height, n = o.transform, a = o.title, s = o.extra, i = o.watchable, l = i === void 0 ? !1 : i, c = ae(ae(ae({}, s.attributes), a ? {
    title: a
  } : {}), {}, {
    class: s.classes.join(" ")
  });
  l && (c[dt] = "");
  var u = ae({}, s.styles);
  yp(n) && (u.transform = gv({
    transform: n,
    width: r,
    height: t
  }), u["-webkit-transform"] = u.transform);
  var f = Pi(u);
  f.length > 0 && (c.style = f);
  var g = [];
  return g.push({
    tag: "span",
    attributes: c,
    children: [e]
  }), a && g.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [a]
  }), g;
}
function Wv(o) {
  var e = o.content, r = o.title, t = o.extra, n = ae(ae(ae({}, t.attributes), r ? {
    title: r
  } : {}), {}, {
    class: t.classes.join(" ")
  }), a = Pi(t.styles);
  a.length > 0 && (n.style = a);
  var s = [];
  return s.push({
    tag: "span",
    attributes: n,
    children: [e]
  }), r && s.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [r]
  }), s;
}
var nl = Ho.styles;
function lu(o) {
  var e = o[0], r = o[1], t = o.slice(4), n = up(t, 1), a = n[0], s = null;
  return Array.isArray(a) ? s = {
    tag: "g",
    attributes: {
      class: "".concat(ie.cssPrefix, "-").concat(et.GROUP)
    },
    children: [{
      tag: "path",
      attributes: {
        class: "".concat(ie.cssPrefix, "-").concat(et.SECONDARY),
        fill: "currentColor",
        d: a[0]
      }
    }, {
      tag: "path",
      attributes: {
        class: "".concat(ie.cssPrefix, "-").concat(et.PRIMARY),
        fill: "currentColor",
        d: a[1]
      }
    }]
  } : s = {
    tag: "path",
    attributes: {
      fill: "currentColor",
      d: a
    }
  }, {
    found: !0,
    width: e,
    height: r,
    icon: s
  };
}
var Nv = {
  found: !1,
  width: 512,
  height: 512
};
function Vv(o, e) {
  !Xh && !ie.showMissingIcons && o && console.error('Icon with name "'.concat(o, '" and prefix "').concat(e, '" is missing.'));
}
function cu(o, e) {
  var r = e;
  return e === "fa" && ie.styleDefault !== null && (e = Vr()), new Promise(function(t, n) {
    if (mr("missingIconAbstract"), r === "fa") {
      var a = a1(o) || {};
      o = a.iconName || o, e = a.prefix || e;
    }
    if (o && e && nl[e] && nl[e][o]) {
      var s = nl[e][o];
      return t(lu(s));
    }
    Vv(o, e), t(ae(ae({}, Nv), {}, {
      icon: ie.showMissingIcons && o ? mr("missingIconAbstract") || {} : {}
    }));
  });
}
var Hd = function() {
}, uu = ie.measurePerformance && rs && rs.mark && rs.measure ? rs : {
  mark: Hd,
  measure: Hd
}, fn = 'FA "6.5.1"', zv = function(e) {
  return uu.mark("".concat(fn, " ").concat(e, " begins")), function() {
    return i1(e);
  };
}, i1 = function(e) {
  uu.mark("".concat(fn, " ").concat(e, " ends")), uu.measure("".concat(fn, " ").concat(e), "".concat(fn, " ").concat(e, " begins"), "".concat(fn, " ").concat(e, " ends"));
}, Bp = {
  begin: zv,
  end: i1
}, Cs = function() {
};
function Yd(o) {
  var e = o.getAttribute ? o.getAttribute(dt) : null;
  return typeof e == "string";
}
function Iv(o) {
  var e = o.getAttribute ? o.getAttribute(dp) : null, r = o.getAttribute ? o.getAttribute(gp) : null;
  return e && r;
}
function Rv(o) {
  return o && o.classList && o.classList.contains && o.classList.contains(ie.replacementClass);
}
function Hv() {
  if (ie.autoReplaceSvg === !0)
    return Os.replace;
  var o = Os[ie.autoReplaceSvg];
  return o || Os.replace;
}
function Yv(o) {
  return We.createElementNS("http://www.w3.org/2000/svg", o);
}
function qv(o) {
  return We.createElement(o);
}
function l1(o) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = e.ceFn, t = r === void 0 ? o.tag === "svg" ? Yv : qv : r;
  if (typeof o == "string")
    return We.createTextNode(o);
  var n = t(o.tag);
  Object.keys(o.attributes || []).forEach(function(s) {
    n.setAttribute(s, o.attributes[s]);
  });
  var a = o.children || [];
  return a.forEach(function(s) {
    n.appendChild(l1(s, {
      ceFn: t
    }));
  }), n;
}
function Gv(o) {
  var e = " ".concat(o.outerHTML, " ");
  return e = "".concat(e, "Font Awesome fontawesome.com "), e;
}
var Os = {
  replace: function(e) {
    var r = e[0];
    if (r.parentNode)
      if (e[1].forEach(function(n) {
        r.parentNode.insertBefore(l1(n), r);
      }), r.getAttribute(dt) === null && ie.keepOriginalSource) {
        var t = We.createComment(Gv(r));
        r.parentNode.replaceChild(t, r);
      } else
        r.remove();
  },
  nest: function(e) {
    var r = e[0], t = e[1];
    if (~fp(r).indexOf(ie.replacementClass))
      return Os.replace(e);
    var n = new RegExp("".concat(ie.cssPrefix, "-.*"));
    if (delete t[0].attributes.id, t[0].attributes.class) {
      var a = t[0].attributes.class.split(" ").reduce(function(i, l) {
        return l === ie.replacementClass || l.match(n) ? i.toSvg.push(l) : i.toNode.push(l), i;
      }, {
        toNode: [],
        toSvg: []
      });
      t[0].attributes.class = a.toSvg.join(" "), a.toNode.length === 0 ? r.removeAttribute("class") : r.setAttribute("class", a.toNode.join(" "));
    }
    var s = t.map(function(i) {
      return Ya(i);
    }).join(`
`);
    r.setAttribute(dt, ""), r.innerHTML = s;
  }
};
function qd(o) {
  o();
}
function c1(o, e) {
  var r = typeof e == "function" ? e : Cs;
  if (o.length === 0)
    r();
  else {
    var t = qd;
    ie.mutateApproach === Q2 && (t = Nr.requestAnimationFrame || qd), t(function() {
      var n = Hv(), a = Bp.begin("mutate");
      o.map(n), a(), r();
    });
  }
}
var Pp = !1;
function u1() {
  Pp = !0;
}
function pu() {
  Pp = !1;
}
var Zs = null;
function Gd(o) {
  if (jd && ie.observeMutations) {
    var e = o.treeCallback, r = e === void 0 ? Cs : e, t = o.nodeCallback, n = t === void 0 ? Cs : t, a = o.pseudoElementsCallback, s = a === void 0 ? Cs : a, i = o.observeMutationsRoot, l = i === void 0 ? We : i;
    Zs = new jd(function(c) {
      if (!Pp) {
        var u = Vr();
        on(c).forEach(function(f) {
          if (f.type === "childList" && f.addedNodes.length > 0 && !Yd(f.addedNodes[0]) && (ie.searchPseudoElements && s(f.target), r(f.target)), f.type === "attributes" && f.target.parentNode && ie.searchPseudoElements && s(f.target.parentNode), f.type === "attributes" && Yd(f.target) && ~tv.indexOf(f.attributeName))
            if (f.attributeName === "class" && Iv(f.target)) {
              var g = ki(fp(f.target)), d = g.prefix, p = g.iconName;
              f.target.setAttribute(dp, d || u), p && f.target.setAttribute(gp, p);
            } else Rv(f.target) && n(f.target);
        });
      }
    }), br && Zs.observe(l, {
      childList: !0,
      attributes: !0,
      characterData: !0,
      subtree: !0
    });
  }
}
function Xv() {
  Zs && Zs.disconnect();
}
function Uv(o) {
  var e = o.getAttribute("style"), r = [];
  return e && (r = e.split(";").reduce(function(t, n) {
    var a = n.split(":"), s = a[0], i = a.slice(1);
    return s && i.length > 0 && (t[s] = i.join(":").trim()), t;
  }, {})), r;
}
function Zv(o) {
  var e = o.getAttribute("data-prefix"), r = o.getAttribute("data-icon"), t = o.innerText !== void 0 ? o.innerText.trim() : "", n = ki(fp(o));
  return n.prefix || (n.prefix = Vr()), e && r && (n.prefix = e, n.iconName = r), n.iconName && n.prefix || (n.prefix && t.length > 0 && (n.iconName = Dv(n.prefix, o.innerText) || Fp(n.prefix, nu(o.innerText))), !n.iconName && ie.autoFetchSvg && o.firstChild && o.firstChild.nodeType === Node.TEXT_NODE && (n.iconName = o.firstChild.data)), n;
}
function Kv(o) {
  var e = on(o.attributes).reduce(function(n, a) {
    return n.name !== "class" && n.name !== "style" && (n[a.name] = a.value), n;
  }, {}), r = o.getAttribute("title"), t = o.getAttribute("data-fa-title-id");
  return ie.autoA11y && (r ? e["aria-labelledby"] = "".concat(ie.replacementClass, "-title-").concat(t || Wn()) : (e["aria-hidden"] = "true", e.focusable = "false")), e;
}
function Qv() {
  return {
    iconName: null,
    title: null,
    titleId: null,
    prefix: null,
    transform: er,
    symbol: !1,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    extra: {
      classes: [],
      styles: {},
      attributes: {}
    }
  };
}
function Xd(o) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    styleParser: !0
  }, r = Zv(o), t = r.iconName, n = r.prefix, a = r.rest, s = Kv(o), i = su("parseNodeAttributes", {}, o), l = e.styleParser ? Uv(o) : [];
  return ae({
    iconName: t,
    title: o.getAttribute("title"),
    titleId: o.getAttribute("data-fa-title-id"),
    prefix: n,
    transform: er,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    symbol: !1,
    extra: {
      classes: a,
      styles: l,
      attributes: s
    }
  }, i);
}
var Jv = Ho.styles;
function p1(o) {
  var e = ie.autoReplaceSvg === "nest" ? Xd(o, {
    styleParser: !1
  }) : Xd(o);
  return ~e.extra.classes.indexOf(Uh) ? mr("generateLayersText", o, e) : mr("generateSvgReplacementMutation", o, e);
}
var zr = /* @__PURE__ */ new Set();
mp.map(function(o) {
  zr.add("fa-".concat(o));
});
Object.keys(Tn[Me]).map(zr.add.bind(zr));
Object.keys(Tn[ze]).map(zr.add.bind(zr));
zr = Ra(zr);
function Ud(o) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  if (!br) return Promise.resolve();
  var r = We.documentElement.classList, t = function(f) {
    return r.add("".concat(Md, "-").concat(f));
  }, n = function(f) {
    return r.remove("".concat(Md, "-").concat(f));
  }, a = ie.autoFetchSvg ? zr : mp.map(function(u) {
    return "fa-".concat(u);
  }).concat(Object.keys(Jv));
  a.includes("fa") || a.push("fa");
  var s = [".".concat(Uh, ":not([").concat(dt, "])")].concat(a.map(function(u) {
    return ".".concat(u, ":not([").concat(dt, "])");
  })).join(", ");
  if (s.length === 0)
    return Promise.resolve();
  var i = [];
  try {
    i = on(o.querySelectorAll(s));
  } catch {
  }
  if (i.length > 0)
    t("pending"), n("complete");
  else
    return Promise.resolve();
  var l = Bp.begin("onTree"), c = i.reduce(function(u, f) {
    try {
      var g = p1(f);
      g && u.push(g);
    } catch (d) {
      Xh || d.name === "MissingIcon" && console.error(d);
    }
    return u;
  }, []);
  return new Promise(function(u, f) {
    Promise.all(c).then(function(g) {
      c1(g, function() {
        t("active"), t("complete"), n("pending"), typeof e == "function" && e(), l(), u();
      });
    }).catch(function(g) {
      l(), f(g);
    });
  });
}
function _v(o) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  p1(o).then(function(r) {
    r && c1([r], e);
  });
}
function $v(o) {
  return function(e) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = (e || {}).icon ? e : iu(e || {}), n = r.mask;
    return n && (n = (n || {}).icon ? n : iu(n || {})), o(t, ae(ae({}, r), {}, {
      mask: n
    }));
  };
}
var e3 = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = r.transform, n = t === void 0 ? er : t, a = r.symbol, s = a === void 0 ? !1 : a, i = r.mask, l = i === void 0 ? null : i, c = r.maskId, u = c === void 0 ? null : c, f = r.title, g = f === void 0 ? null : f, d = r.titleId, p = d === void 0 ? null : d, m = r.classes, y = m === void 0 ? [] : m, h = r.attributes, F = h === void 0 ? {} : h, b = r.styles, v = b === void 0 ? {} : b;
  if (e) {
    var P = e.prefix, E = e.iconName, S = e.icon;
    return Di(ae({
      type: "icon"
    }, e), function() {
      return gt("beforeDOMElementCreation", {
        iconDefinition: e,
        params: r
      }), ie.autoA11y && (g ? F["aria-labelledby"] = "".concat(ie.replacementClass, "-title-").concat(p || Wn()) : (F["aria-hidden"] = "true", F.focusable = "false")), vp({
        icons: {
          main: lu(S),
          mask: l ? lu(l.icon) : {
            found: !1,
            width: null,
            height: null,
            icon: {}
          }
        },
        prefix: P,
        iconName: E,
        transform: ae(ae({}, er), n),
        symbol: s,
        title: g,
        maskId: u,
        titleId: p,
        extra: {
          attributes: F,
          styles: v,
          classes: y
        }
      });
    });
  }
}, o3 = {
  mixout: function() {
    return {
      icon: $v(e3)
    };
  },
  hooks: function() {
    return {
      mutationObserverCallbacks: function(r) {
        return r.treeCallback = Ud, r.nodeCallback = _v, r;
      }
    };
  },
  provides: function(e) {
    e.i2svg = function(r) {
      var t = r.node, n = t === void 0 ? We : t, a = r.callback, s = a === void 0 ? function() {
      } : a;
      return Ud(n, s);
    }, e.generateSvgReplacementMutation = function(r, t) {
      var n = t.iconName, a = t.title, s = t.titleId, i = t.prefix, l = t.transform, c = t.symbol, u = t.mask, f = t.maskId, g = t.extra;
      return new Promise(function(d, p) {
        Promise.all([cu(n, i), u.iconName ? cu(u.iconName, u.prefix) : Promise.resolve({
          found: !1,
          width: 512,
          height: 512,
          icon: {}
        })]).then(function(m) {
          var y = up(m, 2), h = y[0], F = y[1];
          d([r, vp({
            icons: {
              main: h,
              mask: F
            },
            prefix: i,
            iconName: n,
            transform: l,
            symbol: c,
            maskId: f,
            title: a,
            titleId: s,
            extra: g,
            watchable: !0
          })]);
        }).catch(p);
      });
    }, e.generateAbstractIcon = function(r) {
      var t = r.children, n = r.attributes, a = r.main, s = r.transform, i = r.styles, l = Pi(i);
      l.length > 0 && (n.style = l);
      var c;
      return yp(s) && (c = mr("generateAbstractTransformGrouping", {
        main: a,
        transform: s,
        containerWidth: a.width,
        iconWidth: a.width
      })), t.push(c || a.icon), {
        children: t,
        attributes: n
      };
    };
  }
}, r3 = {
  mixout: function() {
    return {
      layer: function(r) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.classes, a = n === void 0 ? [] : n;
        return Di({
          type: "layer"
        }, function() {
          gt("beforeDOMElementCreation", {
            assembler: r,
            params: t
          });
          var s = [];
          return r(function(i) {
            Array.isArray(i) ? i.map(function(l) {
              s = s.concat(l.abstract);
            }) : s = s.concat(i.abstract);
          }), [{
            tag: "span",
            attributes: {
              class: ["".concat(ie.cssPrefix, "-layers")].concat(Ra(a)).join(" ")
            },
            children: s
          }];
        });
      }
    };
  }
}, t3 = {
  mixout: function() {
    return {
      counter: function(r) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.title, a = n === void 0 ? null : n, s = t.classes, i = s === void 0 ? [] : s, l = t.attributes, c = l === void 0 ? {} : l, u = t.styles, f = u === void 0 ? {} : u;
        return Di({
          type: "counter",
          content: r
        }, function() {
          return gt("beforeDOMElementCreation", {
            content: r,
            params: t
          }), Wv({
            content: r.toString(),
            title: a,
            extra: {
              attributes: c,
              styles: f,
              classes: ["".concat(ie.cssPrefix, "-layers-counter")].concat(Ra(i))
            }
          });
        });
      }
    };
  }
}, n3 = {
  mixout: function() {
    return {
      text: function(r) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.transform, a = n === void 0 ? er : n, s = t.title, i = s === void 0 ? null : s, l = t.classes, c = l === void 0 ? [] : l, u = t.attributes, f = u === void 0 ? {} : u, g = t.styles, d = g === void 0 ? {} : g;
        return Di({
          type: "text",
          content: r
        }, function() {
          return gt("beforeDOMElementCreation", {
            content: r,
            params: t
          }), Rd({
            content: r,
            transform: ae(ae({}, er), a),
            title: i,
            extra: {
              attributes: f,
              styles: d,
              classes: ["".concat(ie.cssPrefix, "-layers-text")].concat(Ra(c))
            }
          });
        });
      }
    };
  },
  provides: function(e) {
    e.generateLayersText = function(r, t) {
      var n = t.title, a = t.transform, s = t.extra, i = null, l = null;
      if (Yh) {
        var c = parseInt(getComputedStyle(r).fontSize, 10), u = r.getBoundingClientRect();
        i = u.width / c, l = u.height / c;
      }
      return ie.autoA11y && !n && (s.attributes["aria-hidden"] = "true"), Promise.resolve([r, Rd({
        content: r.innerHTML,
        width: i,
        height: l,
        transform: a,
        title: n,
        extra: s,
        watchable: !0
      })]);
    };
  }
}, a3 = new RegExp('"', "ug"), Zd = [1105920, 1112319];
function s3(o) {
  var e = o.replace(a3, ""), r = bv(e, 0), t = r >= Zd[0] && r <= Zd[1], n = e.length === 2 ? e[0] === e[1] : !1;
  return {
    value: nu(n ? e[0] : e),
    isSecondary: t || n
  };
}
function Kd(o, e) {
  var r = "".concat(K2).concat(e.replace(":", "-"));
  return new Promise(function(t, n) {
    if (o.getAttribute(r) !== null)
      return t();
    var a = on(o.children), s = a.filter(function(S) {
      return S.getAttribute(tu) === e;
    })[0], i = Nr.getComputedStyle(o, e), l = i.getPropertyValue("font-family").match(ev), c = i.getPropertyValue("font-weight"), u = i.getPropertyValue("content");
    if (s && !l)
      return o.removeChild(s), t();
    if (l && u !== "none" && u !== "") {
      var f = i.getPropertyValue("content"), g = ~["Sharp"].indexOf(l[2]) ? ze : Me, d = ~["Solid", "Regular", "Light", "Thin", "Duotone", "Brands", "Kit"].indexOf(l[2]) ? Ln[g][l[2].toLowerCase()] : ov[g][c], p = s3(f), m = p.value, y = p.isSecondary, h = l[0].startsWith("FontAwesome"), F = Fp(d, m), b = F;
      if (h) {
        var v = Sv(m);
        v.iconName && v.prefix && (F = v.iconName, d = v.prefix);
      }
      if (F && !y && (!s || s.getAttribute(dp) !== d || s.getAttribute(gp) !== b)) {
        o.setAttribute(r, b), s && o.removeChild(s);
        var P = Qv(), E = P.extra;
        E.attributes[tu] = e, cu(F, d).then(function(S) {
          var D = vp(ae(ae({}, P), {}, {
            icons: {
              main: S,
              mask: bp()
            },
            prefix: d,
            iconName: b,
            extra: E,
            watchable: !0
          })), w = We.createElementNS("http://www.w3.org/2000/svg", "svg");
          e === "::before" ? o.insertBefore(w, o.firstChild) : o.appendChild(w), w.outerHTML = D.map(function(A) {
            return Ya(A);
          }).join(`
`), o.removeAttribute(r), t();
        }).catch(n);
      } else
        t();
    } else
      t();
  });
}
function i3(o) {
  return Promise.all([Kd(o, "::before"), Kd(o, "::after")]);
}
function l3(o) {
  return o.parentNode !== document.head && !~J2.indexOf(o.tagName.toUpperCase()) && !o.getAttribute(tu) && (!o.parentNode || o.parentNode.tagName !== "svg");
}
function Qd(o) {
  if (br)
    return new Promise(function(e, r) {
      var t = on(o.querySelectorAll("*")).filter(l3).map(i3), n = Bp.begin("searchPseudoElements");
      u1(), Promise.all(t).then(function() {
        n(), pu(), e();
      }).catch(function() {
        n(), pu(), r();
      });
    });
}
var c3 = {
  hooks: function() {
    return {
      mutationObserverCallbacks: function(r) {
        return r.pseudoElementsCallback = Qd, r;
      }
    };
  },
  provides: function(e) {
    e.pseudoElements2svg = function(r) {
      var t = r.node, n = t === void 0 ? We : t;
      ie.searchPseudoElements && Qd(n);
    };
  }
}, Jd = !1, u3 = {
  mixout: function() {
    return {
      dom: {
        unwatch: function() {
          u1(), Jd = !0;
        }
      }
    };
  },
  hooks: function() {
    return {
      bootstrap: function() {
        Gd(su("mutationObserverCallbacks", {}));
      },
      noAuto: function() {
        Xv();
      },
      watch: function(r) {
        var t = r.observeMutationsRoot;
        Jd ? pu() : Gd(su("mutationObserverCallbacks", {
          observeMutationsRoot: t
        }));
      }
    };
  }
}, _d = function(e) {
  var r = {
    size: 16,
    x: 0,
    y: 0,
    flipX: !1,
    flipY: !1,
    rotate: 0
  };
  return e.toLowerCase().split(" ").reduce(function(t, n) {
    var a = n.toLowerCase().split("-"), s = a[0], i = a.slice(1).join("-");
    if (s && i === "h")
      return t.flipX = !0, t;
    if (s && i === "v")
      return t.flipY = !0, t;
    if (i = parseFloat(i), isNaN(i))
      return t;
    switch (s) {
      case "grow":
        t.size = t.size + i;
        break;
      case "shrink":
        t.size = t.size - i;
        break;
      case "left":
        t.x = t.x - i;
        break;
      case "right":
        t.x = t.x + i;
        break;
      case "up":
        t.y = t.y - i;
        break;
      case "down":
        t.y = t.y + i;
        break;
      case "rotate":
        t.rotate = t.rotate + i;
        break;
    }
    return t;
  }, r);
}, p3 = {
  mixout: function() {
    return {
      parse: {
        transform: function(r) {
          return _d(r);
        }
      }
    };
  },
  hooks: function() {
    return {
      parseNodeAttributes: function(r, t) {
        var n = t.getAttribute("data-fa-transform");
        return n && (r.transform = _d(n)), r;
      }
    };
  },
  provides: function(e) {
    e.generateAbstractTransformGrouping = function(r) {
      var t = r.main, n = r.transform, a = r.containerWidth, s = r.iconWidth, i = {
        transform: "translate(".concat(a / 2, " 256)")
      }, l = "translate(".concat(n.x * 32, ", ").concat(n.y * 32, ") "), c = "scale(".concat(n.size / 16 * (n.flipX ? -1 : 1), ", ").concat(n.size / 16 * (n.flipY ? -1 : 1), ") "), u = "rotate(".concat(n.rotate, " 0 0)"), f = {
        transform: "".concat(l, " ").concat(c, " ").concat(u)
      }, g = {
        transform: "translate(".concat(s / 2 * -1, " -256)")
      }, d = {
        outer: i,
        inner: f,
        path: g
      };
      return {
        tag: "g",
        attributes: ae({}, d.outer),
        children: [{
          tag: "g",
          attributes: ae({}, d.inner),
          children: [{
            tag: t.icon.tag,
            children: t.icon.children,
            attributes: ae(ae({}, t.icon.attributes), d.path)
          }]
        }]
      };
    };
  }
}, al = {
  x: 0,
  y: 0,
  width: "100%",
  height: "100%"
};
function $d(o) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
  return o.attributes && (o.attributes.fill || e) && (o.attributes.fill = "black"), o;
}
function d3(o) {
  return o.tag === "g" ? o.children : [o];
}
var g3 = {
  hooks: function() {
    return {
      parseNodeAttributes: function(r, t) {
        var n = t.getAttribute("data-fa-mask"), a = n ? ki(n.split(" ").map(function(s) {
          return s.trim();
        })) : bp();
        return a.prefix || (a.prefix = Vr()), r.mask = a, r.maskId = t.getAttribute("data-fa-mask-id"), r;
      }
    };
  },
  provides: function(e) {
    e.generateAbstractMask = function(r) {
      var t = r.children, n = r.attributes, a = r.main, s = r.mask, i = r.maskId, l = r.transform, c = a.width, u = a.icon, f = s.width, g = s.icon, d = dv({
        transform: l,
        containerWidth: f,
        iconWidth: c
      }), p = {
        tag: "rect",
        attributes: ae(ae({}, al), {}, {
          fill: "white"
        })
      }, m = u.children ? {
        children: u.children.map($d)
      } : {}, y = {
        tag: "g",
        attributes: ae({}, d.inner),
        children: [$d(ae({
          tag: u.tag,
          attributes: ae(ae({}, u.attributes), d.path)
        }, m))]
      }, h = {
        tag: "g",
        attributes: ae({}, d.outer),
        children: [y]
      }, F = "mask-".concat(i || Wn()), b = "clip-".concat(i || Wn()), v = {
        tag: "mask",
        attributes: ae(ae({}, al), {}, {
          id: F,
          maskUnits: "userSpaceOnUse",
          maskContentUnits: "userSpaceOnUse"
        }),
        children: [p, h]
      }, P = {
        tag: "defs",
        children: [{
          tag: "clipPath",
          attributes: {
            id: b
          },
          children: d3(g)
        }, v]
      };
      return t.push(P, {
        tag: "rect",
        attributes: ae({
          fill: "currentColor",
          "clip-path": "url(#".concat(b, ")"),
          mask: "url(#".concat(F, ")")
        }, al)
      }), {
        children: t,
        attributes: n
      };
    };
  }
}, m3 = {
  provides: function(e) {
    var r = !1;
    Nr.matchMedia && (r = Nr.matchMedia("(prefers-reduced-motion: reduce)").matches), e.missingIconAbstract = function() {
      var t = [], n = {
        fill: "currentColor"
      }, a = {
        attributeType: "XML",
        repeatCount: "indefinite",
        dur: "2s"
      };
      t.push({
        tag: "path",
        attributes: ae(ae({}, n), {}, {
          d: "M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z"
        })
      });
      var s = ae(ae({}, a), {}, {
        attributeName: "opacity"
      }), i = {
        tag: "circle",
        attributes: ae(ae({}, n), {}, {
          cx: "256",
          cy: "364",
          r: "28"
        }),
        children: []
      };
      return r || i.children.push({
        tag: "animate",
        attributes: ae(ae({}, a), {}, {
          attributeName: "r",
          values: "28;14;28;28;14;28;"
        })
      }, {
        tag: "animate",
        attributes: ae(ae({}, s), {}, {
          values: "1;0;1;1;0;1;"
        })
      }), t.push(i), t.push({
        tag: "path",
        attributes: ae(ae({}, n), {}, {
          opacity: "1",
          d: "M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z"
        }),
        children: r ? [] : [{
          tag: "animate",
          attributes: ae(ae({}, s), {}, {
            values: "1;0;0;0;0;1;"
          })
        }]
      }), r || t.push({
        tag: "path",
        attributes: ae(ae({}, n), {}, {
          opacity: "0",
          d: "M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z"
        }),
        children: [{
          tag: "animate",
          attributes: ae(ae({}, s), {}, {
            values: "0;0;1;1;0;0;"
          })
        }]
      }), {
        tag: "g",
        attributes: {
          class: "missing"
        },
        children: t
      };
    };
  }
}, f3 = {
  hooks: function() {
    return {
      parseNodeAttributes: function(r, t) {
        var n = t.getAttribute("data-fa-symbol"), a = n === null ? !1 : n === "" ? !0 : n;
        return r.symbol = a, r;
      }
    };
  }
}, y3 = [fv, o3, r3, t3, n3, c3, u3, p3, g3, m3, f3];
xv(y3, {
  mixoutsTo: Oo
});
Oo.noAuto;
var d1 = Oo.config;
Oo.library;
Oo.dom;
var Ks = Oo.parse;
Oo.findIconDefinition;
Oo.toHtml;
var h3 = Oo.icon;
Oo.layer;
var F3 = Oo.text;
Oo.counter;
function eg(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function Ro(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? eg(Object(r), !0).forEach(function(t) {
      vo(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : eg(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function Qs(o) {
  "@babel/helpers - typeof";
  return Qs = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Qs(o);
}
function vo(o, e, r) {
  return e = S3(e), e in o ? Object.defineProperty(o, e, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : o[e] = r, o;
}
function b3(o, e) {
  if (o == null) return {};
  var r = {}, t = Object.keys(o), n, a;
  for (a = 0; a < t.length; a++)
    n = t[a], !(e.indexOf(n) >= 0) && (r[n] = o[n]);
  return r;
}
function v3(o, e) {
  if (o == null) return {};
  var r = b3(o, e), t, n;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(o);
    for (n = 0; n < a.length; n++)
      t = a[n], !(e.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(o, t) && (r[t] = o[t]);
  }
  return r;
}
function du(o) {
  return B3(o) || P3(o) || w3(o) || k3();
}
function B3(o) {
  if (Array.isArray(o)) return gu(o);
}
function P3(o) {
  if (typeof Symbol < "u" && o[Symbol.iterator] != null || o["@@iterator"] != null) return Array.from(o);
}
function w3(o, e) {
  if (o) {
    if (typeof o == "string") return gu(o, e);
    var r = Object.prototype.toString.call(o).slice(8, -1);
    if (r === "Object" && o.constructor && (r = o.constructor.name), r === "Map" || r === "Set") return Array.from(o);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return gu(o, e);
  }
}
function gu(o, e) {
  (e == null || e > o.length) && (e = o.length);
  for (var r = 0, t = new Array(e); r < e; r++) t[r] = o[r];
  return t;
}
function k3() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function D3(o, e) {
  if (typeof o != "object" || o === null) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (typeof t != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
function S3(o) {
  var e = D3(o, "string");
  return typeof e == "symbol" ? e : String(e);
}
var A3 = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, g1 = { exports: {} };
(function(o) {
  (function(e) {
    var r = function(h, F, b) {
      if (!c(F) || f(F) || g(F) || d(F) || l(F))
        return F;
      var v, P = 0, E = 0;
      if (u(F))
        for (v = [], E = F.length; P < E; P++)
          v.push(r(h, F[P], b));
      else {
        v = {};
        for (var S in F)
          Object.prototype.hasOwnProperty.call(F, S) && (v[h(S, b)] = r(h, F[S], b));
      }
      return v;
    }, t = function(h, F) {
      F = F || {};
      var b = F.separator || "_", v = F.split || /(?=[A-Z])/;
      return h.split(v).join(b);
    }, n = function(h) {
      return p(h) ? h : (h = h.replace(/[\-_\s]+(.)?/g, function(F, b) {
        return b ? b.toUpperCase() : "";
      }), h.substr(0, 1).toLowerCase() + h.substr(1));
    }, a = function(h) {
      var F = n(h);
      return F.substr(0, 1).toUpperCase() + F.substr(1);
    }, s = function(h, F) {
      return t(h, F).toLowerCase();
    }, i = Object.prototype.toString, l = function(h) {
      return typeof h == "function";
    }, c = function(h) {
      return h === Object(h);
    }, u = function(h) {
      return i.call(h) == "[object Array]";
    }, f = function(h) {
      return i.call(h) == "[object Date]";
    }, g = function(h) {
      return i.call(h) == "[object RegExp]";
    }, d = function(h) {
      return i.call(h) == "[object Boolean]";
    }, p = function(h) {
      return h = h - 0, h === h;
    }, m = function(h, F) {
      var b = F && "process" in F ? F.process : F;
      return typeof b != "function" ? h : function(v, P) {
        return b(v, h, P);
      };
    }, y = {
      camelize: n,
      decamelize: s,
      pascalize: a,
      depascalize: s,
      camelizeKeys: function(h, F) {
        return r(m(n, F), h);
      },
      decamelizeKeys: function(h, F) {
        return r(m(s, F), h, F);
      },
      pascalizeKeys: function(h, F) {
        return r(m(a, F), h);
      },
      depascalizeKeys: function() {
        return this.decamelizeKeys.apply(this, arguments);
      }
    };
    o.exports ? o.exports = y : e.humps = y;
  })(A3);
})(g1);
var E3 = g1.exports, x3 = ["class", "style"];
function C3(o) {
  return o.split(";").map(function(e) {
    return e.trim();
  }).filter(function(e) {
    return e;
  }).reduce(function(e, r) {
    var t = r.indexOf(":"), n = E3.camelize(r.slice(0, t)), a = r.slice(t + 1).trim();
    return e[n] = a, e;
  }, {});
}
function O3(o) {
  return o.split(/\s+/).reduce(function(e, r) {
    return e[r] = !0, e;
  }, {});
}
function wp(o) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (typeof o == "string")
    return o;
  var t = (o.children || []).map(function(l) {
    return wp(l);
  }), n = Object.keys(o.attributes || {}).reduce(function(l, c) {
    var u = o.attributes[c];
    switch (c) {
      case "class":
        l.class = O3(u);
        break;
      case "style":
        l.style = C3(u);
        break;
      default:
        l.attrs[c] = u;
    }
    return l;
  }, {
    attrs: {},
    class: {},
    style: {}
  });
  r.class;
  var a = r.style, s = a === void 0 ? {} : a, i = v3(r, x3);
  return tt(o.tag, Ro(Ro(Ro({}, e), {}, {
    class: n.class,
    style: Ro(Ro({}, n.style), s)
  }, n.attrs), i), t);
}
var m1 = !1;
try {
  m1 = process.env.NODE_ENV === "production";
} catch {
}
function T3() {
  if (!m1 && console && typeof console.error == "function") {
    var o;
    (o = console).error.apply(o, arguments);
  }
}
function Sn(o, e) {
  return Array.isArray(e) && e.length > 0 || !Array.isArray(e) && e ? vo({}, o, e) : {};
}
function L3(o) {
  var e, r = (e = {
    "fa-spin": o.spin,
    "fa-pulse": o.pulse,
    "fa-fw": o.fixedWidth,
    "fa-border": o.border,
    "fa-li": o.listItem,
    "fa-inverse": o.inverse,
    "fa-flip": o.flip === !0,
    "fa-flip-horizontal": o.flip === "horizontal" || o.flip === "both",
    "fa-flip-vertical": o.flip === "vertical" || o.flip === "both"
  }, vo(e, "fa-".concat(o.size), o.size !== null), vo(e, "fa-rotate-".concat(o.rotation), o.rotation !== null), vo(e, "fa-pull-".concat(o.pull), o.pull !== null), vo(e, "fa-swap-opacity", o.swapOpacity), vo(e, "fa-bounce", o.bounce), vo(e, "fa-shake", o.shake), vo(e, "fa-beat", o.beat), vo(e, "fa-fade", o.fade), vo(e, "fa-beat-fade", o.beatFade), vo(e, "fa-flash", o.flash), vo(e, "fa-spin-pulse", o.spinPulse), vo(e, "fa-spin-reverse", o.spinReverse), e);
  return Object.keys(r).map(function(t) {
    return r[t] ? t : null;
  }).filter(function(t) {
    return t;
  });
}
function og(o) {
  if (o && Qs(o) === "object" && o.prefix && o.iconName && o.icon)
    return o;
  if (Ks.icon)
    return Ks.icon(o);
  if (o === null)
    return null;
  if (Qs(o) === "object" && o.prefix && o.iconName)
    return o;
  if (Array.isArray(o) && o.length === 2)
    return {
      prefix: o[0],
      iconName: o[1]
    };
  if (typeof o == "string")
    return {
      prefix: "fas",
      iconName: o
    };
}
var le = H({
  name: "FontAwesomeIcon",
  props: {
    border: {
      type: Boolean,
      default: !1
    },
    fixedWidth: {
      type: Boolean,
      default: !1
    },
    flip: {
      type: [Boolean, String],
      default: !1,
      validator: function(e) {
        return [!0, !1, "horizontal", "vertical", "both"].indexOf(e) > -1;
      }
    },
    icon: {
      type: [Object, Array, String],
      required: !0
    },
    mask: {
      type: [Object, Array, String],
      default: null
    },
    maskId: {
      type: String,
      default: null
    },
    listItem: {
      type: Boolean,
      default: !1
    },
    pull: {
      type: String,
      default: null,
      validator: function(e) {
        return ["right", "left"].indexOf(e) > -1;
      }
    },
    pulse: {
      type: Boolean,
      default: !1
    },
    rotation: {
      type: [String, Number],
      default: null,
      validator: function(e) {
        return [90, 180, 270].indexOf(Number.parseInt(e, 10)) > -1;
      }
    },
    swapOpacity: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: null,
      validator: function(e) {
        return ["2xs", "xs", "sm", "lg", "xl", "2xl", "1x", "2x", "3x", "4x", "5x", "6x", "7x", "8x", "9x", "10x"].indexOf(e) > -1;
      }
    },
    spin: {
      type: Boolean,
      default: !1
    },
    transform: {
      type: [String, Object],
      default: null
    },
    symbol: {
      type: [Boolean, String],
      default: !1
    },
    title: {
      type: String,
      default: null
    },
    titleId: {
      type: String,
      default: null
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    bounce: {
      type: Boolean,
      default: !1
    },
    shake: {
      type: Boolean,
      default: !1
    },
    beat: {
      type: Boolean,
      default: !1
    },
    fade: {
      type: Boolean,
      default: !1
    },
    beatFade: {
      type: Boolean,
      default: !1
    },
    flash: {
      type: Boolean,
      default: !1
    },
    spinPulse: {
      type: Boolean,
      default: !1
    },
    spinReverse: {
      type: Boolean,
      default: !1
    }
  },
  setup: function(e, r) {
    var t = r.attrs, n = se(function() {
      return og(e.icon);
    }), a = se(function() {
      return Sn("classes", L3(e));
    }), s = se(function() {
      return Sn("transform", typeof e.transform == "string" ? Ks.transform(e.transform) : e.transform);
    }), i = se(function() {
      return Sn("mask", og(e.mask));
    }), l = se(function() {
      return h3(n.value, Ro(Ro(Ro(Ro({}, a.value), s.value), i.value), {}, {
        symbol: e.symbol,
        title: e.title,
        titleId: e.titleId,
        maskId: e.maskId
      }));
    });
    Ir(l, function(u) {
      if (!u)
        return T3("Could not find one or more icon(s)", n.value, i.value);
    }, {
      immediate: !0
    });
    var c = se(function() {
      return l.value ? wp(l.value.abstract[0], {}, t) : null;
    });
    return function() {
      return c.value;
    };
  }
});
H({
  name: "FontAwesomeLayers",
  props: {
    fixedWidth: {
      type: Boolean,
      default: !1
    }
  },
  setup: function(e, r) {
    var t = r.slots, n = d1.familyPrefix, a = se(function() {
      return ["".concat(n, "-layers")].concat(du(e.fixedWidth ? ["".concat(n, "-fw")] : []));
    });
    return function() {
      return tt("div", {
        class: a.value
      }, t.default ? t.default() : []);
    };
  }
});
H({
  name: "FontAwesomeLayersText",
  props: {
    value: {
      type: [String, Number],
      default: ""
    },
    transform: {
      type: [String, Object],
      default: null
    },
    counter: {
      type: Boolean,
      default: !1
    },
    position: {
      type: String,
      default: null,
      validator: function(e) {
        return ["bottom-left", "bottom-right", "top-left", "top-right"].indexOf(e) > -1;
      }
    }
  },
  setup: function(e, r) {
    var t = r.attrs, n = d1.familyPrefix, a = se(function() {
      return Sn("classes", [].concat(du(e.counter ? ["".concat(n, "-layers-counter")] : []), du(e.position ? ["".concat(n, "-layers-").concat(e.position)] : [])));
    }), s = se(function() {
      return Sn("transform", typeof e.transform == "string" ? Ks.transform(e.transform) : e.transform);
    }), i = se(function() {
      var c = F3(e.value.toString(), Ro(Ro({}, s.value), a.value)), u = c.abstract;
      return e.counter && (u[0].attributes.class = u[0].attributes.class.replace("fa-layers-text", "")), u[0];
    }), l = se(function() {
      return wp(i.value, {}, t);
    });
    return function() {
      return l.value;
    };
  }
});
var qa = {
  prefix: "far",
  iconName: "check",
  icon: [
    448,
    512,
    [10003, 10004],
    "f00c",
    "M441 103c9.4 9.4 9.4 24.6 0 33.9L177 401c-9.4 9.4-24.6 9.4-33.9 0L7 265c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l119 119L407 103c9.4-9.4 24.6-9.4 33.9 0z"
  ]
}, j3 = {
  prefix: "far",
  iconName: "face-smile",
  icon: [
    512,
    512,
    [128578, "smile"],
    "f118",
    "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm177.6 62.1C192.8 334.5 218.8 352 256 352s63.2-17.5 78.4-33.9c9-9.7 24.2-10.4 33.9-1.4s10.4 24.2 1.4 33.9c-22 23.8-60 49.4-113.6 49.4s-91.7-25.5-113.6-49.4c-9-9.7-8.4-24.9 1.4-33.9s24.9-8.4 33.9 1.4zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
  ]
}, M3 = j3, Si = {
  prefix: "far",
  iconName: "chevron-right",
  icon: [
    320,
    512,
    [9002],
    "f054",
    "M305 239c9.4 9.4 9.4 24.6 0 33.9L113 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L79 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L305 239z"
  ]
}, kp = {
  prefix: "far",
  iconName: "chevron-left",
  icon: [
    320,
    512,
    [9001],
    "f053",
    "M15 239c-9.4 9.4-9.4 24.6 0 33.9L207 465c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L65.9 256 241 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L15 239z"
  ]
}, Hr = {
  prefix: "far",
  iconName: "xmark",
  icon: [
    384,
    512,
    [215, 10005, 10006, 10060, 128473, "close", "multiply", "remove", "times"],
    "f00d",
    "M345 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-119 119L73 103c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l119 119L39 375c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l119-119L311 409c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-119-119L345 137z"
  ]
}, Dp = {
  prefix: "far",
  iconName: "plus",
  icon: [
    448,
    512,
    [10133, 61543, "add"],
    "2b",
    "M248 72c0-13.3-10.7-24-24-24s-24 10.7-24 24V232H40c-13.3 0-24 10.7-24 24s10.7 24 24 24H200V440c0 13.3 10.7 24 24 24s24-10.7 24-24V280H408c13.3 0 24-10.7 24-24s-10.7-24-24-24H248V72z"
  ]
}, Sp = {
  prefix: "far",
  iconName: "chevron-down",
  icon: [
    512,
    512,
    [],
    "f078",
    "M239 401c9.4 9.4 24.6 9.4 33.9 0L465 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-175 175L81 175c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L239 401z"
  ]
}, W3 = {
  prefix: "far",
  iconName: "ellipsis-vertical",
  icon: [
    128,
    512,
    ["ellipsis-v"],
    "f142",
    "M64 368a48 48 0 1 0 0 96 48 48 0 1 0 0-96zm0-160a48 48 0 1 0 0 96 48 48 0 1 0 0-96zM112 96A48 48 0 1 0 16 96a48 48 0 1 0 96 0z"
  ]
}, N3 = W3, V3 = {
  prefix: "far",
  iconName: "minus",
  icon: [
    448,
    512,
    [8211, 8722, 10134, "subtract"],
    "f068",
    "M432 256c0 13.3-10.7 24-24 24L40 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l368 0c13.3 0 24 10.7 24 24z"
  ]
}, z3 = {
  prefix: "far",
  iconName: "arrow-left",
  icon: [
    448,
    512,
    [8592],
    "f060",
    "M7.4 273.4C2.7 268.8 0 262.6 0 256s2.7-12.8 7.4-17.4l176-168c9.6-9.2 24.8-8.8 33.9 .8s8.8 24.8-.8 33.9L83.9 232 424 232c13.3 0 24 10.7 24 24s-10.7 24-24 24L83.9 280 216.6 406.6c9.6 9.2 9.9 24.3 .8 33.9s-24.3 9.9-33.9 .8l-176-168z"
  ]
}, rg = {
  prefix: "far",
  iconName: "arrow-right",
  icon: [
    448,
    512,
    [8594],
    "f061",
    "M440.6 273.4c4.7-4.5 7.4-10.8 7.4-17.4s-2.7-12.8-7.4-17.4l-176-168c-9.6-9.2-24.8-8.8-33.9 .8s-8.8 24.8 .8 33.9L364.1 232 24 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l340.1 0L231.4 406.6c-9.6 9.2-9.9 24.3-.8 33.9s24.3 9.9 33.9 .8l176-168z"
  ]
}, f1 = {
  prefix: "far",
  iconName: "italic",
  icon: [
    384,
    512,
    [],
    "f033",
    "M128 56c0-13.3 10.7-24 24-24H360c13.3 0 24 10.7 24 24s-10.7 24-24 24H291.3L144.7 432H232c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H92.7L239.3 80H152c-13.3 0-24-10.7-24-24z"
  ]
}, y1 = {
  prefix: "far",
  iconName: "bold",
  icon: [
    384,
    512,
    [],
    "f032",
    "M0 56C0 42.7 10.7 32 24 32H72 88 212c68.5 0 124 55.5 124 124c0 34.7-14.3 66.2-37.3 88.7C339.7 264.9 368 307.1 368 356c0 68.5-55.5 124-124 124H88 72 24c-13.3 0-24-10.7-24-24s10.7-24 24-24H48V256 80H24C10.7 80 0 69.3 0 56zM212 232c42 0 76-34 76-76s-34-76-76-76H96V232H212zM96 280V432H244c42 0 76-34 76-76s-34-76-76-76H212 96z"
  ]
}, h1 = {
  prefix: "far",
  iconName: "underline",
  icon: [
    448,
    512,
    [],
    "f0cd",
    "M16 56c0-13.3 10.7-24 24-24h96c13.3 0 24 10.7 24 24s-10.7 24-24 24H112V224c0 61.9 50.1 112 112 112s112-50.1 112-112V80H312c-13.3 0-24-10.7-24-24s10.7-24 24-24h96c13.3 0 24 10.7 24 24s-10.7 24-24 24H384V224c0 88.4-71.6 160-160 160s-160-71.6-160-160V80H40C26.7 80 16 69.3 16 56zM0 456c0-13.3 10.7-24 24-24H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24z"
  ]
}, F1 = {
  prefix: "far",
  iconName: "sparkles",
  icon: [
    512,
    512,
    [10024],
    "f890",
    "M327.5 85.2c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L384 128l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L448 128l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L448 64 426.8 7.5C425.1 3 420.8 0 416 0s-9.1 3-10.8 7.5L384 64 327.5 85.2zM9.3 240C3.6 242.6 0 248.3 0 254.6s3.6 11.9 9.3 14.5L26.3 277l8.1 3.7 .6 .3 88.3 40.8L164.1 410l.3 .6 3.7 8.1 7.9 17.1c2.6 5.7 8.3 9.3 14.5 9.3s11.9-3.6 14.5-9.3l7.9-17.1 3.7-8.1 .3-.6 40.8-88.3L346 281l.6-.3 8.1-3.7 17.1-7.9c5.7-2.6 9.3-8.3 9.3-14.5s-3.6-11.9-9.3-14.5l-17.1-7.9-8.1-3.7-.6-.3-88.3-40.8L217 99.1l-.3-.6L213 90.3l-7.9-17.1c-2.6-5.7-8.3-9.3-14.5-9.3s-11.9 3.6-14.5 9.3l-7.9 17.1-3.7 8.1-.3 .6-40.8 88.3L35.1 228.1l-.6 .3-8.1 3.7L9.3 240zm83 14.5l51.2-23.6c10.4-4.8 18.7-13.1 23.5-23.5l23.6-51.2 23.6 51.2c4.8 10.4 13.1 18.7 23.5 23.5l51.2 23.6-51.2 23.6c-10.4 4.8-18.7 13.1-23.5 23.5l-23.6 51.2-23.6-51.2c-4.8-10.4-13.1-18.7-23.5-23.5L92.3 254.6zM384 384l-56.5 21.2c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L384 448l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L448 448l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L448 384l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L384 384z"
  ]
}, I3 = {
  prefix: "far",
  iconName: "chevron-up",
  icon: [
    512,
    512,
    [],
    "f077",
    "M239 111c9.4-9.4 24.6-9.4 33.9 0L465 303c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-175-175L81 337c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L239 111z"
  ]
}, R3 = {
  prefix: "far",
  iconName: "bars",
  icon: [
    448,
    512,
    ["navicon"],
    "f0c9",
    "M0 88C0 74.7 10.7 64 24 64H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H24C10.7 112 0 101.3 0 88zM0 248c0-13.3 10.7-24 24-24H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24zM448 408c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H424c13.3 0 24 10.7 24 24z"
  ]
}, b1 = {
  prefix: "far",
  iconName: "strikethrough",
  icon: [
    512,
    512,
    [],
    "f0cc",
    "M145.5 138c4-21.5 17.9-37.4 41.7-47.4c24.7-10.4 59.4-13.7 99.9-7.5c12.8 2 52.4 9.5 64.9 12.8c12.8 3.3 25.9-4.3 29.3-17.2s-4.3-25.9-17.2-29.3c-14.7-3.8-56.1-11.7-69.7-13.8c-46.2-7.1-90.4-4.1-125.7 10.7c-36.1 15.1-63.3 43.1-70.5 83.9c-.1 .4-.1 .9-.2 1.3c-2.8 23.4 .5 44.2 9.8 62.2c9.2 17.8 23.2 31.2 38.8 41.5c2.4 1.6 5 3.2 7.5 4.7H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H295.8c-9.9-3.1-19.7-6-29.2-8.8l-.3-.1c-37.7-11.1-70.5-20.7-93.3-35.8c-10.9-7.2-18.2-14.9-22.6-23.5c-4.2-8.2-6.6-18.9-4.9-33.8zM364 337.1c3.7 8.6 5.5 20.1 2.6 36.3c-3.8 21.8-17.8 37.9-41.8 48c-24.7 10.4-59.4 13.7-99.8 7.5c-20.1-3.2-54.3-14.6-81.2-23.6l0 0 0 0c-5.9-2-11.4-3.8-16.3-5.4c-12.6-4.1-26.1 2.8-30.3 15.4s2.8 26.2 15.4 30.3c4 1.3 8.8 2.9 14 4.7c26.6 8.9 66.4 22.2 90.9 26.2l.1 0c46.2 7.1 90.4 4.1 125.7-10.7c36.1-15.1 63.3-43.1 70.5-83.9c4-22.9 2.4-43.5-5-61.7H351.6c5.7 5.3 9.7 11 12.3 17.1z"
  ]
};
const H3 = { class: "flex-1 text-left" }, _z = /* @__PURE__ */ H({
  __name: "AccordionButton",
  setup(o) {
    const e = ce("multiple", !1);
    return (r, t) => (k(), R(ve(B(e) ? "dt" : "div"), null, {
      default: j(() => [
        z(B(Dh), {
          class: q([
            "w-full text-sm flex justify-between items-center gap-2 text-default-600",
            "hover:text-default-700"
          ])
        }, {
          default: j(({ open: n }) => [
            O("span", H3, [
              I(r.$slots, "default", { open: n })
            ]),
            z(B(le), {
              icon: n ? B(V3) : B(Dp),
              class: "size-5 flex-none",
              "aria-hidden": "true"
            }, null, 8, ["icon"])
          ]),
          _: 3
        })
      ]),
      _: 3
    }));
  }
}), Y3 = {
  class: /* @__PURE__ */ q([
    "divide-y divide-gray-900/10",
    "[&>div]:py-6 [&>div:first-child]:pt-0 [&>div:last-child]:pb-0"
  ])
}, $z = /* @__PURE__ */ H({
  __name: "AccordionGroup",
  setup(o) {
    return he("multiple", !0), (e, r) => (k(), N("dl", Y3, [
      I(e.$slots, "default")
    ]));
  }
}), eI = /* @__PURE__ */ H({
  __name: "AccordionPanel",
  setup(o) {
    const e = ce("multiple", !1);
    return (r, t) => (k(), R(B(Sh), {
      class: "pt-6 text-sm",
      as: B(e) ? "dd" : void 0
    }, {
      default: j(({ open: n, close: a }) => [
        I(r.$slots, "default", {
          open: n,
          close: a
        })
      ]),
      _: 3
    }, 8, ["as"]));
  }
}), q3 = {
  class: /* @__PURE__ */ q([
    "shadow rounded-2xl bg-primary-100 p-6 flex items-center",
    "md:space-x-base"
  ])
}, G3 = {
  key: 0,
  class: /* @__PURE__ */ q([
    "hidden size-10 rounded-full bg-primary-600 items-center justify-center",
    "md:inline-flex"
  ])
}, X3 = {
  class: /* @__PURE__ */ q([
    "flex-1 grid-cols-12 grid-rows-[repeat(2,minmax(0,auto))]",
    "md:grid"
  ])
}, oI = /* @__PURE__ */ H({
  __name: "ActionBanner",
  props: {
    icon: {}
  },
  setup(o) {
    return (e, r) => (k(), N("div", q3, [
      e.icon ? (k(), N("span", G3, [
        z(B(le), {
          icon: e.icon,
          class: "size-4 text-white",
          "aria-hidden": "true"
        }, null, 8, ["icon"])
      ])) : K("", !0),
      O("div", X3, [
        I(e.$slots, "default")
      ])
    ]));
  }
}), fe = (o, e) => {
  const r = o.__vccOpts || o;
  for (const [t, n] of e)
    r[t] = n;
  return r;
}, U3 = {}, Z3 = {
  class: /* @__PURE__ */ q([
    "col-start-9 col-end-13 row-start-1 row-end-3 pt-4",
    "md:pt-0 md:self-center md:justify-self-end"
  ])
};
function K3(o, e) {
  return k(), N("div", Z3, [
    I(o.$slots, "default")
  ]);
}
const rI = /* @__PURE__ */ fe(U3, [["render", K3]]), oo = /* @__PURE__ */ H({
  __name: "Text",
  props: {
    as: { default: "p" },
    color: { default: "primary" },
    size: { default: "base" },
    weight: { default: "normal" }
  },
  setup(o) {
    const e = /* @__PURE__ */ new Map([
      ["sm", "text-xs"],
      ["base", "text-sm"],
      ["lg", "text-base"]
    ]), r = /* @__PURE__ */ new Map([
      ["primary", "text-default-900"],
      ["secondary", "text-default-500"],
      ["tertiary", "text-default-700"],
      ["light", "text-white"]
    ]), t = /* @__PURE__ */ new Map([
      ["light", "font-light"],
      ["normal", "font-normal"],
      ["medium", "font-medium"],
      ["bold", "font-bold"]
    ]);
    return (n, a) => (k(), R(ve(n.as), {
      class: q([
        B(e).get(n.size),
        B(r).get(n.color),
        B(t).get(n.weight)
      ])
    }, {
      default: j(() => [
        I(n.$slots, "default")
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), Q3 = { class: "mt-1 col-start-1 col-end-9 row-start-2 row-end-3" }, tI = /* @__PURE__ */ H({
  __name: "ActionBannerDescription",
  setup(o) {
    return (e, r) => (k(), N("div", Q3, [
      z(oo, null, {
        default: j(() => [
          I(e.$slots, "default")
        ]),
        _: 3
      })
    ]));
  }
}), Vo = /* @__PURE__ */ H({
  __name: "Heading",
  props: {
    as: {},
    color: { default: "default" },
    size: { default: "base" }
  },
  setup(o) {
    const e = /* @__PURE__ */ new Map([
      ["sm", "text-sm font-bold"],
      ["base", "text-base font-semibold"],
      ["lg", "text-lg font-semibold"],
      ["xl", "text-xl font-bold"],
      ["2xl", "text-2xl font-bold"]
    ]), r = /* @__PURE__ */ new Map([
      ["default", "text-default-900"],
      ["primary", "text-primary-600"],
      ["light", "text-white"]
    ]);
    return (t, n) => (k(), R(ve(t.as), {
      class: q([
        "font-gilmer",
        B(e).get(t.size),
        B(r).get(t.color)
      ])
    }, {
      default: j(() => [
        I(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), J3 = { class: "col-start-1 col-end-9 row-start-1 row-end-2" }, nI = /* @__PURE__ */ H({
  inheritAttrs: !1,
  __name: "ActionBannerTitle",
  props: {
    as: { default: "h3" }
  },
  setup(o) {
    return (e, r) => (k(), N("div", J3, [
      z(Vo, Ve({
        as: e.as,
        size: "2xl"
      }, e.$attrs), {
        default: j(() => [
          I(e.$slots, "default")
        ]),
        _: 3
      }, 16, ["as"])
    ]));
  }
}), _3 = {}, $3 = {
  class: "absolute bg-[linear-gradient(90deg,_rgba(172,167,232,0.6)_0%,_rgba(214,150,229,0.6)_38.42%,_rgba(135,199,235,0.6)_66.92%,_rgba(119,165,234,0.6)_100%)] blur-3xl h-[250px] right-[-220px] rotate-[-120deg] top-[-100px] w-[480px]",
  "aria-hidden": "true"
};
function eB(o, e) {
  return k(), N("div", $3);
}
const Ai = /* @__PURE__ */ fe(_3, [["render", eB]]), oB = {
  class: /* @__PURE__ */ q([
    "px-4 py-5",
    "sm:p-6"
  ])
}, aI = /* @__PURE__ */ H({
  __name: "ActionPanel",
  props: {
    color: { default: "default" }
  },
  setup(o) {
    const e = /* @__PURE__ */ new Map([
      ["default", "bg-white"],
      ["ai", "bg-white border border-primary-500"]
    ]);
    return (r, t) => (k(), N("div", {
      class: q([
        "mx-auto shadow relative overflow-hidden",
        "sm:rounded-lg",
        B(e).get(r.color)
      ])
    }, [
      r.color === "ai" ? (k(), R(Ai, { key: 0 })) : K("", !0),
      O("div", oB, [
        I(r.$slots, "default")
      ])
    ], 2));
  }
}), Yr = /* @__PURE__ */ H({
  __name: "Spinner",
  props: {
    as: { default: "span" }
  },
  setup(o) {
    return (e, r) => (k(), R(ve(e.as), {
      role: "status",
      class: "inline-flex"
    }, {
      default: j(() => r[0] || (r[0] = [
        O("svg", {
          class: "animate-spin",
          xmlns: "http://www.w3.org/2000/svg",
          fill: "none",
          viewBox: "0 0 24 24",
          "aria-hidden": "true"
        }, [
          O("circle", {
            class: "opacity-25",
            cx: "12",
            cy: "12",
            r: "10",
            stroke: "currentColor",
            "stroke-width": "4"
          }),
          O("path", {
            class: "opacity-75",
            fill: "currentColor",
            d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          })
        ], -1),
        O("span", { class: "sr-only" }, " Loading... ", -1)
      ])),
      _: 1
    }));
  }
}), rB = {};
function tB(o, e) {
  return k(), N(ye, null, [
    e[0] || (e[0] = O("span", { class: "absolute top-1/2 left-1/2 size-[max(100%,2.75rem)] -translate-x-1/2 -translate-y-1/2 [@media(pointer:fine)]:hidden" }, null, -1)),
    I(o.$slots, "default")
  ], 64);
}
const vr = /* @__PURE__ */ fe(rB, [["render", tB]]), Re = /* @__PURE__ */ H({
  __name: "IconButton",
  props: {
    as: { default: void 0 },
    ariaLabel: {},
    circle: { type: Boolean, default: !1 },
    color: { default: "primary" },
    disabled: { type: Boolean },
    href: { default: void 0 },
    icon: {},
    loading: { type: Boolean },
    method: { default: void 0 },
    size: { default: "base" },
    stretched: { type: Boolean },
    type: { default: void 0 }
  },
  setup(o) {
    const e = o, r = {
      sm: "p-2",
      base: "p-2.5",
      lg: "p-3",
      xl: "p-5"
    }, t = {
      primary: "shadow-sm ring-transparent bg-primary-600 text-white hover:bg-primary-700 active:bg-primary-900 focus-visible:bg-primary-900 focus-visible:outline-primary-900",
      secondary: "shadow-sm ring-default-300 bg-white text-default-900 hover:bg-default-50 active:bg-white focus-visible:outline-primary-900 disabled:border-transparent",
      tertiary: "ring-transparent bg-transparent text-default-900 hover:bg-default-50 active:bg-white focus-visible:bg-default-200 focus-visible:outline-primary-900",
      danger: "shadow-sm ring-transparent bg-red-600 text-white hover:bg-red-700 active:bg-red-800 focus-visible:outline-primary-900",
      ai: "shadow-sm ring-transparent bg-gradient-to-r from-[#942aa9] to-[#2b4dd0] text-white hover:bg-gradient-to-l active:bg-gradient-to-r focus-visible:outline-primary-900 disabled:bg-none",
      dark: "shadow-sm ring-transparent bg-black text-white hover:bg-default-900 active:bg-default-900 focus-visible:bg-default-900 focus-visible:outline-primary-900"
    }, n = se(() => r[e.size]), a = se(() => t[e.color]), s = se(() => e.circle ? "rounded-full" : e.size === "sm" ? "rounded" : "rounded-md"), i = se(() => e.disabled || e.loading);
    return (l, c) => (k(), R(ve(l.as ?? (l.href ? B(yo) : "button")), {
      class: q([
        "inline-flex border-0 ring-1",
        "focus-visible:outline-none focus-visible:outline-2 focus-visible:outline-offset-2",
        n.value,
        a.value,
        i.value && "disabled:pointer-events-none disabled:bg-default-200 disabled:ring-default-400 disabled:text-default-400",
        s.value,
        l.stretched ? "after:absolute after:inset-0" : "relative"
      ]),
      href: l.href,
      type: l.type,
      method: l.method,
      disabled: i.value,
      "aria-disabled": i.value,
      "aria-busy": l.loading,
      tabindex: i.value ? "-1" : 0,
      "aria-label": l.ariaLabel
    }, {
      default: j(() => [
        z(vr),
        l.loading ? (k(), R(Yr, {
          key: 0,
          class: q(l.size === "sm" ? "size-3" : "size-4")
        }, null, 8, ["class"])) : (k(), R(B(le), {
          key: 1,
          icon: l.icon,
          "aria-hidden": "true",
          class: q(l.size === "sm" ? "size-3" : "size-4")
        }, null, 8, ["icon", "class"]))
      ]),
      _: 1
    }, 8, ["class", "href", "type", "method", "disabled", "aria-disabled", "aria-busy", "tabindex", "aria-label"]));
  }
}), nB = { class: "absolute top-1 right-1" }, sI = /* @__PURE__ */ H({
  __name: "ActionPanelCloseButton",
  emits: ["click"],
  setup(o, { emit: e }) {
    const r = e;
    return (t, n) => (k(), N("div", nB, [
      z(Re, {
        color: "tertiary",
        icon: B(Hr),
        ariaLabel: "Close action panel",
        onClick: n[0] || (n[0] = (a) => r("click"))
      }, null, 8, ["icon"])
    ]));
  }
}), aB = {}, sB = { class: "pt-5" };
function iB(o, e) {
  return k(), N("div", sB, [
    I(o.$slots, "default")
  ]);
}
const iI = /* @__PURE__ */ fe(aB, [["render", iB]]), lB = { class: "mt-2 max-w-xl" }, lI = /* @__PURE__ */ H({
  __name: "ActionPanelDescription",
  setup(o) {
    return (e, r) => (k(), N("div", lB, [
      z(oo, { color: "secondary" }, {
        default: j(() => [
          I(e.$slots, "default")
        ]),
        _: 3
      })
    ]));
  }
}), cI = /* @__PURE__ */ H({
  __name: "ActionPanelTitle",
  props: {
    as: { default: "h3" }
  },
  setup(o) {
    return (e, r) => (k(), R(Vo, { as: e.as }, {
      default: j(() => [
        I(e.$slots, "default")
      ]),
      _: 3
    }, 8, ["as"]));
  }
});
function cB(o, e, r) {
  if (!o) throw new Error("You need to provide `widgetName` in your data");
  var t = ["ais-" + o];
  return e && t.push("-" + e), r && t.push("--" + r), t.join("");
}
var Pe = function(o) {
  var e = o.name;
  return { props: { classNames: { type: Object, default: void 0 } }, methods: { suit: function(r, t) {
    var n = cB(e, r, t), a = this.classNames && this.classNames[n];
    return a ? [n, a].join(" ") : n;
  } } };
};
function Nn(o) {
  for (var e = arguments, r = 1; r < arguments.length; r++) {
    var t = e[r] != null ? e[r] : {}, n = Object.keys(t);
    typeof Object.getOwnPropertySymbols == "function" && (n = n.concat(Object.getOwnPropertySymbols(t).filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    }))), n.forEach(function(a) {
      uB(o, a, t[a]);
    });
  }
  return o;
}
function uB(o, e, r) {
  return e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
var pB = !1, dB = !0;
function Ga(o) {
  function e(r, t) {
    for (var n = [], a = arguments.length - 2; a-- > 0; ) n[a] = arguments[a + 2];
    var s = n.length > 0 ? n : void 0;
    if (typeof t == "object" && (t.attrs || t.props || t.scopedSlots || t.on)) {
      var i = Object.keys(t.on || {}), l = Object.assign({}, t, t.attrs, t.props, i.reduce(function(c, u) {
        return c["on" + u[0].toUpperCase() + u.slice(1)] = t.on[u], c;
      }, {}));
      return delete l.attrs, delete l.props, delete l.scopedSlots, i.forEach(function(c) {
        return delete l.on[c];
      }), l.on && Object.keys(l.on).length === 0 && delete l.on, tt(r, l, t.scopedSlots ? Object.assign({ default: function() {
        return s;
      } }, t.scopedSlots) : s);
    }
    return tt(r, t, s);
  }
  return function() {
    return o.call(this, e);
  };
}
function Ap(o) {
  var e = o.$slots || o.slots;
  return typeof e.default == "function" ? e.default() : e.default;
}
function sl(o, e) {
  return (o.$slots || o.slots || {})[e];
}
var tg = /* @__PURE__ */ new Set();
function zt(o) {
  tg.has(o) || (tg.add(o), console.warn(o));
}
var xe = function(o, e) {
  var r;
  o === void 0 && (o = {});
  var t = o.connector;
  return e === void 0 && (e = {}), (r = { inject: { instantSearchInstance: { from: "$_ais_instantSearchInstance", default: function() {
    var n = this.$options._componentTag;
    throw new TypeError('It looks like you forgot to wrap your Algolia search component "<' + n + '>" inside of an "<ais-instant-search>" component.');
  } }, getParentIndex: { from: "$_ais_getParentIndex", default: function() {
    var n = this;
    return function() {
      return n.instantSearchInstance.mainIndex;
    };
  } } }, data: function() {
    return { state: null };
  }, created: function() {
    if (typeof t == "function") {
      if (this.factory = t(this.updateState, function() {
      }), this.widget = Nn(this.factory(this.widgetParams), e), this.getParentIndex().addWidgets([this.widget]), this.instantSearchInstance._initialResults && !this.instantSearchInstance.started) {
        if (typeof this.instantSearchInstance.__forceRender != "function") throw new Error("You are using server side rendering with <ais-instant-search> instead of <ais-instant-search-ssr>.");
        this.instantSearchInstance.__forceRender(this.widget, this.getParentIndex());
      }
    } else t !== !0 && zt(`You are using the InstantSearch widget mixin, but didn't provide a connector.
While this is technically possible, and will give you access to the Helper,
it's not the recommended way of making custom components.

If you want to disable this message, pass { connector: true } to the mixin.

Read more on using connectors: https://alg.li/vue-custom`);
  } }).beforeUnmount = function() {
    this.widget && this.getParentIndex().removeWidgets([this.widget]);
  }, r.watch = { widgetParams: { handler: function(n) {
    this.state = null, this.getParentIndex().removeWidgets([this.widget]), this.widget = Nn(this.factory(n), e), this.getParentIndex().addWidgets([this.widget]);
  }, deep: !0 } }, r.methods = { updateState: function(n, a) {
    n === void 0 && (n = {}), a || (this.state = n);
  } }, r;
}, gB = 0;
function mB(o) {
  o.dependsOn === "recommend" && (o.$$id = gB++);
}
function ng(o) {
  return o.toString().charAt(0).toUpperCase() + o.toString().slice(1);
}
function Fe() {
}
var Br = function(e, r) {
  return e;
}, il = Fe, de = Fe;
process.env.NODE_ENV === "development" && (il = function(e) {
  console.warn("[InstantSearch.js]: ".concat(e.trim()));
}, Br = function(e, r) {
  var t = !1;
  return function() {
    return t || (t = !0, process.env.NODE_ENV === "development" && il(r)), e.apply(void 0, arguments);
  };
}, de = function(e, r) {
  if (!e) {
    var t = de.cache[r];
    t || (de.cache[r] = !0, process.env.NODE_ENV === "development" && il(r));
  }
}, de.cache = {});
var fB = Object.keys;
function yB(o) {
  return bB(o) || FB(o) || v1(o) || hB();
}
function hB() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function FB(o) {
  if (typeof Symbol < "u" && o[Symbol.iterator] != null || o["@@iterator"] != null) return Array.from(o);
}
function bB(o) {
  if (Array.isArray(o)) return mu(o);
}
function ln(o, e) {
  return PB(o) || BB(o, e) || v1(o, e) || vB();
}
function vB() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function v1(o, e) {
  if (o) {
    if (typeof o == "string") return mu(o, e);
    var r = Object.prototype.toString.call(o).slice(8, -1);
    if (r === "Object" && o.constructor && (r = o.constructor.name), r === "Map" || r === "Set") return Array.from(o);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return mu(o, e);
  }
}
function mu(o, e) {
  (e == null || e > o.length) && (e = o.length);
  for (var r = 0, t = new Array(e); r < e; r++) t[r] = o[r];
  return t;
}
function BB(o, e) {
  var r = o == null ? null : typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (r != null) {
    var t, n, a, s, i = [], l = !0, c = !1;
    try {
      if (a = (r = r.call(o)).next, e !== 0) for (; !(l = (t = a.call(r)).done) && (i.push(t.value), i.length !== e); l = !0) ;
    } catch (u) {
      c = !0, n = u;
    } finally {
      try {
        if (!l && r.return != null && (s = r.return(), Object(s) !== s)) return;
      } finally {
        if (c) throw n;
      }
    }
    return i;
  }
}
function PB(o) {
  if (Array.isArray(o)) return o;
}
function wB(o) {
  switch (o) {
    case "range":
      return [];
    case "menu":
      return ["menu", "menuSelect"];
    default:
      return [o];
  }
}
var kB = {
  query: {
    connectors: ["connectSearchBox"],
    widgets: ["ais.searchBox", "ais.autocomplete", "ais.voiceSearch"]
  },
  refinementList: {
    connectors: ["connectRefinementList"],
    widgets: ["ais.refinementList"]
  },
  menu: {
    connectors: ["connectMenu"],
    widgets: ["ais.menu"]
  },
  hierarchicalMenu: {
    connectors: ["connectHierarchicalMenu"],
    widgets: ["ais.hierarchicalMenu"]
  },
  numericMenu: {
    connectors: ["connectNumericMenu"],
    widgets: ["ais.numericMenu"]
  },
  ratingMenu: {
    connectors: ["connectRatingMenu"],
    widgets: ["ais.ratingMenu"]
  },
  range: {
    connectors: ["connectRange"],
    widgets: ["ais.rangeInput", "ais.rangeSlider", "ais.range"]
  },
  toggle: {
    connectors: ["connectToggleRefinement"],
    widgets: ["ais.toggleRefinement"]
  },
  geoSearch: {
    connectors: ["connectGeoSearch"],
    widgets: ["ais.geoSearch"]
  },
  sortBy: {
    connectors: ["connectSortBy"],
    widgets: ["ais.sortBy"]
  },
  page: {
    connectors: ["connectPagination"],
    widgets: ["ais.pagination", "ais.infiniteHits"]
  },
  hitsPerPage: {
    connectors: ["connectHitsPerPage"],
    widgets: ["ais.hitsPerPage"]
  },
  configure: {
    connectors: ["connectConfigure"],
    widgets: ["ais.configure"]
  },
  places: {
    connectors: [],
    widgets: ["ais.places"]
  }
};
function B1(o) {
  var e = o.index, r = o.indexUiState, t = e.getWidgets().map(function(a) {
    return a.$$type;
  }).filter(Boolean), n = fB(r).reduce(function(a, s) {
    var i = kB[s];
    if (!i)
      return a;
    var l = i.widgets;
    return l && !l.some(function(c) {
      return t.includes(c);
    }) && a.push([s, {
      connectors: i.connectors,
      widgets: i.widgets.map(function(c) {
        return c.split("ais.")[1];
      })
    }]), a;
  }, []);
  process.env.NODE_ENV === "development" && de(n.length === 0, 'The UI state for the index "'.concat(e.getIndexId(), '" is not consistent with the widgets mounted.\n\nThis can happen when the UI state is specified via `initialUiState`, `routing` or `setUiState` but that the widgets responsible for this state were not added. This results in those query parameters not being sent to the API.\n\nTo fully reflect the state, some widgets need to be added to the index "').concat(e.getIndexId(), `":

`).concat(n.map(function(a) {
    var s, i = ln(a, 2), l = i[0], c = i[1].widgets;
    return "- `".concat(l, "` needs one of these widgets: ").concat((s = []).concat.apply(s, yB(c.map(function(u) {
      return wB(u);
    }))).map(function(u) {
      return '"'.concat(u, '"');
    }).join(", "));
  }).join(`
`), `

If you do not wish to display widgets but still want to support their search parameters, you can mount "virtual widgets" that don't render anything:

\`\`\`
`).concat(n.filter(function(a) {
    var s = ln(a, 2);
    s[0];
    var i = s[1].connectors;
    return i.length > 0;
  }).map(function(a) {
    var s = ln(a, 2);
    s[0];
    var i = s[1], l = i.connectors, c = i.widgets, u = ng(c[0]), f = l[0];
    return "const virtual".concat(u, " = ").concat(f, "(() => null);");
  }).join(`
`), `

search.addWidgets([
  `).concat(n.filter(function(a) {
    var s = ln(a, 2);
    s[0];
    var i = s[1].connectors;
    return i.length > 0;
  }).map(function(a) {
    var s = ln(a, 2);
    s[0];
    var i = s[1].widgets, l = ng(i[0]);
    return "virtual".concat(l, "({ /* ... */ })");
  }).join(`,
  `), `
]);
\`\`\`

If you're using custom widgets that do set these query parameters, we recommend using connectors instead.

See https://www.algolia.com/doc/guides/building-search-ui/widgets/customize-an-existing-widget/js/#customize-the-complete-ui-of-the-widgets`));
}
function P1(o) {
  return Object.prototype.toString.call(o).slice(8, -1);
}
function Ie(o, e) {
  if (o === void 0 || typeof o != "function")
    throw new Error("The render function is not valid (received type ".concat(P1(o), `).

`).concat(e));
}
function ag(o) {
  var e = o.helper, r = o.attributesToClear, t = r === void 0 ? [] : r, n = e.state.setPage(0);
  return n = t.reduce(function(a, s) {
    return n.isNumericRefined(s) ? a.removeNumericRefinement(s) : n.isHierarchicalFacet(s) ? a.removeHierarchicalFacetRefinement(s) : n.isDisjunctiveFacet(s) ? a.removeDisjunctiveFacetRefinement(s) : n.isConjunctiveFacet(s) ? a.removeFacetRefinement(s) : a;
  }, n), t.indexOf("query") !== -1 && (n = n.setQuery("")), n;
}
var DB = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;"
}, w1 = /[&<>"']/g, SB = RegExp(w1.source);
function AB(o) {
  return o && SB.test(o) ? o.replace(w1, function(e) {
    return DB[e];
  }) : o;
}
var EB = {
  "&amp;": "&",
  "&lt;": "<",
  "&gt;": ">",
  "&quot;": '"',
  "&#39;": "'"
}, k1 = /&(amp|quot|lt|gt|#39);/g, xB = RegExp(k1.source);
function D1(o) {
  return o && xB.test(o) ? o.replace(k1, function(e) {
    return EB[e];
  }) : o;
}
function fu(o) {
  "@babel/helpers - typeof";
  return fu = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, fu(o);
}
function CB(o) {
  return o === null ? o === void 0 ? "[object Undefined]" : "[object Null]" : Object.prototype.toString.call(o);
}
function OB(o) {
  return fu(o) === "object" && o !== null;
}
function S1(o) {
  if (!OB(o) || CB(o) !== "[object Object]")
    return !1;
  if (Object.getPrototypeOf(o) === null)
    return !0;
  for (var e = o; Object.getPrototypeOf(e) !== null; )
    e = Object.getPrototypeOf(e);
  return Object.getPrototypeOf(o) === e;
}
function Vn(o) {
  "@babel/helpers - typeof";
  return Vn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Vn(o);
}
function TB(o) {
  if (o == null) throw new TypeError("Cannot destructure " + o);
}
function yu() {
  return yu = Object.assign ? Object.assign.bind() : function(o) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var t in r)
        Object.prototype.hasOwnProperty.call(r, t) && (o[t] = r[t]);
    }
    return o;
  }, yu.apply(this, arguments);
}
function sg(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function Wt(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? sg(Object(r), !0).forEach(function(t) {
      A1(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : sg(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function A1(o, e, r) {
  return e = LB(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function LB(o) {
  var e = jB(o, "string");
  return Vn(e) == "symbol" ? e : String(e);
}
function jB(o, e) {
  if (Vn(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (Vn(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
var nr = {
  highlightPreTag: "__ais-highlight__",
  highlightPostTag: "__/ais-highlight__"
}, io = {
  highlightPreTag: "<mark>",
  highlightPostTag: "</mark>"
};
function E1(o) {
  return AB(o).replace(new RegExp(nr.highlightPreTag, "g"), io.highlightPreTag).replace(new RegExp(nr.highlightPostTag, "g"), io.highlightPostTag);
}
function Js(o) {
  return S1(o) && typeof o.value != "string" ? Object.keys(o).reduce(function(e, r) {
    return Wt(Wt({}, e), {}, A1({}, r, Js(o[r])));
  }, {}) : Array.isArray(o) ? o.map(Js) : Wt(Wt({}, o), {}, {
    value: E1(o.value)
  });
}
function Ei(o) {
  return o.__escaped === void 0 && (o = o.map(function(e) {
    var r = yu({}, (TB(e), e));
    return r._highlightResult && (r._highlightResult = Js(r._highlightResult)), r._snippetResult && (r._snippetResult = Js(r._snippetResult)), r;
  }), o.__escaped = !0), o;
}
function MB(o) {
  return o.map(function(e) {
    return Wt(Wt({}, e), {}, {
      highlighted: E1(e.highlighted)
    });
  });
}
function x1(o) {
  var e = io.highlightPreTag, r = io.highlightPostTag;
  return o.map(function(t) {
    return t.isHighlighted ? e + t.value + r : t.value;
  }).join("");
}
function WB() {
  var o = -1, e = -1, r = void 0;
  return function(n) {
    var a = ++o;
    return Promise.resolve(n).then(function(s) {
      return r && a < e ? r : (e = a, r = s, s);
    });
  };
}
function NB(o, e, r) {
  return o.state.isHierarchicalFacet(e) ? o.state.isHierarchicalFacetRefined(e, r) : o.state.isConjunctiveFacet(e) ? o.state.isFacetRefined(e, r) : o.state.isDisjunctiveFacetRefined(e, r);
}
function ig(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function VB(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? ig(Object(r), !0).forEach(function(t) {
      zB(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : ig(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function zB(o, e, r) {
  return e = IB(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function IB(o) {
  var e = RB(o, "string");
  return Yt(e) == "symbol" ? e : String(e);
}
function RB(o, e) {
  if (Yt(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (Yt(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
function Yt(o) {
  "@babel/helpers - typeof";
  return Yt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Yt(o);
}
function HB(o, e) {
  return XB(o) || GB(o, e) || qB(o, e) || YB();
}
function YB() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function qB(o, e) {
  if (o) {
    if (typeof o == "string") return lg(o, e);
    var r = Object.prototype.toString.call(o).slice(8, -1);
    if (r === "Object" && o.constructor && (r = o.constructor.name), r === "Map" || r === "Set") return Array.from(o);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return lg(o, e);
  }
}
function lg(o, e) {
  (e == null || e > o.length) && (e = o.length);
  for (var r = 0, t = new Array(e); r < e; r++) t[r] = o[r];
  return t;
}
function GB(o, e) {
  var r = o == null ? null : typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (r != null) {
    var t, n, a, s, i = [], l = !0, c = !1;
    try {
      if (a = (r = r.call(o)).next, e !== 0) for (; !(l = (t = a.call(r)).done) && (i.push(t.value), i.length !== e); l = !0) ;
    } catch (u) {
      c = !0, n = u;
    } finally {
      try {
        if (!l && r.return != null && (s = r.return(), Object(s) !== s)) return;
      } finally {
        if (c) throw n;
      }
    }
    return i;
  }
}
function XB(o) {
  if (Array.isArray(o)) return o;
}
function Ep(o) {
  var e = o.instantSearchInstance, r = o.helper, t = o.attribute, n = o.widgetType, a = function() {
    for (var i = arguments.length, l = new Array(i), c = 0; c < i; c++)
      l[c] = arguments[c];
    var u = l[1], f = l[2], g = f === void 0 ? "Filter Applied" : f, d = l[3], p = d === void 0 ? {} : d, m = l[0].split(":"), y = HB(m, 2), h = y[0], F = y[1], b = typeof t == "string" ? t : t(u);
    if (l.length === 1 && Yt(l[0]) === "object")
      e.sendEventToInsights(l[0]);
    else if (h === "click" && l.length >= 2 && l.length <= 4)
      NB(r, b, u) || e.sendEventToInsights({
        insightsMethod: "clickedFilters",
        widgetType: n,
        eventType: h,
        eventModifier: F,
        payload: VB({
          eventName: g,
          index: r.getIndex(),
          filters: ["".concat(b, ":").concat(u)]
        }, p),
        attribute: b
      });
    else if (process.env.NODE_ENV === "development")
      throw new Error(`You need to pass between two and four arguments like:
  sendEvent('click', facetValue, eventName?, additionalData?);

If you want to send a custom payload, you can pass one object: sendEvent(customPayload);
`);
  };
  return a;
}
function C1(o) {
  return btoa(encodeURIComponent(JSON.stringify(o)));
}
function cg(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function ll(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? cg(Object(r), !0).forEach(function(t) {
      UB(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : cg(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function UB(o, e, r) {
  return e = ZB(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function ZB(o) {
  var e = KB(o, "string");
  return qt(e) == "symbol" ? e : String(e);
}
function KB(o, e) {
  if (qt(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (qt(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
function QB(o, e) {
  return eP(o) || $B(o, e) || _B(o, e) || JB();
}
function JB() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _B(o, e) {
  if (o) {
    if (typeof o == "string") return ug(o, e);
    var r = Object.prototype.toString.call(o).slice(8, -1);
    if (r === "Object" && o.constructor && (r = o.constructor.name), r === "Map" || r === "Set") return Array.from(o);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return ug(o, e);
  }
}
function ug(o, e) {
  (e == null || e > o.length) && (e = o.length);
  for (var r = 0, t = new Array(e); r < e; r++) t[r] = o[r];
  return t;
}
function $B(o, e) {
  var r = o == null ? null : typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (r != null) {
    var t, n, a, s, i = [], l = !0, c = !1;
    try {
      if (a = (r = r.call(o)).next, e !== 0) for (; !(l = (t = a.call(r)).done) && (i.push(t.value), i.length !== e); l = !0) ;
    } catch (u) {
      c = !0, n = u;
    } finally {
      try {
        if (!l && r.return != null && (s = r.return(), Object(s) !== s)) return;
      } finally {
        if (c) throw n;
      }
    }
    return i;
  }
}
function eP(o) {
  if (Array.isArray(o)) return o;
}
function qt(o) {
  "@babel/helpers - typeof";
  return qt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, qt(o);
}
function oP(o) {
  for (var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 20, r = [], t = 0; t < Math.ceil(o.length / e); t++)
    r.push(o.slice(t * e, (t + 1) * e));
  return r;
}
function O1(o) {
  var e = o.getIndex, r = o.widgetType, t = o.methodName, n = o.args, a = o.instantSearchInstance;
  if (n.length === 1 && qt(n[0]) === "object")
    return [n[0]];
  var s = n[0].split(":"), i = QB(s, 2), l = i[0], c = i[1], u = n[1], f = n[2], g = n[3] || {};
  if (!u) {
    if (process.env.NODE_ENV === "development")
      throw new Error(`You need to pass hit or hits as the second argument like:
  `.concat(t, `(eventType, hit);
  `));
    return [];
  }
  if ((l === "click" || l === "conversion") && !f) {
    if (process.env.NODE_ENV === "development")
      throw new Error(`You need to pass eventName as the third argument for 'click' or 'conversion' events like:
  `.concat(t, `('click', hit, 'Product Purchased');

  To learn more about event naming: https://www.algolia.com/doc/guides/getting-insights-and-analytics/search-analytics/click-through-and-conversions/in-depth/clicks-conversions-best-practices/
  `));
    return [];
  }
  var d = Array.isArray(u) ? u : [u];
  if (d.length === 0)
    return [];
  var p = d[0].__queryID, m = oP(d), y = m.map(function(F) {
    return F.map(function(b) {
      return b.objectID;
    });
  }), h = m.map(function(F) {
    return F.map(function(b) {
      return b.__position;
    });
  });
  if (l === "view")
    return a.status !== "idle" ? [] : m.map(function(F, b) {
      return {
        insightsMethod: "viewedObjectIDs",
        widgetType: r,
        eventType: l,
        payload: ll({
          eventName: f || "Hits Viewed",
          index: e(),
          objectIDs: y[b]
        }, g),
        hits: F,
        eventModifier: c
      };
    });
  if (l === "click")
    return m.map(function(F, b) {
      return {
        insightsMethod: "clickedObjectIDsAfterSearch",
        widgetType: r,
        eventType: l,
        payload: ll({
          eventName: f || "Hit Clicked",
          index: e(),
          queryID: p,
          objectIDs: y[b],
          positions: h[b]
        }, g),
        hits: F,
        eventModifier: c
      };
    });
  if (l === "conversion")
    return m.map(function(F, b) {
      return {
        insightsMethod: "convertedObjectIDsAfterSearch",
        widgetType: r,
        eventType: l,
        payload: ll({
          eventName: f || "Hit Converted",
          index: e(),
          queryID: p,
          objectIDs: y[b]
        }, g),
        hits: F,
        eventModifier: c
      };
    });
  if (process.env.NODE_ENV === "development")
    throw new Error('eventType("'.concat(l, `") is not supported.
    If you want to send a custom payload, you can pass one object: `).concat(t, `(customPayload);
    `));
  return [];
}
function xp(o) {
  var e = o.instantSearchInstance, r = o.getIndex, t = o.widgetType, n = {}, a = void 0, s = function() {
    for (var l = arguments.length, c = new Array(l), u = 0; u < l; u++)
      c[u] = arguments[u];
    var f = O1({
      widgetType: t,
      getIndex: r,
      methodName: "sendEvent",
      args: c,
      instantSearchInstance: e
    });
    f.forEach(function(g) {
      g.eventType === "click" && g.eventModifier === "internal" && n[g.eventType] || (n[g.eventType] = !0, e.sendEventToInsights(g));
    }), clearTimeout(a), a = setTimeout(function() {
      n = {};
    }, 0);
  };
  return s;
}
function T1(o) {
  var e = o.getIndex, r = o.widgetType, t = o.instantSearchInstance, n = function() {
    for (var s = arguments.length, i = new Array(s), l = 0; l < s; l++)
      i[l] = arguments[l];
    var c = O1({
      widgetType: r,
      getIndex: e,
      methodName: "bindEvent",
      args: i,
      instantSearchInstance: t
    });
    return c.length ? "data-insights-event=".concat(C1(c)) : "";
  };
  return n;
}
function Bo(o) {
  return o.$$type === "ais.index";
}
function hu(o, e) {
  var r = o[e.getIndexId()] || {};
  process.env.NODE_ENV === "development" && B1({
    index: e,
    indexUiState: r
  }), e.getHelper().setState(e.getWidgetSearchParameters(e.getHelper().state, {
    uiState: r
  })), e.getWidgets().filter(Bo).forEach(function(t) {
    return hu(o, t);
  });
}
function pg(o, e) {
  var r = null;
  return function() {
    for (var t = arguments.length, n = new Array(t), a = 0; a < t; a++)
      n[a] = arguments[a];
    return new Promise(function(s, i) {
      r && clearTimeout(r), r = setTimeout(function() {
        r = null, Promise.resolve(o.apply(void 0, n)).then(s).catch(i);
      }, e);
    });
  };
}
var rP = Promise.resolve();
function cn(o) {
  var e = null, r = !1, t = function() {
    for (var a = arguments.length, s = new Array(a), i = 0; i < a; i++)
      s[i] = arguments[i];
    e === null && (e = rP.then(function() {
      if (e = null, r) {
        r = !1;
        return;
      }
      o.apply(void 0, s);
    }));
  };
  return t.wait = function() {
    if (e === null)
      throw new Error("The deferred function should be called before calling `wait()`");
    return e;
  }, t.cancel = function() {
    e !== null && (r = !0);
  }, t;
}
function zn(o) {
  var e = o.name, r = o.connector, t = r === void 0 ? !1 : r;
  return ["https://www.algolia.com/doc/api-reference/widgets/", e, "/js/", t ? "#connector" : ""].join("");
}
function Te() {
  for (var o = arguments.length, e = new Array(o), r = 0; r < o; r++)
    e[r] = arguments[r];
  var t = e.map(function(n) {
    return zn(n);
  }).join(", ");
  return function(n) {
    return [n, "See documentation: ".concat(t)].filter(Boolean).join(`

`);
  };
}
function tP(o) {
  return typeof o == "string" ? o.replace(/^\\-/, "-") : o;
}
function yn(o) {
  return typeof o == "number" && o < 0 || typeof o == "string" ? String(o).replace(/^-/, "\\-") : o;
}
function fr(o, e) {
  for (var r, t = 0; t < o.length; t++)
    if (r = o[t], e(r, t, o))
      return r;
}
function nP(o, e) {
  if (!Array.isArray(o))
    return -1;
  for (var r = 0; r < o.length; r++)
    if (e(o[r]))
      return r;
  return -1;
}
function aP(o) {
  if (o.appId && o.apiKey)
    return [o.appId, o.apiKey];
  if (o.transporter) {
    var e = o.transporter, r = e.headers || e.baseHeaders, t = e.queryParameters || e.baseQueryParameters, n = "x-algolia-application-id", a = "x-algolia-api-key", s = r[n] || t[n], i = r[a] || t[a];
    return [s, i];
  } else
    return [o.applicationID, o.apiKey];
}
function Cp(o) {
  var e = io.highlightPostTag, r = io.highlightPreTag, t = o.split(r), n = t.shift(), a = n ? [{
    value: n,
    isHighlighted: !1
  }] : [];
  return t.forEach(function(s) {
    var i = s.split(e);
    a.push({
      value: i[0],
      isHighlighted: !0
    }), i[1] !== "" && a.push({
      value: i[1],
      isHighlighted: !1
    });
  }), a;
}
var sP = new RegExp(/\w/i);
function iP(o, e) {
  var r, t, n = o[e], a = ((r = o[e + 1]) === null || r === void 0 ? void 0 : r.isHighlighted) || !0, s = ((t = o[e - 1]) === null || t === void 0 ? void 0 : t.isHighlighted) || !0;
  return !sP.test(D1(n.value)) && s === a ? s : n.isHighlighted;
}
function rn(o, e) {
  var r = Array.isArray(e) ? e : e.split(".");
  return r.reduce(function(t, n) {
    return t && t[n];
  }, o);
}
function cl(o, e, r, t) {
  var n = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : [], a = {
    type: e,
    attribute: r,
    name: t,
    escapedValue: yn(t)
  }, s = fr(n, function(d) {
    return d.name === r;
  }), i;
  if (e === "hierarchical") {
    for (var l = o.getHierarchicalFacetByName(r), c = t.split(l.separator), u = function(p) {
      return function(m) {
        return p[m];
      };
    }, f = function(p) {
      s = s && s.data && fr(Object.keys(s.data).map(u(s.data)), function(m) {
        return m.name === c[p];
      });
    }, g = 0; s !== void 0 && g < c.length; ++g)
      f(g);
    i = s && s.count;
  } else
    i = s && s.data && s.data[a.name];
  return i !== void 0 && (a.count = i), s && s.exhaustive !== void 0 && (a.exhaustive = s.exhaustive), a;
}
function Op(o, e) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, t = o || {}, n = [], a = e.facetsRefinements, s = a === void 0 ? {} : a, i = e.facetsExcludes, l = i === void 0 ? {} : i, c = e.disjunctiveFacetsRefinements, u = c === void 0 ? {} : c, f = e.hierarchicalFacetsRefinements, g = f === void 0 ? {} : f, d = e.numericRefinements, p = d === void 0 ? {} : d, m = e.tagRefinements, y = m === void 0 ? [] : m;
  return Object.keys(s).forEach(function(h) {
    var F = s[h];
    F.forEach(function(b) {
      n.push(cl(e, "facet", h, b, t.facets));
    });
  }), Object.keys(l).forEach(function(h) {
    var F = l[h];
    F.forEach(function(b) {
      n.push({
        type: "exclude",
        attribute: h,
        name: b,
        exclude: !0
      });
    });
  }), Object.keys(u).forEach(function(h) {
    var F = u[h];
    F.forEach(function(b) {
      n.push(cl(
        e,
        "disjunctive",
        h,
        // We unescape any disjunctive refined values with `unescapeFacetValue` because
        // they can be escaped on negative numeric values with `escapeFacetValue`.
        tP(b),
        t.disjunctiveFacets
      ));
    });
  }), Object.keys(g).forEach(function(h) {
    var F = g[h];
    F.forEach(function(b) {
      n.push(cl(e, "hierarchical", h, b, t.hierarchicalFacets));
    });
  }), Object.keys(p).forEach(function(h) {
    var F = p[h];
    Object.keys(F).forEach(function(b) {
      var v = b, P = F[v], E = Array.isArray(P) ? P : [P];
      E.forEach(function(S) {
        n.push({
          type: "numeric",
          attribute: h,
          name: "".concat(S),
          numericValue: S,
          operator: v
        });
      });
    });
  }), y.forEach(function(h) {
    n.push({
      type: "tag",
      attribute: "_tags",
      name: h
    });
  }), r && e.query && e.query.trim() && n.push({
    attribute: "query",
    type: "query",
    name: e.query,
    query: e.query
  }), n;
}
function lP(o, e) {
  var r, t = (r = o.getWidgetRenderState) === null || r === void 0 ? void 0 : r.call(o, e), n = null;
  if (t && t.widgetParams) {
    var a = t.widgetParams;
    a.attribute ? n = a.attribute : Array.isArray(a.attributes) && (n = a.attributes[0]);
  }
  if (typeof n != "string")
    throw new Error(`Could not find the attribute of the widget:

`.concat(JSON.stringify(o), `

Please check whether the widget's getWidgetRenderState returns widgetParams.attribute correctly.`));
  return n;
}
function In(o) {
  "@babel/helpers - typeof";
  return In = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, In(o);
}
function dg(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function gg(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? dg(Object(r), !0).forEach(function(t) {
      cP(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : dg(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function cP(o, e, r) {
  return e = uP(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function uP(o) {
  var e = pP(o, "string");
  return In(e) == "symbol" ? e : String(e);
}
function pP(o, e) {
  if (In(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (In(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
function Tp(o, e, r) {
  return o.map(function(t, n) {
    return gg(gg({}, t), {}, {
      __position: r * e + n + 1
    });
  });
}
function Rn(o) {
  "@babel/helpers - typeof";
  return Rn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Rn(o);
}
function mg(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function fg(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? mg(Object(r), !0).forEach(function(t) {
      dP(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : mg(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function dP(o, e, r) {
  return e = gP(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function gP(o) {
  var e = mP(o, "string");
  return Rn(e) == "symbol" ? e : String(e);
}
function mP(o, e) {
  if (Rn(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (Rn(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
function Lp(o, e) {
  return e ? o.map(function(r) {
    return fg(fg({}, r), {}, {
      __queryID: e
    });
  }) : o;
}
function Hn(o) {
  "@babel/helpers - typeof";
  return Hn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Hn(o);
}
function yg(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function hg(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? yg(Object(r), !0).forEach(function(t) {
      fP(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : yg(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function fP(o, e, r) {
  return e = yP(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function yP(o) {
  var e = hP(o, "string");
  return Hn(e) == "symbol" ? e : String(e);
}
function hP(o, e) {
  if (Hn(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (Hn(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
function FP(o, e) {
  var r = Object.keys(e).reduce(function(t, n) {
    var a = e[n];
    return a.recommendResults ? hg(hg({}, t), a.recommendResults.results) : t;
  }, {});
  o._recommendCache = r;
}
function Yn(o) {
  "@babel/helpers - typeof";
  return Yn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Yn(o);
}
function bP(o, e) {
  return wP(o) || PP(o, e) || BP(o, e) || vP();
}
function vP() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function BP(o, e) {
  if (o) {
    if (typeof o == "string") return Fg(o, e);
    var r = Object.prototype.toString.call(o).slice(8, -1);
    if (r === "Object" && o.constructor && (r = o.constructor.name), r === "Map" || r === "Set") return Array.from(o);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Fg(o, e);
  }
}
function Fg(o, e) {
  (e == null || e > o.length) && (e = o.length);
  for (var r = 0, t = new Array(e); r < e; r++) t[r] = o[r];
  return t;
}
function PP(o, e) {
  var r = o == null ? null : typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (r != null) {
    var t, n, a, s, i = [], l = !0, c = !1;
    try {
      if (a = (r = r.call(o)).next, e !== 0) for (; !(l = (t = a.call(r)).done) && (i.push(t.value), i.length !== e); l = !0) ;
    } catch (u) {
      c = !0, n = u;
    } finally {
      try {
        if (!l && r.return != null && (s = r.return(), Object(s) !== s)) return;
      } finally {
        if (c) throw n;
      }
    }
    return i;
  }
}
function wP(o) {
  if (Array.isArray(o)) return o;
}
function bg(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function un(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? bg(Object(r), !0).forEach(function(t) {
      L1(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : bg(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function L1(o, e, r) {
  return e = kP(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function kP(o) {
  var e = DP(o, "string");
  return Yn(e) == "symbol" ? e : String(e);
}
function DP(o, e) {
  if (Yn(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (Yn(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
function SP(o, e) {
  if (e && !((!("transporter" in o) || o._cacheHydrated) && (!o._useCache || typeof o.addAlgoliaAgent != "function"))) {
    var r = [Object.keys(e).reduce(function(s, i) {
      var l = e[i], c = l.state, u = l.requestParams, f = l.results, g = f && c ? f.map(function(d, p) {
        return un({
          indexName: c.index || d.index
        }, u != null && u[p] || d.params ? {
          params: ul((u == null ? void 0 : u[p]) || AP(d.params))
        } : {});
      }) : [];
      return s.concat(g);
    }, [])], t = Object.keys(e).reduce(function(s, i) {
      var l = e[i].results;
      return l ? s.concat(l) : s;
    }, []);
    if ("transporter" in o && !o._cacheHydrated) {
      o._cacheHydrated = !0;
      var n = o.search.bind(o);
      o.search = function(s) {
        for (var i = arguments.length, l = new Array(i > 1 ? i - 1 : 0), c = 1; c < i; c++)
          l[c - 1] = arguments[c];
        var u = Array.isArray(s) ? (
          // search client
          s.map(function(f) {
            return un(un({}, f), {}, {
              params: ul(f.params)
            });
          })
        ) : (
          // composition client
          ul(s.requestBody.params)
        );
        return o.transporter.responsesCache.get({
          method: "search",
          args: [u].concat(l)
        }, function() {
          return n.apply(void 0, [s].concat(l));
        });
      }, o.transporter.responsesCache.set({
        method: "search",
        args: r
      }, {
        results: t
      });
    }
    if (!("transporter" in o)) {
      var a = "/1/indexes/*/queries_body_".concat(JSON.stringify({
        requests: r
      }));
      o.cache = un(un({}, o.cache), {}, L1({}, a, JSON.stringify({
        results: Object.keys(e).map(function(s) {
          return e[s].results;
        })
      })));
    }
  }
}
function AP(o) {
  return o.split("&").reduce(function(e, r) {
    var t = r.split("="), n = bP(t, 2), a = n[0], s = n[1];
    return e[a] = s ? decodeURIComponent(s) : "", e;
  }, {});
}
function ul(o) {
  var e = function(n) {
    return Object.prototype.toString.call(n) === "[object Object]" || Object.prototype.toString.call(n) === "[object Array]";
  }, r = function(n) {
    for (var a = arguments.length, s = new Array(a > 1 ? a - 1 : 0), i = 1; i < a; i++)
      s[i - 1] = arguments[i];
    var l = 0;
    return n.replace(/%s/g, function() {
      return encodeURIComponent(s[l++]);
    });
  };
  return Object.keys(o).map(function(t) {
    return r("%s=%s", t, e(o[t]) ? JSON.stringify(o[t]) : o[t]);
  }).join("&");
}
function vg(o) {
  return o !== Object(o);
}
function yt(o, e) {
  if (o === e)
    return !0;
  if (vg(o) || vg(e) || typeof o == "function" || typeof e == "function")
    return o === e;
  if (Object.keys(o).length !== Object.keys(e).length)
    return !1;
  for (var r = 0, t = Object.keys(o); r < t.length; r++) {
    var n = t[r];
    if (!(n in e) || !yt(o[n], e[n]))
      return !1;
  }
  return !0;
}
function Ee(o) {
  return typeof o == "number" && isFinite(o);
}
function j1(o, e) {
  e(o), o.getWidgets().forEach(function(r) {
    Bo(r) && j1(r, e);
  });
}
function jp(o) {
  return o.filter(function(e, r, t) {
    return t.indexOf(e) === r;
  });
}
function qn(o) {
  "@babel/helpers - typeof";
  return qn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, qn(o);
}
var EP = ["facets", "disjunctiveFacets", "facetsRefinements", "facetsExcludes", "disjunctiveFacetsRefinements", "numericRefinements", "tagRefinements", "hierarchicalFacets", "hierarchicalFacetsRefinements", "ruleContexts"];
function Bg(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function ar(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Bg(Object(r), !0).forEach(function(t) {
      xP(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : Bg(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function xP(o, e, r) {
  return e = CP(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function CP(o) {
  var e = OP(o, "string");
  return qn(e) == "symbol" ? e : String(e);
}
function OP(o, e) {
  if (qn(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (qn(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
function TP(o, e) {
  if (o == null) return {};
  var r = LP(o, e), t, n;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(o);
    for (n = 0; n < a.length; n++)
      t = a[n], !(e.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(o, t) && (r[t] = o[t]);
  }
  return r;
}
function LP(o, e) {
  if (o == null) return {};
  var r = {}, t = Object.keys(o), n, a;
  for (a = 0; a < t.length; a++)
    n = t[a], !(e.indexOf(n) >= 0) && (r[n] = o[n]);
  return r;
}
var jP = function(e, r) {
  r.facets, r.disjunctiveFacets, r.facetsRefinements, r.facetsExcludes, r.disjunctiveFacetsRefinements, r.numericRefinements, r.tagRefinements, r.hierarchicalFacets, r.hierarchicalFacetsRefinements, r.ruleContexts;
  var t = TP(r, EP);
  return e.setQueryParameters(t);
}, MP = function(e, r) {
  return r.facets.reduce(function(t, n) {
    return t.addFacet(n);
  }, e);
}, WP = function(e, r) {
  return r.disjunctiveFacets.reduce(function(t, n) {
    return t.addDisjunctiveFacet(n);
  }, e);
}, NP = function(e, r) {
  return e.setQueryParameters({
    hierarchicalFacets: r.hierarchicalFacets.reduce(function(t, n) {
      var a = nP(t, function(i) {
        return i.name === n.name;
      });
      if (a === -1)
        return t.concat(n);
      var s = t.slice();
      return s.splice(a, 1, n), s;
    }, e.hierarchicalFacets)
  });
}, VP = function(e, r) {
  return r.tagRefinements.reduce(function(t, n) {
    return t.addTagRefinement(n);
  }, e);
}, zP = function(e, r) {
  return e.setQueryParameters({
    facetsRefinements: ar(ar({}, e.facetsRefinements), r.facetsRefinements)
  });
}, IP = function(e, r) {
  return e.setQueryParameters({
    facetsExcludes: ar(ar({}, e.facetsExcludes), r.facetsExcludes)
  });
}, RP = function(e, r) {
  return e.setQueryParameters({
    disjunctiveFacetsRefinements: ar(ar({}, e.disjunctiveFacetsRefinements), r.disjunctiveFacetsRefinements)
  });
}, HP = function(e, r) {
  return e.setQueryParameters({
    numericRefinements: ar(ar({}, e.numericRefinements), r.numericRefinements)
  });
}, YP = function(e, r) {
  return e.setQueryParameters({
    hierarchicalFacetsRefinements: ar(ar({}, e.hierarchicalFacetsRefinements), r.hierarchicalFacetsRefinements)
  });
}, qP = function(e, r) {
  var t = jp([].concat(e.ruleContexts).concat(r.ruleContexts).filter(Boolean));
  return t.length > 0 ? e.setQueryParameters({
    ruleContexts: t
  }) : e;
}, An = function() {
  for (var e = arguments.length, r = new Array(e), t = 0; t < e; t++)
    r[t] = arguments[t];
  return r.reduce(function(n, a) {
    var s = YP(n, a), i = NP(s, a), l = VP(i, a), c = HP(l, a), u = RP(c, a), f = IP(u, a), g = zP(f, a), d = WP(g, a), p = qP(d, a), m = MP(p, a);
    return jP(m, a);
  });
};
function GP(o) {
  return KP(o) || ZP(o) || UP(o) || XP();
}
function XP() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function UP(o, e) {
  if (o) {
    if (typeof o == "string") return Fu(o, e);
    var r = Object.prototype.toString.call(o).slice(8, -1);
    if (r === "Object" && o.constructor && (r = o.constructor.name), r === "Map" || r === "Set") return Array.from(o);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Fu(o, e);
  }
}
function ZP(o) {
  if (typeof Symbol < "u" && o[Symbol.iterator] != null || o["@@iterator"] != null) return Array.from(o);
}
function KP(o) {
  if (Array.isArray(o)) return Fu(o);
}
function Fu(o, e) {
  (e == null || e > o.length) && (e = o.length);
  for (var r = 0, t = new Array(e); r < e; r++) t[r] = o[r];
  return t;
}
function Pg(o) {
  var e = o.start, r = e === void 0 ? 0 : e, t = o.end, n = o.step, a = n === void 0 ? 1 : n, s = a === 0 ? 1 : a, i = Math.round((t - r) / s);
  return GP(Array(i)).map(function(l, c) {
    return r + c * s;
  });
}
function hn(o, e, r) {
  var t = e.getHelper();
  return {
    uiState: r,
    helper: t,
    parent: e,
    instantSearchInstance: o,
    state: t.state,
    renderState: o.renderState,
    templatesConfig: o.templatesConfig,
    createURL: e.createURL,
    scopedResults: [],
    searchMetadata: {
      isSearchStalled: o.status === "stalled"
    },
    status: o.status,
    error: o.error
  };
}
function wg(o, e, r) {
  var t = e.getResultsForWidget(r), n = e.getHelper();
  return {
    helper: n,
    parent: e,
    instantSearchInstance: o,
    results: t,
    scopedResults: e.getScopedResults(),
    state: t && "_state" in t ? t._state : n.state,
    renderState: o.renderState,
    templatesConfig: o.templatesConfig,
    createURL: e.createURL,
    searchMetadata: {
      isSearchStalled: o.status === "stalled"
    },
    status: o.status,
    error: o.error
  };
}
function QP(o) {
  for (var e = o.getParent(), r = [o.getHelper().state]; e !== null; )
    r = [e.getHelper().state].concat(r), e = e.getParent();
  return r;
}
function Gn(o) {
  "@babel/helpers - typeof";
  return Gn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Gn(o);
}
function kg(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function ps(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? kg(Object(r), !0).forEach(function(t) {
      JP(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : kg(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function JP(o, e, r) {
  return e = _P(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function _P(o) {
  var e = $P(o, "string");
  return Gn(e) == "symbol" ? e : String(e);
}
function $P(o, e) {
  if (Gn(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (Gn(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
function M1(o) {
  return o.some(function(e) {
    return e.isHighlighted;
  }) ? o.map(function(e, r) {
    return ps(ps({}, e), {}, {
      isHighlighted: !iP(o, r)
    });
  }) : o.map(function(e) {
    return ps(ps({}, e), {}, {
      isHighlighted: !1
    });
  });
}
function _o(o) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    fallback: function() {
    }
  }, r = e.fallback;
  return typeof window > "u" ? r() : o({
    window
  });
}
function pl(o) {
  return Array.isArray(o) ? o : [o];
}
function Xn(o) {
  "@babel/helpers - typeof";
  return Xn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Xn(o);
}
function Dg(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function To(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Dg(Object(r), !0).forEach(function(t) {
      ew(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : Dg(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function ew(o, e, r) {
  return e = ow(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function ow(o) {
  var e = rw(o, "string");
  return Xn(e) == "symbol" ? e : String(e);
}
function rw(o, e) {
  if (Xn(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (Xn(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
function tw(o) {
  return typeof o.findAnswers == "function";
}
var ds = Te({
  name: "answers",
  connector: !0
}), nw = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Fe;
  return Ie(e, ds()), function(t) {
    var n = t || {}, a = n.queryLanguages, s = n.attributesForPrediction, i = n.nbHits, l = i === void 0 ? 1 : i, c = n.renderDebounceTime, u = c === void 0 ? 100 : c, f = n.searchDebounceTime, g = f === void 0 ? 100 : f, d = n.escapeHTML, p = d === void 0 ? !0 : d, m = n.extraParameters, y = m === void 0 ? {} : m;
    if (!a || a.length === 0)
      throw new Error(ds("The `queryLanguages` expects an array of strings."));
    var h = WB(), F = [], b = !1, v = pg(e, u), P;
    return {
      $$type: "ais.answers",
      init: function(S) {
        var D = S.state, w = S.instantSearchInstance;
        if (typeof w.client.initIndex != "function")
          throw new Error(ds("`algoliasearch` <5 required."));
        var A = w.client.initIndex(D.index);
        if (!tw(A))
          throw new Error(ds("`algoliasearch` >= 4.8.0 required."));
        P = pg(A.findAnswers, g), e(To(To({}, this.getWidgetRenderState(S)), {}, {
          instantSearchInstance: S.instantSearchInstance
        }), !0);
      },
      render: function(S) {
        var D = this, w = S.state.query;
        if (!w) {
          F = [], b = !1, e(To(To({}, this.getWidgetRenderState(S)), {}, {
            instantSearchInstance: S.instantSearchInstance
          }), !1);
          return;
        }
        F = [], b = !0, e(To(To({}, this.getWidgetRenderState(S)), {}, {
          instantSearchInstance: S.instantSearchInstance
        }), !1), h(P(w, a, To(To({}, y), {}, {
          nbHits: l,
          attributesForPrediction: s
        }))).then(function(A) {
          if (A) {
            p && A.hits.length > 0 && (A.hits = Ei(A.hits));
            var C = Tp(A.hits, 0, l), x = Lp(C, A.queryID);
            F = x, b = !1, v(To(To({}, D.getWidgetRenderState(S)), {}, {
              instantSearchInstance: S.instantSearchInstance
            }), !1);
          }
        });
      },
      getRenderState: function(S, D) {
        return To(To({}, S), {}, {
          answers: this.getWidgetRenderState(D)
        });
      },
      getWidgetRenderState: function() {
        return {
          hits: F,
          isLoading: b,
          widgetParams: t
        };
      },
      dispose: function(S) {
        var D = S.state;
        return r(), D;
      },
      getWidgetSearchParameters: function(S) {
        return S;
      }
    };
  };
};
function qr(o) {
  return o && o.__esModule && Object.prototype.hasOwnProperty.call(o, "default") ? o.default : o;
}
var dl, Sg;
function Mp() {
  if (Sg) return dl;
  Sg = 1;
  function o() {
    this._events = this._events || {}, this._maxListeners = this._maxListeners || void 0;
  }
  dl = o, o.prototype._events = void 0, o.prototype._maxListeners = void 0, o.defaultMaxListeners = 10, o.prototype.setMaxListeners = function(a) {
    if (!r(a) || a < 0 || isNaN(a))
      throw TypeError("n must be a positive number");
    return this._maxListeners = a, this;
  }, o.prototype.emit = function(a) {
    var s, i, l, c, u, f;
    if (this._events || (this._events = {}), a === "error" && (!this._events.error || t(this._events.error) && !this._events.error.length)) {
      if (s = arguments[1], s instanceof Error)
        throw s;
      var g = new Error('Uncaught, unspecified "error" event. (' + s + ")");
      throw g.context = s, g;
    }
    if (i = this._events[a], n(i))
      return !1;
    if (e(i))
      switch (arguments.length) {
        // fast cases
        case 1:
          i.call(this);
          break;
        case 2:
          i.call(this, arguments[1]);
          break;
        case 3:
          i.call(this, arguments[1], arguments[2]);
          break;
        // slower
        default:
          c = Array.prototype.slice.call(arguments, 1), i.apply(this, c);
      }
    else if (t(i))
      for (c = Array.prototype.slice.call(arguments, 1), f = i.slice(), l = f.length, u = 0; u < l; u++)
        f[u].apply(this, c);
    return !0;
  }, o.prototype.addListener = function(a, s) {
    var i;
    if (!e(s))
      throw TypeError("listener must be a function");
    return this._events || (this._events = {}), this._events.newListener && this.emit(
      "newListener",
      a,
      e(s.listener) ? s.listener : s
    ), this._events[a] ? t(this._events[a]) ? this._events[a].push(s) : this._events[a] = [this._events[a], s] : this._events[a] = s, t(this._events[a]) && !this._events[a].warned && (n(this._maxListeners) ? i = o.defaultMaxListeners : i = this._maxListeners, i && i > 0 && this._events[a].length > i && (this._events[a].warned = !0, console.error(
      "(node) warning: possible EventEmitter memory leak detected. %d listeners added. Use emitter.setMaxListeners() to increase limit.",
      this._events[a].length
    ), typeof console.trace == "function" && console.trace())), this;
  }, o.prototype.on = o.prototype.addListener, o.prototype.once = function(a, s) {
    if (!e(s))
      throw TypeError("listener must be a function");
    var i = !1;
    function l() {
      this.removeListener(a, l), i || (i = !0, s.apply(this, arguments));
    }
    return l.listener = s, this.on(a, l), this;
  }, o.prototype.removeListener = function(a, s) {
    var i, l, c, u;
    if (!e(s))
      throw TypeError("listener must be a function");
    if (!this._events || !this._events[a])
      return this;
    if (i = this._events[a], c = i.length, l = -1, i === s || e(i.listener) && i.listener === s)
      delete this._events[a], this._events.removeListener && this.emit("removeListener", a, s);
    else if (t(i)) {
      for (u = c; u-- > 0; )
        if (i[u] === s || i[u].listener && i[u].listener === s) {
          l = u;
          break;
        }
      if (l < 0)
        return this;
      i.length === 1 ? (i.length = 0, delete this._events[a]) : i.splice(l, 1), this._events.removeListener && this.emit("removeListener", a, s);
    }
    return this;
  }, o.prototype.removeAllListeners = function(a) {
    var s, i;
    if (!this._events)
      return this;
    if (!this._events.removeListener)
      return arguments.length === 0 ? this._events = {} : this._events[a] && delete this._events[a], this;
    if (arguments.length === 0) {
      for (s in this._events)
        s !== "removeListener" && this.removeAllListeners(s);
      return this.removeAllListeners("removeListener"), this._events = {}, this;
    }
    if (i = this._events[a], e(i))
      this.removeListener(a, i);
    else if (i)
      for (; i.length; )
        this.removeListener(a, i[i.length - 1]);
    return delete this._events[a], this;
  }, o.prototype.listeners = function(a) {
    var s;
    return !this._events || !this._events[a] ? s = [] : e(this._events[a]) ? s = [this._events[a]] : s = this._events[a].slice(), s;
  }, o.prototype.listenerCount = function(a) {
    if (this._events) {
      var s = this._events[a];
      if (e(s))
        return 1;
      if (s)
        return s.length;
    }
    return 0;
  }, o.listenerCount = function(a, s) {
    return a.listenerCount(s);
  };
  function e(a) {
    return typeof a == "function";
  }
  function r(a) {
    return typeof a == "number";
  }
  function t(a) {
    return typeof a == "object" && a !== null;
  }
  function n(a) {
    return a === void 0;
  }
  return dl;
}
var gl, Ag;
function W1() {
  if (Ag) return gl;
  Ag = 1;
  function o(e, r) {
    e.prototype = Object.create(r.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    });
  }
  return gl = o, gl;
}
var ml, Eg;
function aw() {
  if (Eg) return ml;
  Eg = 1;
  var o = Mp(), e = W1();
  function r(t, n, a) {
    this.main = t, this.fn = n, this.recommendFn = a, this.lastResults = null, this.lastRecommendResults = null;
  }
  return e(r, o), r.prototype.detach = function() {
    this.removeAllListeners(), this.main.detachDerivedHelper(this);
  }, r.prototype.getModifiedState = function(t) {
    return this.fn(t);
  }, r.prototype.getModifiedRecommendState = function(t) {
    return this.recommendFn(t);
  }, ml = r, ml;
}
var fl, xg;
function Wp() {
  if (xg) return fl;
  xg = 1;
  function o(r) {
    return typeof r != "string" ? r : String(r).replace(/^-/, "\\-");
  }
  function e(r) {
    return typeof r != "string" ? r : r.replace(/^\\-/, "-");
  }
  return fl = {
    escapeFacetValue: o,
    unescapeFacetValue: e
  }, fl;
}
var yl, Cg;
function Np() {
  if (Cg) return yl;
  Cg = 1;
  function o(n) {
    return typeof n == "object" && n !== null ? r(Array.isArray(n) ? [] : {}, n) : n;
  }
  function e(n) {
    return typeof n == "function" || Array.isArray(n) || Object.prototype.toString.call(n) === "[object Object]";
  }
  function r(n, a) {
    if (n === a)
      return n;
    for (var s in a)
      if (!(!Object.prototype.hasOwnProperty.call(a, s) || s === "__proto__" || s === "constructor")) {
        var i = a[s], l = n[s];
        typeof l < "u" && typeof i > "u" || (e(l) && e(i) ? n[s] = r(l, i) : n[s] = o(i));
      }
    return n;
  }
  function t(n) {
    e(n) || (n = {});
    for (var a = 1, s = arguments.length; a < s; a++) {
      var i = arguments[a];
      e(i) && r(n, i);
    }
    return n;
  }
  return yl = t, yl;
}
var hl, Og;
function Vp() {
  if (Og) return hl;
  Og = 1;
  function o(e) {
    return e && Object.keys(e).length > 0;
  }
  return hl = o, hl;
}
var Fl, Tg;
function zp() {
  if (Tg) return Fl;
  Tg = 1;
  function o(e, r) {
    if (e === null) return {};
    var t = {}, n = Object.keys(e), a, s;
    for (s = 0; s < n.length; s++)
      a = n[s], !(r.indexOf(a) >= 0) && (t[a] = e[a]);
    return t;
  }
  return Fl = o, Fl;
}
var bl, Lg;
function N1() {
  if (Lg) return bl;
  Lg = 1;
  function o(e) {
    e = e || {}, this.params = e.params || [];
  }
  return o.prototype = {
    constructor: o,
    addParams: function(e) {
      var r = this.params.slice();
      return r.push(e), new o({ params: r });
    },
    removeParams: function(e) {
      return new o({
        params: this.params.filter(function(r) {
          return r.$$id !== e;
        })
      });
    },
    addFrequentlyBoughtTogether: function(e) {
      return this.addParams(
        Object.assign({}, e, { model: "bought-together" })
      );
    },
    addRelatedProducts: function(e) {
      return this.addParams(
        Object.assign({}, e, { model: "related-products" })
      );
    },
    addTrendingItems: function(e) {
      return this.addParams(
        Object.assign({}, e, { model: "trending-items" })
      );
    },
    addTrendingFacets: function(e) {
      return this.addParams(
        Object.assign({}, e, { model: "trending-facets" })
      );
    },
    addLookingSimilar: function(e) {
      return this.addParams(
        Object.assign({}, e, { model: "looking-similar" })
      );
    },
    _buildQueries: function(e, r) {
      return this.params.filter(function(t) {
        return r[t.$$id] === void 0;
      }).map(function(t) {
        var n = Object.assign({}, t, {
          indexName: e,
          // @TODO: remove this if it ever gets handled by the API
          threshold: t.threshold || 0
        });
        return delete n.$$id, n;
      });
    }
  }, bl = o, bl;
}
var vl, jg;
function V1() {
  if (jg) return vl;
  jg = 1;
  function o(e, r) {
    this._state = e, this._rawResults = {};
    var t = this;
    e.params.forEach(function(n) {
      var a = n.$$id;
      t[a] = r[a], t._rawResults[a] = r[a];
    });
  }
  return o.prototype = {
    constructor: o
  }, vl = o, vl;
}
var Bl, Mg;
function sw() {
  if (Mg) return Bl;
  Mg = 1;
  var o = Np();
  function e(t) {
    return Object.keys(t).sort().reduce(function(n, a) {
      return n[a] = t[a], n;
    }, {});
  }
  var r = {
    /**
     * Get all the queries to send to the client, those queries can used directly
     * with the Algolia client.
     * @private
     * @param  {string} index The name of the index
     * @param  {SearchParameters} state The state from which to get the queries
     * @return {object[]} The queries
     */
    _getQueries: function(n, a) {
      var s = [];
      return s.push({
        indexName: n,
        params: r._getHitsSearchParams(a)
      }), a.getRefinedDisjunctiveFacets().forEach(function(i) {
        s.push({
          indexName: n,
          params: r._getDisjunctiveFacetSearchParams(
            a,
            i
          )
        });
      }), a.getRefinedHierarchicalFacets().forEach(function(i) {
        var l = a.getHierarchicalFacetByName(i), c = a.getHierarchicalRefinement(i), u = a._getHierarchicalFacetSeparator(l);
        if (c.length > 0 && c[0].split(u).length > 1) {
          var f = c[0].split(u).slice(0, -1).reduce(function(d, p, m) {
            return d.concat({
              attribute: l.attributes[m],
              value: m === 0 ? p : [d[d.length - 1].value, p].join(u)
            });
          }, []);
          f.forEach(function(g, d) {
            var p = r._getDisjunctiveFacetSearchParams(
              a,
              g.attribute,
              d === 0
            );
            function m(F) {
              return l.attributes.some(function(b) {
                return b === F.split(":")[0];
              });
            }
            var y = (p.facetFilters || []).reduce(
              function(F, b) {
                if (Array.isArray(b)) {
                  var v = b.filter(function(P) {
                    return !m(P);
                  });
                  v.length > 0 && F.push(v);
                }
                return typeof b == "string" && !m(b) && F.push(b), F;
              },
              []
            ), h = f[d - 1];
            d > 0 ? p.facetFilters = y.concat(
              h.attribute + ":" + h.value
            ) : y.length > 0 ? p.facetFilters = y : delete p.facetFilters, s.push({ indexName: n, params: p });
          });
        }
      }), s;
    },
    /**
     * Get all the queries to send to the client, those queries can used directly
     * with the Algolia client.
     * @private
     * @param  {SearchParameters} state The state from which to get the queries
     * @return {object[]} The queries
     */
    _getCompositionQueries: function(n) {
      return [
        {
          compositionID: n.index,
          requestBody: {
            params: r._getCompositionHitsSearchParams(n)
          }
        }
      ];
    },
    /**
     * Build search parameters used to fetch hits
     * @private
     * @param  {SearchParameters} state The state from which to get the queries
     * @return {object.<string, any>} The search parameters for hits
     */
    _getHitsSearchParams: function(t) {
      var n = t.facets.concat(t.disjunctiveFacets).concat(r._getHitsHierarchicalFacetsAttributes(t)).sort(), a = r._getFacetFilters(t), s = r._getNumericFilters(t), i = r._getTagFilters(t), l = {};
      return n.length > 0 && (l.facets = n.indexOf("*") > -1 ? ["*"] : n), i.length > 0 && (l.tagFilters = i), a.length > 0 && (l.facetFilters = a), s.length > 0 && (l.numericFilters = s), e(o({}, t.getQueryParams(), l));
    },
    /**
     * Build search parameters used to fetch hits
     * @private
     * @param  {SearchParameters} state The state from which to get the queries
     * @return {object.<string, any>} The search parameters for hits
     */
    _getCompositionHitsSearchParams: function(t) {
      var n = t.facets.concat(
        t.disjunctiveFacets.map(function(u) {
          return "disjunctive(" + u + ")";
        })
      ).concat(r._getHitsHierarchicalFacetsAttributes(t)).sort(), a = r._getFacetFilters(t), s = r._getNumericFilters(t), i = r._getTagFilters(t), l = {};
      n.length > 0 && (l.facets = n.indexOf("*") > -1 ? ["*"] : n), i.length > 0 && (l.tagFilters = i), a.length > 0 && (l.facetFilters = a), s.length > 0 && (l.numericFilters = s);
      var c = t.getQueryParams();
      return delete c.highlightPreTag, delete c.highlightPostTag, delete c.index, e(o({}, c, l));
    },
    /**
     * Build search parameters used to fetch a disjunctive facet
     * @private
     * @param  {SearchParameters} state The state from which to get the queries
     * @param  {string} facet the associated facet name
     * @param  {boolean} hierarchicalRootLevel ?? FIXME
     * @return {object} The search parameters for a disjunctive facet
     */
    _getDisjunctiveFacetSearchParams: function(t, n, a) {
      var s = r._getFacetFilters(
        t,
        n,
        a
      ), i = r._getNumericFilters(t, n), l = r._getTagFilters(t), c = {
        hitsPerPage: 0,
        page: 0,
        analytics: !1,
        clickAnalytics: !1
      };
      l.length > 0 && (c.tagFilters = l);
      var u = t.getHierarchicalFacetByName(n);
      return u ? c.facets = r._getDisjunctiveHierarchicalFacetAttribute(
        t,
        u,
        a
      ) : c.facets = n, i.length > 0 && (c.numericFilters = i), s.length > 0 && (c.facetFilters = s), e(o({}, t.getQueryParams(), c));
    },
    /**
     * Return the numeric filters in an algolia request fashion
     * @private
     * @param {SearchParameters} state the state from which to get the filters
     * @param {string} [facetName] the name of the attribute for which the filters should be excluded
     * @return {string[]} the numeric filters in the algolia format
     */
    _getNumericFilters: function(t, n) {
      if (t.numericFilters)
        return t.numericFilters;
      var a = [];
      return Object.keys(t.numericRefinements).forEach(function(s) {
        var i = t.numericRefinements[s] || {};
        Object.keys(i).forEach(function(l) {
          var c = i[l] || [];
          n !== s && c.forEach(function(u) {
            if (Array.isArray(u)) {
              var f = u.map(function(g) {
                return s + l + g;
              });
              a.push(f);
            } else
              a.push(s + l + u);
          });
        });
      }), a;
    },
    /**
     * Return the tags filters depending on which format is used, either tagFilters or tagRefinements
     * @private
     * @param {SearchParameters} state the state from which to get the filters
     * @return {string} Tag filters in a single string
     */
    _getTagFilters: function(t) {
      return t.tagFilters ? t.tagFilters : t.tagRefinements.join(",");
    },
    /**
     * Build facetFilters parameter based on current refinements. The array returned
     * contains strings representing the facet filters in the algolia format.
     * @private
     * @param  {SearchParameters} state The state from which to get the queries
     * @param  {string} [facet] if set, the current disjunctive facet
     * @param  {boolean} [hierarchicalRootLevel] ?? FIXME
     * @return {array.<string>} The facet filters in the algolia format
     */
    _getFacetFilters: function(t, n, a) {
      var s = [], i = t.facetsRefinements || {};
      Object.keys(i).sort().forEach(function(f) {
        var g = i[f] || [];
        g.slice().sort().forEach(function(d) {
          s.push(f + ":" + d);
        });
      });
      var l = t.facetsExcludes || {};
      Object.keys(l).sort().forEach(function(f) {
        var g = l[f] || [];
        g.sort().forEach(function(d) {
          s.push(f + ":-" + d);
        });
      });
      var c = t.disjunctiveFacetsRefinements || {};
      Object.keys(c).sort().forEach(function(f) {
        var g = c[f] || [];
        if (!(f === n || !g || g.length === 0)) {
          var d = [];
          g.slice().sort().forEach(function(p) {
            d.push(f + ":" + p);
          }), s.push(d);
        }
      });
      var u = t.hierarchicalFacetsRefinements || {};
      return Object.keys(u).sort().forEach(function(f) {
        var g = u[f] || [], d = g[0];
        if (d !== void 0) {
          var p = t.getHierarchicalFacetByName(f), m = t._getHierarchicalFacetSeparator(p), y = t._getHierarchicalRootPath(p), h, F;
          if (n === f) {
            if (d.indexOf(m) === -1 || !y && a === !0 || y && y.split(m).length === d.split(m).length)
              return;
            y ? (F = y.split(m).length - 1, d = y) : (F = d.split(m).length - 2, d = d.slice(0, d.lastIndexOf(m))), h = p.attributes[F];
          } else
            F = d.split(m).length - 1, h = p.attributes[F];
          h && s.push([h + ":" + d]);
        }
      }), s;
    },
    _getHitsHierarchicalFacetsAttributes: function(t) {
      var n = [];
      return t.hierarchicalFacets.reduce(
        // ask for as much levels as there's hierarchical refinements
        function(s, i) {
          var l = t.getHierarchicalRefinement(
            i.name
          )[0];
          if (!l)
            return s.push(i.attributes[0]), s;
          var c = t._getHierarchicalFacetSeparator(i), u = l.split(c).length, f = i.attributes.slice(0, u + 1);
          return s.concat(f);
        },
        n
      );
    },
    _getDisjunctiveHierarchicalFacetAttribute: function(t, n, a) {
      var s = t._getHierarchicalFacetSeparator(n);
      if (a === !0) {
        var i = t._getHierarchicalRootPath(n), l = 0;
        return i && (l = i.split(s).length), [n.attributes[l]];
      }
      var c = t.getHierarchicalRefinement(n.name)[0] || "", u = c.split(s).length - 1;
      return n.attributes.slice(0, u + 1);
    },
    getSearchForFacetQuery: function(t, n, a, s) {
      var i = s.isDisjunctiveFacet(t) ? s.clearRefinements(t) : s, l = {
        facetQuery: n,
        facetName: t
      };
      return typeof a == "number" && (l.maxFacetHits = a), e(
        o(
          {},
          r._getHitsSearchParams(i),
          l
        )
      );
    }
  };
  return Bl = r, Bl;
}
var Pl, Wg;
function Ip() {
  return Wg || (Wg = 1, Pl = function() {
    var e = Array.prototype.slice.call(arguments);
    return e.reduceRight(function(r, t) {
      return Object.keys(Object(t)).forEach(function(n) {
        t[n] !== void 0 && (r[n] !== void 0 && delete r[n], r[n] = t[n]);
      }), r;
    }, {});
  }), Pl;
}
var wl, Ng;
function Xa() {
  return Ng || (Ng = 1, wl = function(e, r) {
    if (Array.isArray(e)) {
      for (var t = 0; t < e.length; t++)
        if (r(e[t]))
          return e[t];
    }
  }), wl;
}
var kl, Vg;
function iw() {
  if (Vg) return kl;
  Vg = 1;
  function o(e, r) {
    return e.filter(function(t, n) {
      return r.indexOf(t) > -1 && e.indexOf(t) === n;
    });
  }
  return kl = o, kl;
}
var Dl, zg;
function lw() {
  if (zg) return Dl;
  zg = 1;
  function o(e) {
    if (typeof e == "number")
      return e;
    if (typeof e == "string")
      return parseFloat(e);
    if (Array.isArray(e))
      return e.map(o);
    throw new Error(
      "The value should be a number, a parsable string or an array of those."
    );
  }
  return Dl = o, Dl;
}
var Sl, Ig;
function cw() {
  return Ig || (Ig = 1, Sl = function(e) {
    return e === null ? !1 : /^[a-zA-Z0-9_-]{1,64}$/.test(e);
  }), Sl;
}
var Al, Rg;
function uw() {
  if (Rg) return Al;
  Rg = 1;
  var o = Ip(), e = Vp(), r = zp(), t = {
    /**
     * Adds a refinement to a RefinementList
     * @param {RefinementList} refinementList the initial list
     * @param {string} attribute the attribute to refine
     * @param {string} value the value of the refinement, if the value is not a string it will be converted
     * @return {RefinementList} a new and updated refinement list
     */
    addRefinement: function(a, s, i) {
      if (t.isRefined(a, s, i))
        return a;
      var l = "" + i, c = a[s] ? a[s].concat(l) : [l], u = {};
      return u[s] = c, o(u, a);
    },
    /**
     * Removes refinement(s) for an attribute:
     *  - if the value is specified removes the refinement for the value on the attribute
     *  - if no value is specified removes all the refinements for this attribute
     * @param {RefinementList} refinementList the initial list
     * @param {string} attribute the attribute to refine
     * @param {string} [value] the value of the refinement
     * @return {RefinementList} a new and updated refinement lst
     */
    removeRefinement: function(a, s, i) {
      if (i === void 0)
        return t.clearRefinement(a, function(c, u) {
          return s === u;
        });
      var l = "" + i;
      return t.clearRefinement(a, function(c, u) {
        return s === u && l === c;
      });
    },
    /**
     * Toggles the refinement value for an attribute.
     * @param {RefinementList} refinementList the initial list
     * @param {string} attribute the attribute to refine
     * @param {string} value the value of the refinement
     * @return {RefinementList} a new and updated list
     */
    toggleRefinement: function(a, s, i) {
      if (i === void 0)
        throw new Error("toggleRefinement should be used with a value");
      return t.isRefined(a, s, i) ? t.removeRefinement(a, s, i) : t.addRefinement(a, s, i);
    },
    /**
     * Clear all or parts of a RefinementList. Depending on the arguments, three
     * kinds of behavior can happen:
     *  - if no attribute is provided: clears the whole list
     *  - if an attribute is provided as a string: clears the list for the specific attribute
     *  - if an attribute is provided as a function: discards the elements for which the function returns true
     * @param {RefinementList} refinementList the initial list
     * @param {string} [attribute] the attribute or function to discard
     * @param {string} [refinementType] optional parameter to give more context to the attribute function
     * @return {RefinementList} a new and updated refinement list
     */
    clearRefinement: function(a, s, i) {
      if (s === void 0)
        return e(a) ? {} : a;
      if (typeof s == "string")
        return r(a, [s]);
      if (typeof s == "function") {
        var l = !1, c = Object.keys(a).reduce(
          function(u, f) {
            var g = a[f] || [], d = g.filter(function(p) {
              return !s(p, f, i);
            });
            return d.length !== g.length && (l = !0), u[f] = d, u;
          },
          {}
        );
        return l ? c : a;
      }
    },
    /**
     * Test if the refinement value is used for the attribute. If no refinement value
     * is provided, test if the refinementList contains any refinement for the
     * given attribute.
     * @param {RefinementList} refinementList the list of refinement
     * @param {string} attribute name of the attribute
     * @param {string} [refinementValue] value of the filter/refinement
     * @return {boolean} true if the attribute is refined, false otherwise
     */
    isRefined: function(a, s, i) {
      var l = !!a[s] && a[s].length > 0;
      if (i === void 0 || !l)
        return l;
      var c = "" + i;
      return a[s].indexOf(c) !== -1;
    }
  };
  return Al = t, Al;
}
var El, Hg;
function z1() {
  if (Hg) return El;
  Hg = 1;
  var o = Ip(), e = Xa(), r = iw(), t = Np(), n = Vp(), a = zp(), s = lw(), i = cw(), l = uw();
  function c(g, d) {
    return Array.isArray(g) && Array.isArray(d) ? g.length === d.length && g.every(function(p, m) {
      return c(d[m], p);
    }) : g === d;
  }
  function u(g, d) {
    return e(g, function(p) {
      return c(p, d);
    });
  }
  function f(g) {
    var d = g ? f._parseNumbers(g) : {};
    d.userToken !== void 0 && !i(d.userToken) && console.warn(
      "[algoliasearch-helper] The `userToken` parameter is invalid. This can lead to wrong analytics.\n  - Format: [a-zA-Z0-9_-]{1,64}"
    ), this.facets = d.facets || [], this.disjunctiveFacets = d.disjunctiveFacets || [], this.hierarchicalFacets = d.hierarchicalFacets || [], this.facetsRefinements = d.facetsRefinements || {}, this.facetsExcludes = d.facetsExcludes || {}, this.disjunctiveFacetsRefinements = d.disjunctiveFacetsRefinements || {}, this.numericRefinements = d.numericRefinements || {}, this.tagRefinements = d.tagRefinements || [], this.hierarchicalFacetsRefinements = d.hierarchicalFacetsRefinements || {};
    var p = this;
    Object.keys(d).forEach(function(m) {
      var y = f.PARAMETERS.indexOf(m) !== -1, h = d[m] !== void 0;
      !y && h && (p[m] = d[m]);
    });
  }
  return f.PARAMETERS = Object.keys(new f()), f._parseNumbers = function(g) {
    if (g instanceof f) return g;
    var d = {}, p = [
      "aroundPrecision",
      "aroundRadius",
      "getRankingInfo",
      "minWordSizefor2Typos",
      "minWordSizefor1Typo",
      "page",
      "maxValuesPerFacet",
      "distinct",
      "minimumAroundRadius",
      "hitsPerPage",
      "minProximity"
    ];
    if (p.forEach(function(y) {
      var h = g[y];
      if (typeof h == "string") {
        var F = parseFloat(h);
        d[y] = isNaN(F) ? h : F;
      }
    }), Array.isArray(g.insideBoundingBox) && (d.insideBoundingBox = g.insideBoundingBox.map(function(y) {
      return Array.isArray(y) ? y.map(function(h) {
        return parseFloat(h);
      }) : y;
    })), g.numericRefinements) {
      var m = {};
      Object.keys(g.numericRefinements).forEach(function(y) {
        var h = g.numericRefinements[y] || {};
        m[y] = {}, Object.keys(h).forEach(function(F) {
          var b = h[F], v = b.map(function(P) {
            return Array.isArray(P) ? P.map(function(E) {
              return typeof E == "string" ? parseFloat(E) : E;
            }) : typeof P == "string" ? parseFloat(P) : P;
          });
          m[y][F] = v;
        });
      }), d.numericRefinements = m;
    }
    return t(g, d);
  }, f.make = function(d) {
    var p = new f(d), m = d.hierarchicalFacets || [];
    return m.forEach(function(y) {
      if (y.rootPath) {
        var h = p.getHierarchicalRefinement(y.name);
        h.length > 0 && h[0].indexOf(y.rootPath) !== 0 && (p = p.clearRefinements(y.name)), h = p.getHierarchicalRefinement(y.name), h.length === 0 && (p = p.toggleHierarchicalFacetRefinement(
          y.name,
          y.rootPath
        ));
      }
    }), p;
  }, f.validate = function(g, d) {
    var p = d || {};
    return g.tagFilters && p.tagRefinements && p.tagRefinements.length > 0 ? new Error(
      "[Tags] Cannot switch from the managed tag API to the advanced API. It is probably an error, if it is really what you want, you should first clear the tags with clearTags method."
    ) : g.tagRefinements.length > 0 && p.tagFilters ? new Error(
      "[Tags] Cannot switch from the advanced tag API to the managed API. It is probably an error, if it is not, you should first clear the tags with clearTags method."
    ) : g.numericFilters && p.numericRefinements && n(p.numericRefinements) ? new Error(
      "[Numeric filters] Can't switch from the advanced to the managed API. It is probably an error, if this is really what you want, you have to first clear the numeric filters."
    ) : n(g.numericRefinements) && p.numericFilters ? new Error(
      "[Numeric filters] Can't switch from the managed API to the advanced. It is probably an error, if this is really what you want, you have to first clear the numeric filters."
    ) : null;
  }, f.prototype = {
    constructor: f,
    /**
     * Remove all refinements (disjunctive + conjunctive + excludes + numeric filters)
     * @method
     * @param {undefined|string|SearchParameters.clearCallback} [attribute] optional string or function
     * - If not given, means to clear all the filters.
     * - If `string`, means to clear all refinements for the `attribute` named filter.
     * - If `function`, means to clear all the refinements that return truthy values.
     * @return {SearchParameters} new instance with filters cleared
     */
    clearRefinements: function(d) {
      var p = {
        numericRefinements: this._clearNumericRefinements(d),
        facetsRefinements: l.clearRefinement(
          this.facetsRefinements,
          d,
          "conjunctiveFacet"
        ),
        facetsExcludes: l.clearRefinement(
          this.facetsExcludes,
          d,
          "exclude"
        ),
        disjunctiveFacetsRefinements: l.clearRefinement(
          this.disjunctiveFacetsRefinements,
          d,
          "disjunctiveFacet"
        ),
        hierarchicalFacetsRefinements: l.clearRefinement(
          this.hierarchicalFacetsRefinements,
          d,
          "hierarchicalFacet"
        )
      };
      return p.numericRefinements === this.numericRefinements && p.facetsRefinements === this.facetsRefinements && p.facetsExcludes === this.facetsExcludes && p.disjunctiveFacetsRefinements === this.disjunctiveFacetsRefinements && p.hierarchicalFacetsRefinements === this.hierarchicalFacetsRefinements ? this : this.setQueryParameters(p);
    },
    /**
     * Remove all the refined tags from the SearchParameters
     * @method
     * @return {SearchParameters} new instance with tags cleared
     */
    clearTags: function() {
      return this.tagFilters === void 0 && this.tagRefinements.length === 0 ? this : this.setQueryParameters({
        tagFilters: void 0,
        tagRefinements: []
      });
    },
    /**
     * Set the index.
     * @method
     * @param {string} index the index name
     * @return {SearchParameters} new instance
     */
    setIndex: function(d) {
      return d === this.index ? this : this.setQueryParameters({
        index: d
      });
    },
    /**
     * Query setter
     * @method
     * @param {string} newQuery value for the new query
     * @return {SearchParameters} new instance
     */
    setQuery: function(d) {
      return d === this.query ? this : this.setQueryParameters({
        query: d
      });
    },
    /**
     * Page setter
     * @method
     * @param {number} newPage new page number
     * @return {SearchParameters} new instance
     */
    setPage: function(d) {
      return d === this.page ? this : this.setQueryParameters({
        page: d
      });
    },
    /**
     * Facets setter
     * The facets are the simple facets, used for conjunctive (and) faceting.
     * @method
     * @param {string[]} facets all the attributes of the algolia records used for conjunctive faceting
     * @return {SearchParameters} new instance
     */
    setFacets: function(d) {
      return this.setQueryParameters({
        facets: d
      });
    },
    /**
     * Disjunctive facets setter
     * Change the list of disjunctive (or) facets the helper chan handle.
     * @method
     * @param {string[]} facets all the attributes of the algolia records used for disjunctive faceting
     * @return {SearchParameters} new instance
     */
    setDisjunctiveFacets: function(d) {
      return this.setQueryParameters({
        disjunctiveFacets: d
      });
    },
    /**
     * HitsPerPage setter
     * Hits per page represents the number of hits retrieved for this query
     * @method
     * @param {number} n number of hits retrieved per page of results
     * @return {SearchParameters} new instance
     */
    setHitsPerPage: function(d) {
      return this.hitsPerPage === d ? this : this.setQueryParameters({
        hitsPerPage: d
      });
    },
    /**
     * typoTolerance setter
     * Set the value of typoTolerance
     * @method
     * @param {string} typoTolerance new value of typoTolerance ("true", "false", "min" or "strict")
     * @return {SearchParameters} new instance
     */
    setTypoTolerance: function(d) {
      return this.typoTolerance === d ? this : this.setQueryParameters({
        typoTolerance: d
      });
    },
    /**
     * Add a numeric filter for a given attribute
     * When value is an array, they are combined with OR
     * When value is a single value, it will combined with AND
     * @method
     * @param {string} attribute attribute to set the filter on
     * @param {string} operator operator of the filter (possible values: =, >, >=, <, <=, !=)
     * @param {number | number[]} value value of the filter
     * @return {SearchParameters} new instance
     * @example
     * // for price = 50 or 40
     * state.addNumericRefinement('price', '=', [50, 40]);
     * @example
     * // for size = 38 and 40
     * state.addNumericRefinement('size', '=', 38);
     * state.addNumericRefinement('size', '=', 40);
     */
    addNumericRefinement: function(g, d, p) {
      var m = s(p);
      if (this.isNumericRefined(g, d, m)) return this;
      var y = t({}, this.numericRefinements);
      return y[g] = t({}, y[g]), y[g][d] ? (y[g][d] = y[g][d].slice(), y[g][d].push(m)) : y[g][d] = [m], this.setQueryParameters({
        numericRefinements: y
      });
    },
    /**
     * Get the list of conjunctive refinements for a single facet
     * @param {string} facetName name of the attribute used for faceting
     * @return {string[]} list of refinements
     */
    getConjunctiveRefinements: function(g) {
      return this.isConjunctiveFacet(g) ? this.facetsRefinements[g] || [] : [];
    },
    /**
     * Get the list of disjunctive refinements for a single facet
     * @param {string} facetName name of the attribute used for faceting
     * @return {string[]} list of refinements
     */
    getDisjunctiveRefinements: function(g) {
      return this.isDisjunctiveFacet(g) ? this.disjunctiveFacetsRefinements[g] || [] : [];
    },
    /**
     * Get the list of hierarchical refinements for a single facet
     * @param {string} facetName name of the attribute used for faceting
     * @return {string[]} list of refinements
     */
    getHierarchicalRefinement: function(g) {
      return this.hierarchicalFacetsRefinements[g] || [];
    },
    /**
     * Get the list of exclude refinements for a single facet
     * @param {string} facetName name of the attribute used for faceting
     * @return {string[]} list of refinements
     */
    getExcludeRefinements: function(g) {
      return this.isConjunctiveFacet(g) ? this.facetsExcludes[g] || [] : [];
    },
    /**
     * Remove all the numeric filter for a given (attribute, operator)
     * @method
     * @param {string} attribute attribute to set the filter on
     * @param {string} [operator] operator of the filter (possible values: =, >, >=, <, <=, !=)
     * @param {number} [number] the value to be removed
     * @return {SearchParameters} new instance
     */
    removeNumericRefinement: function(g, d, p) {
      var m = p;
      return m !== void 0 ? this.isNumericRefined(g, d, m) ? this.setQueryParameters({
        numericRefinements: this._clearNumericRefinements(function(y, h) {
          return h === g && y.op === d && c(y.val, s(m));
        })
      }) : this : d !== void 0 ? this.isNumericRefined(g, d) ? this.setQueryParameters({
        numericRefinements: this._clearNumericRefinements(function(y, h) {
          return h === g && y.op === d;
        })
      }) : this : this.isNumericRefined(g) ? this.setQueryParameters({
        numericRefinements: this._clearNumericRefinements(function(y, h) {
          return h === g;
        })
      }) : this;
    },
    /**
     * Get the list of numeric refinements for a single facet
     * @param {string} facetName name of the attribute used for faceting
     * @return {SearchParameters.OperatorList} list of refinements
     */
    getNumericRefinements: function(g) {
      return this.numericRefinements[g] || {};
    },
    /**
     * Return the current refinement for the (attribute, operator)
     * @param {string} attribute attribute in the record
     * @param {string} operator operator applied on the refined values
     * @return {Array.<number|number[]>} refined values
     */
    getNumericRefinement: function(g, d) {
      return this.numericRefinements[g] && this.numericRefinements[g][d];
    },
    /**
     * Clear numeric filters.
     * @method
     * @private
     * @param {string|SearchParameters.clearCallback} [attribute] optional string or function
     * - If not given, means to clear all the filters.
     * - If `string`, means to clear all refinements for the `attribute` named filter.
     * - If `function`, means to clear all the refinements that return truthy values.
     * @return {Object.<string, OperatorList>} new numeric refinements
     */
    _clearNumericRefinements: function(d) {
      if (d === void 0)
        return n(this.numericRefinements) ? {} : this.numericRefinements;
      if (typeof d == "string")
        return a(this.numericRefinements, [d]);
      if (typeof d == "function") {
        var p = !1, m = this.numericRefinements, y = Object.keys(m).reduce(
          function(h, F) {
            var b = m[F], v = {};
            return b = b || {}, Object.keys(b).forEach(function(P) {
              var E = b[P] || [], S = [];
              E.forEach(function(D) {
                var w = d(
                  { val: D, op: P },
                  F,
                  "numeric"
                );
                w || S.push(D);
              }), S.length !== E.length && (p = !0), v[P] = S;
            }), h[F] = v, h;
          },
          {}
        );
        return p ? y : this.numericRefinements;
      }
    },
    /**
     * Add a facet to the facets attribute of the helper configuration, if it
     * isn't already present.
     * @method
     * @param {string} facet facet name to add
     * @return {SearchParameters} new instance
     */
    addFacet: function(d) {
      return this.isConjunctiveFacet(d) ? this : this.setQueryParameters({
        facets: this.facets.concat([d])
      });
    },
    /**
     * Add a disjunctive facet to the disjunctiveFacets attribute of the helper
     * configuration, if it isn't already present.
     * @method
     * @param {string} facet disjunctive facet name to add
     * @return {SearchParameters} new instance
     */
    addDisjunctiveFacet: function(d) {
      return this.isDisjunctiveFacet(d) ? this : this.setQueryParameters({
        disjunctiveFacets: this.disjunctiveFacets.concat([d])
      });
    },
    /**
     * Add a hierarchical facet to the hierarchicalFacets attribute of the helper
     * configuration.
     * @method
     * @param {object} hierarchicalFacet hierarchical facet to add
     * @return {SearchParameters} new instance
     * @throws will throw an error if a hierarchical facet with the same name was already declared
     */
    addHierarchicalFacet: function(d) {
      if (this.isHierarchicalFacet(d.name))
        throw new Error(
          "Cannot declare two hierarchical facets with the same name: `" + d.name + "`"
        );
      return this.setQueryParameters({
        hierarchicalFacets: this.hierarchicalFacets.concat([d])
      });
    },
    /**
     * Add a refinement on a "normal" facet
     * @method
     * @param {string} facet attribute to apply the faceting on
     * @param {string} value value of the attribute (will be converted to string)
     * @return {SearchParameters} new instance
     */
    addFacetRefinement: function(d, p) {
      if (!this.isConjunctiveFacet(d))
        throw new Error(
          d + " is not defined in the facets attribute of the helper configuration"
        );
      return l.isRefined(this.facetsRefinements, d, p) ? this : this.setQueryParameters({
        facetsRefinements: l.addRefinement(
          this.facetsRefinements,
          d,
          p
        )
      });
    },
    /**
     * Exclude a value from a "normal" facet
     * @method
     * @param {string} facet attribute to apply the exclusion on
     * @param {string} value value of the attribute (will be converted to string)
     * @return {SearchParameters} new instance
     */
    addExcludeRefinement: function(d, p) {
      if (!this.isConjunctiveFacet(d))
        throw new Error(
          d + " is not defined in the facets attribute of the helper configuration"
        );
      return l.isRefined(this.facetsExcludes, d, p) ? this : this.setQueryParameters({
        facetsExcludes: l.addRefinement(
          this.facetsExcludes,
          d,
          p
        )
      });
    },
    /**
     * Adds a refinement on a disjunctive facet.
     * @method
     * @param {string} facet attribute to apply the faceting on
     * @param {string} value value of the attribute (will be converted to string)
     * @return {SearchParameters} new instance
     */
    addDisjunctiveFacetRefinement: function(d, p) {
      if (!this.isDisjunctiveFacet(d))
        throw new Error(
          d + " is not defined in the disjunctiveFacets attribute of the helper configuration"
        );
      return l.isRefined(this.disjunctiveFacetsRefinements, d, p) ? this : this.setQueryParameters({
        disjunctiveFacetsRefinements: l.addRefinement(
          this.disjunctiveFacetsRefinements,
          d,
          p
        )
      });
    },
    /**
     * addTagRefinement adds a tag to the list used to filter the results
     * @param {string} tag tag to be added
     * @return {SearchParameters} new instance
     */
    addTagRefinement: function(d) {
      if (this.isTagRefined(d)) return this;
      var p = {
        tagRefinements: this.tagRefinements.concat(d)
      };
      return this.setQueryParameters(p);
    },
    /**
     * Remove a facet from the facets attribute of the helper configuration, if it
     * is present.
     * @method
     * @param {string} facet facet name to remove
     * @return {SearchParameters} new instance
     */
    removeFacet: function(d) {
      return this.isConjunctiveFacet(d) ? this.clearRefinements(d).setQueryParameters({
        facets: this.facets.filter(function(p) {
          return p !== d;
        })
      }) : this;
    },
    /**
     * Remove a disjunctive facet from the disjunctiveFacets attribute of the
     * helper configuration, if it is present.
     * @method
     * @param {string} facet disjunctive facet name to remove
     * @return {SearchParameters} new instance
     */
    removeDisjunctiveFacet: function(d) {
      return this.isDisjunctiveFacet(d) ? this.clearRefinements(d).setQueryParameters({
        disjunctiveFacets: this.disjunctiveFacets.filter(function(p) {
          return p !== d;
        })
      }) : this;
    },
    /**
     * Remove a hierarchical facet from the hierarchicalFacets attribute of the
     * helper configuration, if it is present.
     * @method
     * @param {string} facet hierarchical facet name to remove
     * @return {SearchParameters} new instance
     */
    removeHierarchicalFacet: function(d) {
      return this.isHierarchicalFacet(d) ? this.clearRefinements(d).setQueryParameters({
        hierarchicalFacets: this.hierarchicalFacets.filter(function(p) {
          return p.name !== d;
        })
      }) : this;
    },
    /**
     * Remove a refinement set on facet. If a value is provided, it will clear the
     * refinement for the given value, otherwise it will clear all the refinement
     * values for the faceted attribute.
     * @method
     * @param {string} facet name of the attribute used for faceting
     * @param {string} [value] value used to filter
     * @return {SearchParameters} new instance
     */
    removeFacetRefinement: function(d, p) {
      if (!this.isConjunctiveFacet(d))
        throw new Error(
          d + " is not defined in the facets attribute of the helper configuration"
        );
      return l.isRefined(this.facetsRefinements, d, p) ? this.setQueryParameters({
        facetsRefinements: l.removeRefinement(
          this.facetsRefinements,
          d,
          p
        )
      }) : this;
    },
    /**
     * Remove a negative refinement on a facet
     * @method
     * @param {string} facet name of the attribute used for faceting
     * @param {string} value value used to filter
     * @return {SearchParameters} new instance
     */
    removeExcludeRefinement: function(d, p) {
      if (!this.isConjunctiveFacet(d))
        throw new Error(
          d + " is not defined in the facets attribute of the helper configuration"
        );
      return l.isRefined(this.facetsExcludes, d, p) ? this.setQueryParameters({
        facetsExcludes: l.removeRefinement(
          this.facetsExcludes,
          d,
          p
        )
      }) : this;
    },
    /**
     * Remove a refinement on a disjunctive facet
     * @method
     * @param {string} facet name of the attribute used for faceting
     * @param {string} value value used to filter
     * @return {SearchParameters} new instance
     */
    removeDisjunctiveFacetRefinement: function(d, p) {
      if (!this.isDisjunctiveFacet(d))
        throw new Error(
          d + " is not defined in the disjunctiveFacets attribute of the helper configuration"
        );
      return l.isRefined(this.disjunctiveFacetsRefinements, d, p) ? this.setQueryParameters({
        disjunctiveFacetsRefinements: l.removeRefinement(
          this.disjunctiveFacetsRefinements,
          d,
          p
        )
      }) : this;
    },
    /**
     * Remove a tag from the list of tag refinements
     * @method
     * @param {string} tag the tag to remove
     * @return {SearchParameters} new instance
     */
    removeTagRefinement: function(d) {
      if (!this.isTagRefined(d)) return this;
      var p = {
        tagRefinements: this.tagRefinements.filter(function(m) {
          return m !== d;
        })
      };
      return this.setQueryParameters(p);
    },
    /**
     * Generic toggle refinement method to use with facet, disjunctive facets
     * and hierarchical facets
     * @param  {string} facet the facet to refine
     * @param  {string} value the associated value
     * @return {SearchParameters} new instance
     * @throws will throw an error if the facet is not declared in the settings of the helper
     * @deprecated since version 2.19.0, see {@link SearchParameters#toggleFacetRefinement}
     */
    toggleRefinement: function(d, p) {
      return this.toggleFacetRefinement(d, p);
    },
    /**
     * Generic toggle refinement method to use with facet, disjunctive facets
     * and hierarchical facets
     * @param  {string} facet the facet to refine
     * @param  {string} value the associated value
     * @return {SearchParameters} new instance
     * @throws will throw an error if the facet is not declared in the settings of the helper
     */
    toggleFacetRefinement: function(d, p) {
      if (this.isHierarchicalFacet(d))
        return this.toggleHierarchicalFacetRefinement(d, p);
      if (this.isConjunctiveFacet(d))
        return this.toggleConjunctiveFacetRefinement(d, p);
      if (this.isDisjunctiveFacet(d))
        return this.toggleDisjunctiveFacetRefinement(d, p);
      throw new Error(
        "Cannot refine the undeclared facet " + d + "; it should be added to the helper options facets, disjunctiveFacets or hierarchicalFacets"
      );
    },
    /**
     * Switch the refinement applied over a facet/value
     * @method
     * @param {string} facet name of the attribute used for faceting
     * @param {value} value value used for filtering
     * @return {SearchParameters} new instance
     */
    toggleConjunctiveFacetRefinement: function(d, p) {
      if (!this.isConjunctiveFacet(d))
        throw new Error(
          d + " is not defined in the facets attribute of the helper configuration"
        );
      return this.setQueryParameters({
        facetsRefinements: l.toggleRefinement(
          this.facetsRefinements,
          d,
          p
        )
      });
    },
    /**
     * Switch the refinement applied over a facet/value
     * @method
     * @param {string} facet name of the attribute used for faceting
     * @param {value} value value used for filtering
     * @return {SearchParameters} new instance
     */
    toggleExcludeFacetRefinement: function(d, p) {
      if (!this.isConjunctiveFacet(d))
        throw new Error(
          d + " is not defined in the facets attribute of the helper configuration"
        );
      return this.setQueryParameters({
        facetsExcludes: l.toggleRefinement(
          this.facetsExcludes,
          d,
          p
        )
      });
    },
    /**
     * Switch the refinement applied over a facet/value
     * @method
     * @param {string} facet name of the attribute used for faceting
     * @param {value} value value used for filtering
     * @return {SearchParameters} new instance
     */
    toggleDisjunctiveFacetRefinement: function(d, p) {
      if (!this.isDisjunctiveFacet(d))
        throw new Error(
          d + " is not defined in the disjunctiveFacets attribute of the helper configuration"
        );
      return this.setQueryParameters({
        disjunctiveFacetsRefinements: l.toggleRefinement(
          this.disjunctiveFacetsRefinements,
          d,
          p
        )
      });
    },
    /**
     * Switch the refinement applied over a facet/value
     * @method
     * @param {string} facet name of the attribute used for faceting
     * @param {value} value value used for filtering
     * @return {SearchParameters} new instance
     */
    toggleHierarchicalFacetRefinement: function(d, p) {
      if (!this.isHierarchicalFacet(d))
        throw new Error(
          d + " is not defined in the hierarchicalFacets attribute of the helper configuration"
        );
      var m = this._getHierarchicalFacetSeparator(
        this.getHierarchicalFacetByName(d)
      ), y = {}, h = this.hierarchicalFacetsRefinements[d] !== void 0 && this.hierarchicalFacetsRefinements[d].length > 0 && // remove current refinement:
      // refinement was 'beer > IPA', call is toggleRefine('beer > IPA'), refinement should be `beer`
      (this.hierarchicalFacetsRefinements[d][0] === p || // remove a parent refinement of the current refinement:
      //  - refinement was 'beer > IPA > Flying dog'
      //  - call is toggleRefine('beer > IPA')
      //  - refinement should be `beer`
      this.hierarchicalFacetsRefinements[d][0].indexOf(
        p + m
      ) === 0);
      return h ? p.indexOf(m) === -1 ? y[d] = [] : y[d] = [p.slice(0, p.lastIndexOf(m))] : y[d] = [p], this.setQueryParameters({
        hierarchicalFacetsRefinements: o(
          y,
          this.hierarchicalFacetsRefinements
        )
      });
    },
    /**
     * Adds a refinement on a hierarchical facet.
     * @param {string} facet the facet name
     * @param {string} path the hierarchical facet path
     * @return {SearchParameter} the new state
     * @throws Error if the facet is not defined or if the facet is refined
     */
    addHierarchicalFacetRefinement: function(g, d) {
      if (this.isHierarchicalFacetRefined(g))
        throw new Error(g + " is already refined.");
      if (!this.isHierarchicalFacet(g))
        throw new Error(
          g + " is not defined in the hierarchicalFacets attribute of the helper configuration."
        );
      var p = {};
      return p[g] = [d], this.setQueryParameters({
        hierarchicalFacetsRefinements: o(
          p,
          this.hierarchicalFacetsRefinements
        )
      });
    },
    /**
     * Removes the refinement set on a hierarchical facet.
     * @param {string} facet the facet name
     * @return {SearchParameter} the new state
     * @throws Error if the facet is not defined or if the facet is not refined
     */
    removeHierarchicalFacetRefinement: function(g) {
      if (!this.isHierarchicalFacetRefined(g))
        return this;
      var d = {};
      return d[g] = [], this.setQueryParameters({
        hierarchicalFacetsRefinements: o(
          d,
          this.hierarchicalFacetsRefinements
        )
      });
    },
    /**
     * Switch the tag refinement
     * @method
     * @param {string} tag the tag to remove or add
     * @return {SearchParameters} new instance
     */
    toggleTagRefinement: function(d) {
      return this.isTagRefined(d) ? this.removeTagRefinement(d) : this.addTagRefinement(d);
    },
    /**
     * Test if the facet name is from one of the disjunctive facets
     * @method
     * @param {string} facet facet name to test
     * @return {boolean} true if facet is a disjunctive facet
     */
    isDisjunctiveFacet: function(g) {
      return this.disjunctiveFacets.indexOf(g) > -1;
    },
    /**
     * Test if the facet name is from one of the hierarchical facets
     * @method
     * @param {string} facetName facet name to test
     * @return {boolean} true if facetName is a hierarchical facet
     */
    isHierarchicalFacet: function(g) {
      return this.getHierarchicalFacetByName(g) !== void 0;
    },
    /**
     * Test if the facet name is from one of the conjunctive/normal facets
     * @method
     * @param {string} facet facet name to test
     * @return {boolean} true if facet is a conjunctive facet
     */
    isConjunctiveFacet: function(g) {
      return this.facets.indexOf(g) > -1;
    },
    /**
     * Returns true if the facet is refined, either for a specific value or in
     * general.
     * @method
     * @param {string} facet name of the attribute for used for faceting
     * @param {string} value, optional value. If passed will test that this value
     * is filtering the given facet.
     * @return {boolean} returns true if refined
     */
    isFacetRefined: function(d, p) {
      return this.isConjunctiveFacet(d) ? l.isRefined(this.facetsRefinements, d, p) : !1;
    },
    /**
     * Returns true if the facet contains exclusions or if a specific value is
     * excluded.
     *
     * @method
     * @param {string} facet name of the attribute for used for faceting
     * @param {string} [value] optional value. If passed will test that this value
     * is filtering the given facet.
     * @return {boolean} returns true if refined
     */
    isExcludeRefined: function(d, p) {
      return this.isConjunctiveFacet(d) ? l.isRefined(this.facetsExcludes, d, p) : !1;
    },
    /**
     * Returns true if the facet contains a refinement, or if a value passed is a
     * refinement for the facet.
     * @method
     * @param {string} facet name of the attribute for used for faceting
     * @param {string} value optional, will test if the value is used for refinement
     * if there is one, otherwise will test if the facet contains any refinement
     * @return {boolean} true if the facet is refined
     */
    isDisjunctiveFacetRefined: function(d, p) {
      return this.isDisjunctiveFacet(d) ? l.isRefined(
        this.disjunctiveFacetsRefinements,
        d,
        p
      ) : !1;
    },
    /**
     * Returns true if the facet contains a refinement, or if a value passed is a
     * refinement for the facet.
     * @method
     * @param {string} facet name of the attribute for used for faceting
     * @param {string} value optional, will test if the value is used for refinement
     * if there is one, otherwise will test if the facet contains any refinement
     * @return {boolean} true if the facet is refined
     */
    isHierarchicalFacetRefined: function(d, p) {
      if (!this.isHierarchicalFacet(d))
        return !1;
      var m = this.getHierarchicalRefinement(d);
      return p ? m.indexOf(p) !== -1 : m.length > 0;
    },
    /**
     * Test if the triple (attribute, operator, value) is already refined.
     * If only the attribute and the operator are provided, it tests if the
     * contains any refinement value.
     * @method
     * @param {string} attribute attribute for which the refinement is applied
     * @param {string} [operator] operator of the refinement
     * @param {string} [value] value of the refinement
     * @return {boolean} true if it is refined
     */
    isNumericRefined: function(d, p, m) {
      if (m === void 0 && p === void 0)
        return !!this.numericRefinements[d];
      var y = this.numericRefinements[d] && this.numericRefinements[d][p] !== void 0;
      if (m === void 0 || !y)
        return y;
      var h = s(m), F = u(this.numericRefinements[d][p], h) !== void 0;
      return y && F;
    },
    /**
     * Returns true if the tag refined, false otherwise
     * @method
     * @param {string} tag the tag to check
     * @return {boolean} true if tag is refined
     */
    isTagRefined: function(d) {
      return this.tagRefinements.indexOf(d) !== -1;
    },
    /**
     * Returns the list of all disjunctive facets refined
     * @method
     * @param {string} facet name of the attribute used for faceting
     * @param {value} value value used for filtering
     * @return {string[]} returns the list of refinements
     */
    getRefinedDisjunctiveFacets: function() {
      var d = this, p = r(
        Object.keys(this.numericRefinements).filter(function(m) {
          return Object.keys(d.numericRefinements[m]).length > 0;
        }),
        this.disjunctiveFacets
      );
      return Object.keys(this.disjunctiveFacetsRefinements).filter(function(m) {
        return d.disjunctiveFacetsRefinements[m].length > 0;
      }).concat(p).concat(this.getRefinedHierarchicalFacets()).sort();
    },
    /**
     * Returns the list of all disjunctive facets refined
     * @method
     * @param {string} facet name of the attribute used for faceting
     * @param {value} value value used for filtering
     * @return {string[]} returns the list of refinements
     */
    getRefinedHierarchicalFacets: function() {
      var d = this;
      return r(
        // enforce the order between the two arrays,
        // so that refinement name index === hierarchical facet index
        this.hierarchicalFacets.map(function(p) {
          return p.name;
        }),
        Object.keys(this.hierarchicalFacetsRefinements).filter(function(p) {
          return d.hierarchicalFacetsRefinements[p].length > 0;
        })
      ).sort();
    },
    /**
     * Returned the list of all disjunctive facets not refined
     * @method
     * @return {string[]} returns the list of facets that are not refined
     */
    getUnrefinedDisjunctiveFacets: function() {
      var g = this.getRefinedDisjunctiveFacets();
      return this.disjunctiveFacets.filter(function(d) {
        return g.indexOf(d) === -1;
      });
    },
    managedParameters: [
      "index",
      "facets",
      "disjunctiveFacets",
      "facetsRefinements",
      "hierarchicalFacets",
      "facetsExcludes",
      "disjunctiveFacetsRefinements",
      "numericRefinements",
      "tagRefinements",
      "hierarchicalFacetsRefinements"
    ],
    getQueryParams: function() {
      var d = this.managedParameters, p = {}, m = this;
      return Object.keys(this).forEach(function(y) {
        var h = m[y];
        d.indexOf(y) === -1 && h !== void 0 && (p[y] = h);
      }), p;
    },
    /**
     * Let the user set a specific value for a given parameter. Will return the
     * same instance if the parameter is invalid or if the value is the same as the
     * previous one.
     * @method
     * @param {string} parameter the parameter name
     * @param {any} value the value to be set, must be compliant with the definition
     * of the attribute on the object
     * @return {SearchParameters} the updated state
     */
    setQueryParameter: function(d, p) {
      if (this[d] === p) return this;
      var m = {};
      return m[d] = p, this.setQueryParameters(m);
    },
    /**
     * Let the user set any of the parameters with a plain object.
     * @method
     * @param {object} params all the keys and the values to be updated
     * @return {SearchParameters} a new updated instance
     */
    setQueryParameters: function(d) {
      if (!d) return this;
      var p = f.validate(this, d);
      if (p)
        throw p;
      var m = this, y = f._parseNumbers(d), h = Object.keys(this).reduce(function(b, v) {
        return b[v] = m[v], b;
      }, {}), F = Object.keys(y).reduce(
        function(b, v) {
          var P = b[v] !== void 0, E = y[v] !== void 0;
          return P && !E ? a(b, [v]) : (E && (b[v] = y[v]), b);
        },
        h
      );
      return new this.constructor(F);
    },
    /**
     * Returns a new instance with the page reset. Two scenarios possible:
     * the page is omitted -> return the given instance
     * the page is set -> return a new instance with a page of 0
     * @return {SearchParameters} a new updated instance
     */
    resetPage: function() {
      return this.page === void 0 ? this : this.setPage(0);
    },
    /**
     * Helper function to get the hierarchicalFacet separator or the default one (`>`)
     * @param  {object} hierarchicalFacet the hierarchicalFacet object
     * @return {string} returns the hierarchicalFacet.separator or `>` as default
     */
    _getHierarchicalFacetSortBy: function(g) {
      return g.sortBy || ["isRefined:desc", "name:asc"];
    },
    /**
     * Helper function to get the hierarchicalFacet separator or the default one (`>`)
     * @private
     * @param  {object} hierarchicalFacet the hierarchicalFacet object
     * @return {string} returns the hierarchicalFacet.separator or `>` as default
     */
    _getHierarchicalFacetSeparator: function(g) {
      return g.separator || " > ";
    },
    /**
     * Helper function to get the hierarchicalFacet prefix path or null
     * @private
     * @param  {object} hierarchicalFacet the hierarchicalFacet object
     * @return {string} returns the hierarchicalFacet.rootPath or null as default
     */
    _getHierarchicalRootPath: function(g) {
      return g.rootPath || null;
    },
    /**
     * Helper function to check if we show the parent level of the hierarchicalFacet
     * @private
     * @param  {object} hierarchicalFacet the hierarchicalFacet object
     * @return {string} returns the hierarchicalFacet.showParentLevel or true as default
     */
    _getHierarchicalShowParentLevel: function(g) {
      return typeof g.showParentLevel == "boolean" ? g.showParentLevel : !0;
    },
    /**
     * Helper function to get the hierarchicalFacet by it's name
     * @param  {string} hierarchicalFacetName the hierarchicalFacet name
     * @return {object} a hierarchicalFacet
     */
    getHierarchicalFacetByName: function(g) {
      return e(this.hierarchicalFacets, function(d) {
        return d.name === g;
      });
    },
    /**
     * Get the current breadcrumb for a hierarchical facet, as an array
     * @param  {string} facetName Hierarchical facet name
     * @return {array.<string>} the path as an array of string
     */
    getHierarchicalFacetBreadcrumb: function(g) {
      if (!this.isHierarchicalFacet(g))
        return [];
      var d = this.getHierarchicalRefinement(g)[0];
      if (!d) return [];
      var p = this._getHierarchicalFacetSeparator(
        this.getHierarchicalFacetByName(g)
      ), m = d.split(p);
      return m.map(function(y) {
        return y.trim();
      });
    },
    toString: function() {
      return JSON.stringify(this, null, 2);
    }
  }, El = f, El;
}
var xl, Yg;
function pw() {
  return Yg || (Yg = 1, xl = function(e) {
    return Array.isArray(e) ? e.filter(Boolean) : [];
  }), xl;
}
var Cl, qg;
function dw() {
  return qg || (qg = 1, Cl = function(e, r) {
    if (!Array.isArray(e))
      return -1;
    for (var t = 0; t < e.length; t++)
      if (r(e[t]))
        return t;
    return -1;
  }), Cl;
}
var Ol, Gg;
function I1() {
  if (Gg) return Ol;
  Gg = 1;
  var o = Xa();
  return Ol = function(r, t) {
    var n = (t || []).map(function(a) {
      return a.split(":");
    });
    return r.reduce(
      function(s, i) {
        var l = i.split(":"), c = o(
          n,
          function(u) {
            return u[0] === l[0];
          }
        );
        return l.length > 1 || !c ? (s[0].push(l[0]), s[1].push(l[1]), s) : (s[0].push(c[0]), s[1].push(c[1]), s);
      },
      [[], []]
    );
  }, Ol;
}
var Tl, Xg;
function gw() {
  if (Xg) return Tl;
  Xg = 1;
  function o() {
    var e = Array.prototype.slice.call(arguments);
    return e.reduceRight(function(r, t) {
      return Object.keys(Object(t)).forEach(function(n) {
        var a = typeof r[n] == "number" ? r[n] : 0, s = t[n];
        s !== void 0 && s >= a && (r[n] !== void 0 && delete r[n], r[n] = s);
      }), r;
    }, {});
  }
  return Tl = o, Tl;
}
var Ll, Ug;
function R1() {
  if (Ug) return Ll;
  Ug = 1;
  function o(r, t) {
    if (r !== t) {
      var n = r !== void 0, a = r === null, s = t !== void 0, i = t === null;
      if (!i && r > t || a && s || !n)
        return 1;
      if (!a && r < t || i && n || !s)
        return -1;
    }
    return 0;
  }
  function e(r, t, n) {
    if (!Array.isArray(r))
      return [];
    Array.isArray(n) || (n = []);
    var a = r.map(function(s, i) {
      return {
        criteria: t.map(function(l) {
          return s[l];
        }),
        index: i,
        value: s
      };
    });
    return a.sort(function(i, l) {
      for (var c = -1; ++c < i.criteria.length; ) {
        var u = o(i.criteria[c], l.criteria[c]);
        if (u)
          return c >= n.length ? u : n[c] === "desc" ? -u : u;
      }
      return i.index - l.index;
    }), a.map(function(s) {
      return s.value;
    });
  }
  return Ll = e, Ll;
}
var jl, Zg;
function mw() {
  if (Zg) return jl;
  Zg = 1, jl = s;
  var o = Wp(), e = Xa(), r = I1(), t = R1(), n = o.escapeFacetValue, a = o.unescapeFacetValue;
  function s(u) {
    return function(g, d) {
      var p = u.hierarchicalFacets[d], m = u.hierarchicalFacetsRefinements[p.name] && u.hierarchicalFacetsRefinements[p.name][0] || "", y = u._getHierarchicalFacetSeparator(p), h = u._getHierarchicalRootPath(p), F = u._getHierarchicalShowParentLevel(p), b = r(
        u._getHierarchicalFacetSortBy(p)
      ), v = g.every(function(S) {
        return S.exhaustive;
      }), P = i(
        b,
        y,
        h,
        F,
        m
      ), E = g;
      return h && (E = g.slice(
        h.split(y).length
      )), E.reduce(P, {
        name: u.hierarchicalFacets[d].name,
        count: null,
        // root level, no count
        isRefined: !0,
        // root level, always refined
        path: null,
        // root level, no path
        escapedValue: null,
        exhaustive: v,
        data: null
      });
    };
  }
  function i(u, f, g, d, p) {
    return function(y, h, F) {
      var b = y;
      if (F > 0) {
        var v = 0;
        for (b = y; v < F; ) {
          var P = b && Array.isArray(b.data) ? b.data : [];
          b = e(P, function(S) {
            return S.isRefined;
          }), v++;
        }
      }
      if (b) {
        var E = Object.keys(h.data).map(function(S) {
          return [S, h.data[S]];
        }).filter(function(S) {
          var D = S[0];
          return l(
            D,
            b.path || g,
            p,
            f,
            g,
            d
          );
        });
        b.data = t(
          E.map(function(S) {
            var D = S[0], w = S[1];
            return c(
              w,
              D,
              f,
              a(p),
              h.exhaustive
            );
          }),
          u[0],
          u[1]
        );
      }
      return y;
    };
  }
  function l(u, f, g, d, p, m) {
    return p && (u.indexOf(p) !== 0 || p === u) ? !1 : !p && u.indexOf(d) === -1 || // if there is a rootPath, being root level mean 1 level under rootPath
    p && u.split(d).length - p.split(d).length === 1 || // if current refinement is a root level and current facetValue is a root level,
    // keep the facetValue
    u.indexOf(d) === -1 && g.indexOf(d) === -1 || // currentRefinement is a child of the facet value
    g.indexOf(u) === 0 || // facetValue is a child of the current parent, add it
    u.indexOf(f + d) === 0 && (m || u.indexOf(g) === 0);
  }
  function c(u, f, g, d, p) {
    var m = f.split(g);
    return {
      name: m[m.length - 1].trim(),
      path: f,
      escapedValue: n(f),
      count: u,
      isRefined: d === f || d.indexOf(f + g) === 0,
      exhaustive: p,
      data: null
    };
  }
  return jl;
}
var Ml, Kg;
function H1() {
  if (Kg) return Ml;
  Kg = 1;
  var o = pw(), e = Ip(), r = Wp(), t = Xa(), n = dw(), a = I1(), s = gw(), i = R1(), l = r.escapeFacetValue, c = r.unescapeFacetValue, u = mw();
  function f(D) {
    var w = {};
    return D.forEach(function(A, C) {
      w[A] = C;
    }), w;
  }
  function g(D, w, A) {
    w && w[A] && (D.stats = w[A]);
  }
  function d(D, w) {
    return t(
      D,
      function(C) {
        var x = C.attributes || [];
        return x.indexOf(w) > -1;
      }
    );
  }
  function p(D, w, A) {
    var C = w[0] || {};
    this._rawResults = w;
    var x = this;
    Object.keys(C).forEach(function(Y) {
      x[Y] = C[Y];
    });
    var T = e(A, {
      persistHierarchicalRootCount: !1
    });
    Object.keys(T).forEach(function(Y) {
      x[Y] = T[Y];
    }), this.processingTimeMS = w.reduce(function(Y, X) {
      return X.processingTimeMS === void 0 ? Y : Y + X.processingTimeMS;
    }, 0), this.disjunctiveFacets = [], this.hierarchicalFacets = D.hierarchicalFacets.map(
      function() {
        return [];
      }
    ), this.facets = [];
    var M = D.getRefinedDisjunctiveFacets(), V = f(D.facets), G = f(D.disjunctiveFacets), L = 1, W = C.facets || {};
    Object.keys(W).forEach(function(Y) {
      var X = W[Y], J = d(
        D.hierarchicalFacets,
        Y
      );
      if (J) {
        var ee = J.attributes.indexOf(Y), re = n(D.hierarchicalFacets, function(Q) {
          return Q.name === J.name;
        });
        x.hierarchicalFacets[re][ee] = {
          attribute: Y,
          data: X,
          exhaustive: C.exhaustiveFacetsCount
        };
      } else {
        var pe = D.disjunctiveFacets.indexOf(Y) !== -1, U = D.facets.indexOf(Y) !== -1, Z;
        pe && (Z = G[Y], x.disjunctiveFacets[Z] = {
          name: Y,
          data: X,
          exhaustive: C.exhaustiveFacetsCount
        }, g(
          x.disjunctiveFacets[Z],
          C.facets_stats,
          Y
        )), U && (Z = V[Y], x.facets[Z] = {
          name: Y,
          data: X,
          exhaustive: C.exhaustiveFacetsCount
        }, g(
          x.facets[Z],
          C.facets_stats,
          Y
        ));
      }
    }), this.hierarchicalFacets = o(this.hierarchicalFacets), M.forEach(function(Y) {
      var X = w[L], J = X && X.facets ? X.facets : {}, ee = D.getHierarchicalFacetByName(Y);
      Object.keys(J).forEach(function(re) {
        var pe = J[re], U;
        if (ee) {
          U = n(D.hierarchicalFacets, function(oe) {
            return oe.name === ee.name;
          });
          var Z = n(
            x.hierarchicalFacets[U],
            function(oe) {
              return oe.attribute === re;
            }
          );
          if (Z === -1)
            return;
          x.hierarchicalFacets[U][Z].data = x.persistHierarchicalRootCount ? s(
            x.hierarchicalFacets[U][Z].data,
            pe
          ) : e(
            pe,
            x.hierarchicalFacets[U][Z].data
          );
        } else {
          U = G[re];
          var Q = C.facets && C.facets[re] || {};
          x.disjunctiveFacets[U] = {
            name: re,
            data: s(Q, pe),
            exhaustive: X.exhaustiveFacetsCount
          }, g(
            x.disjunctiveFacets[U],
            X.facets_stats,
            re
          ), D.disjunctiveFacetsRefinements[re] && D.disjunctiveFacetsRefinements[re].forEach(function(oe) {
            !x.disjunctiveFacets[U].data[oe] && D.disjunctiveFacetsRefinements[re].indexOf(
              c(oe)
            ) > -1 && (x.disjunctiveFacets[U].data[oe] = 0);
          });
        }
      }), L++;
    }), D.getRefinedHierarchicalFacets().forEach(function(Y) {
      var X = D.getHierarchicalFacetByName(Y), J = D._getHierarchicalFacetSeparator(X), ee = D.getHierarchicalRefinement(Y);
      ee.length === 0 || ee[0].split(J).length < 2 || w.slice(L).forEach(function(re) {
        var pe = re && re.facets ? re.facets : {};
        Object.keys(pe).forEach(function(U) {
          var Z = pe[U], Q = n(D.hierarchicalFacets, function(ke) {
            return ke.name === X.name;
          }), oe = n(
            x.hierarchicalFacets[Q],
            function(ke) {
              return ke.attribute === U;
            }
          );
          if (oe !== -1) {
            var ge = {};
            if (ee.length > 0 && !x.persistHierarchicalRootCount) {
              var Ae = ee[0].split(J)[0];
              ge[Ae] = x.hierarchicalFacets[Q][oe].data[Ae];
            }
            x.hierarchicalFacets[Q][oe].data = e(
              ge,
              Z,
              x.hierarchicalFacets[Q][oe].data
            );
          }
        }), L++;
      });
    }), Object.keys(D.facetsExcludes).forEach(function(Y) {
      var X = D.facetsExcludes[Y], J = V[Y];
      x.facets[J] = {
        name: Y,
        data: W[Y],
        exhaustive: C.exhaustiveFacetsCount
      }, X.forEach(function(ee) {
        x.facets[J] = x.facets[J] || { name: Y }, x.facets[J].data = x.facets[J].data || {}, x.facets[J].data[ee] = 0;
      });
    }), this.hierarchicalFacets = this.hierarchicalFacets.map(
      u(D)
    ), this.facets = o(this.facets), this.disjunctiveFacets = o(this.disjunctiveFacets), this._state = D;
  }
  p.prototype.getFacetByName = function(D) {
    function w(A) {
      return A.name === D;
    }
    return t(this.facets, w) || t(this.disjunctiveFacets, w) || t(this.hierarchicalFacets, w);
  };
  function m(D, w) {
    function A(W) {
      return W.name === w;
    }
    if (D._state.isConjunctiveFacet(w)) {
      var C = t(D.facets, A);
      return C ? Object.keys(C.data).map(function(W) {
        var Y = l(W);
        return {
          name: W,
          escapedValue: Y,
          count: C.data[W],
          isRefined: D._state.isFacetRefined(w, Y),
          isExcluded: D._state.isExcludeRefined(w, W)
        };
      }) : [];
    } else if (D._state.isDisjunctiveFacet(w)) {
      var x = t(D.disjunctiveFacets, A);
      return x ? Object.keys(x.data).map(function(W) {
        var Y = l(W);
        return {
          name: W,
          escapedValue: Y,
          count: x.data[W],
          isRefined: D._state.isDisjunctiveFacetRefined(w, Y)
        };
      }) : [];
    } else if (D._state.isHierarchicalFacet(w)) {
      var T = t(D.hierarchicalFacets, A);
      if (!T) return T;
      var M = D._state.getHierarchicalFacetByName(w), V = D._state._getHierarchicalFacetSeparator(M), G = c(
        D._state.getHierarchicalRefinement(w)[0] || ""
      );
      G.indexOf(M.rootPath) === 0 && (G = G.replace(
        M.rootPath + V,
        ""
      ));
      var L = G.split(V);
      return L.unshift(w), y(T, L, 0), T;
    }
  }
  function y(D, w, A) {
    D.isRefined = D.name === (w[A] && w[A].trim()), D.data && D.data.forEach(function(C) {
      y(C, w, A + 1);
    });
  }
  function h(D, w, A, C) {
    if (C = C || 0, Array.isArray(w))
      return D(w, A[C]);
    if (!w.data || w.data.length === 0)
      return w;
    var x = w.data.map(function(V) {
      return h(D, V, A, C + 1);
    }), T = D(x, A[C]), M = e({ data: T }, w);
    return M;
  }
  p.DEFAULT_SORT = ["isRefined:desc", "count:desc", "name:asc"];
  function F(D, w) {
    return w.sort(D);
  }
  function b(D, w) {
    var A = [], C = [], x = w.hide || [], T = w.order || [], M = T.reduce(function(L, W, Y) {
      return L[W] = Y, L;
    }, {});
    D.forEach(function(L) {
      var W = L.path || L.name, Y = x.indexOf(W) > -1;
      !Y && M[W] !== void 0 ? A[M[W]] = L : Y || C.push(L);
    }), A = A.filter(function(L) {
      return L;
    });
    var V = w.sortRemainingBy, G;
    return V === "hidden" ? A : (V === "alpha" ? G = [
      ["path", "name"],
      ["asc", "asc"]
    ] : G = [["count"], ["desc"]], A.concat(
      i(C, G[0], G[1])
    ));
  }
  function v(D, w) {
    return D.renderingContent && D.renderingContent.facetOrdering && D.renderingContent.facetOrdering.values && D.renderingContent.facetOrdering.values[w];
  }
  p.prototype.getFacetValues = function(D, w) {
    var A = m(this, D);
    if (A) {
      var C = e(w, {
        sortBy: p.DEFAULT_SORT,
        // if no sortBy is given, attempt to sort based on facetOrdering
        // if it is given, we still allow to sort via facet ordering first
        facetOrdering: !(w && w.sortBy)
      }), x = this, T;
      if (Array.isArray(A))
        T = [D];
      else {
        var M = x._state.getHierarchicalFacetByName(A.name);
        T = M.attributes;
      }
      return h(
        function(V, G) {
          if (C.facetOrdering) {
            var L = v(x, G);
            if (L)
              return b(V, L);
          }
          if (Array.isArray(C.sortBy)) {
            var W = a(C.sortBy, p.DEFAULT_SORT);
            return i(V, W[0], W[1]);
          } else if (typeof C.sortBy == "function")
            return F(C.sortBy, V);
          throw new Error(
            "options.sortBy is optional but if defined it must be either an array of string (predicates) or a sorting function"
          );
        },
        A,
        T
      );
    }
  }, p.prototype.getFacetStats = function(D) {
    if (this._state.isConjunctiveFacet(D))
      return P(this.facets, D);
    if (this._state.isDisjunctiveFacet(D))
      return P(this.disjunctiveFacets, D);
  };
  function P(D, w) {
    var A = t(D, function(C) {
      return C.name === w;
    });
    return A && A.stats;
  }
  p.prototype.getRefinements = function() {
    var D = this._state, w = this, A = [];
    return Object.keys(D.facetsRefinements).forEach(function(C) {
      D.facetsRefinements[C].forEach(function(x) {
        A.push(
          E(D, "facet", C, x, w.facets)
        );
      });
    }), Object.keys(D.facetsExcludes).forEach(function(C) {
      D.facetsExcludes[C].forEach(function(x) {
        A.push(
          E(D, "exclude", C, x, w.facets)
        );
      });
    }), Object.keys(D.disjunctiveFacetsRefinements).forEach(function(C) {
      D.disjunctiveFacetsRefinements[C].forEach(function(x) {
        A.push(
          E(
            D,
            "disjunctive",
            C,
            x,
            w.disjunctiveFacets
          )
        );
      });
    }), Object.keys(D.hierarchicalFacetsRefinements).forEach(function(C) {
      D.hierarchicalFacetsRefinements[C].forEach(function(x) {
        A.push(
          S(
            D,
            C,
            x,
            w.hierarchicalFacets
          )
        );
      });
    }), Object.keys(D.numericRefinements).forEach(function(C) {
      var x = D.numericRefinements[C];
      Object.keys(x).forEach(function(T) {
        x[T].forEach(function(M) {
          A.push({
            type: "numeric",
            attributeName: C,
            name: M,
            numericValue: M,
            operator: T
          });
        });
      });
    }), D.tagRefinements.forEach(function(C) {
      A.push({ type: "tag", attributeName: "_tags", name: C });
    }), A;
  };
  function E(D, w, A, C, x) {
    var T = t(x, function(G) {
      return G.name === A;
    }), M = T && T.data && T.data[C] ? T.data[C] : 0, V = T && T.exhaustive || !1;
    return {
      type: w,
      attributeName: A,
      name: C,
      count: M,
      exhaustive: V
    };
  }
  function S(D, w, A, C) {
    var x = D.getHierarchicalFacetByName(w), T = D._getHierarchicalFacetSeparator(x), M = A.split(T), V = t(C, function(X) {
      return X.name === w;
    }), G = M.reduce(function(X, J) {
      var ee = X && t(X.data, function(re) {
        return re.name === J;
      });
      return ee !== void 0 ? ee : X;
    }, V), L = G && G.count || 0, W = G && G.exhaustive || !1, Y = G && G.path || "";
    return {
      type: "hierarchical",
      attributeName: w,
      name: Y,
      count: L,
      exhaustive: W
    };
  }
  return Ml = p, Ml;
}
var Wl, Qg;
function fw() {
  return Qg || (Qg = 1, Wl = function(e) {
    return e.reduce(function(r, t) {
      return r.concat(t);
    }, []);
  }), Wl;
}
var Nl, Jg;
function yw() {
  if (Jg) return Nl;
  Jg = 1;
  var o = Xa(), e = fw();
  function r(n, a) {
    var s = [];
    return Object.keys(n).forEach(function(i) {
      n[i].count < 2 && (n[i].indexSum += 100), s.push({
        objectID: i,
        avgOfIndices: n[i].indexSum / a
      });
    }), s.sort(function(i, l) {
      return i.avgOfIndices > l.avgOfIndices ? 1 : -1;
    });
  }
  function t(n) {
    var a = {};
    n.forEach(function(l) {
      l.forEach(function(c, u) {
        a[c.objectID] ? a[c.objectID] = {
          indexSum: a[c.objectID].indexSum + u,
          count: a[c.objectID].count + 1
        } : a[c.objectID] = { indexSum: u, count: 1 };
      });
    });
    var s = r(a, n.length), i = s.reduce(
      function(l, c) {
        var u = o(e(n), function(f) {
          return f.objectID === c.objectID;
        });
        return u ? l.concat(u) : l;
      },
      []
    );
    return i;
  }
  return Nl = t, Nl;
}
var Vl, _g;
function Y1() {
  return _g || (_g = 1, Vl = "3.24.1"), Vl;
}
var zl, $g;
function hw() {
  if ($g) return zl;
  $g = 1;
  var o = Mp(), e = aw(), r = Wp().escapeFacetValue, t = W1(), n = Np(), a = Vp(), s = zp(), i = N1(), l = V1(), c = sw(), u = z1(), f = H1(), g = yw(), d = Y1();
  function p(h, F, b, v) {
    typeof h.addAlgoliaAgent == "function" && h.addAlgoliaAgent("JS Helper (" + d + ")"), this.setClient(h);
    var P = b || {};
    P.index = F, this.state = u.make(P), this.recommendState = new i({
      params: P.recommendState
    }), this.lastResults = null, this.lastRecommendResults = null, this._queryId = 0, this._recommendQueryId = 0, this._lastQueryIdReceived = -1, this._lastRecommendQueryIdReceived = -1, this.derivedHelpers = [], this._currentNbQueries = 0, this._currentNbRecommendQueries = 0, this._searchResultsOptions = v, this._recommendCache = {};
  }
  t(p, o), p.prototype.search = function() {
    return this._search({ onlyWithDerivedHelpers: !1 }), this;
  }, p.prototype.searchOnlyWithDerivedHelpers = function() {
    return this._search({ onlyWithDerivedHelpers: !0 }), this;
  }, p.prototype.searchWithComposition = function() {
    return this._runComposition({ onlyWithDerivedHelpers: !0 }), this;
  }, p.prototype.recommend = function() {
    return this._recommend(), this;
  }, p.prototype.getQuery = function() {
    var h = this.state;
    return c._getHitsSearchParams(h);
  }, p.prototype.searchOnce = function(h, F) {
    var b = h ? this.state.setQueryParameters(h) : this.state, v = c._getQueries(b.index, b), P = this;
    if (this._currentNbQueries++, this.emit("searchOnce", {
      state: b
    }), F) {
      this.client.search(v).then(function(E) {
        P._currentNbQueries--, P._currentNbQueries === 0 && P.emit("searchQueueEmpty"), F(null, new f(b, E.results), b);
      }).catch(function(E) {
        P._currentNbQueries--, P._currentNbQueries === 0 && P.emit("searchQueueEmpty"), F(E, null, b);
      });
      return;
    }
    return this.client.search(v).then(
      function(E) {
        return P._currentNbQueries--, P._currentNbQueries === 0 && P.emit("searchQueueEmpty"), {
          content: new f(b, E.results),
          state: b,
          _originalResponse: E
        };
      },
      function(E) {
        throw P._currentNbQueries--, P._currentNbQueries === 0 && P.emit("searchQueueEmpty"), E;
      }
    );
  }, p.prototype.findAnswers = function(h) {
    console.warn("[algoliasearch-helper] answers is no longer supported");
    var F = this.state, b = this.derivedHelpers[0];
    if (!b)
      return Promise.resolve([]);
    var v = b.getModifiedState(F), P = n(
      {
        attributesForPrediction: h.attributesForPrediction,
        nbHits: h.nbHits
      },
      {
        params: s(c._getHitsSearchParams(v), [
          "attributesToSnippet",
          "hitsPerPage",
          "restrictSearchableAttributes",
          "snippetEllipsisText"
        ])
      }
    ), E = "search for answers was called, but this client does not have a function client.initIndex(index).findAnswers";
    if (typeof this.client.initIndex != "function")
      throw new Error(E);
    var S = this.client.initIndex(v.index);
    if (typeof S.findAnswers != "function")
      throw new Error(E);
    return S.findAnswers(v.query, h.queryLanguages, P);
  }, p.prototype.searchForFacetValues = function(h, F, b, v) {
    var P = typeof this.client.searchForFacetValues == "function" && // v5 has a wrong sffv signature
    typeof this.client.searchForFacets != "function", E = typeof this.client.initIndex == "function";
    if (!P && !E && typeof this.client.search != "function")
      throw new Error(
        "search for facet values (searchable) was called, but this client does not have a function client.searchForFacetValues or client.initIndex(index).searchForFacetValues"
      );
    var S = this.state.setQueryParameters(v || {}), D = S.isDisjunctiveFacet(h), w = c.getSearchForFacetQuery(
      h,
      F,
      b,
      S
    );
    this._currentNbQueries++;
    var A = this, C;
    return P ? C = this.client.searchForFacetValues([
      { indexName: S.index, params: w }
    ]) : E ? C = this.client.initIndex(S.index).searchForFacetValues(w) : (delete w.facetName, C = this.client.search([
      {
        type: "facet",
        facet: h,
        indexName: S.index,
        params: w
      }
    ]).then(function(T) {
      return T.results[0];
    })), this.emit("searchForFacetValues", {
      state: S,
      facet: h,
      query: F
    }), C.then(
      function(T) {
        return A._currentNbQueries--, A._currentNbQueries === 0 && A.emit("searchQueueEmpty"), T = Array.isArray(T) ? T[0] : T, T.facetHits.forEach(function(M) {
          M.escapedValue = r(M.value), M.isRefined = D ? S.isDisjunctiveFacetRefined(h, M.escapedValue) : S.isFacetRefined(h, M.escapedValue);
        }), T;
      },
      function(x) {
        throw A._currentNbQueries--, A._currentNbQueries === 0 && A.emit("searchQueueEmpty"), x;
      }
    );
  }, p.prototype.searchForCompositionFacetValues = function(h, F, b, v) {
    if (typeof this.client.searchForFacetValues != "function")
      throw new Error(
        "search for facet values (searchable) was called, but this client does not have a function client.searchForFacetValues"
      );
    var P = this.state.setQueryParameters(v || {}), E = P.isDisjunctiveFacet(h);
    this._currentNbQueries++;
    var S = this, D;
    return D = this.client.searchForFacetValues({
      compositionID: P.index,
      facetName: h,
      searchForFacetValuesRequest: {
        params: {
          query: F,
          maxFacetHits: b,
          searchQuery: c._getCompositionHitsSearchParams(P)
        }
      }
    }), this.emit("searchForFacetValues", {
      state: P,
      facet: h,
      query: F
    }), D.then(
      function(A) {
        return S._currentNbQueries--, S._currentNbQueries === 0 && S.emit("searchQueueEmpty"), A = A.results[0], A.facetHits.forEach(function(C) {
          C.escapedValue = r(C.value), C.isRefined = E ? P.isDisjunctiveFacetRefined(h, C.escapedValue) : P.isFacetRefined(h, C.escapedValue);
        }), A;
      },
      function(w) {
        throw S._currentNbQueries--, S._currentNbQueries === 0 && S.emit("searchQueueEmpty"), w;
      }
    );
  }, p.prototype.setQuery = function(h) {
    return this._change({
      state: this.state.resetPage().setQuery(h),
      isPageReset: !0
    }), this;
  }, p.prototype.clearRefinements = function(h) {
    return this._change({
      state: this.state.resetPage().clearRefinements(h),
      isPageReset: !0
    }), this;
  }, p.prototype.clearTags = function() {
    return this._change({
      state: this.state.resetPage().clearTags(),
      isPageReset: !0
    }), this;
  }, p.prototype.addDisjunctiveFacetRefinement = function(h, F) {
    return this._change({
      state: this.state.resetPage().addDisjunctiveFacetRefinement(h, F),
      isPageReset: !0
    }), this;
  }, p.prototype.addDisjunctiveRefine = function() {
    return this.addDisjunctiveFacetRefinement.apply(this, arguments);
  }, p.prototype.addHierarchicalFacetRefinement = function(h, F) {
    return this._change({
      state: this.state.resetPage().addHierarchicalFacetRefinement(h, F),
      isPageReset: !0
    }), this;
  }, p.prototype.addNumericRefinement = function(h, F, b) {
    return this._change({
      state: this.state.resetPage().addNumericRefinement(h, F, b),
      isPageReset: !0
    }), this;
  }, p.prototype.addFacetRefinement = function(h, F) {
    return this._change({
      state: this.state.resetPage().addFacetRefinement(h, F),
      isPageReset: !0
    }), this;
  }, p.prototype.addRefine = function() {
    return this.addFacetRefinement.apply(this, arguments);
  }, p.prototype.addFacetExclusion = function(h, F) {
    return this._change({
      state: this.state.resetPage().addExcludeRefinement(h, F),
      isPageReset: !0
    }), this;
  }, p.prototype.addExclude = function() {
    return this.addFacetExclusion.apply(this, arguments);
  }, p.prototype.addTag = function(h) {
    return this._change({
      state: this.state.resetPage().addTagRefinement(h),
      isPageReset: !0
    }), this;
  }, p.prototype.addFrequentlyBoughtTogether = function(h) {
    return this._recommendChange({
      state: this.recommendState.addFrequentlyBoughtTogether(h)
    }), this;
  }, p.prototype.addRelatedProducts = function(h) {
    return this._recommendChange({
      state: this.recommendState.addRelatedProducts(h)
    }), this;
  }, p.prototype.addTrendingItems = function(h) {
    return this._recommendChange({
      state: this.recommendState.addTrendingItems(h)
    }), this;
  }, p.prototype.addTrendingFacets = function(h) {
    return this._recommendChange({
      state: this.recommendState.addTrendingFacets(h)
    }), this;
  }, p.prototype.addLookingSimilar = function(h) {
    return this._recommendChange({
      state: this.recommendState.addLookingSimilar(h)
    }), this;
  }, p.prototype.removeNumericRefinement = function(h, F, b) {
    return this._change({
      state: this.state.resetPage().removeNumericRefinement(h, F, b),
      isPageReset: !0
    }), this;
  }, p.prototype.removeDisjunctiveFacetRefinement = function(h, F) {
    return this._change({
      state: this.state.resetPage().removeDisjunctiveFacetRefinement(h, F),
      isPageReset: !0
    }), this;
  }, p.prototype.removeDisjunctiveRefine = function() {
    return this.removeDisjunctiveFacetRefinement.apply(this, arguments);
  }, p.prototype.removeHierarchicalFacetRefinement = function(h) {
    return this._change({
      state: this.state.resetPage().removeHierarchicalFacetRefinement(h),
      isPageReset: !0
    }), this;
  }, p.prototype.removeFacetRefinement = function(h, F) {
    return this._change({
      state: this.state.resetPage().removeFacetRefinement(h, F),
      isPageReset: !0
    }), this;
  }, p.prototype.removeRefine = function() {
    return this.removeFacetRefinement.apply(this, arguments);
  }, p.prototype.removeFacetExclusion = function(h, F) {
    return this._change({
      state: this.state.resetPage().removeExcludeRefinement(h, F),
      isPageReset: !0
    }), this;
  }, p.prototype.removeExclude = function() {
    return this.removeFacetExclusion.apply(this, arguments);
  }, p.prototype.removeTag = function(h) {
    return this._change({
      state: this.state.resetPage().removeTagRefinement(h),
      isPageReset: !0
    }), this;
  }, p.prototype.removeFrequentlyBoughtTogether = function(h) {
    return this._recommendChange({
      state: this.recommendState.removeParams(h)
    }), this;
  }, p.prototype.removeRelatedProducts = function(h) {
    return this._recommendChange({
      state: this.recommendState.removeParams(h)
    }), this;
  }, p.prototype.removeTrendingItems = function(h) {
    return this._recommendChange({
      state: this.recommendState.removeParams(h)
    }), this;
  }, p.prototype.removeTrendingFacets = function(h) {
    return this._recommendChange({
      state: this.recommendState.removeParams(h)
    }), this;
  }, p.prototype.removeLookingSimilar = function(h) {
    return this._recommendChange({
      state: this.recommendState.removeParams(h)
    }), this;
  }, p.prototype.toggleFacetExclusion = function(h, F) {
    return this._change({
      state: this.state.resetPage().toggleExcludeFacetRefinement(h, F),
      isPageReset: !0
    }), this;
  }, p.prototype.toggleExclude = function() {
    return this.toggleFacetExclusion.apply(this, arguments);
  }, p.prototype.toggleRefinement = function(h, F) {
    return this.toggleFacetRefinement(h, F);
  }, p.prototype.toggleFacetRefinement = function(h, F) {
    return this._change({
      state: this.state.resetPage().toggleFacetRefinement(h, F),
      isPageReset: !0
    }), this;
  }, p.prototype.toggleRefine = function() {
    return this.toggleFacetRefinement.apply(this, arguments);
  }, p.prototype.toggleTag = function(h) {
    return this._change({
      state: this.state.resetPage().toggleTagRefinement(h),
      isPageReset: !0
    }), this;
  }, p.prototype.nextPage = function() {
    var h = this.state.page || 0;
    return this.setPage(h + 1);
  }, p.prototype.previousPage = function() {
    var h = this.state.page || 0;
    return this.setPage(h - 1);
  };
  function m(h) {
    if (h < 0) throw new Error("Page requested below 0.");
    return this._change({
      state: this.state.setPage(h),
      isPageReset: !1
    }), this;
  }
  p.prototype.setCurrentPage = m, p.prototype.setPage = m, p.prototype.setIndex = function(h) {
    return this._change({
      state: this.state.resetPage().setIndex(h),
      isPageReset: !0
    }), this;
  }, p.prototype.setQueryParameter = function(h, F) {
    return this._change({
      state: this.state.resetPage().setQueryParameter(h, F),
      isPageReset: !0
    }), this;
  }, p.prototype.setState = function(h) {
    return this._change({
      state: u.make(h),
      isPageReset: !1
    }), this;
  }, p.prototype.overrideStateWithoutTriggeringChangeEvent = function(h) {
    return this.state = new u(h), this;
  }, p.prototype.hasRefinements = function(h) {
    return a(this.state.getNumericRefinements(h)) ? !0 : this.state.isConjunctiveFacet(h) ? this.state.isFacetRefined(h) : this.state.isDisjunctiveFacet(h) ? this.state.isDisjunctiveFacetRefined(h) : this.state.isHierarchicalFacet(h) ? this.state.isHierarchicalFacetRefined(h) : !1;
  }, p.prototype.isExcluded = function(h, F) {
    return this.state.isExcludeRefined(h, F);
  }, p.prototype.isDisjunctiveRefined = function(h, F) {
    return this.state.isDisjunctiveFacetRefined(h, F);
  }, p.prototype.hasTag = function(h) {
    return this.state.isTagRefined(h);
  }, p.prototype.isTagRefined = function() {
    return this.hasTagRefinements.apply(this, arguments);
  }, p.prototype.getIndex = function() {
    return this.state.index;
  };
  function y() {
    return this.state.page;
  }
  return p.prototype.getCurrentPage = y, p.prototype.getPage = y, p.prototype.getTags = function() {
    return this.state.tagRefinements;
  }, p.prototype.getRefinements = function(h) {
    var F = [];
    if (this.state.isConjunctiveFacet(h)) {
      var b = this.state.getConjunctiveRefinements(h);
      b.forEach(function(S) {
        F.push({
          value: S,
          type: "conjunctive"
        });
      });
      var v = this.state.getExcludeRefinements(h);
      v.forEach(function(S) {
        F.push({
          value: S,
          type: "exclude"
        });
      });
    } else if (this.state.isDisjunctiveFacet(h)) {
      var P = this.state.getDisjunctiveRefinements(h);
      P.forEach(function(S) {
        F.push({
          value: S,
          type: "disjunctive"
        });
      });
    }
    var E = this.state.getNumericRefinements(h);
    return Object.keys(E).forEach(function(S) {
      var D = E[S];
      F.push({
        value: D,
        operator: S,
        type: "numeric"
      });
    }), F;
  }, p.prototype.getNumericRefinement = function(h, F) {
    return this.state.getNumericRefinement(h, F);
  }, p.prototype.getHierarchicalFacetBreadcrumb = function(h) {
    return this.state.getHierarchicalFacetBreadcrumb(h);
  }, p.prototype._search = function(h) {
    var F = this.state, b = [], v = [];
    h.onlyWithDerivedHelpers || (v = c._getQueries(F.index, F), b.push({
      state: F,
      queriesCount: v.length,
      helper: this
    }), this.emit("search", {
      state: F,
      results: this.lastResults
    }));
    var P = this.derivedHelpers.map(function(D) {
      var w = D.getModifiedState(F), A = w.index ? c._getQueries(w.index, w) : [];
      return b.push({
        state: w,
        queriesCount: A.length,
        helper: D
      }), D.emit("search", {
        state: w,
        results: D.lastResults
      }), A;
    }), E = Array.prototype.concat.apply(v, P), S = this._queryId++;
    if (this._currentNbQueries++, !E.length)
      return Promise.resolve({ results: [] }).then(
        this._dispatchAlgoliaResponse.bind(this, b, S)
      );
    try {
      this.client.search(E).then(this._dispatchAlgoliaResponse.bind(this, b, S)).catch(this._dispatchAlgoliaError.bind(this, S));
    } catch (D) {
      this.emit("error", {
        error: D
      });
    }
  }, p.prototype._runComposition = function() {
    var h = this.state, F = [], b = [], v = this.derivedHelpers.map(function(D) {
      var w = D.getModifiedState(h), A = c._getCompositionQueries(w);
      return F.push({
        state: w,
        queriesCount: A.length,
        helper: D
      }), D.emit("search", {
        state: w,
        results: D.lastResults
      }), A;
    }), P = Array.prototype.concat.apply(b, v), E = this._queryId++;
    if (this._currentNbQueries++, !P.length)
      return Promise.resolve({ results: [] }).then(
        this._dispatchAlgoliaResponse.bind(this, F, E)
      );
    if (P.length > 1)
      throw new Error("Only one query is allowed when using a composition.");
    var S = P[0];
    try {
      this.client.search(S).then(this._dispatchAlgoliaResponse.bind(this, F, E)).catch(this._dispatchAlgoliaError.bind(this, E));
    } catch (D) {
      this.emit("error", {
        error: D
      });
    }
  }, p.prototype._recommend = function() {
    var h = this.state, F = this.recommendState, b = this.getIndex(), v = [{ state: F, index: b, helper: this }], P = F.params.map(function(A) {
      return A.$$id;
    });
    this.emit("fetch", {
      recommend: {
        state: F,
        results: this.lastRecommendResults
      }
    });
    var E = this._recommendCache, S = this.derivedHelpers.map(function(A) {
      var C = A.getModifiedState(h).index;
      if (!C)
        return [];
      var x = A.getModifiedRecommendState(
        new i()
      );
      return v.push({
        state: x,
        index: C,
        helper: A
      }), P = Array.prototype.concat.apply(
        P,
        x.params.map(function(T) {
          return T.$$id;
        })
      ), A.emit("fetch", {
        recommend: {
          state: x,
          results: A.lastRecommendResults
        }
      }), x._buildQueries(C, E);
    }), D = Array.prototype.concat.apply(
      this.recommendState._buildQueries(b, E),
      S
    );
    if (D.length !== 0) {
      if (D.length > 0 && typeof this.client.getRecommendations > "u") {
        console.warn(
          "Please update algoliasearch/lite to the latest version in order to use recommend widgets."
        );
        return;
      }
      var w = this._recommendQueryId++;
      this._currentNbRecommendQueries++;
      try {
        this.client.getRecommendations(D).then(this._dispatchRecommendResponse.bind(this, w, v, P)).catch(this._dispatchRecommendError.bind(this, w));
      } catch (A) {
        this.emit("error", {
          error: A
        });
      }
    }
  }, p.prototype._dispatchAlgoliaResponse = function(h, F, b) {
    var v = this;
    if (!(F < this._lastQueryIdReceived)) {
      this._currentNbQueries -= F - this._lastQueryIdReceived, this._lastQueryIdReceived = F, this._currentNbQueries === 0 && this.emit("searchQueueEmpty");
      var P = b.results.slice(), E = Object.keys(b).reduce(function(S, D) {
        return D !== "results" && (S[D] = b[D]), S;
      }, {});
      Object.keys(E).length <= 0 && (E = void 0), h.forEach(function(S) {
        var D = S.state, w = S.queriesCount, A = S.helper, C = P.splice(0, w);
        if (!D.index) {
          A.emit("result", {
            results: null,
            state: D
          });
          return;
        }
        A.lastResults = new f(
          D,
          C,
          v._searchResultsOptions
        ), E !== void 0 && (A.lastResults._rawContent = E), A.emit("result", {
          results: A.lastResults,
          state: D
        });
      });
    }
  }, p.prototype._dispatchRecommendResponse = function(h, F, b, v) {
    if (!(h < this._lastRecommendQueryIdReceived)) {
      this._currentNbRecommendQueries -= h - this._lastRecommendQueryIdReceived, this._lastRecommendQueryIdReceived = h, this._currentNbRecommendQueries === 0 && this.emit("recommendQueueEmpty");
      var P = this._recommendCache, E = {};
      b.filter(function(D) {
        return P[D] === void 0;
      }).forEach(function(D, w) {
        E[D] || (E[D] = []), E[D].push(w);
      }), Object.keys(E).forEach(function(D) {
        var w = E[D], A = v.results[w[0]];
        if (w.length === 1) {
          P[D] = A;
          return;
        }
        P[D] = Object.assign({}, A, {
          hits: g(
            w.map(function(C) {
              return v.results[C].hits;
            })
          )
        });
      });
      var S = {};
      b.forEach(function(D) {
        S[D] = P[D];
      }), F.forEach(function(D) {
        var w = D.state, A = D.helper;
        if (!D.index) {
          A.emit("recommend:result", {
            results: null,
            state: w
          });
          return;
        }
        A.lastRecommendResults = new l(w, S), A.emit("recommend:result", {
          recommend: {
            results: A.lastRecommendResults,
            state: w
          }
        });
      });
    }
  }, p.prototype._dispatchAlgoliaError = function(h, F) {
    h < this._lastQueryIdReceived || (this._currentNbQueries -= h - this._lastQueryIdReceived, this._lastQueryIdReceived = h, this.emit("error", {
      error: F
    }), this._currentNbQueries === 0 && this.emit("searchQueueEmpty"));
  }, p.prototype._dispatchRecommendError = function(h, F) {
    h < this._lastRecommendQueryIdReceived || (this._currentNbRecommendQueries -= h - this._lastRecommendQueryIdReceived, this._lastRecommendQueryIdReceived = h, this.emit("error", {
      error: F
    }), this._currentNbRecommendQueries === 0 && this.emit("recommendQueueEmpty"));
  }, p.prototype.containsRefinement = function(h, F, b, v) {
    return h || F.length !== 0 || b.length !== 0 || v.length !== 0;
  }, p.prototype._hasDisjunctiveRefinements = function(h) {
    return this.state.disjunctiveRefinements[h] && this.state.disjunctiveRefinements[h].length > 0;
  }, p.prototype._change = function(h) {
    var F = h.state, b = h.isPageReset;
    F !== this.state && (this.state = F, this.emit("change", {
      state: this.state,
      results: this.lastResults,
      isPageReset: b
    }));
  }, p.prototype._recommendChange = function(h) {
    var F = h.state;
    F !== this.recommendState && (this.recommendState = F, this.emit("recommend:change", {
      search: {
        results: this.lastResults,
        state: this.state
      },
      recommend: {
        results: this.lastRecommendResults,
        state: this.recommendState
      }
    }));
  }, p.prototype.clearCache = function() {
    return this.client.clearCache && this.client.clearCache(), this;
  }, p.prototype.setClient = function(h) {
    return this.client === h ? this : (typeof h.addAlgoliaAgent == "function" && h.addAlgoliaAgent("JS Helper (" + d + ")"), this.client = h, this);
  }, p.prototype.getClient = function() {
    return this.client;
  }, p.prototype.derive = function(h, F) {
    var b = new e(this, h, F);
    return this.derivedHelpers.push(b), b;
  }, p.prototype.detachDerivedHelper = function(h) {
    var F = this.derivedHelpers.indexOf(h);
    if (F === -1) throw new Error("Derived helper already detached");
    this.derivedHelpers.splice(F, 1);
  }, p.prototype.hasPendingRequests = function() {
    return this._currentNbQueries > 0;
  }, zl = p, zl;
}
var Il, em;
function Fw() {
  if (em) return Il;
  em = 1;
  var o = hw(), e = N1(), r = V1(), t = z1(), n = H1();
  function a(s, i, l, c) {
    return new o(s, i, l, c);
  }
  return a.version = Y1(), a.AlgoliaSearchHelper = o, a.SearchParameters = t, a.RecommendParameters = e, a.SearchResults = n, a.RecommendResults = r, Il = a, Il;
}
var bw = Fw();
const so = /* @__PURE__ */ qr(bw);
function Un(o) {
  "@babel/helpers - typeof";
  return Un = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Un(o);
}
function om(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function Ue(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? om(Object(r), !0).forEach(function(t) {
      q1(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : om(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function q1(o, e, r) {
  return e = vw(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function vw(o) {
  var e = Bw(o, "string");
  return Un(e) == "symbol" ? e : String(e);
}
function Bw(o, e) {
  if (Un(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (Un(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
var Pw = Te({
  name: "configure",
  connector: !0
});
function rm(o, e) {
  return o.setQueryParameters(Object.keys(e.searchParameters).reduce(function(r, t) {
    return Ue(Ue({}, r), {}, q1({}, t, void 0));
  }, {}));
}
var G1 = function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Fe, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Fe;
  return function(t) {
    if (!t || !S1(t.searchParameters))
      throw new Error(Pw("The `searchParameters` option expects an object."));
    var n = {};
    function a(s) {
      return function(i) {
        var l = rm(s.state, t), c = An(l, new so.SearchParameters(i));
        t.searchParameters = i, s.setState(c).search();
      };
    }
    return {
      $$type: "ais.configure",
      init: function(i) {
        var l = i.instantSearchInstance;
        e(Ue(Ue({}, this.getWidgetRenderState(i)), {}, {
          instantSearchInstance: l
        }), !0);
      },
      render: function(i) {
        var l = i.instantSearchInstance;
        e(Ue(Ue({}, this.getWidgetRenderState(i)), {}, {
          instantSearchInstance: l
        }), !1);
      },
      dispose: function(i) {
        var l = i.state;
        return r(), rm(l, t);
      },
      getRenderState: function(i, l) {
        var c, u = this.getWidgetRenderState(l);
        return Ue(Ue({}, i), {}, {
          configure: Ue(Ue({}, u), {}, {
            widgetParams: Ue(Ue({}, u.widgetParams), {}, {
              searchParameters: An(new so.SearchParameters((c = i.configure) === null || c === void 0 ? void 0 : c.widgetParams.searchParameters), new so.SearchParameters(u.widgetParams.searchParameters)).getQueryParams()
            })
          })
        });
      },
      getWidgetRenderState: function(i) {
        var l = i.helper;
        return n.refine || (n.refine = a(l)), {
          refine: n.refine,
          widgetParams: t
        };
      },
      getWidgetSearchParameters: function(i, l) {
        var c = l.uiState;
        return An(i, new so.SearchParameters(Ue(Ue({}, c.configure), t.searchParameters)));
      },
      getWidgetUiState: function(i) {
        return Ue(Ue({}, i), {}, {
          configure: Ue(Ue({}, i.configure), t.searchParameters)
        });
      }
    };
  };
};
function Zn(o) {
  "@babel/helpers - typeof";
  return Zn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Zn(o);
}
function tm(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function Rl(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? tm(Object(r), !0).forEach(function(t) {
      ww(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : tm(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function ww(o, e, r) {
  return e = kw(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function kw(o) {
  var e = Dw(o, "string");
  return Zn(e) == "symbol" ? e : String(e);
}
function Dw(o, e) {
  if (Zn(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (Zn(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
function nm(o) {
  return xw(o) || Ew(o) || Aw(o) || Sw();
}
function Sw() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Aw(o, e) {
  if (o) {
    if (typeof o == "string") return bu(o, e);
    var r = Object.prototype.toString.call(o).slice(8, -1);
    if (r === "Object" && o.constructor && (r = o.constructor.name), r === "Map" || r === "Set") return Array.from(o);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return bu(o, e);
  }
}
function Ew(o) {
  if (typeof Symbol < "u" && o[Symbol.iterator] != null || o["@@iterator"] != null) return Array.from(o);
}
function xw(o) {
  if (Array.isArray(o)) return bu(o);
}
function bu(o, e) {
  (e == null || e > o.length) && (e = o.length);
  for (var r = 0, t = new Array(e); r < e; r++) t[r] = o[r];
  return t;
}
var am = Te({
  name: "configure-related-items",
  connector: !0
});
function sm(o) {
  var e = o.attributeName, r = o.attributeValue, t = o.attributeScore;
  return "".concat(e, ":").concat(r, "<score=").concat(t || 1, ">");
}
var Cw = function(e, r) {
  return function(t) {
    var n = t || {}, a = n.hit, s = n.matchingPatterns, i = n.transformSearchParameters, l = i === void 0 ? function(g) {
      return g;
    } : i;
    if (!a)
      throw new Error(am("The `hit` option is required."));
    if (!s)
      throw new Error(am("The `matchingPatterns` option is required."));
    var c = Object.keys(s).reduce(function(g, d) {
      var p = s[d], m = rn(a, d), y = p.score;
      return Array.isArray(m) ? [].concat(nm(g), [m.map(function(h) {
        return sm({
          attributeName: d,
          attributeValue: h,
          attributeScore: y
        });
      })]) : typeof m == "string" ? [].concat(nm(g), [sm({
        attributeName: d,
        attributeValue: m,
        attributeScore: y
      })]) : (process.env.NODE_ENV === "development" && de(!1, "\nThe `matchingPatterns` option returned a value of type ".concat(P1(m), ' for the "').concat(d, '" key. This value was not sent to Algolia because `optionalFilters` only supports strings and array of strings.\n\nYou can remove the "').concat(d, `" key from the \`matchingPatterns\` option.

See https://www.algolia.com/doc/api-reference/api-parameters/optionalFilters/
            `)), g);
    }, []), u = Rl({}, l(new so.SearchParameters({
      sumOrFiltersScores: !0,
      facetFilters: ["objectID:-".concat(a.objectID)],
      optionalFilters: c
    }))), f = G1(e, r);
    return Rl(Rl({}, f({
      searchParameters: u
    })), {}, {
      $$type: "ais.configureRelatedItems"
    });
  };
};
function im(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function Dt(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? im(Object(r), !0).forEach(function(t) {
      Ow(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : im(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function Ow(o, e, r) {
  return e = Tw(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function Tw(o) {
  var e = Lw(o, "string");
  return Gt(e) == "symbol" ? e : String(e);
}
function Lw(o, e) {
  if (Gt(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (Gt(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
function Gt(o) {
  "@babel/helpers - typeof";
  return Gt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Gt(o);
}
var gs = Te({
  name: "dynamic-widgets",
  connector: !0
}), lm = 20, X1 = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Fe;
  return Ie(e, gs()), function(t) {
    var n = t.widgets, a = t.maxValuesPerFacet, s = a === void 0 ? 20 : a, i = t.facets, l = i === void 0 ? ["*"] : i, c = t.transformItems, u = c === void 0 ? function(d) {
      return d;
    } : c, f = t.fallbackWidget;
    if (!(n && Array.isArray(n) && n.every(function(d) {
      return Gt(d) === "object";
    })))
      throw new Error(gs("The `widgets` option expects an array of widgets."));
    if (!Array.isArray(l))
      throw new Error(gs("The `facets` option only accepts an array of facets, you passed ".concat(JSON.stringify(l))));
    var g = /* @__PURE__ */ new Map();
    return {
      $$type: "ais.dynamicWidgets",
      init: function(p) {
        n.forEach(function(m) {
          var y = lP(m, p);
          g.set(y, {
            widget: m,
            isMounted: !1
          });
        }), e(Dt(Dt({}, this.getWidgetRenderState(p)), {}, {
          instantSearchInstance: p.instantSearchInstance
        }), !0);
      },
      render: function(p) {
        var m = p.parent, y = this.getWidgetRenderState(p), h = [], F = [];
        f && y.attributesToRender.forEach(function(b) {
          if (!g.has(b)) {
            var v = f({
              attribute: b
            });
            g.set(b, {
              widget: v,
              isMounted: !1
            });
          }
        }), g.forEach(function(b, v) {
          var P = b.widget, E = b.isMounted, S = y.attributesToRender.indexOf(v) > -1;
          !E && S ? (F.push(P), g.set(v, {
            widget: P,
            isMounted: !0
          })) : E && !S && (h.push(P), g.set(v, {
            widget: P,
            isMounted: !1
          }));
        }), m.addWidgets(F), setTimeout(function() {
          return m.removeWidgets(h);
        }, 0), e(Dt(Dt({}, y), {}, {
          instantSearchInstance: p.instantSearchInstance
        }), !1);
      },
      dispose: function(p) {
        var m = p.parent, y = [];
        g.forEach(function(h) {
          var F = h.widget, b = h.isMounted;
          b && y.push(F);
        }), m.removeWidgets(y), r();
      },
      getWidgetSearchParameters: function(p) {
        return l.reduce(function(m, y) {
          return m.addFacet(y);
        }, p.setQueryParameters({
          maxValuesPerFacet: Math.max(s || 0, p.maxValuesPerFacet || 0)
        }));
      },
      getRenderState: function(p, m) {
        return Dt(Dt({}, p), {}, {
          dynamicWidgets: this.getWidgetRenderState(m)
        });
      },
      getWidgetRenderState: function(p) {
        var m, y, h, F, b = p.results, v = p.state;
        if (!b)
          return {
            attributesToRender: [],
            widgetParams: t
          };
        var P = u((m = (y = b.renderingContent) === null || y === void 0 || (h = y.facetOrdering) === null || h === void 0 || (F = h.facets) === null || F === void 0 ? void 0 : F.order) !== null && m !== void 0 ? m : [], {
          results: b
        });
        if (!Array.isArray(P))
          throw new Error(gs("The `transformItems` option expects a function that returns an Array."));
        return process.env.NODE_ENV === "development" && de(s >= (v.maxValuesPerFacet || 0), "The maxValuesPerFacet set by dynamic widgets (".concat(s, ") is smaller than one of the limits set by a widget (").concat(v.maxValuesPerFacet, "). This causes a mismatch in query parameters and thus an extra network request when that widget is mounted.")), process.env.NODE_ENV === "development" && de(P.length <= lm || t.facets !== void 0, "More than ".concat(lm, ` facets are requested to be displayed without explicitly setting which facets to retrieve. This could have a performance impact. Set "facets" to [] to do two smaller network requests, or explicitly to ['*'] to avoid this warning.`)), {
          attributesToRender: P,
          widgetParams: t
        };
      }
    };
  };
};
function Kn(o) {
  "@babel/helpers - typeof";
  return Kn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Kn(o);
}
function jw(o) {
  return Vw(o) || Nw(o) || Ww(o) || Mw();
}
function Mw() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Ww(o, e) {
  if (o) {
    if (typeof o == "string") return vu(o, e);
    var r = Object.prototype.toString.call(o).slice(8, -1);
    if (r === "Object" && o.constructor && (r = o.constructor.name), r === "Map" || r === "Set") return Array.from(o);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return vu(o, e);
  }
}
function Nw(o) {
  if (typeof Symbol < "u" && o[Symbol.iterator] != null || o["@@iterator"] != null) return Array.from(o);
}
function Vw(o) {
  if (Array.isArray(o)) return vu(o);
}
function vu(o, e) {
  (e == null || e > o.length) && (e = o.length);
  for (var r = 0, t = new Array(e); r < e; r++) t[r] = o[r];
  return t;
}
function cm(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function St(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? cm(Object(r), !0).forEach(function(t) {
      zw(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : cm(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function zw(o, e, r) {
  return e = Iw(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function Iw(o) {
  var e = Rw(o, "string");
  return Kn(e) == "symbol" ? e : String(e);
}
function Rw(o, e) {
  if (Kn(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (Kn(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
var um = Te({
  name: "clear-refinements",
  connector: !0
}), Hw = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Fe;
  return Ie(e, um()), function(t) {
    var n = t || {}, a = n.includedAttributes, s = a === void 0 ? [] : a, i = n.excludedAttributes, l = i === void 0 ? ["query"] : i, c = n.transformItems, u = c === void 0 ? function(p) {
      return p;
    } : c;
    if (t && t.includedAttributes && t.excludedAttributes)
      throw new Error(um("The options `includedAttributes` and `excludedAttributes` cannot be used together."));
    var f = {
      refine: Fe,
      createURL: function() {
        return "";
      },
      attributesToClear: []
    }, g = function() {
      return f.refine();
    }, d = function() {
      return f.createURL();
    };
    return {
      $$type: "ais.clearRefinements",
      init: function(m) {
        var y = m.instantSearchInstance;
        e(St(St({}, this.getWidgetRenderState(m)), {}, {
          instantSearchInstance: y
        }), !0);
      },
      render: function(m) {
        var y = m.instantSearchInstance;
        e(St(St({}, this.getWidgetRenderState(m)), {}, {
          instantSearchInstance: y
        }), !1);
      },
      dispose: function() {
        r();
      },
      getRenderState: function(m, y) {
        return St(St({}, m), {}, {
          clearRefinements: this.getWidgetRenderState(y)
        });
      },
      getWidgetRenderState: function(m) {
        var y = m.createURL, h = m.scopedResults, F = m.results;
        f.attributesToClear = h.reduce(function(v, P) {
          return v.concat(Yw({
            scopedResult: P,
            includedAttributes: s,
            excludedAttributes: l,
            transformItems: u,
            results: F
          }));
        }, []), f.refine = function() {
          f.attributesToClear.forEach(function(v) {
            var P = v.helper, E = v.items;
            P.setState(ag({
              helper: P,
              attributesToClear: E
            })).search();
          });
        }, f.createURL = function() {
          return y(An.apply(void 0, jw(f.attributesToClear.map(function(v) {
            var P = v.helper, E = v.items;
            return ag({
              helper: P,
              attributesToClear: E
            });
          }))));
        };
        var b = f.attributesToClear.some(function(v) {
          return v.items.length > 0;
        });
        return {
          canRefine: b,
          hasRefinements: b,
          refine: g,
          createURL: d,
          widgetParams: t
        };
      }
    };
  };
};
function Yw(o) {
  var e = o.scopedResult, r = o.includedAttributes, t = o.excludedAttributes, n = o.transformItems, a = o.results, s = r.indexOf("query") !== -1 || t.indexOf("query") === -1;
  return {
    helper: e.helper,
    items: n(jp(Op(e.results, e.helper.state, s).map(function(i) {
      return i.attribute;
    }).filter(function(i) {
      return (
        // If the array is empty (default case), we keep all the attributes
        r.length === 0 || // Otherwise, only add the specified attributes
        r.indexOf(i) !== -1
      );
    }).filter(function(i) {
      return (
        // If the query is included, we ignore the default `excludedAttributes = ['query']`
        i === "query" && s || // Otherwise, ignore the excluded attributes
        t.indexOf(i) === -1
      );
    })), {
      results: a
    })
  };
}
function Qn(o) {
  "@babel/helpers - typeof";
  return Qn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Qn(o);
}
function qw(o) {
  return Zw(o) || Uw(o) || Xw(o) || Gw();
}
function Gw() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Xw(o, e) {
  if (o) {
    if (typeof o == "string") return Bu(o, e);
    var r = Object.prototype.toString.call(o).slice(8, -1);
    if (r === "Object" && o.constructor && (r = o.constructor.name), r === "Map" || r === "Set") return Array.from(o);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Bu(o, e);
  }
}
function Uw(o) {
  if (typeof Symbol < "u" && o[Symbol.iterator] != null || o["@@iterator"] != null) return Array.from(o);
}
function Zw(o) {
  if (Array.isArray(o)) return Bu(o);
}
function Bu(o, e) {
  (e == null || e > o.length) && (e = o.length);
  for (var r = 0, t = new Array(e); r < e; r++) t[r] = o[r];
  return t;
}
function pm(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function At(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? pm(Object(r), !0).forEach(function(t) {
      Kw(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : pm(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function Kw(o, e, r) {
  return e = Qw(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function Qw(o) {
  var e = Jw(o, "string");
  return Qn(e) == "symbol" ? e : String(e);
}
function Jw(o, e) {
  if (Qn(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (Qn(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
var dm = Te({
  name: "current-refinements",
  connector: !0
}), _w = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Fe;
  return Ie(e, dm()), function(t) {
    if ((t || {}).includedAttributes && (t || {}).excludedAttributes)
      throw new Error(dm("The options `includedAttributes` and `excludedAttributes` cannot be used together."));
    var n = t || {}, a = n.includedAttributes, s = n.excludedAttributes, i = s === void 0 ? ["query"] : s, l = n.transformItems, c = l === void 0 ? function(u) {
      return u;
    } : l;
    return {
      $$type: "ais.currentRefinements",
      init: function(f) {
        var g = f.instantSearchInstance;
        e(At(At({}, this.getWidgetRenderState(f)), {}, {
          instantSearchInstance: g
        }), !0);
      },
      render: function(f) {
        var g = f.instantSearchInstance;
        e(At(At({}, this.getWidgetRenderState(f)), {}, {
          instantSearchInstance: g
        }), !1);
      },
      dispose: function() {
        r();
      },
      getRenderState: function(f, g) {
        return At(At({}, f), {}, {
          currentRefinements: this.getWidgetRenderState(g)
        });
      },
      getWidgetRenderState: function(f) {
        var g = f.results, d = f.scopedResults, p = f.createURL, m = f.helper;
        function y() {
          return g ? d.reduce(function(F, b) {
            return F.concat(c(gm({
              results: b.results,
              helper: b.helper,
              indexId: b.indexId,
              includedAttributes: a,
              excludedAttributes: i
            }), {
              results: g
            }));
          }, []) : c(gm({
            results: null,
            helper: m,
            indexId: m.state.index,
            includedAttributes: a,
            excludedAttributes: i
          }), {
            results: g
          });
        }
        var h = y();
        return {
          items: h,
          canRefine: h.length > 0,
          refine: function(b) {
            return Z1(m, b);
          },
          createURL: function(b) {
            return p(U1(m.state, b));
          },
          widgetParams: t
        };
      }
    };
  };
};
function gm(o) {
  var e = o.results, r = o.helper, t = o.indexId, n = o.includedAttributes, a = o.excludedAttributes, s = (n || []).indexOf("query") !== -1 || (a || []).indexOf("query") === -1, i = n ? function(c) {
    return n.indexOf(c.attribute) !== -1;
  } : function(c) {
    return a.indexOf(c.attribute) === -1;
  }, l = Op(e, r.state, s).map(e4).filter(i);
  return l.reduce(function(c, u) {
    return [].concat(qw(c.filter(function(f) {
      return f.attribute !== u.attribute;
    })), [{
      indexName: r.state.index,
      indexId: t,
      attribute: u.attribute,
      label: u.attribute,
      refinements: l.filter(function(f) {
        return f.attribute === u.attribute;
      }).sort(function(f, g) {
        return f.type === "numeric" ? f.value - g.value : 0;
      }),
      refine: function(g) {
        return Z1(r, g);
      }
    }]);
  }, []);
}
function U1(o, e) {
  switch (o = o.resetPage(), e.type) {
    case "facet":
      return o.removeFacetRefinement(e.attribute, String(e.value));
    case "disjunctive":
      return o.removeDisjunctiveFacetRefinement(e.attribute, String(e.value));
    case "hierarchical":
      return o.removeHierarchicalFacetRefinement(e.attribute);
    case "exclude":
      return o.removeExcludeRefinement(e.attribute, String(e.value));
    case "numeric":
      return o.removeNumericRefinement(e.attribute, e.operator, String(e.value));
    case "tag":
      return o.removeTagRefinement(String(e.value));
    case "query":
      return o.setQueryParameter("query", "");
    default:
      return process.env.NODE_ENV === "development" && de(!1, 'The refinement type "'.concat(e.type, '" does not exist and cannot be cleared from the current refinements.')), o;
  }
}
function Z1(o, e) {
  o.setState(U1(o.state, e)).search();
}
function $w(o) {
  switch (o) {
    case ">=":
      return "≥";
    case "<=":
      return "≤";
    default:
      return o;
  }
}
function e4(o) {
  var e = o4(o), r = o.operator ? "".concat($w(o.operator), " ").concat(o.name) : o.name, t = {
    attribute: o.attribute,
    type: o.type,
    value: e,
    label: r
  };
  return o.operator !== void 0 && (t.operator = o.operator), o.count !== void 0 && (t.count = o.count), o.exhaustive !== void 0 && (t.exhaustive = o.exhaustive), t;
}
function o4(o) {
  return o.type === "numeric" ? Number(o.name) : "escapedValue" in o ? o.escapedValue : o.name;
}
function Jn(o) {
  "@babel/helpers - typeof";
  return Jn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Jn(o);
}
var r4 = ["name", "escapedValue", "data", "path"];
function mm(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function to(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? mm(Object(r), !0).forEach(function(t) {
      Ts(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : mm(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function Ts(o, e, r) {
  return e = t4(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function t4(o) {
  var e = n4(o, "string");
  return Jn(e) == "symbol" ? e : String(e);
}
function n4(o, e) {
  if (Jn(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (Jn(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
function a4(o, e) {
  if (o == null) return {};
  var r = s4(o, e), t, n;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(o);
    for (n = 0; n < a.length; n++)
      t = a[n], !(e.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(o, t) && (r[t] = o[t]);
  }
  return r;
}
function s4(o, e) {
  if (o == null) return {};
  var r = {}, t = Object.keys(o), n, a;
  for (a = 0; a < t.length; a++)
    n = t[a], !(e.indexOf(n) >= 0) && (r[n] = o[n]);
  return r;
}
function i4(o, e) {
  return p4(o) || u4(o, e) || c4(o, e) || l4();
}
function l4() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function c4(o, e) {
  if (o) {
    if (typeof o == "string") return fm(o, e);
    var r = Object.prototype.toString.call(o).slice(8, -1);
    if (r === "Object" && o.constructor && (r = o.constructor.name), r === "Map" || r === "Set") return Array.from(o);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return fm(o, e);
  }
}
function fm(o, e) {
  (e == null || e > o.length) && (e = o.length);
  for (var r = 0, t = new Array(e); r < e; r++) t[r] = o[r];
  return t;
}
function u4(o, e) {
  var r = o == null ? null : typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (r != null) {
    var t, n, a, s, i = [], l = !0, c = !1;
    try {
      if (a = (r = r.call(o)).next, e !== 0) for (; !(l = (t = a.call(r)).done) && (i.push(t.value), i.length !== e); l = !0) ;
    } catch (u) {
      c = !0, n = u;
    } finally {
      try {
        if (!l && r.return != null && (s = r.return(), Object(s) !== s)) return;
      } finally {
        if (c) throw n;
      }
    }
    return i;
  }
}
function p4(o) {
  if (Array.isArray(o)) return o;
}
var Hl = Te({
  name: "hierarchical-menu",
  connector: !0
}), ym = ["name:asc"], d4 = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Fe;
  return Ie(e, Hl()), function(t) {
    var n = t || {}, a = n.attributes, s = n.separator, i = s === void 0 ? " > " : s, l = n.rootPath, c = l === void 0 ? null : l, u = n.showParentLevel, f = u === void 0 ? !0 : u, g = n.limit, d = g === void 0 ? 10 : g, p = n.showMore, m = p === void 0 ? !1 : p, y = n.showMoreLimit, h = y === void 0 ? 20 : y, F = n.sortBy, b = F === void 0 ? ym : F, v = n.transformItems, P = v === void 0 ? function(G) {
      return G;
    } : v;
    if (!a || !Array.isArray(a) || a.length === 0)
      throw new Error(Hl("The `attributes` option expects an array of strings."));
    if (m === !0 && h <= d)
      throw new Error(Hl("The `showMoreLimit` option must be greater than `limit`."));
    var E = i4(a, 1), S = E[0], D, w = function() {
    };
    function A() {
      w();
    }
    var C, x = !1;
    function T(G, L) {
      return function() {
        x = !x, L.render(G);
      };
    }
    function M() {
      return x ? h : d;
    }
    function V(G) {
      return G.slice(0, M()).map(function(L) {
        var W = L.name, Y = L.escapedValue, X = L.data;
        L.path;
        var J = a4(L, r4), ee = to(to({}, J), {}, {
          value: Y,
          label: W,
          data: null
        });
        return Array.isArray(X) && (ee.data = V(X)), ee;
      });
    }
    return {
      $$type: "ais.hierarchicalMenu",
      init: function(L) {
        var W = L.instantSearchInstance;
        e(to(to({}, this.getWidgetRenderState(L)), {}, {
          instantSearchInstance: W
        }), !0);
      },
      render: function(L) {
        var W = L.instantSearchInstance;
        w = T(L, this), e(to(to({}, this.getWidgetRenderState(L)), {}, {
          instantSearchInstance: W
        }), !1);
      },
      dispose: function(L) {
        var W = L.state;
        return r(), W.removeHierarchicalFacet(S).setQueryParameter("maxValuesPerFacet", void 0);
      },
      getRenderState: function(L, W) {
        return to(to({}, L), {}, {
          hierarchicalMenu: to(to({}, L.hierarchicalMenu), {}, Ts({}, S, this.getWidgetRenderState(W)))
        });
      },
      getWidgetRenderState: function(L) {
        var W = this, Y = L.results, X = L.state, J = L.createURL, ee = L.instantSearchInstance, re = L.helper, pe = [], U = !1, Z = function(ke) {
          return J(function(po) {
            return W.getWidgetUiState(po, {
              searchParameters: X.resetPage().toggleFacetRefinement(S, ke),
              helper: re
            });
          });
        };
        if (D || (D = Ep({
          instantSearchInstance: ee,
          helper: re,
          attribute: function(ke) {
            var po = ke.split(i).length - 1;
            return a[po];
          },
          widgetType: this.$$type
        })), C || (C = function(ke) {
          D("click:internal", ke), re.toggleFacetRefinement(S, ke).search();
        }), Y) {
          var Q = Y.getFacetValues(S, {
            sortBy: b,
            facetOrdering: b === ym
          }), oe = Q && !Array.isArray(Q) && Q.data ? Q.data : [], ge = (X.maxValuesPerFacet || 0) > M() ? oe.length <= M() : oe.length < M();
          U = m && (x || !ge), pe = P(V(oe), {
            results: Y
          });
        }
        return {
          items: pe,
          refine: C,
          canRefine: pe.length > 0,
          createURL: Z,
          sendEvent: D,
          widgetParams: t,
          isShowingMore: x,
          toggleShowMore: A,
          canToggleShowMore: U
        };
      },
      getWidgetUiState: function(L, W) {
        var Y = W.searchParameters, X = Y.getHierarchicalFacetBreadcrumb(S);
        return g4(to(to({}, L), {}, {
          hierarchicalMenu: to(to({}, L.hierarchicalMenu), {}, Ts({}, S, X))
        }), S);
      },
      getWidgetSearchParameters: function(L, W) {
        var Y = W.uiState, X = Y.hierarchicalMenu && Y.hierarchicalMenu[S];
        if (L.isConjunctiveFacet(S) || L.isDisjunctiveFacet(S))
          return process.env.NODE_ENV === "development" && de(!1, 'HierarchicalMenu: Attribute "'.concat(S, `" is already used by another widget applying conjunctive or disjunctive faceting.
As this is not supported, please make sure to remove this other widget or this HierarchicalMenu widget will not work at all.`)), L;
        if (L.isHierarchicalFacet(S)) {
          var J = L.getHierarchicalFacetByName(S);
          process.env.NODE_ENV === "development" && de(yt(J.attributes, a) && J.separator === i && J.rootPath === c, "Using Breadcrumb and HierarchicalMenu on the same facet with different options overrides the configuration of the HierarchicalMenu.");
        }
        var ee = L.removeHierarchicalFacet(S).addHierarchicalFacet({
          name: S,
          attributes: a,
          separator: i,
          rootPath: c,
          showParentLevel: f
        }), re = ee.maxValuesPerFacet || 0, pe = Math.max(re, m ? h : d), U = ee.setQueryParameter("maxValuesPerFacet", pe);
        return X ? U.addHierarchicalFacetRefinement(S, X.join(i)) : U.setQueryParameters({
          hierarchicalFacetsRefinements: to(to({}, U.hierarchicalFacetsRefinements), {}, Ts({}, S, []))
        });
      }
    };
  };
};
function g4(o, e) {
  return o.hierarchicalMenu && ((!o.hierarchicalMenu[e] || o.hierarchicalMenu[e].length === 0) && delete o.hierarchicalMenu[e], Object.keys(o.hierarchicalMenu).length === 0 && delete o.hierarchicalMenu), o;
}
function _n(o) {
  "@babel/helpers - typeof";
  return _n = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, _n(o);
}
function hm(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function Pr(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? hm(Object(r), !0).forEach(function(t) {
      K1(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : hm(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function K1(o, e, r) {
  return e = m4(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function m4(o) {
  var e = f4(o, "string");
  return _n(e) == "symbol" ? e : String(e);
}
function f4(o, e) {
  if (_n(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (_n(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
var y4 = Te({
  name: "hits",
  connector: !0
});
const h4 = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Fe;
  return Ie(e, y4()), function(t) {
    var n = t || {}, a = n.escapeHTML, s = a === void 0 ? !0 : a, i = n.transformItems, l = i === void 0 ? function(f) {
      return f;
    } : i, c, u;
    return {
      $$type: "ais.hits",
      init: function(g) {
        e(Pr(Pr({}, this.getWidgetRenderState(g)), {}, {
          instantSearchInstance: g.instantSearchInstance
        }), !0);
      },
      render: function(g) {
        var d = this.getWidgetRenderState(g);
        e(Pr(Pr({}, d), {}, {
          instantSearchInstance: g.instantSearchInstance
        }), !1), d.sendEvent("view:internal", d.items);
      },
      getRenderState: function(g, d) {
        return Pr(Pr({}, g), {}, {
          hits: this.getWidgetRenderState(d)
        });
      },
      getWidgetRenderState: function(g) {
        var d, p, m, y = g.results, h = g.helper, F = g.instantSearchInstance;
        if (c || (c = xp({
          instantSearchInstance: F,
          getIndex: function() {
            return h.getIndex();
          },
          widgetType: this.$$type
        })), u || (u = T1({
          getIndex: function() {
            return h.getIndex();
          },
          widgetType: this.$$type,
          instantSearchInstance: F
        })), !y)
          return {
            hits: [],
            items: [],
            results: void 0,
            banner: void 0,
            sendEvent: c,
            bindEvent: u,
            widgetParams: t
          };
        s && y.hits.length > 0 && (y.hits = Ei(y.hits));
        var b = Tp(y.hits, y.page, y.hitsPerPage), v = Lp(b, y.queryID), P = l(v, {
          results: y
        }), E = (d = y.renderingContent) === null || d === void 0 || (p = d.widgets) === null || p === void 0 || (m = p.banners) === null || m === void 0 ? void 0 : m[0];
        return {
          hits: P,
          items: P,
          results: y,
          banner: E,
          sendEvent: c,
          bindEvent: u,
          widgetParams: t
        };
      },
      dispose: function(g) {
        var d = g.state;
        return r(), s ? d.setQueryParameters(Object.keys(nr).reduce(function(p, m) {
          return Pr(Pr({}, p), {}, K1({}, m, void 0));
        }, {})) : d;
      },
      getWidgetSearchParameters: function(g, d) {
        return s ? g.setQueryParameters(nr) : g;
      }
    };
  };
};
function $n(o) {
  "@babel/helpers - typeof";
  return $n = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, $n(o);
}
function Fm(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function _s(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Fm(Object(r), !0).forEach(function(t) {
      F4(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : Fm(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function F4(o, e, r) {
  return e = b4(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function b4(o) {
  var e = v4(o, "string");
  return $n(e) == "symbol" ? e : String(e);
}
function v4(o, e) {
  if ($n(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if ($n(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
var B4 = function(e, r) {
  return r.map(function(t) {
    var n = fr(e, function(a) {
      return a.objectID === t;
    });
    if (typeof n > "u")
      throw new Error('Could not find objectID "'.concat(t, '" passed to `clickedObjectIDsAfterSearch` in the returned hits. This is necessary to infer the absolute position and the query ID.'));
    return n;
  });
}, P4 = function(e) {
  var r = jp(e.map(function(n) {
    return n.__queryID;
  }));
  if (r.length > 1)
    throw new Error("Insights currently allows a single `queryID`. The `objectIDs` provided map to multiple `queryID`s.");
  var t = r[0];
  if (typeof t != "string")
    throw new Error("Could not infer `queryID`. Ensure InstantSearch `clickAnalytics: true` was added with the Configure widget.\n\nSee: https://alg.li/lNiZZ7");
  return t;
}, w4 = function(e) {
  return e.map(function(r) {
    return r.__position;
  });
}, k4 = function(e) {
  var r = e.method, t = e.results, n = e.hits, a = e.objectIDs, s = t.index, i = B4(n, a), l = P4(i);
  switch (r) {
    case "clickedObjectIDsAfterSearch": {
      var c = w4(i);
      return {
        index: s,
        queryID: l,
        objectIDs: a,
        positions: c
      };
    }
    case "convertedObjectIDsAfterSearch":
      return {
        index: s,
        queryID: l,
        objectIDs: a
      };
    default:
      throw new Error('Unsupported method passed to insights: "'.concat(r, '".'));
  }
}, D4 = function(e, r, t) {
  return function(n) {
    for (var a = arguments.length, s = new Array(a > 1 ? a - 1 : 0), i = 1; i < a; i++)
      s[i - 1] = arguments[i];
    var l = s[0];
    if (process.env.NODE_ENV === "development" && de(!1, "`insights` function has been deprecated. It is still supported in 4.x releases, but not further. It is replaced by the `insights` middleware.\n\nFor more information, visit https://www.algolia.com/doc/guides/getting-insights-and-analytics/search-analytics/click-through-and-conversions/how-to/send-click-and-conversion-events-with-instantsearch/js/"), !e) {
      var c = Te({
        name: "instantsearch"
      });
      throw new Error(c("The `insightsClient` option has not been provided to `instantsearch`."));
    }
    if (!Array.isArray(l.objectIDs))
      throw new TypeError("Expected `objectIDs` to be an array.");
    var u = k4({
      method: n,
      results: r,
      hits: t,
      objectIDs: l.objectIDs
    });
    e(n, _s(_s({}, u), l));
  };
};
function Q1(o) {
  return function(e, r) {
    return o(function(t, n) {
      var a = t.results, s = t.hits, i = t.instantSearchInstance;
      if (a && s && i) {
        var l = D4(i.insightsClient, a, s);
        return e(_s(_s({}, t), {}, {
          insights: l
        }), n);
      }
      return e(t, n);
    }, r);
  };
}
function Pu(o) {
  "@babel/helpers - typeof";
  return Pu = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Pu(o);
}
function S4(o) {
  var e = o.method, r = o.payload;
  if (Pu(r) !== "object")
    throw new Error("The insights helper expects the payload to be an object.");
  var t;
  try {
    t = C1(r);
  } catch {
    throw new Error("Could not JSON serialize the payload object.");
  }
  return 'data-insights-method="'.concat(e, '" data-insights-payload="').concat(t, '"');
}
function J1(o, e) {
  return process.env.NODE_ENV === "development" && de(!1, "`insights` function has been deprecated. It is still supported in 4.x releases, but not further. It is replaced by the `insights` middleware.\n\nFor more information, visit https://www.algolia.com/doc/guides/getting-insights-and-analytics/search-analytics/click-through-and-conversions/how-to/send-click-and-conversion-events-with-instantsearch/js/"), S4({
    method: o,
    payload: e
  });
}
var A4 = Q1(h4);
function ea(o) {
  "@babel/helpers - typeof";
  return ea = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, ea(o);
}
function E4(o) {
  return T4(o) || O4(o) || C4(o) || x4();
}
function x4() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function C4(o, e) {
  if (o) {
    if (typeof o == "string") return wu(o, e);
    var r = Object.prototype.toString.call(o).slice(8, -1);
    if (r === "Object" && o.constructor && (r = o.constructor.name), r === "Map" || r === "Set") return Array.from(o);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return wu(o, e);
  }
}
function O4(o) {
  if (typeof Symbol < "u" && o[Symbol.iterator] != null || o["@@iterator"] != null) return Array.from(o);
}
function T4(o) {
  if (Array.isArray(o)) return wu(o);
}
function wu(o, e) {
  (e == null || e > o.length) && (e = o.length);
  for (var r = 0, t = new Array(e); r < e; r++) t[r] = o[r];
  return t;
}
function bm(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function Zo(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? bm(Object(r), !0).forEach(function(t) {
      L4(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : bm(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function L4(o, e, r) {
  return e = j4(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function j4(o) {
  var e = M4(o, "string");
  return ea(e) == "symbol" ? e : String(e);
}
function M4(o, e) {
  if (ea(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (ea(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
var ms = Te({
  name: "hits-per-page",
  connector: !0
}), W4 = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Fe;
  return Ie(e, ms()), function(t) {
    var n = t || {}, a = n.items, s = n.transformItems, i = s === void 0 ? function(d) {
      return d;
    } : s;
    if (!Array.isArray(a))
      throw new Error(ms("The `items` option expects an array of objects."));
    var l = a, c = l.filter(function(d) {
      return d.default === !0;
    });
    if (c.length === 0)
      throw new Error(ms("A default value must be specified in `items`."));
    if (c.length > 1)
      throw new Error(ms("More than one default value is specified in `items`."));
    var u = c[0], f = function(p) {
      var m = p.hitsPerPage;
      return l.map(function(y) {
        return Zo(Zo({}, y), {}, {
          isRefined: Number(y.value) === Number(m)
        });
      });
    }, g = {
      getRefine: function(p) {
        return function(m) {
          return !m && m !== 0 ? p.setQueryParameter("hitsPerPage", void 0).search() : p.setQueryParameter("hitsPerPage", m).search();
        };
      },
      createURLFactory: function(p) {
        var m = p.state, y = p.createURL, h = p.getWidgetUiState, F = p.helper;
        return function(b) {
          return y(function(v) {
            return h(v, {
              searchParameters: m.resetPage().setQueryParameter("hitsPerPage", !b && b !== 0 ? void 0 : b),
              helper: F
            });
          });
        };
      }
    };
    return {
      $$type: "ais.hitsPerPage",
      init: function(p) {
        var m = p.state, y = p.instantSearchInstance, h = l.some(function(F) {
          return Number(m.hitsPerPage) === Number(F.value);
        });
        h || (process.env.NODE_ENV === "development" && de(m.hitsPerPage !== void 0, "\n`hitsPerPage` is not defined.\nThe option `hitsPerPage` needs to be set using the `configure` widget.\n\nLearn more: https://www.algolia.com/doc/api-reference/widgets/hits-per-page/js/\n            "), process.env.NODE_ENV === "development" && de(!1, '\nThe `items` option of `hitsPerPage` does not contain the "hits per page" value coming from the state: '.concat(m.hitsPerPage, ".\n\nYou may want to add another entry to the `items` option with this value.")), l = [
          // The helper will convert the empty string to `undefined`.
          {
            value: "",
            label: ""
          }
        ].concat(E4(l))), e(Zo(Zo({}, this.getWidgetRenderState(p)), {}, {
          instantSearchInstance: y
        }), !0);
      },
      render: function(p) {
        var m = p.instantSearchInstance;
        e(Zo(Zo({}, this.getWidgetRenderState(p)), {}, {
          instantSearchInstance: m
        }), !1);
      },
      dispose: function(p) {
        var m = p.state;
        return r(), m.setQueryParameter("hitsPerPage", void 0);
      },
      getRenderState: function(p, m) {
        return Zo(Zo({}, p), {}, {
          hitsPerPage: this.getWidgetRenderState(m)
        });
      },
      getWidgetRenderState: function(p) {
        var m = p.state, y = p.results, h = p.createURL, F = p.helper, b = y ? y.nbHits > 0 : !1;
        return {
          items: i(f(m), {
            results: y
          }),
          refine: g.getRefine(F),
          createURL: g.createURLFactory({
            state: m,
            createURL: h,
            getWidgetUiState: this.getWidgetUiState,
            helper: F
          }),
          hasNoResults: !b,
          canRefine: b,
          widgetParams: t
        };
      },
      getWidgetUiState: function(p, m) {
        var y = m.searchParameters, h = y.hitsPerPage;
        return h === void 0 || h === u.value ? p : Zo(Zo({}, p), {}, {
          hitsPerPage: h
        });
      },
      getWidgetSearchParameters: function(p, m) {
        var y = m.uiState;
        return p.setQueryParameters({
          hitsPerPage: y.hitsPerPage || u.value
        });
      }
    };
  };
};
function oa(o) {
  "@babel/helpers - typeof";
  return oa = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, oa(o);
}
var N4 = ["page"], V4 = ["clickAnalytics", "userToken"];
function vm(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function Lo(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? vm(Object(r), !0).forEach(function(t) {
      _1(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : vm(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function _1(o, e, r) {
  return e = z4(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function z4(o) {
  var e = I4(o, "string");
  return oa(e) == "symbol" ? e : String(e);
}
function I4(o, e) {
  if (oa(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (oa(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
function Bm(o) {
  return q4(o) || Y4(o) || H4(o) || R4();
}
function R4() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function H4(o, e) {
  if (o) {
    if (typeof o == "string") return ku(o, e);
    var r = Object.prototype.toString.call(o).slice(8, -1);
    if (r === "Object" && o.constructor && (r = o.constructor.name), r === "Map" || r === "Set") return Array.from(o);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return ku(o, e);
  }
}
function Y4(o) {
  if (typeof Symbol < "u" && o[Symbol.iterator] != null || o["@@iterator"] != null) return Array.from(o);
}
function q4(o) {
  if (Array.isArray(o)) return ku(o);
}
function ku(o, e) {
  (e == null || e > o.length) && (e = o.length);
  for (var r = 0, t = new Array(e); r < e; r++) t[r] = o[r];
  return t;
}
function $1(o, e) {
  if (o == null) return {};
  var r = G4(o, e), t, n;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(o);
    for (n = 0; n < a.length; n++)
      t = a[n], !(e.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(o, t) && (r[t] = o[t]);
  }
  return r;
}
function G4(o, e) {
  if (o == null) return {};
  var r = {}, t = Object.keys(o), n, a;
  for (a = 0; a < t.length; a++)
    n = t[a], !(e.indexOf(n) >= 0) && (r[n] = o[n]);
  return r;
}
var X4 = Te({
  name: "infinite-hits",
  connector: !0
});
function Pm(o) {
  var e = o || {};
  e.page;
  var r = $1(e, N4);
  return r;
}
function fs(o) {
  var e = o || {};
  e.clickAnalytics, e.userToken;
  var r = $1(e, V4);
  return r;
}
function U4() {
  var o = null, e = null;
  return {
    read: function(t) {
      var n = t.state;
      return yt(e, Pm(n)) ? o : null;
    },
    write: function(t) {
      var n = t.state, a = t.hits;
      e = Pm(n), o = a;
    }
  };
}
function Z4(o) {
  return Object.keys(o).map(Number).sort(function(e, r) {
    return e - r;
  }).reduce(function(e, r) {
    return e.concat(o[r]);
  }, []);
}
const K4 = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Fe;
  return Ie(e, X4()), function(t) {
    var n = t || {}, a = n.escapeHTML, s = a === void 0 ? !0 : a, i = n.transformItems, l = i === void 0 ? function(b) {
      return b;
    } : i, c = n.cache, u = c === void 0 ? U4() : c, f, g, d, p, m = function(v, P) {
      var E = v.page, S = E === void 0 ? 0 : E, D = Object.keys(P).map(Number);
      return D.length === 0 ? S : Math.min.apply(Math, [S].concat(Bm(D)));
    }, y = function(v, P) {
      var E = v.page, S = E === void 0 ? 0 : E, D = Object.keys(P).map(Number);
      return D.length === 0 ? S : Math.max.apply(Math, [S].concat(Bm(D)));
    }, h = function(v) {
      return function() {
        v.overrideStateWithoutTriggeringChangeEvent(Lo(Lo({}, v.state), {}, {
          page: m(v.state, u.read({
            state: fs(v.state)
          }) || {}) - 1
        })).searchWithoutTriggeringOnStateChange();
      };
    }, F = function(v) {
      return function() {
        v.setPage(y(v.state, u.read({
          state: fs(v.state)
        }) || {}) + 1).search();
      };
    };
    return {
      $$type: "ais.infiniteHits",
      init: function(v) {
        e(Lo(Lo({}, this.getWidgetRenderState(v)), {}, {
          instantSearchInstance: v.instantSearchInstance
        }), !0);
      },
      render: function(v) {
        var P = v.instantSearchInstance, E = this.getWidgetRenderState(v);
        e(Lo(Lo({}, E), {}, {
          instantSearchInstance: P
        }), !1), d("view:internal", E.currentPageHits);
      },
      getRenderState: function(v, P) {
        return Lo(Lo({}, v), {}, {
          infiniteHits: this.getWidgetRenderState(P)
        });
      },
      getWidgetRenderState: function(v) {
        var P, E, S, D = v.results, w = v.helper, A = v.parent, C = v.state, x = v.instantSearchInstance, T, M = [], V = A.getPreviousState() || C, G = u.read({
          state: fs(V)
        }) || {}, L = D == null || (P = D.renderingContent) === null || P === void 0 || (E = P.widgets) === null || E === void 0 || (S = E.banners) === null || S === void 0 ? void 0 : S[0];
        if (!D)
          f = h(w), g = F(w), d = xp({
            instantSearchInstance: x,
            getIndex: function() {
              return w.getIndex();
            },
            widgetType: this.$$type
          }), p = T1({
            getIndex: function() {
              return w.getIndex();
            },
            widgetType: this.$$type,
            instantSearchInstance: x
          }), T = V.page === void 0 || m(V, G) === 0;
        else {
          var W, Y, X = V.page, J = X === void 0 ? 0 : X;
          s && D.hits.length > 0 && (D.hits = Ei(D.hits));
          var ee = Tp(D.hits, D.page, D.hitsPerPage), re = Lp(ee, D.queryID), pe = l(re, {
            results: D
          }), U = !1;
          j1(x.mainIndex, function(ge) {
            !U && ge.getWidgets().some(function(Ae) {
              var ke = Ae.$$type;
              return ke === "ais.dynamicWidgets";
            }) && (U = !0);
          });
          var Z = !((W = V.disjunctiveFacets) !== null && W !== void 0 && W.length) && !(V.facets || []).filter(function(ge) {
            return ge !== "*";
          }).length && !((Y = V.hierarchicalFacets) !== null && Y !== void 0 && Y.length);
          G[J] === void 0 && !D.__isArtificial && x.status === "idle" && !(U && Z) && (G[J] = pe, u.write({
            state: fs(V),
            hits: G
          })), M = pe, T = m(V, G) === 0;
        }
        var Q = Z4(G), oe = D ? D.nbPages <= y(V, G) + 1 : !0;
        return {
          hits: Q,
          items: Q,
          currentPageHits: M,
          sendEvent: d,
          bindEvent: p,
          banner: L,
          results: D || void 0,
          showPrevious: f,
          showMore: g,
          isFirstPage: T,
          isLastPage: oe,
          widgetParams: t
        };
      },
      dispose: function(v) {
        var P = v.state;
        r();
        var E = P.setQueryParameter("page", void 0);
        return s ? E.setQueryParameters(Object.keys(nr).reduce(function(S, D) {
          return Lo(Lo({}, S), {}, _1({}, D, void 0));
        }, {})) : E;
      },
      getWidgetUiState: function(v, P) {
        var E = P.searchParameters, S = E.page || 0;
        return S ? Lo(Lo({}, v), {}, {
          // The page in the UI state is incremented by one
          // to expose the user value (not `0`).
          page: S + 1
        }) : v;
      },
      getWidgetSearchParameters: function(v, P) {
        var E = P.uiState, S = v;
        s && (S = v.setQueryParameters(nr));
        var D = E.page ? E.page - 1 : 0;
        return S.setQueryParameter("page", D);
      }
    };
  };
};
var Q4 = Q1(K4), J4 = ["name", "escapedValue", "path"];
function ra(o) {
  "@babel/helpers - typeof";
  return ra = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, ra(o);
}
function _4(o, e) {
  if (o == null) return {};
  var r = $4(o, e), t, n;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(o);
    for (n = 0; n < a.length; n++)
      t = a[n], !(e.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(o, t) && (r[t] = o[t]);
  }
  return r;
}
function $4(o, e) {
  if (o == null) return {};
  var r = {}, t = Object.keys(o), n, a;
  for (a = 0; a < t.length; a++)
    n = t[a], !(e.indexOf(n) >= 0) && (r[n] = o[n]);
  return r;
}
function wm(o, e) {
  return t6(o) || r6(o, e) || o6(o, e) || e6();
}
function e6() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function o6(o, e) {
  if (o) {
    if (typeof o == "string") return km(o, e);
    var r = Object.prototype.toString.call(o).slice(8, -1);
    if (r === "Object" && o.constructor && (r = o.constructor.name), r === "Map" || r === "Set") return Array.from(o);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return km(o, e);
  }
}
function km(o, e) {
  (e == null || e > o.length) && (e = o.length);
  for (var r = 0, t = new Array(e); r < e; r++) t[r] = o[r];
  return t;
}
function r6(o, e) {
  var r = o == null ? null : typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (r != null) {
    var t, n, a, s, i = [], l = !0, c = !1;
    try {
      if (a = (r = r.call(o)).next, e !== 0) for (; !(l = (t = a.call(r)).done) && (i.push(t.value), i.length !== e); l = !0) ;
    } catch (u) {
      c = !0, n = u;
    } finally {
      try {
        if (!l && r.return != null && (s = r.return(), Object(s) !== s)) return;
      } finally {
        if (c) throw n;
      }
    }
    return i;
  }
}
function t6(o) {
  if (Array.isArray(o)) return o;
}
function Dm(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function no(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Dm(Object(r), !0).forEach(function(t) {
      Ls(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : Dm(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function Ls(o, e, r) {
  return e = n6(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function n6(o) {
  var e = a6(o, "string");
  return ra(e) == "symbol" ? e : String(e);
}
function a6(o, e) {
  if (ra(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (ra(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
var Yl = Te({
  name: "menu",
  connector: !0
}), Sm = ["isRefined", "name:asc"], eF = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Fe;
  return Ie(e, Yl()), function(t) {
    var n = t || {}, a = n.attribute, s = n.limit, i = s === void 0 ? 10 : s, l = n.showMore, c = l === void 0 ? !1 : l, u = n.showMoreLimit, f = u === void 0 ? 20 : u, g = n.sortBy, d = g === void 0 ? Sm : g, p = n.transformItems, m = p === void 0 ? function(D) {
      return D;
    } : p;
    if (!a)
      throw new Error(Yl("The `attribute` option is required."));
    if (c === !0 && f <= i)
      throw new Error(Yl("The `showMoreLimit` option must be greater than `limit`."));
    var y, h, F, b = !1, v = function() {
    };
    function P(D, w) {
      return function() {
        b = !b, w.render(D);
      };
    }
    function E() {
      v();
    }
    function S() {
      return b ? f : i;
    }
    return {
      $$type: "ais.menu",
      init: function(w) {
        var A = w.instantSearchInstance;
        e(no(no({}, this.getWidgetRenderState(w)), {}, {
          instantSearchInstance: A
        }), !0);
      },
      render: function(w) {
        var A = w.instantSearchInstance;
        e(no(no({}, this.getWidgetRenderState(w)), {}, {
          instantSearchInstance: A
        }), !1);
      },
      dispose: function(w) {
        var A = w.state;
        return r(), A.removeHierarchicalFacet(a).setQueryParameter("maxValuesPerFacet", void 0);
      },
      getRenderState: function(w, A) {
        return no(no({}, w), {}, {
          menu: no(no({}, w.menu), {}, Ls({}, a, this.getWidgetRenderState(A)))
        });
      },
      getWidgetRenderState: function(w) {
        var A = this, C = w.results, x = w.createURL, T = w.instantSearchInstance, M = w.helper, V = [], G = !1;
        if (y || (y = Ep({
          instantSearchInstance: T,
          helper: M,
          attribute: a,
          widgetType: this.$$type
        })), h || (h = function(X) {
          return x(function(J) {
            return A.getWidgetUiState(J, {
              searchParameters: M.state.resetPage().toggleFacetRefinement(a, X),
              helper: M
            });
          });
        }), F || (F = function(X) {
          var J = M.getHierarchicalFacetBreadcrumb(a), ee = wm(J, 1), re = ee[0];
          y("click:internal", X || re), M.toggleFacetRefinement(a, X || re).search();
        }), w.results && (v = P(w, this)), C) {
          var L = C.getFacetValues(a, {
            sortBy: d,
            facetOrdering: d === Sm
          }), W = L && !Array.isArray(L) && L.data ? L.data : [];
          G = c && (b || W.length > S()), V = m(W.slice(0, S()).map(function(Y) {
            var X = Y.name, J = Y.escapedValue;
            Y.path;
            var ee = _4(Y, J4);
            return no(no({}, ee), {}, {
              label: X,
              value: J
            });
          }), {
            results: C
          });
        }
        return {
          items: V,
          createURL: h,
          refine: F,
          sendEvent: y,
          canRefine: V.length > 0,
          widgetParams: t,
          isShowingMore: b,
          toggleShowMore: E,
          canToggleShowMore: G
        };
      },
      getWidgetUiState: function(w, A) {
        var C = A.searchParameters, x = C.getHierarchicalFacetBreadcrumb(a), T = wm(x, 1), M = T[0];
        return s6(no(no({}, w), {}, {
          menu: no(no({}, w.menu), {}, Ls({}, a, M))
        }), a);
      },
      getWidgetSearchParameters: function(w, A) {
        var C = A.uiState, x = C.menu && C.menu[a];
        if (w.isConjunctiveFacet(a) || w.isDisjunctiveFacet(a))
          return process.env.NODE_ENV === "development" && de(!1, 'Menu: Attribute "'.concat(a, `" is already used by another widget applying conjunctive or disjunctive faceting.
As this is not supported, please make sure to remove this other widget or this Menu widget will not work at all.`)), w;
        var T = w.removeHierarchicalFacet(a).addHierarchicalFacet({
          name: a,
          attributes: [a]
        }), M = T.maxValuesPerFacet || 0, V = Math.max(M, c ? f : i), G = T.setQueryParameter("maxValuesPerFacet", V);
        return x ? G.addHierarchicalFacetRefinement(a, x) : G.setQueryParameters({
          hierarchicalFacetsRefinements: no(no({}, G.hierarchicalFacetsRefinements), {}, Ls({}, a, []))
        });
      }
    };
  };
};
function s6(o, e) {
  return o.menu && (o.menu[e] === void 0 && delete o.menu[e], Object.keys(o.menu).length === 0 && delete o.menu), o;
}
function ta(o) {
  "@babel/helpers - typeof";
  return ta = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, ta(o);
}
function i6(o, e) {
  var r = typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (!r) {
    if (Array.isArray(o) || (r = oF(o)) || e) {
      r && (o = r);
      var t = 0, n = function() {
      };
      return { s: n, n: function() {
        return t >= o.length ? { done: !0 } : { done: !1, value: o[t++] };
      }, e: function(c) {
        throw c;
      }, f: n };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var a = !0, s = !1, i;
  return { s: function() {
    r = r.call(o);
  }, n: function() {
    var c = r.next();
    return a = c.done, c;
  }, e: function(c) {
    s = !0, i = c;
  }, f: function() {
    try {
      !a && r.return != null && r.return();
    } finally {
      if (s) throw i;
    }
  } };
}
function l6(o, e) {
  return p6(o) || u6(o, e) || oF(o, e) || c6();
}
function c6() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function oF(o, e) {
  if (o) {
    if (typeof o == "string") return Am(o, e);
    var r = Object.prototype.toString.call(o).slice(8, -1);
    if (r === "Object" && o.constructor && (r = o.constructor.name), r === "Map" || r === "Set") return Array.from(o);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Am(o, e);
  }
}
function Am(o, e) {
  (e == null || e > o.length) && (e = o.length);
  for (var r = 0, t = new Array(e); r < e; r++) t[r] = o[r];
  return t;
}
function u6(o, e) {
  var r = o == null ? null : typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (r != null) {
    var t, n, a, s, i = [], l = !0, c = !1;
    try {
      if (a = (r = r.call(o)).next, e !== 0) for (; !(l = (t = a.call(r)).done) && (i.push(t.value), i.length !== e); l = !0) ;
    } catch (u) {
      c = !0, n = u;
    } finally {
      try {
        if (!l && r.return != null && (s = r.return(), Object(s) !== s)) return;
      } finally {
        if (c) throw n;
      }
    }
    return i;
  }
}
function p6(o) {
  if (Array.isArray(o)) return o;
}
function Em(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function Ge(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Em(Object(r), !0).forEach(function(t) {
      Fn(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : Em(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function Fn(o, e, r) {
  return e = d6(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function d6(o) {
  var e = g6(o, "string");
  return ta(e) == "symbol" ? e : String(e);
}
function g6(o, e) {
  if (ta(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (ta(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
var ql = Te({
  name: "numeric-menu",
  connector: !0
}), m6 = "ais.numericMenu", f6 = function(e) {
  var r = e.instantSearchInstance;
  return function() {
    if (arguments.length === 1) {
      r.sendEventToInsights(arguments.length <= 0 ? void 0 : arguments[0]);
      return;
    }
  };
}, y6 = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Fe;
  return Ie(e, ql()), function(t) {
    var n = t || {}, a = n.attribute, s = a === void 0 ? "" : a, i = n.items, l = i === void 0 ? [] : i, c = n.transformItems, u = c === void 0 ? function(d) {
      return d;
    } : c;
    if (s === "")
      throw new Error(ql("The `attribute` option is required."));
    if (!l || l.length === 0)
      throw new Error(ql("The `items` option expects an array of objects."));
    var f = function(p) {
      return l.map(function(m) {
        var y = m.start, h = m.end, F = m.label;
        return {
          label: F,
          value: encodeURI(JSON.stringify({
            start: y,
            end: h
          })),
          isRefined: rF(p, s, {
            start: y,
            end: h
          })
        };
      });
    }, g = {};
    return {
      $$type: m6,
      init: function(p) {
        var m = p.instantSearchInstance;
        e(Ge(Ge({}, this.getWidgetRenderState(p)), {}, {
          instantSearchInstance: m
        }), !0);
      },
      render: function(p) {
        var m = p.instantSearchInstance;
        e(Ge(Ge({}, this.getWidgetRenderState(p)), {}, {
          instantSearchInstance: m
        }), !1);
      },
      dispose: function(p) {
        var m = p.state;
        return r(), m.removeNumericRefinement(s);
      },
      getWidgetUiState: function(p, m) {
        var y = m.searchParameters, h = y.getNumericRefinements(s), F = h["="] && h["="][0];
        if (F || F === 0)
          return Ge(Ge({}, p), {}, {
            numericMenu: Ge(Ge({}, p.numericMenu), {}, Fn({}, s, "".concat(h["="])))
          });
        var b = h[">="] && h[">="][0] || "", v = h["<="] && h["<="][0] || "";
        return h6(Ge(Ge({}, p), {}, {
          numericMenu: Ge(Ge({}, p.numericMenu), {}, Fn({}, s, "".concat(b, ":").concat(v)))
        }), s);
      },
      getWidgetSearchParameters: function(p, m) {
        var y = m.uiState, h = y.numericMenu && y.numericMenu[s], F = p.setQueryParameters({
          numericRefinements: Ge(Ge({}, p.numericRefinements), {}, Fn({}, s, {}))
        });
        if (!h)
          return F;
        var b = h.indexOf(":") === -1;
        if (b)
          return F.addNumericRefinement(s, "=", Number(h));
        var v = h.split(":").map(parseFloat), P = l6(v, 2), E = P[0], S = P[1], D = Ee(E) ? F.addNumericRefinement(s, ">=", E) : F, w = Ee(S) ? D.addNumericRefinement(s, "<=", S) : D;
        return w;
      },
      getRenderState: function(p, m) {
        return Ge(Ge({}, p), {}, {
          numericMenu: Ge(Ge({}, p.numericMenu), {}, Fn({}, s, this.getWidgetRenderState(m)))
        });
      },
      getWidgetRenderState: function(p) {
        var m = this, y = p.results, h = p.state, F = p.instantSearchInstance, b = p.helper, v = p.createURL;
        g.refine || (g.refine = function(C) {
          var x = xm(b.state, s, C);
          g.sendEvent("click:internal", C), b.setState(x).search();
        }), g.createURL || (g.createURL = function(C) {
          return function(x) {
            return v(function(T) {
              return m.getWidgetUiState(T, {
                searchParameters: xm(C, s, x),
                helper: b
              });
            });
          };
        }), g.sendEvent || (g.sendEvent = f6({
          instantSearchInstance: F
        }));
        var P = y ? y.nbHits === 0 : !0, E = f(h), S = !0, D = i6(E), w;
        try {
          for (D.s(); !(w = D.n()).done; ) {
            var A = w.value;
            if (A.isRefined && decodeURI(A.value) !== "{}") {
              S = !1;
              break;
            }
          }
        } catch (C) {
          D.e(C);
        } finally {
          D.f();
        }
        return {
          createURL: g.createURL(h),
          items: u(E, {
            results: y
          }),
          hasNoResults: P,
          canRefine: !(P && S),
          refine: g.refine,
          sendEvent: g.sendEvent,
          widgetParams: t
        };
      }
    };
  };
};
function rF(o, e, r) {
  var t = o.getNumericRefinements(e);
  return r.start !== void 0 && r.end !== void 0 ? r.start === r.end ? Or(t, "=", r.start) : Or(t, ">=", r.start) && Or(t, "<=", r.end) : r.start !== void 0 ? Or(t, ">=", r.start) : r.end !== void 0 ? Or(t, "<=", r.end) : r.start === void 0 && r.end === void 0 ? Object.keys(t).every(function(n) {
    return (t[n] || []).length === 0;
  }) : !1;
}
function xm(o, e, r) {
  var t = o, n = JSON.parse(decodeURI(r)), a = t.getNumericRefinements(e);
  if (n.start === void 0 && n.end === void 0)
    return t.removeNumericRefinement(e);
  if (rF(t, e, n) || (t = t.removeNumericRefinement(e)), n.start !== void 0 && n.end !== void 0) {
    if (n.start > n.end)
      throw new Error("option.start should be > to option.end");
    if (n.start === n.end)
      return Or(a, "=", n.start) ? t = t.removeNumericRefinement(e, "=", n.start) : t = t.addNumericRefinement(e, "=", n.start), t;
  }
  return n.start !== void 0 && (Or(a, ">=", n.start) && (t = t.removeNumericRefinement(e, ">=", n.start)), t = t.addNumericRefinement(e, ">=", n.start)), n.end !== void 0 && (Or(a, "<=", n.end) && (t = t.removeNumericRefinement(e, "<=", n.end)), t = t.addNumericRefinement(e, "<=", n.end)), typeof t.page == "number" && (t.page = 0), t;
}
function Or(o, e, r) {
  return o[e] !== void 0 && o[e].includes(r);
}
function h6(o, e) {
  return o.numericMenu && (o.numericMenu[e] === ":" && delete o.numericMenu[e], Object.keys(o.numericMenu).length === 0 && delete o.numericMenu), o;
}
function na(o) {
  "@babel/helpers - typeof";
  return na = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, na(o);
}
function F6(o, e) {
  if (!(o instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function b6(o, e) {
  for (var r = 0; r < e.length; r++) {
    var t = e[r];
    t.enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(o, tF(t.key), t);
  }
}
function v6(o, e, r) {
  return e && b6(o.prototype, e), Object.defineProperty(o, "prototype", { writable: !1 }), o;
}
function Gl(o, e, r) {
  return e = tF(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function tF(o) {
  var e = B6(o, "string");
  return na(e) == "symbol" ? e : String(e);
}
function B6(o, e) {
  if (na(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (na(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
var P6 = /* @__PURE__ */ function() {
  function o(e) {
    F6(this, o), Gl(this, "currentPage", void 0), Gl(this, "total", void 0), Gl(this, "padding", void 0), this.currentPage = e.currentPage, this.total = e.total, this.padding = e.padding;
  }
  return v6(o, [{
    key: "pages",
    value: function() {
      var r = this.total, t = this.currentPage, n = this.padding;
      if (r === 0) return [0];
      var a = this.nbPagesDisplayed(n, r);
      if (a === r)
        return Pg({
          end: r
        });
      var s = this.calculatePaddingLeft(t, n, r, a), i = a - s, l = t - s, c = t + i;
      return Pg({
        start: l,
        end: c
      });
    }
  }, {
    key: "nbPagesDisplayed",
    value: function(r, t) {
      return Math.min(2 * r + 1, t);
    }
  }, {
    key: "calculatePaddingLeft",
    value: function(r, t, n, a) {
      return r <= t ? r : r >= n - t ? a - (n - r) : t;
    }
  }, {
    key: "isLastPage",
    value: function() {
      return this.currentPage >= this.total - 1;
    }
  }, {
    key: "isFirstPage",
    value: function() {
      return this.currentPage <= 0;
    }
  }]), o;
}();
function aa(o) {
  "@babel/helpers - typeof";
  return aa = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, aa(o);
}
function Cm(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function Ko(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Cm(Object(r), !0).forEach(function(t) {
      w6(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : Cm(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function w6(o, e, r) {
  return e = k6(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function k6(o) {
  var e = D6(o, "string");
  return aa(e) == "symbol" ? e : String(e);
}
function D6(o, e) {
  if (aa(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (aa(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
var S6 = Te({
  name: "pagination",
  connector: !0
}), A6 = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Fe;
  return Ie(e, S6()), function(t) {
    var n = t || {}, a = n.totalPages, s = n.padding, i = s === void 0 ? 3 : s, l = new P6({
      currentPage: 0,
      total: 0,
      padding: i
    }), c = {};
    function u(f) {
      var g = f.nbPages;
      return a !== void 0 ? Math.min(a, g) : g;
    }
    return {
      $$type: "ais.pagination",
      init: function(g) {
        var d = g.instantSearchInstance;
        e(Ko(Ko({}, this.getWidgetRenderState(g)), {}, {
          instantSearchInstance: d
        }), !0);
      },
      render: function(g) {
        var d = g.instantSearchInstance;
        e(Ko(Ko({}, this.getWidgetRenderState(g)), {}, {
          instantSearchInstance: d
        }), !1);
      },
      dispose: function(g) {
        var d = g.state;
        return r(), d.setQueryParameter("page", void 0);
      },
      getWidgetUiState: function(g, d) {
        var p = d.searchParameters, m = p.page || 0;
        return m ? Ko(Ko({}, g), {}, {
          page: m + 1
        }) : g;
      },
      getWidgetSearchParameters: function(g, d) {
        var p = d.uiState, m = p.page ? p.page - 1 : 0;
        return g.setQueryParameter("page", m);
      },
      getWidgetRenderState: function(g) {
        var d = g.results, p = g.helper, m = g.state, y = g.createURL;
        c.refine || (c.refine = function(b) {
          p.setPage(b), p.search();
        }), c.createURL || (c.createURL = function(b) {
          return y(function(v) {
            return Ko(Ko({}, v), {}, {
              page: b + 1
            });
          });
        });
        var h = m.page || 0, F = u(d || {
          nbPages: 0
        });
        return l.currentPage = h, l.total = F, {
          createURL: c.createURL,
          refine: c.refine,
          canRefine: F > 1,
          currentRefinement: h,
          nbHits: (d == null ? void 0 : d.nbHits) || 0,
          nbPages: F,
          pages: d ? l.pages() : [],
          isFirstPage: l.isFirstPage(),
          isLastPage: l.isLastPage(),
          widgetParams: t
        };
      },
      getRenderState: function(g, d) {
        return Ko(Ko({}, g), {}, {
          pagination: this.getWidgetRenderState(d)
        });
      }
    };
  };
};
function sa(o) {
  "@babel/helpers - typeof";
  return sa = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, sa(o);
}
function Om(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function ao(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Om(Object(r), !0).forEach(function(t) {
      js(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : Om(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function js(o, e, r) {
  return e = E6(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function E6(o) {
  var e = x6(o, "string");
  return sa(e) == "symbol" ? e : String(e);
}
function x6(o, e) {
  if (sa(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (sa(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
function Et(o, e) {
  return L6(o) || T6(o, e) || O6(o, e) || C6();
}
function C6() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function O6(o, e) {
  if (o) {
    if (typeof o == "string") return Tm(o, e);
    var r = Object.prototype.toString.call(o).slice(8, -1);
    if (r === "Object" && o.constructor && (r = o.constructor.name), r === "Map" || r === "Set") return Array.from(o);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Tm(o, e);
  }
}
function Tm(o, e) {
  (e == null || e > o.length) && (e = o.length);
  for (var r = 0, t = new Array(e); r < e; r++) t[r] = o[r];
  return t;
}
function T6(o, e) {
  var r = o == null ? null : typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (r != null) {
    var t, n, a, s, i = [], l = !0, c = !1;
    try {
      if (a = (r = r.call(o)).next, e === 0) {
        if (Object(r) !== r) return;
        l = !1;
      } else for (; !(l = (t = a.call(r)).done) && (i.push(t.value), i.length !== e); l = !0) ;
    } catch (u) {
      c = !0, n = u;
    } finally {
      try {
        if (!l && r.return != null && (s = r.return(), Object(s) !== s)) return;
      } finally {
        if (c) throw n;
      }
    }
    return i;
  }
}
function L6(o) {
  if (Array.isArray(o)) return o;
}
var Xl = Te({
  name: "range-input",
  connector: !0
}, {
  name: "range-slider",
  connector: !0
}), j6 = "ais.range";
function Lm(o) {
  var e = o.min, r = o.max, t = o.precision, n = Math.pow(10, t);
  return {
    min: e && Math.floor(e * n) / n,
    max: r && Math.ceil(r * n) / n
  };
}
var M6 = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Fe;
  return Ie(e, Xl()), function(t) {
    var n = t || {}, a = n.attribute, s = a === void 0 ? "" : a, i = n.min, l = n.max, c = n.precision, u = c === void 0 ? 0 : c;
    if (!s)
      throw new Error(Xl("The `attribute` option is required."));
    if (Ee(i) && Ee(l) && i > l)
      throw new Error(Xl("The `max` option can't be lower than `min`."));
    var f = function(b) {
      return Number(Number(b).toFixed(u));
    }, g = {
      from: function(b) {
        return b.toLocaleString();
      },
      to: function(b) {
        return f(b).toLocaleString();
      }
    }, d = function(b, v, P, E) {
      var S = b.state, D = v.min, w = v.max, A = S.getNumericRefinement(s, ">=") || [], C = Et(A, 1), x = C[0], T = S.getNumericRefinement(s, "<=") || [], M = Et(T, 1), V = M[0], G = P === void 0 || P === "", L = E === void 0 || E === "", W = Lm({
        min: G ? void 0 : parseFloat(P),
        max: L ? void 0 : parseFloat(E),
        precision: u
      }), Y = W.min, X = W.max, J;
      !Ee(i) && D === Y ? J = void 0 : Ee(i) && G ? J = i : J = Y;
      var ee;
      !Ee(l) && w === X ? ee = void 0 : Ee(l) && L ? ee = l : ee = X;
      var re = J === void 0, pe = Ee(D) && D <= J, U = re || Ee(J) && (!Ee(D) || pe), Z = ee === void 0, Q = Ee(ee) && w >= ee, oe = Z || Ee(ee) && (!Ee(w) || Q), ge = x !== J, Ae = V !== ee;
      return (ge || Ae) && U && oe ? (S = S.removeNumericRefinement(s), Ee(J) && (S = S.addNumericRefinement(s, ">=", J)), Ee(ee) && (S = S.addNumericRefinement(s, "<=", ee)), S.resetPage()) : null;
    }, p = function(b) {
      return function() {
        if (arguments.length === 1) {
          b.sendEventToInsights(arguments.length <= 0 ? void 0 : arguments[0]);
          return;
        }
      };
    };
    function m(F) {
      var b;
      Ee(i) ? b = i : Ee(F.min) ? b = F.min : b = 0;
      var v;
      return Ee(l) ? v = l : Ee(F.max) ? v = F.max : v = 0, Lm({
        min: b,
        max: v,
        precision: u
      });
    }
    function y(F) {
      var b = F.getNumericRefinement(s, ">=") || [], v = Et(b, 1), P = v[0], E = F.getNumericRefinement(s, "<=") || [], S = Et(E, 1), D = S[0], w = Ee(P) ? P : -1 / 0, A = Ee(D) ? D : 1 / 0;
      return [w, A];
    }
    function h(F, b) {
      return function() {
        var v = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [void 0, void 0], P = Et(v, 2), E = P[0], S = P[1], D = d(F, b, E, S);
        D && F.setState(D).search();
      };
    }
    return {
      $$type: j6,
      init: function(b) {
        e(ao(ao({}, this.getWidgetRenderState(b)), {}, {
          instantSearchInstance: b.instantSearchInstance
        }), !0);
      },
      render: function(b) {
        e(ao(ao({}, this.getWidgetRenderState(b)), {}, {
          instantSearchInstance: b.instantSearchInstance
        }), !1);
      },
      getRenderState: function(b, v) {
        return ao(ao({}, b), {}, {
          range: ao(ao({}, b.range), {}, js({}, s, this.getWidgetRenderState(v)))
        });
      },
      getWidgetRenderState: function(b) {
        var v = b.results, P = b.helper, E = b.instantSearchInstance, S = v && v.disjunctiveFacets || [], D = fr(S, function(T) {
          return T.name === s;
        }), w = D && D.stats || {
          min: void 0,
          max: void 0
        }, A = m(w), C = y(P), x;
        return v ? x = h(P, A) : x = h(P, {
          min: void 0,
          max: void 0
        }), {
          refine: x,
          canRefine: A.min !== A.max,
          format: g,
          range: A,
          sendEvent: p(E),
          widgetParams: ao(ao({}, t), {}, {
            precision: u
          }),
          start: C
        };
      },
      dispose: function(b) {
        var v = b.state;
        return r(), v.removeDisjunctiveFacet(s).removeNumericRefinement(s);
      },
      getWidgetUiState: function(b, v) {
        var P = v.searchParameters, E = P.getNumericRefinements(s), S = E[">="], D = S === void 0 ? [] : S, w = E["<="], A = w === void 0 ? [] : w;
        return D.length === 0 && A.length === 0 ? b : ao(ao({}, b), {}, {
          range: ao(ao({}, b.range), {}, js({}, s, "".concat(D, ":").concat(A)))
        });
      },
      getWidgetSearchParameters: function(b, v) {
        var P = v.uiState, E = b.addDisjunctiveFacet(s).setQueryParameters({
          numericRefinements: ao(ao({}, b.numericRefinements), {}, js({}, s, {}))
        });
        Ee(i) && (E = E.addNumericRefinement(s, ">=", i)), Ee(l) && (E = E.addNumericRefinement(s, "<=", l));
        var S = P.range && P.range[s];
        if (!S || S.indexOf(":") === -1)
          return E;
        var D = S.split(":").map(parseFloat), w = Et(D, 2), A = w[0], C = w[1];
        return Ee(A) && (!Ee(i) || i < A) && (E = E.removeNumericRefinement(s, ">="), E = E.addNumericRefinement(s, ">=", A)), Ee(C) && (!Ee(l) || C < l) && (E = E.removeNumericRefinement(s, "<="), E = E.addNumericRefinement(s, "<=", C)), E;
      }
    };
  };
};
function ia(o) {
  "@babel/helpers - typeof";
  return ia = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, ia(o);
}
var W6 = ["name", "escapedValue"], N6 = ["escapedValue", "value"];
function jm(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function Le(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? jm(Object(r), !0).forEach(function(t) {
      bn(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : jm(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function bn(o, e, r) {
  return e = V6(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function V6(o) {
  var e = z6(o, "string");
  return ia(e) == "symbol" ? e : String(e);
}
function z6(o, e) {
  if (ia(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (ia(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
function Mm(o, e) {
  if (o == null) return {};
  var r = I6(o, e), t, n;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(o);
    for (n = 0; n < a.length; n++)
      t = a[n], !(e.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(o, t) && (r[t] = o[t]);
  }
  return r;
}
function I6(o, e) {
  if (o == null) return {};
  var r = {}, t = Object.keys(o), n, a;
  for (a = 0; a < t.length; a++)
    n = t[a], !(e.indexOf(n) >= 0) && (r[n] = o[n]);
  return r;
}
var ys = Te({
  name: "refinement-list",
  connector: !0
}), Wm = ["isRefined", "count:desc", "name:asc"], R6 = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Fe;
  return Ie(e, ys()), function(t) {
    var n = t || {}, a = n.attribute, s = n.operator, i = s === void 0 ? "or" : s, l = n.limit, c = l === void 0 ? 10 : l, u = n.showMore, f = u === void 0 ? !1 : u, g = n.showMoreLimit, d = g === void 0 ? 20 : g, p = n.sortBy, m = p === void 0 ? Wm : p, y = n.escapeFacetValues, h = y === void 0 ? !0 : y, F = n.transformItems, b = F === void 0 ? function(L) {
      return L;
    } : F;
    if (!a)
      throw new Error(ys("The `attribute` option is required."));
    if (!/^(and|or)$/.test(i))
      throw new Error(ys('The `operator` must one of: `"and"`, `"or"` (got "'.concat(i, '").')));
    if (f === !0 && d <= c)
      throw new Error(ys("`showMoreLimit` should be greater than `limit`."));
    var v = function(W) {
      var Y = W.name, X = W.escapedValue, J = Mm(W, W6);
      return Le(Le({}, J), {}, {
        value: X,
        label: Y,
        highlighted: Y
      });
    }, P, E = [], S = !0, D, w, A = !1, C = function() {
    };
    function x() {
      C();
    }
    function T(L, W) {
      return function() {
        A = !A, W.render(L);
      };
    }
    function M() {
      return A ? d : c;
    }
    var V = function() {
      return function() {
      };
    }, G = function(W, Y) {
      return function(X) {
        return function(J) {
          var ee = X.instantSearchInstance, re = X.results;
          if (J === "" && E)
            e(Le(Le({}, Y.getWidgetRenderState(Le(Le({}, X), {}, {
              results: P
            }))), {}, {
              instantSearchInstance: ee
            }), !1);
          else {
            var pe = {
              highlightPreTag: h ? nr.highlightPreTag : io.highlightPreTag,
              highlightPostTag: h ? nr.highlightPostTag : io.highlightPostTag
            };
            W.searchForFacetValues(
              a,
              J,
              // We cap the `maxFacetHits` value to 100 because the Algolia API
              // doesn't support a greater number.
              // See https://www.algolia.com/doc/api-reference/api-parameters/maxFacetHits/
              Math.min(M(), 100),
              pe
            ).then(function(U) {
              var Z = h ? MB(U.facetHits) : U.facetHits, Q = b(Z.map(function(oe) {
                var ge = oe.escapedValue, Ae = oe.value, ke = Mm(oe, N6);
                return Le(Le({}, ke), {}, {
                  value: ge,
                  label: Ae
                });
              }), {
                results: re
              });
              e(Le(Le({}, Y.getWidgetRenderState(Le(Le({}, X), {}, {
                results: P
              }))), {}, {
                items: Q,
                canToggleShowMore: !1,
                canRefine: !0,
                isFromSearch: !0,
                instantSearchInstance: ee
              }), !1);
            });
          }
        };
      };
    };
    return {
      $$type: "ais.refinementList",
      init: function(W) {
        e(Le(Le({}, this.getWidgetRenderState(W)), {}, {
          instantSearchInstance: W.instantSearchInstance
        }), !0);
      },
      render: function(W) {
        e(Le(Le({}, this.getWidgetRenderState(W)), {}, {
          instantSearchInstance: W.instantSearchInstance
        }), !1);
      },
      getRenderState: function(W, Y) {
        return Le(Le({}, W), {}, {
          refinementList: Le(Le({}, W.refinementList), {}, bn({}, a, this.getWidgetRenderState(Y)))
        });
      },
      getWidgetRenderState: function(W) {
        var Y = this, X = W.results, J = W.state, ee = W.createURL, re = W.instantSearchInstance, pe = W.helper, U = [], Z = [];
        if ((!w || !D || !V) && (w = Ep({
          instantSearchInstance: re,
          helper: pe,
          attribute: a,
          widgetType: this.$$type
        }), D = function(ro) {
          w("click:internal", ro), pe.toggleFacetRefinement(a, ro).search();
        }, V = G(pe, this)), X) {
          var Q = X.getFacetValues(a, {
            sortBy: m,
            facetOrdering: m === Wm
          });
          Z = Q && Array.isArray(Q) ? Q : [], U = b(Z.slice(0, M()).map(v), {
            results: X
          });
          var oe = J.maxValuesPerFacet, ge = M();
          S = oe > ge ? Z.length <= ge : Z.length < ge, P = X, E = U, W.results && (C = T(W, this));
        }
        var Ae = V && V(W), ke = A && E.length > c, po = f && !S, Uo = ke || po;
        return {
          createURL: function(ro) {
            return ee(function(Qr) {
              return Y.getWidgetUiState(Qr, {
                searchParameters: J.resetPage().toggleFacetRefinement(a, ro),
                helper: pe
              });
            });
          },
          items: U,
          refine: D,
          searchForItems: Ae,
          isFromSearch: !1,
          canRefine: U.length > 0,
          widgetParams: t,
          isShowingMore: A,
          canToggleShowMore: Uo,
          toggleShowMore: x,
          sendEvent: w,
          hasExhaustiveItems: S
        };
      },
      dispose: function(W) {
        var Y = W.state;
        r();
        var X = Y.setQueryParameter("maxValuesPerFacet", void 0);
        return i === "and" ? X.removeFacet(a) : X.removeDisjunctiveFacet(a);
      },
      getWidgetUiState: function(W, Y) {
        var X = Y.searchParameters, J = i === "or" ? X.getDisjunctiveRefinements(a) : X.getConjunctiveRefinements(a);
        return H6(Le(Le({}, W), {}, {
          refinementList: Le(Le({}, W.refinementList), {}, bn({}, a, J))
        }), a);
      },
      getWidgetSearchParameters: function(W, Y) {
        var X = Y.uiState, J = i === "or";
        if (W.isHierarchicalFacet(a))
          return process.env.NODE_ENV === "development" && de(!1, 'RefinementList: Attribute "'.concat(a, `" is already used by another widget applying hierarchical faceting.
As this is not supported, please make sure to remove this other widget or this RefinementList widget will not work at all.`)), W;
        if (J && W.isConjunctiveFacet(a) || !J && W.isDisjunctiveFacet(a))
          return process.env.NODE_ENV === "development" && de(!1, 'RefinementList: Attribute "'.concat(a, `" is used by another refinement list with a different operator.
As this is not supported, please make sure to only use this attribute with one of the two operators.`)), W;
        var ee = X.refinementList && X.refinementList[a], re = J ? W.addDisjunctiveFacet(a).removeDisjunctiveFacetRefinement(a) : W.addFacet(a).removeFacetRefinement(a), pe = re.maxValuesPerFacet || 0, U = Math.max(pe, f ? d : c), Z = re.setQueryParameter("maxValuesPerFacet", U);
        if (!ee) {
          var Q = J ? "disjunctiveFacetsRefinements" : "facetsRefinements";
          return Z.setQueryParameters(bn({}, Q, Le(Le({}, Z[Q]), {}, bn({}, a, []))));
        }
        return ee.reduce(function(oe, ge) {
          return J ? oe.addDisjunctiveFacetRefinement(a, ge) : oe.addFacetRefinement(a, ge);
        }, Z);
      }
    };
  };
};
function H6(o, e) {
  return o.refinementList && ((!o.refinementList[e] || o.refinementList[e].length === 0) && delete o.refinementList[e], Object.keys(o.refinementList).length === 0 && delete o.refinementList), o;
}
function la(o) {
  "@babel/helpers - typeof";
  return la = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, la(o);
}
function Nm(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function wr(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Nm(Object(r), !0).forEach(function(t) {
      Y6(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : Nm(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function Y6(o, e, r) {
  return e = q6(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function q6(o) {
  var e = G6(o, "string");
  return la(e) == "symbol" ? e : String(e);
}
function G6(o, e) {
  if (la(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (la(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
var X6 = Te({
  name: "search-box",
  connector: !0
}), U6 = function(e, r) {
  return r(e);
}, Z6 = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Fe;
  return Ie(e, X6()), function(t) {
    var n = t || {}, a = n.queryHook, s = a === void 0 ? U6 : a, i, l;
    return {
      $$type: "ais.searchBox",
      init: function(u) {
        var f = u.instantSearchInstance;
        e(wr(wr({}, this.getWidgetRenderState(u)), {}, {
          instantSearchInstance: f
        }), !0);
      },
      render: function(u) {
        var f = u.instantSearchInstance;
        e(wr(wr({}, this.getWidgetRenderState(u)), {}, {
          instantSearchInstance: f
        }), !1);
      },
      dispose: function(u) {
        var f = u.state;
        return r(), f.setQueryParameter("query", void 0);
      },
      getRenderState: function(u, f) {
        return wr(wr({}, u), {}, {
          searchBox: this.getWidgetRenderState(f)
        });
      },
      getWidgetRenderState: function(u) {
        var f = u.helper, g = u.instantSearchInstance, d = u.state;
        return i || (i = function(m) {
          s(m, function(y) {
            return f.setQuery(y).search();
          });
        }, l = function() {
          f.setQuery("").search();
        }), {
          query: d.query || "",
          refine: i,
          clear: l,
          widgetParams: t,
          isSearchStalled: g.status === "stalled"
        };
      },
      getWidgetUiState: function(u, f) {
        var g = f.searchParameters, d = g.query || "";
        return d === "" || u && u.query === d ? u : wr(wr({}, u), {}, {
          query: d
        });
      },
      getWidgetSearchParameters: function(u, f) {
        var g = f.uiState;
        return u.setQueryParameter("query", g.query || "");
      }
    };
  };
};
function ca(o) {
  "@babel/helpers - typeof";
  return ca = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, ca(o);
}
function Vm(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function kr(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Vm(Object(r), !0).forEach(function(t) {
      K6(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : Vm(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function K6(o, e, r) {
  return e = Q6(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function Q6(o) {
  var e = J6(o, "string");
  return ca(e) == "symbol" ? e : String(e);
}
function J6(o, e) {
  if (ca(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (ca(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
var zm = Te({
  name: "sort-by",
  connector: !0
}), _6 = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Fe;
  Ie(e, zm());
  var t = {};
  return function(n) {
    var a = n || {}, s = a.items, i = a.transformItems, l = i === void 0 ? function(c) {
      return c;
    } : i;
    if (!Array.isArray(s))
      throw new Error(zm("The `items` option expects an array of objects."));
    return {
      $$type: "ais.sortBy",
      init: function(u) {
        var f = u.instantSearchInstance, g = this.getWidgetRenderState(u), d = g.currentRefinement, p = fr(s, function(m) {
          return m.value === d;
        });
        process.env.NODE_ENV === "development" && de(p !== void 0, 'The index named "'.concat(d, '" is not listed in the `items` of `sortBy`.')), e(kr(kr({}, g), {}, {
          instantSearchInstance: f
        }), !0);
      },
      render: function(u) {
        var f = u.instantSearchInstance;
        e(kr(kr({}, this.getWidgetRenderState(u)), {}, {
          instantSearchInstance: f
        }), !1);
      },
      dispose: function(u) {
        var f = u.state;
        return r(), t.initialIndex ? f.setIndex(t.initialIndex) : f;
      },
      getRenderState: function(u, f) {
        return kr(kr({}, u), {}, {
          sortBy: this.getWidgetRenderState(f)
        });
      },
      getWidgetRenderState: function(u) {
        var f = u.results, g = u.helper, d = u.state, p = u.parent;
        !t.initialIndex && p && (t.initialIndex = p.getIndexName()), t.setIndex || (t.setIndex = function(y) {
          g.setIndex(y).search();
        });
        var m = f ? f.nbHits === 0 : !0;
        return {
          currentRefinement: d.index,
          options: l(s, {
            results: f
          }),
          refine: t.setIndex,
          hasNoResults: m,
          canRefine: !m && s.length > 0,
          widgetParams: n
        };
      },
      getWidgetUiState: function(u, f) {
        var g = f.searchParameters, d = g.index;
        return kr(kr({}, u), {}, {
          sortBy: d !== t.initialIndex ? d : void 0
        });
      },
      getWidgetSearchParameters: function(u, f) {
        var g = f.uiState;
        return u.setQueryParameter("index", g.sortBy || t.initialIndex || u.index);
      }
    };
  };
};
function ua(o) {
  "@babel/helpers - typeof";
  return ua = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, ua(o);
}
function $6(o) {
  return rk(o) || ok(o) || aF(o) || ek();
}
function ek() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ok(o) {
  if (typeof Symbol < "u" && o[Symbol.iterator] != null || o["@@iterator"] != null) return Array.from(o);
}
function rk(o) {
  if (Array.isArray(o)) return Du(o);
}
function Im(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function ho(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Im(Object(r), !0).forEach(function(t) {
      Ms(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : Im(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function Ms(o, e, r) {
  return e = tk(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function tk(o) {
  var e = nk(o, "string");
  return ua(e) == "symbol" ? e : String(e);
}
function nk(o, e) {
  if (ua(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (ua(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
function nF(o, e) {
  return ik(o) || sk(o, e) || aF(o, e) || ak();
}
function ak() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function aF(o, e) {
  if (o) {
    if (typeof o == "string") return Du(o, e);
    var r = Object.prototype.toString.call(o).slice(8, -1);
    if (r === "Object" && o.constructor && (r = o.constructor.name), r === "Map" || r === "Set") return Array.from(o);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Du(o, e);
  }
}
function Du(o, e) {
  (e == null || e > o.length) && (e = o.length);
  for (var r = 0, t = new Array(e); r < e; r++) t[r] = o[r];
  return t;
}
function sk(o, e) {
  var r = o == null ? null : typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (r != null) {
    var t, n, a, s, i = [], l = !0, c = !1;
    try {
      if (a = (r = r.call(o)).next, e !== 0) for (; !(l = (t = a.call(r)).done) && (i.push(t.value), i.length !== e); l = !0) ;
    } catch (u) {
      c = !0, n = u;
    } finally {
      try {
        if (!l && r.return != null && (s = r.return(), Object(s) !== s)) return;
      } finally {
        if (c) throw n;
      }
    }
    return i;
  }
}
function ik(o) {
  if (Array.isArray(o)) return o;
}
var Rm = Te({
  name: "rating-menu",
  connector: !0
}), sF = "ais.ratingMenu", Ul = 1e3, hs = 1, lk = function(e) {
  var r = e.instantSearchInstance, t = e.helper, n = e.getRefinedStar, a = e.attribute;
  return function() {
    for (var s = arguments.length, i = new Array(s), l = 0; l < s; l++)
      i[l] = arguments[l];
    if (i.length === 1) {
      r.sendEventToInsights(i[0]);
      return;
    }
    var c = i[1], u = i[2], f = u === void 0 ? "Filter Applied" : u, g = i[0].split(":"), d = nF(g, 2), p = d[0], m = d[1];
    if (p === "click") {
      var y = n() === Number(c);
      y || r.sendEventToInsights({
        insightsMethod: "clickedFilters",
        widgetType: sF,
        eventType: p,
        eventModifier: m,
        payload: {
          eventName: f,
          index: t.getIndex(),
          filters: ["".concat(a, ">=").concat(c)]
        },
        attribute: a
      });
    }
  };
}, ck = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Fe;
  return Ie(e, Rm()), function(t) {
    var n = t || {}, a = n.attribute, s = n.max, i = s === void 0 ? 5 : s, l;
    if (!a)
      throw new Error(Rm("The `attribute` option is required."));
    var c = function(y) {
      var h, F = y.getNumericRefinements(a);
      if ((h = F[">="]) !== null && h !== void 0 && h.length)
        return F[">="][0];
    }, u = function(y) {
      var h = 0;
      return y.forEach(function(F) {
        var b = F.name.split("."), v = nF(b, 2), P = v[1], E = P === void 0 ? "" : P;
        h = Math.max(h, E.length);
      }), h;
    }, f = function(y) {
      var h = y.maxDecimalPlaces, F = y.maxFacets, b = y.maxValuesPerFacet, v = Math.max(0, Math.floor(Math.log10(Ul / i))), P = Math.min(Ul, Math.pow(10, v) * i), E = [];
      return F > Ul && E.push('- Update your records to lower the precision of the values in the "'.concat(a, '" attribute (for example: ').concat(5.123456789.toPrecision(h + 1), " to ").concat(5.123456789.toPrecision(v + 1), ")")), b < P && E.push("- Increase the maximum number of facet values to ".concat(P, ' using the "configure" widget ').concat(zn({
        name: "configure"
      }), ' and the "maxValuesPerFacet" parameter https://www.algolia.com/doc/api-reference/api-parameters/maxValuesPerFacet/')), "The ".concat(a, " attribute can have ").concat(F, " different values (0 to ").concat(i, " with a maximum of ").concat(h, " decimals = ").concat(F, ") but you retrieved only ").concat(b, ` facet values. Therefore the number of results that match the refinements can be incorrect.
    `).concat(E.length ? `To resolve this problem you can:
`.concat(E.join(`
`)) : "");
    };
    function g(m, y) {
      var h = c(m) === Number(y), F = m.resetPage().removeNumericRefinement(a);
      return h ? F : F.addNumericRefinement(a, "<=", i).addNumericRefinement(a, ">=", Number(y));
    }
    var d = function(y, h) {
      l("click:internal", h), y.setState(g(y.state, h)).search();
    }, p = {
      toggleRefinementFactory: function(y) {
        return d.bind(null, y);
      },
      createURLFactory: function(y) {
        var h = y.state, F = y.createURL, b = y.getWidgetUiState, v = y.helper;
        return function(P) {
          return F(function(E) {
            return b(E, {
              searchParameters: g(h, P),
              helper: v
            });
          });
        };
      }
    };
    return {
      $$type: sF,
      init: function(y) {
        var h = y.instantSearchInstance;
        e(ho(ho({}, this.getWidgetRenderState(y)), {}, {
          instantSearchInstance: h
        }), !0);
      },
      render: function(y) {
        var h = y.instantSearchInstance;
        e(ho(ho({}, this.getWidgetRenderState(y)), {}, {
          instantSearchInstance: h
        }), !1);
      },
      getRenderState: function(y, h) {
        return ho(ho({}, y), {}, {
          ratingMenu: ho(ho({}, y.ratingMenu), {}, Ms({}, a, this.getWidgetRenderState(h)))
        });
      },
      getWidgetRenderState: function(y) {
        var h = y.helper, F = y.results, b = y.state, v = y.instantSearchInstance, P = y.createURL, E = [];
        l || (l = lk({
          instantSearchInstance: v,
          helper: h,
          getRefinedStar: function() {
            return c(h.state);
          },
          attribute: a
        }));
        var S = !1, D = 0, w = F == null ? void 0 : F.getFacetValues(a, {});
        if (F && w) {
          var A = w.length, C = u(w), x = Math.pow(10, C) * i;
          process.env.NODE_ENV === "development" && de(x <= A || !!F.__isArtificial, f({
            maxDecimalPlaces: C,
            maxFacets: x,
            maxValuesPerFacet: A
          }));
          for (var T = c(b), M = function(Y) {
            var X = T === Y;
            S = S || X;
            var J = w.filter(function(re) {
              return Number(re.name) >= Y && Number(re.name) <= i;
            }).map(function(re) {
              return re.count;
            }).reduce(function(re, pe) {
              return re + pe;
            }, 0);
            if (D += J, T && !X && J === 0)
              return "continue";
            var ee = $6(new Array(Math.floor(i / hs))).map(function(re, pe) {
              return pe * hs < Y;
            });
            E.push({
              stars: ee,
              name: String(Y),
              label: String(Y),
              value: String(Y),
              count: J,
              isRefined: X
            });
          }, V = hs; V < i; V += hs)
            var G = M(V);
        }
        E = E.reverse();
        var L = F ? F.nbHits === 0 : !0;
        return {
          items: E,
          hasNoResults: L,
          canRefine: (!L || S) && D > 0,
          refine: p.toggleRefinementFactory(h),
          sendEvent: l,
          createURL: p.createURLFactory({
            state: b,
            createURL: P,
            helper: h,
            getWidgetUiState: this.getWidgetUiState
          }),
          widgetParams: t
        };
      },
      dispose: function(y) {
        var h = y.state;
        return r(), h.removeNumericRefinement(a);
      },
      getWidgetUiState: function(y, h) {
        var F = h.searchParameters, b = c(F);
        return uk(ho(ho({}, y), {}, {
          ratingMenu: ho(ho({}, y.ratingMenu), {}, Ms({}, a, typeof b == "number" ? b : void 0))
        }), a);
      },
      getWidgetSearchParameters: function(y, h) {
        var F = h.uiState, b = F.ratingMenu && F.ratingMenu[a], v = y.addDisjunctiveFacet(a).removeNumericRefinement(a).removeDisjunctiveFacetRefinement(a);
        return b ? v.addNumericRefinement(a, "<=", i).addNumericRefinement(a, ">=", b) : v.setQueryParameters({
          numericRefinements: ho(ho({}, v.numericRefinements), {}, Ms({}, a, {}))
        });
      }
    };
  };
};
function uk(o, e) {
  return o.ratingMenu && (typeof o.ratingMenu[e] != "number" && delete o.ratingMenu[e], Object.keys(o.ratingMenu).length === 0 && delete o.ratingMenu), o;
}
function pa(o) {
  "@babel/helpers - typeof";
  return pa = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, pa(o);
}
function Hm(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function xt(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Hm(Object(r), !0).forEach(function(t) {
      pk(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : Hm(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function pk(o, e, r) {
  return e = dk(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function dk(o) {
  var e = gk(o, "string");
  return pa(e) == "symbol" ? e : String(e);
}
function gk(o, e) {
  if (pa(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (pa(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
var mk = Te({
  name: "stats",
  connector: !0
}), fk = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Fe;
  return Ie(e, mk()), function(t) {
    return {
      $$type: "ais.stats",
      init: function(a) {
        var s = a.instantSearchInstance;
        e(xt(xt({}, this.getWidgetRenderState(a)), {}, {
          instantSearchInstance: s
        }), !0);
      },
      render: function(a) {
        var s = a.instantSearchInstance;
        e(xt(xt({}, this.getWidgetRenderState(a)), {}, {
          instantSearchInstance: s
        }), !1);
      },
      dispose: function() {
        r();
      },
      getRenderState: function(a, s) {
        return xt(xt({}, a), {}, {
          stats: this.getWidgetRenderState(s)
        });
      },
      getWidgetRenderState: function(a) {
        var s = a.results, i = a.state;
        return s ? {
          hitsPerPage: s.hitsPerPage,
          nbHits: s.nbHits,
          nbSortedHits: s.nbSortedHits,
          areHitsSorted: typeof s.appliedRelevancyStrictness < "u" && s.appliedRelevancyStrictness > 0 && s.nbSortedHits !== s.nbHits,
          nbPages: s.nbPages,
          page: s.page,
          processingTimeMS: s.processingTimeMS,
          query: s.query,
          widgetParams: t
        } : {
          hitsPerPage: i.hitsPerPage,
          nbHits: 0,
          nbSortedHits: void 0,
          areHitsSorted: !1,
          nbPages: 0,
          page: i.page || 0,
          processingTimeMS: -1,
          query: i.query || "",
          widgetParams: t
        };
      }
    };
  };
};
function da(o) {
  "@babel/helpers - typeof";
  return da = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, da(o);
}
function Ym(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function Fo(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Ym(Object(r), !0).forEach(function(t) {
      Ws(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : Ym(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function Ws(o, e, r) {
  return e = yk(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function yk(o) {
  var e = hk(o, "string");
  return da(e) == "symbol" ? e : String(e);
}
function hk(o, e) {
  if (da(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (da(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
function Fk(o, e) {
  return Pk(o) || Bk(o, e) || vk(o, e) || bk();
}
function bk() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function vk(o, e) {
  if (o) {
    if (typeof o == "string") return qm(o, e);
    var r = Object.prototype.toString.call(o).slice(8, -1);
    if (r === "Object" && o.constructor && (r = o.constructor.name), r === "Map" || r === "Set") return Array.from(o);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return qm(o, e);
  }
}
function qm(o, e) {
  (e == null || e > o.length) && (e = o.length);
  for (var r = 0, t = new Array(e); r < e; r++) t[r] = o[r];
  return t;
}
function Bk(o, e) {
  var r = o == null ? null : typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (r != null) {
    var t, n, a, s, i = [], l = !0, c = !1;
    try {
      if (a = (r = r.call(o)).next, e !== 0) for (; !(l = (t = a.call(r)).done) && (i.push(t.value), i.length !== e); l = !0) ;
    } catch (u) {
      c = !0, n = u;
    } finally {
      try {
        if (!l && r.return != null && (s = r.return(), Object(s) !== s)) return;
      } finally {
        if (c) throw n;
      }
    }
    return i;
  }
}
function Pk(o) {
  if (Array.isArray(o)) return o;
}
var Gm = Te({
  name: "toggle-refinement",
  connector: !0
}), iF = "ais.toggleRefinement", wk = function(e) {
  var r = e.instantSearchInstance, t = e.helper, n = e.attribute, a = e.on, s = function() {
    for (var l = arguments.length, c = new Array(l), u = 0; u < l; u++)
      c[u] = arguments[u];
    if (c.length === 1) {
      r.sendEventToInsights(c[0]);
      return;
    }
    var f = c[1], g = c[2], d = g === void 0 ? "Filter Applied" : g, p = c[0].split(":"), m = Fk(p, 2), y = m[0], h = m[1];
    y !== "click" || a === void 0 || f || r.sendEventToInsights({
      insightsMethod: "clickedFilters",
      widgetType: iF,
      eventType: y,
      eventModifier: h,
      payload: {
        eventName: d,
        index: t.getIndex(),
        filters: a.map(function(F) {
          return "".concat(n, ":").concat(F);
        })
      },
      attribute: n
    });
  };
  return s;
}, kk = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Fe;
  return Ie(e, Gm()), function(t) {
    var n = t || {}, a = n.attribute, s = n.on, i = s === void 0 ? !0 : s, l = n.off;
    if (!a)
      throw new Error(Gm("The `attribute` option is required."));
    var c = l !== void 0, u = pl(i).map(yn), f = c ? pl(l).map(yn) : void 0, g, d = function(y) {
      return function() {
        var h = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
          isRefined: !1
        }, F = h.isRefined;
        F ? (u.forEach(function(b) {
          return y.removeDisjunctiveFacetRefinement(a, b);
        }), c && f.forEach(function(b) {
          return y.addDisjunctiveFacetRefinement(a, b);
        })) : (g("click:internal", F), c && f.forEach(function(b) {
          return y.removeDisjunctiveFacetRefinement(a, b);
        }), u.forEach(function(b) {
          return y.addDisjunctiveFacetRefinement(a, b);
        })), y.search();
      };
    }, p = {
      createURLFactory: function(y, h) {
        var F = h.state, b = h.createURL, v = h.getWidgetUiState, P = h.helper;
        return function() {
          F = F.resetPage();
          var E = y ? u : f;
          E && E.forEach(function(D) {
            F = F.removeDisjunctiveFacetRefinement(a, D);
          });
          var S = y ? f : u;
          return S && S.forEach(function(D) {
            F = F.addDisjunctiveFacetRefinement(a, D);
          }), b(function(D) {
            return v(D, {
              searchParameters: F,
              helper: P
            });
          });
        };
      }
    };
    return {
      $$type: iF,
      init: function(y) {
        var h = y.instantSearchInstance;
        e(Fo(Fo({}, this.getWidgetRenderState(y)), {}, {
          instantSearchInstance: h
        }), !0);
      },
      render: function(y) {
        var h = y.instantSearchInstance;
        e(Fo(Fo({}, this.getWidgetRenderState(y)), {}, {
          instantSearchInstance: h
        }), !1);
      },
      dispose: function(y) {
        var h = y.state;
        return r(), h.removeDisjunctiveFacet(a);
      },
      getRenderState: function(y, h) {
        return Fo(Fo({}, y), {}, {
          toggleRefinement: Fo(Fo({}, y.toggleRefinement), {}, Ws({}, a, this.getWidgetRenderState(h)))
        });
      },
      getWidgetRenderState: function(y) {
        var h = y.state, F = y.helper, b = y.results, v = y.createURL, P = y.instantSearchInstance, E = b ? u.every(function(M) {
          return h.isDisjunctiveFacetRefined(a, M);
        }) : u.every(function(M) {
          return h.isDisjunctiveFacetRefined(a, M);
        }), S = {
          isRefined: E,
          count: 0
        }, D = {
          isRefined: c && !E,
          count: 0
        };
        if (b) {
          var w = pl(f || !1), A = b.getFacetValues(a, {}) || [], C = u.map(function(M) {
            return fr(A, function(V) {
              var G = V.escapedValue;
              return G === yn(String(M));
            });
          }).filter(function(M) {
            return M !== void 0;
          }), x = c ? w.map(function(M) {
            return fr(A, function(V) {
              var G = V.escapedValue;
              return G === yn(String(M));
            });
          }).filter(function(M) {
            return M !== void 0;
          }) : [];
          S = {
            isRefined: C.length ? C.every(function(M) {
              return M.isRefined;
            }) : !1,
            count: C.reduce(function(M, V) {
              return M + V.count;
            }, 0) || null
          }, D = {
            isRefined: x.length ? x.every(function(M) {
              return M.isRefined;
            }) : !1,
            count: x.reduce(function(M, V) {
              return M + V.count;
            }, 0) || A.reduce(function(M, V) {
              var G = V.count;
              return M + G;
            }, 0)
          };
        }
        g || (g = wk({
          instantSearchInstance: P,
          attribute: a,
          on: u,
          helper: F
        }));
        var T = E ? D : S;
        return {
          value: {
            name: a,
            isRefined: E,
            count: b ? T.count : null,
            onFacetValue: S,
            offFacetValue: D
          },
          createURL: p.createURLFactory(E, {
            state: h,
            createURL: v,
            helper: F,
            getWidgetUiState: this.getWidgetUiState
          }),
          sendEvent: g,
          canRefine: !!(b && T.count),
          refine: d(F),
          widgetParams: t
        };
      },
      getWidgetUiState: function(y, h) {
        var F = h.searchParameters, b = u && u.every(function(P) {
          return F.isDisjunctiveFacetRefined(a, P);
        });
        if (!b) {
          var v;
          return (v = y.toggle) === null || v === void 0 || delete v[a], y;
        }
        return Fo(Fo({}, y), {}, {
          toggle: Fo(Fo({}, y.toggle), {}, Ws({}, a, b))
        });
      },
      getWidgetSearchParameters: function(y, h) {
        var F = h.uiState;
        if (y.isHierarchicalFacet(a) || y.isConjunctiveFacet(a))
          return process.env.NODE_ENV === "development" && de(!1, 'ToggleRefinement: Attribute "'.concat(a, `" is already used by another widget of a different type.
As this is not supported, please make sure to remove this other widget or this ToggleRefinement widget will not work at all.`)), y;
        var b = y.addDisjunctiveFacet(a).removeDisjunctiveFacetRefinement(a), v = !!(F.toggle && F.toggle[a]);
        return v ? (u && u.forEach(function(P) {
          b = b.addDisjunctiveFacetRefinement(a, P);
        }), b) : c ? (f && f.forEach(function(P) {
          b = b.addDisjunctiveFacetRefinement(a, P);
        }), b) : b.setQueryParameters({
          disjunctiveFacetsRefinements: Fo(Fo({}, y.disjunctiveFacetsRefinements), {}, Ws({}, a, []))
        });
      }
    };
  };
};
function ga(o) {
  "@babel/helpers - typeof";
  return ga = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, ga(o);
}
function Xm(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function bo(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Xm(Object(r), !0).forEach(function(t) {
      Ns(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : Xm(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function Ns(o, e, r) {
  return e = Dk(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function Dk(o) {
  var e = Sk(o, "string");
  return ga(e) == "symbol" ? e : String(e);
}
function Sk(o, e) {
  if (ga(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (ga(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
function Um(o, e) {
  return Ck(o) || xk(o, e) || Ek(o, e) || Ak();
}
function Ak() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Ek(o, e) {
  if (o) {
    if (typeof o == "string") return Zm(o, e);
    var r = Object.prototype.toString.call(o).slice(8, -1);
    if (r === "Object" && o.constructor && (r = o.constructor.name), r === "Map" || r === "Set") return Array.from(o);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Zm(o, e);
  }
}
function Zm(o, e) {
  (e == null || e > o.length) && (e = o.length);
  for (var r = 0, t = new Array(e); r < e; r++) t[r] = o[r];
  return t;
}
function xk(o, e) {
  var r = o == null ? null : typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (r != null) {
    var t, n, a, s, i = [], l = !0, c = !1;
    try {
      if (a = (r = r.call(o)).next, e !== 0) for (; !(l = (t = a.call(r)).done) && (i.push(t.value), i.length !== e); l = !0) ;
    } catch (u) {
      c = !0, n = u;
    } finally {
      try {
        if (!l && r.return != null && (s = r.return(), Object(s) !== s)) return;
      } finally {
        if (c) throw n;
      }
    }
    return i;
  }
}
function Ck(o) {
  if (Array.isArray(o)) return o;
}
var Km = Te({
  name: "breadcrumb",
  connector: !0
}), Ok = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Fe;
  Ie(e, Km());
  var t = {};
  return function(n) {
    var a = n || {}, s = a.attributes, i = a.separator, l = i === void 0 ? " > " : i, c = a.rootPath, u = c === void 0 ? null : c, f = a.transformItems, g = f === void 0 ? function(y) {
      return y;
    } : f;
    if (!s || !Array.isArray(s) || s.length === 0)
      throw new Error(Km("The `attributes` option expects an array of strings."));
    var d = Um(s, 1), p = d[0];
    function m(y, h) {
      if (!h) {
        var F = y.getHierarchicalFacetBreadcrumb(p);
        return F.length === 0 ? y : y.resetPage().toggleFacetRefinement(p, F[0]);
      }
      return y.resetPage().toggleFacetRefinement(p, h);
    }
    return {
      $$type: "ais.breadcrumb",
      init: function(h) {
        e(bo(bo({}, this.getWidgetRenderState(h)), {}, {
          instantSearchInstance: h.instantSearchInstance
        }), !0);
      },
      render: function(h) {
        e(bo(bo({}, this.getWidgetRenderState(h)), {}, {
          instantSearchInstance: h.instantSearchInstance
        }), !1);
      },
      dispose: function() {
        r();
      },
      getRenderState: function(h, F) {
        return bo(bo({}, h), {}, {
          breadcrumb: bo(bo({}, h.breadcrumb), {}, Ns({}, p, this.getWidgetRenderState(F)))
        });
      },
      getWidgetRenderState: function(h) {
        var F = this, b = h.helper, v = h.createURL, P = h.results, E = h.state;
        function S() {
          if (!P || E.hierarchicalFacets.length === 0)
            return [];
          var w = Um(E.hierarchicalFacets, 1), A = w[0].name, C = P.getFacetValues(A, {}), x = C && !Array.isArray(C) && C.data ? C.data : [], T = g(Tk(lF(x)), {
            results: P
          });
          return T;
        }
        var D = S();
        return t.createURL || (t.createURL = function(w) {
          return v(function(A) {
            return F.getWidgetUiState(A, {
              searchParameters: m(b.state, w),
              helper: b
            });
          });
        }), t.refine || (t.refine = function(w) {
          b.setState(m(b.state, w)).search();
        }), {
          canRefine: D.length > 0,
          createURL: t.createURL,
          items: D,
          refine: t.refine,
          widgetParams: n
        };
      },
      getWidgetUiState: function(h, F) {
        var b = F.searchParameters, v = b.getHierarchicalFacetBreadcrumb(p);
        return Lk(bo(bo({}, h), {}, {
          hierarchicalMenu: bo(bo({}, h.hierarchicalMenu), {}, Ns({}, p, v))
        }), p);
      },
      getWidgetSearchParameters: function(h, F) {
        var b = F.uiState, v = b.hierarchicalMenu && b.hierarchicalMenu[p];
        if (h.isConjunctiveFacet(p) || h.isDisjunctiveFacet(p))
          return process.env.NODE_ENV === "development" && de(!1, 'HierarchicalMenu: Attribute "'.concat(p, `" is already used by another widget applying conjunctive or disjunctive faceting.
As this is not supported, please make sure to remove this other widget or this HierarchicalMenu widget will not work at all.`)), h;
        if (h.isHierarchicalFacet(p)) {
          var P = h.getHierarchicalFacetByName(p);
          process.env.NODE_ENV === "development" && de(yt(P.attributes, s) && P.separator === l && P.rootPath === u, "Using Breadcrumb and HierarchicalMenu on the same facet with different options overrides the configuration of the HierarchicalMenu.");
        }
        var E = h.removeHierarchicalFacet(p).addHierarchicalFacet({
          name: p,
          attributes: s,
          separator: l,
          rootPath: u
        });
        return v ? E.addHierarchicalFacetRefinement(p, v.join(l)) : E.setQueryParameters({
          hierarchicalFacetsRefinements: bo(bo({}, E.hierarchicalFacetsRefinements), {}, Ns({}, p, []))
        });
      }
    };
  };
};
function lF(o) {
  return o.reduce(function(e, r) {
    return r.isRefined && (e.push({
      label: r.name,
      value: r.escapedValue
    }), Array.isArray(r.data) && (e = e.concat(lF(r.data)))), e;
  }, []);
}
function Tk(o) {
  return o.map(function(e, r) {
    return {
      label: e.label,
      value: r + 1 === o.length ? null : o[r + 1].value
    };
  });
}
function Lk(o, e) {
  return o.hierarchicalMenu && ((!o.hierarchicalMenu[e] || !o.hierarchicalMenu[e].length) && delete o.hierarchicalMenu[e], Object.keys(o.hierarchicalMenu).length === 0 && delete o.hierarchicalMenu), o;
}
function ma(o) {
  "@babel/helpers - typeof";
  return ma = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, ma(o);
}
function Qm(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function jo(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Qm(Object(r), !0).forEach(function(t) {
      cF(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : Qm(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function cF(o, e, r) {
  return e = jk(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function jk(o) {
  var e = Mk(o, "string");
  return ma(e) == "symbol" ? e : String(e);
}
function Mk(o, e) {
  if (ma(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (ma(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
var Wk = Te({
  name: "autocomplete",
  connector: !0
}), Nk = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Fe;
  return Ie(e, Wk()), function(t) {
    var n = t || {}, a = n.escapeHTML, s = a === void 0 ? !0 : a;
    process.env.NODE_ENV === "development" && de(!t.indices, `
The option \`indices\` has been removed from the Autocomplete connector.

The indices to target are now inferred from the widgets tree.
`.concat(Array.isArray(t.indices) ? `
An alternative would be:

const autocomplete = connectAutocomplete(renderer);

search.addWidgets([
  `.concat(t.indices.map(function(l) {
      var c = l.value;
      return "index({ indexName: '".concat(c, "' }),");
    }).join(`
  `), `
  autocomplete()
]);
`) : "", `
      `));
    var i = {};
    return {
      $$type: "ais.autocomplete",
      init: function(c) {
        var u = c.instantSearchInstance;
        e(jo(jo({}, this.getWidgetRenderState(c)), {}, {
          instantSearchInstance: u
        }), !0);
      },
      render: function(c) {
        var u = c.instantSearchInstance, f = this.getWidgetRenderState(c);
        f.indices.forEach(function(g) {
          var d = g.sendEvent, p = g.hits;
          d("view:internal", p);
        }), e(jo(jo({}, f), {}, {
          instantSearchInstance: u
        }), !1);
      },
      getRenderState: function(c, u) {
        return jo(jo({}, c), {}, {
          autocomplete: this.getWidgetRenderState(u)
        });
      },
      getWidgetRenderState: function(c) {
        var u = this, f = c.helper, g = c.state, d = c.scopedResults, p = c.instantSearchInstance;
        i.refine || (i.refine = function(y) {
          f.setQuery(y).search();
        });
        var m = d.map(function(y) {
          var h, F;
          y.results && (y.results.hits = s ? Ei(y.results.hits) : y.results.hits);
          var b = xp({
            instantSearchInstance: p,
            getIndex: function() {
              var P;
              return ((P = y.results) === null || P === void 0 ? void 0 : P.index) || "";
            },
            widgetType: u.$$type
          });
          return {
            indexId: y.indexId,
            indexName: ((h = y.results) === null || h === void 0 ? void 0 : h.index) || "",
            hits: ((F = y.results) === null || F === void 0 ? void 0 : F.hits) || [],
            results: y.results || {},
            sendEvent: b
          };
        });
        return {
          currentRefinement: g.query || "",
          indices: m,
          refine: i.refine,
          widgetParams: t
        };
      },
      getWidgetUiState: function(c, u) {
        var f = u.searchParameters, g = f.query || "";
        return g === "" || c && c.query === g ? c : jo(jo({}, c), {}, {
          query: g
        });
      },
      getWidgetSearchParameters: function(c, u) {
        var f = u.uiState, g = {
          query: f.query || ""
        };
        return s ? c.setQueryParameters(jo(jo({}, g), nr)) : c.setQueryParameters(g);
      },
      dispose: function(c) {
        var u = c.state;
        r();
        var f = u.setQueryParameter("query", void 0);
        return s ? f.setQueryParameters(Object.keys(nr).reduce(function(g, d) {
          return jo(jo({}, g), {}, cF({}, d, void 0));
        }, {})) : f;
      }
    };
  };
};
function fa(o) {
  "@babel/helpers - typeof";
  return fa = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, fa(o);
}
function Jm(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function xr(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Jm(Object(r), !0).forEach(function(t) {
      Vk(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : Jm(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function Vk(o, e, r) {
  return e = zk(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function zk(o) {
  var e = Ik(o, "string");
  return fa(e) == "symbol" ? e : String(e);
}
function Ik(o, e) {
  if (fa(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (fa(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
function $s(o) {
  return qk(o) || Yk(o) || Hk(o) || Rk();
}
function Rk() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Hk(o, e) {
  if (o) {
    if (typeof o == "string") return Su(o, e);
    var r = Object.prototype.toString.call(o).slice(8, -1);
    if (r === "Object" && o.constructor && (r = o.constructor.name), r === "Map" || r === "Set") return Array.from(o);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Su(o, e);
  }
}
function Yk(o) {
  if (typeof Symbol < "u" && o[Symbol.iterator] != null || o["@@iterator"] != null) return Array.from(o);
}
function qk(o) {
  if (Array.isArray(o)) return Su(o);
}
function Su(o, e) {
  (e == null || e > o.length) && (e = o.length);
  for (var r = 0, t = new Array(e); r < e; r++) t[r] = o[r];
  return t;
}
var _m = Te({
  name: "query-rules",
  connector: !0
});
function Gk(o) {
  return [o.disjunctiveFacetsRefinements, o.facetsRefinements, o.hierarchicalFacetsRefinements, o.numericRefinements].some(function(e) {
    return !!(e && Object.keys(e).length > 0);
  });
}
function Xk(o) {
  return o.replace(/[^a-z0-9-_]+/gi, "_");
}
function Uk(o) {
  var e = o.helper, r = o.sharedHelperState, t = o.trackedFilters, n = Object.keys(t).reduce(function(a, s) {
    var i = Op(e.lastResults || {}, r, !0).filter(function(u) {
      return u.attribute === s;
    }).map(function(u) {
      return u.numericValue || u.name;
    }), l = t[s], c = l(i);
    return [].concat($s(a), $s(i.filter(function(u) {
      return c.includes(u);
    }).map(function(u) {
      return Xk("ais-".concat(s, "-").concat(u));
    })));
  }, []);
  return n;
}
function Zk(o) {
  var e = this.helper, r = this.initialRuleContexts, t = this.trackedFilters, n = this.transformRuleContexts, a = o.state, s = a.ruleContexts || [], i = Uk({
    helper: e,
    sharedHelperState: a,
    trackedFilters: t
  }), l = [].concat($s(r), $s(i));
  process.env.NODE_ENV === "development" && de(l.length <= 10, "\nThe maximum number of `ruleContexts` is 10. They have been sliced to that limit.\nConsider using `transformRuleContexts` to minimize the number of rules sent to Algolia.\n");
  var c = n(l).slice(0, 10);
  yt(s, c) || e.overrideStateWithoutTriggeringChangeEvent(xr(xr({}, a), {}, {
    ruleContexts: c
  }));
}
var uF = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Fe;
  return Ie(e, _m()), function(t) {
    var n = t || {}, a = n.trackedFilters, s = a === void 0 ? {} : a, i = n.transformRuleContexts, l = i === void 0 ? function(p) {
      return p;
    } : i, c = n.transformItems, u = c === void 0 ? function(p) {
      return p;
    } : c;
    Object.keys(s).forEach(function(p) {
      if (typeof s[p] != "function")
        throw new Error(_m(`'The "`.concat(p, '" filter value in the `trackedFilters` option expects a function.')));
    });
    var f = Object.keys(s).length > 0, g = [], d;
    return {
      $$type: "ais.queryRules",
      init: function(m) {
        var y = m.helper, h = m.state, F = m.instantSearchInstance;
        g = h.ruleContexts || [], d = Zk.bind({
          helper: y,
          initialRuleContexts: g,
          trackedFilters: s,
          transformRuleContexts: l
        }), f && ((Gk(h) || t.transformRuleContexts) && d({
          state: h
        }), y.on("change", d)), e(xr(xr({}, this.getWidgetRenderState(m)), {}, {
          instantSearchInstance: F
        }), !0);
      },
      render: function(m) {
        var y = m.instantSearchInstance;
        e(xr(xr({}, this.getWidgetRenderState(m)), {}, {
          instantSearchInstance: y
        }), !1);
      },
      getWidgetRenderState: function(m) {
        var y = m.results, h = y || {}, F = h.userData, b = F === void 0 ? [] : F, v = u(b, {
          results: y
        });
        return {
          items: v,
          widgetParams: t
        };
      },
      getRenderState: function(m, y) {
        return xr(xr({}, m), {}, {
          queryRules: this.getWidgetRenderState(y)
        });
      },
      dispose: function(m) {
        var y = m.helper, h = m.state;
        return r(), f ? (y.removeListener("change", d), h.setQueryParameter("ruleContexts", g)) : h;
      }
    };
  };
};
function ya(o) {
  "@babel/helpers - typeof";
  return ya = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, ya(o);
}
function $m(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function ef(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? $m(Object(r), !0).forEach(function(t) {
      Kk(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : $m(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function Kk(o, e, r) {
  return e = Qk(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function Qk(o) {
  var e = Jk(o, "string");
  return ya(e) == "symbol" ? e : String(e);
}
function Jk(o, e) {
  if (ya(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (ya(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
var _k = function(e) {
  var r = e.searchAsYouSpeak, t = e.language, n = e.onQueryChange, a = e.onStateChange, s = window.webkitSpeechRecognition || window.SpeechRecognition, i = function(S) {
    return {
      status: S,
      transcript: "",
      isSpeechFinal: !1,
      errorCode: void 0
    };
  }, l = i("initial"), c, u = function() {
    return !!s;
  }, f = function() {
    return l.status === "askingPermission" || l.status === "waiting" || l.status === "recognizing";
  }, g = function() {
    var S = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    l = ef(ef({}, l), S), a();
  }, d = function() {
    return l;
  }, p = function() {
    var S = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "initial";
    g(i(S));
  }, m = function() {
    g({
      status: "waiting"
    });
  }, y = function(S) {
    g({
      status: "error",
      errorCode: S.error
    });
  }, h = function(S) {
    g({
      status: "recognizing",
      transcript: S.results[0] && S.results[0][0] && S.results[0][0].transcript || "",
      isSpeechFinal: S.results[0] && S.results[0].isFinal
    }), r && l.transcript && n(l.transcript);
  }, F = function() {
    !l.errorCode && l.transcript && !r && n(l.transcript), l.status !== "error" && g({
      status: "finished"
    });
  }, b = function() {
    c = new s(), c && (p("askingPermission"), c.interimResults = !0, t && (c.lang = t), c.addEventListener("start", m), c.addEventListener("error", y), c.addEventListener("result", h), c.addEventListener("end", F), c.start());
  }, v = function() {
    c && (c.stop(), c.removeEventListener("start", m), c.removeEventListener("error", y), c.removeEventListener("result", h), c.removeEventListener("end", F), c = void 0);
  }, P = function() {
    v(), p("finished");
  };
  return {
    getState: d,
    isBrowserSupported: u,
    isListening: f,
    startListening: b,
    stopListening: P,
    dispose: v
  };
};
function ha(o) {
  "@babel/helpers - typeof";
  return ha = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, ha(o);
}
function of(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function Mo(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? of(Object(r), !0).forEach(function(t) {
      $k(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : of(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function $k(o, e, r) {
  return e = eD(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function eD(o) {
  var e = oD(o, "string");
  return ha(e) == "symbol" ? e : String(e);
}
function oD(o, e) {
  if (ha(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (ha(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
var rD = Te({
  name: "voice-search",
  connector: !0
}), tD = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Fe;
  return Ie(e, rD()), function(t) {
    var n = t.searchAsYouSpeak, a = n === void 0 ? !1 : n, s = t.language, i = t.additionalQueryParameters, l = t.createVoiceSearchHelper, c = l === void 0 ? _k : l;
    return {
      $$type: "ais.voiceSearch",
      init: function(f) {
        var g = f.instantSearchInstance;
        e(Mo(Mo({}, this.getWidgetRenderState(f)), {}, {
          instantSearchInstance: g
        }), !0);
      },
      render: function(f) {
        var g = f.instantSearchInstance;
        e(Mo(Mo({}, this.getWidgetRenderState(f)), {}, {
          instantSearchInstance: g
        }), !1);
      },
      getRenderState: function(f, g) {
        return Mo(Mo({}, f), {}, {
          voiceSearch: this.getWidgetRenderState(g)
        });
      },
      getWidgetRenderState: function(f) {
        var g = this, d = f.helper, p = f.instantSearchInstance;
        this._refine || (this._refine = function(P) {
          if (P !== d.state.query) {
            var E = s ? [s.split("-")[0]] : void 0;
            d.setQueryParameter("queryLanguages", E), typeof i == "function" && d.setState(d.state.setQueryParameters(Mo({
              ignorePlurals: !0,
              removeStopWords: !0,
              // @ts-ignore optionalWords is allowed to be a string too
              optionalWords: P
            }, i({
              query: P
            })))), d.setQuery(P).search();
          }
        }), this._voiceSearchHelper || (this._voiceSearchHelper = c({
          searchAsYouSpeak: a,
          language: s,
          onQueryChange: function(E) {
            return g._refine(E);
          },
          onStateChange: function() {
            e(Mo(Mo({}, g.getWidgetRenderState(f)), {}, {
              instantSearchInstance: p
            }), !1);
          }
        }));
        var m = this._voiceSearchHelper, y = m.isBrowserSupported, h = m.isListening, F = m.startListening, b = m.stopListening, v = m.getState;
        return {
          isBrowserSupported: y(),
          isListening: h(),
          toggleListening: function() {
            y() && (h() ? b() : F());
          },
          voiceListeningState: v(),
          widgetParams: t
        };
      },
      dispose: function(f) {
        var g = f.state;
        this._voiceSearchHelper.dispose(), r();
        var d = g;
        if (typeof i == "function") {
          var p = i({
            query: ""
          }), m = p ? Object.keys(p).reduce(function(y, h) {
            return y[h] = void 0, y;
          }, {}) : {};
          d = g.setQueryParameters(Mo({
            // @ts-ignore (queryLanguages is not added to algoliasearch v3)
            queryLanguages: void 0,
            ignorePlurals: void 0,
            removeStopWords: void 0,
            optionalWords: void 0
          }, m));
        }
        return d.setQueryParameter("query", void 0);
      },
      getWidgetUiState: function(f, g) {
        var d = g.searchParameters, p = d.query || "";
        return p ? Mo(Mo({}, f), {}, {
          query: p
        }) : f;
      },
      getWidgetSearchParameters: function(f, g) {
        var d = g.uiState;
        return f.setQueryParameter("query", d.query || "");
      }
    };
  };
};
function Fa(o) {
  "@babel/helpers - typeof";
  return Fa = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Fa(o);
}
function rf(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function Dr(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? rf(Object(r), !0).forEach(function(t) {
      nD(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : rf(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function nD(o, e, r) {
  return e = aD(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function aD(o) {
  var e = sD(o, "string");
  return Fa(e) == "symbol" ? e : String(e);
}
function sD(o, e) {
  if (Fa(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (Fa(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
var iD = function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Fe, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Fe;
  return function(t) {
    var n = {};
    return {
      $$type: "ais.relevantSort",
      init: function(s) {
        var i = s.instantSearchInstance;
        e(Dr(Dr({}, this.getWidgetRenderState(s)), {}, {
          instantSearchInstance: i
        }), !0);
      },
      render: function(s) {
        var i = s.instantSearchInstance;
        e(Dr(Dr({}, this.getWidgetRenderState(s)), {}, {
          instantSearchInstance: i
        }), !1);
      },
      dispose: function(s) {
        var i = s.state;
        return r(), i.setQueryParameter("relevancyStrictness", void 0);
      },
      getRenderState: function(s, i) {
        return Dr(Dr({}, s), {}, {
          relevantSort: this.getWidgetRenderState(i)
        });
      },
      getWidgetRenderState: function(s) {
        var i = s.results, l = s.helper;
        n.refine || (n.refine = function(g) {
          l.setQueryParameter("relevancyStrictness", g).search();
        });
        var c = i || {}, u = c.appliedRelevancyStrictness, f = u !== void 0;
        return {
          isRelevantSorted: typeof u < "u" && u > 0,
          isVirtualReplica: f,
          canRefine: f,
          refine: n.refine,
          widgetParams: t
        };
      },
      getWidgetSearchParameters: function(s, i) {
        var l, c = i.uiState;
        return s.setQueryParameter("relevancyStrictness", (l = c.relevantSort) !== null && l !== void 0 ? l : s.relevancyStrictness);
      },
      getWidgetUiState: function(s, i) {
        var l = i.searchParameters;
        return Dr(Dr({}, s), {}, {
          relevantSort: l.relevancyStrictness || s.relevantSort
        });
      }
    };
  };
};
Br(nw, "answers is no longer supported");
var lD = Br(Cw, "EXPERIMENTAL_connectConfigureRelatedItems is deprecated and will be removed in a next minor version of InstantSearch. Please use connectRelatedItems instead.");
Br(X1, "use connectDynamicWidgets");
xe({ connector: Nk }, { $$widgetType: "ais.autocomplete" }), Pe({ name: "Autocomplete" });
O("p", null, " This widget doesn't render anything without a filled in default slot. ", -1);
O("p", null, "query, function to refine and results are provided.", -1);
O("pre", null, "refine: Function", -1);
O("summary", null, [O("code", null, "indices"), ne(":")], -1);
function cD(o) {
  return { all: o = o || /* @__PURE__ */ new Map(), on: function(e, r) {
    var t = o.get(e);
    t && t.push(r) || o.set(e, [r]);
  }, off: function(e, r) {
    var t = o.get(e);
    t && t.splice(t.indexOf(r) >>> 0, 1);
  }, emit: function(e, r) {
    (o.get(e) || []).slice().map(function(t) {
      t(r);
    }), (o.get("*") || []).slice().map(function(t) {
      t(e, r);
    });
  } };
}
var uD = function() {
  var o;
  return (o = { props: { emitter: { type: Object, required: !1, default: function() {
    return cD();
  } } }, provide: function() {
    var e;
    return (e = {}).instantSearchPanelEmitter = this.emitter, e;
  }, data: function() {
    return { canRefine: !0 };
  }, created: function() {
    var e = this;
    this.emitter.on("PANEL_CHANGE_EVENT", function(r) {
      e.updateCanRefine(r);
    });
  } }).beforeUnmount = function() {
    this.emitter.all.clear();
  }, o.methods = { updateCanRefine: function(e) {
    this.canRefine = e;
  } }, o;
}, wo = function(o) {
  o === void 0 && (o = {});
  var e = o.mapStateToCanRefine;
  return e === void 0 && (e = function(r) {
    return !!r.canRefine;
  }), { inject: { emitter: { from: "instantSearchPanelEmitter", default: function() {
    return { emit: function() {
    } };
  } } }, data: function() {
    return { state: null, hasAlreadyEmitted: !1 };
  }, watch: { state: { immediate: !0, handler: function(r, t) {
    if (r) {
      var n = e(t || {}), a = e(r);
      this.hasAlreadyEmitted && n === a || (this.emitter.emit("PANEL_CHANGE_EVENT", a), this.hasAlreadyEmitted = !0);
    }
  } } } };
};
xe({ connector: Ok }, { $$widgetType: "ais.breadcrumb" }), wo(), Pe({ name: "Breadcrumb" });
xe({ connector: Hw }, { $$widgetType: "ais.clearRefinements" }), wo(), Pe({ name: "ClearRefinements" });
const pF = { inheritAttrs: !1, name: "AisConfigure", mixins: [Pe({ name: "Configure" }), xe({ connector: G1 }, { $$widgetType: "ais.configure" })], computed: { widgetParams: function() {
  return { searchParameters: Object.assign({}, this.$attrs) };
} }, render: Ga(function(o) {
  var e = this.$slots.default;
  return this.state && e ? o("div", { class: this.suit() }, [e({ refine: this.state.refine, searchParameters: this.state.widgetParams.searchParameters })]) : null;
}) };
xe({ connector: lD }, { $$widgetType: "ais.configureRelatedItems" });
Pe({ name: "CurrentRefinements" }), xe({ connector: _w }, { $$widgetType: "ais.currentRefinements" }), wo();
Pe({ name: "HierarchicalMenu" }), xe({ connector: d4 }, { $$widgetType: "ais.hierarchicalMenu" }), wo();
function ei() {
  return ei = Object.assign ? Object.assign.bind() : function(o) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var t in r) ({}).hasOwnProperty.call(r, t) && (o[t] = r[t]);
    }
    return o;
  }, ei.apply(null, arguments);
}
function pD(o, e) {
  if (o == null) return {};
  var r = {};
  for (var t in o) if ({}.hasOwnProperty.call(o, t)) {
    if (e.indexOf(t) !== -1) continue;
    r[t] = o[t];
  }
  return r;
}
function dF(o, e) {
  if (o == null) return {};
  var r, t, n = pD(o, e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(o);
    for (t = 0; t < a.length; t++) r = a[t], e.indexOf(r) === -1 && {}.propertyIsEnumerable.call(o, r) && (n[r] = o[r]);
  }
  return n;
}
function $o() {
  for (var o = arguments.length, e = new Array(o), r = 0; r < o; r++)
    e[r] = arguments[r];
  return e.reduce(function(t, n) {
    return Array.isArray(n) ? t.concat(n) : t.concat([n]);
  }, []).filter(Boolean).join(" ");
}
var dD = ["parts", "highlightedTagName", "nonHighlightedTagName", "separator", "className", "classNames"];
function gD(o) {
  var e = o.createElement;
  return function(t) {
    var n = t.classNames, a = t.children, s = t.highlightedTagName, i = t.isHighlighted, l = t.nonHighlightedTagName, c = i ? s : l;
    return e(c, {
      className: i ? n.highlighted : n.nonHighlighted
    }, a);
  };
}
function mD(o) {
  var e = o.createElement, r = o.Fragment, t = gD({
    createElement: e
  });
  return function(a) {
    var s = a.parts, i = a.highlightedTagName, l = i === void 0 ? "mark" : i, c = a.nonHighlightedTagName, u = c === void 0 ? "span" : c, f = a.separator, g = f === void 0 ? ", " : f, d = a.className, p = a.classNames, m = p === void 0 ? {} : p, y = dF(a, dD);
    return e("span", ei({}, y, {
      className: $o(m.root, d)
    }), s.map(function(h, F) {
      var b = F === s.length - 1;
      return e(r, {
        key: F
      }, h.map(function(v, P) {
        return e(t, {
          key: P,
          classNames: m,
          highlightedTagName: l,
          nonHighlightedTagName: u,
          isHighlighted: v.isHighlighted
        }, v.value);
      }), !b && e("span", {
        className: m.separator
      }, g));
    }));
  };
}
var fD = ["classNames", "hits", "itemComponent", "sendEvent", "emptyComponent", "banner", "bannerComponent"];
function yD(o) {
  var e = o.createElement;
  return function(t) {
    var n = t.classNames, a = t.banner;
    return a.image.urls[0].url ? e("aside", {
      className: $o("ais-Hits-banner", n.bannerRoot)
    }, a.link ? e("a", {
      className: $o("ais-Hits-banner-link", n.bannerLink),
      href: a.link.url,
      target: a.link.target
    }, e("img", {
      className: $o("ais-Hits-banner-image", n.bannerImage),
      src: a.image.urls[0].url,
      alt: a.image.title
    })) : e("img", {
      className: $o("ais-Hits-banner-image", n.bannerImage),
      src: a.image.urls[0].url,
      alt: a.image.title
    })) : null;
  };
}
function hD(o) {
  var e = o.createElement, r = yD({
    createElement: e
  });
  return function(n) {
    var a = n.classNames, s = a === void 0 ? {} : a, i = n.hits, l = n.itemComponent, c = n.sendEvent, u = n.emptyComponent, f = n.banner, g = n.bannerComponent, d = dF(n, fD);
    return e("div", ei({}, d, {
      className: $o("ais-Hits", s.root, i.length === 0 && $o("ais-Hits--empty", s.emptyRoot), d.className)
    }), f && (g ? e(g, {
      className: $o("ais-Hits-banner", s.bannerRoot),
      banner: f
    }) : e(r, {
      classNames: s,
      banner: f
    })), i.length === 0 && u ? e(u, null) : e("ol", {
      className: $o("ais-Hits-list", s.list)
    }, i.map(function(p, m) {
      return e(l, {
        key: p.objectID,
        hit: p,
        index: m,
        className: $o("ais-Hits-item", s.item),
        onClick: function() {
          c("click:internal", p, "Hit Clicked");
        },
        onAuxClick: function() {
          c("click:internal", p, "Hit Clicked");
        }
      });
    })));
  };
}
var gF = function(o, e, r) {
  if (!r) return tt(o, e);
  if (o === ye) return tt(o, Array.isArray(r) ? r : [r]);
  var t = typeof r == "string" ? { default: function() {
    return r;
  } } : r, n = typeof o == "string" ? e : Object.assign(e, { children: r });
  return tt(o, n, t);
}, FD = mD({ createElement: gF, Fragment: ye });
const bD = { name: "AisHighlighter", props: { hit: { type: Object, required: !0 }, attribute: { type: String, required: !0 }, highlightedTagName: { type: String, default: "mark" }, suit: { type: Function, required: !0 }, highlightProperty: { type: String, required: !0 }, preTag: { type: String, required: !0 }, postTag: { type: String, required: !0 } }, render: function() {
  var o = rn(this.hit[this.highlightProperty], this.attribute) || [], e = (Array.isArray(o) ? o : [o]).map(function(r) {
    return Cp(D1(r.value || "")).map(function(t) {
      var n = t.value;
      return { value: n === " " ? "  " : n, isHighlighted: t.isHighlighted };
    });
  });
  return gF(FD, { classNames: { root: this.suit(), highlighted: this.suit("highlighted") }, highlightedTagName: this.highlightedTagName, nonHighlightedTagName: ye, parts: e });
} }, Ua = { name: "AisHighlight", mixins: [Pe({ name: "Highlight" })], components: { AisHighlighter: bD }, props: { hit: { type: Object, required: !0 }, attribute: { type: String, required: !0 }, highlightedTagName: { type: String, default: "mark" } } };
function vD(o, e, r, t, n, a) {
  var s = hh("ais-highlighter");
  return k(), R(s, { hit: r.hit, attribute: r.attribute, "highlighted-tag-name": r.highlightedTagName, suit: o.suit, "highlight-property": "_highlightResult", "pre-tag": "<mark>", "post-tag": "</mark>" }, null, 8, ["hit", "attribute", "highlighted-tag-name", "suit"]);
}
Ua.render = vD;
const BD = { name: "AisHits", mixins: [xe({ connector: A4 }, { $$widgetType: "ais.hits" }), Pe({ name: "Hits" })], props: { showBanner: { type: Boolean, default: !0 }, escapeHTML: { type: Boolean, default: !0 }, transformItems: { type: Function, default: void 0 } }, computed: { widgetParams: function() {
  return { showBanner: this.showBanner, escapeHTML: this.escapeHTML, transformItems: this.transformItems };
} }, render: Ga(function(o) {
  var e = this;
  if (!this.state) return null;
  var r = sl(this, "default"), t = sl(this, "item"), n = sl(this, "banner");
  return t || n || !r ? o(hD({ createElement: o }), { hits: this.state.items, itemComponent: function(a) {
    var s = a.hit, i = a.index, l = a.onClick, c = a.onAuxClick, u = (a.key, function(f, g) {
      var d = {};
      for (var p in f) Object.prototype.hasOwnProperty.call(f, p) && g.indexOf(p) === -1 && (d[p] = f[p]);
      return d;
    }(a, ["hit", "index", "onClick", "onAuxClick", "key"]));
    return o("li", { key: s.objectID, attrs: u, on: { click: l, auxclick: c } }, [t && t({ item: s, index: i, insights: e.state.insights, sendEvent: e.state.sendEvent }) || "objectID: " + s.objectID + ", index: " + i]);
  }, banner: this.showBanner ? this.state.banner : void 0, bannerComponent: n, sendEvent: this.state.sendEvent, classNames: this.classNames && { root: this.classNames["ais-Hits"], list: this.classNames["ais-Hits-list"], item: this.classNames["ais-Hits-item"], bannerRoot: this.classNames["ais-Hits-banner"], bannerImage: this.classNames["ais-Hits-banner-image"], bannerLink: this.classNames["ais-Hits-banner-link"] } }) : o("div", { attrs: { class: this.suit() } }, [r({ banner: this.state.banner, items: this.state.items, insights: this.state.insights, sendEvent: this.state.sendEvent })]);
}) };
Pe({ name: "HitsPerPage" }), xe({ connector: W4 }, { $$widgetType: "ais.hitsPerPage" }), wo();
function ba(o) {
  "@babel/helpers - typeof";
  return ba = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, ba(o);
}
var PD = ["initialSearchParameters"], wD = ["initialRecommendParameters"];
function tf(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function Jo(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? tf(Object(r), !0).forEach(function(t) {
      Nt(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : tf(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function Nt(o, e, r) {
  return e = kD(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function kD(o) {
  var e = DD(o, "string");
  return ba(e) == "symbol" ? e : String(e);
}
function DD(o, e) {
  if (ba(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (ba(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
function mF(o) {
  return xD(o) || ED(o) || AD(o) || SD();
}
function SD() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function AD(o, e) {
  if (o) {
    if (typeof o == "string") return Au(o, e);
    var r = Object.prototype.toString.call(o).slice(8, -1);
    if (r === "Object" && o.constructor && (r = o.constructor.name), r === "Map" || r === "Set") return Array.from(o);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Au(o, e);
  }
}
function ED(o) {
  if (typeof Symbol < "u" && o[Symbol.iterator] != null || o["@@iterator"] != null) return Array.from(o);
}
function xD(o) {
  if (Array.isArray(o)) return Au(o);
}
function Au(o, e) {
  (e == null || e > o.length) && (e = o.length);
  for (var r = 0, t = new Array(e); r < e; r++) t[r] = o[r];
  return t;
}
function fF(o, e) {
  if (o == null) return {};
  var r = CD(o, e), t, n;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(o);
    for (n = 0; n < a.length; n++)
      t = a[n], !(e.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(o, t) && (r[t] = o[t]);
  }
  return r;
}
function CD(o, e) {
  if (o == null) return {};
  var r = {}, t = Object.keys(o), n, a;
  for (a = 0; a < t.length; a++)
    n = t[a], !(e.indexOf(n) >= 0) && (r[n] = o[n]);
  return r;
}
var pn = Te({
  name: "index-widget"
});
function yF(o, e) {
  var r = e.state, t = e.recommendState, n = e.isPageReset, a = e._uiState;
  r !== o.state && (o.state = r, o.emit("change", {
    state: o.state,
    results: o.lastResults,
    isPageReset: n,
    _uiState: a
  })), t !== o.recommendState && (o.recommendState = t);
}
function dn(o, e) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  return o.reduce(function(t, n) {
    return Bo(n) || !n.getWidgetUiState && !n.getWidgetState ? t : n.getWidgetUiState ? n.getWidgetUiState(t, e) : n.getWidgetState(t, e);
  }, r);
}
function gn(o, e) {
  var r = e.initialSearchParameters, t = fF(e, PD);
  return o.reduce(function(n, a) {
    return !a.getWidgetSearchParameters || Bo(a) ? n : a.dependsOn === "search" && a.getWidgetParameters ? a.getWidgetParameters(n, t) : a.getWidgetSearchParameters(n, t);
  }, r);
}
function nf(o, e) {
  var r = e.initialRecommendParameters, t = fF(e, wD);
  return o.reduce(function(n, a) {
    return !Bo(a) && a.dependsOn === "recommend" && a.getWidgetParameters ? a.getWidgetParameters(n, t) : n;
  }, r);
}
function hF(o) {
  var e = o.filter(Bo);
  e.length !== 0 && e.forEach(function(r) {
    var t = r.getHelper();
    yF(t, {
      state: t.state.resetPage(),
      recommendState: t.recommendState,
      isPageReset: !0
    }), hF(r.getWidgets());
  });
}
function FF(o) {
  var e = o.filter(Bo);
  return e.reduce(function(r, t) {
    return r.concat.apply(r, [{
      indexId: t.getIndexId(),
      results: t.getResults(),
      helper: t.getHelper()
    }].concat(mF(FF(t.getWidgets()))));
  }, []);
}
var bF = function(e) {
  if (e === void 0 || e.indexName === void 0)
    throw new Error(pn("The `indexName` option is required."));
  var r = e.indexName, t = e.indexId, n = t === void 0 ? r : t, a = [], s = {}, i = null, l = null, c = null, u = null, f = null, g = !1, d = !1;
  return {
    $$type: "ais.index",
    $$widgetType: "ais.index",
    getIndexName: function() {
      return r;
    },
    getIndexId: function() {
      return n;
    },
    getHelper: function() {
      return c;
    },
    getResults: function() {
      var m;
      return (m = u) !== null && m !== void 0 && m.lastResults ? (u.lastResults._state = c.state, u.lastResults) : null;
    },
    getResultsForWidget: function(m) {
      var y;
      return m.dependsOn !== "recommend" || Bo(m) || m.$$id === void 0 ? this.getResults() : (y = c) !== null && y !== void 0 && y.lastRecommendResults ? c.lastRecommendResults[m.$$id] : null;
    },
    getPreviousState: function() {
      return f;
    },
    getScopedResults: function() {
      var m = this.getParent(), y;
      return m ? y = m.getWidgets() : r.length === 0 ? y = this.getWidgets() : y = [this], FF(y);
    },
    getParent: function() {
      return l;
    },
    createURL: function(m) {
      return typeof m == "function" ? i._createURL(Nt({}, n, m(s))) : i._createURL(Nt({}, n, dn(a, {
        searchParameters: m,
        helper: c
      })));
    },
    getWidgets: function() {
      return a;
    },
    addWidgets: function(m) {
      var y = this;
      if (!Array.isArray(m))
        throw new Error(pn("The `addWidgets` method expects an array of widgets."));
      if (m.some(function(h) {
        return typeof h.init != "function" && typeof h.render != "function";
      }))
        throw new Error(pn("The widget definition expects a `render` and/or an `init` method."));
      return m.forEach(function(h) {
        Bo(h) || (i && h.dependsOn === "recommend" ? i._hasRecommendWidget = !0 : i ? i._hasSearchWidget = !0 : h.dependsOn === "recommend" ? g = !0 : d = !0, mB(h));
      }), a = a.concat(m), i && m.length && (yF(c, {
        state: gn(a, {
          uiState: s,
          initialSearchParameters: c.state
        }),
        recommendState: nf(a, {
          uiState: s,
          initialRecommendParameters: c.recommendState
        }),
        _uiState: s
      }), m.forEach(function(h) {
        if (h.getRenderState) {
          var F = h.getRenderState(i.renderState[y.getIndexId()] || {}, hn(i, y, i._initialUiState));
          Zl({
            renderState: F,
            instantSearchInstance: i,
            parent: y
          });
        }
      }), m.forEach(function(h) {
        h.init && h.init(hn(i, y, i._initialUiState));
      }), i.scheduleSearch()), this;
    },
    removeWidgets: function(m) {
      var y = this;
      if (!Array.isArray(m))
        throw new Error(pn("The `removeWidgets` method expects an array of widgets."));
      if (m.some(function(P) {
        return typeof P.dispose != "function";
      }))
        throw new Error(pn("The widget definition expects a `dispose` method."));
      if (a = a.filter(function(P) {
        return m.indexOf(P) === -1;
      }), a.forEach(function(P) {
        Bo(P) || (i && P.dependsOn === "recommend" ? i._hasRecommendWidget = !0 : i ? i._hasSearchWidget = !0 : P.dependsOn === "recommend" ? g = !0 : d = !0);
      }), i && m.length) {
        var h = m.reduce(function(P, E) {
          var S = E.dispose({
            helper: c,
            state: P.cleanedSearchState,
            recommendState: P.cleanedRecommendState,
            parent: y
          });
          return S instanceof so.RecommendParameters ? P.cleanedRecommendState = S : S && (P.cleanedSearchState = S), P;
        }, {
          cleanedSearchState: c.state,
          cleanedRecommendState: c.recommendState
        }), F = h.cleanedSearchState, b = h.cleanedRecommendState, v = i.future.preserveSharedStateOnUnmount ? gn(a, {
          uiState: s,
          initialSearchParameters: new so.SearchParameters({
            index: this.getIndexName()
          })
        }) : gn(a, {
          uiState: dn(a, {
            searchParameters: F,
            helper: c
          }),
          initialSearchParameters: F
        });
        s = dn(a, {
          searchParameters: v,
          helper: c
        }), c.setState(v), c.recommendState = b, a.length && i.scheduleSearch();
      }
      return this;
    },
    init: function(m) {
      var y = this, h, F = m.instantSearchInstance, b = m.parent, v = m.uiState;
      if (c === null) {
        i = F, l = b, s = v[n] || {};
        var P = F.mainHelper, E = gn(a, {
          uiState: s,
          initialSearchParameters: new so.SearchParameters({
            index: r
          })
        }), S = nf(a, {
          uiState: s,
          initialRecommendParameters: new so.RecommendParameters()
        });
        c = so({}, E.index, E), c.recommendState = S, c.search = function() {
          return F.onStateChange ? (F.onStateChange({
            uiState: F.mainIndex.getWidgetUiState({}),
            setUiState: function(x) {
              return F.setUiState(x, !1);
            }
          }), P) : P.search();
        }, c.searchWithoutTriggeringOnStateChange = function() {
          return P.search();
        }, c.searchForFacetValues = function(C, x, T, M) {
          var V = c.state.setQueryParameters(M);
          return P.searchForFacetValues(C, x, T, V);
        }, u = P.derive(function() {
          return An.apply(void 0, [P.state].concat(mF(QP(y))));
        }, function() {
          return y.getHelper().recommendState;
        });
        var D = (h = F._initialResults) === null || h === void 0 ? void 0 : h[this.getIndexId()];
        if (D != null && D.results) {
          var w = new so.SearchResults(new so.SearchParameters(D.state), D.results);
          u.lastResults = w, c.lastResults = w;
        }
        if (D != null && D.recommendResults) {
          var A = new so.RecommendResults(new so.RecommendParameters({
            params: D.recommendResults.params
          }), D.recommendResults.results);
          u.lastRecommendResults = A, c.lastRecommendResults = A;
        }
        c.on("change", function(C) {
          var x = C.isPageReset;
          x && hF(a);
        }), u.on("search", function() {
          F.scheduleStalledRender(), process.env.NODE_ENV === "development" && B1({
            index: y,
            indexUiState: s
          });
        }), u.on("result", function(C) {
          var x = C.results;
          F.scheduleRender(), c.lastResults = x, f = x == null ? void 0 : x._state;
        }), u.on("recommend:result", function(C) {
          var x = C.recommend;
          F.scheduleRender(), c.lastRecommendResults = x.results;
        }), a.forEach(function(C) {
          if (C.getRenderState) {
            var x = C.getRenderState(F.renderState[y.getIndexId()] || {}, hn(F, y, v));
            Zl({
              renderState: x,
              instantSearchInstance: F,
              parent: y
            });
          }
        }), a.forEach(function(C) {
          process.env.NODE_ENV === "development" && de(
            // if it has NO getWidgetState or if it has getWidgetUiState, we don't warn
            // aka we warn if there's _only_ getWidgetState
            !C.getWidgetState || !!C.getWidgetUiState,
            "The `getWidgetState` method is renamed `getWidgetUiState` and will no longer exist under that name in InstantSearch.js 5.x. Please use `getWidgetUiState` instead."
          ), C.init && C.init(hn(F, y, v));
        }), c.on("change", function(C) {
          var x = C.state, T = C._uiState;
          s = dn(a, {
            searchParameters: x,
            helper: c
          }, T || {}), F.onStateChange || F.onInternalStateChange();
        }), D && F.scheduleRender(), g && (F._hasRecommendWidget = !0), d && (F._hasSearchWidget = !0);
      }
    },
    render: function(m) {
      var y, h = this, F = m.instantSearchInstance;
      F.status === "error" && !F.mainHelper.hasPendingRequests() && f && c.setState(f);
      var b = this.getResults() || (y = u) !== null && y !== void 0 && y.lastRecommendResults ? a : a.filter(Bo);
      b = b.filter(function(v) {
        return v.shouldRender ? v.shouldRender({
          instantSearchInstance: F
        }) : !0;
      }), b.forEach(function(v) {
        if (v.getRenderState) {
          var P = v.getRenderState(F.renderState[h.getIndexId()] || {}, wg(F, h, v));
          Zl({
            renderState: P,
            instantSearchInstance: F,
            parent: h
          });
        }
      }), b.forEach(function(v) {
        v.render && v.render(wg(F, h, v));
      });
    },
    dispose: function() {
      var m = this, y, h;
      a.forEach(function(F) {
        F.dispose && c && F.dispose({
          helper: c,
          state: c.state,
          recommendState: c.recommendState,
          parent: m
        });
      }), i = null, l = null, (y = c) === null || y === void 0 || y.removeAllListeners(), c = null, (h = u) === null || h === void 0 || h.detach(), u = null;
    },
    getWidgetUiState: function(m) {
      return a.filter(Bo).reduce(function(y, h) {
        return h.getWidgetUiState(y);
      }, Jo(Jo({}, m), {}, Nt({}, n, Jo(Jo({}, m[n]), s))));
    },
    getWidgetState: function(m) {
      return process.env.NODE_ENV === "development" && de(!1, "The `getWidgetState` method is renamed `getWidgetUiState` and will no longer exist under that name in InstantSearch.js 5.x. Please use `getWidgetUiState` instead."), this.getWidgetUiState(m);
    },
    getWidgetSearchParameters: function(m, y) {
      var h = y.uiState;
      return gn(a, {
        uiState: h,
        initialSearchParameters: m
      });
    },
    refreshUiState: function() {
      s = dn(a, {
        searchParameters: this.getHelper().state,
        helper: this.getHelper()
      }, s);
    },
    setIndexUiState: function(m) {
      var y = typeof m == "function" ? m(s) : m;
      i.setUiState(function(h) {
        return Jo(Jo({}, h), {}, Nt({}, n, y));
      });
    }
  };
};
function Zl(o) {
  var e = o.renderState, r = o.instantSearchInstance, t = o.parent, n = t ? t.getIndexId() : r.mainIndex.getIndexId();
  r.renderState = Jo(Jo({}, r.renderState), {}, Nt({}, n, Jo(Jo({}, r.renderState[n]), e)));
}
Pe({ name: "Index" }), xe({ connector: function() {
  return bF;
} }, { $$widgetType: "ais.index" });
var OD = "ais", xi = function(e) {
  return function() {
    var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = r.descendantName, n = r.modifierName, a = t ? "-".concat(t) : "", s = n ? "--".concat(n) : "";
    return "".concat(OD, "-").concat(e).concat(a).concat(s);
  };
}, TD = xi("Highlight");
function vF(o) {
  var e = o.attribute, r = o.highlightedTagName, t = r === void 0 ? "mark" : r, n = o.hit, a = o.cssClasses, s = a === void 0 ? {} : a;
  process.env.NODE_ENV === "development" && de(!1, "`instantsearch.highlight` function has been deprecated. It is still supported in 4.x releases, but not further. It is replaced by the `Highlight` component.\n\nFor more information, visit https://www.algolia.com/doc/guides/building-search-ui/upgrade-guides/js/?client=html+tagged+templates#upgrade-templates");
  var i = rn(n._highlightResult, e);
  process.env.NODE_ENV === "development" && de(i, 'Could not enable highlight for "'.concat(e, `", will display an empty string.
Please check whether this attribute exists and is either searchable or specified in \`attributesToHighlight\`.

See: https://alg.li/highlighting
`));
  var l = i || {}, c = l.value, u = c === void 0 ? "" : c, f = TD({
    descendantName: "highlighted"
  }) + (s.highlighted ? " ".concat(s.highlighted) : "");
  return u.replace(new RegExp(io.highlightPreTag, "g"), "<".concat(t, ' class="').concat(f, '">')).replace(new RegExp(io.highlightPostTag, "g"), "</".concat(t, ">"));
}
var LD = xi("ReverseHighlight");
function BF(o) {
  var e = o.attribute, r = o.highlightedTagName, t = r === void 0 ? "mark" : r, n = o.hit, a = o.cssClasses, s = a === void 0 ? {} : a;
  process.env.NODE_ENV === "development" && de(!1, "`instantsearch.reverseHighlight` function has been deprecated. It is still supported in 4.x releases, but not further. It is replaced by the `ReverseHighlight` component.\n\nFor more information, visit https://www.algolia.com/doc/guides/building-search-ui/upgrade-guides/js/?client=html+tagged+templates#upgrade-templates");
  var i = rn(n._highlightResult, e);
  process.env.NODE_ENV === "development" && de(i, 'Could not enable reverse highlight for "'.concat(e, `", will display an empty string.
Please check whether this attribute exists and is either searchable or specified in \`attributesToHighlight\`.

See: https://alg.li/highlighting
`));
  var l = i || {}, c = l.value, u = c === void 0 ? "" : c, f = LD({
    descendantName: "highlighted"
  }) + (s.highlighted ? " ".concat(s.highlighted) : ""), g = x1(M1(Cp(u)));
  return g.replace(new RegExp(io.highlightPreTag, "g"), "<".concat(t, ' class="').concat(f, '">')).replace(new RegExp(io.highlightPostTag, "g"), "</".concat(t, ">"));
}
var jD = xi("Snippet");
function PF(o) {
  var e = o.attribute, r = o.highlightedTagName, t = r === void 0 ? "mark" : r, n = o.hit, a = o.cssClasses, s = a === void 0 ? {} : a;
  process.env.NODE_ENV === "development" && de(!1, "`instantsearch.snippet` function has been deprecated. It is still supported in 4.x releases, but not further. It is replaced by the `Snippet` component.\n\nFor more information, visit https://www.algolia.com/doc/guides/building-search-ui/upgrade-guides/js/?client=html+tagged+templates#upgrade-templates");
  var i = rn(n._snippetResult, e);
  process.env.NODE_ENV === "development" && de(i, 'Could not enable snippet for "'.concat(e, `", will display an empty string.
Please check whether this attribute exists and is specified in \`attributesToSnippet\`.

See: https://alg.li/highlighting
`));
  var l = i || {}, c = l.value, u = c === void 0 ? "" : c, f = jD({
    descendantName: "highlighted"
  }) + (s.highlighted ? " ".concat(s.highlighted) : "");
  return u.replace(new RegExp(io.highlightPreTag, "g"), "<".concat(t, ' class="').concat(f, '">')).replace(new RegExp(io.highlightPostTag, "g"), "</".concat(t, ">"));
}
var MD = xi("ReverseSnippet");
function wF(o) {
  var e = o.attribute, r = o.highlightedTagName, t = r === void 0 ? "mark" : r, n = o.hit, a = o.cssClasses, s = a === void 0 ? {} : a;
  process.env.NODE_ENV === "development" && de(!1, "`instantsearch.reverseSnippet` function has been deprecated. It is still supported in 4.x releases, but not further. It is replaced by the `ReverseSnippet` component.\n\nFor more information, visit https://www.algolia.com/doc/guides/building-search-ui/upgrade-guides/js/?client=html+tagged+templates#upgrade-templates");
  var i = rn(n._snippetResult, e);
  process.env.NODE_ENV === "development" && de(i, 'Could not enable reverse snippet for "'.concat(e, `", will display an empty string.
Please check whether this attribute exists and is specified in \`attributesToSnippet\`.

See: https://alg.li/highlighting
`));
  var l = i || {}, c = l.value, u = c === void 0 ? "" : c, f = MD({
    descendantName: "highlighted"
  }) + (s.highlighted ? " ".concat(s.highlighted) : ""), g = x1(M1(Cp(u)));
  return g.replace(new RegExp(io.highlightPreTag, "g"), "<".concat(t, ' class="').concat(f, '">')).replace(new RegExp(io.highlightPostTag, "g"), "</".concat(t, ">"));
}
function Eu(o) {
  "@babel/helpers - typeof";
  return Eu = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Eu(o);
}
var WD = "_ALGOLIA";
function ND(o) {
  if (!((typeof document > "u" ? "undefined" : Eu(document)) !== "object" || typeof document.cookie != "string"))
    for (var e = "".concat(o, "="), r = document.cookie.split(";"), t = 0; t < r.length; t++) {
      for (var n = r[t]; n.charAt(0) === " "; )
        n = n.substring(1);
      if (n.indexOf(e) === 0)
        return n.substring(e.length, n.length);
    }
}
function kF() {
  return ND(WD);
}
function VD() {
  return process.env.NODE_ENV === "development" && de(!1, "`getInsightsAnonymousUserToken` function has been deprecated. It is still supported in 4.x releases, but not further. It is replaced by the `insights` middleware.\n\nFor more information, visit https://www.algolia.com/doc/guides/getting-insights-and-analytics/search-analytics/click-through-and-conversions/how-to/send-click-and-conversion-events-with-instantsearch/js/"), kF();
}
var zD = ["page"];
function ID(o, e) {
  if (o == null) return {};
  var r = RD(o, e), t, n;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(o);
    for (n = 0; n < a.length; n++)
      t = a[n], !(e.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(o, t) && (r[t] = o[t]);
  }
  return r;
}
function RD(o, e) {
  if (o == null) return {};
  var r = {}, t = Object.keys(o), n, a;
  for (a = 0; a < t.length; a++)
    n = t[a], !(e.indexOf(n) >= 0) && (r[n] = o[n]);
  return r;
}
function af(o) {
  var e = o || {};
  e.page;
  var r = ID(e, zD);
  return r;
}
function HD() {
  var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, e = o.key, r = ["ais.infiniteHits", e].filter(Boolean).join(":");
  return {
    read: function(n) {
      var a = n.state, s = _o(function(l) {
        var c = l.window;
        return c.sessionStorage;
      });
      if (!s)
        return null;
      try {
        var i = JSON.parse(
          // @ts-expect-error JSON.parse() requires a string, but it actually accepts null, too.
          s.getItem(r)
        );
        return i && yt(i.state, af(a)) ? i.hits : null;
      } catch (l) {
        if (l instanceof SyntaxError)
          try {
            s.removeItem(r);
          } catch {
          }
        return null;
      }
    },
    write: function(n) {
      var a = n.state, s = n.hits, i = _o(function(l) {
        var c = l.window;
        return c.sessionStorage;
      });
      if (i)
        try {
          i.setItem(r, JSON.stringify({
            state: af(a),
            hits: s
          }));
        } catch {
        }
    }
  };
}
var YD = Mp();
const qD = /* @__PURE__ */ qr(YD);
function GD() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(o) {
    var e = Math.random() * 16 | 0, r = o === "x" ? e : e & 3 | 8;
    return r.toString(16);
  });
}
function va(o) {
  "@babel/helpers - typeof";
  return va = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, va(o);
}
function sf(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function Jr(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? sf(Object(r), !0).forEach(function(t) {
      XD(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : sf(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function XD(o, e, r) {
  return e = UD(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function UD(o) {
  var e = ZD(o, "string");
  return va(e) == "symbol" ? e : String(e);
}
function ZD(o, e) {
  if (va(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (va(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
function Ar(o, e) {
  return JD(o) || QD(o, e) || DF(o, e) || KD();
}
function KD() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function QD(o, e) {
  var r = o == null ? null : typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (r != null) {
    var t, n, a, s, i = [], l = !0, c = !1;
    try {
      if (a = (r = r.call(o)).next, e === 0) {
        if (Object(r) !== r) return;
        l = !1;
      } else for (; !(l = (t = a.call(r)).done) && (i.push(t.value), i.length !== e); l = !0) ;
    } catch (u) {
      c = !0, n = u;
    } finally {
      try {
        if (!l && r.return != null && (s = r.return(), Object(s) !== s)) return;
      } finally {
        if (c) throw n;
      }
    }
    return i;
  }
}
function JD(o) {
  if (Array.isArray(o)) return o;
}
function _D(o) {
  return o9(o) || e9(o) || DF(o) || $D();
}
function $D() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function DF(o, e) {
  if (o) {
    if (typeof o == "string") return xu(o, e);
    var r = Object.prototype.toString.call(o).slice(8, -1);
    if (r === "Object" && o.constructor && (r = o.constructor.name), r === "Map" || r === "Set") return Array.from(o);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return xu(o, e);
  }
}
function e9(o) {
  if (typeof Symbol < "u" && o[Symbol.iterator] != null || o["@@iterator"] != null) return Array.from(o);
}
function o9(o) {
  if (Array.isArray(o)) return xu(o);
}
function xu(o, e) {
  (e == null || e > o.length) && (e = o.length);
  for (var r = 0, t = new Array(e); r < e; r++) t[r] = o[r];
  return t;
}
var SF = "2.17.2", r9 = "https://cdn.jsdelivr.net/npm/search-insights@".concat(SF, "/dist/search-insights.min.js");
function lf() {
  var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, e = o.insightsClient, r = o.insightsInitParams, t = o.onEvent, n = o.$$internal, a = n === void 0 ? !1 : n, s = o.$$automatic, i = s === void 0 ? !1 : s, l = e;
  !e && e !== null && _o(function(u) {
    var f = u.window, g = f.AlgoliaAnalyticsObject || "aa";
    typeof g == "string" && (l = f[g]), l || (f.AlgoliaAnalyticsObject = g, f[g] || (f[g] = function() {
      f[g].queue || (f[g].queue = []);
      for (var d = arguments.length, p = new Array(d), m = 0; m < d; m++)
        p[m] = arguments[m];
      f[g].queue.push(p);
    }, f[g].version = SF, f[g].shouldAddScript = !0), l = f[g]);
  });
  var c = l || Fe;
  return function(u) {
    var f = u.instantSearchInstance, g = f.middleware.filter(function(w) {
      return w.instance.$$type === "ais.insights" && w.instance.$$internal;
    }).map(function(w) {
      return w.creator;
    });
    f.unuse.apply(f, _D(g));
    var d = aP(f.client), p = Ar(d, 2), m = p[0], y = p[1];
    process.env.NODE_ENV === "development" && de(!!(m && y), "could not extract Algolia credentials from searchClient in insights middleware.");
    var h = void 0, F = void 0, b = void 0, v = c.queue;
    if (Array.isArray(v)) {
      var P = ["setUserToken", "init"].map(function(w) {
        var A = fr(v.slice().reverse(), function(T) {
          var M = Ar(T, 1), V = M[0];
          return V === w;
        }) || [], C = Ar(A, 2), x = C[1];
        return x;
      }), E = Ar(P, 2);
      F = E[0], h = E[1];
    }
    c("getUserToken", null, function(w, A) {
      b = uf(A);
    }), (r || !cf(c)) && c("init", Jr({
      appId: m,
      apiKey: y,
      partial: !0
    }, r));
    var S, D;
    return {
      $$type: "ais.insights",
      $$internal: a,
      $$automatic: i,
      onStateChange: function() {
      },
      subscribe: function() {
        if (c.shouldAddScript) {
          var A = "[insights middleware]: could not load search-insights.js. Please load it manually following https://alg.li/insights-init";
          try {
            var C = document.createElement("script");
            C.async = !0, C.src = r9, C.onerror = function() {
              f.emit("error", new Error(A));
            }, document.body.appendChild(C), c.shouldAddScript = !1;
          } catch {
            c.shouldAddScript = !1, f.emit("error", new Error(A));
          }
        }
      },
      started: function() {
        c("addAlgoliaAgent", "insights-middleware"), D = f.mainHelper;
        var A = c.queue;
        if (Array.isArray(A)) {
          var C = ["setUserToken", "init"].map(function(U) {
            var Z = fr(A.slice().reverse(), function(ge) {
              var Ae = Ar(ge, 1), ke = Ae[0];
              return ke === U;
            }) || [], Q = Ar(Z, 2), oe = Q[1];
            return oe;
          }), x = Ar(C, 2);
          F = x[0], h = x[1];
        }
        S = t9(f), i || D.overrideStateWithoutTriggeringChangeEvent(Jr(Jr({}, D.state), {}, {
          clickAnalytics: !0
        })), a || f.scheduleSearch();
        var T = function(Z) {
          var Q = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, oe = uf(Z);
          if (!oe)
            return;
          var ge = D.state.userToken;
          function Ae() {
            D.overrideStateWithoutTriggeringChangeEvent(Jr(Jr({}, D.state), {}, {
              userToken: oe
            })), ge && ge !== Z && f.scheduleSearch();
          }
          Q ? Ae() : setTimeout(Ae, 0);
        };
        function M(U) {
          T(U, !0), c("setUserToken", U);
        }
        var V = void 0, G = kF();
        if (G)
          V = G;
        else {
          var L = "anonymous-".concat(GD());
          V = L;
        }
        var W, Y = S.userToken;
        if (r != null && r.userToken && (W = r.userToken), W)
          M(W);
        else if (Y)
          M(Y);
        else if (b)
          M(b);
        else if (F)
          M(F);
        else if (V) {
          var X;
          if (M(V), r != null && r.useCookie || (X = h) !== null && X !== void 0 && X.useCookie) {
            var J;
            n9(V, (r == null ? void 0 : r.cookieDuration) || ((J = h) === null || J === void 0 ? void 0 : J.cookieDuration));
          }
        }
        c("onUserTokenChange", function(U) {
          return T(U, !0);
        }, {
          immediate: !0
        });
        var ee = c;
        cf(c) && (ee = function(Z, Q) {
          var oe = {
            headers: {
              "X-Algolia-Application-Id": m,
              "X-Algolia-API-Key": y
            }
          };
          return c(Z, Q, oe);
        });
        var re = /* @__PURE__ */ new Set(), pe;
        f.mainHelper.derivedHelpers[0].on("result", function(U) {
          var Z = U.results;
          Z && (!Z.queryID || Z.queryID !== pe) && (pe = Z.queryID, re.clear());
        }), f.sendEventToInsights = function(U) {
          if (t)
            t(U, ee);
          else if (U.insightsMethod) {
            if (U.insightsMethod === "viewedObjectIDs") {
              var Z = U.payload, Q = Z.objectIDs.filter(function(oe) {
                return !re.has(oe);
              });
              if (Q.length === 0)
                return;
              Q.forEach(function(oe) {
                return re.add(oe);
              }), Z.objectIDs = Q;
            }
            U.payload.algoliaSource = ["instantsearch"], i && U.payload.algoliaSource.push("instantsearch-automatic"), U.eventModifier === "internal" && U.payload.algoliaSource.push("instantsearch-internal"), ee(U.insightsMethod, U.payload), process.env.NODE_ENV === "development" && de(!!D.state.userToken, `
Cannot send event to Algolia Insights because \`userToken\` is not set.

See documentation: https://www.algolia.com/doc/guides/building-search-ui/going-further/send-insights-events/js/#setting-the-usertoken
`);
          } else
            process.env.NODE_ENV === "development" && de(!1, "Cannot send event to Algolia Insights because `insightsMethod` option is missing.");
        };
      },
      unsubscribe: function() {
        c("onUserTokenChange", void 0), f.sendEventToInsights = Fe, D && S && (D.overrideStateWithoutTriggeringChangeEvent(Jr(Jr({}, D.state), S)), f.scheduleSearch());
      }
    };
  };
}
function t9(o) {
  var e, r, t = ((e = o._initialResults) === null || e === void 0 || (r = e[o.indexName]) === null || r === void 0 ? void 0 : r.state) || {}, n = o.mainHelper.state;
  return {
    userToken: t.userToken || n.userToken,
    clickAnalytics: t.clickAnalytics || n.clickAnalytics
  };
}
function n9(o, e) {
  var r = 2592e6, t = /* @__PURE__ */ new Date();
  t.setTime(t.getTime() + (e || r * 6));
  var n = "expires=".concat(t.toUTCString());
  document.cookie = "_ALGOLIA=".concat(o, ";").concat(n, ";path=/");
}
function cf(o) {
  var e = (o.version || "").split(".").map(Number), r = Ar(e, 2), t = r[0], n = r[1], a = t >= 3, s = t === 2 && n >= 6, i = t === 1 && n >= 10;
  return a || s || i;
}
function uf(o) {
  if (o)
    return typeof o == "number" ? o.toString() : o;
}
function AF(o, e, r) {
  var t = hn(e, e.mainIndex, e._initialUiState);
  o.forEach(function(n) {
    var a = {};
    if (n.getWidgetRenderState) {
      var s = n.getWidgetRenderState(t);
      s && s.widgetParams && (a = s.widgetParams);
    }
    var i = Object.keys(a).filter(function(l) {
      return a[l] !== void 0;
    });
    r.widgets.push({
      type: n.$$type,
      widgetType: n.$$widgetType,
      params: i
    }), n.$$type === "ais.index" && AF(n.getWidgets(), e, r);
  });
}
function a9() {
  return _o(function(o) {
    var e, r, t = o.window;
    return ((e = t.navigator) === null || e === void 0 || (r = e.userAgent) === null || r === void 0 ? void 0 : r.indexOf("Algolia Crawler")) > -1;
  }, {
    fallback: function() {
      return !1;
    }
  });
}
function s9() {
  var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, e = o.$$internal, r = e === void 0 ? !1 : e;
  return function(t) {
    var n = t.instantSearchInstance, a = {
      widgets: []
    }, s = document.createElement("meta"), i = document.querySelector("head");
    return s.name = "instantsearch:widgets", {
      $$type: "ais.metadata",
      $$internal: r,
      onStateChange: function() {
      },
      subscribe: function() {
        setTimeout(function() {
          var c = n.client;
          a.ua = c.transporter && c.transporter.userAgent ? c.transporter.userAgent.value : c._ua, AF(n.mainIndex.getWidgets(), n, a), n.middleware.forEach(function(u) {
            return a.widgets.push({
              middleware: !0,
              type: u.instance.$$type,
              internal: u.instance.$$internal
            });
          }), s.content = JSON.stringify(a), i.appendChild(s);
        }, 0);
      },
      started: function() {
      },
      unsubscribe: function() {
        s.remove();
      }
    };
  };
}
var Kl, pf;
function Rp() {
  if (pf) return Kl;
  pf = 1;
  var o = String.prototype.replace, e = /%20/g, r = {
    RFC1738: "RFC1738",
    RFC3986: "RFC3986"
  };
  return Kl = {
    default: r.RFC3986,
    formatters: {
      RFC1738: function(t) {
        return o.call(t, e, "+");
      },
      RFC3986: function(t) {
        return String(t);
      }
    },
    RFC1738: r.RFC1738,
    RFC3986: r.RFC3986
  }, Kl;
}
var Ql, df;
function EF() {
  if (df) return Ql;
  df = 1;
  var o = Rp(), e = Object.prototype.hasOwnProperty, r = Array.isArray, t = function() {
    for (var m = [], y = 0; y < 256; ++y)
      m.push("%" + ((y < 16 ? "0" : "") + y.toString(16)).toUpperCase());
    return m;
  }(), n = function(y) {
    for (; y.length > 1; ) {
      var h = y.pop(), F = h.obj[h.prop];
      if (r(F)) {
        for (var b = [], v = 0; v < F.length; ++v)
          typeof F[v] < "u" && b.push(F[v]);
        h.obj[h.prop] = b;
      }
    }
  }, a = function(y, h) {
    for (var F = h && h.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, b = 0; b < y.length; ++b)
      typeof y[b] < "u" && (F[b] = y[b]);
    return F;
  }, s = function m(y, h, F) {
    if (!h)
      return y;
    if (typeof h != "object") {
      if (r(y))
        y.push(h);
      else if (y && typeof y == "object")
        (F && (F.plainObjects || F.allowPrototypes) || !e.call(Object.prototype, h)) && (y[h] = !0);
      else
        return [y, h];
      return y;
    }
    if (!y || typeof y != "object")
      return [y].concat(h);
    var b = y;
    return r(y) && !r(h) && (b = a(y, F)), r(y) && r(h) ? (h.forEach(function(v, P) {
      if (e.call(y, P)) {
        var E = y[P];
        E && typeof E == "object" && v && typeof v == "object" ? y[P] = m(E, v, F) : y.push(v);
      } else
        y[P] = v;
    }), y) : Object.keys(h).reduce(function(v, P) {
      var E = h[P];
      return e.call(v, P) ? v[P] = m(v[P], E, F) : v[P] = E, v;
    }, b);
  }, i = function(y, h) {
    return Object.keys(h).reduce(function(F, b) {
      return F[b] = h[b], F;
    }, y);
  }, l = function(m, y, h) {
    var F = m.replace(/\+/g, " ");
    if (h === "iso-8859-1")
      return F.replace(/%[0-9a-f]{2}/gi, unescape);
    try {
      return decodeURIComponent(F);
    } catch {
      return F;
    }
  }, c = function(y, h, F, b, v) {
    if (y.length === 0)
      return y;
    var P = y;
    if (typeof y == "symbol" ? P = Symbol.prototype.toString.call(y) : typeof y != "string" && (P = String(y)), F === "iso-8859-1")
      return escape(P).replace(/%u[0-9a-f]{4}/gi, function(w) {
        return "%26%23" + parseInt(w.slice(2), 16) + "%3B";
      });
    for (var E = "", S = 0; S < P.length; ++S) {
      var D = P.charCodeAt(S);
      if (D === 45 || D === 46 || D === 95 || D === 126 || D >= 48 && D <= 57 || D >= 65 && D <= 90 || D >= 97 && D <= 122 || v === o.RFC1738 && (D === 40 || D === 41)) {
        E += P.charAt(S);
        continue;
      }
      if (D < 128) {
        E = E + t[D];
        continue;
      }
      if (D < 2048) {
        E = E + (t[192 | D >> 6] + t[128 | D & 63]);
        continue;
      }
      if (D < 55296 || D >= 57344) {
        E = E + (t[224 | D >> 12] + t[128 | D >> 6 & 63] + t[128 | D & 63]);
        continue;
      }
      S += 1, D = 65536 + ((D & 1023) << 10 | P.charCodeAt(S) & 1023), E += t[240 | D >> 18] + t[128 | D >> 12 & 63] + t[128 | D >> 6 & 63] + t[128 | D & 63];
    }
    return E;
  }, u = function(y) {
    for (var h = [{ obj: { o: y }, prop: "o" }], F = [], b = 0; b < h.length; ++b)
      for (var v = h[b], P = v.obj[v.prop], E = Object.keys(P), S = 0; S < E.length; ++S) {
        var D = E[S], w = P[D];
        typeof w == "object" && w !== null && F.indexOf(w) === -1 && (h.push({ obj: P, prop: D }), F.push(w));
      }
    return n(h), y;
  }, f = function(y) {
    return Object.prototype.toString.call(y) === "[object RegExp]";
  }, g = function(y) {
    return !y || typeof y != "object" ? !1 : !!(y.constructor && y.constructor.isBuffer && y.constructor.isBuffer(y));
  }, d = function(y, h) {
    return [].concat(y, h);
  }, p = function(y, h) {
    if (r(y)) {
      for (var F = [], b = 0; b < y.length; b += 1)
        F.push(h(y[b]));
      return F;
    }
    return h(y);
  };
  return Ql = {
    arrayToObject: a,
    assign: i,
    combine: d,
    compact: u,
    decode: l,
    encode: c,
    isBuffer: g,
    isRegExp: f,
    maybeMap: p,
    merge: s
  }, Ql;
}
var Jl, gf;
function i9() {
  if (gf) return Jl;
  gf = 1;
  var o = EF(), e = Rp(), r = Object.prototype.hasOwnProperty, t = {
    brackets: function(m) {
      return m + "[]";
    },
    comma: "comma",
    indices: function(m, y) {
      return m + "[" + y + "]";
    },
    repeat: function(m) {
      return m;
    }
  }, n = Array.isArray, a = String.prototype.split, s = Array.prototype.push, i = function(p, m) {
    s.apply(p, n(m) ? m : [m]);
  }, l = Date.prototype.toISOString, c = e.default, u = {
    addQueryPrefix: !1,
    allowDots: !1,
    charset: "utf-8",
    charsetSentinel: !1,
    delimiter: "&",
    encode: !0,
    encoder: o.encode,
    encodeValuesOnly: !1,
    format: c,
    formatter: e.formatters[c],
    // deprecated
    indices: !1,
    serializeDate: function(m) {
      return l.call(m);
    },
    skipNulls: !1,
    strictNullHandling: !1
  }, f = function(m) {
    return typeof m == "string" || typeof m == "number" || typeof m == "boolean" || typeof m == "symbol" || typeof m == "bigint";
  }, g = function p(m, y, h, F, b, v, P, E, S, D, w, A, C, x) {
    var T = m;
    if (typeof P == "function" ? T = P(y, T) : T instanceof Date ? T = D(T) : h === "comma" && n(T) && (T = o.maybeMap(T, function(U) {
      return U instanceof Date ? D(U) : U;
    })), T === null) {
      if (F)
        return v && !C ? v(y, u.encoder, x, "key", w) : y;
      T = "";
    }
    if (f(T) || o.isBuffer(T)) {
      if (v) {
        var M = C ? y : v(y, u.encoder, x, "key", w);
        if (h === "comma" && C) {
          for (var V = a.call(String(T), ","), G = "", L = 0; L < V.length; ++L)
            G += (L === 0 ? "" : ",") + A(v(V[L], u.encoder, x, "value", w));
          return [A(M) + "=" + G];
        }
        return [A(M) + "=" + A(v(T, u.encoder, x, "value", w))];
      }
      return [A(y) + "=" + A(String(T))];
    }
    var W = [];
    if (typeof T > "u")
      return W;
    var Y;
    if (h === "comma" && n(T))
      Y = [{ value: T.length > 0 ? T.join(",") || null : void 0 }];
    else if (n(P))
      Y = P;
    else {
      var X = Object.keys(T);
      Y = E ? X.sort(E) : X;
    }
    for (var J = 0; J < Y.length; ++J) {
      var ee = Y[J], re = typeof ee == "object" && typeof ee.value < "u" ? ee.value : T[ee];
      if (!(b && re === null)) {
        var pe = n(T) ? typeof h == "function" ? h(y, ee) : y : y + (S ? "." + ee : "[" + ee + "]");
        i(W, p(
          re,
          pe,
          h,
          F,
          b,
          v,
          P,
          E,
          S,
          D,
          w,
          A,
          C,
          x
        ));
      }
    }
    return W;
  }, d = function(m) {
    if (!m)
      return u;
    if (m.encoder !== null && typeof m.encoder < "u" && typeof m.encoder != "function")
      throw new TypeError("Encoder has to be a function.");
    var y = m.charset || u.charset;
    if (typeof m.charset < "u" && m.charset !== "utf-8" && m.charset !== "iso-8859-1")
      throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var h = e.default;
    if (typeof m.format < "u") {
      if (!r.call(e.formatters, m.format))
        throw new TypeError("Unknown format option provided.");
      h = m.format;
    }
    var F = e.formatters[h], b = u.filter;
    return (typeof m.filter == "function" || n(m.filter)) && (b = m.filter), {
      addQueryPrefix: typeof m.addQueryPrefix == "boolean" ? m.addQueryPrefix : u.addQueryPrefix,
      allowDots: typeof m.allowDots > "u" ? u.allowDots : !!m.allowDots,
      charset: y,
      charsetSentinel: typeof m.charsetSentinel == "boolean" ? m.charsetSentinel : u.charsetSentinel,
      delimiter: typeof m.delimiter > "u" ? u.delimiter : m.delimiter,
      encode: typeof m.encode == "boolean" ? m.encode : u.encode,
      encoder: typeof m.encoder == "function" ? m.encoder : u.encoder,
      encodeValuesOnly: typeof m.encodeValuesOnly == "boolean" ? m.encodeValuesOnly : u.encodeValuesOnly,
      filter: b,
      format: h,
      formatter: F,
      serializeDate: typeof m.serializeDate == "function" ? m.serializeDate : u.serializeDate,
      skipNulls: typeof m.skipNulls == "boolean" ? m.skipNulls : u.skipNulls,
      sort: typeof m.sort == "function" ? m.sort : null,
      strictNullHandling: typeof m.strictNullHandling == "boolean" ? m.strictNullHandling : u.strictNullHandling
    };
  };
  return Jl = function(p, m) {
    var y = p, h = d(m), F, b;
    typeof h.filter == "function" ? (b = h.filter, y = b("", y)) : n(h.filter) && (b = h.filter, F = b);
    var v = [];
    if (typeof y != "object" || y === null)
      return "";
    var P;
    m && m.arrayFormat in t ? P = m.arrayFormat : m && "indices" in m ? P = m.indices ? "indices" : "repeat" : P = "indices";
    var E = t[P];
    F || (F = Object.keys(y)), h.sort && F.sort(h.sort);
    for (var S = 0; S < F.length; ++S) {
      var D = F[S];
      h.skipNulls && y[D] === null || i(v, g(
        y[D],
        D,
        E,
        h.strictNullHandling,
        h.skipNulls,
        h.encode ? h.encoder : null,
        h.filter,
        h.sort,
        h.allowDots,
        h.serializeDate,
        h.format,
        h.formatter,
        h.encodeValuesOnly,
        h.charset
      ));
    }
    var w = v.join(h.delimiter), A = h.addQueryPrefix === !0 ? "?" : "";
    return h.charsetSentinel && (h.charset === "iso-8859-1" ? A += "utf8=%26%2310003%3B&" : A += "utf8=%E2%9C%93&"), w.length > 0 ? A + w : "";
  }, Jl;
}
var _l, mf;
function l9() {
  if (mf) return _l;
  mf = 1;
  var o = EF(), e = Object.prototype.hasOwnProperty, r = Array.isArray, t = {
    allowDots: !1,
    allowPrototypes: !1,
    arrayLimit: 20,
    charset: "utf-8",
    charsetSentinel: !1,
    comma: !1,
    decoder: o.decode,
    delimiter: "&",
    depth: 5,
    ignoreQueryPrefix: !1,
    interpretNumericEntities: !1,
    parameterLimit: 1e3,
    parseArrays: !0,
    plainObjects: !1,
    strictNullHandling: !1
  }, n = function(g) {
    return g.replace(/&#(\d+);/g, function(d, p) {
      return String.fromCharCode(parseInt(p, 10));
    });
  }, a = function(g, d) {
    return g && typeof g == "string" && d.comma && g.indexOf(",") > -1 ? g.split(",") : g;
  }, s = "utf8=%26%2310003%3B", i = "utf8=%E2%9C%93", l = function(d, p) {
    var m = {}, y = p.ignoreQueryPrefix ? d.replace(/^\?/, "") : d, h = p.parameterLimit === 1 / 0 ? void 0 : p.parameterLimit, F = y.split(p.delimiter, h), b = -1, v, P = p.charset;
    if (p.charsetSentinel)
      for (v = 0; v < F.length; ++v)
        F[v].indexOf("utf8=") === 0 && (F[v] === i ? P = "utf-8" : F[v] === s && (P = "iso-8859-1"), b = v, v = F.length);
    for (v = 0; v < F.length; ++v)
      if (v !== b) {
        var E = F[v], S = E.indexOf("]="), D = S === -1 ? E.indexOf("=") : S + 1, w, A;
        D === -1 ? (w = p.decoder(E, t.decoder, P, "key"), A = p.strictNullHandling ? null : "") : (w = p.decoder(E.slice(0, D), t.decoder, P, "key"), A = o.maybeMap(
          a(E.slice(D + 1), p),
          function(C) {
            return p.decoder(C, t.decoder, P, "value");
          }
        )), A && p.interpretNumericEntities && P === "iso-8859-1" && (A = n(A)), E.indexOf("[]=") > -1 && (A = r(A) ? [A] : A), e.call(m, w) ? m[w] = o.combine(m[w], A) : m[w] = A;
      }
    return m;
  }, c = function(g, d, p, m) {
    for (var y = m ? d : a(d, p), h = g.length - 1; h >= 0; --h) {
      var F, b = g[h];
      if (b === "[]" && p.parseArrays)
        F = [].concat(y);
      else {
        F = p.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
        var v = b.charAt(0) === "[" && b.charAt(b.length - 1) === "]" ? b.slice(1, -1) : b, P = parseInt(v, 10);
        !p.parseArrays && v === "" ? F = { 0: y } : !isNaN(P) && b !== v && String(P) === v && P >= 0 && p.parseArrays && P <= p.arrayLimit ? (F = [], F[P] = y) : v !== "__proto__" && (F[v] = y);
      }
      y = F;
    }
    return y;
  }, u = function(d, p, m, y) {
    if (d) {
      var h = m.allowDots ? d.replace(/\.([^.[]+)/g, "[$1]") : d, F = /(\[[^[\]]*])/, b = /(\[[^[\]]*])/g, v = m.depth > 0 && F.exec(h), P = v ? h.slice(0, v.index) : h, E = [];
      if (P) {
        if (!m.plainObjects && e.call(Object.prototype, P) && !m.allowPrototypes)
          return;
        E.push(P);
      }
      for (var S = 0; m.depth > 0 && (v = b.exec(h)) !== null && S < m.depth; ) {
        if (S += 1, !m.plainObjects && e.call(Object.prototype, v[1].slice(1, -1)) && !m.allowPrototypes)
          return;
        E.push(v[1]);
      }
      return v && E.push("[" + h.slice(v.index) + "]"), c(E, p, m, y);
    }
  }, f = function(d) {
    if (!d)
      return t;
    if (d.decoder !== null && d.decoder !== void 0 && typeof d.decoder != "function")
      throw new TypeError("Decoder has to be a function.");
    if (typeof d.charset < "u" && d.charset !== "utf-8" && d.charset !== "iso-8859-1")
      throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var p = typeof d.charset > "u" ? t.charset : d.charset;
    return {
      allowDots: typeof d.allowDots > "u" ? t.allowDots : !!d.allowDots,
      allowPrototypes: typeof d.allowPrototypes == "boolean" ? d.allowPrototypes : t.allowPrototypes,
      arrayLimit: typeof d.arrayLimit == "number" ? d.arrayLimit : t.arrayLimit,
      charset: p,
      charsetSentinel: typeof d.charsetSentinel == "boolean" ? d.charsetSentinel : t.charsetSentinel,
      comma: typeof d.comma == "boolean" ? d.comma : t.comma,
      decoder: typeof d.decoder == "function" ? d.decoder : t.decoder,
      delimiter: typeof d.delimiter == "string" || o.isRegExp(d.delimiter) ? d.delimiter : t.delimiter,
      // eslint-disable-next-line no-implicit-coercion, no-extra-parens
      depth: typeof d.depth == "number" || d.depth === !1 ? +d.depth : t.depth,
      ignoreQueryPrefix: d.ignoreQueryPrefix === !0,
      interpretNumericEntities: typeof d.interpretNumericEntities == "boolean" ? d.interpretNumericEntities : t.interpretNumericEntities,
      parameterLimit: typeof d.parameterLimit == "number" ? d.parameterLimit : t.parameterLimit,
      parseArrays: d.parseArrays !== !1,
      plainObjects: typeof d.plainObjects == "boolean" ? d.plainObjects : t.plainObjects,
      strictNullHandling: typeof d.strictNullHandling == "boolean" ? d.strictNullHandling : t.strictNullHandling
    };
  };
  return _l = function(g, d) {
    var p = f(d);
    if (g === "" || g === null || typeof g > "u")
      return p.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
    for (var m = typeof g == "string" ? l(g, p) : g, y = p.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, h = Object.keys(m), F = 0; F < h.length; ++F) {
      var b = h[F], v = u(b, m[b], p, typeof g == "string");
      y = o.merge(y, v, p);
    }
    return o.compact(y);
  }, _l;
}
var $l, ff;
function c9() {
  if (ff) return $l;
  ff = 1;
  var o = i9(), e = l9(), r = Rp();
  return $l = {
    formats: r,
    parse: e,
    stringify: o
  }, $l;
}
var u9 = c9();
const yf = /* @__PURE__ */ qr(u9);
function Ba(o) {
  "@babel/helpers - typeof";
  return Ba = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Ba(o);
}
function p9(o, e) {
  if (!(o instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function d9(o, e) {
  for (var r = 0; r < e.length; r++) {
    var t = e[r];
    t.enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(o, xF(t.key), t);
  }
}
function g9(o, e, r) {
  return e && d9(o.prototype, e), Object.defineProperty(o, "prototype", { writable: !1 }), o;
}
function go(o, e, r) {
  return e = xF(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function xF(o) {
  var e = m9(o, "string");
  return Ba(e) == "symbol" ? e : String(e);
}
function m9(o, e) {
  if (Ba(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (Ba(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
var hf = function(e) {
  e && (window.document.title = e);
}, f9 = /* @__PURE__ */ function() {
  function o(e) {
    var r = this, t = e.windowTitle, n = e.writeDelay, a = n === void 0 ? 400 : n, s = e.createURL, i = e.parseURL, l = e.getLocation, c = e.start, u = e.dispose, f = e.push, g = e.cleanUrlOnDispose;
    p9(this, o), go(this, "$$type", "ais.browser"), go(this, "windowTitle", void 0), go(this, "writeDelay", void 0), go(this, "_createURL", void 0), go(this, "parseURL", void 0), go(this, "getLocation", void 0), go(this, "writeTimer", void 0), go(this, "_onPopState", void 0), go(this, "inPopState", !1), go(this, "isDisposed", !1), go(this, "latestAcknowledgedHistory", 0), go(this, "_start", void 0), go(this, "_dispose", void 0), go(this, "_push", void 0), go(this, "_cleanUrlOnDispose", void 0), this.windowTitle = t, this.writeTimer = void 0, this.writeDelay = a, this._createURL = s, this.parseURL = i, this.getLocation = l, this._start = c, this._dispose = u, this._push = f, this._cleanUrlOnDispose = typeof g > "u" ? !0 : g, process.env.NODE_ENV === "development" && typeof g > "u" && console.info(`Starting from the next major version, InstantSearch will not clean up the URL from active refinements when it is disposed.

We recommend setting \`cleanUrlOnDispose\` to false to adopt this change today.
To stay with the current behaviour and remove this warning, set the option to true.

See documentation: `.concat(zn({
      name: "history-router"
    }), "#widget-param-cleanurlondispose")), _o(function(d) {
      var p = d.window, m = r.windowTitle && r.windowTitle(r.read());
      hf(m), r.latestAcknowledgedHistory = p.history.length;
    });
  }
  return g9(o, [{
    key: "read",
    value: function() {
      return this.parseURL({
        qsModule: yf,
        location: this.getLocation()
      });
    }
    /**
     * Pushes a search state into the URL.
     */
  }, {
    key: "write",
    value: function(r) {
      var t = this;
      _o(function(n) {
        var a = n.window, s = t.createURL(r), i = t.windowTitle && t.windowTitle(r);
        t.writeTimer && clearTimeout(t.writeTimer), t.writeTimer = setTimeout(function() {
          hf(i), t.shouldWrite(s) && (t._push ? t._push(s) : a.history.pushState(r, i || "", s), t.latestAcknowledgedHistory = a.history.length), t.inPopState = !1, t.writeTimer = void 0;
        }, t.writeDelay);
      });
    }
    /**
     * Sets a callback on the `onpopstate` event of the history API of the current page.
     * It enables the URL sync to keep track of the changes.
     */
  }, {
    key: "onUpdate",
    value: function(r) {
      var t = this;
      this._start && this._start(function() {
        r(t.read());
      }), this._onPopState = function() {
        t.writeTimer && (clearTimeout(t.writeTimer), t.writeTimer = void 0), t.inPopState = !0, r(t.read());
      }, _o(function(n) {
        var a = n.window;
        a.addEventListener("popstate", t._onPopState);
      });
    }
    /**
     * Creates a complete URL from a given syncable UI state.
     *
     * It always generates the full URL, not a relative one.
     * This allows to handle cases like using a <base href>.
     * See: https://github.com/algolia/instantsearch/issues/790
     */
  }, {
    key: "createURL",
    value: function(r) {
      var t = this._createURL({
        qsModule: yf,
        routeState: r,
        location: this.getLocation()
      });
      if (process.env.NODE_ENV === "development")
        try {
          new URL(t);
        } catch {
          process.env.NODE_ENV === "development" && de(!1, "The URL returned by the `createURL` function is invalid.\nPlease make sure it returns an absolute URL to avoid issues, e.g: `https://algolia.com/search?query=iphone`.");
        }
      return t;
    }
    /**
     * Removes the event listener and cleans up the URL.
     */
  }, {
    key: "dispose",
    value: function() {
      var r = this;
      this._dispose && this._dispose(), this.isDisposed = !0, _o(function(t) {
        var n = t.window;
        r._onPopState && n.removeEventListener("popstate", r._onPopState);
      }), this.writeTimer && clearTimeout(this.writeTimer), this._cleanUrlOnDispose && this.write({});
    }
  }, {
    key: "start",
    value: function() {
      this.isDisposed = !1;
    }
  }, {
    key: "shouldWrite",
    value: function(r) {
      var t = this;
      return _o(function(n) {
        var a = n.window;
        if (t.isDisposed && !t._cleanUrlOnDispose)
          return !1;
        var s = !(t.isDisposed && t.latestAcknowledgedHistory !== a.history.length);
        return (
          // When the last state change was through popstate, the IS.js state changes,
          // but that should not write the URL.
          !t.inPopState && // When the previous pushState after dispose was by IS.js, we want to write the URL.
          s && // When the URL is the same as the current one, we do not want to write it.
          r !== a.location.href
        );
      });
    }
  }]), o;
}();
function y9() {
  var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, e = o.createURL, r = e === void 0 ? function(p) {
    var m = p.qsModule, y = p.routeState, h = p.location, F = h.protocol, b = h.hostname, v = h.port, P = v === void 0 ? "" : v, E = h.pathname, S = h.hash, D = m.stringify(y), w = P === "" ? "" : ":".concat(P);
    return D ? "".concat(F, "//").concat(b).concat(w).concat(E, "?").concat(D).concat(S) : "".concat(F, "//").concat(b).concat(w).concat(E).concat(S);
  } : e, t = o.parseURL, n = t === void 0 ? function(p) {
    var m = p.qsModule, y = p.location;
    return m.parse(y.search.slice(1), {
      arrayLimit: 99
    });
  } : t, a = o.writeDelay, s = a === void 0 ? 400 : a, i = o.windowTitle, l = o.getLocation, c = l === void 0 ? function() {
    return _o(function(p) {
      var m = p.window;
      return m.location;
    }, {
      fallback: function() {
        throw new Error("You need to provide `getLocation` to the `history` router in environments where `window` does not exist.");
      }
    });
  } : l, u = o.start, f = o.dispose, g = o.push, d = o.cleanUrlOnDispose;
  return new f9({
    createURL: r,
    parseURL: n,
    writeDelay: s,
    windowTitle: i,
    getLocation: c,
    start: u,
    dispose: f,
    push: g,
    cleanUrlOnDispose: d
  });
}
function Pa(o) {
  "@babel/helpers - typeof";
  return Pa = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Pa(o);
}
var h9 = ["configure"];
function Ff(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function Fs(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Ff(Object(r), !0).forEach(function(t) {
      Cu(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : Ff(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function Cu(o, e, r) {
  return e = F9(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function F9(o) {
  var e = b9(o, "string");
  return Pa(e) == "symbol" ? e : String(e);
}
function b9(o, e) {
  if (Pa(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (Pa(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
function v9(o, e) {
  if (o == null) return {};
  var r = B9(o, e), t, n;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(o);
    for (n = 0; n < a.length; n++)
      t = a[n], !(e.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(o, t) && (r[t] = o[t]);
  }
  return r;
}
function B9(o, e) {
  if (o == null) return {};
  var r = {}, t = Object.keys(o), n, a;
  for (a = 0; a < t.length; a++)
    n = t[a], !(e.indexOf(n) >= 0) && (r[n] = o[n]);
  return r;
}
function bf(o) {
  o.configure;
  var e = v9(o, h9);
  return e;
}
function P9() {
  return {
    $$type: "ais.simple",
    stateToRoute: function(e) {
      return Object.keys(e).reduce(function(r, t) {
        return Fs(Fs({}, r), {}, Cu({}, t, bf(e[t])));
      }, {});
    },
    routeToState: function() {
      var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      return Object.keys(e).reduce(function(r, t) {
        return Fs(Fs({}, r), {}, Cu({}, t, bf(e[t])));
      }, {});
    }
  };
}
function wa(o) {
  "@babel/helpers - typeof";
  return wa = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, wa(o);
}
function vf(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function bs(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? vf(Object(r), !0).forEach(function(t) {
      CF(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : vf(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function CF(o, e, r) {
  return e = w9(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function w9(o) {
  var e = k9(o, "string");
  return wa(e) == "symbol" ? e : String(e);
}
function k9(o, e) {
  if (wa(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (wa(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
var D9 = function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = e.router, t = r === void 0 ? y9() : r, n = e.stateMapping, a = n === void 0 ? P9() : n, s = e.$$internal, i = s === void 0 ? !1 : s;
  return function(l) {
    var c = l.instantSearchInstance;
    function u(d) {
      var p = (
        // If only the mainIndex is initialized, we don't yet know what other
        // index widgets are used. Therefore we fall back to the initialUiState.
        // We can't indiscriminately use the initialUiState because then we
        // reintroduce state that was changed by the user.
        // When there are no widgets, we are sure the user can't yet have made
        // any changes.
        c.mainIndex.getWidgets().length === 0 ? c._initialUiState : c.mainIndex.getWidgetUiState({})
      ), m = Object.keys(d).reduce(function(h, F) {
        return bs(bs({}, h), {}, CF({}, F, d[F]));
      }, p), y = a.stateToRoute(m);
      return t.createURL(y);
    }
    c._createURL = u;
    var f = void 0, g = c._initialUiState;
    return {
      $$type: "ais.router({router:".concat(t.$$type || "__unknown__", ", stateMapping:").concat(a.$$type || "__unknown__", "})"),
      $$internal: i,
      onStateChange: function(p) {
        var m = p.uiState, y = a.stateToRoute(m);
        (f === void 0 || !yt(f, y)) && (t.write(y), f = y);
      },
      subscribe: function() {
        process.env.NODE_ENV === "development" && de(Object.keys(g).length === 0, "Using `initialUiState` together with routing is not recommended. The `initialUiState` will be overwritten by the URL parameters."), c._initialUiState = bs(bs({}, g), a.routeToState(t.read())), t.onUpdate(function(p) {
          c.mainIndex.getWidgets().length > 0 && c.setUiState(a.routeToState(p));
        });
      },
      started: function() {
        var p;
        (p = t.start) === null || p === void 0 || p.call(t);
      },
      unsubscribe: function() {
        t.dispose();
      }
    };
  };
};
function S9(o, e) {
  return o.toLocaleString(e);
}
function ka(o) {
  "@babel/helpers - typeof";
  return ka = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, ka(o);
}
function Bf(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function lr(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Bf(Object(r), !0).forEach(function(t) {
      A9(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : Bf(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function A9(o, e, r) {
  return e = E9(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function E9(o) {
  var e = x9(o, "string");
  return ka(e) == "symbol" ? e : String(e);
}
function x9(o, e) {
  if (ka(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (ka(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
function C9(o) {
  var e = o.numberLocale;
  return {
    formatNumber: function(t, n) {
      return S9(Number(n(t)), e);
    },
    highlight: function(t, n) {
      try {
        var a = JSON.parse(t);
        return n(vF(lr(lr({}, a), {}, {
          hit: this
        })));
      } catch {
        throw new Error(`
The highlight helper expects a JSON object of the format:
{ "attribute": "name", "highlightedTagName": "mark" }`);
      }
    },
    reverseHighlight: function(t, n) {
      try {
        var a = JSON.parse(t);
        return n(BF(lr(lr({}, a), {}, {
          hit: this
        })));
      } catch {
        throw new Error(`
  The reverseHighlight helper expects a JSON object of the format:
  { "attribute": "name", "highlightedTagName": "mark" }`);
      }
    },
    snippet: function(t, n) {
      try {
        var a = JSON.parse(t);
        return n(PF(lr(lr({}, a), {}, {
          hit: this
        })));
      } catch {
        throw new Error(`
The snippet helper expects a JSON object of the format:
{ "attribute": "name", "highlightedTagName": "mark" }`);
      }
    },
    reverseSnippet: function(t, n) {
      try {
        var a = JSON.parse(t);
        return n(wF(lr(lr({}, a), {}, {
          hit: this
        })));
      } catch {
        throw new Error(`
  The reverseSnippet helper expects a JSON object of the format:
  { "attribute": "name", "highlightedTagName": "mark" }`);
      }
    },
    insights: function(t, n) {
      try {
        var a = JSON.parse(t), s = a.method, i = a.payload;
        return n(J1(s, lr({
          objectIDs: [this.objectID]
        }, i)));
      } catch {
        throw new Error(`
The insights helper expects a JSON object of the format:
{ "method": "method-name", "payload": { "eventName": "name of the event" } }`);
      }
    }
  };
}
const OF = "4.77.3";
function Xt(o) {
  "@babel/helpers - typeof";
  return Xt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Xt(o);
}
function Pf(o, e) {
  var r = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    e && (t = t.filter(function(n) {
      return Object.getOwnPropertyDescriptor(o, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function ec(o) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Pf(Object(r), !0).forEach(function(t) {
      Se(o, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : Pf(Object(r)).forEach(function(t) {
      Object.defineProperty(o, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return o;
}
function O9(o, e) {
  if (!(o instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function T9(o, e) {
  for (var r = 0; r < e.length; r++) {
    var t = e[r];
    t.enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(o, TF(t.key), t);
  }
}
function L9(o, e, r) {
  return e && T9(o.prototype, e), Object.defineProperty(o, "prototype", { writable: !1 }), o;
}
function j9(o, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  o.prototype = Object.create(e && e.prototype, { constructor: { value: o, writable: !0, configurable: !0 } }), Object.defineProperty(o, "prototype", { writable: !1 }), e && Ou(o, e);
}
function Ou(o, e) {
  return Ou = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, n) {
    return t.__proto__ = n, t;
  }, Ou(o, e);
}
function M9(o) {
  var e = N9();
  return function() {
    var t = oi(o), n;
    if (e) {
      var a = oi(this).constructor;
      n = Reflect.construct(t, arguments, a);
    } else
      n = t.apply(this, arguments);
    return W9(this, n);
  };
}
function W9(o, e) {
  if (e && (Xt(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return De(o);
}
function De(o) {
  if (o === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return o;
}
function N9() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function oi(o) {
  return oi = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, oi(o);
}
function Se(o, e, r) {
  return e = TF(e), e in o ? Object.defineProperty(o, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : o[e] = r, o;
}
function TF(o) {
  var e = V9(o, "string");
  return Xt(e) == "symbol" ? e : String(e);
}
function V9(o, e) {
  if (Xt(o) != "object" || !o) return o;
  var r = o[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(o, e);
    if (Xt(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
var Io = Te({
  name: "instantsearch"
});
function z9() {
  return "#";
}
var LF = {
  preserveSharedStateOnUnmount: !1,
  persistHierarchicalRootCount: !1
}, I9 = /* @__PURE__ */ function(o) {
  j9(r, o);
  var e = M9(r);
  function r(t) {
    var n, a;
    O9(this, r), a = e.call(this), Se(De(a), "client", void 0), Se(De(a), "indexName", void 0), Se(De(a), "compositionID", void 0), Se(De(a), "insightsClient", void 0), Se(De(a), "onStateChange", null), Se(De(a), "future", void 0), Se(De(a), "helper", void 0), Se(De(a), "mainHelper", void 0), Se(De(a), "mainIndex", void 0), Se(De(a), "started", void 0), Se(De(a), "templatesConfig", void 0), Se(De(a), "renderState", {}), Se(De(a), "_stalledSearchDelay", void 0), Se(De(a), "_searchStalledTimer", void 0), Se(De(a), "_initialUiState", void 0), Se(De(a), "_initialResults", void 0), Se(De(a), "_createURL", void 0), Se(De(a), "_searchFunction", void 0), Se(De(a), "_mainHelperSearch", void 0), Se(De(a), "_hasSearchWidget", !1), Se(De(a), "_hasRecommendWidget", !1), Se(De(a), "_insights", void 0), Se(De(a), "middleware", []), Se(De(a), "sendEventToInsights", void 0), Se(De(a), "status", "idle"), Se(De(a), "error", void 0), Se(De(a), "scheduleSearch", cn(function() {
      a.started && a.mainHelper.search();
    })), Se(De(a), "scheduleRender", cn(function() {
      var T, M = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
      (T = a.mainHelper) !== null && T !== void 0 && T.hasPendingRequests() || (clearTimeout(a._searchStalledTimer), a._searchStalledTimer = null, M && (a.status = "idle", a.error = void 0)), a.mainIndex.render({
        instantSearchInstance: De(a)
      }), a.emit("render");
    })), Se(De(a), "onInternalStateChange", cn(function() {
      var T = a.mainIndex.getWidgetUiState({});
      a.middleware.forEach(function(M) {
        var V = M.instance;
        V.onStateChange({
          uiState: T
        });
      });
    })), a.setMaxListeners(100);
    var s = t.indexName, i = s === void 0 ? "" : s, l = t.compositionID, c = t.numberLocale, u = t.initialUiState, f = u === void 0 ? {} : u, g = t.routing, d = g === void 0 ? null : g, p = t.insights, m = p === void 0 ? void 0 : p, y = t.searchFunction, h = t.stalledSearchDelay, F = h === void 0 ? 200 : h, b = t.searchClient, v = b === void 0 ? null : b, P = t.insightsClient, E = P === void 0 ? null : P, S = t.onStateChange, D = S === void 0 ? null : S, w = t.future, A = w === void 0 ? ec(ec({}, LF), t.future || {}) : w;
    if (v === null)
      throw new Error(Io("The `searchClient` option is required."));
    if (typeof v.search != "function")
      throw new Error("The `searchClient` must implement a `search` method.\n\nSee: https://www.algolia.com/doc/guides/building-search-ui/going-further/backend-search/in-depth/backend-instantsearch/js/");
    if (typeof v.addAlgoliaAgent == "function" && v.addAlgoliaAgent("instantsearch.js (".concat(OF, ")")), process.env.NODE_ENV === "development" && de(E === null, "`insightsClient` property has been deprecated. It is still supported in 4.x releases, but not further. It is replaced by the `insights` middleware.\n\nFor more information, visit https://www.algolia.com/doc/guides/getting-insights-and-analytics/search-analytics/click-through-and-conversions/how-to/send-click-and-conversion-events-with-instantsearch/js/"), E && typeof E != "function")
      throw new Error(Io("The `insightsClient` option should be a function."));
    if (process.env.NODE_ENV === "development" && de(!t.searchParameters, "The `searchParameters` option is deprecated and will not be supported in InstantSearch.js 4.x.\n\nYou can replace it with the `configure` widget:\n\n```\nsearch.addWidgets([\n  configure(".concat(JSON.stringify(t.searchParameters, null, 2), `)
]);
\`\`\`

See `).concat(zn({
      name: "configure"
    }))), process.env.NODE_ENV === "development" && ((n = t.future) === null || n === void 0 ? void 0 : n.preserveSharedStateOnUnmount) === void 0 && console.info(`Starting from the next major version, InstantSearch will change how widgets state is preserved when they are removed. InstantSearch will keep the state of unmounted widgets to be usable by other widgets with the same attribute.

We recommend setting \`future.preserveSharedStateOnUnmount\` to true to adopt this change today.
To stay with the current behaviour and remove this warning, set the option to false.

See documentation: `.concat(zn({
      name: "instantsearch"
    }), `#widget-param-future
          `)), a.client = v, a.future = A, a.insightsClient = E, a.indexName = i, a.compositionID = l, a.helper = null, a.mainHelper = null, a.mainIndex = bF({
      // we use an index widget to render compositions
      // this only works because there's only one composition index allow for now
      indexName: a.compositionID || a.indexName
    }), a.onStateChange = D, a.started = !1, a.templatesConfig = {
      helpers: C9({
        numberLocale: c
      }),
      compileOptions: {}
    }, a._stalledSearchDelay = F, a._searchStalledTimer = null, a._createURL = z9, a._initialUiState = f, a._initialResults = null, a._insights = m, y && (process.env.NODE_ENV === "development" && de(!1, "The `searchFunction` option is deprecated. Use `onStateChange` instead."), a._searchFunction = y), a.sendEventToInsights = Fe, d) {
      var C = typeof d == "boolean" ? {} : d;
      C.$$internal = !0, a.use(D9(C));
    }
    if (m) {
      var x = typeof m == "boolean" ? {} : m;
      x.$$internal = !0, a.use(lf(x));
    }
    return a9() && a.use(s9({
      $$internal: !0
    })), a;
  }
  return L9(r, [{
    key: "_isSearchStalled",
    get: (
      /**
       * @deprecated use `status === 'stalled'` instead
       */
      function() {
        return process.env.NODE_ENV === "development" && de(!1, '`InstantSearch._isSearchStalled` is deprecated and will be removed in InstantSearch.js 5.0.\n\nUse `InstantSearch.status === "stalled"` instead.'), this.status === "stalled";
      }
    )
  }, {
    key: "use",
    value: function() {
      for (var n = this, a = arguments.length, s = new Array(a), i = 0; i < a; i++)
        s[i] = arguments[i];
      var l = s.map(function(c) {
        var u = ec({
          $$type: "__unknown__",
          $$internal: !1,
          subscribe: Fe,
          started: Fe,
          unsubscribe: Fe,
          onStateChange: Fe
        }, c({
          instantSearchInstance: n
        }));
        return n.middleware.push({
          creator: c,
          instance: u
        }), u;
      });
      return this.started && l.forEach(function(c) {
        c.subscribe(), c.started();
      }), this;
    }
    /**
     * Removes a middleware from the InstantSearch lifecycle.
     */
  }, {
    key: "unuse",
    value: function() {
      for (var n = arguments.length, a = new Array(n), s = 0; s < n; s++)
        a[s] = arguments[s];
      return this.middleware.filter(function(i) {
        return a.includes(i.creator);
      }).forEach(function(i) {
        return i.instance.unsubscribe();
      }), this.middleware = this.middleware.filter(function(i) {
        return !a.includes(i.creator);
      }), this;
    }
    // @major we shipped with EXPERIMENTAL_use, but have changed that to just `use` now
  }, {
    key: "EXPERIMENTAL_use",
    value: function() {
      return process.env.NODE_ENV === "development" && de(!1, "The middleware API is now considered stable, so we recommend replacing `EXPERIMENTAL_use` with `use` before upgrading to the next major version."), this.use.apply(this, arguments);
    }
    /**
     * Adds a widget to the search instance.
     * A widget can be added either before or after InstantSearch has started.
     * @param widget The widget to add to InstantSearch.
     *
     * @deprecated This method will still be supported in 4.x releases, but not further. It is replaced by `addWidgets([widget])`.
     */
  }, {
    key: "addWidget",
    value: function(n) {
      return process.env.NODE_ENV === "development" && de(!1, "addWidget will still be supported in 4.x releases, but not further. It is replaced by `addWidgets([widget])`"), this.addWidgets([n]);
    }
    /**
     * Adds multiple widgets to the search instance.
     * Widgets can be added either before or after InstantSearch has started.
     * @param widgets The array of widgets to add to InstantSearch.
     */
  }, {
    key: "addWidgets",
    value: function(n) {
      if (!Array.isArray(n))
        throw new Error(Io("The `addWidgets` method expects an array of widgets. Please use `addWidget`."));
      if (n.some(function(a) {
        return typeof a.init != "function" && typeof a.render != "function";
      }))
        throw new Error(Io("The widget definition expects a `render` and/or an `init` method."));
      if (this.compositionID && n.some(Bo))
        throw new Error(Io("The `index` widget cannot be used with a composition-based InstantSearch implementation."));
      return this.mainIndex.addWidgets(n), this;
    }
    /**
     * Removes a widget from the search instance.
     * @deprecated This method will still be supported in 4.x releases, but not further. It is replaced by `removeWidgets([widget])`
     * @param widget The widget instance to remove from InstantSearch.
     *
     * The widget must implement a `dispose()` method to clear its state.
     */
  }, {
    key: "removeWidget",
    value: function(n) {
      return process.env.NODE_ENV === "development" && de(!1, "removeWidget will still be supported in 4.x releases, but not further. It is replaced by `removeWidgets([widget])`"), this.removeWidgets([n]);
    }
    /**
     * Removes multiple widgets from the search instance.
     * @param widgets Array of widgets instances to remove from InstantSearch.
     *
     * The widgets must implement a `dispose()` method to clear their states.
     */
  }, {
    key: "removeWidgets",
    value: function(n) {
      if (!Array.isArray(n))
        throw new Error(Io("The `removeWidgets` method expects an array of widgets. Please use `removeWidget`."));
      if (n.some(function(a) {
        return typeof a.dispose != "function";
      }))
        throw new Error(Io("The widget definition expects a `dispose` method."));
      return this.mainIndex.removeWidgets(n), this;
    }
    /**
     * Ends the initialization of InstantSearch.js and triggers the
     * first search.
     */
  }, {
    key: "start",
    value: function() {
      var n = this;
      if (this.started)
        throw new Error(Io("The `start` method has already been called once."));
      var a = this.mainHelper || so(this.client, this.indexName, void 0, {
        persistHierarchicalRootCount: this.future.persistHierarchicalRootCount
      });
      if (this.compositionID && (a.searchForFacetValues = a.searchForCompositionFacetValues.bind(a)), a.search = function() {
        return n.status = "loading", n.scheduleRender(!1), process.env.NODE_ENV === "development" && de(!!n.indexName || !!n.compositionID || n.mainIndex.getWidgets().some(Bo), "No indexName provided, nor an explicit index widget in the widgets tree. This is required to be able to display results."), n._hasSearchWidget && (n.compositionID ? a.searchWithComposition() : a.searchOnlyWithDerivedHelpers()), n._hasRecommendWidget && a.recommend(), a;
      }, this._searchFunction) {
        var s = {
          search: function() {
            return new Promise(Fe);
          }
        };
        this._mainHelperSearch = a.search.bind(a), a.search = function() {
          var l = n.mainIndex.getHelper(), c = so(s, l.state.index, l.state);
          return c.once("search", function(u) {
            var f = u.state;
            l.overrideStateWithoutTriggeringChangeEvent(f), n._mainHelperSearch();
          }), c.on("change", function(u) {
            var f = u.state;
            l.setState(f);
          }), n._searchFunction(c), a;
        };
      }
      if (a.on("error", function(l) {
        var c = l.error;
        if (!(c instanceof Error)) {
          var u = c;
          c = Object.keys(u).reduce(function(f, g) {
            return f[g] = u[g], f;
          }, new Error(u.message));
        }
        c.error = c, n.error = c, n.status = "error", n.scheduleRender(!1), n.emit("error", c);
      }), this.mainHelper = a, this.middleware.forEach(function(l) {
        var c = l.instance;
        c.subscribe();
      }), this.mainIndex.init({
        instantSearchInstance: this,
        parent: null,
        uiState: this._initialUiState
      }), this._initialResults) {
        SP(this.client, this._initialResults), FP(this.mainHelper, this._initialResults);
        var i = this.scheduleSearch;
        this.scheduleSearch = cn(Fe), cn(function() {
          n.scheduleSearch = i;
        })();
      } else this.mainIndex.getWidgets().length > 0 && this.scheduleSearch();
      this.helper = this.mainIndex.getHelper(), this.started = !0, this.middleware.forEach(function(l) {
        var c = l.instance;
        c.started();
      }), typeof this._insights > "u" && a.derivedHelpers[0].once("result", function() {
        var l = n.mainIndex.getScopedResults().some(function(c) {
          var u = c.results;
          return u == null ? void 0 : u._automaticInsights;
        });
        l && n.use(lf({
          $$internal: !0,
          $$automatic: !0
        }));
      });
    }
    /**
     * Removes all widgets without triggering a search afterwards.
     * @return {undefined} This method does not return anything
     */
  }, {
    key: "dispose",
    value: function() {
      var n;
      this.scheduleSearch.cancel(), this.scheduleRender.cancel(), clearTimeout(this._searchStalledTimer), this.removeWidgets(this.mainIndex.getWidgets()), this.mainIndex.dispose(), this.started = !1, this.removeAllListeners(), (n = this.mainHelper) === null || n === void 0 || n.removeAllListeners(), this.mainHelper = null, this.helper = null, this.middleware.forEach(function(a) {
        var s = a.instance;
        s.unsubscribe();
      });
    }
  }, {
    key: "scheduleStalledRender",
    value: function() {
      var n = this;
      this._searchStalledTimer || (this._searchStalledTimer = setTimeout(function() {
        n.status = "stalled", n.scheduleRender();
      }, this._stalledSearchDelay));
    }
    /**
     * Set the UI state and trigger a search.
     * @param uiState The next UI state or a function computing it from the current state
     * @param callOnStateChange private parameter used to know if the method is called from a state change
     */
  }, {
    key: "setUiState",
    value: function(n) {
      var a = this, s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
      if (!this.mainHelper)
        throw new Error(Io("The `start` method needs to be called before `setUiState`."));
      this.mainIndex.refreshUiState();
      var i = typeof n == "function" ? n(this.mainIndex.getWidgetUiState({})) : n;
      this.onStateChange && s ? this.onStateChange({
        uiState: i,
        setUiState: function(c) {
          hu(typeof c == "function" ? c(i) : c, a.mainIndex), a.scheduleSearch(), a.onInternalStateChange();
        }
      }) : (hu(i, this.mainIndex), this.scheduleSearch(), this.onInternalStateChange());
    }
  }, {
    key: "getUiState",
    value: function() {
      return this.started && this.mainIndex.refreshUiState(), this.mainIndex.getWidgetUiState({});
    }
  }, {
    key: "createURL",
    value: function() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      if (!this.started)
        throw new Error(Io("The `start` method needs to be called before `createURL`."));
      return this._createURL(n);
    }
  }, {
    key: "refresh",
    value: function() {
      if (!this.mainHelper)
        throw new Error(Io("The `start` method needs to be called before `refresh`."));
      this.mainHelper.clearCache().search();
    }
  }]), r;
}(qD), zo = function(e) {
  return new I9(e);
};
zo.version = OF;
zo.createInfiniteHitsSessionStorageCache = Br(HD, "import { createInfiniteHitsSessionStorageCache } from 'instantsearch.js/es/lib/infiniteHitsCache'");
zo.highlight = Br(vF, "import { highlight } from 'instantsearch.js/es/helpers'");
zo.reverseHighlight = Br(BF, "import { reverseHighlight } from 'instantsearch.js/es/helpers'");
zo.snippet = Br(PF, "import { snippet } from 'instantsearch.js/es/helpers'");
zo.reverseSnippet = Br(wF, "import { reverseSnippet } from 'instantsearch.js/es/helpers'");
zo.insights = J1;
zo.getInsightsAnonymousUserToken = VD;
Object.defineProperty(zo, "widgets", {
  get: function() {
    throw new ReferenceError(`"instantsearch.widgets" are not available from the ES build.

To import the widgets:

import { searchBox } from 'instantsearch.js/es/widgets'`);
  }
});
Object.defineProperty(zo, "connectors", {
  get: function() {
    throw new ReferenceError(`"instantsearch.connectors" are not available from the ES build.

To import the connectors:

import { connectSearchBox } from 'instantsearch.js/es/connectors'`);
  }
});
Object.defineProperty(zo, "templates", {
  get: function() {
    throw new ReferenceError(`"instantsearch.templates" are not available from the ES build.

To import the templates:

import { carousel } from 'instantsearch.js/es/templates'`);
  }
});
var R9 = "4.20.4", jF = function(o) {
  var e;
  return Nn(((e = { mixins: [Pe({ name: "InstantSearch" })], provide: function() {
    return { $_ais_instantSearchInstance: this.instantSearchInstance };
  }, watch: { searchClient: function(r) {
    zt(!1), this.instantSearchInstance.helper.setClient(r).search();
  }, indexName: function(r) {
    this.instantSearchInstance.helper.setIndex(r || "").search();
  }, compositionID: function(r) {
    this.instantSearchInstance.helper.setIndex(r || "").search();
  }, stalledSearchDelay: function(r) {
    this.instantSearchInstance._stalledSearchDelay = r;
  }, routing: function() {
    throw new Error(`routing configuration can not be changed dynamically at this point.

Please open a new issue: https://github.com/algolia/instantsearch/discussions/new?category=ideas&labels=triage%2cLibrary%3A+Vue+InstantSearch&title=Feature%20request%3A%20dynamic%20props`);
  }, onStateChange: function() {
    throw new Error(`onStateChange configuration can not be changed dynamically at this point.

Please open a new issue: https://github.com/algolia/instantsearch/discussions/new?category=ideas&labels=triage%2cLibrary%3A+Vue+InstantSearch&title=Feature%20request%3A%20dynamic%20props`);
  }, searchFunction: function(r) {
    this.instantSearchInstance._searchFunction = r;
  }, middlewares: { immediate: !0, handler: function(r, t) {
    var n = this;
    (t || []).filter(function(a) {
      return (r || []).indexOf(a) === -1;
    }).forEach(function(a) {
      n.instantSearchInstance.unuse(a);
    }), (r || []).filter(function(a) {
      return (t || []).indexOf(a) === -1;
    }).forEach(function(a) {
      n.instantSearchInstance.use(a);
    });
  } }, future: function(r) {
    this.instantSearchInstance.future = Object.assign(LF, r);
  } }, created: function() {
    var r = this.instantSearchInstance.client;
    typeof r.addAlgoliaAgent == "function" && (r.addAlgoliaAgent("Vue (" + qb + ")"), r.addAlgoliaAgent("Vue InstantSearch (" + R9 + ")"));
  }, mounted: function() {
    var r = this;
    this.$nextTick(function() {
      r.instantSearchInstance.started || r.instantSearchInstance.start();
    });
  } }).beforeUnmount = function() {
    this.instantSearchInstance.started && this.instantSearchInstance.dispose(), this.instantSearchInstance.__initialSearchResults = void 0;
  }, e), o);
}, wf = `Vue InstantSearch: You used the prop api-key or app-id.
These have been replaced by search-client.

See more info here: https://www.algolia.com/doc/api-reference/widgets/instantsearch/vue/#widget-param-search-client`;
const Ci = jF({ name: "AisInstantSearch", props: { searchClient: { type: Object, required: !0 }, insightsClient: { type: Function, default: void 0 }, indexName: { type: String, required: !1 }, compositionID: { type: String, required: !1 }, routing: { default: void 0, validator: function(o) {
  return !(typeof o == "boolean" || !o.router && !o.stateMapping) || (zt("The `routing` option expects an object with `router` and/or `stateMapping`.\n\nSee https://www.algolia.com/doc/api-reference/widgets/instantsearch/vue/#widget-param-routing"), !1);
} }, insights: { default: void 0, validator: function(o) {
  return o === void 0 || typeof o == "boolean" || typeof o == "object";
} }, stalledSearchDelay: { type: Number, default: void 0 }, searchFunction: { type: Function, default: void 0 }, onStateChange: { type: Function, default: void 0 }, initialUiState: { type: Object, default: void 0 }, apiKey: { type: String, default: void 0, validator: function(o) {
  return o && zt(wf), !1;
} }, appId: { type: String, default: void 0, validator: function(o) {
  return o && zt(wf), !1;
} }, middlewares: { type: Array, default: null }, future: { type: Object, default: void 0 } }, data: function() {
  return { instantSearchInstance: zo({ searchClient: this.searchClient, insightsClient: this.insightsClient, insights: this.insights, indexName: this.indexName, compositionID: this.compositionID, routing: this.routing, stalledSearchDelay: this.stalledSearchDelay, searchFunction: this.searchFunction, onStateChange: this.onStateChange, initialUiState: this.initialUiState, future: this.future }) };
}, render: Ga(function(o) {
  var e;
  return o("div", { class: (e = {}, e[this.suit()] = !0, e[this.suit("", "ssr")] = !1, e) }, Ap(this));
}) });
jF({ name: "AisInstantSearchSsr", inject: { $_ais_ssrInstantSearchInstance: { default: function() {
  throw new Error("`createServerRootMixin` is required when using SSR.");
} } }, data: function() {
  return { instantSearchInstance: this.$_ais_ssrInstantSearchInstance };
}, render: Ga(function(o) {
  var e;
  return o("div", { class: (e = {}, e[this.suit()] = !0, e[this.suit("", "ssr")] = !0, e) }, Ap(this));
}) });
const Oi = { name: "AisInfiniteHits", mixins: [xe({ connector: Q4 }, { $$widgetType: "ais.infiniteHits" }), Pe({ name: "InfiniteHits" })], props: { showBanner: { type: Boolean, default: !0 }, showPrevious: { type: Boolean, default: !1 }, escapeHTML: { type: Boolean, default: !0 }, transformItems: { type: Function, default: void 0 }, cache: { type: Object, default: void 0 } }, computed: { widgetParams: function() {
  return { showBanner: this.showBanner, showPrevious: this.showPrevious, escapeHTML: this.escapeHTML, transformItems: this.transformItems, cache: this.cache };
} }, methods: { refinePrevious: function() {
  this.state.showPrevious();
}, refineNext: function() {
  this.state.showMore();
} } };
var H9 = ["disabled"], Y9 = ["href", "target"], q9 = ["src", "alt"], G9 = ["src", "alt"], X9 = ["onClick", "onAuxclick"], U9 = ["disabled"];
function Z9(o, e, r, t, n, a) {
  return o.state ? (k(), N("div", { key: 0, class: q(o.suit()) }, [r.showPrevious ? I(o.$slots, "loadPrevious", { key: 0, refinePrevious: a.refinePrevious, page: o.state.results.page, isFirstPage: o.state.isFirstPage }, function() {
    return [O("button", { class: q([o.suit("loadPrevious"), o.state.isFirstPage && o.suit("loadPrevious", "disabled")]), disabled: o.state.isFirstPage, onClick: e[0] || (e[0] = function(s) {
      return a.refinePrevious();
    }) }, " Show previous results ", 10, H9)];
  }) : K("", !0), I(o.$slots, "default", { items: o.state.items, results: o.state.results, banner: o.state.banner, isLastPage: o.state.isLastPage, refinePrevious: a.refinePrevious, refineNext: a.refineNext, refine: a.refineNext, insights: o.state.insights, sendEvent: o.state.sendEvent }, function() {
    return [r.showBanner && o.state.banner && o.state.banner.image.urls[0].url ? I(o.$slots, "banner", { key: 0, banner: o.state.banner }, function() {
      return [O("aside", { class: q(o.suit("banner")) }, [o.state.banner.link ? (k(), N("a", { key: 0, href: o.state.banner.link.url, target: o.state.banner.link.target, class: q(o.suit("banner-link")) }, [O("img", { src: o.state.banner.image.urls[0].url, alt: o.state.banner.image.title, class: q(o.suit("banner-image")) }, null, 10, q9)], 10, Y9)) : (k(), N("img", { key: 1, src: o.state.banner.image.urls[0].url, alt: o.state.banner.image.title, class: q(o.suit("banner-image")) }, null, 10, G9))], 2)];
    }) : K("", !0), O("ol", { class: q(o.suit("list")) }, [(k(!0), N(ye, null, Oe(o.state.items, function(s, i) {
      return k(), N("li", { class: q(o.suit("item")), key: s.objectID, onClick: function(l) {
        return o.state.sendEvent("click:internal", s, "Hit Clicked");
      }, onAuxclick: function(l) {
        return o.state.sendEvent("click:internal", s, "Hit Clicked");
      } }, [I(o.$slots, "item", { item: s, index: i, insights: o.state.insights, sendEvent: o.state.sendEvent }, function() {
        return [ne(" objectID: " + _(s.objectID) + ", index: " + _(i), 1)];
      })], 42, X9);
    }), 128))], 2), I(o.$slots, "loadMore", { refineNext: a.refineNext, refine: a.refineNext, page: o.state.results.page, isLastPage: o.state.isLastPage }, function() {
      return [O("button", { class: q([o.suit("loadMore"), o.state.isLastPage && o.suit("loadMore", "disabled")]), disabled: o.state.isLastPage, onClick: e[1] || (e[1] = function(s) {
        return a.refineNext();
      }) }, " Show more results ", 10, U9)];
    })];
  })], 2)) : K("", !0);
}
Oi.render = Z9;
Pe({ name: "Menu" }), xe({ connector: eF }, { $$widgetType: "ais.menu" }), wo();
Pe({ name: "MenuSelect" }), xe({ connector: eF }, { $$widgetType: "ais.menuSelect" }), wo();
xe({ connector: y6 }, { $$widgetType: "ais.numericMenu" }), Pe({ name: "NumericMenu" }), wo();
Pe({ name: "Pagination" }), xe({ connector: A6 }, { $$widgetType: "ais.pagination" }), wo();
Pe({ name: "Panel" }), uD();
Pe({ name: "PoweredBy" });
Pe({ name: "QueryRuleContext" }), xe({ connector: uF }, { $$widgetType: "ais.queryRuleContext" });
Pe({ name: "QueryRuleCustomData" }), xe({ connector: uF }, { $$widgetType: "ais.queryRuleCustomData" });
Pe({ name: "RangeInput" }), xe({ connector: M6 }, { $$widgetType: "ais.rangeInput" }), wo();
Pe({ name: "RatingMenu" }), xe({ connector: ck }, { $$widgetType: "ais.ratingMenu" }), wo();
O("symbol", { id: "ais-RatingMenu-starSymbol", viewBox: "0 0 24 24" }, [O("path", { d: "M12 .288l2.833 8.718h9.167l-7.417 5.389 2.833 8.718-7.416-5.388-7.417 5.388 2.833-8.718-7.416-5.389h9.167z" })], -1), O("symbol", { id: "ais-RatingMenu-starEmptySymbol", viewBox: "0 0 24 24" }, [O("path", { d: "M12 6.76l1.379 4.246h4.465l-3.612 2.625 1.379 4.246-3.611-2.625-3.612 2.625 1.379-4.246-3.612-2.625h4.465l1.38-4.246zm0-6.472l-2.833 8.718h-9.167l7.416 5.389-2.833 8.718 7.417-5.388 7.416 5.388-2.833-8.718 7.417-5.389h-9.167l-2.833-8.718z" })], -1);
O("use", { "xlink:href": "#ais-RatingMenu-starSymbol" }, null, -1);
O("use", { "xlink:href": "#ais-RatingMenu-starEmptySymbol" }, null, -1);
const MF = { name: "SearchInput", mixins: [Pe({ name: "SearchBox" })], props: { placeholder: { type: String, default: "Search here…" }, autofocus: { type: Boolean, default: !1 }, showLoadingIndicator: { type: Boolean, default: !1 }, shouldShowLoadingIndicator: { type: Boolean, default: !1 }, ignoreCompositionEvents: { type: Boolean, default: !1 }, submitTitle: { type: String, default: "Search" }, resetTitle: { type: String, default: "Clear" }, value: { type: String, required: !1, default: void 0 }, modelValue: { type: String, required: !1, default: void 0 } }, emits: ["input", "update:modelValue", "blur", "focus", "reset"], data: function() {
  return { query: "" };
}, methods: { isFocused: function() {
  return document.activeElement === this.$refs.input;
}, onInput: function(o) {
  this.ignoreCompositionEvents && o.isComposing || (this.$emit("input", o.target.value), this.$emit("update:modelValue", o.target.value));
}, onFormSubmit: function() {
  this.$refs.input.blur();
}, onFormReset: function() {
  this.$emit("input", ""), this.$emit("update:modelValue", ""), this.$emit("reset");
} } };
var K9 = ["placeholder", "autofocus", "value"], Q9 = ["title", "hidden"], J9 = [O("path", { d: "M26.804 29.01c-2.832 2.34-6.465 3.746-10.426 3.746C7.333 32.756 0 25.424 0 16.378 0 7.333 7.333 0 16.378 0c9.046 0 16.378 7.333 16.378 16.378 0 3.96-1.406 7.594-3.746 10.426l10.534 10.534c.607.607.61 1.59-.004 2.202-.61.61-1.597.61-2.202.004L26.804 29.01zm-10.426.627c7.323 0 13.26-5.936 13.26-13.26 0-7.32-5.937-13.257-13.26-13.257C9.056 3.12 3.12 9.056 3.12 16.378c0 7.323 5.936 13.26 13.258 13.26z" }, null, -1)], _9 = ["title", "hidden"], $9 = [O("path", { d: "M8.114 10L.944 2.83 0 1.885 1.886 0l.943.943L10 8.113l7.17-7.17.944-.943L20 1.886l-.943.943-7.17 7.17 7.17 7.17.943.944L18.114 20l-.943-.943-7.17-7.17-7.17 7.17-.944.943L0 18.114l.943-.943L8.113 10z" }, null, -1)], eS = ["hidden"], oS = ["aria-hidden"], rS = [Rr('<g fill="none" fill-rule="evenodd"><g transform="translate(1 1)" stroke-width="2"><circle stroke-opacity=".5" cx="18" cy="18" r="18"></circle><path d="M36 18c0-9.94-8.06-18-18-18"><animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="1s" repeatCount="indefinite"></animateTransform></path></g></g>', 1)];
function tS(o, e, r, t, n, a) {
  return k(), N("form", { action: "", role: "search", novalidate: "", class: q(o.suit("form")), onSubmit: e[4] || (e[4] = _c(function() {
    for (var s = [], i = arguments.length; i--; ) s[i] = arguments[i];
    return a.onFormSubmit && a.onFormSubmit.apply(a, s);
  }, ["prevent"])), onReset: e[5] || (e[5] = _c(function() {
    for (var s = [], i = arguments.length; i--; ) s[i] = arguments[i];
    return a.onFormReset && a.onFormReset.apply(a, s);
  }, ["prevent"])) }, [O("input", { type: "search", autocorrect: "off", autocapitalize: "off", autocomplete: "off", spellcheck: "false", maxlength: "512", "aria-label": "Search", placeholder: r.placeholder, autofocus: r.autofocus, class: q(o.suit("input")), value: r.value || r.modelValue, onFocus: e[0] || (e[0] = function(s) {
    return o.$emit("focus", s);
  }), onBlur: e[1] || (e[1] = function(s) {
    return o.$emit("blur", s);
  }), onInput: e[2] || (e[2] = function(s) {
    return a.onInput(s);
  }), onCompositionend: e[3] || (e[3] = function(s) {
    return a.onInput(s);
  }), ref: "input" }, null, 42, K9), O("button", { type: "submit", title: r.submitTitle, class: q(o.suit("submit")), hidden: r.showLoadingIndicator && r.shouldShowLoadingIndicator }, [I(o.$slots, "submit-icon", {}, function() {
    return [(k(), N("svg", { "aria-hidden": "true", width: "10", height: "10", viewBox: "0 0 40 40", class: q(o.suit("submitIcon")) }, J9, 2))];
  })], 10, Q9), O("button", { type: "reset", title: r.resetTitle, class: q(o.suit("reset")), hidden: !r.value && !r.modelValue || r.showLoadingIndicator && r.shouldShowLoadingIndicator }, [I(o.$slots, "reset-icon", {}, function() {
    return [(k(), N("svg", { "aria-hidden": "true", height: "10", viewBox: "0 0 20 20", class: q(o.suit("resetIcon")), width: "10" }, $9, 2))];
  })], 10, _9), r.showLoadingIndicator ? (k(), N("span", { key: 0, hidden: !r.shouldShowLoadingIndicator, class: q(o.suit("loadingIndicator")) }, [I(o.$slots, "loading-indicator", {}, function() {
    return [(k(), N("svg", { "aria-hidden": !r.shouldShowLoadingIndicator, "aria-label": "Results are loading", width: "16", height: "16", stroke: "#444", viewBox: "0 0 38 38", class: q(o.suit("loadingIcon")) }, rS, 10, oS))];
  })], 10, eS)) : K("", !0)], 34);
}
MF.render = tS;
Pe({ name: "RefinementList" }), xe({ connector: R6 }, { $$widgetType: "ais.refinementList" }), wo();
var vs;
const nS = ((vs = { name: "AisStateResults", mixins: [xe({ connector: !0 }), Pe({ name: "StateResults" })], props: { catchError: { type: Boolean, default: !1 } }, data: function() {
  var o = this;
  return { renderFn: function() {
    var e = o.instantSearchInstance, r = e.status, t = e.error, n = o.getParentIndex().getResults(), a = o.getParentIndex().getHelper(), s = a ? a.state : null;
    o.state = { results: n, state: s, status: r, error: t };
  } };
}, created: function() {
  this.instantSearchInstance.addListener("render", this.renderFn), this.renderFn();
} }).beforeUnmount = function() {
  this.widget && (this.instantSearchInstance.removeListener("render", this.renderFn), this.errorFn && this.instantSearchInstance.removeListener("error", this.errorFn));
}, vs.watch = { catchError: { immediate: !0, handler: function(o) {
  o ? (this.errorFn = function() {
  }, this.instantSearchInstance.addListener("error", this.errorFn)) : this.errorFn && (this.instantSearchInstance.removeListener("error", this.errorFn), this.errorFn = void 0);
} } }, vs.computed = { stateResults: function() {
  var o = this.state, e = o.results, r = o.state, t = o.status, n = o.error;
  return Nn({}, e, { results: e, state: r, status: t, error: n });
} }, vs);
var aS = O("p", null, " Use this component to have a different layout based on a certain state. ", -1), sS = O("p", null, "Fill in the slot, and get access to the following things:", -1);
function iS(o, e, r, t, n, a) {
  return o.state && o.state.state && o.state.results ? (k(), N("div", { key: 0, class: q(o.suit()) }, [I(o.$slots, "default", $c(Fh(a.stateResults)), function() {
    return [aS, sS, O("pre", null, "results: " + _(Object.keys(o.state.results)), 1), O("pre", null, "state: " + _(Object.keys(o.state.state)), 1), O("pre", null, "status: " + _(o.state.status), 1), O("pre", null, "error: " + _(o.state.error), 1)];
  })], 2)) : K("", !0);
}
nS.render = iS;
const Za = { name: "AisSearchBox", mixins: [xe({ connector: Z6 }, { $$widgetType: "ais.searchBox" }), Pe({ name: "SearchBox" })], components: { SearchInput: MF }, props: { placeholder: { type: String, default: "" }, autofocus: { type: Boolean, default: !1 }, showLoadingIndicator: { type: Boolean, default: !0 }, ignoreCompositionEvents: { type: Boolean, default: !1 }, submitTitle: { type: String, default: "Submit the search query" }, resetTitle: { type: String, default: "Clear the search query" }, value: { type: String, default: void 0 }, modelValue: { type: String, default: void 0 }, queryHook: { type: Function, default: void 0 } }, data: function() {
  return { localValue: "", isVue2: pB, isVue3: dB };
}, computed: { widgetParams: function() {
  return { queryHook: this.queryHook };
}, isControlled: function() {
  return this.value !== void 0 || this.modelValue !== void 0;
}, model: function() {
  return this.value || this.modelValue;
}, currentRefinement: { get: function() {
  this.isControlled && this.model !== this.localValue && (this.localValue = this.model, this.$emit("input", this.model), this.$emit("update:modelValue", this.model), this.state.refine(this.model));
  var o = this.$refs.searchInput;
  return o && o.isFocused() ? this.localValue : this.model || this.state.query || "";
}, set: function(o) {
  this.localValue = o, this.state.refine(o), this.isControlled && (this.$emit("input", o), this.$emit("update:modelValue", o));
} } } };
function lS(o, e, r, t, n, a) {
  var s = hh("search-input");
  return o.state ? (k(), N("div", { key: 0, class: q(o.suit()) }, [I(o.$slots, "default", { currentRefinement: a.currentRefinement, isSearchStalled: o.state.isSearchStalled, refine: o.state.refine }, function() {
    return [z(s, { onFocus: e[0] || (e[0] = function(i) {
      return o.$emit("focus", i);
    }), onBlur: e[1] || (e[1] = function(i) {
      return o.$emit("blur", i);
    }), onReset: e[2] || (e[2] = function(i) {
      return o.$emit("reset");
    }), placeholder: r.placeholder, autofocus: r.autofocus, "show-loading-indicator": r.showLoadingIndicator, "should-show-loading-indicator": o.state.isSearchStalled, "ignore-composition-events": r.ignoreCompositionEvents, "submit-title": r.submitTitle, "reset-title": r.resetTitle, "class-names": o.classNames, modelValue: a.currentRefinement, "onUpdate:modelValue": e[3] || (e[3] = function(i) {
      return a.currentRefinement = i;
    }), ref: "searchInput" }, bh({ default: j(function() {
      return [n.isVue2 ? I(o.$slots, "loading-indicator", { key: 0, slot: "loading-indicator" }) : K("", !0), n.isVue2 ? I(o.$slots, "submit-icon", { key: 1, slot: "submit-icon" }) : K("", !0), n.isVue2 ? I(o.$slots, "reset-icon", { key: 2, slot: "reset-icon" }) : K("", !0)];
    }), _: 2 }, [n.isVue3 ? { name: "loading-indicator", fn: j(function() {
      return [I(o.$slots, "loading-indicator")];
    }), key: "0" } : void 0, n.isVue3 ? { name: "submit-icon", fn: j(function() {
      return [I(o.$slots, "submit-icon")];
    }), key: "1" } : void 0, n.isVue3 ? { name: "reset-icon", fn: j(function() {
      return [I(o.$slots, "reset-icon")];
    }), key: "2" } : void 0]), 1032, ["placeholder", "autofocus", "show-loading-indicator", "should-show-loading-indicator", "ignore-composition-events", "submit-title", "reset-title", "class-names", "modelValue"])];
  })], 2)) : K("", !0);
}
Za.render = lS;
Pe({ name: "Snippet" });
Pe({ name: "SortBy" }), xe({ connector: _6 }, { $$widgetType: "ais.sortBy" }), wo();
xe({ connector: fk }, { $$widgetType: "ais.stats" }), Pe({ name: "Stats" });
Pe({ name: "ToggleRefinement" }), xe({ connector: kk }, { $$widgetType: "ais.toggleRefinement" }), wo();
xe({ connector: tD }, { $$widgetType: "ais.voiceSearch" }), Pe({ name: "VoiceSearch" });
Rr('<line x1="1" y1="1" x2="23" y2="23"></line><path d="M9 9v3a3 3 0 0 0 5.12 2.12M15 9.34V4a3 3 0 0 0-5.94-.6"></path><path d="M17 16.95A7 7 0 0 1 5 12v-2m14 0v2a7 7 0 0 1-.11 1.23"></path><line x1="12" y1="19" x2="12" y2="23"></line><line x1="8" y1="23" x2="16" y2="23"></line>', 5);
O("path", { d: "M19 10v2a7 7 0 0 1-14 0v-2" }, null, -1);
O("line", { x1: "12", y1: "19", x2: "12", y2: "23" }, null, -1);
O("line", { x1: "8", y1: "23", x2: "16", y2: "23" }, null, -1);
Pe({ name: "RelevantSort" }), xe({ connector: iD }, { $$widgetType: "ais.relevantSort" });
const cS = { name: "AisDynamicWidgets", mixins: [xe({ connector: X1 }, { $$widgetType: "ais.dynamicWidgets" }), Pe({ name: "DynamicWidgets" })], props: { transformItems: { type: Function, default: void 0 }, facets: { type: Array, default: void 0 }, maxValuesPerFacet: { type: Number, default: void 0 } }, render: Ga(function(o) {
  var e = this, r = /* @__PURE__ */ new Map();
  if ((Ap(this) || []).forEach(function(n) {
    var a = function s(i) {
      var l, c = i.props;
      if (c) {
        if (c.attribute) return c.attribute;
        if (Array.isArray(c.attributes)) return c.attributes[0];
      }
      if (l = i.children && i.children.default && i.children.default(), Array.isArray(l)) return l.reduce(function(u, f) {
        return u || s(f);
      }, void 0);
    }(n);
    a && r.set(a, o("div", { key: a, class: [e.suit("widget")] }, [n]));
  }), !this.state) {
    var t = [];
    return r.forEach(function(n) {
      return t.push(n);
    }), o("div", Nn({ class: [this.suit()] }, { attrs: { hidden: !0 } }), t);
  }
  return o("div", { class: [this.suit()] }, this.state.attributesToRender.map(function(n) {
    return r.get(n);
  }));
}), computed: { widgetParams: function() {
  return { transformItems: this.transformItems, facets: this.facets, maxValuesPerFacet: this.maxValuesPerFacet, widgets: [] };
} } };
Object.assign({}, cS, { name: "AisExperimentalDynamicWidgets", mounted: function() {
  zt("Use AisDynamicWidgets instead of AisExperimentalDynamicWidgets.");
} });
var uS = {
  prefix: "fal",
  iconName: "calendar-day",
  icon: [
    448,
    512,
    [],
    "f783",
    "M128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H64C28.7 64 0 92.7 0 128v32 32V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 160 128c0-35.3-28.7-64-64-64H352V16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H128V16zM32 192H416V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V192zM64 96H384c17.7 0 32 14.3 32 32v32H32V128c0-17.7 14.3-32 32-32zm40 160h80c4.4 0 8 3.6 8 8v80c0 4.4-3.6 8-8 8H104c-4.4 0-8-3.6-8-8V264c0-4.4 3.6-8 8-8zm-40 8v80c0 22.1 17.9 40 40 40h80c22.1 0 40-17.9 40-40V264c0-22.1-17.9-40-40-40H104c-22.1 0-40 17.9-40 40z"
  ]
}, pS = {
  prefix: "fal",
  iconName: "scale-balanced",
  icon: [
    640,
    512,
    [9878, "balance-scale"],
    "f24e",
    "M384 64c0 29.8-20.4 54.9-48 62V480H528c8.8 0 16 7.2 16 16s-7.2 16-16 16H320 112c-8.8 0-16-7.2-16-16s7.2-16 16-16H304V126c-27.6-7.1-48-32.2-48-62H112c-8.8 0-16-7.2-16-16s7.2-16 16-16H264.6C275.6 12.9 296.3 0 320 0s44.4 12.9 55.4 32H512c8.8 0 16 7.2 16 16s-7.2 16-16 16H384zm56.7 298.3C457.8 375.1 482.9 384 512 384s54.2-8.9 71.3-21.7C600.4 349.5 608 334.2 608 320H416v-1.6l0 .1V320c0 14.2 7.6 29.5 24.7 42.3zm71.3-215L426.3 288H597.7L512 147.3zM384 320v-1.6c0-14.7 4-29.1 11.7-41.6l92-151.2c5.2-8.5 14.4-13.7 24.3-13.7s19.2 5.2 24.3 13.7l92 151.2c7.6 12.5 11.7 26.9 11.7 41.6V320c0 53-57.3 96-128 96s-128-43-128-96zM32 320c0 14.2 7.6 29.5 24.7 42.3C73.8 375.1 98.9 384 128 384s54.2-8.9 71.3-21.7C216.4 349.5 224 334.2 224 320H32v-1.6l0 .1V320zm10.3-32H213.7L128 147.3 42.3 288zM128 416C57.3 416 0 373 0 320v-1.6c0-14.7 4-29.1 11.7-41.6l92-151.2c5.2-8.5 14.4-13.7 24.3-13.7s19.2 5.2 24.3 13.7l92 151.2c7.6 12.5 11.7 26.9 11.7 41.6V320c0 53-57.3 96-128 96zM320 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
  ]
}, kf = {
  prefix: "fal",
  iconName: "circle-plus",
  icon: [
    512,
    512,
    ["plus-circle"],
    "f055",
    "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM240 352c0 8.8 7.2 16 16 16s16-7.2 16-16V272h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V160c0-8.8-7.2-16-16-16s-16 7.2-16 16v80H160c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v80z"
  ]
}, dS = {
  prefix: "fal",
  iconName: "gears",
  icon: [
    640,
    512,
    ["cogs"],
    "f085",
    "M146.2 40.7l-6.9 25.1c-1.4 5.2-5.4 9.4-10.6 11c-14.6 4.6-27.9 12.4-39 22.5c-4 3.7-9.6 5.1-14.9 3.7L49.7 96.4c-2.2 3.1-4.3 6.3-6.3 9.6l-2.4 4.2c-1.8 3.3-3.5 6.6-5 10l18.3 18.5c3.8 3.9 5.4 9.4 4.2 14.7C56.8 160.7 56 168.2 56 176s.8 15.3 2.4 22.5c1.2 5.3-.4 10.8-4.2 14.7L35.9 231.8c1.5 3.4 3.2 6.7 5 10l2.5 4.3c2 3.3 4.1 6.5 6.3 9.6L74.9 249c5.3-1.4 10.9 0 14.9 3.7c11.1 10.2 24.3 17.9 39 22.5c5.2 1.6 9.2 5.8 10.6 11l6.9 25.1c4.5 .5 9.1 .7 13.8 .7s9.2-.2 13.8-.7l6.9-25.1c1.4-5.2 5.4-9.4 10.6-11c14.6-4.6 27.9-12.4 39-22.5c4-3.7 9.6-5.1 14.9-3.7l25.2 6.6c2.2-3 4.2-6.1 6.1-9.3l2.8-4.8c1.7-3.2 3.4-6.4 4.8-9.7l-18.3-18.5c-3.8-3.9-5.4-9.4-4.2-14.7c1.6-7.2 2.4-14.8 2.4-22.6s-.8-15.3-2.4-22.6c-1.2-5.3 .4-10.8 4.2-14.7l18.3-18.5c-1.5-3.3-3.1-6.5-4.8-9.7l-2.8-4.8c-1.9-3.2-4-6.3-6.1-9.3L245.1 103c-5.3 1.4-10.9 0-14.9-3.7c-11.1-10.2-24.3-17.9-39-22.5c-5.2-1.6-9.2-5.8-10.6-11l-6.9-25.1c-4.5-.5-9.1-.7-13.8-.7s-9.2 .2-13.8 .7zM130.8 10.5C140.3 8.9 150.1 8 160 8s19.7 .9 29.1 2.5c6.1 1.1 11 5.6 12.7 11.5l7.5 27.2c13.1 5.1 25.1 12.1 35.9 20.7l27.3-7.1c6-1.6 12.3 .5 16.3 5.2c5.6 6.7 10.7 13.8 15.2 21.3l.2 .3 0 0 2.9 5.1 .2 .3 0 0c4.1 7.5 7.7 15.4 10.7 23.6c2.1 5.8 .7 12.3-3.6 16.7l-19.8 20.1c1 6.8 1.6 13.7 1.6 20.7s-.5 13.9-1.6 20.7l19.8 20.1c4.3 4.4 5.8 10.9 3.6 16.7c-3 8.2-6.6 16-10.7 23.6l-.2 .3 0 0-3 5.1-.2 .3 0 0c-4.5 7.5-9.6 14.6-15.2 21.3c-4 4.7-10.3 6.8-16.3 5.2l-27.3-7.1c-10.7 8.6-22.8 15.6-35.8 20.7L201.8 330c-1.6 6-6.6 10.5-12.7 11.5c-9.5 1.7-19.2 2.5-29.1 2.5s-19.7-.9-29.2-2.5c-6.1-1.1-11-5.6-12.7-11.5l-7.5-27.2c-13.1-5.1-25.1-12.1-35.8-20.7l-27.3 7.1c-6 1.6-12.3-.5-16.3-5.2c-5.7-6.8-10.9-14-15.4-21.6l-.1-.2 0 0-2.6-4.5-.1-.2 0 0c-4.2-7.6-7.9-15.6-10.9-23.9c-2.1-5.8-.7-12.3 3.6-16.7l19.8-20.1C24.5 189.9 24 183 24 176s.5-13.9 1.6-20.7L5.7 135.2c-4.3-4.4-5.8-10.9-3.6-16.7c3-8.3 6.7-16.3 10.9-23.9l.1-.2 0 0 2.6-4.5 .1-.2 0 0C20.4 82 25.6 74.8 31.3 68c4-4.7 10.3-6.8 16.3-5.2l27.3 7.1c10.7-8.6 22.8-15.6 35.8-20.7L118.2 22c1.6-6 6.6-10.5 12.7-11.5zM104 176a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM328.7 365.8l25.1 6.9c5.2 1.4 9.4 5.4 11 10.6c4.6 14.6 12.4 27.9 22.5 39c3.7 4 5.1 9.6 3.7 14.9l-6.6 25.2c3.1 2.2 6.3 4.3 9.6 6.3l4.2 2.4c3.3 1.8 6.6 3.5 10 5l18.5-18.3c3.9-3.8 9.4-5.4 14.7-4.2c7.2 1.6 14.8 2.4 22.5 2.4s15.3-.8 22.5-2.4c5.3-1.2 10.8 .4 14.7 4.2l18.5 18.3c3.4-1.5 6.7-3.2 10-5l4.3-2.5c3.3-2 6.5-4.1 9.6-6.3L537 437.1c-1.4-5.3 0-10.9 3.7-14.9c10.2-11.1 17.9-24.3 22.5-39c1.6-5.2 5.8-9.2 11-10.6l25.1-6.9c.5-4.5 .7-9.1 .7-13.8s-.2-9.2-.7-13.8l-25.1-6.9c-5.2-1.4-9.4-5.4-11-10.6c-4.6-14.7-12.4-27.9-22.5-39c-3.7-4-5.1-9.6-3.7-14.9l6.6-25.2c-3-2.2-6.1-4.2-9.3-6.1l-4.8-2.8c-3.2-1.7-6.4-3.4-9.7-4.8l-18.5 18.3c-3.9 3.8-9.4 5.4-14.7 4.2c-7.2-1.6-14.8-2.4-22.6-2.4s-15.3 .8-22.6 2.4c-5.3 1.2-10.8-.4-14.7-4.2l-18.5-18.3c-3.3 1.5-6.5 3.1-9.7 4.8l-4.8 2.8c-3.2 1.9-6.3 4-9.3 6.1l6.6 25.2c1.4 5.3 0 10.9-3.7 14.9c-10.2 11.1-17.9 24.3-22.5 39c-1.6 5.2-5.8 9.2-11 10.6l-25.1 6.9c-.5 4.5-.7 9.1-.7 13.8s.2 9.2 .7 13.8zm-30.2 15.4c-1.7-9.5-2.5-19.2-2.5-29.2s.9-19.7 2.5-29.1c1.1-6.1 5.6-11 11.5-12.7l27.2-7.5c5.1-13.1 12.1-25.1 20.7-35.9l-7.1-27.3c-1.6-6 .5-12.3 5.2-16.3c6.7-5.6 13.8-10.7 21.3-15.2l.3-.2 0 0 5.1-2.9 .3-.2 0 0c7.5-4.1 15.4-7.7 23.6-10.7c5.8-2.1 12.3-.7 16.7 3.6l20.1 19.8c6.8-1 13.7-1.6 20.7-1.6s13.9 .5 20.7 1.6l20.1-19.8c4.4-4.3 10.9-5.8 16.7-3.6c8.2 3 16 6.6 23.6 10.7l.3 .2 0 0 5.1 3 .3 .2 0 0c7.5 4.5 14.6 9.6 21.3 15.2c4.7 4 6.7 10.3 5.2 16.3l-7.1 27.3c8.6 10.7 15.6 22.8 20.7 35.8l27.2 7.5c6 1.6 10.5 6.6 11.5 12.7c1.7 9.5 2.5 19.2 2.5 29.1s-.9 19.7-2.5 29.2c-1.1 6.1-5.6 11-11.5 12.7l-27.2 7.5c-5.1 13.1-12.1 25.1-20.7 35.8l7.1 27.3c1.6 6-.5 12.3-5.2 16.3c-6.8 5.7-14 10.9-21.6 15.4l-.2 .1 0 0-4.5 2.6-.2 .1 0 0c-7.6 4.2-15.6 7.9-23.9 10.9c-5.8 2.1-12.3 .7-16.7-3.6l-20.1-19.8c-6.8 1-13.7 1.6-20.7 1.6s-13.9-.5-20.7-1.6l-20.1 19.8c-4.4 4.3-10.9 5.8-16.7 3.6c-8.3-3-16.3-6.7-23.9-10.9l-.2-.1 0 0-4.5-2.6-.2-.1 0 0c-7.6-4.6-14.9-9.8-21.6-15.4c-4.7-4-6.8-10.3-5.2-16.3l7.1-27.3c-8.6-10.7-15.6-22.8-20.7-35.8L310 393.8c-6-1.6-10.5-6.6-11.5-12.7zM464 408a56 56 0 1 1 0-112 56 56 0 1 1 0 112zm24-56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"
  ]
}, gS = {
  prefix: "fal",
  iconName: "building-magnifying-glass",
  icon: [
    603,
    512,
    [],
    "e61c",
    "M60.6 30.1H301.5c16.6 0 30.1 13.5 30.1 30.1V180.7c9.3-7 19.4-12.9 30.1-17.6V60.2C361.7 27 334.8 0 301.5 0H60.6C27.3 0 .3 27 .3 60.2V421.6c0 33.3 27 60.2 60.2 60.2h60.2 30.1 60.2 30.1 60.2c27.5 0 50.7-18.5 57.9-43.7c-9.9-4.5-19.2-10.1-27.8-16.5c0 16.6-13.5 30.1-30.1 30.1H241.3V391.5c0-33.3-27-60.2-60.2-60.2s-60.2 27-60.2 60.2v60.2H60.6c-16.6 0-30.1-13.5-30.1-30.1V60.2c0-16.6 13.5-30.1 30.1-30.1zM278.9 210.8H233.7c-12.5 0-22.6 10.1-22.6 22.6v45.2c0 12.5 10.1 22.6 22.6 22.6h37.6c0-30.5 9.1-58.8 24.6-82.5c-4.1-4.8-10.3-7.8-17.1-7.8zM211.1 391.5v60.2H150.9V391.5c0-16.6 13.5-30.1 30.1-30.1s30.1 13.5 30.1 30.1zM60.6 112.9v45.2c0 12.5 10.1 22.6 22.6 22.6h45.2c12.5 0 22.6-10.1 22.6-22.6V112.9c0-12.5-10.1-22.6-22.6-22.6H83.1c-12.5 0-22.6 10.1-22.6 22.6zm30.1 7.5h30.1v30.1H90.7V120.5zM233.7 90.4c-12.5 0-22.6 10.1-22.6 22.6v45.2c0 12.5 10.1 22.6 22.6 22.6h45.2c12.5 0 22.6-10.1 22.6-22.6V112.9c0-12.5-10.1-22.6-22.6-22.6H233.7zm7.5 60.2V120.5h30.1v30.1H241.3zM60.6 233.4v45.2c0 12.5 10.1 22.6 22.6 22.6h45.2c12.5 0 22.6-10.1 22.6-22.6V233.4c0-12.5-10.1-22.6-22.6-22.6H83.1c-12.5 0-22.6 10.1-22.6 22.6zm30.1 7.5h30.1v30.1H90.7V240.9zm150.6 30.1V240.9h30.1v30.1H241.3zM422 211a90.4 90.4 0 1 1 0 180.7A90.4 90.4 0 1 1 422 211zm0 210.8c27.8 0 53.5-9.4 73.9-25.3L577 477.6c5.9 5.9 15.4 5.9 21.3 0s5.9-15.4 0-21.3l-81.1-81.1c15.9-20.4 25.3-46 25.3-73.9c0-66.5-53.9-120.5-120.5-120.5s-120.5 53.9-120.5 120.5s53.9 120.5 120.5 120.5z"
  ]
}, mS = {
  prefix: "fal",
  iconName: "magnifying-glass",
  icon: [
    512,
    512,
    [128269, "search"],
    "f002",
    "M384 208A176 176 0 1 0 32 208a176 176 0 1 0 352 0zM343.3 366C307 397.2 259.7 416 208 416C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208c0 51.7-18.8 99-50 135.3L507.3 484.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L343.3 366z"
  ]
}, fS = mS, yS = {
  prefix: "fal",
  iconName: "link",
  icon: [
    640,
    512,
    [128279, "chain"],
    "f0c1",
    "M591.5 256c50-50 50-131 0-181s-131-50-181 0L387.9 97.6c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l22.6-22.6c37.5-37.5 98.3-37.5 135.8 0s37.5 98.3 0 135.8L444.3 357.9c-37.4 37.4-98.1 37.4-135.6 0c-35.6-35.6-37.6-92.6-4.7-130.6l5.3-6.1c5.8-6.7 5.1-16.8-1.6-22.6s-16.8-5.1-22.6 1.6l-5.3 6.1c-43.9 50.7-41.2 126.7 6.2 174.1c49.9 49.9 130.9 49.9 180.8 0L591.5 256zM48.5 256c-50 50-50 131 0 181s131 50 181 0l22.6-22.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-22.6 22.6c-37.5 37.5-98.3 37.5-135.8 0s-37.5-98.3 0-135.8L195.7 154.1c37.4-37.4 98.1-37.4 135.6 0c35.6 35.6 37.6 92.6 4.7 130.6l-5.3 6.1c-5.8 6.7-5.1 16.8 1.6 22.6s16.8 5.1 22.6-1.6l5.3-6.1c43.9-50.7 41.2-126.7-6.2-174.1C303.9 81.5 223 81.5 173 131.4L48.5 256z"
  ]
}, hS = {
  prefix: "fal",
  iconName: "bolt",
  icon: [
    448,
    512,
    [9889, "zap"],
    "f0e7",
    "M306.8 6.3C311.4 2.2 317.3 0 323.4 0c17.2 0 29.2 17.1 23.4 33.3L278.7 224H389c14.9 0 27 12.1 27 27c0 7.8-3.3 15.1-9.1 20.3L141.1 505.8c-4.5 4-10.4 6.2-16.5 6.2c-17.2 0-29.2-17.1-23.5-33.3L169.3 288H57.8C43.6 288 32 276.4 32 262.2c0-7.4 3.2-14.4 8.7-19.3L306.8 6.3zm.5 42.4L74.1 256H192c5.2 0 10.1 2.5 13.1 6.8s3.7 9.7 2 14.6L140.6 463.6 375.8 256H256c-5.2 0-10.1-2.5-13.1-6.8s-3.7-9.7-2-14.6l66.4-186z"
  ]
}, FS = {
  prefix: "fal",
  iconName: "pipe",
  icon: [
    64,
    512,
    [],
    "7c",
    "M32 0c8.8 0 16 7.2 16 16V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V16C16 7.2 23.2 0 32 0z"
  ]
}, WF = {
  prefix: "fal",
  iconName: "house",
  icon: [
    576,
    512,
    [63498, 63500, 127968, "home", "home-alt", "home-lg-alt"],
    "f015",
    "M298.6 4c-6-5.3-15.1-5.3-21.2 0L5.4 244c-6.6 5.8-7.3 16-1.4 22.6s16 7.3 22.6 1.4L64 235V432c0 44.2 35.8 80 80 80H432c44.2 0 80-35.8 80-80V235l37.4 33c6.6 5.8 16.7 5.2 22.6-1.4s5.2-16.7-1.4-22.6L298.6 4zM96 432V206.7L288 37.3 480 206.7V432c0 26.5-21.5 48-48 48H368V320c0-17.7-14.3-32-32-32H240c-17.7 0-32 14.3-32 32V480H144c-26.5 0-48-21.5-48-48zm144 48V320h96V480H240z"
  ]
}, bS = {
  prefix: "fal",
  iconName: "eye-dropper",
  icon: [
    512,
    512,
    ["eye-dropper-empty", "eyedropper"],
    "f1fb",
    "M198.1 172.7l22.6 22.6 95.9 95.9 22.6 22.6 17.4 17.4c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l0 0-17.4-17.4 22.6-22.6 98.3-98.3c39-39 39-102.2 0-141.1s-102.2-39-141.1 0l-98.3 98.3-22.6 22.6-17.4-17.4 0 0 0 0c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l17.4 17.4zm45.3 0L364.2 51.9c26.5-26.5 69.4-26.5 95.9 0s26.5 69.4 0 95.9L339.3 268.6l-95.9-95.9zm-56.1 62.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L55.4 321.9c-15 15-23.4 35.4-23.4 56.6v41.2L3.8 469.1C1.3 473.5 0 478.4 0 483.4C0 499.2 12.8 512 28.6 512c5 0 9.9-1.3 14.2-3.8L92.2 480h41.2c21.2 0 41.6-8.4 56.6-23.4L299.3 347.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L167.4 433.9c-9 9-21.2 14.1-33.9 14.1H88 83.8l-3.7 2.1L37.7 474.3l24.2-42.4 2.1-3.7V424 378.5c0-12.7 5.1-24.9 14.1-33.9L187.3 235.3z"
  ]
}, vS = {
  prefix: "fal",
  iconName: "gear",
  icon: [
    512,
    512,
    [9881, "cog"],
    "f013",
    "M223.3 37.8c.4-1.5 1.3-2.8 2.4-3.8c9.9-1.3 20-2 30.3-2s20.4 .7 30.3 2c1.1 1 1.9 2.3 2.4 3.8l13.7 47.7c3.5 12.1 12.2 21.1 22.5 26.1c7.6 3.6 14.8 7.8 21.7 12.5c9.4 6.5 21.7 9.5 33.9 6.5l48.2-12c1.5-.4 3-.3 4.4 .2c5.4 6.9 10.4 14.2 14.9 21.8l4.3 7.4c4.2 7.5 7.9 15.3 11.2 23.3c-.3 1.5-1 2.9-2.1 4L426.8 211c-8.7 9-12.2 21.1-11.3 32.5c.3 4.1 .5 8.3 .5 12.5s-.2 8.4-.5 12.5c-.9 11.4 2.6 23.5 11.3 32.5l34.5 35.7c1.1 1.1 1.8 2.5 2.1 4c-3.3 8-7 15.8-11.2 23.4l-4.2 7.3c-4.6 7.6-9.6 14.8-14.9 21.8c-1.4 .5-2.9 .5-4.4 .2l-48.2-12c-12.2-3-24.4 0-33.9 6.5c-6.9 4.7-14.1 8.9-21.7 12.5c-10.3 4.9-19.1 14-22.5 26.1l-13.7 47.7c-.4 1.5-1.3 2.8-2.4 3.8c-9.9 1.3-20 2-30.3 2s-20.4-.7-30.3-2c-1.1-1-1.9-2.3-2.4-3.8l-13.7-47.7c-3.5-12.1-12.2-21.1-22.5-26.1c-7.6-3.6-14.8-7.8-21.7-12.5c-9.4-6.5-21.7-9.5-33.9-6.5l-48.2 12c-1.5 .4-3 .3-4.4-.2c-5.4-7-10.4-14.2-15-21.8l-4.2-7.3c-4.2-7.5-7.9-15.3-11.2-23.4c.3-1.5 1-2.9 2.1-4L85.2 301c8.7-9 12.2-21.1 11.3-32.5c-.3-4.1-.5-8.3-.5-12.5s.2-8.4 .5-12.5c.9-11.4-2.6-23.5-11.3-32.5L50.7 175.2c-1.1-1.1-1.8-2.5-2.1-4c3.3-8 7-15.8 11.2-23.4l4.2-7.3c4.6-7.6 9.6-14.8 15-21.8c1.4-.5 2.9-.5 4.4-.2l48.2 12c12.2 3 24.4 0 33.9-6.5c6.9-4.7 14.1-8.9 21.7-12.5c10.3-4.9 19.1-14 22.5-26.1l13.7-47.7zM256 0c-13 0-25.9 1-38.4 2.9c-1.7 .3-3.4 .8-5 1.6c-9.5 4.9-16.9 13.6-20 24.5L178.9 76.7c-.6 2.2-2.5 4.5-5.6 6c-9.1 4.3-17.8 9.4-26 15c-2.8 1.9-5.8 2.4-8 1.8l-48.2-12C80.2 84.8 69 86.9 60 92.6c-1.5 .9-2.8 2.1-3.9 3.5C49 105 42.4 114.3 36.5 124.1l-.1 .3L32 132l-.1 .3c-5.4 9.8-10.2 19.9-14.3 30.4c-.6 1.6-1 3.3-1.1 5c-.5 10.8 3.3 21.6 11.2 29.8l34.5 35.7c1.6 1.7 2.7 4.4 2.4 7.8c-.4 5-.6 10-.6 15s.2 10.1 .6 15c.3 3.4-.8 6.2-2.4 7.8L27.7 314.6c-7.9 8.2-11.7 19-11.2 29.8c.1 1.7 .5 3.4 1.1 5c4.1 10.5 8.9 20.6 14.3 30.4l.1 .3 4.4 7.6 .1 .3c5.9 9.8 12.4 19.2 19.6 28.1c1.1 1.4 2.4 2.6 3.9 3.5c9 5.7 20.2 7.8 31.1 5.1l48.2-12c2.2-.6 5.2-.1 8 1.8c8.2 5.7 16.9 10.7 26 15c3.1 1.5 4.9 3.8 5.6 6L192.6 483c3.1 10.8 10.5 19.5 20 24.5c1.6 .8 3.2 1.4 5 1.6C230.1 511 243 512 256 512s25.9-1 38.4-2.9c1.7-.3 3.4-.8 5-1.6c9.5-4.9 16.9-13.6 20-24.5l13.7-47.7c.6-2.2 2.5-4.5 5.6-6c9.1-4.3 17.8-9.4 26-15c2.8-1.9 5.8-2.4 8-1.8l48.2 12c10.9 2.7 22.1 .7 31.1-5.1c1.5-.9 2.8-2.1 3.9-3.5c7.1-8.9 13.6-18.2 19.5-28l.1-.3L480 380l.1-.3c5.4-9.7 10.2-19.9 14.3-30.4c.6-1.6 1-3.3 1.1-5c.5-10.8-3.3-21.6-11.2-29.8l-34.5-35.7c-1.6-1.7-2.7-4.4-2.4-7.8c.4-5 .6-10 .6-15s-.2-10.1-.6-15c-.3-3.4 .8-6.2 2.4-7.8l34.5-35.7c7.9-8.2 11.7-19 11.2-29.8c-.1-1.7-.5-3.4-1.1-5c-4.1-10.5-8.9-20.6-14.3-30.4l-.1-.3-4.4-7.6-.1-.3c-5.9-9.8-12.4-19.2-19.5-28c-1.1-1.4-2.4-2.6-3.9-3.5c-9-5.7-20.2-7.8-31.1-5.1l-48.2 12c-2.2 .6-5.2 .1-8-1.8c-8.2-5.7-16.9-10.7-26-15c-3.1-1.5-4.9-3.8-5.6-6L319.4 29c-3.1-10.8-10.5-19.5-20-24.5c-1.6-.8-3.2-1.4-5-1.6C281.9 1 269 0 256 0zM200 256a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm144 0a88 88 0 1 0 -176 0 88 88 0 1 0 176 0z"
  ]
}, BS = {
  prefix: "fal",
  iconName: "circle-info",
  icon: [
    512,
    512,
    ["info-circle"],
    "f05a",
    "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM208 352c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V240c0-8.8-7.2-16-16-16H216c-8.8 0-16 7.2-16 16s7.2 16 16 16h24v96H208zm48-168a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
  ]
}, PS = BS, wS = {
  prefix: "fal",
  iconName: "image-user",
  icon: [
    512,
    512,
    [],
    "e1b8",
    "M64 64C46.3 64 32 78.3 32 96V416c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm288 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM299.4 320H212.6c-18.6 0-34 14-36.3 32H335.7c-2.2-18-17.6-32-36.3-32zm-86.9-32H256h43.4c37.9 0 68.6 30.7 68.6 68.6c0 15.1-12.3 27.4-27.4 27.4H171.4c-15.1 0-27.4-12.3-27.4-27.4c0-37.9 30.7-68.6 68.6-68.6z"
  ]
}, kS = {
  prefix: "fal",
  iconName: "badge-check",
  icon: [
    512,
    512,
    [],
    "f336",
    "M190.6 71.4C203 47.9 227.7 32 256 32s53 15.9 65.4 39.4c3.6 6.8 11.5 10.1 18.8 7.8c25.4-7.8 54.1-1.6 74.1 18.4s26.2 48.7 18.4 74.1c-2.3 7.3 1 15.2 7.8 18.8C464.1 203 480 227.7 480 256s-15.9 53-39.4 65.4c-6.8 3.6-10.1 11.5-7.8 18.8c7.8 25.4 1.6 54.1-18.4 74.1s-48.7 26.2-74.1 18.4c-7.3-2.3-15.2 1-18.8 7.8C309 464.1 284.3 480 256 480s-53-15.9-65.4-39.4c-3.6-6.8-11.5-10.1-18.8-7.8c-25.4 7.8-54.1 1.6-74.1-18.4s-26.2-48.7-18.4-74.1c2.3-7.3-1-15.2-7.8-18.8C47.9 309 32 284.3 32 256s15.9-53 39.4-65.4c6.8-3.6 10.1-11.5 7.8-18.8c-7.8-25.4-1.6-54.1 18.4-74.1s48.7-26.2 74.1-18.4c7.3 2.3 15.2-1 18.8-7.8zM256 0c-36.1 0-68 18.1-87.1 45.6c-33-6-68.3 3.8-93.9 29.4s-35.3 60.9-29.4 93.9C18.1 188 0 219.9 0 256s18.1 68 45.6 87.1c-6 33 3.8 68.3 29.4 93.9s60.9 35.3 93.9 29.4C188 493.9 219.9 512 256 512s68-18.1 87.1-45.6c33 6 68.3-3.8 93.9-29.4s35.3-60.9 29.4-93.9C493.9 324 512 292.1 512 256s-18.1-68-45.6-87.1c6-33-3.8-68.3-29.4-93.9s-60.9-35.3-93.9-29.4C324 18.1 292.1 0 256 0zM363.3 203.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L224 297.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0l128-128z"
  ]
}, DS = {
  prefix: "fal",
  iconName: "screwdriver-wrench",
  icon: [
    512,
    512,
    ["tools"],
    "f7d9",
    "M64.7 34.6L160 107.9V160H107.9L34.6 64.7 64.7 34.6zM192 169.3c0-.4 0-.9 0-1.3V104c0-7.5-3.5-14.5-9.4-19L78.6 5C69.1-2.4 55.6-1.5 47 7L7 47c-8.5 8.5-9.4 22-2.1 31.6l80 104c4.5 5.9 11.6 9.4 19 9.4h64c.4 0 .9 0 1.3 0L271.2 293.9c-19.5 30-16.2 70.5 10.1 96.8l112 112c12.5 12.5 32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3l-112-112c-26.3-26.3-66.8-29.7-96.8-10.1L192 169.3zM304 304c17.7-17.7 46.3-17.7 64 0L480 416l-64 64L304 368c-17.7-17.7-17.7-46.3 0-64zM104 424a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM23.2 376.8C8.3 391.7 0 411.8 0 432.8C0 476.5 35.5 512 79.2 512c21 0 41.1-8.3 56-23.2L238.5 385.5c-5.7-11.2-9.3-23.1-10.9-35.3L112.1 465.7c-8.7 8.7-20.6 13.6-32.9 13.6c-25.7 0-46.6-20.8-46.6-46.6c0-12.3 4.9-24.2 13.6-32.9L189.1 257l-23.1-23.1L23.2 376.8zM479.4 160c0 44.8-23.1 84.1-58 106.8l23.5 23.5c40.7-29 67.2-76.6 67.2-130.3c0-24.8-5.7-48.3-15.7-69.3c-4.4-9.2-16.5-10.5-23.7-3.3l-67.9 67.9c-3 3-7.1 4.7-11.3 4.7H368c-8.8 0-16-7.2-16-16V118.6c0-4.2 1.7-8.3 4.7-11.3l67.9-67.9c7.2-7.2 5.9-19.3-3.3-23.7C400.3 5.7 376.8 0 352 0C296.1 0 246.9 28.6 218.3 72.1l26 20C266.8 56.3 306.7 32.6 352 32.6c10.3 0 20.2 1.2 29.7 3.5L333.6 84.2c-9.1 9.1-14.2 21.5-14.2 34.4V144c0 26.9 21.8 48.6 48.6 48.6h25.4c12.9 0 25.3-5.1 34.4-14.2l48.1-48.1c2.3 9.5 3.5 19.5 3.5 29.7z"
  ]
}, SS = {
  prefix: "fal",
  iconName: "chart-line",
  icon: [
    512,
    512,
    ["line-chart"],
    "f201",
    "M32 48c0-8.8-7.2-16-16-16S0 39.2 0 48V400c0 44.2 35.8 80 80 80H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-26.5 0-48-21.5-48-48V48zM475.3 155.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L320 265.4l-84.7-84.7c-6.2-6.2-16.4-6.2-22.6 0l-112 112c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L224 214.6l84.7 84.7c6.2 6.2 16.4 6.2 22.6 0l144-144z"
  ]
}, AS = {
  prefix: "fal",
  iconName: "memo-circle-check",
  icon: [
    576,
    512,
    [],
    "e1d9",
    "M320 32H64C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32H296.2c9.8 11.8 21 22.3 33.5 31.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V198.6c-11.2 3.2-21.9 7.4-32 12.6V64c0-17.7-14.3-32-32-32zM64 144c0-8.8 7.2-16 16-16H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm16 80H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 96H208c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zM432 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm44.7 100.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L416 385.4l60.7-60.7z"
  ]
}, ES = {
  prefix: "fal",
  iconName: "comments-dollar",
  icon: [
    640,
    512,
    [],
    "f653",
    "M208 32C105.7 32 32 101.2 32 176c0 37.1 18 68.2 45.1 96.6c4.8 5 5.8 12.5 2.5 18.6c-10.9 20.2-22.7 40.8-37.6 59.9c31.3-3 63.2-13.2 91.5-26c6-2.7 11.9-5.6 18-8.7c3.2-1.6 6.8-2.1 10.2-1.4c15.6 3.1 30.9 5 46.3 5c102.3 0 176-69.2 176-144s-73.7-144-176-144zM0 176C0 78.9 93.1 0 208 0S416 78.9 416 176s-93.1 176-208 176c-16.1 0-31.7-1.8-47-4.6c-4.6 2.3-9.4 4.6-14.3 6.8C110.5 370.7 67 384 24 384c-9.6 0-18.2-5.7-22-14.5c-3.8-8.7-2-18.9 4.4-25.8l.1-.1 0 0C22 326.6 34.3 307.1 46 286C19.8 256.1 0 220.2 0 176zm441.8-47.8C552.2 132.5 640 209.6 640 304c0 44.2-19.8 80.1-46 110c11.7 21 24 40.6 39.5 57.5l0 0 .1 .1c6.5 7 8.2 17.1 4.4 25.8c-3.8 8.8-12.5 14.5-22 14.5c-43 0-86.5-13.3-122.7-29.7c-4.9-2.2-9.6-4.5-14.3-6.8c-15.3 2.8-30.9 4.6-47 4.6c-82.1 0-153-40.2-186.8-98.5c11.5-1.6 22.8-3.9 33.8-6.8C308.4 417.3 363.8 448 432 448c15.3 0 30.6-1.9 46.3-5c3.5-.7 7.1-.2 10.2 1.4c6.1 3.1 12 6 18 8.7c28.4 12.9 60.2 23.1 91.5 26c-14.9-19-26.8-39.7-37.6-59.9c-3.3-6.1-2.3-13.6 2.5-18.6C590 372.2 608 341.1 608 304c0-71-66.4-137-160.6-143.5c-.9-11.1-2.8-21.9-5.6-32.3zM224 83.6V97.4c7.2 1.1 14.1 2.7 20.5 4.4c8.5 2.2 13.7 11 11.4 19.5s-11 13.7-19.5 11.4c-10-2.6-19.7-4.5-28.6-4.7c-7.4-.1-15.1 1.6-20.5 4.7c-4.8 2.8-6.5 5.8-6.4 9.8c0 2.3 .6 4.4 5.7 7.4c6 3.6 14.5 6.2 25.9 9.6l.5 .2 0 0c10.1 3 22.9 6.8 33 13.1c11.2 7 21 18.2 21.2 35.5c.2 18-9.1 30.9-21.5 38.5c-6.7 4.1-14.2 6.7-21.7 8v13.7c0 8.8-7.2 16-16 16s-16-7.2-16-16V254.1c-9.7-1.9-18.8-5-26.7-7.7l0 0 0 0c-1.9-.7-3.8-1.3-5.5-1.9c-8.4-2.8-13-11.8-10.2-20.2s11.8-13 20.2-10.2c2.2 .7 4.4 1.5 6.5 2.2l0 0c12.2 4.1 21.9 7.4 32.3 7.7c8 .3 15.6-1.5 20.5-4.5c4.2-2.6 6.3-5.7 6.2-10.8c0-3.2-1.1-5.6-6.1-8.7c-5.9-3.7-14.5-6.4-25.7-9.8l-1.5-.4 0 0c-9.8-2.9-22-6.6-31.6-12.3c-11-6.6-21.2-17.4-21.3-34.7c-.1-18.1 10.2-30.5 22.3-37.6c6.5-3.8 13.7-6.2 20.8-7.6V83.6c0-8.8 7.2-16 16-16s16 7.2 16 16z"
  ]
}, xS = {
  prefix: "fal",
  iconName: "layer-group",
  icon: [
    576,
    512,
    [],
    "f5fd",
    "M266.2 4.7C273 1.6 280.5 0 288 0s15 1.6 21.8 4.7l217.4 97.5c10.2 4.6 16.8 14.7 16.8 25.9s-6.6 21.3-16.8 25.9L309.8 251.3c-6.9 3.1-14.3 4.7-21.8 4.7s-15-1.6-21.8-4.7L48.8 153.9C38.6 149.3 32 139.2 32 128s6.6-21.3 16.8-25.9L266.2 4.7zM288 32c-3 0-6 .6-8.8 1.9L69.3 128l210 94.1c2.8 1.2 5.7 1.9 8.8 1.9s6-.6 8.8-1.9l210-94.1-210-94.1C294 32.6 291 32 288 32zM48.8 358.1l45.9-20.6 39.1 17.5L69.3 384l210 94.1c2.8 1.2 5.7 1.9 8.8 1.9s6-.6 8.8-1.9l210-94.1-64.5-28.9 39.1-17.5 45.9 20.6c10.2 4.6 16.8 14.7 16.8 25.9s-6.6 21.3-16.8 25.9L309.8 507.3c-6.9 3.1-14.3 4.7-21.8 4.7s-15-1.6-21.8-4.7L48.8 409.9C38.6 405.3 32 395.2 32 384s6.6-21.3 16.8-25.9zM94.7 209.5l39.1 17.5L69.3 256l210 94.1c2.8 1.2 5.7 1.9 8.8 1.9s6-.6 8.8-1.9l210-94.1-64.5-28.9 39.1-17.5 45.9 20.6c10.2 4.6 16.8 14.7 16.8 25.9s-6.6 21.3-16.8 25.9L309.8 379.3c-6.9 3.1-14.3 4.7-21.8 4.7s-15-1.6-21.8-4.7L48.8 281.9C38.6 277.3 32 267.2 32 256s6.6-21.3 16.8-25.9l45.9-20.6z"
  ]
}, CS = {
  prefix: "fal",
  iconName: "person-shelter",
  icon: [
    512,
    512,
    [],
    "e54f",
    "M264.2 2.3c-5.1-3-11.4-3-16.5 0l-240 144C2.9 149.2 0 154.4 0 160V496c0 8.8 7.2 16 16 16s16-7.2 16-16V169.1L256 34.7 480 169.1V496c0 8.8 7.2 16 16 16s16-7.2 16-16V160c0-5.6-2.9-10.8-7.8-13.7l-240-144zM240 168a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-72 97.5c3.8-1 7.7-1.5 11.8-1.5h24.5c4 0 8 .5 11.8 1.5V368H232V265.5zM232 400h48v96c0 8.8 7.2 16 16 16s16-7.2 16-16V291.5l42.4 68.9c4.6 7.5 14.5 9.9 22 5.2s9.9-14.5 5.2-22l-45.3-73.5C321.8 246.4 296 232 268.2 232H243.8c-27.8 0-53.6 14.4-68.1 38.1l-45.3 73.5c-4.6 7.5-2.3 17.4 5.2 22s17.4 2.3 22-5.2L200 291.5V496c0 8.8 7.2 16 16 16s16-7.2 16-16V400z"
  ]
}, NF = {
  prefix: "fal",
  iconName: "circle-check",
  icon: [
    512,
    512,
    [61533, "check-circle"],
    "f058",
    "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM363.3 203.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L224 297.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0l128-128z"
  ]
}, VF = {
  prefix: "fal",
  iconName: "clipboard",
  icon: [
    384,
    512,
    [128203],
    "f328",
    "M192 32c-22.3 0-41.2 15.3-46.5 36c-1.8 7.1-8.2 12-15.5 12H112c-8.8 0-16 7.2-16 16v32h96 96V96c0-8.8-7.2-16-16-16H254c-7.3 0-13.7-4.9-15.5-12c-5.3-20.7-24.1-36-46.5-36zM118.7 48C131 19.8 159.2 0 192 0s61 19.8 73.3 48H272c20.9 0 38.7 13.4 45.3 32H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V144c0-35.3 28.7-64 64-64h2.7C73.3 61.4 91.1 48 112 48h6.7zM320 128c0 17.7-14.3 32-32 32H192 96c-17.7 0-32-14.3-32-32V112c-17.7 0-32 14.3-32 32V448c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32v16zM192 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
  ]
}, OS = {
  prefix: "fal",
  iconName: "paper-plane-top",
  icon: [
    512,
    512,
    ["paper-plane-alt", "send"],
    "e20a",
    "M3.4 78.3c-6-12-3.9-26.5 5.3-36.3s23.5-12.7 35.9-7.5l448 192c11.8 5 19.4 16.6 19.4 29.4s-7.6 24.4-19.4 29.4l-448 192c-12.3 5.3-26.7 2.3-35.9-7.5s-11.3-24.3-5.3-36.3L92.2 256 3.4 78.3zM120 272L32 448 442.7 272H120zm322.7-32L32 64l88 176H442.7z"
  ]
}, TS = {
  prefix: "fal",
  iconName: "calendar-star",
  icon: [
    448,
    512,
    [],
    "f736",
    "M128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H64C28.7 64 0 92.7 0 128v32 32V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 160 128c0-35.3-28.7-64-64-64H352V16c0-8.8-7.2-16-16-16s-16 7.2-16 16V64H128V16zM32 192H416V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V192zM64 96H384c17.7 0 32 14.3 32 32v32H32V128c0-17.7 14.3-32 32-32zM245.5 231.5c-8.8-17.8-34.2-17.8-43 0l-22 44.6-49.2 7.2c-19.7 2.9-27.5 27.1-13.3 40.9l35.6 34.7-8.4 49c-3.4 19.6 17.2 34.6 34.8 25.3l44-23.2 44 23.2c17.6 9.3 38.2-5.7 34.8-25.3l-8.4-49 35.6-34.7c14.2-13.9 6.4-38.1-13.3-40.9l-49.2-7.2-22-44.6zm-40.1 66.3L224 260.2l18.6 37.6 3.7 7.5 8.3 1.2 41.5 6-30 29.3-6 5.9 1.4 8.3 7.1 41.4-37.1-19.5-7.4-3.9-7.4 3.9-37.1 19.5 7.1-41.4 1.4-8.3-6-5.9-30-29.3 41.5-6 8.3-1.2 3.7-7.5z"
  ]
}, LS = {
  prefix: "fal",
  iconName: "star",
  icon: [
    576,
    512,
    [11088, 61446],
    "f005",
    "M226.5 168.8L287.9 42.3l61.4 126.5c4.6 9.5 13.6 16.1 24.1 17.7l137.4 20.3-99.8 98.8c-7.4 7.3-10.8 17.8-9 28.1l23.5 139.5L303 407.7c-9.4-5-20.7-5-30.2 0L150.2 473.2l23.5-139.5c1.7-10.3-1.6-20.7-9-28.1L65 206.8l137.4-20.3c10.5-1.5 19.5-8.2 24.1-17.7zM424.9 509.1c8.1 4.3 17.9 3.7 25.3-1.7s11.2-14.5 9.7-23.5L433.6 328.4 544.8 218.2c6.5-6.4 8.7-15.9 5.9-24.5s-10.3-14.9-19.3-16.3L378.1 154.8 309.5 13.5C305.5 5.2 297.1 0 287.9 0s-17.6 5.2-21.6 13.5L197.7 154.8 44.5 177.5c-9 1.3-16.5 7.6-19.3 16.3s-.5 18.1 5.9 24.5L142.2 328.4 116 483.9c-1.5 9 2.2 18.1 9.7 23.5s17.3 6 25.3 1.7l137-73.2 137 73.2z"
  ]
}, jS = {
  prefix: "fal",
  iconName: "file-chart-column",
  icon: [
    384,
    512,
    ["file-chart-line"],
    "f659",
    "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H192V144c0 26.5 21.5 48 48 48H352V448c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16V32.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zM208 240c0-8.8-7.2-16-16-16s-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V240zm96 64c0-8.8-7.2-16-16-16s-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V304zM112 368c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V368z"
  ]
}, MS = jS, WS = {
  prefix: "fal",
  iconName: "globe",
  icon: [
    512,
    512,
    [127760],
    "f0ac",
    "M256 480c16.7 0 40.4-14.4 61.9-57.3c9.9-19.8 18.2-43.7 24.1-70.7H170c5.9 27 14.2 50.9 24.1 70.7C215.6 465.6 239.3 480 256 480zM164.3 320H347.7c2.8-20.2 4.3-41.7 4.3-64s-1.5-43.8-4.3-64H164.3c-2.8 20.2-4.3 41.7-4.3 64s1.5 43.8 4.3 64zM170 160H342c-5.9-27-14.2-50.9-24.1-70.7C296.4 46.4 272.7 32 256 32s-40.4 14.4-61.9 57.3C184.2 109.1 175.9 133 170 160zm210 32c2.6 20.5 4 41.9 4 64s-1.4 43.5-4 64h90.8c6-20.3 9.3-41.8 9.3-64s-3.2-43.7-9.3-64H380zm78.5-32c-25.9-54.5-73.1-96.9-130.9-116.3c21 28.3 37.6 68.8 47.2 116.3h83.8zm-321.1 0c9.6-47.6 26.2-88 47.2-116.3C126.7 63.1 79.4 105.5 53.6 160h83.7zm-96 32c-6 20.3-9.3 41.8-9.3 64s3.2 43.7 9.3 64H132c-2.6-20.5-4-41.9-4-64s1.4-43.5 4-64H41.3zM327.5 468.3c57.8-19.5 105-61.8 130.9-116.3H374.7c-9.6 47.6-26.2 88-47.2 116.3zm-143 0c-21-28.3-37.5-68.8-47.2-116.3H53.6c25.9 54.5 73.1 96.9 130.9 116.3zM256 512A256 256 0 1 1 256 0a256 256 0 1 1 0 512z"
  ]
}, NS = {
  prefix: "fal",
  iconName: "key",
  icon: [
    512,
    512,
    [128273],
    "f084",
    "M192 176c0-79.5 64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144c-11.1 0-22-1.3-32.4-3.6c-5.4-1.2-11 .4-14.9 4.3L257.4 352H208c-8.8 0-16 7.2-16 16v48H144c-8.8 0-16 7.2-16 16v48H32V398.6L194.8 235.8c4.2-4.2 5.7-10.5 3.9-16.2c-4.4-13.8-6.7-28.4-6.7-43.7zM336 0C238.8 0 160 78.8 160 176c0 15.1 1.9 29.8 5.5 43.9L4.7 380.7c-3 3-4.7 7.1-4.7 11.3V496c0 8.8 7.2 16 16 16H144c8.8 0 16-7.2 16-16V448h48c8.8 0 16-7.2 16-16V384h40c4.2 0 8.3-1.7 11.3-4.7l30-30c10 1.8 20.2 2.7 30.7 2.7c97.2 0 176-78.8 176-176S433.2 0 336 0zm32 168a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
  ]
}, zF = {
  prefix: "fal",
  iconName: "eye-slash",
  icon: [
    640,
    512,
    [],
    "f070",
    "M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM605.5 268.3c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-51.2 0-96 14.8-133.9 36.8l27.3 21.5C244.6 74.2 280.2 64 320 64c70.4 0 127.7 32 170.8 72c43.1 40 71.9 88 85.2 120c-9.2 22.1-25.9 52-49.5 81.5l25.1 19.8c25.6-32 43.7-64.4 53.9-89zM88.4 154.7c-25.6 32-43.7 64.4-53.9 89c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c51.2 0 96-14.8 133.9-36.8l-27.3-21.5C395.4 437.8 359.8 448 320 448c-70.4 0-127.7-32-170.8-72C106.1 336 77.3 288 64 256c9.2-22.1 25.9-52 49.5-81.5L88.4 154.7zM320 384c16.7 0 32.7-3.2 47.4-9.1l-30.9-24.4c-5.4 .9-10.9 1.4-16.5 1.4c-51 0-92.8-39.8-95.8-90.1l-30.9-24.4c-.9 6-1.3 12.2-1.3 18.5c0 70.7 57.3 128 128 128zM448 256c0-70.7-57.3-128-128-128c-16.7 0-32.7 3.2-47.4 9.1l30.9 24.4c5.4-.9 10.9-1.4 16.5-1.4c51 0 92.8 39.8 95.8 90.1l30.9 24.4c.9-6 1.3-12.2 1.3-18.5z"
  ]
}, VS = {
  prefix: "fal",
  iconName: "users",
  icon: [
    640,
    512,
    [],
    "f0c0",
    "M96 80a48 48 0 1 1 96 0A48 48 0 1 1 96 80zm128 0A80 80 0 1 0 64 80a80 80 0 1 0 160 0zm96 80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 160a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm-58.7 64H378.7c54.2 0 98.4 42.5 101.2 96H160.1c2.8-53.5 47-96 101.2-96zm0-32C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7H485.3c14.7 0 26.7-11.9 26.7-26.7C512 411.7 452.3 352 378.7 352H261.3zM512 32a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128A80 80 0 1 0 512 0a80 80 0 1 0 0 160zm16 64c44.2 0 80 35.8 80 80c0 8.8 7.2 16 16 16s16-7.2 16-16c0-61.9-50.1-112-112-112H444c2.6 10.2 4 21 4 32h80zm-336 0c0-11 1.4-21.8 4-32H112C50.1 192 0 242.1 0 304c0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.2 35.8-80 80-80h80z"
  ]
}, zS = {
  prefix: "fal",
  iconName: "lightbulb-on",
  icon: [
    640,
    512,
    [],
    "f672",
    "M55.2 1.7c-7.9-4-17.5-.7-21.5 7.2s-.7 17.5 7.2 21.5l64 32c7.9 4 17.5 .7 21.5-7.2s.7-17.5-7.2-21.5l-64-32zm544 28.6c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2l-64 32c-7.9 4-11.1 13.6-7.2 21.5s13.6 11.1 21.5 7.2l64-32zM16 160c-8.8 0-16 7.2-16 16s7.2 16 16 16H80c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zm544 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H560zM119.2 318.3c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2l-64 32c-7.9 4-11.1 13.6-7.2 21.5s13.6 11.1 21.5 7.2l64-32zm416-28.6c-7.9-4-17.5-.7-21.5 7.2s-.7 17.5 7.2 21.5l64 32c7.9 4 17.5 .7 21.5-7.2s.7-17.5-7.2-21.5l-64-32zM464 176c0 30.6-9.5 58.8-25.7 82.1c-4.1 5.9-8.7 12.3-13.6 19c-12.7 17.5-27.1 37.2-38 57.1c-8.9 16.2-13.7 33.3-16.2 49.9H403c2.2-12 5.9-23.7 11.8-34.5c9.9-18 22.2-34.9 34.5-51.8l0 0 0 0 0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C496 78.8 417.2 0 320 0S144 78.8 144 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4l0 0 0 0 0 0c12.3 16.8 24.6 33.7 34.5 51.8c5.9 10.8 9.6 22.5 11.8 34.5h32.4c-2.5-16.6-7.3-33.7-16.2-49.9c-10.9-20-25.3-39.7-38-57.1l0 0c-4.9-6.7-9.5-13-13.6-19C185.5 234.8 176 206.6 176 176c0-79.5 64.5-144 144-144s144 64.5 144 144zm-224 0c0-44.2 35.8-80 80-80c8.8 0 16-7.2 16-16s-7.2-16-16-16c-61.9 0-112 50.1-112 112c0 8.8 7.2 16 16 16s16-7.2 16-16zm80 304c-20.9 0-38.7-13.4-45.3-32h90.5c-6.6 18.6-24.4 32-45.3 32zm-80-53.3V432c0 44.2 35.8 80 80 80s80-35.8 80-80v-5.3c0-5.9-4.8-10.7-10.7-10.7H250.7c-5.9 0-10.7 4.8-10.7 10.7z"
  ]
}, IS = {
  prefix: "fal",
  iconName: "arrow-progress",
  icon: [
    512,
    512,
    [],
    "e5df",
    "M281.6 3.2c-7.1-5.3-17.1-3.9-22.4 3.2s-3.9 17.1 3.2 22.4L288 48H112C50.1 48 0 98.1 0 160s50.1 112 112 112H400c44.2 0 80 35.8 80 80c0 39.5-28.7 72.3-66.3 78.8c-7.5-27-32.3-46.8-61.7-46.8c-35.3 0-64 28.7-64 64s28.7 64 64 64c30.1 0 55.4-20.8 62.2-48.9C469.4 456.1 512 409 512 352c0-61.9-50.1-112-112-112H112c-44.2 0-80-35.8-80-80s35.8-80 80-80H288L262.4 99.2c-7.1 5.3-8.5 15.3-3.2 22.4s15.3 8.5 22.4 3.2l64-48c4-3 6.4-7.8 6.4-12.8s-2.4-9.8-6.4-12.8l-64-48zM351.9 480a32 32 0 1 1 .1-64 32 32 0 1 1 -.1 64zM448 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96A64 64 0 1 0 448 0a64 64 0 1 0 0 128zM126 432c-7.1-27.6-32.2-48-62-48c-35.3 0-64 28.7-64 64s28.7 64 64 64c29.8 0 54.9-20.4 62-48h66l-25.6 19.2c-7.1 5.3-8.5 15.3-3.2 22.4s15.3 8.5 22.4 3.2l64-48c4-3 6.4-7.8 6.4-12.8s-2.4-9.8-6.4-12.8l-64-48c-7.1-5.3-17.1-3.9-22.4 3.2s-3.9 17.1 3.2 22.4L192 432H126zM32 448a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
  ]
}, RS = {
  prefix: "fal",
  iconName: "browsers",
  icon: [
    576,
    512,
    [],
    "e0cb",
    "M512 32c17.7 0 32 14.3 32 32V96H256V32H512zM160 32h64V96H128V64c0-17.7 14.3-32 32-32zM128 352V128H240 544V352c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32zM160 0C124.7 0 96 28.7 96 64V352c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H160zM32 112c0-8.8-7.2-16-16-16s-16 7.2-16 16V384c0 70.7 57.3 128 128 128H464c8.8 0 16-7.2 16-16s-7.2-16-16-16H128c-53 0-96-43-96-96V112z"
  ]
}, HS = {
  prefix: "fal",
  iconName: "calendar-days",
  icon: [
    448,
    512,
    ["calendar-alt"],
    "f073",
    "M112 0c8.8 0 16 7.2 16 16V64H320V16c0-8.8 7.2-16 16-16s16 7.2 16 16V64h32c35.3 0 64 28.7 64 64v32 32V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192 160 128C0 92.7 28.7 64 64 64H96V16c0-8.8 7.2-16 16-16zM416 192H312v72H416V192zm0 104H312v80H416V296zm0 112H312v72h72c17.7 0 32-14.3 32-32V408zM280 376V296H168v80H280zM168 408v72H280V408H168zm-32-32V296H32v80H136zM32 408v40c0 17.7 14.3 32 32 32h72V408H32zm0-144H136V192H32v72zm136 0H280V192H168v72zM384 96H64c-17.7 0-32 14.3-32 32v32H416V128c0-17.7-14.3-32-32-32z"
  ]
};
const YS = { class: "relative rounded-md shadow-sm" }, qS = {
  key: 1,
  class: "absolute inset-y-0 right-0 flex py-1.5 pr-1.5"
}, GS = { class: "inline-flex items-center rounded border border-default-200 px-1 font-sans text-xs text-default-400" }, XS = ["id", "disabled", "tabindex", "aria-disabled", "aria-invalid", "aria-describedby", "type"], US = ["disabled", "tabindex", "aria-disabled"], Ut = /* @__PURE__ */ H({
  inheritAttrs: !1,
  __name: "Input",
  props: /* @__PURE__ */ yr({
    disabled: { type: Boolean },
    invalid: { type: Boolean },
    keyboardShortcut: { default: void 0 },
    leadingIcon: { default: void 0 },
    trailingIcon: { default: void 0 },
    type: { default: "text" }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(o, { expose: e }) {
    const r = o, t = hr(o, "modelValue"), n = ue(), [a, s] = Po(!1), i = se(() => r.type === "password"), l = ce("field-id", null), c = ce("has-hint", !1), u = se(() => {
      if (r.invalid)
        return `${l}-error`;
      if (c)
        return `${l}-hint`;
    });
    return e({
      input: n
    }), (f, g) => (k(), N("div", YS, [
      f.leadingIcon || f.trailingIcon ? (k(), N("div", {
        key: 0,
        class: q([
          "pointer-events-none absolute inset-y-0 flex items-center",
          f.leadingIcon && "left-0 pl-3",
          f.trailingIcon && "right-0 pr-3"
        ])
      }, [
        z(B(le), {
          icon: f.leadingIcon ?? f.trailingIcon,
          class: "h-4 w-4 text-default-400",
          "aria-hidden": "true"
        }, null, 8, ["icon"])
      ], 2)) : K("", !0),
      f.keyboardShortcut ? (k(), N("div", qS, [
        O("kbd", GS, _(f.keyboardShortcut), 1)
      ])) : K("", !0),
      co(O("input", Ve({
        id: B(l) ?? void 0,
        ref_key: "input",
        ref: n,
        "onUpdate:modelValue": g[0] || (g[0] = (d) => t.value = d),
        class: [
          "block w-full rounded-md border-0 py-1.5 text-default-900 outline outline-1 -outline-offset-1 outline-default-300",
          "placeholder:text-default-400",
          "focus:ring-0 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-primary-600",
          "sm:text-sm sm:leading-6",
          f.leadingIcon && "pl-10",
          (f.trailingIcon || f.keyboardShortcut || i.value) && "pr-10",
          f.disabled && "disabled:opacity-50 disabled:pointer-events-none"
        ],
        disabled: f.disabled,
        tabindex: f.disabled ? "-1" : 0,
        "aria-disabled": f.disabled,
        "aria-invalid": !!f.invalid,
        "aria-describedby": u.value,
        type: B(a) ? "text" : f.type
      }, f.$attrs), null, 16, XS), [
        [vh, t.value]
      ]),
      i.value && !f.trailingIcon ? (k(), N("button", {
        key: 2,
        class: q([
          "absolute inset-y-0 right-0 flex items-center rounded-md px-3",
          "focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary-600",
          f.disabled && "disabled:opacity-50 disabled:pointer-events-none"
        ]),
        type: "button",
        disabled: f.disabled,
        tabindex: f.disabled ? "-1" : 0,
        "aria-disabled": f.disabled,
        onClick: g[1] || (g[1] = () => B(s)())
      }, [
        z(B(le), {
          icon: B(zF),
          class: q([B(a) ? "text-neutral-800" : "text-default-400", "size-5 cursor-pointer"]),
          "aria-hidden": "true"
        }, null, 8, ["icon", "class"]),
        g[2] || (g[2] = O("span", { class: "sr-only" }, " Show password ", -1))
      ], 10, US)) : K("", !0)
    ]));
  }
}), ZS = /* @__PURE__ */ H({
  __name: "ModalTitle",
  setup(o) {
    return (e, r) => (k(), R(Vo, { as: B(yi) }, {
      default: j(() => [
        I(e.$slots, "default")
      ]),
      _: 3
    }, 8, ["as"]));
  }
}), KS = {
  class: /* @__PURE__ */ q([
    "flex min-h-full items-start justify-center p-4 text-center",
    "sm:items-center"
  ])
}, IF = /* @__PURE__ */ H({
  inheritAttrs: !1,
  __name: "Modal",
  props: {
    open: { type: Boolean, default: !1 },
    color: { default: "white" },
    fullHeight: { type: Boolean, default: !1 },
    scrollable: { type: Boolean, default: !1 },
    size: { default: "base" }
  },
  emits: ["close"],
  setup(o, { emit: e }) {
    const r = o, t = e;
    he("scrollable", r.fullHeight ? !0 : r.scrollable), he("color", r.color), he("emit", t);
    const n = /* @__PURE__ */ new Map([
      ["sm", "sm:max-w-md"],
      ["base", "sm:max-w-lg"],
      ["lg", "sm:max-w-2xl"],
      ["xl", "sm:max-w-4xl"],
      ["2xl", "sm:max-w-6xl"],
      ["full", "sm:max-w-screen"]
    ]);
    return (a, s) => (k(), R(B(Wa), {
      appear: "",
      show: a.open,
      as: "template"
    }, {
      default: j(() => [
        z(B(Na), {
          as: "div",
          class: "relative z-[60]",
          onClose: s[0] || (s[0] = (i) => t("close"))
        }, {
          default: j(() => [
            z(B(tr), {
              as: "template",
              enter: "duration-300 ease-out",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "duration-200 ease-in",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: j(() => s[1] || (s[1] = [
                O("div", { class: "fixed inset-0 bg-black/25" }, null, -1)
              ])),
              _: 1
            }),
            O("div", {
              class: q([
                "fixed inset-0 w-screen",
                (!a.scrollable || !a.fullHeight) && "overflow-y-auto"
              ])
            }, [
              O("div", KS, [
                z(B(tr), {
                  as: "template",
                  enter: "ease-out duration-300",
                  "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                  "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                  leave: "ease-in duration-200",
                  "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                  "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                }, {
                  default: j(() => [
                    z(B(Va), Ve({
                      class: [
                        "relative w-full transform rounded-lg bg-white text-left shadow-xl transition-all divide-y divide-default-300",
                        "sm:my-8",
                        B(n).get(a.size),
                        (a.scrollable || a.fullHeight) && "flex flex-col max-h-[calc(100dvh-2rem)] md:max-h-[calc(100dvh-6rem)]",
                        // Apply top border radius to ModalContent if there is no ModalHeader
                        "[&:not(:has([data-slot=modal-header]))_[data-slot=modal-content]]:rounded-t-lg",
                        // Apply bottom border radius to ModalContent if there is no ModalFooter
                        "[&:not(:has([data-slot=modal-footer]))_[data-slot=modal-content]]:rounded-b-lg",
                        a.fullHeight && "h-[calc(100dvh-2rem)] md:h-[calc(100dvh-6rem)]"
                      ]
                    }, a.$attrs), {
                      default: j(() => [
                        I(a.$slots, "default")
                      ]),
                      _: 3
                    }, 16, ["class"])
                  ]),
                  _: 3
                })
              ])
            ], 2)
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["show"]));
  }
}), QS = {
  class: "py-2 pl-6 pr-2 flex items-center justify-between gap-2",
  "data-slot": "modal-header"
}, JS = { class: "flex-none flex gap-2" }, _S = { class: "flex-none flex gap-2" }, $S = /* @__PURE__ */ H({
  __name: "ModalHeader",
  setup(o) {
    const e = ce("emit");
    return (r, t) => (k(), N("div", QS, [
      O("div", JS, [
        I(r.$slots, "default")
      ]),
      O("div", _S, [
        I(r.$slots, "buttons"),
        z(Re, {
          color: "tertiary",
          ariaLabel: "Close",
          type: "button",
          icon: B(Hr),
          onClick: t[0] || (t[0] = (n) => B(e) && B(e)("close"))
        }, null, 8, ["icon"])
      ])
    ]));
  }
}), e8 = /* @__PURE__ */ H({
  __name: "ModalContent",
  setup(o) {
    const e = ce("scrollable"), r = ce("color"), t = /* @__PURE__ */ new Map([
      ["white", "bg-white"],
      ["gray", "bg-default-100"]
    ]);
    return (n, a) => (k(), N("div", {
      class: q([
        "p-6",
        B(e) && "flex-1 overflow-y-auto",
        B(t).get(B(r) ?? "white")
      ]),
      "data-slot": "modal-content"
    }, [
      I(n.$slots, "default")
    ], 2));
  }
}), o8 = ["id"], r8 = {
  role: "listbox",
  class: "divide-y divide-default-200"
}, t8 = ["onClick"], uI = /* @__PURE__ */ H({
  inheritAttrs: !1,
  __name: "AddressSearchModal",
  props: {
    config: {},
    open: { type: Boolean, default: !1 }
  },
  emits: ["close", "update:modelValue"],
  setup(o, { emit: e }) {
    const r = o, t = e, n = fo(), { searchClient: a } = vi(r.config.hostUrl, r.config.apiKey), s = ue(), i = ue(""), [l, c] = Po(!1);
    Bi(s, (d) => {
      Gb(() => {
        d.input.focus();
      });
    });
    const u = pt((d, p) => {
      c(!0), i.value = p, d(p);
    }, 300), f = (d) => {
      t("update:modelValue", d.barcode);
    }, g = async () => {
      t("close"), await $u(200), i.value = "";
    };
    return (d, p) => (k(), R(IF, {
      open: d.open,
      scrollable: "",
      onClose: g
    }, {
      default: j(() => [
        z($S, null, {
          default: j(() => [
            z(ZS, null, {
              default: j(() => p[0] || (p[0] = [
                ne(" Find your address ")
              ])),
              _: 1
            })
          ]),
          _: 1
        }),
        z(e8, null, {
          default: j(() => [
            I(d.$slots, "default"),
            z(B(Ci), {
              class: "space-y-base",
              "search-client": B(a),
              "index-name": "addresses:building_number:asc",
              future: { preserveSharedStateOnUnmount: !0 }
            }, {
              default: j(() => [
                z(B(pF), { hitsPerPage: 100 }),
                z(B(Za), { class: "flex-none" }, {
                  default: j(({ refine: m }) => [
                    z(Ut, Ve({
                      ref_key: "refInput",
                      ref: s,
                      "model-value": i.value,
                      type: "search",
                      "aria-controls": B(n),
                      "aria-expanded": B(l)
                    }, d.$attrs, {
                      "onUpdate:modelValue": (y) => B(u)(m, y)
                    }), null, 16, ["model-value", "aria-controls", "aria-expanded", "onUpdate:modelValue"])
                  ]),
                  _: 1
                }),
                i.value.length ? (k(), R(B(BD), {
                  key: 0,
                  class: "-mx-6"
                }, {
                  default: j(({ items: m }) => [
                    O("div", {
                      id: B(n),
                      class: q([
                        "w-full text-base",
                        "sm:text-sm"
                      ])
                    }, [
                      O("ul", r8, [
                        (k(!0), N(ye, null, Oe(m, (y) => (k(), N("li", {
                          key: y.id,
                          class: q([
                            "relative cursor-default select-none py-2 px-base text-default-700",
                            "hover:bg-default-100"
                          ]),
                          role: "option",
                          onClick: (h) => f(y)
                        }, [
                          z(B(Ua), {
                            hit: y,
                            attribute: "single_line_address",
                            "class-names": { "ais-Highlight-highlighted": "bg-transparent font-semibold text-inherit" }
                          }, null, 8, ["hit"])
                        ], 8, t8))), 128))
                      ])
                    ], 8, o8)
                  ]),
                  _: 1
                })) : K("", !0)
              ]),
              _: 1
            }, 8, ["search-client"])
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["open"]));
  }
}), n8 = { class: "fixed inset-0 w-screen overflow-y-auto" }, a8 = {
  class: /* @__PURE__ */ q([
    "flex min-h-full items-end justify-center p-4 text-center",
    "sm:items-center"
  ])
}, s8 = { class: "relative" }, pI = /* @__PURE__ */ H({
  inheritAttrs: !1,
  __name: "AiModal",
  props: {
    open: { type: Boolean, default: !1 },
    size: { default: "base" }
  },
  emits: ["close"],
  setup(o, { emit: e }) {
    const r = e;
    he("emit", r);
    const t = /* @__PURE__ */ new Map([
      ["sm", "sm:max-w-md"],
      ["base", "sm:max-w-lg"],
      ["lg", "sm:max-w-2xl"],
      ["xl", "sm:max-w-4xl"],
      ["2xl", "sm:max-w-6xl"]
    ]);
    return (n, a) => (k(), R(B(Wa), {
      appear: "",
      show: n.open,
      as: "template"
    }, {
      default: j(() => [
        z(B(Na), {
          as: "div",
          class: "relative z-[60]",
          onClose: a[0] || (a[0] = (s) => r("close"))
        }, {
          default: j(() => [
            z(B(tr), {
              as: "template",
              enter: "duration-300 ease-out",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "duration-200 ease-in",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: j(() => a[1] || (a[1] = [
                O("div", { class: "fixed inset-0 bg-black/25" }, null, -1)
              ])),
              _: 1
            }),
            O("div", n8, [
              O("div", a8, [
                z(B(tr), {
                  as: "template",
                  enter: "ease-out duration-300",
                  "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                  "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                  leave: "ease-in duration-200",
                  "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                  "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                }, {
                  default: j(() => [
                    z(B(Va), Ve({
                      class: [
                        "bg-white relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all",
                        "sm:my-8 sm:w-full",
                        B(t).get(n.size),
                        // Apply top border radius to ModalContent if there is no ModalHeader
                        "[&:not(:has([data-slot=modal-header]))_[data-slot=modal-content]]:rounded-t-lg",
                        // Apply bottom border radius to ModalContent if there is no ModalFooter
                        "[&:not(:has([data-slot=modal-footer]))_[data-slot=modal-content]]:rounded-b-lg"
                      ]
                    }, n.$attrs), {
                      default: j(() => [
                        z(Ai),
                        O("div", s8, [
                          I(n.$slots, "default")
                        ])
                      ]),
                      _: 3
                    }, 16, ["class"])
                  ]),
                  _: 3
                })
              ])
            ])
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["show"]));
  }
}), i8 = {}, l8 = {
  class: "p-6 text-sm",
  "data-slot": "modal-content"
};
function c8(o, e) {
  return k(), N("div", l8, [
    I(o.$slots, "default")
  ]);
}
const dI = /* @__PURE__ */ fe(i8, [["render", c8]]), eo = /* @__PURE__ */ H({
  __name: "Button",
  props: {
    as: { default: void 0 },
    block: { type: Boolean },
    circle: { type: Boolean },
    color: { default: "primary" },
    disabled: { type: Boolean },
    href: { default: void 0 },
    leadingIcon: { default: void 0 },
    loading: { type: Boolean },
    method: { default: void 0 },
    size: { default: "base" },
    stretched: { type: Boolean },
    trailingIcon: { default: void 0 },
    type: { default: void 0 }
  },
  setup(o) {
    const e = o, r = {
      sm: "px-2 py-1 text-sm gap-x-1.5",
      base: "px-3 py-2 text-sm gap-x-1.5",
      lg: "px-3.5 py-2.5 text-sm gap-x-2",
      xl: "px-7 py-4 text-base gap-x-2"
    }, t = {
      primary: "shadow-sm ring-transparent bg-primary-600 text-white hover:bg-primary-700 active:bg-primary-900 focus-visible:bg-primary-900 focus-visible:outline-primary-900",
      secondary: "shadow-sm ring-default-300 bg-white text-default-900 hover:bg-default-50 active:bg-white focus-visible:outline-primary-900",
      tertiary: "ring-transparent bg-transparent text-default-900 hover:bg-default-50 active:bg-white focus-visible:bg-default-200 focus-visible:outline-primary-900",
      danger: "shadow-sm ring-transparent bg-red-600 text-white hover:bg-red-700 active:bg-red-800 focus-visible:outline-primary-900",
      ai: "shadow-sm ring-transparent bg-gradient-to-r from-[#942aa9] to-[#2b4dd0] text-white focus-visible:outline-primary-900 disabled:bg-none",
      dark: "shadow-sm ring-transparent bg-black text-white hover:bg-default-900 active:bg-default-900 focus-visible:bg-default-900 focus-visible:outline-primary-900"
    }, n = {
      sm: "rounded",
      base: "rounded-md",
      lg: "rounded-md",
      xl: "rounded-md"
    }, a = se(() => e.circle ? "rounded-full" : n[e.size]), s = se(() => r[e.size]), i = se(() => t[e.color]), l = se(() => e.disabled || e.loading);
    return (c, u) => (k(), R(ve(c.as ?? (c.href ? B(yo) : "button")), {
      class: q([
        "inline-flex justify-center items-center font-medium border-0 ring-1 ring-inset",
        "focus-visible:outline-none focus-visible:outline-2 focus-visible:outline-offset-2",
        s.value,
        i.value,
        c.block && "w-full",
        l.value && "disabled:pointer-events-none disabled:bg-default-200 disabled:ring-default-400 disabled:text-default-400",
        a.value,
        c.stretched ? "after:absolute after:inset-0" : "relative"
      ]),
      href: c.href,
      type: c.type,
      method: c.method,
      disabled: l.value,
      "aria-disabled": l.value,
      "aria-busy": c.loading,
      tabindex: l.value ? "-1" : 0
    }, {
      default: j(() => [
        z(vr),
        c.leadingIcon && !c.loading ? (k(), R(B(le), {
          key: 0,
          icon: c.leadingIcon,
          "aria-hidden": "true",
          class: q(c.size === "sm" ? "size-3" : "size-4")
        }, null, 8, ["icon", "class"])) : K("", !0),
        c.loading ? (k(), R(Yr, {
          key: 1,
          class: "size-4"
        })) : K("", !0),
        I(c.$slots, "default"),
        c.trailingIcon ? (k(), R(B(le), {
          key: 2,
          icon: c.trailingIcon,
          "aria-hidden": "true",
          class: q(c.size === "sm" ? "size-3" : "size-4")
        }, null, 8, ["icon", "class"])) : K("", !0)
      ]),
      _: 3
    }, 8, ["class", "href", "type", "method", "disabled", "aria-disabled", "aria-busy", "tabindex"]));
  }
}), u8 = {
  class: /* @__PURE__ */ q([
    "flex flex-row-reverse justify-start gap-2 px-6 py-4 border-t border-default-300"
  ]),
  "data-slot": "modal-footer"
}, gI = /* @__PURE__ */ H({
  __name: "AiModalFooter",
  props: {
    hideCancel: { type: Boolean, default: !1 }
  },
  setup(o) {
    const e = ce("emit");
    return (r, t) => (k(), N("div", u8, [
      I(r.$slots, "default"),
      r.hideCancel ? K("", !0) : (k(), R(eo, {
        key: 0,
        color: "secondary",
        type: "button",
        onClick: t[0] || (t[0] = (n) => B(e) && B(e)("close"))
      }, {
        default: j(() => t[1] || (t[1] = [
          ne(" Cancel ")
        ])),
        _: 1
      }))
    ]));
  }
}), p8 = {
  class: "px-6 pt-6 text-center",
  "data-slot": "modal-header"
}, d8 = { class: "absolute top-2 right-2" }, g8 = { class: "space-y-2" }, mI = /* @__PURE__ */ H({
  __name: "AiModalHeader",
  setup(o) {
    const e = ce("emit");
    return (r, t) => (k(), N("div", p8, [
      O("div", d8, [
        z(Re, {
          color: "tertiary",
          ariaLabel: "Close",
          type: "button",
          icon: B(Hr),
          onClick: t[0] || (t[0] = (n) => B(e) && B(e)("close"))
        }, null, 8, ["icon"])
      ]),
      O("div", g8, [
        z(B(le), {
          icon: B(F1),
          class: "text-violet-800 size-10 opacity-30",
          "aria-hidden": "true"
        }, null, 8, ["icon"]),
        I(r.$slots, "default")
      ])
    ]));
  }
}), fI = /* @__PURE__ */ H({
  __name: "AiModalTitle",
  setup(o) {
    return (e, r) => (k(), R(Vo, {
      as: B(yi),
      size: "lg"
    }, {
      default: j(() => [
        I(e.$slots, "default")
      ]),
      _: 3
    }, 8, ["as"]));
  }
});
var m8 = {
  prefix: "fas",
  iconName: "circle-xmark",
  icon: [
    512,
    512,
    [61532, "times-circle", "xmark-circle"],
    "f057",
    "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
  ]
}, f8 = m8, RF = {
  prefix: "fas",
  iconName: "triangle-exclamation",
  icon: [
    512,
    512,
    [9888, "exclamation-triangle", "warning"],
    "f071",
    "M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480H40c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
  ]
}, y8 = {
  prefix: "fas",
  iconName: "check",
  icon: [
    448,
    512,
    [10003, 10004],
    "f00c",
    "M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"
  ]
}, h8 = {
  prefix: "fas",
  iconName: "circle-plus",
  icon: [
    512,
    512,
    ["plus-circle"],
    "f055",
    "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM232 344V280H168c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V168c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"
  ]
}, HF = h8, F8 = {
  prefix: "fas",
  iconName: "chevron-right",
  icon: [
    320,
    512,
    [9002],
    "f054",
    "M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"
  ]
}, b8 = {
  prefix: "fas",
  iconName: "circle-info",
  icon: [
    512,
    512,
    ["info-circle"],
    "f05a",
    "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336h24V272H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
  ]
}, YF = b8, v8 = {
  prefix: "fas",
  iconName: "circle-check",
  icon: [
    512,
    512,
    [61533, "check-circle"],
    "f058",
    "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
  ]
}, Hp = v8, B8 = {
  prefix: "fas",
  iconName: "sparkles",
  icon: [
    512,
    512,
    [10024],
    "f890",
    "M327.5 85.2c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L384 128l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L448 128l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L448 64 426.8 7.5C425.1 3 420.8 0 416 0s-9.1 3-10.8 7.5L384 64 327.5 85.2zM205.1 73.3c-2.6-5.7-8.3-9.3-14.5-9.3s-11.9 3.6-14.5 9.3L123.3 187.3 9.3 240C3.6 242.6 0 248.3 0 254.6s3.6 11.9 9.3 14.5l114.1 52.7L176 435.8c2.6 5.7 8.3 9.3 14.5 9.3s11.9-3.6 14.5-9.3l52.7-114.1 114.1-52.7c5.7-2.6 9.3-8.3 9.3-14.5s-3.6-11.9-9.3-14.5L257.8 187.4 205.1 73.3zM384 384l-56.5 21.2c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L384 448l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L448 448l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L448 384l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L384 384z"
  ]
}, P8 = {
  prefix: "fas",
  iconName: "circle-exclamation",
  icon: [
    512,
    512,
    ["exclamation-circle"],
    "f06a",
    "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
  ]
};
const w8 = { class: "flex" }, k8 = {
  key: 0,
  class: "shrink-0"
}, yI = /* @__PURE__ */ H({
  __name: "Alert",
  props: {
    icon: { default: void 0 },
    link: { default: void 0 },
    type: { default: "info" },
    hideIcon: { type: Boolean, default: !1 }
  },
  setup(o) {
    const e = o;
    he("type", e.type);
    const r = /* @__PURE__ */ new Map([
      ["info", "bg-blue-50"],
      ["success", "bg-green-50"],
      ["error", "bg-red-50"],
      ["warning", "bg-yellow-50"]
    ]), t = /* @__PURE__ */ new Map([
      ["info", "text-blue-400"],
      ["success", "text-green-400"],
      ["error", "text-red-400"],
      ["warning", "text-yellow-400"]
    ]), n = se(() => e.icon ? e.icon : {
      info: YF,
      error: RF,
      warning: P8,
      success: Hp
    }[e.type]);
    return (a, s) => (k(), N("div", {
      class: q(["rounded-md p-4", B(r).get(a.type)])
    }, [
      O("div", w8, [
        a.hideIcon ? K("", !0) : (k(), N("div", k8, [
          z(B(le), {
            icon: n.value,
            class: q(["size-4", B(t).get(a.type)]),
            "aria-hidden": "true"
          }, null, 8, ["icon", "class"])
        ])),
        O("div", {
          class: q([[
            "flex-1 grid grid-cols-1",
            "md:grid-cols-12",
            !a.hideIcon && "ml-3 gap-2"
          ], "[&:has([data-slot='description'])_[data-slot='title']]:font-medium"])
        }, [
          I(a.$slots, "default")
        ], 2)
      ])
    ], 2));
  }
}), hI = /* @__PURE__ */ H({
  __name: "AlertDescription",
  props: {
    as: { default: "div" }
  },
  setup(o) {
    const e = ce("type", "info"), r = /* @__PURE__ */ new Map([
      ["info", "text-blue-700 [&_li]:text-blue-700"],
      ["success", "text-green-700 [&_li]:text-green-700"],
      ["error", "text-red-700 [&_li]:text-red-700"],
      ["warning", "text-yellow-700 [&_li]:text-yellow-700"]
    ]);
    return (t, n) => (k(), R(ve(t.as), {
      class: q([
        "text-sm",
        "md:col-start-1 md:col-end-11 md:row-start-2 md:row-end-3",
        B(r).get(B(e))
      ]),
      "data-slot": "description"
    }, {
      default: j(() => [
        I(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), D8 = {
  class: /* @__PURE__ */ q([
    "pt-3 whitespace-nowrap",
    "md:pt-0 md:text-right md:col-start-11 md:col-end-13"
  ])
}, FI = /* @__PURE__ */ H({
  __name: "AlertLink",
  props: {
    as: { default: yo }
  },
  setup(o) {
    const e = ce("type", "info"), r = /* @__PURE__ */ new Map([
      ["info", "text-blue-700 hover:text-blue-600"],
      ["success", "text-green-700 hover:text-green-600"],
      ["error", "text-red-700 hover:text-red-600"],
      ["warning", "text-yellow-700 hover:text-yellow-600"]
    ]);
    return (t, n) => (k(), N("div", D8, [
      (k(), R(ve(t.as), {
        class: q([
          "text-sm font-medium",
          B(r).get(B(e))
        ])
      }, {
        default: j(() => [
          I(t.$slots, "default"),
          n[0] || (n[0] = O("span", { "aria-hidden": "true" }, " →", -1))
        ]),
        _: 3
      }, 8, ["class"]))
    ]));
  }
}), S8 = { class: "fixed inset-0 w-screen overflow-y-auto" }, A8 = {
  class: /* @__PURE__ */ q([
    "flex min-h-full items-end justify-center p-4 text-center",
    "sm:items-center"
  ])
}, bI = /* @__PURE__ */ H({
  inheritAttrs: !1,
  __name: "AlertModal",
  props: {
    open: { type: Boolean, default: !1 }
  },
  emits: ["close"],
  setup(o, { emit: e }) {
    const r = e;
    return he("emit", r), (t, n) => (k(), R(B(Wa), {
      appear: "",
      show: t.open,
      as: "template"
    }, {
      default: j(() => [
        z(B(Na), {
          as: "div",
          class: "relative z-[60]",
          onClose: n[0] || (n[0] = (a) => r("close"))
        }, {
          default: j(() => [
            z(B(tr), {
              as: "template",
              enter: "duration-300 ease-out",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "duration-200 ease-in",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: j(() => n[1] || (n[1] = [
                O("div", { class: "fixed inset-0 bg-black/25" }, null, -1)
              ])),
              _: 1
            }),
            O("div", S8, [
              O("div", A8, [
                z(B(tr), {
                  as: "template",
                  enter: "ease-out duration-300",
                  "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                  "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                  leave: "ease-in duration-200",
                  "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                  "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                }, {
                  default: j(() => [
                    z(B(Va), Ve({ class: [
                      "relative transform rounded-lg bg-white text-left shadow-xl transition-all",
                      "sm:my-8 sm:w-full sm:max-w-lg"
                    ] }, t.$attrs), {
                      default: j(() => [
                        I(t.$slots, "default")
                      ]),
                      _: 3
                    }, 16)
                  ]),
                  _: 3
                })
              ])
            ])
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["show"]));
  }
}), vI = /* @__PURE__ */ H({
  __name: "AlertModalDescription",
  setup(o) {
    return (e, r) => (k(), R(B(_u), { class: "text-default-500 text-sm" }, {
      default: j(() => [
        I(e.$slots, "default")
      ]),
      _: 3
    }));
  }
}), E8 = { class: "py-4 px-6 flex flex-row-reverse justify-start gap-x-2 border-t border-default-300" }, BI = /* @__PURE__ */ H({
  __name: "AlertModalFooter",
  props: {
    hideCancel: { type: Boolean, default: !1 }
  },
  setup(o) {
    const e = ce("emit");
    return (r, t) => (k(), N("div", E8, [
      I(r.$slots, "default"),
      r.hideCancel ? K("", !0) : (k(), R(eo, {
        key: 0,
        color: "secondary",
        onClick: t[0] || (t[0] = (n) => B(e) && B(e)("close"))
      }, {
        default: j(() => t[1] || (t[1] = [
          ne(" Cancel ")
        ])),
        _: 1
      }))
    ]));
  }
}), x8 = {}, C8 = { class: "p-6 space-y-2" };
function O8(o, e) {
  return k(), N("div", C8, [
    I(o.$slots, "default")
  ]);
}
const PI = /* @__PURE__ */ fe(x8, [["render", O8]]), wI = /* @__PURE__ */ H({
  __name: "AlertModalTitle",
  setup(o) {
    return (e, r) => (k(), R(Vo, { as: B(yi) }, {
      default: j(() => [
        I(e.$slots, "default")
      ]),
      _: 3
    }, 8, ["as"]));
  }
}), kI = /* @__PURE__ */ H({
  __name: "AlertTitle",
  props: {
    as: { default: "h3" }
  },
  setup(o) {
    const e = ce("type", "info"), r = /* @__PURE__ */ new Map([
      ["info", "text-blue-800"],
      ["success", "text-green-800"],
      ["error", "text-red-800"],
      ["warning", "text-yellow-800"]
    ]);
    return (t, n) => (k(), R(ve(t.as), {
      class: q([
        "text-sm",
        "md:col-start-1 md:col-end-11 md:row-start-1 md:row-end-2",
        B(r).get(B(e))
      ]),
      "data-slot": "title"
    }, {
      default: j(() => [
        I(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), T8 = ["src"], DI = /* @__PURE__ */ H({
  __name: "Avatar",
  props: {
    shape: { default: "circle" },
    size: { default: "base" },
    src: { default: void 0 }
  },
  setup(o) {
    const e = /* @__PURE__ */ new Map([
      ["sm", "size-8"],
      ["base", "size-10"],
      ["lg", "size-12"]
    ]), r = /* @__PURE__ */ new Map([
      ["circle", "rounded-full"],
      ["square", ""]
    ]);
    return (t, n) => (k(), N("span", {
      class: q([
        "inline-flex overflow-hidden border border-default-200 bg-default-100",
        B(r).get(t.shape),
        B(e).get(t.size)
      ])
    }, [
      t.src ? (k(), N("img", {
        key: 0,
        src: t.src,
        alt: ""
      }, null, 8, T8)) : K("", !0)
    ], 2));
  }
}), L8 = {
  key: 0,
  class: "inline-flex justify-center items-center -ml-1 size-3.5"
}, Yp = /* @__PURE__ */ H({
  __name: "Badge",
  props: {
    color: { default: "default" },
    icon: { default: void 0 }
  },
  setup(o) {
    he("badge-color", o.color);
    const r = /* @__PURE__ */ new Map([
      ["default", "bg-default-50 text-default-600 ring-default-500/10"],
      ["gray", "bg-gray-50 text-gray-600 ring-gray-500/10"],
      ["darkGray", "bg-gray-300 text-gray-700 ring-gray-500/10"],
      ["red", "bg-red-50 text-red-700 ring-red-600/10"],
      ["orange", "bg-orange-100 text-orange-700 ring-orange-400/10"],
      ["yellow", "bg-yellow-50 text-yellow-800 ring-yellow-600/20"],
      ["green", "bg-green-50 text-green-700 ring-green-600/20"],
      ["teal", "bg-teal-50 text-teal-700 ring-teal-600/20"],
      ["blue", "bg-blue-50 text-blue-700 ring-blue-700/10"],
      ["darkBlue", "bg-blue-200 text-blue-700 ring-blue-700/10"],
      ["primary", "bg-primary-50 text-primary-700 ring-primary-700/10"],
      ["purple", "bg-purple-50 text-purple-700 ring-purple-700/10"],
      ["pink", "bg-pink-50 text-pink-700 ring-pink-700/10"]
    ]);
    return (t, n) => (k(), N("span", {
      class: q([
        "inline-flex items-center gap-x-0.5 rounded-md px-2 py-1 text-xs font-medium ring-1 ring-inset font-sans",
        B(r).get(t.color)
      ])
    }, [
      t.icon ? (k(), N("span", L8, [
        z(B(le), {
          icon: t.icon,
          class: "size-2.5",
          "aria-hidden": "true"
        }, null, 8, ["icon"])
      ])) : K("", !0),
      I(t.$slots, "default")
    ], 2));
  }
}), j8 = { class: "sr-only" }, qF = /* @__PURE__ */ H({
  __name: "BadgeButton",
  props: {
    icon: {}
  },
  setup(o) {
    const e = ce("badge-color") ?? "default", r = /* @__PURE__ */ new Map([
      ["default", "hover:bg-default-500/20 text-default-600/50 hover:text-default-600/75"],
      ["gray", "hover:bg-gray-500/20 text-gray-600/50 hover:text-gray-600/75"],
      ["darkGray", "hover:bg-gray-500/20 text-gray-600/50 hover:text-gray-600/75"],
      ["red", "hover:bg-red-500/20 text-red-600/50 hover:text-red-600/75"],
      ["orange", "hover:bg-orange-500/20 text-orange-600/50 hover:text-orange-600/75"],
      ["yellow", "hover:bg-yellow-500/20 text-yellow-600/50 hover:text-yellow-600/75"],
      ["green", "hover:bg-green-500/20 text-green-600/50 hover:text-green-600/75"],
      ["teal", "hover:bg-teal-500/20 text-teal-600/50 hover:text-teal-600/75"],
      ["blue", "hover:bg-blue-500/20 text-blue-600/50 hover:text-blue-600/75"],
      ["darkBlue", "hover:bg-blue-500/20 text-blue-600/50 hover:text-blue-600/75"],
      ["primary", "hover:bg-primary-500/20 text-primary-600/50 hover:text-primary-600/75"],
      ["purple", "hover:bg-purple-500/20 text-purple-600/50 hover:text-purple-600/75"],
      ["pink", "hover:bg-pink-500/20 text-pink-600/50 hover:text-pink-600/75"]
    ]);
    return (t, n) => (k(), N("button", {
      type: "button",
      class: q([
        "relative inline-flex justify-center items-center -mr-1 size-3.5 rounded-sm",
        B(r).get(B(e))
      ])
    }, [
      z(vr),
      O("span", j8, [
        I(t.$slots, "default")
      ]),
      z(B(le), {
        icon: t.icon,
        class: "size-2.5",
        "aria-hidden": "true"
      }, null, 8, ["icon"])
    ], 2));
  }
}), M8 = { class: "flex items-center" }, SI = /* @__PURE__ */ H({
  __name: "Breadcrumb",
  props: {
    current: { type: Boolean, default: !1 },
    href: {}
  },
  setup(o) {
    const e = ce("as");
    return (r, t) => (k(), N("li", null, [
      O("div", M8, [
        z(B(le), {
          icon: B(F8),
          class: "size-3 shrink-0 text-default-400",
          "aria-hidden": "true"
        }, null, 8, ["icon"]),
        (k(), R(ve(B(e)), {
          href: r.href,
          class: q([
            "ml-3 text-sm font-medium",
            r.current ? "text-primary-600" : "text-default-600 hover:text-default-700"
          ]),
          "aria-current": r.current ? "page" : void 0
        }, {
          default: j(() => [
            I(r.$slots, "default")
          ]),
          _: 3
        }, 8, ["href", "class", "aria-current"]))
      ])
    ]));
  }
}), W8 = {
  class: "flex text-sm",
  "aria-label": "Breadcrumb"
}, N8 = {
  role: "list",
  class: "flex items-center space-x-3"
}, AI = /* @__PURE__ */ H({
  __name: "BreadcrumbGroup",
  props: {
    as: { default: yo },
    homeUrl: {}
  },
  setup(o) {
    return he("as", o.as), (r, t) => (k(), N("nav", W8, [
      O("ol", N8, [
        O("li", null, [
          O("div", null, [
            (k(), R(ve(r.as), {
              href: r.homeUrl,
              class: q([
                "text-default-600 hover:text-default-700"
              ])
            }, {
              default: j(() => [
                z(B(le), {
                  icon: B(WF),
                  class: "size-4",
                  "aria-hidden": "true"
                }, null, 8, ["icon"]),
                t[0] || (t[0] = O("span", { class: "sr-only" }, " Home ", -1))
              ]),
              _: 1
            }, 8, ["href"]))
          ])
        ]),
        I(r.$slots, "default")
      ])
    ]));
  }
}), V8 = (o = "idle") => {
  const e = ue(o), r = (i) => {
    e.value = i;
  }, t = se(() => e.value === "loading"), n = se(() => e.value === "success"), a = se(() => e.value === "error"), s = se(() => e.value === "idle");
  return {
    setStatus: r,
    isLoading: t,
    isSuccess: n,
    isError: a,
    isIdle: s,
    status: cr(e)
  };
}, z8 = {
  key: 0,
  ref: "refMenuBar",
  class: "flex py-1.5 px-3 bg-default-50 border-b border-b-default-200 space-x-tiny",
  "aria-hidden": "true"
}, I8 = {
  key: 0,
  class: "bg-white flex items-center justify-center h-full"
}, R8 = ["title", "src"], H8 = {
  key: 2,
  class: "text-center h-full flex items-center justify-center bg-white"
}, EI = /* @__PURE__ */ H({
  __name: "BrowserWindow",
  props: {
    aspectRatio: { default: "16/9" },
    breakpoint: { default: "sm" },
    hideMenuBar: { type: Boolean },
    interactive: { type: Boolean, default: !1 },
    title: {},
    type: { default: "desktop" },
    url: {}
  },
  setup(o) {
    const e = o, r = V8(), t = ue(), n = ue(), a = Bh({}), s = se(() => ({
      xs: 425,
      sm: 640,
      md: 768,
      lg: 1024,
      xl: 1280,
      "2xl": 1536
    })[e.breakpoint]), i = async () => {
      var c;
      if ((c = t.value) != null && c.contentWindow)
        try {
          const u = t.value.contentWindow.document;
          u.readyState === "complete" || u.readyState === "interactive" ? r.setStatus("success") : Mh(u, "DOMContentLoaded", () => {
            r.setStatus("success");
          });
        } catch (u) {
          r.setStatus("error"), console.error(u);
        }
    }, l = () => {
      if (!t.value || !n.value)
        return;
      const c = s.value, u = n.value.clientWidth / c, [f, g] = e.aspectRatio.split("/").map(Number), d = Math.ceil(n.value.clientWidth * g / f);
      a.width = `${c}px`, a.height = `${Math.ceil(d / u)}px`, a.transform = `scale(${u})`, n.value.style.height = `${d}px`;
    };
    return Fr(() => {
      r.setStatus("loading"), l(), p2(n, () => {
        l();
      });
    }), Ir(s, l), (c, u) => (k(), N("div", {
      class: q([
        "overflow-hidden bg-white",
        c.type === "mobile" ? "ring-black ring-4 rounded-[2rem] shadow-lg" : "rounded-lg"
      ])
    }, [
      !c.hideMenuBar && c.type === "desktop" ? (k(), N("div", z8, u[0] || (u[0] = [
        O("span", { class: "bg-red-400 w-1.5 h-1.5 rounded-full block" }, null, -1),
        O("span", { class: "bg-yellow-300 w-1.5 h-1.5 rounded-full block" }, null, -1),
        O("span", { class: "bg-green-400 w-1.5 h-1.5 rounded-full block" }, null, -1)
      ]), 512)) : K("", !0),
      O("div", {
        ref_key: "refIframeContainer",
        ref: n
      }, [
        B(r).isLoading.value ? (k(), N("div", I8, [
          z(B(Yr), { class: "size-4 text-primary-500" })
        ])) : K("", !0),
        B(r).isError.value ? (k(), N("div", H8, u[1] || (u[1] = [
          Rr('<div><svg xmlns="http://www.w3.org/2000/svg" width="64" height="51" viewBox="0 0 64 51" class="mx-auto mb-sm" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.25 48.9999C6.17489 48.9999 1.25 44.187 1.25 38.2499C1.25 32.3128 6.17489 27.4998 12.25 27.4998C12.5084 27.4998 12.7646 27.5085 13.0185 27.5257C12.8421 26.5437 12.75 25.5325 12.75 24.4998C12.75 15.1109 20.3612 7.49976 29.7501 7.49976C37.2457 7.49976 43.6082 12.3508 45.8695 19.0846C46.4053 19.0285 46.9493 18.9998 47.5002 18.9998C55.9226 18.9998 62.7502 25.7156 62.7502 33.9999C62.7502 41.8702 56.5879 48.3636 48.7502 48.989V48.9999H20.504H12.25ZM18.2481 48.9999H14.7657H18.2481Z" fill="white"></path><path d="M18.2481 48.9999H14.7657M12.25 48.9999C6.17489 48.9999 1.25 44.187 1.25 38.2499C1.25 32.3128 6.17489 27.4998 12.25 27.4998C12.5084 27.4998 12.7646 27.5085 13.0185 27.5257C12.8421 26.5437 12.75 25.5325 12.75 24.4998C12.75 15.1109 20.3612 7.49976 29.7501 7.49976C37.2457 7.49976 43.6082 12.3508 45.8695 19.0846C46.4053 19.0285 46.9493 18.9998 47.5002 18.9998C55.9226 18.9998 62.7502 25.7156 62.7502 33.9999C62.7502 41.8702 56.5879 48.3636 48.7502 48.989V48.9999H20.504H12.25Z" stroke="#1F64E7" stroke-width="2.5" stroke-linecap="round"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M24.5563 11.1711C24.5563 27.2827 39.0666 40.5589 57.7502 42.3513C55.4089 45.2305 51.793 47.1837 47.6736 47.4905V47.4999H14.1216C10.0507 47.4999 3.25 45.7847 3.25 38.274C3.25 30.7633 8.5371 29.0482 14.1216 29.0482C14.359 29.0482 14.5946 29.0556 14.828 29.0703C14.6658 28.2276 14.6373 27.359 14.5812 26.4735C14.2019 20.4919 16.8115 12.9532 24.5653 10.4998C24.5591 10.7234 24.5563 10.947 24.5563 11.1711ZM29.8083 36.3788C28.2889 36.3788 27.0572 37.5959 27.0572 39.0973C27.0572 40.5987 28.2889 41.8158 29.8083 41.8158C31.3276 41.8158 32.5593 40.5987 32.5593 39.0973C32.5593 37.5959 31.3276 36.3788 29.8083 36.3788Z" fill="#E8F0FE"></path><path d="M30.002 42.0003C31.5208 42.0003 32.752 40.769 32.752 39.2503C32.752 37.7315 31.5208 36.5002 30.002 36.5002C28.4832 36.5002 27.252 37.7315 27.252 39.2503C27.252 40.769 28.4832 42.0003 30.002 42.0003Z" stroke="#1F64E7" stroke-width="2.5"></path><path d="M22.25 33.5001L25.75 30.7536L22.25 28.1389" stroke="#1F64E7" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M37.75 33.5001L34.25 30.7536L37.75 28.1389" stroke="#1F64E7" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M34.7505 12.5002C38.005 13.3615 40.5747 15.9067 41.4707 19.1469" stroke="#75A4FE" stroke-width="2.5" stroke-linecap="round"></path><path d="M45.252 4.00001C46.0804 4.00001 46.752 3.32844 46.752 2.50001C46.752 1.67158 46.0804 1 45.252 1C44.4235 1 43.752 1.67158 43.752 2.50001C43.752 3.32844 44.4235 4.00001 45.252 4.00001Z" stroke="#75A4FE" stroke-width="2"></path><path d="M60.75 11.9998C61.5784 11.9998 62.25 11.3282 62.25 10.4998C62.25 9.67133 61.5784 8.99976 60.75 8.99976C59.9216 8.99976 59.25 9.67133 59.25 10.4998C59.25 11.3282 59.9216 11.9998 60.75 11.9998Z" fill="#75A4FE"></path><path d="M49.1309 7.87842L53.31 12.0575M53.3735 7.87842L49.1944 12.0575L53.3735 7.87842Z" stroke="#75A4FE" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M1.95117 16.7986L4.95118 19.7986M4.95118 16.7986L1.95117 19.7986L4.95118 16.7986Z" stroke="#75A4FE" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M8.75001 13.4998C9.57844 13.4998 10.25 12.8282 10.25 11.9998C10.25 11.1713 9.57844 10.4998 8.75001 10.4998C7.92158 10.4998 7.25 11.1713 7.25 11.9998C7.25 12.8282 7.92158 13.4998 8.75001 13.4998Z" fill="#75A4FE"></path></svg><p class="text-md font-bold text-primary-600"> Whoops! </p></div>', 1)
        ]))) : (k(), N("iframe", {
          key: 1,
          ref_key: "refIframe",
          ref: t,
          title: c.title,
          style: qo(a),
          class: q([
            "transform origin-top-left",
            !c.interactive && "pointer-events-none",
            B(r).isLoading.value ? "opacity-0" : "opacity-100"
          ]),
          src: c.url,
          onLoad: i
        }, null, 46, R8))
      ], 512)
    ], 2));
  }
}), Y8 = ["aria-label"], xI = /* @__PURE__ */ H({
  __name: "ButtonGroup",
  props: {
    ariaLabel: {}
  },
  setup(o) {
    return (e, r) => (k(), N("span", {
      class: q([
        "isolate inline-flex rounded-md",
        "[&>*]:rounded-none [&>*:not(:first-child)]:-ml-px [&>*:first-child]:rounded-l-md [&>*:last-child]:rounded-r-md [&>*]:relative [&>*:focus]:z-10"
      ]),
      role: "group",
      "aria-label": e.ariaLabel
    }, [
      I(e.$slots, "default")
    ], 8, Y8));
  }
}), q8 = {}, G8 = { class: "isolate mt-2 grid grid-cols-7 gap-px bg-default-200 text-sm shadow ring-1 ring-default-200 rounded-lg overflow-hidden" };
function X8(o, e) {
  return k(), N(ye, null, [
    e[0] || (e[0] = Rr('<div class="grid grid-cols-7 text-center text-xs/6 text-default-900 font-medium"><span><abbr title="Monday">M</abbr></span><span><abbr title="Tuesday">T</abbr></span><span><abbr title="Wednesday">W</abbr></span><span><abbr title="Thursday">T</abbr></span><span><abbr title="Friday">F</abbr></span><span><abbr title="Saturday">S</abbr></span><span><abbr title="Sunday">S</abbr></span></div>', 1)),
    O("div", G8, [
      I(o.$slots, "default")
    ])
  ], 64);
}
const CI = /* @__PURE__ */ fe(q8, [["render", X8]]), U8 = ["datetime", "aria-current"], OI = /* @__PURE__ */ H({
  __name: "CalendarMonthViewDay",
  props: {
    as: { default: "span" },
    day: {},
    disabled: { type: Boolean },
    selected: { type: Boolean }
  },
  setup(o) {
    const e = o, r = se(() => e.as === "button");
    return (t, n) => (k(), R(ve(t.as), {
      type: r.value ? "button" : void 0,
      class: q([
        "py-1.5 font-medium",
        t.disabled && "cursor-not-allowed",
        r.value && !t.selected && !t.disabled && "hover:bg-default-100",
        r.value && t.selected && !t.disabled && "hover:bg-primary-700",
        r.value && "focus:z-10",
        t.day.isCurrentMonth && !t.selected ? "bg-white" : "bg-default-100",
        t.selected && "text-white bg-primary-600",
        !t.selected && t.day.isCurrentMonth && !t.day.isToday && "text-default-900",
        !t.selected && !t.day.isCurrentMonth && !t.day.isToday && "text-default-400",
        t.day.isToday && !t.selected && "text-primary-600"
      ]),
      disabled: r.value ? t.disabled : void 0,
      "aria-disabled": r.value ? t.disabled : void 0,
      tabindex: r.value ? t.disabled ? "-1" : 0 : void 0
    }, {
      default: j(() => {
        var a;
        return [
          O("time", {
            datetime: t.day.date,
            class: "mx-auto flex size-7 items-center justify-center",
            "aria-current": t.day.isToday ? "date" : void 0
          }, _((a = t.day.date.split("-").pop()) == null ? void 0 : a.replace(/^0/, "")), 9, U8)
        ];
      }),
      _: 1
    }, 8, ["type", "class", "disabled", "aria-disabled", "tabindex"]));
  }
}), Z8 = {}, K8 = { class: "flex items-center gap-x-base" };
function Q8(o, e) {
  return k(), N("div", K8, [
    I(o.$slots, "default")
  ]);
}
const TI = /* @__PURE__ */ fe(Z8, [["render", Q8]]), LI = /* @__PURE__ */ H({
  __name: "CalendarNavigationTitle",
  props: {
    as: { default: "h2" }
  },
  setup(o) {
    return (e, r) => (k(), R(ve(e.as), { class: "flex-1 text-sm font-semibold text-default-900 text-center" }, {
      default: j(() => [
        I(e.$slots, "default")
      ]),
      _: 3
    }));
  }
}), J8 = { class: "flex flex-col overflow-hidden rounded-lg border border-default-200" }, jI = /* @__PURE__ */ H({
  __name: "CalendarWeekView",
  props: {
    days: {}
  },
  setup(o) {
    return he("calendar-week-view-days", o.days), (r, t) => (k(), N("div", J8, [
      I(r.$slots, "default")
    ]));
  }
}), _8 = {
  class: /* @__PURE__ */ q([
    "flex max-w-full flex-none flex-col",
    "sm:max-w-none",
    "md:max-w-full"
  ]),
  style: { width: "165%" }
}, $8 = {
  class: /* @__PURE__ */ q([
    "grid grid-cols-7 text-sm/6 text-default-500",
    "sm:hidden"
  ])
}, e7 = ["onClick"], o7 = {
  class: /* @__PURE__ */ q([
    "-mr-px hidden grid-cols-7 divide-x divide-default-100 border-r border-default-100 text-sm/6 text-default-500",
    "sm:grid"
  ])
}, r7 = {
  key: 0,
  class: "flex items-baseline"
}, t7 = { class: "ml-1.5 flex size-8 items-center justify-center rounded-full bg-primary-600 font-semibold text-white" }, n7 = { key: 1 }, a7 = { class: "ml-1.5 items-center justify-center font-semibold text-default-900" }, s7 = { class: "flex flex-auto" }, i7 = { class: "grid flex-auto grid-cols-1 grid-rows-1" }, l7 = {
  class: "col-start-1 col-end-2 row-start-1 grid divide-y divide-default-100",
  style: { "grid-template-rows": "repeat(48, minmax(3.5rem, 1fr))" }
}, c7 = { class: "sticky left-0 z-20 -ml-14 -mt-2.5 w-14 pr-2 text-right text-xs/5 text-default-400" }, u7 = {
  class: /* @__PURE__ */ q([
    "col-start-1 col-end-2 row-start-1 grid grid-cols-1",
    "sm:grid-cols-7 sm:pr-8"
  ]),
  style: { "grid-template-rows": "1.75rem repeat(288, minmax(0, 1fr)) auto" }
}, MI = /* @__PURE__ */ H({
  __name: "CalendarWeekViewGrid",
  emits: ["click"],
  setup(o, { emit: e }) {
    const r = ce("calendar-week-view-days"), t = ue(null), n = ue(null), a = ue(null), s = e;
    Fr(() => {
      if (!t.value || !n.value || !a.value)
        return;
      const l = (/* @__PURE__ */ new Date()).getHours() * 60;
      t.value.scrollTop = (t.value.scrollHeight - n.value.offsetHeight - a.value.offsetHeight) * l / 1440;
    });
    const i = [
      "12AM",
      "1AM",
      "2AM",
      "3AM",
      "4AM",
      "5AM",
      "6AM",
      "7AM",
      "8AM",
      "9AM",
      "10AM",
      "11AM",
      "12PM",
      "1PM",
      "2PM",
      "3PM",
      "4PM",
      "5PM",
      "6PM",
      "7PM",
      "8PM",
      "9PM",
      "10PM",
      "11PM"
    ];
    return (l, c) => (k(), N("div", {
      ref_key: "container",
      ref: t,
      class: "isolate flex flex-auto flex-col overflow-auto bg-white"
    }, [
      O("div", _8, [
        O("div", {
          ref_key: "containerNav",
          ref: n,
          class: q([
            "sticky top-0 z-30 flex-none bg-white shadow ring-1 ring-black/5",
            "sm:pr-8"
          ])
        }, [
          O("div", $8, [
            (k(!0), N(ye, null, Oe(B(r), (u) => (k(), N("button", {
              key: u.date,
              class: "flex flex-col items-center pb-3 pt-2",
              onClick: (f) => s("click", u)
            }, [
              ne(_(u.dayName.substring(0, 1)) + " ", 1),
              O("span", {
                class: q([
                  "mt-1 flex size-8 items-center justify-center font-semibold",
                  u.isToday ? "rounded-full bg-primary-600 font-semibold text-white" : "text-default-900"
                ])
              }, _(u.day), 3)
            ], 8, e7))), 128))
          ]),
          O("div", o7, [
            c[0] || (c[0] = O("div", { class: "col-end-1 w-14" }, null, -1)),
            (k(!0), N(ye, null, Oe(B(r), (u) => (k(), N("div", {
              key: u.date,
              class: "flex items-center justify-center py-2"
            }, [
              u.isToday ? (k(), N("span", r7, [
                ne(_(u.dayName.substring(0, 3)) + " ", 1),
                O("span", t7, _(u.day), 1)
              ])) : (k(), N("span", n7, [
                ne(_(u.dayName.substring(0, 3)) + " ", 1),
                O("span", a7, _(u.day), 1)
              ]))
            ]))), 128))
          ])
        ], 512),
        O("div", s7, [
          c[3] || (c[3] = O("div", { class: "sticky left-0 z-10 w-14 flex-none bg-white ring-1 ring-default-100" }, null, -1)),
          O("div", i7, [
            O("div", l7, [
              O("div", {
                ref_key: "containerOffset",
                ref: a,
                class: "row-end-1 h-7"
              }, null, 512),
              (k(), N(ye, null, Oe(i, (u) => (k(), N(ye, { key: u }, [
                O("div", null, [
                  O("div", c7, _(u), 1)
                ]),
                c[1] || (c[1] = O("div", null, null, -1))
              ], 64))), 64))
            ]),
            c[2] || (c[2] = Rr('<div class="col-start-1 col-end-2 row-start-1 hidden grid-cols-7 grid-rows-1 divide-x divide-default-100 sm:grid sm:grid-cols-7"><div class="col-start-1 row-span-full"></div><div class="col-start-2 row-span-full"></div><div class="col-start-3 row-span-full"></div><div class="col-start-4 row-span-full"></div><div class="col-start-5 row-span-full"></div><div class="col-start-6 row-span-full"></div><div class="col-start-7 row-span-full"></div><div class="col-start-8 row-span-full w-8"></div></div>', 1)),
            O("ol", u7, [
              I(l.$slots, "default")
            ])
          ])
        ])
      ])
    ], 512));
  }
});
var Vs = { exports: {} }, p7 = Vs.exports, Df;
function d7() {
  return Df || (Df = 1, function(o, e) {
    (function(r, t) {
      o.exports = t();
    })(p7, function() {
      var r = "minute", t = /[+-]\d\d(?::?\d\d)?/g, n = /([+-]|\d\d)/g;
      return function(a, s, i) {
        var l = s.prototype;
        i.utc = function(m) {
          var y = { date: m, utc: !0, args: arguments };
          return new s(y);
        }, l.utc = function(m) {
          var y = i(this.toDate(), { locale: this.$L, utc: !0 });
          return m ? y.add(this.utcOffset(), r) : y;
        }, l.local = function() {
          return i(this.toDate(), { locale: this.$L, utc: !1 });
        };
        var c = l.parse;
        l.parse = function(m) {
          m.utc && (this.$u = !0), this.$utils().u(m.$offset) || (this.$offset = m.$offset), c.call(this, m);
        };
        var u = l.init;
        l.init = function() {
          if (this.$u) {
            var m = this.$d;
            this.$y = m.getUTCFullYear(), this.$M = m.getUTCMonth(), this.$D = m.getUTCDate(), this.$W = m.getUTCDay(), this.$H = m.getUTCHours(), this.$m = m.getUTCMinutes(), this.$s = m.getUTCSeconds(), this.$ms = m.getUTCMilliseconds();
          } else u.call(this);
        };
        var f = l.utcOffset;
        l.utcOffset = function(m, y) {
          var h = this.$utils().u;
          if (h(m)) return this.$u ? 0 : h(this.$offset) ? f.call(this) : this.$offset;
          if (typeof m == "string" && (m = function(P) {
            P === void 0 && (P = "");
            var E = P.match(t);
            if (!E) return null;
            var S = ("" + E[0]).match(n) || ["-", 0, 0], D = S[0], w = 60 * +S[1] + +S[2];
            return w === 0 ? 0 : D === "+" ? w : -w;
          }(m), m === null)) return this;
          var F = Math.abs(m) <= 16 ? 60 * m : m, b = this;
          if (y) return b.$offset = F, b.$u = m === 0, b;
          if (m !== 0) {
            var v = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
            (b = this.local().add(F + v, r)).$offset = F, b.$x.$localOffset = v;
          } else b = this.utc();
          return b;
        };
        var g = l.format;
        l.format = function(m) {
          var y = m || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
          return g.call(this, y);
        }, l.valueOf = function() {
          var m = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
          return this.$d.valueOf() - 6e4 * m;
        }, l.isUTC = function() {
          return !!this.$u;
        }, l.toISOString = function() {
          return this.toDate().toISOString();
        }, l.toString = function() {
          return this.toDate().toUTCString();
        };
        var d = l.toDate;
        l.toDate = function(m) {
          return m === "s" && this.$offset ? i(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : d.call(this);
        };
        var p = l.diff;
        l.diff = function(m, y, h) {
          if (m && this.$u === m.$u) return p.call(this, m, y, h);
          var F = this.local(), b = i(m).local();
          return p.call(F, b, y, h);
        };
      };
    });
  }(Vs)), Vs.exports;
}
var g7 = d7();
const m7 = /* @__PURE__ */ qr(g7);
var zs = { exports: {} }, f7 = zs.exports, Sf;
function y7() {
  return Sf || (Sf = 1, function(o, e) {
    (function(r, t) {
      o.exports = t();
    })(f7, function() {
      var r = { year: 0, month: 1, day: 2, hour: 3, minute: 4, second: 5 }, t = {};
      return function(n, a, s) {
        var i, l = function(g, d, p) {
          p === void 0 && (p = {});
          var m = new Date(g), y = function(h, F) {
            F === void 0 && (F = {});
            var b = F.timeZoneName || "short", v = h + "|" + b, P = t[v];
            return P || (P = new Intl.DateTimeFormat("en-US", { hour12: !1, timeZone: h, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit", timeZoneName: b }), t[v] = P), P;
          }(d, p);
          return y.formatToParts(m);
        }, c = function(g, d) {
          for (var p = l(g, d), m = [], y = 0; y < p.length; y += 1) {
            var h = p[y], F = h.type, b = h.value, v = r[F];
            v >= 0 && (m[v] = parseInt(b, 10));
          }
          var P = m[3], E = P === 24 ? 0 : P, S = m[0] + "-" + m[1] + "-" + m[2] + " " + E + ":" + m[4] + ":" + m[5] + ":000", D = +g;
          return (s.utc(S).valueOf() - (D -= D % 1e3)) / 6e4;
        }, u = a.prototype;
        u.tz = function(g, d) {
          g === void 0 && (g = i);
          var p, m = this.utcOffset(), y = this.toDate(), h = y.toLocaleString("en-US", { timeZone: g }), F = Math.round((y - new Date(h)) / 1e3 / 60), b = 15 * -Math.round(y.getTimezoneOffset() / 15) - F;
          if (!Number(b)) p = this.utcOffset(0, d);
          else if (p = s(h, { locale: this.$L }).$set("millisecond", this.$ms).utcOffset(b, !0), d) {
            var v = p.utcOffset();
            p = p.add(m - v, "minute");
          }
          return p.$x.$timezone = g, p;
        }, u.offsetName = function(g) {
          var d = this.$x.$timezone || s.tz.guess(), p = l(this.valueOf(), d, { timeZoneName: g }).find(function(m) {
            return m.type.toLowerCase() === "timezonename";
          });
          return p && p.value;
        };
        var f = u.startOf;
        u.startOf = function(g, d) {
          if (!this.$x || !this.$x.$timezone) return f.call(this, g, d);
          var p = s(this.format("YYYY-MM-DD HH:mm:ss:SSS"), { locale: this.$L });
          return f.call(p, g, d).tz(this.$x.$timezone, !0);
        }, s.tz = function(g, d, p) {
          var m = p && d, y = p || d || i, h = c(+s(), y);
          if (typeof g != "string") return s(g).tz(y);
          var F = function(E, S, D) {
            var w = E - 60 * S * 1e3, A = c(w, D);
            if (S === A) return [w, S];
            var C = c(w -= 60 * (A - S) * 1e3, D);
            return A === C ? [w, A] : [E - 60 * Math.min(A, C) * 1e3, Math.max(A, C)];
          }(s.utc(g, m).valueOf(), h, y), b = F[0], v = F[1], P = s(b).utcOffset(v);
          return P.$x.$timezone = y, P;
        }, s.tz.guess = function() {
          return Intl.DateTimeFormat().resolvedOptions().timeZone;
        }, s.tz.setDefault = function(g) {
          i = g;
        };
      };
    });
  }(zs)), zs.exports;
}
var h7 = y7();
const F7 = /* @__PURE__ */ qr(h7), b7 = { class: "absolute inset-0.5" }, WI = /* @__PURE__ */ H({
  __name: "CalendarWeekViewGridItem",
  props: {
    datetime: {},
    duration: {},
    timezone: { default: "Europe/London" },
    color: { default: "white" }
  },
  setup(o) {
    _r.extend(m7), _r.extend(F7);
    const e = o, r = /* @__PURE__ */ new Map([
      [0, "sm:col-start-7"],
      [1, "sm:col-start-1"],
      [2, "sm:col-start-2"],
      [3, "sm:col-start-3"],
      [4, "sm:col-start-4"],
      [5, "sm:col-start-5"],
      [6, "sm:col-start-6"]
    ]), t = se(() => {
      const s = _r.utc(e.datetime).tz(e.timezone), i = _r().hour(s.hour()).minute(s.minute()).second(0), l = i.hour() * 60 + i.minute();
      return Math.floor(l / 5) + 2;
    }), n = {
      white: "bg-white",
      gray: "bg-gray-50"
    }, a = se(() => n[e.color]);
    return (s, i) => (k(), N("li", {
      class: q([
        "relative mt-px flex sm:ml-px",
        B(r).get(B(_r).utc(s.datetime).tz(s.timezone).day()),
        a.value
      ]),
      style: qo({ gridRow: `${t.value} / span ${s.duration / 5}` })
    }, [
      O("div", b7, [
        I(s.$slots, "default")
      ])
    ], 6));
  }
}), v7 = { class: "flex flex-none items-center justify-between border-b border-default-200 px-6 py-4" }, B7 = { class: "flex items-center" }, P7 = { class: "pl-2 pr-base" }, w7 = ["datetime"], NI = /* @__PURE__ */ H({
  __name: "CalendarWeekViewHeader",
  props: {
    current: {}
  },
  emits: ["previous", "today", "next"],
  setup(o, { emit: e }) {
    const r = e;
    return (t, n) => (k(), N("header", v7, [
      O("div", B7, [
        z(Re, {
          color: "tertiary",
          icon: B(kp),
          ariaLabel: "Previous week",
          onClick: n[0] || (n[0] = (a) => r("previous"))
        }, null, 8, ["icon"]),
        z(Re, {
          color: "tertiary",
          icon: B(Si),
          ariaLabel: "Next week",
          onClick: n[1] || (n[1] = (a) => r("next"))
        }, null, 8, ["icon"]),
        O("div", P7, [
          z(Vo, { as: "h2" }, {
            default: j(() => [
              O("time", {
                datetime: B(_r)(t.current).format("YYYY-MM")
              }, _(B(_r)(t.current).format("MMMM YYYY")), 9, w7)
            ]),
            _: 1
          })
        ]),
        z(eo, {
          color: "secondary",
          onClick: n[2] || (n[2] = (a) => r("today"))
        }, {
          default: j(() => n[3] || (n[3] = [
            ne(" Today ")
          ])),
          _: 1
        })
      ]),
      I(t.$slots, "default")
    ]));
  }
}), k7 = {}, D7 = { class: "absolute -top-0.5 -start-1.5 end-[-2px] rounded-full border-t-2 border-red-500" };
function S7(o, e) {
  return k(), N("div", D7, e[0] || (e[0] = [
    O("div", { class: "absolute start-0 -top-[5px] z-10 size-2 rounded-full bg-red-500" }, null, -1)
  ]));
}
const VI = /* @__PURE__ */ fe(k7, [["render", S7]]), Ti = /* @__PURE__ */ H({
  __name: "Card",
  props: {
    color: { default: "white" },
    size: { default: "xl" },
    variant: { default: "default" }
  },
  setup(o) {
    const e = o, r = /* @__PURE__ */ new Map([
      ["gray", "bg-default-50"],
      ["white", "bg-white"],
      ["purple", "bg-purple-50"]
    ]), t = /* @__PURE__ */ new Map([
      ["default", ""],
      ["border", "divide-y divide-default-200"]
    ]);
    return he("card-size", e.size), (n, a) => (k(), N("div", {
      class: q([
        "rounded-lg shadow",
        B(r).get(n.color),
        B(t).get(n.variant)
      ])
    }, [
      I(n.$slots, "default")
    ], 2));
  }
}), Li = /* @__PURE__ */ H({
  __name: "CardContent",
  setup(o) {
    const e = ce("card-size", "xl"), r = /* @__PURE__ */ new Map([
      ["xs", "p-1"],
      ["sm", "p-2"],
      ["base", "p-3"],
      ["lg", "p-4"],
      ["xl", "p-6"]
    ]);
    return (t, n) => (k(), N("div", {
      class: q(B(r).get(B(e)))
    }, [
      I(t.$slots, "default")
    ], 2));
  }
}), A7 = /* @__PURE__ */ H({
  __name: "CardFooter",
  setup(o) {
    const e = ce("card-size", "xl"), r = /* @__PURE__ */ new Map([
      ["xs", "p-1"],
      ["sm", "p-2"],
      ["base", "p-3"],
      ["lg", "p-4"],
      ["xl", "p-6"]
    ]);
    return (t, n) => (k(), N("div", {
      class: q([
        "bg-default-50 rounded-b-lg",
        B(r).get(B(e))
      ])
    }, [
      I(t.$slots, "default")
    ], 2));
  }
}), E7 = /* @__PURE__ */ H({
  __name: "CardHeader",
  setup(o) {
    const e = ce("card-size", "xl"), r = /* @__PURE__ */ new Map([
      ["xs", "p-1"],
      ["sm", "p-2"],
      ["base", "p-3"],
      ["lg", "p-4"],
      ["xl", "p-6"]
    ]);
    return (t, n) => (k(), N("div", {
      class: q(B(r).get(B(e)))
    }, [
      I(t.$slots, "default")
    ], 2));
  }
});
function Af(o) {
  return o !== null && typeof o == "object" && "constructor" in o && o.constructor === Object;
}
function qp(o, e) {
  o === void 0 && (o = {}), e === void 0 && (e = {});
  const r = ["__proto__", "constructor", "prototype"];
  Object.keys(e).filter((t) => r.indexOf(t) < 0).forEach((t) => {
    typeof o[t] > "u" ? o[t] = e[t] : Af(e[t]) && Af(o[t]) && Object.keys(e[t]).length > 0 && qp(o[t], e[t]);
  });
}
const GF = {
  body: {},
  addEventListener() {
  },
  removeEventListener() {
  },
  activeElement: {
    blur() {
    },
    nodeName: ""
  },
  querySelector() {
    return null;
  },
  querySelectorAll() {
    return [];
  },
  getElementById() {
    return null;
  },
  createEvent() {
    return {
      initEvent() {
      }
    };
  },
  createElement() {
    return {
      children: [],
      childNodes: [],
      style: {},
      setAttribute() {
      },
      getElementsByTagName() {
        return [];
      }
    };
  },
  createElementNS() {
    return {};
  },
  importNode() {
    return null;
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  }
};
function Qe() {
  const o = typeof document < "u" ? document : {};
  return qp(o, GF), o;
}
const x7 = {
  document: GF,
  navigator: {
    userAgent: ""
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  },
  history: {
    replaceState() {
    },
    pushState() {
    },
    go() {
    },
    back() {
    }
  },
  CustomEvent: function() {
    return this;
  },
  addEventListener() {
  },
  removeEventListener() {
  },
  getComputedStyle() {
    return {
      getPropertyValue() {
        return "";
      }
    };
  },
  Image() {
  },
  Date() {
  },
  screen: {},
  setTimeout() {
  },
  clearTimeout() {
  },
  matchMedia() {
    return {};
  },
  requestAnimationFrame(o) {
    return typeof setTimeout > "u" ? (o(), null) : setTimeout(o, 0);
  },
  cancelAnimationFrame(o) {
    typeof setTimeout > "u" || clearTimeout(o);
  }
};
function Ne() {
  const o = typeof window < "u" ? window : {};
  return qp(o, x7), o;
}
function Er(o) {
  return o === void 0 && (o = ""), o.trim().split(" ").filter((e) => !!e.trim());
}
function C7(o) {
  const e = o;
  Object.keys(e).forEach((r) => {
    try {
      e[r] = null;
    } catch {
    }
    try {
      delete e[r];
    } catch {
    }
  });
}
function mt(o, e) {
  return e === void 0 && (e = 0), setTimeout(o, e);
}
function No() {
  return Date.now();
}
function O7(o) {
  const e = Ne();
  let r;
  return e.getComputedStyle && (r = e.getComputedStyle(o, null)), !r && o.currentStyle && (r = o.currentStyle), r || (r = o.style), r;
}
function Tu(o, e) {
  e === void 0 && (e = "x");
  const r = Ne();
  let t, n, a;
  const s = O7(o);
  return r.WebKitCSSMatrix ? (n = s.transform || s.webkitTransform, n.split(",").length > 6 && (n = n.split(", ").map((i) => i.replace(",", ".")).join(", ")), a = new r.WebKitCSSMatrix(n === "none" ? "" : n)) : (a = s.MozTransform || s.OTransform || s.MsTransform || s.msTransform || s.transform || s.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,"), t = a.toString().split(",")), e === "x" && (r.WebKitCSSMatrix ? n = a.m41 : t.length === 16 ? n = parseFloat(t[12]) : n = parseFloat(t[4])), e === "y" && (r.WebKitCSSMatrix ? n = a.m42 : t.length === 16 ? n = parseFloat(t[13]) : n = parseFloat(t[5])), n || 0;
}
function vn(o) {
  return typeof o == "object" && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === "Object";
}
function T7(o) {
  return typeof window < "u" && typeof window.HTMLElement < "u" ? o instanceof HTMLElement : o && (o.nodeType === 1 || o.nodeType === 11);
}
function Do() {
  const o = Object(arguments.length <= 0 ? void 0 : arguments[0]), e = ["__proto__", "constructor", "prototype"];
  for (let r = 1; r < arguments.length; r += 1) {
    const t = r < 0 || arguments.length <= r ? void 0 : arguments[r];
    if (t != null && !T7(t)) {
      const n = Object.keys(Object(t)).filter((a) => e.indexOf(a) < 0);
      for (let a = 0, s = n.length; a < s; a += 1) {
        const i = n[a], l = Object.getOwnPropertyDescriptor(t, i);
        l !== void 0 && l.enumerable && (vn(o[i]) && vn(t[i]) ? t[i].__swiper__ ? o[i] = t[i] : Do(o[i], t[i]) : !vn(o[i]) && vn(t[i]) ? (o[i] = {}, t[i].__swiper__ ? o[i] = t[i] : Do(o[i], t[i])) : o[i] = t[i]);
      }
    }
  }
  return o;
}
function Bn(o, e, r) {
  o.style.setProperty(e, r);
}
function XF(o) {
  let {
    swiper: e,
    targetPosition: r,
    side: t
  } = o;
  const n = Ne(), a = -e.translate;
  let s = null, i;
  const l = e.params.speed;
  e.wrapperEl.style.scrollSnapType = "none", n.cancelAnimationFrame(e.cssModeFrameID);
  const c = r > a ? "next" : "prev", u = (g, d) => c === "next" && g >= d || c === "prev" && g <= d, f = () => {
    i = (/* @__PURE__ */ new Date()).getTime(), s === null && (s = i);
    const g = Math.max(Math.min((i - s) / l, 1), 0), d = 0.5 - Math.cos(g * Math.PI) / 2;
    let p = a + d * (r - a);
    if (u(p, r) && (p = r), e.wrapperEl.scrollTo({
      [t]: p
    }), u(p, r)) {
      e.wrapperEl.style.overflow = "hidden", e.wrapperEl.style.scrollSnapType = "", setTimeout(() => {
        e.wrapperEl.style.overflow = "", e.wrapperEl.scrollTo({
          [t]: p
        });
      }), n.cancelAnimationFrame(e.cssModeFrameID);
      return;
    }
    e.cssModeFrameID = n.requestAnimationFrame(f);
  };
  f();
}
function ht(o) {
  return o.querySelector(".swiper-slide-transform") || o.shadowRoot && o.shadowRoot.querySelector(".swiper-slide-transform") || o;
}
function $e(o, e) {
  e === void 0 && (e = "");
  const r = Ne(), t = [...o.children];
  return r.HTMLSlotElement && o instanceof HTMLSlotElement && t.push(...o.assignedElements()), e ? t.filter((n) => n.matches(e)) : t;
}
function L7(o, e) {
  const r = [e];
  for (; r.length > 0; ) {
    const t = r.shift();
    if (o === t)
      return !0;
    r.push(...t.children, ...t.shadowRoot ? t.shadowRoot.children : [], ...t.assignedElements ? t.assignedElements() : []);
  }
}
function j7(o, e) {
  const r = Ne();
  let t = e.contains(o);
  return !t && r.HTMLSlotElement && e instanceof HTMLSlotElement && (t = [...e.assignedElements()].includes(o), t || (t = L7(o, e))), t;
}
function ri(o) {
  try {
    console.warn(o);
    return;
  } catch {
  }
}
function Ao(o, e) {
  e === void 0 && (e = []);
  const r = document.createElement(o);
  return r.classList.add(...Array.isArray(e) ? e : Er(e)), r;
}
function ti(o) {
  const e = Ne(), r = Qe(), t = o.getBoundingClientRect(), n = r.body, a = o.clientTop || n.clientTop || 0, s = o.clientLeft || n.clientLeft || 0, i = o === e ? e.scrollY : o.scrollTop, l = o === e ? e.scrollX : o.scrollLeft;
  return {
    top: t.top + i - a,
    left: t.left + l - s
  };
}
function M7(o, e) {
  const r = [];
  for (; o.previousElementSibling; ) {
    const t = o.previousElementSibling;
    e ? t.matches(e) && r.push(t) : r.push(t), o = t;
  }
  return r;
}
function W7(o, e) {
  const r = [];
  for (; o.nextElementSibling; ) {
    const t = o.nextElementSibling;
    e ? t.matches(e) && r.push(t) : r.push(t), o = t;
  }
  return r;
}
function Tr(o, e) {
  return Ne().getComputedStyle(o, null).getPropertyValue(e);
}
function Da(o) {
  let e = o, r;
  if (e) {
    for (r = 0; (e = e.previousSibling) !== null; )
      e.nodeType === 1 && (r += 1);
    return r;
  }
}
function nt(o, e) {
  const r = [];
  let t = o.parentElement;
  for (; t; )
    e ? t.matches(e) && r.push(t) : r.push(t), t = t.parentElement;
  return r;
}
function En(o, e) {
  function r(t) {
    t.target === o && (e.call(o, t), o.removeEventListener("transitionend", r));
  }
  e && o.addEventListener("transitionend", r);
}
function Lu(o, e, r) {
  const t = Ne();
  return o[e === "width" ? "offsetWidth" : "offsetHeight"] + parseFloat(t.getComputedStyle(o, null).getPropertyValue(e === "width" ? "margin-right" : "margin-top")) + parseFloat(t.getComputedStyle(o, null).getPropertyValue(e === "width" ? "margin-left" : "margin-bottom"));
}
function be(o) {
  return (Array.isArray(o) ? o : [o]).filter((e) => !!e);
}
function ji(o) {
  return (e) => Math.abs(e) > 0 && o.browser && o.browser.need3dFix && Math.abs(e) % 90 === 0 ? e + 1e-3 : e;
}
let oc;
function N7() {
  const o = Ne(), e = Qe();
  return {
    smoothScroll: e.documentElement && e.documentElement.style && "scrollBehavior" in e.documentElement.style,
    touch: !!("ontouchstart" in o || o.DocumentTouch && e instanceof o.DocumentTouch)
  };
}
function UF() {
  return oc || (oc = N7()), oc;
}
let rc;
function V7(o) {
  let {
    userAgent: e
  } = o === void 0 ? {} : o;
  const r = UF(), t = Ne(), n = t.navigator.platform, a = e || t.navigator.userAgent, s = {
    ios: !1,
    android: !1
  }, i = t.screen.width, l = t.screen.height, c = a.match(/(Android);?[\s\/]+([\d.]+)?/);
  let u = a.match(/(iPad).*OS\s([\d_]+)/);
  const f = a.match(/(iPod)(.*OS\s([\d_]+))?/), g = !u && a.match(/(iPhone\sOS|iOS)\s([\d_]+)/), d = n === "Win32";
  let p = n === "MacIntel";
  const m = ["1024x1366", "1366x1024", "834x1194", "1194x834", "834x1112", "1112x834", "768x1024", "1024x768", "820x1180", "1180x820", "810x1080", "1080x810"];
  return !u && p && r.touch && m.indexOf(`${i}x${l}`) >= 0 && (u = a.match(/(Version)\/([\d.]+)/), u || (u = [0, 1, "13_0_0"]), p = !1), c && !d && (s.os = "android", s.android = !0), (u || g || f) && (s.os = "ios", s.ios = !0), s;
}
function ZF(o) {
  return o === void 0 && (o = {}), rc || (rc = V7(o)), rc;
}
let tc;
function z7() {
  const o = Ne(), e = ZF();
  let r = !1;
  function t() {
    const i = o.navigator.userAgent.toLowerCase();
    return i.indexOf("safari") >= 0 && i.indexOf("chrome") < 0 && i.indexOf("android") < 0;
  }
  if (t()) {
    const i = String(o.navigator.userAgent);
    if (i.includes("Version/")) {
      const [l, c] = i.split("Version/")[1].split(" ")[0].split(".").map((u) => Number(u));
      r = l < 16 || l === 16 && c < 2;
    }
  }
  const n = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(o.navigator.userAgent), a = t(), s = a || n && e.ios;
  return {
    isSafari: r || a,
    needPerspectiveFix: r,
    need3dFix: s,
    isWebView: n
  };
}
function KF() {
  return tc || (tc = z7()), tc;
}
function I7(o) {
  let {
    swiper: e,
    on: r,
    emit: t
  } = o;
  const n = Ne();
  let a = null, s = null;
  const i = () => {
    !e || e.destroyed || !e.initialized || (t("beforeResize"), t("resize"));
  }, l = () => {
    !e || e.destroyed || !e.initialized || (a = new ResizeObserver((f) => {
      s = n.requestAnimationFrame(() => {
        const {
          width: g,
          height: d
        } = e;
        let p = g, m = d;
        f.forEach((y) => {
          let {
            contentBoxSize: h,
            contentRect: F,
            target: b
          } = y;
          b && b !== e.el || (p = F ? F.width : (h[0] || h).inlineSize, m = F ? F.height : (h[0] || h).blockSize);
        }), (p !== g || m !== d) && i();
      });
    }), a.observe(e.el));
  }, c = () => {
    s && n.cancelAnimationFrame(s), a && a.unobserve && e.el && (a.unobserve(e.el), a = null);
  }, u = () => {
    !e || e.destroyed || !e.initialized || t("orientationchange");
  };
  r("init", () => {
    if (e.params.resizeObserver && typeof n.ResizeObserver < "u") {
      l();
      return;
    }
    n.addEventListener("resize", i), n.addEventListener("orientationchange", u);
  }), r("destroy", () => {
    c(), n.removeEventListener("resize", i), n.removeEventListener("orientationchange", u);
  });
}
function R7(o) {
  let {
    swiper: e,
    extendParams: r,
    on: t,
    emit: n
  } = o;
  const a = [], s = Ne(), i = function(u, f) {
    f === void 0 && (f = {});
    const g = s.MutationObserver || s.WebkitMutationObserver, d = new g((p) => {
      if (e.__preventObserver__) return;
      if (p.length === 1) {
        n("observerUpdate", p[0]);
        return;
      }
      const m = function() {
        n("observerUpdate", p[0]);
      };
      s.requestAnimationFrame ? s.requestAnimationFrame(m) : s.setTimeout(m, 0);
    });
    d.observe(u, {
      attributes: typeof f.attributes > "u" ? !0 : f.attributes,
      childList: e.isElement || (typeof f.childList > "u" ? !0 : f).childList,
      characterData: typeof f.characterData > "u" ? !0 : f.characterData
    }), a.push(d);
  }, l = () => {
    if (e.params.observer) {
      if (e.params.observeParents) {
        const u = nt(e.hostEl);
        for (let f = 0; f < u.length; f += 1)
          i(u[f]);
      }
      i(e.hostEl, {
        childList: e.params.observeSlideChildren
      }), i(e.wrapperEl, {
        attributes: !1
      });
    }
  }, c = () => {
    a.forEach((u) => {
      u.disconnect();
    }), a.splice(0, a.length);
  };
  r({
    observer: !1,
    observeParents: !1,
    observeSlideChildren: !1
  }), t("init", l), t("destroy", c);
}
var H7 = {
  on(o, e, r) {
    const t = this;
    if (!t.eventsListeners || t.destroyed || typeof e != "function") return t;
    const n = r ? "unshift" : "push";
    return o.split(" ").forEach((a) => {
      t.eventsListeners[a] || (t.eventsListeners[a] = []), t.eventsListeners[a][n](e);
    }), t;
  },
  once(o, e, r) {
    const t = this;
    if (!t.eventsListeners || t.destroyed || typeof e != "function") return t;
    function n() {
      t.off(o, n), n.__emitterProxy && delete n.__emitterProxy;
      for (var a = arguments.length, s = new Array(a), i = 0; i < a; i++)
        s[i] = arguments[i];
      e.apply(t, s);
    }
    return n.__emitterProxy = e, t.on(o, n, r);
  },
  onAny(o, e) {
    const r = this;
    if (!r.eventsListeners || r.destroyed || typeof o != "function") return r;
    const t = e ? "unshift" : "push";
    return r.eventsAnyListeners.indexOf(o) < 0 && r.eventsAnyListeners[t](o), r;
  },
  offAny(o) {
    const e = this;
    if (!e.eventsListeners || e.destroyed || !e.eventsAnyListeners) return e;
    const r = e.eventsAnyListeners.indexOf(o);
    return r >= 0 && e.eventsAnyListeners.splice(r, 1), e;
  },
  off(o, e) {
    const r = this;
    return !r.eventsListeners || r.destroyed || !r.eventsListeners || o.split(" ").forEach((t) => {
      typeof e > "u" ? r.eventsListeners[t] = [] : r.eventsListeners[t] && r.eventsListeners[t].forEach((n, a) => {
        (n === e || n.__emitterProxy && n.__emitterProxy === e) && r.eventsListeners[t].splice(a, 1);
      });
    }), r;
  },
  emit() {
    const o = this;
    if (!o.eventsListeners || o.destroyed || !o.eventsListeners) return o;
    let e, r, t;
    for (var n = arguments.length, a = new Array(n), s = 0; s < n; s++)
      a[s] = arguments[s];
    return typeof a[0] == "string" || Array.isArray(a[0]) ? (e = a[0], r = a.slice(1, a.length), t = o) : (e = a[0].events, r = a[0].data, t = a[0].context || o), r.unshift(t), (Array.isArray(e) ? e : e.split(" ")).forEach((l) => {
      o.eventsAnyListeners && o.eventsAnyListeners.length && o.eventsAnyListeners.forEach((c) => {
        c.apply(t, [l, ...r]);
      }), o.eventsListeners && o.eventsListeners[l] && o.eventsListeners[l].forEach((c) => {
        c.apply(t, r);
      });
    }), o;
  }
};
function Y7() {
  const o = this;
  let e, r;
  const t = o.el;
  typeof o.params.width < "u" && o.params.width !== null ? e = o.params.width : e = t.clientWidth, typeof o.params.height < "u" && o.params.height !== null ? r = o.params.height : r = t.clientHeight, !(e === 0 && o.isHorizontal() || r === 0 && o.isVertical()) && (e = e - parseInt(Tr(t, "padding-left") || 0, 10) - parseInt(Tr(t, "padding-right") || 0, 10), r = r - parseInt(Tr(t, "padding-top") || 0, 10) - parseInt(Tr(t, "padding-bottom") || 0, 10), Number.isNaN(e) && (e = 0), Number.isNaN(r) && (r = 0), Object.assign(o, {
    width: e,
    height: r,
    size: o.isHorizontal() ? e : r
  }));
}
function q7() {
  const o = this;
  function e(A, C) {
    return parseFloat(A.getPropertyValue(o.getDirectionLabel(C)) || 0);
  }
  const r = o.params, {
    wrapperEl: t,
    slidesEl: n,
    size: a,
    rtlTranslate: s,
    wrongRTL: i
  } = o, l = o.virtual && r.virtual.enabled, c = l ? o.virtual.slides.length : o.slides.length, u = $e(n, `.${o.params.slideClass}, swiper-slide`), f = l ? o.virtual.slides.length : u.length;
  let g = [];
  const d = [], p = [];
  let m = r.slidesOffsetBefore;
  typeof m == "function" && (m = r.slidesOffsetBefore.call(o));
  let y = r.slidesOffsetAfter;
  typeof y == "function" && (y = r.slidesOffsetAfter.call(o));
  const h = o.snapGrid.length, F = o.slidesGrid.length;
  let b = r.spaceBetween, v = -m, P = 0, E = 0;
  if (typeof a > "u")
    return;
  typeof b == "string" && b.indexOf("%") >= 0 ? b = parseFloat(b.replace("%", "")) / 100 * a : typeof b == "string" && (b = parseFloat(b)), o.virtualSize = -b, u.forEach((A) => {
    s ? A.style.marginLeft = "" : A.style.marginRight = "", A.style.marginBottom = "", A.style.marginTop = "";
  }), r.centeredSlides && r.cssMode && (Bn(t, "--swiper-centered-offset-before", ""), Bn(t, "--swiper-centered-offset-after", ""));
  const S = r.grid && r.grid.rows > 1 && o.grid;
  S ? o.grid.initSlides(u) : o.grid && o.grid.unsetSlides();
  let D;
  const w = r.slidesPerView === "auto" && r.breakpoints && Object.keys(r.breakpoints).filter((A) => typeof r.breakpoints[A].slidesPerView < "u").length > 0;
  for (let A = 0; A < f; A += 1) {
    D = 0;
    let C;
    if (u[A] && (C = u[A]), S && o.grid.updateSlide(A, C, u), !(u[A] && Tr(C, "display") === "none")) {
      if (r.slidesPerView === "auto") {
        w && (u[A].style[o.getDirectionLabel("width")] = "");
        const x = getComputedStyle(C), T = C.style.transform, M = C.style.webkitTransform;
        if (T && (C.style.transform = "none"), M && (C.style.webkitTransform = "none"), r.roundLengths)
          D = o.isHorizontal() ? Lu(C, "width") : Lu(C, "height");
        else {
          const V = e(x, "width"), G = e(x, "padding-left"), L = e(x, "padding-right"), W = e(x, "margin-left"), Y = e(x, "margin-right"), X = x.getPropertyValue("box-sizing");
          if (X && X === "border-box")
            D = V + W + Y;
          else {
            const {
              clientWidth: J,
              offsetWidth: ee
            } = C;
            D = V + G + L + W + Y + (ee - J);
          }
        }
        T && (C.style.transform = T), M && (C.style.webkitTransform = M), r.roundLengths && (D = Math.floor(D));
      } else
        D = (a - (r.slidesPerView - 1) * b) / r.slidesPerView, r.roundLengths && (D = Math.floor(D)), u[A] && (u[A].style[o.getDirectionLabel("width")] = `${D}px`);
      u[A] && (u[A].swiperSlideSize = D), p.push(D), r.centeredSlides ? (v = v + D / 2 + P / 2 + b, P === 0 && A !== 0 && (v = v - a / 2 - b), A === 0 && (v = v - a / 2 - b), Math.abs(v) < 1 / 1e3 && (v = 0), r.roundLengths && (v = Math.floor(v)), E % r.slidesPerGroup === 0 && g.push(v), d.push(v)) : (r.roundLengths && (v = Math.floor(v)), (E - Math.min(o.params.slidesPerGroupSkip, E)) % o.params.slidesPerGroup === 0 && g.push(v), d.push(v), v = v + D + b), o.virtualSize += D + b, P = D, E += 1;
    }
  }
  if (o.virtualSize = Math.max(o.virtualSize, a) + y, s && i && (r.effect === "slide" || r.effect === "coverflow") && (t.style.width = `${o.virtualSize + b}px`), r.setWrapperSize && (t.style[o.getDirectionLabel("width")] = `${o.virtualSize + b}px`), S && o.grid.updateWrapperSize(D, g), !r.centeredSlides) {
    const A = [];
    for (let C = 0; C < g.length; C += 1) {
      let x = g[C];
      r.roundLengths && (x = Math.floor(x)), g[C] <= o.virtualSize - a && A.push(x);
    }
    g = A, Math.floor(o.virtualSize - a) - Math.floor(g[g.length - 1]) > 1 && g.push(o.virtualSize - a);
  }
  if (l && r.loop) {
    const A = p[0] + b;
    if (r.slidesPerGroup > 1) {
      const C = Math.ceil((o.virtual.slidesBefore + o.virtual.slidesAfter) / r.slidesPerGroup), x = A * r.slidesPerGroup;
      for (let T = 0; T < C; T += 1)
        g.push(g[g.length - 1] + x);
    }
    for (let C = 0; C < o.virtual.slidesBefore + o.virtual.slidesAfter; C += 1)
      r.slidesPerGroup === 1 && g.push(g[g.length - 1] + A), d.push(d[d.length - 1] + A), o.virtualSize += A;
  }
  if (g.length === 0 && (g = [0]), b !== 0) {
    const A = o.isHorizontal() && s ? "marginLeft" : o.getDirectionLabel("marginRight");
    u.filter((C, x) => !r.cssMode || r.loop ? !0 : x !== u.length - 1).forEach((C) => {
      C.style[A] = `${b}px`;
    });
  }
  if (r.centeredSlides && r.centeredSlidesBounds) {
    let A = 0;
    p.forEach((x) => {
      A += x + (b || 0);
    }), A -= b;
    const C = A > a ? A - a : 0;
    g = g.map((x) => x <= 0 ? -m : x > C ? C + y : x);
  }
  if (r.centerInsufficientSlides) {
    let A = 0;
    p.forEach((x) => {
      A += x + (b || 0);
    }), A -= b;
    const C = (r.slidesOffsetBefore || 0) + (r.slidesOffsetAfter || 0);
    if (A + C < a) {
      const x = (a - A - C) / 2;
      g.forEach((T, M) => {
        g[M] = T - x;
      }), d.forEach((T, M) => {
        d[M] = T + x;
      });
    }
  }
  if (Object.assign(o, {
    slides: u,
    snapGrid: g,
    slidesGrid: d,
    slidesSizesGrid: p
  }), r.centeredSlides && r.cssMode && !r.centeredSlidesBounds) {
    Bn(t, "--swiper-centered-offset-before", `${-g[0]}px`), Bn(t, "--swiper-centered-offset-after", `${o.size / 2 - p[p.length - 1] / 2}px`);
    const A = -o.snapGrid[0], C = -o.slidesGrid[0];
    o.snapGrid = o.snapGrid.map((x) => x + A), o.slidesGrid = o.slidesGrid.map((x) => x + C);
  }
  if (f !== c && o.emit("slidesLengthChange"), g.length !== h && (o.params.watchOverflow && o.checkOverflow(), o.emit("snapGridLengthChange")), d.length !== F && o.emit("slidesGridLengthChange"), r.watchSlidesProgress && o.updateSlidesOffset(), o.emit("slidesUpdated"), !l && !r.cssMode && (r.effect === "slide" || r.effect === "fade")) {
    const A = `${r.containerModifierClass}backface-hidden`, C = o.el.classList.contains(A);
    f <= r.maxBackfaceHiddenSlides ? C || o.el.classList.add(A) : C && o.el.classList.remove(A);
  }
}
function G7(o) {
  const e = this, r = [], t = e.virtual && e.params.virtual.enabled;
  let n = 0, a;
  typeof o == "number" ? e.setTransition(o) : o === !0 && e.setTransition(e.params.speed);
  const s = (i) => t ? e.slides[e.getSlideIndexByData(i)] : e.slides[i];
  if (e.params.slidesPerView !== "auto" && e.params.slidesPerView > 1)
    if (e.params.centeredSlides)
      (e.visibleSlides || []).forEach((i) => {
        r.push(i);
      });
    else
      for (a = 0; a < Math.ceil(e.params.slidesPerView); a += 1) {
        const i = e.activeIndex + a;
        if (i > e.slides.length && !t) break;
        r.push(s(i));
      }
  else
    r.push(s(e.activeIndex));
  for (a = 0; a < r.length; a += 1)
    if (typeof r[a] < "u") {
      const i = r[a].offsetHeight;
      n = i > n ? i : n;
    }
  (n || n === 0) && (e.wrapperEl.style.height = `${n}px`);
}
function X7() {
  const o = this, e = o.slides, r = o.isElement ? o.isHorizontal() ? o.wrapperEl.offsetLeft : o.wrapperEl.offsetTop : 0;
  for (let t = 0; t < e.length; t += 1)
    e[t].swiperSlideOffset = (o.isHorizontal() ? e[t].offsetLeft : e[t].offsetTop) - r - o.cssOverflowAdjustment();
}
const Ef = (o, e, r) => {
  e && !o.classList.contains(r) ? o.classList.add(r) : !e && o.classList.contains(r) && o.classList.remove(r);
};
function U7(o) {
  o === void 0 && (o = this && this.translate || 0);
  const e = this, r = e.params, {
    slides: t,
    rtlTranslate: n,
    snapGrid: a
  } = e;
  if (t.length === 0) return;
  typeof t[0].swiperSlideOffset > "u" && e.updateSlidesOffset();
  let s = -o;
  n && (s = o), e.visibleSlidesIndexes = [], e.visibleSlides = [];
  let i = r.spaceBetween;
  typeof i == "string" && i.indexOf("%") >= 0 ? i = parseFloat(i.replace("%", "")) / 100 * e.size : typeof i == "string" && (i = parseFloat(i));
  for (let l = 0; l < t.length; l += 1) {
    const c = t[l];
    let u = c.swiperSlideOffset;
    r.cssMode && r.centeredSlides && (u -= t[0].swiperSlideOffset);
    const f = (s + (r.centeredSlides ? e.minTranslate() : 0) - u) / (c.swiperSlideSize + i), g = (s - a[0] + (r.centeredSlides ? e.minTranslate() : 0) - u) / (c.swiperSlideSize + i), d = -(s - u), p = d + e.slidesSizesGrid[l], m = d >= 0 && d <= e.size - e.slidesSizesGrid[l], y = d >= 0 && d < e.size - 1 || p > 1 && p <= e.size || d <= 0 && p >= e.size;
    y && (e.visibleSlides.push(c), e.visibleSlidesIndexes.push(l)), Ef(c, y, r.slideVisibleClass), Ef(c, m, r.slideFullyVisibleClass), c.progress = n ? -f : f, c.originalProgress = n ? -g : g;
  }
}
function Z7(o) {
  const e = this;
  if (typeof o > "u") {
    const u = e.rtlTranslate ? -1 : 1;
    o = e && e.translate && e.translate * u || 0;
  }
  const r = e.params, t = e.maxTranslate() - e.minTranslate();
  let {
    progress: n,
    isBeginning: a,
    isEnd: s,
    progressLoop: i
  } = e;
  const l = a, c = s;
  if (t === 0)
    n = 0, a = !0, s = !0;
  else {
    n = (o - e.minTranslate()) / t;
    const u = Math.abs(o - e.minTranslate()) < 1, f = Math.abs(o - e.maxTranslate()) < 1;
    a = u || n <= 0, s = f || n >= 1, u && (n = 0), f && (n = 1);
  }
  if (r.loop) {
    const u = e.getSlideIndexByData(0), f = e.getSlideIndexByData(e.slides.length - 1), g = e.slidesGrid[u], d = e.slidesGrid[f], p = e.slidesGrid[e.slidesGrid.length - 1], m = Math.abs(o);
    m >= g ? i = (m - g) / p : i = (m + p - d) / p, i > 1 && (i -= 1);
  }
  Object.assign(e, {
    progress: n,
    progressLoop: i,
    isBeginning: a,
    isEnd: s
  }), (r.watchSlidesProgress || r.centeredSlides && r.autoHeight) && e.updateSlidesProgress(o), a && !l && e.emit("reachBeginning toEdge"), s && !c && e.emit("reachEnd toEdge"), (l && !a || c && !s) && e.emit("fromEdge"), e.emit("progress", n);
}
const nc = (o, e, r) => {
  e && !o.classList.contains(r) ? o.classList.add(r) : !e && o.classList.contains(r) && o.classList.remove(r);
};
function K7() {
  const o = this, {
    slides: e,
    params: r,
    slidesEl: t,
    activeIndex: n
  } = o, a = o.virtual && r.virtual.enabled, s = o.grid && r.grid && r.grid.rows > 1, i = (f) => $e(t, `.${r.slideClass}${f}, swiper-slide${f}`)[0];
  let l, c, u;
  if (a)
    if (r.loop) {
      let f = n - o.virtual.slidesBefore;
      f < 0 && (f = o.virtual.slides.length + f), f >= o.virtual.slides.length && (f -= o.virtual.slides.length), l = i(`[data-swiper-slide-index="${f}"]`);
    } else
      l = i(`[data-swiper-slide-index="${n}"]`);
  else
    s ? (l = e.find((f) => f.column === n), u = e.find((f) => f.column === n + 1), c = e.find((f) => f.column === n - 1)) : l = e[n];
  l && (s || (u = W7(l, `.${r.slideClass}, swiper-slide`)[0], r.loop && !u && (u = e[0]), c = M7(l, `.${r.slideClass}, swiper-slide`)[0], r.loop && !c === 0 && (c = e[e.length - 1]))), e.forEach((f) => {
    nc(f, f === l, r.slideActiveClass), nc(f, f === u, r.slideNextClass), nc(f, f === c, r.slidePrevClass);
  }), o.emitSlidesClasses();
}
const Is = (o, e) => {
  if (!o || o.destroyed || !o.params) return;
  const r = () => o.isElement ? "swiper-slide" : `.${o.params.slideClass}`, t = e.closest(r());
  if (t) {
    let n = t.querySelector(`.${o.params.lazyPreloaderClass}`);
    !n && o.isElement && (t.shadowRoot ? n = t.shadowRoot.querySelector(`.${o.params.lazyPreloaderClass}`) : requestAnimationFrame(() => {
      t.shadowRoot && (n = t.shadowRoot.querySelector(`.${o.params.lazyPreloaderClass}`), n && n.remove());
    })), n && n.remove();
  }
}, ac = (o, e) => {
  if (!o.slides[e]) return;
  const r = o.slides[e].querySelector('[loading="lazy"]');
  r && r.removeAttribute("loading");
}, ju = (o) => {
  if (!o || o.destroyed || !o.params) return;
  let e = o.params.lazyPreloadPrevNext;
  const r = o.slides.length;
  if (!r || !e || e < 0) return;
  e = Math.min(e, r);
  const t = o.params.slidesPerView === "auto" ? o.slidesPerViewDynamic() : Math.ceil(o.params.slidesPerView), n = o.activeIndex;
  if (o.params.grid && o.params.grid.rows > 1) {
    const s = n, i = [s - e];
    i.push(...Array.from({
      length: e
    }).map((l, c) => s + t + c)), o.slides.forEach((l, c) => {
      i.includes(l.column) && ac(o, c);
    });
    return;
  }
  const a = n + t - 1;
  if (o.params.rewind || o.params.loop)
    for (let s = n - e; s <= a + e; s += 1) {
      const i = (s % r + r) % r;
      (i < n || i > a) && ac(o, i);
    }
  else
    for (let s = Math.max(n - e, 0); s <= Math.min(a + e, r - 1); s += 1)
      s !== n && (s > a || s < n) && ac(o, s);
};
function Q7(o) {
  const {
    slidesGrid: e,
    params: r
  } = o, t = o.rtlTranslate ? o.translate : -o.translate;
  let n;
  for (let a = 0; a < e.length; a += 1)
    typeof e[a + 1] < "u" ? t >= e[a] && t < e[a + 1] - (e[a + 1] - e[a]) / 2 ? n = a : t >= e[a] && t < e[a + 1] && (n = a + 1) : t >= e[a] && (n = a);
  return r.normalizeSlideIndex && (n < 0 || typeof n > "u") && (n = 0), n;
}
function J7(o) {
  const e = this, r = e.rtlTranslate ? e.translate : -e.translate, {
    snapGrid: t,
    params: n,
    activeIndex: a,
    realIndex: s,
    snapIndex: i
  } = e;
  let l = o, c;
  const u = (d) => {
    let p = d - e.virtual.slidesBefore;
    return p < 0 && (p = e.virtual.slides.length + p), p >= e.virtual.slides.length && (p -= e.virtual.slides.length), p;
  };
  if (typeof l > "u" && (l = Q7(e)), t.indexOf(r) >= 0)
    c = t.indexOf(r);
  else {
    const d = Math.min(n.slidesPerGroupSkip, l);
    c = d + Math.floor((l - d) / n.slidesPerGroup);
  }
  if (c >= t.length && (c = t.length - 1), l === a && !e.params.loop) {
    c !== i && (e.snapIndex = c, e.emit("snapIndexChange"));
    return;
  }
  if (l === a && e.params.loop && e.virtual && e.params.virtual.enabled) {
    e.realIndex = u(l);
    return;
  }
  const f = e.grid && n.grid && n.grid.rows > 1;
  let g;
  if (e.virtual && n.virtual.enabled && n.loop)
    g = u(l);
  else if (f) {
    const d = e.slides.find((m) => m.column === l);
    let p = parseInt(d.getAttribute("data-swiper-slide-index"), 10);
    Number.isNaN(p) && (p = Math.max(e.slides.indexOf(d), 0)), g = Math.floor(p / n.grid.rows);
  } else if (e.slides[l]) {
    const d = e.slides[l].getAttribute("data-swiper-slide-index");
    d ? g = parseInt(d, 10) : g = l;
  } else
    g = l;
  Object.assign(e, {
    previousSnapIndex: i,
    snapIndex: c,
    previousRealIndex: s,
    realIndex: g,
    previousIndex: a,
    activeIndex: l
  }), e.initialized && ju(e), e.emit("activeIndexChange"), e.emit("snapIndexChange"), (e.initialized || e.params.runCallbacksOnInit) && (s !== g && e.emit("realIndexChange"), e.emit("slideChange"));
}
function _7(o, e) {
  const r = this, t = r.params;
  let n = o.closest(`.${t.slideClass}, swiper-slide`);
  !n && r.isElement && e && e.length > 1 && e.includes(o) && [...e.slice(e.indexOf(o) + 1, e.length)].forEach((i) => {
    !n && i.matches && i.matches(`.${t.slideClass}, swiper-slide`) && (n = i);
  });
  let a = !1, s;
  if (n) {
    for (let i = 0; i < r.slides.length; i += 1)
      if (r.slides[i] === n) {
        a = !0, s = i;
        break;
      }
  }
  if (n && a)
    r.clickedSlide = n, r.virtual && r.params.virtual.enabled ? r.clickedIndex = parseInt(n.getAttribute("data-swiper-slide-index"), 10) : r.clickedIndex = s;
  else {
    r.clickedSlide = void 0, r.clickedIndex = void 0;
    return;
  }
  t.slideToClickedSlide && r.clickedIndex !== void 0 && r.clickedIndex !== r.activeIndex && r.slideToClickedSlide();
}
var $7 = {
  updateSize: Y7,
  updateSlides: q7,
  updateAutoHeight: G7,
  updateSlidesOffset: X7,
  updateSlidesProgress: U7,
  updateProgress: Z7,
  updateSlidesClasses: K7,
  updateActiveIndex: J7,
  updateClickedSlide: _7
};
function eA(o) {
  o === void 0 && (o = this.isHorizontal() ? "x" : "y");
  const e = this, {
    params: r,
    rtlTranslate: t,
    translate: n,
    wrapperEl: a
  } = e;
  if (r.virtualTranslate)
    return t ? -n : n;
  if (r.cssMode)
    return n;
  let s = Tu(a, o);
  return s += e.cssOverflowAdjustment(), t && (s = -s), s || 0;
}
function oA(o, e) {
  const r = this, {
    rtlTranslate: t,
    params: n,
    wrapperEl: a,
    progress: s
  } = r;
  let i = 0, l = 0;
  const c = 0;
  r.isHorizontal() ? i = t ? -o : o : l = o, n.roundLengths && (i = Math.floor(i), l = Math.floor(l)), r.previousTranslate = r.translate, r.translate = r.isHorizontal() ? i : l, n.cssMode ? a[r.isHorizontal() ? "scrollLeft" : "scrollTop"] = r.isHorizontal() ? -i : -l : n.virtualTranslate || (r.isHorizontal() ? i -= r.cssOverflowAdjustment() : l -= r.cssOverflowAdjustment(), a.style.transform = `translate3d(${i}px, ${l}px, ${c}px)`);
  let u;
  const f = r.maxTranslate() - r.minTranslate();
  f === 0 ? u = 0 : u = (o - r.minTranslate()) / f, u !== s && r.updateProgress(o), r.emit("setTranslate", r.translate, e);
}
function rA() {
  return -this.snapGrid[0];
}
function tA() {
  return -this.snapGrid[this.snapGrid.length - 1];
}
function nA(o, e, r, t, n) {
  o === void 0 && (o = 0), e === void 0 && (e = this.params.speed), r === void 0 && (r = !0), t === void 0 && (t = !0);
  const a = this, {
    params: s,
    wrapperEl: i
  } = a;
  if (a.animating && s.preventInteractionOnTransition)
    return !1;
  const l = a.minTranslate(), c = a.maxTranslate();
  let u;
  if (t && o > l ? u = l : t && o < c ? u = c : u = o, a.updateProgress(u), s.cssMode) {
    const f = a.isHorizontal();
    if (e === 0)
      i[f ? "scrollLeft" : "scrollTop"] = -u;
    else {
      if (!a.support.smoothScroll)
        return XF({
          swiper: a,
          targetPosition: -u,
          side: f ? "left" : "top"
        }), !0;
      i.scrollTo({
        [f ? "left" : "top"]: -u,
        behavior: "smooth"
      });
    }
    return !0;
  }
  return e === 0 ? (a.setTransition(0), a.setTranslate(u), r && (a.emit("beforeTransitionStart", e, n), a.emit("transitionEnd"))) : (a.setTransition(e), a.setTranslate(u), r && (a.emit("beforeTransitionStart", e, n), a.emit("transitionStart")), a.animating || (a.animating = !0, a.onTranslateToWrapperTransitionEnd || (a.onTranslateToWrapperTransitionEnd = function(g) {
    !a || a.destroyed || g.target === this && (a.wrapperEl.removeEventListener("transitionend", a.onTranslateToWrapperTransitionEnd), a.onTranslateToWrapperTransitionEnd = null, delete a.onTranslateToWrapperTransitionEnd, a.animating = !1, r && a.emit("transitionEnd"));
  }), a.wrapperEl.addEventListener("transitionend", a.onTranslateToWrapperTransitionEnd))), !0;
}
var aA = {
  getTranslate: eA,
  setTranslate: oA,
  minTranslate: rA,
  maxTranslate: tA,
  translateTo: nA
};
function sA(o, e) {
  const r = this;
  r.params.cssMode || (r.wrapperEl.style.transitionDuration = `${o}ms`, r.wrapperEl.style.transitionDelay = o === 0 ? "0ms" : ""), r.emit("setTransition", o, e);
}
function QF(o) {
  let {
    swiper: e,
    runCallbacks: r,
    direction: t,
    step: n
  } = o;
  const {
    activeIndex: a,
    previousIndex: s
  } = e;
  let i = t;
  if (i || (a > s ? i = "next" : a < s ? i = "prev" : i = "reset"), e.emit(`transition${n}`), r && a !== s) {
    if (i === "reset") {
      e.emit(`slideResetTransition${n}`);
      return;
    }
    e.emit(`slideChangeTransition${n}`), i === "next" ? e.emit(`slideNextTransition${n}`) : e.emit(`slidePrevTransition${n}`);
  }
}
function iA(o, e) {
  o === void 0 && (o = !0);
  const r = this, {
    params: t
  } = r;
  t.cssMode || (t.autoHeight && r.updateAutoHeight(), QF({
    swiper: r,
    runCallbacks: o,
    direction: e,
    step: "Start"
  }));
}
function lA(o, e) {
  o === void 0 && (o = !0);
  const r = this, {
    params: t
  } = r;
  r.animating = !1, !t.cssMode && (r.setTransition(0), QF({
    swiper: r,
    runCallbacks: o,
    direction: e,
    step: "End"
  }));
}
var cA = {
  setTransition: sA,
  transitionStart: iA,
  transitionEnd: lA
};
function uA(o, e, r, t, n) {
  o === void 0 && (o = 0), r === void 0 && (r = !0), typeof o == "string" && (o = parseInt(o, 10));
  const a = this;
  let s = o;
  s < 0 && (s = 0);
  const {
    params: i,
    snapGrid: l,
    slidesGrid: c,
    previousIndex: u,
    activeIndex: f,
    rtlTranslate: g,
    wrapperEl: d,
    enabled: p
  } = a;
  if (!p && !t && !n || a.destroyed || a.animating && i.preventInteractionOnTransition)
    return !1;
  typeof e > "u" && (e = a.params.speed);
  const m = Math.min(a.params.slidesPerGroupSkip, s);
  let y = m + Math.floor((s - m) / a.params.slidesPerGroup);
  y >= l.length && (y = l.length - 1);
  const h = -l[y];
  if (i.normalizeSlideIndex)
    for (let S = 0; S < c.length; S += 1) {
      const D = -Math.floor(h * 100), w = Math.floor(c[S] * 100), A = Math.floor(c[S + 1] * 100);
      typeof c[S + 1] < "u" ? D >= w && D < A - (A - w) / 2 ? s = S : D >= w && D < A && (s = S + 1) : D >= w && (s = S);
    }
  if (a.initialized && s !== f && (!a.allowSlideNext && (g ? h > a.translate && h > a.minTranslate() : h < a.translate && h < a.minTranslate()) || !a.allowSlidePrev && h > a.translate && h > a.maxTranslate() && (f || 0) !== s))
    return !1;
  s !== (u || 0) && r && a.emit("beforeSlideChangeStart"), a.updateProgress(h);
  let F;
  s > f ? F = "next" : s < f ? F = "prev" : F = "reset";
  const b = a.virtual && a.params.virtual.enabled;
  if (!(b && n) && (g && -h === a.translate || !g && h === a.translate))
    return a.updateActiveIndex(s), i.autoHeight && a.updateAutoHeight(), a.updateSlidesClasses(), i.effect !== "slide" && a.setTranslate(h), F !== "reset" && (a.transitionStart(r, F), a.transitionEnd(r, F)), !1;
  if (i.cssMode) {
    const S = a.isHorizontal(), D = g ? h : -h;
    if (e === 0)
      b && (a.wrapperEl.style.scrollSnapType = "none", a._immediateVirtual = !0), b && !a._cssModeVirtualInitialSet && a.params.initialSlide > 0 ? (a._cssModeVirtualInitialSet = !0, requestAnimationFrame(() => {
        d[S ? "scrollLeft" : "scrollTop"] = D;
      })) : d[S ? "scrollLeft" : "scrollTop"] = D, b && requestAnimationFrame(() => {
        a.wrapperEl.style.scrollSnapType = "", a._immediateVirtual = !1;
      });
    else {
      if (!a.support.smoothScroll)
        return XF({
          swiper: a,
          targetPosition: D,
          side: S ? "left" : "top"
        }), !0;
      d.scrollTo({
        [S ? "left" : "top"]: D,
        behavior: "smooth"
      });
    }
    return !0;
  }
  const E = KF().isSafari;
  return b && !n && E && a.isElement && a.virtual.update(!1, !1, s), a.setTransition(e), a.setTranslate(h), a.updateActiveIndex(s), a.updateSlidesClasses(), a.emit("beforeTransitionStart", e, t), a.transitionStart(r, F), e === 0 ? a.transitionEnd(r, F) : a.animating || (a.animating = !0, a.onSlideToWrapperTransitionEnd || (a.onSlideToWrapperTransitionEnd = function(D) {
    !a || a.destroyed || D.target === this && (a.wrapperEl.removeEventListener("transitionend", a.onSlideToWrapperTransitionEnd), a.onSlideToWrapperTransitionEnd = null, delete a.onSlideToWrapperTransitionEnd, a.transitionEnd(r, F));
  }), a.wrapperEl.addEventListener("transitionend", a.onSlideToWrapperTransitionEnd)), !0;
}
function pA(o, e, r, t) {
  o === void 0 && (o = 0), r === void 0 && (r = !0), typeof o == "string" && (o = parseInt(o, 10));
  const n = this;
  if (n.destroyed) return;
  typeof e > "u" && (e = n.params.speed);
  const a = n.grid && n.params.grid && n.params.grid.rows > 1;
  let s = o;
  if (n.params.loop)
    if (n.virtual && n.params.virtual.enabled)
      s = s + n.virtual.slidesBefore;
    else {
      let i;
      if (a) {
        const g = s * n.params.grid.rows;
        i = n.slides.find((d) => d.getAttribute("data-swiper-slide-index") * 1 === g).column;
      } else
        i = n.getSlideIndexByData(s);
      const l = a ? Math.ceil(n.slides.length / n.params.grid.rows) : n.slides.length, {
        centeredSlides: c
      } = n.params;
      let u = n.params.slidesPerView;
      u === "auto" ? u = n.slidesPerViewDynamic() : (u = Math.ceil(parseFloat(n.params.slidesPerView, 10)), c && u % 2 === 0 && (u = u + 1));
      let f = l - i < u;
      if (c && (f = f || i < Math.ceil(u / 2)), t && c && n.params.slidesPerView !== "auto" && !a && (f = !1), f) {
        const g = c ? i < n.activeIndex ? "prev" : "next" : i - n.activeIndex - 1 < n.params.slidesPerView ? "next" : "prev";
        n.loopFix({
          direction: g,
          slideTo: !0,
          activeSlideIndex: g === "next" ? i + 1 : i - l + 1,
          slideRealIndex: g === "next" ? n.realIndex : void 0
        });
      }
      if (a) {
        const g = s * n.params.grid.rows;
        s = n.slides.find((d) => d.getAttribute("data-swiper-slide-index") * 1 === g).column;
      } else
        s = n.getSlideIndexByData(s);
    }
  return requestAnimationFrame(() => {
    n.slideTo(s, e, r, t);
  }), n;
}
function dA(o, e, r) {
  e === void 0 && (e = !0);
  const t = this, {
    enabled: n,
    params: a,
    animating: s
  } = t;
  if (!n || t.destroyed) return t;
  typeof o > "u" && (o = t.params.speed);
  let i = a.slidesPerGroup;
  a.slidesPerView === "auto" && a.slidesPerGroup === 1 && a.slidesPerGroupAuto && (i = Math.max(t.slidesPerViewDynamic("current", !0), 1));
  const l = t.activeIndex < a.slidesPerGroupSkip ? 1 : i, c = t.virtual && a.virtual.enabled;
  if (a.loop) {
    if (s && !c && a.loopPreventsSliding) return !1;
    if (t.loopFix({
      direction: "next"
    }), t._clientLeft = t.wrapperEl.clientLeft, t.activeIndex === t.slides.length - 1 && a.cssMode)
      return requestAnimationFrame(() => {
        t.slideTo(t.activeIndex + l, o, e, r);
      }), !0;
  }
  return a.rewind && t.isEnd ? t.slideTo(0, o, e, r) : t.slideTo(t.activeIndex + l, o, e, r);
}
function gA(o, e, r) {
  e === void 0 && (e = !0);
  const t = this, {
    params: n,
    snapGrid: a,
    slidesGrid: s,
    rtlTranslate: i,
    enabled: l,
    animating: c
  } = t;
  if (!l || t.destroyed) return t;
  typeof o > "u" && (o = t.params.speed);
  const u = t.virtual && n.virtual.enabled;
  if (n.loop) {
    if (c && !u && n.loopPreventsSliding) return !1;
    t.loopFix({
      direction: "prev"
    }), t._clientLeft = t.wrapperEl.clientLeft;
  }
  const f = i ? t.translate : -t.translate;
  function g(F) {
    return F < 0 ? -Math.floor(Math.abs(F)) : Math.floor(F);
  }
  const d = g(f), p = a.map((F) => g(F)), m = n.freeMode && n.freeMode.enabled;
  let y = a[p.indexOf(d) - 1];
  if (typeof y > "u" && (n.cssMode || m)) {
    let F;
    a.forEach((b, v) => {
      d >= b && (F = v);
    }), typeof F < "u" && (y = m ? a[F] : a[F > 0 ? F - 1 : F]);
  }
  let h = 0;
  if (typeof y < "u" && (h = s.indexOf(y), h < 0 && (h = t.activeIndex - 1), n.slidesPerView === "auto" && n.slidesPerGroup === 1 && n.slidesPerGroupAuto && (h = h - t.slidesPerViewDynamic("previous", !0) + 1, h = Math.max(h, 0))), n.rewind && t.isBeginning) {
    const F = t.params.virtual && t.params.virtual.enabled && t.virtual ? t.virtual.slides.length - 1 : t.slides.length - 1;
    return t.slideTo(F, o, e, r);
  } else if (n.loop && t.activeIndex === 0 && n.cssMode)
    return requestAnimationFrame(() => {
      t.slideTo(h, o, e, r);
    }), !0;
  return t.slideTo(h, o, e, r);
}
function mA(o, e, r) {
  e === void 0 && (e = !0);
  const t = this;
  if (!t.destroyed)
    return typeof o > "u" && (o = t.params.speed), t.slideTo(t.activeIndex, o, e, r);
}
function fA(o, e, r, t) {
  e === void 0 && (e = !0), t === void 0 && (t = 0.5);
  const n = this;
  if (n.destroyed) return;
  typeof o > "u" && (o = n.params.speed);
  let a = n.activeIndex;
  const s = Math.min(n.params.slidesPerGroupSkip, a), i = s + Math.floor((a - s) / n.params.slidesPerGroup), l = n.rtlTranslate ? n.translate : -n.translate;
  if (l >= n.snapGrid[i]) {
    const c = n.snapGrid[i], u = n.snapGrid[i + 1];
    l - c > (u - c) * t && (a += n.params.slidesPerGroup);
  } else {
    const c = n.snapGrid[i - 1], u = n.snapGrid[i];
    l - c <= (u - c) * t && (a -= n.params.slidesPerGroup);
  }
  return a = Math.max(a, 0), a = Math.min(a, n.slidesGrid.length - 1), n.slideTo(a, o, e, r);
}
function yA() {
  const o = this;
  if (o.destroyed) return;
  const {
    params: e,
    slidesEl: r
  } = o, t = e.slidesPerView === "auto" ? o.slidesPerViewDynamic() : e.slidesPerView;
  let n = o.clickedIndex, a;
  const s = o.isElement ? "swiper-slide" : `.${e.slideClass}`;
  if (e.loop) {
    if (o.animating) return;
    a = parseInt(o.clickedSlide.getAttribute("data-swiper-slide-index"), 10), e.centeredSlides ? n < o.loopedSlides - t / 2 || n > o.slides.length - o.loopedSlides + t / 2 ? (o.loopFix(), n = o.getSlideIndex($e(r, `${s}[data-swiper-slide-index="${a}"]`)[0]), mt(() => {
      o.slideTo(n);
    })) : o.slideTo(n) : n > o.slides.length - t ? (o.loopFix(), n = o.getSlideIndex($e(r, `${s}[data-swiper-slide-index="${a}"]`)[0]), mt(() => {
      o.slideTo(n);
    })) : o.slideTo(n);
  } else
    o.slideTo(n);
}
var hA = {
  slideTo: uA,
  slideToLoop: pA,
  slideNext: dA,
  slidePrev: gA,
  slideReset: mA,
  slideToClosest: fA,
  slideToClickedSlide: yA
};
function FA(o) {
  const e = this, {
    params: r,
    slidesEl: t
  } = e;
  if (!r.loop || e.virtual && e.params.virtual.enabled) return;
  const n = () => {
    $e(t, `.${r.slideClass}, swiper-slide`).forEach((f, g) => {
      f.setAttribute("data-swiper-slide-index", g);
    });
  }, a = e.grid && r.grid && r.grid.rows > 1, s = r.slidesPerGroup * (a ? r.grid.rows : 1), i = e.slides.length % s !== 0, l = a && e.slides.length % r.grid.rows !== 0, c = (u) => {
    for (let f = 0; f < u; f += 1) {
      const g = e.isElement ? Ao("swiper-slide", [r.slideBlankClass]) : Ao("div", [r.slideClass, r.slideBlankClass]);
      e.slidesEl.append(g);
    }
  };
  if (i) {
    if (r.loopAddBlankSlides) {
      const u = s - e.slides.length % s;
      c(u), e.recalcSlides(), e.updateSlides();
    } else
      ri("Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
    n();
  } else if (l) {
    if (r.loopAddBlankSlides) {
      const u = r.grid.rows - e.slides.length % r.grid.rows;
      c(u), e.recalcSlides(), e.updateSlides();
    } else
      ri("Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
    n();
  } else
    n();
  e.loopFix({
    slideRealIndex: o,
    direction: r.centeredSlides ? void 0 : "next"
  });
}
function bA(o) {
  let {
    slideRealIndex: e,
    slideTo: r = !0,
    direction: t,
    setTranslate: n,
    activeSlideIndex: a,
    byController: s,
    byMousewheel: i
  } = o === void 0 ? {} : o;
  const l = this;
  if (!l.params.loop) return;
  l.emit("beforeLoopFix");
  const {
    slides: c,
    allowSlidePrev: u,
    allowSlideNext: f,
    slidesEl: g,
    params: d
  } = l, {
    centeredSlides: p
  } = d;
  if (l.allowSlidePrev = !0, l.allowSlideNext = !0, l.virtual && d.virtual.enabled) {
    r && (!d.centeredSlides && l.snapIndex === 0 ? l.slideTo(l.virtual.slides.length, 0, !1, !0) : d.centeredSlides && l.snapIndex < d.slidesPerView ? l.slideTo(l.virtual.slides.length + l.snapIndex, 0, !1, !0) : l.snapIndex === l.snapGrid.length - 1 && l.slideTo(l.virtual.slidesBefore, 0, !1, !0)), l.allowSlidePrev = u, l.allowSlideNext = f, l.emit("loopFix");
    return;
  }
  let m = d.slidesPerView;
  m === "auto" ? m = l.slidesPerViewDynamic() : (m = Math.ceil(parseFloat(d.slidesPerView, 10)), p && m % 2 === 0 && (m = m + 1));
  const y = d.slidesPerGroupAuto ? m : d.slidesPerGroup;
  let h = y;
  h % y !== 0 && (h += y - h % y), h += d.loopAdditionalSlides, l.loopedSlides = h;
  const F = l.grid && d.grid && d.grid.rows > 1;
  c.length < m + h ? ri("Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled and not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters") : F && d.grid.fill === "row" && ri("Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`");
  const b = [], v = [];
  let P = l.activeIndex;
  typeof a > "u" ? a = l.getSlideIndex(c.find((T) => T.classList.contains(d.slideActiveClass))) : P = a;
  const E = t === "next" || !t, S = t === "prev" || !t;
  let D = 0, w = 0;
  const A = F ? Math.ceil(c.length / d.grid.rows) : c.length, x = (F ? c[a].column : a) + (p && typeof n > "u" ? -m / 2 + 0.5 : 0);
  if (x < h) {
    D = Math.max(h - x, y);
    for (let T = 0; T < h - x; T += 1) {
      const M = T - Math.floor(T / A) * A;
      if (F) {
        const V = A - M - 1;
        for (let G = c.length - 1; G >= 0; G -= 1)
          c[G].column === V && b.push(G);
      } else
        b.push(A - M - 1);
    }
  } else if (x + m > A - h) {
    w = Math.max(x - (A - h * 2), y);
    for (let T = 0; T < w; T += 1) {
      const M = T - Math.floor(T / A) * A;
      F ? c.forEach((V, G) => {
        V.column === M && v.push(G);
      }) : v.push(M);
    }
  }
  if (l.__preventObserver__ = !0, requestAnimationFrame(() => {
    l.__preventObserver__ = !1;
  }), S && b.forEach((T) => {
    c[T].swiperLoopMoveDOM = !0, g.prepend(c[T]), c[T].swiperLoopMoveDOM = !1;
  }), E && v.forEach((T) => {
    c[T].swiperLoopMoveDOM = !0, g.append(c[T]), c[T].swiperLoopMoveDOM = !1;
  }), l.recalcSlides(), d.slidesPerView === "auto" ? l.updateSlides() : F && (b.length > 0 && S || v.length > 0 && E) && l.slides.forEach((T, M) => {
    l.grid.updateSlide(M, T, l.slides);
  }), d.watchSlidesProgress && l.updateSlidesOffset(), r) {
    if (b.length > 0 && S) {
      if (typeof e > "u") {
        const T = l.slidesGrid[P], V = l.slidesGrid[P + D] - T;
        i ? l.setTranslate(l.translate - V) : (l.slideTo(P + Math.ceil(D), 0, !1, !0), n && (l.touchEventsData.startTranslate = l.touchEventsData.startTranslate - V, l.touchEventsData.currentTranslate = l.touchEventsData.currentTranslate - V));
      } else if (n) {
        const T = F ? b.length / d.grid.rows : b.length;
        l.slideTo(l.activeIndex + T, 0, !1, !0), l.touchEventsData.currentTranslate = l.translate;
      }
    } else if (v.length > 0 && E)
      if (typeof e > "u") {
        const T = l.slidesGrid[P], V = l.slidesGrid[P - w] - T;
        i ? l.setTranslate(l.translate - V) : (l.slideTo(P - w, 0, !1, !0), n && (l.touchEventsData.startTranslate = l.touchEventsData.startTranslate - V, l.touchEventsData.currentTranslate = l.touchEventsData.currentTranslate - V));
      } else {
        const T = F ? v.length / d.grid.rows : v.length;
        l.slideTo(l.activeIndex - T, 0, !1, !0);
      }
  }
  if (l.allowSlidePrev = u, l.allowSlideNext = f, l.controller && l.controller.control && !s) {
    const T = {
      slideRealIndex: e,
      direction: t,
      setTranslate: n,
      activeSlideIndex: a,
      byController: !0
    };
    Array.isArray(l.controller.control) ? l.controller.control.forEach((M) => {
      !M.destroyed && M.params.loop && M.loopFix({
        ...T,
        slideTo: M.params.slidesPerView === d.slidesPerView ? r : !1
      });
    }) : l.controller.control instanceof l.constructor && l.controller.control.params.loop && l.controller.control.loopFix({
      ...T,
      slideTo: l.controller.control.params.slidesPerView === d.slidesPerView ? r : !1
    });
  }
  l.emit("loopFix");
}
function vA() {
  const o = this, {
    params: e,
    slidesEl: r
  } = o;
  if (!e.loop || !r || o.virtual && o.params.virtual.enabled) return;
  o.recalcSlides();
  const t = [];
  o.slides.forEach((n) => {
    const a = typeof n.swiperSlideIndex > "u" ? n.getAttribute("data-swiper-slide-index") * 1 : n.swiperSlideIndex;
    t[a] = n;
  }), o.slides.forEach((n) => {
    n.removeAttribute("data-swiper-slide-index");
  }), t.forEach((n) => {
    r.append(n);
  }), o.recalcSlides(), o.slideTo(o.realIndex, 0);
}
var BA = {
  loopCreate: FA,
  loopFix: bA,
  loopDestroy: vA
};
function PA(o) {
  const e = this;
  if (!e.params.simulateTouch || e.params.watchOverflow && e.isLocked || e.params.cssMode) return;
  const r = e.params.touchEventsTarget === "container" ? e.el : e.wrapperEl;
  e.isElement && (e.__preventObserver__ = !0), r.style.cursor = "move", r.style.cursor = o ? "grabbing" : "grab", e.isElement && requestAnimationFrame(() => {
    e.__preventObserver__ = !1;
  });
}
function wA() {
  const o = this;
  o.params.watchOverflow && o.isLocked || o.params.cssMode || (o.isElement && (o.__preventObserver__ = !0), o[o.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "", o.isElement && requestAnimationFrame(() => {
    o.__preventObserver__ = !1;
  }));
}
var kA = {
  setGrabCursor: PA,
  unsetGrabCursor: wA
};
function DA(o, e) {
  e === void 0 && (e = this);
  function r(t) {
    if (!t || t === Qe() || t === Ne()) return null;
    t.assignedSlot && (t = t.assignedSlot);
    const n = t.closest(o);
    return !n && !t.getRootNode ? null : n || r(t.getRootNode().host);
  }
  return r(e);
}
function xf(o, e, r) {
  const t = Ne(), {
    params: n
  } = o, a = n.edgeSwipeDetection, s = n.edgeSwipeThreshold;
  return a && (r <= s || r >= t.innerWidth - s) ? a === "prevent" ? (e.preventDefault(), !0) : !1 : !0;
}
function SA(o) {
  const e = this, r = Qe();
  let t = o;
  t.originalEvent && (t = t.originalEvent);
  const n = e.touchEventsData;
  if (t.type === "pointerdown") {
    if (n.pointerId !== null && n.pointerId !== t.pointerId)
      return;
    n.pointerId = t.pointerId;
  } else t.type === "touchstart" && t.targetTouches.length === 1 && (n.touchId = t.targetTouches[0].identifier);
  if (t.type === "touchstart") {
    xf(e, t, t.targetTouches[0].pageX);
    return;
  }
  const {
    params: a,
    touches: s,
    enabled: i
  } = e;
  if (!i || !a.simulateTouch && t.pointerType === "mouse" || e.animating && a.preventInteractionOnTransition)
    return;
  !e.animating && a.cssMode && a.loop && e.loopFix();
  let l = t.target;
  if (a.touchEventsTarget === "wrapper" && !j7(l, e.wrapperEl) || "which" in t && t.which === 3 || "button" in t && t.button > 0 || n.isTouched && n.isMoved) return;
  const c = !!a.noSwipingClass && a.noSwipingClass !== "", u = t.composedPath ? t.composedPath() : t.path;
  c && t.target && t.target.shadowRoot && u && (l = u[0]);
  const f = a.noSwipingSelector ? a.noSwipingSelector : `.${a.noSwipingClass}`, g = !!(t.target && t.target.shadowRoot);
  if (a.noSwiping && (g ? DA(f, l) : l.closest(f))) {
    e.allowClick = !0;
    return;
  }
  if (a.swipeHandler && !l.closest(a.swipeHandler))
    return;
  s.currentX = t.pageX, s.currentY = t.pageY;
  const d = s.currentX, p = s.currentY;
  if (!xf(e, t, d))
    return;
  Object.assign(n, {
    isTouched: !0,
    isMoved: !1,
    allowTouchCallbacks: !0,
    isScrolling: void 0,
    startMoving: void 0
  }), s.startX = d, s.startY = p, n.touchStartTime = No(), e.allowClick = !0, e.updateSize(), e.swipeDirection = void 0, a.threshold > 0 && (n.allowThresholdMove = !1);
  let m = !0;
  l.matches(n.focusableElements) && (m = !1, l.nodeName === "SELECT" && (n.isTouched = !1)), r.activeElement && r.activeElement.matches(n.focusableElements) && r.activeElement !== l && (t.pointerType === "mouse" || t.pointerType !== "mouse" && !l.matches(n.focusableElements)) && r.activeElement.blur();
  const y = m && e.allowTouchMove && a.touchStartPreventDefault;
  (a.touchStartForcePreventDefault || y) && !l.isContentEditable && t.preventDefault(), a.freeMode && a.freeMode.enabled && e.freeMode && e.animating && !a.cssMode && e.freeMode.onTouchStart(), e.emit("touchStart", t);
}
function AA(o) {
  const e = Qe(), r = this, t = r.touchEventsData, {
    params: n,
    touches: a,
    rtlTranslate: s,
    enabled: i
  } = r;
  if (!i || !n.simulateTouch && o.pointerType === "mouse") return;
  let l = o;
  if (l.originalEvent && (l = l.originalEvent), l.type === "pointermove" && (t.touchId !== null || l.pointerId !== t.pointerId))
    return;
  let c;
  if (l.type === "touchmove") {
    if (c = [...l.changedTouches].find((P) => P.identifier === t.touchId), !c || c.identifier !== t.touchId) return;
  } else
    c = l;
  if (!t.isTouched) {
    t.startMoving && t.isScrolling && r.emit("touchMoveOpposite", l);
    return;
  }
  const u = c.pageX, f = c.pageY;
  if (l.preventedByNestedSwiper) {
    a.startX = u, a.startY = f;
    return;
  }
  if (!r.allowTouchMove) {
    l.target.matches(t.focusableElements) || (r.allowClick = !1), t.isTouched && (Object.assign(a, {
      startX: u,
      startY: f,
      currentX: u,
      currentY: f
    }), t.touchStartTime = No());
    return;
  }
  if (n.touchReleaseOnEdges && !n.loop) {
    if (r.isVertical()) {
      if (f < a.startY && r.translate <= r.maxTranslate() || f > a.startY && r.translate >= r.minTranslate()) {
        t.isTouched = !1, t.isMoved = !1;
        return;
      }
    } else if (u < a.startX && r.translate <= r.maxTranslate() || u > a.startX && r.translate >= r.minTranslate())
      return;
  }
  if (e.activeElement && e.activeElement.matches(t.focusableElements) && e.activeElement !== l.target && l.pointerType !== "mouse" && e.activeElement.blur(), e.activeElement && l.target === e.activeElement && l.target.matches(t.focusableElements)) {
    t.isMoved = !0, r.allowClick = !1;
    return;
  }
  t.allowTouchCallbacks && r.emit("touchMove", l), a.previousX = a.currentX, a.previousY = a.currentY, a.currentX = u, a.currentY = f;
  const g = a.currentX - a.startX, d = a.currentY - a.startY;
  if (r.params.threshold && Math.sqrt(g ** 2 + d ** 2) < r.params.threshold) return;
  if (typeof t.isScrolling > "u") {
    let P;
    r.isHorizontal() && a.currentY === a.startY || r.isVertical() && a.currentX === a.startX ? t.isScrolling = !1 : g * g + d * d >= 25 && (P = Math.atan2(Math.abs(d), Math.abs(g)) * 180 / Math.PI, t.isScrolling = r.isHorizontal() ? P > n.touchAngle : 90 - P > n.touchAngle);
  }
  if (t.isScrolling && r.emit("touchMoveOpposite", l), typeof t.startMoving > "u" && (a.currentX !== a.startX || a.currentY !== a.startY) && (t.startMoving = !0), t.isScrolling || l.type === "touchmove" && t.preventTouchMoveFromPointerMove) {
    t.isTouched = !1;
    return;
  }
  if (!t.startMoving)
    return;
  r.allowClick = !1, !n.cssMode && l.cancelable && l.preventDefault(), n.touchMoveStopPropagation && !n.nested && l.stopPropagation();
  let p = r.isHorizontal() ? g : d, m = r.isHorizontal() ? a.currentX - a.previousX : a.currentY - a.previousY;
  n.oneWayMovement && (p = Math.abs(p) * (s ? 1 : -1), m = Math.abs(m) * (s ? 1 : -1)), a.diff = p, p *= n.touchRatio, s && (p = -p, m = -m);
  const y = r.touchesDirection;
  r.swipeDirection = p > 0 ? "prev" : "next", r.touchesDirection = m > 0 ? "prev" : "next";
  const h = r.params.loop && !n.cssMode, F = r.touchesDirection === "next" && r.allowSlideNext || r.touchesDirection === "prev" && r.allowSlidePrev;
  if (!t.isMoved) {
    if (h && F && r.loopFix({
      direction: r.swipeDirection
    }), t.startTranslate = r.getTranslate(), r.setTransition(0), r.animating) {
      const P = new window.CustomEvent("transitionend", {
        bubbles: !0,
        cancelable: !0,
        detail: {
          bySwiperTouchMove: !0
        }
      });
      r.wrapperEl.dispatchEvent(P);
    }
    t.allowMomentumBounce = !1, n.grabCursor && (r.allowSlideNext === !0 || r.allowSlidePrev === !0) && r.setGrabCursor(!0), r.emit("sliderFirstMove", l);
  }
  if ((/* @__PURE__ */ new Date()).getTime(), n._loopSwapReset !== !1 && t.isMoved && t.allowThresholdMove && y !== r.touchesDirection && h && F && Math.abs(p) >= 1) {
    Object.assign(a, {
      startX: u,
      startY: f,
      currentX: u,
      currentY: f,
      startTranslate: t.currentTranslate
    }), t.loopSwapReset = !0, t.startTranslate = t.currentTranslate;
    return;
  }
  r.emit("sliderMove", l), t.isMoved = !0, t.currentTranslate = p + t.startTranslate;
  let b = !0, v = n.resistanceRatio;
  if (n.touchReleaseOnEdges && (v = 0), p > 0 ? (h && F && t.allowThresholdMove && t.currentTranslate > (n.centeredSlides ? r.minTranslate() - r.slidesSizesGrid[r.activeIndex + 1] - (n.slidesPerView !== "auto" && r.slides.length - n.slidesPerView >= 2 ? r.slidesSizesGrid[r.activeIndex + 1] + r.params.spaceBetween : 0) - r.params.spaceBetween : r.minTranslate()) && r.loopFix({
    direction: "prev",
    setTranslate: !0,
    activeSlideIndex: 0
  }), t.currentTranslate > r.minTranslate() && (b = !1, n.resistance && (t.currentTranslate = r.minTranslate() - 1 + (-r.minTranslate() + t.startTranslate + p) ** v))) : p < 0 && (h && F && t.allowThresholdMove && t.currentTranslate < (n.centeredSlides ? r.maxTranslate() + r.slidesSizesGrid[r.slidesSizesGrid.length - 1] + r.params.spaceBetween + (n.slidesPerView !== "auto" && r.slides.length - n.slidesPerView >= 2 ? r.slidesSizesGrid[r.slidesSizesGrid.length - 1] + r.params.spaceBetween : 0) : r.maxTranslate()) && r.loopFix({
    direction: "next",
    setTranslate: !0,
    activeSlideIndex: r.slides.length - (n.slidesPerView === "auto" ? r.slidesPerViewDynamic() : Math.ceil(parseFloat(n.slidesPerView, 10)))
  }), t.currentTranslate < r.maxTranslate() && (b = !1, n.resistance && (t.currentTranslate = r.maxTranslate() + 1 - (r.maxTranslate() - t.startTranslate - p) ** v))), b && (l.preventedByNestedSwiper = !0), !r.allowSlideNext && r.swipeDirection === "next" && t.currentTranslate < t.startTranslate && (t.currentTranslate = t.startTranslate), !r.allowSlidePrev && r.swipeDirection === "prev" && t.currentTranslate > t.startTranslate && (t.currentTranslate = t.startTranslate), !r.allowSlidePrev && !r.allowSlideNext && (t.currentTranslate = t.startTranslate), n.threshold > 0)
    if (Math.abs(p) > n.threshold || t.allowThresholdMove) {
      if (!t.allowThresholdMove) {
        t.allowThresholdMove = !0, a.startX = a.currentX, a.startY = a.currentY, t.currentTranslate = t.startTranslate, a.diff = r.isHorizontal() ? a.currentX - a.startX : a.currentY - a.startY;
        return;
      }
    } else {
      t.currentTranslate = t.startTranslate;
      return;
    }
  !n.followFinger || n.cssMode || ((n.freeMode && n.freeMode.enabled && r.freeMode || n.watchSlidesProgress) && (r.updateActiveIndex(), r.updateSlidesClasses()), n.freeMode && n.freeMode.enabled && r.freeMode && r.freeMode.onTouchMove(), r.updateProgress(t.currentTranslate), r.setTranslate(t.currentTranslate));
}
function EA(o) {
  const e = this, r = e.touchEventsData;
  let t = o;
  t.originalEvent && (t = t.originalEvent);
  let n;
  if (t.type === "touchend" || t.type === "touchcancel") {
    if (n = [...t.changedTouches].find((P) => P.identifier === r.touchId), !n || n.identifier !== r.touchId) return;
  } else {
    if (r.touchId !== null || t.pointerId !== r.pointerId) return;
    n = t;
  }
  if (["pointercancel", "pointerout", "pointerleave", "contextmenu"].includes(t.type) && !(["pointercancel", "contextmenu"].includes(t.type) && (e.browser.isSafari || e.browser.isWebView)))
    return;
  r.pointerId = null, r.touchId = null;
  const {
    params: s,
    touches: i,
    rtlTranslate: l,
    slidesGrid: c,
    enabled: u
  } = e;
  if (!u || !s.simulateTouch && t.pointerType === "mouse") return;
  if (r.allowTouchCallbacks && e.emit("touchEnd", t), r.allowTouchCallbacks = !1, !r.isTouched) {
    r.isMoved && s.grabCursor && e.setGrabCursor(!1), r.isMoved = !1, r.startMoving = !1;
    return;
  }
  s.grabCursor && r.isMoved && r.isTouched && (e.allowSlideNext === !0 || e.allowSlidePrev === !0) && e.setGrabCursor(!1);
  const f = No(), g = f - r.touchStartTime;
  if (e.allowClick) {
    const P = t.path || t.composedPath && t.composedPath();
    e.updateClickedSlide(P && P[0] || t.target, P), e.emit("tap click", t), g < 300 && f - r.lastClickTime < 300 && e.emit("doubleTap doubleClick", t);
  }
  if (r.lastClickTime = No(), mt(() => {
    e.destroyed || (e.allowClick = !0);
  }), !r.isTouched || !r.isMoved || !e.swipeDirection || i.diff === 0 && !r.loopSwapReset || r.currentTranslate === r.startTranslate && !r.loopSwapReset) {
    r.isTouched = !1, r.isMoved = !1, r.startMoving = !1;
    return;
  }
  r.isTouched = !1, r.isMoved = !1, r.startMoving = !1;
  let d;
  if (s.followFinger ? d = l ? e.translate : -e.translate : d = -r.currentTranslate, s.cssMode)
    return;
  if (s.freeMode && s.freeMode.enabled) {
    e.freeMode.onTouchEnd({
      currentPos: d
    });
    return;
  }
  const p = d >= -e.maxTranslate() && !e.params.loop;
  let m = 0, y = e.slidesSizesGrid[0];
  for (let P = 0; P < c.length; P += P < s.slidesPerGroupSkip ? 1 : s.slidesPerGroup) {
    const E = P < s.slidesPerGroupSkip - 1 ? 1 : s.slidesPerGroup;
    typeof c[P + E] < "u" ? (p || d >= c[P] && d < c[P + E]) && (m = P, y = c[P + E] - c[P]) : (p || d >= c[P]) && (m = P, y = c[c.length - 1] - c[c.length - 2]);
  }
  let h = null, F = null;
  s.rewind && (e.isBeginning ? F = s.virtual && s.virtual.enabled && e.virtual ? e.virtual.slides.length - 1 : e.slides.length - 1 : e.isEnd && (h = 0));
  const b = (d - c[m]) / y, v = m < s.slidesPerGroupSkip - 1 ? 1 : s.slidesPerGroup;
  if (g > s.longSwipesMs) {
    if (!s.longSwipes) {
      e.slideTo(e.activeIndex);
      return;
    }
    e.swipeDirection === "next" && (b >= s.longSwipesRatio ? e.slideTo(s.rewind && e.isEnd ? h : m + v) : e.slideTo(m)), e.swipeDirection === "prev" && (b > 1 - s.longSwipesRatio ? e.slideTo(m + v) : F !== null && b < 0 && Math.abs(b) > s.longSwipesRatio ? e.slideTo(F) : e.slideTo(m));
  } else {
    if (!s.shortSwipes) {
      e.slideTo(e.activeIndex);
      return;
    }
    e.navigation && (t.target === e.navigation.nextEl || t.target === e.navigation.prevEl) ? t.target === e.navigation.nextEl ? e.slideTo(m + v) : e.slideTo(m) : (e.swipeDirection === "next" && e.slideTo(h !== null ? h : m + v), e.swipeDirection === "prev" && e.slideTo(F !== null ? F : m));
  }
}
function Cf() {
  const o = this, {
    params: e,
    el: r
  } = o;
  if (r && r.offsetWidth === 0) return;
  e.breakpoints && o.setBreakpoint();
  const {
    allowSlideNext: t,
    allowSlidePrev: n,
    snapGrid: a
  } = o, s = o.virtual && o.params.virtual.enabled;
  o.allowSlideNext = !0, o.allowSlidePrev = !0, o.updateSize(), o.updateSlides(), o.updateSlidesClasses();
  const i = s && e.loop;
  (e.slidesPerView === "auto" || e.slidesPerView > 1) && o.isEnd && !o.isBeginning && !o.params.centeredSlides && !i ? o.slideTo(o.slides.length - 1, 0, !1, !0) : o.params.loop && !s ? o.slideToLoop(o.realIndex, 0, !1, !0) : o.slideTo(o.activeIndex, 0, !1, !0), o.autoplay && o.autoplay.running && o.autoplay.paused && (clearTimeout(o.autoplay.resizeTimeout), o.autoplay.resizeTimeout = setTimeout(() => {
    o.autoplay && o.autoplay.running && o.autoplay.paused && o.autoplay.resume();
  }, 500)), o.allowSlidePrev = n, o.allowSlideNext = t, o.params.watchOverflow && a !== o.snapGrid && o.checkOverflow();
}
function xA(o) {
  const e = this;
  e.enabled && (e.allowClick || (e.params.preventClicks && o.preventDefault(), e.params.preventClicksPropagation && e.animating && (o.stopPropagation(), o.stopImmediatePropagation())));
}
function CA() {
  const o = this, {
    wrapperEl: e,
    rtlTranslate: r,
    enabled: t
  } = o;
  if (!t) return;
  o.previousTranslate = o.translate, o.isHorizontal() ? o.translate = -e.scrollLeft : o.translate = -e.scrollTop, o.translate === 0 && (o.translate = 0), o.updateActiveIndex(), o.updateSlidesClasses();
  let n;
  const a = o.maxTranslate() - o.minTranslate();
  a === 0 ? n = 0 : n = (o.translate - o.minTranslate()) / a, n !== o.progress && o.updateProgress(r ? -o.translate : o.translate), o.emit("setTranslate", o.translate, !1);
}
function OA(o) {
  const e = this;
  Is(e, o.target), !(e.params.cssMode || e.params.slidesPerView !== "auto" && !e.params.autoHeight) && e.update();
}
function TA() {
  const o = this;
  o.documentTouchHandlerProceeded || (o.documentTouchHandlerProceeded = !0, o.params.touchReleaseOnEdges && (o.el.style.touchAction = "auto"));
}
const JF = (o, e) => {
  const r = Qe(), {
    params: t,
    el: n,
    wrapperEl: a,
    device: s
  } = o, i = !!t.nested, l = e === "on" ? "addEventListener" : "removeEventListener", c = e;
  !n || typeof n == "string" || (r[l]("touchstart", o.onDocumentTouchStart, {
    passive: !1,
    capture: i
  }), n[l]("touchstart", o.onTouchStart, {
    passive: !1
  }), n[l]("pointerdown", o.onTouchStart, {
    passive: !1
  }), r[l]("touchmove", o.onTouchMove, {
    passive: !1,
    capture: i
  }), r[l]("pointermove", o.onTouchMove, {
    passive: !1,
    capture: i
  }), r[l]("touchend", o.onTouchEnd, {
    passive: !0
  }), r[l]("pointerup", o.onTouchEnd, {
    passive: !0
  }), r[l]("pointercancel", o.onTouchEnd, {
    passive: !0
  }), r[l]("touchcancel", o.onTouchEnd, {
    passive: !0
  }), r[l]("pointerout", o.onTouchEnd, {
    passive: !0
  }), r[l]("pointerleave", o.onTouchEnd, {
    passive: !0
  }), r[l]("contextmenu", o.onTouchEnd, {
    passive: !0
  }), (t.preventClicks || t.preventClicksPropagation) && n[l]("click", o.onClick, !0), t.cssMode && a[l]("scroll", o.onScroll), t.updateOnWindowResize ? o[c](s.ios || s.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", Cf, !0) : o[c]("observerUpdate", Cf, !0), n[l]("load", o.onLoad, {
    capture: !0
  }));
};
function LA() {
  const o = this, {
    params: e
  } = o;
  o.onTouchStart = SA.bind(o), o.onTouchMove = AA.bind(o), o.onTouchEnd = EA.bind(o), o.onDocumentTouchStart = TA.bind(o), e.cssMode && (o.onScroll = CA.bind(o)), o.onClick = xA.bind(o), o.onLoad = OA.bind(o), JF(o, "on");
}
function jA() {
  JF(this, "off");
}
var MA = {
  attachEvents: LA,
  detachEvents: jA
};
const Of = (o, e) => o.grid && e.grid && e.grid.rows > 1;
function WA() {
  const o = this, {
    realIndex: e,
    initialized: r,
    params: t,
    el: n
  } = o, a = t.breakpoints;
  if (!a || a && Object.keys(a).length === 0) return;
  const s = Qe(), i = t.breakpointsBase === "window" || !t.breakpointsBase ? t.breakpointsBase : "container", l = ["window", "container"].includes(t.breakpointsBase) || !t.breakpointsBase ? o.el : s.querySelector(t.breakpointsBase), c = o.getBreakpoint(a, i, l);
  if (!c || o.currentBreakpoint === c) return;
  const f = (c in a ? a[c] : void 0) || o.originalParams, g = Of(o, t), d = Of(o, f), p = o.params.grabCursor, m = f.grabCursor, y = t.enabled;
  g && !d ? (n.classList.remove(`${t.containerModifierClass}grid`, `${t.containerModifierClass}grid-column`), o.emitContainerClasses()) : !g && d && (n.classList.add(`${t.containerModifierClass}grid`), (f.grid.fill && f.grid.fill === "column" || !f.grid.fill && t.grid.fill === "column") && n.classList.add(`${t.containerModifierClass}grid-column`), o.emitContainerClasses()), p && !m ? o.unsetGrabCursor() : !p && m && o.setGrabCursor(), ["navigation", "pagination", "scrollbar"].forEach((E) => {
    if (typeof f[E] > "u") return;
    const S = t[E] && t[E].enabled, D = f[E] && f[E].enabled;
    S && !D && o[E].disable(), !S && D && o[E].enable();
  });
  const h = f.direction && f.direction !== t.direction, F = t.loop && (f.slidesPerView !== t.slidesPerView || h), b = t.loop;
  h && r && o.changeDirection(), Do(o.params, f);
  const v = o.params.enabled, P = o.params.loop;
  Object.assign(o, {
    allowTouchMove: o.params.allowTouchMove,
    allowSlideNext: o.params.allowSlideNext,
    allowSlidePrev: o.params.allowSlidePrev
  }), y && !v ? o.disable() : !y && v && o.enable(), o.currentBreakpoint = c, o.emit("_beforeBreakpoint", f), r && (F ? (o.loopDestroy(), o.loopCreate(e), o.updateSlides()) : !b && P ? (o.loopCreate(e), o.updateSlides()) : b && !P && o.loopDestroy()), o.emit("breakpoint", f);
}
function NA(o, e, r) {
  if (e === void 0 && (e = "window"), !o || e === "container" && !r) return;
  let t = !1;
  const n = Ne(), a = e === "window" ? n.innerHeight : r.clientHeight, s = Object.keys(o).map((i) => {
    if (typeof i == "string" && i.indexOf("@") === 0) {
      const l = parseFloat(i.substr(1));
      return {
        value: a * l,
        point: i
      };
    }
    return {
      value: i,
      point: i
    };
  });
  s.sort((i, l) => parseInt(i.value, 10) - parseInt(l.value, 10));
  for (let i = 0; i < s.length; i += 1) {
    const {
      point: l,
      value: c
    } = s[i];
    e === "window" ? n.matchMedia(`(min-width: ${c}px)`).matches && (t = l) : c <= r.clientWidth && (t = l);
  }
  return t || "max";
}
var VA = {
  setBreakpoint: WA,
  getBreakpoint: NA
};
function zA(o, e) {
  const r = [];
  return o.forEach((t) => {
    typeof t == "object" ? Object.keys(t).forEach((n) => {
      t[n] && r.push(e + n);
    }) : typeof t == "string" && r.push(e + t);
  }), r;
}
function IA() {
  const o = this, {
    classNames: e,
    params: r,
    rtl: t,
    el: n,
    device: a
  } = o, s = zA(["initialized", r.direction, {
    "free-mode": o.params.freeMode && r.freeMode.enabled
  }, {
    autoheight: r.autoHeight
  }, {
    rtl: t
  }, {
    grid: r.grid && r.grid.rows > 1
  }, {
    "grid-column": r.grid && r.grid.rows > 1 && r.grid.fill === "column"
  }, {
    android: a.android
  }, {
    ios: a.ios
  }, {
    "css-mode": r.cssMode
  }, {
    centered: r.cssMode && r.centeredSlides
  }, {
    "watch-progress": r.watchSlidesProgress
  }], r.containerModifierClass);
  e.push(...s), n.classList.add(...e), o.emitContainerClasses();
}
function RA() {
  const o = this, {
    el: e,
    classNames: r
  } = o;
  !e || typeof e == "string" || (e.classList.remove(...r), o.emitContainerClasses());
}
var HA = {
  addClasses: IA,
  removeClasses: RA
};
function YA() {
  const o = this, {
    isLocked: e,
    params: r
  } = o, {
    slidesOffsetBefore: t
  } = r;
  if (t) {
    const n = o.slides.length - 1, a = o.slidesGrid[n] + o.slidesSizesGrid[n] + t * 2;
    o.isLocked = o.size > a;
  } else
    o.isLocked = o.snapGrid.length === 1;
  r.allowSlideNext === !0 && (o.allowSlideNext = !o.isLocked), r.allowSlidePrev === !0 && (o.allowSlidePrev = !o.isLocked), e && e !== o.isLocked && (o.isEnd = !1), e !== o.isLocked && o.emit(o.isLocked ? "lock" : "unlock");
}
var qA = {
  checkOverflow: YA
}, Mu = {
  init: !0,
  direction: "horizontal",
  oneWayMovement: !1,
  swiperElementNodeName: "SWIPER-CONTAINER",
  touchEventsTarget: "wrapper",
  initialSlide: 0,
  speed: 300,
  cssMode: !1,
  updateOnWindowResize: !0,
  resizeObserver: !0,
  nested: !1,
  createElements: !1,
  eventsPrefix: "swiper",
  enabled: !0,
  focusableElements: "input, select, option, textarea, button, video, label",
  // Overrides
  width: null,
  height: null,
  //
  preventInteractionOnTransition: !1,
  // ssr
  userAgent: null,
  url: null,
  // To support iOS's swipe-to-go-back gesture (when being used in-app).
  edgeSwipeDetection: !1,
  edgeSwipeThreshold: 20,
  // Autoheight
  autoHeight: !1,
  // Set wrapper width
  setWrapperSize: !1,
  // Virtual Translate
  virtualTranslate: !1,
  // Effects
  effect: "slide",
  // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
  // Breakpoints
  breakpoints: void 0,
  breakpointsBase: "window",
  // Slides grid
  spaceBetween: 0,
  slidesPerView: 1,
  slidesPerGroup: 1,
  slidesPerGroupSkip: 0,
  slidesPerGroupAuto: !1,
  centeredSlides: !1,
  centeredSlidesBounds: !1,
  slidesOffsetBefore: 0,
  // in px
  slidesOffsetAfter: 0,
  // in px
  normalizeSlideIndex: !0,
  centerInsufficientSlides: !1,
  // Disable swiper and hide navigation when container not overflow
  watchOverflow: !0,
  // Round length
  roundLengths: !1,
  // Touches
  touchRatio: 1,
  touchAngle: 45,
  simulateTouch: !0,
  shortSwipes: !0,
  longSwipes: !0,
  longSwipesRatio: 0.5,
  longSwipesMs: 300,
  followFinger: !0,
  allowTouchMove: !0,
  threshold: 5,
  touchMoveStopPropagation: !1,
  touchStartPreventDefault: !0,
  touchStartForcePreventDefault: !1,
  touchReleaseOnEdges: !1,
  // Unique Navigation Elements
  uniqueNavElements: !0,
  // Resistance
  resistance: !0,
  resistanceRatio: 0.85,
  // Progress
  watchSlidesProgress: !1,
  // Cursor
  grabCursor: !1,
  // Clicks
  preventClicks: !0,
  preventClicksPropagation: !0,
  slideToClickedSlide: !1,
  // loop
  loop: !1,
  loopAddBlankSlides: !0,
  loopAdditionalSlides: 0,
  loopPreventsSliding: !0,
  // rewind
  rewind: !1,
  // Swiping/no swiping
  allowSlidePrev: !0,
  allowSlideNext: !0,
  swipeHandler: null,
  // '.swipe-handler',
  noSwiping: !0,
  noSwipingClass: "swiper-no-swiping",
  noSwipingSelector: null,
  // Passive Listeners
  passiveListeners: !0,
  maxBackfaceHiddenSlides: 10,
  // NS
  containerModifierClass: "swiper-",
  // NEW
  slideClass: "swiper-slide",
  slideBlankClass: "swiper-slide-blank",
  slideActiveClass: "swiper-slide-active",
  slideVisibleClass: "swiper-slide-visible",
  slideFullyVisibleClass: "swiper-slide-fully-visible",
  slideNextClass: "swiper-slide-next",
  slidePrevClass: "swiper-slide-prev",
  wrapperClass: "swiper-wrapper",
  lazyPreloaderClass: "swiper-lazy-preloader",
  lazyPreloadPrevNext: 0,
  // Callbacks
  runCallbacksOnInit: !0,
  // Internals
  _emitClasses: !1
};
function GA(o, e) {
  return function(t) {
    t === void 0 && (t = {});
    const n = Object.keys(t)[0], a = t[n];
    if (typeof a != "object" || a === null) {
      Do(e, t);
      return;
    }
    if (o[n] === !0 && (o[n] = {
      enabled: !0
    }), n === "navigation" && o[n] && o[n].enabled && !o[n].prevEl && !o[n].nextEl && (o[n].auto = !0), ["pagination", "scrollbar"].indexOf(n) >= 0 && o[n] && o[n].enabled && !o[n].el && (o[n].auto = !0), !(n in o && "enabled" in a)) {
      Do(e, t);
      return;
    }
    typeof o[n] == "object" && !("enabled" in o[n]) && (o[n].enabled = !0), o[n] || (o[n] = {
      enabled: !1
    }), Do(e, t);
  };
}
const sc = {
  eventsEmitter: H7,
  update: $7,
  translate: aA,
  transition: cA,
  slide: hA,
  loop: BA,
  grabCursor: kA,
  events: MA,
  breakpoints: VA,
  checkOverflow: qA,
  classes: HA
}, ic = {};
class ko {
  constructor() {
    let e, r;
    for (var t = arguments.length, n = new Array(t), a = 0; a < t; a++)
      n[a] = arguments[a];
    n.length === 1 && n[0].constructor && Object.prototype.toString.call(n[0]).slice(8, -1) === "Object" ? r = n[0] : [e, r] = n, r || (r = {}), r = Do({}, r), e && !r.el && (r.el = e);
    const s = Qe();
    if (r.el && typeof r.el == "string" && s.querySelectorAll(r.el).length > 1) {
      const u = [];
      return s.querySelectorAll(r.el).forEach((f) => {
        const g = Do({}, r, {
          el: f
        });
        u.push(new ko(g));
      }), u;
    }
    const i = this;
    i.__swiper__ = !0, i.support = UF(), i.device = ZF({
      userAgent: r.userAgent
    }), i.browser = KF(), i.eventsListeners = {}, i.eventsAnyListeners = [], i.modules = [...i.__modules__], r.modules && Array.isArray(r.modules) && i.modules.push(...r.modules);
    const l = {};
    i.modules.forEach((u) => {
      u({
        params: r,
        swiper: i,
        extendParams: GA(r, l),
        on: i.on.bind(i),
        once: i.once.bind(i),
        off: i.off.bind(i),
        emit: i.emit.bind(i)
      });
    });
    const c = Do({}, Mu, l);
    return i.params = Do({}, c, ic, r), i.originalParams = Do({}, i.params), i.passedParams = Do({}, r), i.params && i.params.on && Object.keys(i.params.on).forEach((u) => {
      i.on(u, i.params.on[u]);
    }), i.params && i.params.onAny && i.onAny(i.params.onAny), Object.assign(i, {
      enabled: i.params.enabled,
      el: e,
      // Classes
      classNames: [],
      // Slides
      slides: [],
      slidesGrid: [],
      snapGrid: [],
      slidesSizesGrid: [],
      // isDirection
      isHorizontal() {
        return i.params.direction === "horizontal";
      },
      isVertical() {
        return i.params.direction === "vertical";
      },
      // Indexes
      activeIndex: 0,
      realIndex: 0,
      //
      isBeginning: !0,
      isEnd: !1,
      // Props
      translate: 0,
      previousTranslate: 0,
      progress: 0,
      velocity: 0,
      animating: !1,
      cssOverflowAdjustment() {
        return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
      },
      // Locks
      allowSlideNext: i.params.allowSlideNext,
      allowSlidePrev: i.params.allowSlidePrev,
      // Touch Events
      touchEventsData: {
        isTouched: void 0,
        isMoved: void 0,
        allowTouchCallbacks: void 0,
        touchStartTime: void 0,
        isScrolling: void 0,
        currentTranslate: void 0,
        startTranslate: void 0,
        allowThresholdMove: void 0,
        // Form elements to match
        focusableElements: i.params.focusableElements,
        // Last click time
        lastClickTime: 0,
        clickTimeout: void 0,
        // Velocities
        velocities: [],
        allowMomentumBounce: void 0,
        startMoving: void 0,
        pointerId: null,
        touchId: null
      },
      // Clicks
      allowClick: !0,
      // Touches
      allowTouchMove: i.params.allowTouchMove,
      touches: {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0
      },
      // Images
      imagesToLoad: [],
      imagesLoaded: 0
    }), i.emit("_swiper"), i.params.init && i.init(), i;
  }
  getDirectionLabel(e) {
    return this.isHorizontal() ? e : {
      width: "height",
      "margin-top": "margin-left",
      "margin-bottom ": "margin-right",
      "margin-left": "margin-top",
      "margin-right": "margin-bottom",
      "padding-left": "padding-top",
      "padding-right": "padding-bottom",
      marginRight: "marginBottom"
    }[e];
  }
  getSlideIndex(e) {
    const {
      slidesEl: r,
      params: t
    } = this, n = $e(r, `.${t.slideClass}, swiper-slide`), a = Da(n[0]);
    return Da(e) - a;
  }
  getSlideIndexByData(e) {
    return this.getSlideIndex(this.slides.find((r) => r.getAttribute("data-swiper-slide-index") * 1 === e));
  }
  recalcSlides() {
    const e = this, {
      slidesEl: r,
      params: t
    } = e;
    e.slides = $e(r, `.${t.slideClass}, swiper-slide`);
  }
  enable() {
    const e = this;
    e.enabled || (e.enabled = !0, e.params.grabCursor && e.setGrabCursor(), e.emit("enable"));
  }
  disable() {
    const e = this;
    e.enabled && (e.enabled = !1, e.params.grabCursor && e.unsetGrabCursor(), e.emit("disable"));
  }
  setProgress(e, r) {
    const t = this;
    e = Math.min(Math.max(e, 0), 1);
    const n = t.minTranslate(), s = (t.maxTranslate() - n) * e + n;
    t.translateTo(s, typeof r > "u" ? 0 : r), t.updateActiveIndex(), t.updateSlidesClasses();
  }
  emitContainerClasses() {
    const e = this;
    if (!e.params._emitClasses || !e.el) return;
    const r = e.el.className.split(" ").filter((t) => t.indexOf("swiper") === 0 || t.indexOf(e.params.containerModifierClass) === 0);
    e.emit("_containerClasses", r.join(" "));
  }
  getSlideClasses(e) {
    const r = this;
    return r.destroyed ? "" : e.className.split(" ").filter((t) => t.indexOf("swiper-slide") === 0 || t.indexOf(r.params.slideClass) === 0).join(" ");
  }
  emitSlidesClasses() {
    const e = this;
    if (!e.params._emitClasses || !e.el) return;
    const r = [];
    e.slides.forEach((t) => {
      const n = e.getSlideClasses(t);
      r.push({
        slideEl: t,
        classNames: n
      }), e.emit("_slideClass", t, n);
    }), e.emit("_slideClasses", r);
  }
  slidesPerViewDynamic(e, r) {
    e === void 0 && (e = "current"), r === void 0 && (r = !1);
    const t = this, {
      params: n,
      slides: a,
      slidesGrid: s,
      slidesSizesGrid: i,
      size: l,
      activeIndex: c
    } = t;
    let u = 1;
    if (typeof n.slidesPerView == "number") return n.slidesPerView;
    if (n.centeredSlides) {
      let f = a[c] ? Math.ceil(a[c].swiperSlideSize) : 0, g;
      for (let d = c + 1; d < a.length; d += 1)
        a[d] && !g && (f += Math.ceil(a[d].swiperSlideSize), u += 1, f > l && (g = !0));
      for (let d = c - 1; d >= 0; d -= 1)
        a[d] && !g && (f += a[d].swiperSlideSize, u += 1, f > l && (g = !0));
    } else if (e === "current")
      for (let f = c + 1; f < a.length; f += 1)
        (r ? s[f] + i[f] - s[c] < l : s[f] - s[c] < l) && (u += 1);
    else
      for (let f = c - 1; f >= 0; f -= 1)
        s[c] - s[f] < l && (u += 1);
    return u;
  }
  update() {
    const e = this;
    if (!e || e.destroyed) return;
    const {
      snapGrid: r,
      params: t
    } = e;
    t.breakpoints && e.setBreakpoint(), [...e.el.querySelectorAll('[loading="lazy"]')].forEach((s) => {
      s.complete && Is(e, s);
    }), e.updateSize(), e.updateSlides(), e.updateProgress(), e.updateSlidesClasses();
    function n() {
      const s = e.rtlTranslate ? e.translate * -1 : e.translate, i = Math.min(Math.max(s, e.maxTranslate()), e.minTranslate());
      e.setTranslate(i), e.updateActiveIndex(), e.updateSlidesClasses();
    }
    let a;
    if (t.freeMode && t.freeMode.enabled && !t.cssMode)
      n(), t.autoHeight && e.updateAutoHeight();
    else {
      if ((t.slidesPerView === "auto" || t.slidesPerView > 1) && e.isEnd && !t.centeredSlides) {
        const s = e.virtual && t.virtual.enabled ? e.virtual.slides : e.slides;
        a = e.slideTo(s.length - 1, 0, !1, !0);
      } else
        a = e.slideTo(e.activeIndex, 0, !1, !0);
      a || n();
    }
    t.watchOverflow && r !== e.snapGrid && e.checkOverflow(), e.emit("update");
  }
  changeDirection(e, r) {
    r === void 0 && (r = !0);
    const t = this, n = t.params.direction;
    return e || (e = n === "horizontal" ? "vertical" : "horizontal"), e === n || e !== "horizontal" && e !== "vertical" || (t.el.classList.remove(`${t.params.containerModifierClass}${n}`), t.el.classList.add(`${t.params.containerModifierClass}${e}`), t.emitContainerClasses(), t.params.direction = e, t.slides.forEach((a) => {
      e === "vertical" ? a.style.width = "" : a.style.height = "";
    }), t.emit("changeDirection"), r && t.update()), t;
  }
  changeLanguageDirection(e) {
    const r = this;
    r.rtl && e === "rtl" || !r.rtl && e === "ltr" || (r.rtl = e === "rtl", r.rtlTranslate = r.params.direction === "horizontal" && r.rtl, r.rtl ? (r.el.classList.add(`${r.params.containerModifierClass}rtl`), r.el.dir = "rtl") : (r.el.classList.remove(`${r.params.containerModifierClass}rtl`), r.el.dir = "ltr"), r.update());
  }
  mount(e) {
    const r = this;
    if (r.mounted) return !0;
    let t = e || r.params.el;
    if (typeof t == "string" && (t = document.querySelector(t)), !t)
      return !1;
    t.swiper = r, t.parentNode && t.parentNode.host && t.parentNode.host.nodeName === r.params.swiperElementNodeName.toUpperCase() && (r.isElement = !0);
    const n = () => `.${(r.params.wrapperClass || "").trim().split(" ").join(".")}`;
    let s = t && t.shadowRoot && t.shadowRoot.querySelector ? t.shadowRoot.querySelector(n()) : $e(t, n())[0];
    return !s && r.params.createElements && (s = Ao("div", r.params.wrapperClass), t.append(s), $e(t, `.${r.params.slideClass}`).forEach((i) => {
      s.append(i);
    })), Object.assign(r, {
      el: t,
      wrapperEl: s,
      slidesEl: r.isElement && !t.parentNode.host.slideSlots ? t.parentNode.host : s,
      hostEl: r.isElement ? t.parentNode.host : t,
      mounted: !0,
      // RTL
      rtl: t.dir.toLowerCase() === "rtl" || Tr(t, "direction") === "rtl",
      rtlTranslate: r.params.direction === "horizontal" && (t.dir.toLowerCase() === "rtl" || Tr(t, "direction") === "rtl"),
      wrongRTL: Tr(s, "display") === "-webkit-box"
    }), !0;
  }
  init(e) {
    const r = this;
    if (r.initialized || r.mount(e) === !1) return r;
    r.emit("beforeInit"), r.params.breakpoints && r.setBreakpoint(), r.addClasses(), r.updateSize(), r.updateSlides(), r.params.watchOverflow && r.checkOverflow(), r.params.grabCursor && r.enabled && r.setGrabCursor(), r.params.loop && r.virtual && r.params.virtual.enabled ? r.slideTo(r.params.initialSlide + r.virtual.slidesBefore, 0, r.params.runCallbacksOnInit, !1, !0) : r.slideTo(r.params.initialSlide, 0, r.params.runCallbacksOnInit, !1, !0), r.params.loop && r.loopCreate(), r.attachEvents();
    const n = [...r.el.querySelectorAll('[loading="lazy"]')];
    return r.isElement && n.push(...r.hostEl.querySelectorAll('[loading="lazy"]')), n.forEach((a) => {
      a.complete ? Is(r, a) : a.addEventListener("load", (s) => {
        Is(r, s.target);
      });
    }), ju(r), r.initialized = !0, ju(r), r.emit("init"), r.emit("afterInit"), r;
  }
  destroy(e, r) {
    e === void 0 && (e = !0), r === void 0 && (r = !0);
    const t = this, {
      params: n,
      el: a,
      wrapperEl: s,
      slides: i
    } = t;
    return typeof t.params > "u" || t.destroyed || (t.emit("beforeDestroy"), t.initialized = !1, t.detachEvents(), n.loop && t.loopDestroy(), r && (t.removeClasses(), a && typeof a != "string" && a.removeAttribute("style"), s && s.removeAttribute("style"), i && i.length && i.forEach((l) => {
      l.classList.remove(n.slideVisibleClass, n.slideFullyVisibleClass, n.slideActiveClass, n.slideNextClass, n.slidePrevClass), l.removeAttribute("style"), l.removeAttribute("data-swiper-slide-index");
    })), t.emit("destroy"), Object.keys(t.eventsListeners).forEach((l) => {
      t.off(l);
    }), e !== !1 && (t.el && typeof t.el != "string" && (t.el.swiper = null), C7(t)), t.destroyed = !0), null;
  }
  static extendDefaults(e) {
    Do(ic, e);
  }
  static get extendedDefaults() {
    return ic;
  }
  static get defaults() {
    return Mu;
  }
  static installModule(e) {
    ko.prototype.__modules__ || (ko.prototype.__modules__ = []);
    const r = ko.prototype.__modules__;
    typeof e == "function" && r.indexOf(e) < 0 && r.push(e);
  }
  static use(e) {
    return Array.isArray(e) ? (e.forEach((r) => ko.installModule(r)), ko) : (ko.installModule(e), ko);
  }
}
Object.keys(sc).forEach((o) => {
  Object.keys(sc[o]).forEach((e) => {
    ko.prototype[e] = sc[o][e];
  });
});
ko.use([I7, R7]);
function XA(o) {
  let {
    swiper: e,
    extendParams: r,
    on: t,
    emit: n
  } = o;
  r({
    virtual: {
      enabled: !1,
      slides: [],
      cache: !0,
      renderSlide: null,
      renderExternal: null,
      renderExternalUpdate: !0,
      addSlidesBefore: 0,
      addSlidesAfter: 0
    }
  });
  let a;
  const s = Qe();
  e.virtual = {
    cache: {},
    from: void 0,
    to: void 0,
    slides: [],
    offset: 0,
    slidesGrid: []
  };
  const i = s.createElement("div");
  function l(p, m) {
    const y = e.params.virtual;
    if (y.cache && e.virtual.cache[m])
      return e.virtual.cache[m];
    let h;
    return y.renderSlide ? (h = y.renderSlide.call(e, p, m), typeof h == "string" && (i.innerHTML = h, h = i.children[0])) : e.isElement ? h = Ao("swiper-slide") : h = Ao("div", e.params.slideClass), h.setAttribute("data-swiper-slide-index", m), y.renderSlide || (h.innerHTML = p), y.cache && (e.virtual.cache[m] = h), h;
  }
  function c(p, m, y) {
    const {
      slidesPerView: h,
      slidesPerGroup: F,
      centeredSlides: b,
      loop: v,
      initialSlide: P
    } = e.params;
    if (m && !v && P > 0)
      return;
    const {
      addSlidesBefore: E,
      addSlidesAfter: S
    } = e.params.virtual, {
      from: D,
      to: w,
      slides: A,
      slidesGrid: C,
      offset: x
    } = e.virtual;
    e.params.cssMode || e.updateActiveIndex();
    const T = typeof y > "u" ? e.activeIndex || 0 : y;
    let M;
    e.rtlTranslate ? M = "right" : M = e.isHorizontal() ? "left" : "top";
    let V, G;
    b ? (V = Math.floor(h / 2) + F + S, G = Math.floor(h / 2) + F + E) : (V = h + (F - 1) + S, G = (v ? h : F) + E);
    let L = T - G, W = T + V;
    v || (L = Math.max(L, 0), W = Math.min(W, A.length - 1));
    let Y = (e.slidesGrid[L] || 0) - (e.slidesGrid[0] || 0);
    v && T >= G ? (L -= G, b || (Y += e.slidesGrid[0])) : v && T < G && (L = -G, b && (Y += e.slidesGrid[0])), Object.assign(e.virtual, {
      from: L,
      to: W,
      offset: Y,
      slidesGrid: e.slidesGrid,
      slidesBefore: G,
      slidesAfter: V
    });
    function X() {
      e.updateSlides(), e.updateProgress(), e.updateSlidesClasses(), n("virtualUpdate");
    }
    if (D === L && w === W && !p) {
      e.slidesGrid !== C && Y !== x && e.slides.forEach((Z) => {
        Z.style[M] = `${Y - Math.abs(e.cssOverflowAdjustment())}px`;
      }), e.updateProgress(), n("virtualUpdate");
      return;
    }
    if (e.params.virtual.renderExternal) {
      e.params.virtual.renderExternal.call(e, {
        offset: Y,
        from: L,
        to: W,
        slides: function() {
          const Q = [];
          for (let oe = L; oe <= W; oe += 1)
            Q.push(A[oe]);
          return Q;
        }()
      }), e.params.virtual.renderExternalUpdate ? X() : n("virtualUpdate");
      return;
    }
    const J = [], ee = [], re = (Z) => {
      let Q = Z;
      return Z < 0 ? Q = A.length + Z : Q >= A.length && (Q = Q - A.length), Q;
    };
    if (p)
      e.slides.filter((Z) => Z.matches(`.${e.params.slideClass}, swiper-slide`)).forEach((Z) => {
        Z.remove();
      });
    else
      for (let Z = D; Z <= w; Z += 1)
        if (Z < L || Z > W) {
          const Q = re(Z);
          e.slides.filter((oe) => oe.matches(`.${e.params.slideClass}[data-swiper-slide-index="${Q}"], swiper-slide[data-swiper-slide-index="${Q}"]`)).forEach((oe) => {
            oe.remove();
          });
        }
    const pe = v ? -A.length : 0, U = v ? A.length * 2 : A.length;
    for (let Z = pe; Z < U; Z += 1)
      if (Z >= L && Z <= W) {
        const Q = re(Z);
        typeof w > "u" || p ? ee.push(Q) : (Z > w && ee.push(Q), Z < D && J.push(Q));
      }
    if (ee.forEach((Z) => {
      e.slidesEl.append(l(A[Z], Z));
    }), v)
      for (let Z = J.length - 1; Z >= 0; Z -= 1) {
        const Q = J[Z];
        e.slidesEl.prepend(l(A[Q], Q));
      }
    else
      J.sort((Z, Q) => Q - Z), J.forEach((Z) => {
        e.slidesEl.prepend(l(A[Z], Z));
      });
    $e(e.slidesEl, ".swiper-slide, swiper-slide").forEach((Z) => {
      Z.style[M] = `${Y - Math.abs(e.cssOverflowAdjustment())}px`;
    }), X();
  }
  function u(p) {
    if (typeof p == "object" && "length" in p)
      for (let m = 0; m < p.length; m += 1)
        p[m] && e.virtual.slides.push(p[m]);
    else
      e.virtual.slides.push(p);
    c(!0);
  }
  function f(p) {
    const m = e.activeIndex;
    let y = m + 1, h = 1;
    if (Array.isArray(p)) {
      for (let F = 0; F < p.length; F += 1)
        p[F] && e.virtual.slides.unshift(p[F]);
      y = m + p.length, h = p.length;
    } else
      e.virtual.slides.unshift(p);
    if (e.params.virtual.cache) {
      const F = e.virtual.cache, b = {};
      Object.keys(F).forEach((v) => {
        const P = F[v], E = P.getAttribute("data-swiper-slide-index");
        E && P.setAttribute("data-swiper-slide-index", parseInt(E, 10) + h), b[parseInt(v, 10) + h] = P;
      }), e.virtual.cache = b;
    }
    c(!0), e.slideTo(y, 0);
  }
  function g(p) {
    if (typeof p > "u" || p === null) return;
    let m = e.activeIndex;
    if (Array.isArray(p))
      for (let y = p.length - 1; y >= 0; y -= 1)
        e.params.virtual.cache && (delete e.virtual.cache[p[y]], Object.keys(e.virtual.cache).forEach((h) => {
          h > p && (e.virtual.cache[h - 1] = e.virtual.cache[h], e.virtual.cache[h - 1].setAttribute("data-swiper-slide-index", h - 1), delete e.virtual.cache[h]);
        })), e.virtual.slides.splice(p[y], 1), p[y] < m && (m -= 1), m = Math.max(m, 0);
    else
      e.params.virtual.cache && (delete e.virtual.cache[p], Object.keys(e.virtual.cache).forEach((y) => {
        y > p && (e.virtual.cache[y - 1] = e.virtual.cache[y], e.virtual.cache[y - 1].setAttribute("data-swiper-slide-index", y - 1), delete e.virtual.cache[y]);
      })), e.virtual.slides.splice(p, 1), p < m && (m -= 1), m = Math.max(m, 0);
    c(!0), e.slideTo(m, 0);
  }
  function d() {
    e.virtual.slides = [], e.params.virtual.cache && (e.virtual.cache = {}), c(!0), e.slideTo(0, 0);
  }
  t("beforeInit", () => {
    if (!e.params.virtual.enabled) return;
    let p;
    if (typeof e.passedParams.virtual.slides > "u") {
      const m = [...e.slidesEl.children].filter((y) => y.matches(`.${e.params.slideClass}, swiper-slide`));
      m && m.length && (e.virtual.slides = [...m], p = !0, m.forEach((y, h) => {
        y.setAttribute("data-swiper-slide-index", h), e.virtual.cache[h] = y, y.remove();
      }));
    }
    p || (e.virtual.slides = e.params.virtual.slides), e.classNames.push(`${e.params.containerModifierClass}virtual`), e.params.watchSlidesProgress = !0, e.originalParams.watchSlidesProgress = !0, c(!1, !0);
  }), t("setTranslate", () => {
    e.params.virtual.enabled && (e.params.cssMode && !e._immediateVirtual ? (clearTimeout(a), a = setTimeout(() => {
      c();
    }, 100)) : c());
  }), t("init update resize", () => {
    e.params.virtual.enabled && e.params.cssMode && Bn(e.wrapperEl, "--swiper-virtual-size", `${e.virtualSize}px`);
  }), Object.assign(e.virtual, {
    appendSlide: u,
    prependSlide: f,
    removeSlide: g,
    removeAllSlides: d,
    update: c
  });
}
function UA(o) {
  let {
    swiper: e,
    extendParams: r,
    on: t,
    emit: n
  } = o;
  const a = Qe(), s = Ne();
  e.keyboard = {
    enabled: !1
  }, r({
    keyboard: {
      enabled: !1,
      onlyInViewport: !0,
      pageUpDown: !0
    }
  });
  function i(u) {
    if (!e.enabled) return;
    const {
      rtlTranslate: f
    } = e;
    let g = u;
    g.originalEvent && (g = g.originalEvent);
    const d = g.keyCode || g.charCode, p = e.params.keyboard.pageUpDown, m = p && d === 33, y = p && d === 34, h = d === 37, F = d === 39, b = d === 38, v = d === 40;
    if (!e.allowSlideNext && (e.isHorizontal() && F || e.isVertical() && v || y) || !e.allowSlidePrev && (e.isHorizontal() && h || e.isVertical() && b || m))
      return !1;
    if (!(g.shiftKey || g.altKey || g.ctrlKey || g.metaKey) && !(a.activeElement && a.activeElement.nodeName && (a.activeElement.nodeName.toLowerCase() === "input" || a.activeElement.nodeName.toLowerCase() === "textarea"))) {
      if (e.params.keyboard.onlyInViewport && (m || y || h || F || b || v)) {
        let P = !1;
        if (nt(e.el, `.${e.params.slideClass}, swiper-slide`).length > 0 && nt(e.el, `.${e.params.slideActiveClass}`).length === 0)
          return;
        const E = e.el, S = E.clientWidth, D = E.clientHeight, w = s.innerWidth, A = s.innerHeight, C = ti(E);
        f && (C.left -= E.scrollLeft);
        const x = [[C.left, C.top], [C.left + S, C.top], [C.left, C.top + D], [C.left + S, C.top + D]];
        for (let T = 0; T < x.length; T += 1) {
          const M = x[T];
          if (M[0] >= 0 && M[0] <= w && M[1] >= 0 && M[1] <= A) {
            if (M[0] === 0 && M[1] === 0) continue;
            P = !0;
          }
        }
        if (!P) return;
      }
      e.isHorizontal() ? ((m || y || h || F) && (g.preventDefault ? g.preventDefault() : g.returnValue = !1), ((y || F) && !f || (m || h) && f) && e.slideNext(), ((m || h) && !f || (y || F) && f) && e.slidePrev()) : ((m || y || b || v) && (g.preventDefault ? g.preventDefault() : g.returnValue = !1), (y || v) && e.slideNext(), (m || b) && e.slidePrev()), n("keyPress", d);
    }
  }
  function l() {
    e.keyboard.enabled || (a.addEventListener("keydown", i), e.keyboard.enabled = !0);
  }
  function c() {
    e.keyboard.enabled && (a.removeEventListener("keydown", i), e.keyboard.enabled = !1);
  }
  t("init", () => {
    e.params.keyboard.enabled && l();
  }), t("destroy", () => {
    e.keyboard.enabled && c();
  }), Object.assign(e.keyboard, {
    enable: l,
    disable: c
  });
}
function ZA(o) {
  let {
    swiper: e,
    extendParams: r,
    on: t,
    emit: n
  } = o;
  const a = Ne();
  r({
    mousewheel: {
      enabled: !1,
      releaseOnEdges: !1,
      invert: !1,
      forceToAxis: !1,
      sensitivity: 1,
      eventsTarget: "container",
      thresholdDelta: null,
      thresholdTime: null,
      noMousewheelClass: "swiper-no-mousewheel"
    }
  }), e.mousewheel = {
    enabled: !1
  };
  let s, i = No(), l;
  const c = [];
  function u(b) {
    let S = 0, D = 0, w = 0, A = 0;
    return "detail" in b && (D = b.detail), "wheelDelta" in b && (D = -b.wheelDelta / 120), "wheelDeltaY" in b && (D = -b.wheelDeltaY / 120), "wheelDeltaX" in b && (S = -b.wheelDeltaX / 120), "axis" in b && b.axis === b.HORIZONTAL_AXIS && (S = D, D = 0), w = S * 10, A = D * 10, "deltaY" in b && (A = b.deltaY), "deltaX" in b && (w = b.deltaX), b.shiftKey && !w && (w = A, A = 0), (w || A) && b.deltaMode && (b.deltaMode === 1 ? (w *= 40, A *= 40) : (w *= 800, A *= 800)), w && !S && (S = w < 1 ? -1 : 1), A && !D && (D = A < 1 ? -1 : 1), {
      spinX: S,
      spinY: D,
      pixelX: w,
      pixelY: A
    };
  }
  function f() {
    e.enabled && (e.mouseEntered = !0);
  }
  function g() {
    e.enabled && (e.mouseEntered = !1);
  }
  function d(b) {
    return e.params.mousewheel.thresholdDelta && b.delta < e.params.mousewheel.thresholdDelta || e.params.mousewheel.thresholdTime && No() - i < e.params.mousewheel.thresholdTime ? !1 : b.delta >= 6 && No() - i < 60 ? !0 : (b.direction < 0 ? (!e.isEnd || e.params.loop) && !e.animating && (e.slideNext(), n("scroll", b.raw)) : (!e.isBeginning || e.params.loop) && !e.animating && (e.slidePrev(), n("scroll", b.raw)), i = new a.Date().getTime(), !1);
  }
  function p(b) {
    const v = e.params.mousewheel;
    if (b.direction < 0) {
      if (e.isEnd && !e.params.loop && v.releaseOnEdges)
        return !0;
    } else if (e.isBeginning && !e.params.loop && v.releaseOnEdges)
      return !0;
    return !1;
  }
  function m(b) {
    let v = b, P = !0;
    if (!e.enabled || b.target.closest(`.${e.params.mousewheel.noMousewheelClass}`)) return;
    const E = e.params.mousewheel;
    e.params.cssMode && v.preventDefault();
    let S = e.el;
    e.params.mousewheel.eventsTarget !== "container" && (S = document.querySelector(e.params.mousewheel.eventsTarget));
    const D = S && S.contains(v.target);
    if (!e.mouseEntered && !D && !E.releaseOnEdges) return !0;
    v.originalEvent && (v = v.originalEvent);
    let w = 0;
    const A = e.rtlTranslate ? -1 : 1, C = u(v);
    if (E.forceToAxis)
      if (e.isHorizontal())
        if (Math.abs(C.pixelX) > Math.abs(C.pixelY)) w = -C.pixelX * A;
        else return !0;
      else if (Math.abs(C.pixelY) > Math.abs(C.pixelX)) w = -C.pixelY;
      else return !0;
    else
      w = Math.abs(C.pixelX) > Math.abs(C.pixelY) ? -C.pixelX * A : -C.pixelY;
    if (w === 0) return !0;
    E.invert && (w = -w);
    let x = e.getTranslate() + w * E.sensitivity;
    if (x >= e.minTranslate() && (x = e.minTranslate()), x <= e.maxTranslate() && (x = e.maxTranslate()), P = e.params.loop ? !0 : !(x === e.minTranslate() || x === e.maxTranslate()), P && e.params.nested && v.stopPropagation(), !e.params.freeMode || !e.params.freeMode.enabled) {
      const T = {
        time: No(),
        delta: Math.abs(w),
        direction: Math.sign(w),
        raw: b
      };
      c.length >= 2 && c.shift();
      const M = c.length ? c[c.length - 1] : void 0;
      if (c.push(T), M ? (T.direction !== M.direction || T.delta > M.delta || T.time > M.time + 150) && d(T) : d(T), p(T))
        return !0;
    } else {
      const T = {
        time: No(),
        delta: Math.abs(w),
        direction: Math.sign(w)
      }, M = l && T.time < l.time + 500 && T.delta <= l.delta && T.direction === l.direction;
      if (!M) {
        l = void 0;
        let V = e.getTranslate() + w * E.sensitivity;
        const G = e.isBeginning, L = e.isEnd;
        if (V >= e.minTranslate() && (V = e.minTranslate()), V <= e.maxTranslate() && (V = e.maxTranslate()), e.setTransition(0), e.setTranslate(V), e.updateProgress(), e.updateActiveIndex(), e.updateSlidesClasses(), (!G && e.isBeginning || !L && e.isEnd) && e.updateSlidesClasses(), e.params.loop && e.loopFix({
          direction: T.direction < 0 ? "next" : "prev",
          byMousewheel: !0
        }), e.params.freeMode.sticky) {
          clearTimeout(s), s = void 0, c.length >= 15 && c.shift();
          const W = c.length ? c[c.length - 1] : void 0, Y = c[0];
          if (c.push(T), W && (T.delta > W.delta || T.direction !== W.direction))
            c.splice(0);
          else if (c.length >= 15 && T.time - Y.time < 500 && Y.delta - T.delta >= 1 && T.delta <= 6) {
            const X = w > 0 ? 0.8 : 0.2;
            l = T, c.splice(0), s = mt(() => {
              e.destroyed || !e.params || e.slideToClosest(e.params.speed, !0, void 0, X);
            }, 0);
          }
          s || (s = mt(() => {
            if (e.destroyed || !e.params) return;
            const X = 0.5;
            l = T, c.splice(0), e.slideToClosest(e.params.speed, !0, void 0, X);
          }, 500));
        }
        if (M || n("scroll", v), e.params.autoplay && e.params.autoplay.disableOnInteraction && e.autoplay.stop(), E.releaseOnEdges && (V === e.minTranslate() || V === e.maxTranslate()))
          return !0;
      }
    }
    return v.preventDefault ? v.preventDefault() : v.returnValue = !1, !1;
  }
  function y(b) {
    let v = e.el;
    e.params.mousewheel.eventsTarget !== "container" && (v = document.querySelector(e.params.mousewheel.eventsTarget)), v[b]("mouseenter", f), v[b]("mouseleave", g), v[b]("wheel", m);
  }
  function h() {
    return e.params.cssMode ? (e.wrapperEl.removeEventListener("wheel", m), !0) : e.mousewheel.enabled ? !1 : (y("addEventListener"), e.mousewheel.enabled = !0, !0);
  }
  function F() {
    return e.params.cssMode ? (e.wrapperEl.addEventListener(event, m), !0) : e.mousewheel.enabled ? (y("removeEventListener"), e.mousewheel.enabled = !1, !0) : !1;
  }
  t("init", () => {
    !e.params.mousewheel.enabled && e.params.cssMode && F(), e.params.mousewheel.enabled && h();
  }), t("destroy", () => {
    e.params.cssMode && h(), e.mousewheel.enabled && F();
  }), Object.assign(e.mousewheel, {
    enable: h,
    disable: F
  });
}
function Gp(o, e, r, t) {
  return o.params.createElements && Object.keys(t).forEach((n) => {
    if (!r[n] && r.auto === !0) {
      let a = $e(o.el, `.${t[n]}`)[0];
      a || (a = Ao("div", t[n]), a.className = t[n], o.el.append(a)), r[n] = a, e[n] = a;
    }
  }), r;
}
function KA(o) {
  let {
    swiper: e,
    extendParams: r,
    on: t,
    emit: n
  } = o;
  r({
    navigation: {
      nextEl: null,
      prevEl: null,
      hideOnClick: !1,
      disabledClass: "swiper-button-disabled",
      hiddenClass: "swiper-button-hidden",
      lockClass: "swiper-button-lock",
      navigationDisabledClass: "swiper-navigation-disabled"
    }
  }), e.navigation = {
    nextEl: null,
    prevEl: null
  };
  function a(p) {
    let m;
    return p && typeof p == "string" && e.isElement && (m = e.el.querySelector(p) || e.hostEl.querySelector(p), m) ? m : (p && (typeof p == "string" && (m = [...document.querySelectorAll(p)]), e.params.uniqueNavElements && typeof p == "string" && m && m.length > 1 && e.el.querySelectorAll(p).length === 1 ? m = e.el.querySelector(p) : m && m.length === 1 && (m = m[0])), p && !m ? p : m);
  }
  function s(p, m) {
    const y = e.params.navigation;
    p = be(p), p.forEach((h) => {
      h && (h.classList[m ? "add" : "remove"](...y.disabledClass.split(" ")), h.tagName === "BUTTON" && (h.disabled = m), e.params.watchOverflow && e.enabled && h.classList[e.isLocked ? "add" : "remove"](y.lockClass));
    });
  }
  function i() {
    const {
      nextEl: p,
      prevEl: m
    } = e.navigation;
    if (e.params.loop) {
      s(m, !1), s(p, !1);
      return;
    }
    s(m, e.isBeginning && !e.params.rewind), s(p, e.isEnd && !e.params.rewind);
  }
  function l(p) {
    p.preventDefault(), !(e.isBeginning && !e.params.loop && !e.params.rewind) && (e.slidePrev(), n("navigationPrev"));
  }
  function c(p) {
    p.preventDefault(), !(e.isEnd && !e.params.loop && !e.params.rewind) && (e.slideNext(), n("navigationNext"));
  }
  function u() {
    const p = e.params.navigation;
    if (e.params.navigation = Gp(e, e.originalParams.navigation, e.params.navigation, {
      nextEl: "swiper-button-next",
      prevEl: "swiper-button-prev"
    }), !(p.nextEl || p.prevEl)) return;
    let m = a(p.nextEl), y = a(p.prevEl);
    Object.assign(e.navigation, {
      nextEl: m,
      prevEl: y
    }), m = be(m), y = be(y);
    const h = (F, b) => {
      F && F.addEventListener("click", b === "next" ? c : l), !e.enabled && F && F.classList.add(...p.lockClass.split(" "));
    };
    m.forEach((F) => h(F, "next")), y.forEach((F) => h(F, "prev"));
  }
  function f() {
    let {
      nextEl: p,
      prevEl: m
    } = e.navigation;
    p = be(p), m = be(m);
    const y = (h, F) => {
      h.removeEventListener("click", F === "next" ? c : l), h.classList.remove(...e.params.navigation.disabledClass.split(" "));
    };
    p.forEach((h) => y(h, "next")), m.forEach((h) => y(h, "prev"));
  }
  t("init", () => {
    e.params.navigation.enabled === !1 ? d() : (u(), i());
  }), t("toEdge fromEdge lock unlock", () => {
    i();
  }), t("destroy", () => {
    f();
  }), t("enable disable", () => {
    let {
      nextEl: p,
      prevEl: m
    } = e.navigation;
    if (p = be(p), m = be(m), e.enabled) {
      i();
      return;
    }
    [...p, ...m].filter((y) => !!y).forEach((y) => y.classList.add(e.params.navigation.lockClass));
  }), t("click", (p, m) => {
    let {
      nextEl: y,
      prevEl: h
    } = e.navigation;
    y = be(y), h = be(h);
    const F = m.target;
    let b = h.includes(F) || y.includes(F);
    if (e.isElement && !b) {
      const v = m.path || m.composedPath && m.composedPath();
      v && (b = v.find((P) => y.includes(P) || h.includes(P)));
    }
    if (e.params.navigation.hideOnClick && !b) {
      if (e.pagination && e.params.pagination && e.params.pagination.clickable && (e.pagination.el === F || e.pagination.el.contains(F))) return;
      let v;
      y.length ? v = y[0].classList.contains(e.params.navigation.hiddenClass) : h.length && (v = h[0].classList.contains(e.params.navigation.hiddenClass)), n(v === !0 ? "navigationShow" : "navigationHide"), [...y, ...h].filter((P) => !!P).forEach((P) => P.classList.toggle(e.params.navigation.hiddenClass));
    }
  });
  const g = () => {
    e.el.classList.remove(...e.params.navigation.navigationDisabledClass.split(" ")), u(), i();
  }, d = () => {
    e.el.classList.add(...e.params.navigation.navigationDisabledClass.split(" ")), f();
  };
  Object.assign(e.navigation, {
    enable: g,
    disable: d,
    update: i,
    init: u,
    destroy: f
  });
}
function ur(o) {
  return o === void 0 && (o = ""), `.${o.trim().replace(/([\.:!+\/])/g, "\\$1").replace(/ /g, ".")}`;
}
function QA(o) {
  let {
    swiper: e,
    extendParams: r,
    on: t,
    emit: n
  } = o;
  const a = "swiper-pagination";
  r({
    pagination: {
      el: null,
      bulletElement: "span",
      clickable: !1,
      hideOnClick: !1,
      renderBullet: null,
      renderProgressbar: null,
      renderFraction: null,
      renderCustom: null,
      progressbarOpposite: !1,
      type: "bullets",
      // 'bullets' or 'progressbar' or 'fraction' or 'custom'
      dynamicBullets: !1,
      dynamicMainBullets: 1,
      formatFractionCurrent: (F) => F,
      formatFractionTotal: (F) => F,
      bulletClass: `${a}-bullet`,
      bulletActiveClass: `${a}-bullet-active`,
      modifierClass: `${a}-`,
      currentClass: `${a}-current`,
      totalClass: `${a}-total`,
      hiddenClass: `${a}-hidden`,
      progressbarFillClass: `${a}-progressbar-fill`,
      progressbarOppositeClass: `${a}-progressbar-opposite`,
      clickableClass: `${a}-clickable`,
      lockClass: `${a}-lock`,
      horizontalClass: `${a}-horizontal`,
      verticalClass: `${a}-vertical`,
      paginationDisabledClass: `${a}-disabled`
    }
  }), e.pagination = {
    el: null,
    bullets: []
  };
  let s, i = 0;
  function l() {
    return !e.params.pagination.el || !e.pagination.el || Array.isArray(e.pagination.el) && e.pagination.el.length === 0;
  }
  function c(F, b) {
    const {
      bulletActiveClass: v
    } = e.params.pagination;
    F && (F = F[`${b === "prev" ? "previous" : "next"}ElementSibling`], F && (F.classList.add(`${v}-${b}`), F = F[`${b === "prev" ? "previous" : "next"}ElementSibling`], F && F.classList.add(`${v}-${b}-${b}`)));
  }
  function u(F, b, v) {
    if (F = F % v, b = b % v, b === F + 1)
      return "next";
    if (b === F - 1)
      return "previous";
  }
  function f(F) {
    const b = F.target.closest(ur(e.params.pagination.bulletClass));
    if (!b)
      return;
    F.preventDefault();
    const v = Da(b) * e.params.slidesPerGroup;
    if (e.params.loop) {
      if (e.realIndex === v) return;
      const P = u(e.realIndex, v, e.slides.length);
      P === "next" ? e.slideNext() : P === "previous" ? e.slidePrev() : e.slideToLoop(v);
    } else
      e.slideTo(v);
  }
  function g() {
    const F = e.rtl, b = e.params.pagination;
    if (l()) return;
    let v = e.pagination.el;
    v = be(v);
    let P, E;
    const S = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.slides.length, D = e.params.loop ? Math.ceil(S / e.params.slidesPerGroup) : e.snapGrid.length;
    if (e.params.loop ? (E = e.previousRealIndex || 0, P = e.params.slidesPerGroup > 1 ? Math.floor(e.realIndex / e.params.slidesPerGroup) : e.realIndex) : typeof e.snapIndex < "u" ? (P = e.snapIndex, E = e.previousSnapIndex) : (E = e.previousIndex || 0, P = e.activeIndex || 0), b.type === "bullets" && e.pagination.bullets && e.pagination.bullets.length > 0) {
      const w = e.pagination.bullets;
      let A, C, x;
      if (b.dynamicBullets && (s = Lu(w[0], e.isHorizontal() ? "width" : "height"), v.forEach((T) => {
        T.style[e.isHorizontal() ? "width" : "height"] = `${s * (b.dynamicMainBullets + 4)}px`;
      }), b.dynamicMainBullets > 1 && E !== void 0 && (i += P - (E || 0), i > b.dynamicMainBullets - 1 ? i = b.dynamicMainBullets - 1 : i < 0 && (i = 0)), A = Math.max(P - i, 0), C = A + (Math.min(w.length, b.dynamicMainBullets) - 1), x = (C + A) / 2), w.forEach((T) => {
        const M = [...["", "-next", "-next-next", "-prev", "-prev-prev", "-main"].map((V) => `${b.bulletActiveClass}${V}`)].map((V) => typeof V == "string" && V.includes(" ") ? V.split(" ") : V).flat();
        T.classList.remove(...M);
      }), v.length > 1)
        w.forEach((T) => {
          const M = Da(T);
          M === P ? T.classList.add(...b.bulletActiveClass.split(" ")) : e.isElement && T.setAttribute("part", "bullet"), b.dynamicBullets && (M >= A && M <= C && T.classList.add(...`${b.bulletActiveClass}-main`.split(" ")), M === A && c(T, "prev"), M === C && c(T, "next"));
        });
      else {
        const T = w[P];
        if (T && T.classList.add(...b.bulletActiveClass.split(" ")), e.isElement && w.forEach((M, V) => {
          M.setAttribute("part", V === P ? "bullet-active" : "bullet");
        }), b.dynamicBullets) {
          const M = w[A], V = w[C];
          for (let G = A; G <= C; G += 1)
            w[G] && w[G].classList.add(...`${b.bulletActiveClass}-main`.split(" "));
          c(M, "prev"), c(V, "next");
        }
      }
      if (b.dynamicBullets) {
        const T = Math.min(w.length, b.dynamicMainBullets + 4), M = (s * T - s) / 2 - x * s, V = F ? "right" : "left";
        w.forEach((G) => {
          G.style[e.isHorizontal() ? V : "top"] = `${M}px`;
        });
      }
    }
    v.forEach((w, A) => {
      if (b.type === "fraction" && (w.querySelectorAll(ur(b.currentClass)).forEach((C) => {
        C.textContent = b.formatFractionCurrent(P + 1);
      }), w.querySelectorAll(ur(b.totalClass)).forEach((C) => {
        C.textContent = b.formatFractionTotal(D);
      })), b.type === "progressbar") {
        let C;
        b.progressbarOpposite ? C = e.isHorizontal() ? "vertical" : "horizontal" : C = e.isHorizontal() ? "horizontal" : "vertical";
        const x = (P + 1) / D;
        let T = 1, M = 1;
        C === "horizontal" ? T = x : M = x, w.querySelectorAll(ur(b.progressbarFillClass)).forEach((V) => {
          V.style.transform = `translate3d(0,0,0) scaleX(${T}) scaleY(${M})`, V.style.transitionDuration = `${e.params.speed}ms`;
        });
      }
      b.type === "custom" && b.renderCustom ? (w.innerHTML = b.renderCustom(e, P + 1, D), A === 0 && n("paginationRender", w)) : (A === 0 && n("paginationRender", w), n("paginationUpdate", w)), e.params.watchOverflow && e.enabled && w.classList[e.isLocked ? "add" : "remove"](b.lockClass);
    });
  }
  function d() {
    const F = e.params.pagination;
    if (l()) return;
    const b = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.grid && e.params.grid.rows > 1 ? e.slides.length / Math.ceil(e.params.grid.rows) : e.slides.length;
    let v = e.pagination.el;
    v = be(v);
    let P = "";
    if (F.type === "bullets") {
      let E = e.params.loop ? Math.ceil(b / e.params.slidesPerGroup) : e.snapGrid.length;
      e.params.freeMode && e.params.freeMode.enabled && E > b && (E = b);
      for (let S = 0; S < E; S += 1)
        F.renderBullet ? P += F.renderBullet.call(e, S, F.bulletClass) : P += `<${F.bulletElement} ${e.isElement ? 'part="bullet"' : ""} class="${F.bulletClass}"></${F.bulletElement}>`;
    }
    F.type === "fraction" && (F.renderFraction ? P = F.renderFraction.call(e, F.currentClass, F.totalClass) : P = `<span class="${F.currentClass}"></span> / <span class="${F.totalClass}"></span>`), F.type === "progressbar" && (F.renderProgressbar ? P = F.renderProgressbar.call(e, F.progressbarFillClass) : P = `<span class="${F.progressbarFillClass}"></span>`), e.pagination.bullets = [], v.forEach((E) => {
      F.type !== "custom" && (E.innerHTML = P || ""), F.type === "bullets" && e.pagination.bullets.push(...E.querySelectorAll(ur(F.bulletClass)));
    }), F.type !== "custom" && n("paginationRender", v[0]);
  }
  function p() {
    e.params.pagination = Gp(e, e.originalParams.pagination, e.params.pagination, {
      el: "swiper-pagination"
    });
    const F = e.params.pagination;
    if (!F.el) return;
    let b;
    typeof F.el == "string" && e.isElement && (b = e.el.querySelector(F.el)), !b && typeof F.el == "string" && (b = [...document.querySelectorAll(F.el)]), b || (b = F.el), !(!b || b.length === 0) && (e.params.uniqueNavElements && typeof F.el == "string" && Array.isArray(b) && b.length > 1 && (b = [...e.el.querySelectorAll(F.el)], b.length > 1 && (b = b.find((v) => nt(v, ".swiper")[0] === e.el))), Array.isArray(b) && b.length === 1 && (b = b[0]), Object.assign(e.pagination, {
      el: b
    }), b = be(b), b.forEach((v) => {
      F.type === "bullets" && F.clickable && v.classList.add(...(F.clickableClass || "").split(" ")), v.classList.add(F.modifierClass + F.type), v.classList.add(e.isHorizontal() ? F.horizontalClass : F.verticalClass), F.type === "bullets" && F.dynamicBullets && (v.classList.add(`${F.modifierClass}${F.type}-dynamic`), i = 0, F.dynamicMainBullets < 1 && (F.dynamicMainBullets = 1)), F.type === "progressbar" && F.progressbarOpposite && v.classList.add(F.progressbarOppositeClass), F.clickable && v.addEventListener("click", f), e.enabled || v.classList.add(F.lockClass);
    }));
  }
  function m() {
    const F = e.params.pagination;
    if (l()) return;
    let b = e.pagination.el;
    b && (b = be(b), b.forEach((v) => {
      v.classList.remove(F.hiddenClass), v.classList.remove(F.modifierClass + F.type), v.classList.remove(e.isHorizontal() ? F.horizontalClass : F.verticalClass), F.clickable && (v.classList.remove(...(F.clickableClass || "").split(" ")), v.removeEventListener("click", f));
    })), e.pagination.bullets && e.pagination.bullets.forEach((v) => v.classList.remove(...F.bulletActiveClass.split(" ")));
  }
  t("changeDirection", () => {
    if (!e.pagination || !e.pagination.el) return;
    const F = e.params.pagination;
    let {
      el: b
    } = e.pagination;
    b = be(b), b.forEach((v) => {
      v.classList.remove(F.horizontalClass, F.verticalClass), v.classList.add(e.isHorizontal() ? F.horizontalClass : F.verticalClass);
    });
  }), t("init", () => {
    e.params.pagination.enabled === !1 ? h() : (p(), d(), g());
  }), t("activeIndexChange", () => {
    typeof e.snapIndex > "u" && g();
  }), t("snapIndexChange", () => {
    g();
  }), t("snapGridLengthChange", () => {
    d(), g();
  }), t("destroy", () => {
    m();
  }), t("enable disable", () => {
    let {
      el: F
    } = e.pagination;
    F && (F = be(F), F.forEach((b) => b.classList[e.enabled ? "remove" : "add"](e.params.pagination.lockClass)));
  }), t("lock unlock", () => {
    g();
  }), t("click", (F, b) => {
    const v = b.target, P = be(e.pagination.el);
    if (e.params.pagination.el && e.params.pagination.hideOnClick && P && P.length > 0 && !v.classList.contains(e.params.pagination.bulletClass)) {
      if (e.navigation && (e.navigation.nextEl && v === e.navigation.nextEl || e.navigation.prevEl && v === e.navigation.prevEl)) return;
      const E = P[0].classList.contains(e.params.pagination.hiddenClass);
      n(E === !0 ? "paginationShow" : "paginationHide"), P.forEach((S) => S.classList.toggle(e.params.pagination.hiddenClass));
    }
  });
  const y = () => {
    e.el.classList.remove(e.params.pagination.paginationDisabledClass);
    let {
      el: F
    } = e.pagination;
    F && (F = be(F), F.forEach((b) => b.classList.remove(e.params.pagination.paginationDisabledClass))), p(), d(), g();
  }, h = () => {
    e.el.classList.add(e.params.pagination.paginationDisabledClass);
    let {
      el: F
    } = e.pagination;
    F && (F = be(F), F.forEach((b) => b.classList.add(e.params.pagination.paginationDisabledClass))), m();
  };
  Object.assign(e.pagination, {
    enable: y,
    disable: h,
    render: d,
    update: g,
    init: p,
    destroy: m
  });
}
function JA(o) {
  let {
    swiper: e,
    extendParams: r,
    on: t,
    emit: n
  } = o;
  const a = Qe();
  let s = !1, i = null, l = null, c, u, f, g;
  r({
    scrollbar: {
      el: null,
      dragSize: "auto",
      hide: !1,
      draggable: !1,
      snapOnRelease: !0,
      lockClass: "swiper-scrollbar-lock",
      dragClass: "swiper-scrollbar-drag",
      scrollbarDisabledClass: "swiper-scrollbar-disabled",
      horizontalClass: "swiper-scrollbar-horizontal",
      verticalClass: "swiper-scrollbar-vertical"
    }
  }), e.scrollbar = {
    el: null,
    dragEl: null
  };
  function d() {
    if (!e.params.scrollbar.el || !e.scrollbar.el) return;
    const {
      scrollbar: x,
      rtlTranslate: T
    } = e, {
      dragEl: M,
      el: V
    } = x, G = e.params.scrollbar, L = e.params.loop ? e.progressLoop : e.progress;
    let W = u, Y = (f - u) * L;
    T ? (Y = -Y, Y > 0 ? (W = u - Y, Y = 0) : -Y + u > f && (W = f + Y)) : Y < 0 ? (W = u + Y, Y = 0) : Y + u > f && (W = f - Y), e.isHorizontal() ? (M.style.transform = `translate3d(${Y}px, 0, 0)`, M.style.width = `${W}px`) : (M.style.transform = `translate3d(0px, ${Y}px, 0)`, M.style.height = `${W}px`), G.hide && (clearTimeout(i), V.style.opacity = 1, i = setTimeout(() => {
      V.style.opacity = 0, V.style.transitionDuration = "400ms";
    }, 1e3));
  }
  function p(x) {
    !e.params.scrollbar.el || !e.scrollbar.el || (e.scrollbar.dragEl.style.transitionDuration = `${x}ms`);
  }
  function m() {
    if (!e.params.scrollbar.el || !e.scrollbar.el) return;
    const {
      scrollbar: x
    } = e, {
      dragEl: T,
      el: M
    } = x;
    T.style.width = "", T.style.height = "", f = e.isHorizontal() ? M.offsetWidth : M.offsetHeight, g = e.size / (e.virtualSize + e.params.slidesOffsetBefore - (e.params.centeredSlides ? e.snapGrid[0] : 0)), e.params.scrollbar.dragSize === "auto" ? u = f * g : u = parseInt(e.params.scrollbar.dragSize, 10), e.isHorizontal() ? T.style.width = `${u}px` : T.style.height = `${u}px`, g >= 1 ? M.style.display = "none" : M.style.display = "", e.params.scrollbar.hide && (M.style.opacity = 0), e.params.watchOverflow && e.enabled && x.el.classList[e.isLocked ? "add" : "remove"](e.params.scrollbar.lockClass);
  }
  function y(x) {
    return e.isHorizontal() ? x.clientX : x.clientY;
  }
  function h(x) {
    const {
      scrollbar: T,
      rtlTranslate: M
    } = e, {
      el: V
    } = T;
    let G;
    G = (y(x) - ti(V)[e.isHorizontal() ? "left" : "top"] - (c !== null ? c : u / 2)) / (f - u), G = Math.max(Math.min(G, 1), 0), M && (G = 1 - G);
    const L = e.minTranslate() + (e.maxTranslate() - e.minTranslate()) * G;
    e.updateProgress(L), e.setTranslate(L), e.updateActiveIndex(), e.updateSlidesClasses();
  }
  function F(x) {
    const T = e.params.scrollbar, {
      scrollbar: M,
      wrapperEl: V
    } = e, {
      el: G,
      dragEl: L
    } = M;
    s = !0, c = x.target === L ? y(x) - x.target.getBoundingClientRect()[e.isHorizontal() ? "left" : "top"] : null, x.preventDefault(), x.stopPropagation(), V.style.transitionDuration = "100ms", L.style.transitionDuration = "100ms", h(x), clearTimeout(l), G.style.transitionDuration = "0ms", T.hide && (G.style.opacity = 1), e.params.cssMode && (e.wrapperEl.style["scroll-snap-type"] = "none"), n("scrollbarDragStart", x);
  }
  function b(x) {
    const {
      scrollbar: T,
      wrapperEl: M
    } = e, {
      el: V,
      dragEl: G
    } = T;
    s && (x.preventDefault && x.cancelable ? x.preventDefault() : x.returnValue = !1, h(x), M.style.transitionDuration = "0ms", V.style.transitionDuration = "0ms", G.style.transitionDuration = "0ms", n("scrollbarDragMove", x));
  }
  function v(x) {
    const T = e.params.scrollbar, {
      scrollbar: M,
      wrapperEl: V
    } = e, {
      el: G
    } = M;
    s && (s = !1, e.params.cssMode && (e.wrapperEl.style["scroll-snap-type"] = "", V.style.transitionDuration = ""), T.hide && (clearTimeout(l), l = mt(() => {
      G.style.opacity = 0, G.style.transitionDuration = "400ms";
    }, 1e3)), n("scrollbarDragEnd", x), T.snapOnRelease && e.slideToClosest());
  }
  function P(x) {
    const {
      scrollbar: T,
      params: M
    } = e, V = T.el;
    if (!V) return;
    const G = V, L = M.passiveListeners ? {
      passive: !1,
      capture: !1
    } : !1, W = M.passiveListeners ? {
      passive: !0,
      capture: !1
    } : !1;
    if (!G) return;
    const Y = x === "on" ? "addEventListener" : "removeEventListener";
    G[Y]("pointerdown", F, L), a[Y]("pointermove", b, L), a[Y]("pointerup", v, W);
  }
  function E() {
    !e.params.scrollbar.el || !e.scrollbar.el || P("on");
  }
  function S() {
    !e.params.scrollbar.el || !e.scrollbar.el || P("off");
  }
  function D() {
    const {
      scrollbar: x,
      el: T
    } = e;
    e.params.scrollbar = Gp(e, e.originalParams.scrollbar, e.params.scrollbar, {
      el: "swiper-scrollbar"
    });
    const M = e.params.scrollbar;
    if (!M.el) return;
    let V;
    if (typeof M.el == "string" && e.isElement && (V = e.el.querySelector(M.el)), !V && typeof M.el == "string") {
      if (V = a.querySelectorAll(M.el), !V.length) return;
    } else V || (V = M.el);
    e.params.uniqueNavElements && typeof M.el == "string" && V.length > 1 && T.querySelectorAll(M.el).length === 1 && (V = T.querySelector(M.el)), V.length > 0 && (V = V[0]), V.classList.add(e.isHorizontal() ? M.horizontalClass : M.verticalClass);
    let G;
    V && (G = V.querySelector(ur(e.params.scrollbar.dragClass)), G || (G = Ao("div", e.params.scrollbar.dragClass), V.append(G))), Object.assign(x, {
      el: V,
      dragEl: G
    }), M.draggable && E(), V && V.classList[e.enabled ? "remove" : "add"](...Er(e.params.scrollbar.lockClass));
  }
  function w() {
    const x = e.params.scrollbar, T = e.scrollbar.el;
    T && T.classList.remove(...Er(e.isHorizontal() ? x.horizontalClass : x.verticalClass)), S();
  }
  t("changeDirection", () => {
    if (!e.scrollbar || !e.scrollbar.el) return;
    const x = e.params.scrollbar;
    let {
      el: T
    } = e.scrollbar;
    T = be(T), T.forEach((M) => {
      M.classList.remove(x.horizontalClass, x.verticalClass), M.classList.add(e.isHorizontal() ? x.horizontalClass : x.verticalClass);
    });
  }), t("init", () => {
    e.params.scrollbar.enabled === !1 ? C() : (D(), m(), d());
  }), t("update resize observerUpdate lock unlock changeDirection", () => {
    m();
  }), t("setTranslate", () => {
    d();
  }), t("setTransition", (x, T) => {
    p(T);
  }), t("enable disable", () => {
    const {
      el: x
    } = e.scrollbar;
    x && x.classList[e.enabled ? "remove" : "add"](...Er(e.params.scrollbar.lockClass));
  }), t("destroy", () => {
    w();
  });
  const A = () => {
    e.el.classList.remove(...Er(e.params.scrollbar.scrollbarDisabledClass)), e.scrollbar.el && e.scrollbar.el.classList.remove(...Er(e.params.scrollbar.scrollbarDisabledClass)), D(), m(), d();
  }, C = () => {
    e.el.classList.add(...Er(e.params.scrollbar.scrollbarDisabledClass)), e.scrollbar.el && e.scrollbar.el.classList.add(...Er(e.params.scrollbar.scrollbarDisabledClass)), w();
  };
  Object.assign(e.scrollbar, {
    enable: A,
    disable: C,
    updateSize: m,
    setTranslate: d,
    init: D,
    destroy: w
  });
}
function _A(o) {
  let {
    swiper: e,
    extendParams: r,
    on: t
  } = o;
  r({
    parallax: {
      enabled: !1
    }
  });
  const n = "[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]", a = (l, c) => {
    const {
      rtl: u
    } = e, f = u ? -1 : 1, g = l.getAttribute("data-swiper-parallax") || "0";
    let d = l.getAttribute("data-swiper-parallax-x"), p = l.getAttribute("data-swiper-parallax-y");
    const m = l.getAttribute("data-swiper-parallax-scale"), y = l.getAttribute("data-swiper-parallax-opacity"), h = l.getAttribute("data-swiper-parallax-rotate");
    if (d || p ? (d = d || "0", p = p || "0") : e.isHorizontal() ? (d = g, p = "0") : (p = g, d = "0"), d.indexOf("%") >= 0 ? d = `${parseInt(d, 10) * c * f}%` : d = `${d * c * f}px`, p.indexOf("%") >= 0 ? p = `${parseInt(p, 10) * c}%` : p = `${p * c}px`, typeof y < "u" && y !== null) {
      const b = y - (y - 1) * (1 - Math.abs(c));
      l.style.opacity = b;
    }
    let F = `translate3d(${d}, ${p}, 0px)`;
    if (typeof m < "u" && m !== null) {
      const b = m - (m - 1) * (1 - Math.abs(c));
      F += ` scale(${b})`;
    }
    if (h && typeof h < "u" && h !== null) {
      const b = h * c * -1;
      F += ` rotate(${b}deg)`;
    }
    l.style.transform = F;
  }, s = () => {
    const {
      el: l,
      slides: c,
      progress: u,
      snapGrid: f,
      isElement: g
    } = e, d = $e(l, n);
    e.isElement && d.push(...$e(e.hostEl, n)), d.forEach((p) => {
      a(p, u);
    }), c.forEach((p, m) => {
      let y = p.progress;
      e.params.slidesPerGroup > 1 && e.params.slidesPerView !== "auto" && (y += Math.ceil(m / 2) - u * (f.length - 1)), y = Math.min(Math.max(y, -1), 1), p.querySelectorAll(`${n}, [data-swiper-parallax-rotate]`).forEach((h) => {
        a(h, y);
      });
    });
  }, i = function(l) {
    l === void 0 && (l = e.params.speed);
    const {
      el: c,
      hostEl: u
    } = e, f = [...c.querySelectorAll(n)];
    e.isElement && f.push(...u.querySelectorAll(n)), f.forEach((g) => {
      let d = parseInt(g.getAttribute("data-swiper-parallax-duration"), 10) || l;
      l === 0 && (d = 0), g.style.transitionDuration = `${d}ms`;
    });
  };
  t("beforeInit", () => {
    e.params.parallax.enabled && (e.params.watchSlidesProgress = !0, e.originalParams.watchSlidesProgress = !0);
  }), t("init", () => {
    e.params.parallax.enabled && s();
  }), t("setTranslate", () => {
    e.params.parallax.enabled && s();
  }), t("setTransition", (l, c) => {
    e.params.parallax.enabled && i(c);
  });
}
function $A(o) {
  let {
    swiper: e,
    extendParams: r,
    on: t,
    emit: n
  } = o;
  const a = Ne();
  r({
    zoom: {
      enabled: !1,
      limitToOriginalSize: !1,
      maxRatio: 3,
      minRatio: 1,
      panOnMouseMove: !1,
      toggle: !0,
      containerClass: "swiper-zoom-container",
      zoomedSlideClass: "swiper-slide-zoomed"
    }
  }), e.zoom = {
    enabled: !1
  };
  let s = 1, i = !1, l = !1, c = {
    x: 0,
    y: 0
  };
  const u = -3;
  let f, g;
  const d = [], p = {
    originX: 0,
    originY: 0,
    slideEl: void 0,
    slideWidth: void 0,
    slideHeight: void 0,
    imageEl: void 0,
    imageWrapEl: void 0,
    maxRatio: 3
  }, m = {
    isTouched: void 0,
    isMoved: void 0,
    currentX: void 0,
    currentY: void 0,
    minX: void 0,
    minY: void 0,
    maxX: void 0,
    maxY: void 0,
    width: void 0,
    height: void 0,
    startX: void 0,
    startY: void 0,
    touchesStart: {},
    touchesCurrent: {}
  }, y = {
    x: void 0,
    y: void 0,
    prevPositionX: void 0,
    prevPositionY: void 0,
    prevTime: void 0
  };
  let h = 1;
  Object.defineProperty(e.zoom, "scale", {
    get() {
      return h;
    },
    set(U) {
      if (h !== U) {
        const Z = p.imageEl, Q = p.slideEl;
        n("zoomChange", U, Z, Q);
      }
      h = U;
    }
  });
  function F() {
    if (d.length < 2) return 1;
    const U = d[0].pageX, Z = d[0].pageY, Q = d[1].pageX, oe = d[1].pageY;
    return Math.sqrt((Q - U) ** 2 + (oe - Z) ** 2);
  }
  function b() {
    const U = e.params.zoom, Z = p.imageWrapEl.getAttribute("data-swiper-zoom") || U.maxRatio;
    if (U.limitToOriginalSize && p.imageEl && p.imageEl.naturalWidth) {
      const Q = p.imageEl.naturalWidth / p.imageEl.offsetWidth;
      return Math.min(Q, Z);
    }
    return Z;
  }
  function v() {
    if (d.length < 2) return {
      x: null,
      y: null
    };
    const U = p.imageEl.getBoundingClientRect();
    return [(d[0].pageX + (d[1].pageX - d[0].pageX) / 2 - U.x - a.scrollX) / s, (d[0].pageY + (d[1].pageY - d[0].pageY) / 2 - U.y - a.scrollY) / s];
  }
  function P() {
    return e.isElement ? "swiper-slide" : `.${e.params.slideClass}`;
  }
  function E(U) {
    const Z = P();
    return !!(U.target.matches(Z) || e.slides.filter((Q) => Q.contains(U.target)).length > 0);
  }
  function S(U) {
    const Z = `.${e.params.zoom.containerClass}`;
    return !!(U.target.matches(Z) || [...e.hostEl.querySelectorAll(Z)].filter((Q) => Q.contains(U.target)).length > 0);
  }
  function D(U) {
    if (U.pointerType === "mouse" && d.splice(0, d.length), !E(U)) return;
    const Z = e.params.zoom;
    if (f = !1, g = !1, d.push(U), !(d.length < 2)) {
      if (f = !0, p.scaleStart = F(), !p.slideEl) {
        p.slideEl = U.target.closest(`.${e.params.slideClass}, swiper-slide`), p.slideEl || (p.slideEl = e.slides[e.activeIndex]);
        let Q = p.slideEl.querySelector(`.${Z.containerClass}`);
        if (Q && (Q = Q.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]), p.imageEl = Q, Q ? p.imageWrapEl = nt(p.imageEl, `.${Z.containerClass}`)[0] : p.imageWrapEl = void 0, !p.imageWrapEl) {
          p.imageEl = void 0;
          return;
        }
        p.maxRatio = b();
      }
      if (p.imageEl) {
        const [Q, oe] = v();
        p.originX = Q, p.originY = oe, p.imageEl.style.transitionDuration = "0ms";
      }
      i = !0;
    }
  }
  function w(U) {
    if (!E(U)) return;
    const Z = e.params.zoom, Q = e.zoom, oe = d.findIndex((ge) => ge.pointerId === U.pointerId);
    oe >= 0 && (d[oe] = U), !(d.length < 2) && (g = !0, p.scaleMove = F(), p.imageEl && (Q.scale = p.scaleMove / p.scaleStart * s, Q.scale > p.maxRatio && (Q.scale = p.maxRatio - 1 + (Q.scale - p.maxRatio + 1) ** 0.5), Q.scale < Z.minRatio && (Q.scale = Z.minRatio + 1 - (Z.minRatio - Q.scale + 1) ** 0.5), p.imageEl.style.transform = `translate3d(0,0,0) scale(${Q.scale})`));
  }
  function A(U) {
    if (!E(U) || U.pointerType === "mouse" && U.type === "pointerout") return;
    const Z = e.params.zoom, Q = e.zoom, oe = d.findIndex((ge) => ge.pointerId === U.pointerId);
    oe >= 0 && d.splice(oe, 1), !(!f || !g) && (f = !1, g = !1, p.imageEl && (Q.scale = Math.max(Math.min(Q.scale, p.maxRatio), Z.minRatio), p.imageEl.style.transitionDuration = `${e.params.speed}ms`, p.imageEl.style.transform = `translate3d(0,0,0) scale(${Q.scale})`, s = Q.scale, i = !1, Q.scale > 1 && p.slideEl ? p.slideEl.classList.add(`${Z.zoomedSlideClass}`) : Q.scale <= 1 && p.slideEl && p.slideEl.classList.remove(`${Z.zoomedSlideClass}`), Q.scale === 1 && (p.originX = 0, p.originY = 0, p.slideEl = void 0)));
  }
  let C;
  function x() {
    e.touchEventsData.preventTouchMoveFromPointerMove = !1;
  }
  function T() {
    clearTimeout(C), e.touchEventsData.preventTouchMoveFromPointerMove = !0, C = setTimeout(() => {
      e.destroyed || x();
    });
  }
  function M(U) {
    const Z = e.device;
    if (!p.imageEl || m.isTouched) return;
    Z.android && U.cancelable && U.preventDefault(), m.isTouched = !0;
    const Q = d.length > 0 ? d[0] : U;
    m.touchesStart.x = Q.pageX, m.touchesStart.y = Q.pageY;
  }
  function V(U) {
    const Q = U.pointerType === "mouse" && e.params.zoom.panOnMouseMove;
    if (!E(U) || !S(U))
      return;
    const oe = e.zoom;
    if (!p.imageEl)
      return;
    if (!m.isTouched || !p.slideEl) {
      Q && W(U);
      return;
    }
    if (Q) {
      W(U);
      return;
    }
    m.isMoved || (m.width = p.imageEl.offsetWidth || p.imageEl.clientWidth, m.height = p.imageEl.offsetHeight || p.imageEl.clientHeight, m.startX = Tu(p.imageWrapEl, "x") || 0, m.startY = Tu(p.imageWrapEl, "y") || 0, p.slideWidth = p.slideEl.offsetWidth, p.slideHeight = p.slideEl.offsetHeight, p.imageWrapEl.style.transitionDuration = "0ms");
    const ge = m.width * oe.scale, Ae = m.height * oe.scale;
    if (m.minX = Math.min(p.slideWidth / 2 - ge / 2, 0), m.maxX = -m.minX, m.minY = Math.min(p.slideHeight / 2 - Ae / 2, 0), m.maxY = -m.minY, m.touchesCurrent.x = d.length > 0 ? d[0].pageX : U.pageX, m.touchesCurrent.y = d.length > 0 ? d[0].pageY : U.pageY, Math.max(Math.abs(m.touchesCurrent.x - m.touchesStart.x), Math.abs(m.touchesCurrent.y - m.touchesStart.y)) > 5 && (e.allowClick = !1), !m.isMoved && !i) {
      if (e.isHorizontal() && (Math.floor(m.minX) === Math.floor(m.startX) && m.touchesCurrent.x < m.touchesStart.x || Math.floor(m.maxX) === Math.floor(m.startX) && m.touchesCurrent.x > m.touchesStart.x)) {
        m.isTouched = !1, x();
        return;
      }
      if (!e.isHorizontal() && (Math.floor(m.minY) === Math.floor(m.startY) && m.touchesCurrent.y < m.touchesStart.y || Math.floor(m.maxY) === Math.floor(m.startY) && m.touchesCurrent.y > m.touchesStart.y)) {
        m.isTouched = !1, x();
        return;
      }
    }
    U.cancelable && U.preventDefault(), U.stopPropagation(), T(), m.isMoved = !0;
    const po = (oe.scale - s) / (p.maxRatio - e.params.zoom.minRatio), {
      originX: Uo,
      originY: qe
    } = p;
    m.currentX = m.touchesCurrent.x - m.touchesStart.x + m.startX + po * (m.width - Uo * 2), m.currentY = m.touchesCurrent.y - m.touchesStart.y + m.startY + po * (m.height - qe * 2), m.currentX < m.minX && (m.currentX = m.minX + 1 - (m.minX - m.currentX + 1) ** 0.8), m.currentX > m.maxX && (m.currentX = m.maxX - 1 + (m.currentX - m.maxX + 1) ** 0.8), m.currentY < m.minY && (m.currentY = m.minY + 1 - (m.minY - m.currentY + 1) ** 0.8), m.currentY > m.maxY && (m.currentY = m.maxY - 1 + (m.currentY - m.maxY + 1) ** 0.8), y.prevPositionX || (y.prevPositionX = m.touchesCurrent.x), y.prevPositionY || (y.prevPositionY = m.touchesCurrent.y), y.prevTime || (y.prevTime = Date.now()), y.x = (m.touchesCurrent.x - y.prevPositionX) / (Date.now() - y.prevTime) / 2, y.y = (m.touchesCurrent.y - y.prevPositionY) / (Date.now() - y.prevTime) / 2, Math.abs(m.touchesCurrent.x - y.prevPositionX) < 2 && (y.x = 0), Math.abs(m.touchesCurrent.y - y.prevPositionY) < 2 && (y.y = 0), y.prevPositionX = m.touchesCurrent.x, y.prevPositionY = m.touchesCurrent.y, y.prevTime = Date.now(), p.imageWrapEl.style.transform = `translate3d(${m.currentX}px, ${m.currentY}px,0)`;
  }
  function G() {
    const U = e.zoom;
    if (d.length = 0, !p.imageEl) return;
    if (!m.isTouched || !m.isMoved) {
      m.isTouched = !1, m.isMoved = !1;
      return;
    }
    m.isTouched = !1, m.isMoved = !1;
    let Z = 300, Q = 300;
    const oe = y.x * Z, ge = m.currentX + oe, Ae = y.y * Q, ke = m.currentY + Ae;
    y.x !== 0 && (Z = Math.abs((ge - m.currentX) / y.x)), y.y !== 0 && (Q = Math.abs((ke - m.currentY) / y.y));
    const po = Math.max(Z, Q);
    m.currentX = ge, m.currentY = ke;
    const Uo = m.width * U.scale, qe = m.height * U.scale;
    m.minX = Math.min(p.slideWidth / 2 - Uo / 2, 0), m.maxX = -m.minX, m.minY = Math.min(p.slideHeight / 2 - qe / 2, 0), m.maxY = -m.minY, m.currentX = Math.max(Math.min(m.currentX, m.maxX), m.minX), m.currentY = Math.max(Math.min(m.currentY, m.maxY), m.minY), p.imageWrapEl.style.transitionDuration = `${po}ms`, p.imageWrapEl.style.transform = `translate3d(${m.currentX}px, ${m.currentY}px,0)`;
  }
  function L() {
    const U = e.zoom;
    p.slideEl && e.activeIndex !== e.slides.indexOf(p.slideEl) && (p.imageEl && (p.imageEl.style.transform = "translate3d(0,0,0) scale(1)"), p.imageWrapEl && (p.imageWrapEl.style.transform = "translate3d(0,0,0)"), p.slideEl.classList.remove(`${e.params.zoom.zoomedSlideClass}`), U.scale = 1, s = 1, p.slideEl = void 0, p.imageEl = void 0, p.imageWrapEl = void 0, p.originX = 0, p.originY = 0);
  }
  function W(U) {
    if (s <= 1 || !p.imageWrapEl || !E(U) || !S(U)) return;
    const Z = a.getComputedStyle(p.imageWrapEl).transform, Q = new a.DOMMatrix(Z);
    if (!l) {
      l = !0, c.x = U.clientX, c.y = U.clientY, m.startX = Q.e, m.startY = Q.f, m.width = p.imageEl.offsetWidth || p.imageEl.clientWidth, m.height = p.imageEl.offsetHeight || p.imageEl.clientHeight, p.slideWidth = p.slideEl.offsetWidth, p.slideHeight = p.slideEl.offsetHeight;
      return;
    }
    const oe = (U.clientX - c.x) * u, ge = (U.clientY - c.y) * u, Ae = m.width * s, ke = m.height * s, po = p.slideWidth, Uo = p.slideHeight, qe = Math.min(po / 2 - Ae / 2, 0), ro = -qe, Qr = Math.min(Uo / 2 - ke / 2, 0), _a = -Qr, Bt = Math.max(Math.min(m.startX + oe, ro), qe), Pt = Math.max(Math.min(m.startY + ge, _a), Qr);
    p.imageWrapEl.style.transitionDuration = "0ms", p.imageWrapEl.style.transform = `translate3d(${Bt}px, ${Pt}px, 0)`, c.x = U.clientX, c.y = U.clientY, m.startX = Bt, m.startY = Pt, m.currentX = Bt, m.currentY = Pt;
  }
  function Y(U) {
    const Z = e.zoom, Q = e.params.zoom;
    if (!p.slideEl) {
      U && U.target && (p.slideEl = U.target.closest(`.${e.params.slideClass}, swiper-slide`)), p.slideEl || (e.params.virtual && e.params.virtual.enabled && e.virtual ? p.slideEl = $e(e.slidesEl, `.${e.params.slideActiveClass}`)[0] : p.slideEl = e.slides[e.activeIndex]);
      let sn = p.slideEl.querySelector(`.${Q.containerClass}`);
      sn && (sn = sn.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]), p.imageEl = sn, sn ? p.imageWrapEl = nt(p.imageEl, `.${Q.containerClass}`)[0] : p.imageWrapEl = void 0;
    }
    if (!p.imageEl || !p.imageWrapEl) return;
    e.params.cssMode && (e.wrapperEl.style.overflow = "hidden", e.wrapperEl.style.touchAction = "none"), p.slideEl.classList.add(`${Q.zoomedSlideClass}`);
    let oe, ge, Ae, ke, po, Uo, qe, ro, Qr, _a, Bt, Pt, $a, es, Qi, Ji, _i, $i;
    typeof m.touchesStart.x > "u" && U ? (oe = U.pageX, ge = U.pageY) : (oe = m.touchesStart.x, ge = m.touchesStart.y);
    const el = s, wt = typeof U == "number" ? U : null;
    s === 1 && wt && (oe = void 0, ge = void 0, m.touchesStart.x = void 0, m.touchesStart.y = void 0);
    const Dd = b();
    Z.scale = wt || Dd, s = wt || Dd, U && !(s === 1 && wt) ? (_i = p.slideEl.offsetWidth, $i = p.slideEl.offsetHeight, Ae = ti(p.slideEl).left + a.scrollX, ke = ti(p.slideEl).top + a.scrollY, po = Ae + _i / 2 - oe, Uo = ke + $i / 2 - ge, Qr = p.imageEl.offsetWidth || p.imageEl.clientWidth, _a = p.imageEl.offsetHeight || p.imageEl.clientHeight, Bt = Qr * Z.scale, Pt = _a * Z.scale, $a = Math.min(_i / 2 - Bt / 2, 0), es = Math.min($i / 2 - Pt / 2, 0), Qi = -$a, Ji = -es, el > 0 && wt && typeof m.currentX == "number" && typeof m.currentY == "number" ? (qe = m.currentX * Z.scale / el, ro = m.currentY * Z.scale / el) : (qe = po * Z.scale, ro = Uo * Z.scale), qe < $a && (qe = $a), qe > Qi && (qe = Qi), ro < es && (ro = es), ro > Ji && (ro = Ji)) : (qe = 0, ro = 0), wt && Z.scale === 1 && (p.originX = 0, p.originY = 0), m.currentX = qe, m.currentY = ro, p.imageWrapEl.style.transitionDuration = "300ms", p.imageWrapEl.style.transform = `translate3d(${qe}px, ${ro}px,0)`, p.imageEl.style.transitionDuration = "300ms", p.imageEl.style.transform = `translate3d(0,0,0) scale(${Z.scale})`;
  }
  function X() {
    const U = e.zoom, Z = e.params.zoom;
    if (!p.slideEl) {
      e.params.virtual && e.params.virtual.enabled && e.virtual ? p.slideEl = $e(e.slidesEl, `.${e.params.slideActiveClass}`)[0] : p.slideEl = e.slides[e.activeIndex];
      let Q = p.slideEl.querySelector(`.${Z.containerClass}`);
      Q && (Q = Q.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]), p.imageEl = Q, Q ? p.imageWrapEl = nt(p.imageEl, `.${Z.containerClass}`)[0] : p.imageWrapEl = void 0;
    }
    !p.imageEl || !p.imageWrapEl || (e.params.cssMode && (e.wrapperEl.style.overflow = "", e.wrapperEl.style.touchAction = ""), U.scale = 1, s = 1, m.currentX = void 0, m.currentY = void 0, m.touchesStart.x = void 0, m.touchesStart.y = void 0, p.imageWrapEl.style.transitionDuration = "300ms", p.imageWrapEl.style.transform = "translate3d(0,0,0)", p.imageEl.style.transitionDuration = "300ms", p.imageEl.style.transform = "translate3d(0,0,0) scale(1)", p.slideEl.classList.remove(`${Z.zoomedSlideClass}`), p.slideEl = void 0, p.originX = 0, p.originY = 0, e.params.zoom.panOnMouseMove && (c = {
      x: 0,
      y: 0
    }, l && (l = !1, m.startX = 0, m.startY = 0)));
  }
  function J(U) {
    const Z = e.zoom;
    Z.scale && Z.scale !== 1 ? X() : Y(U);
  }
  function ee() {
    const U = e.params.passiveListeners ? {
      passive: !0,
      capture: !1
    } : !1, Z = e.params.passiveListeners ? {
      passive: !1,
      capture: !0
    } : !0;
    return {
      passiveListener: U,
      activeListenerWithCapture: Z
    };
  }
  function re() {
    const U = e.zoom;
    if (U.enabled) return;
    U.enabled = !0;
    const {
      passiveListener: Z,
      activeListenerWithCapture: Q
    } = ee();
    e.wrapperEl.addEventListener("pointerdown", D, Z), e.wrapperEl.addEventListener("pointermove", w, Q), ["pointerup", "pointercancel", "pointerout"].forEach((oe) => {
      e.wrapperEl.addEventListener(oe, A, Z);
    }), e.wrapperEl.addEventListener("pointermove", V, Q);
  }
  function pe() {
    const U = e.zoom;
    if (!U.enabled) return;
    U.enabled = !1;
    const {
      passiveListener: Z,
      activeListenerWithCapture: Q
    } = ee();
    e.wrapperEl.removeEventListener("pointerdown", D, Z), e.wrapperEl.removeEventListener("pointermove", w, Q), ["pointerup", "pointercancel", "pointerout"].forEach((oe) => {
      e.wrapperEl.removeEventListener(oe, A, Z);
    }), e.wrapperEl.removeEventListener("pointermove", V, Q);
  }
  t("init", () => {
    e.params.zoom.enabled && re();
  }), t("destroy", () => {
    pe();
  }), t("touchStart", (U, Z) => {
    e.zoom.enabled && M(Z);
  }), t("touchEnd", (U, Z) => {
    e.zoom.enabled && G();
  }), t("doubleTap", (U, Z) => {
    !e.animating && e.params.zoom.enabled && e.zoom.enabled && e.params.zoom.toggle && J(Z);
  }), t("transitionEnd", () => {
    e.zoom.enabled && e.params.zoom.enabled && L();
  }), t("slideChange", () => {
    e.zoom.enabled && e.params.zoom.enabled && e.params.cssMode && L();
  }), Object.assign(e.zoom, {
    enable: re,
    disable: pe,
    in: Y,
    out: X,
    toggle: J
  });
}
function e5(o) {
  let {
    swiper: e,
    extendParams: r,
    on: t
  } = o;
  r({
    controller: {
      control: void 0,
      inverse: !1,
      by: "slide"
      // or 'container'
    }
  }), e.controller = {
    control: void 0
  };
  function n(c, u) {
    const f = /* @__PURE__ */ function() {
      let m, y, h;
      return (F, b) => {
        for (y = -1, m = F.length; m - y > 1; )
          h = m + y >> 1, F[h] <= b ? y = h : m = h;
        return m;
      };
    }();
    this.x = c, this.y = u, this.lastIndex = c.length - 1;
    let g, d;
    return this.interpolate = function(m) {
      return m ? (d = f(this.x, m), g = d - 1, (m - this.x[g]) * (this.y[d] - this.y[g]) / (this.x[d] - this.x[g]) + this.y[g]) : 0;
    }, this;
  }
  function a(c) {
    e.controller.spline = e.params.loop ? new n(e.slidesGrid, c.slidesGrid) : new n(e.snapGrid, c.snapGrid);
  }
  function s(c, u) {
    const f = e.controller.control;
    let g, d;
    const p = e.constructor;
    function m(y) {
      if (y.destroyed) return;
      const h = e.rtlTranslate ? -e.translate : e.translate;
      e.params.controller.by === "slide" && (a(y), d = -e.controller.spline.interpolate(-h)), (!d || e.params.controller.by === "container") && (g = (y.maxTranslate() - y.minTranslate()) / (e.maxTranslate() - e.minTranslate()), (Number.isNaN(g) || !Number.isFinite(g)) && (g = 1), d = (h - e.minTranslate()) * g + y.minTranslate()), e.params.controller.inverse && (d = y.maxTranslate() - d), y.updateProgress(d), y.setTranslate(d, e), y.updateActiveIndex(), y.updateSlidesClasses();
    }
    if (Array.isArray(f))
      for (let y = 0; y < f.length; y += 1)
        f[y] !== u && f[y] instanceof p && m(f[y]);
    else f instanceof p && u !== f && m(f);
  }
  function i(c, u) {
    const f = e.constructor, g = e.controller.control;
    let d;
    function p(m) {
      m.destroyed || (m.setTransition(c, e), c !== 0 && (m.transitionStart(), m.params.autoHeight && mt(() => {
        m.updateAutoHeight();
      }), En(m.wrapperEl, () => {
        g && m.transitionEnd();
      })));
    }
    if (Array.isArray(g))
      for (d = 0; d < g.length; d += 1)
        g[d] !== u && g[d] instanceof f && p(g[d]);
    else g instanceof f && u !== g && p(g);
  }
  function l() {
    e.controller.control && e.controller.spline && (e.controller.spline = void 0, delete e.controller.spline);
  }
  t("beforeInit", () => {
    if (typeof window < "u" && // eslint-disable-line
    (typeof e.params.controller.control == "string" || e.params.controller.control instanceof HTMLElement)) {
      (typeof e.params.controller.control == "string" ? [...document.querySelectorAll(e.params.controller.control)] : [e.params.controller.control]).forEach((u) => {
        if (e.controller.control || (e.controller.control = []), u && u.swiper)
          e.controller.control.push(u.swiper);
        else if (u) {
          const f = `${e.params.eventsPrefix}init`, g = (d) => {
            e.controller.control.push(d.detail[0]), e.update(), u.removeEventListener(f, g);
          };
          u.addEventListener(f, g);
        }
      });
      return;
    }
    e.controller.control = e.params.controller.control;
  }), t("update", () => {
    l();
  }), t("resize", () => {
    l();
  }), t("observerUpdate", () => {
    l();
  }), t("setTranslate", (c, u, f) => {
    !e.controller.control || e.controller.control.destroyed || e.controller.setTranslate(u, f);
  }), t("setTransition", (c, u, f) => {
    !e.controller.control || e.controller.control.destroyed || e.controller.setTransition(u, f);
  }), Object.assign(e.controller, {
    setTranslate: s,
    setTransition: i
  });
}
function o5(o) {
  let {
    swiper: e,
    extendParams: r,
    on: t
  } = o;
  r({
    a11y: {
      enabled: !0,
      notificationClass: "swiper-notification",
      prevSlideMessage: "Previous slide",
      nextSlideMessage: "Next slide",
      firstSlideMessage: "This is the first slide",
      lastSlideMessage: "This is the last slide",
      paginationBulletMessage: "Go to slide {{index}}",
      slideLabelMessage: "{{index}} / {{slidesLength}}",
      containerMessage: null,
      containerRoleDescriptionMessage: null,
      containerRole: null,
      itemRoleDescriptionMessage: null,
      slideRole: "group",
      id: null,
      scrollOnFocus: !0
    }
  }), e.a11y = {
    clicked: !1
  };
  let n = null, a, s, i = (/* @__PURE__ */ new Date()).getTime();
  function l(L) {
    const W = n;
    W.length !== 0 && (W.innerHTML = "", W.innerHTML = L);
  }
  function c(L) {
    const W = () => Math.round(16 * Math.random()).toString(16);
    return "x".repeat(L).replace(/x/g, W);
  }
  function u(L) {
    L = be(L), L.forEach((W) => {
      W.setAttribute("tabIndex", "0");
    });
  }
  function f(L) {
    L = be(L), L.forEach((W) => {
      W.setAttribute("tabIndex", "-1");
    });
  }
  function g(L, W) {
    L = be(L), L.forEach((Y) => {
      Y.setAttribute("role", W);
    });
  }
  function d(L, W) {
    L = be(L), L.forEach((Y) => {
      Y.setAttribute("aria-roledescription", W);
    });
  }
  function p(L, W) {
    L = be(L), L.forEach((Y) => {
      Y.setAttribute("aria-controls", W);
    });
  }
  function m(L, W) {
    L = be(L), L.forEach((Y) => {
      Y.setAttribute("aria-label", W);
    });
  }
  function y(L, W) {
    L = be(L), L.forEach((Y) => {
      Y.setAttribute("id", W);
    });
  }
  function h(L, W) {
    L = be(L), L.forEach((Y) => {
      Y.setAttribute("aria-live", W);
    });
  }
  function F(L) {
    L = be(L), L.forEach((W) => {
      W.setAttribute("aria-disabled", !0);
    });
  }
  function b(L) {
    L = be(L), L.forEach((W) => {
      W.setAttribute("aria-disabled", !1);
    });
  }
  function v(L) {
    if (L.keyCode !== 13 && L.keyCode !== 32) return;
    const W = e.params.a11y, Y = L.target;
    if (!(e.pagination && e.pagination.el && (Y === e.pagination.el || e.pagination.el.contains(L.target)) && !L.target.matches(ur(e.params.pagination.bulletClass)))) {
      if (e.navigation && e.navigation.prevEl && e.navigation.nextEl) {
        const X = be(e.navigation.prevEl);
        be(e.navigation.nextEl).includes(Y) && (e.isEnd && !e.params.loop || e.slideNext(), e.isEnd ? l(W.lastSlideMessage) : l(W.nextSlideMessage)), X.includes(Y) && (e.isBeginning && !e.params.loop || e.slidePrev(), e.isBeginning ? l(W.firstSlideMessage) : l(W.prevSlideMessage));
      }
      e.pagination && Y.matches(ur(e.params.pagination.bulletClass)) && Y.click();
    }
  }
  function P() {
    if (e.params.loop || e.params.rewind || !e.navigation) return;
    const {
      nextEl: L,
      prevEl: W
    } = e.navigation;
    W && (e.isBeginning ? (F(W), f(W)) : (b(W), u(W))), L && (e.isEnd ? (F(L), f(L)) : (b(L), u(L)));
  }
  function E() {
    return e.pagination && e.pagination.bullets && e.pagination.bullets.length;
  }
  function S() {
    return E() && e.params.pagination.clickable;
  }
  function D() {
    const L = e.params.a11y;
    E() && e.pagination.bullets.forEach((W) => {
      e.params.pagination.clickable && (u(W), e.params.pagination.renderBullet || (g(W, "button"), m(W, L.paginationBulletMessage.replace(/\{\{index\}\}/, Da(W) + 1)))), W.matches(ur(e.params.pagination.bulletActiveClass)) ? W.setAttribute("aria-current", "true") : W.removeAttribute("aria-current");
    });
  }
  const w = (L, W, Y) => {
    u(L), L.tagName !== "BUTTON" && (g(L, "button"), L.addEventListener("keydown", v)), m(L, Y), p(L, W);
  }, A = (L) => {
    s && s !== L.target && !s.contains(L.target) && (a = !0), e.a11y.clicked = !0;
  }, C = () => {
    a = !1, requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        e.destroyed || (e.a11y.clicked = !1);
      });
    });
  }, x = (L) => {
    i = (/* @__PURE__ */ new Date()).getTime();
  }, T = (L) => {
    if (e.a11y.clicked || !e.params.a11y.scrollOnFocus || (/* @__PURE__ */ new Date()).getTime() - i < 100) return;
    const W = L.target.closest(`.${e.params.slideClass}, swiper-slide`);
    if (!W || !e.slides.includes(W)) return;
    s = W;
    const Y = e.slides.indexOf(W) === e.activeIndex, X = e.params.watchSlidesProgress && e.visibleSlides && e.visibleSlides.includes(W);
    Y || X || L.sourceCapabilities && L.sourceCapabilities.firesTouchEvents || (e.isHorizontal() ? e.el.scrollLeft = 0 : e.el.scrollTop = 0, requestAnimationFrame(() => {
      a || (e.params.loop ? e.slideToLoop(parseInt(W.getAttribute("data-swiper-slide-index")), 0) : e.slideTo(e.slides.indexOf(W), 0), a = !1);
    }));
  }, M = () => {
    const L = e.params.a11y;
    L.itemRoleDescriptionMessage && d(e.slides, L.itemRoleDescriptionMessage), L.slideRole && g(e.slides, L.slideRole);
    const W = e.slides.length;
    L.slideLabelMessage && e.slides.forEach((Y, X) => {
      const J = e.params.loop ? parseInt(Y.getAttribute("data-swiper-slide-index"), 10) : X, ee = L.slideLabelMessage.replace(/\{\{index\}\}/, J + 1).replace(/\{\{slidesLength\}\}/, W);
      m(Y, ee);
    });
  }, V = () => {
    const L = e.params.a11y;
    e.el.append(n);
    const W = e.el;
    L.containerRoleDescriptionMessage && d(W, L.containerRoleDescriptionMessage), L.containerMessage && m(W, L.containerMessage), L.containerRole && g(W, L.containerRole);
    const Y = e.wrapperEl, X = L.id || Y.getAttribute("id") || `swiper-wrapper-${c(16)}`, J = e.params.autoplay && e.params.autoplay.enabled ? "off" : "polite";
    y(Y, X), h(Y, J), M();
    let {
      nextEl: ee,
      prevEl: re
    } = e.navigation ? e.navigation : {};
    ee = be(ee), re = be(re), ee && ee.forEach((U) => w(U, X, L.nextSlideMessage)), re && re.forEach((U) => w(U, X, L.prevSlideMessage)), S() && be(e.pagination.el).forEach((Z) => {
      Z.addEventListener("keydown", v);
    }), Qe().addEventListener("visibilitychange", x), e.el.addEventListener("focus", T, !0), e.el.addEventListener("focus", T, !0), e.el.addEventListener("pointerdown", A, !0), e.el.addEventListener("pointerup", C, !0);
  };
  function G() {
    n && n.remove();
    let {
      nextEl: L,
      prevEl: W
    } = e.navigation ? e.navigation : {};
    L = be(L), W = be(W), L && L.forEach((X) => X.removeEventListener("keydown", v)), W && W.forEach((X) => X.removeEventListener("keydown", v)), S() && be(e.pagination.el).forEach((J) => {
      J.removeEventListener("keydown", v);
    }), Qe().removeEventListener("visibilitychange", x), e.el && typeof e.el != "string" && (e.el.removeEventListener("focus", T, !0), e.el.removeEventListener("pointerdown", A, !0), e.el.removeEventListener("pointerup", C, !0));
  }
  t("beforeInit", () => {
    n = Ao("span", e.params.a11y.notificationClass), n.setAttribute("aria-live", "assertive"), n.setAttribute("aria-atomic", "true");
  }), t("afterInit", () => {
    e.params.a11y.enabled && V();
  }), t("slidesLengthChange snapGridLengthChange slidesGridLengthChange", () => {
    e.params.a11y.enabled && M();
  }), t("fromEdge toEdge afterInit lock unlock", () => {
    e.params.a11y.enabled && P();
  }), t("paginationUpdate", () => {
    e.params.a11y.enabled && D();
  }), t("destroy", () => {
    e.params.a11y.enabled && G();
  });
}
function r5(o) {
  let {
    swiper: e,
    extendParams: r,
    on: t
  } = o;
  r({
    history: {
      enabled: !1,
      root: "",
      replaceState: !1,
      key: "slides",
      keepQuery: !1
    }
  });
  let n = !1, a = {};
  const s = (d) => d.toString().replace(/\s+/g, "-").replace(/[^\w-]+/g, "").replace(/--+/g, "-").replace(/^-+/, "").replace(/-+$/, ""), i = (d) => {
    const p = Ne();
    let m;
    d ? m = new URL(d) : m = p.location;
    const y = m.pathname.slice(1).split("/").filter((v) => v !== ""), h = y.length, F = y[h - 2], b = y[h - 1];
    return {
      key: F,
      value: b
    };
  }, l = (d, p) => {
    const m = Ne();
    if (!n || !e.params.history.enabled) return;
    let y;
    e.params.url ? y = new URL(e.params.url) : y = m.location;
    const h = e.virtual && e.params.virtual.enabled ? e.slidesEl.querySelector(`[data-swiper-slide-index="${p}"]`) : e.slides[p];
    let F = s(h.getAttribute("data-history"));
    if (e.params.history.root.length > 0) {
      let v = e.params.history.root;
      v[v.length - 1] === "/" && (v = v.slice(0, v.length - 1)), F = `${v}/${d ? `${d}/` : ""}${F}`;
    } else y.pathname.includes(d) || (F = `${d ? `${d}/` : ""}${F}`);
    e.params.history.keepQuery && (F += y.search);
    const b = m.history.state;
    b && b.value === F || (e.params.history.replaceState ? m.history.replaceState({
      value: F
    }, null, F) : m.history.pushState({
      value: F
    }, null, F));
  }, c = (d, p, m) => {
    if (p)
      for (let y = 0, h = e.slides.length; y < h; y += 1) {
        const F = e.slides[y];
        if (s(F.getAttribute("data-history")) === p) {
          const v = e.getSlideIndex(F);
          e.slideTo(v, d, m);
        }
      }
    else
      e.slideTo(0, d, m);
  }, u = () => {
    a = i(e.params.url), c(e.params.speed, a.value, !1);
  }, f = () => {
    const d = Ne();
    if (e.params.history) {
      if (!d.history || !d.history.pushState) {
        e.params.history.enabled = !1, e.params.hashNavigation.enabled = !0;
        return;
      }
      if (n = !0, a = i(e.params.url), !a.key && !a.value) {
        e.params.history.replaceState || d.addEventListener("popstate", u);
        return;
      }
      c(0, a.value, e.params.runCallbacksOnInit), e.params.history.replaceState || d.addEventListener("popstate", u);
    }
  }, g = () => {
    const d = Ne();
    e.params.history.replaceState || d.removeEventListener("popstate", u);
  };
  t("init", () => {
    e.params.history.enabled && f();
  }), t("destroy", () => {
    e.params.history.enabled && g();
  }), t("transitionEnd _freeModeNoMomentumRelease", () => {
    n && l(e.params.history.key, e.activeIndex);
  }), t("slideChange", () => {
    n && e.params.cssMode && l(e.params.history.key, e.activeIndex);
  });
}
function t5(o) {
  let {
    swiper: e,
    extendParams: r,
    emit: t,
    on: n
  } = o, a = !1;
  const s = Qe(), i = Ne();
  r({
    hashNavigation: {
      enabled: !1,
      replaceState: !1,
      watchState: !1,
      getSlideIndex(g, d) {
        if (e.virtual && e.params.virtual.enabled) {
          const p = e.slides.find((y) => y.getAttribute("data-hash") === d);
          return p ? parseInt(p.getAttribute("data-swiper-slide-index"), 10) : 0;
        }
        return e.getSlideIndex($e(e.slidesEl, `.${e.params.slideClass}[data-hash="${d}"], swiper-slide[data-hash="${d}"]`)[0]);
      }
    }
  });
  const l = () => {
    t("hashChange");
    const g = s.location.hash.replace("#", ""), d = e.virtual && e.params.virtual.enabled ? e.slidesEl.querySelector(`[data-swiper-slide-index="${e.activeIndex}"]`) : e.slides[e.activeIndex], p = d ? d.getAttribute("data-hash") : "";
    if (g !== p) {
      const m = e.params.hashNavigation.getSlideIndex(e, g);
      if (typeof m > "u" || Number.isNaN(m)) return;
      e.slideTo(m);
    }
  }, c = () => {
    if (!a || !e.params.hashNavigation.enabled) return;
    const g = e.virtual && e.params.virtual.enabled ? e.slidesEl.querySelector(`[data-swiper-slide-index="${e.activeIndex}"]`) : e.slides[e.activeIndex], d = g ? g.getAttribute("data-hash") || g.getAttribute("data-history") : "";
    e.params.hashNavigation.replaceState && i.history && i.history.replaceState ? (i.history.replaceState(null, null, `#${d}` || ""), t("hashSet")) : (s.location.hash = d || "", t("hashSet"));
  }, u = () => {
    if (!e.params.hashNavigation.enabled || e.params.history && e.params.history.enabled) return;
    a = !0;
    const g = s.location.hash.replace("#", "");
    if (g) {
      const p = e.params.hashNavigation.getSlideIndex(e, g);
      e.slideTo(p || 0, 0, e.params.runCallbacksOnInit, !0);
    }
    e.params.hashNavigation.watchState && i.addEventListener("hashchange", l);
  }, f = () => {
    e.params.hashNavigation.watchState && i.removeEventListener("hashchange", l);
  };
  n("init", () => {
    e.params.hashNavigation.enabled && u();
  }), n("destroy", () => {
    e.params.hashNavigation.enabled && f();
  }), n("transitionEnd _freeModeNoMomentumRelease", () => {
    a && c();
  }), n("slideChange", () => {
    a && e.params.cssMode && c();
  });
}
function n5(o) {
  let {
    swiper: e,
    extendParams: r,
    on: t,
    emit: n,
    params: a
  } = o;
  e.autoplay = {
    running: !1,
    paused: !1,
    timeLeft: 0
  }, r({
    autoplay: {
      enabled: !1,
      delay: 3e3,
      waitForTransition: !0,
      disableOnInteraction: !1,
      stopOnLastSlide: !1,
      reverseDirection: !1,
      pauseOnMouseEnter: !1
    }
  });
  let s, i, l = a && a.autoplay ? a.autoplay.delay : 3e3, c = a && a.autoplay ? a.autoplay.delay : 3e3, u, f = (/* @__PURE__ */ new Date()).getTime(), g, d, p, m, y, h, F;
  function b(W) {
    !e || e.destroyed || !e.wrapperEl || W.target === e.wrapperEl && (e.wrapperEl.removeEventListener("transitionend", b), !(F || W.detail && W.detail.bySwiperTouchMove) && A());
  }
  const v = () => {
    if (e.destroyed || !e.autoplay.running) return;
    e.autoplay.paused ? g = !0 : g && (c = u, g = !1);
    const W = e.autoplay.paused ? u : f + c - (/* @__PURE__ */ new Date()).getTime();
    e.autoplay.timeLeft = W, n("autoplayTimeLeft", W, W / l), i = requestAnimationFrame(() => {
      v();
    });
  }, P = () => {
    let W;
    return e.virtual && e.params.virtual.enabled ? W = e.slides.find((X) => X.classList.contains("swiper-slide-active")) : W = e.slides[e.activeIndex], W ? parseInt(W.getAttribute("data-swiper-autoplay"), 10) : void 0;
  }, E = (W) => {
    if (e.destroyed || !e.autoplay.running) return;
    cancelAnimationFrame(i), v();
    let Y = typeof W > "u" ? e.params.autoplay.delay : W;
    l = e.params.autoplay.delay, c = e.params.autoplay.delay;
    const X = P();
    !Number.isNaN(X) && X > 0 && typeof W > "u" && (Y = X, l = X, c = X), u = Y;
    const J = e.params.speed, ee = () => {
      !e || e.destroyed || (e.params.autoplay.reverseDirection ? !e.isBeginning || e.params.loop || e.params.rewind ? (e.slidePrev(J, !0, !0), n("autoplay")) : e.params.autoplay.stopOnLastSlide || (e.slideTo(e.slides.length - 1, J, !0, !0), n("autoplay")) : !e.isEnd || e.params.loop || e.params.rewind ? (e.slideNext(J, !0, !0), n("autoplay")) : e.params.autoplay.stopOnLastSlide || (e.slideTo(0, J, !0, !0), n("autoplay")), e.params.cssMode && (f = (/* @__PURE__ */ new Date()).getTime(), requestAnimationFrame(() => {
        E();
      })));
    };
    return Y > 0 ? (clearTimeout(s), s = setTimeout(() => {
      ee();
    }, Y)) : requestAnimationFrame(() => {
      ee();
    }), Y;
  }, S = () => {
    f = (/* @__PURE__ */ new Date()).getTime(), e.autoplay.running = !0, E(), n("autoplayStart");
  }, D = () => {
    e.autoplay.running = !1, clearTimeout(s), cancelAnimationFrame(i), n("autoplayStop");
  }, w = (W, Y) => {
    if (e.destroyed || !e.autoplay.running) return;
    clearTimeout(s), W || (h = !0);
    const X = () => {
      n("autoplayPause"), e.params.autoplay.waitForTransition ? e.wrapperEl.addEventListener("transitionend", b) : A();
    };
    if (e.autoplay.paused = !0, Y) {
      y && (u = e.params.autoplay.delay), y = !1, X();
      return;
    }
    u = (u || e.params.autoplay.delay) - ((/* @__PURE__ */ new Date()).getTime() - f), !(e.isEnd && u < 0 && !e.params.loop) && (u < 0 && (u = 0), X());
  }, A = () => {
    e.isEnd && u < 0 && !e.params.loop || e.destroyed || !e.autoplay.running || (f = (/* @__PURE__ */ new Date()).getTime(), h ? (h = !1, E(u)) : E(), e.autoplay.paused = !1, n("autoplayResume"));
  }, C = () => {
    if (e.destroyed || !e.autoplay.running) return;
    const W = Qe();
    W.visibilityState === "hidden" && (h = !0, w(!0)), W.visibilityState === "visible" && A();
  }, x = (W) => {
    W.pointerType === "mouse" && (h = !0, F = !0, !(e.animating || e.autoplay.paused) && w(!0));
  }, T = (W) => {
    W.pointerType === "mouse" && (F = !1, e.autoplay.paused && A());
  }, M = () => {
    e.params.autoplay.pauseOnMouseEnter && (e.el.addEventListener("pointerenter", x), e.el.addEventListener("pointerleave", T));
  }, V = () => {
    e.el && typeof e.el != "string" && (e.el.removeEventListener("pointerenter", x), e.el.removeEventListener("pointerleave", T));
  }, G = () => {
    Qe().addEventListener("visibilitychange", C);
  }, L = () => {
    Qe().removeEventListener("visibilitychange", C);
  };
  t("init", () => {
    e.params.autoplay.enabled && (M(), G(), S());
  }), t("destroy", () => {
    V(), L(), e.autoplay.running && D();
  }), t("_freeModeStaticRelease", () => {
    (p || h) && A();
  }), t("_freeModeNoMomentumRelease", () => {
    e.params.autoplay.disableOnInteraction ? D() : w(!0, !0);
  }), t("beforeTransitionStart", (W, Y, X) => {
    e.destroyed || !e.autoplay.running || (X || !e.params.autoplay.disableOnInteraction ? w(!0, !0) : D());
  }), t("sliderFirstMove", () => {
    if (!(e.destroyed || !e.autoplay.running)) {
      if (e.params.autoplay.disableOnInteraction) {
        D();
        return;
      }
      d = !0, p = !1, h = !1, m = setTimeout(() => {
        h = !0, p = !0, w(!0);
      }, 200);
    }
  }), t("touchEnd", () => {
    if (!(e.destroyed || !e.autoplay.running || !d)) {
      if (clearTimeout(m), clearTimeout(s), e.params.autoplay.disableOnInteraction) {
        p = !1, d = !1;
        return;
      }
      p && e.params.cssMode && A(), p = !1, d = !1;
    }
  }), t("slideChange", () => {
    e.destroyed || !e.autoplay.running || (y = !0);
  }), Object.assign(e.autoplay, {
    start: S,
    stop: D,
    pause: w,
    resume: A
  });
}
function a5(o) {
  let {
    swiper: e,
    extendParams: r,
    on: t
  } = o;
  r({
    thumbs: {
      swiper: null,
      multipleActiveThumbs: !0,
      autoScrollOffset: 0,
      slideThumbActiveClass: "swiper-slide-thumb-active",
      thumbsContainerClass: "swiper-thumbs"
    }
  });
  let n = !1, a = !1;
  e.thumbs = {
    swiper: null
  };
  function s() {
    const c = e.thumbs.swiper;
    if (!c || c.destroyed) return;
    const u = c.clickedIndex, f = c.clickedSlide;
    if (f && f.classList.contains(e.params.thumbs.slideThumbActiveClass) || typeof u > "u" || u === null) return;
    let g;
    c.params.loop ? g = parseInt(c.clickedSlide.getAttribute("data-swiper-slide-index"), 10) : g = u, e.params.loop ? e.slideToLoop(g) : e.slideTo(g);
  }
  function i() {
    const {
      thumbs: c
    } = e.params;
    if (n) return !1;
    n = !0;
    const u = e.constructor;
    if (c.swiper instanceof u) {
      if (c.swiper.destroyed)
        return n = !1, !1;
      e.thumbs.swiper = c.swiper, Object.assign(e.thumbs.swiper.originalParams, {
        watchSlidesProgress: !0,
        slideToClickedSlide: !1
      }), Object.assign(e.thumbs.swiper.params, {
        watchSlidesProgress: !0,
        slideToClickedSlide: !1
      }), e.thumbs.swiper.update();
    } else if (vn(c.swiper)) {
      const f = Object.assign({}, c.swiper);
      Object.assign(f, {
        watchSlidesProgress: !0,
        slideToClickedSlide: !1
      }), e.thumbs.swiper = new u(f), a = !0;
    }
    return e.thumbs.swiper.el.classList.add(e.params.thumbs.thumbsContainerClass), e.thumbs.swiper.on("tap", s), !0;
  }
  function l(c) {
    const u = e.thumbs.swiper;
    if (!u || u.destroyed) return;
    const f = u.params.slidesPerView === "auto" ? u.slidesPerViewDynamic() : u.params.slidesPerView;
    let g = 1;
    const d = e.params.thumbs.slideThumbActiveClass;
    if (e.params.slidesPerView > 1 && !e.params.centeredSlides && (g = e.params.slidesPerView), e.params.thumbs.multipleActiveThumbs || (g = 1), g = Math.floor(g), u.slides.forEach((y) => y.classList.remove(d)), u.params.loop || u.params.virtual && u.params.virtual.enabled)
      for (let y = 0; y < g; y += 1)
        $e(u.slidesEl, `[data-swiper-slide-index="${e.realIndex + y}"]`).forEach((h) => {
          h.classList.add(d);
        });
    else
      for (let y = 0; y < g; y += 1)
        u.slides[e.realIndex + y] && u.slides[e.realIndex + y].classList.add(d);
    const p = e.params.thumbs.autoScrollOffset, m = p && !u.params.loop;
    if (e.realIndex !== u.realIndex || m) {
      const y = u.activeIndex;
      let h, F;
      if (u.params.loop) {
        const b = u.slides.find((v) => v.getAttribute("data-swiper-slide-index") === `${e.realIndex}`);
        h = u.slides.indexOf(b), F = e.activeIndex > e.previousIndex ? "next" : "prev";
      } else
        h = e.realIndex, F = h > e.previousIndex ? "next" : "prev";
      m && (h += F === "next" ? p : -1 * p), u.visibleSlidesIndexes && u.visibleSlidesIndexes.indexOf(h) < 0 && (u.params.centeredSlides ? h > y ? h = h - Math.floor(f / 2) + 1 : h = h + Math.floor(f / 2) - 1 : h > y && u.params.slidesPerGroup, u.slideTo(h, c ? 0 : void 0));
    }
  }
  t("beforeInit", () => {
    const {
      thumbs: c
    } = e.params;
    if (!(!c || !c.swiper))
      if (typeof c.swiper == "string" || c.swiper instanceof HTMLElement) {
        const u = Qe(), f = () => {
          const d = typeof c.swiper == "string" ? u.querySelector(c.swiper) : c.swiper;
          if (d && d.swiper)
            c.swiper = d.swiper, i(), l(!0);
          else if (d) {
            const p = `${e.params.eventsPrefix}init`, m = (y) => {
              c.swiper = y.detail[0], d.removeEventListener(p, m), i(), l(!0), c.swiper.update(), e.update();
            };
            d.addEventListener(p, m);
          }
          return d;
        }, g = () => {
          if (e.destroyed) return;
          f() || requestAnimationFrame(g);
        };
        requestAnimationFrame(g);
      } else
        i(), l(!0);
  }), t("slideChange update resize observerUpdate", () => {
    l();
  }), t("setTransition", (c, u) => {
    const f = e.thumbs.swiper;
    !f || f.destroyed || f.setTransition(u);
  }), t("beforeDestroy", () => {
    const c = e.thumbs.swiper;
    !c || c.destroyed || a && c.destroy();
  }), Object.assign(e.thumbs, {
    init: i,
    update: l
  });
}
function s5(o) {
  let {
    swiper: e,
    extendParams: r,
    emit: t,
    once: n
  } = o;
  r({
    freeMode: {
      enabled: !1,
      momentum: !0,
      momentumRatio: 1,
      momentumBounce: !0,
      momentumBounceRatio: 1,
      momentumVelocityRatio: 1,
      sticky: !1,
      minimumVelocity: 0.02
    }
  });
  function a() {
    if (e.params.cssMode) return;
    const l = e.getTranslate();
    e.setTranslate(l), e.setTransition(0), e.touchEventsData.velocities.length = 0, e.freeMode.onTouchEnd({
      currentPos: e.rtl ? e.translate : -e.translate
    });
  }
  function s() {
    if (e.params.cssMode) return;
    const {
      touchEventsData: l,
      touches: c
    } = e;
    l.velocities.length === 0 && l.velocities.push({
      position: c[e.isHorizontal() ? "startX" : "startY"],
      time: l.touchStartTime
    }), l.velocities.push({
      position: c[e.isHorizontal() ? "currentX" : "currentY"],
      time: No()
    });
  }
  function i(l) {
    let {
      currentPos: c
    } = l;
    if (e.params.cssMode) return;
    const {
      params: u,
      wrapperEl: f,
      rtlTranslate: g,
      snapGrid: d,
      touchEventsData: p
    } = e, y = No() - p.touchStartTime;
    if (c < -e.minTranslate()) {
      e.slideTo(e.activeIndex);
      return;
    }
    if (c > -e.maxTranslate()) {
      e.slides.length < d.length ? e.slideTo(d.length - 1) : e.slideTo(e.slides.length - 1);
      return;
    }
    if (u.freeMode.momentum) {
      if (p.velocities.length > 1) {
        const D = p.velocities.pop(), w = p.velocities.pop(), A = D.position - w.position, C = D.time - w.time;
        e.velocity = A / C, e.velocity /= 2, Math.abs(e.velocity) < u.freeMode.minimumVelocity && (e.velocity = 0), (C > 150 || No() - D.time > 300) && (e.velocity = 0);
      } else
        e.velocity = 0;
      e.velocity *= u.freeMode.momentumVelocityRatio, p.velocities.length = 0;
      let h = 1e3 * u.freeMode.momentumRatio;
      const F = e.velocity * h;
      let b = e.translate + F;
      g && (b = -b);
      let v = !1, P;
      const E = Math.abs(e.velocity) * 20 * u.freeMode.momentumBounceRatio;
      let S;
      if (b < e.maxTranslate())
        u.freeMode.momentumBounce ? (b + e.maxTranslate() < -E && (b = e.maxTranslate() - E), P = e.maxTranslate(), v = !0, p.allowMomentumBounce = !0) : b = e.maxTranslate(), u.loop && u.centeredSlides && (S = !0);
      else if (b > e.minTranslate())
        u.freeMode.momentumBounce ? (b - e.minTranslate() > E && (b = e.minTranslate() + E), P = e.minTranslate(), v = !0, p.allowMomentumBounce = !0) : b = e.minTranslate(), u.loop && u.centeredSlides && (S = !0);
      else if (u.freeMode.sticky) {
        let D;
        for (let w = 0; w < d.length; w += 1)
          if (d[w] > -b) {
            D = w;
            break;
          }
        Math.abs(d[D] - b) < Math.abs(d[D - 1] - b) || e.swipeDirection === "next" ? b = d[D] : b = d[D - 1], b = -b;
      }
      if (S && n("transitionEnd", () => {
        e.loopFix();
      }), e.velocity !== 0) {
        if (g ? h = Math.abs((-b - e.translate) / e.velocity) : h = Math.abs((b - e.translate) / e.velocity), u.freeMode.sticky) {
          const D = Math.abs((g ? -b : b) - e.translate), w = e.slidesSizesGrid[e.activeIndex];
          D < w ? h = u.speed : D < 2 * w ? h = u.speed * 1.5 : h = u.speed * 2.5;
        }
      } else if (u.freeMode.sticky) {
        e.slideToClosest();
        return;
      }
      u.freeMode.momentumBounce && v ? (e.updateProgress(P), e.setTransition(h), e.setTranslate(b), e.transitionStart(!0, e.swipeDirection), e.animating = !0, En(f, () => {
        !e || e.destroyed || !p.allowMomentumBounce || (t("momentumBounce"), e.setTransition(u.speed), setTimeout(() => {
          e.setTranslate(P), En(f, () => {
            !e || e.destroyed || e.transitionEnd();
          });
        }, 0));
      })) : e.velocity ? (t("_freeModeNoMomentumRelease"), e.updateProgress(b), e.setTransition(h), e.setTranslate(b), e.transitionStart(!0, e.swipeDirection), e.animating || (e.animating = !0, En(f, () => {
        !e || e.destroyed || e.transitionEnd();
      }))) : e.updateProgress(b), e.updateActiveIndex(), e.updateSlidesClasses();
    } else if (u.freeMode.sticky) {
      e.slideToClosest();
      return;
    } else u.freeMode && t("_freeModeNoMomentumRelease");
    (!u.freeMode.momentum || y >= u.longSwipesMs) && (t("_freeModeStaticRelease"), e.updateProgress(), e.updateActiveIndex(), e.updateSlidesClasses());
  }
  Object.assign(e, {
    freeMode: {
      onTouchStart: a,
      onTouchMove: s,
      onTouchEnd: i
    }
  });
}
function i5(o) {
  let {
    swiper: e,
    extendParams: r,
    on: t
  } = o;
  r({
    grid: {
      rows: 1,
      fill: "column"
    }
  });
  let n, a, s, i;
  const l = () => {
    let m = e.params.spaceBetween;
    return typeof m == "string" && m.indexOf("%") >= 0 ? m = parseFloat(m.replace("%", "")) / 100 * e.size : typeof m == "string" && (m = parseFloat(m)), m;
  }, c = (m) => {
    const {
      slidesPerView: y
    } = e.params, {
      rows: h,
      fill: F
    } = e.params.grid, b = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : m.length;
    s = Math.floor(b / h), Math.floor(b / h) === b / h ? n = b : n = Math.ceil(b / h) * h, y !== "auto" && F === "row" && (n = Math.max(n, y * h)), a = n / h;
  }, u = () => {
    e.slides && e.slides.forEach((m) => {
      m.swiperSlideGridSet && (m.style.height = "", m.style[e.getDirectionLabel("margin-top")] = "");
    });
  }, f = (m, y, h) => {
    const {
      slidesPerGroup: F
    } = e.params, b = l(), {
      rows: v,
      fill: P
    } = e.params.grid, E = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : h.length;
    let S, D, w;
    if (P === "row" && F > 1) {
      const A = Math.floor(m / (F * v)), C = m - v * F * A, x = A === 0 ? F : Math.min(Math.ceil((E - A * v * F) / v), F);
      w = Math.floor(C / x), D = C - w * x + A * F, S = D + w * n / v, y.style.order = S;
    } else P === "column" ? (D = Math.floor(m / v), w = m - D * v, (D > s || D === s && w === v - 1) && (w += 1, w >= v && (w = 0, D += 1))) : (w = Math.floor(m / a), D = m - w * a);
    y.row = w, y.column = D, y.style.height = `calc((100% - ${(v - 1) * b}px) / ${v})`, y.style[e.getDirectionLabel("margin-top")] = w !== 0 ? b && `${b}px` : "", y.swiperSlideGridSet = !0;
  }, g = (m, y) => {
    const {
      centeredSlides: h,
      roundLengths: F
    } = e.params, b = l(), {
      rows: v
    } = e.params.grid;
    if (e.virtualSize = (m + b) * n, e.virtualSize = Math.ceil(e.virtualSize / v) - b, e.params.cssMode || (e.wrapperEl.style[e.getDirectionLabel("width")] = `${e.virtualSize + b}px`), h) {
      const P = [];
      for (let E = 0; E < y.length; E += 1) {
        let S = y[E];
        F && (S = Math.floor(S)), y[E] < e.virtualSize + y[0] && P.push(S);
      }
      y.splice(0, y.length), y.push(...P);
    }
  }, d = () => {
    i = e.params.grid && e.params.grid.rows > 1;
  }, p = () => {
    const {
      params: m,
      el: y
    } = e, h = m.grid && m.grid.rows > 1;
    i && !h ? (y.classList.remove(`${m.containerModifierClass}grid`, `${m.containerModifierClass}grid-column`), s = 1, e.emitContainerClasses()) : !i && h && (y.classList.add(`${m.containerModifierClass}grid`), m.grid.fill === "column" && y.classList.add(`${m.containerModifierClass}grid-column`), e.emitContainerClasses()), i = h;
  };
  t("init", d), t("update", p), e.grid = {
    initSlides: c,
    unsetSlides: u,
    updateSlide: f,
    updateWrapperSize: g
  };
}
function l5(o) {
  const e = this, {
    params: r,
    slidesEl: t
  } = e;
  r.loop && e.loopDestroy();
  const n = (a) => {
    if (typeof a == "string") {
      const s = document.createElement("div");
      s.innerHTML = a, t.append(s.children[0]), s.innerHTML = "";
    } else
      t.append(a);
  };
  if (typeof o == "object" && "length" in o)
    for (let a = 0; a < o.length; a += 1)
      o[a] && n(o[a]);
  else
    n(o);
  e.recalcSlides(), r.loop && e.loopCreate(), (!r.observer || e.isElement) && e.update();
}
function c5(o) {
  const e = this, {
    params: r,
    activeIndex: t,
    slidesEl: n
  } = e;
  r.loop && e.loopDestroy();
  let a = t + 1;
  const s = (i) => {
    if (typeof i == "string") {
      const l = document.createElement("div");
      l.innerHTML = i, n.prepend(l.children[0]), l.innerHTML = "";
    } else
      n.prepend(i);
  };
  if (typeof o == "object" && "length" in o) {
    for (let i = 0; i < o.length; i += 1)
      o[i] && s(o[i]);
    a = t + o.length;
  } else
    s(o);
  e.recalcSlides(), r.loop && e.loopCreate(), (!r.observer || e.isElement) && e.update(), e.slideTo(a, 0, !1);
}
function u5(o, e) {
  const r = this, {
    params: t,
    activeIndex: n,
    slidesEl: a
  } = r;
  let s = n;
  t.loop && (s -= r.loopedSlides, r.loopDestroy(), r.recalcSlides());
  const i = r.slides.length;
  if (o <= 0) {
    r.prependSlide(e);
    return;
  }
  if (o >= i) {
    r.appendSlide(e);
    return;
  }
  let l = s > o ? s + 1 : s;
  const c = [];
  for (let u = i - 1; u >= o; u -= 1) {
    const f = r.slides[u];
    f.remove(), c.unshift(f);
  }
  if (typeof e == "object" && "length" in e) {
    for (let u = 0; u < e.length; u += 1)
      e[u] && a.append(e[u]);
    l = s > o ? s + e.length : s;
  } else
    a.append(e);
  for (let u = 0; u < c.length; u += 1)
    a.append(c[u]);
  r.recalcSlides(), t.loop && r.loopCreate(), (!t.observer || r.isElement) && r.update(), t.loop ? r.slideTo(l + r.loopedSlides, 0, !1) : r.slideTo(l, 0, !1);
}
function p5(o) {
  const e = this, {
    params: r,
    activeIndex: t
  } = e;
  let n = t;
  r.loop && (n -= e.loopedSlides, e.loopDestroy());
  let a = n, s;
  if (typeof o == "object" && "length" in o) {
    for (let i = 0; i < o.length; i += 1)
      s = o[i], e.slides[s] && e.slides[s].remove(), s < a && (a -= 1);
    a = Math.max(a, 0);
  } else
    s = o, e.slides[s] && e.slides[s].remove(), s < a && (a -= 1), a = Math.max(a, 0);
  e.recalcSlides(), r.loop && e.loopCreate(), (!r.observer || e.isElement) && e.update(), r.loop ? e.slideTo(a + e.loopedSlides, 0, !1) : e.slideTo(a, 0, !1);
}
function d5() {
  const o = this, e = [];
  for (let r = 0; r < o.slides.length; r += 1)
    e.push(r);
  o.removeSlide(e);
}
function g5(o) {
  let {
    swiper: e
  } = o;
  Object.assign(e, {
    appendSlide: l5.bind(e),
    prependSlide: c5.bind(e),
    addSlide: u5.bind(e),
    removeSlide: p5.bind(e),
    removeAllSlides: d5.bind(e)
  });
}
function tn(o) {
  const {
    effect: e,
    swiper: r,
    on: t,
    setTranslate: n,
    setTransition: a,
    overwriteParams: s,
    perspective: i,
    recreateShadows: l,
    getEffectParams: c
  } = o;
  t("beforeInit", () => {
    if (r.params.effect !== e) return;
    r.classNames.push(`${r.params.containerModifierClass}${e}`), i && i() && r.classNames.push(`${r.params.containerModifierClass}3d`);
    const f = s ? s() : {};
    Object.assign(r.params, f), Object.assign(r.originalParams, f);
  }), t("setTranslate", () => {
    r.params.effect === e && n();
  }), t("setTransition", (f, g) => {
    r.params.effect === e && a(g);
  }), t("transitionEnd", () => {
    if (r.params.effect === e && l) {
      if (!c || !c().slideShadows) return;
      r.slides.forEach((f) => {
        f.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((g) => g.remove());
      }), l();
    }
  });
  let u;
  t("virtualUpdate", () => {
    r.params.effect === e && (r.slides.length || (u = !0), requestAnimationFrame(() => {
      u && r.slides && r.slides.length && (n(), u = !1);
    }));
  });
}
function Ka(o, e) {
  const r = ht(e);
  return r !== e && (r.style.backfaceVisibility = "hidden", r.style["-webkit-backface-visibility"] = "hidden"), r;
}
function Mi(o) {
  let {
    swiper: e,
    duration: r,
    transformElements: t,
    allSlides: n
  } = o;
  const {
    activeIndex: a
  } = e, s = (i) => i.parentElement ? i.parentElement : e.slides.find((c) => c.shadowRoot && c.shadowRoot === i.parentNode);
  if (e.params.virtualTranslate && r !== 0) {
    let i = !1, l;
    n ? l = t : l = t.filter((c) => {
      const u = c.classList.contains("swiper-slide-transform") ? s(c) : c;
      return e.getSlideIndex(u) === a;
    }), l.forEach((c) => {
      En(c, () => {
        if (i || !e || e.destroyed) return;
        i = !0, e.animating = !1;
        const u = new window.CustomEvent("transitionend", {
          bubbles: !0,
          cancelable: !0
        });
        e.wrapperEl.dispatchEvent(u);
      });
    });
  }
}
function m5(o) {
  let {
    swiper: e,
    extendParams: r,
    on: t
  } = o;
  r({
    fadeEffect: {
      crossFade: !1
    }
  }), tn({
    effect: "fade",
    swiper: e,
    on: t,
    setTranslate: () => {
      const {
        slides: s
      } = e, i = e.params.fadeEffect;
      for (let l = 0; l < s.length; l += 1) {
        const c = e.slides[l];
        let f = -c.swiperSlideOffset;
        e.params.virtualTranslate || (f -= e.translate);
        let g = 0;
        e.isHorizontal() || (g = f, f = 0);
        const d = e.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(c.progress), 0) : 1 + Math.min(Math.max(c.progress, -1), 0), p = Ka(i, c);
        p.style.opacity = d, p.style.transform = `translate3d(${f}px, ${g}px, 0px)`;
      }
    },
    setTransition: (s) => {
      const i = e.slides.map((l) => ht(l));
      i.forEach((l) => {
        l.style.transitionDuration = `${s}ms`;
      }), Mi({
        swiper: e,
        duration: s,
        transformElements: i,
        allSlides: !0
      });
    },
    overwriteParams: () => ({
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchSlidesProgress: !0,
      spaceBetween: 0,
      virtualTranslate: !e.params.cssMode
    })
  });
}
function f5(o) {
  let {
    swiper: e,
    extendParams: r,
    on: t
  } = o;
  r({
    cubeEffect: {
      slideShadows: !0,
      shadow: !0,
      shadowOffset: 20,
      shadowScale: 0.94
    }
  });
  const n = (l, c, u) => {
    let f = u ? l.querySelector(".swiper-slide-shadow-left") : l.querySelector(".swiper-slide-shadow-top"), g = u ? l.querySelector(".swiper-slide-shadow-right") : l.querySelector(".swiper-slide-shadow-bottom");
    f || (f = Ao("div", `swiper-slide-shadow-cube swiper-slide-shadow-${u ? "left" : "top"}`.split(" ")), l.append(f)), g || (g = Ao("div", `swiper-slide-shadow-cube swiper-slide-shadow-${u ? "right" : "bottom"}`.split(" ")), l.append(g)), f && (f.style.opacity = Math.max(-c, 0)), g && (g.style.opacity = Math.max(c, 0));
  };
  tn({
    effect: "cube",
    swiper: e,
    on: t,
    setTranslate: () => {
      const {
        el: l,
        wrapperEl: c,
        slides: u,
        width: f,
        height: g,
        rtlTranslate: d,
        size: p,
        browser: m
      } = e, y = ji(e), h = e.params.cubeEffect, F = e.isHorizontal(), b = e.virtual && e.params.virtual.enabled;
      let v = 0, P;
      h.shadow && (F ? (P = e.wrapperEl.querySelector(".swiper-cube-shadow"), P || (P = Ao("div", "swiper-cube-shadow"), e.wrapperEl.append(P)), P.style.height = `${f}px`) : (P = l.querySelector(".swiper-cube-shadow"), P || (P = Ao("div", "swiper-cube-shadow"), l.append(P))));
      for (let S = 0; S < u.length; S += 1) {
        const D = u[S];
        let w = S;
        b && (w = parseInt(D.getAttribute("data-swiper-slide-index"), 10));
        let A = w * 90, C = Math.floor(A / 360);
        d && (A = -A, C = Math.floor(-A / 360));
        const x = Math.max(Math.min(D.progress, 1), -1);
        let T = 0, M = 0, V = 0;
        w % 4 === 0 ? (T = -C * 4 * p, V = 0) : (w - 1) % 4 === 0 ? (T = 0, V = -C * 4 * p) : (w - 2) % 4 === 0 ? (T = p + C * 4 * p, V = p) : (w - 3) % 4 === 0 && (T = -p, V = 3 * p + p * 4 * C), d && (T = -T), F || (M = T, T = 0);
        const G = `rotateX(${y(F ? 0 : -A)}deg) rotateY(${y(F ? A : 0)}deg) translate3d(${T}px, ${M}px, ${V}px)`;
        x <= 1 && x > -1 && (v = w * 90 + x * 90, d && (v = -w * 90 - x * 90)), D.style.transform = G, h.slideShadows && n(D, x, F);
      }
      if (c.style.transformOrigin = `50% 50% -${p / 2}px`, c.style["-webkit-transform-origin"] = `50% 50% -${p / 2}px`, h.shadow)
        if (F)
          P.style.transform = `translate3d(0px, ${f / 2 + h.shadowOffset}px, ${-f / 2}px) rotateX(89.99deg) rotateZ(0deg) scale(${h.shadowScale})`;
        else {
          const S = Math.abs(v) - Math.floor(Math.abs(v) / 90) * 90, D = 1.5 - (Math.sin(S * 2 * Math.PI / 360) / 2 + Math.cos(S * 2 * Math.PI / 360) / 2), w = h.shadowScale, A = h.shadowScale / D, C = h.shadowOffset;
          P.style.transform = `scale3d(${w}, 1, ${A}) translate3d(0px, ${g / 2 + C}px, ${-g / 2 / A}px) rotateX(-89.99deg)`;
        }
      const E = (m.isSafari || m.isWebView) && m.needPerspectiveFix ? -p / 2 : 0;
      c.style.transform = `translate3d(0px,0,${E}px) rotateX(${y(e.isHorizontal() ? 0 : v)}deg) rotateY(${y(e.isHorizontal() ? -v : 0)}deg)`, c.style.setProperty("--swiper-cube-translate-z", `${E}px`);
    },
    setTransition: (l) => {
      const {
        el: c,
        slides: u
      } = e;
      if (u.forEach((f) => {
        f.style.transitionDuration = `${l}ms`, f.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((g) => {
          g.style.transitionDuration = `${l}ms`;
        });
      }), e.params.cubeEffect.shadow && !e.isHorizontal()) {
        const f = c.querySelector(".swiper-cube-shadow");
        f && (f.style.transitionDuration = `${l}ms`);
      }
    },
    recreateShadows: () => {
      const l = e.isHorizontal();
      e.slides.forEach((c) => {
        const u = Math.max(Math.min(c.progress, 1), -1);
        n(c, u, l);
      });
    },
    getEffectParams: () => e.params.cubeEffect,
    perspective: () => !0,
    overwriteParams: () => ({
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchSlidesProgress: !0,
      resistanceRatio: 0,
      spaceBetween: 0,
      centeredSlides: !1,
      virtualTranslate: !0
    })
  });
}
function Zt(o, e, r) {
  const t = `swiper-slide-shadow${r ? `-${r}` : ""}${o ? ` swiper-slide-shadow-${o}` : ""}`, n = ht(e);
  let a = n.querySelector(`.${t.split(" ").join(".")}`);
  return a || (a = Ao("div", t.split(" ")), n.append(a)), a;
}
function y5(o) {
  let {
    swiper: e,
    extendParams: r,
    on: t
  } = o;
  r({
    flipEffect: {
      slideShadows: !0,
      limitRotation: !0
    }
  });
  const n = (l, c) => {
    let u = e.isHorizontal() ? l.querySelector(".swiper-slide-shadow-left") : l.querySelector(".swiper-slide-shadow-top"), f = e.isHorizontal() ? l.querySelector(".swiper-slide-shadow-right") : l.querySelector(".swiper-slide-shadow-bottom");
    u || (u = Zt("flip", l, e.isHorizontal() ? "left" : "top")), f || (f = Zt("flip", l, e.isHorizontal() ? "right" : "bottom")), u && (u.style.opacity = Math.max(-c, 0)), f && (f.style.opacity = Math.max(c, 0));
  };
  tn({
    effect: "flip",
    swiper: e,
    on: t,
    setTranslate: () => {
      const {
        slides: l,
        rtlTranslate: c
      } = e, u = e.params.flipEffect, f = ji(e);
      for (let g = 0; g < l.length; g += 1) {
        const d = l[g];
        let p = d.progress;
        e.params.flipEffect.limitRotation && (p = Math.max(Math.min(d.progress, 1), -1));
        const m = d.swiperSlideOffset;
        let h = -180 * p, F = 0, b = e.params.cssMode ? -m - e.translate : -m, v = 0;
        e.isHorizontal() ? c && (h = -h) : (v = b, b = 0, F = -h, h = 0), d.style.zIndex = -Math.abs(Math.round(p)) + l.length, u.slideShadows && n(d, p);
        const P = `translate3d(${b}px, ${v}px, 0px) rotateX(${f(F)}deg) rotateY(${f(h)}deg)`, E = Ka(u, d);
        E.style.transform = P;
      }
    },
    setTransition: (l) => {
      const c = e.slides.map((u) => ht(u));
      c.forEach((u) => {
        u.style.transitionDuration = `${l}ms`, u.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((f) => {
          f.style.transitionDuration = `${l}ms`;
        });
      }), Mi({
        swiper: e,
        duration: l,
        transformElements: c
      });
    },
    recreateShadows: () => {
      e.params.flipEffect, e.slides.forEach((l) => {
        let c = l.progress;
        e.params.flipEffect.limitRotation && (c = Math.max(Math.min(l.progress, 1), -1)), n(l, c);
      });
    },
    getEffectParams: () => e.params.flipEffect,
    perspective: () => !0,
    overwriteParams: () => ({
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchSlidesProgress: !0,
      spaceBetween: 0,
      virtualTranslate: !e.params.cssMode
    })
  });
}
function h5(o) {
  let {
    swiper: e,
    extendParams: r,
    on: t
  } = o;
  r({
    coverflowEffect: {
      rotate: 50,
      stretch: 0,
      depth: 100,
      scale: 1,
      modifier: 1,
      slideShadows: !0
    }
  }), tn({
    effect: "coverflow",
    swiper: e,
    on: t,
    setTranslate: () => {
      const {
        width: s,
        height: i,
        slides: l,
        slidesSizesGrid: c
      } = e, u = e.params.coverflowEffect, f = e.isHorizontal(), g = e.translate, d = f ? -g + s / 2 : -g + i / 2, p = f ? u.rotate : -u.rotate, m = u.depth, y = ji(e);
      for (let h = 0, F = l.length; h < F; h += 1) {
        const b = l[h], v = c[h], P = b.swiperSlideOffset, E = (d - P - v / 2) / v, S = typeof u.modifier == "function" ? u.modifier(E) : E * u.modifier;
        let D = f ? p * S : 0, w = f ? 0 : p * S, A = -m * Math.abs(S), C = u.stretch;
        typeof C == "string" && C.indexOf("%") !== -1 && (C = parseFloat(u.stretch) / 100 * v);
        let x = f ? 0 : C * S, T = f ? C * S : 0, M = 1 - (1 - u.scale) * Math.abs(S);
        Math.abs(T) < 1e-3 && (T = 0), Math.abs(x) < 1e-3 && (x = 0), Math.abs(A) < 1e-3 && (A = 0), Math.abs(D) < 1e-3 && (D = 0), Math.abs(w) < 1e-3 && (w = 0), Math.abs(M) < 1e-3 && (M = 0);
        const V = `translate3d(${T}px,${x}px,${A}px)  rotateX(${y(w)}deg) rotateY(${y(D)}deg) scale(${M})`, G = Ka(u, b);
        if (G.style.transform = V, b.style.zIndex = -Math.abs(Math.round(S)) + 1, u.slideShadows) {
          let L = f ? b.querySelector(".swiper-slide-shadow-left") : b.querySelector(".swiper-slide-shadow-top"), W = f ? b.querySelector(".swiper-slide-shadow-right") : b.querySelector(".swiper-slide-shadow-bottom");
          L || (L = Zt("coverflow", b, f ? "left" : "top")), W || (W = Zt("coverflow", b, f ? "right" : "bottom")), L && (L.style.opacity = S > 0 ? S : 0), W && (W.style.opacity = -S > 0 ? -S : 0);
        }
      }
    },
    setTransition: (s) => {
      e.slides.map((l) => ht(l)).forEach((l) => {
        l.style.transitionDuration = `${s}ms`, l.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((c) => {
          c.style.transitionDuration = `${s}ms`;
        });
      });
    },
    perspective: () => !0,
    overwriteParams: () => ({
      watchSlidesProgress: !0
    })
  });
}
function F5(o) {
  let {
    swiper: e,
    extendParams: r,
    on: t
  } = o;
  r({
    creativeEffect: {
      limitProgress: 1,
      shadowPerProgress: !1,
      progressMultiplier: 1,
      perspective: !0,
      prev: {
        translate: [0, 0, 0],
        rotate: [0, 0, 0],
        opacity: 1,
        scale: 1
      },
      next: {
        translate: [0, 0, 0],
        rotate: [0, 0, 0],
        opacity: 1,
        scale: 1
      }
    }
  });
  const n = (i) => typeof i == "string" ? i : `${i}px`;
  tn({
    effect: "creative",
    swiper: e,
    on: t,
    setTranslate: () => {
      const {
        slides: i,
        wrapperEl: l,
        slidesSizesGrid: c
      } = e, u = e.params.creativeEffect, {
        progressMultiplier: f
      } = u, g = e.params.centeredSlides, d = ji(e);
      if (g) {
        const p = c[0] / 2 - e.params.slidesOffsetBefore || 0;
        l.style.transform = `translateX(calc(50% - ${p}px))`;
      }
      for (let p = 0; p < i.length; p += 1) {
        const m = i[p], y = m.progress, h = Math.min(Math.max(m.progress, -u.limitProgress), u.limitProgress);
        let F = h;
        g || (F = Math.min(Math.max(m.originalProgress, -u.limitProgress), u.limitProgress));
        const b = m.swiperSlideOffset, v = [e.params.cssMode ? -b - e.translate : -b, 0, 0], P = [0, 0, 0];
        let E = !1;
        e.isHorizontal() || (v[1] = v[0], v[0] = 0);
        let S = {
          translate: [0, 0, 0],
          rotate: [0, 0, 0],
          scale: 1,
          opacity: 1
        };
        h < 0 ? (S = u.next, E = !0) : h > 0 && (S = u.prev, E = !0), v.forEach((M, V) => {
          v[V] = `calc(${M}px + (${n(S.translate[V])} * ${Math.abs(h * f)}))`;
        }), P.forEach((M, V) => {
          let G = S.rotate[V] * Math.abs(h * f);
          P[V] = G;
        }), m.style.zIndex = -Math.abs(Math.round(y)) + i.length;
        const D = v.join(", "), w = `rotateX(${d(P[0])}deg) rotateY(${d(P[1])}deg) rotateZ(${d(P[2])}deg)`, A = F < 0 ? `scale(${1 + (1 - S.scale) * F * f})` : `scale(${1 - (1 - S.scale) * F * f})`, C = F < 0 ? 1 + (1 - S.opacity) * F * f : 1 - (1 - S.opacity) * F * f, x = `translate3d(${D}) ${w} ${A}`;
        if (E && S.shadow || !E) {
          let M = m.querySelector(".swiper-slide-shadow");
          if (!M && S.shadow && (M = Zt("creative", m)), M) {
            const V = u.shadowPerProgress ? h * (1 / u.limitProgress) : h;
            M.style.opacity = Math.min(Math.max(Math.abs(V), 0), 1);
          }
        }
        const T = Ka(u, m);
        T.style.transform = x, T.style.opacity = C, S.origin && (T.style.transformOrigin = S.origin);
      }
    },
    setTransition: (i) => {
      const l = e.slides.map((c) => ht(c));
      l.forEach((c) => {
        c.style.transitionDuration = `${i}ms`, c.querySelectorAll(".swiper-slide-shadow").forEach((u) => {
          u.style.transitionDuration = `${i}ms`;
        });
      }), Mi({
        swiper: e,
        duration: i,
        transformElements: l,
        allSlides: !0
      });
    },
    perspective: () => e.params.creativeEffect.perspective,
    overwriteParams: () => ({
      watchSlidesProgress: !0,
      virtualTranslate: !e.params.cssMode
    })
  });
}
function b5(o) {
  let {
    swiper: e,
    extendParams: r,
    on: t
  } = o;
  r({
    cardsEffect: {
      slideShadows: !0,
      rotate: !0,
      perSlideRotate: 2,
      perSlideOffset: 8
    }
  }), tn({
    effect: "cards",
    swiper: e,
    on: t,
    setTranslate: () => {
      const {
        slides: s,
        activeIndex: i,
        rtlTranslate: l
      } = e, c = e.params.cardsEffect, {
        startTranslate: u,
        isTouched: f
      } = e.touchEventsData, g = l ? -e.translate : e.translate;
      for (let d = 0; d < s.length; d += 1) {
        const p = s[d], m = p.progress, y = Math.min(Math.max(m, -4), 4);
        let h = p.swiperSlideOffset;
        e.params.centeredSlides && !e.params.cssMode && (e.wrapperEl.style.transform = `translateX(${e.minTranslate()}px)`), e.params.centeredSlides && e.params.cssMode && (h -= s[0].swiperSlideOffset);
        let F = e.params.cssMode ? -h - e.translate : -h, b = 0;
        const v = -100 * Math.abs(y);
        let P = 1, E = -c.perSlideRotate * y, S = c.perSlideOffset - Math.abs(y) * 0.75;
        const D = e.virtual && e.params.virtual.enabled ? e.virtual.from + d : d, w = (D === i || D === i - 1) && y > 0 && y < 1 && (f || e.params.cssMode) && g < u, A = (D === i || D === i + 1) && y < 0 && y > -1 && (f || e.params.cssMode) && g > u;
        if (w || A) {
          const M = (1 - Math.abs((Math.abs(y) - 0.5) / 0.5)) ** 0.5;
          E += -28 * y * M, P += -0.5 * M, S += 96 * M, b = `${-25 * M * Math.abs(y)}%`;
        }
        if (y < 0 ? F = `calc(${F}px ${l ? "-" : "+"} (${S * Math.abs(y)}%))` : y > 0 ? F = `calc(${F}px ${l ? "-" : "+"} (-${S * Math.abs(y)}%))` : F = `${F}px`, !e.isHorizontal()) {
          const M = b;
          b = F, F = M;
        }
        const C = y < 0 ? `${1 + (1 - P) * y}` : `${1 - (1 - P) * y}`, x = `
        translate3d(${F}, ${b}, ${v}px)
        rotateZ(${c.rotate ? l ? -E : E : 0}deg)
        scale(${C})
      `;
        if (c.slideShadows) {
          let M = p.querySelector(".swiper-slide-shadow");
          M || (M = Zt("cards", p)), M && (M.style.opacity = Math.min(Math.max((Math.abs(y) - 0.5) / 0.5, 0), 1));
        }
        p.style.zIndex = -Math.abs(Math.round(m)) + s.length;
        const T = Ka(c, p);
        T.style.transform = x;
      }
    },
    setTransition: (s) => {
      const i = e.slides.map((l) => ht(l));
      i.forEach((l) => {
        l.style.transitionDuration = `${s}ms`, l.querySelectorAll(".swiper-slide-shadow").forEach((c) => {
          c.style.transitionDuration = `${s}ms`;
        });
      }), Mi({
        swiper: e,
        duration: s,
        transformElements: i
      });
    },
    perspective: () => !0,
    overwriteParams: () => ({
      _loopSwapReset: !1,
      watchSlidesProgress: !0,
      loopAdditionalSlides: 3,
      centeredSlides: !0,
      virtualTranslate: !e.params.cssMode
    })
  });
}
const v5 = [XA, UA, ZA, KA, QA, JA, _A, $A, e5, o5, r5, t5, n5, a5, s5, i5, g5, m5, f5, y5, h5, F5, b5];
ko.use(v5);
const Wi = [
  "eventsPrefix",
  "injectStyles",
  "injectStylesUrls",
  "modules",
  "init",
  "_direction",
  "oneWayMovement",
  "swiperElementNodeName",
  "touchEventsTarget",
  "initialSlide",
  "_speed",
  "cssMode",
  "updateOnWindowResize",
  "resizeObserver",
  "nested",
  "focusableElements",
  "_enabled",
  "_width",
  "_height",
  "preventInteractionOnTransition",
  "userAgent",
  "url",
  "_edgeSwipeDetection",
  "_edgeSwipeThreshold",
  "_freeMode",
  "_autoHeight",
  "setWrapperSize",
  "virtualTranslate",
  "_effect",
  "breakpoints",
  "breakpointsBase",
  "_spaceBetween",
  "_slidesPerView",
  "maxBackfaceHiddenSlides",
  "_grid",
  "_slidesPerGroup",
  "_slidesPerGroupSkip",
  "_slidesPerGroupAuto",
  "_centeredSlides",
  "_centeredSlidesBounds",
  "_slidesOffsetBefore",
  "_slidesOffsetAfter",
  "normalizeSlideIndex",
  "_centerInsufficientSlides",
  "_watchOverflow",
  "roundLengths",
  "touchRatio",
  "touchAngle",
  "simulateTouch",
  "_shortSwipes",
  "_longSwipes",
  "longSwipesRatio",
  "longSwipesMs",
  "_followFinger",
  "allowTouchMove",
  "_threshold",
  "touchMoveStopPropagation",
  "touchStartPreventDefault",
  "touchStartForcePreventDefault",
  "touchReleaseOnEdges",
  "uniqueNavElements",
  "_resistance",
  "_resistanceRatio",
  "_watchSlidesProgress",
  "_grabCursor",
  "preventClicks",
  "preventClicksPropagation",
  "_slideToClickedSlide",
  "_loop",
  "loopAdditionalSlides",
  "loopAddBlankSlides",
  "loopPreventsSliding",
  "_rewind",
  "_allowSlidePrev",
  "_allowSlideNext",
  "_swipeHandler",
  "_noSwiping",
  "noSwipingClass",
  "noSwipingSelector",
  "passiveListeners",
  "containerModifierClass",
  "slideClass",
  "slideActiveClass",
  "slideVisibleClass",
  "slideFullyVisibleClass",
  "slideNextClass",
  "slidePrevClass",
  "slideBlankClass",
  "wrapperClass",
  "lazyPreloaderClass",
  "lazyPreloadPrevNext",
  "runCallbacksOnInit",
  "observer",
  "observeParents",
  "observeSlideChildren",
  // modules
  "a11y",
  "_autoplay",
  "_controller",
  "coverflowEffect",
  "cubeEffect",
  "fadeEffect",
  "flipEffect",
  "creativeEffect",
  "cardsEffect",
  "hashNavigation",
  "history",
  "keyboard",
  "mousewheel",
  "_navigation",
  "_pagination",
  "parallax",
  "_scrollbar",
  "_thumbs",
  "virtual",
  "zoom",
  "control"
];
function Kt(o) {
  return typeof o == "object" && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === "Object" && !o.__swiper__;
}
function Wu(o, e) {
  const r = ["__proto__", "constructor", "prototype"];
  Object.keys(e).filter((t) => r.indexOf(t) < 0).forEach((t) => {
    typeof o[t] > "u" ? o[t] = e[t] : Kt(e[t]) && Kt(o[t]) && Object.keys(e[t]).length > 0 ? e[t].__swiper__ ? o[t] = e[t] : Wu(o[t], e[t]) : o[t] = e[t];
  });
}
function B5(o) {
  return o === void 0 && (o = {}), o.navigation && typeof o.navigation.nextEl > "u" && typeof o.navigation.prevEl > "u";
}
function P5(o) {
  return o === void 0 && (o = {}), o.pagination && typeof o.pagination.el > "u";
}
function w5(o) {
  return o === void 0 && (o = {}), o.scrollbar && typeof o.scrollbar.el > "u";
}
function Rs(o) {
  return o === void 0 && (o = ""), o.replace(/-[a-z]/g, (e) => e.toUpperCase().replace("-", ""));
}
function k5(o) {
  let {
    swiper: e,
    slides: r,
    passedParams: t,
    changedParams: n,
    nextEl: a,
    prevEl: s,
    scrollbarEl: i,
    paginationEl: l
  } = o;
  const c = n.filter((w) => w !== "children" && w !== "direction" && w !== "wrapperClass"), {
    params: u,
    pagination: f,
    navigation: g,
    scrollbar: d,
    virtual: p,
    thumbs: m
  } = e;
  let y, h, F, b, v, P, E, S;
  n.includes("thumbs") && t.thumbs && t.thumbs.swiper && !t.thumbs.swiper.destroyed && u.thumbs && (!u.thumbs.swiper || u.thumbs.swiper.destroyed) && (y = !0), n.includes("controller") && t.controller && t.controller.control && u.controller && !u.controller.control && (h = !0), n.includes("pagination") && t.pagination && (t.pagination.el || l) && (u.pagination || u.pagination === !1) && f && !f.el && (F = !0), n.includes("scrollbar") && t.scrollbar && (t.scrollbar.el || i) && (u.scrollbar || u.scrollbar === !1) && d && !d.el && (b = !0), n.includes("navigation") && t.navigation && (t.navigation.prevEl || s) && (t.navigation.nextEl || a) && (u.navigation || u.navigation === !1) && g && !g.prevEl && !g.nextEl && (v = !0);
  const D = (w) => {
    e[w] && (e[w].destroy(), w === "navigation" ? (e.isElement && (e[w].prevEl.remove(), e[w].nextEl.remove()), u[w].prevEl = void 0, u[w].nextEl = void 0, e[w].prevEl = void 0, e[w].nextEl = void 0) : (e.isElement && e[w].el.remove(), u[w].el = void 0, e[w].el = void 0));
  };
  n.includes("loop") && e.isElement && (u.loop && !t.loop ? P = !0 : !u.loop && t.loop ? E = !0 : S = !0), c.forEach((w) => {
    if (Kt(u[w]) && Kt(t[w]))
      Object.assign(u[w], t[w]), (w === "navigation" || w === "pagination" || w === "scrollbar") && "enabled" in t[w] && !t[w].enabled && D(w);
    else {
      const A = t[w];
      (A === !0 || A === !1) && (w === "navigation" || w === "pagination" || w === "scrollbar") ? A === !1 && D(w) : u[w] = t[w];
    }
  }), c.includes("controller") && !h && e.controller && e.controller.control && u.controller && u.controller.control && (e.controller.control = u.controller.control), n.includes("children") && r && p && u.virtual.enabled ? (p.slides = r, p.update(!0)) : n.includes("virtual") && p && u.virtual.enabled && (r && (p.slides = r), p.update(!0)), n.includes("children") && r && u.loop && (S = !0), y && m.init() && m.update(!0), h && (e.controller.control = u.controller.control), F && (e.isElement && (!l || typeof l == "string") && (l = document.createElement("div"), l.classList.add("swiper-pagination"), l.part.add("pagination"), e.el.appendChild(l)), l && (u.pagination.el = l), f.init(), f.render(), f.update()), b && (e.isElement && (!i || typeof i == "string") && (i = document.createElement("div"), i.classList.add("swiper-scrollbar"), i.part.add("scrollbar"), e.el.appendChild(i)), i && (u.scrollbar.el = i), d.init(), d.updateSize(), d.setTranslate()), v && (e.isElement && ((!a || typeof a == "string") && (a = document.createElement("div"), a.classList.add("swiper-button-next"), a.innerHTML = e.hostEl.constructor.nextButtonSvg, a.part.add("button-next"), e.el.appendChild(a)), (!s || typeof s == "string") && (s = document.createElement("div"), s.classList.add("swiper-button-prev"), s.innerHTML = e.hostEl.constructor.prevButtonSvg, s.part.add("button-prev"), e.el.appendChild(s))), a && (u.navigation.nextEl = a), s && (u.navigation.prevEl = s), g.init(), g.update()), n.includes("allowSlideNext") && (e.allowSlideNext = t.allowSlideNext), n.includes("allowSlidePrev") && (e.allowSlidePrev = t.allowSlidePrev), n.includes("direction") && e.changeDirection(t.direction, !1), (P || S) && e.loopDestroy(), (E || S) && e.loopCreate(), e.update();
}
const Tf = (o) => {
  if (parseFloat(o) === Number(o)) return Number(o);
  if (o === "true" || o === "") return !0;
  if (o === "false") return !1;
  if (o === "null") return null;
  if (o !== "undefined") {
    if (typeof o == "string" && o.includes("{") && o.includes("}") && o.includes('"')) {
      let e;
      try {
        e = JSON.parse(o);
      } catch {
        e = o;
      }
      return e;
    }
    return o;
  }
}, Lf = ["a11y", "autoplay", "controller", "cards-effect", "coverflow-effect", "creative-effect", "cube-effect", "fade-effect", "flip-effect", "free-mode", "grid", "hash-navigation", "history", "keyboard", "mousewheel", "navigation", "pagination", "parallax", "scrollbar", "thumbs", "virtual", "zoom"];
function jf(o, e, r) {
  const t = {}, n = {};
  Wu(t, Mu);
  const a = [...Wi, "on"], s = a.map((l) => l.replace(/_/, ""));
  a.forEach((l) => {
    l = l.replace("_", ""), typeof o[l] < "u" && (n[l] = o[l]);
  });
  const i = [...o.attributes];
  return typeof e == "string" && typeof r < "u" && i.push({
    name: e,
    value: Kt(r) ? {
      ...r
    } : r
  }), i.forEach((l) => {
    const c = Lf.find((u) => l.name.startsWith(`${u}-`));
    if (c) {
      const u = Rs(c), f = Rs(l.name.split(`${c}-`)[1]);
      typeof n[u] > "u" && (n[u] = {}), n[u] === !0 && (n[u] = {
        enabled: !0
      }), n[u][f] = Tf(l.value);
    } else {
      const u = Rs(l.name);
      if (!s.includes(u)) return;
      const f = Tf(l.value);
      n[u] && Lf.includes(l.name) && !Kt(f) ? (n[u].constructor !== Object && (n[u] = {}), n[u].enabled = !!f) : n[u] = f;
    }
  }), Wu(t, n), t.navigation ? t.navigation = {
    prevEl: ".swiper-button-prev",
    nextEl: ".swiper-button-next",
    ...t.navigation !== !0 ? t.navigation : {}
  } : t.navigation === !1 && delete t.navigation, t.scrollbar ? t.scrollbar = {
    el: ".swiper-scrollbar",
    ...t.scrollbar !== !0 ? t.scrollbar : {}
  } : t.scrollbar === !1 && delete t.scrollbar, t.pagination ? t.pagination = {
    el: ".swiper-pagination",
    ...t.pagination !== !0 ? t.pagination : {}
  } : t.pagination === !1 && delete t.pagination, {
    params: t,
    passedParams: n
  };
}
const D5 = ":host{--swiper-theme-color:#007aff}:host{position:relative;display:block;margin-left:auto;margin-right:auto;z-index:1}.swiper{width:100%;height:100%;margin-left:auto;margin-right:auto;position:relative;overflow:hidden;list-style:none;padding:0;z-index:1;display:block}.swiper-vertical>.swiper-wrapper{flex-direction:column}.swiper-wrapper{position:relative;width:100%;height:100%;z-index:1;display:flex;transition-property:transform;transition-timing-function:var(--swiper-wrapper-transition-timing-function,initial);box-sizing:content-box}.swiper-android ::slotted(swiper-slide),.swiper-ios ::slotted(swiper-slide),.swiper-wrapper{transform:translate3d(0px,0,0)}.swiper-horizontal{touch-action:pan-y}.swiper-vertical{touch-action:pan-x}::slotted(swiper-slide){flex-shrink:0;width:100%;height:100%;position:relative;transition-property:transform;display:block}::slotted(.swiper-slide-invisible-blank){visibility:hidden}.swiper-autoheight,.swiper-autoheight ::slotted(swiper-slide){height:auto}.swiper-autoheight .swiper-wrapper{align-items:flex-start;transition-property:transform,height}.swiper-backface-hidden ::slotted(swiper-slide){transform:translateZ(0);-webkit-backface-visibility:hidden;backface-visibility:hidden}.swiper-3d.swiper-css-mode .swiper-wrapper{perspective:1200px}.swiper-3d .swiper-wrapper{transform-style:preserve-3d}.swiper-3d{perspective:1200px}.swiper-3d .swiper-cube-shadow,.swiper-3d ::slotted(swiper-slide){transform-style:preserve-3d}.swiper-css-mode>.swiper-wrapper{overflow:auto;scrollbar-width:none;-ms-overflow-style:none}.swiper-css-mode>.swiper-wrapper::-webkit-scrollbar{display:none}.swiper-css-mode ::slotted(swiper-slide){scroll-snap-align:start start}.swiper-css-mode.swiper-horizontal>.swiper-wrapper{scroll-snap-type:x mandatory}.swiper-css-mode.swiper-vertical>.swiper-wrapper{scroll-snap-type:y mandatory}.swiper-css-mode.swiper-free-mode>.swiper-wrapper{scroll-snap-type:none}.swiper-css-mode.swiper-free-mode ::slotted(swiper-slide){scroll-snap-align:none}.swiper-css-mode.swiper-centered>.swiper-wrapper::before{content:'';flex-shrink:0;order:9999}.swiper-css-mode.swiper-centered ::slotted(swiper-slide){scroll-snap-align:center center;scroll-snap-stop:always}.swiper-css-mode.swiper-centered.swiper-horizontal ::slotted(swiper-slide):first-child{margin-inline-start:var(--swiper-centered-offset-before)}.swiper-css-mode.swiper-centered.swiper-horizontal>.swiper-wrapper::before{height:100%;min-height:1px;width:var(--swiper-centered-offset-after)}.swiper-css-mode.swiper-centered.swiper-vertical ::slotted(swiper-slide):first-child{margin-block-start:var(--swiper-centered-offset-before)}.swiper-css-mode.swiper-centered.swiper-vertical>.swiper-wrapper::before{width:100%;min-width:1px;height:var(--swiper-centered-offset-after)}.swiper-virtual ::slotted(swiper-slide){-webkit-backface-visibility:hidden;transform:translateZ(0)}.swiper-virtual.swiper-css-mode .swiper-wrapper::after{content:'';position:absolute;left:0;top:0;pointer-events:none}.swiper-virtual.swiper-css-mode.swiper-horizontal .swiper-wrapper::after{height:1px;width:var(--swiper-virtual-size)}.swiper-virtual.swiper-css-mode.swiper-vertical .swiper-wrapper::after{width:1px;height:var(--swiper-virtual-size)}:host{--swiper-navigation-size:44px}.swiper-button-next,.swiper-button-prev{position:absolute;top:var(--swiper-navigation-top-offset,50%);width:calc(var(--swiper-navigation-size)/ 44 * 27);height:var(--swiper-navigation-size);margin-top:calc(0px - (var(--swiper-navigation-size)/ 2));z-index:10;cursor:pointer;display:flex;align-items:center;justify-content:center;color:var(--swiper-navigation-color,var(--swiper-theme-color))}.swiper-button-next.swiper-button-disabled,.swiper-button-prev.swiper-button-disabled{opacity:.35;cursor:auto;pointer-events:none}.swiper-button-next.swiper-button-hidden,.swiper-button-prev.swiper-button-hidden{opacity:0;cursor:auto;pointer-events:none}.swiper-navigation-disabled .swiper-button-next,.swiper-navigation-disabled .swiper-button-prev{display:none!important}.swiper-button-next svg,.swiper-button-prev svg{width:100%;height:100%;object-fit:contain;transform-origin:center}.swiper-rtl .swiper-button-next svg,.swiper-rtl .swiper-button-prev svg{transform:rotate(180deg)}.swiper-button-prev,.swiper-rtl .swiper-button-next{left:var(--swiper-navigation-sides-offset,10px);right:auto}.swiper-button-next,.swiper-rtl .swiper-button-prev{right:var(--swiper-navigation-sides-offset,10px);left:auto}.swiper-button-lock{display:none}.swiper-pagination{position:absolute;text-align:center;transition:.3s opacity;transform:translate3d(0,0,0);z-index:10}.swiper-pagination.swiper-pagination-hidden{opacity:0}.swiper-pagination-disabled>.swiper-pagination,.swiper-pagination.swiper-pagination-disabled{display:none!important}.swiper-horizontal>.swiper-pagination-bullets,.swiper-pagination-bullets.swiper-pagination-horizontal,.swiper-pagination-custom,.swiper-pagination-fraction{bottom:var(--swiper-pagination-bottom,8px);top:var(--swiper-pagination-top,auto);left:0;width:100%}.swiper-pagination-bullets-dynamic{overflow:hidden;font-size:0}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transform:scale(.33);position:relative}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active{transform:scale(1)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-main{transform:scale(1)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev{transform:scale(.66)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev{transform:scale(.33)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next{transform:scale(.66)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next{transform:scale(.33)}.swiper-pagination-bullet{width:var(--swiper-pagination-bullet-width,var(--swiper-pagination-bullet-size,8px));height:var(--swiper-pagination-bullet-height,var(--swiper-pagination-bullet-size,8px));display:inline-block;border-radius:var(--swiper-pagination-bullet-border-radius,50%);background:var(--swiper-pagination-bullet-inactive-color,#000);opacity:var(--swiper-pagination-bullet-inactive-opacity, .2)}button.swiper-pagination-bullet{border:none;margin:0;padding:0;box-shadow:none;-webkit-appearance:none;appearance:none}.swiper-pagination-clickable .swiper-pagination-bullet{cursor:pointer}.swiper-pagination-bullet:only-child{display:none!important}.swiper-pagination-bullet-active{opacity:var(--swiper-pagination-bullet-opacity, 1);background:var(--swiper-pagination-color,var(--swiper-theme-color))}.swiper-pagination-vertical.swiper-pagination-bullets,.swiper-vertical>.swiper-pagination-bullets{right:var(--swiper-pagination-right,8px);left:var(--swiper-pagination-left,auto);top:50%;transform:translate3d(0px,-50%,0)}.swiper-pagination-vertical.swiper-pagination-bullets .swiper-pagination-bullet,.swiper-vertical>.swiper-pagination-bullets .swiper-pagination-bullet{margin:var(--swiper-pagination-bullet-vertical-gap,6px) 0;display:block}.swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic,.swiper-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic{top:50%;transform:translateY(-50%);width:8px}.swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,.swiper-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{display:inline-block;transition:.2s transform,.2s top}.swiper-horizontal>.swiper-pagination-bullets .swiper-pagination-bullet,.swiper-pagination-horizontal.swiper-pagination-bullets .swiper-pagination-bullet{margin:0 var(--swiper-pagination-bullet-horizontal-gap,4px)}.swiper-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic,.swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic{left:50%;transform:translateX(-50%);white-space:nowrap}.swiper-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,.swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transition:.2s transform,.2s left}.swiper-horizontal.swiper-rtl>.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transition:.2s transform,.2s right}.swiper-pagination-fraction{color:var(--swiper-pagination-fraction-color,inherit)}.swiper-pagination-progressbar{background:var(--swiper-pagination-progressbar-bg-color,rgba(0,0,0,.25));position:absolute}.swiper-pagination-progressbar .swiper-pagination-progressbar-fill{background:var(--swiper-pagination-color,var(--swiper-theme-color));position:absolute;left:0;top:0;width:100%;height:100%;transform:scale(0);transform-origin:left top}.swiper-rtl .swiper-pagination-progressbar .swiper-pagination-progressbar-fill{transform-origin:right top}.swiper-horizontal>.swiper-pagination-progressbar,.swiper-pagination-progressbar.swiper-pagination-horizontal,.swiper-pagination-progressbar.swiper-pagination-vertical.swiper-pagination-progressbar-opposite,.swiper-vertical>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite{width:100%;height:var(--swiper-pagination-progressbar-size,4px);left:0;top:0}.swiper-horizontal>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite,.swiper-pagination-progressbar.swiper-pagination-horizontal.swiper-pagination-progressbar-opposite,.swiper-pagination-progressbar.swiper-pagination-vertical,.swiper-vertical>.swiper-pagination-progressbar{width:var(--swiper-pagination-progressbar-size,4px);height:100%;left:0;top:0}.swiper-pagination-lock{display:none}.swiper-scrollbar{border-radius:var(--swiper-scrollbar-border-radius,10px);position:relative;touch-action:none;background:var(--swiper-scrollbar-bg-color,rgba(0,0,0,.1))}.swiper-scrollbar-disabled>.swiper-scrollbar,.swiper-scrollbar.swiper-scrollbar-disabled{display:none!important}.swiper-horizontal>.swiper-scrollbar,.swiper-scrollbar.swiper-scrollbar-horizontal{position:absolute;left:var(--swiper-scrollbar-sides-offset,1%);bottom:var(--swiper-scrollbar-bottom,4px);top:var(--swiper-scrollbar-top,auto);z-index:50;height:var(--swiper-scrollbar-size,4px);width:calc(100% - 2 * var(--swiper-scrollbar-sides-offset,1%))}.swiper-scrollbar.swiper-scrollbar-vertical,.swiper-vertical>.swiper-scrollbar{position:absolute;left:var(--swiper-scrollbar-left,auto);right:var(--swiper-scrollbar-right,4px);top:var(--swiper-scrollbar-sides-offset,1%);z-index:50;width:var(--swiper-scrollbar-size,4px);height:calc(100% - 2 * var(--swiper-scrollbar-sides-offset,1%))}.swiper-scrollbar-drag{height:100%;width:100%;position:relative;background:var(--swiper-scrollbar-drag-bg-color,rgba(0,0,0,.5));border-radius:var(--swiper-scrollbar-border-radius,10px);left:0;top:0}.swiper-scrollbar-cursor-drag{cursor:move}.swiper-scrollbar-lock{display:none}::slotted(.swiper-slide-zoomed){cursor:move;touch-action:none}.swiper .swiper-notification{position:absolute;left:0;top:0;pointer-events:none;opacity:0;z-index:-1000}.swiper-free-mode>.swiper-wrapper{transition-timing-function:ease-out;margin:0 auto}.swiper-grid>.swiper-wrapper{flex-wrap:wrap}.swiper-grid-column>.swiper-wrapper{flex-wrap:wrap;flex-direction:column}.swiper-fade.swiper-free-mode ::slotted(swiper-slide){transition-timing-function:ease-out}.swiper-fade ::slotted(swiper-slide){pointer-events:none;transition-property:opacity}.swiper-fade ::slotted(swiper-slide) ::slotted(swiper-slide){pointer-events:none}.swiper-fade ::slotted(.swiper-slide-active){pointer-events:auto}.swiper-fade ::slotted(.swiper-slide-active) ::slotted(.swiper-slide-active){pointer-events:auto}.swiper.swiper-cube{overflow:visible}.swiper-cube ::slotted(swiper-slide){pointer-events:none;-webkit-backface-visibility:hidden;backface-visibility:hidden;z-index:1;visibility:hidden;transform-origin:0 0;width:100%;height:100%}.swiper-cube ::slotted(swiper-slide) ::slotted(swiper-slide){pointer-events:none}.swiper-cube.swiper-rtl ::slotted(swiper-slide){transform-origin:100% 0}.swiper-cube ::slotted(.swiper-slide-active),.swiper-cube ::slotted(.swiper-slide-active) ::slotted(.swiper-slide-active){pointer-events:auto}.swiper-cube ::slotted(.swiper-slide-active),.swiper-cube ::slotted(.swiper-slide-next),.swiper-cube ::slotted(.swiper-slide-prev){pointer-events:auto;visibility:visible}.swiper-cube .swiper-cube-shadow{position:absolute;left:0;bottom:0px;width:100%;height:100%;opacity:.6;z-index:0}.swiper-cube .swiper-cube-shadow:before{content:'';background:#000;position:absolute;left:0;top:0;bottom:0;right:0;filter:blur(50px)}.swiper-cube ::slotted(.swiper-slide-next)+::slotted(swiper-slide){pointer-events:auto;visibility:visible}.swiper.swiper-flip{overflow:visible}.swiper-flip ::slotted(swiper-slide){pointer-events:none;-webkit-backface-visibility:hidden;backface-visibility:hidden;z-index:1}.swiper-flip ::slotted(swiper-slide) ::slotted(swiper-slide){pointer-events:none}.swiper-flip ::slotted(.swiper-slide-active),.swiper-flip ::slotted(.swiper-slide-active) ::slotted(.swiper-slide-active){pointer-events:auto}.swiper-creative ::slotted(swiper-slide){-webkit-backface-visibility:hidden;backface-visibility:hidden;overflow:hidden;transition-property:transform,opacity,height}.swiper.swiper-cards{overflow:visible}.swiper-cards ::slotted(swiper-slide){transform-origin:center bottom;-webkit-backface-visibility:hidden;backface-visibility:hidden;overflow:hidden}", S5 = "::slotted(.swiper-slide-shadow),::slotted(.swiper-slide-shadow-bottom),::slotted(.swiper-slide-shadow-left),::slotted(.swiper-slide-shadow-right),::slotted(.swiper-slide-shadow-top){position:absolute;left:0;top:0;width:100%;height:100%;pointer-events:none;z-index:10}::slotted(.swiper-slide-shadow){background:rgba(0,0,0,.15)}::slotted(.swiper-slide-shadow-left){background-image:linear-gradient(to left,rgba(0,0,0,.5),rgba(0,0,0,0))}::slotted(.swiper-slide-shadow-right){background-image:linear-gradient(to right,rgba(0,0,0,.5),rgba(0,0,0,0))}::slotted(.swiper-slide-shadow-top){background-image:linear-gradient(to top,rgba(0,0,0,.5),rgba(0,0,0,0))}::slotted(.swiper-slide-shadow-bottom){background-image:linear-gradient(to bottom,rgba(0,0,0,.5),rgba(0,0,0,0))}.swiper-lazy-preloader{animation:swiper-preloader-spin 1s infinite linear;width:42px;height:42px;position:absolute;left:50%;top:50%;margin-left:-21px;margin-top:-21px;z-index:10;transform-origin:50%;box-sizing:border-box;border:4px solid var(--swiper-preloader-color,var(--swiper-theme-color));border-radius:50%;border-top-color:transparent}@keyframes swiper-preloader-spin{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}::slotted(.swiper-slide-shadow-cube.swiper-slide-shadow-bottom),::slotted(.swiper-slide-shadow-cube.swiper-slide-shadow-left),::slotted(.swiper-slide-shadow-cube.swiper-slide-shadow-right),::slotted(.swiper-slide-shadow-cube.swiper-slide-shadow-top){z-index:0;-webkit-backface-visibility:hidden;backface-visibility:hidden}::slotted(.swiper-slide-shadow-flip.swiper-slide-shadow-bottom),::slotted(.swiper-slide-shadow-flip.swiper-slide-shadow-left),::slotted(.swiper-slide-shadow-flip.swiper-slide-shadow-right),::slotted(.swiper-slide-shadow-flip.swiper-slide-shadow-top){z-index:0;-webkit-backface-visibility:hidden;backface-visibility:hidden}::slotted(.swiper-zoom-container){width:100%;height:100%;display:flex;justify-content:center;align-items:center;text-align:center}::slotted(.swiper-zoom-container)>canvas,::slotted(.swiper-zoom-container)>img,::slotted(.swiper-zoom-container)>svg{max-width:100%;max-height:100%;object-fit:contain}";
class A5 {
}
const _F = typeof window > "u" || typeof HTMLElement > "u" ? A5 : HTMLElement, Mf = `<svg width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.38296 20.0762C0.111788 19.805 0.111788 19.3654 0.38296 19.0942L9.19758 10.2796L0.38296 1.46497C0.111788 1.19379 0.111788 0.754138 0.38296 0.482966C0.654131 0.211794 1.09379 0.211794 1.36496 0.482966L10.4341 9.55214C10.8359 9.9539 10.8359 10.6053 10.4341 11.007L1.36496 20.0762C1.09379 20.3474 0.654131 20.3474 0.38296 20.0762Z" fill="currentColor"/></svg>
    `, $F = (o, e) => {
  if (typeof CSSStyleSheet < "u" && o.adoptedStyleSheets) {
    const r = new CSSStyleSheet();
    r.replaceSync(e), o.adoptedStyleSheets = [r];
  } else {
    const r = document.createElement("style");
    r.rel = "stylesheet", r.textContent = e, o.appendChild(r);
  }
};
class e0 extends _F {
  constructor() {
    super(), this.attachShadow({
      mode: "open"
    });
  }
  static get nextButtonSvg() {
    return Mf;
  }
  static get prevButtonSvg() {
    return Mf.replace("/></svg>", ' transform-origin="center" transform="rotate(180)"/></svg>');
  }
  cssStyles() {
    return [
      D5,
      // eslint-disable-line
      ...this.injectStyles && Array.isArray(this.injectStyles) ? this.injectStyles : []
    ].join(`
`);
  }
  cssLinks() {
    return this.injectStylesUrls || [];
  }
  calcSlideSlots() {
    const e = this.slideSlots || 0, r = [...this.querySelectorAll("[slot^=slide-]")].map((t) => parseInt(t.getAttribute("slot").split("slide-")[1], 10));
    if (this.slideSlots = r.length ? Math.max(...r) + 1 : 0, !!this.rendered) {
      if (this.slideSlots > e)
        for (let t = e; t < this.slideSlots; t += 1) {
          const n = document.createElement("swiper-slide");
          n.setAttribute("part", `slide slide-${t + 1}`);
          const a = document.createElement("slot");
          a.setAttribute("name", `slide-${t + 1}`), n.appendChild(a), this.shadowRoot.querySelector(".swiper-wrapper").appendChild(n);
        }
      else if (this.slideSlots < e) {
        const t = this.swiper.slides;
        for (let n = t.length - 1; n >= 0; n -= 1)
          n > this.slideSlots && t[n].remove();
      }
    }
  }
  render() {
    if (this.rendered) return;
    this.calcSlideSlots();
    let e = this.cssStyles();
    this.slideSlots > 0 && (e = e.replace(/::slotted\(([a-z-0-9.]*)\)/g, "$1")), e.length && $F(this.shadowRoot, e), this.cssLinks().forEach((t) => {
      if (this.shadowRoot.querySelector(`link[href="${t}"]`)) return;
      const a = document.createElement("link");
      a.rel = "stylesheet", a.href = t, this.shadowRoot.appendChild(a);
    });
    const r = document.createElement("div");
    r.classList.add("swiper"), r.part = "container", r.innerHTML = `
      <slot name="container-start"></slot>
      <div class="swiper-wrapper" part="wrapper">
        <slot></slot>
        ${Array.from({
      length: this.slideSlots
    }).map((t, n) => `
        <swiper-slide part="slide slide-${n}">
          <slot name="slide-${n}"></slot>
        </swiper-slide>
        `).join("")}
      </div>
      <slot name="container-end"></slot>
      ${B5(this.passedParams) ? `
        <div part="button-prev" class="swiper-button-prev">${this.constructor.prevButtonSvg}</div>
        <div part="button-next" class="swiper-button-next">${this.constructor.nextButtonSvg}</div>
      ` : ""}
      ${P5(this.passedParams) ? `
        <div part="pagination" class="swiper-pagination"></div>
      ` : ""}
      ${w5(this.passedParams) ? `
        <div part="scrollbar" class="swiper-scrollbar"></div>
      ` : ""}
    `, this.shadowRoot.appendChild(r), this.rendered = !0;
  }
  initialize() {
    var e = this;
    if (this.swiper && this.swiper.initialized) return;
    const {
      params: r,
      passedParams: t
    } = jf(this);
    this.swiperParams = r, this.passedParams = t, delete this.swiperParams.init, this.render(), this.swiper = new ko(this.shadowRoot.querySelector(".swiper"), {
      ...r.virtual ? {} : {
        observer: !0
      },
      ...r,
      touchEventsTarget: "container",
      onAny: function(n) {
        n === "observerUpdate" && e.calcSlideSlots();
        const a = r.eventsPrefix ? `${r.eventsPrefix}${n.toLowerCase()}` : n.toLowerCase();
        for (var s = arguments.length, i = new Array(s > 1 ? s - 1 : 0), l = 1; l < s; l++)
          i[l - 1] = arguments[l];
        const c = new CustomEvent(a, {
          detail: i,
          bubbles: n !== "hashChange",
          cancelable: !0
        });
        e.dispatchEvent(c);
      }
    });
  }
  connectedCallback() {
    this.swiper && this.swiper.initialized && this.nested && this.closest("swiper-slide") && this.closest("swiper-slide").swiperLoopMoveDOM || this.init === !1 || this.getAttribute("init") === "false" || this.initialize();
  }
  disconnectedCallback() {
    this.nested && this.closest("swiper-slide") && this.closest("swiper-slide").swiperLoopMoveDOM || this.swiper && this.swiper.destroy && this.swiper.destroy();
  }
  updateSwiperOnPropChange(e, r) {
    const {
      params: t,
      passedParams: n
    } = jf(this, e, r);
    this.passedParams = n, this.swiperParams = t, !(this.swiper && this.swiper.params[e] === r) && k5({
      swiper: this.swiper,
      passedParams: this.passedParams,
      changedParams: [Rs(e)],
      ...e === "navigation" && n[e] ? {
        prevEl: ".swiper-button-prev",
        nextEl: ".swiper-button-next"
      } : {},
      ...e === "pagination" && n[e] ? {
        paginationEl: ".swiper-pagination"
      } : {},
      ...e === "scrollbar" && n[e] ? {
        scrollbarEl: ".swiper-scrollbar"
      } : {}
    });
  }
  attributeChangedCallback(e, r, t) {
    this.swiper && this.swiper.initialized && (r === "true" && t === null && (t = !1), this.updateSwiperOnPropChange(e, t));
  }
  static get observedAttributes() {
    return Wi.filter((r) => r.includes("_")).map((r) => r.replace(/[A-Z]/g, (t) => `-${t}`).replace("_", "").toLowerCase());
  }
}
Wi.forEach((o) => {
  o !== "init" && (o = o.replace("_", ""), Object.defineProperty(e0.prototype, o, {
    configurable: !0,
    get() {
      return (this.passedParams || {})[o];
    },
    set(e) {
      this.passedParams || (this.passedParams = {}), this.passedParams[o] = e, this.swiper && this.swiper.initialized && this.updateSwiperOnPropChange(o, e);
    }
  }));
});
class E5 extends _F {
  constructor() {
    super(), this.attachShadow({
      mode: "open"
    });
  }
  render() {
    const e = this.lazy || this.getAttribute("lazy") === "" || this.getAttribute("lazy") === "true";
    if ($F(this.shadowRoot, S5), this.shadowRoot.appendChild(document.createElement("slot")), e) {
      const r = document.createElement("div");
      r.classList.add("swiper-lazy-preloader"), r.part.add("preloader"), this.shadowRoot.appendChild(r);
    }
  }
  initialize() {
    this.render();
  }
  connectedCallback() {
    this.swiperLoopMoveDOM || this.initialize();
  }
}
const x5 = () => {
  typeof window > "u" || (window.customElements.get("swiper-container") || window.customElements.define("swiper-container", e0), window.customElements.get("swiper-slide") || window.customElements.define("swiper-slide", E5));
};
typeof window < "u" && (window.SwiperElementRegisterParams = (o) => {
  Wi.push(...o);
});
const C5 = ["pagination", "navigation"], O5 = /* @__PURE__ */ H({
  __name: "Carousel",
  props: {
    pagination: { type: [Object, Boolean], default: !0 },
    navigation: { type: [Object, Boolean], default: !1 }
  },
  setup(o) {
    const e = o, r = se(() => e.pagination === !0 ? { clickable: !0 } : e.pagination), t = se(() => e.navigation === !0 ? { clickable: !0 } : e.navigation);
    return x5(), (n, a) => (k(), N("swiper-container", {
      class: "rounded-md overflow-hidden",
      pagination: n.pagination ? r.value : !1,
      navigation: n.navigation ? t.value : !1
    }, [
      I(n.$slots, "default", {}, void 0, !0)
    ], 8, C5));
  }
}), zI = /* @__PURE__ */ fe(O5, [["__scopeId", "data-v-dbe48761"]]), T5 = {};
function L5(o, e) {
  return k(), N("swiper-slide", null, [
    I(o.$slots, "default")
  ]);
}
const II = /* @__PURE__ */ fe(T5, [["render", L5]]), j5 = ["id", "value", "indeterminate", "checked", "disabled", "tabindex", "aria-disabled"], RI = /* @__PURE__ */ H({
  __name: "Checkbox",
  props: {
    checked: { type: Boolean },
    modelValue: { type: [Boolean, Array] },
    indeterminate: { type: Boolean },
    value: {},
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(o, { emit: e }) {
    const r = e, t = o, n = se(() => t.checked ? !0 : Array.isArray(t.modelValue) && t.value ? t.modelValue.includes(t.value) : t.modelValue), a = (i) => {
      if (Array.isArray(t.modelValue) && t.value) {
        const l = t.modelValue.indexOf(t.value), { modelValue: c } = t;
        l === -1 ? c.push(t.value) : c.splice(l, 1), r("update:modelValue", c);
        return;
      }
      r("update:modelValue", i.target.checked);
    }, s = ce("field-id");
    return (i, l) => (k(), N("input", {
      id: B(s),
      type: "checkbox",
      class: q([
        "h-4 w-4 rounded border-default-300 text-primary-600 focus:ring-primary-600",
        "disabled:opacity-50 disabled:pointer-events-none"
      ]),
      value: i.value,
      indeterminate: i.indeterminate,
      checked: n.value,
      disabled: i.disabled,
      tabindex: i.disabled ? "-1" : 0,
      "aria-disabled": i.disabled,
      onChange: a
    }, null, 40, j5));
  }
}), M5 = {
  class: /* @__PURE__ */ q([
    "grid grid-cols-[1rem_1fr] gap-x-4 gap-y-1",
    "[&>input]:col-start-1 [&>input]:row-start-1 [&>input]:mt-1",
    "[&>label]:col-start-2 [&>label]:row-start-1",
    "[&>p]:col-start-2 [&>p]:row-start-2"
  ])
}, HI = /* @__PURE__ */ H({
  __name: "CheckboxField",
  setup(o) {
    const e = fo();
    return he("field-id", e), (r, t) => (k(), N("div", M5, [
      I(r.$slots, "default")
    ]));
  }
}), YI = /* @__PURE__ */ H({
  __name: "CheckboxGroup",
  props: {
    columns: { default: 1 }
  },
  setup(o) {
    const e = /* @__PURE__ */ new Map([
      [1, "grid-cols-1"],
      [2, "grid-cols-2"],
      [3, "grid-cols-3"],
      [4, "grid-cols-4"],
      [5, "grid-cols-5"]
    ]);
    return (r, t) => (k(), N("div", {
      class: q([
        "grid gap-3",
        B(e).get(r.columns)
      ])
    }, [
      I(r.$slots, "default")
    ], 2));
  }
}), W5 = ["for"], qI = /* @__PURE__ */ H({
  __name: "CheckboxGroupField",
  setup(o) {
    const e = fo();
    return he("field-id", e), he("field-label-context", {
      as: "span"
    }), (r, t) => (k(), N("label", {
      for: B(e),
      class: q([
        "bg-white flex items-center justify-between space-x-3 rounded-xl p-base border border-default-200 cursor-pointer",
        "[&>*]:cursor-pointer"
      ])
    }, [
      I(r.$slots, "default")
    ], 8, W5));
  }
}), Ni = () => ({
  alignmentClasses: /* @__PURE__ */ new Map([
    ["start", "items-start"],
    ["center", "items-center"],
    ["end", "items-end"]
  ]),
  gapClasses: /* @__PURE__ */ new Map([
    ["tiny", "gap-tiny"],
    ["xxs", "gap-xxs"],
    ["xs", "gap-xs"],
    ["sm", "gap-sm"],
    ["base", "gap-base"],
    ["lg", "gap-lg"],
    ["xl", "gap-xl"],
    ["xxl", "gap-xxl"],
    ["huge", "gap-huge"]
  ]),
  horizontalSpacingClasses: /* @__PURE__ */ new Map([
    ["tiny", "space-x-tiny"],
    ["xxs", "space-x-xxs"],
    ["xs", "space-x-xs"],
    ["sm", "space-x-sm"],
    ["base", "space-x-base"],
    ["lg", "space-x-lg"],
    ["xl", "space-x-xl"],
    ["xxl", "space-x-xxl"],
    ["huge", "space-x-huge"]
  ]),
  justifyClasses: /* @__PURE__ */ new Map([
    ["start", "justify-start"],
    ["center", "justify-center"],
    ["end", "justify-end"]
  ]),
  labelClasses: "text-sm/6 font-medium text-default-900",
  verticalSpacingClasses: /* @__PURE__ */ new Map([
    ["tiny", "space-y-tiny"],
    ["xxs", "space-y-xxs"],
    ["xs", "space-y-xs"],
    ["sm", "space-y-sm"],
    ["base", "space-y-base"],
    ["lg", "space-y-lg"],
    ["xl", "space-y-xl"],
    ["xxl", "space-y-xxl"],
    ["huge", "space-y-huge"]
  ])
}), Sa = /* @__PURE__ */ H({
  __name: "Label",
  props: {
    as: { default: "label" }
  },
  setup(o) {
    const e = o, { labelClasses: r } = Ni(), t = ce("field-label-context", void 0), n = e.as === "label" && !t ? ce("field-id") : void 0;
    return (a, s) => {
      var i;
      return k(), R(ve(((i = B(t)) == null ? void 0 : i.as) ?? a.as), {
        for: a.as === "label" ? B(n) : void 0,
        class: q([
          "block",
          B(r)
        ]),
        "data-slot": "label"
      }, {
        default: j(() => [
          I(a.$slots, "default")
        ]),
        _: 3
      }, 8, ["for", "class"]);
    };
  }
}), N5 = ["id"], Xp = /* @__PURE__ */ H({
  inheritAttrs: !1,
  __name: "Field",
  props: {
    as: { default: "div" },
    hint: { default: void 0 }
  },
  setup(o) {
    const e = o, r = fo();
    return he("field-id", r), he("has-hint", !!e.hint), (t, n) => t.hint ? (k(), N("div", {
      key: 0,
      class: q([
        t.hint && "relative"
      ])
    }, [
      O("span", {
        id: `${B(r)}-hint`,
        class: "absolute top-0 right-0 text-default-500 text-sm"
      }, _(t.hint), 9, N5),
      (k(), R(ve(t.as), $c(Fh(t.$attrs)), {
        default: j(() => [
          I(t.$slots, "default")
        ]),
        _: 3
      }, 16))
    ], 2)) : (k(), R(ve(t.as), $c(Ve({ key: 1 }, t.$attrs)), {
      default: j(() => [
        I(t.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), Bs = /* @__PURE__ */ H({
  __name: "Color",
  props: {
    color: {},
    size: { default: "base" }
  },
  setup(o) {
    return (e, r) => (k(), N("span", {
      style: qo({ backgroundColor: e.color }),
      class: q([
        "block rounded border border-black/10",
        e.size === "base" && "size-9",
        e.size === "sm" && "size-8",
        e.size === "xs" && "size-5"
      ])
    }, null, 6));
  }
}), o0 = /* @__PURE__ */ H({
  inheritAttrs: !1,
  __name: "Popover",
  props: {
    disabled: { type: Boolean, default: !1 },
    placement: { default: void 0 },
    size: { default: "base" },
    trigger: { default: void 0 }
  },
  setup(o) {
    const e = /* @__PURE__ */ new Map([
      ["xs", "max-w-xs"],
      ["sm", "max-w-sm"],
      ["base", "max-w-md"],
      ["lg", "max-w-lg"],
      ["xl", "max-w-xl"],
      ["2xl", "max-w-2xl"]
    ]);
    return (r, t) => (k(), R(B($t), null, {
      default: j(({ open: n, close: a }) => [
        z(B(Vh), {
          placement: r.placement,
          offset: 8,
          enter: "transition ease-out duration-100",
          "enter-from": "transform opacity-0 scale-95",
          "enter-to": "transform opacity-100 scale-100",
          leave: "transition ease-in duration-75",
          "leave-from": "transform opacity-100 scale-100",
          "leave-to": "transform opacity-0 scale-95"
        }, {
          default: j(() => [
            r.$slots.trigger ? I(r.$slots, "trigger", {
              key: 0,
              open: n
            }) : (k(), R(B(rr), {
              key: 1,
              as: eo,
              disabled: r.disabled,
              color: "tertiary"
            }, {
              default: j(() => [
                ne(_(r.trigger), 1)
              ]),
              _: 1
            }, 8, ["disabled"])),
            z(B(en), Ve({
              class: [
                B(e).get(r.size),
                "w-screen p-base rounded-md bg-white shadow-lg ring-1 ring-black/5 whitespace-normal"
              ]
            }, r.$attrs), {
              default: j(() => [
                I(r.$slots, "default", {
                  open: n,
                  close: a
                })
              ]),
              _: 2
            }, 1040, ["class"])
          ]),
          _: 2
        }, 1032, ["placement"])
      ]),
      _: 3
    }));
  }
}), V5 = ["aria-disabled"], z5 = /* @__PURE__ */ H({
  __name: "InputGroup",
  props: {
    disabled: { type: Boolean },
    invalid: { type: Boolean }
  },
  setup(o) {
    return he("disabled", o.disabled), (r, t) => (k(), N("div", {
      class: q([
        "relative flex shadow-sm items-center rounded-md bg-white outline outline-1 -outline-offset-1 outline-default-300",
        "has-[input:focus-within]:outline has-[input:focus-within]:outline-2 has-[input:focus-within]:-outline-offset-2 has-[input:focus-within]:outline-primary-600",
        "[&>[data-slot=addon]:first-child]:pl-3",
        "[&>[data-slot=addon]:last-child]:pr-3",
        r.disabled && "opacity-50 pointer-events-none"
      ]),
      "aria-disabled": r.disabled
    }, [
      I(r.$slots, "default")
    ], 10, V5));
  }
}), I5 = {}, R5 = {
  "data-slot": "addon",
  class: /* @__PURE__ */ q([
    "shrink-0 select-none text-base text-default-500",
    "sm:text-sm/6"
  ])
};
function H5(o, e) {
  return k(), N("div", R5, [
    I(o.$slots, "default")
  ]);
}
const Y5 = /* @__PURE__ */ fe(I5, [["render", H5]]), q5 = { class: "flex-1" }, G5 = {
  key: 0,
  class: "left-0 pl-3 pointer-events-none absolute inset-y-0 flex items-center"
}, X5 = ["id", "type", "disabled", "tabindex", "aria-disabled", "aria-describedby"], U5 = /* @__PURE__ */ H({
  inheritAttrs: !1,
  __name: "InputGroupInput",
  props: /* @__PURE__ */ yr({
    invalid: { type: Boolean, default: !1 },
    leadingIcon: { default: void 0 },
    type: { default: "text" }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(o) {
    const e = o, r = hr(o, "modelValue"), t = ce("field-id"), n = ce("disabled"), a = ce("has-hint", !1), s = se(() => {
      if (e.invalid)
        return `${t}-error`;
      if (a)
        return `${t}-hint`;
    });
    return (i, l) => (k(), N("div", q5, [
      i.leadingIcon ? (k(), N("div", G5, [
        z(B(le), {
          icon: i.leadingIcon,
          class: "h-4 w-4 text-default-400",
          "aria-hidden": "true"
        }, null, 8, ["icon"])
      ])) : K("", !0),
      co(O("input", Ve({
        id: B(t),
        "onUpdate:modelValue": l[0] || (l[0] = (c) => r.value = c),
        class: [
          "block w-full rounded-md border-0 py-1.5 text-default-900",
          "placeholder:text-default-400",
          "focus:ring-0",
          "sm:text-sm sm:leading-6",
          i.leadingIcon && "pl-10"
        ],
        type: i.type,
        disabled: B(n),
        tabindex: B(n) ? "-1" : 0,
        "aria-disabled": B(n),
        "aria-describedby": s.value
      }, i.$attrs), null, 16, X5), [
        [vh, r.value]
      ])
    ]));
  }
}), Z5 = {}, K5 = { class: "flex items-center justify-center" }, Q5 = {
  key: 0,
  class: "px-4 text-sm text-default-500"
};
function J5(o, e) {
  return k(), N("div", K5, [
    e[0] || (e[0] = O("div", {
      class: "grow border-t border-default-300",
      "aria-hidden": "true"
    }, null, -1)),
    o.$slots.default ? (k(), N("span", Q5, [
      I(o.$slots, "default")
    ])) : K("", !0),
    e[1] || (e[1] = O("div", {
      class: "grow border-t border-default-300",
      "aria-hidden": "true"
    }, null, -1))
  ]);
}
const r0 = /* @__PURE__ */ fe(Z5, [["render", J5]]), _5 = { class: "px-base" }, Wf = /* @__PURE__ */ H({
  __name: "Section",
  setup(o) {
    return (e, r) => (k(), N(ye, null, [
      z(r0, { class: "pt-base" }),
      O("div", _5, [
        I(e.$slots, "default")
      ])
    ], 64));
  }
}), $5 = { class: "pt-base pb-2" }, Nf = /* @__PURE__ */ H({
  __name: "SectionLabel",
  setup(o) {
    return (e, r) => (k(), N("div", $5, [
      z(Sa, { as: "span" }, {
        default: j(() => [
          I(e.$slots, "default")
        ]),
        _: 3
      })
    ]));
  }
}), Aa = /* @__PURE__ */ H({
  __name: "Wrap",
  props: {
    as: { default: "div" },
    alignment: { default: "center" },
    gap: { default: "base" },
    justify: { default: "start" }
  },
  setup(o) {
    const { alignmentClasses: e, justifyClasses: r, gapClasses: t } = Ni();
    return (n, a) => (k(), R(ve(n.as), {
      class: q([
        "flex flex-wrap",
        B(t).get(n.gap),
        B(e).get(n.alignment),
        B(r).get(n.justify)
      ])
    }, {
      default: j(() => [
        I(n.$slots, "default")
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), Ea = /* @__PURE__ */ H({
  __name: "WrapItem",
  props: {
    as: { default: "div" }
  },
  setup(o) {
    return (e, r) => (k(), R(ve(e.as), null, {
      default: j(() => [
        I(e.$slots, "default")
      ]),
      _: 3
    }));
  }
}), eE = { key: 0 }, oE = { class: "flex pb-base space-x-3 items-center" }, rE = { class: "flex-none" }, tE = ["color"], nE = ["color"], aE = {
  key: 2,
  class: "-mx-base"
}, GI = /* @__PURE__ */ H({
  inheritAttrs: !1,
  __name: "ColorPicker",
  props: {
    alpha: { type: Boolean, default: !0 },
    disabled: { type: Boolean },
    label: { default: void 0 },
    modelValue: {},
    options: { default: void 0 },
    placement: { default: void 0 }
  },
  emits: ["update:modelValue"],
  setup(o, { emit: e }) {
    const r = o;
    Fr(async () => {
      await import("./hex-alpha-color-picker-Bf_ybK0Q.js"), await import("./hex-color-picker-DuRkZwuF.js");
    });
    const t = ue(r.modelValue), { isSupported: n, open: a, sRGBHex: s } = d2(), i = g2("recently-used-colors", []);
    Bi(() => r.modelValue, (g) => {
      t.value = g;
    });
    const l = e, c = async (g) => {
      await $u(75), l("update:modelValue", g), !i.value.includes(g) && (i.value.length === 7 && i.value.pop(), i.value.unshift(g));
    }, u = se({
      get: () => t.value.replace(/^#/, ""),
      set: (g) => {
        t.value = `#${g.replace(/#/g, "")}`;
      }
    }), f = async () => {
      try {
        await a(), t.value = s.value;
      } catch {
      }
    };
    return (g, d) => (k(), R(o0, Ve({
      trigger: "Open colour picker",
      size: "xs",
      placement: g.placement
    }, g.$attrs), {
      trigger: j(({ open: p }) => [
        g.$slots.trigger ? I(g.$slots, "trigger", {
          key: 0,
          open: p
        }) : (k(), R(B(rr), {
          key: 1,
          as: eo,
          type: "button",
          color: "tertiary",
          "aria-label": "Open colour picker",
          disabled: g.disabled
        }, {
          default: j(() => [
            z(Bs, {
              color: g.modelValue,
              size: "xs",
              class: q(g.disabled && "opacity-50")
            }, null, 8, ["color", "class"]),
            g.label ? (k(), N("span", eE, _(g.label), 1)) : K("", !0)
          ]),
          _: 1
        }, 8, ["disabled"]))
      ]),
      default: j(() => [
        z(B(b2), {
          onTrigger: d[3] || (d[3] = (p) => c(t.value))
        }, {
          default: j(() => {
            var p, m;
            return [
              O("div", oE, [
                O("div", rE, [
                  z(Bs, { color: t.value }, null, 8, ["color"])
                ]),
                z(Xp, { class: "flex-1" }, {
                  default: j(() => [
                    z(Sa, { class: "sr-only" }, {
                      default: j(() => d[4] || (d[4] = [
                        ne(" Colour ")
                      ])),
                      _: 1
                    }),
                    z(z5, null, {
                      default: j(() => [
                        z(Y5, null, {
                          default: j(() => d[5] || (d[5] = [
                            ne("#")
                          ])),
                          _: 1
                        }),
                        z(U5, {
                          modelValue: u.value,
                          "onUpdate:modelValue": d[0] || (d[0] = (y) => u.value = y)
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                B(n) ? (k(), R(Re, {
                  key: 0,
                  ariaLabel: "Open eye dropper",
                  type: "button",
                  color: "secondary",
                  icon: B(bS),
                  onClick: f
                }, null, 8, ["icon"])) : K("", !0)
              ]),
              g.alpha ? (k(), N("hex-alpha-color-picker", {
                key: 0,
                color: t.value,
                class: "w-full",
                onColorChanged: d[1] || (d[1] = (y) => t.value = y.detail.value)
              }, null, 40, tE)) : (k(), N("hex-color-picker", {
                key: 1,
                color: t.value,
                class: "w-full",
                onColorChanged: d[2] || (d[2] = (y) => t.value = y.detail.value)
              }, null, 40, nE)),
              (p = g.options) != null && p.length || B(i).length ? (k(), N("div", aE, [
                (m = g.options) != null && m.length ? (k(), R(Wf, { key: 0 }, {
                  default: j(() => [
                    z(Nf, null, {
                      default: j(() => d[6] || (d[6] = [
                        ne(" Brand colours ")
                      ])),
                      _: 1
                    }),
                    z(Aa, { gap: "sm" }, {
                      default: j(() => [
                        (k(!0), N(ye, null, Oe(g.options, (y) => (k(), R(Ea, { key: y }, {
                          default: j(() => [
                            z(B(rr), {
                              as: "button",
                              class: q([
                                "border-transparent bg-transparent border border-px rounded-md",
                                "hover:bg-default-50",
                                "active:bg-white",
                                "focus-visible:outline-none focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:bg-default-200 focus-visible:outline-primary-900"
                              ]),
                              onClick: (h) => c(y)
                            }, {
                              default: j(() => [
                                z(Bs, {
                                  color: y,
                                  size: "sm"
                                }, null, 8, ["color"])
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]),
                          _: 2
                        }, 1024))), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })) : K("", !0),
                B(i).length ? (k(), R(Wf, { key: 1 }, {
                  default: j(() => [
                    z(Nf, null, {
                      default: j(() => d[7] || (d[7] = [
                        ne(" Recently used ")
                      ])),
                      _: 1
                    }),
                    z(Aa, { gap: "sm" }, {
                      default: j(() => [
                        (k(!0), N(ye, null, Oe(B(i), (y) => (k(), R(Ea, { key: y }, {
                          default: j(() => [
                            z(B(rr), {
                              as: "button",
                              class: q([
                                "border-transparent bg-transparent border border-px rounded-md",
                                "hover:bg-default-50",
                                "active:bg-white",
                                "focus-visible:outline-none focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:bg-default-200 focus-visible:outline-primary-900"
                              ]),
                              onClick: (h) => c(y)
                            }, {
                              default: j(() => [
                                z(Bs, {
                                  color: y,
                                  size: "sm"
                                }, null, 8, ["color"])
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]),
                          _: 2
                        }, 1024))), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })) : K("", !0)
              ])) : K("", !0)
            ];
          }),
          _: 1
        })
      ]),
      _: 3
    }, 16, ["placement"]));
  }
}), XI = /* @__PURE__ */ H({
  __name: "Combobox",
  props: /* @__PURE__ */ yr({
    disabled: { type: Boolean },
    multiple: { type: Boolean }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(o) {
    const e = o, r = hr(o, "modelValue");
    return he("disabled", e.disabled), he("modelValue", r), he("field-label-context", {
      as: Qb
    }), (t, n) => (k(), R(B(Jb), {
      modelValue: r.value,
      "onUpdate:modelValue": n[0] || (n[0] = (a) => r.value = a),
      disabled: t.disabled,
      multiple: t.multiple,
      by: "id"
    }, {
      default: j(({ open: a, disabled: s }) => [
        I(t.$slots, "default", {
          open: a,
          disabled: s
        })
      ]),
      _: 3
    }, 8, ["modelValue", "disabled", "multiple"]));
  }
}), UI = /* @__PURE__ */ H({
  __name: "ComboboxBadges",
  emits: ["remove"],
  setup(o, { emit: e }) {
    const r = ce("modelValue"), t = e;
    return (n, a) => {
      var s;
      return (s = B(r)) != null && s.length ? (k(), R(Aa, {
        key: 0,
        gap: "sm",
        class: "pt-2"
      }, {
        default: j(() => [
          (k(!0), N(ye, null, Oe(B(r), (i) => (k(), R(Ea, {
            key: i.id
          }, {
            default: j(() => [
              z(Yp, { color: "blue" }, {
                default: j(() => [
                  ne(_(i.label) + " ", 1),
                  z(qF, {
                    icon: B(Hr),
                    onClick: (l) => t("remove", i)
                  }, null, 8, ["icon", "onClick"])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024))), 128))
        ]),
        _: 1
      })) : K("", !0);
    };
  }
}), ZI = /* @__PURE__ */ H({
  __name: "ComboboxControl",
  props: {
    query: {},
    value: {}
  },
  emits: ["change"],
  setup(o, { emit: e }) {
    const r = e, t = ce("disabled");
    return (n, a) => (k(), N("div", {
      class: q([
        "relative",
        B(t) && "opacity-50 pointer-events-none"
      ])
    }, [
      z(B(_b), {
        class: q([
          "border-none block w-full rounded-md bg-white py-1.5 pl-3 pr-12 text-base text-default-900 outline outline-1 -outline-offset-1 outline-default-300",
          "placeholder:text-default-400",
          "focus:ring-0 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-primary-600",
          "sm:text-sm/6"
        ]),
        "display-value": (s) => {
          if (n.value)
            return n.value;
          const i = s;
          return Array.isArray(i) ? i.map((l) => l.label).join(", ") : i == null ? void 0 : i.label;
        },
        onChange: a[0] || (a[0] = (s) => r("change", s.target.value))
      }, null, 8, ["display-value"]),
      z(B($b), {
        class: q([
          "absolute inset-y-0 right-0 flex items-center rounded-r-md px-3",
          "focus:outline-none"
        ])
      }, {
        default: j(() => [
          z(B(le), {
            icon: B(Sp),
            class: q([
              "text-default-500 size-4",
              "sm:size-3"
            ]),
            "aria-hidden": "true"
          }, null, 8, ["icon"])
        ]),
        _: 1
      }),
      I(n.$slots, "default")
    ], 2));
  }
}), KI = /* @__PURE__ */ H({
  __name: "ComboboxOption",
  props: {
    disabled: { type: Boolean },
    value: {}
  },
  setup(o) {
    return (e, r) => (k(), R(B(e2), {
      as: "template",
      value: e.value,
      disabled: e.disabled
    }, {
      default: j(({ active: t, selected: n }) => [
        O("li", {
          class: q([
            "relative cursor-default select-none py-2 pl-3 pr-9",
            t ? "bg-primary-600 text-white outline-none" : "text-default-900",
            e.disabled && "opacity-50 pointer-events-none"
          ])
        }, [
          O("span", {
            class: q([
              n ? "font-semibold" : "font-normal",
              "block truncate"
            ])
          }, [
            I(e.$slots, "default")
          ], 2),
          n ? (k(), N("span", {
            key: 0,
            class: q([
              t ? "text-white" : "text-primary-600",
              "absolute inset-y-0 right-0 flex items-center pr-4"
            ])
          }, [
            z(B(le), {
              icon: B(qa),
              class: "size-4",
              "aria-hidden": "true"
            }, null, 8, ["icon"])
          ], 2)) : K("", !0)
        ], 2)
      ]),
      _: 3
    }, 8, ["value", "disabled"]));
  }
}), sE = { key: 0 }, iE = { class: "flex justify-center items-center py-2" }, lE = {
  key: 1,
  class: "flex justify-center items-center py-2 text-default-700"
}, QI = /* @__PURE__ */ H({
  __name: "ComboboxOptions",
  props: {
    endReached: { type: Boolean },
    empty: { type: Boolean },
    loading: { type: Boolean }
  },
  emits: ["loadMore"],
  setup(o, { emit: e }) {
    const r = e;
    return (t, n) => (k(), R(Co, {
      "leave-active-class": "transition ease-in duration-100",
      "leave-from-class": "opacity-100",
      "leave-to-class": "opacity-0"
    }, {
      default: j(() => [
        co((k(), R(B(o2), {
          class: q([
            "absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5",
            "focus:outline-none",
            "sm:text-sm"
          ])
        }, {
          default: j(() => [
            I(t.$slots, "default"),
            t.loading ? (k(), N("li", sE, [
              O("span", iE, [
                z(Yr, { class: "size-4 text-primary-600" })
              ])
            ])) : K("", !0),
            t.empty && !t.loading ? (k(), N("li", lE, " No results found. ")) : K("", !0)
          ]),
          _: 3
        })), [
          [B(Ia), [() => r("loadMore"), { distance: 10, canLoadMore: () => !t.loading && !t.endReached && !t.empty }]]
        ])
      ]),
      _: 3
    }));
  }
}), t0 = /* @__PURE__ */ H({
  __name: "Container",
  props: {
    as: { default: "main" },
    size: { default: "base" }
  },
  setup(o) {
    const e = /* @__PURE__ */ new Map([
      ["xs", "max-w-lg"],
      ["sm", "max-w-7xl"],
      ["base", "max-w-[1920px]"]
    ]);
    return (r, t) => (k(), R(ve(r.as), {
      class: q([
        "w-full mx-auto px-base lg:px-lg",
        B(e).get(r.size)
      ])
    }, {
      default: j(() => [
        I(r.$slots, "default")
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), Up = {
  mounted(o, e) {
    const { tippy: r } = B2(o, {
      content: e.value,
      theme: "spectre",
      maxWidth: 160,
      allowHTML: !0,
      interactive: !0,
      appendTo: () => document.body
    });
    o._tippy = r.value;
  },
  updated(o, e) {
    var r;
    (r = o._tippy) == null || r.setContent(e.value);
  },
  unmounted(o) {
    var e;
    (e = o._tippy) == null || e.destroy();
  }
}, JI = /* @__PURE__ */ H({
  __name: "CopyToClipboard",
  props: {
    tooltip: {},
    value: {}
  },
  setup(o) {
    const e = o, { copy: r, copied: t } = Wh({
      legacy: !0,
      source: e.value.toString()
    });
    return (n, a) => co((k(), N("button", {
      class: "relative",
      type: "button",
      onClick: a[0] || (a[0] = (s) => B(r)(n.value.toString()))
    }, [
      z(vr),
      B(t) ? (k(), R(B(le), {
        key: 1,
        icon: B(NF),
        class: "size-4 text-emerald-800",
        "aria-hidden": "true"
      }, null, 8, ["icon"])) : (k(), N(ye, { key: 0 }, [
        z(B(le), {
          icon: B(VF),
          class: "size-4",
          "aria-hidden": "true"
        }, null, 8, ["icon"]),
        a[1] || (a[1] = O("span", { class: "sr-only" }, " Copy to clipboard ", -1))
      ], 64))
    ])), [
      [B(Up), n.tooltip]
    ]);
  }
}), _I = /* @__PURE__ */ H({
  __name: "Description",
  props: {
    as: { default: "p" }
  },
  setup(o) {
    const e = ce("field-id", "");
    return (r, t) => (k(), R(oo, {
      id: B(e) ? `${B(e)}-description` : void 0,
      as: r.as,
      color: "secondary"
    }, {
      default: j(() => [
        I(r.$slots, "default")
      ]),
      _: 3
    }, 8, ["id", "as"]));
  }
}), cE = {}, uE = {
  class: /* @__PURE__ */ q([
    "pt-1 pb-3 text-default-700",
    "sm:border-t sm:border-default-950/5 sm:py-3 sm:[&:nth-child(2)]:border-none"
  ])
};
function pE(o, e) {
  return k(), N("dd", uE, [
    I(o.$slots, "default")
  ]);
}
const $I = /* @__PURE__ */ fe(cE, [["render", pE]]), dE = {}, gE = {
  class: /* @__PURE__ */ q([
    "grid grid-cols-1",
    "sm:grid-cols-[min(50%,calc(.25rem*80))_auto] sm:text-sm/6"
  ])
};
function mE(o, e) {
  return k(), N("dl", gE, [
    I(o.$slots, "default")
  ]);
}
const eR = /* @__PURE__ */ fe(dE, [["render", mE]]), fE = {}, yE = {
  class: /* @__PURE__ */ q([
    "col-start-1 border-t border-default-950/5 pt-3 text-default-500",
    "first:border-none",
    "sm:border-t sm:border-default-950/5 sm:py-3"
  ])
};
function hE(o, e) {
  return k(), N("dt", yE, [
    I(o.$slots, "default")
  ]);
}
const oR = /* @__PURE__ */ fe(fE, [["render", hE]]), FE = {
  class: "size-full",
  xmlns: "http://www.w3.org/2000/svg"
}, bE = ["id"], vE = ["fill"], rR = /* @__PURE__ */ H({
  __name: "DotPattern",
  setup(o) {
    const e = fo();
    return (r, t) => (k(), N("svg", FE, [
      O("defs", null, [
        O("pattern", {
          id: B(e),
          x: "8",
          y: "8",
          width: "16",
          height: "16",
          patternUnits: "userSpaceOnUse"
        }, t[0] || (t[0] = [
          O("circle", {
            cx: "0.5",
            cy: "0.5",
            r: "0.5",
            fill: "currentColor"
          }, null, -1)
        ]), 8, bE)
      ]),
      O("rect", {
        width: "100%",
        height: "100%",
        fill: `url(#${B(e)})`
      }, null, 8, vE)
    ]));
  }
}), BE = { class: "fixed inset-0 overflow-hidden" }, PE = { class: "absolute inset-0 overflow-hidden" }, tR = /* @__PURE__ */ H({
  inheritAttrs: !1,
  __name: "Drawer",
  props: {
    color: { default: "white" },
    direction: { default: "right" },
    open: { type: Boolean, default: !1 }
  },
  emits: ["close"],
  setup(o, { emit: e }) {
    const r = o, t = e;
    return he("color", r.color), he("emit", t), (n, a) => (k(), R(B(Wa), {
      appear: "",
      as: "template",
      show: n.open
    }, {
      default: j(() => [
        z(B(Na), {
          as: "div",
          class: "relative z-[60]",
          onClose: a[0] || (a[0] = (s) => t("close"))
        }, {
          default: j(() => [
            z(B(tr), {
              as: "template",
              enter: "ease-in-out duration-500",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "ease-in-out duration-500",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: j(() => a[1] || (a[1] = [
                O("div", { class: "fixed inset-0 bg-black/25 transition-opacity" }, null, -1)
              ])),
              _: 1
            }),
            O("div", BE, [
              O("div", PE, [
                O("div", {
                  class: q(["pointer-events-none fixed inset-y-0 flex max-w-full", n.direction === "right" ? "pl-10 right-0" : "pr-10 left-0"])
                }, [
                  z(B(tr), {
                    as: "template",
                    enter: "transform transition ease-in-out duration-500 sm:duration-700",
                    "enter-from": n.direction === "right" ? "translate-x-full" : "-translate-x-full",
                    "enter-to": "translate-x-0",
                    leave: "transform transition ease-in-out duration-500 sm:duration-700",
                    "leave-from": "translate-x-0",
                    "leave-to": n.direction === "right" ? "translate-x-full" : "-translate-x-full"
                  }, {
                    default: j(() => [
                      z(B(Va), Ve({ class: "bg-white pointer-events-auto w-screen max-w-lg divide-y divide-default-300 flex flex-col" }, n.$attrs), {
                        default: j(() => [
                          I(n.$slots, "default")
                        ]),
                        _: 3
                      }, 16)
                    ]),
                    _: 3
                  }, 8, ["enter-from", "leave-to"])
                ], 2)
              ])
            ])
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["show"]));
  }
}), nR = /* @__PURE__ */ H({
  __name: "DrawerContent",
  setup(o) {
    const e = ce("color"), r = /* @__PURE__ */ new Map([
      ["white", "bg-white"],
      ["gray", "bg-default-100"]
    ]);
    return (t, n) => (k(), N("div", {
      class: q([
        "flex-1 overflow-y-auto py-6 px-4",
        "sm:px-6",
        B(r).get(B(e) ?? "white")
      ])
    }, [
      I(t.$slots, "default")
    ], 2));
  }
}), aR = /* @__PURE__ */ H({
  __name: "DrawerDescription",
  setup(o) {
    return (e, r) => (k(), R(oo, { as: B(_u) }, {
      default: j(() => [
        I(e.$slots, "default")
      ]),
      _: 3
    }, 8, ["as"]));
  }
}), wE = {}, kE = { class: "flex flex-row-reverse justify-start gap-2 px-6 py-4" };
function DE(o, e) {
  return k(), N("div", kE, [
    I(o.$slots, "default")
  ]);
}
const sR = /* @__PURE__ */ fe(wE, [["render", DE]]), SE = {
  class: "py-2 pl-6 pr-2 flex items-center justify-between gap-2",
  "data-slot": "drawer-header"
}, AE = { class: "flex-none flex gap-2" }, EE = { class: "flex-none flex gap-2" }, iR = /* @__PURE__ */ H({
  __name: "DrawerHeader",
  setup(o) {
    const e = ce("emit");
    return (r, t) => (k(), N("div", SE, [
      O("div", AE, [
        I(r.$slots, "default")
      ]),
      O("div", EE, [
        I(r.$slots, "buttons"),
        z(Re, {
          color: "tertiary",
          ariaLabel: "Close",
          type: "button",
          icon: B(Hr),
          onClick: t[0] || (t[0] = (n) => B(e) && B(e)("close"))
        }, null, 8, ["icon"])
      ])
    ]));
  }
}), lR = /* @__PURE__ */ H({
  __name: "DrawerTitle",
  setup(o) {
    return (e, r) => (k(), R(Vo, { as: B(yi) }, {
      default: j(() => [
        I(e.$slots, "default")
      ]),
      _: 3
    }, 8, ["as"]));
  }
}), cR = /* @__PURE__ */ H({
  __name: "Dropdown",
  props: {
    disabled: { type: Boolean },
    trigger: { default: void 0 },
    placement: { default: void 0 },
    variant: { default: "default" }
  },
  setup(o) {
    return (e, r) => (k(), R(B(Ah), {
      as: "div",
      class: "inline-block text-left"
    }, {
      default: j(({ open: t }) => [
        z(B(Vh), {
          placement: e.placement,
          offset: 4,
          enter: "transition ease-out duration-100",
          "enter-from": "transform opacity-0 scale-95",
          "enter-to": "transform opacity-100 scale-100",
          leave: "transition ease-in duration-75",
          "leave-from": "transform opacity-100 scale-100",
          "leave-to": "transform opacity-0 scale-95"
        }, {
          default: j(() => [
            e.variant === "default" ? (k(), N(ye, { key: 0 }, [
              e.$slots.trigger ? I(e.$slots, "trigger", {
                key: 0,
                open: t,
                disabled: e.disabled
              }) : (k(), R(B(eu), {
                key: 1,
                as: eo,
                "trailing-icon": t ? B(I3) : B(Sp),
                disabled: e.disabled,
                color: "secondary"
              }, {
                default: j(() => [
                  ne(_(e.trigger), 1)
                ]),
                _: 2
              }, 1032, ["trailing-icon", "disabled"]))
            ], 64)) : (k(), R(B(eu), {
              key: 1,
              as: Re,
              icon: B(N3),
              disabled: e.disabled,
              color: "tertiary",
              "aria-label": e.trigger
            }, null, 8, ["icon", "disabled", "aria-label"])),
            z(B(Eh), {
              class: q([
                "z-10 p-1 w-56 rounded-lg bg-white shadow border border-default-200 whitespace-normal",
                "focus:outline-none"
              ])
            }, {
              default: j(() => [
                I(e.$slots, "default")
              ]),
              _: 3
            })
          ]),
          _: 2
        }, 1032, ["placement"])
      ]),
      _: 3
    }));
  }
}), xE = {}, CE = {
  class: "-mx-1 h-px bg-default-100 my-1.5",
  role: "separator"
};
function OE(o, e) {
  return k(), N("div", CE);
}
const TE = /* @__PURE__ */ fe(xE, [["render", OE]]), LE = { class: "py-1.5 px-3 text-sm/6 text-default-900" }, uR = /* @__PURE__ */ H({
  __name: "DropdownHeader",
  setup(o) {
    return (e, r) => (k(), N(ye, null, [
      O("div", LE, [
        I(e.$slots, "default")
      ]),
      z(TE)
    ], 64));
  }
}), jE = { class: "inline-flex items-center gap-x-0.5" }, ME = { class: "inline-flex items-center gap-x-3" }, WE = {
  key: 0,
  class: "-mt-1.5"
}, pR = /* @__PURE__ */ H({
  inheritAttrs: !1,
  __name: "DropdownItem",
  props: {
    as: { default: void 0 },
    disabled: { type: Boolean },
    href: { default: void 0 },
    leadingIcon: { default: void 0 },
    variant: { default: "default" }
  },
  emits: ["click"],
  setup(o, { emit: e }) {
    const r = /* @__PURE__ */ new Map([
      ["default", "ui-active:bg-primary-600 ui-active:text-white text-default-900"],
      ["ai", "ui-active:bg-primary-600 ui-active:text-white text-default-900"],
      ["destructive", "ui-active:bg-red-600 ui-active:text-white ui-not-active:text-red-600"]
    ]), t = e;
    return (n, a) => (k(), R(B(xh), { disabled: n.disabled }, {
      default: j(({ active: s, close: i }) => [
        (k(), R(ve(n.as ?? (n.href ? B(yo) : "button")), Ve({
          href: n.href,
          class: [
            n.disabled && "opacity-50 pointer-events-none",
            "text-left w-full rounded-md py-1.5 px-3 leading-6 text-sm inline-flex items-center",
            B(r).get(n.variant)
          ]
        }, n.$attrs, {
          onClick: () => {
            t("click"), i();
          }
        }), {
          default: j(() => [
            O("span", jE, [
              O("span", ME, [
                n.leadingIcon ? (k(), R(B(le), {
                  key: 0,
                  icon: n.leadingIcon,
                  class: q([
                    !s && (n.variant === "default" || n.variant === "ai") && "text-default-500",
                    "size-4"
                  ]),
                  "aria-hidden": "true"
                }, null, 8, ["icon", "class"])) : K("", !0),
                O("span", null, [
                  I(n.$slots, "default")
                ])
              ]),
              n.variant === "ai" ? (k(), N("span", WE, [
                z(B(le), {
                  icon: B(B8),
                  "aria-hidden": "true",
                  class: q([
                    "size-3",
                    s ? "text-white" : "text-primary-600"
                  ])
                }, null, 8, ["icon", "class"])
              ])) : K("", !0)
            ])
          ]),
          _: 2
        }, 1040, ["href", "class", "onClick"]))
      ]),
      _: 3
    }, 8, ["disabled"]));
  }
}), Vf = /* @__PURE__ */ JSON.parse('[{"codes":"1F600","char":"😀","name":"grinning face","category":"Smileys & Emotion (face-smiling)","group":"Smileys & Emotion","subgroup":"face-smiling"},{"codes":"1F603","char":"😃","name":"grinning face with big eyes","category":"Smileys & Emotion (face-smiling)","group":"Smileys & Emotion","subgroup":"face-smiling"},{"codes":"1F604","char":"😄","name":"grinning face with smiling eyes","category":"Smileys & Emotion (face-smiling)","group":"Smileys & Emotion","subgroup":"face-smiling"},{"codes":"1F601","char":"😁","name":"beaming face with smiling eyes","category":"Smileys & Emotion (face-smiling)","group":"Smileys & Emotion","subgroup":"face-smiling"},{"codes":"1F606","char":"😆","name":"grinning squinting face","category":"Smileys & Emotion (face-smiling)","group":"Smileys & Emotion","subgroup":"face-smiling"},{"codes":"1F605","char":"😅","name":"grinning face with sweat","category":"Smileys & Emotion (face-smiling)","group":"Smileys & Emotion","subgroup":"face-smiling"},{"codes":"1F923","char":"🤣","name":"rolling on the floor laughing","category":"Smileys & Emotion (face-smiling)","group":"Smileys & Emotion","subgroup":"face-smiling"},{"codes":"1F602","char":"😂","name":"face with tears of joy","category":"Smileys & Emotion (face-smiling)","group":"Smileys & Emotion","subgroup":"face-smiling"},{"codes":"1F642","char":"🙂","name":"slightly smiling face","category":"Smileys & Emotion (face-smiling)","group":"Smileys & Emotion","subgroup":"face-smiling"},{"codes":"1F643","char":"🙃","name":"upside-down face","category":"Smileys & Emotion (face-smiling)","group":"Smileys & Emotion","subgroup":"face-smiling"},{"codes":"1FAE0","char":"🫠","name":"melting face","category":"Smileys & Emotion (face-smiling)","group":"Smileys & Emotion","subgroup":"face-smiling"},{"codes":"1F609","char":"😉","name":"winking face","category":"Smileys & Emotion (face-smiling)","group":"Smileys & Emotion","subgroup":"face-smiling"},{"codes":"1F60A","char":"😊","name":"smiling face with smiling eyes","category":"Smileys & Emotion (face-smiling)","group":"Smileys & Emotion","subgroup":"face-smiling"},{"codes":"1F607","char":"😇","name":"smiling face with halo","category":"Smileys & Emotion (face-smiling)","group":"Smileys & Emotion","subgroup":"face-smiling"},{"codes":"1F970","char":"🥰","name":"smiling face with hearts","category":"Smileys & Emotion (face-affection)","group":"Smileys & Emotion","subgroup":"face-affection"},{"codes":"1F60D","char":"😍","name":"smiling face with heart-eyes","category":"Smileys & Emotion (face-affection)","group":"Smileys & Emotion","subgroup":"face-affection"},{"codes":"1F929","char":"🤩","name":"star-struck","category":"Smileys & Emotion (face-affection)","group":"Smileys & Emotion","subgroup":"face-affection"},{"codes":"1F618","char":"😘","name":"face blowing a kiss","category":"Smileys & Emotion (face-affection)","group":"Smileys & Emotion","subgroup":"face-affection"},{"codes":"1F617","char":"😗","name":"kissing face","category":"Smileys & Emotion (face-affection)","group":"Smileys & Emotion","subgroup":"face-affection"},{"codes":"263A FE0F","char":"☺️","name":"smiling face","category":"Smileys & Emotion (face-affection)","group":"Smileys & Emotion","subgroup":"face-affection"},{"codes":"263A","char":"☺","name":"smiling face","category":"Smileys & Emotion (face-affection)","group":"Smileys & Emotion","subgroup":"face-affection"},{"codes":"1F61A","char":"😚","name":"kissing face with closed eyes","category":"Smileys & Emotion (face-affection)","group":"Smileys & Emotion","subgroup":"face-affection"},{"codes":"1F619","char":"😙","name":"kissing face with smiling eyes","category":"Smileys & Emotion (face-affection)","group":"Smileys & Emotion","subgroup":"face-affection"},{"codes":"1F972","char":"🥲","name":"smiling face with tear","category":"Smileys & Emotion (face-affection)","group":"Smileys & Emotion","subgroup":"face-affection"},{"codes":"1F60B","char":"😋","name":"face savoring food","category":"Smileys & Emotion (face-tongue)","group":"Smileys & Emotion","subgroup":"face-tongue"},{"codes":"1F61B","char":"😛","name":"face with tongue","category":"Smileys & Emotion (face-tongue)","group":"Smileys & Emotion","subgroup":"face-tongue"},{"codes":"1F61C","char":"😜","name":"winking face with tongue","category":"Smileys & Emotion (face-tongue)","group":"Smileys & Emotion","subgroup":"face-tongue"},{"codes":"1F92A","char":"🤪","name":"zany face","category":"Smileys & Emotion (face-tongue)","group":"Smileys & Emotion","subgroup":"face-tongue"},{"codes":"1F61D","char":"😝","name":"squinting face with tongue","category":"Smileys & Emotion (face-tongue)","group":"Smileys & Emotion","subgroup":"face-tongue"},{"codes":"1F911","char":"🤑","name":"money-mouth face","category":"Smileys & Emotion (face-tongue)","group":"Smileys & Emotion","subgroup":"face-tongue"},{"codes":"1F917","char":"🤗","name":"smiling face with open hands","category":"Smileys & Emotion (face-hand)","group":"Smileys & Emotion","subgroup":"face-hand"},{"codes":"1F92D","char":"🤭","name":"face with hand over mouth","category":"Smileys & Emotion (face-hand)","group":"Smileys & Emotion","subgroup":"face-hand"},{"codes":"1FAE2","char":"🫢","name":"face with open eyes and hand over mouth","category":"Smileys & Emotion (face-hand)","group":"Smileys & Emotion","subgroup":"face-hand"},{"codes":"1FAE3","char":"🫣","name":"face with peeking eye","category":"Smileys & Emotion (face-hand)","group":"Smileys & Emotion","subgroup":"face-hand"},{"codes":"1F92B","char":"🤫","name":"shushing face","category":"Smileys & Emotion (face-hand)","group":"Smileys & Emotion","subgroup":"face-hand"},{"codes":"1F914","char":"🤔","name":"thinking face","category":"Smileys & Emotion (face-hand)","group":"Smileys & Emotion","subgroup":"face-hand"},{"codes":"1FAE1","char":"🫡","name":"saluting face","category":"Smileys & Emotion (face-hand)","group":"Smileys & Emotion","subgroup":"face-hand"},{"codes":"1F910","char":"🤐","name":"zipper-mouth face","category":"Smileys & Emotion (face-neutral-skeptical)","group":"Smileys & Emotion","subgroup":"face-neutral-skeptical"},{"codes":"1F928","char":"🤨","name":"face with raised eyebrow","category":"Smileys & Emotion (face-neutral-skeptical)","group":"Smileys & Emotion","subgroup":"face-neutral-skeptical"},{"codes":"1F610","char":"😐","name":"neutral face","category":"Smileys & Emotion (face-neutral-skeptical)","group":"Smileys & Emotion","subgroup":"face-neutral-skeptical"},{"codes":"1F611","char":"😑","name":"expressionless face","category":"Smileys & Emotion (face-neutral-skeptical)","group":"Smileys & Emotion","subgroup":"face-neutral-skeptical"},{"codes":"1F636","char":"😶","name":"face without mouth","category":"Smileys & Emotion (face-neutral-skeptical)","group":"Smileys & Emotion","subgroup":"face-neutral-skeptical"},{"codes":"1FAE5","char":"🫥","name":"dotted line face","category":"Smileys & Emotion (face-neutral-skeptical)","group":"Smileys & Emotion","subgroup":"face-neutral-skeptical"},{"codes":"1F636 200D 1F32B FE0F","char":"😶‍🌫️","name":"face in clouds","category":"Smileys & Emotion (face-neutral-skeptical)","group":"Smileys & Emotion","subgroup":"face-neutral-skeptical"},{"codes":"1F636 200D 1F32B","char":"😶‍🌫","name":"face in clouds","category":"Smileys & Emotion (face-neutral-skeptical)","group":"Smileys & Emotion","subgroup":"face-neutral-skeptical"},{"codes":"1F60F","char":"😏","name":"smirking face","category":"Smileys & Emotion (face-neutral-skeptical)","group":"Smileys & Emotion","subgroup":"face-neutral-skeptical"},{"codes":"1F612","char":"😒","name":"unamused face","category":"Smileys & Emotion (face-neutral-skeptical)","group":"Smileys & Emotion","subgroup":"face-neutral-skeptical"},{"codes":"1F644","char":"🙄","name":"face with rolling eyes","category":"Smileys & Emotion (face-neutral-skeptical)","group":"Smileys & Emotion","subgroup":"face-neutral-skeptical"},{"codes":"1F62C","char":"😬","name":"grimacing face","category":"Smileys & Emotion (face-neutral-skeptical)","group":"Smileys & Emotion","subgroup":"face-neutral-skeptical"},{"codes":"1F62E 200D 1F4A8","char":"😮‍💨","name":"face exhaling","category":"Smileys & Emotion (face-neutral-skeptical)","group":"Smileys & Emotion","subgroup":"face-neutral-skeptical"},{"codes":"1F925","char":"🤥","name":"lying face","category":"Smileys & Emotion (face-neutral-skeptical)","group":"Smileys & Emotion","subgroup":"face-neutral-skeptical"},{"codes":"1FAE8","char":"🫨","name":"shaking face","category":"Smileys & Emotion (face-neutral-skeptical)","group":"Smileys & Emotion","subgroup":"face-neutral-skeptical"},{"codes":"1F642 200D 2194 FE0F","char":"🙂‍↔️","name":"head shaking horizontally","category":"Smileys & Emotion (face-neutral-skeptical)","group":"Smileys & Emotion","subgroup":"face-neutral-skeptical"},{"codes":"1F642 200D 2194","char":"🙂‍↔","name":"head shaking horizontally","category":"Smileys & Emotion (face-neutral-skeptical)","group":"Smileys & Emotion","subgroup":"face-neutral-skeptical"},{"codes":"1F642 200D 2195 FE0F","char":"🙂‍↕️","name":"head shaking vertically","category":"Smileys & Emotion (face-neutral-skeptical)","group":"Smileys & Emotion","subgroup":"face-neutral-skeptical"},{"codes":"1F642 200D 2195","char":"🙂‍↕","name":"head shaking vertically","category":"Smileys & Emotion (face-neutral-skeptical)","group":"Smileys & Emotion","subgroup":"face-neutral-skeptical"},{"codes":"1F60C","char":"😌","name":"relieved face","category":"Smileys & Emotion (face-sleepy)","group":"Smileys & Emotion","subgroup":"face-sleepy"},{"codes":"1F614","char":"😔","name":"pensive face","category":"Smileys & Emotion (face-sleepy)","group":"Smileys & Emotion","subgroup":"face-sleepy"},{"codes":"1F62A","char":"😪","name":"sleepy face","category":"Smileys & Emotion (face-sleepy)","group":"Smileys & Emotion","subgroup":"face-sleepy"},{"codes":"1F924","char":"🤤","name":"drooling face","category":"Smileys & Emotion (face-sleepy)","group":"Smileys & Emotion","subgroup":"face-sleepy"},{"codes":"1F634","char":"😴","name":"sleeping face","category":"Smileys & Emotion (face-sleepy)","group":"Smileys & Emotion","subgroup":"face-sleepy"},{"codes":"1F637","char":"😷","name":"face with medical mask","category":"Smileys & Emotion (face-unwell)","group":"Smileys & Emotion","subgroup":"face-unwell"},{"codes":"1F912","char":"🤒","name":"face with thermometer","category":"Smileys & Emotion (face-unwell)","group":"Smileys & Emotion","subgroup":"face-unwell"},{"codes":"1F915","char":"🤕","name":"face with head-bandage","category":"Smileys & Emotion (face-unwell)","group":"Smileys & Emotion","subgroup":"face-unwell"},{"codes":"1F922","char":"🤢","name":"nauseated face","category":"Smileys & Emotion (face-unwell)","group":"Smileys & Emotion","subgroup":"face-unwell"},{"codes":"1F92E","char":"🤮","name":"face vomiting","category":"Smileys & Emotion (face-unwell)","group":"Smileys & Emotion","subgroup":"face-unwell"},{"codes":"1F927","char":"🤧","name":"sneezing face","category":"Smileys & Emotion (face-unwell)","group":"Smileys & Emotion","subgroup":"face-unwell"},{"codes":"1F975","char":"🥵","name":"hot face","category":"Smileys & Emotion (face-unwell)","group":"Smileys & Emotion","subgroup":"face-unwell"},{"codes":"1F976","char":"🥶","name":"cold face","category":"Smileys & Emotion (face-unwell)","group":"Smileys & Emotion","subgroup":"face-unwell"},{"codes":"1F974","char":"🥴","name":"woozy face","category":"Smileys & Emotion (face-unwell)","group":"Smileys & Emotion","subgroup":"face-unwell"},{"codes":"1F635","char":"😵","name":"face with crossed-out eyes","category":"Smileys & Emotion (face-unwell)","group":"Smileys & Emotion","subgroup":"face-unwell"},{"codes":"1F635 200D 1F4AB","char":"😵‍💫","name":"face with spiral eyes","category":"Smileys & Emotion (face-unwell)","group":"Smileys & Emotion","subgroup":"face-unwell"},{"codes":"1F92F","char":"🤯","name":"exploding head","category":"Smileys & Emotion (face-unwell)","group":"Smileys & Emotion","subgroup":"face-unwell"},{"codes":"1F920","char":"🤠","name":"cowboy hat face","category":"Smileys & Emotion (face-hat)","group":"Smileys & Emotion","subgroup":"face-hat"},{"codes":"1F973","char":"🥳","name":"partying face","category":"Smileys & Emotion (face-hat)","group":"Smileys & Emotion","subgroup":"face-hat"},{"codes":"1F978","char":"🥸","name":"disguised face","category":"Smileys & Emotion (face-hat)","group":"Smileys & Emotion","subgroup":"face-hat"},{"codes":"1F60E","char":"😎","name":"smiling face with sunglasses","category":"Smileys & Emotion (face-glasses)","group":"Smileys & Emotion","subgroup":"face-glasses"},{"codes":"1F913","char":"🤓","name":"nerd face","category":"Smileys & Emotion (face-glasses)","group":"Smileys & Emotion","subgroup":"face-glasses"},{"codes":"1F9D0","char":"🧐","name":"face with monocle","category":"Smileys & Emotion (face-glasses)","group":"Smileys & Emotion","subgroup":"face-glasses"},{"codes":"1F615","char":"😕","name":"confused face","category":"Smileys & Emotion (face-concerned)","group":"Smileys & Emotion","subgroup":"face-concerned"},{"codes":"1FAE4","char":"🫤","name":"face with diagonal mouth","category":"Smileys & Emotion (face-concerned)","group":"Smileys & Emotion","subgroup":"face-concerned"},{"codes":"1F61F","char":"😟","name":"worried face","category":"Smileys & Emotion (face-concerned)","group":"Smileys & Emotion","subgroup":"face-concerned"},{"codes":"1F641","char":"🙁","name":"slightly frowning face","category":"Smileys & Emotion (face-concerned)","group":"Smileys & Emotion","subgroup":"face-concerned"},{"codes":"2639 FE0F","char":"☹️","name":"frowning face","category":"Smileys & Emotion (face-concerned)","group":"Smileys & Emotion","subgroup":"face-concerned"},{"codes":"2639","char":"☹","name":"frowning face","category":"Smileys & Emotion (face-concerned)","group":"Smileys & Emotion","subgroup":"face-concerned"},{"codes":"1F62E","char":"😮","name":"face with open mouth","category":"Smileys & Emotion (face-concerned)","group":"Smileys & Emotion","subgroup":"face-concerned"},{"codes":"1F62F","char":"😯","name":"hushed face","category":"Smileys & Emotion (face-concerned)","group":"Smileys & Emotion","subgroup":"face-concerned"},{"codes":"1F632","char":"😲","name":"astonished face","category":"Smileys & Emotion (face-concerned)","group":"Smileys & Emotion","subgroup":"face-concerned"},{"codes":"1F633","char":"😳","name":"flushed face","category":"Smileys & Emotion (face-concerned)","group":"Smileys & Emotion","subgroup":"face-concerned"},{"codes":"1F97A","char":"🥺","name":"pleading face","category":"Smileys & Emotion (face-concerned)","group":"Smileys & Emotion","subgroup":"face-concerned"},{"codes":"1F979","char":"🥹","name":"face holding back tears","category":"Smileys & Emotion (face-concerned)","group":"Smileys & Emotion","subgroup":"face-concerned"},{"codes":"1F626","char":"😦","name":"frowning face with open mouth","category":"Smileys & Emotion (face-concerned)","group":"Smileys & Emotion","subgroup":"face-concerned"},{"codes":"1F627","char":"😧","name":"anguished face","category":"Smileys & Emotion (face-concerned)","group":"Smileys & Emotion","subgroup":"face-concerned"},{"codes":"1F628","char":"😨","name":"fearful face","category":"Smileys & Emotion (face-concerned)","group":"Smileys & Emotion","subgroup":"face-concerned"},{"codes":"1F630","char":"😰","name":"anxious face with sweat","category":"Smileys & Emotion (face-concerned)","group":"Smileys & Emotion","subgroup":"face-concerned"},{"codes":"1F625","char":"😥","name":"sad but relieved face","category":"Smileys & Emotion (face-concerned)","group":"Smileys & Emotion","subgroup":"face-concerned"},{"codes":"1F622","char":"😢","name":"crying face","category":"Smileys & Emotion (face-concerned)","group":"Smileys & Emotion","subgroup":"face-concerned"},{"codes":"1F62D","char":"😭","name":"loudly crying face","category":"Smileys & Emotion (face-concerned)","group":"Smileys & Emotion","subgroup":"face-concerned"},{"codes":"1F631","char":"😱","name":"face screaming in fear","category":"Smileys & Emotion (face-concerned)","group":"Smileys & Emotion","subgroup":"face-concerned"},{"codes":"1F616","char":"😖","name":"confounded face","category":"Smileys & Emotion (face-concerned)","group":"Smileys & Emotion","subgroup":"face-concerned"},{"codes":"1F623","char":"😣","name":"persevering face","category":"Smileys & Emotion (face-concerned)","group":"Smileys & Emotion","subgroup":"face-concerned"},{"codes":"1F61E","char":"😞","name":"disappointed face","category":"Smileys & Emotion (face-concerned)","group":"Smileys & Emotion","subgroup":"face-concerned"},{"codes":"1F613","char":"😓","name":"downcast face with sweat","category":"Smileys & Emotion (face-concerned)","group":"Smileys & Emotion","subgroup":"face-concerned"},{"codes":"1F629","char":"😩","name":"weary face","category":"Smileys & Emotion (face-concerned)","group":"Smileys & Emotion","subgroup":"face-concerned"},{"codes":"1F62B","char":"😫","name":"tired face","category":"Smileys & Emotion (face-concerned)","group":"Smileys & Emotion","subgroup":"face-concerned"},{"codes":"1F971","char":"🥱","name":"yawning face","category":"Smileys & Emotion (face-concerned)","group":"Smileys & Emotion","subgroup":"face-concerned"},{"codes":"1F624","char":"😤","name":"face with steam from nose","category":"Smileys & Emotion (face-negative)","group":"Smileys & Emotion","subgroup":"face-negative"},{"codes":"1F621","char":"😡","name":"enraged face","category":"Smileys & Emotion (face-negative)","group":"Smileys & Emotion","subgroup":"face-negative"},{"codes":"1F620","char":"😠","name":"angry face","category":"Smileys & Emotion (face-negative)","group":"Smileys & Emotion","subgroup":"face-negative"},{"codes":"1F92C","char":"🤬","name":"face with symbols on mouth","category":"Smileys & Emotion (face-negative)","group":"Smileys & Emotion","subgroup":"face-negative"},{"codes":"1F608","char":"😈","name":"smiling face with horns","category":"Smileys & Emotion (face-negative)","group":"Smileys & Emotion","subgroup":"face-negative"},{"codes":"1F47F","char":"👿","name":"angry face with horns","category":"Smileys & Emotion (face-negative)","group":"Smileys & Emotion","subgroup":"face-negative"},{"codes":"1F480","char":"💀","name":"skull","category":"Smileys & Emotion (face-negative)","group":"Smileys & Emotion","subgroup":"face-negative"},{"codes":"2620 FE0F","char":"☠️","name":"skull and crossbones","category":"Smileys & Emotion (face-negative)","group":"Smileys & Emotion","subgroup":"face-negative"},{"codes":"2620","char":"☠","name":"skull and crossbones","category":"Smileys & Emotion (face-negative)","group":"Smileys & Emotion","subgroup":"face-negative"},{"codes":"1F4A9","char":"💩","name":"pile of poo","category":"Smileys & Emotion (face-costume)","group":"Smileys & Emotion","subgroup":"face-costume"},{"codes":"1F921","char":"🤡","name":"clown face","category":"Smileys & Emotion (face-costume)","group":"Smileys & Emotion","subgroup":"face-costume"},{"codes":"1F479","char":"👹","name":"ogre","category":"Smileys & Emotion (face-costume)","group":"Smileys & Emotion","subgroup":"face-costume"},{"codes":"1F47A","char":"👺","name":"goblin","category":"Smileys & Emotion (face-costume)","group":"Smileys & Emotion","subgroup":"face-costume"},{"codes":"1F47B","char":"👻","name":"ghost","category":"Smileys & Emotion (face-costume)","group":"Smileys & Emotion","subgroup":"face-costume"},{"codes":"1F47D","char":"👽","name":"alien","category":"Smileys & Emotion (face-costume)","group":"Smileys & Emotion","subgroup":"face-costume"},{"codes":"1F47E","char":"👾","name":"alien monster","category":"Smileys & Emotion (face-costume)","group":"Smileys & Emotion","subgroup":"face-costume"},{"codes":"1F916","char":"🤖","name":"robot","category":"Smileys & Emotion (face-costume)","group":"Smileys & Emotion","subgroup":"face-costume"},{"codes":"1F63A","char":"😺","name":"grinning cat","category":"Smileys & Emotion (cat-face)","group":"Smileys & Emotion","subgroup":"cat-face"},{"codes":"1F638","char":"😸","name":"grinning cat with smiling eyes","category":"Smileys & Emotion (cat-face)","group":"Smileys & Emotion","subgroup":"cat-face"},{"codes":"1F639","char":"😹","name":"cat with tears of joy","category":"Smileys & Emotion (cat-face)","group":"Smileys & Emotion","subgroup":"cat-face"},{"codes":"1F63B","char":"😻","name":"smiling cat with heart-eyes","category":"Smileys & Emotion (cat-face)","group":"Smileys & Emotion","subgroup":"cat-face"},{"codes":"1F63C","char":"😼","name":"cat with wry smile","category":"Smileys & Emotion (cat-face)","group":"Smileys & Emotion","subgroup":"cat-face"},{"codes":"1F63D","char":"😽","name":"kissing cat","category":"Smileys & Emotion (cat-face)","group":"Smileys & Emotion","subgroup":"cat-face"},{"codes":"1F640","char":"🙀","name":"weary cat","category":"Smileys & Emotion (cat-face)","group":"Smileys & Emotion","subgroup":"cat-face"},{"codes":"1F63F","char":"😿","name":"crying cat","category":"Smileys & Emotion (cat-face)","group":"Smileys & Emotion","subgroup":"cat-face"},{"codes":"1F63E","char":"😾","name":"pouting cat","category":"Smileys & Emotion (cat-face)","group":"Smileys & Emotion","subgroup":"cat-face"},{"codes":"1F648","char":"🙈","name":"see-no-evil monkey","category":"Smileys & Emotion (monkey-face)","group":"Smileys & Emotion","subgroup":"monkey-face"},{"codes":"1F649","char":"🙉","name":"hear-no-evil monkey","category":"Smileys & Emotion (monkey-face)","group":"Smileys & Emotion","subgroup":"monkey-face"},{"codes":"1F64A","char":"🙊","name":"speak-no-evil monkey","category":"Smileys & Emotion (monkey-face)","group":"Smileys & Emotion","subgroup":"monkey-face"},{"codes":"1F48C","char":"💌","name":"love letter","category":"Smileys & Emotion (heart)","group":"Smileys & Emotion","subgroup":"heart"},{"codes":"1F498","char":"💘","name":"heart with arrow","category":"Smileys & Emotion (heart)","group":"Smileys & Emotion","subgroup":"heart"},{"codes":"1F49D","char":"💝","name":"heart with ribbon","category":"Smileys & Emotion (heart)","group":"Smileys & Emotion","subgroup":"heart"},{"codes":"1F496","char":"💖","name":"sparkling heart","category":"Smileys & Emotion (heart)","group":"Smileys & Emotion","subgroup":"heart"},{"codes":"1F497","char":"💗","name":"growing heart","category":"Smileys & Emotion (heart)","group":"Smileys & Emotion","subgroup":"heart"},{"codes":"1F493","char":"💓","name":"beating heart","category":"Smileys & Emotion (heart)","group":"Smileys & Emotion","subgroup":"heart"},{"codes":"1F49E","char":"💞","name":"revolving hearts","category":"Smileys & Emotion (heart)","group":"Smileys & Emotion","subgroup":"heart"},{"codes":"1F495","char":"💕","name":"two hearts","category":"Smileys & Emotion (heart)","group":"Smileys & Emotion","subgroup":"heart"},{"codes":"1F49F","char":"💟","name":"heart decoration","category":"Smileys & Emotion (heart)","group":"Smileys & Emotion","subgroup":"heart"},{"codes":"2763 FE0F","char":"❣️","name":"heart exclamation","category":"Smileys & Emotion (heart)","group":"Smileys & Emotion","subgroup":"heart"},{"codes":"2763","char":"❣","name":"heart exclamation","category":"Smileys & Emotion (heart)","group":"Smileys & Emotion","subgroup":"heart"},{"codes":"1F494","char":"💔","name":"broken heart","category":"Smileys & Emotion (heart)","group":"Smileys & Emotion","subgroup":"heart"},{"codes":"2764 FE0F 200D 1F525","char":"❤️‍🔥","name":"heart on fire","category":"Smileys & Emotion (heart)","group":"Smileys & Emotion","subgroup":"heart"},{"codes":"2764 200D 1F525","char":"❤‍🔥","name":"heart on fire","category":"Smileys & Emotion (heart)","group":"Smileys & Emotion","subgroup":"heart"},{"codes":"2764 FE0F 200D 1FA79","char":"❤️‍🩹","name":"mending heart","category":"Smileys & Emotion (heart)","group":"Smileys & Emotion","subgroup":"heart"},{"codes":"2764 200D 1FA79","char":"❤‍🩹","name":"mending heart","category":"Smileys & Emotion (heart)","group":"Smileys & Emotion","subgroup":"heart"},{"codes":"2764 FE0F","char":"❤️","name":"red heart","category":"Smileys & Emotion (heart)","group":"Smileys & Emotion","subgroup":"heart"},{"codes":"2764","char":"❤","name":"red heart","category":"Smileys & Emotion (heart)","group":"Smileys & Emotion","subgroup":"heart"},{"codes":"1FA77","char":"🩷","name":"pink heart","category":"Smileys & Emotion (heart)","group":"Smileys & Emotion","subgroup":"heart"},{"codes":"1F9E1","char":"🧡","name":"orange heart","category":"Smileys & Emotion (heart)","group":"Smileys & Emotion","subgroup":"heart"},{"codes":"1F49B","char":"💛","name":"yellow heart","category":"Smileys & Emotion (heart)","group":"Smileys & Emotion","subgroup":"heart"},{"codes":"1F49A","char":"💚","name":"green heart","category":"Smileys & Emotion (heart)","group":"Smileys & Emotion","subgroup":"heart"},{"codes":"1F499","char":"💙","name":"blue heart","category":"Smileys & Emotion (heart)","group":"Smileys & Emotion","subgroup":"heart"},{"codes":"1FA75","char":"🩵","name":"light blue heart","category":"Smileys & Emotion (heart)","group":"Smileys & Emotion","subgroup":"heart"},{"codes":"1F49C","char":"💜","name":"purple heart","category":"Smileys & Emotion (heart)","group":"Smileys & Emotion","subgroup":"heart"},{"codes":"1F90E","char":"🤎","name":"brown heart","category":"Smileys & Emotion (heart)","group":"Smileys & Emotion","subgroup":"heart"},{"codes":"1F5A4","char":"🖤","name":"black heart","category":"Smileys & Emotion (heart)","group":"Smileys & Emotion","subgroup":"heart"},{"codes":"1FA76","char":"🩶","name":"grey heart","category":"Smileys & Emotion (heart)","group":"Smileys & Emotion","subgroup":"heart"},{"codes":"1F90D","char":"🤍","name":"white heart","category":"Smileys & Emotion (heart)","group":"Smileys & Emotion","subgroup":"heart"},{"codes":"1F48B","char":"💋","name":"kiss mark","category":"Smileys & Emotion (emotion)","group":"Smileys & Emotion","subgroup":"emotion"},{"codes":"1F4AF","char":"💯","name":"hundred points","category":"Smileys & Emotion (emotion)","group":"Smileys & Emotion","subgroup":"emotion"},{"codes":"1F4A2","char":"💢","name":"anger symbol","category":"Smileys & Emotion (emotion)","group":"Smileys & Emotion","subgroup":"emotion"},{"codes":"1F4A5","char":"💥","name":"collision","category":"Smileys & Emotion (emotion)","group":"Smileys & Emotion","subgroup":"emotion"},{"codes":"1F4AB","char":"💫","name":"dizzy","category":"Smileys & Emotion (emotion)","group":"Smileys & Emotion","subgroup":"emotion"},{"codes":"1F4A6","char":"💦","name":"sweat droplets","category":"Smileys & Emotion (emotion)","group":"Smileys & Emotion","subgroup":"emotion"},{"codes":"1F4A8","char":"💨","name":"dashing away","category":"Smileys & Emotion (emotion)","group":"Smileys & Emotion","subgroup":"emotion"},{"codes":"1F573 FE0F","char":"🕳️","name":"hole","category":"Smileys & Emotion (emotion)","group":"Smileys & Emotion","subgroup":"emotion"},{"codes":"1F573","char":"🕳","name":"hole","category":"Smileys & Emotion (emotion)","group":"Smileys & Emotion","subgroup":"emotion"},{"codes":"1F4AC","char":"💬","name":"speech balloon","category":"Smileys & Emotion (emotion)","group":"Smileys & Emotion","subgroup":"emotion"},{"codes":"1F441 FE0F 200D 1F5E8 FE0F","char":"👁️‍🗨️","name":"eye in speech bubble","category":"Smileys & Emotion (emotion)","group":"Smileys & Emotion","subgroup":"emotion"},{"codes":"1F441 200D 1F5E8 FE0F","char":"👁‍🗨️","name":"eye in speech bubble","category":"Smileys & Emotion (emotion)","group":"Smileys & Emotion","subgroup":"emotion"},{"codes":"1F441 FE0F 200D 1F5E8","char":"👁️‍🗨","name":"eye in speech bubble","category":"Smileys & Emotion (emotion)","group":"Smileys & Emotion","subgroup":"emotion"},{"codes":"1F441 200D 1F5E8","char":"👁‍🗨","name":"eye in speech bubble","category":"Smileys & Emotion (emotion)","group":"Smileys & Emotion","subgroup":"emotion"},{"codes":"1F5E8 FE0F","char":"🗨️","name":"left speech bubble","category":"Smileys & Emotion (emotion)","group":"Smileys & Emotion","subgroup":"emotion"},{"codes":"1F5E8","char":"🗨","name":"left speech bubble","category":"Smileys & Emotion (emotion)","group":"Smileys & Emotion","subgroup":"emotion"},{"codes":"1F5EF FE0F","char":"🗯️","name":"right anger bubble","category":"Smileys & Emotion (emotion)","group":"Smileys & Emotion","subgroup":"emotion"},{"codes":"1F5EF","char":"🗯","name":"right anger bubble","category":"Smileys & Emotion (emotion)","group":"Smileys & Emotion","subgroup":"emotion"},{"codes":"1F4AD","char":"💭","name":"thought balloon","category":"Smileys & Emotion (emotion)","group":"Smileys & Emotion","subgroup":"emotion"},{"codes":"1F4A4","char":"💤","name":"ZZZ","category":"Smileys & Emotion (emotion)","group":"Smileys & Emotion","subgroup":"emotion"},{"codes":"1F44B","char":"👋","name":"waving hand","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1F44B 1F3FB","char":"👋🏻","name":"waving hand: light skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1F44B 1F3FC","char":"👋🏼","name":"waving hand: medium-light skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1F44B 1F3FD","char":"👋🏽","name":"waving hand: medium skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1F44B 1F3FE","char":"👋🏾","name":"waving hand: medium-dark skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1F44B 1F3FF","char":"👋🏿","name":"waving hand: dark skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1F91A","char":"🤚","name":"raised back of hand","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1F91A 1F3FB","char":"🤚🏻","name":"raised back of hand: light skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1F91A 1F3FC","char":"🤚🏼","name":"raised back of hand: medium-light skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1F91A 1F3FD","char":"🤚🏽","name":"raised back of hand: medium skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1F91A 1F3FE","char":"🤚🏾","name":"raised back of hand: medium-dark skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1F91A 1F3FF","char":"🤚🏿","name":"raised back of hand: dark skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1F590 FE0F","char":"🖐️","name":"hand with fingers splayed","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1F590","char":"🖐","name":"hand with fingers splayed","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1F590 1F3FB","char":"🖐🏻","name":"hand with fingers splayed: light skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1F590 1F3FC","char":"🖐🏼","name":"hand with fingers splayed: medium-light skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1F590 1F3FD","char":"🖐🏽","name":"hand with fingers splayed: medium skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1F590 1F3FE","char":"🖐🏾","name":"hand with fingers splayed: medium-dark skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1F590 1F3FF","char":"🖐🏿","name":"hand with fingers splayed: dark skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"270B","char":"✋","name":"raised hand","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"270B 1F3FB","char":"✋🏻","name":"raised hand: light skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"270B 1F3FC","char":"✋🏼","name":"raised hand: medium-light skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"270B 1F3FD","char":"✋🏽","name":"raised hand: medium skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"270B 1F3FE","char":"✋🏾","name":"raised hand: medium-dark skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"270B 1F3FF","char":"✋🏿","name":"raised hand: dark skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1F596","char":"🖖","name":"vulcan salute","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1F596 1F3FB","char":"🖖🏻","name":"vulcan salute: light skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1F596 1F3FC","char":"🖖🏼","name":"vulcan salute: medium-light skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1F596 1F3FD","char":"🖖🏽","name":"vulcan salute: medium skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1F596 1F3FE","char":"🖖🏾","name":"vulcan salute: medium-dark skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1F596 1F3FF","char":"🖖🏿","name":"vulcan salute: dark skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1FAF1","char":"🫱","name":"rightwards hand","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1FAF1 1F3FB","char":"🫱🏻","name":"rightwards hand: light skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1FAF1 1F3FC","char":"🫱🏼","name":"rightwards hand: medium-light skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1FAF1 1F3FD","char":"🫱🏽","name":"rightwards hand: medium skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1FAF1 1F3FE","char":"🫱🏾","name":"rightwards hand: medium-dark skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1FAF1 1F3FF","char":"🫱🏿","name":"rightwards hand: dark skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1FAF2","char":"🫲","name":"leftwards hand","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1FAF2 1F3FB","char":"🫲🏻","name":"leftwards hand: light skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1FAF2 1F3FC","char":"🫲🏼","name":"leftwards hand: medium-light skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1FAF2 1F3FD","char":"🫲🏽","name":"leftwards hand: medium skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1FAF2 1F3FE","char":"🫲🏾","name":"leftwards hand: medium-dark skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1FAF2 1F3FF","char":"🫲🏿","name":"leftwards hand: dark skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1FAF3","char":"🫳","name":"palm down hand","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1FAF3 1F3FB","char":"🫳🏻","name":"palm down hand: light skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1FAF3 1F3FC","char":"🫳🏼","name":"palm down hand: medium-light skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1FAF3 1F3FD","char":"🫳🏽","name":"palm down hand: medium skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1FAF3 1F3FE","char":"🫳🏾","name":"palm down hand: medium-dark skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1FAF3 1F3FF","char":"🫳🏿","name":"palm down hand: dark skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1FAF4","char":"🫴","name":"palm up hand","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1FAF4 1F3FB","char":"🫴🏻","name":"palm up hand: light skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1FAF4 1F3FC","char":"🫴🏼","name":"palm up hand: medium-light skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1FAF4 1F3FD","char":"🫴🏽","name":"palm up hand: medium skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1FAF4 1F3FE","char":"🫴🏾","name":"palm up hand: medium-dark skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1FAF4 1F3FF","char":"🫴🏿","name":"palm up hand: dark skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1FAF7","char":"🫷","name":"leftwards pushing hand","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1FAF7 1F3FB","char":"🫷🏻","name":"leftwards pushing hand: light skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1FAF7 1F3FC","char":"🫷🏼","name":"leftwards pushing hand: medium-light skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1FAF7 1F3FD","char":"🫷🏽","name":"leftwards pushing hand: medium skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1FAF7 1F3FE","char":"🫷🏾","name":"leftwards pushing hand: medium-dark skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1FAF7 1F3FF","char":"🫷🏿","name":"leftwards pushing hand: dark skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1FAF8","char":"🫸","name":"rightwards pushing hand","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1FAF8 1F3FB","char":"🫸🏻","name":"rightwards pushing hand: light skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1FAF8 1F3FC","char":"🫸🏼","name":"rightwards pushing hand: medium-light skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1FAF8 1F3FD","char":"🫸🏽","name":"rightwards pushing hand: medium skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1FAF8 1F3FE","char":"🫸🏾","name":"rightwards pushing hand: medium-dark skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1FAF8 1F3FF","char":"🫸🏿","name":"rightwards pushing hand: dark skin tone","category":"People & Body (hand-fingers-open)","group":"People & Body","subgroup":"hand-fingers-open"},{"codes":"1F44C","char":"👌","name":"OK hand","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F44C 1F3FB","char":"👌🏻","name":"OK hand: light skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F44C 1F3FC","char":"👌🏼","name":"OK hand: medium-light skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F44C 1F3FD","char":"👌🏽","name":"OK hand: medium skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F44C 1F3FE","char":"👌🏾","name":"OK hand: medium-dark skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F44C 1F3FF","char":"👌🏿","name":"OK hand: dark skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F90C","char":"🤌","name":"pinched fingers","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F90C 1F3FB","char":"🤌🏻","name":"pinched fingers: light skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F90C 1F3FC","char":"🤌🏼","name":"pinched fingers: medium-light skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F90C 1F3FD","char":"🤌🏽","name":"pinched fingers: medium skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F90C 1F3FE","char":"🤌🏾","name":"pinched fingers: medium-dark skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F90C 1F3FF","char":"🤌🏿","name":"pinched fingers: dark skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F90F","char":"🤏","name":"pinching hand","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F90F 1F3FB","char":"🤏🏻","name":"pinching hand: light skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F90F 1F3FC","char":"🤏🏼","name":"pinching hand: medium-light skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F90F 1F3FD","char":"🤏🏽","name":"pinching hand: medium skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F90F 1F3FE","char":"🤏🏾","name":"pinching hand: medium-dark skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F90F 1F3FF","char":"🤏🏿","name":"pinching hand: dark skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"270C FE0F","char":"✌️","name":"victory hand","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"270C","char":"✌","name":"victory hand","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"270C 1F3FB","char":"✌🏻","name":"victory hand: light skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"270C 1F3FC","char":"✌🏼","name":"victory hand: medium-light skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"270C 1F3FD","char":"✌🏽","name":"victory hand: medium skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"270C 1F3FE","char":"✌🏾","name":"victory hand: medium-dark skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"270C 1F3FF","char":"✌🏿","name":"victory hand: dark skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F91E","char":"🤞","name":"crossed fingers","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F91E 1F3FB","char":"🤞🏻","name":"crossed fingers: light skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F91E 1F3FC","char":"🤞🏼","name":"crossed fingers: medium-light skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F91E 1F3FD","char":"🤞🏽","name":"crossed fingers: medium skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F91E 1F3FE","char":"🤞🏾","name":"crossed fingers: medium-dark skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F91E 1F3FF","char":"🤞🏿","name":"crossed fingers: dark skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1FAF0","char":"🫰","name":"hand with index finger and thumb crossed","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1FAF0 1F3FB","char":"🫰🏻","name":"hand with index finger and thumb crossed: light skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1FAF0 1F3FC","char":"🫰🏼","name":"hand with index finger and thumb crossed: medium-light skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1FAF0 1F3FD","char":"🫰🏽","name":"hand with index finger and thumb crossed: medium skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1FAF0 1F3FE","char":"🫰🏾","name":"hand with index finger and thumb crossed: medium-dark skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1FAF0 1F3FF","char":"🫰🏿","name":"hand with index finger and thumb crossed: dark skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F91F","char":"🤟","name":"love-you gesture","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F91F 1F3FB","char":"🤟🏻","name":"love-you gesture: light skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F91F 1F3FC","char":"🤟🏼","name":"love-you gesture: medium-light skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F91F 1F3FD","char":"🤟🏽","name":"love-you gesture: medium skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F91F 1F3FE","char":"🤟🏾","name":"love-you gesture: medium-dark skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F91F 1F3FF","char":"🤟🏿","name":"love-you gesture: dark skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F918","char":"🤘","name":"sign of the horns","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F918 1F3FB","char":"🤘🏻","name":"sign of the horns: light skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F918 1F3FC","char":"🤘🏼","name":"sign of the horns: medium-light skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F918 1F3FD","char":"🤘🏽","name":"sign of the horns: medium skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F918 1F3FE","char":"🤘🏾","name":"sign of the horns: medium-dark skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F918 1F3FF","char":"🤘🏿","name":"sign of the horns: dark skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F919","char":"🤙","name":"call me hand","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F919 1F3FB","char":"🤙🏻","name":"call me hand: light skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F919 1F3FC","char":"🤙🏼","name":"call me hand: medium-light skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F919 1F3FD","char":"🤙🏽","name":"call me hand: medium skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F919 1F3FE","char":"🤙🏾","name":"call me hand: medium-dark skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F919 1F3FF","char":"🤙🏿","name":"call me hand: dark skin tone","category":"People & Body (hand-fingers-partial)","group":"People & Body","subgroup":"hand-fingers-partial"},{"codes":"1F448","char":"👈","name":"backhand index pointing left","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"1F448 1F3FB","char":"👈🏻","name":"backhand index pointing left: light skin tone","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"1F448 1F3FC","char":"👈🏼","name":"backhand index pointing left: medium-light skin tone","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"1F448 1F3FD","char":"👈🏽","name":"backhand index pointing left: medium skin tone","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"1F448 1F3FE","char":"👈🏾","name":"backhand index pointing left: medium-dark skin tone","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"1F448 1F3FF","char":"👈🏿","name":"backhand index pointing left: dark skin tone","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"1F449","char":"👉","name":"backhand index pointing right","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"1F449 1F3FB","char":"👉🏻","name":"backhand index pointing right: light skin tone","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"1F449 1F3FC","char":"👉🏼","name":"backhand index pointing right: medium-light skin tone","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"1F449 1F3FD","char":"👉🏽","name":"backhand index pointing right: medium skin tone","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"1F449 1F3FE","char":"👉🏾","name":"backhand index pointing right: medium-dark skin tone","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"1F449 1F3FF","char":"👉🏿","name":"backhand index pointing right: dark skin tone","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"1F446","char":"👆","name":"backhand index pointing up","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"1F446 1F3FB","char":"👆🏻","name":"backhand index pointing up: light skin tone","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"1F446 1F3FC","char":"👆🏼","name":"backhand index pointing up: medium-light skin tone","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"1F446 1F3FD","char":"👆🏽","name":"backhand index pointing up: medium skin tone","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"1F446 1F3FE","char":"👆🏾","name":"backhand index pointing up: medium-dark skin tone","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"1F446 1F3FF","char":"👆🏿","name":"backhand index pointing up: dark skin tone","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"1F595","char":"🖕","name":"middle finger","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"1F595 1F3FB","char":"🖕🏻","name":"middle finger: light skin tone","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"1F595 1F3FC","char":"🖕🏼","name":"middle finger: medium-light skin tone","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"1F595 1F3FD","char":"🖕🏽","name":"middle finger: medium skin tone","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"1F595 1F3FE","char":"🖕🏾","name":"middle finger: medium-dark skin tone","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"1F595 1F3FF","char":"🖕🏿","name":"middle finger: dark skin tone","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"1F447","char":"👇","name":"backhand index pointing down","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"1F447 1F3FB","char":"👇🏻","name":"backhand index pointing down: light skin tone","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"1F447 1F3FC","char":"👇🏼","name":"backhand index pointing down: medium-light skin tone","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"1F447 1F3FD","char":"👇🏽","name":"backhand index pointing down: medium skin tone","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"1F447 1F3FE","char":"👇🏾","name":"backhand index pointing down: medium-dark skin tone","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"1F447 1F3FF","char":"👇🏿","name":"backhand index pointing down: dark skin tone","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"261D FE0F","char":"☝️","name":"index pointing up","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"261D","char":"☝","name":"index pointing up","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"261D 1F3FB","char":"☝🏻","name":"index pointing up: light skin tone","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"261D 1F3FC","char":"☝🏼","name":"index pointing up: medium-light skin tone","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"261D 1F3FD","char":"☝🏽","name":"index pointing up: medium skin tone","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"261D 1F3FE","char":"☝🏾","name":"index pointing up: medium-dark skin tone","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"261D 1F3FF","char":"☝🏿","name":"index pointing up: dark skin tone","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"1FAF5","char":"🫵","name":"index pointing at the viewer","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"1FAF5 1F3FB","char":"🫵🏻","name":"index pointing at the viewer: light skin tone","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"1FAF5 1F3FC","char":"🫵🏼","name":"index pointing at the viewer: medium-light skin tone","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"1FAF5 1F3FD","char":"🫵🏽","name":"index pointing at the viewer: medium skin tone","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"1FAF5 1F3FE","char":"🫵🏾","name":"index pointing at the viewer: medium-dark skin tone","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"1FAF5 1F3FF","char":"🫵🏿","name":"index pointing at the viewer: dark skin tone","category":"People & Body (hand-single-finger)","group":"People & Body","subgroup":"hand-single-finger"},{"codes":"1F44D","char":"👍","name":"thumbs up","category":"People & Body (hand-fingers-closed)","group":"People & Body","subgroup":"hand-fingers-closed"},{"codes":"1F44D 1F3FB","char":"👍🏻","name":"thumbs up: light skin tone","category":"People & Body (hand-fingers-closed)","group":"People & Body","subgroup":"hand-fingers-closed"},{"codes":"1F44D 1F3FC","char":"👍🏼","name":"thumbs up: medium-light skin tone","category":"People & Body (hand-fingers-closed)","group":"People & Body","subgroup":"hand-fingers-closed"},{"codes":"1F44D 1F3FD","char":"👍🏽","name":"thumbs up: medium skin tone","category":"People & Body (hand-fingers-closed)","group":"People & Body","subgroup":"hand-fingers-closed"},{"codes":"1F44D 1F3FE","char":"👍🏾","name":"thumbs up: medium-dark skin tone","category":"People & Body (hand-fingers-closed)","group":"People & Body","subgroup":"hand-fingers-closed"},{"codes":"1F44D 1F3FF","char":"👍🏿","name":"thumbs up: dark skin tone","category":"People & Body (hand-fingers-closed)","group":"People & Body","subgroup":"hand-fingers-closed"},{"codes":"1F44E","char":"👎","name":"thumbs down","category":"People & Body (hand-fingers-closed)","group":"People & Body","subgroup":"hand-fingers-closed"},{"codes":"1F44E 1F3FB","char":"👎🏻","name":"thumbs down: light skin tone","category":"People & Body (hand-fingers-closed)","group":"People & Body","subgroup":"hand-fingers-closed"},{"codes":"1F44E 1F3FC","char":"👎🏼","name":"thumbs down: medium-light skin tone","category":"People & Body (hand-fingers-closed)","group":"People & Body","subgroup":"hand-fingers-closed"},{"codes":"1F44E 1F3FD","char":"👎🏽","name":"thumbs down: medium skin tone","category":"People & Body (hand-fingers-closed)","group":"People & Body","subgroup":"hand-fingers-closed"},{"codes":"1F44E 1F3FE","char":"👎🏾","name":"thumbs down: medium-dark skin tone","category":"People & Body (hand-fingers-closed)","group":"People & Body","subgroup":"hand-fingers-closed"},{"codes":"1F44E 1F3FF","char":"👎🏿","name":"thumbs down: dark skin tone","category":"People & Body (hand-fingers-closed)","group":"People & Body","subgroup":"hand-fingers-closed"},{"codes":"270A","char":"✊","name":"raised fist","category":"People & Body (hand-fingers-closed)","group":"People & Body","subgroup":"hand-fingers-closed"},{"codes":"270A 1F3FB","char":"✊🏻","name":"raised fist: light skin tone","category":"People & Body (hand-fingers-closed)","group":"People & Body","subgroup":"hand-fingers-closed"},{"codes":"270A 1F3FC","char":"✊🏼","name":"raised fist: medium-light skin tone","category":"People & Body (hand-fingers-closed)","group":"People & Body","subgroup":"hand-fingers-closed"},{"codes":"270A 1F3FD","char":"✊🏽","name":"raised fist: medium skin tone","category":"People & Body (hand-fingers-closed)","group":"People & Body","subgroup":"hand-fingers-closed"},{"codes":"270A 1F3FE","char":"✊🏾","name":"raised fist: medium-dark skin tone","category":"People & Body (hand-fingers-closed)","group":"People & Body","subgroup":"hand-fingers-closed"},{"codes":"270A 1F3FF","char":"✊🏿","name":"raised fist: dark skin tone","category":"People & Body (hand-fingers-closed)","group":"People & Body","subgroup":"hand-fingers-closed"},{"codes":"1F44A","char":"👊","name":"oncoming fist","category":"People & Body (hand-fingers-closed)","group":"People & Body","subgroup":"hand-fingers-closed"},{"codes":"1F44A 1F3FB","char":"👊🏻","name":"oncoming fist: light skin tone","category":"People & Body (hand-fingers-closed)","group":"People & Body","subgroup":"hand-fingers-closed"},{"codes":"1F44A 1F3FC","char":"👊🏼","name":"oncoming fist: medium-light skin tone","category":"People & Body (hand-fingers-closed)","group":"People & Body","subgroup":"hand-fingers-closed"},{"codes":"1F44A 1F3FD","char":"👊🏽","name":"oncoming fist: medium skin tone","category":"People & Body (hand-fingers-closed)","group":"People & Body","subgroup":"hand-fingers-closed"},{"codes":"1F44A 1F3FE","char":"👊🏾","name":"oncoming fist: medium-dark skin tone","category":"People & Body (hand-fingers-closed)","group":"People & Body","subgroup":"hand-fingers-closed"},{"codes":"1F44A 1F3FF","char":"👊🏿","name":"oncoming fist: dark skin tone","category":"People & Body (hand-fingers-closed)","group":"People & Body","subgroup":"hand-fingers-closed"},{"codes":"1F91B","char":"🤛","name":"left-facing fist","category":"People & Body (hand-fingers-closed)","group":"People & Body","subgroup":"hand-fingers-closed"},{"codes":"1F91B 1F3FB","char":"🤛🏻","name":"left-facing fist: light skin tone","category":"People & Body (hand-fingers-closed)","group":"People & Body","subgroup":"hand-fingers-closed"},{"codes":"1F91B 1F3FC","char":"🤛🏼","name":"left-facing fist: medium-light skin tone","category":"People & Body (hand-fingers-closed)","group":"People & Body","subgroup":"hand-fingers-closed"},{"codes":"1F91B 1F3FD","char":"🤛🏽","name":"left-facing fist: medium skin tone","category":"People & Body (hand-fingers-closed)","group":"People & Body","subgroup":"hand-fingers-closed"},{"codes":"1F91B 1F3FE","char":"🤛🏾","name":"left-facing fist: medium-dark skin tone","category":"People & Body (hand-fingers-closed)","group":"People & Body","subgroup":"hand-fingers-closed"},{"codes":"1F91B 1F3FF","char":"🤛🏿","name":"left-facing fist: dark skin tone","category":"People & Body (hand-fingers-closed)","group":"People & Body","subgroup":"hand-fingers-closed"},{"codes":"1F91C","char":"🤜","name":"right-facing fist","category":"People & Body (hand-fingers-closed)","group":"People & Body","subgroup":"hand-fingers-closed"},{"codes":"1F91C 1F3FB","char":"🤜🏻","name":"right-facing fist: light skin tone","category":"People & Body (hand-fingers-closed)","group":"People & Body","subgroup":"hand-fingers-closed"},{"codes":"1F91C 1F3FC","char":"🤜🏼","name":"right-facing fist: medium-light skin tone","category":"People & Body (hand-fingers-closed)","group":"People & Body","subgroup":"hand-fingers-closed"},{"codes":"1F91C 1F3FD","char":"🤜🏽","name":"right-facing fist: medium skin tone","category":"People & Body (hand-fingers-closed)","group":"People & Body","subgroup":"hand-fingers-closed"},{"codes":"1F91C 1F3FE","char":"🤜🏾","name":"right-facing fist: medium-dark skin tone","category":"People & Body (hand-fingers-closed)","group":"People & Body","subgroup":"hand-fingers-closed"},{"codes":"1F91C 1F3FF","char":"🤜🏿","name":"right-facing fist: dark skin tone","category":"People & Body (hand-fingers-closed)","group":"People & Body","subgroup":"hand-fingers-closed"},{"codes":"1F44F","char":"👏","name":"clapping hands","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1F44F 1F3FB","char":"👏🏻","name":"clapping hands: light skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1F44F 1F3FC","char":"👏🏼","name":"clapping hands: medium-light skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1F44F 1F3FD","char":"👏🏽","name":"clapping hands: medium skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1F44F 1F3FE","char":"👏🏾","name":"clapping hands: medium-dark skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1F44F 1F3FF","char":"👏🏿","name":"clapping hands: dark skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1F64C","char":"🙌","name":"raising hands","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1F64C 1F3FB","char":"🙌🏻","name":"raising hands: light skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1F64C 1F3FC","char":"🙌🏼","name":"raising hands: medium-light skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1F64C 1F3FD","char":"🙌🏽","name":"raising hands: medium skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1F64C 1F3FE","char":"🙌🏾","name":"raising hands: medium-dark skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1F64C 1F3FF","char":"🙌🏿","name":"raising hands: dark skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1FAF6","char":"🫶","name":"heart hands","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1FAF6 1F3FB","char":"🫶🏻","name":"heart hands: light skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1FAF6 1F3FC","char":"🫶🏼","name":"heart hands: medium-light skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1FAF6 1F3FD","char":"🫶🏽","name":"heart hands: medium skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1FAF6 1F3FE","char":"🫶🏾","name":"heart hands: medium-dark skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1FAF6 1F3FF","char":"🫶🏿","name":"heart hands: dark skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1F450","char":"👐","name":"open hands","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1F450 1F3FB","char":"👐🏻","name":"open hands: light skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1F450 1F3FC","char":"👐🏼","name":"open hands: medium-light skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1F450 1F3FD","char":"👐🏽","name":"open hands: medium skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1F450 1F3FE","char":"👐🏾","name":"open hands: medium-dark skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1F450 1F3FF","char":"👐🏿","name":"open hands: dark skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1F932","char":"🤲","name":"palms up together","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1F932 1F3FB","char":"🤲🏻","name":"palms up together: light skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1F932 1F3FC","char":"🤲🏼","name":"palms up together: medium-light skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1F932 1F3FD","char":"🤲🏽","name":"palms up together: medium skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1F932 1F3FE","char":"🤲🏾","name":"palms up together: medium-dark skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1F932 1F3FF","char":"🤲🏿","name":"palms up together: dark skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1F91D","char":"🤝","name":"handshake","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1F91D 1F3FB","char":"🤝🏻","name":"handshake: light skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1F91D 1F3FC","char":"🤝🏼","name":"handshake: medium-light skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1F91D 1F3FD","char":"🤝🏽","name":"handshake: medium skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1F91D 1F3FE","char":"🤝🏾","name":"handshake: medium-dark skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1F91D 1F3FF","char":"🤝🏿","name":"handshake: dark skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1FAF1 1F3FB 200D 1FAF2 1F3FC","char":"🫱🏻‍🫲🏼","name":"handshake: light skin tone, medium-light skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1FAF1 1F3FB 200D 1FAF2 1F3FD","char":"🫱🏻‍🫲🏽","name":"handshake: light skin tone, medium skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1FAF1 1F3FB 200D 1FAF2 1F3FE","char":"🫱🏻‍🫲🏾","name":"handshake: light skin tone, medium-dark skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1FAF1 1F3FB 200D 1FAF2 1F3FF","char":"🫱🏻‍🫲🏿","name":"handshake: light skin tone, dark skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1FAF1 1F3FC 200D 1FAF2 1F3FB","char":"🫱🏼‍🫲🏻","name":"handshake: medium-light skin tone, light skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1FAF1 1F3FC 200D 1FAF2 1F3FD","char":"🫱🏼‍🫲🏽","name":"handshake: medium-light skin tone, medium skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1FAF1 1F3FC 200D 1FAF2 1F3FE","char":"🫱🏼‍🫲🏾","name":"handshake: medium-light skin tone, medium-dark skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1FAF1 1F3FC 200D 1FAF2 1F3FF","char":"🫱🏼‍🫲🏿","name":"handshake: medium-light skin tone, dark skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1FAF1 1F3FD 200D 1FAF2 1F3FB","char":"🫱🏽‍🫲🏻","name":"handshake: medium skin tone, light skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1FAF1 1F3FD 200D 1FAF2 1F3FC","char":"🫱🏽‍🫲🏼","name":"handshake: medium skin tone, medium-light skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1FAF1 1F3FD 200D 1FAF2 1F3FE","char":"🫱🏽‍🫲🏾","name":"handshake: medium skin tone, medium-dark skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1FAF1 1F3FD 200D 1FAF2 1F3FF","char":"🫱🏽‍🫲🏿","name":"handshake: medium skin tone, dark skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1FAF1 1F3FE 200D 1FAF2 1F3FB","char":"🫱🏾‍🫲🏻","name":"handshake: medium-dark skin tone, light skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1FAF1 1F3FE 200D 1FAF2 1F3FC","char":"🫱🏾‍🫲🏼","name":"handshake: medium-dark skin tone, medium-light skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1FAF1 1F3FE 200D 1FAF2 1F3FD","char":"🫱🏾‍🫲🏽","name":"handshake: medium-dark skin tone, medium skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1FAF1 1F3FE 200D 1FAF2 1F3FF","char":"🫱🏾‍🫲🏿","name":"handshake: medium-dark skin tone, dark skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1FAF1 1F3FF 200D 1FAF2 1F3FB","char":"🫱🏿‍🫲🏻","name":"handshake: dark skin tone, light skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1FAF1 1F3FF 200D 1FAF2 1F3FC","char":"🫱🏿‍🫲🏼","name":"handshake: dark skin tone, medium-light skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1FAF1 1F3FF 200D 1FAF2 1F3FD","char":"🫱🏿‍🫲🏽","name":"handshake: dark skin tone, medium skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1FAF1 1F3FF 200D 1FAF2 1F3FE","char":"🫱🏿‍🫲🏾","name":"handshake: dark skin tone, medium-dark skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1F64F","char":"🙏","name":"folded hands","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1F64F 1F3FB","char":"🙏🏻","name":"folded hands: light skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1F64F 1F3FC","char":"🙏🏼","name":"folded hands: medium-light skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1F64F 1F3FD","char":"🙏🏽","name":"folded hands: medium skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1F64F 1F3FE","char":"🙏🏾","name":"folded hands: medium-dark skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"1F64F 1F3FF","char":"🙏🏿","name":"folded hands: dark skin tone","category":"People & Body (hands)","group":"People & Body","subgroup":"hands"},{"codes":"270D FE0F","char":"✍️","name":"writing hand","category":"People & Body (hand-prop)","group":"People & Body","subgroup":"hand-prop"},{"codes":"270D","char":"✍","name":"writing hand","category":"People & Body (hand-prop)","group":"People & Body","subgroup":"hand-prop"},{"codes":"270D 1F3FB","char":"✍🏻","name":"writing hand: light skin tone","category":"People & Body (hand-prop)","group":"People & Body","subgroup":"hand-prop"},{"codes":"270D 1F3FC","char":"✍🏼","name":"writing hand: medium-light skin tone","category":"People & Body (hand-prop)","group":"People & Body","subgroup":"hand-prop"},{"codes":"270D 1F3FD","char":"✍🏽","name":"writing hand: medium skin tone","category":"People & Body (hand-prop)","group":"People & Body","subgroup":"hand-prop"},{"codes":"270D 1F3FE","char":"✍🏾","name":"writing hand: medium-dark skin tone","category":"People & Body (hand-prop)","group":"People & Body","subgroup":"hand-prop"},{"codes":"270D 1F3FF","char":"✍🏿","name":"writing hand: dark skin tone","category":"People & Body (hand-prop)","group":"People & Body","subgroup":"hand-prop"},{"codes":"1F485","char":"💅","name":"nail polish","category":"People & Body (hand-prop)","group":"People & Body","subgroup":"hand-prop"},{"codes":"1F485 1F3FB","char":"💅🏻","name":"nail polish: light skin tone","category":"People & Body (hand-prop)","group":"People & Body","subgroup":"hand-prop"},{"codes":"1F485 1F3FC","char":"💅🏼","name":"nail polish: medium-light skin tone","category":"People & Body (hand-prop)","group":"People & Body","subgroup":"hand-prop"},{"codes":"1F485 1F3FD","char":"💅🏽","name":"nail polish: medium skin tone","category":"People & Body (hand-prop)","group":"People & Body","subgroup":"hand-prop"},{"codes":"1F485 1F3FE","char":"💅🏾","name":"nail polish: medium-dark skin tone","category":"People & Body (hand-prop)","group":"People & Body","subgroup":"hand-prop"},{"codes":"1F485 1F3FF","char":"💅🏿","name":"nail polish: dark skin tone","category":"People & Body (hand-prop)","group":"People & Body","subgroup":"hand-prop"},{"codes":"1F933","char":"🤳","name":"selfie","category":"People & Body (hand-prop)","group":"People & Body","subgroup":"hand-prop"},{"codes":"1F933 1F3FB","char":"🤳🏻","name":"selfie: light skin tone","category":"People & Body (hand-prop)","group":"People & Body","subgroup":"hand-prop"},{"codes":"1F933 1F3FC","char":"🤳🏼","name":"selfie: medium-light skin tone","category":"People & Body (hand-prop)","group":"People & Body","subgroup":"hand-prop"},{"codes":"1F933 1F3FD","char":"🤳🏽","name":"selfie: medium skin tone","category":"People & Body (hand-prop)","group":"People & Body","subgroup":"hand-prop"},{"codes":"1F933 1F3FE","char":"🤳🏾","name":"selfie: medium-dark skin tone","category":"People & Body (hand-prop)","group":"People & Body","subgroup":"hand-prop"},{"codes":"1F933 1F3FF","char":"🤳🏿","name":"selfie: dark skin tone","category":"People & Body (hand-prop)","group":"People & Body","subgroup":"hand-prop"},{"codes":"1F4AA","char":"💪","name":"flexed biceps","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F4AA 1F3FB","char":"💪🏻","name":"flexed biceps: light skin tone","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F4AA 1F3FC","char":"💪🏼","name":"flexed biceps: medium-light skin tone","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F4AA 1F3FD","char":"💪🏽","name":"flexed biceps: medium skin tone","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F4AA 1F3FE","char":"💪🏾","name":"flexed biceps: medium-dark skin tone","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F4AA 1F3FF","char":"💪🏿","name":"flexed biceps: dark skin tone","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F9BE","char":"🦾","name":"mechanical arm","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F9BF","char":"🦿","name":"mechanical leg","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F9B5","char":"🦵","name":"leg","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F9B5 1F3FB","char":"🦵🏻","name":"leg: light skin tone","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F9B5 1F3FC","char":"🦵🏼","name":"leg: medium-light skin tone","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F9B5 1F3FD","char":"🦵🏽","name":"leg: medium skin tone","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F9B5 1F3FE","char":"🦵🏾","name":"leg: medium-dark skin tone","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F9B5 1F3FF","char":"🦵🏿","name":"leg: dark skin tone","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F9B6","char":"🦶","name":"foot","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F9B6 1F3FB","char":"🦶🏻","name":"foot: light skin tone","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F9B6 1F3FC","char":"🦶🏼","name":"foot: medium-light skin tone","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F9B6 1F3FD","char":"🦶🏽","name":"foot: medium skin tone","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F9B6 1F3FE","char":"🦶🏾","name":"foot: medium-dark skin tone","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F9B6 1F3FF","char":"🦶🏿","name":"foot: dark skin tone","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F442","char":"👂","name":"ear","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F442 1F3FB","char":"👂🏻","name":"ear: light skin tone","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F442 1F3FC","char":"👂🏼","name":"ear: medium-light skin tone","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F442 1F3FD","char":"👂🏽","name":"ear: medium skin tone","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F442 1F3FE","char":"👂🏾","name":"ear: medium-dark skin tone","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F442 1F3FF","char":"👂🏿","name":"ear: dark skin tone","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F9BB","char":"🦻","name":"ear with hearing aid","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F9BB 1F3FB","char":"🦻🏻","name":"ear with hearing aid: light skin tone","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F9BB 1F3FC","char":"🦻🏼","name":"ear with hearing aid: medium-light skin tone","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F9BB 1F3FD","char":"🦻🏽","name":"ear with hearing aid: medium skin tone","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F9BB 1F3FE","char":"🦻🏾","name":"ear with hearing aid: medium-dark skin tone","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F9BB 1F3FF","char":"🦻🏿","name":"ear with hearing aid: dark skin tone","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F443","char":"👃","name":"nose","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F443 1F3FB","char":"👃🏻","name":"nose: light skin tone","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F443 1F3FC","char":"👃🏼","name":"nose: medium-light skin tone","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F443 1F3FD","char":"👃🏽","name":"nose: medium skin tone","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F443 1F3FE","char":"👃🏾","name":"nose: medium-dark skin tone","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F443 1F3FF","char":"👃🏿","name":"nose: dark skin tone","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F9E0","char":"🧠","name":"brain","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1FAC0","char":"🫀","name":"anatomical heart","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1FAC1","char":"🫁","name":"lungs","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F9B7","char":"🦷","name":"tooth","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F9B4","char":"🦴","name":"bone","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F440","char":"👀","name":"eyes","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F441 FE0F","char":"👁️","name":"eye","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F441","char":"👁","name":"eye","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F445","char":"👅","name":"tongue","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F444","char":"👄","name":"mouth","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1FAE6","char":"🫦","name":"biting lip","category":"People & Body (body-parts)","group":"People & Body","subgroup":"body-parts"},{"codes":"1F476","char":"👶","name":"baby","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F476 1F3FB","char":"👶🏻","name":"baby: light skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F476 1F3FC","char":"👶🏼","name":"baby: medium-light skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F476 1F3FD","char":"👶🏽","name":"baby: medium skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F476 1F3FE","char":"👶🏾","name":"baby: medium-dark skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F476 1F3FF","char":"👶🏿","name":"baby: dark skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D2","char":"🧒","name":"child","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D2 1F3FB","char":"🧒🏻","name":"child: light skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D2 1F3FC","char":"🧒🏼","name":"child: medium-light skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D2 1F3FD","char":"🧒🏽","name":"child: medium skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D2 1F3FE","char":"🧒🏾","name":"child: medium-dark skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D2 1F3FF","char":"🧒🏿","name":"child: dark skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F466","char":"👦","name":"boy","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F466 1F3FB","char":"👦🏻","name":"boy: light skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F466 1F3FC","char":"👦🏼","name":"boy: medium-light skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F466 1F3FD","char":"👦🏽","name":"boy: medium skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F466 1F3FE","char":"👦🏾","name":"boy: medium-dark skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F466 1F3FF","char":"👦🏿","name":"boy: dark skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F467","char":"👧","name":"girl","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F467 1F3FB","char":"👧🏻","name":"girl: light skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F467 1F3FC","char":"👧🏼","name":"girl: medium-light skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F467 1F3FD","char":"👧🏽","name":"girl: medium skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F467 1F3FE","char":"👧🏾","name":"girl: medium-dark skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F467 1F3FF","char":"👧🏿","name":"girl: dark skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D1","char":"🧑","name":"person","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D1 1F3FB","char":"🧑🏻","name":"person: light skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D1 1F3FC","char":"🧑🏼","name":"person: medium-light skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D1 1F3FD","char":"🧑🏽","name":"person: medium skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D1 1F3FE","char":"🧑🏾","name":"person: medium-dark skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D1 1F3FF","char":"🧑🏿","name":"person: dark skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F471","char":"👱","name":"person: blond hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F471 1F3FB","char":"👱🏻","name":"person: light skin tone, blond hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F471 1F3FC","char":"👱🏼","name":"person: medium-light skin tone, blond hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F471 1F3FD","char":"👱🏽","name":"person: medium skin tone, blond hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F471 1F3FE","char":"👱🏾","name":"person: medium-dark skin tone, blond hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F471 1F3FF","char":"👱🏿","name":"person: dark skin tone, blond hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F468","char":"👨","name":"man","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F468 1F3FB","char":"👨🏻","name":"man: light skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F468 1F3FC","char":"👨🏼","name":"man: medium-light skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F468 1F3FD","char":"👨🏽","name":"man: medium skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F468 1F3FE","char":"👨🏾","name":"man: medium-dark skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F468 1F3FF","char":"👨🏿","name":"man: dark skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D4","char":"🧔","name":"person: beard","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D4 1F3FB","char":"🧔🏻","name":"person: light skin tone, beard","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D4 1F3FC","char":"🧔🏼","name":"person: medium-light skin tone, beard","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D4 1F3FD","char":"🧔🏽","name":"person: medium skin tone, beard","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D4 1F3FE","char":"🧔🏾","name":"person: medium-dark skin tone, beard","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D4 1F3FF","char":"🧔🏿","name":"person: dark skin tone, beard","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D4 200D 2642 FE0F","char":"🧔‍♂️","name":"man: beard","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D4 200D 2642","char":"🧔‍♂","name":"man: beard","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D4 1F3FB 200D 2642 FE0F","char":"🧔🏻‍♂️","name":"man: light skin tone, beard","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D4 1F3FB 200D 2642","char":"🧔🏻‍♂","name":"man: light skin tone, beard","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D4 1F3FC 200D 2642 FE0F","char":"🧔🏼‍♂️","name":"man: medium-light skin tone, beard","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D4 1F3FC 200D 2642","char":"🧔🏼‍♂","name":"man: medium-light skin tone, beard","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D4 1F3FD 200D 2642 FE0F","char":"🧔🏽‍♂️","name":"man: medium skin tone, beard","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D4 1F3FD 200D 2642","char":"🧔🏽‍♂","name":"man: medium skin tone, beard","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D4 1F3FE 200D 2642 FE0F","char":"🧔🏾‍♂️","name":"man: medium-dark skin tone, beard","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D4 1F3FE 200D 2642","char":"🧔🏾‍♂","name":"man: medium-dark skin tone, beard","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D4 1F3FF 200D 2642 FE0F","char":"🧔🏿‍♂️","name":"man: dark skin tone, beard","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D4 1F3FF 200D 2642","char":"🧔🏿‍♂","name":"man: dark skin tone, beard","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D4 200D 2640 FE0F","char":"🧔‍♀️","name":"woman: beard","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D4 200D 2640","char":"🧔‍♀","name":"woman: beard","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D4 1F3FB 200D 2640 FE0F","char":"🧔🏻‍♀️","name":"woman: light skin tone, beard","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D4 1F3FB 200D 2640","char":"🧔🏻‍♀","name":"woman: light skin tone, beard","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D4 1F3FC 200D 2640 FE0F","char":"🧔🏼‍♀️","name":"woman: medium-light skin tone, beard","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D4 1F3FC 200D 2640","char":"🧔🏼‍♀","name":"woman: medium-light skin tone, beard","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D4 1F3FD 200D 2640 FE0F","char":"🧔🏽‍♀️","name":"woman: medium skin tone, beard","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D4 1F3FD 200D 2640","char":"🧔🏽‍♀","name":"woman: medium skin tone, beard","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D4 1F3FE 200D 2640 FE0F","char":"🧔🏾‍♀️","name":"woman: medium-dark skin tone, beard","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D4 1F3FE 200D 2640","char":"🧔🏾‍♀","name":"woman: medium-dark skin tone, beard","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D4 1F3FF 200D 2640 FE0F","char":"🧔🏿‍♀️","name":"woman: dark skin tone, beard","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D4 1F3FF 200D 2640","char":"🧔🏿‍♀","name":"woman: dark skin tone, beard","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F468 200D 1F9B0","char":"👨‍🦰","name":"man: red hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F468 1F3FB 200D 1F9B0","char":"👨🏻‍🦰","name":"man: light skin tone, red hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F468 1F3FC 200D 1F9B0","char":"👨🏼‍🦰","name":"man: medium-light skin tone, red hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F468 1F3FD 200D 1F9B0","char":"👨🏽‍🦰","name":"man: medium skin tone, red hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F468 1F3FE 200D 1F9B0","char":"👨🏾‍🦰","name":"man: medium-dark skin tone, red hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F468 1F3FF 200D 1F9B0","char":"👨🏿‍🦰","name":"man: dark skin tone, red hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F468 200D 1F9B1","char":"👨‍🦱","name":"man: curly hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F468 1F3FB 200D 1F9B1","char":"👨🏻‍🦱","name":"man: light skin tone, curly hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F468 1F3FC 200D 1F9B1","char":"👨🏼‍🦱","name":"man: medium-light skin tone, curly hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F468 1F3FD 200D 1F9B1","char":"👨🏽‍🦱","name":"man: medium skin tone, curly hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F468 1F3FE 200D 1F9B1","char":"👨🏾‍🦱","name":"man: medium-dark skin tone, curly hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F468 1F3FF 200D 1F9B1","char":"👨🏿‍🦱","name":"man: dark skin tone, curly hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F468 200D 1F9B3","char":"👨‍🦳","name":"man: white hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F468 1F3FB 200D 1F9B3","char":"👨🏻‍🦳","name":"man: light skin tone, white hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F468 1F3FC 200D 1F9B3","char":"👨🏼‍🦳","name":"man: medium-light skin tone, white hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F468 1F3FD 200D 1F9B3","char":"👨🏽‍🦳","name":"man: medium skin tone, white hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F468 1F3FE 200D 1F9B3","char":"👨🏾‍🦳","name":"man: medium-dark skin tone, white hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F468 1F3FF 200D 1F9B3","char":"👨🏿‍🦳","name":"man: dark skin tone, white hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F468 200D 1F9B2","char":"👨‍🦲","name":"man: bald","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F468 1F3FB 200D 1F9B2","char":"👨🏻‍🦲","name":"man: light skin tone, bald","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F468 1F3FC 200D 1F9B2","char":"👨🏼‍🦲","name":"man: medium-light skin tone, bald","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F468 1F3FD 200D 1F9B2","char":"👨🏽‍🦲","name":"man: medium skin tone, bald","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F468 1F3FE 200D 1F9B2","char":"👨🏾‍🦲","name":"man: medium-dark skin tone, bald","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F468 1F3FF 200D 1F9B2","char":"👨🏿‍🦲","name":"man: dark skin tone, bald","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F469","char":"👩","name":"woman","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F469 1F3FB","char":"👩🏻","name":"woman: light skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F469 1F3FC","char":"👩🏼","name":"woman: medium-light skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F469 1F3FD","char":"👩🏽","name":"woman: medium skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F469 1F3FE","char":"👩🏾","name":"woman: medium-dark skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F469 1F3FF","char":"👩🏿","name":"woman: dark skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F469 200D 1F9B0","char":"👩‍🦰","name":"woman: red hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F469 1F3FB 200D 1F9B0","char":"👩🏻‍🦰","name":"woman: light skin tone, red hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F469 1F3FC 200D 1F9B0","char":"👩🏼‍🦰","name":"woman: medium-light skin tone, red hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F469 1F3FD 200D 1F9B0","char":"👩🏽‍🦰","name":"woman: medium skin tone, red hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F469 1F3FE 200D 1F9B0","char":"👩🏾‍🦰","name":"woman: medium-dark skin tone, red hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F469 1F3FF 200D 1F9B0","char":"👩🏿‍🦰","name":"woman: dark skin tone, red hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D1 200D 1F9B0","char":"🧑‍🦰","name":"person: red hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D1 1F3FB 200D 1F9B0","char":"🧑🏻‍🦰","name":"person: light skin tone, red hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D1 1F3FC 200D 1F9B0","char":"🧑🏼‍🦰","name":"person: medium-light skin tone, red hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D1 1F3FD 200D 1F9B0","char":"🧑🏽‍🦰","name":"person: medium skin tone, red hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D1 1F3FE 200D 1F9B0","char":"🧑🏾‍🦰","name":"person: medium-dark skin tone, red hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D1 1F3FF 200D 1F9B0","char":"🧑🏿‍🦰","name":"person: dark skin tone, red hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F469 200D 1F9B1","char":"👩‍🦱","name":"woman: curly hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F469 1F3FB 200D 1F9B1","char":"👩🏻‍🦱","name":"woman: light skin tone, curly hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F469 1F3FC 200D 1F9B1","char":"👩🏼‍🦱","name":"woman: medium-light skin tone, curly hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F469 1F3FD 200D 1F9B1","char":"👩🏽‍🦱","name":"woman: medium skin tone, curly hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F469 1F3FE 200D 1F9B1","char":"👩🏾‍🦱","name":"woman: medium-dark skin tone, curly hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F469 1F3FF 200D 1F9B1","char":"👩🏿‍🦱","name":"woman: dark skin tone, curly hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D1 200D 1F9B1","char":"🧑‍🦱","name":"person: curly hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D1 1F3FB 200D 1F9B1","char":"🧑🏻‍🦱","name":"person: light skin tone, curly hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D1 1F3FC 200D 1F9B1","char":"🧑🏼‍🦱","name":"person: medium-light skin tone, curly hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D1 1F3FD 200D 1F9B1","char":"🧑🏽‍🦱","name":"person: medium skin tone, curly hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D1 1F3FE 200D 1F9B1","char":"🧑🏾‍🦱","name":"person: medium-dark skin tone, curly hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D1 1F3FF 200D 1F9B1","char":"🧑🏿‍🦱","name":"person: dark skin tone, curly hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F469 200D 1F9B3","char":"👩‍🦳","name":"woman: white hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F469 1F3FB 200D 1F9B3","char":"👩🏻‍🦳","name":"woman: light skin tone, white hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F469 1F3FC 200D 1F9B3","char":"👩🏼‍🦳","name":"woman: medium-light skin tone, white hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F469 1F3FD 200D 1F9B3","char":"👩🏽‍🦳","name":"woman: medium skin tone, white hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F469 1F3FE 200D 1F9B3","char":"👩🏾‍🦳","name":"woman: medium-dark skin tone, white hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F469 1F3FF 200D 1F9B3","char":"👩🏿‍🦳","name":"woman: dark skin tone, white hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D1 200D 1F9B3","char":"🧑‍🦳","name":"person: white hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D1 1F3FB 200D 1F9B3","char":"🧑🏻‍🦳","name":"person: light skin tone, white hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D1 1F3FC 200D 1F9B3","char":"🧑🏼‍🦳","name":"person: medium-light skin tone, white hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D1 1F3FD 200D 1F9B3","char":"🧑🏽‍🦳","name":"person: medium skin tone, white hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D1 1F3FE 200D 1F9B3","char":"🧑🏾‍🦳","name":"person: medium-dark skin tone, white hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D1 1F3FF 200D 1F9B3","char":"🧑🏿‍🦳","name":"person: dark skin tone, white hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F469 200D 1F9B2","char":"👩‍🦲","name":"woman: bald","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F469 1F3FB 200D 1F9B2","char":"👩🏻‍🦲","name":"woman: light skin tone, bald","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F469 1F3FC 200D 1F9B2","char":"👩🏼‍🦲","name":"woman: medium-light skin tone, bald","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F469 1F3FD 200D 1F9B2","char":"👩🏽‍🦲","name":"woman: medium skin tone, bald","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F469 1F3FE 200D 1F9B2","char":"👩🏾‍🦲","name":"woman: medium-dark skin tone, bald","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F469 1F3FF 200D 1F9B2","char":"👩🏿‍🦲","name":"woman: dark skin tone, bald","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D1 200D 1F9B2","char":"🧑‍🦲","name":"person: bald","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D1 1F3FB 200D 1F9B2","char":"🧑🏻‍🦲","name":"person: light skin tone, bald","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D1 1F3FC 200D 1F9B2","char":"🧑🏼‍🦲","name":"person: medium-light skin tone, bald","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D1 1F3FD 200D 1F9B2","char":"🧑🏽‍🦲","name":"person: medium skin tone, bald","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D1 1F3FE 200D 1F9B2","char":"🧑🏾‍🦲","name":"person: medium-dark skin tone, bald","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D1 1F3FF 200D 1F9B2","char":"🧑🏿‍🦲","name":"person: dark skin tone, bald","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F471 200D 2640 FE0F","char":"👱‍♀️","name":"woman: blond hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F471 200D 2640","char":"👱‍♀","name":"woman: blond hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F471 1F3FB 200D 2640 FE0F","char":"👱🏻‍♀️","name":"woman: light skin tone, blond hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F471 1F3FB 200D 2640","char":"👱🏻‍♀","name":"woman: light skin tone, blond hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F471 1F3FC 200D 2640 FE0F","char":"👱🏼‍♀️","name":"woman: medium-light skin tone, blond hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F471 1F3FC 200D 2640","char":"👱🏼‍♀","name":"woman: medium-light skin tone, blond hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F471 1F3FD 200D 2640 FE0F","char":"👱🏽‍♀️","name":"woman: medium skin tone, blond hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F471 1F3FD 200D 2640","char":"👱🏽‍♀","name":"woman: medium skin tone, blond hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F471 1F3FE 200D 2640 FE0F","char":"👱🏾‍♀️","name":"woman: medium-dark skin tone, blond hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F471 1F3FE 200D 2640","char":"👱🏾‍♀","name":"woman: medium-dark skin tone, blond hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F471 1F3FF 200D 2640 FE0F","char":"👱🏿‍♀️","name":"woman: dark skin tone, blond hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F471 1F3FF 200D 2640","char":"👱🏿‍♀","name":"woman: dark skin tone, blond hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F471 200D 2642 FE0F","char":"👱‍♂️","name":"man: blond hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F471 200D 2642","char":"👱‍♂","name":"man: blond hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F471 1F3FB 200D 2642 FE0F","char":"👱🏻‍♂️","name":"man: light skin tone, blond hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F471 1F3FB 200D 2642","char":"👱🏻‍♂","name":"man: light skin tone, blond hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F471 1F3FC 200D 2642 FE0F","char":"👱🏼‍♂️","name":"man: medium-light skin tone, blond hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F471 1F3FC 200D 2642","char":"👱🏼‍♂","name":"man: medium-light skin tone, blond hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F471 1F3FD 200D 2642 FE0F","char":"👱🏽‍♂️","name":"man: medium skin tone, blond hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F471 1F3FD 200D 2642","char":"👱🏽‍♂","name":"man: medium skin tone, blond hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F471 1F3FE 200D 2642 FE0F","char":"👱🏾‍♂️","name":"man: medium-dark skin tone, blond hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F471 1F3FE 200D 2642","char":"👱🏾‍♂","name":"man: medium-dark skin tone, blond hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F471 1F3FF 200D 2642 FE0F","char":"👱🏿‍♂️","name":"man: dark skin tone, blond hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F471 1F3FF 200D 2642","char":"👱🏿‍♂","name":"man: dark skin tone, blond hair","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D3","char":"🧓","name":"older person","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D3 1F3FB","char":"🧓🏻","name":"older person: light skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D3 1F3FC","char":"🧓🏼","name":"older person: medium-light skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D3 1F3FD","char":"🧓🏽","name":"older person: medium skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D3 1F3FE","char":"🧓🏾","name":"older person: medium-dark skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F9D3 1F3FF","char":"🧓🏿","name":"older person: dark skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F474","char":"👴","name":"old man","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F474 1F3FB","char":"👴🏻","name":"old man: light skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F474 1F3FC","char":"👴🏼","name":"old man: medium-light skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F474 1F3FD","char":"👴🏽","name":"old man: medium skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F474 1F3FE","char":"👴🏾","name":"old man: medium-dark skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F474 1F3FF","char":"👴🏿","name":"old man: dark skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F475","char":"👵","name":"old woman","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F475 1F3FB","char":"👵🏻","name":"old woman: light skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F475 1F3FC","char":"👵🏼","name":"old woman: medium-light skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F475 1F3FD","char":"👵🏽","name":"old woman: medium skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F475 1F3FE","char":"👵🏾","name":"old woman: medium-dark skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F475 1F3FF","char":"👵🏿","name":"old woman: dark skin tone","category":"People & Body (person)","group":"People & Body","subgroup":"person"},{"codes":"1F64D","char":"🙍","name":"person frowning","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64D 1F3FB","char":"🙍🏻","name":"person frowning: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64D 1F3FC","char":"🙍🏼","name":"person frowning: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64D 1F3FD","char":"🙍🏽","name":"person frowning: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64D 1F3FE","char":"🙍🏾","name":"person frowning: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64D 1F3FF","char":"🙍🏿","name":"person frowning: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64D 200D 2642 FE0F","char":"🙍‍♂️","name":"man frowning","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64D 200D 2642","char":"🙍‍♂","name":"man frowning","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64D 1F3FB 200D 2642 FE0F","char":"🙍🏻‍♂️","name":"man frowning: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64D 1F3FB 200D 2642","char":"🙍🏻‍♂","name":"man frowning: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64D 1F3FC 200D 2642 FE0F","char":"🙍🏼‍♂️","name":"man frowning: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64D 1F3FC 200D 2642","char":"🙍🏼‍♂","name":"man frowning: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64D 1F3FD 200D 2642 FE0F","char":"🙍🏽‍♂️","name":"man frowning: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64D 1F3FD 200D 2642","char":"🙍🏽‍♂","name":"man frowning: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64D 1F3FE 200D 2642 FE0F","char":"🙍🏾‍♂️","name":"man frowning: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64D 1F3FE 200D 2642","char":"🙍🏾‍♂","name":"man frowning: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64D 1F3FF 200D 2642 FE0F","char":"🙍🏿‍♂️","name":"man frowning: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64D 1F3FF 200D 2642","char":"🙍🏿‍♂","name":"man frowning: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64D 200D 2640 FE0F","char":"🙍‍♀️","name":"woman frowning","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64D 200D 2640","char":"🙍‍♀","name":"woman frowning","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64D 1F3FB 200D 2640 FE0F","char":"🙍🏻‍♀️","name":"woman frowning: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64D 1F3FB 200D 2640","char":"🙍🏻‍♀","name":"woman frowning: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64D 1F3FC 200D 2640 FE0F","char":"🙍🏼‍♀️","name":"woman frowning: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64D 1F3FC 200D 2640","char":"🙍🏼‍♀","name":"woman frowning: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64D 1F3FD 200D 2640 FE0F","char":"🙍🏽‍♀️","name":"woman frowning: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64D 1F3FD 200D 2640","char":"🙍🏽‍♀","name":"woman frowning: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64D 1F3FE 200D 2640 FE0F","char":"🙍🏾‍♀️","name":"woman frowning: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64D 1F3FE 200D 2640","char":"🙍🏾‍♀","name":"woman frowning: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64D 1F3FF 200D 2640 FE0F","char":"🙍🏿‍♀️","name":"woman frowning: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64D 1F3FF 200D 2640","char":"🙍🏿‍♀","name":"woman frowning: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64E","char":"🙎","name":"person pouting","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64E 1F3FB","char":"🙎🏻","name":"person pouting: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64E 1F3FC","char":"🙎🏼","name":"person pouting: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64E 1F3FD","char":"🙎🏽","name":"person pouting: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64E 1F3FE","char":"🙎🏾","name":"person pouting: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64E 1F3FF","char":"🙎🏿","name":"person pouting: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64E 200D 2642 FE0F","char":"🙎‍♂️","name":"man pouting","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64E 200D 2642","char":"🙎‍♂","name":"man pouting","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64E 1F3FB 200D 2642 FE0F","char":"🙎🏻‍♂️","name":"man pouting: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64E 1F3FB 200D 2642","char":"🙎🏻‍♂","name":"man pouting: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64E 1F3FC 200D 2642 FE0F","char":"🙎🏼‍♂️","name":"man pouting: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64E 1F3FC 200D 2642","char":"🙎🏼‍♂","name":"man pouting: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64E 1F3FD 200D 2642 FE0F","char":"🙎🏽‍♂️","name":"man pouting: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64E 1F3FD 200D 2642","char":"🙎🏽‍♂","name":"man pouting: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64E 1F3FE 200D 2642 FE0F","char":"🙎🏾‍♂️","name":"man pouting: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64E 1F3FE 200D 2642","char":"🙎🏾‍♂","name":"man pouting: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64E 1F3FF 200D 2642 FE0F","char":"🙎🏿‍♂️","name":"man pouting: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64E 1F3FF 200D 2642","char":"🙎🏿‍♂","name":"man pouting: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64E 200D 2640 FE0F","char":"🙎‍♀️","name":"woman pouting","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64E 200D 2640","char":"🙎‍♀","name":"woman pouting","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64E 1F3FB 200D 2640 FE0F","char":"🙎🏻‍♀️","name":"woman pouting: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64E 1F3FB 200D 2640","char":"🙎🏻‍♀","name":"woman pouting: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64E 1F3FC 200D 2640 FE0F","char":"🙎🏼‍♀️","name":"woman pouting: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64E 1F3FC 200D 2640","char":"🙎🏼‍♀","name":"woman pouting: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64E 1F3FD 200D 2640 FE0F","char":"🙎🏽‍♀️","name":"woman pouting: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64E 1F3FD 200D 2640","char":"🙎🏽‍♀","name":"woman pouting: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64E 1F3FE 200D 2640 FE0F","char":"🙎🏾‍♀️","name":"woman pouting: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64E 1F3FE 200D 2640","char":"🙎🏾‍♀","name":"woman pouting: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64E 1F3FF 200D 2640 FE0F","char":"🙎🏿‍♀️","name":"woman pouting: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64E 1F3FF 200D 2640","char":"🙎🏿‍♀","name":"woman pouting: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F645","char":"🙅","name":"person gesturing NO","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F645 1F3FB","char":"🙅🏻","name":"person gesturing NO: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F645 1F3FC","char":"🙅🏼","name":"person gesturing NO: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F645 1F3FD","char":"🙅🏽","name":"person gesturing NO: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F645 1F3FE","char":"🙅🏾","name":"person gesturing NO: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F645 1F3FF","char":"🙅🏿","name":"person gesturing NO: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F645 200D 2642 FE0F","char":"🙅‍♂️","name":"man gesturing NO","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F645 200D 2642","char":"🙅‍♂","name":"man gesturing NO","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F645 1F3FB 200D 2642 FE0F","char":"🙅🏻‍♂️","name":"man gesturing NO: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F645 1F3FB 200D 2642","char":"🙅🏻‍♂","name":"man gesturing NO: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F645 1F3FC 200D 2642 FE0F","char":"🙅🏼‍♂️","name":"man gesturing NO: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F645 1F3FC 200D 2642","char":"🙅🏼‍♂","name":"man gesturing NO: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F645 1F3FD 200D 2642 FE0F","char":"🙅🏽‍♂️","name":"man gesturing NO: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F645 1F3FD 200D 2642","char":"🙅🏽‍♂","name":"man gesturing NO: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F645 1F3FE 200D 2642 FE0F","char":"🙅🏾‍♂️","name":"man gesturing NO: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F645 1F3FE 200D 2642","char":"🙅🏾‍♂","name":"man gesturing NO: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F645 1F3FF 200D 2642 FE0F","char":"🙅🏿‍♂️","name":"man gesturing NO: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F645 1F3FF 200D 2642","char":"🙅🏿‍♂","name":"man gesturing NO: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F645 200D 2640 FE0F","char":"🙅‍♀️","name":"woman gesturing NO","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F645 200D 2640","char":"🙅‍♀","name":"woman gesturing NO","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F645 1F3FB 200D 2640 FE0F","char":"🙅🏻‍♀️","name":"woman gesturing NO: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F645 1F3FB 200D 2640","char":"🙅🏻‍♀","name":"woman gesturing NO: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F645 1F3FC 200D 2640 FE0F","char":"🙅🏼‍♀️","name":"woman gesturing NO: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F645 1F3FC 200D 2640","char":"🙅🏼‍♀","name":"woman gesturing NO: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F645 1F3FD 200D 2640 FE0F","char":"🙅🏽‍♀️","name":"woman gesturing NO: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F645 1F3FD 200D 2640","char":"🙅🏽‍♀","name":"woman gesturing NO: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F645 1F3FE 200D 2640 FE0F","char":"🙅🏾‍♀️","name":"woman gesturing NO: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F645 1F3FE 200D 2640","char":"🙅🏾‍♀","name":"woman gesturing NO: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F645 1F3FF 200D 2640 FE0F","char":"🙅🏿‍♀️","name":"woman gesturing NO: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F645 1F3FF 200D 2640","char":"🙅🏿‍♀","name":"woman gesturing NO: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F646","char":"🙆","name":"person gesturing OK","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F646 1F3FB","char":"🙆🏻","name":"person gesturing OK: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F646 1F3FC","char":"🙆🏼","name":"person gesturing OK: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F646 1F3FD","char":"🙆🏽","name":"person gesturing OK: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F646 1F3FE","char":"🙆🏾","name":"person gesturing OK: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F646 1F3FF","char":"🙆🏿","name":"person gesturing OK: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F646 200D 2642 FE0F","char":"🙆‍♂️","name":"man gesturing OK","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F646 200D 2642","char":"🙆‍♂","name":"man gesturing OK","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F646 1F3FB 200D 2642 FE0F","char":"🙆🏻‍♂️","name":"man gesturing OK: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F646 1F3FB 200D 2642","char":"🙆🏻‍♂","name":"man gesturing OK: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F646 1F3FC 200D 2642 FE0F","char":"🙆🏼‍♂️","name":"man gesturing OK: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F646 1F3FC 200D 2642","char":"🙆🏼‍♂","name":"man gesturing OK: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F646 1F3FD 200D 2642 FE0F","char":"🙆🏽‍♂️","name":"man gesturing OK: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F646 1F3FD 200D 2642","char":"🙆🏽‍♂","name":"man gesturing OK: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F646 1F3FE 200D 2642 FE0F","char":"🙆🏾‍♂️","name":"man gesturing OK: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F646 1F3FE 200D 2642","char":"🙆🏾‍♂","name":"man gesturing OK: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F646 1F3FF 200D 2642 FE0F","char":"🙆🏿‍♂️","name":"man gesturing OK: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F646 1F3FF 200D 2642","char":"🙆🏿‍♂","name":"man gesturing OK: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F646 200D 2640 FE0F","char":"🙆‍♀️","name":"woman gesturing OK","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F646 200D 2640","char":"🙆‍♀","name":"woman gesturing OK","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F646 1F3FB 200D 2640 FE0F","char":"🙆🏻‍♀️","name":"woman gesturing OK: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F646 1F3FB 200D 2640","char":"🙆🏻‍♀","name":"woman gesturing OK: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F646 1F3FC 200D 2640 FE0F","char":"🙆🏼‍♀️","name":"woman gesturing OK: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F646 1F3FC 200D 2640","char":"🙆🏼‍♀","name":"woman gesturing OK: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F646 1F3FD 200D 2640 FE0F","char":"🙆🏽‍♀️","name":"woman gesturing OK: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F646 1F3FD 200D 2640","char":"🙆🏽‍♀","name":"woman gesturing OK: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F646 1F3FE 200D 2640 FE0F","char":"🙆🏾‍♀️","name":"woman gesturing OK: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F646 1F3FE 200D 2640","char":"🙆🏾‍♀","name":"woman gesturing OK: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F646 1F3FF 200D 2640 FE0F","char":"🙆🏿‍♀️","name":"woman gesturing OK: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F646 1F3FF 200D 2640","char":"🙆🏿‍♀","name":"woman gesturing OK: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F481","char":"💁","name":"person tipping hand","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F481 1F3FB","char":"💁🏻","name":"person tipping hand: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F481 1F3FC","char":"💁🏼","name":"person tipping hand: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F481 1F3FD","char":"💁🏽","name":"person tipping hand: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F481 1F3FE","char":"💁🏾","name":"person tipping hand: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F481 1F3FF","char":"💁🏿","name":"person tipping hand: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F481 200D 2642 FE0F","char":"💁‍♂️","name":"man tipping hand","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F481 200D 2642","char":"💁‍♂","name":"man tipping hand","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F481 1F3FB 200D 2642 FE0F","char":"💁🏻‍♂️","name":"man tipping hand: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F481 1F3FB 200D 2642","char":"💁🏻‍♂","name":"man tipping hand: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F481 1F3FC 200D 2642 FE0F","char":"💁🏼‍♂️","name":"man tipping hand: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F481 1F3FC 200D 2642","char":"💁🏼‍♂","name":"man tipping hand: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F481 1F3FD 200D 2642 FE0F","char":"💁🏽‍♂️","name":"man tipping hand: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F481 1F3FD 200D 2642","char":"💁🏽‍♂","name":"man tipping hand: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F481 1F3FE 200D 2642 FE0F","char":"💁🏾‍♂️","name":"man tipping hand: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F481 1F3FE 200D 2642","char":"💁🏾‍♂","name":"man tipping hand: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F481 1F3FF 200D 2642 FE0F","char":"💁🏿‍♂️","name":"man tipping hand: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F481 1F3FF 200D 2642","char":"💁🏿‍♂","name":"man tipping hand: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F481 200D 2640 FE0F","char":"💁‍♀️","name":"woman tipping hand","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F481 200D 2640","char":"💁‍♀","name":"woman tipping hand","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F481 1F3FB 200D 2640 FE0F","char":"💁🏻‍♀️","name":"woman tipping hand: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F481 1F3FB 200D 2640","char":"💁🏻‍♀","name":"woman tipping hand: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F481 1F3FC 200D 2640 FE0F","char":"💁🏼‍♀️","name":"woman tipping hand: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F481 1F3FC 200D 2640","char":"💁🏼‍♀","name":"woman tipping hand: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F481 1F3FD 200D 2640 FE0F","char":"💁🏽‍♀️","name":"woman tipping hand: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F481 1F3FD 200D 2640","char":"💁🏽‍♀","name":"woman tipping hand: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F481 1F3FE 200D 2640 FE0F","char":"💁🏾‍♀️","name":"woman tipping hand: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F481 1F3FE 200D 2640","char":"💁🏾‍♀","name":"woman tipping hand: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F481 1F3FF 200D 2640 FE0F","char":"💁🏿‍♀️","name":"woman tipping hand: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F481 1F3FF 200D 2640","char":"💁🏿‍♀","name":"woman tipping hand: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64B","char":"🙋","name":"person raising hand","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64B 1F3FB","char":"🙋🏻","name":"person raising hand: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64B 1F3FC","char":"🙋🏼","name":"person raising hand: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64B 1F3FD","char":"🙋🏽","name":"person raising hand: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64B 1F3FE","char":"🙋🏾","name":"person raising hand: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64B 1F3FF","char":"🙋🏿","name":"person raising hand: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64B 200D 2642 FE0F","char":"🙋‍♂️","name":"man raising hand","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64B 200D 2642","char":"🙋‍♂","name":"man raising hand","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64B 1F3FB 200D 2642 FE0F","char":"🙋🏻‍♂️","name":"man raising hand: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64B 1F3FB 200D 2642","char":"🙋🏻‍♂","name":"man raising hand: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64B 1F3FC 200D 2642 FE0F","char":"🙋🏼‍♂️","name":"man raising hand: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64B 1F3FC 200D 2642","char":"🙋🏼‍♂","name":"man raising hand: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64B 1F3FD 200D 2642 FE0F","char":"🙋🏽‍♂️","name":"man raising hand: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64B 1F3FD 200D 2642","char":"🙋🏽‍♂","name":"man raising hand: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64B 1F3FE 200D 2642 FE0F","char":"🙋🏾‍♂️","name":"man raising hand: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64B 1F3FE 200D 2642","char":"🙋🏾‍♂","name":"man raising hand: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64B 1F3FF 200D 2642 FE0F","char":"🙋🏿‍♂️","name":"man raising hand: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64B 1F3FF 200D 2642","char":"🙋🏿‍♂","name":"man raising hand: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64B 200D 2640 FE0F","char":"🙋‍♀️","name":"woman raising hand","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64B 200D 2640","char":"🙋‍♀","name":"woman raising hand","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64B 1F3FB 200D 2640 FE0F","char":"🙋🏻‍♀️","name":"woman raising hand: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64B 1F3FB 200D 2640","char":"🙋🏻‍♀","name":"woman raising hand: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64B 1F3FC 200D 2640 FE0F","char":"🙋🏼‍♀️","name":"woman raising hand: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64B 1F3FC 200D 2640","char":"🙋🏼‍♀","name":"woman raising hand: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64B 1F3FD 200D 2640 FE0F","char":"🙋🏽‍♀️","name":"woman raising hand: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64B 1F3FD 200D 2640","char":"🙋🏽‍♀","name":"woman raising hand: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64B 1F3FE 200D 2640 FE0F","char":"🙋🏾‍♀️","name":"woman raising hand: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64B 1F3FE 200D 2640","char":"🙋🏾‍♀","name":"woman raising hand: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64B 1F3FF 200D 2640 FE0F","char":"🙋🏿‍♀️","name":"woman raising hand: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F64B 1F3FF 200D 2640","char":"🙋🏿‍♀","name":"woman raising hand: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F9CF","char":"🧏","name":"deaf person","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F9CF 1F3FB","char":"🧏🏻","name":"deaf person: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F9CF 1F3FC","char":"🧏🏼","name":"deaf person: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F9CF 1F3FD","char":"🧏🏽","name":"deaf person: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F9CF 1F3FE","char":"🧏🏾","name":"deaf person: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F9CF 1F3FF","char":"🧏🏿","name":"deaf person: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F9CF 200D 2642 FE0F","char":"🧏‍♂️","name":"deaf man","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F9CF 200D 2642","char":"🧏‍♂","name":"deaf man","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F9CF 1F3FB 200D 2642 FE0F","char":"🧏🏻‍♂️","name":"deaf man: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F9CF 1F3FB 200D 2642","char":"🧏🏻‍♂","name":"deaf man: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F9CF 1F3FC 200D 2642 FE0F","char":"🧏🏼‍♂️","name":"deaf man: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F9CF 1F3FC 200D 2642","char":"🧏🏼‍♂","name":"deaf man: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F9CF 1F3FD 200D 2642 FE0F","char":"🧏🏽‍♂️","name":"deaf man: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F9CF 1F3FD 200D 2642","char":"🧏🏽‍♂","name":"deaf man: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F9CF 1F3FE 200D 2642 FE0F","char":"🧏🏾‍♂️","name":"deaf man: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F9CF 1F3FE 200D 2642","char":"🧏🏾‍♂","name":"deaf man: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F9CF 1F3FF 200D 2642 FE0F","char":"🧏🏿‍♂️","name":"deaf man: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F9CF 1F3FF 200D 2642","char":"🧏🏿‍♂","name":"deaf man: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F9CF 200D 2640 FE0F","char":"🧏‍♀️","name":"deaf woman","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F9CF 200D 2640","char":"🧏‍♀","name":"deaf woman","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F9CF 1F3FB 200D 2640 FE0F","char":"🧏🏻‍♀️","name":"deaf woman: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F9CF 1F3FB 200D 2640","char":"🧏🏻‍♀","name":"deaf woman: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F9CF 1F3FC 200D 2640 FE0F","char":"🧏🏼‍♀️","name":"deaf woman: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F9CF 1F3FC 200D 2640","char":"🧏🏼‍♀","name":"deaf woman: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F9CF 1F3FD 200D 2640 FE0F","char":"🧏🏽‍♀️","name":"deaf woman: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F9CF 1F3FD 200D 2640","char":"🧏🏽‍♀","name":"deaf woman: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F9CF 1F3FE 200D 2640 FE0F","char":"🧏🏾‍♀️","name":"deaf woman: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F9CF 1F3FE 200D 2640","char":"🧏🏾‍♀","name":"deaf woman: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F9CF 1F3FF 200D 2640 FE0F","char":"🧏🏿‍♀️","name":"deaf woman: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F9CF 1F3FF 200D 2640","char":"🧏🏿‍♀","name":"deaf woman: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F647","char":"🙇","name":"person bowing","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F647 1F3FB","char":"🙇🏻","name":"person bowing: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F647 1F3FC","char":"🙇🏼","name":"person bowing: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F647 1F3FD","char":"🙇🏽","name":"person bowing: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F647 1F3FE","char":"🙇🏾","name":"person bowing: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F647 1F3FF","char":"🙇🏿","name":"person bowing: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F647 200D 2642 FE0F","char":"🙇‍♂️","name":"man bowing","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F647 200D 2642","char":"🙇‍♂","name":"man bowing","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F647 1F3FB 200D 2642 FE0F","char":"🙇🏻‍♂️","name":"man bowing: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F647 1F3FB 200D 2642","char":"🙇🏻‍♂","name":"man bowing: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F647 1F3FC 200D 2642 FE0F","char":"🙇🏼‍♂️","name":"man bowing: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F647 1F3FC 200D 2642","char":"🙇🏼‍♂","name":"man bowing: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F647 1F3FD 200D 2642 FE0F","char":"🙇🏽‍♂️","name":"man bowing: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F647 1F3FD 200D 2642","char":"🙇🏽‍♂","name":"man bowing: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F647 1F3FE 200D 2642 FE0F","char":"🙇🏾‍♂️","name":"man bowing: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F647 1F3FE 200D 2642","char":"🙇🏾‍♂","name":"man bowing: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F647 1F3FF 200D 2642 FE0F","char":"🙇🏿‍♂️","name":"man bowing: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F647 1F3FF 200D 2642","char":"🙇🏿‍♂","name":"man bowing: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F647 200D 2640 FE0F","char":"🙇‍♀️","name":"woman bowing","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F647 200D 2640","char":"🙇‍♀","name":"woman bowing","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F647 1F3FB 200D 2640 FE0F","char":"🙇🏻‍♀️","name":"woman bowing: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F647 1F3FB 200D 2640","char":"🙇🏻‍♀","name":"woman bowing: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F647 1F3FC 200D 2640 FE0F","char":"🙇🏼‍♀️","name":"woman bowing: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F647 1F3FC 200D 2640","char":"🙇🏼‍♀","name":"woman bowing: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F647 1F3FD 200D 2640 FE0F","char":"🙇🏽‍♀️","name":"woman bowing: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F647 1F3FD 200D 2640","char":"🙇🏽‍♀","name":"woman bowing: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F647 1F3FE 200D 2640 FE0F","char":"🙇🏾‍♀️","name":"woman bowing: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F647 1F3FE 200D 2640","char":"🙇🏾‍♀","name":"woman bowing: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F647 1F3FF 200D 2640 FE0F","char":"🙇🏿‍♀️","name":"woman bowing: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F647 1F3FF 200D 2640","char":"🙇🏿‍♀","name":"woman bowing: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F926","char":"🤦","name":"person facepalming","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F926 1F3FB","char":"🤦🏻","name":"person facepalming: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F926 1F3FC","char":"🤦🏼","name":"person facepalming: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F926 1F3FD","char":"🤦🏽","name":"person facepalming: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F926 1F3FE","char":"🤦🏾","name":"person facepalming: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F926 1F3FF","char":"🤦🏿","name":"person facepalming: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F926 200D 2642 FE0F","char":"🤦‍♂️","name":"man facepalming","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F926 200D 2642","char":"🤦‍♂","name":"man facepalming","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F926 1F3FB 200D 2642 FE0F","char":"🤦🏻‍♂️","name":"man facepalming: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F926 1F3FB 200D 2642","char":"🤦🏻‍♂","name":"man facepalming: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F926 1F3FC 200D 2642 FE0F","char":"🤦🏼‍♂️","name":"man facepalming: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F926 1F3FC 200D 2642","char":"🤦🏼‍♂","name":"man facepalming: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F926 1F3FD 200D 2642 FE0F","char":"🤦🏽‍♂️","name":"man facepalming: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F926 1F3FD 200D 2642","char":"🤦🏽‍♂","name":"man facepalming: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F926 1F3FE 200D 2642 FE0F","char":"🤦🏾‍♂️","name":"man facepalming: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F926 1F3FE 200D 2642","char":"🤦🏾‍♂","name":"man facepalming: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F926 1F3FF 200D 2642 FE0F","char":"🤦🏿‍♂️","name":"man facepalming: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F926 1F3FF 200D 2642","char":"🤦🏿‍♂","name":"man facepalming: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F926 200D 2640 FE0F","char":"🤦‍♀️","name":"woman facepalming","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F926 200D 2640","char":"🤦‍♀","name":"woman facepalming","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F926 1F3FB 200D 2640 FE0F","char":"🤦🏻‍♀️","name":"woman facepalming: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F926 1F3FB 200D 2640","char":"🤦🏻‍♀","name":"woman facepalming: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F926 1F3FC 200D 2640 FE0F","char":"🤦🏼‍♀️","name":"woman facepalming: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F926 1F3FC 200D 2640","char":"🤦🏼‍♀","name":"woman facepalming: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F926 1F3FD 200D 2640 FE0F","char":"🤦🏽‍♀️","name":"woman facepalming: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F926 1F3FD 200D 2640","char":"🤦🏽‍♀","name":"woman facepalming: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F926 1F3FE 200D 2640 FE0F","char":"🤦🏾‍♀️","name":"woman facepalming: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F926 1F3FE 200D 2640","char":"🤦🏾‍♀","name":"woman facepalming: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F926 1F3FF 200D 2640 FE0F","char":"🤦🏿‍♀️","name":"woman facepalming: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F926 1F3FF 200D 2640","char":"🤦🏿‍♀","name":"woman facepalming: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F937","char":"🤷","name":"person shrugging","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F937 1F3FB","char":"🤷🏻","name":"person shrugging: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F937 1F3FC","char":"🤷🏼","name":"person shrugging: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F937 1F3FD","char":"🤷🏽","name":"person shrugging: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F937 1F3FE","char":"🤷🏾","name":"person shrugging: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F937 1F3FF","char":"🤷🏿","name":"person shrugging: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F937 200D 2642 FE0F","char":"🤷‍♂️","name":"man shrugging","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F937 200D 2642","char":"🤷‍♂","name":"man shrugging","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F937 1F3FB 200D 2642 FE0F","char":"🤷🏻‍♂️","name":"man shrugging: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F937 1F3FB 200D 2642","char":"🤷🏻‍♂","name":"man shrugging: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F937 1F3FC 200D 2642 FE0F","char":"🤷🏼‍♂️","name":"man shrugging: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F937 1F3FC 200D 2642","char":"🤷🏼‍♂","name":"man shrugging: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F937 1F3FD 200D 2642 FE0F","char":"🤷🏽‍♂️","name":"man shrugging: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F937 1F3FD 200D 2642","char":"🤷🏽‍♂","name":"man shrugging: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F937 1F3FE 200D 2642 FE0F","char":"🤷🏾‍♂️","name":"man shrugging: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F937 1F3FE 200D 2642","char":"🤷🏾‍♂","name":"man shrugging: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F937 1F3FF 200D 2642 FE0F","char":"🤷🏿‍♂️","name":"man shrugging: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F937 1F3FF 200D 2642","char":"🤷🏿‍♂","name":"man shrugging: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F937 200D 2640 FE0F","char":"🤷‍♀️","name":"woman shrugging","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F937 200D 2640","char":"🤷‍♀","name":"woman shrugging","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F937 1F3FB 200D 2640 FE0F","char":"🤷🏻‍♀️","name":"woman shrugging: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F937 1F3FB 200D 2640","char":"🤷🏻‍♀","name":"woman shrugging: light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F937 1F3FC 200D 2640 FE0F","char":"🤷🏼‍♀️","name":"woman shrugging: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F937 1F3FC 200D 2640","char":"🤷🏼‍♀","name":"woman shrugging: medium-light skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F937 1F3FD 200D 2640 FE0F","char":"🤷🏽‍♀️","name":"woman shrugging: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F937 1F3FD 200D 2640","char":"🤷🏽‍♀","name":"woman shrugging: medium skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F937 1F3FE 200D 2640 FE0F","char":"🤷🏾‍♀️","name":"woman shrugging: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F937 1F3FE 200D 2640","char":"🤷🏾‍♀","name":"woman shrugging: medium-dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F937 1F3FF 200D 2640 FE0F","char":"🤷🏿‍♀️","name":"woman shrugging: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F937 1F3FF 200D 2640","char":"🤷🏿‍♀","name":"woman shrugging: dark skin tone","category":"People & Body (person-gesture)","group":"People & Body","subgroup":"person-gesture"},{"codes":"1F9D1 200D 2695 FE0F","char":"🧑‍⚕️","name":"health worker","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 200D 2695","char":"🧑‍⚕","name":"health worker","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FB 200D 2695 FE0F","char":"🧑🏻‍⚕️","name":"health worker: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FB 200D 2695","char":"🧑🏻‍⚕","name":"health worker: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FC 200D 2695 FE0F","char":"🧑🏼‍⚕️","name":"health worker: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FC 200D 2695","char":"🧑🏼‍⚕","name":"health worker: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FD 200D 2695 FE0F","char":"🧑🏽‍⚕️","name":"health worker: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FD 200D 2695","char":"🧑🏽‍⚕","name":"health worker: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FE 200D 2695 FE0F","char":"🧑🏾‍⚕️","name":"health worker: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FE 200D 2695","char":"🧑🏾‍⚕","name":"health worker: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FF 200D 2695 FE0F","char":"🧑🏿‍⚕️","name":"health worker: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FF 200D 2695","char":"🧑🏿‍⚕","name":"health worker: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 200D 2695 FE0F","char":"👨‍⚕️","name":"man health worker","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 200D 2695","char":"👨‍⚕","name":"man health worker","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FB 200D 2695 FE0F","char":"👨🏻‍⚕️","name":"man health worker: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FB 200D 2695","char":"👨🏻‍⚕","name":"man health worker: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FC 200D 2695 FE0F","char":"👨🏼‍⚕️","name":"man health worker: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FC 200D 2695","char":"👨🏼‍⚕","name":"man health worker: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FD 200D 2695 FE0F","char":"👨🏽‍⚕️","name":"man health worker: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FD 200D 2695","char":"👨🏽‍⚕","name":"man health worker: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FE 200D 2695 FE0F","char":"👨🏾‍⚕️","name":"man health worker: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FE 200D 2695","char":"👨🏾‍⚕","name":"man health worker: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FF 200D 2695 FE0F","char":"👨🏿‍⚕️","name":"man health worker: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FF 200D 2695","char":"👨🏿‍⚕","name":"man health worker: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 200D 2695 FE0F","char":"👩‍⚕️","name":"woman health worker","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 200D 2695","char":"👩‍⚕","name":"woman health worker","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FB 200D 2695 FE0F","char":"👩🏻‍⚕️","name":"woman health worker: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FB 200D 2695","char":"👩🏻‍⚕","name":"woman health worker: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FC 200D 2695 FE0F","char":"👩🏼‍⚕️","name":"woman health worker: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FC 200D 2695","char":"👩🏼‍⚕","name":"woman health worker: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FD 200D 2695 FE0F","char":"👩🏽‍⚕️","name":"woman health worker: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FD 200D 2695","char":"👩🏽‍⚕","name":"woman health worker: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FE 200D 2695 FE0F","char":"👩🏾‍⚕️","name":"woman health worker: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FE 200D 2695","char":"👩🏾‍⚕","name":"woman health worker: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FF 200D 2695 FE0F","char":"👩🏿‍⚕️","name":"woman health worker: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FF 200D 2695","char":"👩🏿‍⚕","name":"woman health worker: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 200D 1F393","char":"🧑‍🎓","name":"student","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FB 200D 1F393","char":"🧑🏻‍🎓","name":"student: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FC 200D 1F393","char":"🧑🏼‍🎓","name":"student: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FD 200D 1F393","char":"🧑🏽‍🎓","name":"student: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FE 200D 1F393","char":"🧑🏾‍🎓","name":"student: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FF 200D 1F393","char":"🧑🏿‍🎓","name":"student: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 200D 1F393","char":"👨‍🎓","name":"man student","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FB 200D 1F393","char":"👨🏻‍🎓","name":"man student: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FC 200D 1F393","char":"👨🏼‍🎓","name":"man student: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FD 200D 1F393","char":"👨🏽‍🎓","name":"man student: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FE 200D 1F393","char":"👨🏾‍🎓","name":"man student: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FF 200D 1F393","char":"👨🏿‍🎓","name":"man student: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 200D 1F393","char":"👩‍🎓","name":"woman student","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FB 200D 1F393","char":"👩🏻‍🎓","name":"woman student: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FC 200D 1F393","char":"👩🏼‍🎓","name":"woman student: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FD 200D 1F393","char":"👩🏽‍🎓","name":"woman student: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FE 200D 1F393","char":"👩🏾‍🎓","name":"woman student: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FF 200D 1F393","char":"👩🏿‍🎓","name":"woman student: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 200D 1F3EB","char":"🧑‍🏫","name":"teacher","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FB 200D 1F3EB","char":"🧑🏻‍🏫","name":"teacher: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FC 200D 1F3EB","char":"🧑🏼‍🏫","name":"teacher: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FD 200D 1F3EB","char":"🧑🏽‍🏫","name":"teacher: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FE 200D 1F3EB","char":"🧑🏾‍🏫","name":"teacher: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FF 200D 1F3EB","char":"🧑🏿‍🏫","name":"teacher: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 200D 1F3EB","char":"👨‍🏫","name":"man teacher","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FB 200D 1F3EB","char":"👨🏻‍🏫","name":"man teacher: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FC 200D 1F3EB","char":"👨🏼‍🏫","name":"man teacher: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FD 200D 1F3EB","char":"👨🏽‍🏫","name":"man teacher: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FE 200D 1F3EB","char":"👨🏾‍🏫","name":"man teacher: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FF 200D 1F3EB","char":"👨🏿‍🏫","name":"man teacher: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 200D 1F3EB","char":"👩‍🏫","name":"woman teacher","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FB 200D 1F3EB","char":"👩🏻‍🏫","name":"woman teacher: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FC 200D 1F3EB","char":"👩🏼‍🏫","name":"woman teacher: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FD 200D 1F3EB","char":"👩🏽‍🏫","name":"woman teacher: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FE 200D 1F3EB","char":"👩🏾‍🏫","name":"woman teacher: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FF 200D 1F3EB","char":"👩🏿‍🏫","name":"woman teacher: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 200D 2696 FE0F","char":"🧑‍⚖️","name":"judge","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 200D 2696","char":"🧑‍⚖","name":"judge","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FB 200D 2696 FE0F","char":"🧑🏻‍⚖️","name":"judge: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FB 200D 2696","char":"🧑🏻‍⚖","name":"judge: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FC 200D 2696 FE0F","char":"🧑🏼‍⚖️","name":"judge: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FC 200D 2696","char":"🧑🏼‍⚖","name":"judge: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FD 200D 2696 FE0F","char":"🧑🏽‍⚖️","name":"judge: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FD 200D 2696","char":"🧑🏽‍⚖","name":"judge: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FE 200D 2696 FE0F","char":"🧑🏾‍⚖️","name":"judge: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FE 200D 2696","char":"🧑🏾‍⚖","name":"judge: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FF 200D 2696 FE0F","char":"🧑🏿‍⚖️","name":"judge: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FF 200D 2696","char":"🧑🏿‍⚖","name":"judge: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 200D 2696 FE0F","char":"👨‍⚖️","name":"man judge","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 200D 2696","char":"👨‍⚖","name":"man judge","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FB 200D 2696 FE0F","char":"👨🏻‍⚖️","name":"man judge: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FB 200D 2696","char":"👨🏻‍⚖","name":"man judge: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FC 200D 2696 FE0F","char":"👨🏼‍⚖️","name":"man judge: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FC 200D 2696","char":"👨🏼‍⚖","name":"man judge: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FD 200D 2696 FE0F","char":"👨🏽‍⚖️","name":"man judge: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FD 200D 2696","char":"👨🏽‍⚖","name":"man judge: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FE 200D 2696 FE0F","char":"👨🏾‍⚖️","name":"man judge: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FE 200D 2696","char":"👨🏾‍⚖","name":"man judge: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FF 200D 2696 FE0F","char":"👨🏿‍⚖️","name":"man judge: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FF 200D 2696","char":"👨🏿‍⚖","name":"man judge: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 200D 2696 FE0F","char":"👩‍⚖️","name":"woman judge","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 200D 2696","char":"👩‍⚖","name":"woman judge","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FB 200D 2696 FE0F","char":"👩🏻‍⚖️","name":"woman judge: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FB 200D 2696","char":"👩🏻‍⚖","name":"woman judge: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FC 200D 2696 FE0F","char":"👩🏼‍⚖️","name":"woman judge: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FC 200D 2696","char":"👩🏼‍⚖","name":"woman judge: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FD 200D 2696 FE0F","char":"👩🏽‍⚖️","name":"woman judge: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FD 200D 2696","char":"👩🏽‍⚖","name":"woman judge: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FE 200D 2696 FE0F","char":"👩🏾‍⚖️","name":"woman judge: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FE 200D 2696","char":"👩🏾‍⚖","name":"woman judge: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FF 200D 2696 FE0F","char":"👩🏿‍⚖️","name":"woman judge: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FF 200D 2696","char":"👩🏿‍⚖","name":"woman judge: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 200D 1F33E","char":"🧑‍🌾","name":"farmer","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FB 200D 1F33E","char":"🧑🏻‍🌾","name":"farmer: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FC 200D 1F33E","char":"🧑🏼‍🌾","name":"farmer: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FD 200D 1F33E","char":"🧑🏽‍🌾","name":"farmer: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FE 200D 1F33E","char":"🧑🏾‍🌾","name":"farmer: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FF 200D 1F33E","char":"🧑🏿‍🌾","name":"farmer: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 200D 1F33E","char":"👨‍🌾","name":"man farmer","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FB 200D 1F33E","char":"👨🏻‍🌾","name":"man farmer: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FC 200D 1F33E","char":"👨🏼‍🌾","name":"man farmer: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FD 200D 1F33E","char":"👨🏽‍🌾","name":"man farmer: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FE 200D 1F33E","char":"👨🏾‍🌾","name":"man farmer: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FF 200D 1F33E","char":"👨🏿‍🌾","name":"man farmer: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 200D 1F33E","char":"👩‍🌾","name":"woman farmer","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FB 200D 1F33E","char":"👩🏻‍🌾","name":"woman farmer: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FC 200D 1F33E","char":"👩🏼‍🌾","name":"woman farmer: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FD 200D 1F33E","char":"👩🏽‍🌾","name":"woman farmer: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FE 200D 1F33E","char":"👩🏾‍🌾","name":"woman farmer: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FF 200D 1F33E","char":"👩🏿‍🌾","name":"woman farmer: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 200D 1F373","char":"🧑‍🍳","name":"cook","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FB 200D 1F373","char":"🧑🏻‍🍳","name":"cook: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FC 200D 1F373","char":"🧑🏼‍🍳","name":"cook: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FD 200D 1F373","char":"🧑🏽‍🍳","name":"cook: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FE 200D 1F373","char":"🧑🏾‍🍳","name":"cook: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FF 200D 1F373","char":"🧑🏿‍🍳","name":"cook: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 200D 1F373","char":"👨‍🍳","name":"man cook","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FB 200D 1F373","char":"👨🏻‍🍳","name":"man cook: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FC 200D 1F373","char":"👨🏼‍🍳","name":"man cook: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FD 200D 1F373","char":"👨🏽‍🍳","name":"man cook: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FE 200D 1F373","char":"👨🏾‍🍳","name":"man cook: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FF 200D 1F373","char":"👨🏿‍🍳","name":"man cook: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 200D 1F373","char":"👩‍🍳","name":"woman cook","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FB 200D 1F373","char":"👩🏻‍🍳","name":"woman cook: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FC 200D 1F373","char":"👩🏼‍🍳","name":"woman cook: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FD 200D 1F373","char":"👩🏽‍🍳","name":"woman cook: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FE 200D 1F373","char":"👩🏾‍🍳","name":"woman cook: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FF 200D 1F373","char":"👩🏿‍🍳","name":"woman cook: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 200D 1F527","char":"🧑‍🔧","name":"mechanic","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FB 200D 1F527","char":"🧑🏻‍🔧","name":"mechanic: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FC 200D 1F527","char":"🧑🏼‍🔧","name":"mechanic: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FD 200D 1F527","char":"🧑🏽‍🔧","name":"mechanic: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FE 200D 1F527","char":"🧑🏾‍🔧","name":"mechanic: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FF 200D 1F527","char":"🧑🏿‍🔧","name":"mechanic: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 200D 1F527","char":"👨‍🔧","name":"man mechanic","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FB 200D 1F527","char":"👨🏻‍🔧","name":"man mechanic: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FC 200D 1F527","char":"👨🏼‍🔧","name":"man mechanic: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FD 200D 1F527","char":"👨🏽‍🔧","name":"man mechanic: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FE 200D 1F527","char":"👨🏾‍🔧","name":"man mechanic: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FF 200D 1F527","char":"👨🏿‍🔧","name":"man mechanic: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 200D 1F527","char":"👩‍🔧","name":"woman mechanic","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FB 200D 1F527","char":"👩🏻‍🔧","name":"woman mechanic: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FC 200D 1F527","char":"👩🏼‍🔧","name":"woman mechanic: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FD 200D 1F527","char":"👩🏽‍🔧","name":"woman mechanic: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FE 200D 1F527","char":"👩🏾‍🔧","name":"woman mechanic: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FF 200D 1F527","char":"👩🏿‍🔧","name":"woman mechanic: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 200D 1F3ED","char":"🧑‍🏭","name":"factory worker","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FB 200D 1F3ED","char":"🧑🏻‍🏭","name":"factory worker: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FC 200D 1F3ED","char":"🧑🏼‍🏭","name":"factory worker: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FD 200D 1F3ED","char":"🧑🏽‍🏭","name":"factory worker: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FE 200D 1F3ED","char":"🧑🏾‍🏭","name":"factory worker: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FF 200D 1F3ED","char":"🧑🏿‍🏭","name":"factory worker: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 200D 1F3ED","char":"👨‍🏭","name":"man factory worker","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FB 200D 1F3ED","char":"👨🏻‍🏭","name":"man factory worker: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FC 200D 1F3ED","char":"👨🏼‍🏭","name":"man factory worker: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FD 200D 1F3ED","char":"👨🏽‍🏭","name":"man factory worker: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FE 200D 1F3ED","char":"👨🏾‍🏭","name":"man factory worker: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FF 200D 1F3ED","char":"👨🏿‍🏭","name":"man factory worker: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 200D 1F3ED","char":"👩‍🏭","name":"woman factory worker","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FB 200D 1F3ED","char":"👩🏻‍🏭","name":"woman factory worker: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FC 200D 1F3ED","char":"👩🏼‍🏭","name":"woman factory worker: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FD 200D 1F3ED","char":"👩🏽‍🏭","name":"woman factory worker: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FE 200D 1F3ED","char":"👩🏾‍🏭","name":"woman factory worker: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FF 200D 1F3ED","char":"👩🏿‍🏭","name":"woman factory worker: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 200D 1F4BC","char":"🧑‍💼","name":"office worker","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FB 200D 1F4BC","char":"🧑🏻‍💼","name":"office worker: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FC 200D 1F4BC","char":"🧑🏼‍💼","name":"office worker: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FD 200D 1F4BC","char":"🧑🏽‍💼","name":"office worker: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FE 200D 1F4BC","char":"🧑🏾‍💼","name":"office worker: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FF 200D 1F4BC","char":"🧑🏿‍💼","name":"office worker: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 200D 1F4BC","char":"👨‍💼","name":"man office worker","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FB 200D 1F4BC","char":"👨🏻‍💼","name":"man office worker: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FC 200D 1F4BC","char":"👨🏼‍💼","name":"man office worker: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FD 200D 1F4BC","char":"👨🏽‍💼","name":"man office worker: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FE 200D 1F4BC","char":"👨🏾‍💼","name":"man office worker: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FF 200D 1F4BC","char":"👨🏿‍💼","name":"man office worker: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 200D 1F4BC","char":"👩‍💼","name":"woman office worker","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FB 200D 1F4BC","char":"👩🏻‍💼","name":"woman office worker: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FC 200D 1F4BC","char":"👩🏼‍💼","name":"woman office worker: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FD 200D 1F4BC","char":"👩🏽‍💼","name":"woman office worker: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FE 200D 1F4BC","char":"👩🏾‍💼","name":"woman office worker: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FF 200D 1F4BC","char":"👩🏿‍💼","name":"woman office worker: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 200D 1F52C","char":"🧑‍🔬","name":"scientist","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FB 200D 1F52C","char":"🧑🏻‍🔬","name":"scientist: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FC 200D 1F52C","char":"🧑🏼‍🔬","name":"scientist: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FD 200D 1F52C","char":"🧑🏽‍🔬","name":"scientist: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FE 200D 1F52C","char":"🧑🏾‍🔬","name":"scientist: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FF 200D 1F52C","char":"🧑🏿‍🔬","name":"scientist: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 200D 1F52C","char":"👨‍🔬","name":"man scientist","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FB 200D 1F52C","char":"👨🏻‍🔬","name":"man scientist: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FC 200D 1F52C","char":"👨🏼‍🔬","name":"man scientist: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FD 200D 1F52C","char":"👨🏽‍🔬","name":"man scientist: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FE 200D 1F52C","char":"👨🏾‍🔬","name":"man scientist: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FF 200D 1F52C","char":"👨🏿‍🔬","name":"man scientist: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 200D 1F52C","char":"👩‍🔬","name":"woman scientist","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FB 200D 1F52C","char":"👩🏻‍🔬","name":"woman scientist: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FC 200D 1F52C","char":"👩🏼‍🔬","name":"woman scientist: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FD 200D 1F52C","char":"👩🏽‍🔬","name":"woman scientist: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FE 200D 1F52C","char":"👩🏾‍🔬","name":"woman scientist: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FF 200D 1F52C","char":"👩🏿‍🔬","name":"woman scientist: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 200D 1F4BB","char":"🧑‍💻","name":"technologist","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FB 200D 1F4BB","char":"🧑🏻‍💻","name":"technologist: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FC 200D 1F4BB","char":"🧑🏼‍💻","name":"technologist: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FD 200D 1F4BB","char":"🧑🏽‍💻","name":"technologist: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FE 200D 1F4BB","char":"🧑🏾‍💻","name":"technologist: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FF 200D 1F4BB","char":"🧑🏿‍💻","name":"technologist: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 200D 1F4BB","char":"👨‍💻","name":"man technologist","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FB 200D 1F4BB","char":"👨🏻‍💻","name":"man technologist: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FC 200D 1F4BB","char":"👨🏼‍💻","name":"man technologist: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FD 200D 1F4BB","char":"👨🏽‍💻","name":"man technologist: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FE 200D 1F4BB","char":"👨🏾‍💻","name":"man technologist: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FF 200D 1F4BB","char":"👨🏿‍💻","name":"man technologist: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 200D 1F4BB","char":"👩‍💻","name":"woman technologist","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FB 200D 1F4BB","char":"👩🏻‍💻","name":"woman technologist: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FC 200D 1F4BB","char":"👩🏼‍💻","name":"woman technologist: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FD 200D 1F4BB","char":"👩🏽‍💻","name":"woman technologist: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FE 200D 1F4BB","char":"👩🏾‍💻","name":"woman technologist: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FF 200D 1F4BB","char":"👩🏿‍💻","name":"woman technologist: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 200D 1F3A4","char":"🧑‍🎤","name":"singer","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FB 200D 1F3A4","char":"🧑🏻‍🎤","name":"singer: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FC 200D 1F3A4","char":"🧑🏼‍🎤","name":"singer: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FD 200D 1F3A4","char":"🧑🏽‍🎤","name":"singer: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FE 200D 1F3A4","char":"🧑🏾‍🎤","name":"singer: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FF 200D 1F3A4","char":"🧑🏿‍🎤","name":"singer: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 200D 1F3A4","char":"👨‍🎤","name":"man singer","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FB 200D 1F3A4","char":"👨🏻‍🎤","name":"man singer: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FC 200D 1F3A4","char":"👨🏼‍🎤","name":"man singer: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FD 200D 1F3A4","char":"👨🏽‍🎤","name":"man singer: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FE 200D 1F3A4","char":"👨🏾‍🎤","name":"man singer: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FF 200D 1F3A4","char":"👨🏿‍🎤","name":"man singer: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 200D 1F3A4","char":"👩‍🎤","name":"woman singer","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FB 200D 1F3A4","char":"👩🏻‍🎤","name":"woman singer: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FC 200D 1F3A4","char":"👩🏼‍🎤","name":"woman singer: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FD 200D 1F3A4","char":"👩🏽‍🎤","name":"woman singer: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FE 200D 1F3A4","char":"👩🏾‍🎤","name":"woman singer: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FF 200D 1F3A4","char":"👩🏿‍🎤","name":"woman singer: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 200D 1F3A8","char":"🧑‍🎨","name":"artist","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FB 200D 1F3A8","char":"🧑🏻‍🎨","name":"artist: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FC 200D 1F3A8","char":"🧑🏼‍🎨","name":"artist: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FD 200D 1F3A8","char":"🧑🏽‍🎨","name":"artist: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FE 200D 1F3A8","char":"🧑🏾‍🎨","name":"artist: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FF 200D 1F3A8","char":"🧑🏿‍🎨","name":"artist: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 200D 1F3A8","char":"👨‍🎨","name":"man artist","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FB 200D 1F3A8","char":"👨🏻‍🎨","name":"man artist: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FC 200D 1F3A8","char":"👨🏼‍🎨","name":"man artist: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FD 200D 1F3A8","char":"👨🏽‍🎨","name":"man artist: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FE 200D 1F3A8","char":"👨🏾‍🎨","name":"man artist: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FF 200D 1F3A8","char":"👨🏿‍🎨","name":"man artist: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 200D 1F3A8","char":"👩‍🎨","name":"woman artist","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FB 200D 1F3A8","char":"👩🏻‍🎨","name":"woman artist: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FC 200D 1F3A8","char":"👩🏼‍🎨","name":"woman artist: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FD 200D 1F3A8","char":"👩🏽‍🎨","name":"woman artist: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FE 200D 1F3A8","char":"👩🏾‍🎨","name":"woman artist: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FF 200D 1F3A8","char":"👩🏿‍🎨","name":"woman artist: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 200D 2708 FE0F","char":"🧑‍✈️","name":"pilot","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 200D 2708","char":"🧑‍✈","name":"pilot","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FB 200D 2708 FE0F","char":"🧑🏻‍✈️","name":"pilot: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FB 200D 2708","char":"🧑🏻‍✈","name":"pilot: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FC 200D 2708 FE0F","char":"🧑🏼‍✈️","name":"pilot: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FC 200D 2708","char":"🧑🏼‍✈","name":"pilot: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FD 200D 2708 FE0F","char":"🧑🏽‍✈️","name":"pilot: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FD 200D 2708","char":"🧑🏽‍✈","name":"pilot: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FE 200D 2708 FE0F","char":"🧑🏾‍✈️","name":"pilot: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FE 200D 2708","char":"🧑🏾‍✈","name":"pilot: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FF 200D 2708 FE0F","char":"🧑🏿‍✈️","name":"pilot: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FF 200D 2708","char":"🧑🏿‍✈","name":"pilot: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 200D 2708 FE0F","char":"👨‍✈️","name":"man pilot","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 200D 2708","char":"👨‍✈","name":"man pilot","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FB 200D 2708 FE0F","char":"👨🏻‍✈️","name":"man pilot: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FB 200D 2708","char":"👨🏻‍✈","name":"man pilot: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FC 200D 2708 FE0F","char":"👨🏼‍✈️","name":"man pilot: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FC 200D 2708","char":"👨🏼‍✈","name":"man pilot: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FD 200D 2708 FE0F","char":"👨🏽‍✈️","name":"man pilot: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FD 200D 2708","char":"👨🏽‍✈","name":"man pilot: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FE 200D 2708 FE0F","char":"👨🏾‍✈️","name":"man pilot: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FE 200D 2708","char":"👨🏾‍✈","name":"man pilot: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FF 200D 2708 FE0F","char":"👨🏿‍✈️","name":"man pilot: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FF 200D 2708","char":"👨🏿‍✈","name":"man pilot: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 200D 2708 FE0F","char":"👩‍✈️","name":"woman pilot","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 200D 2708","char":"👩‍✈","name":"woman pilot","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FB 200D 2708 FE0F","char":"👩🏻‍✈️","name":"woman pilot: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FB 200D 2708","char":"👩🏻‍✈","name":"woman pilot: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FC 200D 2708 FE0F","char":"👩🏼‍✈️","name":"woman pilot: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FC 200D 2708","char":"👩🏼‍✈","name":"woman pilot: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FD 200D 2708 FE0F","char":"👩🏽‍✈️","name":"woman pilot: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FD 200D 2708","char":"👩🏽‍✈","name":"woman pilot: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FE 200D 2708 FE0F","char":"👩🏾‍✈️","name":"woman pilot: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FE 200D 2708","char":"👩🏾‍✈","name":"woman pilot: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FF 200D 2708 FE0F","char":"👩🏿‍✈️","name":"woman pilot: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FF 200D 2708","char":"👩🏿‍✈","name":"woman pilot: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 200D 1F680","char":"🧑‍🚀","name":"astronaut","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FB 200D 1F680","char":"🧑🏻‍🚀","name":"astronaut: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FC 200D 1F680","char":"🧑🏼‍🚀","name":"astronaut: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FD 200D 1F680","char":"🧑🏽‍🚀","name":"astronaut: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FE 200D 1F680","char":"🧑🏾‍🚀","name":"astronaut: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FF 200D 1F680","char":"🧑🏿‍🚀","name":"astronaut: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 200D 1F680","char":"👨‍🚀","name":"man astronaut","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FB 200D 1F680","char":"👨🏻‍🚀","name":"man astronaut: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FC 200D 1F680","char":"👨🏼‍🚀","name":"man astronaut: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FD 200D 1F680","char":"👨🏽‍🚀","name":"man astronaut: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FE 200D 1F680","char":"👨🏾‍🚀","name":"man astronaut: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FF 200D 1F680","char":"👨🏿‍🚀","name":"man astronaut: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 200D 1F680","char":"👩‍🚀","name":"woman astronaut","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FB 200D 1F680","char":"👩🏻‍🚀","name":"woman astronaut: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FC 200D 1F680","char":"👩🏼‍🚀","name":"woman astronaut: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FD 200D 1F680","char":"👩🏽‍🚀","name":"woman astronaut: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FE 200D 1F680","char":"👩🏾‍🚀","name":"woman astronaut: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FF 200D 1F680","char":"👩🏿‍🚀","name":"woman astronaut: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 200D 1F692","char":"🧑‍🚒","name":"firefighter","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FB 200D 1F692","char":"🧑🏻‍🚒","name":"firefighter: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FC 200D 1F692","char":"🧑🏼‍🚒","name":"firefighter: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FD 200D 1F692","char":"🧑🏽‍🚒","name":"firefighter: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FE 200D 1F692","char":"🧑🏾‍🚒","name":"firefighter: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FF 200D 1F692","char":"🧑🏿‍🚒","name":"firefighter: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 200D 1F692","char":"👨‍🚒","name":"man firefighter","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FB 200D 1F692","char":"👨🏻‍🚒","name":"man firefighter: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FC 200D 1F692","char":"👨🏼‍🚒","name":"man firefighter: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FD 200D 1F692","char":"👨🏽‍🚒","name":"man firefighter: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FE 200D 1F692","char":"👨🏾‍🚒","name":"man firefighter: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FF 200D 1F692","char":"👨🏿‍🚒","name":"man firefighter: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 200D 1F692","char":"👩‍🚒","name":"woman firefighter","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FB 200D 1F692","char":"👩🏻‍🚒","name":"woman firefighter: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FC 200D 1F692","char":"👩🏼‍🚒","name":"woman firefighter: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FD 200D 1F692","char":"👩🏽‍🚒","name":"woman firefighter: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FE 200D 1F692","char":"👩🏾‍🚒","name":"woman firefighter: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FF 200D 1F692","char":"👩🏿‍🚒","name":"woman firefighter: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F46E","char":"👮","name":"police officer","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F46E 1F3FB","char":"👮🏻","name":"police officer: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F46E 1F3FC","char":"👮🏼","name":"police officer: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F46E 1F3FD","char":"👮🏽","name":"police officer: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F46E 1F3FE","char":"👮🏾","name":"police officer: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F46E 1F3FF","char":"👮🏿","name":"police officer: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F46E 200D 2642 FE0F","char":"👮‍♂️","name":"man police officer","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F46E 200D 2642","char":"👮‍♂","name":"man police officer","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F46E 1F3FB 200D 2642 FE0F","char":"👮🏻‍♂️","name":"man police officer: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F46E 1F3FB 200D 2642","char":"👮🏻‍♂","name":"man police officer: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F46E 1F3FC 200D 2642 FE0F","char":"👮🏼‍♂️","name":"man police officer: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F46E 1F3FC 200D 2642","char":"👮🏼‍♂","name":"man police officer: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F46E 1F3FD 200D 2642 FE0F","char":"👮🏽‍♂️","name":"man police officer: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F46E 1F3FD 200D 2642","char":"👮🏽‍♂","name":"man police officer: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F46E 1F3FE 200D 2642 FE0F","char":"👮🏾‍♂️","name":"man police officer: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F46E 1F3FE 200D 2642","char":"👮🏾‍♂","name":"man police officer: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F46E 1F3FF 200D 2642 FE0F","char":"👮🏿‍♂️","name":"man police officer: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F46E 1F3FF 200D 2642","char":"👮🏿‍♂","name":"man police officer: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F46E 200D 2640 FE0F","char":"👮‍♀️","name":"woman police officer","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F46E 200D 2640","char":"👮‍♀","name":"woman police officer","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F46E 1F3FB 200D 2640 FE0F","char":"👮🏻‍♀️","name":"woman police officer: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F46E 1F3FB 200D 2640","char":"👮🏻‍♀","name":"woman police officer: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F46E 1F3FC 200D 2640 FE0F","char":"👮🏼‍♀️","name":"woman police officer: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F46E 1F3FC 200D 2640","char":"👮🏼‍♀","name":"woman police officer: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F46E 1F3FD 200D 2640 FE0F","char":"👮🏽‍♀️","name":"woman police officer: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F46E 1F3FD 200D 2640","char":"👮🏽‍♀","name":"woman police officer: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F46E 1F3FE 200D 2640 FE0F","char":"👮🏾‍♀️","name":"woman police officer: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F46E 1F3FE 200D 2640","char":"👮🏾‍♀","name":"woman police officer: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F46E 1F3FF 200D 2640 FE0F","char":"👮🏿‍♀️","name":"woman police officer: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F46E 1F3FF 200D 2640","char":"👮🏿‍♀","name":"woman police officer: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F575 FE0F","char":"🕵️","name":"detective","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F575","char":"🕵","name":"detective","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F575 1F3FB","char":"🕵🏻","name":"detective: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F575 1F3FC","char":"🕵🏼","name":"detective: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F575 1F3FD","char":"🕵🏽","name":"detective: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F575 1F3FE","char":"🕵🏾","name":"detective: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F575 1F3FF","char":"🕵🏿","name":"detective: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F575 FE0F 200D 2642 FE0F","char":"🕵️‍♂️","name":"man detective","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F575 200D 2642 FE0F","char":"🕵‍♂️","name":"man detective","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F575 FE0F 200D 2642","char":"🕵️‍♂","name":"man detective","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F575 200D 2642","char":"🕵‍♂","name":"man detective","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F575 1F3FB 200D 2642 FE0F","char":"🕵🏻‍♂️","name":"man detective: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F575 1F3FB 200D 2642","char":"🕵🏻‍♂","name":"man detective: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F575 1F3FC 200D 2642 FE0F","char":"🕵🏼‍♂️","name":"man detective: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F575 1F3FC 200D 2642","char":"🕵🏼‍♂","name":"man detective: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F575 1F3FD 200D 2642 FE0F","char":"🕵🏽‍♂️","name":"man detective: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F575 1F3FD 200D 2642","char":"🕵🏽‍♂","name":"man detective: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F575 1F3FE 200D 2642 FE0F","char":"🕵🏾‍♂️","name":"man detective: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F575 1F3FE 200D 2642","char":"🕵🏾‍♂","name":"man detective: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F575 1F3FF 200D 2642 FE0F","char":"🕵🏿‍♂️","name":"man detective: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F575 1F3FF 200D 2642","char":"🕵🏿‍♂","name":"man detective: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F575 FE0F 200D 2640 FE0F","char":"🕵️‍♀️","name":"woman detective","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F575 200D 2640 FE0F","char":"🕵‍♀️","name":"woman detective","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F575 FE0F 200D 2640","char":"🕵️‍♀","name":"woman detective","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F575 200D 2640","char":"🕵‍♀","name":"woman detective","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F575 1F3FB 200D 2640 FE0F","char":"🕵🏻‍♀️","name":"woman detective: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F575 1F3FB 200D 2640","char":"🕵🏻‍♀","name":"woman detective: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F575 1F3FC 200D 2640 FE0F","char":"🕵🏼‍♀️","name":"woman detective: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F575 1F3FC 200D 2640","char":"🕵🏼‍♀","name":"woman detective: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F575 1F3FD 200D 2640 FE0F","char":"🕵🏽‍♀️","name":"woman detective: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F575 1F3FD 200D 2640","char":"🕵🏽‍♀","name":"woman detective: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F575 1F3FE 200D 2640 FE0F","char":"🕵🏾‍♀️","name":"woman detective: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F575 1F3FE 200D 2640","char":"🕵🏾‍♀","name":"woman detective: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F575 1F3FF 200D 2640 FE0F","char":"🕵🏿‍♀️","name":"woman detective: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F575 1F3FF 200D 2640","char":"🕵🏿‍♀","name":"woman detective: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F482","char":"💂","name":"guard","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F482 1F3FB","char":"💂🏻","name":"guard: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F482 1F3FC","char":"💂🏼","name":"guard: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F482 1F3FD","char":"💂🏽","name":"guard: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F482 1F3FE","char":"💂🏾","name":"guard: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F482 1F3FF","char":"💂🏿","name":"guard: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F482 200D 2642 FE0F","char":"💂‍♂️","name":"man guard","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F482 200D 2642","char":"💂‍♂","name":"man guard","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F482 1F3FB 200D 2642 FE0F","char":"💂🏻‍♂️","name":"man guard: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F482 1F3FB 200D 2642","char":"💂🏻‍♂","name":"man guard: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F482 1F3FC 200D 2642 FE0F","char":"💂🏼‍♂️","name":"man guard: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F482 1F3FC 200D 2642","char":"💂🏼‍♂","name":"man guard: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F482 1F3FD 200D 2642 FE0F","char":"💂🏽‍♂️","name":"man guard: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F482 1F3FD 200D 2642","char":"💂🏽‍♂","name":"man guard: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F482 1F3FE 200D 2642 FE0F","char":"💂🏾‍♂️","name":"man guard: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F482 1F3FE 200D 2642","char":"💂🏾‍♂","name":"man guard: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F482 1F3FF 200D 2642 FE0F","char":"💂🏿‍♂️","name":"man guard: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F482 1F3FF 200D 2642","char":"💂🏿‍♂","name":"man guard: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F482 200D 2640 FE0F","char":"💂‍♀️","name":"woman guard","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F482 200D 2640","char":"💂‍♀","name":"woman guard","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F482 1F3FB 200D 2640 FE0F","char":"💂🏻‍♀️","name":"woman guard: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F482 1F3FB 200D 2640","char":"💂🏻‍♀","name":"woman guard: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F482 1F3FC 200D 2640 FE0F","char":"💂🏼‍♀️","name":"woman guard: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F482 1F3FC 200D 2640","char":"💂🏼‍♀","name":"woman guard: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F482 1F3FD 200D 2640 FE0F","char":"💂🏽‍♀️","name":"woman guard: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F482 1F3FD 200D 2640","char":"💂🏽‍♀","name":"woman guard: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F482 1F3FE 200D 2640 FE0F","char":"💂🏾‍♀️","name":"woman guard: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F482 1F3FE 200D 2640","char":"💂🏾‍♀","name":"woman guard: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F482 1F3FF 200D 2640 FE0F","char":"💂🏿‍♀️","name":"woman guard: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F482 1F3FF 200D 2640","char":"💂🏿‍♀","name":"woman guard: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F977","char":"🥷","name":"ninja","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F977 1F3FB","char":"🥷🏻","name":"ninja: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F977 1F3FC","char":"🥷🏼","name":"ninja: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F977 1F3FD","char":"🥷🏽","name":"ninja: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F977 1F3FE","char":"🥷🏾","name":"ninja: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F977 1F3FF","char":"🥷🏿","name":"ninja: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F477","char":"👷","name":"construction worker","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F477 1F3FB","char":"👷🏻","name":"construction worker: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F477 1F3FC","char":"👷🏼","name":"construction worker: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F477 1F3FD","char":"👷🏽","name":"construction worker: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F477 1F3FE","char":"👷🏾","name":"construction worker: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F477 1F3FF","char":"👷🏿","name":"construction worker: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F477 200D 2642 FE0F","char":"👷‍♂️","name":"man construction worker","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F477 200D 2642","char":"👷‍♂","name":"man construction worker","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F477 1F3FB 200D 2642 FE0F","char":"👷🏻‍♂️","name":"man construction worker: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F477 1F3FB 200D 2642","char":"👷🏻‍♂","name":"man construction worker: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F477 1F3FC 200D 2642 FE0F","char":"👷🏼‍♂️","name":"man construction worker: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F477 1F3FC 200D 2642","char":"👷🏼‍♂","name":"man construction worker: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F477 1F3FD 200D 2642 FE0F","char":"👷🏽‍♂️","name":"man construction worker: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F477 1F3FD 200D 2642","char":"👷🏽‍♂","name":"man construction worker: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F477 1F3FE 200D 2642 FE0F","char":"👷🏾‍♂️","name":"man construction worker: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F477 1F3FE 200D 2642","char":"👷🏾‍♂","name":"man construction worker: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F477 1F3FF 200D 2642 FE0F","char":"👷🏿‍♂️","name":"man construction worker: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F477 1F3FF 200D 2642","char":"👷🏿‍♂","name":"man construction worker: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F477 200D 2640 FE0F","char":"👷‍♀️","name":"woman construction worker","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F477 200D 2640","char":"👷‍♀","name":"woman construction worker","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F477 1F3FB 200D 2640 FE0F","char":"👷🏻‍♀️","name":"woman construction worker: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F477 1F3FB 200D 2640","char":"👷🏻‍♀","name":"woman construction worker: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F477 1F3FC 200D 2640 FE0F","char":"👷🏼‍♀️","name":"woman construction worker: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F477 1F3FC 200D 2640","char":"👷🏼‍♀","name":"woman construction worker: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F477 1F3FD 200D 2640 FE0F","char":"👷🏽‍♀️","name":"woman construction worker: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F477 1F3FD 200D 2640","char":"👷🏽‍♀","name":"woman construction worker: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F477 1F3FE 200D 2640 FE0F","char":"👷🏾‍♀️","name":"woman construction worker: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F477 1F3FE 200D 2640","char":"👷🏾‍♀","name":"woman construction worker: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F477 1F3FF 200D 2640 FE0F","char":"👷🏿‍♀️","name":"woman construction worker: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F477 1F3FF 200D 2640","char":"👷🏿‍♀","name":"woman construction worker: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1FAC5","char":"🫅","name":"person with crown","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1FAC5 1F3FB","char":"🫅🏻","name":"person with crown: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1FAC5 1F3FC","char":"🫅🏼","name":"person with crown: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1FAC5 1F3FD","char":"🫅🏽","name":"person with crown: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1FAC5 1F3FE","char":"🫅🏾","name":"person with crown: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1FAC5 1F3FF","char":"🫅🏿","name":"person with crown: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F934","char":"🤴","name":"prince","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F934 1F3FB","char":"🤴🏻","name":"prince: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F934 1F3FC","char":"🤴🏼","name":"prince: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F934 1F3FD","char":"🤴🏽","name":"prince: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F934 1F3FE","char":"🤴🏾","name":"prince: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F934 1F3FF","char":"🤴🏿","name":"prince: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F478","char":"👸","name":"princess","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F478 1F3FB","char":"👸🏻","name":"princess: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F478 1F3FC","char":"👸🏼","name":"princess: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F478 1F3FD","char":"👸🏽","name":"princess: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F478 1F3FE","char":"👸🏾","name":"princess: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F478 1F3FF","char":"👸🏿","name":"princess: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F473","char":"👳","name":"person wearing turban","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F473 1F3FB","char":"👳🏻","name":"person wearing turban: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F473 1F3FC","char":"👳🏼","name":"person wearing turban: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F473 1F3FD","char":"👳🏽","name":"person wearing turban: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F473 1F3FE","char":"👳🏾","name":"person wearing turban: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F473 1F3FF","char":"👳🏿","name":"person wearing turban: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F473 200D 2642 FE0F","char":"👳‍♂️","name":"man wearing turban","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F473 200D 2642","char":"👳‍♂","name":"man wearing turban","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F473 1F3FB 200D 2642 FE0F","char":"👳🏻‍♂️","name":"man wearing turban: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F473 1F3FB 200D 2642","char":"👳🏻‍♂","name":"man wearing turban: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F473 1F3FC 200D 2642 FE0F","char":"👳🏼‍♂️","name":"man wearing turban: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F473 1F3FC 200D 2642","char":"👳🏼‍♂","name":"man wearing turban: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F473 1F3FD 200D 2642 FE0F","char":"👳🏽‍♂️","name":"man wearing turban: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F473 1F3FD 200D 2642","char":"👳🏽‍♂","name":"man wearing turban: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F473 1F3FE 200D 2642 FE0F","char":"👳🏾‍♂️","name":"man wearing turban: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F473 1F3FE 200D 2642","char":"👳🏾‍♂","name":"man wearing turban: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F473 1F3FF 200D 2642 FE0F","char":"👳🏿‍♂️","name":"man wearing turban: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F473 1F3FF 200D 2642","char":"👳🏿‍♂","name":"man wearing turban: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F473 200D 2640 FE0F","char":"👳‍♀️","name":"woman wearing turban","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F473 200D 2640","char":"👳‍♀","name":"woman wearing turban","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F473 1F3FB 200D 2640 FE0F","char":"👳🏻‍♀️","name":"woman wearing turban: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F473 1F3FB 200D 2640","char":"👳🏻‍♀","name":"woman wearing turban: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F473 1F3FC 200D 2640 FE0F","char":"👳🏼‍♀️","name":"woman wearing turban: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F473 1F3FC 200D 2640","char":"👳🏼‍♀","name":"woman wearing turban: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F473 1F3FD 200D 2640 FE0F","char":"👳🏽‍♀️","name":"woman wearing turban: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F473 1F3FD 200D 2640","char":"👳🏽‍♀","name":"woman wearing turban: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F473 1F3FE 200D 2640 FE0F","char":"👳🏾‍♀️","name":"woman wearing turban: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F473 1F3FE 200D 2640","char":"👳🏾‍♀","name":"woman wearing turban: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F473 1F3FF 200D 2640 FE0F","char":"👳🏿‍♀️","name":"woman wearing turban: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F473 1F3FF 200D 2640","char":"👳🏿‍♀","name":"woman wearing turban: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F472","char":"👲","name":"person with skullcap","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F472 1F3FB","char":"👲🏻","name":"person with skullcap: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F472 1F3FC","char":"👲🏼","name":"person with skullcap: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F472 1F3FD","char":"👲🏽","name":"person with skullcap: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F472 1F3FE","char":"👲🏾","name":"person with skullcap: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F472 1F3FF","char":"👲🏿","name":"person with skullcap: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D5","char":"🧕","name":"woman with headscarf","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D5 1F3FB","char":"🧕🏻","name":"woman with headscarf: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D5 1F3FC","char":"🧕🏼","name":"woman with headscarf: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D5 1F3FD","char":"🧕🏽","name":"woman with headscarf: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D5 1F3FE","char":"🧕🏾","name":"woman with headscarf: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D5 1F3FF","char":"🧕🏿","name":"woman with headscarf: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F935","char":"🤵","name":"person in tuxedo","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F935 1F3FB","char":"🤵🏻","name":"person in tuxedo: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F935 1F3FC","char":"🤵🏼","name":"person in tuxedo: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F935 1F3FD","char":"🤵🏽","name":"person in tuxedo: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F935 1F3FE","char":"🤵🏾","name":"person in tuxedo: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F935 1F3FF","char":"🤵🏿","name":"person in tuxedo: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F935 200D 2642 FE0F","char":"🤵‍♂️","name":"man in tuxedo","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F935 200D 2642","char":"🤵‍♂","name":"man in tuxedo","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F935 1F3FB 200D 2642 FE0F","char":"🤵🏻‍♂️","name":"man in tuxedo: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F935 1F3FB 200D 2642","char":"🤵🏻‍♂","name":"man in tuxedo: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F935 1F3FC 200D 2642 FE0F","char":"🤵🏼‍♂️","name":"man in tuxedo: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F935 1F3FC 200D 2642","char":"🤵🏼‍♂","name":"man in tuxedo: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F935 1F3FD 200D 2642 FE0F","char":"🤵🏽‍♂️","name":"man in tuxedo: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F935 1F3FD 200D 2642","char":"🤵🏽‍♂","name":"man in tuxedo: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F935 1F3FE 200D 2642 FE0F","char":"🤵🏾‍♂️","name":"man in tuxedo: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F935 1F3FE 200D 2642","char":"🤵🏾‍♂","name":"man in tuxedo: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F935 1F3FF 200D 2642 FE0F","char":"🤵🏿‍♂️","name":"man in tuxedo: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F935 1F3FF 200D 2642","char":"🤵🏿‍♂","name":"man in tuxedo: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F935 200D 2640 FE0F","char":"🤵‍♀️","name":"woman in tuxedo","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F935 200D 2640","char":"🤵‍♀","name":"woman in tuxedo","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F935 1F3FB 200D 2640 FE0F","char":"🤵🏻‍♀️","name":"woman in tuxedo: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F935 1F3FB 200D 2640","char":"🤵🏻‍♀","name":"woman in tuxedo: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F935 1F3FC 200D 2640 FE0F","char":"🤵🏼‍♀️","name":"woman in tuxedo: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F935 1F3FC 200D 2640","char":"🤵🏼‍♀","name":"woman in tuxedo: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F935 1F3FD 200D 2640 FE0F","char":"🤵🏽‍♀️","name":"woman in tuxedo: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F935 1F3FD 200D 2640","char":"🤵🏽‍♀","name":"woman in tuxedo: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F935 1F3FE 200D 2640 FE0F","char":"🤵🏾‍♀️","name":"woman in tuxedo: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F935 1F3FE 200D 2640","char":"🤵🏾‍♀","name":"woman in tuxedo: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F935 1F3FF 200D 2640 FE0F","char":"🤵🏿‍♀️","name":"woman in tuxedo: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F935 1F3FF 200D 2640","char":"🤵🏿‍♀","name":"woman in tuxedo: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F470","char":"👰","name":"person with veil","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F470 1F3FB","char":"👰🏻","name":"person with veil: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F470 1F3FC","char":"👰🏼","name":"person with veil: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F470 1F3FD","char":"👰🏽","name":"person with veil: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F470 1F3FE","char":"👰🏾","name":"person with veil: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F470 1F3FF","char":"👰🏿","name":"person with veil: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F470 200D 2642 FE0F","char":"👰‍♂️","name":"man with veil","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F470 200D 2642","char":"👰‍♂","name":"man with veil","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F470 1F3FB 200D 2642 FE0F","char":"👰🏻‍♂️","name":"man with veil: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F470 1F3FB 200D 2642","char":"👰🏻‍♂","name":"man with veil: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F470 1F3FC 200D 2642 FE0F","char":"👰🏼‍♂️","name":"man with veil: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F470 1F3FC 200D 2642","char":"👰🏼‍♂","name":"man with veil: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F470 1F3FD 200D 2642 FE0F","char":"👰🏽‍♂️","name":"man with veil: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F470 1F3FD 200D 2642","char":"👰🏽‍♂","name":"man with veil: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F470 1F3FE 200D 2642 FE0F","char":"👰🏾‍♂️","name":"man with veil: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F470 1F3FE 200D 2642","char":"👰🏾‍♂","name":"man with veil: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F470 1F3FF 200D 2642 FE0F","char":"👰🏿‍♂️","name":"man with veil: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F470 1F3FF 200D 2642","char":"👰🏿‍♂","name":"man with veil: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F470 200D 2640 FE0F","char":"👰‍♀️","name":"woman with veil","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F470 200D 2640","char":"👰‍♀","name":"woman with veil","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F470 1F3FB 200D 2640 FE0F","char":"👰🏻‍♀️","name":"woman with veil: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F470 1F3FB 200D 2640","char":"👰🏻‍♀","name":"woman with veil: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F470 1F3FC 200D 2640 FE0F","char":"👰🏼‍♀️","name":"woman with veil: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F470 1F3FC 200D 2640","char":"👰🏼‍♀","name":"woman with veil: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F470 1F3FD 200D 2640 FE0F","char":"👰🏽‍♀️","name":"woman with veil: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F470 1F3FD 200D 2640","char":"👰🏽‍♀","name":"woman with veil: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F470 1F3FE 200D 2640 FE0F","char":"👰🏾‍♀️","name":"woman with veil: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F470 1F3FE 200D 2640","char":"👰🏾‍♀","name":"woman with veil: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F470 1F3FF 200D 2640 FE0F","char":"👰🏿‍♀️","name":"woman with veil: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F470 1F3FF 200D 2640","char":"👰🏿‍♀","name":"woman with veil: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F930","char":"🤰","name":"pregnant woman","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F930 1F3FB","char":"🤰🏻","name":"pregnant woman: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F930 1F3FC","char":"🤰🏼","name":"pregnant woman: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F930 1F3FD","char":"🤰🏽","name":"pregnant woman: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F930 1F3FE","char":"🤰🏾","name":"pregnant woman: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F930 1F3FF","char":"🤰🏿","name":"pregnant woman: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1FAC3","char":"🫃","name":"pregnant man","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1FAC3 1F3FB","char":"🫃🏻","name":"pregnant man: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1FAC3 1F3FC","char":"🫃🏼","name":"pregnant man: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1FAC3 1F3FD","char":"🫃🏽","name":"pregnant man: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1FAC3 1F3FE","char":"🫃🏾","name":"pregnant man: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1FAC3 1F3FF","char":"🫃🏿","name":"pregnant man: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1FAC4","char":"🫄","name":"pregnant person","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1FAC4 1F3FB","char":"🫄🏻","name":"pregnant person: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1FAC4 1F3FC","char":"🫄🏼","name":"pregnant person: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1FAC4 1F3FD","char":"🫄🏽","name":"pregnant person: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1FAC4 1F3FE","char":"🫄🏾","name":"pregnant person: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1FAC4 1F3FF","char":"🫄🏿","name":"pregnant person: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F931","char":"🤱","name":"breast-feeding","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F931 1F3FB","char":"🤱🏻","name":"breast-feeding: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F931 1F3FC","char":"🤱🏼","name":"breast-feeding: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F931 1F3FD","char":"🤱🏽","name":"breast-feeding: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F931 1F3FE","char":"🤱🏾","name":"breast-feeding: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F931 1F3FF","char":"🤱🏿","name":"breast-feeding: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 200D 1F37C","char":"👩‍🍼","name":"woman feeding baby","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FB 200D 1F37C","char":"👩🏻‍🍼","name":"woman feeding baby: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FC 200D 1F37C","char":"👩🏼‍🍼","name":"woman feeding baby: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FD 200D 1F37C","char":"👩🏽‍🍼","name":"woman feeding baby: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FE 200D 1F37C","char":"👩🏾‍🍼","name":"woman feeding baby: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F469 1F3FF 200D 1F37C","char":"👩🏿‍🍼","name":"woman feeding baby: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 200D 1F37C","char":"👨‍🍼","name":"man feeding baby","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FB 200D 1F37C","char":"👨🏻‍🍼","name":"man feeding baby: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FC 200D 1F37C","char":"👨🏼‍🍼","name":"man feeding baby: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FD 200D 1F37C","char":"👨🏽‍🍼","name":"man feeding baby: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FE 200D 1F37C","char":"👨🏾‍🍼","name":"man feeding baby: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F468 1F3FF 200D 1F37C","char":"👨🏿‍🍼","name":"man feeding baby: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 200D 1F37C","char":"🧑‍🍼","name":"person feeding baby","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FB 200D 1F37C","char":"🧑🏻‍🍼","name":"person feeding baby: light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FC 200D 1F37C","char":"🧑🏼‍🍼","name":"person feeding baby: medium-light skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FD 200D 1F37C","char":"🧑🏽‍🍼","name":"person feeding baby: medium skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FE 200D 1F37C","char":"🧑🏾‍🍼","name":"person feeding baby: medium-dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F9D1 1F3FF 200D 1F37C","char":"🧑🏿‍🍼","name":"person feeding baby: dark skin tone","category":"People & Body (person-role)","group":"People & Body","subgroup":"person-role"},{"codes":"1F47C","char":"👼","name":"baby angel","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F47C 1F3FB","char":"👼🏻","name":"baby angel: light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F47C 1F3FC","char":"👼🏼","name":"baby angel: medium-light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F47C 1F3FD","char":"👼🏽","name":"baby angel: medium skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F47C 1F3FE","char":"👼🏾","name":"baby angel: medium-dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F47C 1F3FF","char":"👼🏿","name":"baby angel: dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F385","char":"🎅","name":"Santa Claus","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F385 1F3FB","char":"🎅🏻","name":"Santa Claus: light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F385 1F3FC","char":"🎅🏼","name":"Santa Claus: medium-light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F385 1F3FD","char":"🎅🏽","name":"Santa Claus: medium skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F385 1F3FE","char":"🎅🏾","name":"Santa Claus: medium-dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F385 1F3FF","char":"🎅🏿","name":"Santa Claus: dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F936","char":"🤶","name":"Mrs. Claus","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F936 1F3FB","char":"🤶🏻","name":"Mrs. Claus: light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F936 1F3FC","char":"🤶🏼","name":"Mrs. Claus: medium-light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F936 1F3FD","char":"🤶🏽","name":"Mrs. Claus: medium skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F936 1F3FE","char":"🤶🏾","name":"Mrs. Claus: medium-dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F936 1F3FF","char":"🤶🏿","name":"Mrs. Claus: dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9D1 200D 1F384","char":"🧑‍🎄","name":"mx claus","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9D1 1F3FB 200D 1F384","char":"🧑🏻‍🎄","name":"mx claus: light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9D1 1F3FC 200D 1F384","char":"🧑🏼‍🎄","name":"mx claus: medium-light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9D1 1F3FD 200D 1F384","char":"🧑🏽‍🎄","name":"mx claus: medium skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9D1 1F3FE 200D 1F384","char":"🧑🏾‍🎄","name":"mx claus: medium-dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9D1 1F3FF 200D 1F384","char":"🧑🏿‍🎄","name":"mx claus: dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B8","char":"🦸","name":"superhero","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B8 1F3FB","char":"🦸🏻","name":"superhero: light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B8 1F3FC","char":"🦸🏼","name":"superhero: medium-light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B8 1F3FD","char":"🦸🏽","name":"superhero: medium skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B8 1F3FE","char":"🦸🏾","name":"superhero: medium-dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B8 1F3FF","char":"🦸🏿","name":"superhero: dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B8 200D 2642 FE0F","char":"🦸‍♂️","name":"man superhero","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B8 200D 2642","char":"🦸‍♂","name":"man superhero","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B8 1F3FB 200D 2642 FE0F","char":"🦸🏻‍♂️","name":"man superhero: light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B8 1F3FB 200D 2642","char":"🦸🏻‍♂","name":"man superhero: light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B8 1F3FC 200D 2642 FE0F","char":"🦸🏼‍♂️","name":"man superhero: medium-light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B8 1F3FC 200D 2642","char":"🦸🏼‍♂","name":"man superhero: medium-light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B8 1F3FD 200D 2642 FE0F","char":"🦸🏽‍♂️","name":"man superhero: medium skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B8 1F3FD 200D 2642","char":"🦸🏽‍♂","name":"man superhero: medium skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B8 1F3FE 200D 2642 FE0F","char":"🦸🏾‍♂️","name":"man superhero: medium-dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B8 1F3FE 200D 2642","char":"🦸🏾‍♂","name":"man superhero: medium-dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B8 1F3FF 200D 2642 FE0F","char":"🦸🏿‍♂️","name":"man superhero: dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B8 1F3FF 200D 2642","char":"🦸🏿‍♂","name":"man superhero: dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B8 200D 2640 FE0F","char":"🦸‍♀️","name":"woman superhero","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B8 200D 2640","char":"🦸‍♀","name":"woman superhero","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B8 1F3FB 200D 2640 FE0F","char":"🦸🏻‍♀️","name":"woman superhero: light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B8 1F3FB 200D 2640","char":"🦸🏻‍♀","name":"woman superhero: light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B8 1F3FC 200D 2640 FE0F","char":"🦸🏼‍♀️","name":"woman superhero: medium-light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B8 1F3FC 200D 2640","char":"🦸🏼‍♀","name":"woman superhero: medium-light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B8 1F3FD 200D 2640 FE0F","char":"🦸🏽‍♀️","name":"woman superhero: medium skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B8 1F3FD 200D 2640","char":"🦸🏽‍♀","name":"woman superhero: medium skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B8 1F3FE 200D 2640 FE0F","char":"🦸🏾‍♀️","name":"woman superhero: medium-dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B8 1F3FE 200D 2640","char":"🦸🏾‍♀","name":"woman superhero: medium-dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B8 1F3FF 200D 2640 FE0F","char":"🦸🏿‍♀️","name":"woman superhero: dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B8 1F3FF 200D 2640","char":"🦸🏿‍♀","name":"woman superhero: dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B9","char":"🦹","name":"supervillain","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B9 1F3FB","char":"🦹🏻","name":"supervillain: light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B9 1F3FC","char":"🦹🏼","name":"supervillain: medium-light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B9 1F3FD","char":"🦹🏽","name":"supervillain: medium skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B9 1F3FE","char":"🦹🏾","name":"supervillain: medium-dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B9 1F3FF","char":"🦹🏿","name":"supervillain: dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B9 200D 2642 FE0F","char":"🦹‍♂️","name":"man supervillain","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B9 200D 2642","char":"🦹‍♂","name":"man supervillain","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B9 1F3FB 200D 2642 FE0F","char":"🦹🏻‍♂️","name":"man supervillain: light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B9 1F3FB 200D 2642","char":"🦹🏻‍♂","name":"man supervillain: light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B9 1F3FC 200D 2642 FE0F","char":"🦹🏼‍♂️","name":"man supervillain: medium-light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B9 1F3FC 200D 2642","char":"🦹🏼‍♂","name":"man supervillain: medium-light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B9 1F3FD 200D 2642 FE0F","char":"🦹🏽‍♂️","name":"man supervillain: medium skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B9 1F3FD 200D 2642","char":"🦹🏽‍♂","name":"man supervillain: medium skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B9 1F3FE 200D 2642 FE0F","char":"🦹🏾‍♂️","name":"man supervillain: medium-dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B9 1F3FE 200D 2642","char":"🦹🏾‍♂","name":"man supervillain: medium-dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B9 1F3FF 200D 2642 FE0F","char":"🦹🏿‍♂️","name":"man supervillain: dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B9 1F3FF 200D 2642","char":"🦹🏿‍♂","name":"man supervillain: dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B9 200D 2640 FE0F","char":"🦹‍♀️","name":"woman supervillain","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B9 200D 2640","char":"🦹‍♀","name":"woman supervillain","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B9 1F3FB 200D 2640 FE0F","char":"🦹🏻‍♀️","name":"woman supervillain: light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B9 1F3FB 200D 2640","char":"🦹🏻‍♀","name":"woman supervillain: light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B9 1F3FC 200D 2640 FE0F","char":"🦹🏼‍♀️","name":"woman supervillain: medium-light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B9 1F3FC 200D 2640","char":"🦹🏼‍♀","name":"woman supervillain: medium-light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B9 1F3FD 200D 2640 FE0F","char":"🦹🏽‍♀️","name":"woman supervillain: medium skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B9 1F3FD 200D 2640","char":"🦹🏽‍♀","name":"woman supervillain: medium skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B9 1F3FE 200D 2640 FE0F","char":"🦹🏾‍♀️","name":"woman supervillain: medium-dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B9 1F3FE 200D 2640","char":"🦹🏾‍♀","name":"woman supervillain: medium-dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B9 1F3FF 200D 2640 FE0F","char":"🦹🏿‍♀️","name":"woman supervillain: dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9B9 1F3FF 200D 2640","char":"🦹🏿‍♀","name":"woman supervillain: dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9D9","char":"🧙","name":"mage","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9D9 1F3FB","char":"🧙🏻","name":"mage: light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9D9 1F3FC","char":"🧙🏼","name":"mage: medium-light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9D9 1F3FD","char":"🧙🏽","name":"mage: medium skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9D9 1F3FE","char":"🧙🏾","name":"mage: medium-dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9D9 1F3FF","char":"🧙🏿","name":"mage: dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9D9 200D 2642 FE0F","char":"🧙‍♂️","name":"man mage","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9D9 200D 2642","char":"🧙‍♂","name":"man mage","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9D9 1F3FB 200D 2642 FE0F","char":"🧙🏻‍♂️","name":"man mage: light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9D9 1F3FB 200D 2642","char":"🧙🏻‍♂","name":"man mage: light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9D9 1F3FC 200D 2642 FE0F","char":"🧙🏼‍♂️","name":"man mage: medium-light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9D9 1F3FC 200D 2642","char":"🧙🏼‍♂","name":"man mage: medium-light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9D9 1F3FD 200D 2642 FE0F","char":"🧙🏽‍♂️","name":"man mage: medium skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9D9 1F3FD 200D 2642","char":"🧙🏽‍♂","name":"man mage: medium skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9D9 1F3FE 200D 2642 FE0F","char":"🧙🏾‍♂️","name":"man mage: medium-dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9D9 1F3FE 200D 2642","char":"🧙🏾‍♂","name":"man mage: medium-dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9D9 1F3FF 200D 2642 FE0F","char":"🧙🏿‍♂️","name":"man mage: dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9D9 1F3FF 200D 2642","char":"🧙🏿‍♂","name":"man mage: dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9D9 200D 2640 FE0F","char":"🧙‍♀️","name":"woman mage","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9D9 200D 2640","char":"🧙‍♀","name":"woman mage","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9D9 1F3FB 200D 2640 FE0F","char":"🧙🏻‍♀️","name":"woman mage: light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9D9 1F3FB 200D 2640","char":"🧙🏻‍♀","name":"woman mage: light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9D9 1F3FC 200D 2640 FE0F","char":"🧙🏼‍♀️","name":"woman mage: medium-light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9D9 1F3FC 200D 2640","char":"🧙🏼‍♀","name":"woman mage: medium-light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9D9 1F3FD 200D 2640 FE0F","char":"🧙🏽‍♀️","name":"woman mage: medium skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9D9 1F3FD 200D 2640","char":"🧙🏽‍♀","name":"woman mage: medium skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9D9 1F3FE 200D 2640 FE0F","char":"🧙🏾‍♀️","name":"woman mage: medium-dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9D9 1F3FE 200D 2640","char":"🧙🏾‍♀","name":"woman mage: medium-dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9D9 1F3FF 200D 2640 FE0F","char":"🧙🏿‍♀️","name":"woman mage: dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9D9 1F3FF 200D 2640","char":"🧙🏿‍♀","name":"woman mage: dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DA","char":"🧚","name":"fairy","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DA 1F3FB","char":"🧚🏻","name":"fairy: light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DA 1F3FC","char":"🧚🏼","name":"fairy: medium-light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DA 1F3FD","char":"🧚🏽","name":"fairy: medium skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DA 1F3FE","char":"🧚🏾","name":"fairy: medium-dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DA 1F3FF","char":"🧚🏿","name":"fairy: dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DA 200D 2642 FE0F","char":"🧚‍♂️","name":"man fairy","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DA 200D 2642","char":"🧚‍♂","name":"man fairy","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DA 1F3FB 200D 2642 FE0F","char":"🧚🏻‍♂️","name":"man fairy: light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DA 1F3FB 200D 2642","char":"🧚🏻‍♂","name":"man fairy: light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DA 1F3FC 200D 2642 FE0F","char":"🧚🏼‍♂️","name":"man fairy: medium-light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DA 1F3FC 200D 2642","char":"🧚🏼‍♂","name":"man fairy: medium-light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DA 1F3FD 200D 2642 FE0F","char":"🧚🏽‍♂️","name":"man fairy: medium skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DA 1F3FD 200D 2642","char":"🧚🏽‍♂","name":"man fairy: medium skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DA 1F3FE 200D 2642 FE0F","char":"🧚🏾‍♂️","name":"man fairy: medium-dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DA 1F3FE 200D 2642","char":"🧚🏾‍♂","name":"man fairy: medium-dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DA 1F3FF 200D 2642 FE0F","char":"🧚🏿‍♂️","name":"man fairy: dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DA 1F3FF 200D 2642","char":"🧚🏿‍♂","name":"man fairy: dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DA 200D 2640 FE0F","char":"🧚‍♀️","name":"woman fairy","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DA 200D 2640","char":"🧚‍♀","name":"woman fairy","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DA 1F3FB 200D 2640 FE0F","char":"🧚🏻‍♀️","name":"woman fairy: light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DA 1F3FB 200D 2640","char":"🧚🏻‍♀","name":"woman fairy: light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DA 1F3FC 200D 2640 FE0F","char":"🧚🏼‍♀️","name":"woman fairy: medium-light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DA 1F3FC 200D 2640","char":"🧚🏼‍♀","name":"woman fairy: medium-light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DA 1F3FD 200D 2640 FE0F","char":"🧚🏽‍♀️","name":"woman fairy: medium skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DA 1F3FD 200D 2640","char":"🧚🏽‍♀","name":"woman fairy: medium skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DA 1F3FE 200D 2640 FE0F","char":"🧚🏾‍♀️","name":"woman fairy: medium-dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DA 1F3FE 200D 2640","char":"🧚🏾‍♀","name":"woman fairy: medium-dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DA 1F3FF 200D 2640 FE0F","char":"🧚🏿‍♀️","name":"woman fairy: dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DA 1F3FF 200D 2640","char":"🧚🏿‍♀","name":"woman fairy: dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DB","char":"🧛","name":"vampire","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DB 1F3FB","char":"🧛🏻","name":"vampire: light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DB 1F3FC","char":"🧛🏼","name":"vampire: medium-light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DB 1F3FD","char":"🧛🏽","name":"vampire: medium skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DB 1F3FE","char":"🧛🏾","name":"vampire: medium-dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DB 1F3FF","char":"🧛🏿","name":"vampire: dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DB 200D 2642 FE0F","char":"🧛‍♂️","name":"man vampire","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DB 200D 2642","char":"🧛‍♂","name":"man vampire","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DB 1F3FB 200D 2642 FE0F","char":"🧛🏻‍♂️","name":"man vampire: light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DB 1F3FB 200D 2642","char":"🧛🏻‍♂","name":"man vampire: light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DB 1F3FC 200D 2642 FE0F","char":"🧛🏼‍♂️","name":"man vampire: medium-light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DB 1F3FC 200D 2642","char":"🧛🏼‍♂","name":"man vampire: medium-light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DB 1F3FD 200D 2642 FE0F","char":"🧛🏽‍♂️","name":"man vampire: medium skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DB 1F3FD 200D 2642","char":"🧛🏽‍♂","name":"man vampire: medium skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DB 1F3FE 200D 2642 FE0F","char":"🧛🏾‍♂️","name":"man vampire: medium-dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DB 1F3FE 200D 2642","char":"🧛🏾‍♂","name":"man vampire: medium-dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DB 1F3FF 200D 2642 FE0F","char":"🧛🏿‍♂️","name":"man vampire: dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DB 1F3FF 200D 2642","char":"🧛🏿‍♂","name":"man vampire: dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DB 200D 2640 FE0F","char":"🧛‍♀️","name":"woman vampire","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DB 200D 2640","char":"🧛‍♀","name":"woman vampire","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DB 1F3FB 200D 2640 FE0F","char":"🧛🏻‍♀️","name":"woman vampire: light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DB 1F3FB 200D 2640","char":"🧛🏻‍♀","name":"woman vampire: light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DB 1F3FC 200D 2640 FE0F","char":"🧛🏼‍♀️","name":"woman vampire: medium-light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DB 1F3FC 200D 2640","char":"🧛🏼‍♀","name":"woman vampire: medium-light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DB 1F3FD 200D 2640 FE0F","char":"🧛🏽‍♀️","name":"woman vampire: medium skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DB 1F3FD 200D 2640","char":"🧛🏽‍♀","name":"woman vampire: medium skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DB 1F3FE 200D 2640 FE0F","char":"🧛🏾‍♀️","name":"woman vampire: medium-dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DB 1F3FE 200D 2640","char":"🧛🏾‍♀","name":"woman vampire: medium-dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DB 1F3FF 200D 2640 FE0F","char":"🧛🏿‍♀️","name":"woman vampire: dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DB 1F3FF 200D 2640","char":"🧛🏿‍♀","name":"woman vampire: dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DC","char":"🧜","name":"merperson","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DC 1F3FB","char":"🧜🏻","name":"merperson: light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DC 1F3FC","char":"🧜🏼","name":"merperson: medium-light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DC 1F3FD","char":"🧜🏽","name":"merperson: medium skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DC 1F3FE","char":"🧜🏾","name":"merperson: medium-dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DC 1F3FF","char":"🧜🏿","name":"merperson: dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DC 200D 2642 FE0F","char":"🧜‍♂️","name":"merman","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DC 200D 2642","char":"🧜‍♂","name":"merman","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DC 1F3FB 200D 2642 FE0F","char":"🧜🏻‍♂️","name":"merman: light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DC 1F3FB 200D 2642","char":"🧜🏻‍♂","name":"merman: light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DC 1F3FC 200D 2642 FE0F","char":"🧜🏼‍♂️","name":"merman: medium-light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DC 1F3FC 200D 2642","char":"🧜🏼‍♂","name":"merman: medium-light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DC 1F3FD 200D 2642 FE0F","char":"🧜🏽‍♂️","name":"merman: medium skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DC 1F3FD 200D 2642","char":"🧜🏽‍♂","name":"merman: medium skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DC 1F3FE 200D 2642 FE0F","char":"🧜🏾‍♂️","name":"merman: medium-dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DC 1F3FE 200D 2642","char":"🧜🏾‍♂","name":"merman: medium-dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DC 1F3FF 200D 2642 FE0F","char":"🧜🏿‍♂️","name":"merman: dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DC 1F3FF 200D 2642","char":"🧜🏿‍♂","name":"merman: dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DC 200D 2640 FE0F","char":"🧜‍♀️","name":"mermaid","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DC 200D 2640","char":"🧜‍♀","name":"mermaid","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DC 1F3FB 200D 2640 FE0F","char":"🧜🏻‍♀️","name":"mermaid: light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DC 1F3FB 200D 2640","char":"🧜🏻‍♀","name":"mermaid: light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DC 1F3FC 200D 2640 FE0F","char":"🧜🏼‍♀️","name":"mermaid: medium-light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DC 1F3FC 200D 2640","char":"🧜🏼‍♀","name":"mermaid: medium-light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DC 1F3FD 200D 2640 FE0F","char":"🧜🏽‍♀️","name":"mermaid: medium skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DC 1F3FD 200D 2640","char":"🧜🏽‍♀","name":"mermaid: medium skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DC 1F3FE 200D 2640 FE0F","char":"🧜🏾‍♀️","name":"mermaid: medium-dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DC 1F3FE 200D 2640","char":"🧜🏾‍♀","name":"mermaid: medium-dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DC 1F3FF 200D 2640 FE0F","char":"🧜🏿‍♀️","name":"mermaid: dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DC 1F3FF 200D 2640","char":"🧜🏿‍♀","name":"mermaid: dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DD","char":"🧝","name":"elf","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DD 1F3FB","char":"🧝🏻","name":"elf: light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DD 1F3FC","char":"🧝🏼","name":"elf: medium-light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DD 1F3FD","char":"🧝🏽","name":"elf: medium skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DD 1F3FE","char":"🧝🏾","name":"elf: medium-dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DD 1F3FF","char":"🧝🏿","name":"elf: dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DD 200D 2642 FE0F","char":"🧝‍♂️","name":"man elf","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DD 200D 2642","char":"🧝‍♂","name":"man elf","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DD 1F3FB 200D 2642 FE0F","char":"🧝🏻‍♂️","name":"man elf: light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DD 1F3FB 200D 2642","char":"🧝🏻‍♂","name":"man elf: light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DD 1F3FC 200D 2642 FE0F","char":"🧝🏼‍♂️","name":"man elf: medium-light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DD 1F3FC 200D 2642","char":"🧝🏼‍♂","name":"man elf: medium-light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DD 1F3FD 200D 2642 FE0F","char":"🧝🏽‍♂️","name":"man elf: medium skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DD 1F3FD 200D 2642","char":"🧝🏽‍♂","name":"man elf: medium skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DD 1F3FE 200D 2642 FE0F","char":"🧝🏾‍♂️","name":"man elf: medium-dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DD 1F3FE 200D 2642","char":"🧝🏾‍♂","name":"man elf: medium-dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DD 1F3FF 200D 2642 FE0F","char":"🧝🏿‍♂️","name":"man elf: dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DD 1F3FF 200D 2642","char":"🧝🏿‍♂","name":"man elf: dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DD 200D 2640 FE0F","char":"🧝‍♀️","name":"woman elf","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DD 200D 2640","char":"🧝‍♀","name":"woman elf","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DD 1F3FB 200D 2640 FE0F","char":"🧝🏻‍♀️","name":"woman elf: light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DD 1F3FB 200D 2640","char":"🧝🏻‍♀","name":"woman elf: light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DD 1F3FC 200D 2640 FE0F","char":"🧝🏼‍♀️","name":"woman elf: medium-light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DD 1F3FC 200D 2640","char":"🧝🏼‍♀","name":"woman elf: medium-light skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DD 1F3FD 200D 2640 FE0F","char":"🧝🏽‍♀️","name":"woman elf: medium skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DD 1F3FD 200D 2640","char":"🧝🏽‍♀","name":"woman elf: medium skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DD 1F3FE 200D 2640 FE0F","char":"🧝🏾‍♀️","name":"woman elf: medium-dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DD 1F3FE 200D 2640","char":"🧝🏾‍♀","name":"woman elf: medium-dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DD 1F3FF 200D 2640 FE0F","char":"🧝🏿‍♀️","name":"woman elf: dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DD 1F3FF 200D 2640","char":"🧝🏿‍♀","name":"woman elf: dark skin tone","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DE","char":"🧞","name":"genie","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DE 200D 2642 FE0F","char":"🧞‍♂️","name":"man genie","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DE 200D 2642","char":"🧞‍♂","name":"man genie","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DE 200D 2640 FE0F","char":"🧞‍♀️","name":"woman genie","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DE 200D 2640","char":"🧞‍♀","name":"woman genie","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DF","char":"🧟","name":"zombie","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DF 200D 2642 FE0F","char":"🧟‍♂️","name":"man zombie","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DF 200D 2642","char":"🧟‍♂","name":"man zombie","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DF 200D 2640 FE0F","char":"🧟‍♀️","name":"woman zombie","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9DF 200D 2640","char":"🧟‍♀","name":"woman zombie","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F9CC","char":"🧌","name":"troll","category":"People & Body (person-fantasy)","group":"People & Body","subgroup":"person-fantasy"},{"codes":"1F486","char":"💆","name":"person getting massage","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F486 1F3FB","char":"💆🏻","name":"person getting massage: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F486 1F3FC","char":"💆🏼","name":"person getting massage: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F486 1F3FD","char":"💆🏽","name":"person getting massage: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F486 1F3FE","char":"💆🏾","name":"person getting massage: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F486 1F3FF","char":"💆🏿","name":"person getting massage: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F486 200D 2642 FE0F","char":"💆‍♂️","name":"man getting massage","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F486 200D 2642","char":"💆‍♂","name":"man getting massage","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F486 1F3FB 200D 2642 FE0F","char":"💆🏻‍♂️","name":"man getting massage: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F486 1F3FB 200D 2642","char":"💆🏻‍♂","name":"man getting massage: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F486 1F3FC 200D 2642 FE0F","char":"💆🏼‍♂️","name":"man getting massage: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F486 1F3FC 200D 2642","char":"💆🏼‍♂","name":"man getting massage: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F486 1F3FD 200D 2642 FE0F","char":"💆🏽‍♂️","name":"man getting massage: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F486 1F3FD 200D 2642","char":"💆🏽‍♂","name":"man getting massage: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F486 1F3FE 200D 2642 FE0F","char":"💆🏾‍♂️","name":"man getting massage: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F486 1F3FE 200D 2642","char":"💆🏾‍♂","name":"man getting massage: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F486 1F3FF 200D 2642 FE0F","char":"💆🏿‍♂️","name":"man getting massage: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F486 1F3FF 200D 2642","char":"💆🏿‍♂","name":"man getting massage: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F486 200D 2640 FE0F","char":"💆‍♀️","name":"woman getting massage","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F486 200D 2640","char":"💆‍♀","name":"woman getting massage","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F486 1F3FB 200D 2640 FE0F","char":"💆🏻‍♀️","name":"woman getting massage: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F486 1F3FB 200D 2640","char":"💆🏻‍♀","name":"woman getting massage: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F486 1F3FC 200D 2640 FE0F","char":"💆🏼‍♀️","name":"woman getting massage: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F486 1F3FC 200D 2640","char":"💆🏼‍♀","name":"woman getting massage: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F486 1F3FD 200D 2640 FE0F","char":"💆🏽‍♀️","name":"woman getting massage: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F486 1F3FD 200D 2640","char":"💆🏽‍♀","name":"woman getting massage: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F486 1F3FE 200D 2640 FE0F","char":"💆🏾‍♀️","name":"woman getting massage: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F486 1F3FE 200D 2640","char":"💆🏾‍♀","name":"woman getting massage: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F486 1F3FF 200D 2640 FE0F","char":"💆🏿‍♀️","name":"woman getting massage: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F486 1F3FF 200D 2640","char":"💆🏿‍♀","name":"woman getting massage: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F487","char":"💇","name":"person getting haircut","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F487 1F3FB","char":"💇🏻","name":"person getting haircut: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F487 1F3FC","char":"💇🏼","name":"person getting haircut: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F487 1F3FD","char":"💇🏽","name":"person getting haircut: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F487 1F3FE","char":"💇🏾","name":"person getting haircut: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F487 1F3FF","char":"💇🏿","name":"person getting haircut: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F487 200D 2642 FE0F","char":"💇‍♂️","name":"man getting haircut","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F487 200D 2642","char":"💇‍♂","name":"man getting haircut","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F487 1F3FB 200D 2642 FE0F","char":"💇🏻‍♂️","name":"man getting haircut: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F487 1F3FB 200D 2642","char":"💇🏻‍♂","name":"man getting haircut: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F487 1F3FC 200D 2642 FE0F","char":"💇🏼‍♂️","name":"man getting haircut: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F487 1F3FC 200D 2642","char":"💇🏼‍♂","name":"man getting haircut: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F487 1F3FD 200D 2642 FE0F","char":"💇🏽‍♂️","name":"man getting haircut: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F487 1F3FD 200D 2642","char":"💇🏽‍♂","name":"man getting haircut: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F487 1F3FE 200D 2642 FE0F","char":"💇🏾‍♂️","name":"man getting haircut: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F487 1F3FE 200D 2642","char":"💇🏾‍♂","name":"man getting haircut: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F487 1F3FF 200D 2642 FE0F","char":"💇🏿‍♂️","name":"man getting haircut: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F487 1F3FF 200D 2642","char":"💇🏿‍♂","name":"man getting haircut: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F487 200D 2640 FE0F","char":"💇‍♀️","name":"woman getting haircut","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F487 200D 2640","char":"💇‍♀","name":"woman getting haircut","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F487 1F3FB 200D 2640 FE0F","char":"💇🏻‍♀️","name":"woman getting haircut: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F487 1F3FB 200D 2640","char":"💇🏻‍♀","name":"woman getting haircut: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F487 1F3FC 200D 2640 FE0F","char":"💇🏼‍♀️","name":"woman getting haircut: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F487 1F3FC 200D 2640","char":"💇🏼‍♀","name":"woman getting haircut: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F487 1F3FD 200D 2640 FE0F","char":"💇🏽‍♀️","name":"woman getting haircut: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F487 1F3FD 200D 2640","char":"💇🏽‍♀","name":"woman getting haircut: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F487 1F3FE 200D 2640 FE0F","char":"💇🏾‍♀️","name":"woman getting haircut: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F487 1F3FE 200D 2640","char":"💇🏾‍♀","name":"woman getting haircut: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F487 1F3FF 200D 2640 FE0F","char":"💇🏿‍♀️","name":"woman getting haircut: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F487 1F3FF 200D 2640","char":"💇🏿‍♀","name":"woman getting haircut: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6","char":"🚶","name":"person walking","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FB","char":"🚶🏻","name":"person walking: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FC","char":"🚶🏼","name":"person walking: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FD","char":"🚶🏽","name":"person walking: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FE","char":"🚶🏾","name":"person walking: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FF","char":"🚶🏿","name":"person walking: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 200D 2642 FE0F","char":"🚶‍♂️","name":"man walking","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 200D 2642","char":"🚶‍♂","name":"man walking","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FB 200D 2642 FE0F","char":"🚶🏻‍♂️","name":"man walking: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FB 200D 2642","char":"🚶🏻‍♂","name":"man walking: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FC 200D 2642 FE0F","char":"🚶🏼‍♂️","name":"man walking: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FC 200D 2642","char":"🚶🏼‍♂","name":"man walking: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FD 200D 2642 FE0F","char":"🚶🏽‍♂️","name":"man walking: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FD 200D 2642","char":"🚶🏽‍♂","name":"man walking: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FE 200D 2642 FE0F","char":"🚶🏾‍♂️","name":"man walking: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FE 200D 2642","char":"🚶🏾‍♂","name":"man walking: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FF 200D 2642 FE0F","char":"🚶🏿‍♂️","name":"man walking: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FF 200D 2642","char":"🚶🏿‍♂","name":"man walking: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 200D 2640 FE0F","char":"🚶‍♀️","name":"woman walking","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 200D 2640","char":"🚶‍♀","name":"woman walking","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FB 200D 2640 FE0F","char":"🚶🏻‍♀️","name":"woman walking: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FB 200D 2640","char":"🚶🏻‍♀","name":"woman walking: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FC 200D 2640 FE0F","char":"🚶🏼‍♀️","name":"woman walking: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FC 200D 2640","char":"🚶🏼‍♀","name":"woman walking: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FD 200D 2640 FE0F","char":"🚶🏽‍♀️","name":"woman walking: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FD 200D 2640","char":"🚶🏽‍♀","name":"woman walking: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FE 200D 2640 FE0F","char":"🚶🏾‍♀️","name":"woman walking: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FE 200D 2640","char":"🚶🏾‍♀","name":"woman walking: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FF 200D 2640 FE0F","char":"🚶🏿‍♀️","name":"woman walking: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FF 200D 2640","char":"🚶🏿‍♀","name":"woman walking: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 200D 27A1 FE0F","char":"🚶‍➡️","name":"person walking facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 200D 27A1","char":"🚶‍➡","name":"person walking facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FB 200D 27A1 FE0F","char":"🚶🏻‍➡️","name":"person walking facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FB 200D 27A1","char":"🚶🏻‍➡","name":"person walking facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FC 200D 27A1 FE0F","char":"🚶🏼‍➡️","name":"person walking facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FC 200D 27A1","char":"🚶🏼‍➡","name":"person walking facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FD 200D 27A1 FE0F","char":"🚶🏽‍➡️","name":"person walking facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FD 200D 27A1","char":"🚶🏽‍➡","name":"person walking facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FE 200D 27A1 FE0F","char":"🚶🏾‍➡️","name":"person walking facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FE 200D 27A1","char":"🚶🏾‍➡","name":"person walking facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FF 200D 27A1 FE0F","char":"🚶🏿‍➡️","name":"person walking facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FF 200D 27A1","char":"🚶🏿‍➡","name":"person walking facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 200D 2640 FE0F 200D 27A1 FE0F","char":"🚶‍♀️‍➡️","name":"woman walking facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 200D 2640 200D 27A1 FE0F","char":"🚶‍♀‍➡️","name":"woman walking facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 200D 2640 FE0F 200D 27A1","char":"🚶‍♀️‍➡","name":"woman walking facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 200D 2640 200D 27A1","char":"🚶‍♀‍➡","name":"woman walking facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FB 200D 2640 FE0F 200D 27A1 FE0F","char":"🚶🏻‍♀️‍➡️","name":"woman walking facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FB 200D 2640 200D 27A1 FE0F","char":"🚶🏻‍♀‍➡️","name":"woman walking facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FB 200D 2640 FE0F 200D 27A1","char":"🚶🏻‍♀️‍➡","name":"woman walking facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FB 200D 2640 200D 27A1","char":"🚶🏻‍♀‍➡","name":"woman walking facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FC 200D 2640 FE0F 200D 27A1 FE0F","char":"🚶🏼‍♀️‍➡️","name":"woman walking facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FC 200D 2640 200D 27A1 FE0F","char":"🚶🏼‍♀‍➡️","name":"woman walking facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FC 200D 2640 FE0F 200D 27A1","char":"🚶🏼‍♀️‍➡","name":"woman walking facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FC 200D 2640 200D 27A1","char":"🚶🏼‍♀‍➡","name":"woman walking facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FD 200D 2640 FE0F 200D 27A1 FE0F","char":"🚶🏽‍♀️‍➡️","name":"woman walking facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FD 200D 2640 200D 27A1 FE0F","char":"🚶🏽‍♀‍➡️","name":"woman walking facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FD 200D 2640 FE0F 200D 27A1","char":"🚶🏽‍♀️‍➡","name":"woman walking facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FD 200D 2640 200D 27A1","char":"🚶🏽‍♀‍➡","name":"woman walking facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FE 200D 2640 FE0F 200D 27A1 FE0F","char":"🚶🏾‍♀️‍➡️","name":"woman walking facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FE 200D 2640 200D 27A1 FE0F","char":"🚶🏾‍♀‍➡️","name":"woman walking facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FE 200D 2640 FE0F 200D 27A1","char":"🚶🏾‍♀️‍➡","name":"woman walking facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FE 200D 2640 200D 27A1","char":"🚶🏾‍♀‍➡","name":"woman walking facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FF 200D 2640 FE0F 200D 27A1 FE0F","char":"🚶🏿‍♀️‍➡️","name":"woman walking facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FF 200D 2640 200D 27A1 FE0F","char":"🚶🏿‍♀‍➡️","name":"woman walking facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FF 200D 2640 FE0F 200D 27A1","char":"🚶🏿‍♀️‍➡","name":"woman walking facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FF 200D 2640 200D 27A1","char":"🚶🏿‍♀‍➡","name":"woman walking facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 200D 2642 FE0F 200D 27A1 FE0F","char":"🚶‍♂️‍➡️","name":"man walking facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 200D 2642 200D 27A1 FE0F","char":"🚶‍♂‍➡️","name":"man walking facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 200D 2642 FE0F 200D 27A1","char":"🚶‍♂️‍➡","name":"man walking facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 200D 2642 200D 27A1","char":"🚶‍♂‍➡","name":"man walking facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FB 200D 2642 FE0F 200D 27A1 FE0F","char":"🚶🏻‍♂️‍➡️","name":"man walking facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FB 200D 2642 200D 27A1 FE0F","char":"🚶🏻‍♂‍➡️","name":"man walking facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FB 200D 2642 FE0F 200D 27A1","char":"🚶🏻‍♂️‍➡","name":"man walking facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FB 200D 2642 200D 27A1","char":"🚶🏻‍♂‍➡","name":"man walking facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FC 200D 2642 FE0F 200D 27A1 FE0F","char":"🚶🏼‍♂️‍➡️","name":"man walking facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FC 200D 2642 200D 27A1 FE0F","char":"🚶🏼‍♂‍➡️","name":"man walking facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FC 200D 2642 FE0F 200D 27A1","char":"🚶🏼‍♂️‍➡","name":"man walking facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FC 200D 2642 200D 27A1","char":"🚶🏼‍♂‍➡","name":"man walking facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FD 200D 2642 FE0F 200D 27A1 FE0F","char":"🚶🏽‍♂️‍➡️","name":"man walking facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FD 200D 2642 200D 27A1 FE0F","char":"🚶🏽‍♂‍➡️","name":"man walking facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FD 200D 2642 FE0F 200D 27A1","char":"🚶🏽‍♂️‍➡","name":"man walking facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FD 200D 2642 200D 27A1","char":"🚶🏽‍♂‍➡","name":"man walking facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FE 200D 2642 FE0F 200D 27A1 FE0F","char":"🚶🏾‍♂️‍➡️","name":"man walking facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FE 200D 2642 200D 27A1 FE0F","char":"🚶🏾‍♂‍➡️","name":"man walking facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FE 200D 2642 FE0F 200D 27A1","char":"🚶🏾‍♂️‍➡","name":"man walking facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FE 200D 2642 200D 27A1","char":"🚶🏾‍♂‍➡","name":"man walking facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FF 200D 2642 FE0F 200D 27A1 FE0F","char":"🚶🏿‍♂️‍➡️","name":"man walking facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FF 200D 2642 200D 27A1 FE0F","char":"🚶🏿‍♂‍➡️","name":"man walking facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FF 200D 2642 FE0F 200D 27A1","char":"🚶🏿‍♂️‍➡","name":"man walking facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F6B6 1F3FF 200D 2642 200D 27A1","char":"🚶🏿‍♂‍➡","name":"man walking facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CD","char":"🧍","name":"person standing","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CD 1F3FB","char":"🧍🏻","name":"person standing: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CD 1F3FC","char":"🧍🏼","name":"person standing: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CD 1F3FD","char":"🧍🏽","name":"person standing: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CD 1F3FE","char":"🧍🏾","name":"person standing: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CD 1F3FF","char":"🧍🏿","name":"person standing: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CD 200D 2642 FE0F","char":"🧍‍♂️","name":"man standing","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CD 200D 2642","char":"🧍‍♂","name":"man standing","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CD 1F3FB 200D 2642 FE0F","char":"🧍🏻‍♂️","name":"man standing: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CD 1F3FB 200D 2642","char":"🧍🏻‍♂","name":"man standing: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CD 1F3FC 200D 2642 FE0F","char":"🧍🏼‍♂️","name":"man standing: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CD 1F3FC 200D 2642","char":"🧍🏼‍♂","name":"man standing: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CD 1F3FD 200D 2642 FE0F","char":"🧍🏽‍♂️","name":"man standing: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CD 1F3FD 200D 2642","char":"🧍🏽‍♂","name":"man standing: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CD 1F3FE 200D 2642 FE0F","char":"🧍🏾‍♂️","name":"man standing: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CD 1F3FE 200D 2642","char":"🧍🏾‍♂","name":"man standing: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CD 1F3FF 200D 2642 FE0F","char":"🧍🏿‍♂️","name":"man standing: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CD 1F3FF 200D 2642","char":"🧍🏿‍♂","name":"man standing: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CD 200D 2640 FE0F","char":"🧍‍♀️","name":"woman standing","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CD 200D 2640","char":"🧍‍♀","name":"woman standing","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CD 1F3FB 200D 2640 FE0F","char":"🧍🏻‍♀️","name":"woman standing: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CD 1F3FB 200D 2640","char":"🧍🏻‍♀","name":"woman standing: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CD 1F3FC 200D 2640 FE0F","char":"🧍🏼‍♀️","name":"woman standing: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CD 1F3FC 200D 2640","char":"🧍🏼‍♀","name":"woman standing: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CD 1F3FD 200D 2640 FE0F","char":"🧍🏽‍♀️","name":"woman standing: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CD 1F3FD 200D 2640","char":"🧍🏽‍♀","name":"woman standing: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CD 1F3FE 200D 2640 FE0F","char":"🧍🏾‍♀️","name":"woman standing: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CD 1F3FE 200D 2640","char":"🧍🏾‍♀","name":"woman standing: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CD 1F3FF 200D 2640 FE0F","char":"🧍🏿‍♀️","name":"woman standing: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CD 1F3FF 200D 2640","char":"🧍🏿‍♀","name":"woman standing: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE","char":"🧎","name":"person kneeling","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FB","char":"🧎🏻","name":"person kneeling: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FC","char":"🧎🏼","name":"person kneeling: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FD","char":"🧎🏽","name":"person kneeling: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FE","char":"🧎🏾","name":"person kneeling: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FF","char":"🧎🏿","name":"person kneeling: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 200D 2642 FE0F","char":"🧎‍♂️","name":"man kneeling","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 200D 2642","char":"🧎‍♂","name":"man kneeling","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FB 200D 2642 FE0F","char":"🧎🏻‍♂️","name":"man kneeling: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FB 200D 2642","char":"🧎🏻‍♂","name":"man kneeling: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FC 200D 2642 FE0F","char":"🧎🏼‍♂️","name":"man kneeling: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FC 200D 2642","char":"🧎🏼‍♂","name":"man kneeling: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FD 200D 2642 FE0F","char":"🧎🏽‍♂️","name":"man kneeling: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FD 200D 2642","char":"🧎🏽‍♂","name":"man kneeling: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FE 200D 2642 FE0F","char":"🧎🏾‍♂️","name":"man kneeling: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FE 200D 2642","char":"🧎🏾‍♂","name":"man kneeling: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FF 200D 2642 FE0F","char":"🧎🏿‍♂️","name":"man kneeling: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FF 200D 2642","char":"🧎🏿‍♂","name":"man kneeling: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 200D 2640 FE0F","char":"🧎‍♀️","name":"woman kneeling","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 200D 2640","char":"🧎‍♀","name":"woman kneeling","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FB 200D 2640 FE0F","char":"🧎🏻‍♀️","name":"woman kneeling: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FB 200D 2640","char":"🧎🏻‍♀","name":"woman kneeling: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FC 200D 2640 FE0F","char":"🧎🏼‍♀️","name":"woman kneeling: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FC 200D 2640","char":"🧎🏼‍♀","name":"woman kneeling: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FD 200D 2640 FE0F","char":"🧎🏽‍♀️","name":"woman kneeling: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FD 200D 2640","char":"🧎🏽‍♀","name":"woman kneeling: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FE 200D 2640 FE0F","char":"🧎🏾‍♀️","name":"woman kneeling: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FE 200D 2640","char":"🧎🏾‍♀","name":"woman kneeling: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FF 200D 2640 FE0F","char":"🧎🏿‍♀️","name":"woman kneeling: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FF 200D 2640","char":"🧎🏿‍♀","name":"woman kneeling: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 200D 27A1 FE0F","char":"🧎‍➡️","name":"person kneeling facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 200D 27A1","char":"🧎‍➡","name":"person kneeling facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FB 200D 27A1 FE0F","char":"🧎🏻‍➡️","name":"person kneeling facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FB 200D 27A1","char":"🧎🏻‍➡","name":"person kneeling facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FC 200D 27A1 FE0F","char":"🧎🏼‍➡️","name":"person kneeling facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FC 200D 27A1","char":"🧎🏼‍➡","name":"person kneeling facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FD 200D 27A1 FE0F","char":"🧎🏽‍➡️","name":"person kneeling facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FD 200D 27A1","char":"🧎🏽‍➡","name":"person kneeling facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FE 200D 27A1 FE0F","char":"🧎🏾‍➡️","name":"person kneeling facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FE 200D 27A1","char":"🧎🏾‍➡","name":"person kneeling facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FF 200D 27A1 FE0F","char":"🧎🏿‍➡️","name":"person kneeling facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FF 200D 27A1","char":"🧎🏿‍➡","name":"person kneeling facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 200D 2640 FE0F 200D 27A1 FE0F","char":"🧎‍♀️‍➡️","name":"woman kneeling facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 200D 2640 200D 27A1 FE0F","char":"🧎‍♀‍➡️","name":"woman kneeling facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 200D 2640 FE0F 200D 27A1","char":"🧎‍♀️‍➡","name":"woman kneeling facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 200D 2640 200D 27A1","char":"🧎‍♀‍➡","name":"woman kneeling facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FB 200D 2640 FE0F 200D 27A1 FE0F","char":"🧎🏻‍♀️‍➡️","name":"woman kneeling facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FB 200D 2640 200D 27A1 FE0F","char":"🧎🏻‍♀‍➡️","name":"woman kneeling facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FB 200D 2640 FE0F 200D 27A1","char":"🧎🏻‍♀️‍➡","name":"woman kneeling facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FB 200D 2640 200D 27A1","char":"🧎🏻‍♀‍➡","name":"woman kneeling facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FC 200D 2640 FE0F 200D 27A1 FE0F","char":"🧎🏼‍♀️‍➡️","name":"woman kneeling facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FC 200D 2640 200D 27A1 FE0F","char":"🧎🏼‍♀‍➡️","name":"woman kneeling facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FC 200D 2640 FE0F 200D 27A1","char":"🧎🏼‍♀️‍➡","name":"woman kneeling facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FC 200D 2640 200D 27A1","char":"🧎🏼‍♀‍➡","name":"woman kneeling facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FD 200D 2640 FE0F 200D 27A1 FE0F","char":"🧎🏽‍♀️‍➡️","name":"woman kneeling facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FD 200D 2640 200D 27A1 FE0F","char":"🧎🏽‍♀‍➡️","name":"woman kneeling facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FD 200D 2640 FE0F 200D 27A1","char":"🧎🏽‍♀️‍➡","name":"woman kneeling facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FD 200D 2640 200D 27A1","char":"🧎🏽‍♀‍➡","name":"woman kneeling facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FE 200D 2640 FE0F 200D 27A1 FE0F","char":"🧎🏾‍♀️‍➡️","name":"woman kneeling facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FE 200D 2640 200D 27A1 FE0F","char":"🧎🏾‍♀‍➡️","name":"woman kneeling facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FE 200D 2640 FE0F 200D 27A1","char":"🧎🏾‍♀️‍➡","name":"woman kneeling facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FE 200D 2640 200D 27A1","char":"🧎🏾‍♀‍➡","name":"woman kneeling facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FF 200D 2640 FE0F 200D 27A1 FE0F","char":"🧎🏿‍♀️‍➡️","name":"woman kneeling facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FF 200D 2640 200D 27A1 FE0F","char":"🧎🏿‍♀‍➡️","name":"woman kneeling facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FF 200D 2640 FE0F 200D 27A1","char":"🧎🏿‍♀️‍➡","name":"woman kneeling facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FF 200D 2640 200D 27A1","char":"🧎🏿‍♀‍➡","name":"woman kneeling facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 200D 2642 FE0F 200D 27A1 FE0F","char":"🧎‍♂️‍➡️","name":"man kneeling facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 200D 2642 200D 27A1 FE0F","char":"🧎‍♂‍➡️","name":"man kneeling facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 200D 2642 FE0F 200D 27A1","char":"🧎‍♂️‍➡","name":"man kneeling facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 200D 2642 200D 27A1","char":"🧎‍♂‍➡","name":"man kneeling facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FB 200D 2642 FE0F 200D 27A1 FE0F","char":"🧎🏻‍♂️‍➡️","name":"man kneeling facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FB 200D 2642 200D 27A1 FE0F","char":"🧎🏻‍♂‍➡️","name":"man kneeling facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FB 200D 2642 FE0F 200D 27A1","char":"🧎🏻‍♂️‍➡","name":"man kneeling facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FB 200D 2642 200D 27A1","char":"🧎🏻‍♂‍➡","name":"man kneeling facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FC 200D 2642 FE0F 200D 27A1 FE0F","char":"🧎🏼‍♂️‍➡️","name":"man kneeling facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FC 200D 2642 200D 27A1 FE0F","char":"🧎🏼‍♂‍➡️","name":"man kneeling facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FC 200D 2642 FE0F 200D 27A1","char":"🧎🏼‍♂️‍➡","name":"man kneeling facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FC 200D 2642 200D 27A1","char":"🧎🏼‍♂‍➡","name":"man kneeling facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FD 200D 2642 FE0F 200D 27A1 FE0F","char":"🧎🏽‍♂️‍➡️","name":"man kneeling facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FD 200D 2642 200D 27A1 FE0F","char":"🧎🏽‍♂‍➡️","name":"man kneeling facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FD 200D 2642 FE0F 200D 27A1","char":"🧎🏽‍♂️‍➡","name":"man kneeling facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FD 200D 2642 200D 27A1","char":"🧎🏽‍♂‍➡","name":"man kneeling facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FE 200D 2642 FE0F 200D 27A1 FE0F","char":"🧎🏾‍♂️‍➡️","name":"man kneeling facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FE 200D 2642 200D 27A1 FE0F","char":"🧎🏾‍♂‍➡️","name":"man kneeling facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FE 200D 2642 FE0F 200D 27A1","char":"🧎🏾‍♂️‍➡","name":"man kneeling facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FE 200D 2642 200D 27A1","char":"🧎🏾‍♂‍➡","name":"man kneeling facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FF 200D 2642 FE0F 200D 27A1 FE0F","char":"🧎🏿‍♂️‍➡️","name":"man kneeling facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FF 200D 2642 200D 27A1 FE0F","char":"🧎🏿‍♂‍➡️","name":"man kneeling facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FF 200D 2642 FE0F 200D 27A1","char":"🧎🏿‍♂️‍➡","name":"man kneeling facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9CE 1F3FF 200D 2642 200D 27A1","char":"🧎🏿‍♂‍➡","name":"man kneeling facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 200D 1F9AF","char":"🧑‍🦯","name":"person with white cane","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FB 200D 1F9AF","char":"🧑🏻‍🦯","name":"person with white cane: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FC 200D 1F9AF","char":"🧑🏼‍🦯","name":"person with white cane: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FD 200D 1F9AF","char":"🧑🏽‍🦯","name":"person with white cane: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FE 200D 1F9AF","char":"🧑🏾‍🦯","name":"person with white cane: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FF 200D 1F9AF","char":"🧑🏿‍🦯","name":"person with white cane: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 200D 1F9AF 200D 27A1 FE0F","char":"🧑‍🦯‍➡️","name":"person with white cane facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 200D 1F9AF 200D 27A1","char":"🧑‍🦯‍➡","name":"person with white cane facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FB 200D 1F9AF 200D 27A1 FE0F","char":"🧑🏻‍🦯‍➡️","name":"person with white cane facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FB 200D 1F9AF 200D 27A1","char":"🧑🏻‍🦯‍➡","name":"person with white cane facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FC 200D 1F9AF 200D 27A1 FE0F","char":"🧑🏼‍🦯‍➡️","name":"person with white cane facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FC 200D 1F9AF 200D 27A1","char":"🧑🏼‍🦯‍➡","name":"person with white cane facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FD 200D 1F9AF 200D 27A1 FE0F","char":"🧑🏽‍🦯‍➡️","name":"person with white cane facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FD 200D 1F9AF 200D 27A1","char":"🧑🏽‍🦯‍➡","name":"person with white cane facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FE 200D 1F9AF 200D 27A1 FE0F","char":"🧑🏾‍🦯‍➡️","name":"person with white cane facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FE 200D 1F9AF 200D 27A1","char":"🧑🏾‍🦯‍➡","name":"person with white cane facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FF 200D 1F9AF 200D 27A1 FE0F","char":"🧑🏿‍🦯‍➡️","name":"person with white cane facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FF 200D 1F9AF 200D 27A1","char":"🧑🏿‍🦯‍➡","name":"person with white cane facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 200D 1F9AF","char":"👨‍🦯","name":"man with white cane","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FB 200D 1F9AF","char":"👨🏻‍🦯","name":"man with white cane: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FC 200D 1F9AF","char":"👨🏼‍🦯","name":"man with white cane: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FD 200D 1F9AF","char":"👨🏽‍🦯","name":"man with white cane: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FE 200D 1F9AF","char":"👨🏾‍🦯","name":"man with white cane: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FF 200D 1F9AF","char":"👨🏿‍🦯","name":"man with white cane: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 200D 1F9AF 200D 27A1 FE0F","char":"👨‍🦯‍➡️","name":"man with white cane facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 200D 1F9AF 200D 27A1","char":"👨‍🦯‍➡","name":"man with white cane facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FB 200D 1F9AF 200D 27A1 FE0F","char":"👨🏻‍🦯‍➡️","name":"man with white cane facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FB 200D 1F9AF 200D 27A1","char":"👨🏻‍🦯‍➡","name":"man with white cane facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FC 200D 1F9AF 200D 27A1 FE0F","char":"👨🏼‍🦯‍➡️","name":"man with white cane facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FC 200D 1F9AF 200D 27A1","char":"👨🏼‍🦯‍➡","name":"man with white cane facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FD 200D 1F9AF 200D 27A1 FE0F","char":"👨🏽‍🦯‍➡️","name":"man with white cane facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FD 200D 1F9AF 200D 27A1","char":"👨🏽‍🦯‍➡","name":"man with white cane facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FE 200D 1F9AF 200D 27A1 FE0F","char":"👨🏾‍🦯‍➡️","name":"man with white cane facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FE 200D 1F9AF 200D 27A1","char":"👨🏾‍🦯‍➡","name":"man with white cane facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FF 200D 1F9AF 200D 27A1 FE0F","char":"👨🏿‍🦯‍➡️","name":"man with white cane facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FF 200D 1F9AF 200D 27A1","char":"👨🏿‍🦯‍➡","name":"man with white cane facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 200D 1F9AF","char":"👩‍🦯","name":"woman with white cane","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FB 200D 1F9AF","char":"👩🏻‍🦯","name":"woman with white cane: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FC 200D 1F9AF","char":"👩🏼‍🦯","name":"woman with white cane: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FD 200D 1F9AF","char":"👩🏽‍🦯","name":"woman with white cane: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FE 200D 1F9AF","char":"👩🏾‍🦯","name":"woman with white cane: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FF 200D 1F9AF","char":"👩🏿‍🦯","name":"woman with white cane: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 200D 1F9AF 200D 27A1 FE0F","char":"👩‍🦯‍➡️","name":"woman with white cane facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 200D 1F9AF 200D 27A1","char":"👩‍🦯‍➡","name":"woman with white cane facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FB 200D 1F9AF 200D 27A1 FE0F","char":"👩🏻‍🦯‍➡️","name":"woman with white cane facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FB 200D 1F9AF 200D 27A1","char":"👩🏻‍🦯‍➡","name":"woman with white cane facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FC 200D 1F9AF 200D 27A1 FE0F","char":"👩🏼‍🦯‍➡️","name":"woman with white cane facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FC 200D 1F9AF 200D 27A1","char":"👩🏼‍🦯‍➡","name":"woman with white cane facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FD 200D 1F9AF 200D 27A1 FE0F","char":"👩🏽‍🦯‍➡️","name":"woman with white cane facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FD 200D 1F9AF 200D 27A1","char":"👩🏽‍🦯‍➡","name":"woman with white cane facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FE 200D 1F9AF 200D 27A1 FE0F","char":"👩🏾‍🦯‍➡️","name":"woman with white cane facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FE 200D 1F9AF 200D 27A1","char":"👩🏾‍🦯‍➡","name":"woman with white cane facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FF 200D 1F9AF 200D 27A1 FE0F","char":"👩🏿‍🦯‍➡️","name":"woman with white cane facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FF 200D 1F9AF 200D 27A1","char":"👩🏿‍🦯‍➡","name":"woman with white cane facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 200D 1F9BC","char":"🧑‍🦼","name":"person in motorized wheelchair","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FB 200D 1F9BC","char":"🧑🏻‍🦼","name":"person in motorized wheelchair: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FC 200D 1F9BC","char":"🧑🏼‍🦼","name":"person in motorized wheelchair: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FD 200D 1F9BC","char":"🧑🏽‍🦼","name":"person in motorized wheelchair: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FE 200D 1F9BC","char":"🧑🏾‍🦼","name":"person in motorized wheelchair: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FF 200D 1F9BC","char":"🧑🏿‍🦼","name":"person in motorized wheelchair: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 200D 1F9BC 200D 27A1 FE0F","char":"🧑‍🦼‍➡️","name":"person in motorized wheelchair facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 200D 1F9BC 200D 27A1","char":"🧑‍🦼‍➡","name":"person in motorized wheelchair facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FB 200D 1F9BC 200D 27A1 FE0F","char":"🧑🏻‍🦼‍➡️","name":"person in motorized wheelchair facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FB 200D 1F9BC 200D 27A1","char":"🧑🏻‍🦼‍➡","name":"person in motorized wheelchair facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FC 200D 1F9BC 200D 27A1 FE0F","char":"🧑🏼‍🦼‍➡️","name":"person in motorized wheelchair facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FC 200D 1F9BC 200D 27A1","char":"🧑🏼‍🦼‍➡","name":"person in motorized wheelchair facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FD 200D 1F9BC 200D 27A1 FE0F","char":"🧑🏽‍🦼‍➡️","name":"person in motorized wheelchair facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FD 200D 1F9BC 200D 27A1","char":"🧑🏽‍🦼‍➡","name":"person in motorized wheelchair facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FE 200D 1F9BC 200D 27A1 FE0F","char":"🧑🏾‍🦼‍➡️","name":"person in motorized wheelchair facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FE 200D 1F9BC 200D 27A1","char":"🧑🏾‍🦼‍➡","name":"person in motorized wheelchair facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FF 200D 1F9BC 200D 27A1 FE0F","char":"🧑🏿‍🦼‍➡️","name":"person in motorized wheelchair facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FF 200D 1F9BC 200D 27A1","char":"🧑🏿‍🦼‍➡","name":"person in motorized wheelchair facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 200D 1F9BC","char":"👨‍🦼","name":"man in motorized wheelchair","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FB 200D 1F9BC","char":"👨🏻‍🦼","name":"man in motorized wheelchair: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FC 200D 1F9BC","char":"👨🏼‍🦼","name":"man in motorized wheelchair: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FD 200D 1F9BC","char":"👨🏽‍🦼","name":"man in motorized wheelchair: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FE 200D 1F9BC","char":"👨🏾‍🦼","name":"man in motorized wheelchair: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FF 200D 1F9BC","char":"👨🏿‍🦼","name":"man in motorized wheelchair: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 200D 1F9BC 200D 27A1 FE0F","char":"👨‍🦼‍➡️","name":"man in motorized wheelchair facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 200D 1F9BC 200D 27A1","char":"👨‍🦼‍➡","name":"man in motorized wheelchair facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FB 200D 1F9BC 200D 27A1 FE0F","char":"👨🏻‍🦼‍➡️","name":"man in motorized wheelchair facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FB 200D 1F9BC 200D 27A1","char":"👨🏻‍🦼‍➡","name":"man in motorized wheelchair facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FC 200D 1F9BC 200D 27A1 FE0F","char":"👨🏼‍🦼‍➡️","name":"man in motorized wheelchair facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FC 200D 1F9BC 200D 27A1","char":"👨🏼‍🦼‍➡","name":"man in motorized wheelchair facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FD 200D 1F9BC 200D 27A1 FE0F","char":"👨🏽‍🦼‍➡️","name":"man in motorized wheelchair facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FD 200D 1F9BC 200D 27A1","char":"👨🏽‍🦼‍➡","name":"man in motorized wheelchair facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FE 200D 1F9BC 200D 27A1 FE0F","char":"👨🏾‍🦼‍➡️","name":"man in motorized wheelchair facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FE 200D 1F9BC 200D 27A1","char":"👨🏾‍🦼‍➡","name":"man in motorized wheelchair facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FF 200D 1F9BC 200D 27A1 FE0F","char":"👨🏿‍🦼‍➡️","name":"man in motorized wheelchair facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FF 200D 1F9BC 200D 27A1","char":"👨🏿‍🦼‍➡","name":"man in motorized wheelchair facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 200D 1F9BC","char":"👩‍🦼","name":"woman in motorized wheelchair","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FB 200D 1F9BC","char":"👩🏻‍🦼","name":"woman in motorized wheelchair: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FC 200D 1F9BC","char":"👩🏼‍🦼","name":"woman in motorized wheelchair: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FD 200D 1F9BC","char":"👩🏽‍🦼","name":"woman in motorized wheelchair: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FE 200D 1F9BC","char":"👩🏾‍🦼","name":"woman in motorized wheelchair: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FF 200D 1F9BC","char":"👩🏿‍🦼","name":"woman in motorized wheelchair: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 200D 1F9BC 200D 27A1 FE0F","char":"👩‍🦼‍➡️","name":"woman in motorized wheelchair facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 200D 1F9BC 200D 27A1","char":"👩‍🦼‍➡","name":"woman in motorized wheelchair facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FB 200D 1F9BC 200D 27A1 FE0F","char":"👩🏻‍🦼‍➡️","name":"woman in motorized wheelchair facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FB 200D 1F9BC 200D 27A1","char":"👩🏻‍🦼‍➡","name":"woman in motorized wheelchair facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FC 200D 1F9BC 200D 27A1 FE0F","char":"👩🏼‍🦼‍➡️","name":"woman in motorized wheelchair facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FC 200D 1F9BC 200D 27A1","char":"👩🏼‍🦼‍➡","name":"woman in motorized wheelchair facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FD 200D 1F9BC 200D 27A1 FE0F","char":"👩🏽‍🦼‍➡️","name":"woman in motorized wheelchair facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FD 200D 1F9BC 200D 27A1","char":"👩🏽‍🦼‍➡","name":"woman in motorized wheelchair facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FE 200D 1F9BC 200D 27A1 FE0F","char":"👩🏾‍🦼‍➡️","name":"woman in motorized wheelchair facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FE 200D 1F9BC 200D 27A1","char":"👩🏾‍🦼‍➡","name":"woman in motorized wheelchair facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FF 200D 1F9BC 200D 27A1 FE0F","char":"👩🏿‍🦼‍➡️","name":"woman in motorized wheelchair facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FF 200D 1F9BC 200D 27A1","char":"👩🏿‍🦼‍➡","name":"woman in motorized wheelchair facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 200D 1F9BD","char":"🧑‍🦽","name":"person in manual wheelchair","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FB 200D 1F9BD","char":"🧑🏻‍🦽","name":"person in manual wheelchair: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FC 200D 1F9BD","char":"🧑🏼‍🦽","name":"person in manual wheelchair: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FD 200D 1F9BD","char":"🧑🏽‍🦽","name":"person in manual wheelchair: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FE 200D 1F9BD","char":"🧑🏾‍🦽","name":"person in manual wheelchair: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FF 200D 1F9BD","char":"🧑🏿‍🦽","name":"person in manual wheelchair: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 200D 1F9BD 200D 27A1 FE0F","char":"🧑‍🦽‍➡️","name":"person in manual wheelchair facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 200D 1F9BD 200D 27A1","char":"🧑‍🦽‍➡","name":"person in manual wheelchair facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FB 200D 1F9BD 200D 27A1 FE0F","char":"🧑🏻‍🦽‍➡️","name":"person in manual wheelchair facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FB 200D 1F9BD 200D 27A1","char":"🧑🏻‍🦽‍➡","name":"person in manual wheelchair facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FC 200D 1F9BD 200D 27A1 FE0F","char":"🧑🏼‍🦽‍➡️","name":"person in manual wheelchair facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FC 200D 1F9BD 200D 27A1","char":"🧑🏼‍🦽‍➡","name":"person in manual wheelchair facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FD 200D 1F9BD 200D 27A1 FE0F","char":"🧑🏽‍🦽‍➡️","name":"person in manual wheelchair facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FD 200D 1F9BD 200D 27A1","char":"🧑🏽‍🦽‍➡","name":"person in manual wheelchair facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FE 200D 1F9BD 200D 27A1 FE0F","char":"🧑🏾‍🦽‍➡️","name":"person in manual wheelchair facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FE 200D 1F9BD 200D 27A1","char":"🧑🏾‍🦽‍➡","name":"person in manual wheelchair facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FF 200D 1F9BD 200D 27A1 FE0F","char":"🧑🏿‍🦽‍➡️","name":"person in manual wheelchair facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D1 1F3FF 200D 1F9BD 200D 27A1","char":"🧑🏿‍🦽‍➡","name":"person in manual wheelchair facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 200D 1F9BD","char":"👨‍🦽","name":"man in manual wheelchair","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FB 200D 1F9BD","char":"👨🏻‍🦽","name":"man in manual wheelchair: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FC 200D 1F9BD","char":"👨🏼‍🦽","name":"man in manual wheelchair: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FD 200D 1F9BD","char":"👨🏽‍🦽","name":"man in manual wheelchair: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FE 200D 1F9BD","char":"👨🏾‍🦽","name":"man in manual wheelchair: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FF 200D 1F9BD","char":"👨🏿‍🦽","name":"man in manual wheelchair: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 200D 1F9BD 200D 27A1 FE0F","char":"👨‍🦽‍➡️","name":"man in manual wheelchair facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 200D 1F9BD 200D 27A1","char":"👨‍🦽‍➡","name":"man in manual wheelchair facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FB 200D 1F9BD 200D 27A1 FE0F","char":"👨🏻‍🦽‍➡️","name":"man in manual wheelchair facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FB 200D 1F9BD 200D 27A1","char":"👨🏻‍🦽‍➡","name":"man in manual wheelchair facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FC 200D 1F9BD 200D 27A1 FE0F","char":"👨🏼‍🦽‍➡️","name":"man in manual wheelchair facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FC 200D 1F9BD 200D 27A1","char":"👨🏼‍🦽‍➡","name":"man in manual wheelchair facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FD 200D 1F9BD 200D 27A1 FE0F","char":"👨🏽‍🦽‍➡️","name":"man in manual wheelchair facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FD 200D 1F9BD 200D 27A1","char":"👨🏽‍🦽‍➡","name":"man in manual wheelchair facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FE 200D 1F9BD 200D 27A1 FE0F","char":"👨🏾‍🦽‍➡️","name":"man in manual wheelchair facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FE 200D 1F9BD 200D 27A1","char":"👨🏾‍🦽‍➡","name":"man in manual wheelchair facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FF 200D 1F9BD 200D 27A1 FE0F","char":"👨🏿‍🦽‍➡️","name":"man in manual wheelchair facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F468 1F3FF 200D 1F9BD 200D 27A1","char":"👨🏿‍🦽‍➡","name":"man in manual wheelchair facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 200D 1F9BD","char":"👩‍🦽","name":"woman in manual wheelchair","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FB 200D 1F9BD","char":"👩🏻‍🦽","name":"woman in manual wheelchair: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FC 200D 1F9BD","char":"👩🏼‍🦽","name":"woman in manual wheelchair: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FD 200D 1F9BD","char":"👩🏽‍🦽","name":"woman in manual wheelchair: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FE 200D 1F9BD","char":"👩🏾‍🦽","name":"woman in manual wheelchair: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FF 200D 1F9BD","char":"👩🏿‍🦽","name":"woman in manual wheelchair: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 200D 1F9BD 200D 27A1 FE0F","char":"👩‍🦽‍➡️","name":"woman in manual wheelchair facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 200D 1F9BD 200D 27A1","char":"👩‍🦽‍➡","name":"woman in manual wheelchair facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FB 200D 1F9BD 200D 27A1 FE0F","char":"👩🏻‍🦽‍➡️","name":"woman in manual wheelchair facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FB 200D 1F9BD 200D 27A1","char":"👩🏻‍🦽‍➡","name":"woman in manual wheelchair facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FC 200D 1F9BD 200D 27A1 FE0F","char":"👩🏼‍🦽‍➡️","name":"woman in manual wheelchair facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FC 200D 1F9BD 200D 27A1","char":"👩🏼‍🦽‍➡","name":"woman in manual wheelchair facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FD 200D 1F9BD 200D 27A1 FE0F","char":"👩🏽‍🦽‍➡️","name":"woman in manual wheelchair facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FD 200D 1F9BD 200D 27A1","char":"👩🏽‍🦽‍➡","name":"woman in manual wheelchair facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FE 200D 1F9BD 200D 27A1 FE0F","char":"👩🏾‍🦽‍➡️","name":"woman in manual wheelchair facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FE 200D 1F9BD 200D 27A1","char":"👩🏾‍🦽‍➡","name":"woman in manual wheelchair facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FF 200D 1F9BD 200D 27A1 FE0F","char":"👩🏿‍🦽‍➡️","name":"woman in manual wheelchair facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F469 1F3FF 200D 1F9BD 200D 27A1","char":"👩🏿‍🦽‍➡","name":"woman in manual wheelchair facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3","char":"🏃","name":"person running","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FB","char":"🏃🏻","name":"person running: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FC","char":"🏃🏼","name":"person running: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FD","char":"🏃🏽","name":"person running: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FE","char":"🏃🏾","name":"person running: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FF","char":"🏃🏿","name":"person running: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 200D 2642 FE0F","char":"🏃‍♂️","name":"man running","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 200D 2642","char":"🏃‍♂","name":"man running","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FB 200D 2642 FE0F","char":"🏃🏻‍♂️","name":"man running: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FB 200D 2642","char":"🏃🏻‍♂","name":"man running: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FC 200D 2642 FE0F","char":"🏃🏼‍♂️","name":"man running: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FC 200D 2642","char":"🏃🏼‍♂","name":"man running: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FD 200D 2642 FE0F","char":"🏃🏽‍♂️","name":"man running: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FD 200D 2642","char":"🏃🏽‍♂","name":"man running: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FE 200D 2642 FE0F","char":"🏃🏾‍♂️","name":"man running: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FE 200D 2642","char":"🏃🏾‍♂","name":"man running: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FF 200D 2642 FE0F","char":"🏃🏿‍♂️","name":"man running: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FF 200D 2642","char":"🏃🏿‍♂","name":"man running: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 200D 2640 FE0F","char":"🏃‍♀️","name":"woman running","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 200D 2640","char":"🏃‍♀","name":"woman running","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FB 200D 2640 FE0F","char":"🏃🏻‍♀️","name":"woman running: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FB 200D 2640","char":"🏃🏻‍♀","name":"woman running: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FC 200D 2640 FE0F","char":"🏃🏼‍♀️","name":"woman running: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FC 200D 2640","char":"🏃🏼‍♀","name":"woman running: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FD 200D 2640 FE0F","char":"🏃🏽‍♀️","name":"woman running: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FD 200D 2640","char":"🏃🏽‍♀","name":"woman running: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FE 200D 2640 FE0F","char":"🏃🏾‍♀️","name":"woman running: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FE 200D 2640","char":"🏃🏾‍♀","name":"woman running: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FF 200D 2640 FE0F","char":"🏃🏿‍♀️","name":"woman running: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FF 200D 2640","char":"🏃🏿‍♀","name":"woman running: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 200D 27A1 FE0F","char":"🏃‍➡️","name":"person running facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 200D 27A1","char":"🏃‍➡","name":"person running facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FB 200D 27A1 FE0F","char":"🏃🏻‍➡️","name":"person running facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FB 200D 27A1","char":"🏃🏻‍➡","name":"person running facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FC 200D 27A1 FE0F","char":"🏃🏼‍➡️","name":"person running facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FC 200D 27A1","char":"🏃🏼‍➡","name":"person running facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FD 200D 27A1 FE0F","char":"🏃🏽‍➡️","name":"person running facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FD 200D 27A1","char":"🏃🏽‍➡","name":"person running facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FE 200D 27A1 FE0F","char":"🏃🏾‍➡️","name":"person running facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FE 200D 27A1","char":"🏃🏾‍➡","name":"person running facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FF 200D 27A1 FE0F","char":"🏃🏿‍➡️","name":"person running facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FF 200D 27A1","char":"🏃🏿‍➡","name":"person running facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 200D 2640 FE0F 200D 27A1 FE0F","char":"🏃‍♀️‍➡️","name":"woman running facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 200D 2640 200D 27A1 FE0F","char":"🏃‍♀‍➡️","name":"woman running facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 200D 2640 FE0F 200D 27A1","char":"🏃‍♀️‍➡","name":"woman running facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 200D 2640 200D 27A1","char":"🏃‍♀‍➡","name":"woman running facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FB 200D 2640 FE0F 200D 27A1 FE0F","char":"🏃🏻‍♀️‍➡️","name":"woman running facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FB 200D 2640 200D 27A1 FE0F","char":"🏃🏻‍♀‍➡️","name":"woman running facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FB 200D 2640 FE0F 200D 27A1","char":"🏃🏻‍♀️‍➡","name":"woman running facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FB 200D 2640 200D 27A1","char":"🏃🏻‍♀‍➡","name":"woman running facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FC 200D 2640 FE0F 200D 27A1 FE0F","char":"🏃🏼‍♀️‍➡️","name":"woman running facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FC 200D 2640 200D 27A1 FE0F","char":"🏃🏼‍♀‍➡️","name":"woman running facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FC 200D 2640 FE0F 200D 27A1","char":"🏃🏼‍♀️‍➡","name":"woman running facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FC 200D 2640 200D 27A1","char":"🏃🏼‍♀‍➡","name":"woman running facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FD 200D 2640 FE0F 200D 27A1 FE0F","char":"🏃🏽‍♀️‍➡️","name":"woman running facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FD 200D 2640 200D 27A1 FE0F","char":"🏃🏽‍♀‍➡️","name":"woman running facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FD 200D 2640 FE0F 200D 27A1","char":"🏃🏽‍♀️‍➡","name":"woman running facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FD 200D 2640 200D 27A1","char":"🏃🏽‍♀‍➡","name":"woman running facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FE 200D 2640 FE0F 200D 27A1 FE0F","char":"🏃🏾‍♀️‍➡️","name":"woman running facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FE 200D 2640 200D 27A1 FE0F","char":"🏃🏾‍♀‍➡️","name":"woman running facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FE 200D 2640 FE0F 200D 27A1","char":"🏃🏾‍♀️‍➡","name":"woman running facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FE 200D 2640 200D 27A1","char":"🏃🏾‍♀‍➡","name":"woman running facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FF 200D 2640 FE0F 200D 27A1 FE0F","char":"🏃🏿‍♀️‍➡️","name":"woman running facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FF 200D 2640 200D 27A1 FE0F","char":"🏃🏿‍♀‍➡️","name":"woman running facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FF 200D 2640 FE0F 200D 27A1","char":"🏃🏿‍♀️‍➡","name":"woman running facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FF 200D 2640 200D 27A1","char":"🏃🏿‍♀‍➡","name":"woman running facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 200D 2642 FE0F 200D 27A1 FE0F","char":"🏃‍♂️‍➡️","name":"man running facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 200D 2642 200D 27A1 FE0F","char":"🏃‍♂‍➡️","name":"man running facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 200D 2642 FE0F 200D 27A1","char":"🏃‍♂️‍➡","name":"man running facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 200D 2642 200D 27A1","char":"🏃‍♂‍➡","name":"man running facing right","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FB 200D 2642 FE0F 200D 27A1 FE0F","char":"🏃🏻‍♂️‍➡️","name":"man running facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FB 200D 2642 200D 27A1 FE0F","char":"🏃🏻‍♂‍➡️","name":"man running facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FB 200D 2642 FE0F 200D 27A1","char":"🏃🏻‍♂️‍➡","name":"man running facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FB 200D 2642 200D 27A1","char":"🏃🏻‍♂‍➡","name":"man running facing right: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FC 200D 2642 FE0F 200D 27A1 FE0F","char":"🏃🏼‍♂️‍➡️","name":"man running facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FC 200D 2642 200D 27A1 FE0F","char":"🏃🏼‍♂‍➡️","name":"man running facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FC 200D 2642 FE0F 200D 27A1","char":"🏃🏼‍♂️‍➡","name":"man running facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FC 200D 2642 200D 27A1","char":"🏃🏼‍♂‍➡","name":"man running facing right: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FD 200D 2642 FE0F 200D 27A1 FE0F","char":"🏃🏽‍♂️‍➡️","name":"man running facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FD 200D 2642 200D 27A1 FE0F","char":"🏃🏽‍♂‍➡️","name":"man running facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FD 200D 2642 FE0F 200D 27A1","char":"🏃🏽‍♂️‍➡","name":"man running facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FD 200D 2642 200D 27A1","char":"🏃🏽‍♂‍➡","name":"man running facing right: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FE 200D 2642 FE0F 200D 27A1 FE0F","char":"🏃🏾‍♂️‍➡️","name":"man running facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FE 200D 2642 200D 27A1 FE0F","char":"🏃🏾‍♂‍➡️","name":"man running facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FE 200D 2642 FE0F 200D 27A1","char":"🏃🏾‍♂️‍➡","name":"man running facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FE 200D 2642 200D 27A1","char":"🏃🏾‍♂‍➡","name":"man running facing right: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FF 200D 2642 FE0F 200D 27A1 FE0F","char":"🏃🏿‍♂️‍➡️","name":"man running facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FF 200D 2642 200D 27A1 FE0F","char":"🏃🏿‍♂‍➡️","name":"man running facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FF 200D 2642 FE0F 200D 27A1","char":"🏃🏿‍♂️‍➡","name":"man running facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F3C3 1F3FF 200D 2642 200D 27A1","char":"🏃🏿‍♂‍➡","name":"man running facing right: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F483","char":"💃","name":"woman dancing","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F483 1F3FB","char":"💃🏻","name":"woman dancing: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F483 1F3FC","char":"💃🏼","name":"woman dancing: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F483 1F3FD","char":"💃🏽","name":"woman dancing: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F483 1F3FE","char":"💃🏾","name":"woman dancing: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F483 1F3FF","char":"💃🏿","name":"woman dancing: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F57A","char":"🕺","name":"man dancing","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F57A 1F3FB","char":"🕺🏻","name":"man dancing: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F57A 1F3FC","char":"🕺🏼","name":"man dancing: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F57A 1F3FD","char":"🕺🏽","name":"man dancing: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F57A 1F3FE","char":"🕺🏾","name":"man dancing: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F57A 1F3FF","char":"🕺🏿","name":"man dancing: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F574 FE0F","char":"🕴️","name":"person in suit levitating","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F574","char":"🕴","name":"person in suit levitating","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F574 1F3FB","char":"🕴🏻","name":"person in suit levitating: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F574 1F3FC","char":"🕴🏼","name":"person in suit levitating: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F574 1F3FD","char":"🕴🏽","name":"person in suit levitating: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F574 1F3FE","char":"🕴🏾","name":"person in suit levitating: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F574 1F3FF","char":"🕴🏿","name":"person in suit levitating: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F46F","char":"👯","name":"people with bunny ears","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F46F 200D 2642 FE0F","char":"👯‍♂️","name":"men with bunny ears","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F46F 200D 2642","char":"👯‍♂","name":"men with bunny ears","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F46F 200D 2640 FE0F","char":"👯‍♀️","name":"women with bunny ears","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F46F 200D 2640","char":"👯‍♀","name":"women with bunny ears","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D6","char":"🧖","name":"person in steamy room","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D6 1F3FB","char":"🧖🏻","name":"person in steamy room: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D6 1F3FC","char":"🧖🏼","name":"person in steamy room: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D6 1F3FD","char":"🧖🏽","name":"person in steamy room: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D6 1F3FE","char":"🧖🏾","name":"person in steamy room: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D6 1F3FF","char":"🧖🏿","name":"person in steamy room: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D6 200D 2642 FE0F","char":"🧖‍♂️","name":"man in steamy room","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D6 200D 2642","char":"🧖‍♂","name":"man in steamy room","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D6 1F3FB 200D 2642 FE0F","char":"🧖🏻‍♂️","name":"man in steamy room: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D6 1F3FB 200D 2642","char":"🧖🏻‍♂","name":"man in steamy room: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D6 1F3FC 200D 2642 FE0F","char":"🧖🏼‍♂️","name":"man in steamy room: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D6 1F3FC 200D 2642","char":"🧖🏼‍♂","name":"man in steamy room: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D6 1F3FD 200D 2642 FE0F","char":"🧖🏽‍♂️","name":"man in steamy room: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D6 1F3FD 200D 2642","char":"🧖🏽‍♂","name":"man in steamy room: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D6 1F3FE 200D 2642 FE0F","char":"🧖🏾‍♂️","name":"man in steamy room: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D6 1F3FE 200D 2642","char":"🧖🏾‍♂","name":"man in steamy room: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D6 1F3FF 200D 2642 FE0F","char":"🧖🏿‍♂️","name":"man in steamy room: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D6 1F3FF 200D 2642","char":"🧖🏿‍♂","name":"man in steamy room: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D6 200D 2640 FE0F","char":"🧖‍♀️","name":"woman in steamy room","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D6 200D 2640","char":"🧖‍♀","name":"woman in steamy room","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D6 1F3FB 200D 2640 FE0F","char":"🧖🏻‍♀️","name":"woman in steamy room: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D6 1F3FB 200D 2640","char":"🧖🏻‍♀","name":"woman in steamy room: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D6 1F3FC 200D 2640 FE0F","char":"🧖🏼‍♀️","name":"woman in steamy room: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D6 1F3FC 200D 2640","char":"🧖🏼‍♀","name":"woman in steamy room: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D6 1F3FD 200D 2640 FE0F","char":"🧖🏽‍♀️","name":"woman in steamy room: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D6 1F3FD 200D 2640","char":"🧖🏽‍♀","name":"woman in steamy room: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D6 1F3FE 200D 2640 FE0F","char":"🧖🏾‍♀️","name":"woman in steamy room: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D6 1F3FE 200D 2640","char":"🧖🏾‍♀","name":"woman in steamy room: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D6 1F3FF 200D 2640 FE0F","char":"🧖🏿‍♀️","name":"woman in steamy room: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D6 1F3FF 200D 2640","char":"🧖🏿‍♀","name":"woman in steamy room: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D7","char":"🧗","name":"person climbing","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D7 1F3FB","char":"🧗🏻","name":"person climbing: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D7 1F3FC","char":"🧗🏼","name":"person climbing: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D7 1F3FD","char":"🧗🏽","name":"person climbing: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D7 1F3FE","char":"🧗🏾","name":"person climbing: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D7 1F3FF","char":"🧗🏿","name":"person climbing: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D7 200D 2642 FE0F","char":"🧗‍♂️","name":"man climbing","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D7 200D 2642","char":"🧗‍♂","name":"man climbing","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D7 1F3FB 200D 2642 FE0F","char":"🧗🏻‍♂️","name":"man climbing: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D7 1F3FB 200D 2642","char":"🧗🏻‍♂","name":"man climbing: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D7 1F3FC 200D 2642 FE0F","char":"🧗🏼‍♂️","name":"man climbing: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D7 1F3FC 200D 2642","char":"🧗🏼‍♂","name":"man climbing: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D7 1F3FD 200D 2642 FE0F","char":"🧗🏽‍♂️","name":"man climbing: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D7 1F3FD 200D 2642","char":"🧗🏽‍♂","name":"man climbing: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D7 1F3FE 200D 2642 FE0F","char":"🧗🏾‍♂️","name":"man climbing: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D7 1F3FE 200D 2642","char":"🧗🏾‍♂","name":"man climbing: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D7 1F3FF 200D 2642 FE0F","char":"🧗🏿‍♂️","name":"man climbing: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D7 1F3FF 200D 2642","char":"🧗🏿‍♂","name":"man climbing: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D7 200D 2640 FE0F","char":"🧗‍♀️","name":"woman climbing","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D7 200D 2640","char":"🧗‍♀","name":"woman climbing","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D7 1F3FB 200D 2640 FE0F","char":"🧗🏻‍♀️","name":"woman climbing: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D7 1F3FB 200D 2640","char":"🧗🏻‍♀","name":"woman climbing: light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D7 1F3FC 200D 2640 FE0F","char":"🧗🏼‍♀️","name":"woman climbing: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D7 1F3FC 200D 2640","char":"🧗🏼‍♀","name":"woman climbing: medium-light skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D7 1F3FD 200D 2640 FE0F","char":"🧗🏽‍♀️","name":"woman climbing: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D7 1F3FD 200D 2640","char":"🧗🏽‍♀","name":"woman climbing: medium skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D7 1F3FE 200D 2640 FE0F","char":"🧗🏾‍♀️","name":"woman climbing: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D7 1F3FE 200D 2640","char":"🧗🏾‍♀","name":"woman climbing: medium-dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D7 1F3FF 200D 2640 FE0F","char":"🧗🏿‍♀️","name":"woman climbing: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F9D7 1F3FF 200D 2640","char":"🧗🏿‍♀","name":"woman climbing: dark skin tone","category":"People & Body (person-activity)","group":"People & Body","subgroup":"person-activity"},{"codes":"1F93A","char":"🤺","name":"person fencing","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C7","char":"🏇","name":"horse racing","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C7 1F3FB","char":"🏇🏻","name":"horse racing: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C7 1F3FC","char":"🏇🏼","name":"horse racing: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C7 1F3FD","char":"🏇🏽","name":"horse racing: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C7 1F3FE","char":"🏇🏾","name":"horse racing: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C7 1F3FF","char":"🏇🏿","name":"horse racing: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"26F7 FE0F","char":"⛷️","name":"skier","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"26F7","char":"⛷","name":"skier","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C2","char":"🏂","name":"snowboarder","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C2 1F3FB","char":"🏂🏻","name":"snowboarder: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C2 1F3FC","char":"🏂🏼","name":"snowboarder: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C2 1F3FD","char":"🏂🏽","name":"snowboarder: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C2 1F3FE","char":"🏂🏾","name":"snowboarder: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C2 1F3FF","char":"🏂🏿","name":"snowboarder: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CC FE0F","char":"🏌️","name":"person golfing","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CC","char":"🏌","name":"person golfing","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CC 1F3FB","char":"🏌🏻","name":"person golfing: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CC 1F3FC","char":"🏌🏼","name":"person golfing: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CC 1F3FD","char":"🏌🏽","name":"person golfing: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CC 1F3FE","char":"🏌🏾","name":"person golfing: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CC 1F3FF","char":"🏌🏿","name":"person golfing: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CC FE0F 200D 2642 FE0F","char":"🏌️‍♂️","name":"man golfing","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CC 200D 2642 FE0F","char":"🏌‍♂️","name":"man golfing","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CC FE0F 200D 2642","char":"🏌️‍♂","name":"man golfing","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CC 200D 2642","char":"🏌‍♂","name":"man golfing","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CC 1F3FB 200D 2642 FE0F","char":"🏌🏻‍♂️","name":"man golfing: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CC 1F3FB 200D 2642","char":"🏌🏻‍♂","name":"man golfing: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CC 1F3FC 200D 2642 FE0F","char":"🏌🏼‍♂️","name":"man golfing: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CC 1F3FC 200D 2642","char":"🏌🏼‍♂","name":"man golfing: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CC 1F3FD 200D 2642 FE0F","char":"🏌🏽‍♂️","name":"man golfing: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CC 1F3FD 200D 2642","char":"🏌🏽‍♂","name":"man golfing: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CC 1F3FE 200D 2642 FE0F","char":"🏌🏾‍♂️","name":"man golfing: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CC 1F3FE 200D 2642","char":"🏌🏾‍♂","name":"man golfing: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CC 1F3FF 200D 2642 FE0F","char":"🏌🏿‍♂️","name":"man golfing: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CC 1F3FF 200D 2642","char":"🏌🏿‍♂","name":"man golfing: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CC FE0F 200D 2640 FE0F","char":"🏌️‍♀️","name":"woman golfing","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CC 200D 2640 FE0F","char":"🏌‍♀️","name":"woman golfing","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CC FE0F 200D 2640","char":"🏌️‍♀","name":"woman golfing","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CC 200D 2640","char":"🏌‍♀","name":"woman golfing","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CC 1F3FB 200D 2640 FE0F","char":"🏌🏻‍♀️","name":"woman golfing: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CC 1F3FB 200D 2640","char":"🏌🏻‍♀","name":"woman golfing: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CC 1F3FC 200D 2640 FE0F","char":"🏌🏼‍♀️","name":"woman golfing: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CC 1F3FC 200D 2640","char":"🏌🏼‍♀","name":"woman golfing: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CC 1F3FD 200D 2640 FE0F","char":"🏌🏽‍♀️","name":"woman golfing: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CC 1F3FD 200D 2640","char":"🏌🏽‍♀","name":"woman golfing: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CC 1F3FE 200D 2640 FE0F","char":"🏌🏾‍♀️","name":"woman golfing: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CC 1F3FE 200D 2640","char":"🏌🏾‍♀","name":"woman golfing: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CC 1F3FF 200D 2640 FE0F","char":"🏌🏿‍♀️","name":"woman golfing: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CC 1F3FF 200D 2640","char":"🏌🏿‍♀","name":"woman golfing: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C4","char":"🏄","name":"person surfing","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C4 1F3FB","char":"🏄🏻","name":"person surfing: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C4 1F3FC","char":"🏄🏼","name":"person surfing: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C4 1F3FD","char":"🏄🏽","name":"person surfing: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C4 1F3FE","char":"🏄🏾","name":"person surfing: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C4 1F3FF","char":"🏄🏿","name":"person surfing: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C4 200D 2642 FE0F","char":"🏄‍♂️","name":"man surfing","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C4 200D 2642","char":"🏄‍♂","name":"man surfing","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C4 1F3FB 200D 2642 FE0F","char":"🏄🏻‍♂️","name":"man surfing: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C4 1F3FB 200D 2642","char":"🏄🏻‍♂","name":"man surfing: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C4 1F3FC 200D 2642 FE0F","char":"🏄🏼‍♂️","name":"man surfing: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C4 1F3FC 200D 2642","char":"🏄🏼‍♂","name":"man surfing: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C4 1F3FD 200D 2642 FE0F","char":"🏄🏽‍♂️","name":"man surfing: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C4 1F3FD 200D 2642","char":"🏄🏽‍♂","name":"man surfing: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C4 1F3FE 200D 2642 FE0F","char":"🏄🏾‍♂️","name":"man surfing: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C4 1F3FE 200D 2642","char":"🏄🏾‍♂","name":"man surfing: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C4 1F3FF 200D 2642 FE0F","char":"🏄🏿‍♂️","name":"man surfing: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C4 1F3FF 200D 2642","char":"🏄🏿‍♂","name":"man surfing: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C4 200D 2640 FE0F","char":"🏄‍♀️","name":"woman surfing","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C4 200D 2640","char":"🏄‍♀","name":"woman surfing","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C4 1F3FB 200D 2640 FE0F","char":"🏄🏻‍♀️","name":"woman surfing: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C4 1F3FB 200D 2640","char":"🏄🏻‍♀","name":"woman surfing: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C4 1F3FC 200D 2640 FE0F","char":"🏄🏼‍♀️","name":"woman surfing: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C4 1F3FC 200D 2640","char":"🏄🏼‍♀","name":"woman surfing: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C4 1F3FD 200D 2640 FE0F","char":"🏄🏽‍♀️","name":"woman surfing: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C4 1F3FD 200D 2640","char":"🏄🏽‍♀","name":"woman surfing: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C4 1F3FE 200D 2640 FE0F","char":"🏄🏾‍♀️","name":"woman surfing: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C4 1F3FE 200D 2640","char":"🏄🏾‍♀","name":"woman surfing: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C4 1F3FF 200D 2640 FE0F","char":"🏄🏿‍♀️","name":"woman surfing: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3C4 1F3FF 200D 2640","char":"🏄🏿‍♀","name":"woman surfing: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6A3","char":"🚣","name":"person rowing boat","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6A3 1F3FB","char":"🚣🏻","name":"person rowing boat: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6A3 1F3FC","char":"🚣🏼","name":"person rowing boat: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6A3 1F3FD","char":"🚣🏽","name":"person rowing boat: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6A3 1F3FE","char":"🚣🏾","name":"person rowing boat: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6A3 1F3FF","char":"🚣🏿","name":"person rowing boat: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6A3 200D 2642 FE0F","char":"🚣‍♂️","name":"man rowing boat","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6A3 200D 2642","char":"🚣‍♂","name":"man rowing boat","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6A3 1F3FB 200D 2642 FE0F","char":"🚣🏻‍♂️","name":"man rowing boat: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6A3 1F3FB 200D 2642","char":"🚣🏻‍♂","name":"man rowing boat: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6A3 1F3FC 200D 2642 FE0F","char":"🚣🏼‍♂️","name":"man rowing boat: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6A3 1F3FC 200D 2642","char":"🚣🏼‍♂","name":"man rowing boat: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6A3 1F3FD 200D 2642 FE0F","char":"🚣🏽‍♂️","name":"man rowing boat: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6A3 1F3FD 200D 2642","char":"🚣🏽‍♂","name":"man rowing boat: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6A3 1F3FE 200D 2642 FE0F","char":"🚣🏾‍♂️","name":"man rowing boat: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6A3 1F3FE 200D 2642","char":"🚣🏾‍♂","name":"man rowing boat: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6A3 1F3FF 200D 2642 FE0F","char":"🚣🏿‍♂️","name":"man rowing boat: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6A3 1F3FF 200D 2642","char":"🚣🏿‍♂","name":"man rowing boat: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6A3 200D 2640 FE0F","char":"🚣‍♀️","name":"woman rowing boat","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6A3 200D 2640","char":"🚣‍♀","name":"woman rowing boat","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6A3 1F3FB 200D 2640 FE0F","char":"🚣🏻‍♀️","name":"woman rowing boat: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6A3 1F3FB 200D 2640","char":"🚣🏻‍♀","name":"woman rowing boat: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6A3 1F3FC 200D 2640 FE0F","char":"🚣🏼‍♀️","name":"woman rowing boat: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6A3 1F3FC 200D 2640","char":"🚣🏼‍♀","name":"woman rowing boat: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6A3 1F3FD 200D 2640 FE0F","char":"🚣🏽‍♀️","name":"woman rowing boat: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6A3 1F3FD 200D 2640","char":"🚣🏽‍♀","name":"woman rowing boat: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6A3 1F3FE 200D 2640 FE0F","char":"🚣🏾‍♀️","name":"woman rowing boat: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6A3 1F3FE 200D 2640","char":"🚣🏾‍♀","name":"woman rowing boat: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6A3 1F3FF 200D 2640 FE0F","char":"🚣🏿‍♀️","name":"woman rowing boat: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6A3 1F3FF 200D 2640","char":"🚣🏿‍♀","name":"woman rowing boat: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CA","char":"🏊","name":"person swimming","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CA 1F3FB","char":"🏊🏻","name":"person swimming: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CA 1F3FC","char":"🏊🏼","name":"person swimming: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CA 1F3FD","char":"🏊🏽","name":"person swimming: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CA 1F3FE","char":"🏊🏾","name":"person swimming: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CA 1F3FF","char":"🏊🏿","name":"person swimming: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CA 200D 2642 FE0F","char":"🏊‍♂️","name":"man swimming","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CA 200D 2642","char":"🏊‍♂","name":"man swimming","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CA 1F3FB 200D 2642 FE0F","char":"🏊🏻‍♂️","name":"man swimming: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CA 1F3FB 200D 2642","char":"🏊🏻‍♂","name":"man swimming: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CA 1F3FC 200D 2642 FE0F","char":"🏊🏼‍♂️","name":"man swimming: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CA 1F3FC 200D 2642","char":"🏊🏼‍♂","name":"man swimming: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CA 1F3FD 200D 2642 FE0F","char":"🏊🏽‍♂️","name":"man swimming: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CA 1F3FD 200D 2642","char":"🏊🏽‍♂","name":"man swimming: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CA 1F3FE 200D 2642 FE0F","char":"🏊🏾‍♂️","name":"man swimming: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CA 1F3FE 200D 2642","char":"🏊🏾‍♂","name":"man swimming: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CA 1F3FF 200D 2642 FE0F","char":"🏊🏿‍♂️","name":"man swimming: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CA 1F3FF 200D 2642","char":"🏊🏿‍♂","name":"man swimming: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CA 200D 2640 FE0F","char":"🏊‍♀️","name":"woman swimming","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CA 200D 2640","char":"🏊‍♀","name":"woman swimming","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CA 1F3FB 200D 2640 FE0F","char":"🏊🏻‍♀️","name":"woman swimming: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CA 1F3FB 200D 2640","char":"🏊🏻‍♀","name":"woman swimming: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CA 1F3FC 200D 2640 FE0F","char":"🏊🏼‍♀️","name":"woman swimming: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CA 1F3FC 200D 2640","char":"🏊🏼‍♀","name":"woman swimming: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CA 1F3FD 200D 2640 FE0F","char":"🏊🏽‍♀️","name":"woman swimming: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CA 1F3FD 200D 2640","char":"🏊🏽‍♀","name":"woman swimming: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CA 1F3FE 200D 2640 FE0F","char":"🏊🏾‍♀️","name":"woman swimming: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CA 1F3FE 200D 2640","char":"🏊🏾‍♀","name":"woman swimming: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CA 1F3FF 200D 2640 FE0F","char":"🏊🏿‍♀️","name":"woman swimming: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CA 1F3FF 200D 2640","char":"🏊🏿‍♀","name":"woman swimming: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"26F9 FE0F","char":"⛹️","name":"person bouncing ball","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"26F9","char":"⛹","name":"person bouncing ball","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"26F9 1F3FB","char":"⛹🏻","name":"person bouncing ball: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"26F9 1F3FC","char":"⛹🏼","name":"person bouncing ball: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"26F9 1F3FD","char":"⛹🏽","name":"person bouncing ball: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"26F9 1F3FE","char":"⛹🏾","name":"person bouncing ball: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"26F9 1F3FF","char":"⛹🏿","name":"person bouncing ball: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"26F9 FE0F 200D 2642 FE0F","char":"⛹️‍♂️","name":"man bouncing ball","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"26F9 200D 2642 FE0F","char":"⛹‍♂️","name":"man bouncing ball","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"26F9 FE0F 200D 2642","char":"⛹️‍♂","name":"man bouncing ball","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"26F9 200D 2642","char":"⛹‍♂","name":"man bouncing ball","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"26F9 1F3FB 200D 2642 FE0F","char":"⛹🏻‍♂️","name":"man bouncing ball: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"26F9 1F3FB 200D 2642","char":"⛹🏻‍♂","name":"man bouncing ball: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"26F9 1F3FC 200D 2642 FE0F","char":"⛹🏼‍♂️","name":"man bouncing ball: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"26F9 1F3FC 200D 2642","char":"⛹🏼‍♂","name":"man bouncing ball: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"26F9 1F3FD 200D 2642 FE0F","char":"⛹🏽‍♂️","name":"man bouncing ball: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"26F9 1F3FD 200D 2642","char":"⛹🏽‍♂","name":"man bouncing ball: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"26F9 1F3FE 200D 2642 FE0F","char":"⛹🏾‍♂️","name":"man bouncing ball: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"26F9 1F3FE 200D 2642","char":"⛹🏾‍♂","name":"man bouncing ball: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"26F9 1F3FF 200D 2642 FE0F","char":"⛹🏿‍♂️","name":"man bouncing ball: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"26F9 1F3FF 200D 2642","char":"⛹🏿‍♂","name":"man bouncing ball: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"26F9 FE0F 200D 2640 FE0F","char":"⛹️‍♀️","name":"woman bouncing ball","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"26F9 200D 2640 FE0F","char":"⛹‍♀️","name":"woman bouncing ball","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"26F9 FE0F 200D 2640","char":"⛹️‍♀","name":"woman bouncing ball","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"26F9 200D 2640","char":"⛹‍♀","name":"woman bouncing ball","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"26F9 1F3FB 200D 2640 FE0F","char":"⛹🏻‍♀️","name":"woman bouncing ball: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"26F9 1F3FB 200D 2640","char":"⛹🏻‍♀","name":"woman bouncing ball: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"26F9 1F3FC 200D 2640 FE0F","char":"⛹🏼‍♀️","name":"woman bouncing ball: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"26F9 1F3FC 200D 2640","char":"⛹🏼‍♀","name":"woman bouncing ball: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"26F9 1F3FD 200D 2640 FE0F","char":"⛹🏽‍♀️","name":"woman bouncing ball: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"26F9 1F3FD 200D 2640","char":"⛹🏽‍♀","name":"woman bouncing ball: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"26F9 1F3FE 200D 2640 FE0F","char":"⛹🏾‍♀️","name":"woman bouncing ball: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"26F9 1F3FE 200D 2640","char":"⛹🏾‍♀","name":"woman bouncing ball: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"26F9 1F3FF 200D 2640 FE0F","char":"⛹🏿‍♀️","name":"woman bouncing ball: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"26F9 1F3FF 200D 2640","char":"⛹🏿‍♀","name":"woman bouncing ball: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CB FE0F","char":"🏋️","name":"person lifting weights","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CB","char":"🏋","name":"person lifting weights","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CB 1F3FB","char":"🏋🏻","name":"person lifting weights: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CB 1F3FC","char":"🏋🏼","name":"person lifting weights: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CB 1F3FD","char":"🏋🏽","name":"person lifting weights: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CB 1F3FE","char":"🏋🏾","name":"person lifting weights: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CB 1F3FF","char":"🏋🏿","name":"person lifting weights: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CB FE0F 200D 2642 FE0F","char":"🏋️‍♂️","name":"man lifting weights","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CB 200D 2642 FE0F","char":"🏋‍♂️","name":"man lifting weights","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CB FE0F 200D 2642","char":"🏋️‍♂","name":"man lifting weights","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CB 200D 2642","char":"🏋‍♂","name":"man lifting weights","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CB 1F3FB 200D 2642 FE0F","char":"🏋🏻‍♂️","name":"man lifting weights: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CB 1F3FB 200D 2642","char":"🏋🏻‍♂","name":"man lifting weights: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CB 1F3FC 200D 2642 FE0F","char":"🏋🏼‍♂️","name":"man lifting weights: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CB 1F3FC 200D 2642","char":"🏋🏼‍♂","name":"man lifting weights: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CB 1F3FD 200D 2642 FE0F","char":"🏋🏽‍♂️","name":"man lifting weights: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CB 1F3FD 200D 2642","char":"🏋🏽‍♂","name":"man lifting weights: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CB 1F3FE 200D 2642 FE0F","char":"🏋🏾‍♂️","name":"man lifting weights: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CB 1F3FE 200D 2642","char":"🏋🏾‍♂","name":"man lifting weights: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CB 1F3FF 200D 2642 FE0F","char":"🏋🏿‍♂️","name":"man lifting weights: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CB 1F3FF 200D 2642","char":"🏋🏿‍♂","name":"man lifting weights: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CB FE0F 200D 2640 FE0F","char":"🏋️‍♀️","name":"woman lifting weights","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CB 200D 2640 FE0F","char":"🏋‍♀️","name":"woman lifting weights","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CB FE0F 200D 2640","char":"🏋️‍♀","name":"woman lifting weights","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CB 200D 2640","char":"🏋‍♀","name":"woman lifting weights","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CB 1F3FB 200D 2640 FE0F","char":"🏋🏻‍♀️","name":"woman lifting weights: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CB 1F3FB 200D 2640","char":"🏋🏻‍♀","name":"woman lifting weights: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CB 1F3FC 200D 2640 FE0F","char":"🏋🏼‍♀️","name":"woman lifting weights: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CB 1F3FC 200D 2640","char":"🏋🏼‍♀","name":"woman lifting weights: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CB 1F3FD 200D 2640 FE0F","char":"🏋🏽‍♀️","name":"woman lifting weights: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CB 1F3FD 200D 2640","char":"🏋🏽‍♀","name":"woman lifting weights: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CB 1F3FE 200D 2640 FE0F","char":"🏋🏾‍♀️","name":"woman lifting weights: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CB 1F3FE 200D 2640","char":"🏋🏾‍♀","name":"woman lifting weights: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CB 1F3FF 200D 2640 FE0F","char":"🏋🏿‍♀️","name":"woman lifting weights: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F3CB 1F3FF 200D 2640","char":"🏋🏿‍♀","name":"woman lifting weights: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B4","char":"🚴","name":"person biking","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B4 1F3FB","char":"🚴🏻","name":"person biking: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B4 1F3FC","char":"🚴🏼","name":"person biking: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B4 1F3FD","char":"🚴🏽","name":"person biking: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B4 1F3FE","char":"🚴🏾","name":"person biking: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B4 1F3FF","char":"🚴🏿","name":"person biking: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B4 200D 2642 FE0F","char":"🚴‍♂️","name":"man biking","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B4 200D 2642","char":"🚴‍♂","name":"man biking","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B4 1F3FB 200D 2642 FE0F","char":"🚴🏻‍♂️","name":"man biking: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B4 1F3FB 200D 2642","char":"🚴🏻‍♂","name":"man biking: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B4 1F3FC 200D 2642 FE0F","char":"🚴🏼‍♂️","name":"man biking: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B4 1F3FC 200D 2642","char":"🚴🏼‍♂","name":"man biking: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B4 1F3FD 200D 2642 FE0F","char":"🚴🏽‍♂️","name":"man biking: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B4 1F3FD 200D 2642","char":"🚴🏽‍♂","name":"man biking: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B4 1F3FE 200D 2642 FE0F","char":"🚴🏾‍♂️","name":"man biking: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B4 1F3FE 200D 2642","char":"🚴🏾‍♂","name":"man biking: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B4 1F3FF 200D 2642 FE0F","char":"🚴🏿‍♂️","name":"man biking: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B4 1F3FF 200D 2642","char":"🚴🏿‍♂","name":"man biking: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B4 200D 2640 FE0F","char":"🚴‍♀️","name":"woman biking","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B4 200D 2640","char":"🚴‍♀","name":"woman biking","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B4 1F3FB 200D 2640 FE0F","char":"🚴🏻‍♀️","name":"woman biking: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B4 1F3FB 200D 2640","char":"🚴🏻‍♀","name":"woman biking: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B4 1F3FC 200D 2640 FE0F","char":"🚴🏼‍♀️","name":"woman biking: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B4 1F3FC 200D 2640","char":"🚴🏼‍♀","name":"woman biking: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B4 1F3FD 200D 2640 FE0F","char":"🚴🏽‍♀️","name":"woman biking: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B4 1F3FD 200D 2640","char":"🚴🏽‍♀","name":"woman biking: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B4 1F3FE 200D 2640 FE0F","char":"🚴🏾‍♀️","name":"woman biking: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B4 1F3FE 200D 2640","char":"🚴🏾‍♀","name":"woman biking: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B4 1F3FF 200D 2640 FE0F","char":"🚴🏿‍♀️","name":"woman biking: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B4 1F3FF 200D 2640","char":"🚴🏿‍♀","name":"woman biking: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B5","char":"🚵","name":"person mountain biking","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B5 1F3FB","char":"🚵🏻","name":"person mountain biking: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B5 1F3FC","char":"🚵🏼","name":"person mountain biking: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B5 1F3FD","char":"🚵🏽","name":"person mountain biking: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B5 1F3FE","char":"🚵🏾","name":"person mountain biking: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B5 1F3FF","char":"🚵🏿","name":"person mountain biking: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B5 200D 2642 FE0F","char":"🚵‍♂️","name":"man mountain biking","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B5 200D 2642","char":"🚵‍♂","name":"man mountain biking","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B5 1F3FB 200D 2642 FE0F","char":"🚵🏻‍♂️","name":"man mountain biking: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B5 1F3FB 200D 2642","char":"🚵🏻‍♂","name":"man mountain biking: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B5 1F3FC 200D 2642 FE0F","char":"🚵🏼‍♂️","name":"man mountain biking: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B5 1F3FC 200D 2642","char":"🚵🏼‍♂","name":"man mountain biking: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B5 1F3FD 200D 2642 FE0F","char":"🚵🏽‍♂️","name":"man mountain biking: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B5 1F3FD 200D 2642","char":"🚵🏽‍♂","name":"man mountain biking: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B5 1F3FE 200D 2642 FE0F","char":"🚵🏾‍♂️","name":"man mountain biking: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B5 1F3FE 200D 2642","char":"🚵🏾‍♂","name":"man mountain biking: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B5 1F3FF 200D 2642 FE0F","char":"🚵🏿‍♂️","name":"man mountain biking: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B5 1F3FF 200D 2642","char":"🚵🏿‍♂","name":"man mountain biking: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B5 200D 2640 FE0F","char":"🚵‍♀️","name":"woman mountain biking","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B5 200D 2640","char":"🚵‍♀","name":"woman mountain biking","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B5 1F3FB 200D 2640 FE0F","char":"🚵🏻‍♀️","name":"woman mountain biking: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B5 1F3FB 200D 2640","char":"🚵🏻‍♀","name":"woman mountain biking: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B5 1F3FC 200D 2640 FE0F","char":"🚵🏼‍♀️","name":"woman mountain biking: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B5 1F3FC 200D 2640","char":"🚵🏼‍♀","name":"woman mountain biking: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B5 1F3FD 200D 2640 FE0F","char":"🚵🏽‍♀️","name":"woman mountain biking: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B5 1F3FD 200D 2640","char":"🚵🏽‍♀","name":"woman mountain biking: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B5 1F3FE 200D 2640 FE0F","char":"🚵🏾‍♀️","name":"woman mountain biking: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B5 1F3FE 200D 2640","char":"🚵🏾‍♀","name":"woman mountain biking: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B5 1F3FF 200D 2640 FE0F","char":"🚵🏿‍♀️","name":"woman mountain biking: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F6B5 1F3FF 200D 2640","char":"🚵🏿‍♀","name":"woman mountain biking: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F938","char":"🤸","name":"person cartwheeling","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F938 1F3FB","char":"🤸🏻","name":"person cartwheeling: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F938 1F3FC","char":"🤸🏼","name":"person cartwheeling: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F938 1F3FD","char":"🤸🏽","name":"person cartwheeling: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F938 1F3FE","char":"🤸🏾","name":"person cartwheeling: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F938 1F3FF","char":"🤸🏿","name":"person cartwheeling: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F938 200D 2642 FE0F","char":"🤸‍♂️","name":"man cartwheeling","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F938 200D 2642","char":"🤸‍♂","name":"man cartwheeling","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F938 1F3FB 200D 2642 FE0F","char":"🤸🏻‍♂️","name":"man cartwheeling: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F938 1F3FB 200D 2642","char":"🤸🏻‍♂","name":"man cartwheeling: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F938 1F3FC 200D 2642 FE0F","char":"🤸🏼‍♂️","name":"man cartwheeling: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F938 1F3FC 200D 2642","char":"🤸🏼‍♂","name":"man cartwheeling: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F938 1F3FD 200D 2642 FE0F","char":"🤸🏽‍♂️","name":"man cartwheeling: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F938 1F3FD 200D 2642","char":"🤸🏽‍♂","name":"man cartwheeling: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F938 1F3FE 200D 2642 FE0F","char":"🤸🏾‍♂️","name":"man cartwheeling: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F938 1F3FE 200D 2642","char":"🤸🏾‍♂","name":"man cartwheeling: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F938 1F3FF 200D 2642 FE0F","char":"🤸🏿‍♂️","name":"man cartwheeling: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F938 1F3FF 200D 2642","char":"🤸🏿‍♂","name":"man cartwheeling: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F938 200D 2640 FE0F","char":"🤸‍♀️","name":"woman cartwheeling","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F938 200D 2640","char":"🤸‍♀","name":"woman cartwheeling","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F938 1F3FB 200D 2640 FE0F","char":"🤸🏻‍♀️","name":"woman cartwheeling: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F938 1F3FB 200D 2640","char":"🤸🏻‍♀","name":"woman cartwheeling: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F938 1F3FC 200D 2640 FE0F","char":"🤸🏼‍♀️","name":"woman cartwheeling: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F938 1F3FC 200D 2640","char":"🤸🏼‍♀","name":"woman cartwheeling: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F938 1F3FD 200D 2640 FE0F","char":"🤸🏽‍♀️","name":"woman cartwheeling: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F938 1F3FD 200D 2640","char":"🤸🏽‍♀","name":"woman cartwheeling: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F938 1F3FE 200D 2640 FE0F","char":"🤸🏾‍♀️","name":"woman cartwheeling: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F938 1F3FE 200D 2640","char":"🤸🏾‍♀","name":"woman cartwheeling: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F938 1F3FF 200D 2640 FE0F","char":"🤸🏿‍♀️","name":"woman cartwheeling: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F938 1F3FF 200D 2640","char":"🤸🏿‍♀","name":"woman cartwheeling: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93C","char":"🤼","name":"people wrestling","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93C 200D 2642 FE0F","char":"🤼‍♂️","name":"men wrestling","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93C 200D 2642","char":"🤼‍♂","name":"men wrestling","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93C 200D 2640 FE0F","char":"🤼‍♀️","name":"women wrestling","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93C 200D 2640","char":"🤼‍♀","name":"women wrestling","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93D","char":"🤽","name":"person playing water polo","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93D 1F3FB","char":"🤽🏻","name":"person playing water polo: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93D 1F3FC","char":"🤽🏼","name":"person playing water polo: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93D 1F3FD","char":"🤽🏽","name":"person playing water polo: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93D 1F3FE","char":"🤽🏾","name":"person playing water polo: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93D 1F3FF","char":"🤽🏿","name":"person playing water polo: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93D 200D 2642 FE0F","char":"🤽‍♂️","name":"man playing water polo","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93D 200D 2642","char":"🤽‍♂","name":"man playing water polo","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93D 1F3FB 200D 2642 FE0F","char":"🤽🏻‍♂️","name":"man playing water polo: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93D 1F3FB 200D 2642","char":"🤽🏻‍♂","name":"man playing water polo: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93D 1F3FC 200D 2642 FE0F","char":"🤽🏼‍♂️","name":"man playing water polo: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93D 1F3FC 200D 2642","char":"🤽🏼‍♂","name":"man playing water polo: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93D 1F3FD 200D 2642 FE0F","char":"🤽🏽‍♂️","name":"man playing water polo: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93D 1F3FD 200D 2642","char":"🤽🏽‍♂","name":"man playing water polo: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93D 1F3FE 200D 2642 FE0F","char":"🤽🏾‍♂️","name":"man playing water polo: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93D 1F3FE 200D 2642","char":"🤽🏾‍♂","name":"man playing water polo: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93D 1F3FF 200D 2642 FE0F","char":"🤽🏿‍♂️","name":"man playing water polo: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93D 1F3FF 200D 2642","char":"🤽🏿‍♂","name":"man playing water polo: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93D 200D 2640 FE0F","char":"🤽‍♀️","name":"woman playing water polo","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93D 200D 2640","char":"🤽‍♀","name":"woman playing water polo","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93D 1F3FB 200D 2640 FE0F","char":"🤽🏻‍♀️","name":"woman playing water polo: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93D 1F3FB 200D 2640","char":"🤽🏻‍♀","name":"woman playing water polo: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93D 1F3FC 200D 2640 FE0F","char":"🤽🏼‍♀️","name":"woman playing water polo: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93D 1F3FC 200D 2640","char":"🤽🏼‍♀","name":"woman playing water polo: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93D 1F3FD 200D 2640 FE0F","char":"🤽🏽‍♀️","name":"woman playing water polo: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93D 1F3FD 200D 2640","char":"🤽🏽‍♀","name":"woman playing water polo: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93D 1F3FE 200D 2640 FE0F","char":"🤽🏾‍♀️","name":"woman playing water polo: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93D 1F3FE 200D 2640","char":"🤽🏾‍♀","name":"woman playing water polo: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93D 1F3FF 200D 2640 FE0F","char":"🤽🏿‍♀️","name":"woman playing water polo: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93D 1F3FF 200D 2640","char":"🤽🏿‍♀","name":"woman playing water polo: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93E","char":"🤾","name":"person playing handball","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93E 1F3FB","char":"🤾🏻","name":"person playing handball: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93E 1F3FC","char":"🤾🏼","name":"person playing handball: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93E 1F3FD","char":"🤾🏽","name":"person playing handball: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93E 1F3FE","char":"🤾🏾","name":"person playing handball: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93E 1F3FF","char":"🤾🏿","name":"person playing handball: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93E 200D 2642 FE0F","char":"🤾‍♂️","name":"man playing handball","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93E 200D 2642","char":"🤾‍♂","name":"man playing handball","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93E 1F3FB 200D 2642 FE0F","char":"🤾🏻‍♂️","name":"man playing handball: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93E 1F3FB 200D 2642","char":"🤾🏻‍♂","name":"man playing handball: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93E 1F3FC 200D 2642 FE0F","char":"🤾🏼‍♂️","name":"man playing handball: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93E 1F3FC 200D 2642","char":"🤾🏼‍♂","name":"man playing handball: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93E 1F3FD 200D 2642 FE0F","char":"🤾🏽‍♂️","name":"man playing handball: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93E 1F3FD 200D 2642","char":"🤾🏽‍♂","name":"man playing handball: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93E 1F3FE 200D 2642 FE0F","char":"🤾🏾‍♂️","name":"man playing handball: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93E 1F3FE 200D 2642","char":"🤾🏾‍♂","name":"man playing handball: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93E 1F3FF 200D 2642 FE0F","char":"🤾🏿‍♂️","name":"man playing handball: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93E 1F3FF 200D 2642","char":"🤾🏿‍♂","name":"man playing handball: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93E 200D 2640 FE0F","char":"🤾‍♀️","name":"woman playing handball","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93E 200D 2640","char":"🤾‍♀","name":"woman playing handball","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93E 1F3FB 200D 2640 FE0F","char":"🤾🏻‍♀️","name":"woman playing handball: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93E 1F3FB 200D 2640","char":"🤾🏻‍♀","name":"woman playing handball: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93E 1F3FC 200D 2640 FE0F","char":"🤾🏼‍♀️","name":"woman playing handball: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93E 1F3FC 200D 2640","char":"🤾🏼‍♀","name":"woman playing handball: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93E 1F3FD 200D 2640 FE0F","char":"🤾🏽‍♀️","name":"woman playing handball: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93E 1F3FD 200D 2640","char":"🤾🏽‍♀","name":"woman playing handball: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93E 1F3FE 200D 2640 FE0F","char":"🤾🏾‍♀️","name":"woman playing handball: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93E 1F3FE 200D 2640","char":"🤾🏾‍♀","name":"woman playing handball: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93E 1F3FF 200D 2640 FE0F","char":"🤾🏿‍♀️","name":"woman playing handball: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F93E 1F3FF 200D 2640","char":"🤾🏿‍♀","name":"woman playing handball: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F939","char":"🤹","name":"person juggling","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F939 1F3FB","char":"🤹🏻","name":"person juggling: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F939 1F3FC","char":"🤹🏼","name":"person juggling: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F939 1F3FD","char":"🤹🏽","name":"person juggling: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F939 1F3FE","char":"🤹🏾","name":"person juggling: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F939 1F3FF","char":"🤹🏿","name":"person juggling: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F939 200D 2642 FE0F","char":"🤹‍♂️","name":"man juggling","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F939 200D 2642","char":"🤹‍♂","name":"man juggling","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F939 1F3FB 200D 2642 FE0F","char":"🤹🏻‍♂️","name":"man juggling: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F939 1F3FB 200D 2642","char":"🤹🏻‍♂","name":"man juggling: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F939 1F3FC 200D 2642 FE0F","char":"🤹🏼‍♂️","name":"man juggling: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F939 1F3FC 200D 2642","char":"🤹🏼‍♂","name":"man juggling: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F939 1F3FD 200D 2642 FE0F","char":"🤹🏽‍♂️","name":"man juggling: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F939 1F3FD 200D 2642","char":"🤹🏽‍♂","name":"man juggling: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F939 1F3FE 200D 2642 FE0F","char":"🤹🏾‍♂️","name":"man juggling: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F939 1F3FE 200D 2642","char":"🤹🏾‍♂","name":"man juggling: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F939 1F3FF 200D 2642 FE0F","char":"🤹🏿‍♂️","name":"man juggling: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F939 1F3FF 200D 2642","char":"🤹🏿‍♂","name":"man juggling: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F939 200D 2640 FE0F","char":"🤹‍♀️","name":"woman juggling","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F939 200D 2640","char":"🤹‍♀","name":"woman juggling","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F939 1F3FB 200D 2640 FE0F","char":"🤹🏻‍♀️","name":"woman juggling: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F939 1F3FB 200D 2640","char":"🤹🏻‍♀","name":"woman juggling: light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F939 1F3FC 200D 2640 FE0F","char":"🤹🏼‍♀️","name":"woman juggling: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F939 1F3FC 200D 2640","char":"🤹🏼‍♀","name":"woman juggling: medium-light skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F939 1F3FD 200D 2640 FE0F","char":"🤹🏽‍♀️","name":"woman juggling: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F939 1F3FD 200D 2640","char":"🤹🏽‍♀","name":"woman juggling: medium skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F939 1F3FE 200D 2640 FE0F","char":"🤹🏾‍♀️","name":"woman juggling: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F939 1F3FE 200D 2640","char":"🤹🏾‍♀","name":"woman juggling: medium-dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F939 1F3FF 200D 2640 FE0F","char":"🤹🏿‍♀️","name":"woman juggling: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F939 1F3FF 200D 2640","char":"🤹🏿‍♀","name":"woman juggling: dark skin tone","category":"People & Body (person-sport)","group":"People & Body","subgroup":"person-sport"},{"codes":"1F9D8","char":"🧘","name":"person in lotus position","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F9D8 1F3FB","char":"🧘🏻","name":"person in lotus position: light skin tone","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F9D8 1F3FC","char":"🧘🏼","name":"person in lotus position: medium-light skin tone","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F9D8 1F3FD","char":"🧘🏽","name":"person in lotus position: medium skin tone","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F9D8 1F3FE","char":"🧘🏾","name":"person in lotus position: medium-dark skin tone","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F9D8 1F3FF","char":"🧘🏿","name":"person in lotus position: dark skin tone","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F9D8 200D 2642 FE0F","char":"🧘‍♂️","name":"man in lotus position","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F9D8 200D 2642","char":"🧘‍♂","name":"man in lotus position","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F9D8 1F3FB 200D 2642 FE0F","char":"🧘🏻‍♂️","name":"man in lotus position: light skin tone","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F9D8 1F3FB 200D 2642","char":"🧘🏻‍♂","name":"man in lotus position: light skin tone","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F9D8 1F3FC 200D 2642 FE0F","char":"🧘🏼‍♂️","name":"man in lotus position: medium-light skin tone","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F9D8 1F3FC 200D 2642","char":"🧘🏼‍♂","name":"man in lotus position: medium-light skin tone","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F9D8 1F3FD 200D 2642 FE0F","char":"🧘🏽‍♂️","name":"man in lotus position: medium skin tone","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F9D8 1F3FD 200D 2642","char":"🧘🏽‍♂","name":"man in lotus position: medium skin tone","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F9D8 1F3FE 200D 2642 FE0F","char":"🧘🏾‍♂️","name":"man in lotus position: medium-dark skin tone","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F9D8 1F3FE 200D 2642","char":"🧘🏾‍♂","name":"man in lotus position: medium-dark skin tone","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F9D8 1F3FF 200D 2642 FE0F","char":"🧘🏿‍♂️","name":"man in lotus position: dark skin tone","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F9D8 1F3FF 200D 2642","char":"🧘🏿‍♂","name":"man in lotus position: dark skin tone","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F9D8 200D 2640 FE0F","char":"🧘‍♀️","name":"woman in lotus position","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F9D8 200D 2640","char":"🧘‍♀","name":"woman in lotus position","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F9D8 1F3FB 200D 2640 FE0F","char":"🧘🏻‍♀️","name":"woman in lotus position: light skin tone","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F9D8 1F3FB 200D 2640","char":"🧘🏻‍♀","name":"woman in lotus position: light skin tone","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F9D8 1F3FC 200D 2640 FE0F","char":"🧘🏼‍♀️","name":"woman in lotus position: medium-light skin tone","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F9D8 1F3FC 200D 2640","char":"🧘🏼‍♀","name":"woman in lotus position: medium-light skin tone","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F9D8 1F3FD 200D 2640 FE0F","char":"🧘🏽‍♀️","name":"woman in lotus position: medium skin tone","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F9D8 1F3FD 200D 2640","char":"🧘🏽‍♀","name":"woman in lotus position: medium skin tone","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F9D8 1F3FE 200D 2640 FE0F","char":"🧘🏾‍♀️","name":"woman in lotus position: medium-dark skin tone","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F9D8 1F3FE 200D 2640","char":"🧘🏾‍♀","name":"woman in lotus position: medium-dark skin tone","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F9D8 1F3FF 200D 2640 FE0F","char":"🧘🏿‍♀️","name":"woman in lotus position: dark skin tone","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F9D8 1F3FF 200D 2640","char":"🧘🏿‍♀","name":"woman in lotus position: dark skin tone","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F6C0","char":"🛀","name":"person taking bath","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F6C0 1F3FB","char":"🛀🏻","name":"person taking bath: light skin tone","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F6C0 1F3FC","char":"🛀🏼","name":"person taking bath: medium-light skin tone","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F6C0 1F3FD","char":"🛀🏽","name":"person taking bath: medium skin tone","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F6C0 1F3FE","char":"🛀🏾","name":"person taking bath: medium-dark skin tone","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F6C0 1F3FF","char":"🛀🏿","name":"person taking bath: dark skin tone","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F6CC","char":"🛌","name":"person in bed","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F6CC 1F3FB","char":"🛌🏻","name":"person in bed: light skin tone","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F6CC 1F3FC","char":"🛌🏼","name":"person in bed: medium-light skin tone","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F6CC 1F3FD","char":"🛌🏽","name":"person in bed: medium skin tone","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F6CC 1F3FE","char":"🛌🏾","name":"person in bed: medium-dark skin tone","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F6CC 1F3FF","char":"🛌🏿","name":"person in bed: dark skin tone","category":"People & Body (person-resting)","group":"People & Body","subgroup":"person-resting"},{"codes":"1F9D1 200D 1F91D 200D 1F9D1","char":"🧑‍🤝‍🧑","name":"people holding hands","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FB 200D 1F91D 200D 1F9D1 1F3FB","char":"🧑🏻‍🤝‍🧑🏻","name":"people holding hands: light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FB 200D 1F91D 200D 1F9D1 1F3FC","char":"🧑🏻‍🤝‍🧑🏼","name":"people holding hands: light skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FB 200D 1F91D 200D 1F9D1 1F3FD","char":"🧑🏻‍🤝‍🧑🏽","name":"people holding hands: light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FB 200D 1F91D 200D 1F9D1 1F3FE","char":"🧑🏻‍🤝‍🧑🏾","name":"people holding hands: light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FB 200D 1F91D 200D 1F9D1 1F3FF","char":"🧑🏻‍🤝‍🧑🏿","name":"people holding hands: light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FC 200D 1F91D 200D 1F9D1 1F3FB","char":"🧑🏼‍🤝‍🧑🏻","name":"people holding hands: medium-light skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FC 200D 1F91D 200D 1F9D1 1F3FC","char":"🧑🏼‍🤝‍🧑🏼","name":"people holding hands: medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FC 200D 1F91D 200D 1F9D1 1F3FD","char":"🧑🏼‍🤝‍🧑🏽","name":"people holding hands: medium-light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FC 200D 1F91D 200D 1F9D1 1F3FE","char":"🧑🏼‍🤝‍🧑🏾","name":"people holding hands: medium-light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FC 200D 1F91D 200D 1F9D1 1F3FF","char":"🧑🏼‍🤝‍🧑🏿","name":"people holding hands: medium-light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FD 200D 1F91D 200D 1F9D1 1F3FB","char":"🧑🏽‍🤝‍🧑🏻","name":"people holding hands: medium skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FD 200D 1F91D 200D 1F9D1 1F3FC","char":"🧑🏽‍🤝‍🧑🏼","name":"people holding hands: medium skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FD 200D 1F91D 200D 1F9D1 1F3FD","char":"🧑🏽‍🤝‍🧑🏽","name":"people holding hands: medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FD 200D 1F91D 200D 1F9D1 1F3FE","char":"🧑🏽‍🤝‍🧑🏾","name":"people holding hands: medium skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FD 200D 1F91D 200D 1F9D1 1F3FF","char":"🧑🏽‍🤝‍🧑🏿","name":"people holding hands: medium skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FE 200D 1F91D 200D 1F9D1 1F3FB","char":"🧑🏾‍🤝‍🧑🏻","name":"people holding hands: medium-dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FE 200D 1F91D 200D 1F9D1 1F3FC","char":"🧑🏾‍🤝‍🧑🏼","name":"people holding hands: medium-dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FE 200D 1F91D 200D 1F9D1 1F3FD","char":"🧑🏾‍🤝‍🧑🏽","name":"people holding hands: medium-dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FE 200D 1F91D 200D 1F9D1 1F3FE","char":"🧑🏾‍🤝‍🧑🏾","name":"people holding hands: medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FE 200D 1F91D 200D 1F9D1 1F3FF","char":"🧑🏾‍🤝‍🧑🏿","name":"people holding hands: medium-dark skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FF 200D 1F91D 200D 1F9D1 1F3FB","char":"🧑🏿‍🤝‍🧑🏻","name":"people holding hands: dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FF 200D 1F91D 200D 1F9D1 1F3FC","char":"🧑🏿‍🤝‍🧑🏼","name":"people holding hands: dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FF 200D 1F91D 200D 1F9D1 1F3FD","char":"🧑🏿‍🤝‍🧑🏽","name":"people holding hands: dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FF 200D 1F91D 200D 1F9D1 1F3FE","char":"🧑🏿‍🤝‍🧑🏾","name":"people holding hands: dark skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FF 200D 1F91D 200D 1F9D1 1F3FF","char":"🧑🏿‍🤝‍🧑🏿","name":"people holding hands: dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F46D","char":"👭","name":"women holding hands","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F46D 1F3FB","char":"👭🏻","name":"women holding hands: light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 1F91D 200D 1F469 1F3FC","char":"👩🏻‍🤝‍👩🏼","name":"women holding hands: light skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 1F91D 200D 1F469 1F3FD","char":"👩🏻‍🤝‍👩🏽","name":"women holding hands: light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 1F91D 200D 1F469 1F3FE","char":"👩🏻‍🤝‍👩🏾","name":"women holding hands: light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 1F91D 200D 1F469 1F3FF","char":"👩🏻‍🤝‍👩🏿","name":"women holding hands: light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 1F91D 200D 1F469 1F3FB","char":"👩🏼‍🤝‍👩🏻","name":"women holding hands: medium-light skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F46D 1F3FC","char":"👭🏼","name":"women holding hands: medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 1F91D 200D 1F469 1F3FD","char":"👩🏼‍🤝‍👩🏽","name":"women holding hands: medium-light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 1F91D 200D 1F469 1F3FE","char":"👩🏼‍🤝‍👩🏾","name":"women holding hands: medium-light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 1F91D 200D 1F469 1F3FF","char":"👩🏼‍🤝‍👩🏿","name":"women holding hands: medium-light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 1F91D 200D 1F469 1F3FB","char":"👩🏽‍🤝‍👩🏻","name":"women holding hands: medium skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 1F91D 200D 1F469 1F3FC","char":"👩🏽‍🤝‍👩🏼","name":"women holding hands: medium skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F46D 1F3FD","char":"👭🏽","name":"women holding hands: medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 1F91D 200D 1F469 1F3FE","char":"👩🏽‍🤝‍👩🏾","name":"women holding hands: medium skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 1F91D 200D 1F469 1F3FF","char":"👩🏽‍🤝‍👩🏿","name":"women holding hands: medium skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 1F91D 200D 1F469 1F3FB","char":"👩🏾‍🤝‍👩🏻","name":"women holding hands: medium-dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 1F91D 200D 1F469 1F3FC","char":"👩🏾‍🤝‍👩🏼","name":"women holding hands: medium-dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 1F91D 200D 1F469 1F3FD","char":"👩🏾‍🤝‍👩🏽","name":"women holding hands: medium-dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F46D 1F3FE","char":"👭🏾","name":"women holding hands: medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 1F91D 200D 1F469 1F3FF","char":"👩🏾‍🤝‍👩🏿","name":"women holding hands: medium-dark skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 1F91D 200D 1F469 1F3FB","char":"👩🏿‍🤝‍👩🏻","name":"women holding hands: dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 1F91D 200D 1F469 1F3FC","char":"👩🏿‍🤝‍👩🏼","name":"women holding hands: dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 1F91D 200D 1F469 1F3FD","char":"👩🏿‍🤝‍👩🏽","name":"women holding hands: dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 1F91D 200D 1F469 1F3FE","char":"👩🏿‍🤝‍👩🏾","name":"women holding hands: dark skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F46D 1F3FF","char":"👭🏿","name":"women holding hands: dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F46B","char":"👫","name":"woman and man holding hands","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F46B 1F3FB","char":"👫🏻","name":"woman and man holding hands: light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 1F91D 200D 1F468 1F3FC","char":"👩🏻‍🤝‍👨🏼","name":"woman and man holding hands: light skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 1F91D 200D 1F468 1F3FD","char":"👩🏻‍🤝‍👨🏽","name":"woman and man holding hands: light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 1F91D 200D 1F468 1F3FE","char":"👩🏻‍🤝‍👨🏾","name":"woman and man holding hands: light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 1F91D 200D 1F468 1F3FF","char":"👩🏻‍🤝‍👨🏿","name":"woman and man holding hands: light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 1F91D 200D 1F468 1F3FB","char":"👩🏼‍🤝‍👨🏻","name":"woman and man holding hands: medium-light skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F46B 1F3FC","char":"👫🏼","name":"woman and man holding hands: medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 1F91D 200D 1F468 1F3FD","char":"👩🏼‍🤝‍👨🏽","name":"woman and man holding hands: medium-light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 1F91D 200D 1F468 1F3FE","char":"👩🏼‍🤝‍👨🏾","name":"woman and man holding hands: medium-light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 1F91D 200D 1F468 1F3FF","char":"👩🏼‍🤝‍👨🏿","name":"woman and man holding hands: medium-light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 1F91D 200D 1F468 1F3FB","char":"👩🏽‍🤝‍👨🏻","name":"woman and man holding hands: medium skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 1F91D 200D 1F468 1F3FC","char":"👩🏽‍🤝‍👨🏼","name":"woman and man holding hands: medium skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F46B 1F3FD","char":"👫🏽","name":"woman and man holding hands: medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 1F91D 200D 1F468 1F3FE","char":"👩🏽‍🤝‍👨🏾","name":"woman and man holding hands: medium skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 1F91D 200D 1F468 1F3FF","char":"👩🏽‍🤝‍👨🏿","name":"woman and man holding hands: medium skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 1F91D 200D 1F468 1F3FB","char":"👩🏾‍🤝‍👨🏻","name":"woman and man holding hands: medium-dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 1F91D 200D 1F468 1F3FC","char":"👩🏾‍🤝‍👨🏼","name":"woman and man holding hands: medium-dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 1F91D 200D 1F468 1F3FD","char":"👩🏾‍🤝‍👨🏽","name":"woman and man holding hands: medium-dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F46B 1F3FE","char":"👫🏾","name":"woman and man holding hands: medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 1F91D 200D 1F468 1F3FF","char":"👩🏾‍🤝‍👨🏿","name":"woman and man holding hands: medium-dark skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 1F91D 200D 1F468 1F3FB","char":"👩🏿‍🤝‍👨🏻","name":"woman and man holding hands: dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 1F91D 200D 1F468 1F3FC","char":"👩🏿‍🤝‍👨🏼","name":"woman and man holding hands: dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 1F91D 200D 1F468 1F3FD","char":"👩🏿‍🤝‍👨🏽","name":"woman and man holding hands: dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 1F91D 200D 1F468 1F3FE","char":"👩🏿‍🤝‍👨🏾","name":"woman and man holding hands: dark skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F46B 1F3FF","char":"👫🏿","name":"woman and man holding hands: dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F46C","char":"👬","name":"men holding hands","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F46C 1F3FB","char":"👬🏻","name":"men holding hands: light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FB 200D 1F91D 200D 1F468 1F3FC","char":"👨🏻‍🤝‍👨🏼","name":"men holding hands: light skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FB 200D 1F91D 200D 1F468 1F3FD","char":"👨🏻‍🤝‍👨🏽","name":"men holding hands: light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FB 200D 1F91D 200D 1F468 1F3FE","char":"👨🏻‍🤝‍👨🏾","name":"men holding hands: light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FB 200D 1F91D 200D 1F468 1F3FF","char":"👨🏻‍🤝‍👨🏿","name":"men holding hands: light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FC 200D 1F91D 200D 1F468 1F3FB","char":"👨🏼‍🤝‍👨🏻","name":"men holding hands: medium-light skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F46C 1F3FC","char":"👬🏼","name":"men holding hands: medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FC 200D 1F91D 200D 1F468 1F3FD","char":"👨🏼‍🤝‍👨🏽","name":"men holding hands: medium-light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FC 200D 1F91D 200D 1F468 1F3FE","char":"👨🏼‍🤝‍👨🏾","name":"men holding hands: medium-light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FC 200D 1F91D 200D 1F468 1F3FF","char":"👨🏼‍🤝‍👨🏿","name":"men holding hands: medium-light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FD 200D 1F91D 200D 1F468 1F3FB","char":"👨🏽‍🤝‍👨🏻","name":"men holding hands: medium skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FD 200D 1F91D 200D 1F468 1F3FC","char":"👨🏽‍🤝‍👨🏼","name":"men holding hands: medium skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F46C 1F3FD","char":"👬🏽","name":"men holding hands: medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FD 200D 1F91D 200D 1F468 1F3FE","char":"👨🏽‍🤝‍👨🏾","name":"men holding hands: medium skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FD 200D 1F91D 200D 1F468 1F3FF","char":"👨🏽‍🤝‍👨🏿","name":"men holding hands: medium skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FE 200D 1F91D 200D 1F468 1F3FB","char":"👨🏾‍🤝‍👨🏻","name":"men holding hands: medium-dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FE 200D 1F91D 200D 1F468 1F3FC","char":"👨🏾‍🤝‍👨🏼","name":"men holding hands: medium-dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FE 200D 1F91D 200D 1F468 1F3FD","char":"👨🏾‍🤝‍👨🏽","name":"men holding hands: medium-dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F46C 1F3FE","char":"👬🏾","name":"men holding hands: medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FE 200D 1F91D 200D 1F468 1F3FF","char":"👨🏾‍🤝‍👨🏿","name":"men holding hands: medium-dark skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FF 200D 1F91D 200D 1F468 1F3FB","char":"👨🏿‍🤝‍👨🏻","name":"men holding hands: dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FF 200D 1F91D 200D 1F468 1F3FC","char":"👨🏿‍🤝‍👨🏼","name":"men holding hands: dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FF 200D 1F91D 200D 1F468 1F3FD","char":"👨🏿‍🤝‍👨🏽","name":"men holding hands: dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FF 200D 1F91D 200D 1F468 1F3FE","char":"👨🏿‍🤝‍👨🏾","name":"men holding hands: dark skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F46C 1F3FF","char":"👬🏿","name":"men holding hands: dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F48F","char":"💏","name":"kiss","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F48F 1F3FB","char":"💏🏻","name":"kiss: light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F48F 1F3FC","char":"💏🏼","name":"kiss: medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F48F 1F3FD","char":"💏🏽","name":"kiss: medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F48F 1F3FE","char":"💏🏾","name":"kiss: medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F48F 1F3FF","char":"💏🏿","name":"kiss: dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FB 200D 2764 FE0F 200D 1F48B 200D 1F9D1 1F3FC","char":"🧑🏻‍❤️‍💋‍🧑🏼","name":"kiss: person, person, light skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FB 200D 2764 200D 1F48B 200D 1F9D1 1F3FC","char":"🧑🏻‍❤‍💋‍🧑🏼","name":"kiss: person, person, light skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FB 200D 2764 FE0F 200D 1F48B 200D 1F9D1 1F3FD","char":"🧑🏻‍❤️‍💋‍🧑🏽","name":"kiss: person, person, light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FB 200D 2764 200D 1F48B 200D 1F9D1 1F3FD","char":"🧑🏻‍❤‍💋‍🧑🏽","name":"kiss: person, person, light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FB 200D 2764 FE0F 200D 1F48B 200D 1F9D1 1F3FE","char":"🧑🏻‍❤️‍💋‍🧑🏾","name":"kiss: person, person, light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FB 200D 2764 200D 1F48B 200D 1F9D1 1F3FE","char":"🧑🏻‍❤‍💋‍🧑🏾","name":"kiss: person, person, light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FB 200D 2764 FE0F 200D 1F48B 200D 1F9D1 1F3FF","char":"🧑🏻‍❤️‍💋‍🧑🏿","name":"kiss: person, person, light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FB 200D 2764 200D 1F48B 200D 1F9D1 1F3FF","char":"🧑🏻‍❤‍💋‍🧑🏿","name":"kiss: person, person, light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FC 200D 2764 FE0F 200D 1F48B 200D 1F9D1 1F3FB","char":"🧑🏼‍❤️‍💋‍🧑🏻","name":"kiss: person, person, medium-light skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FC 200D 2764 200D 1F48B 200D 1F9D1 1F3FB","char":"🧑🏼‍❤‍💋‍🧑🏻","name":"kiss: person, person, medium-light skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FC 200D 2764 FE0F 200D 1F48B 200D 1F9D1 1F3FD","char":"🧑🏼‍❤️‍💋‍🧑🏽","name":"kiss: person, person, medium-light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FC 200D 2764 200D 1F48B 200D 1F9D1 1F3FD","char":"🧑🏼‍❤‍💋‍🧑🏽","name":"kiss: person, person, medium-light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FC 200D 2764 FE0F 200D 1F48B 200D 1F9D1 1F3FE","char":"🧑🏼‍❤️‍💋‍🧑🏾","name":"kiss: person, person, medium-light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FC 200D 2764 200D 1F48B 200D 1F9D1 1F3FE","char":"🧑🏼‍❤‍💋‍🧑🏾","name":"kiss: person, person, medium-light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FC 200D 2764 FE0F 200D 1F48B 200D 1F9D1 1F3FF","char":"🧑🏼‍❤️‍💋‍🧑🏿","name":"kiss: person, person, medium-light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FC 200D 2764 200D 1F48B 200D 1F9D1 1F3FF","char":"🧑🏼‍❤‍💋‍🧑🏿","name":"kiss: person, person, medium-light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FD 200D 2764 FE0F 200D 1F48B 200D 1F9D1 1F3FB","char":"🧑🏽‍❤️‍💋‍🧑🏻","name":"kiss: person, person, medium skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FD 200D 2764 200D 1F48B 200D 1F9D1 1F3FB","char":"🧑🏽‍❤‍💋‍🧑🏻","name":"kiss: person, person, medium skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FD 200D 2764 FE0F 200D 1F48B 200D 1F9D1 1F3FC","char":"🧑🏽‍❤️‍💋‍🧑🏼","name":"kiss: person, person, medium skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FD 200D 2764 200D 1F48B 200D 1F9D1 1F3FC","char":"🧑🏽‍❤‍💋‍🧑🏼","name":"kiss: person, person, medium skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FD 200D 2764 FE0F 200D 1F48B 200D 1F9D1 1F3FE","char":"🧑🏽‍❤️‍💋‍🧑🏾","name":"kiss: person, person, medium skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FD 200D 2764 200D 1F48B 200D 1F9D1 1F3FE","char":"🧑🏽‍❤‍💋‍🧑🏾","name":"kiss: person, person, medium skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FD 200D 2764 FE0F 200D 1F48B 200D 1F9D1 1F3FF","char":"🧑🏽‍❤️‍💋‍🧑🏿","name":"kiss: person, person, medium skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FD 200D 2764 200D 1F48B 200D 1F9D1 1F3FF","char":"🧑🏽‍❤‍💋‍🧑🏿","name":"kiss: person, person, medium skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FE 200D 2764 FE0F 200D 1F48B 200D 1F9D1 1F3FB","char":"🧑🏾‍❤️‍💋‍🧑🏻","name":"kiss: person, person, medium-dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FE 200D 2764 200D 1F48B 200D 1F9D1 1F3FB","char":"🧑🏾‍❤‍💋‍🧑🏻","name":"kiss: person, person, medium-dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FE 200D 2764 FE0F 200D 1F48B 200D 1F9D1 1F3FC","char":"🧑🏾‍❤️‍💋‍🧑🏼","name":"kiss: person, person, medium-dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FE 200D 2764 200D 1F48B 200D 1F9D1 1F3FC","char":"🧑🏾‍❤‍💋‍🧑🏼","name":"kiss: person, person, medium-dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FE 200D 2764 FE0F 200D 1F48B 200D 1F9D1 1F3FD","char":"🧑🏾‍❤️‍💋‍🧑🏽","name":"kiss: person, person, medium-dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FE 200D 2764 200D 1F48B 200D 1F9D1 1F3FD","char":"🧑🏾‍❤‍💋‍🧑🏽","name":"kiss: person, person, medium-dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FE 200D 2764 FE0F 200D 1F48B 200D 1F9D1 1F3FF","char":"🧑🏾‍❤️‍💋‍🧑🏿","name":"kiss: person, person, medium-dark skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FE 200D 2764 200D 1F48B 200D 1F9D1 1F3FF","char":"🧑🏾‍❤‍💋‍🧑🏿","name":"kiss: person, person, medium-dark skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FF 200D 2764 FE0F 200D 1F48B 200D 1F9D1 1F3FB","char":"🧑🏿‍❤️‍💋‍🧑🏻","name":"kiss: person, person, dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FF 200D 2764 200D 1F48B 200D 1F9D1 1F3FB","char":"🧑🏿‍❤‍💋‍🧑🏻","name":"kiss: person, person, dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FF 200D 2764 FE0F 200D 1F48B 200D 1F9D1 1F3FC","char":"🧑🏿‍❤️‍💋‍🧑🏼","name":"kiss: person, person, dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FF 200D 2764 200D 1F48B 200D 1F9D1 1F3FC","char":"🧑🏿‍❤‍💋‍🧑🏼","name":"kiss: person, person, dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FF 200D 2764 FE0F 200D 1F48B 200D 1F9D1 1F3FD","char":"🧑🏿‍❤️‍💋‍🧑🏽","name":"kiss: person, person, dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FF 200D 2764 200D 1F48B 200D 1F9D1 1F3FD","char":"🧑🏿‍❤‍💋‍🧑🏽","name":"kiss: person, person, dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FF 200D 2764 FE0F 200D 1F48B 200D 1F9D1 1F3FE","char":"🧑🏿‍❤️‍💋‍🧑🏾","name":"kiss: person, person, dark skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FF 200D 2764 200D 1F48B 200D 1F9D1 1F3FE","char":"🧑🏿‍❤‍💋‍🧑🏾","name":"kiss: person, person, dark skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 200D 2764 FE0F 200D 1F48B 200D 1F468","char":"👩‍❤️‍💋‍👨","name":"kiss: woman, man","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 200D 2764 200D 1F48B 200D 1F468","char":"👩‍❤‍💋‍👨","name":"kiss: woman, man","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FB","char":"👩🏻‍❤️‍💋‍👨🏻","name":"kiss: woman, man, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 200D 1F48B 200D 1F468 1F3FB","char":"👩🏻‍❤‍💋‍👨🏻","name":"kiss: woman, man, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FC","char":"👩🏻‍❤️‍💋‍👨🏼","name":"kiss: woman, man, light skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 200D 1F48B 200D 1F468 1F3FC","char":"👩🏻‍❤‍💋‍👨🏼","name":"kiss: woman, man, light skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FD","char":"👩🏻‍❤️‍💋‍👨🏽","name":"kiss: woman, man, light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 200D 1F48B 200D 1F468 1F3FD","char":"👩🏻‍❤‍💋‍👨🏽","name":"kiss: woman, man, light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FE","char":"👩🏻‍❤️‍💋‍👨🏾","name":"kiss: woman, man, light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 200D 1F48B 200D 1F468 1F3FE","char":"👩🏻‍❤‍💋‍👨🏾","name":"kiss: woman, man, light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FF","char":"👩🏻‍❤️‍💋‍👨🏿","name":"kiss: woman, man, light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 200D 1F48B 200D 1F468 1F3FF","char":"👩🏻‍❤‍💋‍👨🏿","name":"kiss: woman, man, light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FB","char":"👩🏼‍❤️‍💋‍👨🏻","name":"kiss: woman, man, medium-light skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 200D 1F48B 200D 1F468 1F3FB","char":"👩🏼‍❤‍💋‍👨🏻","name":"kiss: woman, man, medium-light skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FC","char":"👩🏼‍❤️‍💋‍👨🏼","name":"kiss: woman, man, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 200D 1F48B 200D 1F468 1F3FC","char":"👩🏼‍❤‍💋‍👨🏼","name":"kiss: woman, man, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FD","char":"👩🏼‍❤️‍💋‍👨🏽","name":"kiss: woman, man, medium-light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 200D 1F48B 200D 1F468 1F3FD","char":"👩🏼‍❤‍💋‍👨🏽","name":"kiss: woman, man, medium-light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FE","char":"👩🏼‍❤️‍💋‍👨🏾","name":"kiss: woman, man, medium-light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 200D 1F48B 200D 1F468 1F3FE","char":"👩🏼‍❤‍💋‍👨🏾","name":"kiss: woman, man, medium-light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FF","char":"👩🏼‍❤️‍💋‍👨🏿","name":"kiss: woman, man, medium-light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 200D 1F48B 200D 1F468 1F3FF","char":"👩🏼‍❤‍💋‍👨🏿","name":"kiss: woman, man, medium-light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FB","char":"👩🏽‍❤️‍💋‍👨🏻","name":"kiss: woman, man, medium skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 200D 1F48B 200D 1F468 1F3FB","char":"👩🏽‍❤‍💋‍👨🏻","name":"kiss: woman, man, medium skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FC","char":"👩🏽‍❤️‍💋‍👨🏼","name":"kiss: woman, man, medium skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 200D 1F48B 200D 1F468 1F3FC","char":"👩🏽‍❤‍💋‍👨🏼","name":"kiss: woman, man, medium skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FD","char":"👩🏽‍❤️‍💋‍👨🏽","name":"kiss: woman, man, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 200D 1F48B 200D 1F468 1F3FD","char":"👩🏽‍❤‍💋‍👨🏽","name":"kiss: woman, man, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FE","char":"👩🏽‍❤️‍💋‍👨🏾","name":"kiss: woman, man, medium skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 200D 1F48B 200D 1F468 1F3FE","char":"👩🏽‍❤‍💋‍👨🏾","name":"kiss: woman, man, medium skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FF","char":"👩🏽‍❤️‍💋‍👨🏿","name":"kiss: woman, man, medium skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 200D 1F48B 200D 1F468 1F3FF","char":"👩🏽‍❤‍💋‍👨🏿","name":"kiss: woman, man, medium skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FB","char":"👩🏾‍❤️‍💋‍👨🏻","name":"kiss: woman, man, medium-dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 200D 1F48B 200D 1F468 1F3FB","char":"👩🏾‍❤‍💋‍👨🏻","name":"kiss: woman, man, medium-dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FC","char":"👩🏾‍❤️‍💋‍👨🏼","name":"kiss: woman, man, medium-dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 200D 1F48B 200D 1F468 1F3FC","char":"👩🏾‍❤‍💋‍👨🏼","name":"kiss: woman, man, medium-dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FD","char":"👩🏾‍❤️‍💋‍👨🏽","name":"kiss: woman, man, medium-dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 200D 1F48B 200D 1F468 1F3FD","char":"👩🏾‍❤‍💋‍👨🏽","name":"kiss: woman, man, medium-dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FE","char":"👩🏾‍❤️‍💋‍👨🏾","name":"kiss: woman, man, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 200D 1F48B 200D 1F468 1F3FE","char":"👩🏾‍❤‍💋‍👨🏾","name":"kiss: woman, man, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FF","char":"👩🏾‍❤️‍💋‍👨🏿","name":"kiss: woman, man, medium-dark skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 200D 1F48B 200D 1F468 1F3FF","char":"👩🏾‍❤‍💋‍👨🏿","name":"kiss: woman, man, medium-dark skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FB","char":"👩🏿‍❤️‍💋‍👨🏻","name":"kiss: woman, man, dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 200D 1F48B 200D 1F468 1F3FB","char":"👩🏿‍❤‍💋‍👨🏻","name":"kiss: woman, man, dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FC","char":"👩🏿‍❤️‍💋‍👨🏼","name":"kiss: woman, man, dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 200D 1F48B 200D 1F468 1F3FC","char":"👩🏿‍❤‍💋‍👨🏼","name":"kiss: woman, man, dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FD","char":"👩🏿‍❤️‍💋‍👨🏽","name":"kiss: woman, man, dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 200D 1F48B 200D 1F468 1F3FD","char":"👩🏿‍❤‍💋‍👨🏽","name":"kiss: woman, man, dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FE","char":"👩🏿‍❤️‍💋‍👨🏾","name":"kiss: woman, man, dark skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 200D 1F48B 200D 1F468 1F3FE","char":"👩🏿‍❤‍💋‍👨🏾","name":"kiss: woman, man, dark skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FF","char":"👩🏿‍❤️‍💋‍👨🏿","name":"kiss: woman, man, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 200D 1F48B 200D 1F468 1F3FF","char":"👩🏿‍❤‍💋‍👨🏿","name":"kiss: woman, man, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 200D 2764 FE0F 200D 1F48B 200D 1F468","char":"👨‍❤️‍💋‍👨","name":"kiss: man, man","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 200D 2764 200D 1F48B 200D 1F468","char":"👨‍❤‍💋‍👨","name":"kiss: man, man","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FB 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FB","char":"👨🏻‍❤️‍💋‍👨🏻","name":"kiss: man, man, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FB 200D 2764 200D 1F48B 200D 1F468 1F3FB","char":"👨🏻‍❤‍💋‍👨🏻","name":"kiss: man, man, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FB 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FC","char":"👨🏻‍❤️‍💋‍👨🏼","name":"kiss: man, man, light skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FB 200D 2764 200D 1F48B 200D 1F468 1F3FC","char":"👨🏻‍❤‍💋‍👨🏼","name":"kiss: man, man, light skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FB 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FD","char":"👨🏻‍❤️‍💋‍👨🏽","name":"kiss: man, man, light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FB 200D 2764 200D 1F48B 200D 1F468 1F3FD","char":"👨🏻‍❤‍💋‍👨🏽","name":"kiss: man, man, light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FB 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FE","char":"👨🏻‍❤️‍💋‍👨🏾","name":"kiss: man, man, light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FB 200D 2764 200D 1F48B 200D 1F468 1F3FE","char":"👨🏻‍❤‍💋‍👨🏾","name":"kiss: man, man, light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FB 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FF","char":"👨🏻‍❤️‍💋‍👨🏿","name":"kiss: man, man, light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FB 200D 2764 200D 1F48B 200D 1F468 1F3FF","char":"👨🏻‍❤‍💋‍👨🏿","name":"kiss: man, man, light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FC 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FB","char":"👨🏼‍❤️‍💋‍👨🏻","name":"kiss: man, man, medium-light skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FC 200D 2764 200D 1F48B 200D 1F468 1F3FB","char":"👨🏼‍❤‍💋‍👨🏻","name":"kiss: man, man, medium-light skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FC 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FC","char":"👨🏼‍❤️‍💋‍👨🏼","name":"kiss: man, man, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FC 200D 2764 200D 1F48B 200D 1F468 1F3FC","char":"👨🏼‍❤‍💋‍👨🏼","name":"kiss: man, man, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FC 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FD","char":"👨🏼‍❤️‍💋‍👨🏽","name":"kiss: man, man, medium-light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FC 200D 2764 200D 1F48B 200D 1F468 1F3FD","char":"👨🏼‍❤‍💋‍👨🏽","name":"kiss: man, man, medium-light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FC 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FE","char":"👨🏼‍❤️‍💋‍👨🏾","name":"kiss: man, man, medium-light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FC 200D 2764 200D 1F48B 200D 1F468 1F3FE","char":"👨🏼‍❤‍💋‍👨🏾","name":"kiss: man, man, medium-light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FC 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FF","char":"👨🏼‍❤️‍💋‍👨🏿","name":"kiss: man, man, medium-light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FC 200D 2764 200D 1F48B 200D 1F468 1F3FF","char":"👨🏼‍❤‍💋‍👨🏿","name":"kiss: man, man, medium-light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FD 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FB","char":"👨🏽‍❤️‍💋‍👨🏻","name":"kiss: man, man, medium skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FD 200D 2764 200D 1F48B 200D 1F468 1F3FB","char":"👨🏽‍❤‍💋‍👨🏻","name":"kiss: man, man, medium skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FD 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FC","char":"👨🏽‍❤️‍💋‍👨🏼","name":"kiss: man, man, medium skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FD 200D 2764 200D 1F48B 200D 1F468 1F3FC","char":"👨🏽‍❤‍💋‍👨🏼","name":"kiss: man, man, medium skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FD 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FD","char":"👨🏽‍❤️‍💋‍👨🏽","name":"kiss: man, man, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FD 200D 2764 200D 1F48B 200D 1F468 1F3FD","char":"👨🏽‍❤‍💋‍👨🏽","name":"kiss: man, man, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FD 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FE","char":"👨🏽‍❤️‍💋‍👨🏾","name":"kiss: man, man, medium skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FD 200D 2764 200D 1F48B 200D 1F468 1F3FE","char":"👨🏽‍❤‍💋‍👨🏾","name":"kiss: man, man, medium skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FD 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FF","char":"👨🏽‍❤️‍💋‍👨🏿","name":"kiss: man, man, medium skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FD 200D 2764 200D 1F48B 200D 1F468 1F3FF","char":"👨🏽‍❤‍💋‍👨🏿","name":"kiss: man, man, medium skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FE 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FB","char":"👨🏾‍❤️‍💋‍👨🏻","name":"kiss: man, man, medium-dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FE 200D 2764 200D 1F48B 200D 1F468 1F3FB","char":"👨🏾‍❤‍💋‍👨🏻","name":"kiss: man, man, medium-dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FE 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FC","char":"👨🏾‍❤️‍💋‍👨🏼","name":"kiss: man, man, medium-dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FE 200D 2764 200D 1F48B 200D 1F468 1F3FC","char":"👨🏾‍❤‍💋‍👨🏼","name":"kiss: man, man, medium-dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FE 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FD","char":"👨🏾‍❤️‍💋‍👨🏽","name":"kiss: man, man, medium-dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FE 200D 2764 200D 1F48B 200D 1F468 1F3FD","char":"👨🏾‍❤‍💋‍👨🏽","name":"kiss: man, man, medium-dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FE 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FE","char":"👨🏾‍❤️‍💋‍👨🏾","name":"kiss: man, man, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FE 200D 2764 200D 1F48B 200D 1F468 1F3FE","char":"👨🏾‍❤‍💋‍👨🏾","name":"kiss: man, man, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FE 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FF","char":"👨🏾‍❤️‍💋‍👨🏿","name":"kiss: man, man, medium-dark skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FE 200D 2764 200D 1F48B 200D 1F468 1F3FF","char":"👨🏾‍❤‍💋‍👨🏿","name":"kiss: man, man, medium-dark skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FF 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FB","char":"👨🏿‍❤️‍💋‍👨🏻","name":"kiss: man, man, dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FF 200D 2764 200D 1F48B 200D 1F468 1F3FB","char":"👨🏿‍❤‍💋‍👨🏻","name":"kiss: man, man, dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FF 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FC","char":"👨🏿‍❤️‍💋‍👨🏼","name":"kiss: man, man, dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FF 200D 2764 200D 1F48B 200D 1F468 1F3FC","char":"👨🏿‍❤‍💋‍👨🏼","name":"kiss: man, man, dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FF 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FD","char":"👨🏿‍❤️‍💋‍👨🏽","name":"kiss: man, man, dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FF 200D 2764 200D 1F48B 200D 1F468 1F3FD","char":"👨🏿‍❤‍💋‍👨🏽","name":"kiss: man, man, dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FF 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FE","char":"👨🏿‍❤️‍💋‍👨🏾","name":"kiss: man, man, dark skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FF 200D 2764 200D 1F48B 200D 1F468 1F3FE","char":"👨🏿‍❤‍💋‍👨🏾","name":"kiss: man, man, dark skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FF 200D 2764 FE0F 200D 1F48B 200D 1F468 1F3FF","char":"👨🏿‍❤️‍💋‍👨🏿","name":"kiss: man, man, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FF 200D 2764 200D 1F48B 200D 1F468 1F3FF","char":"👨🏿‍❤‍💋‍👨🏿","name":"kiss: man, man, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 200D 2764 FE0F 200D 1F48B 200D 1F469","char":"👩‍❤️‍💋‍👩","name":"kiss: woman, woman","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 200D 2764 200D 1F48B 200D 1F469","char":"👩‍❤‍💋‍👩","name":"kiss: woman, woman","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 FE0F 200D 1F48B 200D 1F469 1F3FB","char":"👩🏻‍❤️‍💋‍👩🏻","name":"kiss: woman, woman, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 200D 1F48B 200D 1F469 1F3FB","char":"👩🏻‍❤‍💋‍👩🏻","name":"kiss: woman, woman, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 FE0F 200D 1F48B 200D 1F469 1F3FC","char":"👩🏻‍❤️‍💋‍👩🏼","name":"kiss: woman, woman, light skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 200D 1F48B 200D 1F469 1F3FC","char":"👩🏻‍❤‍💋‍👩🏼","name":"kiss: woman, woman, light skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 FE0F 200D 1F48B 200D 1F469 1F3FD","char":"👩🏻‍❤️‍💋‍👩🏽","name":"kiss: woman, woman, light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 200D 1F48B 200D 1F469 1F3FD","char":"👩🏻‍❤‍💋‍👩🏽","name":"kiss: woman, woman, light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 FE0F 200D 1F48B 200D 1F469 1F3FE","char":"👩🏻‍❤️‍💋‍👩🏾","name":"kiss: woman, woman, light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 200D 1F48B 200D 1F469 1F3FE","char":"👩🏻‍❤‍💋‍👩🏾","name":"kiss: woman, woman, light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 FE0F 200D 1F48B 200D 1F469 1F3FF","char":"👩🏻‍❤️‍💋‍👩🏿","name":"kiss: woman, woman, light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 200D 1F48B 200D 1F469 1F3FF","char":"👩🏻‍❤‍💋‍👩🏿","name":"kiss: woman, woman, light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 FE0F 200D 1F48B 200D 1F469 1F3FB","char":"👩🏼‍❤️‍💋‍👩🏻","name":"kiss: woman, woman, medium-light skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 200D 1F48B 200D 1F469 1F3FB","char":"👩🏼‍❤‍💋‍👩🏻","name":"kiss: woman, woman, medium-light skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 FE0F 200D 1F48B 200D 1F469 1F3FC","char":"👩🏼‍❤️‍💋‍👩🏼","name":"kiss: woman, woman, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 200D 1F48B 200D 1F469 1F3FC","char":"👩🏼‍❤‍💋‍👩🏼","name":"kiss: woman, woman, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 FE0F 200D 1F48B 200D 1F469 1F3FD","char":"👩🏼‍❤️‍💋‍👩🏽","name":"kiss: woman, woman, medium-light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 200D 1F48B 200D 1F469 1F3FD","char":"👩🏼‍❤‍💋‍👩🏽","name":"kiss: woman, woman, medium-light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 FE0F 200D 1F48B 200D 1F469 1F3FE","char":"👩🏼‍❤️‍💋‍👩🏾","name":"kiss: woman, woman, medium-light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 200D 1F48B 200D 1F469 1F3FE","char":"👩🏼‍❤‍💋‍👩🏾","name":"kiss: woman, woman, medium-light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 FE0F 200D 1F48B 200D 1F469 1F3FF","char":"👩🏼‍❤️‍💋‍👩🏿","name":"kiss: woman, woman, medium-light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 200D 1F48B 200D 1F469 1F3FF","char":"👩🏼‍❤‍💋‍👩🏿","name":"kiss: woman, woman, medium-light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 FE0F 200D 1F48B 200D 1F469 1F3FB","char":"👩🏽‍❤️‍💋‍👩🏻","name":"kiss: woman, woman, medium skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 200D 1F48B 200D 1F469 1F3FB","char":"👩🏽‍❤‍💋‍👩🏻","name":"kiss: woman, woman, medium skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 FE0F 200D 1F48B 200D 1F469 1F3FC","char":"👩🏽‍❤️‍💋‍👩🏼","name":"kiss: woman, woman, medium skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 200D 1F48B 200D 1F469 1F3FC","char":"👩🏽‍❤‍💋‍👩🏼","name":"kiss: woman, woman, medium skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 FE0F 200D 1F48B 200D 1F469 1F3FD","char":"👩🏽‍❤️‍💋‍👩🏽","name":"kiss: woman, woman, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 200D 1F48B 200D 1F469 1F3FD","char":"👩🏽‍❤‍💋‍👩🏽","name":"kiss: woman, woman, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 FE0F 200D 1F48B 200D 1F469 1F3FE","char":"👩🏽‍❤️‍💋‍👩🏾","name":"kiss: woman, woman, medium skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 200D 1F48B 200D 1F469 1F3FE","char":"👩🏽‍❤‍💋‍👩🏾","name":"kiss: woman, woman, medium skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 FE0F 200D 1F48B 200D 1F469 1F3FF","char":"👩🏽‍❤️‍💋‍👩🏿","name":"kiss: woman, woman, medium skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 200D 1F48B 200D 1F469 1F3FF","char":"👩🏽‍❤‍💋‍👩🏿","name":"kiss: woman, woman, medium skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 FE0F 200D 1F48B 200D 1F469 1F3FB","char":"👩🏾‍❤️‍💋‍👩🏻","name":"kiss: woman, woman, medium-dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 200D 1F48B 200D 1F469 1F3FB","char":"👩🏾‍❤‍💋‍👩🏻","name":"kiss: woman, woman, medium-dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 FE0F 200D 1F48B 200D 1F469 1F3FC","char":"👩🏾‍❤️‍💋‍👩🏼","name":"kiss: woman, woman, medium-dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 200D 1F48B 200D 1F469 1F3FC","char":"👩🏾‍❤‍💋‍👩🏼","name":"kiss: woman, woman, medium-dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 FE0F 200D 1F48B 200D 1F469 1F3FD","char":"👩🏾‍❤️‍💋‍👩🏽","name":"kiss: woman, woman, medium-dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 200D 1F48B 200D 1F469 1F3FD","char":"👩🏾‍❤‍💋‍👩🏽","name":"kiss: woman, woman, medium-dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 FE0F 200D 1F48B 200D 1F469 1F3FE","char":"👩🏾‍❤️‍💋‍👩🏾","name":"kiss: woman, woman, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 200D 1F48B 200D 1F469 1F3FE","char":"👩🏾‍❤‍💋‍👩🏾","name":"kiss: woman, woman, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 FE0F 200D 1F48B 200D 1F469 1F3FF","char":"👩🏾‍❤️‍💋‍👩🏿","name":"kiss: woman, woman, medium-dark skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 200D 1F48B 200D 1F469 1F3FF","char":"👩🏾‍❤‍💋‍👩🏿","name":"kiss: woman, woman, medium-dark skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 FE0F 200D 1F48B 200D 1F469 1F3FB","char":"👩🏿‍❤️‍💋‍👩🏻","name":"kiss: woman, woman, dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 200D 1F48B 200D 1F469 1F3FB","char":"👩🏿‍❤‍💋‍👩🏻","name":"kiss: woman, woman, dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 FE0F 200D 1F48B 200D 1F469 1F3FC","char":"👩🏿‍❤️‍💋‍👩🏼","name":"kiss: woman, woman, dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 200D 1F48B 200D 1F469 1F3FC","char":"👩🏿‍❤‍💋‍👩🏼","name":"kiss: woman, woman, dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 FE0F 200D 1F48B 200D 1F469 1F3FD","char":"👩🏿‍❤️‍💋‍👩🏽","name":"kiss: woman, woman, dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 200D 1F48B 200D 1F469 1F3FD","char":"👩🏿‍❤‍💋‍👩🏽","name":"kiss: woman, woman, dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 FE0F 200D 1F48B 200D 1F469 1F3FE","char":"👩🏿‍❤️‍💋‍👩🏾","name":"kiss: woman, woman, dark skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 200D 1F48B 200D 1F469 1F3FE","char":"👩🏿‍❤‍💋‍👩🏾","name":"kiss: woman, woman, dark skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 FE0F 200D 1F48B 200D 1F469 1F3FF","char":"👩🏿‍❤️‍💋‍👩🏿","name":"kiss: woman, woman, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 200D 1F48B 200D 1F469 1F3FF","char":"👩🏿‍❤‍💋‍👩🏿","name":"kiss: woman, woman, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F491","char":"💑","name":"couple with heart","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F491 1F3FB","char":"💑🏻","name":"couple with heart: light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F491 1F3FC","char":"💑🏼","name":"couple with heart: medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F491 1F3FD","char":"💑🏽","name":"couple with heart: medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F491 1F3FE","char":"💑🏾","name":"couple with heart: medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F491 1F3FF","char":"💑🏿","name":"couple with heart: dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FB 200D 2764 FE0F 200D 1F9D1 1F3FC","char":"🧑🏻‍❤️‍🧑🏼","name":"couple with heart: person, person, light skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FB 200D 2764 200D 1F9D1 1F3FC","char":"🧑🏻‍❤‍🧑🏼","name":"couple with heart: person, person, light skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FB 200D 2764 FE0F 200D 1F9D1 1F3FD","char":"🧑🏻‍❤️‍🧑🏽","name":"couple with heart: person, person, light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FB 200D 2764 200D 1F9D1 1F3FD","char":"🧑🏻‍❤‍🧑🏽","name":"couple with heart: person, person, light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FB 200D 2764 FE0F 200D 1F9D1 1F3FE","char":"🧑🏻‍❤️‍🧑🏾","name":"couple with heart: person, person, light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FB 200D 2764 200D 1F9D1 1F3FE","char":"🧑🏻‍❤‍🧑🏾","name":"couple with heart: person, person, light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FB 200D 2764 FE0F 200D 1F9D1 1F3FF","char":"🧑🏻‍❤️‍🧑🏿","name":"couple with heart: person, person, light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FB 200D 2764 200D 1F9D1 1F3FF","char":"🧑🏻‍❤‍🧑🏿","name":"couple with heart: person, person, light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FC 200D 2764 FE0F 200D 1F9D1 1F3FB","char":"🧑🏼‍❤️‍🧑🏻","name":"couple with heart: person, person, medium-light skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FC 200D 2764 200D 1F9D1 1F3FB","char":"🧑🏼‍❤‍🧑🏻","name":"couple with heart: person, person, medium-light skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FC 200D 2764 FE0F 200D 1F9D1 1F3FD","char":"🧑🏼‍❤️‍🧑🏽","name":"couple with heart: person, person, medium-light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FC 200D 2764 200D 1F9D1 1F3FD","char":"🧑🏼‍❤‍🧑🏽","name":"couple with heart: person, person, medium-light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FC 200D 2764 FE0F 200D 1F9D1 1F3FE","char":"🧑🏼‍❤️‍🧑🏾","name":"couple with heart: person, person, medium-light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FC 200D 2764 200D 1F9D1 1F3FE","char":"🧑🏼‍❤‍🧑🏾","name":"couple with heart: person, person, medium-light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FC 200D 2764 FE0F 200D 1F9D1 1F3FF","char":"🧑🏼‍❤️‍🧑🏿","name":"couple with heart: person, person, medium-light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FC 200D 2764 200D 1F9D1 1F3FF","char":"🧑🏼‍❤‍🧑🏿","name":"couple with heart: person, person, medium-light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FD 200D 2764 FE0F 200D 1F9D1 1F3FB","char":"🧑🏽‍❤️‍🧑🏻","name":"couple with heart: person, person, medium skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FD 200D 2764 200D 1F9D1 1F3FB","char":"🧑🏽‍❤‍🧑🏻","name":"couple with heart: person, person, medium skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FD 200D 2764 FE0F 200D 1F9D1 1F3FC","char":"🧑🏽‍❤️‍🧑🏼","name":"couple with heart: person, person, medium skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FD 200D 2764 200D 1F9D1 1F3FC","char":"🧑🏽‍❤‍🧑🏼","name":"couple with heart: person, person, medium skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FD 200D 2764 FE0F 200D 1F9D1 1F3FE","char":"🧑🏽‍❤️‍🧑🏾","name":"couple with heart: person, person, medium skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FD 200D 2764 200D 1F9D1 1F3FE","char":"🧑🏽‍❤‍🧑🏾","name":"couple with heart: person, person, medium skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FD 200D 2764 FE0F 200D 1F9D1 1F3FF","char":"🧑🏽‍❤️‍🧑🏿","name":"couple with heart: person, person, medium skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FD 200D 2764 200D 1F9D1 1F3FF","char":"🧑🏽‍❤‍🧑🏿","name":"couple with heart: person, person, medium skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FE 200D 2764 FE0F 200D 1F9D1 1F3FB","char":"🧑🏾‍❤️‍🧑🏻","name":"couple with heart: person, person, medium-dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FE 200D 2764 200D 1F9D1 1F3FB","char":"🧑🏾‍❤‍🧑🏻","name":"couple with heart: person, person, medium-dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FE 200D 2764 FE0F 200D 1F9D1 1F3FC","char":"🧑🏾‍❤️‍🧑🏼","name":"couple with heart: person, person, medium-dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FE 200D 2764 200D 1F9D1 1F3FC","char":"🧑🏾‍❤‍🧑🏼","name":"couple with heart: person, person, medium-dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FE 200D 2764 FE0F 200D 1F9D1 1F3FD","char":"🧑🏾‍❤️‍🧑🏽","name":"couple with heart: person, person, medium-dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FE 200D 2764 200D 1F9D1 1F3FD","char":"🧑🏾‍❤‍🧑🏽","name":"couple with heart: person, person, medium-dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FE 200D 2764 FE0F 200D 1F9D1 1F3FF","char":"🧑🏾‍❤️‍🧑🏿","name":"couple with heart: person, person, medium-dark skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FE 200D 2764 200D 1F9D1 1F3FF","char":"🧑🏾‍❤‍🧑🏿","name":"couple with heart: person, person, medium-dark skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FF 200D 2764 FE0F 200D 1F9D1 1F3FB","char":"🧑🏿‍❤️‍🧑🏻","name":"couple with heart: person, person, dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FF 200D 2764 200D 1F9D1 1F3FB","char":"🧑🏿‍❤‍🧑🏻","name":"couple with heart: person, person, dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FF 200D 2764 FE0F 200D 1F9D1 1F3FC","char":"🧑🏿‍❤️‍🧑🏼","name":"couple with heart: person, person, dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FF 200D 2764 200D 1F9D1 1F3FC","char":"🧑🏿‍❤‍🧑🏼","name":"couple with heart: person, person, dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FF 200D 2764 FE0F 200D 1F9D1 1F3FD","char":"🧑🏿‍❤️‍🧑🏽","name":"couple with heart: person, person, dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FF 200D 2764 200D 1F9D1 1F3FD","char":"🧑🏿‍❤‍🧑🏽","name":"couple with heart: person, person, dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FF 200D 2764 FE0F 200D 1F9D1 1F3FE","char":"🧑🏿‍❤️‍🧑🏾","name":"couple with heart: person, person, dark skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F9D1 1F3FF 200D 2764 200D 1F9D1 1F3FE","char":"🧑🏿‍❤‍🧑🏾","name":"couple with heart: person, person, dark skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 200D 2764 FE0F 200D 1F468","char":"👩‍❤️‍👨","name":"couple with heart: woman, man","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 200D 2764 200D 1F468","char":"👩‍❤‍👨","name":"couple with heart: woman, man","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 FE0F 200D 1F468 1F3FB","char":"👩🏻‍❤️‍👨🏻","name":"couple with heart: woman, man, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 200D 1F468 1F3FB","char":"👩🏻‍❤‍👨🏻","name":"couple with heart: woman, man, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 FE0F 200D 1F468 1F3FC","char":"👩🏻‍❤️‍👨🏼","name":"couple with heart: woman, man, light skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 200D 1F468 1F3FC","char":"👩🏻‍❤‍👨🏼","name":"couple with heart: woman, man, light skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 FE0F 200D 1F468 1F3FD","char":"👩🏻‍❤️‍👨🏽","name":"couple with heart: woman, man, light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 200D 1F468 1F3FD","char":"👩🏻‍❤‍👨🏽","name":"couple with heart: woman, man, light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 FE0F 200D 1F468 1F3FE","char":"👩🏻‍❤️‍👨🏾","name":"couple with heart: woman, man, light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 200D 1F468 1F3FE","char":"👩🏻‍❤‍👨🏾","name":"couple with heart: woman, man, light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 FE0F 200D 1F468 1F3FF","char":"👩🏻‍❤️‍👨🏿","name":"couple with heart: woman, man, light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 200D 1F468 1F3FF","char":"👩🏻‍❤‍👨🏿","name":"couple with heart: woman, man, light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 FE0F 200D 1F468 1F3FB","char":"👩🏼‍❤️‍👨🏻","name":"couple with heart: woman, man, medium-light skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 200D 1F468 1F3FB","char":"👩🏼‍❤‍👨🏻","name":"couple with heart: woman, man, medium-light skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 FE0F 200D 1F468 1F3FC","char":"👩🏼‍❤️‍👨🏼","name":"couple with heart: woman, man, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 200D 1F468 1F3FC","char":"👩🏼‍❤‍👨🏼","name":"couple with heart: woman, man, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 FE0F 200D 1F468 1F3FD","char":"👩🏼‍❤️‍👨🏽","name":"couple with heart: woman, man, medium-light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 200D 1F468 1F3FD","char":"👩🏼‍❤‍👨🏽","name":"couple with heart: woman, man, medium-light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 FE0F 200D 1F468 1F3FE","char":"👩🏼‍❤️‍👨🏾","name":"couple with heart: woman, man, medium-light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 200D 1F468 1F3FE","char":"👩🏼‍❤‍👨🏾","name":"couple with heart: woman, man, medium-light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 FE0F 200D 1F468 1F3FF","char":"👩🏼‍❤️‍👨🏿","name":"couple with heart: woman, man, medium-light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 200D 1F468 1F3FF","char":"👩🏼‍❤‍👨🏿","name":"couple with heart: woman, man, medium-light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 FE0F 200D 1F468 1F3FB","char":"👩🏽‍❤️‍👨🏻","name":"couple with heart: woman, man, medium skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 200D 1F468 1F3FB","char":"👩🏽‍❤‍👨🏻","name":"couple with heart: woman, man, medium skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 FE0F 200D 1F468 1F3FC","char":"👩🏽‍❤️‍👨🏼","name":"couple with heart: woman, man, medium skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 200D 1F468 1F3FC","char":"👩🏽‍❤‍👨🏼","name":"couple with heart: woman, man, medium skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 FE0F 200D 1F468 1F3FD","char":"👩🏽‍❤️‍👨🏽","name":"couple with heart: woman, man, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 200D 1F468 1F3FD","char":"👩🏽‍❤‍👨🏽","name":"couple with heart: woman, man, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 FE0F 200D 1F468 1F3FE","char":"👩🏽‍❤️‍👨🏾","name":"couple with heart: woman, man, medium skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 200D 1F468 1F3FE","char":"👩🏽‍❤‍👨🏾","name":"couple with heart: woman, man, medium skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 FE0F 200D 1F468 1F3FF","char":"👩🏽‍❤️‍👨🏿","name":"couple with heart: woman, man, medium skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 200D 1F468 1F3FF","char":"👩🏽‍❤‍👨🏿","name":"couple with heart: woman, man, medium skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 FE0F 200D 1F468 1F3FB","char":"👩🏾‍❤️‍👨🏻","name":"couple with heart: woman, man, medium-dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 200D 1F468 1F3FB","char":"👩🏾‍❤‍👨🏻","name":"couple with heart: woman, man, medium-dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 FE0F 200D 1F468 1F3FC","char":"👩🏾‍❤️‍👨🏼","name":"couple with heart: woman, man, medium-dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 200D 1F468 1F3FC","char":"👩🏾‍❤‍👨🏼","name":"couple with heart: woman, man, medium-dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 FE0F 200D 1F468 1F3FD","char":"👩🏾‍❤️‍👨🏽","name":"couple with heart: woman, man, medium-dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 200D 1F468 1F3FD","char":"👩🏾‍❤‍👨🏽","name":"couple with heart: woman, man, medium-dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 FE0F 200D 1F468 1F3FE","char":"👩🏾‍❤️‍👨🏾","name":"couple with heart: woman, man, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 200D 1F468 1F3FE","char":"👩🏾‍❤‍👨🏾","name":"couple with heart: woman, man, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 FE0F 200D 1F468 1F3FF","char":"👩🏾‍❤️‍👨🏿","name":"couple with heart: woman, man, medium-dark skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 200D 1F468 1F3FF","char":"👩🏾‍❤‍👨🏿","name":"couple with heart: woman, man, medium-dark skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 FE0F 200D 1F468 1F3FB","char":"👩🏿‍❤️‍👨🏻","name":"couple with heart: woman, man, dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 200D 1F468 1F3FB","char":"👩🏿‍❤‍👨🏻","name":"couple with heart: woman, man, dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 FE0F 200D 1F468 1F3FC","char":"👩🏿‍❤️‍👨🏼","name":"couple with heart: woman, man, dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 200D 1F468 1F3FC","char":"👩🏿‍❤‍👨🏼","name":"couple with heart: woman, man, dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 FE0F 200D 1F468 1F3FD","char":"👩🏿‍❤️‍👨🏽","name":"couple with heart: woman, man, dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 200D 1F468 1F3FD","char":"👩🏿‍❤‍👨🏽","name":"couple with heart: woman, man, dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 FE0F 200D 1F468 1F3FE","char":"👩🏿‍❤️‍👨🏾","name":"couple with heart: woman, man, dark skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 200D 1F468 1F3FE","char":"👩🏿‍❤‍👨🏾","name":"couple with heart: woman, man, dark skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 FE0F 200D 1F468 1F3FF","char":"👩🏿‍❤️‍👨🏿","name":"couple with heart: woman, man, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 200D 1F468 1F3FF","char":"👩🏿‍❤‍👨🏿","name":"couple with heart: woman, man, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 200D 2764 FE0F 200D 1F468","char":"👨‍❤️‍👨","name":"couple with heart: man, man","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 200D 2764 200D 1F468","char":"👨‍❤‍👨","name":"couple with heart: man, man","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FB 200D 2764 FE0F 200D 1F468 1F3FB","char":"👨🏻‍❤️‍👨🏻","name":"couple with heart: man, man, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FB 200D 2764 200D 1F468 1F3FB","char":"👨🏻‍❤‍👨🏻","name":"couple with heart: man, man, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FB 200D 2764 FE0F 200D 1F468 1F3FC","char":"👨🏻‍❤️‍👨🏼","name":"couple with heart: man, man, light skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FB 200D 2764 200D 1F468 1F3FC","char":"👨🏻‍❤‍👨🏼","name":"couple with heart: man, man, light skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FB 200D 2764 FE0F 200D 1F468 1F3FD","char":"👨🏻‍❤️‍👨🏽","name":"couple with heart: man, man, light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FB 200D 2764 200D 1F468 1F3FD","char":"👨🏻‍❤‍👨🏽","name":"couple with heart: man, man, light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FB 200D 2764 FE0F 200D 1F468 1F3FE","char":"👨🏻‍❤️‍👨🏾","name":"couple with heart: man, man, light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FB 200D 2764 200D 1F468 1F3FE","char":"👨🏻‍❤‍👨🏾","name":"couple with heart: man, man, light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FB 200D 2764 FE0F 200D 1F468 1F3FF","char":"👨🏻‍❤️‍👨🏿","name":"couple with heart: man, man, light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FB 200D 2764 200D 1F468 1F3FF","char":"👨🏻‍❤‍👨🏿","name":"couple with heart: man, man, light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FC 200D 2764 FE0F 200D 1F468 1F3FB","char":"👨🏼‍❤️‍👨🏻","name":"couple with heart: man, man, medium-light skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FC 200D 2764 200D 1F468 1F3FB","char":"👨🏼‍❤‍👨🏻","name":"couple with heart: man, man, medium-light skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FC 200D 2764 FE0F 200D 1F468 1F3FC","char":"👨🏼‍❤️‍👨🏼","name":"couple with heart: man, man, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FC 200D 2764 200D 1F468 1F3FC","char":"👨🏼‍❤‍👨🏼","name":"couple with heart: man, man, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FC 200D 2764 FE0F 200D 1F468 1F3FD","char":"👨🏼‍❤️‍👨🏽","name":"couple with heart: man, man, medium-light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FC 200D 2764 200D 1F468 1F3FD","char":"👨🏼‍❤‍👨🏽","name":"couple with heart: man, man, medium-light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FC 200D 2764 FE0F 200D 1F468 1F3FE","char":"👨🏼‍❤️‍👨🏾","name":"couple with heart: man, man, medium-light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FC 200D 2764 200D 1F468 1F3FE","char":"👨🏼‍❤‍👨🏾","name":"couple with heart: man, man, medium-light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FC 200D 2764 FE0F 200D 1F468 1F3FF","char":"👨🏼‍❤️‍👨🏿","name":"couple with heart: man, man, medium-light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FC 200D 2764 200D 1F468 1F3FF","char":"👨🏼‍❤‍👨🏿","name":"couple with heart: man, man, medium-light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FD 200D 2764 FE0F 200D 1F468 1F3FB","char":"👨🏽‍❤️‍👨🏻","name":"couple with heart: man, man, medium skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FD 200D 2764 200D 1F468 1F3FB","char":"👨🏽‍❤‍👨🏻","name":"couple with heart: man, man, medium skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FD 200D 2764 FE0F 200D 1F468 1F3FC","char":"👨🏽‍❤️‍👨🏼","name":"couple with heart: man, man, medium skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FD 200D 2764 200D 1F468 1F3FC","char":"👨🏽‍❤‍👨🏼","name":"couple with heart: man, man, medium skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FD 200D 2764 FE0F 200D 1F468 1F3FD","char":"👨🏽‍❤️‍👨🏽","name":"couple with heart: man, man, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FD 200D 2764 200D 1F468 1F3FD","char":"👨🏽‍❤‍👨🏽","name":"couple with heart: man, man, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FD 200D 2764 FE0F 200D 1F468 1F3FE","char":"👨🏽‍❤️‍👨🏾","name":"couple with heart: man, man, medium skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FD 200D 2764 200D 1F468 1F3FE","char":"👨🏽‍❤‍👨🏾","name":"couple with heart: man, man, medium skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FD 200D 2764 FE0F 200D 1F468 1F3FF","char":"👨🏽‍❤️‍👨🏿","name":"couple with heart: man, man, medium skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FD 200D 2764 200D 1F468 1F3FF","char":"👨🏽‍❤‍👨🏿","name":"couple with heart: man, man, medium skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FE 200D 2764 FE0F 200D 1F468 1F3FB","char":"👨🏾‍❤️‍👨🏻","name":"couple with heart: man, man, medium-dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FE 200D 2764 200D 1F468 1F3FB","char":"👨🏾‍❤‍👨🏻","name":"couple with heart: man, man, medium-dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FE 200D 2764 FE0F 200D 1F468 1F3FC","char":"👨🏾‍❤️‍👨🏼","name":"couple with heart: man, man, medium-dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FE 200D 2764 200D 1F468 1F3FC","char":"👨🏾‍❤‍👨🏼","name":"couple with heart: man, man, medium-dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FE 200D 2764 FE0F 200D 1F468 1F3FD","char":"👨🏾‍❤️‍👨🏽","name":"couple with heart: man, man, medium-dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FE 200D 2764 200D 1F468 1F3FD","char":"👨🏾‍❤‍👨🏽","name":"couple with heart: man, man, medium-dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FE 200D 2764 FE0F 200D 1F468 1F3FE","char":"👨🏾‍❤️‍👨🏾","name":"couple with heart: man, man, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FE 200D 2764 200D 1F468 1F3FE","char":"👨🏾‍❤‍👨🏾","name":"couple with heart: man, man, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FE 200D 2764 FE0F 200D 1F468 1F3FF","char":"👨🏾‍❤️‍👨🏿","name":"couple with heart: man, man, medium-dark skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FE 200D 2764 200D 1F468 1F3FF","char":"👨🏾‍❤‍👨🏿","name":"couple with heart: man, man, medium-dark skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FF 200D 2764 FE0F 200D 1F468 1F3FB","char":"👨🏿‍❤️‍👨🏻","name":"couple with heart: man, man, dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FF 200D 2764 200D 1F468 1F3FB","char":"👨🏿‍❤‍👨🏻","name":"couple with heart: man, man, dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FF 200D 2764 FE0F 200D 1F468 1F3FC","char":"👨🏿‍❤️‍👨🏼","name":"couple with heart: man, man, dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FF 200D 2764 200D 1F468 1F3FC","char":"👨🏿‍❤‍👨🏼","name":"couple with heart: man, man, dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FF 200D 2764 FE0F 200D 1F468 1F3FD","char":"👨🏿‍❤️‍👨🏽","name":"couple with heart: man, man, dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FF 200D 2764 200D 1F468 1F3FD","char":"👨🏿‍❤‍👨🏽","name":"couple with heart: man, man, dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FF 200D 2764 FE0F 200D 1F468 1F3FE","char":"👨🏿‍❤️‍👨🏾","name":"couple with heart: man, man, dark skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FF 200D 2764 200D 1F468 1F3FE","char":"👨🏿‍❤‍👨🏾","name":"couple with heart: man, man, dark skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FF 200D 2764 FE0F 200D 1F468 1F3FF","char":"👨🏿‍❤️‍👨🏿","name":"couple with heart: man, man, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 1F3FF 200D 2764 200D 1F468 1F3FF","char":"👨🏿‍❤‍👨🏿","name":"couple with heart: man, man, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 200D 2764 FE0F 200D 1F469","char":"👩‍❤️‍👩","name":"couple with heart: woman, woman","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 200D 2764 200D 1F469","char":"👩‍❤‍👩","name":"couple with heart: woman, woman","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 FE0F 200D 1F469 1F3FB","char":"👩🏻‍❤️‍👩🏻","name":"couple with heart: woman, woman, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 200D 1F469 1F3FB","char":"👩🏻‍❤‍👩🏻","name":"couple with heart: woman, woman, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 FE0F 200D 1F469 1F3FC","char":"👩🏻‍❤️‍👩🏼","name":"couple with heart: woman, woman, light skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 200D 1F469 1F3FC","char":"👩🏻‍❤‍👩🏼","name":"couple with heart: woman, woman, light skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 FE0F 200D 1F469 1F3FD","char":"👩🏻‍❤️‍👩🏽","name":"couple with heart: woman, woman, light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 200D 1F469 1F3FD","char":"👩🏻‍❤‍👩🏽","name":"couple with heart: woman, woman, light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 FE0F 200D 1F469 1F3FE","char":"👩🏻‍❤️‍👩🏾","name":"couple with heart: woman, woman, light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 200D 1F469 1F3FE","char":"👩🏻‍❤‍👩🏾","name":"couple with heart: woman, woman, light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 FE0F 200D 1F469 1F3FF","char":"👩🏻‍❤️‍👩🏿","name":"couple with heart: woman, woman, light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FB 200D 2764 200D 1F469 1F3FF","char":"👩🏻‍❤‍👩🏿","name":"couple with heart: woman, woman, light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 FE0F 200D 1F469 1F3FB","char":"👩🏼‍❤️‍👩🏻","name":"couple with heart: woman, woman, medium-light skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 200D 1F469 1F3FB","char":"👩🏼‍❤‍👩🏻","name":"couple with heart: woman, woman, medium-light skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 FE0F 200D 1F469 1F3FC","char":"👩🏼‍❤️‍👩🏼","name":"couple with heart: woman, woman, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 200D 1F469 1F3FC","char":"👩🏼‍❤‍👩🏼","name":"couple with heart: woman, woman, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 FE0F 200D 1F469 1F3FD","char":"👩🏼‍❤️‍👩🏽","name":"couple with heart: woman, woman, medium-light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 200D 1F469 1F3FD","char":"👩🏼‍❤‍👩🏽","name":"couple with heart: woman, woman, medium-light skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 FE0F 200D 1F469 1F3FE","char":"👩🏼‍❤️‍👩🏾","name":"couple with heart: woman, woman, medium-light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 200D 1F469 1F3FE","char":"👩🏼‍❤‍👩🏾","name":"couple with heart: woman, woman, medium-light skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 FE0F 200D 1F469 1F3FF","char":"👩🏼‍❤️‍👩🏿","name":"couple with heart: woman, woman, medium-light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FC 200D 2764 200D 1F469 1F3FF","char":"👩🏼‍❤‍👩🏿","name":"couple with heart: woman, woman, medium-light skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 FE0F 200D 1F469 1F3FB","char":"👩🏽‍❤️‍👩🏻","name":"couple with heart: woman, woman, medium skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 200D 1F469 1F3FB","char":"👩🏽‍❤‍👩🏻","name":"couple with heart: woman, woman, medium skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 FE0F 200D 1F469 1F3FC","char":"👩🏽‍❤️‍👩🏼","name":"couple with heart: woman, woman, medium skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 200D 1F469 1F3FC","char":"👩🏽‍❤‍👩🏼","name":"couple with heart: woman, woman, medium skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 FE0F 200D 1F469 1F3FD","char":"👩🏽‍❤️‍👩🏽","name":"couple with heart: woman, woman, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 200D 1F469 1F3FD","char":"👩🏽‍❤‍👩🏽","name":"couple with heart: woman, woman, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 FE0F 200D 1F469 1F3FE","char":"👩🏽‍❤️‍👩🏾","name":"couple with heart: woman, woman, medium skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 200D 1F469 1F3FE","char":"👩🏽‍❤‍👩🏾","name":"couple with heart: woman, woman, medium skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 FE0F 200D 1F469 1F3FF","char":"👩🏽‍❤️‍👩🏿","name":"couple with heart: woman, woman, medium skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FD 200D 2764 200D 1F469 1F3FF","char":"👩🏽‍❤‍👩🏿","name":"couple with heart: woman, woman, medium skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 FE0F 200D 1F469 1F3FB","char":"👩🏾‍❤️‍👩🏻","name":"couple with heart: woman, woman, medium-dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 200D 1F469 1F3FB","char":"👩🏾‍❤‍👩🏻","name":"couple with heart: woman, woman, medium-dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 FE0F 200D 1F469 1F3FC","char":"👩🏾‍❤️‍👩🏼","name":"couple with heart: woman, woman, medium-dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 200D 1F469 1F3FC","char":"👩🏾‍❤‍👩🏼","name":"couple with heart: woman, woman, medium-dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 FE0F 200D 1F469 1F3FD","char":"👩🏾‍❤️‍👩🏽","name":"couple with heart: woman, woman, medium-dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 200D 1F469 1F3FD","char":"👩🏾‍❤‍👩🏽","name":"couple with heart: woman, woman, medium-dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 FE0F 200D 1F469 1F3FE","char":"👩🏾‍❤️‍👩🏾","name":"couple with heart: woman, woman, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 200D 1F469 1F3FE","char":"👩🏾‍❤‍👩🏾","name":"couple with heart: woman, woman, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 FE0F 200D 1F469 1F3FF","char":"👩🏾‍❤️‍👩🏿","name":"couple with heart: woman, woman, medium-dark skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FE 200D 2764 200D 1F469 1F3FF","char":"👩🏾‍❤‍👩🏿","name":"couple with heart: woman, woman, medium-dark skin tone, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 FE0F 200D 1F469 1F3FB","char":"👩🏿‍❤️‍👩🏻","name":"couple with heart: woman, woman, dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 200D 1F469 1F3FB","char":"👩🏿‍❤‍👩🏻","name":"couple with heart: woman, woman, dark skin tone, light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 FE0F 200D 1F469 1F3FC","char":"👩🏿‍❤️‍👩🏼","name":"couple with heart: woman, woman, dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 200D 1F469 1F3FC","char":"👩🏿‍❤‍👩🏼","name":"couple with heart: woman, woman, dark skin tone, medium-light skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 FE0F 200D 1F469 1F3FD","char":"👩🏿‍❤️‍👩🏽","name":"couple with heart: woman, woman, dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 200D 1F469 1F3FD","char":"👩🏿‍❤‍👩🏽","name":"couple with heart: woman, woman, dark skin tone, medium skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 FE0F 200D 1F469 1F3FE","char":"👩🏿‍❤️‍👩🏾","name":"couple with heart: woman, woman, dark skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 200D 1F469 1F3FE","char":"👩🏿‍❤‍👩🏾","name":"couple with heart: woman, woman, dark skin tone, medium-dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 FE0F 200D 1F469 1F3FF","char":"👩🏿‍❤️‍👩🏿","name":"couple with heart: woman, woman, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 1F3FF 200D 2764 200D 1F469 1F3FF","char":"👩🏿‍❤‍👩🏿","name":"couple with heart: woman, woman, dark skin tone","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 200D 1F469 200D 1F466","char":"👨‍👩‍👦","name":"family: man, woman, boy","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 200D 1F469 200D 1F467","char":"👨‍👩‍👧","name":"family: man, woman, girl","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 200D 1F469 200D 1F467 200D 1F466","char":"👨‍👩‍👧‍👦","name":"family: man, woman, girl, boy","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 200D 1F469 200D 1F466 200D 1F466","char":"👨‍👩‍👦‍👦","name":"family: man, woman, boy, boy","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 200D 1F469 200D 1F467 200D 1F467","char":"👨‍👩‍👧‍👧","name":"family: man, woman, girl, girl","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 200D 1F468 200D 1F466","char":"👨‍👨‍👦","name":"family: man, man, boy","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 200D 1F468 200D 1F467","char":"👨‍👨‍👧","name":"family: man, man, girl","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 200D 1F468 200D 1F467 200D 1F466","char":"👨‍👨‍👧‍👦","name":"family: man, man, girl, boy","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 200D 1F468 200D 1F466 200D 1F466","char":"👨‍👨‍👦‍👦","name":"family: man, man, boy, boy","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 200D 1F468 200D 1F467 200D 1F467","char":"👨‍👨‍👧‍👧","name":"family: man, man, girl, girl","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 200D 1F469 200D 1F466","char":"👩‍👩‍👦","name":"family: woman, woman, boy","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 200D 1F469 200D 1F467","char":"👩‍👩‍👧","name":"family: woman, woman, girl","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 200D 1F469 200D 1F467 200D 1F466","char":"👩‍👩‍👧‍👦","name":"family: woman, woman, girl, boy","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 200D 1F469 200D 1F466 200D 1F466","char":"👩‍👩‍👦‍👦","name":"family: woman, woman, boy, boy","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 200D 1F469 200D 1F467 200D 1F467","char":"👩‍👩‍👧‍👧","name":"family: woman, woman, girl, girl","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 200D 1F466","char":"👨‍👦","name":"family: man, boy","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 200D 1F466 200D 1F466","char":"👨‍👦‍👦","name":"family: man, boy, boy","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 200D 1F467","char":"👨‍👧","name":"family: man, girl","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 200D 1F467 200D 1F466","char":"👨‍👧‍👦","name":"family: man, girl, boy","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F468 200D 1F467 200D 1F467","char":"👨‍👧‍👧","name":"family: man, girl, girl","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 200D 1F466","char":"👩‍👦","name":"family: woman, boy","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 200D 1F466 200D 1F466","char":"👩‍👦‍👦","name":"family: woman, boy, boy","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 200D 1F467","char":"👩‍👧","name":"family: woman, girl","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 200D 1F467 200D 1F466","char":"👩‍👧‍👦","name":"family: woman, girl, boy","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F469 200D 1F467 200D 1F467","char":"👩‍👧‍👧","name":"family: woman, girl, girl","category":"People & Body (family)","group":"People & Body","subgroup":"family"},{"codes":"1F5E3 FE0F","char":"🗣️","name":"speaking head","category":"People & Body (person-symbol)","group":"People & Body","subgroup":"person-symbol"},{"codes":"1F5E3","char":"🗣","name":"speaking head","category":"People & Body (person-symbol)","group":"People & Body","subgroup":"person-symbol"},{"codes":"1F464","char":"👤","name":"bust in silhouette","category":"People & Body (person-symbol)","group":"People & Body","subgroup":"person-symbol"},{"codes":"1F465","char":"👥","name":"busts in silhouette","category":"People & Body (person-symbol)","group":"People & Body","subgroup":"person-symbol"},{"codes":"1FAC2","char":"🫂","name":"people hugging","category":"People & Body (person-symbol)","group":"People & Body","subgroup":"person-symbol"},{"codes":"1F46A","char":"👪","name":"family","category":"People & Body (person-symbol)","group":"People & Body","subgroup":"person-symbol"},{"codes":"1F9D1 200D 1F9D1 200D 1F9D2","char":"🧑‍🧑‍🧒","name":"family: adult, adult, child","category":"People & Body (person-symbol)","group":"People & Body","subgroup":"person-symbol"},{"codes":"1F9D1 200D 1F9D1 200D 1F9D2 200D 1F9D2","char":"🧑‍🧑‍🧒‍🧒","name":"family: adult, adult, child, child","category":"People & Body (person-symbol)","group":"People & Body","subgroup":"person-symbol"},{"codes":"1F9D1 200D 1F9D2","char":"🧑‍🧒","name":"family: adult, child","category":"People & Body (person-symbol)","group":"People & Body","subgroup":"person-symbol"},{"codes":"1F9D1 200D 1F9D2 200D 1F9D2","char":"🧑‍🧒‍🧒","name":"family: adult, child, child","category":"People & Body (person-symbol)","group":"People & Body","subgroup":"person-symbol"},{"codes":"1F463","char":"👣","name":"footprints","category":"People & Body (person-symbol)","group":"People & Body","subgroup":"person-symbol"},{"codes":"1F3FB","char":"🏻","name":"light skin tone","category":"Component (skin-tone)","group":"Component","subgroup":"skin-tone"},{"codes":"1F3FC","char":"🏼","name":"medium-light skin tone","category":"Component (skin-tone)","group":"Component","subgroup":"skin-tone"},{"codes":"1F3FD","char":"🏽","name":"medium skin tone","category":"Component (skin-tone)","group":"Component","subgroup":"skin-tone"},{"codes":"1F3FE","char":"🏾","name":"medium-dark skin tone","category":"Component (skin-tone)","group":"Component","subgroup":"skin-tone"},{"codes":"1F3FF","char":"🏿","name":"dark skin tone","category":"Component (skin-tone)","group":"Component","subgroup":"skin-tone"},{"codes":"1F9B0","char":"🦰","name":"red hair","category":"Component (hair-style)","group":"Component","subgroup":"hair-style"},{"codes":"1F9B1","char":"🦱","name":"curly hair","category":"Component (hair-style)","group":"Component","subgroup":"hair-style"},{"codes":"1F9B3","char":"🦳","name":"white hair","category":"Component (hair-style)","group":"Component","subgroup":"hair-style"},{"codes":"1F9B2","char":"🦲","name":"bald","category":"Component (hair-style)","group":"Component","subgroup":"hair-style"},{"codes":"1F435","char":"🐵","name":"monkey face","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F412","char":"🐒","name":"monkey","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F98D","char":"🦍","name":"gorilla","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F9A7","char":"🦧","name":"orangutan","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F436","char":"🐶","name":"dog face","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F415","char":"🐕","name":"dog","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F9AE","char":"🦮","name":"guide dog","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F415 200D 1F9BA","char":"🐕‍🦺","name":"service dog","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F429","char":"🐩","name":"poodle","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F43A","char":"🐺","name":"wolf","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F98A","char":"🦊","name":"fox","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F99D","char":"🦝","name":"raccoon","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F431","char":"🐱","name":"cat face","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F408","char":"🐈","name":"cat","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F408 200D 2B1B","char":"🐈‍⬛","name":"black cat","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F981","char":"🦁","name":"lion","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F42F","char":"🐯","name":"tiger face","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F405","char":"🐅","name":"tiger","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F406","char":"🐆","name":"leopard","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F434","char":"🐴","name":"horse face","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1FACE","char":"🫎","name":"moose","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1FACF","char":"🫏","name":"donkey","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F40E","char":"🐎","name":"horse","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F984","char":"🦄","name":"unicorn","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F993","char":"🦓","name":"zebra","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F98C","char":"🦌","name":"deer","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F9AC","char":"🦬","name":"bison","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F42E","char":"🐮","name":"cow face","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F402","char":"🐂","name":"ox","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F403","char":"🐃","name":"water buffalo","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F404","char":"🐄","name":"cow","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F437","char":"🐷","name":"pig face","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F416","char":"🐖","name":"pig","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F417","char":"🐗","name":"boar","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F43D","char":"🐽","name":"pig nose","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F40F","char":"🐏","name":"ram","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F411","char":"🐑","name":"ewe","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F410","char":"🐐","name":"goat","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F42A","char":"🐪","name":"camel","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F42B","char":"🐫","name":"two-hump camel","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F999","char":"🦙","name":"llama","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F992","char":"🦒","name":"giraffe","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F418","char":"🐘","name":"elephant","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F9A3","char":"🦣","name":"mammoth","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F98F","char":"🦏","name":"rhinoceros","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F99B","char":"🦛","name":"hippopotamus","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F42D","char":"🐭","name":"mouse face","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F401","char":"🐁","name":"mouse","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F400","char":"🐀","name":"rat","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F439","char":"🐹","name":"hamster","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F430","char":"🐰","name":"rabbit face","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F407","char":"🐇","name":"rabbit","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F43F FE0F","char":"🐿️","name":"chipmunk","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F43F","char":"🐿","name":"chipmunk","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F9AB","char":"🦫","name":"beaver","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F994","char":"🦔","name":"hedgehog","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F987","char":"🦇","name":"bat","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F43B","char":"🐻","name":"bear","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F43B 200D 2744 FE0F","char":"🐻‍❄️","name":"polar bear","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F43B 200D 2744","char":"🐻‍❄","name":"polar bear","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F428","char":"🐨","name":"koala","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F43C","char":"🐼","name":"panda","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F9A5","char":"🦥","name":"sloth","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F9A6","char":"🦦","name":"otter","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F9A8","char":"🦨","name":"skunk","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F998","char":"🦘","name":"kangaroo","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F9A1","char":"🦡","name":"badger","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F43E","char":"🐾","name":"paw prints","category":"Animals & Nature (animal-mammal)","group":"Animals & Nature","subgroup":"animal-mammal"},{"codes":"1F983","char":"🦃","name":"turkey","category":"Animals & Nature (animal-bird)","group":"Animals & Nature","subgroup":"animal-bird"},{"codes":"1F414","char":"🐔","name":"chicken","category":"Animals & Nature (animal-bird)","group":"Animals & Nature","subgroup":"animal-bird"},{"codes":"1F413","char":"🐓","name":"rooster","category":"Animals & Nature (animal-bird)","group":"Animals & Nature","subgroup":"animal-bird"},{"codes":"1F423","char":"🐣","name":"hatching chick","category":"Animals & Nature (animal-bird)","group":"Animals & Nature","subgroup":"animal-bird"},{"codes":"1F424","char":"🐤","name":"baby chick","category":"Animals & Nature (animal-bird)","group":"Animals & Nature","subgroup":"animal-bird"},{"codes":"1F425","char":"🐥","name":"front-facing baby chick","category":"Animals & Nature (animal-bird)","group":"Animals & Nature","subgroup":"animal-bird"},{"codes":"1F426","char":"🐦","name":"bird","category":"Animals & Nature (animal-bird)","group":"Animals & Nature","subgroup":"animal-bird"},{"codes":"1F427","char":"🐧","name":"penguin","category":"Animals & Nature (animal-bird)","group":"Animals & Nature","subgroup":"animal-bird"},{"codes":"1F54A FE0F","char":"🕊️","name":"dove","category":"Animals & Nature (animal-bird)","group":"Animals & Nature","subgroup":"animal-bird"},{"codes":"1F54A","char":"🕊","name":"dove","category":"Animals & Nature (animal-bird)","group":"Animals & Nature","subgroup":"animal-bird"},{"codes":"1F985","char":"🦅","name":"eagle","category":"Animals & Nature (animal-bird)","group":"Animals & Nature","subgroup":"animal-bird"},{"codes":"1F986","char":"🦆","name":"duck","category":"Animals & Nature (animal-bird)","group":"Animals & Nature","subgroup":"animal-bird"},{"codes":"1F9A2","char":"🦢","name":"swan","category":"Animals & Nature (animal-bird)","group":"Animals & Nature","subgroup":"animal-bird"},{"codes":"1F989","char":"🦉","name":"owl","category":"Animals & Nature (animal-bird)","group":"Animals & Nature","subgroup":"animal-bird"},{"codes":"1F9A4","char":"🦤","name":"dodo","category":"Animals & Nature (animal-bird)","group":"Animals & Nature","subgroup":"animal-bird"},{"codes":"1FAB6","char":"🪶","name":"feather","category":"Animals & Nature (animal-bird)","group":"Animals & Nature","subgroup":"animal-bird"},{"codes":"1F9A9","char":"🦩","name":"flamingo","category":"Animals & Nature (animal-bird)","group":"Animals & Nature","subgroup":"animal-bird"},{"codes":"1F99A","char":"🦚","name":"peacock","category":"Animals & Nature (animal-bird)","group":"Animals & Nature","subgroup":"animal-bird"},{"codes":"1F99C","char":"🦜","name":"parrot","category":"Animals & Nature (animal-bird)","group":"Animals & Nature","subgroup":"animal-bird"},{"codes":"1FABD","char":"🪽","name":"wing","category":"Animals & Nature (animal-bird)","group":"Animals & Nature","subgroup":"animal-bird"},{"codes":"1F426 200D 2B1B","char":"🐦‍⬛","name":"black bird","category":"Animals & Nature (animal-bird)","group":"Animals & Nature","subgroup":"animal-bird"},{"codes":"1FABF","char":"🪿","name":"goose","category":"Animals & Nature (animal-bird)","group":"Animals & Nature","subgroup":"animal-bird"},{"codes":"1F426 200D 1F525","char":"🐦‍🔥","name":"phoenix","category":"Animals & Nature (animal-bird)","group":"Animals & Nature","subgroup":"animal-bird"},{"codes":"1F438","char":"🐸","name":"frog","category":"Animals & Nature (animal-amphibian)","group":"Animals & Nature","subgroup":"animal-amphibian"},{"codes":"1F40A","char":"🐊","name":"crocodile","category":"Animals & Nature (animal-reptile)","group":"Animals & Nature","subgroup":"animal-reptile"},{"codes":"1F422","char":"🐢","name":"turtle","category":"Animals & Nature (animal-reptile)","group":"Animals & Nature","subgroup":"animal-reptile"},{"codes":"1F98E","char":"🦎","name":"lizard","category":"Animals & Nature (animal-reptile)","group":"Animals & Nature","subgroup":"animal-reptile"},{"codes":"1F40D","char":"🐍","name":"snake","category":"Animals & Nature (animal-reptile)","group":"Animals & Nature","subgroup":"animal-reptile"},{"codes":"1F432","char":"🐲","name":"dragon face","category":"Animals & Nature (animal-reptile)","group":"Animals & Nature","subgroup":"animal-reptile"},{"codes":"1F409","char":"🐉","name":"dragon","category":"Animals & Nature (animal-reptile)","group":"Animals & Nature","subgroup":"animal-reptile"},{"codes":"1F995","char":"🦕","name":"sauropod","category":"Animals & Nature (animal-reptile)","group":"Animals & Nature","subgroup":"animal-reptile"},{"codes":"1F996","char":"🦖","name":"T-Rex","category":"Animals & Nature (animal-reptile)","group":"Animals & Nature","subgroup":"animal-reptile"},{"codes":"1F433","char":"🐳","name":"spouting whale","category":"Animals & Nature (animal-marine)","group":"Animals & Nature","subgroup":"animal-marine"},{"codes":"1F40B","char":"🐋","name":"whale","category":"Animals & Nature (animal-marine)","group":"Animals & Nature","subgroup":"animal-marine"},{"codes":"1F42C","char":"🐬","name":"dolphin","category":"Animals & Nature (animal-marine)","group":"Animals & Nature","subgroup":"animal-marine"},{"codes":"1F9AD","char":"🦭","name":"seal","category":"Animals & Nature (animal-marine)","group":"Animals & Nature","subgroup":"animal-marine"},{"codes":"1F41F","char":"🐟","name":"fish","category":"Animals & Nature (animal-marine)","group":"Animals & Nature","subgroup":"animal-marine"},{"codes":"1F420","char":"🐠","name":"tropical fish","category":"Animals & Nature (animal-marine)","group":"Animals & Nature","subgroup":"animal-marine"},{"codes":"1F421","char":"🐡","name":"blowfish","category":"Animals & Nature (animal-marine)","group":"Animals & Nature","subgroup":"animal-marine"},{"codes":"1F988","char":"🦈","name":"shark","category":"Animals & Nature (animal-marine)","group":"Animals & Nature","subgroup":"animal-marine"},{"codes":"1F419","char":"🐙","name":"octopus","category":"Animals & Nature (animal-marine)","group":"Animals & Nature","subgroup":"animal-marine"},{"codes":"1F41A","char":"🐚","name":"spiral shell","category":"Animals & Nature (animal-marine)","group":"Animals & Nature","subgroup":"animal-marine"},{"codes":"1FAB8","char":"🪸","name":"coral","category":"Animals & Nature (animal-marine)","group":"Animals & Nature","subgroup":"animal-marine"},{"codes":"1FABC","char":"🪼","name":"jellyfish","category":"Animals & Nature (animal-marine)","group":"Animals & Nature","subgroup":"animal-marine"},{"codes":"1F40C","char":"🐌","name":"snail","category":"Animals & Nature (animal-bug)","group":"Animals & Nature","subgroup":"animal-bug"},{"codes":"1F98B","char":"🦋","name":"butterfly","category":"Animals & Nature (animal-bug)","group":"Animals & Nature","subgroup":"animal-bug"},{"codes":"1F41B","char":"🐛","name":"bug","category":"Animals & Nature (animal-bug)","group":"Animals & Nature","subgroup":"animal-bug"},{"codes":"1F41C","char":"🐜","name":"ant","category":"Animals & Nature (animal-bug)","group":"Animals & Nature","subgroup":"animal-bug"},{"codes":"1F41D","char":"🐝","name":"honeybee","category":"Animals & Nature (animal-bug)","group":"Animals & Nature","subgroup":"animal-bug"},{"codes":"1FAB2","char":"🪲","name":"beetle","category":"Animals & Nature (animal-bug)","group":"Animals & Nature","subgroup":"animal-bug"},{"codes":"1F41E","char":"🐞","name":"lady beetle","category":"Animals & Nature (animal-bug)","group":"Animals & Nature","subgroup":"animal-bug"},{"codes":"1F997","char":"🦗","name":"cricket","category":"Animals & Nature (animal-bug)","group":"Animals & Nature","subgroup":"animal-bug"},{"codes":"1FAB3","char":"🪳","name":"cockroach","category":"Animals & Nature (animal-bug)","group":"Animals & Nature","subgroup":"animal-bug"},{"codes":"1F577 FE0F","char":"🕷️","name":"spider","category":"Animals & Nature (animal-bug)","group":"Animals & Nature","subgroup":"animal-bug"},{"codes":"1F577","char":"🕷","name":"spider","category":"Animals & Nature (animal-bug)","group":"Animals & Nature","subgroup":"animal-bug"},{"codes":"1F578 FE0F","char":"🕸️","name":"spider web","category":"Animals & Nature (animal-bug)","group":"Animals & Nature","subgroup":"animal-bug"},{"codes":"1F578","char":"🕸","name":"spider web","category":"Animals & Nature (animal-bug)","group":"Animals & Nature","subgroup":"animal-bug"},{"codes":"1F982","char":"🦂","name":"scorpion","category":"Animals & Nature (animal-bug)","group":"Animals & Nature","subgroup":"animal-bug"},{"codes":"1F99F","char":"🦟","name":"mosquito","category":"Animals & Nature (animal-bug)","group":"Animals & Nature","subgroup":"animal-bug"},{"codes":"1FAB0","char":"🪰","name":"fly","category":"Animals & Nature (animal-bug)","group":"Animals & Nature","subgroup":"animal-bug"},{"codes":"1FAB1","char":"🪱","name":"worm","category":"Animals & Nature (animal-bug)","group":"Animals & Nature","subgroup":"animal-bug"},{"codes":"1F9A0","char":"🦠","name":"microbe","category":"Animals & Nature (animal-bug)","group":"Animals & Nature","subgroup":"animal-bug"},{"codes":"1F490","char":"💐","name":"bouquet","category":"Animals & Nature (plant-flower)","group":"Animals & Nature","subgroup":"plant-flower"},{"codes":"1F338","char":"🌸","name":"cherry blossom","category":"Animals & Nature (plant-flower)","group":"Animals & Nature","subgroup":"plant-flower"},{"codes":"1F4AE","char":"💮","name":"white flower","category":"Animals & Nature (plant-flower)","group":"Animals & Nature","subgroup":"plant-flower"},{"codes":"1FAB7","char":"🪷","name":"lotus","category":"Animals & Nature (plant-flower)","group":"Animals & Nature","subgroup":"plant-flower"},{"codes":"1F3F5 FE0F","char":"🏵️","name":"rosette","category":"Animals & Nature (plant-flower)","group":"Animals & Nature","subgroup":"plant-flower"},{"codes":"1F3F5","char":"🏵","name":"rosette","category":"Animals & Nature (plant-flower)","group":"Animals & Nature","subgroup":"plant-flower"},{"codes":"1F339","char":"🌹","name":"rose","category":"Animals & Nature (plant-flower)","group":"Animals & Nature","subgroup":"plant-flower"},{"codes":"1F940","char":"🥀","name":"wilted flower","category":"Animals & Nature (plant-flower)","group":"Animals & Nature","subgroup":"plant-flower"},{"codes":"1F33A","char":"🌺","name":"hibiscus","category":"Animals & Nature (plant-flower)","group":"Animals & Nature","subgroup":"plant-flower"},{"codes":"1F33B","char":"🌻","name":"sunflower","category":"Animals & Nature (plant-flower)","group":"Animals & Nature","subgroup":"plant-flower"},{"codes":"1F33C","char":"🌼","name":"blossom","category":"Animals & Nature (plant-flower)","group":"Animals & Nature","subgroup":"plant-flower"},{"codes":"1F337","char":"🌷","name":"tulip","category":"Animals & Nature (plant-flower)","group":"Animals & Nature","subgroup":"plant-flower"},{"codes":"1FABB","char":"🪻","name":"hyacinth","category":"Animals & Nature (plant-flower)","group":"Animals & Nature","subgroup":"plant-flower"},{"codes":"1F331","char":"🌱","name":"seedling","category":"Animals & Nature (plant-other)","group":"Animals & Nature","subgroup":"plant-other"},{"codes":"1FAB4","char":"🪴","name":"potted plant","category":"Animals & Nature (plant-other)","group":"Animals & Nature","subgroup":"plant-other"},{"codes":"1F332","char":"🌲","name":"evergreen tree","category":"Animals & Nature (plant-other)","group":"Animals & Nature","subgroup":"plant-other"},{"codes":"1F333","char":"🌳","name":"deciduous tree","category":"Animals & Nature (plant-other)","group":"Animals & Nature","subgroup":"plant-other"},{"codes":"1F334","char":"🌴","name":"palm tree","category":"Animals & Nature (plant-other)","group":"Animals & Nature","subgroup":"plant-other"},{"codes":"1F335","char":"🌵","name":"cactus","category":"Animals & Nature (plant-other)","group":"Animals & Nature","subgroup":"plant-other"},{"codes":"1F33E","char":"🌾","name":"sheaf of rice","category":"Animals & Nature (plant-other)","group":"Animals & Nature","subgroup":"plant-other"},{"codes":"1F33F","char":"🌿","name":"herb","category":"Animals & Nature (plant-other)","group":"Animals & Nature","subgroup":"plant-other"},{"codes":"2618 FE0F","char":"☘️","name":"shamrock","category":"Animals & Nature (plant-other)","group":"Animals & Nature","subgroup":"plant-other"},{"codes":"2618","char":"☘","name":"shamrock","category":"Animals & Nature (plant-other)","group":"Animals & Nature","subgroup":"plant-other"},{"codes":"1F340","char":"🍀","name":"four leaf clover","category":"Animals & Nature (plant-other)","group":"Animals & Nature","subgroup":"plant-other"},{"codes":"1F341","char":"🍁","name":"maple leaf","category":"Animals & Nature (plant-other)","group":"Animals & Nature","subgroup":"plant-other"},{"codes":"1F342","char":"🍂","name":"fallen leaf","category":"Animals & Nature (plant-other)","group":"Animals & Nature","subgroup":"plant-other"},{"codes":"1F343","char":"🍃","name":"leaf fluttering in wind","category":"Animals & Nature (plant-other)","group":"Animals & Nature","subgroup":"plant-other"},{"codes":"1FAB9","char":"🪹","name":"empty nest","category":"Animals & Nature (plant-other)","group":"Animals & Nature","subgroup":"plant-other"},{"codes":"1FABA","char":"🪺","name":"nest with eggs","category":"Animals & Nature (plant-other)","group":"Animals & Nature","subgroup":"plant-other"},{"codes":"1F344","char":"🍄","name":"mushroom","category":"Animals & Nature (plant-other)","group":"Animals & Nature","subgroup":"plant-other"},{"codes":"1F347","char":"🍇","name":"grapes","category":"Food & Drink (food-fruit)","group":"Food & Drink","subgroup":"food-fruit"},{"codes":"1F348","char":"🍈","name":"melon","category":"Food & Drink (food-fruit)","group":"Food & Drink","subgroup":"food-fruit"},{"codes":"1F349","char":"🍉","name":"watermelon","category":"Food & Drink (food-fruit)","group":"Food & Drink","subgroup":"food-fruit"},{"codes":"1F34A","char":"🍊","name":"tangerine","category":"Food & Drink (food-fruit)","group":"Food & Drink","subgroup":"food-fruit"},{"codes":"1F34B","char":"🍋","name":"lemon","category":"Food & Drink (food-fruit)","group":"Food & Drink","subgroup":"food-fruit"},{"codes":"1F34B 200D 1F7E9","char":"🍋‍🟩","name":"lime","category":"Food & Drink (food-fruit)","group":"Food & Drink","subgroup":"food-fruit"},{"codes":"1F34C","char":"🍌","name":"banana","category":"Food & Drink (food-fruit)","group":"Food & Drink","subgroup":"food-fruit"},{"codes":"1F34D","char":"🍍","name":"pineapple","category":"Food & Drink (food-fruit)","group":"Food & Drink","subgroup":"food-fruit"},{"codes":"1F96D","char":"🥭","name":"mango","category":"Food & Drink (food-fruit)","group":"Food & Drink","subgroup":"food-fruit"},{"codes":"1F34E","char":"🍎","name":"red apple","category":"Food & Drink (food-fruit)","group":"Food & Drink","subgroup":"food-fruit"},{"codes":"1F34F","char":"🍏","name":"green apple","category":"Food & Drink (food-fruit)","group":"Food & Drink","subgroup":"food-fruit"},{"codes":"1F350","char":"🍐","name":"pear","category":"Food & Drink (food-fruit)","group":"Food & Drink","subgroup":"food-fruit"},{"codes":"1F351","char":"🍑","name":"peach","category":"Food & Drink (food-fruit)","group":"Food & Drink","subgroup":"food-fruit"},{"codes":"1F352","char":"🍒","name":"cherries","category":"Food & Drink (food-fruit)","group":"Food & Drink","subgroup":"food-fruit"},{"codes":"1F353","char":"🍓","name":"strawberry","category":"Food & Drink (food-fruit)","group":"Food & Drink","subgroup":"food-fruit"},{"codes":"1FAD0","char":"🫐","name":"blueberries","category":"Food & Drink (food-fruit)","group":"Food & Drink","subgroup":"food-fruit"},{"codes":"1F95D","char":"🥝","name":"kiwi fruit","category":"Food & Drink (food-fruit)","group":"Food & Drink","subgroup":"food-fruit"},{"codes":"1F345","char":"🍅","name":"tomato","category":"Food & Drink (food-fruit)","group":"Food & Drink","subgroup":"food-fruit"},{"codes":"1FAD2","char":"🫒","name":"olive","category":"Food & Drink (food-fruit)","group":"Food & Drink","subgroup":"food-fruit"},{"codes":"1F965","char":"🥥","name":"coconut","category":"Food & Drink (food-fruit)","group":"Food & Drink","subgroup":"food-fruit"},{"codes":"1F951","char":"🥑","name":"avocado","category":"Food & Drink (food-vegetable)","group":"Food & Drink","subgroup":"food-vegetable"},{"codes":"1F346","char":"🍆","name":"eggplant","category":"Food & Drink (food-vegetable)","group":"Food & Drink","subgroup":"food-vegetable"},{"codes":"1F954","char":"🥔","name":"potato","category":"Food & Drink (food-vegetable)","group":"Food & Drink","subgroup":"food-vegetable"},{"codes":"1F955","char":"🥕","name":"carrot","category":"Food & Drink (food-vegetable)","group":"Food & Drink","subgroup":"food-vegetable"},{"codes":"1F33D","char":"🌽","name":"ear of corn","category":"Food & Drink (food-vegetable)","group":"Food & Drink","subgroup":"food-vegetable"},{"codes":"1F336 FE0F","char":"🌶️","name":"hot pepper","category":"Food & Drink (food-vegetable)","group":"Food & Drink","subgroup":"food-vegetable"},{"codes":"1F336","char":"🌶","name":"hot pepper","category":"Food & Drink (food-vegetable)","group":"Food & Drink","subgroup":"food-vegetable"},{"codes":"1FAD1","char":"🫑","name":"bell pepper","category":"Food & Drink (food-vegetable)","group":"Food & Drink","subgroup":"food-vegetable"},{"codes":"1F952","char":"🥒","name":"cucumber","category":"Food & Drink (food-vegetable)","group":"Food & Drink","subgroup":"food-vegetable"},{"codes":"1F96C","char":"🥬","name":"leafy green","category":"Food & Drink (food-vegetable)","group":"Food & Drink","subgroup":"food-vegetable"},{"codes":"1F966","char":"🥦","name":"broccoli","category":"Food & Drink (food-vegetable)","group":"Food & Drink","subgroup":"food-vegetable"},{"codes":"1F9C4","char":"🧄","name":"garlic","category":"Food & Drink (food-vegetable)","group":"Food & Drink","subgroup":"food-vegetable"},{"codes":"1F9C5","char":"🧅","name":"onion","category":"Food & Drink (food-vegetable)","group":"Food & Drink","subgroup":"food-vegetable"},{"codes":"1F95C","char":"🥜","name":"peanuts","category":"Food & Drink (food-vegetable)","group":"Food & Drink","subgroup":"food-vegetable"},{"codes":"1FAD8","char":"🫘","name":"beans","category":"Food & Drink (food-vegetable)","group":"Food & Drink","subgroup":"food-vegetable"},{"codes":"1F330","char":"🌰","name":"chestnut","category":"Food & Drink (food-vegetable)","group":"Food & Drink","subgroup":"food-vegetable"},{"codes":"1FADA","char":"🫚","name":"ginger root","category":"Food & Drink (food-vegetable)","group":"Food & Drink","subgroup":"food-vegetable"},{"codes":"1FADB","char":"🫛","name":"pea pod","category":"Food & Drink (food-vegetable)","group":"Food & Drink","subgroup":"food-vegetable"},{"codes":"1F344 200D 1F7EB","char":"🍄‍🟫","name":"brown mushroom","category":"Food & Drink (food-vegetable)","group":"Food & Drink","subgroup":"food-vegetable"},{"codes":"1F35E","char":"🍞","name":"bread","category":"Food & Drink (food-prepared)","group":"Food & Drink","subgroup":"food-prepared"},{"codes":"1F950","char":"🥐","name":"croissant","category":"Food & Drink (food-prepared)","group":"Food & Drink","subgroup":"food-prepared"},{"codes":"1F956","char":"🥖","name":"baguette bread","category":"Food & Drink (food-prepared)","group":"Food & Drink","subgroup":"food-prepared"},{"codes":"1FAD3","char":"🫓","name":"flatbread","category":"Food & Drink (food-prepared)","group":"Food & Drink","subgroup":"food-prepared"},{"codes":"1F968","char":"🥨","name":"pretzel","category":"Food & Drink (food-prepared)","group":"Food & Drink","subgroup":"food-prepared"},{"codes":"1F96F","char":"🥯","name":"bagel","category":"Food & Drink (food-prepared)","group":"Food & Drink","subgroup":"food-prepared"},{"codes":"1F95E","char":"🥞","name":"pancakes","category":"Food & Drink (food-prepared)","group":"Food & Drink","subgroup":"food-prepared"},{"codes":"1F9C7","char":"🧇","name":"waffle","category":"Food & Drink (food-prepared)","group":"Food & Drink","subgroup":"food-prepared"},{"codes":"1F9C0","char":"🧀","name":"cheese wedge","category":"Food & Drink (food-prepared)","group":"Food & Drink","subgroup":"food-prepared"},{"codes":"1F356","char":"🍖","name":"meat on bone","category":"Food & Drink (food-prepared)","group":"Food & Drink","subgroup":"food-prepared"},{"codes":"1F357","char":"🍗","name":"poultry leg","category":"Food & Drink (food-prepared)","group":"Food & Drink","subgroup":"food-prepared"},{"codes":"1F969","char":"🥩","name":"cut of meat","category":"Food & Drink (food-prepared)","group":"Food & Drink","subgroup":"food-prepared"},{"codes":"1F953","char":"🥓","name":"bacon","category":"Food & Drink (food-prepared)","group":"Food & Drink","subgroup":"food-prepared"},{"codes":"1F354","char":"🍔","name":"hamburger","category":"Food & Drink (food-prepared)","group":"Food & Drink","subgroup":"food-prepared"},{"codes":"1F35F","char":"🍟","name":"french fries","category":"Food & Drink (food-prepared)","group":"Food & Drink","subgroup":"food-prepared"},{"codes":"1F355","char":"🍕","name":"pizza","category":"Food & Drink (food-prepared)","group":"Food & Drink","subgroup":"food-prepared"},{"codes":"1F32D","char":"🌭","name":"hot dog","category":"Food & Drink (food-prepared)","group":"Food & Drink","subgroup":"food-prepared"},{"codes":"1F96A","char":"🥪","name":"sandwich","category":"Food & Drink (food-prepared)","group":"Food & Drink","subgroup":"food-prepared"},{"codes":"1F32E","char":"🌮","name":"taco","category":"Food & Drink (food-prepared)","group":"Food & Drink","subgroup":"food-prepared"},{"codes":"1F32F","char":"🌯","name":"burrito","category":"Food & Drink (food-prepared)","group":"Food & Drink","subgroup":"food-prepared"},{"codes":"1FAD4","char":"🫔","name":"tamale","category":"Food & Drink (food-prepared)","group":"Food & Drink","subgroup":"food-prepared"},{"codes":"1F959","char":"🥙","name":"stuffed flatbread","category":"Food & Drink (food-prepared)","group":"Food & Drink","subgroup":"food-prepared"},{"codes":"1F9C6","char":"🧆","name":"falafel","category":"Food & Drink (food-prepared)","group":"Food & Drink","subgroup":"food-prepared"},{"codes":"1F95A","char":"🥚","name":"egg","category":"Food & Drink (food-prepared)","group":"Food & Drink","subgroup":"food-prepared"},{"codes":"1F373","char":"🍳","name":"cooking","category":"Food & Drink (food-prepared)","group":"Food & Drink","subgroup":"food-prepared"},{"codes":"1F958","char":"🥘","name":"shallow pan of food","category":"Food & Drink (food-prepared)","group":"Food & Drink","subgroup":"food-prepared"},{"codes":"1F372","char":"🍲","name":"pot of food","category":"Food & Drink (food-prepared)","group":"Food & Drink","subgroup":"food-prepared"},{"codes":"1FAD5","char":"🫕","name":"fondue","category":"Food & Drink (food-prepared)","group":"Food & Drink","subgroup":"food-prepared"},{"codes":"1F963","char":"🥣","name":"bowl with spoon","category":"Food & Drink (food-prepared)","group":"Food & Drink","subgroup":"food-prepared"},{"codes":"1F957","char":"🥗","name":"green salad","category":"Food & Drink (food-prepared)","group":"Food & Drink","subgroup":"food-prepared"},{"codes":"1F37F","char":"🍿","name":"popcorn","category":"Food & Drink (food-prepared)","group":"Food & Drink","subgroup":"food-prepared"},{"codes":"1F9C8","char":"🧈","name":"butter","category":"Food & Drink (food-prepared)","group":"Food & Drink","subgroup":"food-prepared"},{"codes":"1F9C2","char":"🧂","name":"salt","category":"Food & Drink (food-prepared)","group":"Food & Drink","subgroup":"food-prepared"},{"codes":"1F96B","char":"🥫","name":"canned food","category":"Food & Drink (food-prepared)","group":"Food & Drink","subgroup":"food-prepared"},{"codes":"1F371","char":"🍱","name":"bento box","category":"Food & Drink (food-asian)","group":"Food & Drink","subgroup":"food-asian"},{"codes":"1F358","char":"🍘","name":"rice cracker","category":"Food & Drink (food-asian)","group":"Food & Drink","subgroup":"food-asian"},{"codes":"1F359","char":"🍙","name":"rice ball","category":"Food & Drink (food-asian)","group":"Food & Drink","subgroup":"food-asian"},{"codes":"1F35A","char":"🍚","name":"cooked rice","category":"Food & Drink (food-asian)","group":"Food & Drink","subgroup":"food-asian"},{"codes":"1F35B","char":"🍛","name":"curry rice","category":"Food & Drink (food-asian)","group":"Food & Drink","subgroup":"food-asian"},{"codes":"1F35C","char":"🍜","name":"steaming bowl","category":"Food & Drink (food-asian)","group":"Food & Drink","subgroup":"food-asian"},{"codes":"1F35D","char":"🍝","name":"spaghetti","category":"Food & Drink (food-asian)","group":"Food & Drink","subgroup":"food-asian"},{"codes":"1F360","char":"🍠","name":"roasted sweet potato","category":"Food & Drink (food-asian)","group":"Food & Drink","subgroup":"food-asian"},{"codes":"1F362","char":"🍢","name":"oden","category":"Food & Drink (food-asian)","group":"Food & Drink","subgroup":"food-asian"},{"codes":"1F363","char":"🍣","name":"sushi","category":"Food & Drink (food-asian)","group":"Food & Drink","subgroup":"food-asian"},{"codes":"1F364","char":"🍤","name":"fried shrimp","category":"Food & Drink (food-asian)","group":"Food & Drink","subgroup":"food-asian"},{"codes":"1F365","char":"🍥","name":"fish cake with swirl","category":"Food & Drink (food-asian)","group":"Food & Drink","subgroup":"food-asian"},{"codes":"1F96E","char":"🥮","name":"moon cake","category":"Food & Drink (food-asian)","group":"Food & Drink","subgroup":"food-asian"},{"codes":"1F361","char":"🍡","name":"dango","category":"Food & Drink (food-asian)","group":"Food & Drink","subgroup":"food-asian"},{"codes":"1F95F","char":"🥟","name":"dumpling","category":"Food & Drink (food-asian)","group":"Food & Drink","subgroup":"food-asian"},{"codes":"1F960","char":"🥠","name":"fortune cookie","category":"Food & Drink (food-asian)","group":"Food & Drink","subgroup":"food-asian"},{"codes":"1F961","char":"🥡","name":"takeout box","category":"Food & Drink (food-asian)","group":"Food & Drink","subgroup":"food-asian"},{"codes":"1F980","char":"🦀","name":"crab","category":"Food & Drink (food-marine)","group":"Food & Drink","subgroup":"food-marine"},{"codes":"1F99E","char":"🦞","name":"lobster","category":"Food & Drink (food-marine)","group":"Food & Drink","subgroup":"food-marine"},{"codes":"1F990","char":"🦐","name":"shrimp","category":"Food & Drink (food-marine)","group":"Food & Drink","subgroup":"food-marine"},{"codes":"1F991","char":"🦑","name":"squid","category":"Food & Drink (food-marine)","group":"Food & Drink","subgroup":"food-marine"},{"codes":"1F9AA","char":"🦪","name":"oyster","category":"Food & Drink (food-marine)","group":"Food & Drink","subgroup":"food-marine"},{"codes":"1F366","char":"🍦","name":"soft ice cream","category":"Food & Drink (food-sweet)","group":"Food & Drink","subgroup":"food-sweet"},{"codes":"1F367","char":"🍧","name":"shaved ice","category":"Food & Drink (food-sweet)","group":"Food & Drink","subgroup":"food-sweet"},{"codes":"1F368","char":"🍨","name":"ice cream","category":"Food & Drink (food-sweet)","group":"Food & Drink","subgroup":"food-sweet"},{"codes":"1F369","char":"🍩","name":"doughnut","category":"Food & Drink (food-sweet)","group":"Food & Drink","subgroup":"food-sweet"},{"codes":"1F36A","char":"🍪","name":"cookie","category":"Food & Drink (food-sweet)","group":"Food & Drink","subgroup":"food-sweet"},{"codes":"1F382","char":"🎂","name":"birthday cake","category":"Food & Drink (food-sweet)","group":"Food & Drink","subgroup":"food-sweet"},{"codes":"1F370","char":"🍰","name":"shortcake","category":"Food & Drink (food-sweet)","group":"Food & Drink","subgroup":"food-sweet"},{"codes":"1F9C1","char":"🧁","name":"cupcake","category":"Food & Drink (food-sweet)","group":"Food & Drink","subgroup":"food-sweet"},{"codes":"1F967","char":"🥧","name":"pie","category":"Food & Drink (food-sweet)","group":"Food & Drink","subgroup":"food-sweet"},{"codes":"1F36B","char":"🍫","name":"chocolate bar","category":"Food & Drink (food-sweet)","group":"Food & Drink","subgroup":"food-sweet"},{"codes":"1F36C","char":"🍬","name":"candy","category":"Food & Drink (food-sweet)","group":"Food & Drink","subgroup":"food-sweet"},{"codes":"1F36D","char":"🍭","name":"lollipop","category":"Food & Drink (food-sweet)","group":"Food & Drink","subgroup":"food-sweet"},{"codes":"1F36E","char":"🍮","name":"custard","category":"Food & Drink (food-sweet)","group":"Food & Drink","subgroup":"food-sweet"},{"codes":"1F36F","char":"🍯","name":"honey pot","category":"Food & Drink (food-sweet)","group":"Food & Drink","subgroup":"food-sweet"},{"codes":"1F37C","char":"🍼","name":"baby bottle","category":"Food & Drink (drink)","group":"Food & Drink","subgroup":"drink"},{"codes":"1F95B","char":"🥛","name":"glass of milk","category":"Food & Drink (drink)","group":"Food & Drink","subgroup":"drink"},{"codes":"2615","char":"☕","name":"hot beverage","category":"Food & Drink (drink)","group":"Food & Drink","subgroup":"drink"},{"codes":"1FAD6","char":"🫖","name":"teapot","category":"Food & Drink (drink)","group":"Food & Drink","subgroup":"drink"},{"codes":"1F375","char":"🍵","name":"teacup without handle","category":"Food & Drink (drink)","group":"Food & Drink","subgroup":"drink"},{"codes":"1F376","char":"🍶","name":"sake","category":"Food & Drink (drink)","group":"Food & Drink","subgroup":"drink"},{"codes":"1F37E","char":"🍾","name":"bottle with popping cork","category":"Food & Drink (drink)","group":"Food & Drink","subgroup":"drink"},{"codes":"1F377","char":"🍷","name":"wine glass","category":"Food & Drink (drink)","group":"Food & Drink","subgroup":"drink"},{"codes":"1F378","char":"🍸","name":"cocktail glass","category":"Food & Drink (drink)","group":"Food & Drink","subgroup":"drink"},{"codes":"1F379","char":"🍹","name":"tropical drink","category":"Food & Drink (drink)","group":"Food & Drink","subgroup":"drink"},{"codes":"1F37A","char":"🍺","name":"beer mug","category":"Food & Drink (drink)","group":"Food & Drink","subgroup":"drink"},{"codes":"1F37B","char":"🍻","name":"clinking beer mugs","category":"Food & Drink (drink)","group":"Food & Drink","subgroup":"drink"},{"codes":"1F942","char":"🥂","name":"clinking glasses","category":"Food & Drink (drink)","group":"Food & Drink","subgroup":"drink"},{"codes":"1F943","char":"🥃","name":"tumbler glass","category":"Food & Drink (drink)","group":"Food & Drink","subgroup":"drink"},{"codes":"1FAD7","char":"🫗","name":"pouring liquid","category":"Food & Drink (drink)","group":"Food & Drink","subgroup":"drink"},{"codes":"1F964","char":"🥤","name":"cup with straw","category":"Food & Drink (drink)","group":"Food & Drink","subgroup":"drink"},{"codes":"1F9CB","char":"🧋","name":"bubble tea","category":"Food & Drink (drink)","group":"Food & Drink","subgroup":"drink"},{"codes":"1F9C3","char":"🧃","name":"beverage box","category":"Food & Drink (drink)","group":"Food & Drink","subgroup":"drink"},{"codes":"1F9C9","char":"🧉","name":"mate","category":"Food & Drink (drink)","group":"Food & Drink","subgroup":"drink"},{"codes":"1F9CA","char":"🧊","name":"ice","category":"Food & Drink (drink)","group":"Food & Drink","subgroup":"drink"},{"codes":"1F962","char":"🥢","name":"chopsticks","category":"Food & Drink (dishware)","group":"Food & Drink","subgroup":"dishware"},{"codes":"1F37D FE0F","char":"🍽️","name":"fork and knife with plate","category":"Food & Drink (dishware)","group":"Food & Drink","subgroup":"dishware"},{"codes":"1F37D","char":"🍽","name":"fork and knife with plate","category":"Food & Drink (dishware)","group":"Food & Drink","subgroup":"dishware"},{"codes":"1F374","char":"🍴","name":"fork and knife","category":"Food & Drink (dishware)","group":"Food & Drink","subgroup":"dishware"},{"codes":"1F944","char":"🥄","name":"spoon","category":"Food & Drink (dishware)","group":"Food & Drink","subgroup":"dishware"},{"codes":"1F52A","char":"🔪","name":"kitchen knife","category":"Food & Drink (dishware)","group":"Food & Drink","subgroup":"dishware"},{"codes":"1FAD9","char":"🫙","name":"jar","category":"Food & Drink (dishware)","group":"Food & Drink","subgroup":"dishware"},{"codes":"1F3FA","char":"🏺","name":"amphora","category":"Food & Drink (dishware)","group":"Food & Drink","subgroup":"dishware"},{"codes":"1F30D","char":"🌍","name":"globe showing Europe-Africa","category":"Travel & Places (place-map)","group":"Travel & Places","subgroup":"place-map"},{"codes":"1F30E","char":"🌎","name":"globe showing Americas","category":"Travel & Places (place-map)","group":"Travel & Places","subgroup":"place-map"},{"codes":"1F30F","char":"🌏","name":"globe showing Asia-Australia","category":"Travel & Places (place-map)","group":"Travel & Places","subgroup":"place-map"},{"codes":"1F310","char":"🌐","name":"globe with meridians","category":"Travel & Places (place-map)","group":"Travel & Places","subgroup":"place-map"},{"codes":"1F5FA FE0F","char":"🗺️","name":"world map","category":"Travel & Places (place-map)","group":"Travel & Places","subgroup":"place-map"},{"codes":"1F5FA","char":"🗺","name":"world map","category":"Travel & Places (place-map)","group":"Travel & Places","subgroup":"place-map"},{"codes":"1F5FE","char":"🗾","name":"map of Japan","category":"Travel & Places (place-map)","group":"Travel & Places","subgroup":"place-map"},{"codes":"1F9ED","char":"🧭","name":"compass","category":"Travel & Places (place-map)","group":"Travel & Places","subgroup":"place-map"},{"codes":"1F3D4 FE0F","char":"🏔️","name":"snow-capped mountain","category":"Travel & Places (place-geographic)","group":"Travel & Places","subgroup":"place-geographic"},{"codes":"1F3D4","char":"🏔","name":"snow-capped mountain","category":"Travel & Places (place-geographic)","group":"Travel & Places","subgroup":"place-geographic"},{"codes":"26F0 FE0F","char":"⛰️","name":"mountain","category":"Travel & Places (place-geographic)","group":"Travel & Places","subgroup":"place-geographic"},{"codes":"26F0","char":"⛰","name":"mountain","category":"Travel & Places (place-geographic)","group":"Travel & Places","subgroup":"place-geographic"},{"codes":"1F30B","char":"🌋","name":"volcano","category":"Travel & Places (place-geographic)","group":"Travel & Places","subgroup":"place-geographic"},{"codes":"1F5FB","char":"🗻","name":"mount fuji","category":"Travel & Places (place-geographic)","group":"Travel & Places","subgroup":"place-geographic"},{"codes":"1F3D5 FE0F","char":"🏕️","name":"camping","category":"Travel & Places (place-geographic)","group":"Travel & Places","subgroup":"place-geographic"},{"codes":"1F3D5","char":"🏕","name":"camping","category":"Travel & Places (place-geographic)","group":"Travel & Places","subgroup":"place-geographic"},{"codes":"1F3D6 FE0F","char":"🏖️","name":"beach with umbrella","category":"Travel & Places (place-geographic)","group":"Travel & Places","subgroup":"place-geographic"},{"codes":"1F3D6","char":"🏖","name":"beach with umbrella","category":"Travel & Places (place-geographic)","group":"Travel & Places","subgroup":"place-geographic"},{"codes":"1F3DC FE0F","char":"🏜️","name":"desert","category":"Travel & Places (place-geographic)","group":"Travel & Places","subgroup":"place-geographic"},{"codes":"1F3DC","char":"🏜","name":"desert","category":"Travel & Places (place-geographic)","group":"Travel & Places","subgroup":"place-geographic"},{"codes":"1F3DD FE0F","char":"🏝️","name":"desert island","category":"Travel & Places (place-geographic)","group":"Travel & Places","subgroup":"place-geographic"},{"codes":"1F3DD","char":"🏝","name":"desert island","category":"Travel & Places (place-geographic)","group":"Travel & Places","subgroup":"place-geographic"},{"codes":"1F3DE FE0F","char":"🏞️","name":"national park","category":"Travel & Places (place-geographic)","group":"Travel & Places","subgroup":"place-geographic"},{"codes":"1F3DE","char":"🏞","name":"national park","category":"Travel & Places (place-geographic)","group":"Travel & Places","subgroup":"place-geographic"},{"codes":"1F3DF FE0F","char":"🏟️","name":"stadium","category":"Travel & Places (place-building)","group":"Travel & Places","subgroup":"place-building"},{"codes":"1F3DF","char":"🏟","name":"stadium","category":"Travel & Places (place-building)","group":"Travel & Places","subgroup":"place-building"},{"codes":"1F3DB FE0F","char":"🏛️","name":"classical building","category":"Travel & Places (place-building)","group":"Travel & Places","subgroup":"place-building"},{"codes":"1F3DB","char":"🏛","name":"classical building","category":"Travel & Places (place-building)","group":"Travel & Places","subgroup":"place-building"},{"codes":"1F3D7 FE0F","char":"🏗️","name":"building construction","category":"Travel & Places (place-building)","group":"Travel & Places","subgroup":"place-building"},{"codes":"1F3D7","char":"🏗","name":"building construction","category":"Travel & Places (place-building)","group":"Travel & Places","subgroup":"place-building"},{"codes":"1F9F1","char":"🧱","name":"brick","category":"Travel & Places (place-building)","group":"Travel & Places","subgroup":"place-building"},{"codes":"1FAA8","char":"🪨","name":"rock","category":"Travel & Places (place-building)","group":"Travel & Places","subgroup":"place-building"},{"codes":"1FAB5","char":"🪵","name":"wood","category":"Travel & Places (place-building)","group":"Travel & Places","subgroup":"place-building"},{"codes":"1F6D6","char":"🛖","name":"hut","category":"Travel & Places (place-building)","group":"Travel & Places","subgroup":"place-building"},{"codes":"1F3D8 FE0F","char":"🏘️","name":"houses","category":"Travel & Places (place-building)","group":"Travel & Places","subgroup":"place-building"},{"codes":"1F3D8","char":"🏘","name":"houses","category":"Travel & Places (place-building)","group":"Travel & Places","subgroup":"place-building"},{"codes":"1F3DA FE0F","char":"🏚️","name":"derelict house","category":"Travel & Places (place-building)","group":"Travel & Places","subgroup":"place-building"},{"codes":"1F3DA","char":"🏚","name":"derelict house","category":"Travel & Places (place-building)","group":"Travel & Places","subgroup":"place-building"},{"codes":"1F3E0","char":"🏠","name":"house","category":"Travel & Places (place-building)","group":"Travel & Places","subgroup":"place-building"},{"codes":"1F3E1","char":"🏡","name":"house with garden","category":"Travel & Places (place-building)","group":"Travel & Places","subgroup":"place-building"},{"codes":"1F3E2","char":"🏢","name":"office building","category":"Travel & Places (place-building)","group":"Travel & Places","subgroup":"place-building"},{"codes":"1F3E3","char":"🏣","name":"Japanese post office","category":"Travel & Places (place-building)","group":"Travel & Places","subgroup":"place-building"},{"codes":"1F3E4","char":"🏤","name":"post office","category":"Travel & Places (place-building)","group":"Travel & Places","subgroup":"place-building"},{"codes":"1F3E5","char":"🏥","name":"hospital","category":"Travel & Places (place-building)","group":"Travel & Places","subgroup":"place-building"},{"codes":"1F3E6","char":"🏦","name":"bank","category":"Travel & Places (place-building)","group":"Travel & Places","subgroup":"place-building"},{"codes":"1F3E8","char":"🏨","name":"hotel","category":"Travel & Places (place-building)","group":"Travel & Places","subgroup":"place-building"},{"codes":"1F3E9","char":"🏩","name":"love hotel","category":"Travel & Places (place-building)","group":"Travel & Places","subgroup":"place-building"},{"codes":"1F3EA","char":"🏪","name":"convenience store","category":"Travel & Places (place-building)","group":"Travel & Places","subgroup":"place-building"},{"codes":"1F3EB","char":"🏫","name":"school","category":"Travel & Places (place-building)","group":"Travel & Places","subgroup":"place-building"},{"codes":"1F3EC","char":"🏬","name":"department store","category":"Travel & Places (place-building)","group":"Travel & Places","subgroup":"place-building"},{"codes":"1F3ED","char":"🏭","name":"factory","category":"Travel & Places (place-building)","group":"Travel & Places","subgroup":"place-building"},{"codes":"1F3EF","char":"🏯","name":"Japanese castle","category":"Travel & Places (place-building)","group":"Travel & Places","subgroup":"place-building"},{"codes":"1F3F0","char":"🏰","name":"castle","category":"Travel & Places (place-building)","group":"Travel & Places","subgroup":"place-building"},{"codes":"1F492","char":"💒","name":"wedding","category":"Travel & Places (place-building)","group":"Travel & Places","subgroup":"place-building"},{"codes":"1F5FC","char":"🗼","name":"Tokyo tower","category":"Travel & Places (place-building)","group":"Travel & Places","subgroup":"place-building"},{"codes":"1F5FD","char":"🗽","name":"Statue of Liberty","category":"Travel & Places (place-building)","group":"Travel & Places","subgroup":"place-building"},{"codes":"26EA","char":"⛪","name":"church","category":"Travel & Places (place-religious)","group":"Travel & Places","subgroup":"place-religious"},{"codes":"1F54C","char":"🕌","name":"mosque","category":"Travel & Places (place-religious)","group":"Travel & Places","subgroup":"place-religious"},{"codes":"1F6D5","char":"🛕","name":"hindu temple","category":"Travel & Places (place-religious)","group":"Travel & Places","subgroup":"place-religious"},{"codes":"1F54D","char":"🕍","name":"synagogue","category":"Travel & Places (place-religious)","group":"Travel & Places","subgroup":"place-religious"},{"codes":"26E9 FE0F","char":"⛩️","name":"shinto shrine","category":"Travel & Places (place-religious)","group":"Travel & Places","subgroup":"place-religious"},{"codes":"26E9","char":"⛩","name":"shinto shrine","category":"Travel & Places (place-religious)","group":"Travel & Places","subgroup":"place-religious"},{"codes":"1F54B","char":"🕋","name":"kaaba","category":"Travel & Places (place-religious)","group":"Travel & Places","subgroup":"place-religious"},{"codes":"26F2","char":"⛲","name":"fountain","category":"Travel & Places (place-other)","group":"Travel & Places","subgroup":"place-other"},{"codes":"26FA","char":"⛺","name":"tent","category":"Travel & Places (place-other)","group":"Travel & Places","subgroup":"place-other"},{"codes":"1F301","char":"🌁","name":"foggy","category":"Travel & Places (place-other)","group":"Travel & Places","subgroup":"place-other"},{"codes":"1F303","char":"🌃","name":"night with stars","category":"Travel & Places (place-other)","group":"Travel & Places","subgroup":"place-other"},{"codes":"1F3D9 FE0F","char":"🏙️","name":"cityscape","category":"Travel & Places (place-other)","group":"Travel & Places","subgroup":"place-other"},{"codes":"1F3D9","char":"🏙","name":"cityscape","category":"Travel & Places (place-other)","group":"Travel & Places","subgroup":"place-other"},{"codes":"1F304","char":"🌄","name":"sunrise over mountains","category":"Travel & Places (place-other)","group":"Travel & Places","subgroup":"place-other"},{"codes":"1F305","char":"🌅","name":"sunrise","category":"Travel & Places (place-other)","group":"Travel & Places","subgroup":"place-other"},{"codes":"1F306","char":"🌆","name":"cityscape at dusk","category":"Travel & Places (place-other)","group":"Travel & Places","subgroup":"place-other"},{"codes":"1F307","char":"🌇","name":"sunset","category":"Travel & Places (place-other)","group":"Travel & Places","subgroup":"place-other"},{"codes":"1F309","char":"🌉","name":"bridge at night","category":"Travel & Places (place-other)","group":"Travel & Places","subgroup":"place-other"},{"codes":"2668 FE0F","char":"♨️","name":"hot springs","category":"Travel & Places (place-other)","group":"Travel & Places","subgroup":"place-other"},{"codes":"2668","char":"♨","name":"hot springs","category":"Travel & Places (place-other)","group":"Travel & Places","subgroup":"place-other"},{"codes":"1F3A0","char":"🎠","name":"carousel horse","category":"Travel & Places (place-other)","group":"Travel & Places","subgroup":"place-other"},{"codes":"1F6DD","char":"🛝","name":"playground slide","category":"Travel & Places (place-other)","group":"Travel & Places","subgroup":"place-other"},{"codes":"1F3A1","char":"🎡","name":"ferris wheel","category":"Travel & Places (place-other)","group":"Travel & Places","subgroup":"place-other"},{"codes":"1F3A2","char":"🎢","name":"roller coaster","category":"Travel & Places (place-other)","group":"Travel & Places","subgroup":"place-other"},{"codes":"1F488","char":"💈","name":"barber pole","category":"Travel & Places (place-other)","group":"Travel & Places","subgroup":"place-other"},{"codes":"1F3AA","char":"🎪","name":"circus tent","category":"Travel & Places (place-other)","group":"Travel & Places","subgroup":"place-other"},{"codes":"1F682","char":"🚂","name":"locomotive","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F683","char":"🚃","name":"railway car","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F684","char":"🚄","name":"high-speed train","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F685","char":"🚅","name":"bullet train","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F686","char":"🚆","name":"train","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F687","char":"🚇","name":"metro","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F688","char":"🚈","name":"light rail","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F689","char":"🚉","name":"station","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F68A","char":"🚊","name":"tram","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F69D","char":"🚝","name":"monorail","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F69E","char":"🚞","name":"mountain railway","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F68B","char":"🚋","name":"tram car","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F68C","char":"🚌","name":"bus","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F68D","char":"🚍","name":"oncoming bus","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F68E","char":"🚎","name":"trolleybus","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F690","char":"🚐","name":"minibus","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F691","char":"🚑","name":"ambulance","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F692","char":"🚒","name":"fire engine","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F693","char":"🚓","name":"police car","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F694","char":"🚔","name":"oncoming police car","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F695","char":"🚕","name":"taxi","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F696","char":"🚖","name":"oncoming taxi","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F697","char":"🚗","name":"automobile","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F698","char":"🚘","name":"oncoming automobile","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F699","char":"🚙","name":"sport utility vehicle","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F6FB","char":"🛻","name":"pickup truck","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F69A","char":"🚚","name":"delivery truck","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F69B","char":"🚛","name":"articulated lorry","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F69C","char":"🚜","name":"tractor","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F3CE FE0F","char":"🏎️","name":"racing car","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F3CE","char":"🏎","name":"racing car","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F3CD FE0F","char":"🏍️","name":"motorcycle","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F3CD","char":"🏍","name":"motorcycle","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F6F5","char":"🛵","name":"motor scooter","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F9BD","char":"🦽","name":"manual wheelchair","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F9BC","char":"🦼","name":"motorized wheelchair","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F6FA","char":"🛺","name":"auto rickshaw","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F6B2","char":"🚲","name":"bicycle","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F6F4","char":"🛴","name":"kick scooter","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F6F9","char":"🛹","name":"skateboard","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F6FC","char":"🛼","name":"roller skate","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F68F","char":"🚏","name":"bus stop","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F6E3 FE0F","char":"🛣️","name":"motorway","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F6E3","char":"🛣","name":"motorway","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F6E4 FE0F","char":"🛤️","name":"railway track","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F6E4","char":"🛤","name":"railway track","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F6E2 FE0F","char":"🛢️","name":"oil drum","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F6E2","char":"🛢","name":"oil drum","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"26FD","char":"⛽","name":"fuel pump","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F6DE","char":"🛞","name":"wheel","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F6A8","char":"🚨","name":"police car light","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F6A5","char":"🚥","name":"horizontal traffic light","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F6A6","char":"🚦","name":"vertical traffic light","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F6D1","char":"🛑","name":"stop sign","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"1F6A7","char":"🚧","name":"construction","category":"Travel & Places (transport-ground)","group":"Travel & Places","subgroup":"transport-ground"},{"codes":"2693","char":"⚓","name":"anchor","category":"Travel & Places (transport-water)","group":"Travel & Places","subgroup":"transport-water"},{"codes":"1F6DF","char":"🛟","name":"ring buoy","category":"Travel & Places (transport-water)","group":"Travel & Places","subgroup":"transport-water"},{"codes":"26F5","char":"⛵","name":"sailboat","category":"Travel & Places (transport-water)","group":"Travel & Places","subgroup":"transport-water"},{"codes":"1F6F6","char":"🛶","name":"canoe","category":"Travel & Places (transport-water)","group":"Travel & Places","subgroup":"transport-water"},{"codes":"1F6A4","char":"🚤","name":"speedboat","category":"Travel & Places (transport-water)","group":"Travel & Places","subgroup":"transport-water"},{"codes":"1F6F3 FE0F","char":"🛳️","name":"passenger ship","category":"Travel & Places (transport-water)","group":"Travel & Places","subgroup":"transport-water"},{"codes":"1F6F3","char":"🛳","name":"passenger ship","category":"Travel & Places (transport-water)","group":"Travel & Places","subgroup":"transport-water"},{"codes":"26F4 FE0F","char":"⛴️","name":"ferry","category":"Travel & Places (transport-water)","group":"Travel & Places","subgroup":"transport-water"},{"codes":"26F4","char":"⛴","name":"ferry","category":"Travel & Places (transport-water)","group":"Travel & Places","subgroup":"transport-water"},{"codes":"1F6E5 FE0F","char":"🛥️","name":"motor boat","category":"Travel & Places (transport-water)","group":"Travel & Places","subgroup":"transport-water"},{"codes":"1F6E5","char":"🛥","name":"motor boat","category":"Travel & Places (transport-water)","group":"Travel & Places","subgroup":"transport-water"},{"codes":"1F6A2","char":"🚢","name":"ship","category":"Travel & Places (transport-water)","group":"Travel & Places","subgroup":"transport-water"},{"codes":"2708 FE0F","char":"✈️","name":"airplane","category":"Travel & Places (transport-air)","group":"Travel & Places","subgroup":"transport-air"},{"codes":"2708","char":"✈","name":"airplane","category":"Travel & Places (transport-air)","group":"Travel & Places","subgroup":"transport-air"},{"codes":"1F6E9 FE0F","char":"🛩️","name":"small airplane","category":"Travel & Places (transport-air)","group":"Travel & Places","subgroup":"transport-air"},{"codes":"1F6E9","char":"🛩","name":"small airplane","category":"Travel & Places (transport-air)","group":"Travel & Places","subgroup":"transport-air"},{"codes":"1F6EB","char":"🛫","name":"airplane departure","category":"Travel & Places (transport-air)","group":"Travel & Places","subgroup":"transport-air"},{"codes":"1F6EC","char":"🛬","name":"airplane arrival","category":"Travel & Places (transport-air)","group":"Travel & Places","subgroup":"transport-air"},{"codes":"1FA82","char":"🪂","name":"parachute","category":"Travel & Places (transport-air)","group":"Travel & Places","subgroup":"transport-air"},{"codes":"1F4BA","char":"💺","name":"seat","category":"Travel & Places (transport-air)","group":"Travel & Places","subgroup":"transport-air"},{"codes":"1F681","char":"🚁","name":"helicopter","category":"Travel & Places (transport-air)","group":"Travel & Places","subgroup":"transport-air"},{"codes":"1F69F","char":"🚟","name":"suspension railway","category":"Travel & Places (transport-air)","group":"Travel & Places","subgroup":"transport-air"},{"codes":"1F6A0","char":"🚠","name":"mountain cableway","category":"Travel & Places (transport-air)","group":"Travel & Places","subgroup":"transport-air"},{"codes":"1F6A1","char":"🚡","name":"aerial tramway","category":"Travel & Places (transport-air)","group":"Travel & Places","subgroup":"transport-air"},{"codes":"1F6F0 FE0F","char":"🛰️","name":"satellite","category":"Travel & Places (transport-air)","group":"Travel & Places","subgroup":"transport-air"},{"codes":"1F6F0","char":"🛰","name":"satellite","category":"Travel & Places (transport-air)","group":"Travel & Places","subgroup":"transport-air"},{"codes":"1F680","char":"🚀","name":"rocket","category":"Travel & Places (transport-air)","group":"Travel & Places","subgroup":"transport-air"},{"codes":"1F6F8","char":"🛸","name":"flying saucer","category":"Travel & Places (transport-air)","group":"Travel & Places","subgroup":"transport-air"},{"codes":"1F6CE FE0F","char":"🛎️","name":"bellhop bell","category":"Travel & Places (hotel)","group":"Travel & Places","subgroup":"hotel"},{"codes":"1F6CE","char":"🛎","name":"bellhop bell","category":"Travel & Places (hotel)","group":"Travel & Places","subgroup":"hotel"},{"codes":"1F9F3","char":"🧳","name":"luggage","category":"Travel & Places (hotel)","group":"Travel & Places","subgroup":"hotel"},{"codes":"231B","char":"⌛","name":"hourglass done","category":"Travel & Places (time)","group":"Travel & Places","subgroup":"time"},{"codes":"23F3","char":"⏳","name":"hourglass not done","category":"Travel & Places (time)","group":"Travel & Places","subgroup":"time"},{"codes":"231A","char":"⌚","name":"watch","category":"Travel & Places (time)","group":"Travel & Places","subgroup":"time"},{"codes":"23F0","char":"⏰","name":"alarm clock","category":"Travel & Places (time)","group":"Travel & Places","subgroup":"time"},{"codes":"23F1 FE0F","char":"⏱️","name":"stopwatch","category":"Travel & Places (time)","group":"Travel & Places","subgroup":"time"},{"codes":"23F1","char":"⏱","name":"stopwatch","category":"Travel & Places (time)","group":"Travel & Places","subgroup":"time"},{"codes":"23F2 FE0F","char":"⏲️","name":"timer clock","category":"Travel & Places (time)","group":"Travel & Places","subgroup":"time"},{"codes":"23F2","char":"⏲","name":"timer clock","category":"Travel & Places (time)","group":"Travel & Places","subgroup":"time"},{"codes":"1F570 FE0F","char":"🕰️","name":"mantelpiece clock","category":"Travel & Places (time)","group":"Travel & Places","subgroup":"time"},{"codes":"1F570","char":"🕰","name":"mantelpiece clock","category":"Travel & Places (time)","group":"Travel & Places","subgroup":"time"},{"codes":"1F55B","char":"🕛","name":"twelve o’clock","category":"Travel & Places (time)","group":"Travel & Places","subgroup":"time"},{"codes":"1F567","char":"🕧","name":"twelve-thirty","category":"Travel & Places (time)","group":"Travel & Places","subgroup":"time"},{"codes":"1F550","char":"🕐","name":"one o’clock","category":"Travel & Places (time)","group":"Travel & Places","subgroup":"time"},{"codes":"1F55C","char":"🕜","name":"one-thirty","category":"Travel & Places (time)","group":"Travel & Places","subgroup":"time"},{"codes":"1F551","char":"🕑","name":"two o’clock","category":"Travel & Places (time)","group":"Travel & Places","subgroup":"time"},{"codes":"1F55D","char":"🕝","name":"two-thirty","category":"Travel & Places (time)","group":"Travel & Places","subgroup":"time"},{"codes":"1F552","char":"🕒","name":"three o’clock","category":"Travel & Places (time)","group":"Travel & Places","subgroup":"time"},{"codes":"1F55E","char":"🕞","name":"three-thirty","category":"Travel & Places (time)","group":"Travel & Places","subgroup":"time"},{"codes":"1F553","char":"🕓","name":"four o’clock","category":"Travel & Places (time)","group":"Travel & Places","subgroup":"time"},{"codes":"1F55F","char":"🕟","name":"four-thirty","category":"Travel & Places (time)","group":"Travel & Places","subgroup":"time"},{"codes":"1F554","char":"🕔","name":"five o’clock","category":"Travel & Places (time)","group":"Travel & Places","subgroup":"time"},{"codes":"1F560","char":"🕠","name":"five-thirty","category":"Travel & Places (time)","group":"Travel & Places","subgroup":"time"},{"codes":"1F555","char":"🕕","name":"six o’clock","category":"Travel & Places (time)","group":"Travel & Places","subgroup":"time"},{"codes":"1F561","char":"🕡","name":"six-thirty","category":"Travel & Places (time)","group":"Travel & Places","subgroup":"time"},{"codes":"1F556","char":"🕖","name":"seven o’clock","category":"Travel & Places (time)","group":"Travel & Places","subgroup":"time"},{"codes":"1F562","char":"🕢","name":"seven-thirty","category":"Travel & Places (time)","group":"Travel & Places","subgroup":"time"},{"codes":"1F557","char":"🕗","name":"eight o’clock","category":"Travel & Places (time)","group":"Travel & Places","subgroup":"time"},{"codes":"1F563","char":"🕣","name":"eight-thirty","category":"Travel & Places (time)","group":"Travel & Places","subgroup":"time"},{"codes":"1F558","char":"🕘","name":"nine o’clock","category":"Travel & Places (time)","group":"Travel & Places","subgroup":"time"},{"codes":"1F564","char":"🕤","name":"nine-thirty","category":"Travel & Places (time)","group":"Travel & Places","subgroup":"time"},{"codes":"1F559","char":"🕙","name":"ten o’clock","category":"Travel & Places (time)","group":"Travel & Places","subgroup":"time"},{"codes":"1F565","char":"🕥","name":"ten-thirty","category":"Travel & Places (time)","group":"Travel & Places","subgroup":"time"},{"codes":"1F55A","char":"🕚","name":"eleven o’clock","category":"Travel & Places (time)","group":"Travel & Places","subgroup":"time"},{"codes":"1F566","char":"🕦","name":"eleven-thirty","category":"Travel & Places (time)","group":"Travel & Places","subgroup":"time"},{"codes":"1F311","char":"🌑","name":"new moon","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F312","char":"🌒","name":"waxing crescent moon","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F313","char":"🌓","name":"first quarter moon","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F314","char":"🌔","name":"waxing gibbous moon","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F315","char":"🌕","name":"full moon","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F316","char":"🌖","name":"waning gibbous moon","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F317","char":"🌗","name":"last quarter moon","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F318","char":"🌘","name":"waning crescent moon","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F319","char":"🌙","name":"crescent moon","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F31A","char":"🌚","name":"new moon face","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F31B","char":"🌛","name":"first quarter moon face","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F31C","char":"🌜","name":"last quarter moon face","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F321 FE0F","char":"🌡️","name":"thermometer","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F321","char":"🌡","name":"thermometer","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"2600 FE0F","char":"☀️","name":"sun","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"2600","char":"☀","name":"sun","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F31D","char":"🌝","name":"full moon face","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F31E","char":"🌞","name":"sun with face","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1FA90","char":"🪐","name":"ringed planet","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"2B50","char":"⭐","name":"star","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F31F","char":"🌟","name":"glowing star","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F320","char":"🌠","name":"shooting star","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F30C","char":"🌌","name":"milky way","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"2601 FE0F","char":"☁️","name":"cloud","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"2601","char":"☁","name":"cloud","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"26C5","char":"⛅","name":"sun behind cloud","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"26C8 FE0F","char":"⛈️","name":"cloud with lightning and rain","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"26C8","char":"⛈","name":"cloud with lightning and rain","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F324 FE0F","char":"🌤️","name":"sun behind small cloud","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F324","char":"🌤","name":"sun behind small cloud","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F325 FE0F","char":"🌥️","name":"sun behind large cloud","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F325","char":"🌥","name":"sun behind large cloud","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F326 FE0F","char":"🌦️","name":"sun behind rain cloud","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F326","char":"🌦","name":"sun behind rain cloud","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F327 FE0F","char":"🌧️","name":"cloud with rain","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F327","char":"🌧","name":"cloud with rain","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F328 FE0F","char":"🌨️","name":"cloud with snow","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F328","char":"🌨","name":"cloud with snow","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F329 FE0F","char":"🌩️","name":"cloud with lightning","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F329","char":"🌩","name":"cloud with lightning","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F32A FE0F","char":"🌪️","name":"tornado","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F32A","char":"🌪","name":"tornado","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F32B FE0F","char":"🌫️","name":"fog","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F32B","char":"🌫","name":"fog","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F32C FE0F","char":"🌬️","name":"wind face","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F32C","char":"🌬","name":"wind face","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F300","char":"🌀","name":"cyclone","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F308","char":"🌈","name":"rainbow","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F302","char":"🌂","name":"closed umbrella","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"2602 FE0F","char":"☂️","name":"umbrella","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"2602","char":"☂","name":"umbrella","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"2614","char":"☔","name":"umbrella with rain drops","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"26F1 FE0F","char":"⛱️","name":"umbrella on ground","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"26F1","char":"⛱","name":"umbrella on ground","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"26A1","char":"⚡","name":"high voltage","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"2744 FE0F","char":"❄️","name":"snowflake","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"2744","char":"❄","name":"snowflake","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"2603 FE0F","char":"☃️","name":"snowman","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"2603","char":"☃","name":"snowman","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"26C4","char":"⛄","name":"snowman without snow","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"2604 FE0F","char":"☄️","name":"comet","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"2604","char":"☄","name":"comet","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F525","char":"🔥","name":"fire","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F4A7","char":"💧","name":"droplet","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F30A","char":"🌊","name":"water wave","category":"Travel & Places (sky & weather)","group":"Travel & Places","subgroup":"sky & weather"},{"codes":"1F383","char":"🎃","name":"jack-o-lantern","category":"Activities (event)","group":"Activities","subgroup":"event"},{"codes":"1F384","char":"🎄","name":"Christmas tree","category":"Activities (event)","group":"Activities","subgroup":"event"},{"codes":"1F386","char":"🎆","name":"fireworks","category":"Activities (event)","group":"Activities","subgroup":"event"},{"codes":"1F387","char":"🎇","name":"sparkler","category":"Activities (event)","group":"Activities","subgroup":"event"},{"codes":"1F9E8","char":"🧨","name":"firecracker","category":"Activities (event)","group":"Activities","subgroup":"event"},{"codes":"2728","char":"✨","name":"sparkles","category":"Activities (event)","group":"Activities","subgroup":"event"},{"codes":"1F388","char":"🎈","name":"balloon","category":"Activities (event)","group":"Activities","subgroup":"event"},{"codes":"1F389","char":"🎉","name":"party popper","category":"Activities (event)","group":"Activities","subgroup":"event"},{"codes":"1F38A","char":"🎊","name":"confetti ball","category":"Activities (event)","group":"Activities","subgroup":"event"},{"codes":"1F38B","char":"🎋","name":"tanabata tree","category":"Activities (event)","group":"Activities","subgroup":"event"},{"codes":"1F38D","char":"🎍","name":"pine decoration","category":"Activities (event)","group":"Activities","subgroup":"event"},{"codes":"1F38E","char":"🎎","name":"Japanese dolls","category":"Activities (event)","group":"Activities","subgroup":"event"},{"codes":"1F38F","char":"🎏","name":"carp streamer","category":"Activities (event)","group":"Activities","subgroup":"event"},{"codes":"1F390","char":"🎐","name":"wind chime","category":"Activities (event)","group":"Activities","subgroup":"event"},{"codes":"1F391","char":"🎑","name":"moon viewing ceremony","category":"Activities (event)","group":"Activities","subgroup":"event"},{"codes":"1F9E7","char":"🧧","name":"red envelope","category":"Activities (event)","group":"Activities","subgroup":"event"},{"codes":"1F380","char":"🎀","name":"ribbon","category":"Activities (event)","group":"Activities","subgroup":"event"},{"codes":"1F381","char":"🎁","name":"wrapped gift","category":"Activities (event)","group":"Activities","subgroup":"event"},{"codes":"1F397 FE0F","char":"🎗️","name":"reminder ribbon","category":"Activities (event)","group":"Activities","subgroup":"event"},{"codes":"1F397","char":"🎗","name":"reminder ribbon","category":"Activities (event)","group":"Activities","subgroup":"event"},{"codes":"1F39F FE0F","char":"🎟️","name":"admission tickets","category":"Activities (event)","group":"Activities","subgroup":"event"},{"codes":"1F39F","char":"🎟","name":"admission tickets","category":"Activities (event)","group":"Activities","subgroup":"event"},{"codes":"1F3AB","char":"🎫","name":"ticket","category":"Activities (event)","group":"Activities","subgroup":"event"},{"codes":"1F396 FE0F","char":"🎖️","name":"military medal","category":"Activities (award-medal)","group":"Activities","subgroup":"award-medal"},{"codes":"1F396","char":"🎖","name":"military medal","category":"Activities (award-medal)","group":"Activities","subgroup":"award-medal"},{"codes":"1F3C6","char":"🏆","name":"trophy","category":"Activities (award-medal)","group":"Activities","subgroup":"award-medal"},{"codes":"1F3C5","char":"🏅","name":"sports medal","category":"Activities (award-medal)","group":"Activities","subgroup":"award-medal"},{"codes":"1F947","char":"🥇","name":"1st place medal","category":"Activities (award-medal)","group":"Activities","subgroup":"award-medal"},{"codes":"1F948","char":"🥈","name":"2nd place medal","category":"Activities (award-medal)","group":"Activities","subgroup":"award-medal"},{"codes":"1F949","char":"🥉","name":"3rd place medal","category":"Activities (award-medal)","group":"Activities","subgroup":"award-medal"},{"codes":"26BD","char":"⚽","name":"soccer ball","category":"Activities (sport)","group":"Activities","subgroup":"sport"},{"codes":"26BE","char":"⚾","name":"baseball","category":"Activities (sport)","group":"Activities","subgroup":"sport"},{"codes":"1F94E","char":"🥎","name":"softball","category":"Activities (sport)","group":"Activities","subgroup":"sport"},{"codes":"1F3C0","char":"🏀","name":"basketball","category":"Activities (sport)","group":"Activities","subgroup":"sport"},{"codes":"1F3D0","char":"🏐","name":"volleyball","category":"Activities (sport)","group":"Activities","subgroup":"sport"},{"codes":"1F3C8","char":"🏈","name":"american football","category":"Activities (sport)","group":"Activities","subgroup":"sport"},{"codes":"1F3C9","char":"🏉","name":"rugby football","category":"Activities (sport)","group":"Activities","subgroup":"sport"},{"codes":"1F3BE","char":"🎾","name":"tennis","category":"Activities (sport)","group":"Activities","subgroup":"sport"},{"codes":"1F94F","char":"🥏","name":"flying disc","category":"Activities (sport)","group":"Activities","subgroup":"sport"},{"codes":"1F3B3","char":"🎳","name":"bowling","category":"Activities (sport)","group":"Activities","subgroup":"sport"},{"codes":"1F3CF","char":"🏏","name":"cricket game","category":"Activities (sport)","group":"Activities","subgroup":"sport"},{"codes":"1F3D1","char":"🏑","name":"field hockey","category":"Activities (sport)","group":"Activities","subgroup":"sport"},{"codes":"1F3D2","char":"🏒","name":"ice hockey","category":"Activities (sport)","group":"Activities","subgroup":"sport"},{"codes":"1F94D","char":"🥍","name":"lacrosse","category":"Activities (sport)","group":"Activities","subgroup":"sport"},{"codes":"1F3D3","char":"🏓","name":"ping pong","category":"Activities (sport)","group":"Activities","subgroup":"sport"},{"codes":"1F3F8","char":"🏸","name":"badminton","category":"Activities (sport)","group":"Activities","subgroup":"sport"},{"codes":"1F94A","char":"🥊","name":"boxing glove","category":"Activities (sport)","group":"Activities","subgroup":"sport"},{"codes":"1F94B","char":"🥋","name":"martial arts uniform","category":"Activities (sport)","group":"Activities","subgroup":"sport"},{"codes":"1F945","char":"🥅","name":"goal net","category":"Activities (sport)","group":"Activities","subgroup":"sport"},{"codes":"26F3","char":"⛳","name":"flag in hole","category":"Activities (sport)","group":"Activities","subgroup":"sport"},{"codes":"26F8 FE0F","char":"⛸️","name":"ice skate","category":"Activities (sport)","group":"Activities","subgroup":"sport"},{"codes":"26F8","char":"⛸","name":"ice skate","category":"Activities (sport)","group":"Activities","subgroup":"sport"},{"codes":"1F3A3","char":"🎣","name":"fishing pole","category":"Activities (sport)","group":"Activities","subgroup":"sport"},{"codes":"1F93F","char":"🤿","name":"diving mask","category":"Activities (sport)","group":"Activities","subgroup":"sport"},{"codes":"1F3BD","char":"🎽","name":"running shirt","category":"Activities (sport)","group":"Activities","subgroup":"sport"},{"codes":"1F3BF","char":"🎿","name":"skis","category":"Activities (sport)","group":"Activities","subgroup":"sport"},{"codes":"1F6F7","char":"🛷","name":"sled","category":"Activities (sport)","group":"Activities","subgroup":"sport"},{"codes":"1F94C","char":"🥌","name":"curling stone","category":"Activities (sport)","group":"Activities","subgroup":"sport"},{"codes":"1F3AF","char":"🎯","name":"bullseye","category":"Activities (game)","group":"Activities","subgroup":"game"},{"codes":"1FA80","char":"🪀","name":"yo-yo","category":"Activities (game)","group":"Activities","subgroup":"game"},{"codes":"1FA81","char":"🪁","name":"kite","category":"Activities (game)","group":"Activities","subgroup":"game"},{"codes":"1F52B","char":"🔫","name":"water pistol","category":"Activities (game)","group":"Activities","subgroup":"game"},{"codes":"1F3B1","char":"🎱","name":"pool 8 ball","category":"Activities (game)","group":"Activities","subgroup":"game"},{"codes":"1F52E","char":"🔮","name":"crystal ball","category":"Activities (game)","group":"Activities","subgroup":"game"},{"codes":"1FA84","char":"🪄","name":"magic wand","category":"Activities (game)","group":"Activities","subgroup":"game"},{"codes":"1F3AE","char":"🎮","name":"video game","category":"Activities (game)","group":"Activities","subgroup":"game"},{"codes":"1F579 FE0F","char":"🕹️","name":"joystick","category":"Activities (game)","group":"Activities","subgroup":"game"},{"codes":"1F579","char":"🕹","name":"joystick","category":"Activities (game)","group":"Activities","subgroup":"game"},{"codes":"1F3B0","char":"🎰","name":"slot machine","category":"Activities (game)","group":"Activities","subgroup":"game"},{"codes":"1F3B2","char":"🎲","name":"game die","category":"Activities (game)","group":"Activities","subgroup":"game"},{"codes":"1F9E9","char":"🧩","name":"puzzle piece","category":"Activities (game)","group":"Activities","subgroup":"game"},{"codes":"1F9F8","char":"🧸","name":"teddy bear","category":"Activities (game)","group":"Activities","subgroup":"game"},{"codes":"1FA85","char":"🪅","name":"piñata","category":"Activities (game)","group":"Activities","subgroup":"game"},{"codes":"1FAA9","char":"🪩","name":"mirror ball","category":"Activities (game)","group":"Activities","subgroup":"game"},{"codes":"1FA86","char":"🪆","name":"nesting dolls","category":"Activities (game)","group":"Activities","subgroup":"game"},{"codes":"2660 FE0F","char":"♠️","name":"spade suit","category":"Activities (game)","group":"Activities","subgroup":"game"},{"codes":"2660","char":"♠","name":"spade suit","category":"Activities (game)","group":"Activities","subgroup":"game"},{"codes":"2665 FE0F","char":"♥️","name":"heart suit","category":"Activities (game)","group":"Activities","subgroup":"game"},{"codes":"2665","char":"♥","name":"heart suit","category":"Activities (game)","group":"Activities","subgroup":"game"},{"codes":"2666 FE0F","char":"♦️","name":"diamond suit","category":"Activities (game)","group":"Activities","subgroup":"game"},{"codes":"2666","char":"♦","name":"diamond suit","category":"Activities (game)","group":"Activities","subgroup":"game"},{"codes":"2663 FE0F","char":"♣️","name":"club suit","category":"Activities (game)","group":"Activities","subgroup":"game"},{"codes":"2663","char":"♣","name":"club suit","category":"Activities (game)","group":"Activities","subgroup":"game"},{"codes":"265F FE0F","char":"♟️","name":"chess pawn","category":"Activities (game)","group":"Activities","subgroup":"game"},{"codes":"265F","char":"♟","name":"chess pawn","category":"Activities (game)","group":"Activities","subgroup":"game"},{"codes":"1F0CF","char":"🃏","name":"joker","category":"Activities (game)","group":"Activities","subgroup":"game"},{"codes":"1F004","char":"🀄","name":"mahjong red dragon","category":"Activities (game)","group":"Activities","subgroup":"game"},{"codes":"1F3B4","char":"🎴","name":"flower playing cards","category":"Activities (game)","group":"Activities","subgroup":"game"},{"codes":"1F3AD","char":"🎭","name":"performing arts","category":"Activities (arts & crafts)","group":"Activities","subgroup":"arts & crafts"},{"codes":"1F5BC FE0F","char":"🖼️","name":"framed picture","category":"Activities (arts & crafts)","group":"Activities","subgroup":"arts & crafts"},{"codes":"1F5BC","char":"🖼","name":"framed picture","category":"Activities (arts & crafts)","group":"Activities","subgroup":"arts & crafts"},{"codes":"1F3A8","char":"🎨","name":"artist palette","category":"Activities (arts & crafts)","group":"Activities","subgroup":"arts & crafts"},{"codes":"1F9F5","char":"🧵","name":"thread","category":"Activities (arts & crafts)","group":"Activities","subgroup":"arts & crafts"},{"codes":"1FAA1","char":"🪡","name":"sewing needle","category":"Activities (arts & crafts)","group":"Activities","subgroup":"arts & crafts"},{"codes":"1F9F6","char":"🧶","name":"yarn","category":"Activities (arts & crafts)","group":"Activities","subgroup":"arts & crafts"},{"codes":"1FAA2","char":"🪢","name":"knot","category":"Activities (arts & crafts)","group":"Activities","subgroup":"arts & crafts"},{"codes":"1F453","char":"👓","name":"glasses","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F576 FE0F","char":"🕶️","name":"sunglasses","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F576","char":"🕶","name":"sunglasses","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F97D","char":"🥽","name":"goggles","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F97C","char":"🥼","name":"lab coat","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F9BA","char":"🦺","name":"safety vest","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F454","char":"👔","name":"necktie","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F455","char":"👕","name":"t-shirt","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F456","char":"👖","name":"jeans","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F9E3","char":"🧣","name":"scarf","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F9E4","char":"🧤","name":"gloves","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F9E5","char":"🧥","name":"coat","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F9E6","char":"🧦","name":"socks","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F457","char":"👗","name":"dress","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F458","char":"👘","name":"kimono","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F97B","char":"🥻","name":"sari","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1FA71","char":"🩱","name":"one-piece swimsuit","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1FA72","char":"🩲","name":"briefs","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1FA73","char":"🩳","name":"shorts","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F459","char":"👙","name":"bikini","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F45A","char":"👚","name":"woman’s clothes","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1FAAD","char":"🪭","name":"folding hand fan","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F45B","char":"👛","name":"purse","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F45C","char":"👜","name":"handbag","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F45D","char":"👝","name":"clutch bag","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F6CD FE0F","char":"🛍️","name":"shopping bags","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F6CD","char":"🛍","name":"shopping bags","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F392","char":"🎒","name":"backpack","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1FA74","char":"🩴","name":"thong sandal","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F45E","char":"👞","name":"man’s shoe","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F45F","char":"👟","name":"running shoe","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F97E","char":"🥾","name":"hiking boot","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F97F","char":"🥿","name":"flat shoe","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F460","char":"👠","name":"high-heeled shoe","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F461","char":"👡","name":"woman’s sandal","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1FA70","char":"🩰","name":"ballet shoes","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F462","char":"👢","name":"woman’s boot","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1FAAE","char":"🪮","name":"hair pick","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F451","char":"👑","name":"crown","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F452","char":"👒","name":"woman’s hat","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F3A9","char":"🎩","name":"top hat","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F393","char":"🎓","name":"graduation cap","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F9E2","char":"🧢","name":"billed cap","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1FA96","char":"🪖","name":"military helmet","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"26D1 FE0F","char":"⛑️","name":"rescue worker’s helmet","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"26D1","char":"⛑","name":"rescue worker’s helmet","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F4FF","char":"📿","name":"prayer beads","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F484","char":"💄","name":"lipstick","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F48D","char":"💍","name":"ring","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F48E","char":"💎","name":"gem stone","category":"Objects (clothing)","group":"Objects","subgroup":"clothing"},{"codes":"1F507","char":"🔇","name":"muted speaker","category":"Objects (sound)","group":"Objects","subgroup":"sound"},{"codes":"1F508","char":"🔈","name":"speaker low volume","category":"Objects (sound)","group":"Objects","subgroup":"sound"},{"codes":"1F509","char":"🔉","name":"speaker medium volume","category":"Objects (sound)","group":"Objects","subgroup":"sound"},{"codes":"1F50A","char":"🔊","name":"speaker high volume","category":"Objects (sound)","group":"Objects","subgroup":"sound"},{"codes":"1F4E2","char":"📢","name":"loudspeaker","category":"Objects (sound)","group":"Objects","subgroup":"sound"},{"codes":"1F4E3","char":"📣","name":"megaphone","category":"Objects (sound)","group":"Objects","subgroup":"sound"},{"codes":"1F4EF","char":"📯","name":"postal horn","category":"Objects (sound)","group":"Objects","subgroup":"sound"},{"codes":"1F514","char":"🔔","name":"bell","category":"Objects (sound)","group":"Objects","subgroup":"sound"},{"codes":"1F515","char":"🔕","name":"bell with slash","category":"Objects (sound)","group":"Objects","subgroup":"sound"},{"codes":"1F3BC","char":"🎼","name":"musical score","category":"Objects (music)","group":"Objects","subgroup":"music"},{"codes":"1F3B5","char":"🎵","name":"musical note","category":"Objects (music)","group":"Objects","subgroup":"music"},{"codes":"1F3B6","char":"🎶","name":"musical notes","category":"Objects (music)","group":"Objects","subgroup":"music"},{"codes":"1F399 FE0F","char":"🎙️","name":"studio microphone","category":"Objects (music)","group":"Objects","subgroup":"music"},{"codes":"1F399","char":"🎙","name":"studio microphone","category":"Objects (music)","group":"Objects","subgroup":"music"},{"codes":"1F39A FE0F","char":"🎚️","name":"level slider","category":"Objects (music)","group":"Objects","subgroup":"music"},{"codes":"1F39A","char":"🎚","name":"level slider","category":"Objects (music)","group":"Objects","subgroup":"music"},{"codes":"1F39B FE0F","char":"🎛️","name":"control knobs","category":"Objects (music)","group":"Objects","subgroup":"music"},{"codes":"1F39B","char":"🎛","name":"control knobs","category":"Objects (music)","group":"Objects","subgroup":"music"},{"codes":"1F3A4","char":"🎤","name":"microphone","category":"Objects (music)","group":"Objects","subgroup":"music"},{"codes":"1F3A7","char":"🎧","name":"headphone","category":"Objects (music)","group":"Objects","subgroup":"music"},{"codes":"1F4FB","char":"📻","name":"radio","category":"Objects (music)","group":"Objects","subgroup":"music"},{"codes":"1F3B7","char":"🎷","name":"saxophone","category":"Objects (musical-instrument)","group":"Objects","subgroup":"musical-instrument"},{"codes":"1FA97","char":"🪗","name":"accordion","category":"Objects (musical-instrument)","group":"Objects","subgroup":"musical-instrument"},{"codes":"1F3B8","char":"🎸","name":"guitar","category":"Objects (musical-instrument)","group":"Objects","subgroup":"musical-instrument"},{"codes":"1F3B9","char":"🎹","name":"musical keyboard","category":"Objects (musical-instrument)","group":"Objects","subgroup":"musical-instrument"},{"codes":"1F3BA","char":"🎺","name":"trumpet","category":"Objects (musical-instrument)","group":"Objects","subgroup":"musical-instrument"},{"codes":"1F3BB","char":"🎻","name":"violin","category":"Objects (musical-instrument)","group":"Objects","subgroup":"musical-instrument"},{"codes":"1FA95","char":"🪕","name":"banjo","category":"Objects (musical-instrument)","group":"Objects","subgroup":"musical-instrument"},{"codes":"1F941","char":"🥁","name":"drum","category":"Objects (musical-instrument)","group":"Objects","subgroup":"musical-instrument"},{"codes":"1FA98","char":"🪘","name":"long drum","category":"Objects (musical-instrument)","group":"Objects","subgroup":"musical-instrument"},{"codes":"1FA87","char":"🪇","name":"maracas","category":"Objects (musical-instrument)","group":"Objects","subgroup":"musical-instrument"},{"codes":"1FA88","char":"🪈","name":"flute","category":"Objects (musical-instrument)","group":"Objects","subgroup":"musical-instrument"},{"codes":"1F4F1","char":"📱","name":"mobile phone","category":"Objects (phone)","group":"Objects","subgroup":"phone"},{"codes":"1F4F2","char":"📲","name":"mobile phone with arrow","category":"Objects (phone)","group":"Objects","subgroup":"phone"},{"codes":"260E FE0F","char":"☎️","name":"telephone","category":"Objects (phone)","group":"Objects","subgroup":"phone"},{"codes":"260E","char":"☎","name":"telephone","category":"Objects (phone)","group":"Objects","subgroup":"phone"},{"codes":"1F4DE","char":"📞","name":"telephone receiver","category":"Objects (phone)","group":"Objects","subgroup":"phone"},{"codes":"1F4DF","char":"📟","name":"pager","category":"Objects (phone)","group":"Objects","subgroup":"phone"},{"codes":"1F4E0","char":"📠","name":"fax machine","category":"Objects (phone)","group":"Objects","subgroup":"phone"},{"codes":"1F50B","char":"🔋","name":"battery","category":"Objects (computer)","group":"Objects","subgroup":"computer"},{"codes":"1FAAB","char":"🪫","name":"low battery","category":"Objects (computer)","group":"Objects","subgroup":"computer"},{"codes":"1F50C","char":"🔌","name":"electric plug","category":"Objects (computer)","group":"Objects","subgroup":"computer"},{"codes":"1F4BB","char":"💻","name":"laptop","category":"Objects (computer)","group":"Objects","subgroup":"computer"},{"codes":"1F5A5 FE0F","char":"🖥️","name":"desktop computer","category":"Objects (computer)","group":"Objects","subgroup":"computer"},{"codes":"1F5A5","char":"🖥","name":"desktop computer","category":"Objects (computer)","group":"Objects","subgroup":"computer"},{"codes":"1F5A8 FE0F","char":"🖨️","name":"printer","category":"Objects (computer)","group":"Objects","subgroup":"computer"},{"codes":"1F5A8","char":"🖨","name":"printer","category":"Objects (computer)","group":"Objects","subgroup":"computer"},{"codes":"2328 FE0F","char":"⌨️","name":"keyboard","category":"Objects (computer)","group":"Objects","subgroup":"computer"},{"codes":"2328","char":"⌨","name":"keyboard","category":"Objects (computer)","group":"Objects","subgroup":"computer"},{"codes":"1F5B1 FE0F","char":"🖱️","name":"computer mouse","category":"Objects (computer)","group":"Objects","subgroup":"computer"},{"codes":"1F5B1","char":"🖱","name":"computer mouse","category":"Objects (computer)","group":"Objects","subgroup":"computer"},{"codes":"1F5B2 FE0F","char":"🖲️","name":"trackball","category":"Objects (computer)","group":"Objects","subgroup":"computer"},{"codes":"1F5B2","char":"🖲","name":"trackball","category":"Objects (computer)","group":"Objects","subgroup":"computer"},{"codes":"1F4BD","char":"💽","name":"computer disk","category":"Objects (computer)","group":"Objects","subgroup":"computer"},{"codes":"1F4BE","char":"💾","name":"floppy disk","category":"Objects (computer)","group":"Objects","subgroup":"computer"},{"codes":"1F4BF","char":"💿","name":"optical disk","category":"Objects (computer)","group":"Objects","subgroup":"computer"},{"codes":"1F4C0","char":"📀","name":"dvd","category":"Objects (computer)","group":"Objects","subgroup":"computer"},{"codes":"1F9EE","char":"🧮","name":"abacus","category":"Objects (computer)","group":"Objects","subgroup":"computer"},{"codes":"1F3A5","char":"🎥","name":"movie camera","category":"Objects (light & video)","group":"Objects","subgroup":"light & video"},{"codes":"1F39E FE0F","char":"🎞️","name":"film frames","category":"Objects (light & video)","group":"Objects","subgroup":"light & video"},{"codes":"1F39E","char":"🎞","name":"film frames","category":"Objects (light & video)","group":"Objects","subgroup":"light & video"},{"codes":"1F4FD FE0F","char":"📽️","name":"film projector","category":"Objects (light & video)","group":"Objects","subgroup":"light & video"},{"codes":"1F4FD","char":"📽","name":"film projector","category":"Objects (light & video)","group":"Objects","subgroup":"light & video"},{"codes":"1F3AC","char":"🎬","name":"clapper board","category":"Objects (light & video)","group":"Objects","subgroup":"light & video"},{"codes":"1F4FA","char":"📺","name":"television","category":"Objects (light & video)","group":"Objects","subgroup":"light & video"},{"codes":"1F4F7","char":"📷","name":"camera","category":"Objects (light & video)","group":"Objects","subgroup":"light & video"},{"codes":"1F4F8","char":"📸","name":"camera with flash","category":"Objects (light & video)","group":"Objects","subgroup":"light & video"},{"codes":"1F4F9","char":"📹","name":"video camera","category":"Objects (light & video)","group":"Objects","subgroup":"light & video"},{"codes":"1F4FC","char":"📼","name":"videocassette","category":"Objects (light & video)","group":"Objects","subgroup":"light & video"},{"codes":"1F50D","char":"🔍","name":"magnifying glass tilted left","category":"Objects (light & video)","group":"Objects","subgroup":"light & video"},{"codes":"1F50E","char":"🔎","name":"magnifying glass tilted right","category":"Objects (light & video)","group":"Objects","subgroup":"light & video"},{"codes":"1F56F FE0F","char":"🕯️","name":"candle","category":"Objects (light & video)","group":"Objects","subgroup":"light & video"},{"codes":"1F56F","char":"🕯","name":"candle","category":"Objects (light & video)","group":"Objects","subgroup":"light & video"},{"codes":"1F4A1","char":"💡","name":"light bulb","category":"Objects (light & video)","group":"Objects","subgroup":"light & video"},{"codes":"1F526","char":"🔦","name":"flashlight","category":"Objects (light & video)","group":"Objects","subgroup":"light & video"},{"codes":"1F3EE","char":"🏮","name":"red paper lantern","category":"Objects (light & video)","group":"Objects","subgroup":"light & video"},{"codes":"1FA94","char":"🪔","name":"diya lamp","category":"Objects (light & video)","group":"Objects","subgroup":"light & video"},{"codes":"1F4D4","char":"📔","name":"notebook with decorative cover","category":"Objects (book-paper)","group":"Objects","subgroup":"book-paper"},{"codes":"1F4D5","char":"📕","name":"closed book","category":"Objects (book-paper)","group":"Objects","subgroup":"book-paper"},{"codes":"1F4D6","char":"📖","name":"open book","category":"Objects (book-paper)","group":"Objects","subgroup":"book-paper"},{"codes":"1F4D7","char":"📗","name":"green book","category":"Objects (book-paper)","group":"Objects","subgroup":"book-paper"},{"codes":"1F4D8","char":"📘","name":"blue book","category":"Objects (book-paper)","group":"Objects","subgroup":"book-paper"},{"codes":"1F4D9","char":"📙","name":"orange book","category":"Objects (book-paper)","group":"Objects","subgroup":"book-paper"},{"codes":"1F4DA","char":"📚","name":"books","category":"Objects (book-paper)","group":"Objects","subgroup":"book-paper"},{"codes":"1F4D3","char":"📓","name":"notebook","category":"Objects (book-paper)","group":"Objects","subgroup":"book-paper"},{"codes":"1F4D2","char":"📒","name":"ledger","category":"Objects (book-paper)","group":"Objects","subgroup":"book-paper"},{"codes":"1F4C3","char":"📃","name":"page with curl","category":"Objects (book-paper)","group":"Objects","subgroup":"book-paper"},{"codes":"1F4DC","char":"📜","name":"scroll","category":"Objects (book-paper)","group":"Objects","subgroup":"book-paper"},{"codes":"1F4C4","char":"📄","name":"page facing up","category":"Objects (book-paper)","group":"Objects","subgroup":"book-paper"},{"codes":"1F4F0","char":"📰","name":"newspaper","category":"Objects (book-paper)","group":"Objects","subgroup":"book-paper"},{"codes":"1F5DE FE0F","char":"🗞️","name":"rolled-up newspaper","category":"Objects (book-paper)","group":"Objects","subgroup":"book-paper"},{"codes":"1F5DE","char":"🗞","name":"rolled-up newspaper","category":"Objects (book-paper)","group":"Objects","subgroup":"book-paper"},{"codes":"1F4D1","char":"📑","name":"bookmark tabs","category":"Objects (book-paper)","group":"Objects","subgroup":"book-paper"},{"codes":"1F516","char":"🔖","name":"bookmark","category":"Objects (book-paper)","group":"Objects","subgroup":"book-paper"},{"codes":"1F3F7 FE0F","char":"🏷️","name":"label","category":"Objects (book-paper)","group":"Objects","subgroup":"book-paper"},{"codes":"1F3F7","char":"🏷","name":"label","category":"Objects (book-paper)","group":"Objects","subgroup":"book-paper"},{"codes":"1F4B0","char":"💰","name":"money bag","category":"Objects (money)","group":"Objects","subgroup":"money"},{"codes":"1FA99","char":"🪙","name":"coin","category":"Objects (money)","group":"Objects","subgroup":"money"},{"codes":"1F4B4","char":"💴","name":"yen banknote","category":"Objects (money)","group":"Objects","subgroup":"money"},{"codes":"1F4B5","char":"💵","name":"dollar banknote","category":"Objects (money)","group":"Objects","subgroup":"money"},{"codes":"1F4B6","char":"💶","name":"euro banknote","category":"Objects (money)","group":"Objects","subgroup":"money"},{"codes":"1F4B7","char":"💷","name":"pound banknote","category":"Objects (money)","group":"Objects","subgroup":"money"},{"codes":"1F4B8","char":"💸","name":"money with wings","category":"Objects (money)","group":"Objects","subgroup":"money"},{"codes":"1F4B3","char":"💳","name":"credit card","category":"Objects (money)","group":"Objects","subgroup":"money"},{"codes":"1F9FE","char":"🧾","name":"receipt","category":"Objects (money)","group":"Objects","subgroup":"money"},{"codes":"1F4B9","char":"💹","name":"chart increasing with yen","category":"Objects (money)","group":"Objects","subgroup":"money"},{"codes":"2709 FE0F","char":"✉️","name":"envelope","category":"Objects (mail)","group":"Objects","subgroup":"mail"},{"codes":"2709","char":"✉","name":"envelope","category":"Objects (mail)","group":"Objects","subgroup":"mail"},{"codes":"1F4E7","char":"📧","name":"e-mail","category":"Objects (mail)","group":"Objects","subgroup":"mail"},{"codes":"1F4E8","char":"📨","name":"incoming envelope","category":"Objects (mail)","group":"Objects","subgroup":"mail"},{"codes":"1F4E9","char":"📩","name":"envelope with arrow","category":"Objects (mail)","group":"Objects","subgroup":"mail"},{"codes":"1F4E4","char":"📤","name":"outbox tray","category":"Objects (mail)","group":"Objects","subgroup":"mail"},{"codes":"1F4E5","char":"📥","name":"inbox tray","category":"Objects (mail)","group":"Objects","subgroup":"mail"},{"codes":"1F4E6","char":"📦","name":"package","category":"Objects (mail)","group":"Objects","subgroup":"mail"},{"codes":"1F4EB","char":"📫","name":"closed mailbox with raised flag","category":"Objects (mail)","group":"Objects","subgroup":"mail"},{"codes":"1F4EA","char":"📪","name":"closed mailbox with lowered flag","category":"Objects (mail)","group":"Objects","subgroup":"mail"},{"codes":"1F4EC","char":"📬","name":"open mailbox with raised flag","category":"Objects (mail)","group":"Objects","subgroup":"mail"},{"codes":"1F4ED","char":"📭","name":"open mailbox with lowered flag","category":"Objects (mail)","group":"Objects","subgroup":"mail"},{"codes":"1F4EE","char":"📮","name":"postbox","category":"Objects (mail)","group":"Objects","subgroup":"mail"},{"codes":"1F5F3 FE0F","char":"🗳️","name":"ballot box with ballot","category":"Objects (mail)","group":"Objects","subgroup":"mail"},{"codes":"1F5F3","char":"🗳","name":"ballot box with ballot","category":"Objects (mail)","group":"Objects","subgroup":"mail"},{"codes":"270F FE0F","char":"✏️","name":"pencil","category":"Objects (writing)","group":"Objects","subgroup":"writing"},{"codes":"270F","char":"✏","name":"pencil","category":"Objects (writing)","group":"Objects","subgroup":"writing"},{"codes":"2712 FE0F","char":"✒️","name":"black nib","category":"Objects (writing)","group":"Objects","subgroup":"writing"},{"codes":"2712","char":"✒","name":"black nib","category":"Objects (writing)","group":"Objects","subgroup":"writing"},{"codes":"1F58B FE0F","char":"🖋️","name":"fountain pen","category":"Objects (writing)","group":"Objects","subgroup":"writing"},{"codes":"1F58B","char":"🖋","name":"fountain pen","category":"Objects (writing)","group":"Objects","subgroup":"writing"},{"codes":"1F58A FE0F","char":"🖊️","name":"pen","category":"Objects (writing)","group":"Objects","subgroup":"writing"},{"codes":"1F58A","char":"🖊","name":"pen","category":"Objects (writing)","group":"Objects","subgroup":"writing"},{"codes":"1F58C FE0F","char":"🖌️","name":"paintbrush","category":"Objects (writing)","group":"Objects","subgroup":"writing"},{"codes":"1F58C","char":"🖌","name":"paintbrush","category":"Objects (writing)","group":"Objects","subgroup":"writing"},{"codes":"1F58D FE0F","char":"🖍️","name":"crayon","category":"Objects (writing)","group":"Objects","subgroup":"writing"},{"codes":"1F58D","char":"🖍","name":"crayon","category":"Objects (writing)","group":"Objects","subgroup":"writing"},{"codes":"1F4DD","char":"📝","name":"memo","category":"Objects (writing)","group":"Objects","subgroup":"writing"},{"codes":"1F4BC","char":"💼","name":"briefcase","category":"Objects (office)","group":"Objects","subgroup":"office"},{"codes":"1F4C1","char":"📁","name":"file folder","category":"Objects (office)","group":"Objects","subgroup":"office"},{"codes":"1F4C2","char":"📂","name":"open file folder","category":"Objects (office)","group":"Objects","subgroup":"office"},{"codes":"1F5C2 FE0F","char":"🗂️","name":"card index dividers","category":"Objects (office)","group":"Objects","subgroup":"office"},{"codes":"1F5C2","char":"🗂","name":"card index dividers","category":"Objects (office)","group":"Objects","subgroup":"office"},{"codes":"1F4C5","char":"📅","name":"calendar","category":"Objects (office)","group":"Objects","subgroup":"office"},{"codes":"1F4C6","char":"📆","name":"tear-off calendar","category":"Objects (office)","group":"Objects","subgroup":"office"},{"codes":"1F5D2 FE0F","char":"🗒️","name":"spiral notepad","category":"Objects (office)","group":"Objects","subgroup":"office"},{"codes":"1F5D2","char":"🗒","name":"spiral notepad","category":"Objects (office)","group":"Objects","subgroup":"office"},{"codes":"1F5D3 FE0F","char":"🗓️","name":"spiral calendar","category":"Objects (office)","group":"Objects","subgroup":"office"},{"codes":"1F5D3","char":"🗓","name":"spiral calendar","category":"Objects (office)","group":"Objects","subgroup":"office"},{"codes":"1F4C7","char":"📇","name":"card index","category":"Objects (office)","group":"Objects","subgroup":"office"},{"codes":"1F4C8","char":"📈","name":"chart increasing","category":"Objects (office)","group":"Objects","subgroup":"office"},{"codes":"1F4C9","char":"📉","name":"chart decreasing","category":"Objects (office)","group":"Objects","subgroup":"office"},{"codes":"1F4CA","char":"📊","name":"bar chart","category":"Objects (office)","group":"Objects","subgroup":"office"},{"codes":"1F4CB","char":"📋","name":"clipboard","category":"Objects (office)","group":"Objects","subgroup":"office"},{"codes":"1F4CC","char":"📌","name":"pushpin","category":"Objects (office)","group":"Objects","subgroup":"office"},{"codes":"1F4CD","char":"📍","name":"round pushpin","category":"Objects (office)","group":"Objects","subgroup":"office"},{"codes":"1F4CE","char":"📎","name":"paperclip","category":"Objects (office)","group":"Objects","subgroup":"office"},{"codes":"1F587 FE0F","char":"🖇️","name":"linked paperclips","category":"Objects (office)","group":"Objects","subgroup":"office"},{"codes":"1F587","char":"🖇","name":"linked paperclips","category":"Objects (office)","group":"Objects","subgroup":"office"},{"codes":"1F4CF","char":"📏","name":"straight ruler","category":"Objects (office)","group":"Objects","subgroup":"office"},{"codes":"1F4D0","char":"📐","name":"triangular ruler","category":"Objects (office)","group":"Objects","subgroup":"office"},{"codes":"2702 FE0F","char":"✂️","name":"scissors","category":"Objects (office)","group":"Objects","subgroup":"office"},{"codes":"2702","char":"✂","name":"scissors","category":"Objects (office)","group":"Objects","subgroup":"office"},{"codes":"1F5C3 FE0F","char":"🗃️","name":"card file box","category":"Objects (office)","group":"Objects","subgroup":"office"},{"codes":"1F5C3","char":"🗃","name":"card file box","category":"Objects (office)","group":"Objects","subgroup":"office"},{"codes":"1F5C4 FE0F","char":"🗄️","name":"file cabinet","category":"Objects (office)","group":"Objects","subgroup":"office"},{"codes":"1F5C4","char":"🗄","name":"file cabinet","category":"Objects (office)","group":"Objects","subgroup":"office"},{"codes":"1F5D1 FE0F","char":"🗑️","name":"wastebasket","category":"Objects (office)","group":"Objects","subgroup":"office"},{"codes":"1F5D1","char":"🗑","name":"wastebasket","category":"Objects (office)","group":"Objects","subgroup":"office"},{"codes":"1F512","char":"🔒","name":"locked","category":"Objects (lock)","group":"Objects","subgroup":"lock"},{"codes":"1F513","char":"🔓","name":"unlocked","category":"Objects (lock)","group":"Objects","subgroup":"lock"},{"codes":"1F50F","char":"🔏","name":"locked with pen","category":"Objects (lock)","group":"Objects","subgroup":"lock"},{"codes":"1F510","char":"🔐","name":"locked with key","category":"Objects (lock)","group":"Objects","subgroup":"lock"},{"codes":"1F511","char":"🔑","name":"key","category":"Objects (lock)","group":"Objects","subgroup":"lock"},{"codes":"1F5DD FE0F","char":"🗝️","name":"old key","category":"Objects (lock)","group":"Objects","subgroup":"lock"},{"codes":"1F5DD","char":"🗝","name":"old key","category":"Objects (lock)","group":"Objects","subgroup":"lock"},{"codes":"1F528","char":"🔨","name":"hammer","category":"Objects (tool)","group":"Objects","subgroup":"tool"},{"codes":"1FA93","char":"🪓","name":"axe","category":"Objects (tool)","group":"Objects","subgroup":"tool"},{"codes":"26CF FE0F","char":"⛏️","name":"pick","category":"Objects (tool)","group":"Objects","subgroup":"tool"},{"codes":"26CF","char":"⛏","name":"pick","category":"Objects (tool)","group":"Objects","subgroup":"tool"},{"codes":"2692 FE0F","char":"⚒️","name":"hammer and pick","category":"Objects (tool)","group":"Objects","subgroup":"tool"},{"codes":"2692","char":"⚒","name":"hammer and pick","category":"Objects (tool)","group":"Objects","subgroup":"tool"},{"codes":"1F6E0 FE0F","char":"🛠️","name":"hammer and wrench","category":"Objects (tool)","group":"Objects","subgroup":"tool"},{"codes":"1F6E0","char":"🛠","name":"hammer and wrench","category":"Objects (tool)","group":"Objects","subgroup":"tool"},{"codes":"1F5E1 FE0F","char":"🗡️","name":"dagger","category":"Objects (tool)","group":"Objects","subgroup":"tool"},{"codes":"1F5E1","char":"🗡","name":"dagger","category":"Objects (tool)","group":"Objects","subgroup":"tool"},{"codes":"2694 FE0F","char":"⚔️","name":"crossed swords","category":"Objects (tool)","group":"Objects","subgroup":"tool"},{"codes":"2694","char":"⚔","name":"crossed swords","category":"Objects (tool)","group":"Objects","subgroup":"tool"},{"codes":"1F4A3","char":"💣","name":"bomb","category":"Objects (tool)","group":"Objects","subgroup":"tool"},{"codes":"1FA83","char":"🪃","name":"boomerang","category":"Objects (tool)","group":"Objects","subgroup":"tool"},{"codes":"1F3F9","char":"🏹","name":"bow and arrow","category":"Objects (tool)","group":"Objects","subgroup":"tool"},{"codes":"1F6E1 FE0F","char":"🛡️","name":"shield","category":"Objects (tool)","group":"Objects","subgroup":"tool"},{"codes":"1F6E1","char":"🛡","name":"shield","category":"Objects (tool)","group":"Objects","subgroup":"tool"},{"codes":"1FA9A","char":"🪚","name":"carpentry saw","category":"Objects (tool)","group":"Objects","subgroup":"tool"},{"codes":"1F527","char":"🔧","name":"wrench","category":"Objects (tool)","group":"Objects","subgroup":"tool"},{"codes":"1FA9B","char":"🪛","name":"screwdriver","category":"Objects (tool)","group":"Objects","subgroup":"tool"},{"codes":"1F529","char":"🔩","name":"nut and bolt","category":"Objects (tool)","group":"Objects","subgroup":"tool"},{"codes":"2699 FE0F","char":"⚙️","name":"gear","category":"Objects (tool)","group":"Objects","subgroup":"tool"},{"codes":"2699","char":"⚙","name":"gear","category":"Objects (tool)","group":"Objects","subgroup":"tool"},{"codes":"1F5DC FE0F","char":"🗜️","name":"clamp","category":"Objects (tool)","group":"Objects","subgroup":"tool"},{"codes":"1F5DC","char":"🗜","name":"clamp","category":"Objects (tool)","group":"Objects","subgroup":"tool"},{"codes":"2696 FE0F","char":"⚖️","name":"balance scale","category":"Objects (tool)","group":"Objects","subgroup":"tool"},{"codes":"2696","char":"⚖","name":"balance scale","category":"Objects (tool)","group":"Objects","subgroup":"tool"},{"codes":"1F9AF","char":"🦯","name":"white cane","category":"Objects (tool)","group":"Objects","subgroup":"tool"},{"codes":"1F517","char":"🔗","name":"link","category":"Objects (tool)","group":"Objects","subgroup":"tool"},{"codes":"26D3 FE0F 200D 1F4A5","char":"⛓️‍💥","name":"broken chain","category":"Objects (tool)","group":"Objects","subgroup":"tool"},{"codes":"26D3 200D 1F4A5","char":"⛓‍💥","name":"broken chain","category":"Objects (tool)","group":"Objects","subgroup":"tool"},{"codes":"26D3 FE0F","char":"⛓️","name":"chains","category":"Objects (tool)","group":"Objects","subgroup":"tool"},{"codes":"26D3","char":"⛓","name":"chains","category":"Objects (tool)","group":"Objects","subgroup":"tool"},{"codes":"1FA9D","char":"🪝","name":"hook","category":"Objects (tool)","group":"Objects","subgroup":"tool"},{"codes":"1F9F0","char":"🧰","name":"toolbox","category":"Objects (tool)","group":"Objects","subgroup":"tool"},{"codes":"1F9F2","char":"🧲","name":"magnet","category":"Objects (tool)","group":"Objects","subgroup":"tool"},{"codes":"1FA9C","char":"🪜","name":"ladder","category":"Objects (tool)","group":"Objects","subgroup":"tool"},{"codes":"2697 FE0F","char":"⚗️","name":"alembic","category":"Objects (science)","group":"Objects","subgroup":"science"},{"codes":"2697","char":"⚗","name":"alembic","category":"Objects (science)","group":"Objects","subgroup":"science"},{"codes":"1F9EA","char":"🧪","name":"test tube","category":"Objects (science)","group":"Objects","subgroup":"science"},{"codes":"1F9EB","char":"🧫","name":"petri dish","category":"Objects (science)","group":"Objects","subgroup":"science"},{"codes":"1F9EC","char":"🧬","name":"dna","category":"Objects (science)","group":"Objects","subgroup":"science"},{"codes":"1F52C","char":"🔬","name":"microscope","category":"Objects (science)","group":"Objects","subgroup":"science"},{"codes":"1F52D","char":"🔭","name":"telescope","category":"Objects (science)","group":"Objects","subgroup":"science"},{"codes":"1F4E1","char":"📡","name":"satellite antenna","category":"Objects (science)","group":"Objects","subgroup":"science"},{"codes":"1F489","char":"💉","name":"syringe","category":"Objects (medical)","group":"Objects","subgroup":"medical"},{"codes":"1FA78","char":"🩸","name":"drop of blood","category":"Objects (medical)","group":"Objects","subgroup":"medical"},{"codes":"1F48A","char":"💊","name":"pill","category":"Objects (medical)","group":"Objects","subgroup":"medical"},{"codes":"1FA79","char":"🩹","name":"adhesive bandage","category":"Objects (medical)","group":"Objects","subgroup":"medical"},{"codes":"1FA7C","char":"🩼","name":"crutch","category":"Objects (medical)","group":"Objects","subgroup":"medical"},{"codes":"1FA7A","char":"🩺","name":"stethoscope","category":"Objects (medical)","group":"Objects","subgroup":"medical"},{"codes":"1FA7B","char":"🩻","name":"x-ray","category":"Objects (medical)","group":"Objects","subgroup":"medical"},{"codes":"1F6AA","char":"🚪","name":"door","category":"Objects (household)","group":"Objects","subgroup":"household"},{"codes":"1F6D7","char":"🛗","name":"elevator","category":"Objects (household)","group":"Objects","subgroup":"household"},{"codes":"1FA9E","char":"🪞","name":"mirror","category":"Objects (household)","group":"Objects","subgroup":"household"},{"codes":"1FA9F","char":"🪟","name":"window","category":"Objects (household)","group":"Objects","subgroup":"household"},{"codes":"1F6CF FE0F","char":"🛏️","name":"bed","category":"Objects (household)","group":"Objects","subgroup":"household"},{"codes":"1F6CF","char":"🛏","name":"bed","category":"Objects (household)","group":"Objects","subgroup":"household"},{"codes":"1F6CB FE0F","char":"🛋️","name":"couch and lamp","category":"Objects (household)","group":"Objects","subgroup":"household"},{"codes":"1F6CB","char":"🛋","name":"couch and lamp","category":"Objects (household)","group":"Objects","subgroup":"household"},{"codes":"1FA91","char":"🪑","name":"chair","category":"Objects (household)","group":"Objects","subgroup":"household"},{"codes":"1F6BD","char":"🚽","name":"toilet","category":"Objects (household)","group":"Objects","subgroup":"household"},{"codes":"1FAA0","char":"🪠","name":"plunger","category":"Objects (household)","group":"Objects","subgroup":"household"},{"codes":"1F6BF","char":"🚿","name":"shower","category":"Objects (household)","group":"Objects","subgroup":"household"},{"codes":"1F6C1","char":"🛁","name":"bathtub","category":"Objects (household)","group":"Objects","subgroup":"household"},{"codes":"1FAA4","char":"🪤","name":"mouse trap","category":"Objects (household)","group":"Objects","subgroup":"household"},{"codes":"1FA92","char":"🪒","name":"razor","category":"Objects (household)","group":"Objects","subgroup":"household"},{"codes":"1F9F4","char":"🧴","name":"lotion bottle","category":"Objects (household)","group":"Objects","subgroup":"household"},{"codes":"1F9F7","char":"🧷","name":"safety pin","category":"Objects (household)","group":"Objects","subgroup":"household"},{"codes":"1F9F9","char":"🧹","name":"broom","category":"Objects (household)","group":"Objects","subgroup":"household"},{"codes":"1F9FA","char":"🧺","name":"basket","category":"Objects (household)","group":"Objects","subgroup":"household"},{"codes":"1F9FB","char":"🧻","name":"roll of paper","category":"Objects (household)","group":"Objects","subgroup":"household"},{"codes":"1FAA3","char":"🪣","name":"bucket","category":"Objects (household)","group":"Objects","subgroup":"household"},{"codes":"1F9FC","char":"🧼","name":"soap","category":"Objects (household)","group":"Objects","subgroup":"household"},{"codes":"1FAE7","char":"🫧","name":"bubbles","category":"Objects (household)","group":"Objects","subgroup":"household"},{"codes":"1FAA5","char":"🪥","name":"toothbrush","category":"Objects (household)","group":"Objects","subgroup":"household"},{"codes":"1F9FD","char":"🧽","name":"sponge","category":"Objects (household)","group":"Objects","subgroup":"household"},{"codes":"1F9EF","char":"🧯","name":"fire extinguisher","category":"Objects (household)","group":"Objects","subgroup":"household"},{"codes":"1F6D2","char":"🛒","name":"shopping cart","category":"Objects (household)","group":"Objects","subgroup":"household"},{"codes":"1F6AC","char":"🚬","name":"cigarette","category":"Objects (other-object)","group":"Objects","subgroup":"other-object"},{"codes":"26B0 FE0F","char":"⚰️","name":"coffin","category":"Objects (other-object)","group":"Objects","subgroup":"other-object"},{"codes":"26B0","char":"⚰","name":"coffin","category":"Objects (other-object)","group":"Objects","subgroup":"other-object"},{"codes":"1FAA6","char":"🪦","name":"headstone","category":"Objects (other-object)","group":"Objects","subgroup":"other-object"},{"codes":"26B1 FE0F","char":"⚱️","name":"funeral urn","category":"Objects (other-object)","group":"Objects","subgroup":"other-object"},{"codes":"26B1","char":"⚱","name":"funeral urn","category":"Objects (other-object)","group":"Objects","subgroup":"other-object"},{"codes":"1F9FF","char":"🧿","name":"nazar amulet","category":"Objects (other-object)","group":"Objects","subgroup":"other-object"},{"codes":"1FAAC","char":"🪬","name":"hamsa","category":"Objects (other-object)","group":"Objects","subgroup":"other-object"},{"codes":"1F5FF","char":"🗿","name":"moai","category":"Objects (other-object)","group":"Objects","subgroup":"other-object"},{"codes":"1FAA7","char":"🪧","name":"placard","category":"Objects (other-object)","group":"Objects","subgroup":"other-object"},{"codes":"1FAAA","char":"🪪","name":"identification card","category":"Objects (other-object)","group":"Objects","subgroup":"other-object"},{"codes":"1F3E7","char":"🏧","name":"ATM sign","category":"Symbols (transport-sign)","group":"Symbols","subgroup":"transport-sign"},{"codes":"1F6AE","char":"🚮","name":"litter in bin sign","category":"Symbols (transport-sign)","group":"Symbols","subgroup":"transport-sign"},{"codes":"1F6B0","char":"🚰","name":"potable water","category":"Symbols (transport-sign)","group":"Symbols","subgroup":"transport-sign"},{"codes":"267F","char":"♿","name":"wheelchair symbol","category":"Symbols (transport-sign)","group":"Symbols","subgroup":"transport-sign"},{"codes":"1F6B9","char":"🚹","name":"men’s room","category":"Symbols (transport-sign)","group":"Symbols","subgroup":"transport-sign"},{"codes":"1F6BA","char":"🚺","name":"women’s room","category":"Symbols (transport-sign)","group":"Symbols","subgroup":"transport-sign"},{"codes":"1F6BB","char":"🚻","name":"restroom","category":"Symbols (transport-sign)","group":"Symbols","subgroup":"transport-sign"},{"codes":"1F6BC","char":"🚼","name":"baby symbol","category":"Symbols (transport-sign)","group":"Symbols","subgroup":"transport-sign"},{"codes":"1F6BE","char":"🚾","name":"water closet","category":"Symbols (transport-sign)","group":"Symbols","subgroup":"transport-sign"},{"codes":"1F6C2","char":"🛂","name":"passport control","category":"Symbols (transport-sign)","group":"Symbols","subgroup":"transport-sign"},{"codes":"1F6C3","char":"🛃","name":"customs","category":"Symbols (transport-sign)","group":"Symbols","subgroup":"transport-sign"},{"codes":"1F6C4","char":"🛄","name":"baggage claim","category":"Symbols (transport-sign)","group":"Symbols","subgroup":"transport-sign"},{"codes":"1F6C5","char":"🛅","name":"left luggage","category":"Symbols (transport-sign)","group":"Symbols","subgroup":"transport-sign"},{"codes":"26A0 FE0F","char":"⚠️","name":"warning","category":"Symbols (warning)","group":"Symbols","subgroup":"warning"},{"codes":"26A0","char":"⚠","name":"warning","category":"Symbols (warning)","group":"Symbols","subgroup":"warning"},{"codes":"1F6B8","char":"🚸","name":"children crossing","category":"Symbols (warning)","group":"Symbols","subgroup":"warning"},{"codes":"26D4","char":"⛔","name":"no entry","category":"Symbols (warning)","group":"Symbols","subgroup":"warning"},{"codes":"1F6AB","char":"🚫","name":"prohibited","category":"Symbols (warning)","group":"Symbols","subgroup":"warning"},{"codes":"1F6B3","char":"🚳","name":"no bicycles","category":"Symbols (warning)","group":"Symbols","subgroup":"warning"},{"codes":"1F6AD","char":"🚭","name":"no smoking","category":"Symbols (warning)","group":"Symbols","subgroup":"warning"},{"codes":"1F6AF","char":"🚯","name":"no littering","category":"Symbols (warning)","group":"Symbols","subgroup":"warning"},{"codes":"1F6B1","char":"🚱","name":"non-potable water","category":"Symbols (warning)","group":"Symbols","subgroup":"warning"},{"codes":"1F6B7","char":"🚷","name":"no pedestrians","category":"Symbols (warning)","group":"Symbols","subgroup":"warning"},{"codes":"1F4F5","char":"📵","name":"no mobile phones","category":"Symbols (warning)","group":"Symbols","subgroup":"warning"},{"codes":"1F51E","char":"🔞","name":"no one under eighteen","category":"Symbols (warning)","group":"Symbols","subgroup":"warning"},{"codes":"2622 FE0F","char":"☢️","name":"radioactive","category":"Symbols (warning)","group":"Symbols","subgroup":"warning"},{"codes":"2622","char":"☢","name":"radioactive","category":"Symbols (warning)","group":"Symbols","subgroup":"warning"},{"codes":"2623 FE0F","char":"☣️","name":"biohazard","category":"Symbols (warning)","group":"Symbols","subgroup":"warning"},{"codes":"2623","char":"☣","name":"biohazard","category":"Symbols (warning)","group":"Symbols","subgroup":"warning"},{"codes":"2B06 FE0F","char":"⬆️","name":"up arrow","category":"Symbols (arrow)","group":"Symbols","subgroup":"arrow"},{"codes":"2B06","char":"⬆","name":"up arrow","category":"Symbols (arrow)","group":"Symbols","subgroup":"arrow"},{"codes":"2197 FE0F","char":"↗️","name":"up-right arrow","category":"Symbols (arrow)","group":"Symbols","subgroup":"arrow"},{"codes":"2197","char":"↗","name":"up-right arrow","category":"Symbols (arrow)","group":"Symbols","subgroup":"arrow"},{"codes":"27A1 FE0F","char":"➡️","name":"right arrow","category":"Symbols (arrow)","group":"Symbols","subgroup":"arrow"},{"codes":"27A1","char":"➡","name":"right arrow","category":"Symbols (arrow)","group":"Symbols","subgroup":"arrow"},{"codes":"2198 FE0F","char":"↘️","name":"down-right arrow","category":"Symbols (arrow)","group":"Symbols","subgroup":"arrow"},{"codes":"2198","char":"↘","name":"down-right arrow","category":"Symbols (arrow)","group":"Symbols","subgroup":"arrow"},{"codes":"2B07 FE0F","char":"⬇️","name":"down arrow","category":"Symbols (arrow)","group":"Symbols","subgroup":"arrow"},{"codes":"2B07","char":"⬇","name":"down arrow","category":"Symbols (arrow)","group":"Symbols","subgroup":"arrow"},{"codes":"2199 FE0F","char":"↙️","name":"down-left arrow","category":"Symbols (arrow)","group":"Symbols","subgroup":"arrow"},{"codes":"2199","char":"↙","name":"down-left arrow","category":"Symbols (arrow)","group":"Symbols","subgroup":"arrow"},{"codes":"2B05 FE0F","char":"⬅️","name":"left arrow","category":"Symbols (arrow)","group":"Symbols","subgroup":"arrow"},{"codes":"2B05","char":"⬅","name":"left arrow","category":"Symbols (arrow)","group":"Symbols","subgroup":"arrow"},{"codes":"2196 FE0F","char":"↖️","name":"up-left arrow","category":"Symbols (arrow)","group":"Symbols","subgroup":"arrow"},{"codes":"2196","char":"↖","name":"up-left arrow","category":"Symbols (arrow)","group":"Symbols","subgroup":"arrow"},{"codes":"2195 FE0F","char":"↕️","name":"up-down arrow","category":"Symbols (arrow)","group":"Symbols","subgroup":"arrow"},{"codes":"2195","char":"↕","name":"up-down arrow","category":"Symbols (arrow)","group":"Symbols","subgroup":"arrow"},{"codes":"2194 FE0F","char":"↔️","name":"left-right arrow","category":"Symbols (arrow)","group":"Symbols","subgroup":"arrow"},{"codes":"2194","char":"↔","name":"left-right arrow","category":"Symbols (arrow)","group":"Symbols","subgroup":"arrow"},{"codes":"21A9 FE0F","char":"↩️","name":"right arrow curving left","category":"Symbols (arrow)","group":"Symbols","subgroup":"arrow"},{"codes":"21A9","char":"↩","name":"right arrow curving left","category":"Symbols (arrow)","group":"Symbols","subgroup":"arrow"},{"codes":"21AA FE0F","char":"↪️","name":"left arrow curving right","category":"Symbols (arrow)","group":"Symbols","subgroup":"arrow"},{"codes":"21AA","char":"↪","name":"left arrow curving right","category":"Symbols (arrow)","group":"Symbols","subgroup":"arrow"},{"codes":"2934 FE0F","char":"⤴️","name":"right arrow curving up","category":"Symbols (arrow)","group":"Symbols","subgroup":"arrow"},{"codes":"2934","char":"⤴","name":"right arrow curving up","category":"Symbols (arrow)","group":"Symbols","subgroup":"arrow"},{"codes":"2935 FE0F","char":"⤵️","name":"right arrow curving down","category":"Symbols (arrow)","group":"Symbols","subgroup":"arrow"},{"codes":"2935","char":"⤵","name":"right arrow curving down","category":"Symbols (arrow)","group":"Symbols","subgroup":"arrow"},{"codes":"1F503","char":"🔃","name":"clockwise vertical arrows","category":"Symbols (arrow)","group":"Symbols","subgroup":"arrow"},{"codes":"1F504","char":"🔄","name":"counterclockwise arrows button","category":"Symbols (arrow)","group":"Symbols","subgroup":"arrow"},{"codes":"1F519","char":"🔙","name":"BACK arrow","category":"Symbols (arrow)","group":"Symbols","subgroup":"arrow"},{"codes":"1F51A","char":"🔚","name":"END arrow","category":"Symbols (arrow)","group":"Symbols","subgroup":"arrow"},{"codes":"1F51B","char":"🔛","name":"ON! arrow","category":"Symbols (arrow)","group":"Symbols","subgroup":"arrow"},{"codes":"1F51C","char":"🔜","name":"SOON arrow","category":"Symbols (arrow)","group":"Symbols","subgroup":"arrow"},{"codes":"1F51D","char":"🔝","name":"TOP arrow","category":"Symbols (arrow)","group":"Symbols","subgroup":"arrow"},{"codes":"1F6D0","char":"🛐","name":"place of worship","category":"Symbols (religion)","group":"Symbols","subgroup":"religion"},{"codes":"269B FE0F","char":"⚛️","name":"atom symbol","category":"Symbols (religion)","group":"Symbols","subgroup":"religion"},{"codes":"269B","char":"⚛","name":"atom symbol","category":"Symbols (religion)","group":"Symbols","subgroup":"religion"},{"codes":"1F549 FE0F","char":"🕉️","name":"om","category":"Symbols (religion)","group":"Symbols","subgroup":"religion"},{"codes":"1F549","char":"🕉","name":"om","category":"Symbols (religion)","group":"Symbols","subgroup":"religion"},{"codes":"2721 FE0F","char":"✡️","name":"star of David","category":"Symbols (religion)","group":"Symbols","subgroup":"religion"},{"codes":"2721","char":"✡","name":"star of David","category":"Symbols (religion)","group":"Symbols","subgroup":"religion"},{"codes":"2638 FE0F","char":"☸️","name":"wheel of dharma","category":"Symbols (religion)","group":"Symbols","subgroup":"religion"},{"codes":"2638","char":"☸","name":"wheel of dharma","category":"Symbols (religion)","group":"Symbols","subgroup":"religion"},{"codes":"262F FE0F","char":"☯️","name":"yin yang","category":"Symbols (religion)","group":"Symbols","subgroup":"religion"},{"codes":"262F","char":"☯","name":"yin yang","category":"Symbols (religion)","group":"Symbols","subgroup":"religion"},{"codes":"271D FE0F","char":"✝️","name":"latin cross","category":"Symbols (religion)","group":"Symbols","subgroup":"religion"},{"codes":"271D","char":"✝","name":"latin cross","category":"Symbols (religion)","group":"Symbols","subgroup":"religion"},{"codes":"2626 FE0F","char":"☦️","name":"orthodox cross","category":"Symbols (religion)","group":"Symbols","subgroup":"religion"},{"codes":"2626","char":"☦","name":"orthodox cross","category":"Symbols (religion)","group":"Symbols","subgroup":"religion"},{"codes":"262A FE0F","char":"☪️","name":"star and crescent","category":"Symbols (religion)","group":"Symbols","subgroup":"religion"},{"codes":"262A","char":"☪","name":"star and crescent","category":"Symbols (religion)","group":"Symbols","subgroup":"religion"},{"codes":"262E FE0F","char":"☮️","name":"peace symbol","category":"Symbols (religion)","group":"Symbols","subgroup":"religion"},{"codes":"262E","char":"☮","name":"peace symbol","category":"Symbols (religion)","group":"Symbols","subgroup":"religion"},{"codes":"1F54E","char":"🕎","name":"menorah","category":"Symbols (religion)","group":"Symbols","subgroup":"religion"},{"codes":"1F52F","char":"🔯","name":"dotted six-pointed star","category":"Symbols (religion)","group":"Symbols","subgroup":"religion"},{"codes":"1FAAF","char":"🪯","name":"khanda","category":"Symbols (religion)","group":"Symbols","subgroup":"religion"},{"codes":"2648","char":"♈","name":"Aries","category":"Symbols (zodiac)","group":"Symbols","subgroup":"zodiac"},{"codes":"2649","char":"♉","name":"Taurus","category":"Symbols (zodiac)","group":"Symbols","subgroup":"zodiac"},{"codes":"264A","char":"♊","name":"Gemini","category":"Symbols (zodiac)","group":"Symbols","subgroup":"zodiac"},{"codes":"264B","char":"♋","name":"Cancer","category":"Symbols (zodiac)","group":"Symbols","subgroup":"zodiac"},{"codes":"264C","char":"♌","name":"Leo","category":"Symbols (zodiac)","group":"Symbols","subgroup":"zodiac"},{"codes":"264D","char":"♍","name":"Virgo","category":"Symbols (zodiac)","group":"Symbols","subgroup":"zodiac"},{"codes":"264E","char":"♎","name":"Libra","category":"Symbols (zodiac)","group":"Symbols","subgroup":"zodiac"},{"codes":"264F","char":"♏","name":"Scorpio","category":"Symbols (zodiac)","group":"Symbols","subgroup":"zodiac"},{"codes":"2650","char":"♐","name":"Sagittarius","category":"Symbols (zodiac)","group":"Symbols","subgroup":"zodiac"},{"codes":"2651","char":"♑","name":"Capricorn","category":"Symbols (zodiac)","group":"Symbols","subgroup":"zodiac"},{"codes":"2652","char":"♒","name":"Aquarius","category":"Symbols (zodiac)","group":"Symbols","subgroup":"zodiac"},{"codes":"2653","char":"♓","name":"Pisces","category":"Symbols (zodiac)","group":"Symbols","subgroup":"zodiac"},{"codes":"26CE","char":"⛎","name":"Ophiuchus","category":"Symbols (zodiac)","group":"Symbols","subgroup":"zodiac"},{"codes":"1F500","char":"🔀","name":"shuffle tracks button","category":"Symbols (av-symbol)","group":"Symbols","subgroup":"av-symbol"},{"codes":"1F501","char":"🔁","name":"repeat button","category":"Symbols (av-symbol)","group":"Symbols","subgroup":"av-symbol"},{"codes":"1F502","char":"🔂","name":"repeat single button","category":"Symbols (av-symbol)","group":"Symbols","subgroup":"av-symbol"},{"codes":"25B6 FE0F","char":"▶️","name":"play button","category":"Symbols (av-symbol)","group":"Symbols","subgroup":"av-symbol"},{"codes":"25B6","char":"▶","name":"play button","category":"Symbols (av-symbol)","group":"Symbols","subgroup":"av-symbol"},{"codes":"23E9","char":"⏩","name":"fast-forward button","category":"Symbols (av-symbol)","group":"Symbols","subgroup":"av-symbol"},{"codes":"23ED FE0F","char":"⏭️","name":"next track button","category":"Symbols (av-symbol)","group":"Symbols","subgroup":"av-symbol"},{"codes":"23ED","char":"⏭","name":"next track button","category":"Symbols (av-symbol)","group":"Symbols","subgroup":"av-symbol"},{"codes":"23EF FE0F","char":"⏯️","name":"play or pause button","category":"Symbols (av-symbol)","group":"Symbols","subgroup":"av-symbol"},{"codes":"23EF","char":"⏯","name":"play or pause button","category":"Symbols (av-symbol)","group":"Symbols","subgroup":"av-symbol"},{"codes":"25C0 FE0F","char":"◀️","name":"reverse button","category":"Symbols (av-symbol)","group":"Symbols","subgroup":"av-symbol"},{"codes":"25C0","char":"◀","name":"reverse button","category":"Symbols (av-symbol)","group":"Symbols","subgroup":"av-symbol"},{"codes":"23EA","char":"⏪","name":"fast reverse button","category":"Symbols (av-symbol)","group":"Symbols","subgroup":"av-symbol"},{"codes":"23EE FE0F","char":"⏮️","name":"last track button","category":"Symbols (av-symbol)","group":"Symbols","subgroup":"av-symbol"},{"codes":"23EE","char":"⏮","name":"last track button","category":"Symbols (av-symbol)","group":"Symbols","subgroup":"av-symbol"},{"codes":"1F53C","char":"🔼","name":"upwards button","category":"Symbols (av-symbol)","group":"Symbols","subgroup":"av-symbol"},{"codes":"23EB","char":"⏫","name":"fast up button","category":"Symbols (av-symbol)","group":"Symbols","subgroup":"av-symbol"},{"codes":"1F53D","char":"🔽","name":"downwards button","category":"Symbols (av-symbol)","group":"Symbols","subgroup":"av-symbol"},{"codes":"23EC","char":"⏬","name":"fast down button","category":"Symbols (av-symbol)","group":"Symbols","subgroup":"av-symbol"},{"codes":"23F8 FE0F","char":"⏸️","name":"pause button","category":"Symbols (av-symbol)","group":"Symbols","subgroup":"av-symbol"},{"codes":"23F8","char":"⏸","name":"pause button","category":"Symbols (av-symbol)","group":"Symbols","subgroup":"av-symbol"},{"codes":"23F9 FE0F","char":"⏹️","name":"stop button","category":"Symbols (av-symbol)","group":"Symbols","subgroup":"av-symbol"},{"codes":"23F9","char":"⏹","name":"stop button","category":"Symbols (av-symbol)","group":"Symbols","subgroup":"av-symbol"},{"codes":"23FA FE0F","char":"⏺️","name":"record button","category":"Symbols (av-symbol)","group":"Symbols","subgroup":"av-symbol"},{"codes":"23FA","char":"⏺","name":"record button","category":"Symbols (av-symbol)","group":"Symbols","subgroup":"av-symbol"},{"codes":"23CF FE0F","char":"⏏️","name":"eject button","category":"Symbols (av-symbol)","group":"Symbols","subgroup":"av-symbol"},{"codes":"23CF","char":"⏏","name":"eject button","category":"Symbols (av-symbol)","group":"Symbols","subgroup":"av-symbol"},{"codes":"1F3A6","char":"🎦","name":"cinema","category":"Symbols (av-symbol)","group":"Symbols","subgroup":"av-symbol"},{"codes":"1F505","char":"🔅","name":"dim button","category":"Symbols (av-symbol)","group":"Symbols","subgroup":"av-symbol"},{"codes":"1F506","char":"🔆","name":"bright button","category":"Symbols (av-symbol)","group":"Symbols","subgroup":"av-symbol"},{"codes":"1F4F6","char":"📶","name":"antenna bars","category":"Symbols (av-symbol)","group":"Symbols","subgroup":"av-symbol"},{"codes":"1F6DC","char":"🛜","name":"wireless","category":"Symbols (av-symbol)","group":"Symbols","subgroup":"av-symbol"},{"codes":"1F4F3","char":"📳","name":"vibration mode","category":"Symbols (av-symbol)","group":"Symbols","subgroup":"av-symbol"},{"codes":"1F4F4","char":"📴","name":"mobile phone off","category":"Symbols (av-symbol)","group":"Symbols","subgroup":"av-symbol"},{"codes":"2640 FE0F","char":"♀️","name":"female sign","category":"Symbols (gender)","group":"Symbols","subgroup":"gender"},{"codes":"2640","char":"♀","name":"female sign","category":"Symbols (gender)","group":"Symbols","subgroup":"gender"},{"codes":"2642 FE0F","char":"♂️","name":"male sign","category":"Symbols (gender)","group":"Symbols","subgroup":"gender"},{"codes":"2642","char":"♂","name":"male sign","category":"Symbols (gender)","group":"Symbols","subgroup":"gender"},{"codes":"26A7 FE0F","char":"⚧️","name":"transgender symbol","category":"Symbols (gender)","group":"Symbols","subgroup":"gender"},{"codes":"26A7","char":"⚧","name":"transgender symbol","category":"Symbols (gender)","group":"Symbols","subgroup":"gender"},{"codes":"2716 FE0F","char":"✖️","name":"multiply","category":"Symbols (math)","group":"Symbols","subgroup":"math"},{"codes":"2716","char":"✖","name":"multiply","category":"Symbols (math)","group":"Symbols","subgroup":"math"},{"codes":"2795","char":"➕","name":"plus","category":"Symbols (math)","group":"Symbols","subgroup":"math"},{"codes":"2796","char":"➖","name":"minus","category":"Symbols (math)","group":"Symbols","subgroup":"math"},{"codes":"2797","char":"➗","name":"divide","category":"Symbols (math)","group":"Symbols","subgroup":"math"},{"codes":"1F7F0","char":"🟰","name":"heavy equals sign","category":"Symbols (math)","group":"Symbols","subgroup":"math"},{"codes":"267E FE0F","char":"♾️","name":"infinity","category":"Symbols (math)","group":"Symbols","subgroup":"math"},{"codes":"267E","char":"♾","name":"infinity","category":"Symbols (math)","group":"Symbols","subgroup":"math"},{"codes":"203C FE0F","char":"‼️","name":"double exclamation mark","category":"Symbols (punctuation)","group":"Symbols","subgroup":"punctuation"},{"codes":"203C","char":"‼","name":"double exclamation mark","category":"Symbols (punctuation)","group":"Symbols","subgroup":"punctuation"},{"codes":"2049 FE0F","char":"⁉️","name":"exclamation question mark","category":"Symbols (punctuation)","group":"Symbols","subgroup":"punctuation"},{"codes":"2049","char":"⁉","name":"exclamation question mark","category":"Symbols (punctuation)","group":"Symbols","subgroup":"punctuation"},{"codes":"2753","char":"❓","name":"red question mark","category":"Symbols (punctuation)","group":"Symbols","subgroup":"punctuation"},{"codes":"2754","char":"❔","name":"white question mark","category":"Symbols (punctuation)","group":"Symbols","subgroup":"punctuation"},{"codes":"2755","char":"❕","name":"white exclamation mark","category":"Symbols (punctuation)","group":"Symbols","subgroup":"punctuation"},{"codes":"2757","char":"❗","name":"red exclamation mark","category":"Symbols (punctuation)","group":"Symbols","subgroup":"punctuation"},{"codes":"3030 FE0F","char":"〰️","name":"wavy dash","category":"Symbols (punctuation)","group":"Symbols","subgroup":"punctuation"},{"codes":"3030","char":"〰","name":"wavy dash","category":"Symbols (punctuation)","group":"Symbols","subgroup":"punctuation"},{"codes":"1F4B1","char":"💱","name":"currency exchange","category":"Symbols (currency)","group":"Symbols","subgroup":"currency"},{"codes":"1F4B2","char":"💲","name":"heavy dollar sign","category":"Symbols (currency)","group":"Symbols","subgroup":"currency"},{"codes":"2695 FE0F","char":"⚕️","name":"medical symbol","category":"Symbols (other-symbol)","group":"Symbols","subgroup":"other-symbol"},{"codes":"2695","char":"⚕","name":"medical symbol","category":"Symbols (other-symbol)","group":"Symbols","subgroup":"other-symbol"},{"codes":"267B FE0F","char":"♻️","name":"recycling symbol","category":"Symbols (other-symbol)","group":"Symbols","subgroup":"other-symbol"},{"codes":"267B","char":"♻","name":"recycling symbol","category":"Symbols (other-symbol)","group":"Symbols","subgroup":"other-symbol"},{"codes":"269C FE0F","char":"⚜️","name":"fleur-de-lis","category":"Symbols (other-symbol)","group":"Symbols","subgroup":"other-symbol"},{"codes":"269C","char":"⚜","name":"fleur-de-lis","category":"Symbols (other-symbol)","group":"Symbols","subgroup":"other-symbol"},{"codes":"1F531","char":"🔱","name":"trident emblem","category":"Symbols (other-symbol)","group":"Symbols","subgroup":"other-symbol"},{"codes":"1F4DB","char":"📛","name":"name badge","category":"Symbols (other-symbol)","group":"Symbols","subgroup":"other-symbol"},{"codes":"1F530","char":"🔰","name":"Japanese symbol for beginner","category":"Symbols (other-symbol)","group":"Symbols","subgroup":"other-symbol"},{"codes":"2B55","char":"⭕","name":"hollow red circle","category":"Symbols (other-symbol)","group":"Symbols","subgroup":"other-symbol"},{"codes":"2705","char":"✅","name":"check mark button","category":"Symbols (other-symbol)","group":"Symbols","subgroup":"other-symbol"},{"codes":"2611 FE0F","char":"☑️","name":"check box with check","category":"Symbols (other-symbol)","group":"Symbols","subgroup":"other-symbol"},{"codes":"2611","char":"☑","name":"check box with check","category":"Symbols (other-symbol)","group":"Symbols","subgroup":"other-symbol"},{"codes":"2714 FE0F","char":"✔️","name":"check mark","category":"Symbols (other-symbol)","group":"Symbols","subgroup":"other-symbol"},{"codes":"2714","char":"✔","name":"check mark","category":"Symbols (other-symbol)","group":"Symbols","subgroup":"other-symbol"},{"codes":"274C","char":"❌","name":"cross mark","category":"Symbols (other-symbol)","group":"Symbols","subgroup":"other-symbol"},{"codes":"274E","char":"❎","name":"cross mark button","category":"Symbols (other-symbol)","group":"Symbols","subgroup":"other-symbol"},{"codes":"27B0","char":"➰","name":"curly loop","category":"Symbols (other-symbol)","group":"Symbols","subgroup":"other-symbol"},{"codes":"27BF","char":"➿","name":"double curly loop","category":"Symbols (other-symbol)","group":"Symbols","subgroup":"other-symbol"},{"codes":"303D FE0F","char":"〽️","name":"part alternation mark","category":"Symbols (other-symbol)","group":"Symbols","subgroup":"other-symbol"},{"codes":"303D","char":"〽","name":"part alternation mark","category":"Symbols (other-symbol)","group":"Symbols","subgroup":"other-symbol"},{"codes":"2733 FE0F","char":"✳️","name":"eight-spoked asterisk","category":"Symbols (other-symbol)","group":"Symbols","subgroup":"other-symbol"},{"codes":"2733","char":"✳","name":"eight-spoked asterisk","category":"Symbols (other-symbol)","group":"Symbols","subgroup":"other-symbol"},{"codes":"2734 FE0F","char":"✴️","name":"eight-pointed star","category":"Symbols (other-symbol)","group":"Symbols","subgroup":"other-symbol"},{"codes":"2734","char":"✴","name":"eight-pointed star","category":"Symbols (other-symbol)","group":"Symbols","subgroup":"other-symbol"},{"codes":"2747 FE0F","char":"❇️","name":"sparkle","category":"Symbols (other-symbol)","group":"Symbols","subgroup":"other-symbol"},{"codes":"2747","char":"❇","name":"sparkle","category":"Symbols (other-symbol)","group":"Symbols","subgroup":"other-symbol"},{"codes":"00A9 FE0F","char":"©️","name":"copyright","category":"Symbols (other-symbol)","group":"Symbols","subgroup":"other-symbol"},{"codes":"00A9","char":"©","name":"copyright","category":"Symbols (other-symbol)","group":"Symbols","subgroup":"other-symbol"},{"codes":"00AE FE0F","char":"®️","name":"registered","category":"Symbols (other-symbol)","group":"Symbols","subgroup":"other-symbol"},{"codes":"00AE","char":"®","name":"registered","category":"Symbols (other-symbol)","group":"Symbols","subgroup":"other-symbol"},{"codes":"2122 FE0F","char":"™️","name":"trade mark","category":"Symbols (other-symbol)","group":"Symbols","subgroup":"other-symbol"},{"codes":"2122","char":"™","name":"trade mark","category":"Symbols (other-symbol)","group":"Symbols","subgroup":"other-symbol"},{"codes":"0023 FE0F 20E3","char":"#️⃣","name":"keycap: #","category":"Symbols (keycap)","group":"Symbols","subgroup":"keycap"},{"codes":"0023 20E3","char":"#⃣","name":"keycap: #","category":"Symbols (keycap)","group":"Symbols","subgroup":"keycap"},{"codes":"002A FE0F 20E3","char":"*️⃣","name":"keycap: *","category":"Symbols (keycap)","group":"Symbols","subgroup":"keycap"},{"codes":"002A 20E3","char":"*⃣","name":"keycap: *","category":"Symbols (keycap)","group":"Symbols","subgroup":"keycap"},{"codes":"0030 FE0F 20E3","char":"0️⃣","name":"keycap: 0","category":"Symbols (keycap)","group":"Symbols","subgroup":"keycap"},{"codes":"0030 20E3","char":"0⃣","name":"keycap: 0","category":"Symbols (keycap)","group":"Symbols","subgroup":"keycap"},{"codes":"0031 FE0F 20E3","char":"1️⃣","name":"keycap: 1","category":"Symbols (keycap)","group":"Symbols","subgroup":"keycap"},{"codes":"0031 20E3","char":"1⃣","name":"keycap: 1","category":"Symbols (keycap)","group":"Symbols","subgroup":"keycap"},{"codes":"0032 FE0F 20E3","char":"2️⃣","name":"keycap: 2","category":"Symbols (keycap)","group":"Symbols","subgroup":"keycap"},{"codes":"0032 20E3","char":"2⃣","name":"keycap: 2","category":"Symbols (keycap)","group":"Symbols","subgroup":"keycap"},{"codes":"0033 FE0F 20E3","char":"3️⃣","name":"keycap: 3","category":"Symbols (keycap)","group":"Symbols","subgroup":"keycap"},{"codes":"0033 20E3","char":"3⃣","name":"keycap: 3","category":"Symbols (keycap)","group":"Symbols","subgroup":"keycap"},{"codes":"0034 FE0F 20E3","char":"4️⃣","name":"keycap: 4","category":"Symbols (keycap)","group":"Symbols","subgroup":"keycap"},{"codes":"0034 20E3","char":"4⃣","name":"keycap: 4","category":"Symbols (keycap)","group":"Symbols","subgroup":"keycap"},{"codes":"0035 FE0F 20E3","char":"5️⃣","name":"keycap: 5","category":"Symbols (keycap)","group":"Symbols","subgroup":"keycap"},{"codes":"0035 20E3","char":"5⃣","name":"keycap: 5","category":"Symbols (keycap)","group":"Symbols","subgroup":"keycap"},{"codes":"0036 FE0F 20E3","char":"6️⃣","name":"keycap: 6","category":"Symbols (keycap)","group":"Symbols","subgroup":"keycap"},{"codes":"0036 20E3","char":"6⃣","name":"keycap: 6","category":"Symbols (keycap)","group":"Symbols","subgroup":"keycap"},{"codes":"0037 FE0F 20E3","char":"7️⃣","name":"keycap: 7","category":"Symbols (keycap)","group":"Symbols","subgroup":"keycap"},{"codes":"0037 20E3","char":"7⃣","name":"keycap: 7","category":"Symbols (keycap)","group":"Symbols","subgroup":"keycap"},{"codes":"0038 FE0F 20E3","char":"8️⃣","name":"keycap: 8","category":"Symbols (keycap)","group":"Symbols","subgroup":"keycap"},{"codes":"0038 20E3","char":"8⃣","name":"keycap: 8","category":"Symbols (keycap)","group":"Symbols","subgroup":"keycap"},{"codes":"0039 FE0F 20E3","char":"9️⃣","name":"keycap: 9","category":"Symbols (keycap)","group":"Symbols","subgroup":"keycap"},{"codes":"0039 20E3","char":"9⃣","name":"keycap: 9","category":"Symbols (keycap)","group":"Symbols","subgroup":"keycap"},{"codes":"1F51F","char":"🔟","name":"keycap: 10","category":"Symbols (keycap)","group":"Symbols","subgroup":"keycap"},{"codes":"1F520","char":"🔠","name":"input latin uppercase","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F521","char":"🔡","name":"input latin lowercase","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F522","char":"🔢","name":"input numbers","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F523","char":"🔣","name":"input symbols","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F524","char":"🔤","name":"input latin letters","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F170 FE0F","char":"🅰️","name":"A button (blood type)","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F170","char":"🅰","name":"A button (blood type)","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F18E","char":"🆎","name":"AB button (blood type)","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F171 FE0F","char":"🅱️","name":"B button (blood type)","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F171","char":"🅱","name":"B button (blood type)","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F191","char":"🆑","name":"CL button","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F192","char":"🆒","name":"COOL button","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F193","char":"🆓","name":"FREE button","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"2139 FE0F","char":"ℹ️","name":"information","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"2139","char":"ℹ","name":"information","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F194","char":"🆔","name":"ID button","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"24C2 FE0F","char":"Ⓜ️","name":"circled M","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"24C2","char":"Ⓜ","name":"circled M","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F195","char":"🆕","name":"NEW button","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F196","char":"🆖","name":"NG button","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F17E FE0F","char":"🅾️","name":"O button (blood type)","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F17E","char":"🅾","name":"O button (blood type)","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F197","char":"🆗","name":"OK button","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F17F FE0F","char":"🅿️","name":"P button","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F17F","char":"🅿","name":"P button","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F198","char":"🆘","name":"SOS button","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F199","char":"🆙","name":"UP! button","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F19A","char":"🆚","name":"VS button","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F201","char":"🈁","name":"Japanese “here” button","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F202 FE0F","char":"🈂️","name":"Japanese “service charge” button","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F202","char":"🈂","name":"Japanese “service charge” button","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F237 FE0F","char":"🈷️","name":"Japanese “monthly amount” button","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F237","char":"🈷","name":"Japanese “monthly amount” button","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F236","char":"🈶","name":"Japanese “not free of charge” button","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F22F","char":"🈯","name":"Japanese “reserved” button","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F250","char":"🉐","name":"Japanese “bargain” button","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F239","char":"🈹","name":"Japanese “discount” button","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F21A","char":"🈚","name":"Japanese “free of charge” button","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F232","char":"🈲","name":"Japanese “prohibited” button","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F251","char":"🉑","name":"Japanese “acceptable” button","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F238","char":"🈸","name":"Japanese “application” button","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F234","char":"🈴","name":"Japanese “passing grade” button","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F233","char":"🈳","name":"Japanese “vacancy” button","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"3297 FE0F","char":"㊗️","name":"Japanese “congratulations” button","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"3297","char":"㊗","name":"Japanese “congratulations” button","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"3299 FE0F","char":"㊙️","name":"Japanese “secret” button","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"3299","char":"㊙","name":"Japanese “secret” button","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F23A","char":"🈺","name":"Japanese “open for business” button","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F235","char":"🈵","name":"Japanese “no vacancy” button","category":"Symbols (alphanum)","group":"Symbols","subgroup":"alphanum"},{"codes":"1F534","char":"🔴","name":"red circle","category":"Symbols (geometric)","group":"Symbols","subgroup":"geometric"},{"codes":"1F7E0","char":"🟠","name":"orange circle","category":"Symbols (geometric)","group":"Symbols","subgroup":"geometric"},{"codes":"1F7E1","char":"🟡","name":"yellow circle","category":"Symbols (geometric)","group":"Symbols","subgroup":"geometric"},{"codes":"1F7E2","char":"🟢","name":"green circle","category":"Symbols (geometric)","group":"Symbols","subgroup":"geometric"},{"codes":"1F535","char":"🔵","name":"blue circle","category":"Symbols (geometric)","group":"Symbols","subgroup":"geometric"},{"codes":"1F7E3","char":"🟣","name":"purple circle","category":"Symbols (geometric)","group":"Symbols","subgroup":"geometric"},{"codes":"1F7E4","char":"🟤","name":"brown circle","category":"Symbols (geometric)","group":"Symbols","subgroup":"geometric"},{"codes":"26AB","char":"⚫","name":"black circle","category":"Symbols (geometric)","group":"Symbols","subgroup":"geometric"},{"codes":"26AA","char":"⚪","name":"white circle","category":"Symbols (geometric)","group":"Symbols","subgroup":"geometric"},{"codes":"1F7E5","char":"🟥","name":"red square","category":"Symbols (geometric)","group":"Symbols","subgroup":"geometric"},{"codes":"1F7E7","char":"🟧","name":"orange square","category":"Symbols (geometric)","group":"Symbols","subgroup":"geometric"},{"codes":"1F7E8","char":"🟨","name":"yellow square","category":"Symbols (geometric)","group":"Symbols","subgroup":"geometric"},{"codes":"1F7E9","char":"🟩","name":"green square","category":"Symbols (geometric)","group":"Symbols","subgroup":"geometric"},{"codes":"1F7E6","char":"🟦","name":"blue square","category":"Symbols (geometric)","group":"Symbols","subgroup":"geometric"},{"codes":"1F7EA","char":"🟪","name":"purple square","category":"Symbols (geometric)","group":"Symbols","subgroup":"geometric"},{"codes":"1F7EB","char":"🟫","name":"brown square","category":"Symbols (geometric)","group":"Symbols","subgroup":"geometric"},{"codes":"2B1B","char":"⬛","name":"black large square","category":"Symbols (geometric)","group":"Symbols","subgroup":"geometric"},{"codes":"2B1C","char":"⬜","name":"white large square","category":"Symbols (geometric)","group":"Symbols","subgroup":"geometric"},{"codes":"25FC FE0F","char":"◼️","name":"black medium square","category":"Symbols (geometric)","group":"Symbols","subgroup":"geometric"},{"codes":"25FC","char":"◼","name":"black medium square","category":"Symbols (geometric)","group":"Symbols","subgroup":"geometric"},{"codes":"25FB FE0F","char":"◻️","name":"white medium square","category":"Symbols (geometric)","group":"Symbols","subgroup":"geometric"},{"codes":"25FB","char":"◻","name":"white medium square","category":"Symbols (geometric)","group":"Symbols","subgroup":"geometric"},{"codes":"25FE","char":"◾","name":"black medium-small square","category":"Symbols (geometric)","group":"Symbols","subgroup":"geometric"},{"codes":"25FD","char":"◽","name":"white medium-small square","category":"Symbols (geometric)","group":"Symbols","subgroup":"geometric"},{"codes":"25AA FE0F","char":"▪️","name":"black small square","category":"Symbols (geometric)","group":"Symbols","subgroup":"geometric"},{"codes":"25AA","char":"▪","name":"black small square","category":"Symbols (geometric)","group":"Symbols","subgroup":"geometric"},{"codes":"25AB FE0F","char":"▫️","name":"white small square","category":"Symbols (geometric)","group":"Symbols","subgroup":"geometric"},{"codes":"25AB","char":"▫","name":"white small square","category":"Symbols (geometric)","group":"Symbols","subgroup":"geometric"},{"codes":"1F536","char":"🔶","name":"large orange diamond","category":"Symbols (geometric)","group":"Symbols","subgroup":"geometric"},{"codes":"1F537","char":"🔷","name":"large blue diamond","category":"Symbols (geometric)","group":"Symbols","subgroup":"geometric"},{"codes":"1F538","char":"🔸","name":"small orange diamond","category":"Symbols (geometric)","group":"Symbols","subgroup":"geometric"},{"codes":"1F539","char":"🔹","name":"small blue diamond","category":"Symbols (geometric)","group":"Symbols","subgroup":"geometric"},{"codes":"1F53A","char":"🔺","name":"red triangle pointed up","category":"Symbols (geometric)","group":"Symbols","subgroup":"geometric"},{"codes":"1F53B","char":"🔻","name":"red triangle pointed down","category":"Symbols (geometric)","group":"Symbols","subgroup":"geometric"},{"codes":"1F4A0","char":"💠","name":"diamond with a dot","category":"Symbols (geometric)","group":"Symbols","subgroup":"geometric"},{"codes":"1F518","char":"🔘","name":"radio button","category":"Symbols (geometric)","group":"Symbols","subgroup":"geometric"},{"codes":"1F533","char":"🔳","name":"white square button","category":"Symbols (geometric)","group":"Symbols","subgroup":"geometric"},{"codes":"1F532","char":"🔲","name":"black square button","category":"Symbols (geometric)","group":"Symbols","subgroup":"geometric"},{"codes":"1F3C1","char":"🏁","name":"chequered flag","category":"Flags (flag)","group":"Flags","subgroup":"flag"},{"codes":"1F6A9","char":"🚩","name":"triangular flag","category":"Flags (flag)","group":"Flags","subgroup":"flag"},{"codes":"1F38C","char":"🎌","name":"crossed flags","category":"Flags (flag)","group":"Flags","subgroup":"flag"},{"codes":"1F3F4","char":"🏴","name":"black flag","category":"Flags (flag)","group":"Flags","subgroup":"flag"},{"codes":"1F3F3 FE0F","char":"🏳️","name":"white flag","category":"Flags (flag)","group":"Flags","subgroup":"flag"},{"codes":"1F3F3","char":"🏳","name":"white flag","category":"Flags (flag)","group":"Flags","subgroup":"flag"},{"codes":"1F3F3 FE0F 200D 1F308","char":"🏳️‍🌈","name":"rainbow flag","category":"Flags (flag)","group":"Flags","subgroup":"flag"},{"codes":"1F3F3 200D 1F308","char":"🏳‍🌈","name":"rainbow flag","category":"Flags (flag)","group":"Flags","subgroup":"flag"},{"codes":"1F3F3 FE0F 200D 26A7 FE0F","char":"🏳️‍⚧️","name":"transgender flag","category":"Flags (flag)","group":"Flags","subgroup":"flag"},{"codes":"1F3F3 200D 26A7 FE0F","char":"🏳‍⚧️","name":"transgender flag","category":"Flags (flag)","group":"Flags","subgroup":"flag"},{"codes":"1F3F3 FE0F 200D 26A7","char":"🏳️‍⚧","name":"transgender flag","category":"Flags (flag)","group":"Flags","subgroup":"flag"},{"codes":"1F3F3 200D 26A7","char":"🏳‍⚧","name":"transgender flag","category":"Flags (flag)","group":"Flags","subgroup":"flag"},{"codes":"1F3F4 200D 2620 FE0F","char":"🏴‍☠️","name":"pirate flag","category":"Flags (flag)","group":"Flags","subgroup":"flag"},{"codes":"1F3F4 200D 2620","char":"🏴‍☠","name":"pirate flag","category":"Flags (flag)","group":"Flags","subgroup":"flag"},{"codes":"1F1E6 1F1E8","char":"🇦🇨","name":"flag: Ascension Island","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E6 1F1E9","char":"🇦🇩","name":"flag: Andorra","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E6 1F1EA","char":"🇦🇪","name":"flag: United Arab Emirates","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E6 1F1EB","char":"🇦🇫","name":"flag: Afghanistan","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E6 1F1EC","char":"🇦🇬","name":"flag: Antigua & Barbuda","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E6 1F1EE","char":"🇦🇮","name":"flag: Anguilla","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E6 1F1F1","char":"🇦🇱","name":"flag: Albania","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E6 1F1F2","char":"🇦🇲","name":"flag: Armenia","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E6 1F1F4","char":"🇦🇴","name":"flag: Angola","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E6 1F1F6","char":"🇦🇶","name":"flag: Antarctica","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E6 1F1F7","char":"🇦🇷","name":"flag: Argentina","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E6 1F1F8","char":"🇦🇸","name":"flag: American Samoa","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E6 1F1F9","char":"🇦🇹","name":"flag: Austria","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E6 1F1FA","char":"🇦🇺","name":"flag: Australia","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E6 1F1FC","char":"🇦🇼","name":"flag: Aruba","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E6 1F1FD","char":"🇦🇽","name":"flag: Åland Islands","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E6 1F1FF","char":"🇦🇿","name":"flag: Azerbaijan","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E7 1F1E6","char":"🇧🇦","name":"flag: Bosnia & Herzegovina","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E7 1F1E7","char":"🇧🇧","name":"flag: Barbados","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E7 1F1E9","char":"🇧🇩","name":"flag: Bangladesh","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E7 1F1EA","char":"🇧🇪","name":"flag: Belgium","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E7 1F1EB","char":"🇧🇫","name":"flag: Burkina Faso","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E7 1F1EC","char":"🇧🇬","name":"flag: Bulgaria","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E7 1F1ED","char":"🇧🇭","name":"flag: Bahrain","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E7 1F1EE","char":"🇧🇮","name":"flag: Burundi","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E7 1F1EF","char":"🇧🇯","name":"flag: Benin","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E7 1F1F1","char":"🇧🇱","name":"flag: St. Barthélemy","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E7 1F1F2","char":"🇧🇲","name":"flag: Bermuda","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E7 1F1F3","char":"🇧🇳","name":"flag: Brunei","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E7 1F1F4","char":"🇧🇴","name":"flag: Bolivia","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E7 1F1F6","char":"🇧🇶","name":"flag: Caribbean Netherlands","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E7 1F1F7","char":"🇧🇷","name":"flag: Brazil","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E7 1F1F8","char":"🇧🇸","name":"flag: Bahamas","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E7 1F1F9","char":"🇧🇹","name":"flag: Bhutan","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E7 1F1FB","char":"🇧🇻","name":"flag: Bouvet Island","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E7 1F1FC","char":"🇧🇼","name":"flag: Botswana","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E7 1F1FE","char":"🇧🇾","name":"flag: Belarus","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E7 1F1FF","char":"🇧🇿","name":"flag: Belize","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E8 1F1E6","char":"🇨🇦","name":"flag: Canada","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E8 1F1E8","char":"🇨🇨","name":"flag: Cocos (Keeling) Islands","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E8 1F1E9","char":"🇨🇩","name":"flag: Congo - Kinshasa","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E8 1F1EB","char":"🇨🇫","name":"flag: Central African Republic","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E8 1F1EC","char":"🇨🇬","name":"flag: Congo - Brazzaville","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E8 1F1ED","char":"🇨🇭","name":"flag: Switzerland","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E8 1F1EE","char":"🇨🇮","name":"flag: Côte d’Ivoire","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E8 1F1F0","char":"🇨🇰","name":"flag: Cook Islands","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E8 1F1F1","char":"🇨🇱","name":"flag: Chile","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E8 1F1F2","char":"🇨🇲","name":"flag: Cameroon","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E8 1F1F3","char":"🇨🇳","name":"flag: China","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E8 1F1F4","char":"🇨🇴","name":"flag: Colombia","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E8 1F1F5","char":"🇨🇵","name":"flag: Clipperton Island","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E8 1F1F7","char":"🇨🇷","name":"flag: Costa Rica","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E8 1F1FA","char":"🇨🇺","name":"flag: Cuba","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E8 1F1FB","char":"🇨🇻","name":"flag: Cape Verde","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E8 1F1FC","char":"🇨🇼","name":"flag: Curaçao","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E8 1F1FD","char":"🇨🇽","name":"flag: Christmas Island","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E8 1F1FE","char":"🇨🇾","name":"flag: Cyprus","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E8 1F1FF","char":"🇨🇿","name":"flag: Czechia","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E9 1F1EA","char":"🇩🇪","name":"flag: Germany","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E9 1F1EC","char":"🇩🇬","name":"flag: Diego Garcia","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E9 1F1EF","char":"🇩🇯","name":"flag: Djibouti","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E9 1F1F0","char":"🇩🇰","name":"flag: Denmark","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E9 1F1F2","char":"🇩🇲","name":"flag: Dominica","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E9 1F1F4","char":"🇩🇴","name":"flag: Dominican Republic","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1E9 1F1FF","char":"🇩🇿","name":"flag: Algeria","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EA 1F1E6","char":"🇪🇦","name":"flag: Ceuta & Melilla","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EA 1F1E8","char":"🇪🇨","name":"flag: Ecuador","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EA 1F1EA","char":"🇪🇪","name":"flag: Estonia","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EA 1F1EC","char":"🇪🇬","name":"flag: Egypt","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EA 1F1ED","char":"🇪🇭","name":"flag: Western Sahara","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EA 1F1F7","char":"🇪🇷","name":"flag: Eritrea","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EA 1F1F8","char":"🇪🇸","name":"flag: Spain","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EA 1F1F9","char":"🇪🇹","name":"flag: Ethiopia","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EA 1F1FA","char":"🇪🇺","name":"flag: European Union","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EB 1F1EE","char":"🇫🇮","name":"flag: Finland","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EB 1F1EF","char":"🇫🇯","name":"flag: Fiji","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EB 1F1F0","char":"🇫🇰","name":"flag: Falkland Islands","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EB 1F1F2","char":"🇫🇲","name":"flag: Micronesia","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EB 1F1F4","char":"🇫🇴","name":"flag: Faroe Islands","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EB 1F1F7","char":"🇫🇷","name":"flag: France","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EC 1F1E6","char":"🇬🇦","name":"flag: Gabon","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EC 1F1E7","char":"🇬🇧","name":"flag: United Kingdom","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EC 1F1E9","char":"🇬🇩","name":"flag: Grenada","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EC 1F1EA","char":"🇬🇪","name":"flag: Georgia","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EC 1F1EB","char":"🇬🇫","name":"flag: French Guiana","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EC 1F1EC","char":"🇬🇬","name":"flag: Guernsey","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EC 1F1ED","char":"🇬🇭","name":"flag: Ghana","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EC 1F1EE","char":"🇬🇮","name":"flag: Gibraltar","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EC 1F1F1","char":"🇬🇱","name":"flag: Greenland","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EC 1F1F2","char":"🇬🇲","name":"flag: Gambia","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EC 1F1F3","char":"🇬🇳","name":"flag: Guinea","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EC 1F1F5","char":"🇬🇵","name":"flag: Guadeloupe","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EC 1F1F6","char":"🇬🇶","name":"flag: Equatorial Guinea","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EC 1F1F7","char":"🇬🇷","name":"flag: Greece","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EC 1F1F8","char":"🇬🇸","name":"flag: South Georgia & South Sandwich Islands","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EC 1F1F9","char":"🇬🇹","name":"flag: Guatemala","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EC 1F1FA","char":"🇬🇺","name":"flag: Guam","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EC 1F1FC","char":"🇬🇼","name":"flag: Guinea-Bissau","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EC 1F1FE","char":"🇬🇾","name":"flag: Guyana","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1ED 1F1F0","char":"🇭🇰","name":"flag: Hong Kong SAR China","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1ED 1F1F2","char":"🇭🇲","name":"flag: Heard & McDonald Islands","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1ED 1F1F3","char":"🇭🇳","name":"flag: Honduras","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1ED 1F1F7","char":"🇭🇷","name":"flag: Croatia","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1ED 1F1F9","char":"🇭🇹","name":"flag: Haiti","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1ED 1F1FA","char":"🇭🇺","name":"flag: Hungary","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EE 1F1E8","char":"🇮🇨","name":"flag: Canary Islands","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EE 1F1E9","char":"🇮🇩","name":"flag: Indonesia","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EE 1F1EA","char":"🇮🇪","name":"flag: Ireland","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EE 1F1F1","char":"🇮🇱","name":"flag: Israel","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EE 1F1F2","char":"🇮🇲","name":"flag: Isle of Man","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EE 1F1F3","char":"🇮🇳","name":"flag: India","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EE 1F1F4","char":"🇮🇴","name":"flag: British Indian Ocean Territory","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EE 1F1F6","char":"🇮🇶","name":"flag: Iraq","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EE 1F1F7","char":"🇮🇷","name":"flag: Iran","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EE 1F1F8","char":"🇮🇸","name":"flag: Iceland","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EE 1F1F9","char":"🇮🇹","name":"flag: Italy","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EF 1F1EA","char":"🇯🇪","name":"flag: Jersey","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EF 1F1F2","char":"🇯🇲","name":"flag: Jamaica","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EF 1F1F4","char":"🇯🇴","name":"flag: Jordan","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1EF 1F1F5","char":"🇯🇵","name":"flag: Japan","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F0 1F1EA","char":"🇰🇪","name":"flag: Kenya","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F0 1F1EC","char":"🇰🇬","name":"flag: Kyrgyzstan","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F0 1F1ED","char":"🇰🇭","name":"flag: Cambodia","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F0 1F1EE","char":"🇰🇮","name":"flag: Kiribati","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F0 1F1F2","char":"🇰🇲","name":"flag: Comoros","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F0 1F1F3","char":"🇰🇳","name":"flag: St. Kitts & Nevis","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F0 1F1F5","char":"🇰🇵","name":"flag: North Korea","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F0 1F1F7","char":"🇰🇷","name":"flag: South Korea","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F0 1F1FC","char":"🇰🇼","name":"flag: Kuwait","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F0 1F1FE","char":"🇰🇾","name":"flag: Cayman Islands","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F0 1F1FF","char":"🇰🇿","name":"flag: Kazakhstan","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F1 1F1E6","char":"🇱🇦","name":"flag: Laos","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F1 1F1E7","char":"🇱🇧","name":"flag: Lebanon","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F1 1F1E8","char":"🇱🇨","name":"flag: St. Lucia","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F1 1F1EE","char":"🇱🇮","name":"flag: Liechtenstein","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F1 1F1F0","char":"🇱🇰","name":"flag: Sri Lanka","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F1 1F1F7","char":"🇱🇷","name":"flag: Liberia","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F1 1F1F8","char":"🇱🇸","name":"flag: Lesotho","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F1 1F1F9","char":"🇱🇹","name":"flag: Lithuania","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F1 1F1FA","char":"🇱🇺","name":"flag: Luxembourg","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F1 1F1FB","char":"🇱🇻","name":"flag: Latvia","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F1 1F1FE","char":"🇱🇾","name":"flag: Libya","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F2 1F1E6","char":"🇲🇦","name":"flag: Morocco","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F2 1F1E8","char":"🇲🇨","name":"flag: Monaco","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F2 1F1E9","char":"🇲🇩","name":"flag: Moldova","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F2 1F1EA","char":"🇲🇪","name":"flag: Montenegro","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F2 1F1EB","char":"🇲🇫","name":"flag: St. Martin","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F2 1F1EC","char":"🇲🇬","name":"flag: Madagascar","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F2 1F1ED","char":"🇲🇭","name":"flag: Marshall Islands","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F2 1F1F0","char":"🇲🇰","name":"flag: North Macedonia","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F2 1F1F1","char":"🇲🇱","name":"flag: Mali","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F2 1F1F2","char":"🇲🇲","name":"flag: Myanmar (Burma)","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F2 1F1F3","char":"🇲🇳","name":"flag: Mongolia","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F2 1F1F4","char":"🇲🇴","name":"flag: Macao SAR China","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F2 1F1F5","char":"🇲🇵","name":"flag: Northern Mariana Islands","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F2 1F1F6","char":"🇲🇶","name":"flag: Martinique","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F2 1F1F7","char":"🇲🇷","name":"flag: Mauritania","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F2 1F1F8","char":"🇲🇸","name":"flag: Montserrat","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F2 1F1F9","char":"🇲🇹","name":"flag: Malta","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F2 1F1FA","char":"🇲🇺","name":"flag: Mauritius","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F2 1F1FB","char":"🇲🇻","name":"flag: Maldives","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F2 1F1FC","char":"🇲🇼","name":"flag: Malawi","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F2 1F1FD","char":"🇲🇽","name":"flag: Mexico","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F2 1F1FE","char":"🇲🇾","name":"flag: Malaysia","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F2 1F1FF","char":"🇲🇿","name":"flag: Mozambique","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F3 1F1E6","char":"🇳🇦","name":"flag: Namibia","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F3 1F1E8","char":"🇳🇨","name":"flag: New Caledonia","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F3 1F1EA","char":"🇳🇪","name":"flag: Niger","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F3 1F1EB","char":"🇳🇫","name":"flag: Norfolk Island","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F3 1F1EC","char":"🇳🇬","name":"flag: Nigeria","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F3 1F1EE","char":"🇳🇮","name":"flag: Nicaragua","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F3 1F1F1","char":"🇳🇱","name":"flag: Netherlands","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F3 1F1F4","char":"🇳🇴","name":"flag: Norway","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F3 1F1F5","char":"🇳🇵","name":"flag: Nepal","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F3 1F1F7","char":"🇳🇷","name":"flag: Nauru","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F3 1F1FA","char":"🇳🇺","name":"flag: Niue","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F3 1F1FF","char":"🇳🇿","name":"flag: New Zealand","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F4 1F1F2","char":"🇴🇲","name":"flag: Oman","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F5 1F1E6","char":"🇵🇦","name":"flag: Panama","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F5 1F1EA","char":"🇵🇪","name":"flag: Peru","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F5 1F1EB","char":"🇵🇫","name":"flag: French Polynesia","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F5 1F1EC","char":"🇵🇬","name":"flag: Papua New Guinea","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F5 1F1ED","char":"🇵🇭","name":"flag: Philippines","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F5 1F1F0","char":"🇵🇰","name":"flag: Pakistan","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F5 1F1F1","char":"🇵🇱","name":"flag: Poland","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F5 1F1F2","char":"🇵🇲","name":"flag: St. Pierre & Miquelon","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F5 1F1F3","char":"🇵🇳","name":"flag: Pitcairn Islands","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F5 1F1F7","char":"🇵🇷","name":"flag: Puerto Rico","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F5 1F1F8","char":"🇵🇸","name":"flag: Palestinian Territories","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F5 1F1F9","char":"🇵🇹","name":"flag: Portugal","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F5 1F1FC","char":"🇵🇼","name":"flag: Palau","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F5 1F1FE","char":"🇵🇾","name":"flag: Paraguay","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F6 1F1E6","char":"🇶🇦","name":"flag: Qatar","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F7 1F1EA","char":"🇷🇪","name":"flag: Réunion","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F7 1F1F4","char":"🇷🇴","name":"flag: Romania","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F7 1F1F8","char":"🇷🇸","name":"flag: Serbia","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F7 1F1FA","char":"🇷🇺","name":"flag: Russia","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F7 1F1FC","char":"🇷🇼","name":"flag: Rwanda","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F8 1F1E6","char":"🇸🇦","name":"flag: Saudi Arabia","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F8 1F1E7","char":"🇸🇧","name":"flag: Solomon Islands","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F8 1F1E8","char":"🇸🇨","name":"flag: Seychelles","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F8 1F1E9","char":"🇸🇩","name":"flag: Sudan","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F8 1F1EA","char":"🇸🇪","name":"flag: Sweden","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F8 1F1EC","char":"🇸🇬","name":"flag: Singapore","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F8 1F1ED","char":"🇸🇭","name":"flag: St. Helena","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F8 1F1EE","char":"🇸🇮","name":"flag: Slovenia","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F8 1F1EF","char":"🇸🇯","name":"flag: Svalbard & Jan Mayen","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F8 1F1F0","char":"🇸🇰","name":"flag: Slovakia","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F8 1F1F1","char":"🇸🇱","name":"flag: Sierra Leone","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F8 1F1F2","char":"🇸🇲","name":"flag: San Marino","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F8 1F1F3","char":"🇸🇳","name":"flag: Senegal","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F8 1F1F4","char":"🇸🇴","name":"flag: Somalia","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F8 1F1F7","char":"🇸🇷","name":"flag: Suriname","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F8 1F1F8","char":"🇸🇸","name":"flag: South Sudan","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F8 1F1F9","char":"🇸🇹","name":"flag: São Tomé & Príncipe","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F8 1F1FB","char":"🇸🇻","name":"flag: El Salvador","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F8 1F1FD","char":"🇸🇽","name":"flag: Sint Maarten","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F8 1F1FE","char":"🇸🇾","name":"flag: Syria","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F8 1F1FF","char":"🇸🇿","name":"flag: Eswatini","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F9 1F1E6","char":"🇹🇦","name":"flag: Tristan da Cunha","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F9 1F1E8","char":"🇹🇨","name":"flag: Turks & Caicos Islands","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F9 1F1E9","char":"🇹🇩","name":"flag: Chad","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F9 1F1EB","char":"🇹🇫","name":"flag: French Southern Territories","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F9 1F1EC","char":"🇹🇬","name":"flag: Togo","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F9 1F1ED","char":"🇹🇭","name":"flag: Thailand","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F9 1F1EF","char":"🇹🇯","name":"flag: Tajikistan","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F9 1F1F0","char":"🇹🇰","name":"flag: Tokelau","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F9 1F1F1","char":"🇹🇱","name":"flag: Timor-Leste","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F9 1F1F2","char":"🇹🇲","name":"flag: Turkmenistan","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F9 1F1F3","char":"🇹🇳","name":"flag: Tunisia","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F9 1F1F4","char":"🇹🇴","name":"flag: Tonga","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F9 1F1F7","char":"🇹🇷","name":"flag: Türkiye","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F9 1F1F9","char":"🇹🇹","name":"flag: Trinidad & Tobago","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F9 1F1FB","char":"🇹🇻","name":"flag: Tuvalu","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F9 1F1FC","char":"🇹🇼","name":"flag: Taiwan","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1F9 1F1FF","char":"🇹🇿","name":"flag: Tanzania","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1FA 1F1E6","char":"🇺🇦","name":"flag: Ukraine","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1FA 1F1EC","char":"🇺🇬","name":"flag: Uganda","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1FA 1F1F2","char":"🇺🇲","name":"flag: U.S. Outlying Islands","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1FA 1F1F3","char":"🇺🇳","name":"flag: United Nations","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1FA 1F1F8","char":"🇺🇸","name":"flag: United States","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1FA 1F1FE","char":"🇺🇾","name":"flag: Uruguay","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1FA 1F1FF","char":"🇺🇿","name":"flag: Uzbekistan","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1FB 1F1E6","char":"🇻🇦","name":"flag: Vatican City","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1FB 1F1E8","char":"🇻🇨","name":"flag: St. Vincent & Grenadines","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1FB 1F1EA","char":"🇻🇪","name":"flag: Venezuela","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1FB 1F1EC","char":"🇻🇬","name":"flag: British Virgin Islands","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1FB 1F1EE","char":"🇻🇮","name":"flag: U.S. Virgin Islands","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1FB 1F1F3","char":"🇻🇳","name":"flag: Vietnam","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1FB 1F1FA","char":"🇻🇺","name":"flag: Vanuatu","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1FC 1F1EB","char":"🇼🇫","name":"flag: Wallis & Futuna","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1FC 1F1F8","char":"🇼🇸","name":"flag: Samoa","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1FD 1F1F0","char":"🇽🇰","name":"flag: Kosovo","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1FE 1F1EA","char":"🇾🇪","name":"flag: Yemen","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1FE 1F1F9","char":"🇾🇹","name":"flag: Mayotte","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1FF 1F1E6","char":"🇿🇦","name":"flag: South Africa","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1FF 1F1F2","char":"🇿🇲","name":"flag: Zambia","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F1FF 1F1FC","char":"🇿🇼","name":"flag: Zimbabwe","category":"Flags (country-flag)","group":"Flags","subgroup":"country-flag"},{"codes":"1F3F4 E0067 E0062 E0065 E006E E0067 E007F","char":"🏴󠁧󠁢󠁥󠁮󠁧󠁿","name":"flag: England","category":"Flags (subdivision-flag)","group":"Flags","subgroup":"subdivision-flag"},{"codes":"1F3F4 E0067 E0062 E0073 E0063 E0074 E007F","char":"🏴󠁧󠁢󠁳󠁣󠁴󠁿","name":"flag: Scotland","category":"Flags (subdivision-flag)","group":"Flags","subgroup":"subdivision-flag"},{"codes":"1F3F4 E0067 E0062 E0077 E006C E0073 E007F","char":"🏴󠁧󠁢󠁷󠁬󠁳󠁿","name":"flag: Wales","category":"Flags (subdivision-flag)","group":"Flags","subgroup":"subdivision-flag"}]'), NE = { class: "-m-base" }, VE = { class: "max-h-72 overflow-y-auto divide-y divide-default-300 pb-base" }, zE = { class: "sticky top-0 bg-white p-base" }, IE = { class: "px-2 grid grid-cols-6 gap-1" }, RE = {
  key: 1,
  class: "pt-base px-base text-sm text-center"
}, dR = /* @__PURE__ */ H({
  __name: "EmojiPicker",
  props: {
    disabled: { type: Boolean },
    placement: { default: void 0 }
  },
  emits: ["change"],
  setup(o, { emit: e }) {
    const r = e, t = ue(""), n = se(() => {
      const a = t.value.length > 2 ? Vf.filter((s) => s.name.includes(t.value)) : Vf;
      return P2(a, (s) => s.category.replace(/\s*\(.*?\)/, ""));
    });
    return (a, s) => (k(), R(o0, {
      size: "xs",
      disabled: a.disabled,
      placement: a.placement
    }, {
      trigger: j(({ open: i }) => [
        a.$slots.default ? I(a.$slots, "default", {
          key: 0,
          open: i
        }) : (k(), R(B(rr), {
          key: 1,
          as: Re,
          icon: B(M3),
          color: "tertiary",
          "aria-label": "Open emoji picker",
          disabled: a.disabled
        }, null, 8, ["icon", "disabled"]))
      ]),
      default: j(() => [
        O("div", NE, [
          z(Xp, { class: "p-base" }, {
            default: j(() => [
              z(Sa, { class: "sr-only" }, {
                default: j(() => s[1] || (s[1] = [
                  ne(" Search ")
                ])),
                _: 1
              }),
              z(Ut, {
                modelValue: t.value,
                "onUpdate:modelValue": s[0] || (s[0] = (i) => t.value = i),
                placeholder: "Search",
                "leading-icon": B(fS),
                type: "search"
              }, null, 8, ["modelValue", "leading-icon"])
            ]),
            _: 1
          }),
          z(r0),
          O("div", VE, [
            Object.values(n.value).length ? (k(!0), N(ye, { key: 0 }, Oe(n.value, (i, l) => (k(), N("div", { key: l }, [
              O("div", zE, [
                z(Sa, { as: "span" }, {
                  default: j(() => [
                    ne(_(l), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              O("div", IE, [
                (k(!0), N(ye, null, Oe(i, (c) => (k(), R(B(rr), {
                  key: c.name,
                  class: q([
                    "border-transparent bg-transparent text-default-900 px-2.5 py-2 inline-flex justify-center items-center font-medium border border-px rounded-md",
                    "hover:bg-default-50",
                    "active:bg-white",
                    "focus-visible:outline-none focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:bg-default-200 focus-visible:outline-primary-900"
                  ]),
                  "aria-label": c.name,
                  onClick: (u) => r("change", c.char)
                }, {
                  default: j(() => [
                    O("span", null, _(c.char), 1)
                  ]),
                  _: 2
                }, 1032, ["aria-label", "onClick"]))), 128))
              ])
            ]))), 128)) : (k(), N("div", RE, [
              z(oo, null, {
                default: j(() => s[2] || (s[2] = [
                  ne("No emojis found.")
                ])),
                _: 1
              })
            ]))
          ])
        ])
      ]),
      _: 3
    }, 8, ["disabled", "placement"]));
  }
}), gR = /* @__PURE__ */ H({
  __name: "EmptyStateCard",
  setup(o) {
    return (e, r) => (k(), R(Ti, { size: "xl" }, {
      default: j(() => [
        z(Li, { class: "text-center [&>svg]:pb-6 [&>*:last-child:not(p)]:mt-6" }, {
          default: j(() => [
            I(e.$slots, "default")
          ]),
          _: 3
        })
      ]),
      _: 3
    }));
  }
}), mR = /* @__PURE__ */ H({
  __name: "EmptyStateCardTitle",
  props: {
    as: {}
  },
  setup(o) {
    return (e, r) => (k(), R(Vo, {
      as: e.as,
      size: "xl",
      color: "primary"
    }, {
      default: j(() => [
        I(e.$slots, "default")
      ]),
      _: 3
    }, 8, ["as"]));
  }
}), fR = /* @__PURE__ */ H({
  __name: "EmptyStateCardDescription",
  setup(o) {
    return (e, r) => (k(), R(oo, {
      color: "secondary",
      class: "pt-2"
    }, {
      default: j(() => [
        I(e.$slots, "default")
      ]),
      _: 3
    }));
  }
}), HE = ["src"], yR = /* @__PURE__ */ H({
  __name: "EmptyStateButton",
  props: {
    as: { default: void 0 },
    block: { type: Boolean, default: !1 },
    color: { default: "primary" },
    disabled: { type: Boolean, default: !1 },
    href: { default: void 0 },
    image: { default: void 0 },
    size: { default: "base" },
    variant: { default: "horizontal" },
    circle: { type: Boolean, default: !1 }
  },
  setup(o) {
    const e = o, r = /* @__PURE__ */ new Map([
      ["primary", "bg-primary-50 text-primary-600 hover:outline-primary-600 focus-visible:border-primary-600 focus-visible:outline-primary-900"],
      ["secondary", "bg-white text-default-900 hover:text-primary-600 focus-visible:text-primary-600 focus-visible:border-primary-600 focus-visible:outline-primary-900"]
    ]), t = /* @__PURE__ */ new Map([
      ["horizontal", "inline-flex"],
      ["vertical", "flex flex-col"]
    ]), n = /* @__PURE__ */ new Map([
      ["sm", "px-2 py-1 text-sm gap-x-1.5 gap-y-2"],
      ["base", "px-3 py-2 text-sm gap-x-1.5 gap-y-2"],
      ["lg", "px-3.5 py-2.5 text-sm gap-x-2 gap-y-2"],
      ["xl", "px-7 py-4 text-base gap-x-2 gap-y-2"]
    ]), a = {
      sm: "rounded",
      base: "rounded-md",
      lg: "rounded-md",
      xl: "rounded-md"
    }, s = se(() => e.circle ? "rounded-full" : a[e.size]);
    return (i, l) => (k(), R(ve(i.as ?? (i.href ? B(yo) : "button")), {
      class: q([
        "relative outline-1 outline-default-300 outline-dashed font-medium justify-center items-center",
        "focus-visible:outline-none focus-visible:outline-2 focus-visible:outline-offset-2",
        B(r).get(i.color),
        B(t).get(i.variant),
        B(n).get(i.size),
        i.disabled && "disabled:pointer-events-none disabled:bg-default-200 disabled:border-default-400 disabled:text-default-400",
        i.block && "w-full",
        s.value
      ]),
      href: i.href,
      disabled: i.disabled,
      "aria-disabled": i.disabled,
      tabindex: i.disabled ? "-1" : 0
    }, {
      default: j(() => [
        z(vr),
        i.color === "primary" ? (k(), R(B(le), {
          key: 0,
          icon: B(HF),
          class: q([
            "rounded-full",
            i.size === "sm" ? "ring-1 size-3" : "ring-4 size-4",
            i.disabled ? "ring-default-300" : "ring-primary-100"
          ])
        }, null, 8, ["icon", "class"])) : i.color === "secondary" ? (k(), R(B(le), {
          key: 1,
          icon: B(Dp),
          class: q([
            "rounded-full",
            i.size === "sm" ? "size-3" : "size-4"
          ])
        }, null, 8, ["icon", "class"])) : K("", !0),
        O("span", null, [
          I(i.$slots, "default")
        ]),
        i.image && i.variant === "vertical" ? (k(), N("img", {
          key: 2,
          src: i.image,
          alt: "",
          class: "absolute bottom-0 w-1/2 h-16"
        }, null, 8, HE)) : K("", !0)
      ]),
      _: 3
    }, 8, ["class", "href", "disabled", "aria-disabled", "tabindex"]));
  }
}), hR = /* @__PURE__ */ H({
  __name: "EmptyStateIconButton",
  props: {
    as: { default: void 0 },
    block: { type: Boolean, default: !1 },
    color: { default: "primary" },
    disabled: { type: Boolean, default: !1 },
    href: { default: void 0 },
    size: { default: "base" }
  },
  setup(o) {
    const e = /* @__PURE__ */ new Map([
      ["primary", "bg-primary-50 text-primary-600 hover:outline-primary-600 focus-visible:border-primary-600 focus-visible:outline-primary-900"],
      ["secondary", "bg-white text-default-900 hover:text-primary-600 focus-visible:text-primary-600 focus-visible:border-primary-600 focus-visible:outline-primary-900"]
    ]), r = /* @__PURE__ */ new Map([
      ["sm", "p-2"],
      ["base", "p-2.5"],
      ["lg", "p-3"],
      ["xl", "p-5"]
    ]);
    return (t, n) => (k(), R(ve(t.as ?? (t.href ? B(yo) : "button")), {
      class: q([
        "relative rounded-md outline-1 outline-default-300 outline-dashed font-medium inline-flex justify-center items-center",
        "focus-visible:outline-none focus-visible:outline-2 focus-visible:outline-offset-2",
        B(e).get(t.color),
        B(r).get(t.size),
        t.disabled && "disabled:pointer-events-none disabled:bg-default-200 disabled:border-default-400 disabled:text-default-400",
        t.block && "w-full"
      ]),
      href: t.href,
      disabled: t.disabled,
      "aria-disabled": t.disabled,
      tabindex: t.disabled ? "-1" : 0
    }, {
      default: j(() => [
        z(vr),
        t.color === "primary" ? (k(), R(B(le), {
          key: 0,
          icon: B(HF),
          class: q([
            "rounded-full",
            t.size === "sm" ? "ring-1 size-3" : "ring-4 size-4",
            t.disabled ? "ring-default-300" : "ring-primary-100"
          ])
        }, null, 8, ["icon", "class"])) : t.color === "secondary" ? (k(), R(B(le), {
          key: 1,
          icon: B(Dp),
          class: q([
            "rounded-full",
            t.size === "sm" ? "size-3" : "size-4"
          ])
        }, null, 8, ["icon", "class"])) : K("", !0)
      ]),
      _: 1
    }, 8, ["class", "href", "disabled", "aria-disabled", "tabindex"]));
  }
}), YE = /* @__PURE__ */ H({
  __name: "ErrorMessage",
  props: {
    as: { default: "p" }
  },
  setup(o) {
    const e = ce("field-id", "");
    return (r, t) => (k(), R(ve(r.as), {
      id: B(e) ? `${B(e)}-error` : void 0,
      class: "text-sm text-red-600"
    }, {
      default: j(() => [
        I(r.$slots, "default")
      ]),
      _: 3
    }, 8, ["id"]));
  }
}), FR = /* @__PURE__ */ H({
  __name: "ExpandingButton",
  props: {
    as: { default: void 0 },
    ariaLabel: {},
    label: {},
    labelPosition: { default: "start" },
    color: { default: "primary" },
    disabled: { type: Boolean },
    href: { default: void 0 },
    icon: {},
    loading: { type: Boolean },
    method: { default: void 0 },
    size: { default: "base" },
    type: { default: void 0 }
  },
  setup(o) {
    const e = o, r = {
      sm: [
        "px-2 py-1 text-sm rounded",
        "hover:gap-x-1.5",
        "focus:gap-x-1.5"
      ].join(" "),
      base: [
        "px-2.5 py-2 text-sm rounded-md",
        "hover:px-3 hover:gap-x-1.5",
        "focus:px-3 focus:gap-x-1.5"
      ].join(" "),
      lg: [
        "px-3 py-2.5 text-sm rounded-md",
        "hover:px-3.5 hover:gap-x-2",
        "focus:px-3.5 focus:gap-x-2"
      ].join(" "),
      xl: [
        "px-5 py-4 text-base rounded-md",
        "hover:px-7 hover:gap-x-2",
        "focus:px-7 focus:gap-x-2"
      ].join(" ")
    }, t = {
      primary: "shadow-sm ring-transparent bg-primary-600 text-white hover:bg-primary-700 active:bg-primary-900 focus-visible:bg-primary-900 focus-visible:outline-primary-900",
      secondary: "shadow-sm ring-default-300 bg-white text-default-900 hover:bg-default-50 active:bg-white focus-visible:outline-primary-900 disabled:border-transparent",
      tertiary: "ring-transparent bg-transparent text-default-900 hover:bg-default-50 active:bg-white focus-visible:bg-default-200 focus-visible:outline-primary-900",
      danger: "shadow-sm ring-transparent bg-red-600 text-white hover:bg-red-700 active:bg-red-800 focus-visible:outline-primary-900",
      ai: "shadow-sm ring-transparent bg-gradient-to-r from-[#942aa9] to-[#2b4dd0] text-white hover:bg-gradient-to-l active:bg-gradient-to-r focus-visible:outline-primary-900 disabled:bg-none",
      dark: "shadow-sm ring-transparent bg-black text-white hover:bg-default-900 active:bg-default-900 focus-visible:bg-default-900 focus-visible:outline-primary-900"
    }, n = se(() => r[e.size]), a = se(() => t[e.color]), s = se(() => e.disabled || e.loading);
    return (i, l) => (k(), R(ve(i.as ?? (i.href ? B(yo) : "button")), {
      class: q([
        "group relative inline-flex justify-center items-center font-medium text-nowrap ring-1 border-0",
        "focus-visible:outline-none focus-visible:outline-2 focus-visible:outline-offset-2",
        "hover:text-wrap",
        "focus:text-wrap",
        n.value,
        a.value,
        s.value && "disabled:pointer-events-none disabled:bg-default-200 disabled:ring-default-400 disabled:text-default-400"
      ]),
      href: i.href,
      type: i.type,
      method: i.method,
      disabled: s.value,
      "aria-disabled": s.value,
      "aria-busy": i.loading,
      tabindex: s.value ? "-1" : 0,
      "aria-label": i.ariaLabel
    }, {
      default: j(() => [
        z(vr),
        i.loading ? (k(), R(Yr, {
          key: 0,
          class: "size-4"
        })) : (k(), R(B(le), {
          key: 1,
          icon: i.icon,
          "aria-hidden": "true",
          class: q(i.size === "sm" ? "size-3" : "size-4")
        }, null, 8, ["icon", "class"])),
        O("span", {
          class: q([
            "invisible w-0 overflow-hidden opacity-50 transition-all duration-150 ease-in",
            "group-hover:visible group-hover:w-auto group-hover:opacity-100",
            "group-focus:visible group-focus:w-auto group-focus:opacity-100",
            i.labelPosition === "start" && "order-first"
          ])
        }, _(i.label), 3)
      ]),
      _: 1
    }, 8, ["class", "href", "type", "method", "disabled", "aria-disabled", "aria-busy", "tabindex", "aria-label"]));
  }
}), qE = ["aria-labelledby"], GE = /* @__PURE__ */ H({
  __name: "Fieldset",
  setup(o) {
    const e = fo();
    return he("fieldset-id", e), (r, t) => (k(), N("fieldset", { "aria-labelledby": B(e) }, [
      I(r.$slots, "default")
    ], 8, qE));
  }
}), bR = /* @__PURE__ */ H({
  __name: "FormatNumber",
  props: {
    maximumFractionDigits: { default: void 0 },
    minimumFractionDigits: { default: void 0 },
    notation: { default: "standard" },
    style: { default: "decimal" },
    unit: { default: void 0 },
    value: {}
  },
  setup(o) {
    const e = o, r = se(() => new Intl.NumberFormat("en-GB", {
      currency: e.style === "currency" ? "GBP" : void 0,
      notation: e.notation,
      minimumFractionDigits: e.minimumFractionDigits,
      maximumFractionDigits: e.maximumFractionDigits,
      style: e.style,
      unit: e.style === "unit" ? e.unit : void 0
    }).format(e.value));
    return (t, n) => _(r.value);
  }
}), vR = /* @__PURE__ */ H({
  __name: "GridCheckboxGroup",
  props: {
    indicator: { default: "default" }
  },
  setup(o) {
    const e = o, r = fo();
    return he("grid-checkbox-group-id", r), he("grid-checkbox-group-indicator", e.indicator), (t, n) => (k(), R(GE, {
      class: "relative [&:has([data-slot='legend']:not(.sr-only))_[data-slot='options']]:mt-4 [&:has([data-slot='description']:not(.sr-only))_[data-slot='options']]:mt-4",
      "aria-describedby": B(r)
    }, {
      default: j(() => [
        I(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["aria-describedby"]));
  }
}), BR = /* @__PURE__ */ H({
  __name: "GridCheckboxGroupDescription",
  props: {
    as: { default: "p" }
  },
  setup(o) {
    const e = ce("grid-checkbox-group-id");
    return (r, t) => (k(), R(ve(r.as), {
      id: B(e),
      class: "text-default-700 font-sans text-sm",
      "data-slot": "description"
    }, {
      default: j(() => [
        I(r.$slots, "default")
      ]),
      _: 3
    }, 8, ["id"]));
  }
}), XE = ["id"], UE = /* @__PURE__ */ H({
  __name: "Legend",
  setup(o) {
    const { labelClasses: e } = Ni(), r = ce("fieldset-id");
    return (t, n) => (k(), N("div", {
      id: B(r),
      class: q(B(e))
    }, [
      I(t.$slots, "default")
    ], 10, XE));
  }
}), PR = /* @__PURE__ */ H({
  __name: "GridCheckboxGroupLegend",
  setup(o) {
    return (e, r) => (k(), R(UE, {
      class: "block",
      "data-slot": "legend"
    }, {
      default: j(() => [
        I(e.$slots, "default")
      ]),
      _: 3
    }));
  }
}), ZE = ["id", "disabled", "tabindex", "aria-disabled", "checked", "value"], KE = ["for"], QE = { class: "sr-only" }, JE = {
  key: 1,
  class: "z-50 absolute top-2 right-2 inline-flex items-center justify-center p-0.5 rounded-full bg-white ring-1 ring-default-300"
}, _E = {
  key: 0,
  class: "inline-flex p-2 rounded-full bg-primary-600"
}, $E = {
  key: 1,
  class: "inline-flex size-7 items-center justify-center rounded-full bg-primary-600 font-medium text-white"
}, wR = /* @__PURE__ */ H({
  inheritAttrs: !1,
  __name: "GridCheckboxGroupOption",
  props: {
    by: { default: void 0 },
    checked: { type: Boolean },
    label: {},
    disabled: { type: Boolean },
    modelValue: { default: void 0 },
    value: { default: void 0 },
    variant: { default: "default" }
  },
  emits: ["update:modelValue"],
  setup(o, { emit: e }) {
    const r = o, t = ce("grid-checkbox-group-indicator"), n = e, a = se(() => {
      var l;
      return r.checked ? !0 : r.by ? !!((l = r.modelValue) != null && l.find((c) => {
        var u;
        return c[r.by] === ((u = r.value) == null ? void 0 : u[r.by]);
      })) : !r.value || !r.modelValue ? !1 : r.modelValue.includes(r.value);
    }), s = () => {
      var u, f;
      if (!r.value || !r.modelValue) {
        n("update:modelValue", !r.checked);
        return;
      }
      const l = r.by ? (u = r.modelValue) == null ? void 0 : u.findIndex((g) => {
        var d;
        return g[r.by] === ((d = r.value) == null ? void 0 : d[r.by]);
      }) : (f = r.modelValue) == null ? void 0 : f.indexOf(r.value), { modelValue: c } = r;
      l === -1 ? c == null || c.push(r.value) : c == null || c.splice(l, 1), n("update:modelValue", c);
    }, i = fo();
    return (l, c) => {
      var u, f;
      return k(), N("div", null, [
        O("input", {
          id: B(i),
          type: "checkbox",
          disabled: l.disabled,
          tabindex: l.disabled ? "-1" : 0,
          "aria-disabled": l.disabled,
          checked: a.value,
          class: q([
            "sr-only",
            "[&:focus-visible+label]:ring-2 [&:focus-visible+label]:ring-offset-2 [&:focus-visible+label]:ring-primary-600"
          ]),
          value: l.value,
          onChange: s
        }, null, 40, ZE),
        O("label", Ve({
          for: B(i),
          class: [
            "isolate flex bg-white min-h-12 relative border-2 border-default-300 w-full shadow-md cursor-pointer outline-none rounded-lg overflow-hidden",
            "hover:ring-2 hover:ring-offset-2 hover:ring-primary-600",
            a.value && "ring-2 ring-offset-2 ring-primary-600",
            l.disabled && "opacity-50 pointer-events-none"
          ]
        }, l.$attrs), [
          l.variant === "ai" ? (k(), R(Ai, { key: 0 })) : K("", !0),
          O("span", QE, _(l.label), 1),
          a.value && B(t) !== "none" ? (k(), N("span", JE, [
            B(t) === "default" ? (k(), N("span", _E, [
              z(B(le), {
                icon: B(qa),
                class: "size-4 text-white",
                "aria-hidden": "true"
              }, null, 8, ["icon"])
            ])) : K("", !0),
            B(t) === "number" ? (k(), N("span", $E, _((l.by ? (u = l.modelValue) == null ? void 0 : u.findIndex((g) => {
              var d;
              return g[l.by] === ((d = l.value) == null ? void 0 : d[l.by]);
            }) : (f = l.modelValue) == null ? void 0 : f.indexOf(l.value)) + 1), 1)) : K("", !0)
          ])) : K("", !0),
          I(l.$slots, "default", { checked: a.value })
        ], 16, KE)
      ]);
    };
  }
}), kR = /* @__PURE__ */ H({
  __name: "GridCheckboxGroupOptions",
  props: {
    columns: { default: 1 },
    gap: { default: "base" }
  },
  setup(o) {
    const e = /* @__PURE__ */ new Map([
      [1, "grid-cols-1"],
      [2, "grid-cols-2"],
      [3, "grid-cols-3"],
      [4, "grid-cols-4"],
      [5, "grid-cols-5"],
      [6, "grid-cols-6"],
      [7, "grid-cols-7"],
      [8, "grid-cols-8"],
      [9, "grid-cols-9"],
      [10, "grid-cols-10"],
      [11, "grid-cols-11"],
      [12, "grid-cols-12"]
    ]), r = /* @__PURE__ */ new Map([
      ["tiny", "gap-tiny [&+div[data-slot=options]]:mt-tiny"],
      ["xxs", "gap-xxs [&+div[data-slot=options]]:mt-xxs"],
      ["xs", "gap-xs [&+div[data-slot=options]]:mt-xs"],
      ["sm", "gap-sm [&+div[data-slot=options]]:mt-sm"],
      ["md", "gap-md [&+div[data-slot=options]]:mt-md"],
      ["base", "gap-base [&+div[data-slot=options]]:mt-base"],
      ["lg", "gap-lg [&+div[data-slot=options]]:mt-lg"],
      ["xl", "gap-xl [&+div[data-slot=options]]:mt-xl"],
      ["xxl", "gap-xxl [&+div[data-slot=options]]:mt-xxl"],
      ["huge", "gap-huge [&+div[data-slot=options]]:mt-huge"]
    ]);
    return (t, n) => (k(), N("div", {
      class: q([
        "grid",
        B(e).get(t.columns),
        B(r).get(t.gap)
      ]),
      "data-slot": "options"
    }, [
      I(t.$slots, "default")
    ], 2));
  }
}), DR = /* @__PURE__ */ H({
  __name: "GridRadioGroup",
  props: {
    by: { type: [String, Function], default: void 0 },
    hideCheckedIndicator: { type: Boolean, default: !1 }
  },
  setup(o) {
    return he("grid-radio-group-hide-checked-indicator", o.hideCheckedIndicator), he("field-label-context", {
      as: hi
    }), (r, t) => (k(), R(B(Fi), {
      by: r.by,
      class: "[&:has([data-slot='label']:not(.sr-only))_[data-slot='options']]:mt-4 [&:has([data-slot='description']:not(.sr-only))_[data-slot='options']]:mt-4"
    }, {
      default: j(() => [
        I(r.$slots, "default")
      ]),
      _: 3
    }, 8, ["by"]));
  }
}), SR = /* @__PURE__ */ H({
  __name: "GridRadioGroupDescription",
  setup(o) {
    return (e, r) => (k(), R(B(Ch), {
      class: "text-default-700 font-sans text-sm",
      "data-slot": "description"
    }, {
      default: j(() => [
        I(e.$slots, "default")
      ]),
      _: 3
    }));
  }
}), ex = {
  key: 1,
  class: "z-50 absolute top-2 right-2 inline-flex items-center justify-center p-0.5 rounded-full bg-white ring-1 ring-default-300"
}, ox = { class: "inline-flex p-2 rounded-full bg-primary-600" }, AR = /* @__PURE__ */ H({
  __name: "GridRadioGroupOption",
  props: {
    variant: { default: "default" }
  },
  setup(o) {
    const e = ce("grid-radio-group-hide-checked-indicator");
    return (r, t) => (k(), R(B(bi), { as: "template" }, {
      default: j(({ checked: n, disabled: a }) => [
        O("button", {
          class: q([
            "isolate bg-white min-h-12 relative border-2 border-default-300 w-full shadow-md cursor-pointer outline-none rounded-lg overflow-hidden",
            "hover:ring-2 hover:ring-offset-2 hover:ring-primary-600",
            "focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-primary-600",
            n && "ring-2 ring-offset-2 ring-primary-600",
            a && "opacity-50 pointer-events-none"
          ]),
          type: "button"
        }, [
          r.variant === "ai" ? (k(), R(Ai, { key: 0 })) : K("", !0),
          n && !B(e) ? (k(), N("span", ex, [
            O("span", ox, [
              z(B(le), {
                icon: B(qa),
                class: "size-4 text-white",
                "aria-hidden": "true"
              }, null, 8, ["icon"])
            ])
          ])) : K("", !0),
          I(r.$slots, "default", { checked: n })
        ], 2)
      ]),
      _: 3
    }));
  }
}), ER = /* @__PURE__ */ H({
  __name: "GridRadioGroupOptions",
  props: {
    columns: { default: 1 },
    gap: { default: "base" }
  },
  setup(o) {
    const e = /* @__PURE__ */ new Map([
      [1, "grid-cols-1"],
      [2, "grid-cols-2"],
      [3, "grid-cols-3"],
      [4, "grid-cols-4"],
      [5, "grid-cols-5"],
      [6, "grid-cols-6"],
      [7, "grid-cols-7"],
      [8, "grid-cols-8"],
      [9, "grid-cols-9"],
      [10, "grid-cols-10"],
      [11, "grid-cols-11"],
      [12, "grid-cols-12"]
    ]), r = /* @__PURE__ */ new Map([
      ["tiny", "gap-tiny [&+div[data-slot=options]]:mt-tiny"],
      ["xxs", "gap-xxs [&+div[data-slot=options]]:mt-xxs"],
      ["xs", "gap-xs [&+div[data-slot=options]]:mt-xs"],
      ["sm", "gap-sm [&+div[data-slot=options]]:mt-sm"],
      ["md", "gap-md [&+div[data-slot=options]]:mt-md"],
      ["base", "gap-base [&+div[data-slot=options]]:mt-base"],
      ["lg", "gap-lg [&+div[data-slot=options]]:mt-lg"],
      ["xl", "gap-xl [&+div[data-slot=options]]:mt-xl"],
      ["xxl", "gap-xxl [&+div[data-slot=options]]:mt-xxl"],
      ["huge", "gap-huge [&+div[data-slot=options]]:mt-huge"]
    ]);
    return (t, n) => (k(), N("div", {
      class: q([
        "grid",
        B(e).get(t.columns),
        B(r).get(t.gap)
      ]),
      "data-slot": "options"
    }, [
      I(t.$slots, "default")
    ], 2));
  }
}), xR = /* @__PURE__ */ H({
  __name: "HoverActions",
  setup(o) {
    const e = ue(), r = m2(e), { focused: t } = f2(e), n = se(() => r.value || t.value);
    return he("hover-actions-is-active", n), (a, s) => (k(), N("div", {
      ref_key: "containerRef",
      ref: e,
      class: q([
        "group relative outline-none",
        "focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-primary-600"
      ]),
      tabindex: "0"
    }, [
      I(a.$slots, "default")
    ], 512));
  }
}), CR = /* @__PURE__ */ H({
  __name: "HoverActionsContent",
  setup(o) {
    const e = ce("hover-actions-is-active");
    return (r, t) => (k(), N("div", {
      class: q([
        "bg-black/75 absolute inset-0 space-y-base flex flex-col items-center justify-center transition-opacity duration-300",
        B(e) ? "opacity-100" : "opacity-0 pointer-events-none"
      ])
    }, [
      I(r.$slots, "default")
    ], 2));
  }
}), OR = /* @__PURE__ */ H({
  __name: "HoverActionsTrigger",
  setup(o) {
    const e = ce("hover-actions-is-active");
    return (r, t) => (k(), N("div", {
      class: q(B(e) && "pointer-events-none")
    }, [
      I(r.$slots, "default")
    ], 2));
  }
}), rx = { xmlns: "http://www.w3.org/2000/svg" }, tx = ["id"], nx = ["fill"], ax = /* @__PURE__ */ H({
  __name: "Checkboard",
  setup(o) {
    const e = fo();
    return (r, t) => (k(), N("svg", rx, [
      O("defs", null, [
        O("pattern", {
          id: B(e),
          width: "16",
          height: "16",
          patternUnits: "userSpaceOnUse"
        }, t[0] || (t[0] = [
          O("rect", {
            x: "0",
            y: "0",
            width: "8",
            height: "8",
            fill: "#eee"
          }, null, -1),
          O("rect", {
            x: "8",
            y: "8",
            width: "8",
            height: "8",
            fill: "#eee"
          }, null, -1)
        ]), 8, tx)
      ]),
      O("rect", {
        width: "100%",
        height: "100%",
        fill: `url(#${B(e)})`
      }, null, 8, nx)
    ]));
  }
}), sx = { class: "flex items-center justify-center rounded-md bg-white overflow-hidden" }, ix = {
  key: 0,
  class: "p-base"
}, lx = ["src"], zf = /* @__PURE__ */ H({
  __name: "ImagePreview",
  props: {
    imageUrl: {}
  },
  setup(o) {
    return (e, r) => (k(), N("div", sx, [
      e.imageUrl ? (k(), N("div", ix, [
        O("img", {
          src: e.imageUrl,
          alt: "Image preview"
        }, null, 8, lx)
      ])) : (k(), R(ax, {
        key: 1,
        class: "size-full"
      }))
    ]));
  }
}), cx = { class: "flex rounded-md border border-blue-400 bg-blue-50 p-4 text-sm text-blue-800" }, ux = /* @__PURE__ */ H({
  __name: "InfoBox",
  setup(o) {
    return (e, r) => (k(), N("div", cx, [
      z(B(le), {
        icon: B(zS),
        class: "mr-3 mt-1 text-lg",
        "aria-hidden": "true"
      }, null, 8, ["icon"]),
      O("div", null, [
        I(e.$slots, "default")
      ])
    ]));
  }
}), TR = /* @__PURE__ */ H({
  __name: "InfoBoxTextLink",
  props: {
    as: { default: yo }
  },
  setup(o) {
    return (e, r) => (k(), R(ve(e.as), {
      class: q([
        "text-blue-800 underline underline-offset-2",
        "hover:text-blue-900"
      ])
    }, {
      default: j(() => [
        I(e.$slots, "default")
      ]),
      _: 3
    }));
  }
});
function _e(o) {
  this.content = o;
}
_e.prototype = {
  constructor: _e,
  find: function(o) {
    for (var e = 0; e < this.content.length; e += 2)
      if (this.content[e] === o) return e;
    return -1;
  },
  // :: (string) → ?any
  // Retrieve the value stored under `key`, or return undefined when
  // no such key exists.
  get: function(o) {
    var e = this.find(o);
    return e == -1 ? void 0 : this.content[e + 1];
  },
  // :: (string, any, ?string) → OrderedMap
  // Create a new map by replacing the value of `key` with a new
  // value, or adding a binding to the end of the map. If `newKey` is
  // given, the key of the binding will be replaced with that key.
  update: function(o, e, r) {
    var t = r && r != o ? this.remove(r) : this, n = t.find(o), a = t.content.slice();
    return n == -1 ? a.push(r || o, e) : (a[n + 1] = e, r && (a[n] = r)), new _e(a);
  },
  // :: (string) → OrderedMap
  // Return a map with the given key removed, if it existed.
  remove: function(o) {
    var e = this.find(o);
    if (e == -1) return this;
    var r = this.content.slice();
    return r.splice(e, 2), new _e(r);
  },
  // :: (string, any) → OrderedMap
  // Add a new key to the start of the map.
  addToStart: function(o, e) {
    return new _e([o, e].concat(this.remove(o).content));
  },
  // :: (string, any) → OrderedMap
  // Add a new key to the end of the map.
  addToEnd: function(o, e) {
    var r = this.remove(o).content.slice();
    return r.push(o, e), new _e(r);
  },
  // :: (string, string, any) → OrderedMap
  // Add a key after the given key. If `place` is not found, the new
  // key is added to the end.
  addBefore: function(o, e, r) {
    var t = this.remove(e), n = t.content.slice(), a = t.find(o);
    return n.splice(a == -1 ? n.length : a, 0, e, r), new _e(n);
  },
  // :: ((key: string, value: any))
  // Call the given function for each key/value pair in the map, in
  // order.
  forEach: function(o) {
    for (var e = 0; e < this.content.length; e += 2)
      o(this.content[e], this.content[e + 1]);
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by prepending the keys in this map that don't
  // appear in `map` before the keys in `map`.
  prepend: function(o) {
    return o = _e.from(o), o.size ? new _e(o.content.concat(this.subtract(o).content)) : this;
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by appending the keys in this map that don't
  // appear in `map` after the keys in `map`.
  append: function(o) {
    return o = _e.from(o), o.size ? new _e(this.subtract(o).content.concat(o.content)) : this;
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a map containing all the keys in this map that don't
  // appear in `map`.
  subtract: function(o) {
    var e = this;
    o = _e.from(o);
    for (var r = 0; r < o.content.length; r += 2)
      e = e.remove(o.content[r]);
    return e;
  },
  // :: () → Object
  // Turn ordered map into a plain object.
  toObject: function() {
    var o = {};
    return this.forEach(function(e, r) {
      o[e] = r;
    }), o;
  },
  // :: number
  // The amount of keys in this map.
  get size() {
    return this.content.length >> 1;
  }
};
_e.from = function(o) {
  if (o instanceof _e) return o;
  var e = [];
  if (o) for (var r in o) e.push(r, o[r]);
  return new _e(e);
};
function n0(o, e, r) {
  for (let t = 0; ; t++) {
    if (t == o.childCount || t == e.childCount)
      return o.childCount == e.childCount ? null : r;
    let n = o.child(t), a = e.child(t);
    if (n == a) {
      r += n.nodeSize;
      continue;
    }
    if (!n.sameMarkup(a))
      return r;
    if (n.isText && n.text != a.text) {
      for (let s = 0; n.text[s] == a.text[s]; s++)
        r++;
      return r;
    }
    if (n.content.size || a.content.size) {
      let s = n0(n.content, a.content, r + 1);
      if (s != null)
        return s;
    }
    r += n.nodeSize;
  }
}
function a0(o, e, r, t) {
  for (let n = o.childCount, a = e.childCount; ; ) {
    if (n == 0 || a == 0)
      return n == a ? null : { a: r, b: t };
    let s = o.child(--n), i = e.child(--a), l = s.nodeSize;
    if (s == i) {
      r -= l, t -= l;
      continue;
    }
    if (!s.sameMarkup(i))
      return { a: r, b: t };
    if (s.isText && s.text != i.text) {
      let c = 0, u = Math.min(s.text.length, i.text.length);
      for (; c < u && s.text[s.text.length - c - 1] == i.text[i.text.length - c - 1]; )
        c++, r--, t--;
      return { a: r, b: t };
    }
    if (s.content.size || i.content.size) {
      let c = a0(s.content, i.content, r - 1, t - 1);
      if (c)
        return c;
    }
    r -= l, t -= l;
  }
}
class $ {
  /**
  @internal
  */
  constructor(e, r) {
    if (this.content = e, this.size = r || 0, r == null)
      for (let t = 0; t < e.length; t++)
        this.size += e[t].nodeSize;
  }
  /**
  Invoke a callback for all descendant nodes between the given two
  positions (relative to start of this fragment). Doesn't descend
  into a node when the callback returns `false`.
  */
  nodesBetween(e, r, t, n = 0, a) {
    for (let s = 0, i = 0; i < r; s++) {
      let l = this.content[s], c = i + l.nodeSize;
      if (c > e && t(l, n + i, a || null, s) !== !1 && l.content.size) {
        let u = i + 1;
        l.nodesBetween(Math.max(0, e - u), Math.min(l.content.size, r - u), t, n + u);
      }
      i = c;
    }
  }
  /**
  Call the given callback for every descendant node. `pos` will be
  relative to the start of the fragment. The callback may return
  `false` to prevent traversal of a given node's children.
  */
  descendants(e) {
    this.nodesBetween(0, this.size, e);
  }
  /**
  Extract the text between `from` and `to`. See the same method on
  [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
  */
  textBetween(e, r, t, n) {
    let a = "", s = !0;
    return this.nodesBetween(e, r, (i, l) => {
      let c = i.isText ? i.text.slice(Math.max(e, l) - l, r - l) : i.isLeaf ? n ? typeof n == "function" ? n(i) : n : i.type.spec.leafText ? i.type.spec.leafText(i) : "" : "";
      i.isBlock && (i.isLeaf && c || i.isTextblock) && t && (s ? s = !1 : a += t), a += c;
    }, 0), a;
  }
  /**
  Create a new fragment containing the combined content of this
  fragment and the other.
  */
  append(e) {
    if (!e.size)
      return this;
    if (!this.size)
      return e;
    let r = this.lastChild, t = e.firstChild, n = this.content.slice(), a = 0;
    for (r.isText && r.sameMarkup(t) && (n[n.length - 1] = r.withText(r.text + t.text), a = 1); a < e.content.length; a++)
      n.push(e.content[a]);
    return new $(n, this.size + e.size);
  }
  /**
  Cut out the sub-fragment between the two given positions.
  */
  cut(e, r = this.size) {
    if (e == 0 && r == this.size)
      return this;
    let t = [], n = 0;
    if (r > e)
      for (let a = 0, s = 0; s < r; a++) {
        let i = this.content[a], l = s + i.nodeSize;
        l > e && ((s < e || l > r) && (i.isText ? i = i.cut(Math.max(0, e - s), Math.min(i.text.length, r - s)) : i = i.cut(Math.max(0, e - s - 1), Math.min(i.content.size, r - s - 1))), t.push(i), n += i.nodeSize), s = l;
      }
    return new $(t, n);
  }
  /**
  @internal
  */
  cutByIndex(e, r) {
    return e == r ? $.empty : e == 0 && r == this.content.length ? this : new $(this.content.slice(e, r));
  }
  /**
  Create a new fragment in which the node at the given index is
  replaced by the given node.
  */
  replaceChild(e, r) {
    let t = this.content[e];
    if (t == r)
      return this;
    let n = this.content.slice(), a = this.size + r.nodeSize - t.nodeSize;
    return n[e] = r, new $(n, a);
  }
  /**
  Create a new fragment by prepending the given node to this
  fragment.
  */
  addToStart(e) {
    return new $([e].concat(this.content), this.size + e.nodeSize);
  }
  /**
  Create a new fragment by appending the given node to this
  fragment.
  */
  addToEnd(e) {
    return new $(this.content.concat(e), this.size + e.nodeSize);
  }
  /**
  Compare this fragment to another one.
  */
  eq(e) {
    if (this.content.length != e.content.length)
      return !1;
    for (let r = 0; r < this.content.length; r++)
      if (!this.content[r].eq(e.content[r]))
        return !1;
    return !0;
  }
  /**
  The first child of the fragment, or `null` if it is empty.
  */
  get firstChild() {
    return this.content.length ? this.content[0] : null;
  }
  /**
  The last child of the fragment, or `null` if it is empty.
  */
  get lastChild() {
    return this.content.length ? this.content[this.content.length - 1] : null;
  }
  /**
  The number of child nodes in this fragment.
  */
  get childCount() {
    return this.content.length;
  }
  /**
  Get the child node at the given index. Raise an error when the
  index is out of range.
  */
  child(e) {
    let r = this.content[e];
    if (!r)
      throw new RangeError("Index " + e + " out of range for " + this);
    return r;
  }
  /**
  Get the child node at the given index, if it exists.
  */
  maybeChild(e) {
    return this.content[e] || null;
  }
  /**
  Call `f` for every child node, passing the node, its offset
  into this parent node, and its index.
  */
  forEach(e) {
    for (let r = 0, t = 0; r < this.content.length; r++) {
      let n = this.content[r];
      e(n, t, r), t += n.nodeSize;
    }
  }
  /**
  Find the first position at which this fragment and another
  fragment differ, or `null` if they are the same.
  */
  findDiffStart(e, r = 0) {
    return n0(this, e, r);
  }
  /**
  Find the first position, searching from the end, at which this
  fragment and the given fragment differ, or `null` if they are
  the same. Since this position will not be the same in both
  nodes, an object with two separate positions is returned.
  */
  findDiffEnd(e, r = this.size, t = e.size) {
    return a0(this, e, r, t);
  }
  /**
  Find the index and inner offset corresponding to a given relative
  position in this fragment. The result object will be reused
  (overwritten) the next time the function is called. @internal
  */
  findIndex(e, r = -1) {
    if (e == 0)
      return Ps(0, e);
    if (e == this.size)
      return Ps(this.content.length, e);
    if (e > this.size || e < 0)
      throw new RangeError(`Position ${e} outside of fragment (${this})`);
    for (let t = 0, n = 0; ; t++) {
      let a = this.child(t), s = n + a.nodeSize;
      if (s >= e)
        return s == e || r > 0 ? Ps(t + 1, s) : Ps(t, n);
      n = s;
    }
  }
  /**
  Return a debugging string that describes this fragment.
  */
  toString() {
    return "<" + this.toStringInner() + ">";
  }
  /**
  @internal
  */
  toStringInner() {
    return this.content.join(", ");
  }
  /**
  Create a JSON-serializeable representation of this fragment.
  */
  toJSON() {
    return this.content.length ? this.content.map((e) => e.toJSON()) : null;
  }
  /**
  Deserialize a fragment from its JSON representation.
  */
  static fromJSON(e, r) {
    if (!r)
      return $.empty;
    if (!Array.isArray(r))
      throw new RangeError("Invalid input for Fragment.fromJSON");
    return new $(r.map(e.nodeFromJSON));
  }
  /**
  Build a fragment from an array of nodes. Ensures that adjacent
  text nodes with the same marks are joined together.
  */
  static fromArray(e) {
    if (!e.length)
      return $.empty;
    let r, t = 0;
    for (let n = 0; n < e.length; n++) {
      let a = e[n];
      t += a.nodeSize, n && a.isText && e[n - 1].sameMarkup(a) ? (r || (r = e.slice(0, n)), r[r.length - 1] = a.withText(r[r.length - 1].text + a.text)) : r && r.push(a);
    }
    return new $(r || e, t);
  }
  /**
  Create a fragment from something that can be interpreted as a
  set of nodes. For `null`, it returns the empty fragment. For a
  fragment, the fragment itself. For a node or array of nodes, a
  fragment containing those nodes.
  */
  static from(e) {
    if (!e)
      return $.empty;
    if (e instanceof $)
      return e;
    if (Array.isArray(e))
      return this.fromArray(e);
    if (e.attrs)
      return new $([e], e.nodeSize);
    throw new RangeError("Can not convert " + e + " to a Fragment" + (e.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
  }
}
$.empty = new $([], 0);
const lc = { index: 0, offset: 0 };
function Ps(o, e) {
  return lc.index = o, lc.offset = e, lc;
}
function ni(o, e) {
  if (o === e)
    return !0;
  if (!(o && typeof o == "object") || !(e && typeof e == "object"))
    return !1;
  let r = Array.isArray(o);
  if (Array.isArray(e) != r)
    return !1;
  if (r) {
    if (o.length != e.length)
      return !1;
    for (let t = 0; t < o.length; t++)
      if (!ni(o[t], e[t]))
        return !1;
  } else {
    for (let t in o)
      if (!(t in e) || !ni(o[t], e[t]))
        return !1;
    for (let t in e)
      if (!(t in o))
        return !1;
  }
  return !0;
}
class Ce {
  /**
  @internal
  */
  constructor(e, r) {
    this.type = e, this.attrs = r;
  }
  /**
  Given a set of marks, create a new set which contains this one as
  well, in the right position. If this mark is already in the set,
  the set itself is returned. If any marks that are set to be
  [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
  those are replaced by this one.
  */
  addToSet(e) {
    let r, t = !1;
    for (let n = 0; n < e.length; n++) {
      let a = e[n];
      if (this.eq(a))
        return e;
      if (this.type.excludes(a.type))
        r || (r = e.slice(0, n));
      else {
        if (a.type.excludes(this.type))
          return e;
        !t && a.type.rank > this.type.rank && (r || (r = e.slice(0, n)), r.push(this), t = !0), r && r.push(a);
      }
    }
    return r || (r = e.slice()), t || r.push(this), r;
  }
  /**
  Remove this mark from the given set, returning a new set. If this
  mark is not in the set, the set itself is returned.
  */
  removeFromSet(e) {
    for (let r = 0; r < e.length; r++)
      if (this.eq(e[r]))
        return e.slice(0, r).concat(e.slice(r + 1));
    return e;
  }
  /**
  Test whether this mark is in the given set of marks.
  */
  isInSet(e) {
    for (let r = 0; r < e.length; r++)
      if (this.eq(e[r]))
        return !0;
    return !1;
  }
  /**
  Test whether this mark has the same type and attributes as
  another mark.
  */
  eq(e) {
    return this == e || this.type == e.type && ni(this.attrs, e.attrs);
  }
  /**
  Convert this mark to a JSON-serializeable representation.
  */
  toJSON() {
    let e = { type: this.type.name };
    for (let r in this.attrs) {
      e.attrs = this.attrs;
      break;
    }
    return e;
  }
  /**
  Deserialize a mark from JSON.
  */
  static fromJSON(e, r) {
    if (!r)
      throw new RangeError("Invalid input for Mark.fromJSON");
    let t = e.marks[r.type];
    if (!t)
      throw new RangeError(`There is no mark type ${r.type} in this schema`);
    let n = t.create(r.attrs);
    return t.checkAttrs(n.attrs), n;
  }
  /**
  Test whether two sets of marks are identical.
  */
  static sameSet(e, r) {
    if (e == r)
      return !0;
    if (e.length != r.length)
      return !1;
    for (let t = 0; t < e.length; t++)
      if (!e[t].eq(r[t]))
        return !1;
    return !0;
  }
  /**
  Create a properly sorted mark set from null, a single mark, or an
  unsorted array of marks.
  */
  static setFrom(e) {
    if (!e || Array.isArray(e) && e.length == 0)
      return Ce.none;
    if (e instanceof Ce)
      return [e];
    let r = e.slice();
    return r.sort((t, n) => t.type.rank - n.type.rank), r;
  }
}
Ce.none = [];
class ai extends Error {
}
class te {
  /**
  Create a slice. When specifying a non-zero open depth, you must
  make sure that there are nodes of at least that depth at the
  appropriate side of the fragment—i.e. if the fragment is an
  empty paragraph node, `openStart` and `openEnd` can't be greater
  than 1.
  
  It is not necessary for the content of open nodes to conform to
  the schema's content constraints, though it should be a valid
  start/end/middle for such a node, depending on which sides are
  open.
  */
  constructor(e, r, t) {
    this.content = e, this.openStart = r, this.openEnd = t;
  }
  /**
  The size this slice would add when inserted into a document.
  */
  get size() {
    return this.content.size - this.openStart - this.openEnd;
  }
  /**
  @internal
  */
  insertAt(e, r) {
    let t = i0(this.content, e + this.openStart, r);
    return t && new te(t, this.openStart, this.openEnd);
  }
  /**
  @internal
  */
  removeBetween(e, r) {
    return new te(s0(this.content, e + this.openStart, r + this.openStart), this.openStart, this.openEnd);
  }
  /**
  Tests whether this slice is equal to another slice.
  */
  eq(e) {
    return this.content.eq(e.content) && this.openStart == e.openStart && this.openEnd == e.openEnd;
  }
  /**
  @internal
  */
  toString() {
    return this.content + "(" + this.openStart + "," + this.openEnd + ")";
  }
  /**
  Convert a slice to a JSON-serializable representation.
  */
  toJSON() {
    if (!this.content.size)
      return null;
    let e = { content: this.content.toJSON() };
    return this.openStart > 0 && (e.openStart = this.openStart), this.openEnd > 0 && (e.openEnd = this.openEnd), e;
  }
  /**
  Deserialize a slice from its JSON representation.
  */
  static fromJSON(e, r) {
    if (!r)
      return te.empty;
    let t = r.openStart || 0, n = r.openEnd || 0;
    if (typeof t != "number" || typeof n != "number")
      throw new RangeError("Invalid input for Slice.fromJSON");
    return new te($.fromJSON(e, r.content), t, n);
  }
  /**
  Create a slice from a fragment by taking the maximum possible
  open value on both side of the fragment.
  */
  static maxOpen(e, r = !0) {
    let t = 0, n = 0;
    for (let a = e.firstChild; a && !a.isLeaf && (r || !a.type.spec.isolating); a = a.firstChild)
      t++;
    for (let a = e.lastChild; a && !a.isLeaf && (r || !a.type.spec.isolating); a = a.lastChild)
      n++;
    return new te(e, t, n);
  }
}
te.empty = new te($.empty, 0, 0);
function s0(o, e, r) {
  let { index: t, offset: n } = o.findIndex(e), a = o.maybeChild(t), { index: s, offset: i } = o.findIndex(r);
  if (n == e || a.isText) {
    if (i != r && !o.child(s).isText)
      throw new RangeError("Removing non-flat range");
    return o.cut(0, e).append(o.cut(r));
  }
  if (t != s)
    throw new RangeError("Removing non-flat range");
  return o.replaceChild(t, a.copy(s0(a.content, e - n - 1, r - n - 1)));
}
function i0(o, e, r, t) {
  let { index: n, offset: a } = o.findIndex(e), s = o.maybeChild(n);
  if (a == e || s.isText)
    return o.cut(0, e).append(r).append(o.cut(e));
  let i = i0(s.content, e - a - 1, r);
  return i && o.replaceChild(n, s.copy(i));
}
function px(o, e, r) {
  if (r.openStart > o.depth)
    throw new ai("Inserted content deeper than insertion position");
  if (o.depth - r.openStart != e.depth - r.openEnd)
    throw new ai("Inconsistent open depths");
  return l0(o, e, r, 0);
}
function l0(o, e, r, t) {
  let n = o.index(t), a = o.node(t);
  if (n == e.index(t) && t < o.depth - r.openStart) {
    let s = l0(o, e, r, t + 1);
    return a.copy(a.content.replaceChild(n, s));
  } else if (r.content.size)
    if (!r.openStart && !r.openEnd && o.depth == t && e.depth == t) {
      let s = o.parent, i = s.content;
      return st(s, i.cut(0, o.parentOffset).append(r.content).append(i.cut(e.parentOffset)));
    } else {
      let { start: s, end: i } = dx(r, o);
      return st(a, u0(o, s, i, e, t));
    }
  else return st(a, si(o, e, t));
}
function c0(o, e) {
  if (!e.type.compatibleContent(o.type))
    throw new ai("Cannot join " + e.type.name + " onto " + o.type.name);
}
function Nu(o, e, r) {
  let t = o.node(r);
  return c0(t, e.node(r)), t;
}
function at(o, e) {
  let r = e.length - 1;
  r >= 0 && o.isText && o.sameMarkup(e[r]) ? e[r] = o.withText(e[r].text + o.text) : e.push(o);
}
function xn(o, e, r, t) {
  let n = (e || o).node(r), a = 0, s = e ? e.index(r) : n.childCount;
  o && (a = o.index(r), o.depth > r ? a++ : o.textOffset && (at(o.nodeAfter, t), a++));
  for (let i = a; i < s; i++)
    at(n.child(i), t);
  e && e.depth == r && e.textOffset && at(e.nodeBefore, t);
}
function st(o, e) {
  return o.type.checkContent(e), o.copy(e);
}
function u0(o, e, r, t, n) {
  let a = o.depth > n && Nu(o, e, n + 1), s = t.depth > n && Nu(r, t, n + 1), i = [];
  return xn(null, o, n, i), a && s && e.index(n) == r.index(n) ? (c0(a, s), at(st(a, u0(o, e, r, t, n + 1)), i)) : (a && at(st(a, si(o, e, n + 1)), i), xn(e, r, n, i), s && at(st(s, si(r, t, n + 1)), i)), xn(t, null, n, i), new $(i);
}
function si(o, e, r) {
  let t = [];
  if (xn(null, o, r, t), o.depth > r) {
    let n = Nu(o, e, r + 1);
    at(st(n, si(o, e, r + 1)), t);
  }
  return xn(e, null, r, t), new $(t);
}
function dx(o, e) {
  let r = e.depth - o.openStart, n = e.node(r).copy(o.content);
  for (let a = r - 1; a >= 0; a--)
    n = e.node(a).copy($.from(n));
  return {
    start: n.resolveNoCache(o.openStart + r),
    end: n.resolveNoCache(n.content.size - o.openEnd - r)
  };
}
class xa {
  /**
  @internal
  */
  constructor(e, r, t) {
    this.pos = e, this.path = r, this.parentOffset = t, this.depth = r.length / 3 - 1;
  }
  /**
  @internal
  */
  resolveDepth(e) {
    return e == null ? this.depth : e < 0 ? this.depth + e : e;
  }
  /**
  The parent node that the position points into. Note that even if
  a position points into a text node, that node is not considered
  the parent—text nodes are ‘flat’ in this model, and have no content.
  */
  get parent() {
    return this.node(this.depth);
  }
  /**
  The root node in which the position was resolved.
  */
  get doc() {
    return this.node(0);
  }
  /**
  The ancestor node at the given level. `p.node(p.depth)` is the
  same as `p.parent`.
  */
  node(e) {
    return this.path[this.resolveDepth(e) * 3];
  }
  /**
  The index into the ancestor at the given level. If this points
  at the 3rd node in the 2nd paragraph on the top level, for
  example, `p.index(0)` is 1 and `p.index(1)` is 2.
  */
  index(e) {
    return this.path[this.resolveDepth(e) * 3 + 1];
  }
  /**
  The index pointing after this position into the ancestor at the
  given level.
  */
  indexAfter(e) {
    return e = this.resolveDepth(e), this.index(e) + (e == this.depth && !this.textOffset ? 0 : 1);
  }
  /**
  The (absolute) position at the start of the node at the given
  level.
  */
  start(e) {
    return e = this.resolveDepth(e), e == 0 ? 0 : this.path[e * 3 - 1] + 1;
  }
  /**
  The (absolute) position at the end of the node at the given
  level.
  */
  end(e) {
    return e = this.resolveDepth(e), this.start(e) + this.node(e).content.size;
  }
  /**
  The (absolute) position directly before the wrapping node at the
  given level, or, when `depth` is `this.depth + 1`, the original
  position.
  */
  before(e) {
    if (e = this.resolveDepth(e), !e)
      throw new RangeError("There is no position before the top-level node");
    return e == this.depth + 1 ? this.pos : this.path[e * 3 - 1];
  }
  /**
  The (absolute) position directly after the wrapping node at the
  given level, or the original position when `depth` is `this.depth + 1`.
  */
  after(e) {
    if (e = this.resolveDepth(e), !e)
      throw new RangeError("There is no position after the top-level node");
    return e == this.depth + 1 ? this.pos : this.path[e * 3 - 1] + this.path[e * 3].nodeSize;
  }
  /**
  When this position points into a text node, this returns the
  distance between the position and the start of the text node.
  Will be zero for positions that point between nodes.
  */
  get textOffset() {
    return this.pos - this.path[this.path.length - 1];
  }
  /**
  Get the node directly after the position, if any. If the position
  points into a text node, only the part of that node after the
  position is returned.
  */
  get nodeAfter() {
    let e = this.parent, r = this.index(this.depth);
    if (r == e.childCount)
      return null;
    let t = this.pos - this.path[this.path.length - 1], n = e.child(r);
    return t ? e.child(r).cut(t) : n;
  }
  /**
  Get the node directly before the position, if any. If the
  position points into a text node, only the part of that node
  before the position is returned.
  */
  get nodeBefore() {
    let e = this.index(this.depth), r = this.pos - this.path[this.path.length - 1];
    return r ? this.parent.child(e).cut(0, r) : e == 0 ? null : this.parent.child(e - 1);
  }
  /**
  Get the position at the given index in the parent node at the
  given depth (which defaults to `this.depth`).
  */
  posAtIndex(e, r) {
    r = this.resolveDepth(r);
    let t = this.path[r * 3], n = r == 0 ? 0 : this.path[r * 3 - 1] + 1;
    for (let a = 0; a < e; a++)
      n += t.child(a).nodeSize;
    return n;
  }
  /**
  Get the marks at this position, factoring in the surrounding
  marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
  position is at the start of a non-empty node, the marks of the
  node after it (if any) are returned.
  */
  marks() {
    let e = this.parent, r = this.index();
    if (e.content.size == 0)
      return Ce.none;
    if (this.textOffset)
      return e.child(r).marks;
    let t = e.maybeChild(r - 1), n = e.maybeChild(r);
    if (!t) {
      let i = t;
      t = n, n = i;
    }
    let a = t.marks;
    for (var s = 0; s < a.length; s++)
      a[s].type.spec.inclusive === !1 && (!n || !a[s].isInSet(n.marks)) && (a = a[s--].removeFromSet(a));
    return a;
  }
  /**
  Get the marks after the current position, if any, except those
  that are non-inclusive and not present at position `$end`. This
  is mostly useful for getting the set of marks to preserve after a
  deletion. Will return `null` if this position is at the end of
  its parent node or its parent node isn't a textblock (in which
  case no marks should be preserved).
  */
  marksAcross(e) {
    let r = this.parent.maybeChild(this.index());
    if (!r || !r.isInline)
      return null;
    let t = r.marks, n = e.parent.maybeChild(e.index());
    for (var a = 0; a < t.length; a++)
      t[a].type.spec.inclusive === !1 && (!n || !t[a].isInSet(n.marks)) && (t = t[a--].removeFromSet(t));
    return t;
  }
  /**
  The depth up to which this position and the given (non-resolved)
  position share the same parent nodes.
  */
  sharedDepth(e) {
    for (let r = this.depth; r > 0; r--)
      if (this.start(r) <= e && this.end(r) >= e)
        return r;
    return 0;
  }
  /**
  Returns a range based on the place where this position and the
  given position diverge around block content. If both point into
  the same textblock, for example, a range around that textblock
  will be returned. If they point into different blocks, the range
  around those blocks in their shared ancestor is returned. You can
  pass in an optional predicate that will be called with a parent
  node to see if a range into that parent is acceptable.
  */
  blockRange(e = this, r) {
    if (e.pos < this.pos)
      return e.blockRange(this);
    for (let t = this.depth - (this.parent.inlineContent || this.pos == e.pos ? 1 : 0); t >= 0; t--)
      if (e.pos <= this.end(t) && (!r || r(this.node(t))))
        return new ii(this, e, t);
    return null;
  }
  /**
  Query whether the given position shares the same parent node.
  */
  sameParent(e) {
    return this.pos - this.parentOffset == e.pos - e.parentOffset;
  }
  /**
  Return the greater of this and the given position.
  */
  max(e) {
    return e.pos > this.pos ? e : this;
  }
  /**
  Return the smaller of this and the given position.
  */
  min(e) {
    return e.pos < this.pos ? e : this;
  }
  /**
  @internal
  */
  toString() {
    let e = "";
    for (let r = 1; r <= this.depth; r++)
      e += (e ? "/" : "") + this.node(r).type.name + "_" + this.index(r - 1);
    return e + ":" + this.parentOffset;
  }
  /**
  @internal
  */
  static resolve(e, r) {
    if (!(r >= 0 && r <= e.content.size))
      throw new RangeError("Position " + r + " out of range");
    let t = [], n = 0, a = r;
    for (let s = e; ; ) {
      let { index: i, offset: l } = s.content.findIndex(a), c = a - l;
      if (t.push(s, i, n + l), !c || (s = s.child(i), s.isText))
        break;
      a = c - 1, n += l + 1;
    }
    return new xa(r, t, a);
  }
  /**
  @internal
  */
  static resolveCached(e, r) {
    let t = If.get(e);
    if (t)
      for (let a = 0; a < t.elts.length; a++) {
        let s = t.elts[a];
        if (s.pos == r)
          return s;
      }
    else
      If.set(e, t = new gx());
    let n = t.elts[t.i] = xa.resolve(e, r);
    return t.i = (t.i + 1) % mx, n;
  }
}
class gx {
  constructor() {
    this.elts = [], this.i = 0;
  }
}
const mx = 12, If = /* @__PURE__ */ new WeakMap();
class ii {
  /**
  Construct a node range. `$from` and `$to` should point into the
  same node until at least the given `depth`, since a node range
  denotes an adjacent set of nodes in a single parent node.
  */
  constructor(e, r, t) {
    this.$from = e, this.$to = r, this.depth = t;
  }
  /**
  The position at the start of the range.
  */
  get start() {
    return this.$from.before(this.depth + 1);
  }
  /**
  The position at the end of the range.
  */
  get end() {
    return this.$to.after(this.depth + 1);
  }
  /**
  The parent node that the range points into.
  */
  get parent() {
    return this.$from.node(this.depth);
  }
  /**
  The start index of the range in the parent node.
  */
  get startIndex() {
    return this.$from.index(this.depth);
  }
  /**
  The end index of the range in the parent node.
  */
  get endIndex() {
    return this.$to.indexAfter(this.depth);
  }
}
const fx = /* @__PURE__ */ Object.create(null);
let it = class Vu {
  /**
  @internal
  */
  constructor(e, r, t, n = Ce.none) {
    this.type = e, this.attrs = r, this.marks = n, this.content = t || $.empty;
  }
  /**
  The array of this node's child nodes.
  */
  get children() {
    return this.content.content;
  }
  /**
  The size of this node, as defined by the integer-based [indexing
  scheme](https://prosemirror.net/docs/guide/#doc.indexing). For text nodes, this is the
  amount of characters. For other leaf nodes, it is one. For
  non-leaf nodes, it is the size of the content plus two (the
  start and end token).
  */
  get nodeSize() {
    return this.isLeaf ? 1 : 2 + this.content.size;
  }
  /**
  The number of children that the node has.
  */
  get childCount() {
    return this.content.childCount;
  }
  /**
  Get the child node at the given index. Raises an error when the
  index is out of range.
  */
  child(e) {
    return this.content.child(e);
  }
  /**
  Get the child node at the given index, if it exists.
  */
  maybeChild(e) {
    return this.content.maybeChild(e);
  }
  /**
  Call `f` for every child node, passing the node, its offset
  into this parent node, and its index.
  */
  forEach(e) {
    this.content.forEach(e);
  }
  /**
  Invoke a callback for all descendant nodes recursively between
  the given two positions that are relative to start of this
  node's content. The callback is invoked with the node, its
  position relative to the original node (method receiver),
  its parent node, and its child index. When the callback returns
  false for a given node, that node's children will not be
  recursed over. The last parameter can be used to specify a
  starting position to count from.
  */
  nodesBetween(e, r, t, n = 0) {
    this.content.nodesBetween(e, r, t, n, this);
  }
  /**
  Call the given callback for every descendant node. Doesn't
  descend into a node when the callback returns `false`.
  */
  descendants(e) {
    this.nodesBetween(0, this.content.size, e);
  }
  /**
  Concatenates all the text nodes found in this fragment and its
  children.
  */
  get textContent() {
    return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
  }
  /**
  Get all text between positions `from` and `to`. When
  `blockSeparator` is given, it will be inserted to separate text
  from different block nodes. If `leafText` is given, it'll be
  inserted for every non-text leaf node encountered, otherwise
  [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec^leafText) will be used.
  */
  textBetween(e, r, t, n) {
    return this.content.textBetween(e, r, t, n);
  }
  /**
  Returns this node's first child, or `null` if there are no
  children.
  */
  get firstChild() {
    return this.content.firstChild;
  }
  /**
  Returns this node's last child, or `null` if there are no
  children.
  */
  get lastChild() {
    return this.content.lastChild;
  }
  /**
  Test whether two nodes represent the same piece of document.
  */
  eq(e) {
    return this == e || this.sameMarkup(e) && this.content.eq(e.content);
  }
  /**
  Compare the markup (type, attributes, and marks) of this node to
  those of another. Returns `true` if both have the same markup.
  */
  sameMarkup(e) {
    return this.hasMarkup(e.type, e.attrs, e.marks);
  }
  /**
  Check whether this node's markup correspond to the given type,
  attributes, and marks.
  */
  hasMarkup(e, r, t) {
    return this.type == e && ni(this.attrs, r || e.defaultAttrs || fx) && Ce.sameSet(this.marks, t || Ce.none);
  }
  /**
  Create a new node with the same markup as this node, containing
  the given content (or empty, if no content is given).
  */
  copy(e = null) {
    return e == this.content ? this : new Vu(this.type, this.attrs, e, this.marks);
  }
  /**
  Create a copy of this node, with the given set of marks instead
  of the node's own marks.
  */
  mark(e) {
    return e == this.marks ? this : new Vu(this.type, this.attrs, this.content, e);
  }
  /**
  Create a copy of this node with only the content between the
  given positions. If `to` is not given, it defaults to the end of
  the node.
  */
  cut(e, r = this.content.size) {
    return e == 0 && r == this.content.size ? this : this.copy(this.content.cut(e, r));
  }
  /**
  Cut out the part of the document between the given positions, and
  return it as a `Slice` object.
  */
  slice(e, r = this.content.size, t = !1) {
    if (e == r)
      return te.empty;
    let n = this.resolve(e), a = this.resolve(r), s = t ? 0 : n.sharedDepth(r), i = n.start(s), c = n.node(s).content.cut(n.pos - i, a.pos - i);
    return new te(c, n.depth - s, a.depth - s);
  }
  /**
  Replace the part of the document between the given positions with
  the given slice. The slice must 'fit', meaning its open sides
  must be able to connect to the surrounding content, and its
  content nodes must be valid children for the node they are placed
  into. If any of this is violated, an error of type
  [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
  */
  replace(e, r, t) {
    return px(this.resolve(e), this.resolve(r), t);
  }
  /**
  Find the node directly after the given position.
  */
  nodeAt(e) {
    for (let r = this; ; ) {
      let { index: t, offset: n } = r.content.findIndex(e);
      if (r = r.maybeChild(t), !r)
        return null;
      if (n == e || r.isText)
        return r;
      e -= n + 1;
    }
  }
  /**
  Find the (direct) child node after the given offset, if any,
  and return it along with its index and offset relative to this
  node.
  */
  childAfter(e) {
    let { index: r, offset: t } = this.content.findIndex(e);
    return { node: this.content.maybeChild(r), index: r, offset: t };
  }
  /**
  Find the (direct) child node before the given offset, if any,
  and return it along with its index and offset relative to this
  node.
  */
  childBefore(e) {
    if (e == 0)
      return { node: null, index: 0, offset: 0 };
    let { index: r, offset: t } = this.content.findIndex(e);
    if (t < e)
      return { node: this.content.child(r), index: r, offset: t };
    let n = this.content.child(r - 1);
    return { node: n, index: r - 1, offset: t - n.nodeSize };
  }
  /**
  Resolve the given position in the document, returning an
  [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
  */
  resolve(e) {
    return xa.resolveCached(this, e);
  }
  /**
  @internal
  */
  resolveNoCache(e) {
    return xa.resolve(this, e);
  }
  /**
  Test whether a given mark or mark type occurs in this document
  between the two given positions.
  */
  rangeHasMark(e, r, t) {
    let n = !1;
    return r > e && this.nodesBetween(e, r, (a) => (t.isInSet(a.marks) && (n = !0), !n)), n;
  }
  /**
  True when this is a block (non-inline node)
  */
  get isBlock() {
    return this.type.isBlock;
  }
  /**
  True when this is a textblock node, a block node with inline
  content.
  */
  get isTextblock() {
    return this.type.isTextblock;
  }
  /**
  True when this node allows inline content.
  */
  get inlineContent() {
    return this.type.inlineContent;
  }
  /**
  True when this is an inline node (a text node or a node that can
  appear among text).
  */
  get isInline() {
    return this.type.isInline;
  }
  /**
  True when this is a text node.
  */
  get isText() {
    return this.type.isText;
  }
  /**
  True when this is a leaf node.
  */
  get isLeaf() {
    return this.type.isLeaf;
  }
  /**
  True when this is an atom, i.e. when it does not have directly
  editable content. This is usually the same as `isLeaf`, but can
  be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
  on a node's spec (typically used when the node is displayed as
  an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
  */
  get isAtom() {
    return this.type.isAtom;
  }
  /**
  Return a string representation of this node for debugging
  purposes.
  */
  toString() {
    if (this.type.spec.toDebugString)
      return this.type.spec.toDebugString(this);
    let e = this.type.name;
    return this.content.size && (e += "(" + this.content.toStringInner() + ")"), p0(this.marks, e);
  }
  /**
  Get the content match in this node at the given index.
  */
  contentMatchAt(e) {
    let r = this.type.contentMatch.matchFragment(this.content, 0, e);
    if (!r)
      throw new Error("Called contentMatchAt on a node with invalid content");
    return r;
  }
  /**
  Test whether replacing the range between `from` and `to` (by
  child index) with the given replacement fragment (which defaults
  to the empty fragment) would leave the node's content valid. You
  can optionally pass `start` and `end` indices into the
  replacement fragment.
  */
  canReplace(e, r, t = $.empty, n = 0, a = t.childCount) {
    let s = this.contentMatchAt(e).matchFragment(t, n, a), i = s && s.matchFragment(this.content, r);
    if (!i || !i.validEnd)
      return !1;
    for (let l = n; l < a; l++)
      if (!this.type.allowsMarks(t.child(l).marks))
        return !1;
    return !0;
  }
  /**
  Test whether replacing the range `from` to `to` (by index) with
  a node of the given type would leave the node's content valid.
  */
  canReplaceWith(e, r, t, n) {
    if (n && !this.type.allowsMarks(n))
      return !1;
    let a = this.contentMatchAt(e).matchType(t), s = a && a.matchFragment(this.content, r);
    return s ? s.validEnd : !1;
  }
  /**
  Test whether the given node's content could be appended to this
  node. If that node is empty, this will only return true if there
  is at least one node type that can appear in both nodes (to avoid
  merging completely incompatible nodes).
  */
  canAppend(e) {
    return e.content.size ? this.canReplace(this.childCount, this.childCount, e.content) : this.type.compatibleContent(e.type);
  }
  /**
  Check whether this node and its descendants conform to the
  schema, and raise an exception when they do not.
  */
  check() {
    this.type.checkContent(this.content), this.type.checkAttrs(this.attrs);
    let e = Ce.none;
    for (let r = 0; r < this.marks.length; r++) {
      let t = this.marks[r];
      t.type.checkAttrs(t.attrs), e = t.addToSet(e);
    }
    if (!Ce.sameSet(e, this.marks))
      throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((r) => r.type.name)}`);
    this.content.forEach((r) => r.check());
  }
  /**
  Return a JSON-serializeable representation of this node.
  */
  toJSON() {
    let e = { type: this.type.name };
    for (let r in this.attrs) {
      e.attrs = this.attrs;
      break;
    }
    return this.content.size && (e.content = this.content.toJSON()), this.marks.length && (e.marks = this.marks.map((r) => r.toJSON())), e;
  }
  /**
  Deserialize a node from its JSON representation.
  */
  static fromJSON(e, r) {
    if (!r)
      throw new RangeError("Invalid input for Node.fromJSON");
    let t;
    if (r.marks) {
      if (!Array.isArray(r.marks))
        throw new RangeError("Invalid mark data for Node.fromJSON");
      t = r.marks.map(e.markFromJSON);
    }
    if (r.type == "text") {
      if (typeof r.text != "string")
        throw new RangeError("Invalid text node in JSON");
      return e.text(r.text, t);
    }
    let n = $.fromJSON(e, r.content), a = e.nodeType(r.type).create(r.attrs, n, t);
    return a.type.checkAttrs(a.attrs), a;
  }
};
it.prototype.text = void 0;
class li extends it {
  /**
  @internal
  */
  constructor(e, r, t, n) {
    if (super(e, r, null, n), !t)
      throw new RangeError("Empty text nodes are not allowed");
    this.text = t;
  }
  toString() {
    return this.type.spec.toDebugString ? this.type.spec.toDebugString(this) : p0(this.marks, JSON.stringify(this.text));
  }
  get textContent() {
    return this.text;
  }
  textBetween(e, r) {
    return this.text.slice(e, r);
  }
  get nodeSize() {
    return this.text.length;
  }
  mark(e) {
    return e == this.marks ? this : new li(this.type, this.attrs, this.text, e);
  }
  withText(e) {
    return e == this.text ? this : new li(this.type, this.attrs, e, this.marks);
  }
  cut(e = 0, r = this.text.length) {
    return e == 0 && r == this.text.length ? this : this.withText(this.text.slice(e, r));
  }
  eq(e) {
    return this.sameMarkup(e) && this.text == e.text;
  }
  toJSON() {
    let e = super.toJSON();
    return e.text = this.text, e;
  }
}
function p0(o, e) {
  for (let r = o.length - 1; r >= 0; r--)
    e = o[r].type.name + "(" + e + ")";
  return e;
}
class ft {
  /**
  @internal
  */
  constructor(e) {
    this.validEnd = e, this.next = [], this.wrapCache = [];
  }
  /**
  @internal
  */
  static parse(e, r) {
    let t = new yx(e, r);
    if (t.next == null)
      return ft.empty;
    let n = d0(t);
    t.next && t.err("Unexpected trailing text");
    let a = wx(Px(n));
    return kx(a, t), a;
  }
  /**
  Match a node type, returning a match after that node if
  successful.
  */
  matchType(e) {
    for (let r = 0; r < this.next.length; r++)
      if (this.next[r].type == e)
        return this.next[r].next;
    return null;
  }
  /**
  Try to match a fragment. Returns the resulting match when
  successful.
  */
  matchFragment(e, r = 0, t = e.childCount) {
    let n = this;
    for (let a = r; n && a < t; a++)
      n = n.matchType(e.child(a).type);
    return n;
  }
  /**
  @internal
  */
  get inlineContent() {
    return this.next.length != 0 && this.next[0].type.isInline;
  }
  /**
  Get the first matching node type at this match position that can
  be generated.
  */
  get defaultType() {
    for (let e = 0; e < this.next.length; e++) {
      let { type: r } = this.next[e];
      if (!(r.isText || r.hasRequiredAttrs()))
        return r;
    }
    return null;
  }
  /**
  @internal
  */
  compatible(e) {
    for (let r = 0; r < this.next.length; r++)
      for (let t = 0; t < e.next.length; t++)
        if (this.next[r].type == e.next[t].type)
          return !0;
    return !1;
  }
  /**
  Try to match the given fragment, and if that fails, see if it can
  be made to match by inserting nodes in front of it. When
  successful, return a fragment of inserted nodes (which may be
  empty if nothing had to be inserted). When `toEnd` is true, only
  return a fragment if the resulting match goes to the end of the
  content expression.
  */
  fillBefore(e, r = !1, t = 0) {
    let n = [this];
    function a(s, i) {
      let l = s.matchFragment(e, t);
      if (l && (!r || l.validEnd))
        return $.from(i.map((c) => c.createAndFill()));
      for (let c = 0; c < s.next.length; c++) {
        let { type: u, next: f } = s.next[c];
        if (!(u.isText || u.hasRequiredAttrs()) && n.indexOf(f) == -1) {
          n.push(f);
          let g = a(f, i.concat(u));
          if (g)
            return g;
        }
      }
      return null;
    }
    return a(this, []);
  }
  /**
  Find a set of wrapping node types that would allow a node of the
  given type to appear at this position. The result may be empty
  (when it fits directly) and will be null when no such wrapping
  exists.
  */
  findWrapping(e) {
    for (let t = 0; t < this.wrapCache.length; t += 2)
      if (this.wrapCache[t] == e)
        return this.wrapCache[t + 1];
    let r = this.computeWrapping(e);
    return this.wrapCache.push(e, r), r;
  }
  /**
  @internal
  */
  computeWrapping(e) {
    let r = /* @__PURE__ */ Object.create(null), t = [{ match: this, type: null, via: null }];
    for (; t.length; ) {
      let n = t.shift(), a = n.match;
      if (a.matchType(e)) {
        let s = [];
        for (let i = n; i.type; i = i.via)
          s.push(i.type);
        return s.reverse();
      }
      for (let s = 0; s < a.next.length; s++) {
        let { type: i, next: l } = a.next[s];
        !i.isLeaf && !i.hasRequiredAttrs() && !(i.name in r) && (!n.type || l.validEnd) && (t.push({ match: i.contentMatch, type: i, via: n }), r[i.name] = !0);
      }
    }
    return null;
  }
  /**
  The number of outgoing edges this node has in the finite
  automaton that describes the content expression.
  */
  get edgeCount() {
    return this.next.length;
  }
  /**
  Get the _n_​th outgoing edge from this node in the finite
  automaton that describes the content expression.
  */
  edge(e) {
    if (e >= this.next.length)
      throw new RangeError(`There's no ${e}th edge in this content match`);
    return this.next[e];
  }
  /**
  @internal
  */
  toString() {
    let e = [];
    function r(t) {
      e.push(t);
      for (let n = 0; n < t.next.length; n++)
        e.indexOf(t.next[n].next) == -1 && r(t.next[n].next);
    }
    return r(this), e.map((t, n) => {
      let a = n + (t.validEnd ? "*" : " ") + " ";
      for (let s = 0; s < t.next.length; s++)
        a += (s ? ", " : "") + t.next[s].type.name + "->" + e.indexOf(t.next[s].next);
      return a;
    }).join(`
`);
  }
}
ft.empty = new ft(!0);
class yx {
  constructor(e, r) {
    this.string = e, this.nodeTypes = r, this.inline = null, this.pos = 0, this.tokens = e.split(/\s*(?=\b|\W|$)/), this.tokens[this.tokens.length - 1] == "" && this.tokens.pop(), this.tokens[0] == "" && this.tokens.shift();
  }
  get next() {
    return this.tokens[this.pos];
  }
  eat(e) {
    return this.next == e && (this.pos++ || !0);
  }
  err(e) {
    throw new SyntaxError(e + " (in content expression '" + this.string + "')");
  }
}
function d0(o) {
  let e = [];
  do
    e.push(hx(o));
  while (o.eat("|"));
  return e.length == 1 ? e[0] : { type: "choice", exprs: e };
}
function hx(o) {
  let e = [];
  do
    e.push(Fx(o));
  while (o.next && o.next != ")" && o.next != "|");
  return e.length == 1 ? e[0] : { type: "seq", exprs: e };
}
function Fx(o) {
  let e = Bx(o);
  for (; ; )
    if (o.eat("+"))
      e = { type: "plus", expr: e };
    else if (o.eat("*"))
      e = { type: "star", expr: e };
    else if (o.eat("?"))
      e = { type: "opt", expr: e };
    else if (o.eat("{"))
      e = bx(o, e);
    else
      break;
  return e;
}
function Rf(o) {
  /\D/.test(o.next) && o.err("Expected number, got '" + o.next + "'");
  let e = Number(o.next);
  return o.pos++, e;
}
function bx(o, e) {
  let r = Rf(o), t = r;
  return o.eat(",") && (o.next != "}" ? t = Rf(o) : t = -1), o.eat("}") || o.err("Unclosed braced range"), { type: "range", min: r, max: t, expr: e };
}
function vx(o, e) {
  let r = o.nodeTypes, t = r[e];
  if (t)
    return [t];
  let n = [];
  for (let a in r) {
    let s = r[a];
    s.isInGroup(e) && n.push(s);
  }
  return n.length == 0 && o.err("No node type or group '" + e + "' found"), n;
}
function Bx(o) {
  if (o.eat("(")) {
    let e = d0(o);
    return o.eat(")") || o.err("Missing closing paren"), e;
  } else if (/\W/.test(o.next))
    o.err("Unexpected token '" + o.next + "'");
  else {
    let e = vx(o, o.next).map((r) => (o.inline == null ? o.inline = r.isInline : o.inline != r.isInline && o.err("Mixing inline and block content"), { type: "name", value: r }));
    return o.pos++, e.length == 1 ? e[0] : { type: "choice", exprs: e };
  }
}
function Px(o) {
  let e = [[]];
  return n(a(o, 0), r()), e;
  function r() {
    return e.push([]) - 1;
  }
  function t(s, i, l) {
    let c = { term: l, to: i };
    return e[s].push(c), c;
  }
  function n(s, i) {
    s.forEach((l) => l.to = i);
  }
  function a(s, i) {
    if (s.type == "choice")
      return s.exprs.reduce((l, c) => l.concat(a(c, i)), []);
    if (s.type == "seq")
      for (let l = 0; ; l++) {
        let c = a(s.exprs[l], i);
        if (l == s.exprs.length - 1)
          return c;
        n(c, i = r());
      }
    else if (s.type == "star") {
      let l = r();
      return t(i, l), n(a(s.expr, l), l), [t(l)];
    } else if (s.type == "plus") {
      let l = r();
      return n(a(s.expr, i), l), n(a(s.expr, l), l), [t(l)];
    } else {
      if (s.type == "opt")
        return [t(i)].concat(a(s.expr, i));
      if (s.type == "range") {
        let l = i;
        for (let c = 0; c < s.min; c++) {
          let u = r();
          n(a(s.expr, l), u), l = u;
        }
        if (s.max == -1)
          n(a(s.expr, l), l);
        else
          for (let c = s.min; c < s.max; c++) {
            let u = r();
            t(l, u), n(a(s.expr, l), u), l = u;
          }
        return [t(l)];
      } else {
        if (s.type == "name")
          return [t(i, void 0, s.value)];
        throw new Error("Unknown expr type");
      }
    }
  }
}
function g0(o, e) {
  return e - o;
}
function Hf(o, e) {
  let r = [];
  return t(e), r.sort(g0);
  function t(n) {
    let a = o[n];
    if (a.length == 1 && !a[0].term)
      return t(a[0].to);
    r.push(n);
    for (let s = 0; s < a.length; s++) {
      let { term: i, to: l } = a[s];
      !i && r.indexOf(l) == -1 && t(l);
    }
  }
}
function wx(o) {
  let e = /* @__PURE__ */ Object.create(null);
  return r(Hf(o, 0));
  function r(t) {
    let n = [];
    t.forEach((s) => {
      o[s].forEach(({ term: i, to: l }) => {
        if (!i)
          return;
        let c;
        for (let u = 0; u < n.length; u++)
          n[u][0] == i && (c = n[u][1]);
        Hf(o, l).forEach((u) => {
          c || n.push([i, c = []]), c.indexOf(u) == -1 && c.push(u);
        });
      });
    });
    let a = e[t.join(",")] = new ft(t.indexOf(o.length - 1) > -1);
    for (let s = 0; s < n.length; s++) {
      let i = n[s][1].sort(g0);
      a.next.push({ type: n[s][0], next: e[i.join(",")] || r(i) });
    }
    return a;
  }
}
function kx(o, e) {
  for (let r = 0, t = [o]; r < t.length; r++) {
    let n = t[r], a = !n.validEnd, s = [];
    for (let i = 0; i < n.next.length; i++) {
      let { type: l, next: c } = n.next[i];
      s.push(l.name), a && !(l.isText || l.hasRequiredAttrs()) && (a = !1), t.indexOf(c) == -1 && t.push(c);
    }
    a && e.err("Only non-generatable nodes (" + s.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
  }
}
function m0(o) {
  let e = /* @__PURE__ */ Object.create(null);
  for (let r in o) {
    let t = o[r];
    if (!t.hasDefault)
      return null;
    e[r] = t.default;
  }
  return e;
}
function f0(o, e) {
  let r = /* @__PURE__ */ Object.create(null);
  for (let t in o) {
    let n = e && e[t];
    if (n === void 0) {
      let a = o[t];
      if (a.hasDefault)
        n = a.default;
      else
        throw new RangeError("No value supplied for attribute " + t);
    }
    r[t] = n;
  }
  return r;
}
function y0(o, e, r, t) {
  for (let n in e)
    if (!(n in o))
      throw new RangeError(`Unsupported attribute ${n} for ${r} of type ${n}`);
  for (let n in o) {
    let a = o[n];
    a.validate && a.validate(e[n]);
  }
}
function h0(o, e) {
  let r = /* @__PURE__ */ Object.create(null);
  if (e)
    for (let t in e)
      r[t] = new Sx(o, t, e[t]);
  return r;
}
let Yf = class F0 {
  /**
  @internal
  */
  constructor(e, r, t) {
    this.name = e, this.schema = r, this.spec = t, this.markSet = null, this.groups = t.group ? t.group.split(" ") : [], this.attrs = h0(e, t.attrs), this.defaultAttrs = m0(this.attrs), this.contentMatch = null, this.inlineContent = null, this.isBlock = !(t.inline || e == "text"), this.isText = e == "text";
  }
  /**
  True if this is an inline type.
  */
  get isInline() {
    return !this.isBlock;
  }
  /**
  True if this is a textblock type, a block that contains inline
  content.
  */
  get isTextblock() {
    return this.isBlock && this.inlineContent;
  }
  /**
  True for node types that allow no content.
  */
  get isLeaf() {
    return this.contentMatch == ft.empty;
  }
  /**
  True when this node is an atom, i.e. when it does not have
  directly editable content.
  */
  get isAtom() {
    return this.isLeaf || !!this.spec.atom;
  }
  /**
  Return true when this node type is part of the given
  [group](https://prosemirror.net/docs/ref/#model.NodeSpec.group).
  */
  isInGroup(e) {
    return this.groups.indexOf(e) > -1;
  }
  /**
  The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
  */
  get whitespace() {
    return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
  }
  /**
  Tells you whether this node type has any required attributes.
  */
  hasRequiredAttrs() {
    for (let e in this.attrs)
      if (this.attrs[e].isRequired)
        return !0;
    return !1;
  }
  /**
  Indicates whether this node allows some of the same content as
  the given node type.
  */
  compatibleContent(e) {
    return this == e || this.contentMatch.compatible(e.contentMatch);
  }
  /**
  @internal
  */
  computeAttrs(e) {
    return !e && this.defaultAttrs ? this.defaultAttrs : f0(this.attrs, e);
  }
  /**
  Create a `Node` of this type. The given attributes are
  checked and defaulted (you can pass `null` to use the type's
  defaults entirely, if no required attributes exist). `content`
  may be a `Fragment`, a node, an array of nodes, or
  `null`. Similarly `marks` may be `null` to default to the empty
  set of marks.
  */
  create(e = null, r, t) {
    if (this.isText)
      throw new Error("NodeType.create can't construct text nodes");
    return new it(this, this.computeAttrs(e), $.from(r), Ce.setFrom(t));
  }
  /**
  Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
  against the node type's content restrictions, and throw an error
  if it doesn't match.
  */
  createChecked(e = null, r, t) {
    return r = $.from(r), this.checkContent(r), new it(this, this.computeAttrs(e), r, Ce.setFrom(t));
  }
  /**
  Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
  necessary to add nodes to the start or end of the given fragment
  to make it fit the node. If no fitting wrapping can be found,
  return null. Note that, due to the fact that required nodes can
  always be created, this will always succeed if you pass null or
  `Fragment.empty` as content.
  */
  createAndFill(e = null, r, t) {
    if (e = this.computeAttrs(e), r = $.from(r), r.size) {
      let s = this.contentMatch.fillBefore(r);
      if (!s)
        return null;
      r = s.append(r);
    }
    let n = this.contentMatch.matchFragment(r), a = n && n.fillBefore($.empty, !0);
    return a ? new it(this, e, r.append(a), Ce.setFrom(t)) : null;
  }
  /**
  Returns true if the given fragment is valid content for this node
  type.
  */
  validContent(e) {
    let r = this.contentMatch.matchFragment(e);
    if (!r || !r.validEnd)
      return !1;
    for (let t = 0; t < e.childCount; t++)
      if (!this.allowsMarks(e.child(t).marks))
        return !1;
    return !0;
  }
  /**
  Throws a RangeError if the given fragment is not valid content for this
  node type.
  @internal
  */
  checkContent(e) {
    if (!this.validContent(e))
      throw new RangeError(`Invalid content for node ${this.name}: ${e.toString().slice(0, 50)}`);
  }
  /**
  @internal
  */
  checkAttrs(e) {
    y0(this.attrs, e, "node", this.name);
  }
  /**
  Check whether the given mark type is allowed in this node.
  */
  allowsMarkType(e) {
    return this.markSet == null || this.markSet.indexOf(e) > -1;
  }
  /**
  Test whether the given set of marks are allowed in this node.
  */
  allowsMarks(e) {
    if (this.markSet == null)
      return !0;
    for (let r = 0; r < e.length; r++)
      if (!this.allowsMarkType(e[r].type))
        return !1;
    return !0;
  }
  /**
  Removes the marks that are not allowed in this node from the given set.
  */
  allowedMarks(e) {
    if (this.markSet == null)
      return e;
    let r;
    for (let t = 0; t < e.length; t++)
      this.allowsMarkType(e[t].type) ? r && r.push(e[t]) : r || (r = e.slice(0, t));
    return r ? r.length ? r : Ce.none : e;
  }
  /**
  @internal
  */
  static compile(e, r) {
    let t = /* @__PURE__ */ Object.create(null);
    e.forEach((a, s) => t[a] = new F0(a, r, s));
    let n = r.spec.topNode || "doc";
    if (!t[n])
      throw new RangeError("Schema is missing its top node type ('" + n + "')");
    if (!t.text)
      throw new RangeError("Every schema needs a 'text' type");
    for (let a in t.text.attrs)
      throw new RangeError("The text node type should not have attributes");
    return t;
  }
};
function Dx(o, e, r) {
  let t = r.split("|");
  return (n) => {
    let a = n === null ? "null" : typeof n;
    if (t.indexOf(a) < 0)
      throw new RangeError(`Expected value of type ${t} for attribute ${e} on type ${o}, got ${a}`);
  };
}
class Sx {
  constructor(e, r, t) {
    this.hasDefault = Object.prototype.hasOwnProperty.call(t, "default"), this.default = t.default, this.validate = typeof t.validate == "string" ? Dx(e, r, t.validate) : t.validate;
  }
  get isRequired() {
    return !this.hasDefault;
  }
}
class Vi {
  /**
  @internal
  */
  constructor(e, r, t, n) {
    this.name = e, this.rank = r, this.schema = t, this.spec = n, this.attrs = h0(e, n.attrs), this.excluded = null;
    let a = m0(this.attrs);
    this.instance = a ? new Ce(this, a) : null;
  }
  /**
  Create a mark of this type. `attrs` may be `null` or an object
  containing only some of the mark's attributes. The others, if
  they have defaults, will be added.
  */
  create(e = null) {
    return !e && this.instance ? this.instance : new Ce(this, f0(this.attrs, e));
  }
  /**
  @internal
  */
  static compile(e, r) {
    let t = /* @__PURE__ */ Object.create(null), n = 0;
    return e.forEach((a, s) => t[a] = new Vi(a, n++, r, s)), t;
  }
  /**
  When there is a mark of this type in the given set, a new set
  without it is returned. Otherwise, the input set is returned.
  */
  removeFromSet(e) {
    for (var r = 0; r < e.length; r++)
      e[r].type == this && (e = e.slice(0, r).concat(e.slice(r + 1)), r--);
    return e;
  }
  /**
  Tests whether there is a mark of this type in the given set.
  */
  isInSet(e) {
    for (let r = 0; r < e.length; r++)
      if (e[r].type == this)
        return e[r];
  }
  /**
  @internal
  */
  checkAttrs(e) {
    y0(this.attrs, e, "mark", this.name);
  }
  /**
  Queries whether a given mark type is
  [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
  */
  excludes(e) {
    return this.excluded.indexOf(e) > -1;
  }
}
class Ax {
  /**
  Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
  */
  constructor(e) {
    this.linebreakReplacement = null, this.cached = /* @__PURE__ */ Object.create(null);
    let r = this.spec = {};
    for (let n in e)
      r[n] = e[n];
    r.nodes = _e.from(e.nodes), r.marks = _e.from(e.marks || {}), this.nodes = Yf.compile(this.spec.nodes, this), this.marks = Vi.compile(this.spec.marks, this);
    let t = /* @__PURE__ */ Object.create(null);
    for (let n in this.nodes) {
      if (n in this.marks)
        throw new RangeError(n + " can not be both a node and a mark");
      let a = this.nodes[n], s = a.spec.content || "", i = a.spec.marks;
      if (a.contentMatch = t[s] || (t[s] = ft.parse(s, this.nodes)), a.inlineContent = a.contentMatch.inlineContent, a.spec.linebreakReplacement) {
        if (this.linebreakReplacement)
          throw new RangeError("Multiple linebreak nodes defined");
        if (!a.isInline || !a.isLeaf)
          throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
        this.linebreakReplacement = a;
      }
      a.markSet = i == "_" ? null : i ? qf(this, i.split(" ")) : i == "" || !a.inlineContent ? [] : null;
    }
    for (let n in this.marks) {
      let a = this.marks[n], s = a.spec.excludes;
      a.excluded = s == null ? [a] : s == "" ? [] : qf(this, s.split(" "));
    }
    this.nodeFromJSON = this.nodeFromJSON.bind(this), this.markFromJSON = this.markFromJSON.bind(this), this.topNodeType = this.nodes[this.spec.topNode || "doc"], this.cached.wrappings = /* @__PURE__ */ Object.create(null);
  }
  /**
  Create a node in this schema. The `type` may be a string or a
  `NodeType` instance. Attributes will be extended with defaults,
  `content` may be a `Fragment`, `null`, a `Node`, or an array of
  nodes.
  */
  node(e, r = null, t, n) {
    if (typeof e == "string")
      e = this.nodeType(e);
    else if (e instanceof Yf) {
      if (e.schema != this)
        throw new RangeError("Node type from different schema used (" + e.name + ")");
    } else throw new RangeError("Invalid node type: " + e);
    return e.createChecked(r, t, n);
  }
  /**
  Create a text node in the schema. Empty text nodes are not
  allowed.
  */
  text(e, r) {
    let t = this.nodes.text;
    return new li(t, t.defaultAttrs, e, Ce.setFrom(r));
  }
  /**
  Create a mark with the given type and attributes.
  */
  mark(e, r) {
    return typeof e == "string" && (e = this.marks[e]), e.create(r);
  }
  /**
  Deserialize a node from its JSON representation. This method is
  bound.
  */
  nodeFromJSON(e) {
    return it.fromJSON(this, e);
  }
  /**
  Deserialize a mark from its JSON representation. This method is
  bound.
  */
  markFromJSON(e) {
    return Ce.fromJSON(this, e);
  }
  /**
  @internal
  */
  nodeType(e) {
    let r = this.nodes[e];
    if (!r)
      throw new RangeError("Unknown node type: " + e);
    return r;
  }
}
function qf(o, e) {
  let r = [];
  for (let t = 0; t < e.length; t++) {
    let n = e[t], a = o.marks[n], s = a;
    if (a)
      r.push(a);
    else
      for (let i in o.marks) {
        let l = o.marks[i];
        (n == "_" || l.spec.group && l.spec.group.split(" ").indexOf(n) > -1) && r.push(s = l);
      }
    if (!s)
      throw new SyntaxError("Unknown mark type: '" + e[t] + "'");
  }
  return r;
}
function Ex(o) {
  return o.tag != null;
}
function xx(o) {
  return o.style != null;
}
class lt {
  /**
  Create a parser that targets the given schema, using the given
  parsing rules.
  */
  constructor(e, r) {
    this.schema = e, this.rules = r, this.tags = [], this.styles = [];
    let t = this.matchedStyles = [];
    r.forEach((n) => {
      if (Ex(n))
        this.tags.push(n);
      else if (xx(n)) {
        let a = /[^=]*/.exec(n.style)[0];
        t.indexOf(a) < 0 && t.push(a), this.styles.push(n);
      }
    }), this.normalizeLists = !this.tags.some((n) => {
      if (!/^(ul|ol)\b/.test(n.tag) || !n.node)
        return !1;
      let a = e.nodes[n.node];
      return a.contentMatch.matchType(a);
    });
  }
  /**
  Parse a document from the content of a DOM node.
  */
  parse(e, r = {}) {
    let t = new Xf(this, r, !1);
    return t.addAll(e, Ce.none, r.from, r.to), t.finish();
  }
  /**
  Parses the content of the given DOM node, like
  [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
  options. But unlike that method, which produces a whole node,
  this one returns a slice that is open at the sides, meaning that
  the schema constraints aren't applied to the start of nodes to
  the left of the input and the end of nodes at the end.
  */
  parseSlice(e, r = {}) {
    let t = new Xf(this, r, !0);
    return t.addAll(e, Ce.none, r.from, r.to), te.maxOpen(t.finish());
  }
  /**
  @internal
  */
  matchTag(e, r, t) {
    for (let n = t ? this.tags.indexOf(t) + 1 : 0; n < this.tags.length; n++) {
      let a = this.tags[n];
      if (Tx(e, a.tag) && (a.namespace === void 0 || e.namespaceURI == a.namespace) && (!a.context || r.matchesContext(a.context))) {
        if (a.getAttrs) {
          let s = a.getAttrs(e);
          if (s === !1)
            continue;
          a.attrs = s || void 0;
        }
        return a;
      }
    }
  }
  /**
  @internal
  */
  matchStyle(e, r, t, n) {
    for (let a = n ? this.styles.indexOf(n) + 1 : 0; a < this.styles.length; a++) {
      let s = this.styles[a], i = s.style;
      if (!(i.indexOf(e) != 0 || s.context && !t.matchesContext(s.context) || // Test that the style string either precisely matches the prop,
      // or has an '=' sign after the prop, followed by the given
      // value.
      i.length > e.length && (i.charCodeAt(e.length) != 61 || i.slice(e.length + 1) != r))) {
        if (s.getAttrs) {
          let l = s.getAttrs(r);
          if (l === !1)
            continue;
          s.attrs = l || void 0;
        }
        return s;
      }
    }
  }
  /**
  @internal
  */
  static schemaRules(e) {
    let r = [];
    function t(n) {
      let a = n.priority == null ? 50 : n.priority, s = 0;
      for (; s < r.length; s++) {
        let i = r[s];
        if ((i.priority == null ? 50 : i.priority) < a)
          break;
      }
      r.splice(s, 0, n);
    }
    for (let n in e.marks) {
      let a = e.marks[n].spec.parseDOM;
      a && a.forEach((s) => {
        t(s = Uf(s)), s.mark || s.ignore || s.clearMark || (s.mark = n);
      });
    }
    for (let n in e.nodes) {
      let a = e.nodes[n].spec.parseDOM;
      a && a.forEach((s) => {
        t(s = Uf(s)), s.node || s.ignore || s.mark || (s.node = n);
      });
    }
    return r;
  }
  /**
  Construct a DOM parser using the parsing rules listed in a
  schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
  [priority](https://prosemirror.net/docs/ref/#model.ParseRule.priority).
  */
  static fromSchema(e) {
    return e.cached.domParser || (e.cached.domParser = new lt(e, lt.schemaRules(e)));
  }
}
const b0 = {
  address: !0,
  article: !0,
  aside: !0,
  blockquote: !0,
  canvas: !0,
  dd: !0,
  div: !0,
  dl: !0,
  fieldset: !0,
  figcaption: !0,
  figure: !0,
  footer: !0,
  form: !0,
  h1: !0,
  h2: !0,
  h3: !0,
  h4: !0,
  h5: !0,
  h6: !0,
  header: !0,
  hgroup: !0,
  hr: !0,
  li: !0,
  noscript: !0,
  ol: !0,
  output: !0,
  p: !0,
  pre: !0,
  section: !0,
  table: !0,
  tfoot: !0,
  ul: !0
}, Cx = {
  head: !0,
  noscript: !0,
  object: !0,
  script: !0,
  style: !0,
  title: !0
}, v0 = { ol: !0, ul: !0 }, Ca = 1, zu = 2, Hs = 4;
function Gf(o, e, r) {
  return e != null ? (e ? Ca : 0) | (e === "full" ? zu : 0) : o && o.whitespace == "pre" ? Ca | zu : r & -5;
}
class ws {
  constructor(e, r, t, n, a, s) {
    this.type = e, this.attrs = r, this.marks = t, this.solid = n, this.options = s, this.content = [], this.activeMarks = Ce.none, this.match = a || (s & Hs ? null : e.contentMatch);
  }
  findWrapping(e) {
    if (!this.match) {
      if (!this.type)
        return [];
      let r = this.type.contentMatch.fillBefore($.from(e));
      if (r)
        this.match = this.type.contentMatch.matchFragment(r);
      else {
        let t = this.type.contentMatch, n;
        return (n = t.findWrapping(e.type)) ? (this.match = t, n) : null;
      }
    }
    return this.match.findWrapping(e.type);
  }
  finish(e) {
    if (!(this.options & Ca)) {
      let t = this.content[this.content.length - 1], n;
      if (t && t.isText && (n = /[ \t\r\n\u000c]+$/.exec(t.text))) {
        let a = t;
        t.text.length == n[0].length ? this.content.pop() : this.content[this.content.length - 1] = a.withText(a.text.slice(0, a.text.length - n[0].length));
      }
    }
    let r = $.from(this.content);
    return !e && this.match && (r = r.append(this.match.fillBefore($.empty, !0))), this.type ? this.type.create(this.attrs, r, this.marks) : r;
  }
  inlineContext(e) {
    return this.type ? this.type.inlineContent : this.content.length ? this.content[0].isInline : e.parentNode && !b0.hasOwnProperty(e.parentNode.nodeName.toLowerCase());
  }
}
class Xf {
  constructor(e, r, t) {
    this.parser = e, this.options = r, this.isOpen = t, this.open = 0, this.localPreserveWS = !1;
    let n = r.topNode, a, s = Gf(null, r.preserveWhitespace, 0) | (t ? Hs : 0);
    n ? a = new ws(n.type, n.attrs, Ce.none, !0, r.topMatch || n.type.contentMatch, s) : t ? a = new ws(null, null, Ce.none, !0, null, s) : a = new ws(e.schema.topNodeType, null, Ce.none, !0, null, s), this.nodes = [a], this.find = r.findPositions, this.needsBlock = !1;
  }
  get top() {
    return this.nodes[this.open];
  }
  // Add a DOM node to the content. Text is inserted as text node,
  // otherwise, the node is passed to `addElement` or, if it has a
  // `style` attribute, `addElementWithStyles`.
  addDOM(e, r) {
    e.nodeType == 3 ? this.addTextNode(e, r) : e.nodeType == 1 && this.addElement(e, r);
  }
  addTextNode(e, r) {
    let t = e.nodeValue, n = this.top, a = n.options & zu ? "full" : this.localPreserveWS || (n.options & Ca) > 0;
    if (a === "full" || n.inlineContext(e) || /[^ \t\r\n\u000c]/.test(t)) {
      if (a)
        a !== "full" ? t = t.replace(/\r?\n|\r/g, " ") : t = t.replace(/\r\n?/g, `
`);
      else if (t = t.replace(/[ \t\r\n\u000c]+/g, " "), /^[ \t\r\n\u000c]/.test(t) && this.open == this.nodes.length - 1) {
        let s = n.content[n.content.length - 1], i = e.previousSibling;
        (!s || i && i.nodeName == "BR" || s.isText && /[ \t\r\n\u000c]$/.test(s.text)) && (t = t.slice(1));
      }
      t && this.insertNode(this.parser.schema.text(t), r), this.findInText(e);
    } else
      this.findInside(e);
  }
  // Try to find a handler for the given tag and use that to parse. If
  // none is found, the element's content nodes are added directly.
  addElement(e, r, t) {
    let n = this.localPreserveWS, a = this.top;
    (e.tagName == "PRE" || /pre/.test(e.style && e.style.whiteSpace)) && (this.localPreserveWS = !0);
    let s = e.nodeName.toLowerCase(), i;
    v0.hasOwnProperty(s) && this.parser.normalizeLists && Ox(e);
    let l = this.options.ruleFromNode && this.options.ruleFromNode(e) || (i = this.parser.matchTag(e, this, t));
    e: if (l ? l.ignore : Cx.hasOwnProperty(s))
      this.findInside(e), this.ignoreFallback(e, r);
    else if (!l || l.skip || l.closeParent) {
      l && l.closeParent ? this.open = Math.max(0, this.open - 1) : l && l.skip.nodeType && (e = l.skip);
      let c, u = this.needsBlock;
      if (b0.hasOwnProperty(s))
        a.content.length && a.content[0].isInline && this.open && (this.open--, a = this.top), c = !0, a.type || (this.needsBlock = !0);
      else if (!e.firstChild) {
        this.leafFallback(e, r);
        break e;
      }
      let f = l && l.skip ? r : this.readStyles(e, r);
      f && this.addAll(e, f), c && this.sync(a), this.needsBlock = u;
    } else {
      let c = this.readStyles(e, r);
      c && this.addElementByRule(e, l, c, l.consuming === !1 ? i : void 0);
    }
    this.localPreserveWS = n;
  }
  // Called for leaf DOM nodes that would otherwise be ignored
  leafFallback(e, r) {
    e.nodeName == "BR" && this.top.type && this.top.type.inlineContent && this.addTextNode(e.ownerDocument.createTextNode(`
`), r);
  }
  // Called for ignored nodes
  ignoreFallback(e, r) {
    e.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent) && this.findPlace(this.parser.schema.text("-"), r);
  }
  // Run any style parser associated with the node's styles. Either
  // return an updated array of marks, or null to indicate some of the
  // styles had a rule with `ignore` set.
  readStyles(e, r) {
    let t = e.style;
    if (t && t.length)
      for (let n = 0; n < this.parser.matchedStyles.length; n++) {
        let a = this.parser.matchedStyles[n], s = t.getPropertyValue(a);
        if (s)
          for (let i = void 0; ; ) {
            let l = this.parser.matchStyle(a, s, this, i);
            if (!l)
              break;
            if (l.ignore)
              return null;
            if (l.clearMark ? r = r.filter((c) => !l.clearMark(c)) : r = r.concat(this.parser.schema.marks[l.mark].create(l.attrs)), l.consuming === !1)
              i = l;
            else
              break;
          }
      }
    return r;
  }
  // Look up a handler for the given node. If none are found, return
  // false. Otherwise, apply it, use its return value to drive the way
  // the node's content is wrapped, and return true.
  addElementByRule(e, r, t, n) {
    let a, s;
    if (r.node)
      if (s = this.parser.schema.nodes[r.node], s.isLeaf)
        this.insertNode(s.create(r.attrs), t) || this.leafFallback(e, t);
      else {
        let l = this.enter(s, r.attrs || null, t, r.preserveWhitespace);
        l && (a = !0, t = l);
      }
    else {
      let l = this.parser.schema.marks[r.mark];
      t = t.concat(l.create(r.attrs));
    }
    let i = this.top;
    if (s && s.isLeaf)
      this.findInside(e);
    else if (n)
      this.addElement(e, t, n);
    else if (r.getContent)
      this.findInside(e), r.getContent(e, this.parser.schema).forEach((l) => this.insertNode(l, t));
    else {
      let l = e;
      typeof r.contentElement == "string" ? l = e.querySelector(r.contentElement) : typeof r.contentElement == "function" ? l = r.contentElement(e) : r.contentElement && (l = r.contentElement), this.findAround(e, l, !0), this.addAll(l, t), this.findAround(e, l, !1);
    }
    a && this.sync(i) && this.open--;
  }
  // Add all child nodes between `startIndex` and `endIndex` (or the
  // whole node, if not given). If `sync` is passed, use it to
  // synchronize after every block element.
  addAll(e, r, t, n) {
    let a = t || 0;
    for (let s = t ? e.childNodes[t] : e.firstChild, i = n == null ? null : e.childNodes[n]; s != i; s = s.nextSibling, ++a)
      this.findAtPoint(e, a), this.addDOM(s, r);
    this.findAtPoint(e, a);
  }
  // Try to find a way to fit the given node type into the current
  // context. May add intermediate wrappers and/or leave non-solid
  // nodes that we're in.
  findPlace(e, r) {
    let t, n;
    for (let a = this.open; a >= 0; a--) {
      let s = this.nodes[a], i = s.findWrapping(e);
      if (i && (!t || t.length > i.length) && (t = i, n = s, !i.length) || s.solid)
        break;
    }
    if (!t)
      return null;
    this.sync(n);
    for (let a = 0; a < t.length; a++)
      r = this.enterInner(t[a], null, r, !1);
    return r;
  }
  // Try to insert the given node, adjusting the context when needed.
  insertNode(e, r) {
    if (e.isInline && this.needsBlock && !this.top.type) {
      let n = this.textblockFromContext();
      n && (r = this.enterInner(n, null, r));
    }
    let t = this.findPlace(e, r);
    if (t) {
      this.closeExtra();
      let n = this.top;
      n.match && (n.match = n.match.matchType(e.type));
      let a = Ce.none;
      for (let s of t.concat(e.marks))
        (n.type ? n.type.allowsMarkType(s.type) : Zf(s.type, e.type)) && (a = s.addToSet(a));
      return n.content.push(e.mark(a)), !0;
    }
    return !1;
  }
  // Try to start a node of the given type, adjusting the context when
  // necessary.
  enter(e, r, t, n) {
    let a = this.findPlace(e.create(r), t);
    return a && (a = this.enterInner(e, r, t, !0, n)), a;
  }
  // Open a node of the given type
  enterInner(e, r, t, n = !1, a) {
    this.closeExtra();
    let s = this.top;
    s.match = s.match && s.match.matchType(e);
    let i = Gf(e, a, s.options);
    s.options & Hs && s.content.length == 0 && (i |= Hs);
    let l = Ce.none;
    return t = t.filter((c) => (s.type ? s.type.allowsMarkType(c.type) : Zf(c.type, e)) ? (l = c.addToSet(l), !1) : !0), this.nodes.push(new ws(e, r, l, n, null, i)), this.open++, t;
  }
  // Make sure all nodes above this.open are finished and added to
  // their parents
  closeExtra(e = !1) {
    let r = this.nodes.length - 1;
    if (r > this.open) {
      for (; r > this.open; r--)
        this.nodes[r - 1].content.push(this.nodes[r].finish(e));
      this.nodes.length = this.open + 1;
    }
  }
  finish() {
    return this.open = 0, this.closeExtra(this.isOpen), this.nodes[0].finish(!!(this.isOpen || this.options.topOpen));
  }
  sync(e) {
    for (let r = this.open; r >= 0; r--) {
      if (this.nodes[r] == e)
        return this.open = r, !0;
      this.localPreserveWS && (this.nodes[r].options |= Ca);
    }
    return !1;
  }
  get currentPos() {
    this.closeExtra();
    let e = 0;
    for (let r = this.open; r >= 0; r--) {
      let t = this.nodes[r].content;
      for (let n = t.length - 1; n >= 0; n--)
        e += t[n].nodeSize;
      r && e++;
    }
    return e;
  }
  findAtPoint(e, r) {
    if (this.find)
      for (let t = 0; t < this.find.length; t++)
        this.find[t].node == e && this.find[t].offset == r && (this.find[t].pos = this.currentPos);
  }
  findInside(e) {
    if (this.find)
      for (let r = 0; r < this.find.length; r++)
        this.find[r].pos == null && e.nodeType == 1 && e.contains(this.find[r].node) && (this.find[r].pos = this.currentPos);
  }
  findAround(e, r, t) {
    if (e != r && this.find)
      for (let n = 0; n < this.find.length; n++)
        this.find[n].pos == null && e.nodeType == 1 && e.contains(this.find[n].node) && r.compareDocumentPosition(this.find[n].node) & (t ? 2 : 4) && (this.find[n].pos = this.currentPos);
  }
  findInText(e) {
    if (this.find)
      for (let r = 0; r < this.find.length; r++)
        this.find[r].node == e && (this.find[r].pos = this.currentPos - (e.nodeValue.length - this.find[r].offset));
  }
  // Determines whether the given context string matches this context.
  matchesContext(e) {
    if (e.indexOf("|") > -1)
      return e.split(/\s*\|\s*/).some(this.matchesContext, this);
    let r = e.split("/"), t = this.options.context, n = !this.isOpen && (!t || t.parent.type == this.nodes[0].type), a = -(t ? t.depth + 1 : 0) + (n ? 0 : 1), s = (i, l) => {
      for (; i >= 0; i--) {
        let c = r[i];
        if (c == "") {
          if (i == r.length - 1 || i == 0)
            continue;
          for (; l >= a; l--)
            if (s(i - 1, l))
              return !0;
          return !1;
        } else {
          let u = l > 0 || l == 0 && n ? this.nodes[l].type : t && l >= a ? t.node(l - a).type : null;
          if (!u || u.name != c && !u.isInGroup(c))
            return !1;
          l--;
        }
      }
      return !0;
    };
    return s(r.length - 1, this.open);
  }
  textblockFromContext() {
    let e = this.options.context;
    if (e)
      for (let r = e.depth; r >= 0; r--) {
        let t = e.node(r).contentMatchAt(e.indexAfter(r)).defaultType;
        if (t && t.isTextblock && t.defaultAttrs)
          return t;
      }
    for (let r in this.parser.schema.nodes) {
      let t = this.parser.schema.nodes[r];
      if (t.isTextblock && t.defaultAttrs)
        return t;
    }
  }
}
function Ox(o) {
  for (let e = o.firstChild, r = null; e; e = e.nextSibling) {
    let t = e.nodeType == 1 ? e.nodeName.toLowerCase() : null;
    t && v0.hasOwnProperty(t) && r ? (r.appendChild(e), e = r) : t == "li" ? r = e : t && (r = null);
  }
}
function Tx(o, e) {
  return (o.matches || o.msMatchesSelector || o.webkitMatchesSelector || o.mozMatchesSelector).call(o, e);
}
function Uf(o) {
  let e = {};
  for (let r in o)
    e[r] = o[r];
  return e;
}
function Zf(o, e) {
  let r = e.schema.nodes;
  for (let t in r) {
    let n = r[t];
    if (!n.allowsMarkType(o))
      continue;
    let a = [], s = (i) => {
      a.push(i);
      for (let l = 0; l < i.edgeCount; l++) {
        let { type: c, next: u } = i.edge(l);
        if (c == e || a.indexOf(u) < 0 && s(u))
          return !0;
      }
    };
    if (s(n.contentMatch))
      return !0;
  }
}
class zi {
  /**
  Create a serializer. `nodes` should map node names to functions
  that take a node and return a description of the corresponding
  DOM. `marks` does the same for mark names, but also gets an
  argument that tells it whether the mark's content is block or
  inline content (for typical use, it'll always be inline). A mark
  serializer may be `null` to indicate that marks of that type
  should not be serialized.
  */
  constructor(e, r) {
    this.nodes = e, this.marks = r;
  }
  /**
  Serialize the content of this fragment to a DOM fragment. When
  not in the browser, the `document` option, containing a DOM
  document, should be passed so that the serializer can create
  nodes.
  */
  serializeFragment(e, r = {}, t) {
    t || (t = cc(r).createDocumentFragment());
    let n = t, a = [];
    return e.forEach((s) => {
      if (a.length || s.marks.length) {
        let i = 0, l = 0;
        for (; i < a.length && l < s.marks.length; ) {
          let c = s.marks[l];
          if (!this.marks[c.type.name]) {
            l++;
            continue;
          }
          if (!c.eq(a[i][0]) || c.type.spec.spanning === !1)
            break;
          i++, l++;
        }
        for (; i < a.length; )
          n = a.pop()[1];
        for (; l < s.marks.length; ) {
          let c = s.marks[l++], u = this.serializeMark(c, s.isInline, r);
          u && (a.push([c, n]), n.appendChild(u.dom), n = u.contentDOM || u.dom);
        }
      }
      n.appendChild(this.serializeNodeInner(s, r));
    }), t;
  }
  /**
  @internal
  */
  serializeNodeInner(e, r) {
    let { dom: t, contentDOM: n } = Ys(cc(r), this.nodes[e.type.name](e), null, e.attrs);
    if (n) {
      if (e.isLeaf)
        throw new RangeError("Content hole not allowed in a leaf node spec");
      this.serializeFragment(e.content, r, n);
    }
    return t;
  }
  /**
  Serialize this node to a DOM node. This can be useful when you
  need to serialize a part of a document, as opposed to the whole
  document. To serialize a whole document, use
  [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
  its [content](https://prosemirror.net/docs/ref/#model.Node.content).
  */
  serializeNode(e, r = {}) {
    let t = this.serializeNodeInner(e, r);
    for (let n = e.marks.length - 1; n >= 0; n--) {
      let a = this.serializeMark(e.marks[n], e.isInline, r);
      a && ((a.contentDOM || a.dom).appendChild(t), t = a.dom);
    }
    return t;
  }
  /**
  @internal
  */
  serializeMark(e, r, t = {}) {
    let n = this.marks[e.type.name];
    return n && Ys(cc(t), n(e, r), null, e.attrs);
  }
  static renderSpec(e, r, t = null, n) {
    return Ys(e, r, t, n);
  }
  /**
  Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
  properties in a schema's node and mark specs.
  */
  static fromSchema(e) {
    return e.cached.domSerializer || (e.cached.domSerializer = new zi(this.nodesFromSchema(e), this.marksFromSchema(e)));
  }
  /**
  Gather the serializers in a schema's node specs into an object.
  This can be useful as a base to build a custom serializer from.
  */
  static nodesFromSchema(e) {
    let r = Kf(e.nodes);
    return r.text || (r.text = (t) => t.text), r;
  }
  /**
  Gather the serializers in a schema's mark specs into an object.
  */
  static marksFromSchema(e) {
    return Kf(e.marks);
  }
}
function Kf(o) {
  let e = {};
  for (let r in o) {
    let t = o[r].spec.toDOM;
    t && (e[r] = t);
  }
  return e;
}
function cc(o) {
  return o.document || window.document;
}
const Qf = /* @__PURE__ */ new WeakMap();
function Lx(o) {
  let e = Qf.get(o);
  return e === void 0 && Qf.set(o, e = jx(o)), e;
}
function jx(o) {
  let e = null;
  function r(t) {
    if (t && typeof t == "object")
      if (Array.isArray(t))
        if (typeof t[0] == "string")
          e || (e = []), e.push(t);
        else
          for (let n = 0; n < t.length; n++)
            r(t[n]);
      else
        for (let n in t)
          r(t[n]);
  }
  return r(o), e;
}
function Ys(o, e, r, t) {
  if (typeof e == "string")
    return { dom: o.createTextNode(e) };
  if (e.nodeType != null)
    return { dom: e };
  if (e.dom && e.dom.nodeType != null)
    return e;
  let n = e[0], a;
  if (typeof n != "string")
    throw new RangeError("Invalid array passed to renderSpec");
  if (t && (a = Lx(t)) && a.indexOf(e) > -1)
    throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
  let s = n.indexOf(" ");
  s > 0 && (r = n.slice(0, s), n = n.slice(s + 1));
  let i, l = r ? o.createElementNS(r, n) : o.createElement(n), c = e[1], u = 1;
  if (c && typeof c == "object" && c.nodeType == null && !Array.isArray(c)) {
    u = 2;
    for (let f in c)
      if (c[f] != null) {
        let g = f.indexOf(" ");
        g > 0 ? l.setAttributeNS(f.slice(0, g), f.slice(g + 1), c[f]) : l.setAttribute(f, c[f]);
      }
  }
  for (let f = u; f < e.length; f++) {
    let g = e[f];
    if (g === 0) {
      if (f < e.length - 1 || f > u)
        throw new RangeError("Content hole must be the only child of its parent node");
      return { dom: l, contentDOM: l };
    } else {
      let { dom: d, contentDOM: p } = Ys(o, g, r, t);
      if (l.appendChild(d), p) {
        if (i)
          throw new RangeError("Multiple content holes");
        i = p;
      }
    }
  }
  return { dom: l, contentDOM: i };
}
const B0 = 65535, P0 = Math.pow(2, 16);
function Mx(o, e) {
  return o + e * P0;
}
function Jf(o) {
  return o & B0;
}
function Wx(o) {
  return (o - (o & B0)) / P0;
}
const w0 = 1, k0 = 2, qs = 4, D0 = 8;
class Iu {
  /**
  @internal
  */
  constructor(e, r, t) {
    this.pos = e, this.delInfo = r, this.recover = t;
  }
  /**
  Tells you whether the position was deleted, that is, whether the
  step removed the token on the side queried (via the `assoc`)
  argument from the document.
  */
  get deleted() {
    return (this.delInfo & D0) > 0;
  }
  /**
  Tells you whether the token before the mapped position was deleted.
  */
  get deletedBefore() {
    return (this.delInfo & (w0 | qs)) > 0;
  }
  /**
  True when the token after the mapped position was deleted.
  */
  get deletedAfter() {
    return (this.delInfo & (k0 | qs)) > 0;
  }
  /**
  Tells whether any of the steps mapped through deletes across the
  position (including both the token before and after the
  position).
  */
  get deletedAcross() {
    return (this.delInfo & qs) > 0;
  }
}
class So {
  /**
  Create a position map. The modifications to the document are
  represented as an array of numbers, in which each group of three
  represents a modified chunk as `[start, oldSize, newSize]`.
  */
  constructor(e, r = !1) {
    if (this.ranges = e, this.inverted = r, !e.length && So.empty)
      return So.empty;
  }
  /**
  @internal
  */
  recover(e) {
    let r = 0, t = Jf(e);
    if (!this.inverted)
      for (let n = 0; n < t; n++)
        r += this.ranges[n * 3 + 2] - this.ranges[n * 3 + 1];
    return this.ranges[t * 3] + r + Wx(e);
  }
  mapResult(e, r = 1) {
    return this._map(e, r, !1);
  }
  map(e, r = 1) {
    return this._map(e, r, !0);
  }
  /**
  @internal
  */
  _map(e, r, t) {
    let n = 0, a = this.inverted ? 2 : 1, s = this.inverted ? 1 : 2;
    for (let i = 0; i < this.ranges.length; i += 3) {
      let l = this.ranges[i] - (this.inverted ? n : 0);
      if (l > e)
        break;
      let c = this.ranges[i + a], u = this.ranges[i + s], f = l + c;
      if (e <= f) {
        let g = c ? e == l ? -1 : e == f ? 1 : r : r, d = l + n + (g < 0 ? 0 : u);
        if (t)
          return d;
        let p = e == (r < 0 ? l : f) ? null : Mx(i / 3, e - l), m = e == l ? k0 : e == f ? w0 : qs;
        return (r < 0 ? e != l : e != f) && (m |= D0), new Iu(d, m, p);
      }
      n += u - c;
    }
    return t ? e + n : new Iu(e + n, 0, null);
  }
  /**
  @internal
  */
  touches(e, r) {
    let t = 0, n = Jf(r), a = this.inverted ? 2 : 1, s = this.inverted ? 1 : 2;
    for (let i = 0; i < this.ranges.length; i += 3) {
      let l = this.ranges[i] - (this.inverted ? t : 0);
      if (l > e)
        break;
      let c = this.ranges[i + a], u = l + c;
      if (e <= u && i == n * 3)
        return !0;
      t += this.ranges[i + s] - c;
    }
    return !1;
  }
  /**
  Calls the given function on each of the changed ranges included in
  this map.
  */
  forEach(e) {
    let r = this.inverted ? 2 : 1, t = this.inverted ? 1 : 2;
    for (let n = 0, a = 0; n < this.ranges.length; n += 3) {
      let s = this.ranges[n], i = s - (this.inverted ? a : 0), l = s + (this.inverted ? 0 : a), c = this.ranges[n + r], u = this.ranges[n + t];
      e(i, i + c, l, l + u), a += u - c;
    }
  }
  /**
  Create an inverted version of this map. The result can be used to
  map positions in the post-step document to the pre-step document.
  */
  invert() {
    return new So(this.ranges, !this.inverted);
  }
  /**
  @internal
  */
  toString() {
    return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
  }
  /**
  Create a map that moves all positions by offset `n` (which may be
  negative). This can be useful when applying steps meant for a
  sub-document to a larger document, or vice-versa.
  */
  static offset(e) {
    return e == 0 ? So.empty : new So(e < 0 ? [0, -e, 0] : [0, 0, e]);
  }
}
So.empty = new So([]);
class ci {
  /**
  Create a new mapping with the given position maps.
  */
  constructor(e, r, t = 0, n = e ? e.length : 0) {
    this.mirror = r, this.from = t, this.to = n, this._maps = e || [], this.ownData = !(e || r);
  }
  /**
  The step maps in this mapping.
  */
  get maps() {
    return this._maps;
  }
  /**
  Create a mapping that maps only through a part of this one.
  */
  slice(e = 0, r = this.maps.length) {
    return new ci(this._maps, this.mirror, e, r);
  }
  /**
  Add a step map to the end of this mapping. If `mirrors` is
  given, it should be the index of the step map that is the mirror
  image of this one.
  */
  appendMap(e, r) {
    this.ownData || (this._maps = this._maps.slice(), this.mirror = this.mirror && this.mirror.slice(), this.ownData = !0), this.to = this._maps.push(e), r != null && this.setMirror(this._maps.length - 1, r);
  }
  /**
  Add all the step maps in a given mapping to this one (preserving
  mirroring information).
  */
  appendMapping(e) {
    for (let r = 0, t = this._maps.length; r < e._maps.length; r++) {
      let n = e.getMirror(r);
      this.appendMap(e._maps[r], n != null && n < r ? t + n : void 0);
    }
  }
  /**
  Finds the offset of the step map that mirrors the map at the
  given offset, in this mapping (as per the second argument to
  `appendMap`).
  */
  getMirror(e) {
    if (this.mirror) {
      for (let r = 0; r < this.mirror.length; r++)
        if (this.mirror[r] == e)
          return this.mirror[r + (r % 2 ? -1 : 1)];
    }
  }
  /**
  @internal
  */
  setMirror(e, r) {
    this.mirror || (this.mirror = []), this.mirror.push(e, r);
  }
  /**
  Append the inverse of the given mapping to this one.
  */
  appendMappingInverted(e) {
    for (let r = e.maps.length - 1, t = this._maps.length + e._maps.length; r >= 0; r--) {
      let n = e.getMirror(r);
      this.appendMap(e._maps[r].invert(), n != null && n > r ? t - n - 1 : void 0);
    }
  }
  /**
  Create an inverted version of this mapping.
  */
  invert() {
    let e = new ci();
    return e.appendMappingInverted(this), e;
  }
  /**
  Map a position through this mapping.
  */
  map(e, r = 1) {
    if (this.mirror)
      return this._map(e, r, !0);
    for (let t = this.from; t < this.to; t++)
      e = this._maps[t].map(e, r);
    return e;
  }
  /**
  Map a position through this mapping, returning a mapping
  result.
  */
  mapResult(e, r = 1) {
    return this._map(e, r, !1);
  }
  /**
  @internal
  */
  _map(e, r, t) {
    let n = 0;
    for (let a = this.from; a < this.to; a++) {
      let s = this._maps[a], i = s.mapResult(e, r);
      if (i.recover != null) {
        let l = this.getMirror(a);
        if (l != null && l > a && l < this.to) {
          a = l, e = this._maps[l].recover(i.recover);
          continue;
        }
      }
      n |= i.delInfo, e = i.pos;
    }
    return t ? e : new Iu(e, n, null);
  }
}
const uc = /* @__PURE__ */ Object.create(null);
class uo {
  /**
  Get the step map that represents the changes made by this step,
  and which can be used to transform between positions in the old
  and the new document.
  */
  getMap() {
    return So.empty;
  }
  /**
  Try to merge this step with another one, to be applied directly
  after it. Returns the merged step when possible, null if the
  steps can't be merged.
  */
  merge(e) {
    return null;
  }
  /**
  Deserialize a step from its JSON representation. Will call
  through to the step class' own implementation of this method.
  */
  static fromJSON(e, r) {
    if (!r || !r.stepType)
      throw new RangeError("Invalid input for Step.fromJSON");
    let t = uc[r.stepType];
    if (!t)
      throw new RangeError(`No step type ${r.stepType} defined`);
    return t.fromJSON(e, r);
  }
  /**
  To be able to serialize steps to JSON, each step needs a string
  ID to attach to its JSON representation. Use this method to
  register an ID for your step classes. Try to pick something
  that's unlikely to clash with steps from other modules.
  */
  static jsonID(e, r) {
    if (e in uc)
      throw new RangeError("Duplicate use of step JSON ID " + e);
    return uc[e] = r, r.prototype.jsonID = e, r;
  }
}
class He {
  /**
  @internal
  */
  constructor(e, r) {
    this.doc = e, this.failed = r;
  }
  /**
  Create a successful step result.
  */
  static ok(e) {
    return new He(e, null);
  }
  /**
  Create a failed step result.
  */
  static fail(e) {
    return new He(null, e);
  }
  /**
  Call [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) with the given
  arguments. Create a successful result if it succeeds, and a
  failed one if it throws a `ReplaceError`.
  */
  static fromReplace(e, r, t, n) {
    try {
      return He.ok(e.replace(r, t, n));
    } catch (a) {
      if (a instanceof ai)
        return He.fail(a.message);
      throw a;
    }
  }
}
function Zp(o, e, r) {
  let t = [];
  for (let n = 0; n < o.childCount; n++) {
    let a = o.child(n);
    a.content.size && (a = a.copy(Zp(a.content, e, a))), a.isInline && (a = e(a, r, n)), t.push(a);
  }
  return $.fromArray(t);
}
class Lr extends uo {
  /**
  Create a mark step.
  */
  constructor(e, r, t) {
    super(), this.from = e, this.to = r, this.mark = t;
  }
  apply(e) {
    let r = e.slice(this.from, this.to), t = e.resolve(this.from), n = t.node(t.sharedDepth(this.to)), a = new te(Zp(r.content, (s, i) => !s.isAtom || !i.type.allowsMarkType(this.mark.type) ? s : s.mark(this.mark.addToSet(s.marks)), n), r.openStart, r.openEnd);
    return He.fromReplace(e, this.from, this.to, a);
  }
  invert() {
    return new Yo(this.from, this.to, this.mark);
  }
  map(e) {
    let r = e.mapResult(this.from, 1), t = e.mapResult(this.to, -1);
    return r.deleted && t.deleted || r.pos >= t.pos ? null : new Lr(r.pos, t.pos, this.mark);
  }
  merge(e) {
    return e instanceof Lr && e.mark.eq(this.mark) && this.from <= e.to && this.to >= e.from ? new Lr(Math.min(this.from, e.from), Math.max(this.to, e.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "addMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(e, r) {
    if (typeof r.from != "number" || typeof r.to != "number")
      throw new RangeError("Invalid input for AddMarkStep.fromJSON");
    return new Lr(r.from, r.to, e.markFromJSON(r.mark));
  }
}
uo.jsonID("addMark", Lr);
class Yo extends uo {
  /**
  Create a mark-removing step.
  */
  constructor(e, r, t) {
    super(), this.from = e, this.to = r, this.mark = t;
  }
  apply(e) {
    let r = e.slice(this.from, this.to), t = new te(Zp(r.content, (n) => n.mark(this.mark.removeFromSet(n.marks)), e), r.openStart, r.openEnd);
    return He.fromReplace(e, this.from, this.to, t);
  }
  invert() {
    return new Lr(this.from, this.to, this.mark);
  }
  map(e) {
    let r = e.mapResult(this.from, 1), t = e.mapResult(this.to, -1);
    return r.deleted && t.deleted || r.pos >= t.pos ? null : new Yo(r.pos, t.pos, this.mark);
  }
  merge(e) {
    return e instanceof Yo && e.mark.eq(this.mark) && this.from <= e.to && this.to >= e.from ? new Yo(Math.min(this.from, e.from), Math.max(this.to, e.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "removeMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(e, r) {
    if (typeof r.from != "number" || typeof r.to != "number")
      throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
    return new Yo(r.from, r.to, e.markFromJSON(r.mark));
  }
}
uo.jsonID("removeMark", Yo);
class jr extends uo {
  /**
  Create a node mark step.
  */
  constructor(e, r) {
    super(), this.pos = e, this.mark = r;
  }
  apply(e) {
    let r = e.nodeAt(this.pos);
    if (!r)
      return He.fail("No node at mark step's position");
    let t = r.type.create(r.attrs, null, this.mark.addToSet(r.marks));
    return He.fromReplace(e, this.pos, this.pos + 1, new te($.from(t), 0, r.isLeaf ? 0 : 1));
  }
  invert(e) {
    let r = e.nodeAt(this.pos);
    if (r) {
      let t = this.mark.addToSet(r.marks);
      if (t.length == r.marks.length) {
        for (let n = 0; n < r.marks.length; n++)
          if (!r.marks[n].isInSet(t))
            return new jr(this.pos, r.marks[n]);
        return new jr(this.pos, this.mark);
      }
    }
    return new Qt(this.pos, this.mark);
  }
  map(e) {
    let r = e.mapResult(this.pos, 1);
    return r.deletedAfter ? null : new jr(r.pos, this.mark);
  }
  toJSON() {
    return { stepType: "addNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(e, r) {
    if (typeof r.pos != "number")
      throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
    return new jr(r.pos, e.markFromJSON(r.mark));
  }
}
uo.jsonID("addNodeMark", jr);
class Qt extends uo {
  /**
  Create a mark-removing step.
  */
  constructor(e, r) {
    super(), this.pos = e, this.mark = r;
  }
  apply(e) {
    let r = e.nodeAt(this.pos);
    if (!r)
      return He.fail("No node at mark step's position");
    let t = r.type.create(r.attrs, null, this.mark.removeFromSet(r.marks));
    return He.fromReplace(e, this.pos, this.pos + 1, new te($.from(t), 0, r.isLeaf ? 0 : 1));
  }
  invert(e) {
    let r = e.nodeAt(this.pos);
    return !r || !this.mark.isInSet(r.marks) ? this : new jr(this.pos, this.mark);
  }
  map(e) {
    let r = e.mapResult(this.pos, 1);
    return r.deletedAfter ? null : new Qt(r.pos, this.mark);
  }
  toJSON() {
    return { stepType: "removeNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(e, r) {
    if (typeof r.pos != "number")
      throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
    return new Qt(r.pos, e.markFromJSON(r.mark));
  }
}
uo.jsonID("removeNodeMark", Qt);
class Ke extends uo {
  /**
  The given `slice` should fit the 'gap' between `from` and
  `to`—the depths must line up, and the surrounding nodes must be
  able to be joined with the open sides of the slice. When
  `structure` is true, the step will fail if the content between
  from and to is not just a sequence of closing and then opening
  tokens (this is to guard against rebased replace steps
  overwriting something they weren't supposed to).
  */
  constructor(e, r, t, n = !1) {
    super(), this.from = e, this.to = r, this.slice = t, this.structure = n;
  }
  apply(e) {
    return this.structure && Ru(e, this.from, this.to) ? He.fail("Structure replace would overwrite content") : He.fromReplace(e, this.from, this.to, this.slice);
  }
  getMap() {
    return new So([this.from, this.to - this.from, this.slice.size]);
  }
  invert(e) {
    return new Ke(this.from, this.from + this.slice.size, e.slice(this.from, this.to));
  }
  map(e) {
    let r = e.mapResult(this.from, 1), t = e.mapResult(this.to, -1);
    return r.deletedAcross && t.deletedAcross ? null : new Ke(r.pos, Math.max(r.pos, t.pos), this.slice);
  }
  merge(e) {
    if (!(e instanceof Ke) || e.structure || this.structure)
      return null;
    if (this.from + this.slice.size == e.from && !this.slice.openEnd && !e.slice.openStart) {
      let r = this.slice.size + e.slice.size == 0 ? te.empty : new te(this.slice.content.append(e.slice.content), this.slice.openStart, e.slice.openEnd);
      return new Ke(this.from, this.to + (e.to - e.from), r, this.structure);
    } else if (e.to == this.from && !this.slice.openStart && !e.slice.openEnd) {
      let r = this.slice.size + e.slice.size == 0 ? te.empty : new te(e.slice.content.append(this.slice.content), e.slice.openStart, this.slice.openEnd);
      return new Ke(e.from, this.to, r, this.structure);
    } else
      return null;
  }
  toJSON() {
    let e = { stepType: "replace", from: this.from, to: this.to };
    return this.slice.size && (e.slice = this.slice.toJSON()), this.structure && (e.structure = !0), e;
  }
  /**
  @internal
  */
  static fromJSON(e, r) {
    if (typeof r.from != "number" || typeof r.to != "number")
      throw new RangeError("Invalid input for ReplaceStep.fromJSON");
    return new Ke(r.from, r.to, te.fromJSON(e, r.slice), !!r.structure);
  }
}
uo.jsonID("replace", Ke);
class Je extends uo {
  /**
  Create a replace-around step with the given range and gap.
  `insert` should be the point in the slice into which the content
  of the gap should be moved. `structure` has the same meaning as
  it has in the [`ReplaceStep`](https://prosemirror.net/docs/ref/#transform.ReplaceStep) class.
  */
  constructor(e, r, t, n, a, s, i = !1) {
    super(), this.from = e, this.to = r, this.gapFrom = t, this.gapTo = n, this.slice = a, this.insert = s, this.structure = i;
  }
  apply(e) {
    if (this.structure && (Ru(e, this.from, this.gapFrom) || Ru(e, this.gapTo, this.to)))
      return He.fail("Structure gap-replace would overwrite content");
    let r = e.slice(this.gapFrom, this.gapTo);
    if (r.openStart || r.openEnd)
      return He.fail("Gap is not a flat range");
    let t = this.slice.insertAt(this.insert, r.content);
    return t ? He.fromReplace(e, this.from, this.to, t) : He.fail("Content does not fit in gap");
  }
  getMap() {
    return new So([
      this.from,
      this.gapFrom - this.from,
      this.insert,
      this.gapTo,
      this.to - this.gapTo,
      this.slice.size - this.insert
    ]);
  }
  invert(e) {
    let r = this.gapTo - this.gapFrom;
    return new Je(this.from, this.from + this.slice.size + r, this.from + this.insert, this.from + this.insert + r, e.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
  }
  map(e) {
    let r = e.mapResult(this.from, 1), t = e.mapResult(this.to, -1), n = this.from == this.gapFrom ? r.pos : e.map(this.gapFrom, -1), a = this.to == this.gapTo ? t.pos : e.map(this.gapTo, 1);
    return r.deletedAcross && t.deletedAcross || n < r.pos || a > t.pos ? null : new Je(r.pos, t.pos, n, a, this.slice, this.insert, this.structure);
  }
  toJSON() {
    let e = {
      stepType: "replaceAround",
      from: this.from,
      to: this.to,
      gapFrom: this.gapFrom,
      gapTo: this.gapTo,
      insert: this.insert
    };
    return this.slice.size && (e.slice = this.slice.toJSON()), this.structure && (e.structure = !0), e;
  }
  /**
  @internal
  */
  static fromJSON(e, r) {
    if (typeof r.from != "number" || typeof r.to != "number" || typeof r.gapFrom != "number" || typeof r.gapTo != "number" || typeof r.insert != "number")
      throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
    return new Je(r.from, r.to, r.gapFrom, r.gapTo, te.fromJSON(e, r.slice), r.insert, !!r.structure);
  }
}
uo.jsonID("replaceAround", Je);
function Ru(o, e, r) {
  let t = o.resolve(e), n = r - e, a = t.depth;
  for (; n > 0 && a > 0 && t.indexAfter(a) == t.node(a).childCount; )
    a--, n--;
  if (n > 0) {
    let s = t.node(a).maybeChild(t.indexAfter(a));
    for (; n > 0; ) {
      if (!s || s.isLeaf)
        return !0;
      s = s.firstChild, n--;
    }
  }
  return !1;
}
function Nx(o, e, r, t) {
  let n = [], a = [], s, i;
  o.doc.nodesBetween(e, r, (l, c, u) => {
    if (!l.isInline)
      return;
    let f = l.marks;
    if (!t.isInSet(f) && u.type.allowsMarkType(t.type)) {
      let g = Math.max(c, e), d = Math.min(c + l.nodeSize, r), p = t.addToSet(f);
      for (let m = 0; m < f.length; m++)
        f[m].isInSet(p) || (s && s.to == g && s.mark.eq(f[m]) ? s.to = d : n.push(s = new Yo(g, d, f[m])));
      i && i.to == g ? i.to = d : a.push(i = new Lr(g, d, t));
    }
  }), n.forEach((l) => o.step(l)), a.forEach((l) => o.step(l));
}
function Vx(o, e, r, t) {
  let n = [], a = 0;
  o.doc.nodesBetween(e, r, (s, i) => {
    if (!s.isInline)
      return;
    a++;
    let l = null;
    if (t instanceof Vi) {
      let c = s.marks, u;
      for (; u = t.isInSet(c); )
        (l || (l = [])).push(u), c = u.removeFromSet(c);
    } else t ? t.isInSet(s.marks) && (l = [t]) : l = s.marks;
    if (l && l.length) {
      let c = Math.min(i + s.nodeSize, r);
      for (let u = 0; u < l.length; u++) {
        let f = l[u], g;
        for (let d = 0; d < n.length; d++) {
          let p = n[d];
          p.step == a - 1 && f.eq(n[d].style) && (g = p);
        }
        g ? (g.to = c, g.step = a) : n.push({ style: f, from: Math.max(i, e), to: c, step: a });
      }
    }
  }), n.forEach((s) => o.step(new Yo(s.from, s.to, s.style)));
}
function Kp(o, e, r, t = r.contentMatch, n = !0) {
  let a = o.doc.nodeAt(e), s = [], i = e + 1;
  for (let l = 0; l < a.childCount; l++) {
    let c = a.child(l), u = i + c.nodeSize, f = t.matchType(c.type);
    if (!f)
      s.push(new Ke(i, u, te.empty));
    else {
      t = f;
      for (let g = 0; g < c.marks.length; g++)
        r.allowsMarkType(c.marks[g].type) || o.step(new Yo(i, u, c.marks[g]));
      if (n && c.isText && r.whitespace != "pre") {
        let g, d = /\r?\n|\r/g, p;
        for (; g = d.exec(c.text); )
          p || (p = new te($.from(r.schema.text(" ", r.allowedMarks(c.marks))), 0, 0)), s.push(new Ke(i + g.index, i + g.index + g[0].length, p));
      }
    }
    i = u;
  }
  if (!t.validEnd) {
    let l = t.fillBefore($.empty, !0);
    o.replace(i, i, new te(l, 0, 0));
  }
  for (let l = s.length - 1; l >= 0; l--)
    o.step(s[l]);
}
function zx(o, e, r) {
  return (e == 0 || o.canReplace(e, o.childCount)) && (r == o.childCount || o.canReplace(0, r));
}
function nn(o) {
  let r = o.parent.content.cutByIndex(o.startIndex, o.endIndex);
  for (let t = o.depth; ; --t) {
    let n = o.$from.node(t), a = o.$from.index(t), s = o.$to.indexAfter(t);
    if (t < o.depth && n.canReplace(a, s, r))
      return t;
    if (t == 0 || n.type.spec.isolating || !zx(n, a, s))
      break;
  }
  return null;
}
function Ix(o, e, r) {
  let { $from: t, $to: n, depth: a } = e, s = t.before(a + 1), i = n.after(a + 1), l = s, c = i, u = $.empty, f = 0;
  for (let p = a, m = !1; p > r; p--)
    m || t.index(p) > 0 ? (m = !0, u = $.from(t.node(p).copy(u)), f++) : l--;
  let g = $.empty, d = 0;
  for (let p = a, m = !1; p > r; p--)
    m || n.after(p + 1) < n.end(p) ? (m = !0, g = $.from(n.node(p).copy(g)), d++) : c++;
  o.step(new Je(l, c, s, i, new te(u.append(g), f, d), u.size - f, !0));
}
function S0(o, e, r = null, t = o) {
  let n = Rx(o, e), a = n && Hx(t, e);
  return a ? n.map(_f).concat({ type: e, attrs: r }).concat(a.map(_f)) : null;
}
function _f(o) {
  return { type: o, attrs: null };
}
function Rx(o, e) {
  let { parent: r, startIndex: t, endIndex: n } = o, a = r.contentMatchAt(t).findWrapping(e);
  if (!a)
    return null;
  let s = a.length ? a[0] : e;
  return r.canReplaceWith(t, n, s) ? a : null;
}
function Hx(o, e) {
  let { parent: r, startIndex: t, endIndex: n } = o, a = r.child(t), s = e.contentMatch.findWrapping(a.type);
  if (!s)
    return null;
  let l = (s.length ? s[s.length - 1] : e).contentMatch;
  for (let c = t; l && c < n; c++)
    l = l.matchType(r.child(c).type);
  return !l || !l.validEnd ? null : s;
}
function Yx(o, e, r) {
  let t = $.empty;
  for (let s = r.length - 1; s >= 0; s--) {
    if (t.size) {
      let i = r[s].type.contentMatch.matchFragment(t);
      if (!i || !i.validEnd)
        throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
    }
    t = $.from(r[s].type.create(r[s].attrs, t));
  }
  let n = e.start, a = e.end;
  o.step(new Je(n, a, n, a, new te(t, 0, 0), r.length, !0));
}
function qx(o, e, r, t, n) {
  if (!t.isTextblock)
    throw new RangeError("Type given to setBlockType should be a textblock");
  let a = o.steps.length;
  o.doc.nodesBetween(e, r, (s, i) => {
    let l = typeof n == "function" ? n(s) : n;
    if (s.isTextblock && !s.hasMarkup(t, l) && Gx(o.doc, o.mapping.slice(a).map(i), t)) {
      let c = null;
      if (t.schema.linebreakReplacement) {
        let d = t.whitespace == "pre", p = !!t.contentMatch.matchType(t.schema.linebreakReplacement);
        d && !p ? c = !1 : !d && p && (c = !0);
      }
      c === !1 && E0(o, s, i, a), Kp(o, o.mapping.slice(a).map(i, 1), t, void 0, c === null);
      let u = o.mapping.slice(a), f = u.map(i, 1), g = u.map(i + s.nodeSize, 1);
      return o.step(new Je(f, g, f + 1, g - 1, new te($.from(t.create(l, null, s.marks)), 0, 0), 1, !0)), c === !0 && A0(o, s, i, a), !1;
    }
  });
}
function A0(o, e, r, t) {
  e.forEach((n, a) => {
    if (n.isText) {
      let s, i = /\r?\n|\r/g;
      for (; s = i.exec(n.text); ) {
        let l = o.mapping.slice(t).map(r + 1 + a + s.index);
        o.replaceWith(l, l + 1, e.type.schema.linebreakReplacement.create());
      }
    }
  });
}
function E0(o, e, r, t) {
  e.forEach((n, a) => {
    if (n.type == n.type.schema.linebreakReplacement) {
      let s = o.mapping.slice(t).map(r + 1 + a);
      o.replaceWith(s, s + 1, e.type.schema.text(`
`));
    }
  });
}
function Gx(o, e, r) {
  let t = o.resolve(e), n = t.index();
  return t.parent.canReplaceWith(n, n + 1, r);
}
function Xx(o, e, r, t, n) {
  let a = o.doc.nodeAt(e);
  if (!a)
    throw new RangeError("No node at given position");
  r || (r = a.type);
  let s = r.create(t, null, n || a.marks);
  if (a.isLeaf)
    return o.replaceWith(e, e + a.nodeSize, s);
  if (!r.validContent(a.content))
    throw new RangeError("Invalid content for node type " + r.name);
  o.step(new Je(e, e + a.nodeSize, e + 1, e + a.nodeSize - 1, new te($.from(s), 0, 0), 1, !0));
}
function pr(o, e, r = 1, t) {
  let n = o.resolve(e), a = n.depth - r, s = t && t[t.length - 1] || n.parent;
  if (a < 0 || n.parent.type.spec.isolating || !n.parent.canReplace(n.index(), n.parent.childCount) || !s.type.validContent(n.parent.content.cutByIndex(n.index(), n.parent.childCount)))
    return !1;
  for (let c = n.depth - 1, u = r - 2; c > a; c--, u--) {
    let f = n.node(c), g = n.index(c);
    if (f.type.spec.isolating)
      return !1;
    let d = f.content.cutByIndex(g, f.childCount), p = t && t[u + 1];
    p && (d = d.replaceChild(0, p.type.create(p.attrs)));
    let m = t && t[u] || f;
    if (!f.canReplace(g + 1, f.childCount) || !m.type.validContent(d))
      return !1;
  }
  let i = n.indexAfter(a), l = t && t[0];
  return n.node(a).canReplaceWith(i, i, l ? l.type : n.node(a + 1).type);
}
function Ux(o, e, r = 1, t) {
  let n = o.doc.resolve(e), a = $.empty, s = $.empty;
  for (let i = n.depth, l = n.depth - r, c = r - 1; i > l; i--, c--) {
    a = $.from(n.node(i).copy(a));
    let u = t && t[c];
    s = $.from(u ? u.type.create(u.attrs, s) : n.node(i).copy(s));
  }
  o.step(new Ke(e, e, new te(a.append(s), r, r), !0));
}
function Ft(o, e) {
  let r = o.resolve(e), t = r.index();
  return x0(r.nodeBefore, r.nodeAfter) && r.parent.canReplace(t, t + 1);
}
function Zx(o, e) {
  e.content.size || o.type.compatibleContent(e.type);
  let r = o.contentMatchAt(o.childCount), { linebreakReplacement: t } = o.type.schema;
  for (let n = 0; n < e.childCount; n++) {
    let a = e.child(n), s = a.type == t ? o.type.schema.nodes.text : a.type;
    if (r = r.matchType(s), !r || !o.type.allowsMarks(a.marks))
      return !1;
  }
  return r.validEnd;
}
function x0(o, e) {
  return !!(o && e && !o.isLeaf && Zx(o, e));
}
function Ii(o, e, r = -1) {
  let t = o.resolve(e);
  for (let n = t.depth; ; n--) {
    let a, s, i = t.index(n);
    if (n == t.depth ? (a = t.nodeBefore, s = t.nodeAfter) : r > 0 ? (a = t.node(n + 1), i++, s = t.node(n).maybeChild(i)) : (a = t.node(n).maybeChild(i - 1), s = t.node(n + 1)), a && !a.isTextblock && x0(a, s) && t.node(n).canReplace(i, i + 1))
      return e;
    if (n == 0)
      break;
    e = r < 0 ? t.before(n) : t.after(n);
  }
}
function Kx(o, e, r) {
  let t = null, { linebreakReplacement: n } = o.doc.type.schema, a = o.doc.resolve(e - r), s = a.node().type;
  if (n && s.inlineContent) {
    let u = s.whitespace == "pre", f = !!s.contentMatch.matchType(n);
    u && !f ? t = !1 : !u && f && (t = !0);
  }
  let i = o.steps.length;
  if (t === !1) {
    let u = o.doc.resolve(e + r);
    E0(o, u.node(), u.before(), i);
  }
  s.inlineContent && Kp(o, e + r - 1, s, a.node().contentMatchAt(a.index()), t == null);
  let l = o.mapping.slice(i), c = l.map(e - r);
  if (o.step(new Ke(c, l.map(e + r, -1), te.empty, !0)), t === !0) {
    let u = o.doc.resolve(c);
    A0(o, u.node(), u.before(), o.steps.length);
  }
  return o;
}
function Qx(o, e, r) {
  let t = o.resolve(e);
  if (t.parent.canReplaceWith(t.index(), t.index(), r))
    return e;
  if (t.parentOffset == 0)
    for (let n = t.depth - 1; n >= 0; n--) {
      let a = t.index(n);
      if (t.node(n).canReplaceWith(a, a, r))
        return t.before(n + 1);
      if (a > 0)
        return null;
    }
  if (t.parentOffset == t.parent.content.size)
    for (let n = t.depth - 1; n >= 0; n--) {
      let a = t.indexAfter(n);
      if (t.node(n).canReplaceWith(a, a, r))
        return t.after(n + 1);
      if (a < t.node(n).childCount)
        return null;
    }
  return null;
}
function Jx(o, e, r) {
  let t = o.resolve(e);
  if (!r.content.size)
    return e;
  let n = r.content;
  for (let a = 0; a < r.openStart; a++)
    n = n.firstChild.content;
  for (let a = 1; a <= (r.openStart == 0 && r.size ? 2 : 1); a++)
    for (let s = t.depth; s >= 0; s--) {
      let i = s == t.depth ? 0 : t.pos <= (t.start(s + 1) + t.end(s + 1)) / 2 ? -1 : 1, l = t.index(s) + (i > 0 ? 1 : 0), c = t.node(s), u = !1;
      if (a == 1)
        u = c.canReplace(l, l, n);
      else {
        let f = c.contentMatchAt(l).findWrapping(n.firstChild.type);
        u = f && c.canReplaceWith(l, l, f[0]);
      }
      if (u)
        return i == 0 ? t.pos : i < 0 ? t.before(s + 1) : t.after(s + 1);
    }
  return null;
}
function Ri(o, e, r = e, t = te.empty) {
  if (e == r && !t.size)
    return null;
  let n = o.resolve(e), a = o.resolve(r);
  return C0(n, a, t) ? new Ke(e, r, t) : new _x(n, a, t).fit();
}
function C0(o, e, r) {
  return !r.openStart && !r.openEnd && o.start() == e.start() && o.parent.canReplace(o.index(), e.index(), r.content);
}
class _x {
  constructor(e, r, t) {
    this.$from = e, this.$to = r, this.unplaced = t, this.frontier = [], this.placed = $.empty;
    for (let n = 0; n <= e.depth; n++) {
      let a = e.node(n);
      this.frontier.push({
        type: a.type,
        match: a.contentMatchAt(e.indexAfter(n))
      });
    }
    for (let n = e.depth; n > 0; n--)
      this.placed = $.from(e.node(n).copy(this.placed));
  }
  get depth() {
    return this.frontier.length - 1;
  }
  fit() {
    for (; this.unplaced.size; ) {
      let c = this.findFittable();
      c ? this.placeNodes(c) : this.openMore() || this.dropNode();
    }
    let e = this.mustMoveInline(), r = this.placed.size - this.depth - this.$from.depth, t = this.$from, n = this.close(e < 0 ? this.$to : t.doc.resolve(e));
    if (!n)
      return null;
    let a = this.placed, s = t.depth, i = n.depth;
    for (; s && i && a.childCount == 1; )
      a = a.firstChild.content, s--, i--;
    let l = new te(a, s, i);
    return e > -1 ? new Je(t.pos, e, this.$to.pos, this.$to.end(), l, r) : l.size || t.pos != this.$to.pos ? new Ke(t.pos, n.pos, l) : null;
  }
  // Find a position on the start spine of `this.unplaced` that has
  // content that can be moved somewhere on the frontier. Returns two
  // depths, one for the slice and one for the frontier.
  findFittable() {
    let e = this.unplaced.openStart;
    for (let r = this.unplaced.content, t = 0, n = this.unplaced.openEnd; t < e; t++) {
      let a = r.firstChild;
      if (r.childCount > 1 && (n = 0), a.type.spec.isolating && n <= t) {
        e = t;
        break;
      }
      r = a.content;
    }
    for (let r = 1; r <= 2; r++)
      for (let t = r == 1 ? e : this.unplaced.openStart; t >= 0; t--) {
        let n, a = null;
        t ? (a = pc(this.unplaced.content, t - 1).firstChild, n = a.content) : n = this.unplaced.content;
        let s = n.firstChild;
        for (let i = this.depth; i >= 0; i--) {
          let { type: l, match: c } = this.frontier[i], u, f = null;
          if (r == 1 && (s ? c.matchType(s.type) || (f = c.fillBefore($.from(s), !1)) : a && l.compatibleContent(a.type)))
            return { sliceDepth: t, frontierDepth: i, parent: a, inject: f };
          if (r == 2 && s && (u = c.findWrapping(s.type)))
            return { sliceDepth: t, frontierDepth: i, parent: a, wrap: u };
          if (a && c.matchType(a.type))
            break;
        }
      }
  }
  openMore() {
    let { content: e, openStart: r, openEnd: t } = this.unplaced, n = pc(e, r);
    return !n.childCount || n.firstChild.isLeaf ? !1 : (this.unplaced = new te(e, r + 1, Math.max(t, n.size + r >= e.size - t ? r + 1 : 0)), !0);
  }
  dropNode() {
    let { content: e, openStart: r, openEnd: t } = this.unplaced, n = pc(e, r);
    if (n.childCount <= 1 && r > 0) {
      let a = e.size - r <= r + n.size;
      this.unplaced = new te(Pn(e, r - 1, 1), r - 1, a ? r - 1 : t);
    } else
      this.unplaced = new te(Pn(e, r, 1), r, t);
  }
  // Move content from the unplaced slice at `sliceDepth` to the
  // frontier node at `frontierDepth`. Close that frontier node when
  // applicable.
  placeNodes({ sliceDepth: e, frontierDepth: r, parent: t, inject: n, wrap: a }) {
    for (; this.depth > r; )
      this.closeFrontierNode();
    if (a)
      for (let m = 0; m < a.length; m++)
        this.openFrontierNode(a[m]);
    let s = this.unplaced, i = t ? t.content : s.content, l = s.openStart - e, c = 0, u = [], { match: f, type: g } = this.frontier[r];
    if (n) {
      for (let m = 0; m < n.childCount; m++)
        u.push(n.child(m));
      f = f.matchFragment(n);
    }
    let d = i.size + e - (s.content.size - s.openEnd);
    for (; c < i.childCount; ) {
      let m = i.child(c), y = f.matchType(m.type);
      if (!y)
        break;
      c++, (c > 1 || l == 0 || m.content.size) && (f = y, u.push(O0(m.mark(g.allowedMarks(m.marks)), c == 1 ? l : 0, c == i.childCount ? d : -1)));
    }
    let p = c == i.childCount;
    p || (d = -1), this.placed = wn(this.placed, r, $.from(u)), this.frontier[r].match = f, p && d < 0 && t && t.type == this.frontier[this.depth].type && this.frontier.length > 1 && this.closeFrontierNode();
    for (let m = 0, y = i; m < d; m++) {
      let h = y.lastChild;
      this.frontier.push({ type: h.type, match: h.contentMatchAt(h.childCount) }), y = h.content;
    }
    this.unplaced = p ? e == 0 ? te.empty : new te(Pn(s.content, e - 1, 1), e - 1, d < 0 ? s.openEnd : e - 1) : new te(Pn(s.content, e, c), s.openStart, s.openEnd);
  }
  mustMoveInline() {
    if (!this.$to.parent.isTextblock)
      return -1;
    let e = this.frontier[this.depth], r;
    if (!e.type.isTextblock || !dc(this.$to, this.$to.depth, e.type, e.match, !1) || this.$to.depth == this.depth && (r = this.findCloseLevel(this.$to)) && r.depth == this.depth)
      return -1;
    let { depth: t } = this.$to, n = this.$to.after(t);
    for (; t > 1 && n == this.$to.end(--t); )
      ++n;
    return n;
  }
  findCloseLevel(e) {
    e: for (let r = Math.min(this.depth, e.depth); r >= 0; r--) {
      let { match: t, type: n } = this.frontier[r], a = r < e.depth && e.end(r + 1) == e.pos + (e.depth - (r + 1)), s = dc(e, r, n, t, a);
      if (s) {
        for (let i = r - 1; i >= 0; i--) {
          let { match: l, type: c } = this.frontier[i], u = dc(e, i, c, l, !0);
          if (!u || u.childCount)
            continue e;
        }
        return { depth: r, fit: s, move: a ? e.doc.resolve(e.after(r + 1)) : e };
      }
    }
  }
  close(e) {
    let r = this.findCloseLevel(e);
    if (!r)
      return null;
    for (; this.depth > r.depth; )
      this.closeFrontierNode();
    r.fit.childCount && (this.placed = wn(this.placed, r.depth, r.fit)), e = r.move;
    for (let t = r.depth + 1; t <= e.depth; t++) {
      let n = e.node(t), a = n.type.contentMatch.fillBefore(n.content, !0, e.index(t));
      this.openFrontierNode(n.type, n.attrs, a);
    }
    return e;
  }
  openFrontierNode(e, r = null, t) {
    let n = this.frontier[this.depth];
    n.match = n.match.matchType(e), this.placed = wn(this.placed, this.depth, $.from(e.create(r, t))), this.frontier.push({ type: e, match: e.contentMatch });
  }
  closeFrontierNode() {
    let r = this.frontier.pop().match.fillBefore($.empty, !0);
    r.childCount && (this.placed = wn(this.placed, this.frontier.length, r));
  }
}
function Pn(o, e, r) {
  return e == 0 ? o.cutByIndex(r, o.childCount) : o.replaceChild(0, o.firstChild.copy(Pn(o.firstChild.content, e - 1, r)));
}
function wn(o, e, r) {
  return e == 0 ? o.append(r) : o.replaceChild(o.childCount - 1, o.lastChild.copy(wn(o.lastChild.content, e - 1, r)));
}
function pc(o, e) {
  for (let r = 0; r < e; r++)
    o = o.firstChild.content;
  return o;
}
function O0(o, e, r) {
  if (e <= 0)
    return o;
  let t = o.content;
  return e > 1 && (t = t.replaceChild(0, O0(t.firstChild, e - 1, t.childCount == 1 ? r - 1 : 0))), e > 0 && (t = o.type.contentMatch.fillBefore(t).append(t), r <= 0 && (t = t.append(o.type.contentMatch.matchFragment(t).fillBefore($.empty, !0)))), o.copy(t);
}
function dc(o, e, r, t, n) {
  let a = o.node(e), s = n ? o.indexAfter(e) : o.index(e);
  if (s == a.childCount && !r.compatibleContent(a.type))
    return null;
  let i = t.fillBefore(a.content, !0, s);
  return i && !$x(r, a.content, s) ? i : null;
}
function $x(o, e, r) {
  for (let t = r; t < e.childCount; t++)
    if (!o.allowsMarks(e.child(t).marks))
      return !0;
  return !1;
}
function eC(o) {
  return o.spec.defining || o.spec.definingForContent;
}
function oC(o, e, r, t) {
  if (!t.size)
    return o.deleteRange(e, r);
  let n = o.doc.resolve(e), a = o.doc.resolve(r);
  if (C0(n, a, t))
    return o.step(new Ke(e, r, t));
  let s = L0(n, o.doc.resolve(r));
  s[s.length - 1] == 0 && s.pop();
  let i = -(n.depth + 1);
  s.unshift(i);
  for (let g = n.depth, d = n.pos - 1; g > 0; g--, d--) {
    let p = n.node(g).type.spec;
    if (p.defining || p.definingAsContext || p.isolating)
      break;
    s.indexOf(g) > -1 ? i = g : n.before(g) == d && s.splice(1, 0, -g);
  }
  let l = s.indexOf(i), c = [], u = t.openStart;
  for (let g = t.content, d = 0; ; d++) {
    let p = g.firstChild;
    if (c.push(p), d == t.openStart)
      break;
    g = p.content;
  }
  for (let g = u - 1; g >= 0; g--) {
    let d = c[g], p = eC(d.type);
    if (p && !d.sameMarkup(n.node(Math.abs(i) - 1)))
      u = g;
    else if (p || !d.type.isTextblock)
      break;
  }
  for (let g = t.openStart; g >= 0; g--) {
    let d = (g + u + 1) % (t.openStart + 1), p = c[d];
    if (p)
      for (let m = 0; m < s.length; m++) {
        let y = s[(m + l) % s.length], h = !0;
        y < 0 && (h = !1, y = -y);
        let F = n.node(y - 1), b = n.index(y - 1);
        if (F.canReplaceWith(b, b, p.type, p.marks))
          return o.replace(n.before(y), h ? a.after(y) : r, new te(T0(t.content, 0, t.openStart, d), d, t.openEnd));
      }
  }
  let f = o.steps.length;
  for (let g = s.length - 1; g >= 0 && (o.replace(e, r, t), !(o.steps.length > f)); g--) {
    let d = s[g];
    d < 0 || (e = n.before(d), r = a.after(d));
  }
}
function T0(o, e, r, t, n) {
  if (e < r) {
    let a = o.firstChild;
    o = o.replaceChild(0, a.copy(T0(a.content, e + 1, r, t, a)));
  }
  if (e > t) {
    let a = n.contentMatchAt(0), s = a.fillBefore(o).append(o);
    o = s.append(a.matchFragment(s).fillBefore($.empty, !0));
  }
  return o;
}
function rC(o, e, r, t) {
  if (!t.isInline && e == r && o.doc.resolve(e).parent.content.size) {
    let n = Qx(o.doc, e, t.type);
    n != null && (e = r = n);
  }
  o.replaceRange(e, r, new te($.from(t), 0, 0));
}
function tC(o, e, r) {
  let t = o.doc.resolve(e), n = o.doc.resolve(r), a = L0(t, n);
  for (let s = 0; s < a.length; s++) {
    let i = a[s], l = s == a.length - 1;
    if (l && i == 0 || t.node(i).type.contentMatch.validEnd)
      return o.delete(t.start(i), n.end(i));
    if (i > 0 && (l || t.node(i - 1).canReplace(t.index(i - 1), n.indexAfter(i - 1))))
      return o.delete(t.before(i), n.after(i));
  }
  for (let s = 1; s <= t.depth && s <= n.depth; s++)
    if (e - t.start(s) == t.depth - s && r > t.end(s) && n.end(s) - r != n.depth - s && t.start(s - 1) == n.start(s - 1) && t.node(s - 1).canReplace(t.index(s - 1), n.index(s - 1)))
      return o.delete(t.before(s), r);
  o.delete(e, r);
}
function L0(o, e) {
  let r = [], t = Math.min(o.depth, e.depth);
  for (let n = t; n >= 0; n--) {
    let a = o.start(n);
    if (a < o.pos - (o.depth - n) || e.end(n) > e.pos + (e.depth - n) || o.node(n).type.spec.isolating || e.node(n).type.spec.isolating)
      break;
    (a == e.start(n) || n == o.depth && n == e.depth && o.parent.inlineContent && e.parent.inlineContent && n && e.start(n - 1) == a - 1) && r.push(n);
  }
  return r;
}
class It extends uo {
  /**
  Construct an attribute step.
  */
  constructor(e, r, t) {
    super(), this.pos = e, this.attr = r, this.value = t;
  }
  apply(e) {
    let r = e.nodeAt(this.pos);
    if (!r)
      return He.fail("No node at attribute step's position");
    let t = /* @__PURE__ */ Object.create(null);
    for (let a in r.attrs)
      t[a] = r.attrs[a];
    t[this.attr] = this.value;
    let n = r.type.create(t, null, r.marks);
    return He.fromReplace(e, this.pos, this.pos + 1, new te($.from(n), 0, r.isLeaf ? 0 : 1));
  }
  getMap() {
    return So.empty;
  }
  invert(e) {
    return new It(this.pos, this.attr, e.nodeAt(this.pos).attrs[this.attr]);
  }
  map(e) {
    let r = e.mapResult(this.pos, 1);
    return r.deletedAfter ? null : new It(r.pos, this.attr, this.value);
  }
  toJSON() {
    return { stepType: "attr", pos: this.pos, attr: this.attr, value: this.value };
  }
  static fromJSON(e, r) {
    if (typeof r.pos != "number" || typeof r.attr != "string")
      throw new RangeError("Invalid input for AttrStep.fromJSON");
    return new It(r.pos, r.attr, r.value);
  }
}
uo.jsonID("attr", It);
class Oa extends uo {
  /**
  Construct an attribute step.
  */
  constructor(e, r) {
    super(), this.attr = e, this.value = r;
  }
  apply(e) {
    let r = /* @__PURE__ */ Object.create(null);
    for (let n in e.attrs)
      r[n] = e.attrs[n];
    r[this.attr] = this.value;
    let t = e.type.create(r, e.content, e.marks);
    return He.ok(t);
  }
  getMap() {
    return So.empty;
  }
  invert(e) {
    return new Oa(this.attr, e.attrs[this.attr]);
  }
  map(e) {
    return this;
  }
  toJSON() {
    return { stepType: "docAttr", attr: this.attr, value: this.value };
  }
  static fromJSON(e, r) {
    if (typeof r.attr != "string")
      throw new RangeError("Invalid input for DocAttrStep.fromJSON");
    return new Oa(r.attr, r.value);
  }
}
uo.jsonID("docAttr", Oa);
let Jt = class extends Error {
};
Jt = function o(e) {
  let r = Error.call(this, e);
  return r.__proto__ = o.prototype, r;
};
Jt.prototype = Object.create(Error.prototype);
Jt.prototype.constructor = Jt;
Jt.prototype.name = "TransformError";
class nC {
  /**
  Create a transform that starts with the given document.
  */
  constructor(e) {
    this.doc = e, this.steps = [], this.docs = [], this.mapping = new ci();
  }
  /**
  The starting document.
  */
  get before() {
    return this.docs.length ? this.docs[0] : this.doc;
  }
  /**
  Apply a new step in this transform, saving the result. Throws an
  error when the step fails.
  */
  step(e) {
    let r = this.maybeStep(e);
    if (r.failed)
      throw new Jt(r.failed);
    return this;
  }
  /**
  Try to apply a step in this transformation, ignoring it if it
  fails. Returns the step result.
  */
  maybeStep(e) {
    let r = e.apply(this.doc);
    return r.failed || this.addStep(e, r.doc), r;
  }
  /**
  True when the document has been changed (when there are any
  steps).
  */
  get docChanged() {
    return this.steps.length > 0;
  }
  /**
  @internal
  */
  addStep(e, r) {
    this.docs.push(this.doc), this.steps.push(e), this.mapping.appendMap(e.getMap()), this.doc = r;
  }
  /**
  Replace the part of the document between `from` and `to` with the
  given `slice`.
  */
  replace(e, r = e, t = te.empty) {
    let n = Ri(this.doc, e, r, t);
    return n && this.step(n), this;
  }
  /**
  Replace the given range with the given content, which may be a
  fragment, node, or array of nodes.
  */
  replaceWith(e, r, t) {
    return this.replace(e, r, new te($.from(t), 0, 0));
  }
  /**
  Delete the content between the given positions.
  */
  delete(e, r) {
    return this.replace(e, r, te.empty);
  }
  /**
  Insert the given content at the given position.
  */
  insert(e, r) {
    return this.replaceWith(e, e, r);
  }
  /**
  Replace a range of the document with a given slice, using
  `from`, `to`, and the slice's
  [`openStart`](https://prosemirror.net/docs/ref/#model.Slice.openStart) property as hints, rather
  than fixed start and end points. This method may grow the
  replaced area or close open nodes in the slice in order to get a
  fit that is more in line with WYSIWYG expectations, by dropping
  fully covered parent nodes of the replaced region when they are
  marked [non-defining as
  context](https://prosemirror.net/docs/ref/#model.NodeSpec.definingAsContext), or including an
  open parent node from the slice that _is_ marked as [defining
  its content](https://prosemirror.net/docs/ref/#model.NodeSpec.definingForContent).
  
  This is the method, for example, to handle paste. The similar
  [`replace`](https://prosemirror.net/docs/ref/#transform.Transform.replace) method is a more
  primitive tool which will _not_ move the start and end of its given
  range, and is useful in situations where you need more precise
  control over what happens.
  */
  replaceRange(e, r, t) {
    return oC(this, e, r, t), this;
  }
  /**
  Replace the given range with a node, but use `from` and `to` as
  hints, rather than precise positions. When from and to are the same
  and are at the start or end of a parent node in which the given
  node doesn't fit, this method may _move_ them out towards a parent
  that does allow the given node to be placed. When the given range
  completely covers a parent node, this method may completely replace
  that parent node.
  */
  replaceRangeWith(e, r, t) {
    return rC(this, e, r, t), this;
  }
  /**
  Delete the given range, expanding it to cover fully covered
  parent nodes until a valid replace is found.
  */
  deleteRange(e, r) {
    return tC(this, e, r), this;
  }
  /**
  Split the content in the given range off from its parent, if there
  is sibling content before or after it, and move it up the tree to
  the depth specified by `target`. You'll probably want to use
  [`liftTarget`](https://prosemirror.net/docs/ref/#transform.liftTarget) to compute `target`, to make
  sure the lift is valid.
  */
  lift(e, r) {
    return Ix(this, e, r), this;
  }
  /**
  Join the blocks around the given position. If depth is 2, their
  last and first siblings are also joined, and so on.
  */
  join(e, r = 1) {
    return Kx(this, e, r), this;
  }
  /**
  Wrap the given [range](https://prosemirror.net/docs/ref/#model.NodeRange) in the given set of wrappers.
  The wrappers are assumed to be valid in this position, and should
  probably be computed with [`findWrapping`](https://prosemirror.net/docs/ref/#transform.findWrapping).
  */
  wrap(e, r) {
    return Yx(this, e, r), this;
  }
  /**
  Set the type of all textblocks (partly) between `from` and `to` to
  the given node type with the given attributes.
  */
  setBlockType(e, r = e, t, n = null) {
    return qx(this, e, r, t, n), this;
  }
  /**
  Change the type, attributes, and/or marks of the node at `pos`.
  When `type` isn't given, the existing node type is preserved,
  */
  setNodeMarkup(e, r, t = null, n) {
    return Xx(this, e, r, t, n), this;
  }
  /**
  Set a single attribute on a given node to a new value.
  The `pos` addresses the document content. Use `setDocAttribute`
  to set attributes on the document itself.
  */
  setNodeAttribute(e, r, t) {
    return this.step(new It(e, r, t)), this;
  }
  /**
  Set a single attribute on the document to a new value.
  */
  setDocAttribute(e, r) {
    return this.step(new Oa(e, r)), this;
  }
  /**
  Add a mark to the node at position `pos`.
  */
  addNodeMark(e, r) {
    return this.step(new jr(e, r)), this;
  }
  /**
  Remove a mark (or a mark of the given type) from the node at
  position `pos`.
  */
  removeNodeMark(e, r) {
    if (!(r instanceof Ce)) {
      let t = this.doc.nodeAt(e);
      if (!t)
        throw new RangeError("No node at position " + e);
      if (r = r.isInSet(t.marks), !r)
        return this;
    }
    return this.step(new Qt(e, r)), this;
  }
  /**
  Split the node at the given position, and optionally, if `depth` is
  greater than one, any number of nodes above that. By default, the
  parts split off will inherit the node type of the original node.
  This can be changed by passing an array of types and attributes to
  use after the split (with the outermost nodes coming first).
  */
  split(e, r = 1, t) {
    return Ux(this, e, r, t), this;
  }
  /**
  Add the given mark to the inline content between `from` and `to`.
  */
  addMark(e, r, t) {
    return Nx(this, e, r, t), this;
  }
  /**
  Remove marks from inline nodes between `from` and `to`. When
  `mark` is a single mark, remove precisely that mark. When it is
  a mark type, remove all marks of that type. When it is null,
  remove all marks of any type.
  */
  removeMark(e, r, t) {
    return Vx(this, e, r, t), this;
  }
  /**
  Removes all marks and nodes from the content of the node at
  `pos` that don't match the given new parent node type. Accepts
  an optional starting [content match](https://prosemirror.net/docs/ref/#model.ContentMatch) as
  third argument.
  */
  clearIncompatible(e, r, t) {
    return Kp(this, e, r, t), this;
  }
}
const gc = /* @__PURE__ */ Object.create(null);
class we {
  /**
  Initialize a selection with the head and anchor and ranges. If no
  ranges are given, constructs a single range across `$anchor` and
  `$head`.
  */
  constructor(e, r, t) {
    this.$anchor = e, this.$head = r, this.ranges = t || [new aC(e.min(r), e.max(r))];
  }
  /**
  The selection's anchor, as an unresolved position.
  */
  get anchor() {
    return this.$anchor.pos;
  }
  /**
  The selection's head.
  */
  get head() {
    return this.$head.pos;
  }
  /**
  The lower bound of the selection's main range.
  */
  get from() {
    return this.$from.pos;
  }
  /**
  The upper bound of the selection's main range.
  */
  get to() {
    return this.$to.pos;
  }
  /**
  The resolved lower  bound of the selection's main range.
  */
  get $from() {
    return this.ranges[0].$from;
  }
  /**
  The resolved upper bound of the selection's main range.
  */
  get $to() {
    return this.ranges[0].$to;
  }
  /**
  Indicates whether the selection contains any content.
  */
  get empty() {
    let e = this.ranges;
    for (let r = 0; r < e.length; r++)
      if (e[r].$from.pos != e[r].$to.pos)
        return !1;
    return !0;
  }
  /**
  Get the content of this selection as a slice.
  */
  content() {
    return this.$from.doc.slice(this.from, this.to, !0);
  }
  /**
  Replace the selection with a slice or, if no slice is given,
  delete the selection. Will append to the given transaction.
  */
  replace(e, r = te.empty) {
    let t = r.content.lastChild, n = null;
    for (let i = 0; i < r.openEnd; i++)
      n = t, t = t.lastChild;
    let a = e.steps.length, s = this.ranges;
    for (let i = 0; i < s.length; i++) {
      let { $from: l, $to: c } = s[i], u = e.mapping.slice(a);
      e.replaceRange(u.map(l.pos), u.map(c.pos), i ? te.empty : r), i == 0 && oy(e, a, (t ? t.isInline : n && n.isTextblock) ? -1 : 1);
    }
  }
  /**
  Replace the selection with the given node, appending the changes
  to the given transaction.
  */
  replaceWith(e, r) {
    let t = e.steps.length, n = this.ranges;
    for (let a = 0; a < n.length; a++) {
      let { $from: s, $to: i } = n[a], l = e.mapping.slice(t), c = l.map(s.pos), u = l.map(i.pos);
      a ? e.deleteRange(c, u) : (e.replaceRangeWith(c, u, r), oy(e, t, r.isInline ? -1 : 1));
    }
  }
  /**
  Find a valid cursor or leaf node selection starting at the given
  position and searching back if `dir` is negative, and forward if
  positive. When `textOnly` is true, only consider cursor
  selections. Will return null when no valid selection position is
  found.
  */
  static findFrom(e, r, t = !1) {
    let n = e.parent.inlineContent ? new Be(e) : Tt(e.node(0), e.parent, e.pos, e.index(), r, t);
    if (n)
      return n;
    for (let a = e.depth - 1; a >= 0; a--) {
      let s = r < 0 ? Tt(e.node(0), e.node(a), e.before(a + 1), e.index(a), r, t) : Tt(e.node(0), e.node(a), e.after(a + 1), e.index(a) + 1, r, t);
      if (s)
        return s;
    }
    return null;
  }
  /**
  Find a valid cursor or leaf node selection near the given
  position. Searches forward first by default, but if `bias` is
  negative, it will search backwards first.
  */
  static near(e, r = 1) {
    return this.findFrom(e, r) || this.findFrom(e, -r) || new Eo(e.node(0));
  }
  /**
  Find the cursor or leaf node selection closest to the start of
  the given document. Will return an
  [`AllSelection`](https://prosemirror.net/docs/ref/#state.AllSelection) if no valid position
  exists.
  */
  static atStart(e) {
    return Tt(e, e, 0, 0, 1) || new Eo(e);
  }
  /**
  Find the cursor or leaf node selection closest to the end of the
  given document.
  */
  static atEnd(e) {
    return Tt(e, e, e.content.size, e.childCount, -1) || new Eo(e);
  }
  /**
  Deserialize the JSON representation of a selection. Must be
  implemented for custom classes (as a static class method).
  */
  static fromJSON(e, r) {
    if (!r || !r.type)
      throw new RangeError("Invalid input for Selection.fromJSON");
    let t = gc[r.type];
    if (!t)
      throw new RangeError(`No selection type ${r.type} defined`);
    return t.fromJSON(e, r);
  }
  /**
  To be able to deserialize selections from JSON, custom selection
  classes must register themselves with an ID string, so that they
  can be disambiguated. Try to pick something that's unlikely to
  clash with classes from other modules.
  */
  static jsonID(e, r) {
    if (e in gc)
      throw new RangeError("Duplicate use of selection JSON ID " + e);
    return gc[e] = r, r.prototype.jsonID = e, r;
  }
  /**
  Get a [bookmark](https://prosemirror.net/docs/ref/#state.SelectionBookmark) for this selection,
  which is a value that can be mapped without having access to a
  current document, and later resolved to a real selection for a
  given document again. (This is used mostly by the history to
  track and restore old selections.) The default implementation of
  this method just converts the selection to a text selection and
  returns the bookmark for that.
  */
  getBookmark() {
    return Be.between(this.$anchor, this.$head).getBookmark();
  }
}
we.prototype.visible = !0;
class aC {
  /**
  Create a range.
  */
  constructor(e, r) {
    this.$from = e, this.$to = r;
  }
}
let $f = !1;
function ey(o) {
  !$f && !o.parent.inlineContent && ($f = !0, console.warn("TextSelection endpoint not pointing into a node with inline content (" + o.parent.type.name + ")"));
}
class Be extends we {
  /**
  Construct a text selection between the given points.
  */
  constructor(e, r = e) {
    ey(e), ey(r), super(e, r);
  }
  /**
  Returns a resolved position if this is a cursor selection (an
  empty text selection), and null otherwise.
  */
  get $cursor() {
    return this.$anchor.pos == this.$head.pos ? this.$head : null;
  }
  map(e, r) {
    let t = e.resolve(r.map(this.head));
    if (!t.parent.inlineContent)
      return we.near(t);
    let n = e.resolve(r.map(this.anchor));
    return new Be(n.parent.inlineContent ? n : t, t);
  }
  replace(e, r = te.empty) {
    if (super.replace(e, r), r == te.empty) {
      let t = this.$from.marksAcross(this.$to);
      t && e.ensureMarks(t);
    }
  }
  eq(e) {
    return e instanceof Be && e.anchor == this.anchor && e.head == this.head;
  }
  getBookmark() {
    return new Hi(this.anchor, this.head);
  }
  toJSON() {
    return { type: "text", anchor: this.anchor, head: this.head };
  }
  /**
  @internal
  */
  static fromJSON(e, r) {
    if (typeof r.anchor != "number" || typeof r.head != "number")
      throw new RangeError("Invalid input for TextSelection.fromJSON");
    return new Be(e.resolve(r.anchor), e.resolve(r.head));
  }
  /**
  Create a text selection from non-resolved positions.
  */
  static create(e, r, t = r) {
    let n = e.resolve(r);
    return new this(n, t == r ? n : e.resolve(t));
  }
  /**
  Return a text selection that spans the given positions or, if
  they aren't text positions, find a text selection near them.
  `bias` determines whether the method searches forward (default)
  or backwards (negative number) first. Will fall back to calling
  [`Selection.near`](https://prosemirror.net/docs/ref/#state.Selection^near) when the document
  doesn't contain a valid text position.
  */
  static between(e, r, t) {
    let n = e.pos - r.pos;
    if ((!t || n) && (t = n >= 0 ? 1 : -1), !r.parent.inlineContent) {
      let a = we.findFrom(r, t, !0) || we.findFrom(r, -t, !0);
      if (a)
        r = a.$head;
      else
        return we.near(r, t);
    }
    return e.parent.inlineContent || (n == 0 ? e = r : (e = (we.findFrom(e, -t, !0) || we.findFrom(e, t, !0)).$anchor, e.pos < r.pos != n < 0 && (e = r))), new Be(e, r);
  }
}
we.jsonID("text", Be);
class Hi {
  constructor(e, r) {
    this.anchor = e, this.head = r;
  }
  map(e) {
    return new Hi(e.map(this.anchor), e.map(this.head));
  }
  resolve(e) {
    return Be.between(e.resolve(this.anchor), e.resolve(this.head));
  }
}
class me extends we {
  /**
  Create a node selection. Does not verify the validity of its
  argument.
  */
  constructor(e) {
    let r = e.nodeAfter, t = e.node(0).resolve(e.pos + r.nodeSize);
    super(e, t), this.node = r;
  }
  map(e, r) {
    let { deleted: t, pos: n } = r.mapResult(this.anchor), a = e.resolve(n);
    return t ? we.near(a) : new me(a);
  }
  content() {
    return new te($.from(this.node), 0, 0);
  }
  eq(e) {
    return e instanceof me && e.anchor == this.anchor;
  }
  toJSON() {
    return { type: "node", anchor: this.anchor };
  }
  getBookmark() {
    return new Qp(this.anchor);
  }
  /**
  @internal
  */
  static fromJSON(e, r) {
    if (typeof r.anchor != "number")
      throw new RangeError("Invalid input for NodeSelection.fromJSON");
    return new me(e.resolve(r.anchor));
  }
  /**
  Create a node selection from non-resolved positions.
  */
  static create(e, r) {
    return new me(e.resolve(r));
  }
  /**
  Determines whether the given node may be selected as a node
  selection.
  */
  static isSelectable(e) {
    return !e.isText && e.type.spec.selectable !== !1;
  }
}
me.prototype.visible = !1;
we.jsonID("node", me);
class Qp {
  constructor(e) {
    this.anchor = e;
  }
  map(e) {
    let { deleted: r, pos: t } = e.mapResult(this.anchor);
    return r ? new Hi(t, t) : new Qp(t);
  }
  resolve(e) {
    let r = e.resolve(this.anchor), t = r.nodeAfter;
    return t && me.isSelectable(t) ? new me(r) : we.near(r);
  }
}
class Eo extends we {
  /**
  Create an all-selection over the given document.
  */
  constructor(e) {
    super(e.resolve(0), e.resolve(e.content.size));
  }
  replace(e, r = te.empty) {
    if (r == te.empty) {
      e.delete(0, e.doc.content.size);
      let t = we.atStart(e.doc);
      t.eq(e.selection) || e.setSelection(t);
    } else
      super.replace(e, r);
  }
  toJSON() {
    return { type: "all" };
  }
  /**
  @internal
  */
  static fromJSON(e) {
    return new Eo(e);
  }
  map(e) {
    return new Eo(e);
  }
  eq(e) {
    return e instanceof Eo;
  }
  getBookmark() {
    return sC;
  }
}
we.jsonID("all", Eo);
const sC = {
  map() {
    return this;
  },
  resolve(o) {
    return new Eo(o);
  }
};
function Tt(o, e, r, t, n, a = !1) {
  if (e.inlineContent)
    return Be.create(o, r);
  for (let s = t - (n > 0 ? 0 : 1); n > 0 ? s < e.childCount : s >= 0; s += n) {
    let i = e.child(s);
    if (i.isAtom) {
      if (!a && me.isSelectable(i))
        return me.create(o, r - (n < 0 ? i.nodeSize : 0));
    } else {
      let l = Tt(o, i, r + n, n < 0 ? i.childCount : 0, n, a);
      if (l)
        return l;
    }
    r += i.nodeSize * n;
  }
  return null;
}
function oy(o, e, r) {
  let t = o.steps.length - 1;
  if (t < e)
    return;
  let n = o.steps[t];
  if (!(n instanceof Ke || n instanceof Je))
    return;
  let a = o.mapping.maps[t], s;
  a.forEach((i, l, c, u) => {
    s == null && (s = u);
  }), o.setSelection(we.near(o.doc.resolve(s), r));
}
function ry(o, e) {
  return !e || !o ? o : o.bind(e);
}
class ks {
  constructor(e, r, t) {
    this.name = e, this.init = ry(r.init, t), this.apply = ry(r.apply, t);
  }
}
new ks("doc", {
  init(o) {
    return o.doc || o.schema.topNodeType.createAndFill();
  },
  apply(o) {
    return o.doc;
  }
}), new ks("selection", {
  init(o, e) {
    return o.selection || we.atStart(e.doc);
  },
  apply(o) {
    return o.selection;
  }
}), new ks("storedMarks", {
  init(o) {
    return o.storedMarks || null;
  },
  apply(o, e, r, t) {
    return t.selection.$cursor ? o.storedMarks : null;
  }
}), new ks("scrollToSelection", {
  init() {
    return 0;
  },
  apply(o, e) {
    return o.scrolledIntoView ? e + 1 : e;
  }
});
function j0(o, e, r) {
  for (let t in o) {
    let n = o[t];
    n instanceof Function ? n = n.bind(e) : t == "handleDOMEvents" && (n = j0(n, e, {})), r[t] = n;
  }
  return r;
}
class Gr {
  /**
  Create a plugin.
  */
  constructor(e) {
    this.spec = e, this.props = {}, e.props && j0(e.props, this, this.props), this.key = e.key ? e.key.key : M0("plugin");
  }
  /**
  Extract the plugin's state field from an editor state.
  */
  getState(e) {
    return e[this.key];
  }
}
const mc = /* @__PURE__ */ Object.create(null);
function M0(o) {
  return o in mc ? o + "$" + ++mc[o] : (mc[o] = 0, o + "$");
}
class Xr {
  /**
  Create a plugin key.
  */
  constructor(e = "key") {
    this.key = M0(e);
  }
  /**
  Get the active plugin with this key, if any, from an editor
  state.
  */
  get(e) {
    return e.config.pluginsByKey[this.key];
  }
  /**
  Get the plugin's state from an editor state.
  */
  getState(e) {
    return e[this.key];
  }
}
const Jp = (o, e) => o.selection.empty ? !1 : (e && e(o.tr.deleteSelection().scrollIntoView()), !0);
function W0(o, e) {
  let { $cursor: r } = o.selection;
  return !r || (e ? !e.endOfTextblock("backward", o) : r.parentOffset > 0) ? null : r;
}
const N0 = (o, e, r) => {
  let t = W0(o, r);
  if (!t)
    return !1;
  let n = _p(t);
  if (!n) {
    let s = t.blockRange(), i = s && nn(s);
    return i == null ? !1 : (e && e(o.tr.lift(s, i).scrollIntoView()), !0);
  }
  let a = n.nodeBefore;
  if (X0(o, n, e, -1))
    return !0;
  if (t.parent.content.size == 0 && (_t(a, "end") || me.isSelectable(a)))
    for (let s = t.depth; ; s--) {
      let i = Ri(o.doc, t.before(s), t.after(s), te.empty);
      if (i && i.slice.size < i.to - i.from) {
        if (e) {
          let l = o.tr.step(i);
          l.setSelection(_t(a, "end") ? we.findFrom(l.doc.resolve(l.mapping.map(n.pos, -1)), -1) : me.create(l.doc, n.pos - a.nodeSize)), e(l.scrollIntoView());
        }
        return !0;
      }
      if (s == 1 || t.node(s - 1).childCount > 1)
        break;
    }
  return a.isAtom && n.depth == t.depth - 1 ? (e && e(o.tr.delete(n.pos - a.nodeSize, n.pos).scrollIntoView()), !0) : !1;
}, iC = (o, e, r) => {
  let t = W0(o, r);
  if (!t)
    return !1;
  let n = _p(t);
  return n ? V0(o, n, e) : !1;
}, lC = (o, e, r) => {
  let t = I0(o, r);
  if (!t)
    return !1;
  let n = $p(t);
  return n ? V0(o, n, e) : !1;
};
function V0(o, e, r) {
  let t = e.nodeBefore, n = t, a = e.pos - 1;
  for (; !n.isTextblock; a--) {
    if (n.type.spec.isolating)
      return !1;
    let u = n.lastChild;
    if (!u)
      return !1;
    n = u;
  }
  let s = e.nodeAfter, i = s, l = e.pos + 1;
  for (; !i.isTextblock; l++) {
    if (i.type.spec.isolating)
      return !1;
    let u = i.firstChild;
    if (!u)
      return !1;
    i = u;
  }
  let c = Ri(o.doc, a, l, te.empty);
  if (!c || c.from != a || c instanceof Ke && c.slice.size >= l - a)
    return !1;
  if (r) {
    let u = o.tr.step(c);
    u.setSelection(Be.create(u.doc, a)), r(u.scrollIntoView());
  }
  return !0;
}
function _t(o, e, r = !1) {
  for (let t = o; t; t = e == "start" ? t.firstChild : t.lastChild) {
    if (t.isTextblock)
      return !0;
    if (r && t.childCount != 1)
      return !1;
  }
  return !1;
}
const z0 = (o, e, r) => {
  let { $head: t, empty: n } = o.selection, a = t;
  if (!n)
    return !1;
  if (t.parent.isTextblock) {
    if (r ? !r.endOfTextblock("backward", o) : t.parentOffset > 0)
      return !1;
    a = _p(t);
  }
  let s = a && a.nodeBefore;
  return !s || !me.isSelectable(s) ? !1 : (e && e(o.tr.setSelection(me.create(o.doc, a.pos - s.nodeSize)).scrollIntoView()), !0);
};
function _p(o) {
  if (!o.parent.type.spec.isolating)
    for (let e = o.depth - 1; e >= 0; e--) {
      if (o.index(e) > 0)
        return o.doc.resolve(o.before(e + 1));
      if (o.node(e).type.spec.isolating)
        break;
    }
  return null;
}
function I0(o, e) {
  let { $cursor: r } = o.selection;
  return !r || (e ? !e.endOfTextblock("forward", o) : r.parentOffset < r.parent.content.size) ? null : r;
}
const R0 = (o, e, r) => {
  let t = I0(o, r);
  if (!t)
    return !1;
  let n = $p(t);
  if (!n)
    return !1;
  let a = n.nodeAfter;
  if (X0(o, n, e, 1))
    return !0;
  if (t.parent.content.size == 0 && (_t(a, "start") || me.isSelectable(a))) {
    let s = Ri(o.doc, t.before(), t.after(), te.empty);
    if (s && s.slice.size < s.to - s.from) {
      if (e) {
        let i = o.tr.step(s);
        i.setSelection(_t(a, "start") ? we.findFrom(i.doc.resolve(i.mapping.map(n.pos)), 1) : me.create(i.doc, i.mapping.map(n.pos))), e(i.scrollIntoView());
      }
      return !0;
    }
  }
  return a.isAtom && n.depth == t.depth - 1 ? (e && e(o.tr.delete(n.pos, n.pos + a.nodeSize).scrollIntoView()), !0) : !1;
}, H0 = (o, e, r) => {
  let { $head: t, empty: n } = o.selection, a = t;
  if (!n)
    return !1;
  if (t.parent.isTextblock) {
    if (r ? !r.endOfTextblock("forward", o) : t.parentOffset < t.parent.content.size)
      return !1;
    a = $p(t);
  }
  let s = a && a.nodeAfter;
  return !s || !me.isSelectable(s) ? !1 : (e && e(o.tr.setSelection(me.create(o.doc, a.pos)).scrollIntoView()), !0);
};
function $p(o) {
  if (!o.parent.type.spec.isolating)
    for (let e = o.depth - 1; e >= 0; e--) {
      let r = o.node(e);
      if (o.index(e) + 1 < r.childCount)
        return o.doc.resolve(o.after(e + 1));
      if (r.type.spec.isolating)
        break;
    }
  return null;
}
const cC = (o, e) => {
  let r = o.selection, t = r instanceof me, n;
  if (t) {
    if (r.node.isTextblock || !Ft(o.doc, r.from))
      return !1;
    n = r.from;
  } else if (n = Ii(o.doc, r.from, -1), n == null)
    return !1;
  if (e) {
    let a = o.tr.join(n);
    t && a.setSelection(me.create(a.doc, n - o.doc.resolve(n).nodeBefore.nodeSize)), e(a.scrollIntoView());
  }
  return !0;
}, uC = (o, e) => {
  let r = o.selection, t;
  if (r instanceof me) {
    if (r.node.isTextblock || !Ft(o.doc, r.to))
      return !1;
    t = r.to;
  } else if (t = Ii(o.doc, r.to, 1), t == null)
    return !1;
  return e && e(o.tr.join(t).scrollIntoView()), !0;
}, pC = (o, e) => {
  let { $from: r, $to: t } = o.selection, n = r.blockRange(t), a = n && nn(n);
  return a == null ? !1 : (e && e(o.tr.lift(n, a).scrollIntoView()), !0);
}, Y0 = (o, e) => {
  let { $head: r, $anchor: t } = o.selection;
  return !r.parent.type.spec.code || !r.sameParent(t) ? !1 : (e && e(o.tr.insertText(`
`).scrollIntoView()), !0);
};
function ed(o) {
  for (let e = 0; e < o.edgeCount; e++) {
    let { type: r } = o.edge(e);
    if (r.isTextblock && !r.hasRequiredAttrs())
      return r;
  }
  return null;
}
const dC = (o, e) => {
  let { $head: r, $anchor: t } = o.selection;
  if (!r.parent.type.spec.code || !r.sameParent(t))
    return !1;
  let n = r.node(-1), a = r.indexAfter(-1), s = ed(n.contentMatchAt(a));
  if (!s || !n.canReplaceWith(a, a, s))
    return !1;
  if (e) {
    let i = r.after(), l = o.tr.replaceWith(i, i, s.createAndFill());
    l.setSelection(we.near(l.doc.resolve(i), 1)), e(l.scrollIntoView());
  }
  return !0;
}, q0 = (o, e) => {
  let r = o.selection, { $from: t, $to: n } = r;
  if (r instanceof Eo || t.parent.inlineContent || n.parent.inlineContent)
    return !1;
  let a = ed(n.parent.contentMatchAt(n.indexAfter()));
  if (!a || !a.isTextblock)
    return !1;
  if (e) {
    let s = (!t.parentOffset && n.index() < n.parent.childCount ? t : n).pos, i = o.tr.insert(s, a.createAndFill());
    i.setSelection(Be.create(i.doc, s + 1)), e(i.scrollIntoView());
  }
  return !0;
}, G0 = (o, e) => {
  let { $cursor: r } = o.selection;
  if (!r || r.parent.content.size)
    return !1;
  if (r.depth > 1 && r.after() != r.end(-1)) {
    let a = r.before();
    if (pr(o.doc, a))
      return e && e(o.tr.split(a).scrollIntoView()), !0;
  }
  let t = r.blockRange(), n = t && nn(t);
  return n == null ? !1 : (e && e(o.tr.lift(t, n).scrollIntoView()), !0);
};
function gC(o) {
  return (e, r) => {
    let { $from: t, $to: n } = e.selection;
    if (e.selection instanceof me && e.selection.node.isBlock)
      return !t.parentOffset || !pr(e.doc, t.pos) ? !1 : (r && r(e.tr.split(t.pos).scrollIntoView()), !0);
    if (!t.depth)
      return !1;
    let a = [], s, i, l = !1, c = !1;
    for (let d = t.depth; ; d--)
      if (t.node(d).isBlock) {
        l = t.end(d) == t.pos + (t.depth - d), c = t.start(d) == t.pos - (t.depth - d), i = ed(t.node(d - 1).contentMatchAt(t.indexAfter(d - 1))), a.unshift(l && i ? { type: i } : null), s = d;
        break;
      } else {
        if (d == 1)
          return !1;
        a.unshift(null);
      }
    let u = e.tr;
    (e.selection instanceof Be || e.selection instanceof Eo) && u.deleteSelection();
    let f = u.mapping.map(t.pos), g = pr(u.doc, f, a.length, a);
    if (g || (a[0] = i ? { type: i } : null, g = pr(u.doc, f, a.length, a)), u.split(f, a.length, a), !l && c && t.node(s).type != i) {
      let d = u.mapping.map(t.before(s)), p = u.doc.resolve(d);
      i && t.node(s - 1).canReplaceWith(p.index(), p.index() + 1, i) && u.setNodeMarkup(u.mapping.map(t.before(s)), i);
    }
    return r && r(u.scrollIntoView()), !0;
  };
}
const mC = gC(), fC = (o, e) => {
  let { $from: r, to: t } = o.selection, n, a = r.sharedDepth(t);
  return a == 0 ? !1 : (n = r.before(a), e && e(o.tr.setSelection(me.create(o.doc, n))), !0);
};
function yC(o, e, r) {
  let t = e.nodeBefore, n = e.nodeAfter, a = e.index();
  return !t || !n || !t.type.compatibleContent(n.type) ? !1 : !t.content.size && e.parent.canReplace(a - 1, a) ? (r && r(o.tr.delete(e.pos - t.nodeSize, e.pos).scrollIntoView()), !0) : !e.parent.canReplace(a, a + 1) || !(n.isTextblock || Ft(o.doc, e.pos)) ? !1 : (r && r(o.tr.join(e.pos).scrollIntoView()), !0);
}
function X0(o, e, r, t) {
  let n = e.nodeBefore, a = e.nodeAfter, s, i, l = n.type.spec.isolating || a.type.spec.isolating;
  if (!l && yC(o, e, r))
    return !0;
  let c = !l && e.parent.canReplace(e.index(), e.index() + 1);
  if (c && (s = (i = n.contentMatchAt(n.childCount)).findWrapping(a.type)) && i.matchType(s[0] || a.type).validEnd) {
    if (r) {
      let d = e.pos + a.nodeSize, p = $.empty;
      for (let h = s.length - 1; h >= 0; h--)
        p = $.from(s[h].create(null, p));
      p = $.from(n.copy(p));
      let m = o.tr.step(new Je(e.pos - 1, d, e.pos, d, new te(p, 1, 0), s.length, !0)), y = m.doc.resolve(d + 2 * s.length);
      y.nodeAfter && y.nodeAfter.type == n.type && Ft(m.doc, y.pos) && m.join(y.pos), r(m.scrollIntoView());
    }
    return !0;
  }
  let u = a.type.spec.isolating || t > 0 && l ? null : we.findFrom(e, 1), f = u && u.$from.blockRange(u.$to), g = f && nn(f);
  if (g != null && g >= e.depth)
    return r && r(o.tr.lift(f, g).scrollIntoView()), !0;
  if (c && _t(a, "start", !0) && _t(n, "end")) {
    let d = n, p = [];
    for (; p.push(d), !d.isTextblock; )
      d = d.lastChild;
    let m = a, y = 1;
    for (; !m.isTextblock; m = m.firstChild)
      y++;
    if (d.canReplace(d.childCount, d.childCount, m.content)) {
      if (r) {
        let h = $.empty;
        for (let b = p.length - 1; b >= 0; b--)
          h = $.from(p[b].copy(h));
        let F = o.tr.step(new Je(e.pos - p.length, e.pos + a.nodeSize, e.pos + y, e.pos + a.nodeSize - y, new te(h, p.length, 0), 0, !0));
        r(F.scrollIntoView());
      }
      return !0;
    }
  }
  return !1;
}
function U0(o) {
  return function(e, r) {
    let t = e.selection, n = o < 0 ? t.$from : t.$to, a = n.depth;
    for (; n.node(a).isInline; ) {
      if (!a)
        return !1;
      a--;
    }
    return n.node(a).isTextblock ? (r && r(e.tr.setSelection(Be.create(e.doc, o < 0 ? n.start(a) : n.end(a)))), !0) : !1;
  };
}
const hC = U0(-1), FC = U0(1);
function bC(o, e = null) {
  return function(r, t) {
    let { $from: n, $to: a } = r.selection, s = n.blockRange(a), i = s && S0(s, o, e);
    return i ? (t && t(r.tr.wrap(s, i).scrollIntoView()), !0) : !1;
  };
}
function ty(o, e = null) {
  return function(r, t) {
    let n = !1;
    for (let a = 0; a < r.selection.ranges.length && !n; a++) {
      let { $from: { pos: s }, $to: { pos: i } } = r.selection.ranges[a];
      r.doc.nodesBetween(s, i, (l, c) => {
        if (n)
          return !1;
        if (!(!l.isTextblock || l.hasMarkup(o, e)))
          if (l.type == o)
            n = !0;
          else {
            let u = r.doc.resolve(c), f = u.index();
            n = u.parent.canReplaceWith(f, f + 1, o);
          }
      });
    }
    if (!n)
      return !1;
    if (t) {
      let a = r.tr;
      for (let s = 0; s < r.selection.ranges.length; s++) {
        let { $from: { pos: i }, $to: { pos: l } } = r.selection.ranges[s];
        a.setBlockType(i, l, o, e);
      }
      t(a.scrollIntoView());
    }
    return !0;
  };
}
function od(...o) {
  return function(e, r, t) {
    for (let n = 0; n < o.length; n++)
      if (o[n](e, r, t))
        return !0;
    return !1;
  };
}
od(Jp, N0, z0);
od(Jp, R0, H0);
od(Y0, q0, G0, mC);
typeof navigator < "u" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : typeof os < "u" && os.platform && os.platform() == "darwin";
function vC(o, e = null) {
  return function(r, t) {
    let { $from: n, $to: a } = r.selection, s = n.blockRange(a);
    if (!s)
      return !1;
    let i = t ? r.tr : null;
    return BC(i, s, o, e) ? (t && t(i.scrollIntoView()), !0) : !1;
  };
}
function BC(o, e, r, t = null) {
  let n = !1, a = e, s = e.$from.doc;
  if (e.depth >= 2 && e.$from.node(e.depth - 1).type.compatibleContent(r) && e.startIndex == 0) {
    if (e.$from.index(e.depth - 1) == 0)
      return !1;
    let l = s.resolve(e.start - 2);
    a = new ii(l, l, e.depth), e.endIndex < e.parent.childCount && (e = new ii(e.$from, s.resolve(e.$to.end(e.depth)), e.depth)), n = !0;
  }
  let i = S0(a, r, t, e);
  return i ? (o && PC(o, e, i, n, r), !0) : !1;
}
function PC(o, e, r, t, n) {
  let a = $.empty;
  for (let u = r.length - 1; u >= 0; u--)
    a = $.from(r[u].type.create(r[u].attrs, a));
  o.step(new Je(e.start - (t ? 2 : 0), e.end, e.start, e.end, new te(a, 0, 0), r.length, !0));
  let s = 0;
  for (let u = 0; u < r.length; u++)
    r[u].type == n && (s = u + 1);
  let i = r.length - s, l = e.start + r.length - (t ? 2 : 0), c = e.parent;
  for (let u = e.startIndex, f = e.endIndex, g = !0; u < f; u++, g = !1)
    !g && pr(o.doc, l, i) && (o.split(l, i), l += 2 * i), l += c.child(u).nodeSize;
  return o;
}
function wC(o) {
  return function(e, r) {
    let { $from: t, $to: n } = e.selection, a = t.blockRange(n, (s) => s.childCount > 0 && s.firstChild.type == o);
    return a ? r ? t.node(a.depth - 1).type == o ? kC(e, r, o, a) : DC(e, r, a) : !0 : !1;
  };
}
function kC(o, e, r, t) {
  let n = o.tr, a = t.end, s = t.$to.end(t.depth);
  a < s && (n.step(new Je(a - 1, s, a, s, new te($.from(r.create(null, t.parent.copy())), 1, 0), 1, !0)), t = new ii(n.doc.resolve(t.$from.pos), n.doc.resolve(s), t.depth));
  const i = nn(t);
  if (i == null)
    return !1;
  n.lift(t, i);
  let l = n.doc.resolve(n.mapping.map(a, -1) - 1);
  return Ft(n.doc, l.pos) && l.nodeBefore.type == l.nodeAfter.type && n.join(l.pos), e(n.scrollIntoView()), !0;
}
function DC(o, e, r) {
  let t = o.tr, n = r.parent;
  for (let d = r.end, p = r.endIndex - 1, m = r.startIndex; p > m; p--)
    d -= n.child(p).nodeSize, t.delete(d - 1, d + 1);
  let a = t.doc.resolve(r.start), s = a.nodeAfter;
  if (t.mapping.map(r.end) != r.start + a.nodeAfter.nodeSize)
    return !1;
  let i = r.startIndex == 0, l = r.endIndex == n.childCount, c = a.node(-1), u = a.index(-1);
  if (!c.canReplace(u + (i ? 0 : 1), u + 1, s.content.append(l ? $.empty : $.from(n))))
    return !1;
  let f = a.pos, g = f + s.nodeSize;
  return t.step(new Je(f - (i ? 1 : 0), g + (l ? 1 : 0), f + 1, g - 1, new te((i ? $.empty : $.from(n.copy($.empty))).append(l ? $.empty : $.from(n.copy($.empty))), i ? 0 : 1, l ? 0 : 1), i ? 0 : 1)), e(t.scrollIntoView()), !0;
}
function SC(o) {
  return function(e, r) {
    let { $from: t, $to: n } = e.selection, a = t.blockRange(n, (c) => c.childCount > 0 && c.firstChild.type == o);
    if (!a)
      return !1;
    let s = a.startIndex;
    if (s == 0)
      return !1;
    let i = a.parent, l = i.child(s - 1);
    if (l.type != o)
      return !1;
    if (r) {
      let c = l.lastChild && l.lastChild.type == i.type, u = $.from(c ? o.create() : null), f = new te($.from(o.create(null, $.from(i.type.create(null, u)))), c ? 3 : 1, 0), g = a.start, d = a.end;
      r(e.tr.step(new Je(g - (c ? 3 : 1), d, g, d, f, 1, !0)).scrollIntoView());
    }
    return !0;
  };
}
const bt = function(o) {
  for (var e = 0; ; e++)
    if (o = o.previousSibling, !o)
      return e;
}, Z0 = function(o, e, r, t) {
  return r && (ny(o, e, r, t, -1) || ny(o, e, r, t, 1));
}, AC = /^(img|br|input|textarea|hr)$/i;
function ny(o, e, r, t, n) {
  for (; ; ) {
    if (o == r && e == t)
      return !0;
    if (e == (n < 0 ? 0 : ui(o))) {
      let a = o.parentNode;
      if (!a || a.nodeType != 1 || rd(o) || AC.test(o.nodeName) || o.contentEditable == "false")
        return !1;
      e = bt(o) + (n < 0 ? 0 : 1), o = a;
    } else if (o.nodeType == 1) {
      if (o = o.childNodes[e + (n < 0 ? -1 : 0)], o.contentEditable == "false")
        return !1;
      e = n < 0 ? ui(o) : 0;
    } else
      return !1;
  }
}
function ui(o) {
  return o.nodeType == 3 ? o.nodeValue.length : o.childNodes.length;
}
function EC(o, e, r) {
  for (let t = e == 0, n = e == ui(o); t || n; ) {
    if (o == r)
      return !0;
    let a = bt(o);
    if (o = o.parentNode, !o)
      return !1;
    t = t && a == 0, n = n && a == ui(o);
  }
}
function rd(o) {
  let e;
  for (let r = o; r && !(e = r.pmViewDesc); r = r.parentNode)
    ;
  return e && e.node && e.node.isBlock && (e.dom == o || e.contentDOM == o);
}
const K0 = function(o) {
  return o.focusNode && Z0(o.focusNode, o.focusOffset, o.anchorNode, o.anchorOffset);
};
function Q0(o, e) {
  let r = document.createEvent("Event");
  return r.initEvent("keydown", !0, !0), r.keyCode = o, r.key = r.code = e, r;
}
const sr = typeof navigator < "u" ? navigator : null, ay = typeof document < "u" ? document : null, Ur = sr && sr.userAgent || "", Hu = /Edge\/(\d+)/.exec(Ur), J0 = /MSIE \d/.exec(Ur), Yu = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(Ur), Qa = !!(J0 || Yu || Hu), _0 = J0 ? document.documentMode : Yu ? +Yu[1] : Hu ? +Hu[1] : 0, Yi = !Qa && /gecko\/(\d+)/i.test(Ur);
Yi && +(/Firefox\/(\d+)/.exec(Ur) || [0, 0])[1];
const qu = !Qa && /Chrome\/(\d+)/.exec(Ur), Zr = !!qu, $0 = qu ? +qu[1] : 0, vt = !Qa && !!sr && /Apple Computer/.test(sr.vendor), td = vt && (/Mobile\/\w+/.test(Ur) || !!sr && sr.maxTouchPoints > 2), Wo = td || (sr ? /Mac/.test(sr.platform) : !1), xC = sr ? /Win/.test(sr.platform) : !1, Ja = /Android \d/.test(Ur), nd = !!ay && "webkitFontSmoothing" in ay.documentElement.style, CC = nd ? +(/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [0, 0])[1] : 0;
function OC(o, e = null) {
  let r = o.domSelectionRange(), t = o.state.doc;
  if (!r.focusNode)
    return null;
  let n = o.docView.nearestDesc(r.focusNode), a = n && n.size == 0, s = o.docView.posFromDOM(r.focusNode, r.focusOffset, 1);
  if (s < 0)
    return null;
  let i = t.resolve(s), l, c;
  if (K0(r)) {
    for (l = s; n && !n.node; )
      n = n.parent;
    let f = n.node;
    if (n && f.isAtom && me.isSelectable(f) && n.parent && !(f.isInline && EC(r.focusNode, r.focusOffset, n.dom))) {
      let g = n.posBefore;
      c = new me(s == g ? i : t.resolve(g));
    }
  } else {
    if (r instanceof o.dom.ownerDocument.defaultView.Selection && r.rangeCount > 1) {
      let f = s, g = s;
      for (let d = 0; d < r.rangeCount; d++) {
        let p = r.getRangeAt(d);
        f = Math.min(f, o.docView.posFromDOM(p.startContainer, p.startOffset, 1)), g = Math.max(g, o.docView.posFromDOM(p.endContainer, p.endOffset, -1));
      }
      if (f < 0)
        return null;
      [l, s] = g == o.state.selection.anchor ? [g, f] : [f, g], i = t.resolve(s);
    } else
      l = o.docView.posFromDOM(r.anchorNode, r.anchorOffset, 1);
    if (l < 0)
      return null;
  }
  let u = t.resolve(l);
  if (!c) {
    let f = e == "pointer" || o.state.selection.head < i.pos && !a ? 1 : -1;
    c = ob(o, u, i, f);
  }
  return c;
}
function eb(o) {
  return o.editable ? o.hasFocus() : MC(o) && document.activeElement && document.activeElement.contains(o.dom);
}
function ad(o, e = !1) {
  let r = o.state.selection;
  if (jC(o, r), !!eb(o)) {
    if (!e && o.input.mouseDown && o.input.mouseDown.allowDefault && Zr) {
      let t = o.domSelectionRange(), n = o.domObserver.currentSelection;
      if (t.anchorNode && n.anchorNode && Z0(t.anchorNode, t.anchorOffset, n.anchorNode, n.anchorOffset)) {
        o.input.mouseDown.delayedSelectionSync = !0, o.domObserver.setCurSelection();
        return;
      }
    }
    if (o.domObserver.disconnectSelection(), o.cursorWrapper)
      LC(o);
    else {
      let { anchor: t, head: n } = r, a, s;
      sy && !(r instanceof Be) && (r.$from.parent.inlineContent || (a = iy(o, r.from)), !r.empty && !r.$from.parent.inlineContent && (s = iy(o, r.to))), o.docView.setSelection(t, n, o, e), sy && (a && ly(a), s && ly(s)), r.visible ? o.dom.classList.remove("ProseMirror-hideselection") : (o.dom.classList.add("ProseMirror-hideselection"), "onselectionchange" in document && TC(o));
    }
    o.domObserver.setCurSelection(), o.domObserver.connectSelection();
  }
}
const sy = vt || Zr && $0 < 63;
function iy(o, e) {
  let { node: r, offset: t } = o.docView.domFromPos(e, 0), n = t < r.childNodes.length ? r.childNodes[t] : null, a = t ? r.childNodes[t - 1] : null;
  if (vt && n && n.contentEditable == "false")
    return fc(n);
  if ((!n || n.contentEditable == "false") && (!a || a.contentEditable == "false")) {
    if (n)
      return fc(n);
    if (a)
      return fc(a);
  }
}
function fc(o) {
  return o.contentEditable = "true", vt && o.draggable && (o.draggable = !1, o.wasDraggable = !0), o;
}
function ly(o) {
  o.contentEditable = "false", o.wasDraggable && (o.draggable = !0, o.wasDraggable = null);
}
function TC(o) {
  let e = o.dom.ownerDocument;
  e.removeEventListener("selectionchange", o.input.hideSelectionGuard);
  let r = o.domSelectionRange(), t = r.anchorNode, n = r.anchorOffset;
  e.addEventListener("selectionchange", o.input.hideSelectionGuard = () => {
    (r.anchorNode != t || r.anchorOffset != n) && (e.removeEventListener("selectionchange", o.input.hideSelectionGuard), setTimeout(() => {
      (!eb(o) || o.state.selection.visible) && o.dom.classList.remove("ProseMirror-hideselection");
    }, 20));
  });
}
function LC(o) {
  let e = o.domSelection(), r = document.createRange();
  if (!e)
    return;
  let t = o.cursorWrapper.dom, n = t.nodeName == "IMG";
  n ? r.setStart(t.parentNode, bt(t) + 1) : r.setStart(t, 0), r.collapse(!0), e.removeAllRanges(), e.addRange(r), !n && !o.state.selection.visible && Qa && _0 <= 11 && (t.disabled = !0, t.disabled = !1);
}
function jC(o, e) {
  if (e instanceof me) {
    let r = o.docView.descAt(e.from);
    r != o.lastSelectedViewDesc && (cy(o), r && r.selectNode(), o.lastSelectedViewDesc = r);
  } else
    cy(o);
}
function cy(o) {
  o.lastSelectedViewDesc && (o.lastSelectedViewDesc.parent && o.lastSelectedViewDesc.deselectNode(), o.lastSelectedViewDesc = void 0);
}
function ob(o, e, r, t) {
  return o.someProp("createSelectionBetween", (n) => n(o, e, r)) || Be.between(e, r, t);
}
function MC(o) {
  let e = o.domSelectionRange();
  if (!e.anchorNode)
    return !1;
  try {
    return o.dom.contains(e.anchorNode.nodeType == 3 ? e.anchorNode.parentNode : e.anchorNode) && (o.editable || o.dom.contains(e.focusNode.nodeType == 3 ? e.focusNode.parentNode : e.focusNode));
  } catch {
    return !1;
  }
}
function Gu(o, e) {
  let { $anchor: r, $head: t } = o.selection, n = e > 0 ? r.max(t) : r.min(t), a = n.parent.inlineContent ? n.depth ? o.doc.resolve(e > 0 ? n.after() : n.before()) : null : n;
  return a && we.findFrom(a, e);
}
function Cr(o, e) {
  return o.dispatch(o.state.tr.setSelection(e).scrollIntoView()), !0;
}
function uy(o, e, r) {
  let t = o.state.selection;
  if (t instanceof Be)
    if (r.indexOf("s") > -1) {
      let { $head: n } = t, a = n.textOffset ? null : e < 0 ? n.nodeBefore : n.nodeAfter;
      if (!a || a.isText || !a.isLeaf)
        return !1;
      let s = o.state.doc.resolve(n.pos + a.nodeSize * (e < 0 ? -1 : 1));
      return Cr(o, new Be(t.$anchor, s));
    } else if (t.empty) {
      if (o.endOfTextblock(e > 0 ? "forward" : "backward")) {
        let n = Gu(o.state, e);
        return n && n instanceof me ? Cr(o, n) : !1;
      } else if (!(Wo && r.indexOf("m") > -1)) {
        let n = t.$head, a = n.textOffset ? null : e < 0 ? n.nodeBefore : n.nodeAfter, s;
        if (!a || a.isText)
          return !1;
        let i = e < 0 ? n.pos - a.nodeSize : n.pos;
        return a.isAtom || (s = o.docView.descAt(i)) && !s.contentDOM ? me.isSelectable(a) ? Cr(o, new me(e < 0 ? o.state.doc.resolve(n.pos - a.nodeSize) : n)) : nd ? Cr(o, new Be(o.state.doc.resolve(e < 0 ? i : i + a.nodeSize))) : !1 : !1;
      }
    } else return !1;
  else {
    if (t instanceof me && t.node.isInline)
      return Cr(o, new Be(e > 0 ? t.$to : t.$from));
    {
      let n = Gu(o.state, e);
      return n ? Cr(o, n) : !1;
    }
  }
}
function pi(o) {
  return o.nodeType == 3 ? o.nodeValue.length : o.childNodes.length;
}
function Cn(o, e) {
  let r = o.pmViewDesc;
  return r && r.size == 0 && (e < 0 || o.nextSibling || o.nodeName != "BR");
}
function Ct(o, e) {
  return e < 0 ? WC(o) : NC(o);
}
function WC(o) {
  let e = o.domSelectionRange(), r = e.focusNode, t = e.focusOffset;
  if (!r)
    return;
  let n, a, s = !1;
  for (Yi && r.nodeType == 1 && t < pi(r) && Cn(r.childNodes[t], -1) && (s = !0); ; )
    if (t > 0) {
      if (r.nodeType != 1)
        break;
      {
        let i = r.childNodes[t - 1];
        if (Cn(i, -1))
          n = r, a = --t;
        else if (i.nodeType == 3)
          r = i, t = r.nodeValue.length;
        else
          break;
      }
    } else {
      if (rb(r))
        break;
      {
        let i = r.previousSibling;
        for (; i && Cn(i, -1); )
          n = r.parentNode, a = bt(i), i = i.previousSibling;
        if (i)
          r = i, t = pi(r);
        else {
          if (r = r.parentNode, r == o.dom)
            break;
          t = 0;
        }
      }
    }
  s ? Xu(o, r, t) : n && Xu(o, n, a);
}
function NC(o) {
  let e = o.domSelectionRange(), r = e.focusNode, t = e.focusOffset;
  if (!r)
    return;
  let n = pi(r), a, s;
  for (; ; )
    if (t < n) {
      if (r.nodeType != 1)
        break;
      let i = r.childNodes[t];
      if (Cn(i, 1))
        a = r, s = ++t;
      else
        break;
    } else {
      if (rb(r))
        break;
      {
        let i = r.nextSibling;
        for (; i && Cn(i, 1); )
          a = i.parentNode, s = bt(i) + 1, i = i.nextSibling;
        if (i)
          r = i, t = 0, n = pi(r);
        else {
          if (r = r.parentNode, r == o.dom)
            break;
          t = n = 0;
        }
      }
    }
  a && Xu(o, a, s);
}
function rb(o) {
  let e = o.pmViewDesc;
  return e && e.node && e.node.isBlock;
}
function VC(o, e) {
  for (; o && e == o.childNodes.length && !rd(o); )
    e = bt(o) + 1, o = o.parentNode;
  for (; o && e < o.childNodes.length; ) {
    let r = o.childNodes[e];
    if (r.nodeType == 3)
      return r;
    if (r.nodeType == 1 && r.contentEditable == "false")
      break;
    o = r, e = 0;
  }
}
function zC(o, e) {
  for (; o && !e && !rd(o); )
    e = bt(o), o = o.parentNode;
  for (; o && e; ) {
    let r = o.childNodes[e - 1];
    if (r.nodeType == 3)
      return r;
    if (r.nodeType == 1 && r.contentEditable == "false")
      break;
    o = r, e = o.childNodes.length;
  }
}
function Xu(o, e, r) {
  if (e.nodeType != 3) {
    let a, s;
    (s = VC(e, r)) ? (e = s, r = 0) : (a = zC(e, r)) && (e = a, r = a.nodeValue.length);
  }
  let t = o.domSelection();
  if (!t)
    return;
  if (K0(t)) {
    let a = document.createRange();
    a.setEnd(e, r), a.setStart(e, r), t.removeAllRanges(), t.addRange(a);
  } else t.extend && t.extend(e, r);
  o.domObserver.setCurSelection();
  let { state: n } = o;
  setTimeout(() => {
    o.state == n && ad(o);
  }, 50);
}
function py(o, e) {
  let r = o.state.doc.resolve(e);
  if (!(Zr || xC) && r.parent.inlineContent) {
    let n = o.coordsAtPos(e);
    if (e > r.start()) {
      let a = o.coordsAtPos(e - 1), s = (a.top + a.bottom) / 2;
      if (s > n.top && s < n.bottom && Math.abs(a.left - n.left) > 1)
        return a.left < n.left ? "ltr" : "rtl";
    }
    if (e < r.end()) {
      let a = o.coordsAtPos(e + 1), s = (a.top + a.bottom) / 2;
      if (s > n.top && s < n.bottom && Math.abs(a.left - n.left) > 1)
        return a.left > n.left ? "ltr" : "rtl";
    }
  }
  return getComputedStyle(o.dom).direction == "rtl" ? "rtl" : "ltr";
}
function dy(o, e, r) {
  let t = o.state.selection;
  if (t instanceof Be && !t.empty || r.indexOf("s") > -1 || Wo && r.indexOf("m") > -1)
    return !1;
  let { $from: n, $to: a } = t;
  if (!n.parent.inlineContent || o.endOfTextblock(e < 0 ? "up" : "down")) {
    let s = Gu(o.state, e);
    if (s && s instanceof me)
      return Cr(o, s);
  }
  if (!n.parent.inlineContent) {
    let s = e < 0 ? n : a, i = t instanceof Eo ? we.near(s, e) : we.findFrom(s, e);
    return i ? Cr(o, i) : !1;
  }
  return !1;
}
function gy(o, e) {
  if (!(o.state.selection instanceof Be))
    return !0;
  let { $head: r, $anchor: t, empty: n } = o.state.selection;
  if (!r.sameParent(t))
    return !0;
  if (!n)
    return !1;
  if (o.endOfTextblock(e > 0 ? "forward" : "backward"))
    return !0;
  let a = !r.textOffset && (e < 0 ? r.nodeBefore : r.nodeAfter);
  if (a && !a.isText) {
    let s = o.state.tr;
    return e < 0 ? s.delete(r.pos - a.nodeSize, r.pos) : s.delete(r.pos, r.pos + a.nodeSize), o.dispatch(s), !0;
  }
  return !1;
}
function my(o, e, r) {
  o.domObserver.stop(), e.contentEditable = r, o.domObserver.start();
}
function IC(o) {
  if (!vt || o.state.selection.$head.parentOffset > 0)
    return !1;
  let { focusNode: e, focusOffset: r } = o.domSelectionRange();
  if (e && e.nodeType == 1 && r == 0 && e.firstChild && e.firstChild.contentEditable == "false") {
    let t = e.firstChild;
    my(o, t, "true"), setTimeout(() => my(o, t, "false"), 20);
  }
  return !1;
}
function RC(o) {
  let e = "";
  return o.ctrlKey && (e += "c"), o.metaKey && (e += "m"), o.altKey && (e += "a"), o.shiftKey && (e += "s"), e;
}
function HC(o, e) {
  let r = e.keyCode, t = RC(e);
  if (r == 8 || Wo && r == 72 && t == "c")
    return gy(o, -1) || Ct(o, -1);
  if (r == 46 && !e.shiftKey || Wo && r == 68 && t == "c")
    return gy(o, 1) || Ct(o, 1);
  if (r == 13 || r == 27)
    return !0;
  if (r == 37 || Wo && r == 66 && t == "c") {
    let n = r == 37 ? py(o, o.state.selection.from) == "ltr" ? -1 : 1 : -1;
    return uy(o, n, t) || Ct(o, n);
  } else if (r == 39 || Wo && r == 70 && t == "c") {
    let n = r == 39 ? py(o, o.state.selection.from) == "ltr" ? 1 : -1 : 1;
    return uy(o, n, t) || Ct(o, n);
  } else {
    if (r == 38 || Wo && r == 80 && t == "c")
      return dy(o, -1, t) || Ct(o, -1);
    if (r == 40 || Wo && r == 78 && t == "c")
      return IC(o) || dy(o, 1, t) || Ct(o, 1);
    if (t == (Wo ? "m" : "c") && (r == 66 || r == 73 || r == 89 || r == 90))
      return !0;
  }
  return !1;
}
function tb(o, e) {
  o.someProp("transformCopied", (d) => {
    e = d(e, o);
  });
  let r = [], { content: t, openStart: n, openEnd: a } = e;
  for (; n > 1 && a > 1 && t.childCount == 1 && t.firstChild.childCount == 1; ) {
    n--, a--;
    let d = t.firstChild;
    r.push(d.type.name, d.attrs != d.type.defaultAttrs ? d.attrs : null), t = d.content;
  }
  let s = o.someProp("clipboardSerializer") || zi.fromSchema(o.state.schema), i = cb(), l = i.createElement("div");
  l.appendChild(s.serializeFragment(t, { document: i }));
  let c = l.firstChild, u, f = 0;
  for (; c && c.nodeType == 1 && (u = lb[c.nodeName.toLowerCase()]); ) {
    for (let d = u.length - 1; d >= 0; d--) {
      let p = i.createElement(u[d]);
      for (; l.firstChild; )
        p.appendChild(l.firstChild);
      l.appendChild(p), f++;
    }
    c = l.firstChild;
  }
  c && c.nodeType == 1 && c.setAttribute("data-pm-slice", `${n} ${a}${f ? ` -${f}` : ""} ${JSON.stringify(r)}`);
  let g = o.someProp("clipboardTextSerializer", (d) => d(e, o)) || e.content.textBetween(0, e.content.size, `

`);
  return { dom: l, text: g, slice: e };
}
function nb(o, e, r, t, n) {
  let a = n.parent.type.spec.code, s, i;
  if (!r && !e)
    return null;
  let l = e && (t || a || !r);
  if (l) {
    if (o.someProp("transformPastedText", (g) => {
      e = g(e, a || t, o);
    }), a)
      return e ? new te($.from(o.state.schema.text(e.replace(/\r\n?/g, `
`))), 0, 0) : te.empty;
    let f = o.someProp("clipboardTextParser", (g) => g(e, n, t, o));
    if (f)
      i = f;
    else {
      let g = n.marks(), { schema: d } = o.state, p = zi.fromSchema(d);
      s = document.createElement("div"), e.split(/(?:\r\n?|\n)+/).forEach((m) => {
        let y = s.appendChild(document.createElement("p"));
        m && y.appendChild(p.serializeNode(d.text(m, g)));
      });
    }
  } else
    o.someProp("transformPastedHTML", (f) => {
      r = f(r, o);
    }), s = XC(r), nd && UC(s);
  let c = s && s.querySelector("[data-pm-slice]"), u = c && /^(\d+) (\d+)(?: -(\d+))? (.*)/.exec(c.getAttribute("data-pm-slice") || "");
  if (u && u[3])
    for (let f = +u[3]; f > 0; f--) {
      let g = s.firstChild;
      for (; g && g.nodeType != 1; )
        g = g.nextSibling;
      if (!g)
        break;
      s = g;
    }
  if (i || (i = (o.someProp("clipboardParser") || o.someProp("domParser") || lt.fromSchema(o.state.schema)).parseSlice(s, {
    preserveWhitespace: !!(l || u),
    context: n,
    ruleFromNode(g) {
      return g.nodeName == "BR" && !g.nextSibling && g.parentNode && !YC.test(g.parentNode.nodeName) ? { ignore: !0 } : null;
    }
  })), u)
    i = ZC(fy(i, +u[1], +u[2]), u[4]);
  else if (i = te.maxOpen(qC(i.content, n), !0), i.openStart || i.openEnd) {
    let f = 0, g = 0;
    for (let d = i.content.firstChild; f < i.openStart && !d.type.spec.isolating; f++, d = d.firstChild)
      ;
    for (let d = i.content.lastChild; g < i.openEnd && !d.type.spec.isolating; g++, d = d.lastChild)
      ;
    i = fy(i, f, g);
  }
  return o.someProp("transformPasted", (f) => {
    i = f(i, o);
  }), i;
}
const YC = /^(a|abbr|acronym|b|cite|code|del|em|i|ins|kbd|label|output|q|ruby|s|samp|span|strong|sub|sup|time|u|tt|var)$/i;
function qC(o, e) {
  if (o.childCount < 2)
    return o;
  for (let r = e.depth; r >= 0; r--) {
    let n = e.node(r).contentMatchAt(e.index(r)), a, s = [];
    if (o.forEach((i) => {
      if (!s)
        return;
      let l = n.findWrapping(i.type), c;
      if (!l)
        return s = null;
      if (c = s.length && a.length && sb(l, a, i, s[s.length - 1], 0))
        s[s.length - 1] = c;
      else {
        s.length && (s[s.length - 1] = ib(s[s.length - 1], a.length));
        let u = ab(i, l);
        s.push(u), n = n.matchType(u.type), a = l;
      }
    }), s)
      return $.from(s);
  }
  return o;
}
function ab(o, e, r = 0) {
  for (let t = e.length - 1; t >= r; t--)
    o = e[t].create(null, $.from(o));
  return o;
}
function sb(o, e, r, t, n) {
  if (n < o.length && n < e.length && o[n] == e[n]) {
    let a = sb(o, e, r, t.lastChild, n + 1);
    if (a)
      return t.copy(t.content.replaceChild(t.childCount - 1, a));
    if (t.contentMatchAt(t.childCount).matchType(n == o.length - 1 ? r.type : o[n + 1]))
      return t.copy(t.content.append($.from(ab(r, o, n + 1))));
  }
}
function ib(o, e) {
  if (e == 0)
    return o;
  let r = o.content.replaceChild(o.childCount - 1, ib(o.lastChild, e - 1)), t = o.contentMatchAt(o.childCount).fillBefore($.empty, !0);
  return o.copy(r.append(t));
}
function Uu(o, e, r, t, n, a) {
  let s = e < 0 ? o.firstChild : o.lastChild, i = s.content;
  return o.childCount > 1 && (a = 0), n < t - 1 && (i = Uu(i, e, r, t, n + 1, a)), n >= r && (i = e < 0 ? s.contentMatchAt(0).fillBefore(i, a <= n).append(i) : i.append(s.contentMatchAt(s.childCount).fillBefore($.empty, !0))), o.replaceChild(e < 0 ? 0 : o.childCount - 1, s.copy(i));
}
function fy(o, e, r) {
  return e < o.openStart && (o = new te(Uu(o.content, -1, e, o.openStart, 0, o.openEnd), e, o.openEnd)), r < o.openEnd && (o = new te(Uu(o.content, 1, r, o.openEnd, 0, 0), o.openStart, r)), o;
}
const lb = {
  thead: ["table"],
  tbody: ["table"],
  tfoot: ["table"],
  caption: ["table"],
  colgroup: ["table"],
  col: ["table", "colgroup"],
  tr: ["table", "tbody"],
  td: ["table", "tbody", "tr"],
  th: ["table", "tbody", "tr"]
};
let yy = null;
function cb() {
  return yy || (yy = document.implementation.createHTMLDocument("title"));
}
let yc = null;
function GC(o) {
  let e = window.trustedTypes;
  return e ? (yc || (yc = e.createPolicy("ProseMirrorClipboard", { createHTML: (r) => r })), yc.createHTML(o)) : o;
}
function XC(o) {
  let e = /^(\s*<meta [^>]*>)*/.exec(o);
  e && (o = o.slice(e[0].length));
  let r = cb().createElement("div"), t = /<([a-z][^>\s]+)/i.exec(o), n;
  if ((n = t && lb[t[1].toLowerCase()]) && (o = n.map((a) => "<" + a + ">").join("") + o + n.map((a) => "</" + a + ">").reverse().join("")), r.innerHTML = GC(o), n)
    for (let a = 0; a < n.length; a++)
      r = r.querySelector(n[a]) || r;
  return r;
}
function UC(o) {
  let e = o.querySelectorAll(Zr ? "span:not([class]):not([style])" : "span.Apple-converted-space");
  for (let r = 0; r < e.length; r++) {
    let t = e[r];
    t.childNodes.length == 1 && t.textContent == " " && t.parentNode && t.parentNode.replaceChild(o.ownerDocument.createTextNode(" "), t);
  }
}
function ZC(o, e) {
  if (!o.size)
    return o;
  let r = o.content.firstChild.type.schema, t;
  try {
    t = JSON.parse(e);
  } catch {
    return o;
  }
  let { content: n, openStart: a, openEnd: s } = o;
  for (let i = t.length - 2; i >= 0; i -= 2) {
    let l = r.nodes[t[i]];
    if (!l || l.hasRequiredAttrs())
      break;
    n = $.from(l.create(t[i + 1], n)), a++, s++;
  }
  return new te(n, a, s);
}
const Go = {}, xo = {};
function Mr(o, e) {
  o.input.lastSelectionOrigin = e, o.input.lastSelectionTime = Date.now();
}
xo.keydown = (o, e) => {
  let r = e;
  if (o.input.shiftKey = r.keyCode == 16 || r.shiftKey, !pb(o, r) && (o.input.lastKeyCode = r.keyCode, o.input.lastKeyCodeTime = Date.now(), !(Ja && Zr && r.keyCode == 13)))
    if (r.keyCode != 229 && o.domObserver.forceFlush(), td && r.keyCode == 13 && !r.ctrlKey && !r.altKey && !r.metaKey) {
      let t = Date.now();
      o.input.lastIOSEnter = t, o.input.lastIOSEnterFallbackTimeout = setTimeout(() => {
        o.input.lastIOSEnter == t && (o.someProp("handleKeyDown", (n) => n(o, Q0(13, "Enter"))), o.input.lastIOSEnter = 0);
      }, 200);
    } else o.someProp("handleKeyDown", (t) => t(o, r)) || HC(o, r) ? r.preventDefault() : Mr(o, "key");
};
xo.keyup = (o, e) => {
  e.keyCode == 16 && (o.input.shiftKey = !1);
};
xo.keypress = (o, e) => {
  let r = e;
  if (pb(o, r) || !r.charCode || r.ctrlKey && !r.altKey || Wo && r.metaKey)
    return;
  if (o.someProp("handleKeyPress", (n) => n(o, r))) {
    r.preventDefault();
    return;
  }
  let t = o.state.selection;
  if (!(t instanceof Be) || !t.$from.sameParent(t.$to)) {
    let n = String.fromCharCode(r.charCode);
    !/[\r\n]/.test(n) && !o.someProp("handleTextInput", (a) => a(o, t.$from.pos, t.$to.pos, n)) && o.dispatch(o.state.tr.insertText(n).scrollIntoView()), r.preventDefault();
  }
};
function qi(o) {
  return { left: o.clientX, top: o.clientY };
}
function KC(o, e) {
  let r = e.x - o.clientX, t = e.y - o.clientY;
  return r * r + t * t < 100;
}
function sd(o, e, r, t, n) {
  if (t == -1)
    return !1;
  let a = o.state.doc.resolve(t);
  for (let s = a.depth + 1; s > 0; s--)
    if (o.someProp(e, (i) => s > a.depth ? i(o, r, a.nodeAfter, a.before(s), n, !0) : i(o, r, a.node(s), a.before(s), n, !1)))
      return !0;
  return !1;
}
function Rt(o, e, r) {
  if (o.focused || o.focus(), o.state.selection.eq(e))
    return;
  let t = o.state.tr.setSelection(e);
  t.setMeta("pointer", !0), o.dispatch(t);
}
function QC(o, e) {
  if (e == -1)
    return !1;
  let r = o.state.doc.resolve(e), t = r.nodeAfter;
  return t && t.isAtom && me.isSelectable(t) ? (Rt(o, new me(r)), !0) : !1;
}
function JC(o, e) {
  if (e == -1)
    return !1;
  let r = o.state.selection, t, n;
  r instanceof me && (t = r.node);
  let a = o.state.doc.resolve(e);
  for (let s = a.depth + 1; s > 0; s--) {
    let i = s > a.depth ? a.nodeAfter : a.node(s);
    if (me.isSelectable(i)) {
      t && r.$from.depth > 0 && s >= r.$from.depth && a.before(r.$from.depth + 1) == r.$from.pos ? n = a.before(r.$from.depth) : n = a.before(s);
      break;
    }
  }
  return n != null ? (Rt(o, me.create(o.state.doc, n)), !0) : !1;
}
function _C(o, e, r, t, n) {
  return sd(o, "handleClickOn", e, r, t) || o.someProp("handleClick", (a) => a(o, e, t)) || (n ? JC(o, r) : QC(o, r));
}
function $C(o, e, r, t) {
  return sd(o, "handleDoubleClickOn", e, r, t) || o.someProp("handleDoubleClick", (n) => n(o, e, t));
}
function eO(o, e, r, t) {
  return sd(o, "handleTripleClickOn", e, r, t) || o.someProp("handleTripleClick", (n) => n(o, e, t)) || oO(o, r, t);
}
function oO(o, e, r) {
  if (r.button != 0)
    return !1;
  let t = o.state.doc;
  if (e == -1)
    return t.inlineContent ? (Rt(o, Be.create(t, 0, t.content.size)), !0) : !1;
  let n = t.resolve(e);
  for (let a = n.depth + 1; a > 0; a--) {
    let s = a > n.depth ? n.nodeAfter : n.node(a), i = n.before(a);
    if (s.inlineContent)
      Rt(o, Be.create(t, i + 1, i + 1 + s.content.size));
    else if (me.isSelectable(s))
      Rt(o, me.create(t, i));
    else
      continue;
    return !0;
  }
}
function id(o) {
  return di(o);
}
const ub = Wo ? "metaKey" : "ctrlKey";
Go.mousedown = (o, e) => {
  let r = e;
  o.input.shiftKey = r.shiftKey;
  let t = id(o), n = Date.now(), a = "singleClick";
  n - o.input.lastClick.time < 500 && KC(r, o.input.lastClick) && !r[ub] && (o.input.lastClick.type == "singleClick" ? a = "doubleClick" : o.input.lastClick.type == "doubleClick" && (a = "tripleClick")), o.input.lastClick = { time: n, x: r.clientX, y: r.clientY, type: a };
  let s = o.posAtCoords(qi(r));
  s && (a == "singleClick" ? (o.input.mouseDown && o.input.mouseDown.done(), o.input.mouseDown = new rO(o, s, r, !!t)) : (a == "doubleClick" ? $C : eO)(o, s.pos, s.inside, r) ? r.preventDefault() : Mr(o, "pointer"));
};
class rO {
  constructor(e, r, t, n) {
    this.view = e, this.pos = r, this.event = t, this.flushed = n, this.delayedSelectionSync = !1, this.mightDrag = null, this.startDoc = e.state.doc, this.selectNode = !!t[ub], this.allowDefault = t.shiftKey;
    let a, s;
    if (r.inside > -1)
      a = e.state.doc.nodeAt(r.inside), s = r.inside;
    else {
      let u = e.state.doc.resolve(r.pos);
      a = u.parent, s = u.depth ? u.before() : 0;
    }
    const i = n ? null : t.target, l = i ? e.docView.nearestDesc(i, !0) : null;
    this.target = l && l.dom.nodeType == 1 ? l.dom : null;
    let { selection: c } = e.state;
    (t.button == 0 && a.type.spec.draggable && a.type.spec.selectable !== !1 || c instanceof me && c.from <= s && c.to > s) && (this.mightDrag = {
      node: a,
      pos: s,
      addAttr: !!(this.target && !this.target.draggable),
      setUneditable: !!(this.target && Yi && !this.target.hasAttribute("contentEditable"))
    }), this.target && this.mightDrag && (this.mightDrag.addAttr || this.mightDrag.setUneditable) && (this.view.domObserver.stop(), this.mightDrag.addAttr && (this.target.draggable = !0), this.mightDrag.setUneditable && setTimeout(() => {
      this.view.input.mouseDown == this && this.target.setAttribute("contentEditable", "false");
    }, 20), this.view.domObserver.start()), e.root.addEventListener("mouseup", this.up = this.up.bind(this)), e.root.addEventListener("mousemove", this.move = this.move.bind(this)), Mr(e, "pointer");
  }
  done() {
    this.view.root.removeEventListener("mouseup", this.up), this.view.root.removeEventListener("mousemove", this.move), this.mightDrag && this.target && (this.view.domObserver.stop(), this.mightDrag.addAttr && this.target.removeAttribute("draggable"), this.mightDrag.setUneditable && this.target.removeAttribute("contentEditable"), this.view.domObserver.start()), this.delayedSelectionSync && setTimeout(() => ad(this.view)), this.view.input.mouseDown = null;
  }
  up(e) {
    if (this.done(), !this.view.dom.contains(e.target))
      return;
    let r = this.pos;
    this.view.state.doc != this.startDoc && (r = this.view.posAtCoords(qi(e))), this.updateAllowDefault(e), this.allowDefault || !r ? Mr(this.view, "pointer") : _C(this.view, r.pos, r.inside, e, this.selectNode) ? e.preventDefault() : e.button == 0 && (this.flushed || // Safari ignores clicks on draggable elements
    vt && this.mightDrag && !this.mightDrag.node.isAtom || // Chrome will sometimes treat a node selection as a
    // cursor, but still report that the node is selected
    // when asked through getSelection. You'll then get a
    // situation where clicking at the point where that
    // (hidden) cursor is doesn't change the selection, and
    // thus doesn't get a reaction from ProseMirror. This
    // works around that.
    Zr && !this.view.state.selection.visible && Math.min(Math.abs(r.pos - this.view.state.selection.from), Math.abs(r.pos - this.view.state.selection.to)) <= 2) ? (Rt(this.view, we.near(this.view.state.doc.resolve(r.pos))), e.preventDefault()) : Mr(this.view, "pointer");
  }
  move(e) {
    this.updateAllowDefault(e), Mr(this.view, "pointer"), e.buttons == 0 && this.done();
  }
  updateAllowDefault(e) {
    !this.allowDefault && (Math.abs(this.event.x - e.clientX) > 4 || Math.abs(this.event.y - e.clientY) > 4) && (this.allowDefault = !0);
  }
}
Go.touchstart = (o) => {
  o.input.lastTouch = Date.now(), id(o), Mr(o, "pointer");
};
Go.touchmove = (o) => {
  o.input.lastTouch = Date.now(), Mr(o, "pointer");
};
Go.contextmenu = (o) => id(o);
function pb(o, e) {
  return o.composing ? !0 : vt && Math.abs(e.timeStamp - o.input.compositionEndedAt) < 500 ? (o.input.compositionEndedAt = -2e8, !0) : !1;
}
const tO = Ja ? 5e3 : -1;
xo.compositionstart = xo.compositionupdate = (o) => {
  if (!o.composing) {
    o.domObserver.flush();
    let { state: e } = o, r = e.selection.$to;
    if (e.selection instanceof Be && (e.storedMarks || !r.textOffset && r.parentOffset && r.nodeBefore.marks.some((t) => t.type.spec.inclusive === !1)))
      o.markCursor = o.state.storedMarks || r.marks(), di(o, !0), o.markCursor = null;
    else if (di(o, !e.selection.empty), Yi && e.selection.empty && r.parentOffset && !r.textOffset && r.nodeBefore.marks.length) {
      let t = o.domSelectionRange();
      for (let n = t.focusNode, a = t.focusOffset; n && n.nodeType == 1 && a != 0; ) {
        let s = a < 0 ? n.lastChild : n.childNodes[a - 1];
        if (!s)
          break;
        if (s.nodeType == 3) {
          let i = o.domSelection();
          i && i.collapse(s, s.nodeValue.length);
          break;
        } else
          n = s, a = -1;
      }
    }
    o.input.composing = !0;
  }
  db(o, tO);
};
xo.compositionend = (o, e) => {
  o.composing && (o.input.composing = !1, o.input.compositionEndedAt = e.timeStamp, o.input.compositionPendingChanges = o.domObserver.pendingRecords().length ? o.input.compositionID : 0, o.input.compositionNode = null, o.input.compositionPendingChanges && Promise.resolve().then(() => o.domObserver.flush()), o.input.compositionID++, db(o, 20));
};
function db(o, e) {
  clearTimeout(o.input.composingTimeout), e > -1 && (o.input.composingTimeout = setTimeout(() => di(o), e));
}
function nO(o) {
  for (o.composing && (o.input.composing = !1, o.input.compositionEndedAt = aO()); o.input.compositionNodes.length > 0; )
    o.input.compositionNodes.pop().markParentsDirty();
}
function aO() {
  let o = document.createEvent("Event");
  return o.initEvent("event", !0, !0), o.timeStamp;
}
function di(o, e = !1) {
  if (!(Ja && o.domObserver.flushingSoon >= 0)) {
    if (o.domObserver.forceFlush(), nO(o), e || o.docView && o.docView.dirty) {
      let r = OC(o);
      return r && !r.eq(o.state.selection) ? o.dispatch(o.state.tr.setSelection(r)) : (o.markCursor || e) && !o.state.selection.empty ? o.dispatch(o.state.tr.deleteSelection()) : o.updateState(o.state), !0;
    }
    return !1;
  }
}
function sO(o, e) {
  if (!o.dom.parentNode)
    return;
  let r = o.dom.parentNode.appendChild(document.createElement("div"));
  r.appendChild(e), r.style.cssText = "position: fixed; left: -10000px; top: 10px";
  let t = getSelection(), n = document.createRange();
  n.selectNodeContents(e), o.dom.blur(), t.removeAllRanges(), t.addRange(n), setTimeout(() => {
    r.parentNode && r.parentNode.removeChild(r), o.focus();
  }, 50);
}
const Ta = Qa && _0 < 15 || td && CC < 604;
Go.copy = xo.cut = (o, e) => {
  let r = e, t = o.state.selection, n = r.type == "cut";
  if (t.empty)
    return;
  let a = Ta ? null : r.clipboardData, s = t.content(), { dom: i, text: l } = tb(o, s);
  a ? (r.preventDefault(), a.clearData(), a.setData("text/html", i.innerHTML), a.setData("text/plain", l)) : sO(o, i), n && o.dispatch(o.state.tr.deleteSelection().scrollIntoView().setMeta("uiEvent", "cut"));
};
function iO(o) {
  return o.openStart == 0 && o.openEnd == 0 && o.content.childCount == 1 ? o.content.firstChild : null;
}
function lO(o, e) {
  if (!o.dom.parentNode)
    return;
  let r = o.input.shiftKey || o.state.selection.$from.parent.type.spec.code, t = o.dom.parentNode.appendChild(document.createElement(r ? "textarea" : "div"));
  r || (t.contentEditable = "true"), t.style.cssText = "position: fixed; left: -10000px; top: 10px", t.focus();
  let n = o.input.shiftKey && o.input.lastKeyCode != 45;
  setTimeout(() => {
    o.focus(), t.parentNode && t.parentNode.removeChild(t), r ? Zu(o, t.value, null, n, e) : Zu(o, t.textContent, t.innerHTML, n, e);
  }, 50);
}
function Zu(o, e, r, t, n) {
  let a = nb(o, e, r, t, o.state.selection.$from);
  if (o.someProp("handlePaste", (l) => l(o, n, a || te.empty)))
    return !0;
  if (!a)
    return !1;
  let s = iO(a), i = s ? o.state.tr.replaceSelectionWith(s, t) : o.state.tr.replaceSelection(a);
  return o.dispatch(i.scrollIntoView().setMeta("paste", !0).setMeta("uiEvent", "paste")), !0;
}
function gb(o) {
  let e = o.getData("text/plain") || o.getData("Text");
  if (e)
    return e;
  let r = o.getData("text/uri-list");
  return r ? r.replace(/\r?\n/g, " ") : "";
}
xo.paste = (o, e) => {
  let r = e;
  if (o.composing && !Ja)
    return;
  let t = Ta ? null : r.clipboardData, n = o.input.shiftKey && o.input.lastKeyCode != 45;
  t && Zu(o, gb(t), t.getData("text/html"), n, r) ? r.preventDefault() : lO(o, r);
};
class cO {
  constructor(e, r, t) {
    this.slice = e, this.move = r, this.node = t;
  }
}
const uO = Wo ? "altKey" : "ctrlKey";
function mb(o, e) {
  let r = o.someProp("dragCopies", (t) => !t(e));
  return r ?? !e[uO];
}
Go.dragstart = (o, e) => {
  let r = e, t = o.input.mouseDown;
  if (t && t.done(), !r.dataTransfer)
    return;
  let n = o.state.selection, a = n.empty ? null : o.posAtCoords(qi(r)), s;
  if (!(a && a.pos >= n.from && a.pos <= (n instanceof me ? n.to - 1 : n.to))) {
    if (t && t.mightDrag)
      s = me.create(o.state.doc, t.mightDrag.pos);
    else if (r.target && r.target.nodeType == 1) {
      let f = o.docView.nearestDesc(r.target, !0);
      f && f.node.type.spec.draggable && f != o.docView && (s = me.create(o.state.doc, f.posBefore));
    }
  }
  let i = (s || o.state.selection).content(), { dom: l, text: c, slice: u } = tb(o, i);
  (!r.dataTransfer.files.length || !Zr || $0 > 120) && r.dataTransfer.clearData(), r.dataTransfer.setData(Ta ? "Text" : "text/html", l.innerHTML), r.dataTransfer.effectAllowed = "copyMove", Ta || r.dataTransfer.setData("text/plain", c), o.dragging = new cO(u, mb(o, r), s);
};
Go.dragend = (o) => {
  let e = o.dragging;
  window.setTimeout(() => {
    o.dragging == e && (o.dragging = null);
  }, 50);
};
xo.dragover = xo.dragenter = (o, e) => e.preventDefault();
xo.drop = (o, e) => {
  let r = e, t = o.dragging;
  if (o.dragging = null, !r.dataTransfer)
    return;
  let n = o.posAtCoords(qi(r));
  if (!n)
    return;
  let a = o.state.doc.resolve(n.pos), s = t && t.slice;
  s ? o.someProp("transformPasted", (p) => {
    s = p(s, o);
  }) : s = nb(o, gb(r.dataTransfer), Ta ? null : r.dataTransfer.getData("text/html"), !1, a);
  let i = !!(t && mb(o, r));
  if (o.someProp("handleDrop", (p) => p(o, r, s || te.empty, i))) {
    r.preventDefault();
    return;
  }
  if (!s)
    return;
  r.preventDefault();
  let l = s ? Jx(o.state.doc, a.pos, s) : a.pos;
  l == null && (l = a.pos);
  let c = o.state.tr;
  if (i) {
    let { node: p } = t;
    p ? p.replace(c) : c.deleteSelection();
  }
  let u = c.mapping.map(l), f = s.openStart == 0 && s.openEnd == 0 && s.content.childCount == 1, g = c.doc;
  if (f ? c.replaceRangeWith(u, u, s.content.firstChild) : c.replaceRange(u, u, s), c.doc.eq(g))
    return;
  let d = c.doc.resolve(u);
  if (f && me.isSelectable(s.content.firstChild) && d.nodeAfter && d.nodeAfter.sameMarkup(s.content.firstChild))
    c.setSelection(new me(d));
  else {
    let p = c.mapping.map(l);
    c.mapping.maps[c.mapping.maps.length - 1].forEach((m, y, h, F) => p = F), c.setSelection(ob(o, d, c.doc.resolve(p)));
  }
  o.focus(), o.dispatch(c.setMeta("uiEvent", "drop"));
};
Go.focus = (o) => {
  o.input.lastFocus = Date.now(), o.focused || (o.domObserver.stop(), o.dom.classList.add("ProseMirror-focused"), o.domObserver.start(), o.focused = !0, setTimeout(() => {
    o.docView && o.hasFocus() && !o.domObserver.currentSelection.eq(o.domSelectionRange()) && ad(o);
  }, 20));
};
Go.blur = (o, e) => {
  let r = e;
  o.focused && (o.domObserver.stop(), o.dom.classList.remove("ProseMirror-focused"), o.domObserver.start(), r.relatedTarget && o.dom.contains(r.relatedTarget) && o.domObserver.currentSelection.clear(), o.focused = !1);
};
Go.beforeinput = (o, e) => {
  if (Zr && Ja && e.inputType == "deleteContentBackward") {
    o.domObserver.flushSoon();
    let { domChangeCount: t } = o.input;
    setTimeout(() => {
      if (o.input.domChangeCount != t || (o.dom.blur(), o.focus(), o.someProp("handleKeyDown", (a) => a(o, Q0(8, "Backspace")))))
        return;
      let { $cursor: n } = o.state.selection;
      n && n.pos > 0 && o.dispatch(o.state.tr.delete(n.pos - 1, n.pos).scrollIntoView());
    }, 50);
  }
};
for (let o in xo)
  Go[o] = xo[o];
function La(o, e) {
  if (o == e)
    return !0;
  for (let r in o)
    if (o[r] !== e[r])
      return !1;
  for (let r in e)
    if (!(r in o))
      return !1;
  return !0;
}
class gi {
  constructor(e, r) {
    this.toDOM = e, this.spec = r || ct, this.side = this.spec.side || 0;
  }
  map(e, r, t, n) {
    let { pos: a, deleted: s } = e.mapResult(r.from + n, this.side < 0 ? -1 : 1);
    return s ? null : new or(a - t, a - t, this);
  }
  valid() {
    return !0;
  }
  eq(e) {
    return this == e || e instanceof gi && (this.spec.key && this.spec.key == e.spec.key || this.toDOM == e.toDOM && La(this.spec, e.spec));
  }
  destroy(e) {
    this.spec.destroy && this.spec.destroy(e);
  }
}
class Wr {
  constructor(e, r) {
    this.attrs = e, this.spec = r || ct;
  }
  map(e, r, t, n) {
    let a = e.map(r.from + n, this.spec.inclusiveStart ? -1 : 1) - t, s = e.map(r.to + n, this.spec.inclusiveEnd ? 1 : -1) - t;
    return a >= s ? null : new or(a, s, this);
  }
  valid(e, r) {
    return r.from < r.to;
  }
  eq(e) {
    return this == e || e instanceof Wr && La(this.attrs, e.attrs) && La(this.spec, e.spec);
  }
  static is(e) {
    return e.type instanceof Wr;
  }
  destroy() {
  }
}
class ld {
  constructor(e, r) {
    this.attrs = e, this.spec = r || ct;
  }
  map(e, r, t, n) {
    let a = e.mapResult(r.from + n, 1);
    if (a.deleted)
      return null;
    let s = e.mapResult(r.to + n, -1);
    return s.deleted || s.pos <= a.pos ? null : new or(a.pos - t, s.pos - t, this);
  }
  valid(e, r) {
    let { index: t, offset: n } = e.content.findIndex(r.from), a;
    return n == r.from && !(a = e.child(t)).isText && n + a.nodeSize == r.to;
  }
  eq(e) {
    return this == e || e instanceof ld && La(this.attrs, e.attrs) && La(this.spec, e.spec);
  }
  destroy() {
  }
}
class or {
  /**
  @internal
  */
  constructor(e, r, t) {
    this.from = e, this.to = r, this.type = t;
  }
  /**
  @internal
  */
  copy(e, r) {
    return new or(e, r, this.type);
  }
  /**
  @internal
  */
  eq(e, r = 0) {
    return this.type.eq(e.type) && this.from + r == e.from && this.to + r == e.to;
  }
  /**
  @internal
  */
  map(e, r, t) {
    return this.type.map(e, this, r, t);
  }
  /**
  Creates a widget decoration, which is a DOM node that's shown in
  the document at the given position. It is recommended that you
  delay rendering the widget by passing a function that will be
  called when the widget is actually drawn in a view, but you can
  also directly pass a DOM node. `getPos` can be used to find the
  widget's current document position.
  */
  static widget(e, r, t) {
    return new or(e, e, new gi(r, t));
  }
  /**
  Creates an inline decoration, which adds the given attributes to
  each inline node between `from` and `to`.
  */
  static inline(e, r, t, n) {
    return new or(e, r, new Wr(t, n));
  }
  /**
  Creates a node decoration. `from` and `to` should point precisely
  before and after a node in the document. That node, and only that
  node, will receive the given attributes.
  */
  static node(e, r, t, n) {
    return new or(e, r, new ld(t, n));
  }
  /**
  The spec provided when creating this decoration. Can be useful
  if you've stored extra information in that object.
  */
  get spec() {
    return this.type.spec;
  }
  /**
  @internal
  */
  get inline() {
    return this.type instanceof Wr;
  }
  /**
  @internal
  */
  get widget() {
    return this.type instanceof gi;
  }
}
const Lt = [], ct = {};
class Ze {
  /**
  @internal
  */
  constructor(e, r) {
    this.local = e.length ? e : Lt, this.children = r.length ? r : Lt;
  }
  /**
  Create a set of decorations, using the structure of the given
  document. This will consume (modify) the `decorations` array, so
  you must make a copy if you want need to preserve that.
  */
  static create(e, r) {
    return r.length ? mi(r, e, 0, ct) : mo;
  }
  /**
  Find all decorations in this set which touch the given range
  (including decorations that start or end directly at the
  boundaries) and match the given predicate on their spec. When
  `start` and `end` are omitted, all decorations in the set are
  considered. When `predicate` isn't given, all decorations are
  assumed to match.
  */
  find(e, r, t) {
    let n = [];
    return this.findInner(e ?? 0, r ?? 1e9, n, 0, t), n;
  }
  findInner(e, r, t, n, a) {
    for (let s = 0; s < this.local.length; s++) {
      let i = this.local[s];
      i.from <= r && i.to >= e && (!a || a(i.spec)) && t.push(i.copy(i.from + n, i.to + n));
    }
    for (let s = 0; s < this.children.length; s += 3)
      if (this.children[s] < r && this.children[s + 1] > e) {
        let i = this.children[s] + 1;
        this.children[s + 2].findInner(e - i, r - i, t, n + i, a);
      }
  }
  /**
  Map the set of decorations in response to a change in the
  document.
  */
  map(e, r, t) {
    return this == mo || e.maps.length == 0 ? this : this.mapInner(e, r, 0, 0, t || ct);
  }
  /**
  @internal
  */
  mapInner(e, r, t, n, a) {
    let s;
    for (let i = 0; i < this.local.length; i++) {
      let l = this.local[i].map(e, t, n);
      l && l.type.valid(r, l) ? (s || (s = [])).push(l) : a.onRemove && a.onRemove(this.local[i].spec);
    }
    return this.children.length ? pO(this.children, s || [], e, r, t, n, a) : s ? new Ze(s.sort(ut), Lt) : mo;
  }
  /**
  Add the given array of decorations to the ones in the set,
  producing a new set. Consumes the `decorations` array. Needs
  access to the current document to create the appropriate tree
  structure.
  */
  add(e, r) {
    return r.length ? this == mo ? Ze.create(e, r) : this.addInner(e, r, 0) : this;
  }
  addInner(e, r, t) {
    let n, a = 0;
    e.forEach((i, l) => {
      let c = l + t, u;
      if (u = yb(r, i, c)) {
        for (n || (n = this.children.slice()); a < n.length && n[a] < l; )
          a += 3;
        n[a] == l ? n[a + 2] = n[a + 2].addInner(i, u, c + 1) : n.splice(a, 0, l, l + i.nodeSize, mi(u, i, c + 1, ct)), a += 3;
      }
    });
    let s = fb(a ? hb(r) : r, -t);
    for (let i = 0; i < s.length; i++)
      s[i].type.valid(e, s[i]) || s.splice(i--, 1);
    return new Ze(s.length ? this.local.concat(s).sort(ut) : this.local, n || this.children);
  }
  /**
  Create a new set that contains the decorations in this set, minus
  the ones in the given array.
  */
  remove(e) {
    return e.length == 0 || this == mo ? this : this.removeInner(e, 0);
  }
  removeInner(e, r) {
    let t = this.children, n = this.local;
    for (let a = 0; a < t.length; a += 3) {
      let s, i = t[a] + r, l = t[a + 1] + r;
      for (let u = 0, f; u < e.length; u++)
        (f = e[u]) && f.from > i && f.to < l && (e[u] = null, (s || (s = [])).push(f));
      if (!s)
        continue;
      t == this.children && (t = this.children.slice());
      let c = t[a + 2].removeInner(s, i + 1);
      c != mo ? t[a + 2] = c : (t.splice(a, 3), a -= 3);
    }
    if (n.length) {
      for (let a = 0, s; a < e.length; a++)
        if (s = e[a])
          for (let i = 0; i < n.length; i++)
            n[i].eq(s, r) && (n == this.local && (n = this.local.slice()), n.splice(i--, 1));
    }
    return t == this.children && n == this.local ? this : n.length || t.length ? new Ze(n, t) : mo;
  }
  forChild(e, r) {
    if (this == mo)
      return this;
    if (r.isLeaf)
      return Ze.empty;
    let t, n;
    for (let i = 0; i < this.children.length; i += 3)
      if (this.children[i] >= e) {
        this.children[i] == e && (t = this.children[i + 2]);
        break;
      }
    let a = e + 1, s = a + r.content.size;
    for (let i = 0; i < this.local.length; i++) {
      let l = this.local[i];
      if (l.from < s && l.to > a && l.type instanceof Wr) {
        let c = Math.max(a, l.from) - a, u = Math.min(s, l.to) - a;
        c < u && (n || (n = [])).push(l.copy(c, u));
      }
    }
    if (n) {
      let i = new Ze(n.sort(ut), Lt);
      return t ? new $r([i, t]) : i;
    }
    return t || mo;
  }
  /**
  @internal
  */
  eq(e) {
    if (this == e)
      return !0;
    if (!(e instanceof Ze) || this.local.length != e.local.length || this.children.length != e.children.length)
      return !1;
    for (let r = 0; r < this.local.length; r++)
      if (!this.local[r].eq(e.local[r]))
        return !1;
    for (let r = 0; r < this.children.length; r += 3)
      if (this.children[r] != e.children[r] || this.children[r + 1] != e.children[r + 1] || !this.children[r + 2].eq(e.children[r + 2]))
        return !1;
    return !0;
  }
  /**
  @internal
  */
  locals(e) {
    return cd(this.localsInner(e));
  }
  /**
  @internal
  */
  localsInner(e) {
    if (this == mo)
      return Lt;
    if (e.inlineContent || !this.local.some(Wr.is))
      return this.local;
    let r = [];
    for (let t = 0; t < this.local.length; t++)
      this.local[t].type instanceof Wr || r.push(this.local[t]);
    return r;
  }
  forEachSet(e) {
    e(this);
  }
}
Ze.empty = new Ze([], []);
Ze.removeOverlap = cd;
const mo = Ze.empty;
class $r {
  constructor(e) {
    this.members = e;
  }
  map(e, r) {
    const t = this.members.map((n) => n.map(e, r, ct));
    return $r.from(t);
  }
  forChild(e, r) {
    if (r.isLeaf)
      return Ze.empty;
    let t = [];
    for (let n = 0; n < this.members.length; n++) {
      let a = this.members[n].forChild(e, r);
      a != mo && (a instanceof $r ? t = t.concat(a.members) : t.push(a));
    }
    return $r.from(t);
  }
  eq(e) {
    if (!(e instanceof $r) || e.members.length != this.members.length)
      return !1;
    for (let r = 0; r < this.members.length; r++)
      if (!this.members[r].eq(e.members[r]))
        return !1;
    return !0;
  }
  locals(e) {
    let r, t = !0;
    for (let n = 0; n < this.members.length; n++) {
      let a = this.members[n].localsInner(e);
      if (a.length)
        if (!r)
          r = a;
        else {
          t && (r = r.slice(), t = !1);
          for (let s = 0; s < a.length; s++)
            r.push(a[s]);
        }
    }
    return r ? cd(t ? r : r.sort(ut)) : Lt;
  }
  // Create a group for the given array of decoration sets, or return
  // a single set when possible.
  static from(e) {
    switch (e.length) {
      case 0:
        return mo;
      case 1:
        return e[0];
      default:
        return new $r(e.every((r) => r instanceof Ze) ? e : e.reduce((r, t) => r.concat(t instanceof Ze ? t : t.members), []));
    }
  }
  forEachSet(e) {
    for (let r = 0; r < this.members.length; r++)
      this.members[r].forEachSet(e);
  }
}
function pO(o, e, r, t, n, a, s) {
  let i = o.slice();
  for (let c = 0, u = a; c < r.maps.length; c++) {
    let f = 0;
    r.maps[c].forEach((g, d, p, m) => {
      let y = m - p - (d - g);
      for (let h = 0; h < i.length; h += 3) {
        let F = i[h + 1];
        if (F < 0 || g > F + u - f)
          continue;
        let b = i[h] + u - f;
        d >= b ? i[h + 1] = g <= b ? -2 : -1 : g >= u && y && (i[h] += y, i[h + 1] += y);
      }
      f += y;
    }), u = r.maps[c].map(u, -1);
  }
  let l = !1;
  for (let c = 0; c < i.length; c += 3)
    if (i[c + 1] < 0) {
      if (i[c + 1] == -2) {
        l = !0, i[c + 1] = -1;
        continue;
      }
      let u = r.map(o[c] + a), f = u - n;
      if (f < 0 || f >= t.content.size) {
        l = !0;
        continue;
      }
      let g = r.map(o[c + 1] + a, -1), d = g - n, { index: p, offset: m } = t.content.findIndex(f), y = t.maybeChild(p);
      if (y && m == f && m + y.nodeSize == d) {
        let h = i[c + 2].mapInner(r, y, u + 1, o[c] + a + 1, s);
        h != mo ? (i[c] = f, i[c + 1] = d, i[c + 2] = h) : (i[c + 1] = -2, l = !0);
      } else
        l = !0;
    }
  if (l) {
    let c = dO(i, o, e, r, n, a, s), u = mi(c, t, 0, s);
    e = u.local;
    for (let f = 0; f < i.length; f += 3)
      i[f + 1] < 0 && (i.splice(f, 3), f -= 3);
    for (let f = 0, g = 0; f < u.children.length; f += 3) {
      let d = u.children[f];
      for (; g < i.length && i[g] < d; )
        g += 3;
      i.splice(g, 0, u.children[f], u.children[f + 1], u.children[f + 2]);
    }
  }
  return new Ze(e.sort(ut), i);
}
function fb(o, e) {
  if (!e || !o.length)
    return o;
  let r = [];
  for (let t = 0; t < o.length; t++) {
    let n = o[t];
    r.push(new or(n.from + e, n.to + e, n.type));
  }
  return r;
}
function dO(o, e, r, t, n, a, s) {
  function i(l, c) {
    for (let u = 0; u < l.local.length; u++) {
      let f = l.local[u].map(t, n, c);
      f ? r.push(f) : s.onRemove && s.onRemove(l.local[u].spec);
    }
    for (let u = 0; u < l.children.length; u += 3)
      i(l.children[u + 2], l.children[u] + c + 1);
  }
  for (let l = 0; l < o.length; l += 3)
    o[l + 1] == -1 && i(o[l + 2], e[l] + a + 1);
  return r;
}
function yb(o, e, r) {
  if (e.isLeaf)
    return null;
  let t = r + e.nodeSize, n = null;
  for (let a = 0, s; a < o.length; a++)
    (s = o[a]) && s.from > r && s.to < t && ((n || (n = [])).push(s), o[a] = null);
  return n;
}
function hb(o) {
  let e = [];
  for (let r = 0; r < o.length; r++)
    o[r] != null && e.push(o[r]);
  return e;
}
function mi(o, e, r, t) {
  let n = [], a = !1;
  e.forEach((i, l) => {
    let c = yb(o, i, l + r);
    if (c) {
      a = !0;
      let u = mi(c, i, r + l + 1, t);
      u != mo && n.push(l, l + i.nodeSize, u);
    }
  });
  let s = fb(a ? hb(o) : o, -r).sort(ut);
  for (let i = 0; i < s.length; i++)
    s[i].type.valid(e, s[i]) || (t.onRemove && t.onRemove(s[i].spec), s.splice(i--, 1));
  return s.length || n.length ? new Ze(s, n) : mo;
}
function ut(o, e) {
  return o.from - e.from || o.to - e.to;
}
function cd(o) {
  let e = o;
  for (let r = 0; r < e.length - 1; r++) {
    let t = e[r];
    if (t.from != t.to)
      for (let n = r + 1; n < e.length; n++) {
        let a = e[n];
        if (a.from == t.from) {
          a.to != t.to && (e == o && (e = o.slice()), e[n] = a.copy(a.from, t.to), hy(e, n + 1, a.copy(t.to, a.to)));
          continue;
        } else {
          a.from < t.to && (e == o && (e = o.slice()), e[r] = t.copy(t.from, a.from), hy(e, n, t.copy(a.from, t.to)));
          break;
        }
      }
  }
  return e;
}
function hy(o, e, r) {
  for (; e < o.length && ut(r, o[e]) > 0; )
    e++;
  o.splice(e, 0, r);
}
var gO = Object.defineProperty, ud = (o, e) => {
  for (var r in e)
    gO(o, r, { get: e[r], enumerable: !0 });
};
function Fb(o) {
  const { state: e, transaction: r } = o;
  let { selection: t } = r, { doc: n } = r, { storedMarks: a } = r;
  return {
    ...e,
    apply: e.apply.bind(e),
    applyTransaction: e.applyTransaction.bind(e),
    plugins: e.plugins,
    schema: e.schema,
    reconfigure: e.reconfigure.bind(e),
    toJSON: e.toJSON.bind(e),
    get storedMarks() {
      return a;
    },
    get selection() {
      return t;
    },
    get doc() {
      return n;
    },
    get tr() {
      return t = r.selection, n = r.doc, a = r.storedMarks, r;
    }
  };
}
var mO = class {
  constructor(o) {
    this.editor = o.editor, this.rawCommands = this.editor.extensionManager.commands, this.customState = o.state;
  }
  get hasCustomState() {
    return !!this.customState;
  }
  get state() {
    return this.customState || this.editor.state;
  }
  get commands() {
    const { rawCommands: o, editor: e, state: r } = this, { view: t } = e, { tr: n } = r, a = this.buildProps(n);
    return Object.fromEntries(
      Object.entries(o).map(([s, i]) => [s, (...c) => {
        const u = i(...c)(a);
        return !n.getMeta("preventDispatch") && !this.hasCustomState && t.dispatch(n), u;
      }])
    );
  }
  get chain() {
    return () => this.createChain();
  }
  get can() {
    return () => this.createCan();
  }
  createChain(o, e = !0) {
    const { rawCommands: r, editor: t, state: n } = this, { view: a } = t, s = [], i = !!o, l = o || n.tr, c = () => (!i && e && !l.getMeta("preventDispatch") && !this.hasCustomState && a.dispatch(l), s.every((f) => f === !0)), u = {
      ...Object.fromEntries(
        Object.entries(r).map(([f, g]) => [f, (...p) => {
          const m = this.buildProps(l, e), y = g(...p)(m);
          return s.push(y), u;
        }])
      ),
      run: c
    };
    return u;
  }
  createCan(o) {
    const { rawCommands: e, state: r } = this, t = !1, n = o || r.tr, a = this.buildProps(n, t);
    return {
      ...Object.fromEntries(
        Object.entries(e).map(([i, l]) => [i, (...c) => l(...c)({ ...a, dispatch: void 0 })])
      ),
      chain: () => this.createChain(n, t)
    };
  }
  buildProps(o, e = !0) {
    const { rawCommands: r, editor: t, state: n } = this, { view: a } = t, s = {
      tr: o,
      editor: t,
      view: a,
      state: Fb({
        state: n,
        transaction: o
      }),
      dispatch: e ? () => {
      } : void 0,
      chain: () => this.createChain(o, e),
      can: () => this.createCan(o),
      get commands() {
        return Object.fromEntries(
          Object.entries(r).map(([i, l]) => [i, (...c) => l(...c)(s)])
        );
      }
    };
    return s;
  }
}, bb = {};
ud(bb, {
  blur: () => fO,
  clearContent: () => yO,
  clearNodes: () => hO,
  command: () => FO,
  createParagraphNear: () => bO,
  cut: () => vO,
  deleteCurrentNode: () => BO,
  deleteNode: () => PO,
  deleteRange: () => wO,
  deleteSelection: () => kO,
  enter: () => DO,
  exitCode: () => SO,
  extendMarkRange: () => EO,
  first: () => xO,
  focus: () => TO,
  forEach: () => LO,
  insertContent: () => jO,
  insertContentAt: () => NO,
  joinBackward: () => IO,
  joinDown: () => zO,
  joinForward: () => RO,
  joinItemBackward: () => HO,
  joinItemForward: () => YO,
  joinTextblockBackward: () => qO,
  joinTextblockForward: () => GO,
  joinUp: () => VO,
  keyboardShortcut: () => UO,
  lift: () => ZO,
  liftEmptyBlock: () => KO,
  liftListItem: () => QO,
  newlineInCode: () => JO,
  resetAttributes: () => _O,
  scrollIntoView: () => $O,
  selectAll: () => eT,
  selectNodeBackward: () => oT,
  selectNodeForward: () => rT,
  selectParentNode: () => tT,
  selectTextblockEnd: () => nT,
  selectTextblockStart: () => aT,
  setContent: () => iT,
  setMark: () => BT,
  setMeta: () => PT,
  setNode: () => wT,
  setNodeSelection: () => kT,
  setTextSelection: () => DT,
  sinkListItem: () => ST,
  splitBlock: () => AT,
  splitListItem: () => ET,
  toggleList: () => xT,
  toggleMark: () => CT,
  toggleNode: () => OT,
  toggleWrap: () => TT,
  undoInputRule: () => LT,
  unsetAllMarks: () => jT,
  unsetMark: () => MT,
  updateAttributes: () => WT,
  wrapIn: () => NT,
  wrapInList: () => VT
});
var fO = () => ({ editor: o, view: e }) => (requestAnimationFrame(() => {
  var r;
  o.isDestroyed || (e.dom.blur(), (r = window == null ? void 0 : window.getSelection()) == null || r.removeAllRanges());
}), !0), yO = (o = !0) => ({ commands: e }) => e.setContent("", { emitUpdate: o }), hO = () => ({ state: o, tr: e, dispatch: r }) => {
  const { selection: t } = e, { ranges: n } = t;
  return r && n.forEach(({ $from: a, $to: s }) => {
    o.doc.nodesBetween(a.pos, s.pos, (i, l) => {
      if (i.type.isText)
        return;
      const { doc: c, mapping: u } = e, f = c.resolve(u.map(l)), g = c.resolve(u.map(l + i.nodeSize)), d = f.blockRange(g);
      if (!d)
        return;
      const p = nn(d);
      if (i.type.isTextblock) {
        const { defaultType: m } = f.parent.contentMatchAt(f.index());
        e.setNodeMarkup(d.start, m);
      }
      (p || p === 0) && e.lift(d, p);
    });
  }), !0;
}, FO = (o) => (e) => o(e), bO = () => ({ state: o, dispatch: e }) => q0(o, e), vO = (o, e) => ({ editor: r, tr: t }) => {
  const { state: n } = r, a = n.doc.slice(o.from, o.to);
  t.deleteRange(o.from, o.to);
  const s = t.mapping.map(e);
  return t.insert(s, a.content), t.setSelection(new Be(t.doc.resolve(Math.max(s - 1, 0)))), !0;
}, BO = () => ({ tr: o, dispatch: e }) => {
  const { selection: r } = o, t = r.$anchor.node();
  if (t.content.size > 0)
    return !1;
  const n = o.selection.$anchor;
  for (let a = n.depth; a > 0; a -= 1)
    if (n.node(a).type === t.type) {
      if (e) {
        const i = n.before(a), l = n.after(a);
        o.delete(i, l).scrollIntoView();
      }
      return !0;
    }
  return !1;
};
function lo(o, e) {
  if (typeof o == "string") {
    if (!e.nodes[o])
      throw Error(`There is no node type named '${o}'. Maybe you forgot to add the extension?`);
    return e.nodes[o];
  }
  return o;
}
var PO = (o) => ({ tr: e, state: r, dispatch: t }) => {
  const n = lo(o, r.schema), a = e.selection.$anchor;
  for (let s = a.depth; s > 0; s -= 1)
    if (a.node(s).type === n) {
      if (t) {
        const l = a.before(s), c = a.after(s);
        e.delete(l, c).scrollIntoView();
      }
      return !0;
    }
  return !1;
}, wO = (o) => ({ tr: e, dispatch: r }) => {
  const { from: t, to: n } = o;
  return r && e.delete(t, n), !0;
}, kO = () => ({ state: o, dispatch: e }) => Jp(o, e), DO = () => ({ commands: o }) => o.keyboardShortcut("Enter"), SO = () => ({ state: o, dispatch: e }) => dC(o, e);
function AO(o) {
  return Object.prototype.toString.call(o) === "[object RegExp]";
}
function fi(o, e, r = { strict: !0 }) {
  const t = Object.keys(e);
  return t.length ? t.every((n) => r.strict ? e[n] === o[n] : AO(e[n]) ? e[n].test(o[n]) : e[n] === o[n]) : !0;
}
function vb(o, e, r = {}) {
  return o.find((t) => t.type === e && fi(
    // Only check equality for the attributes that are provided
    Object.fromEntries(Object.keys(r).map((n) => [n, t.attrs[n]])),
    r
  ));
}
function Fy(o, e, r = {}) {
  return !!vb(o, e, r);
}
function Bb(o, e, r) {
  var t;
  if (!o || !e)
    return;
  let n = o.parent.childAfter(o.parentOffset);
  if ((!n.node || !n.node.marks.some((u) => u.type === e)) && (n = o.parent.childBefore(o.parentOffset)), !n.node || !n.node.marks.some((u) => u.type === e) || (r = r || ((t = n.node.marks[0]) == null ? void 0 : t.attrs), !vb([...n.node.marks], e, r)))
    return;
  let s = n.index, i = o.start() + n.offset, l = s + 1, c = i + n.node.nodeSize;
  for (; s > 0 && Fy([...o.parent.child(s - 1).marks], e, r); )
    s -= 1, i -= o.parent.child(s).nodeSize;
  for (; l < o.parent.childCount && Fy([...o.parent.child(l).marks], e, r); )
    c += o.parent.child(l).nodeSize, l += 1;
  return {
    from: i,
    to: c
  };
}
function Kr(o, e) {
  if (typeof o == "string") {
    if (!e.marks[o])
      throw Error(`There is no mark type named '${o}'. Maybe you forgot to add the extension?`);
    return e.marks[o];
  }
  return o;
}
var EO = (o, e = {}) => ({ tr: r, state: t, dispatch: n }) => {
  const a = Kr(o, t.schema), { doc: s, selection: i } = r, { $from: l, from: c, to: u } = i;
  if (n) {
    const f = Bb(l, a, e);
    if (f && f.from <= c && f.to >= u) {
      const g = Be.create(s, f.from, f.to);
      r.setSelection(g);
    }
  }
  return !0;
}, xO = (o) => (e) => {
  const r = typeof o == "function" ? o(e) : o;
  for (let t = 0; t < r.length; t += 1)
    if (r[t](e))
      return !0;
  return !1;
};
function Pb(o) {
  return o instanceof Be;
}
function rt(o = 0, e = 0, r = 0) {
  return Math.min(Math.max(o, e), r);
}
function CO(o, e = null) {
  if (!e)
    return null;
  const r = we.atStart(o), t = we.atEnd(o);
  if (e === "start" || e === !0)
    return r;
  if (e === "end")
    return t;
  const n = r.from, a = t.to;
  return e === "all" ? Be.create(o, rt(0, n, a), rt(o.content.size, n, a)) : Be.create(o, rt(e, n, a), rt(e, n, a));
}
function OO() {
  return navigator.platform === "Android" || /android/i.test(navigator.userAgent);
}
function pd() {
  return ["iPad Simulator", "iPhone Simulator", "iPod Simulator", "iPad", "iPhone", "iPod"].includes(navigator.platform) || // iPad on iOS 13 detection
  navigator.userAgent.includes("Mac") && "ontouchend" in document;
}
var TO = (o = null, e = {}) => ({ editor: r, view: t, tr: n, dispatch: a }) => {
  e = {
    scrollIntoView: !0,
    ...e
  };
  const s = () => {
    (pd() || OO()) && t.dom.focus(), requestAnimationFrame(() => {
      r.isDestroyed || (t.focus(), e != null && e.scrollIntoView && r.commands.scrollIntoView());
    });
  };
  if (t.hasFocus() && o === null || o === !1)
    return !0;
  if (a && o === null && !Pb(r.state.selection))
    return s(), !0;
  const i = CO(n.doc, o) || r.state.selection, l = r.state.selection.eq(i);
  return a && (l || n.setSelection(i), l && n.storedMarks && n.setStoredMarks(n.storedMarks), s()), !0;
}, LO = (o, e) => (r) => o.every((t, n) => e(t, { ...r, index: n })), jO = (o, e) => ({ tr: r, commands: t }) => t.insertContentAt({ from: r.selection.from, to: r.selection.to }, o, e), wb = (o) => {
  const e = o.childNodes;
  for (let r = e.length - 1; r >= 0; r -= 1) {
    const t = e[r];
    t.nodeType === 3 && t.nodeValue && /^(\n\s\s|\n)$/.test(t.nodeValue) ? o.removeChild(t) : t.nodeType === 1 && wb(t);
  }
  return o;
};
function Ds(o) {
  if (typeof window > "u")
    throw new Error("[tiptap error]: there is no window object available, so this function cannot be used");
  const e = `<body>${o}</body>`, r = new window.DOMParser().parseFromString(e, "text/html").body;
  return wb(r);
}
function ja(o, e, r) {
  if (o instanceof it || o instanceof $)
    return o;
  r = {
    slice: !0,
    parseOptions: {},
    ...r
  };
  const t = typeof o == "object" && o !== null, n = typeof o == "string";
  if (t)
    try {
      if (Array.isArray(o) && o.length > 0)
        return $.fromArray(o.map((i) => e.nodeFromJSON(i)));
      const s = e.nodeFromJSON(o);
      return r.errorOnInvalidContent && s.check(), s;
    } catch (a) {
      if (r.errorOnInvalidContent)
        throw new Error("[tiptap error]: Invalid JSON content", { cause: a });
      return console.warn("[tiptap warn]: Invalid content.", "Passed value:", o, "Error:", a), ja("", e, r);
    }
  if (n) {
    if (r.errorOnInvalidContent) {
      let s = !1, i = "";
      const l = new Ax({
        topNode: e.spec.topNode,
        marks: e.spec.marks,
        // Prosemirror's schemas are executed such that: the last to execute, matches last
        // This means that we can add a catch-all node at the end of the schema to catch any content that we don't know how to handle
        nodes: e.spec.nodes.append({
          __tiptap__private__unknown__catch__all__node: {
            content: "inline*",
            group: "block",
            parseDOM: [
              {
                tag: "*",
                getAttrs: (c) => (s = !0, i = typeof c == "string" ? c : c.outerHTML, null)
              }
            ]
          }
        })
      });
      if (r.slice ? lt.fromSchema(l).parseSlice(Ds(o), r.parseOptions) : lt.fromSchema(l).parse(Ds(o), r.parseOptions), r.errorOnInvalidContent && s)
        throw new Error("[tiptap error]: Invalid HTML content", {
          cause: new Error(`Invalid element found: ${i}`)
        });
    }
    const a = lt.fromSchema(e);
    return r.slice ? a.parseSlice(Ds(o), r.parseOptions).content : a.parse(Ds(o), r.parseOptions);
  }
  return ja("", e, r);
}
function MO(o, e, r) {
  const t = o.steps.length - 1;
  if (t < e)
    return;
  const n = o.steps[t];
  if (!(n instanceof Ke || n instanceof Je))
    return;
  const a = o.mapping.maps[t];
  let s = 0;
  a.forEach((i, l, c, u) => {
    s === 0 && (s = u);
  }), o.setSelection(we.near(o.doc.resolve(s), r));
}
var WO = (o) => !("type" in o), NO = (o, e, r) => ({ tr: t, dispatch: n, editor: a }) => {
  var s;
  if (n) {
    r = {
      parseOptions: a.options.parseOptions,
      updateSelection: !0,
      applyInputRules: !1,
      applyPasteRules: !1,
      ...r
    };
    let i;
    const l = (y) => {
      a.emit("contentError", {
        editor: a,
        error: y,
        disableCollaboration: () => {
          "collaboration" in a.storage && typeof a.storage.collaboration == "object" && a.storage.collaboration && (a.storage.collaboration.isDisabled = !0);
        }
      });
    }, c = {
      preserveWhitespace: "full",
      ...r.parseOptions
    };
    if (!r.errorOnInvalidContent && !a.options.enableContentCheck && a.options.emitContentError)
      try {
        ja(e, a.schema, {
          parseOptions: c,
          errorOnInvalidContent: !0
        });
      } catch (y) {
        l(y);
      }
    try {
      i = ja(e, a.schema, {
        parseOptions: c,
        errorOnInvalidContent: (s = r.errorOnInvalidContent) != null ? s : a.options.enableContentCheck
      });
    } catch (y) {
      return l(y), !1;
    }
    let { from: u, to: f } = typeof o == "number" ? { from: o, to: o } : { from: o.from, to: o.to }, g = !0, d = !0;
    if ((WO(i) ? i : [i]).forEach((y) => {
      y.check(), g = g ? y.isText && y.marks.length === 0 : !1, d = d ? y.isBlock : !1;
    }), u === f && d) {
      const { parent: y } = t.doc.resolve(u);
      y.isTextblock && !y.type.spec.code && !y.childCount && (u -= 1, f += 1);
    }
    let m;
    if (g) {
      if (Array.isArray(e))
        m = e.map((y) => y.text || "").join("");
      else if (e instanceof $) {
        let y = "";
        e.forEach((h) => {
          h.text && (y += h.text);
        }), m = y;
      } else typeof e == "object" && e && e.text ? m = e.text : m = e;
      t.insertText(m, u, f);
    } else {
      m = i;
      const y = t.doc.resolve(u), h = y.node(), F = y.parentOffset === 0, b = h.isText || h.isTextblock, v = h.content.size > 0;
      F && b && v && (u = Math.max(0, u - 1)), t.replaceWith(u, f, m);
    }
    r.updateSelection && MO(t, t.steps.length - 1, -1), r.applyInputRules && t.setMeta("applyInputRules", { from: u, text: m }), r.applyPasteRules && t.setMeta("applyPasteRules", { from: u, text: m });
  }
  return !0;
}, VO = () => ({ state: o, dispatch: e }) => cC(o, e), zO = () => ({ state: o, dispatch: e }) => uC(o, e), IO = () => ({ state: o, dispatch: e }) => N0(o, e), RO = () => ({ state: o, dispatch: e }) => R0(o, e), HO = () => ({ state: o, dispatch: e, tr: r }) => {
  try {
    const t = Ii(o.doc, o.selection.$from.pos, -1);
    return t == null ? !1 : (r.join(t, 2), e && e(r), !0);
  } catch {
    return !1;
  }
}, YO = () => ({ state: o, dispatch: e, tr: r }) => {
  try {
    const t = Ii(o.doc, o.selection.$from.pos, 1);
    return t == null ? !1 : (r.join(t, 2), e && e(r), !0);
  } catch {
    return !1;
  }
}, qO = () => ({ state: o, dispatch: e }) => iC(o, e), GO = () => ({ state: o, dispatch: e }) => lC(o, e);
function kb() {
  return typeof navigator < "u" ? /Mac/.test(navigator.platform) : !1;
}
function XO(o) {
  const e = o.split(/-(?!$)/);
  let r = e[e.length - 1];
  r === "Space" && (r = " ");
  let t, n, a, s;
  for (let i = 0; i < e.length - 1; i += 1) {
    const l = e[i];
    if (/^(cmd|meta|m)$/i.test(l))
      s = !0;
    else if (/^a(lt)?$/i.test(l))
      t = !0;
    else if (/^(c|ctrl|control)$/i.test(l))
      n = !0;
    else if (/^s(hift)?$/i.test(l))
      a = !0;
    else if (/^mod$/i.test(l))
      pd() || kb() ? s = !0 : n = !0;
    else
      throw new Error(`Unrecognized modifier name: ${l}`);
  }
  return t && (r = `Alt-${r}`), n && (r = `Ctrl-${r}`), s && (r = `Meta-${r}`), a && (r = `Shift-${r}`), r;
}
var UO = (o) => ({ editor: e, view: r, tr: t, dispatch: n }) => {
  const a = XO(o).split(/-(?!$)/), s = a.find((c) => !["Alt", "Ctrl", "Meta", "Shift"].includes(c)), i = new KeyboardEvent("keydown", {
    key: s === "Space" ? " " : s,
    altKey: a.includes("Alt"),
    ctrlKey: a.includes("Ctrl"),
    metaKey: a.includes("Meta"),
    shiftKey: a.includes("Shift"),
    bubbles: !0,
    cancelable: !0
  }), l = e.captureTransaction(() => {
    r.someProp("handleKeyDown", (c) => c(r, i));
  });
  return l == null || l.steps.forEach((c) => {
    const u = c.map(t.mapping);
    u && n && t.maybeStep(u);
  }), !0;
};
function dd(o, e, r = {}) {
  const { from: t, to: n, empty: a } = o.selection, s = e ? lo(e, o.schema) : null, i = [];
  o.doc.nodesBetween(t, n, (f, g) => {
    if (f.isText)
      return;
    const d = Math.max(t, g), p = Math.min(n, g + f.nodeSize);
    i.push({
      node: f,
      from: d,
      to: p
    });
  });
  const l = n - t, c = i.filter((f) => s ? s.name === f.node.type.name : !0).filter((f) => fi(f.node.attrs, r, { strict: !1 }));
  return a ? !!c.length : c.reduce((f, g) => f + g.to - g.from, 0) >= l;
}
var ZO = (o, e = {}) => ({ state: r, dispatch: t }) => {
  const n = lo(o, r.schema);
  return dd(r, n, e) ? pC(r, t) : !1;
}, KO = () => ({ state: o, dispatch: e }) => G0(o, e), QO = (o) => ({ state: e, dispatch: r }) => {
  const t = lo(o, e.schema);
  return wC(t)(e, r);
}, JO = () => ({ state: o, dispatch: e }) => Y0(o, e);
function Db(o, e) {
  return e.nodes[o] ? "node" : e.marks[o] ? "mark" : null;
}
function by(o, e) {
  const r = typeof e == "string" ? [e] : e;
  return Object.keys(o).reduce((t, n) => (r.includes(n) || (t[n] = o[n]), t), {});
}
var _O = (o, e) => ({ tr: r, state: t, dispatch: n }) => {
  let a = null, s = null;
  const i = Db(
    typeof o == "string" ? o : o.name,
    t.schema
  );
  return i ? (i === "node" && (a = lo(o, t.schema)), i === "mark" && (s = Kr(o, t.schema)), n && r.selection.ranges.forEach((l) => {
    t.doc.nodesBetween(l.$from.pos, l.$to.pos, (c, u) => {
      a && a === c.type && r.setNodeMarkup(u, void 0, by(c.attrs, e)), s && c.marks.length && c.marks.forEach((f) => {
        s === f.type && r.addMark(u, u + c.nodeSize, s.create(by(f.attrs, e)));
      });
    });
  }), !0) : !1;
}, $O = () => ({ tr: o, dispatch: e }) => (e && o.scrollIntoView(), !0), eT = () => ({ tr: o, dispatch: e }) => {
  if (e) {
    const r = new Eo(o.doc);
    o.setSelection(r);
  }
  return !0;
}, oT = () => ({ state: o, dispatch: e }) => z0(o, e), rT = () => ({ state: o, dispatch: e }) => H0(o, e), tT = () => ({ state: o, dispatch: e }) => fC(o, e), nT = () => ({ state: o, dispatch: e }) => FC(o, e), aT = () => ({ state: o, dispatch: e }) => hC(o, e);
function sT(o, e, r = {}, t = {}) {
  return ja(o, e, {
    slice: !1,
    parseOptions: r,
    errorOnInvalidContent: t.errorOnInvalidContent
  });
}
var iT = (o, { errorOnInvalidContent: e, emitUpdate: r = !0, parseOptions: t = {} } = {}) => ({ editor: n, tr: a, dispatch: s, commands: i }) => {
  const { doc: l } = a;
  if (t.preserveWhitespace !== "full") {
    const c = sT(o, n.schema, t, {
      errorOnInvalidContent: e ?? n.options.enableContentCheck
    });
    return s && a.replaceWith(0, l.content.size, c).setMeta("preventUpdate", !r), !0;
  }
  return s && a.setMeta("preventUpdate", !r), i.insertContentAt({ from: 0, to: l.content.size }, o, {
    parseOptions: t,
    errorOnInvalidContent: e ?? n.options.enableContentCheck
  });
};
function lT(o, e) {
  const r = Kr(e, o.schema), { from: t, to: n, empty: a } = o.selection, s = [];
  a ? (o.storedMarks && s.push(...o.storedMarks), s.push(...o.selection.$head.marks())) : o.doc.nodesBetween(t, n, (l) => {
    s.push(...l.marks);
  });
  const i = s.find((l) => l.type.name === r.name);
  return i ? { ...i.attrs } : {};
}
function cT(o, e) {
  const r = new nC(o);
  return e.forEach((t) => {
    t.steps.forEach((n) => {
      r.step(n);
    });
  }), r;
}
function uT(o) {
  for (let e = 0; e < o.edgeCount; e += 1) {
    const { type: r } = o.edge(e);
    if (r.isTextblock && !r.hasRequiredAttrs())
      return r;
  }
  return null;
}
function pT(o, e) {
  for (let r = o.depth; r > 0; r -= 1) {
    const t = o.node(r);
    if (e(t))
      return {
        pos: r > 0 ? o.before(r) : 0,
        start: o.start(r),
        depth: r,
        node: t
      };
  }
}
function gd(o) {
  return (e) => pT(e.$from, o);
}
function Ma(o, e, r) {
  return o.config[e] === void 0 && o.parent ? Ma(o.parent, e, r) : typeof o.config[e] == "function" ? o.config[e].bind({
    ...r,
    parent: o.parent ? Ma(o.parent, e, r) : null
  }) : o.config[e];
}
function dT(o) {
  return typeof o == "function";
}
function Ku(o, e = void 0, ...r) {
  return dT(o) ? e ? o.bind(e)(...r) : o(...r) : o;
}
function gT(o) {
  const e = o.filter((n) => n.type === "extension"), r = o.filter((n) => n.type === "node"), t = o.filter((n) => n.type === "mark");
  return {
    baseExtensions: e,
    nodeExtensions: r,
    markExtensions: t
  };
}
function mT(o, e, r) {
  const { from: t, to: n } = e, { blockSeparator: a = `

`, textSerializers: s = {} } = r || {};
  let i = "";
  return o.nodesBetween(t, n, (l, c, u, f) => {
    var g;
    l.isBlock && c > t && (i += a);
    const d = s == null ? void 0 : s[l.type.name];
    if (d)
      return u && (i += d({
        node: l,
        pos: c,
        parent: u,
        index: f,
        range: e
      })), !1;
    l.isText && (i += (g = l == null ? void 0 : l.text) == null ? void 0 : g.slice(Math.max(t, c) - c, n - c));
  }), i;
}
function fT(o) {
  return Object.fromEntries(
    Object.entries(o.nodes).filter(([, e]) => e.spec.toText).map(([e, r]) => [e, r.spec.toText])
  );
}
function yT(o, e = JSON.stringify) {
  const r = {};
  return o.filter((t) => {
    const n = e(t);
    return Object.prototype.hasOwnProperty.call(r, n) ? !1 : r[n] = !0;
  });
}
function hT(o) {
  const e = yT(o);
  return e.length === 1 ? e : e.filter((r, t) => !e.filter((a, s) => s !== t).some((a) => r.oldRange.from >= a.oldRange.from && r.oldRange.to <= a.oldRange.to && r.newRange.from >= a.newRange.from && r.newRange.to <= a.newRange.to));
}
function FT(o) {
  const { mapping: e, steps: r } = o, t = [];
  return e.maps.forEach((n, a) => {
    const s = [];
    if (n.ranges.length)
      n.forEach((i, l) => {
        s.push({ from: i, to: l });
      });
    else {
      const { from: i, to: l } = r[a];
      if (i === void 0 || l === void 0)
        return;
      s.push({ from: i, to: l });
    }
    s.forEach(({ from: i, to: l }) => {
      const c = e.slice(a).map(i, -1), u = e.slice(a).map(l), f = e.invert().map(c, -1), g = e.invert().map(u);
      t.push({
        oldRange: {
          from: f,
          to: g
        },
        newRange: {
          from: c,
          to: u
        }
      });
    });
  }), hT(t);
}
function Gs(o, e, r) {
  return Object.fromEntries(
    Object.entries(r).filter(([t]) => {
      const n = o.find((a) => a.type === e && a.name === t);
      return n ? n.attribute.keepOnSplit : !1;
    })
  );
}
function bT(o, e, r = {}) {
  const { empty: t, ranges: n } = o.selection, a = e ? Kr(e, o.schema) : null;
  if (t)
    return !!(o.storedMarks || o.selection.$from.marks()).filter((f) => a ? a.name === f.type.name : !0).find((f) => fi(f.attrs, r, { strict: !1 }));
  let s = 0;
  const i = [];
  if (n.forEach(({ $from: f, $to: g }) => {
    const d = f.pos, p = g.pos;
    o.doc.nodesBetween(d, p, (m, y) => {
      if (!m.isText && !m.marks.length)
        return;
      const h = Math.max(d, y), F = Math.min(p, y + m.nodeSize), b = F - h;
      s += b, i.push(
        ...m.marks.map((v) => ({
          mark: v,
          from: h,
          to: F
        }))
      );
    });
  }), s === 0)
    return !1;
  const l = i.filter((f) => a ? a.name === f.mark.type.name : !0).filter((f) => fi(f.mark.attrs, r, { strict: !1 })).reduce((f, g) => f + g.to - g.from, 0), c = i.filter((f) => a ? f.mark.type !== a && f.mark.type.excludes(a) : !0).reduce((f, g) => f + g.to - g.from, 0);
  return (l > 0 ? l + c : l) >= s;
}
function vy(o, e) {
  const { nodeExtensions: r } = gT(e), t = r.find((s) => s.name === o);
  if (!t)
    return !1;
  const n = {
    name: t.name,
    options: t.options,
    storage: t.storage
  }, a = Ku(Ma(t, "group", n));
  return typeof a != "string" ? !1 : a.split(" ").includes("list");
}
function Sb(o, {
  checkChildren: e = !0,
  ignoreWhitespace: r = !1
} = {}) {
  var t;
  if (r) {
    if (o.type.name === "hardBreak")
      return !0;
    if (o.isText)
      return /^\s*$/m.test((t = o.text) != null ? t : "");
  }
  if (o.isText)
    return !o.text;
  if (o.isAtom || o.isLeaf)
    return !1;
  if (o.content.childCount === 0)
    return !0;
  if (e) {
    let n = !0;
    return o.content.forEach((a) => {
      n !== !1 && (Sb(a, { ignoreWhitespace: r, checkChildren: e }) || (n = !1));
    }), n;
  }
  return !1;
}
function vT(o, e, r) {
  var t;
  const { selection: n } = e;
  let a = null;
  if (Pb(n) && (a = n.$cursor), a) {
    const i = (t = o.storedMarks) != null ? t : a.marks();
    return a.parent.type.allowsMarkType(r) && (!!r.isInSet(i) || !i.some((c) => c.type.excludes(r)));
  }
  const { ranges: s } = n;
  return s.some(({ $from: i, $to: l }) => {
    let c = i.depth === 0 ? o.doc.inlineContent && o.doc.type.allowsMarkType(r) : !1;
    return o.doc.nodesBetween(i.pos, l.pos, (u, f, g) => {
      if (c)
        return !1;
      if (u.isInline) {
        const d = !g || g.type.allowsMarkType(r), p = !!r.isInSet(u.marks) || !u.marks.some((m) => m.type.excludes(r));
        c = d && p;
      }
      return !c;
    }), c;
  });
}
var BT = (o, e = {}) => ({ tr: r, state: t, dispatch: n }) => {
  const { selection: a } = r, { empty: s, ranges: i } = a, l = Kr(o, t.schema);
  if (n)
    if (s) {
      const c = lT(t, l);
      r.addStoredMark(
        l.create({
          ...c,
          ...e
        })
      );
    } else
      i.forEach((c) => {
        const u = c.$from.pos, f = c.$to.pos;
        t.doc.nodesBetween(u, f, (g, d) => {
          const p = Math.max(d, u), m = Math.min(d + g.nodeSize, f);
          g.marks.find((h) => h.type === l) ? g.marks.forEach((h) => {
            l === h.type && r.addMark(
              p,
              m,
              l.create({
                ...h.attrs,
                ...e
              })
            );
          }) : r.addMark(p, m, l.create(e));
        });
      });
  return vT(t, r, l);
}, PT = (o, e) => ({ tr: r }) => (r.setMeta(o, e), !0), wT = (o, e = {}) => ({ state: r, dispatch: t, chain: n }) => {
  const a = lo(o, r.schema);
  let s;
  return r.selection.$anchor.sameParent(r.selection.$head) && (s = r.selection.$anchor.parent.attrs), a.isTextblock ? n().command(({ commands: i }) => ty(a, { ...s, ...e })(r) ? !0 : i.clearNodes()).command(({ state: i }) => ty(a, { ...s, ...e })(i, t)).run() : (console.warn('[tiptap warn]: Currently "setNode()" only supports text block nodes.'), !1);
}, kT = (o) => ({ tr: e, dispatch: r }) => {
  if (r) {
    const { doc: t } = e, n = rt(o, 0, t.content.size), a = me.create(t, n);
    e.setSelection(a);
  }
  return !0;
}, DT = (o) => ({ tr: e, dispatch: r }) => {
  if (r) {
    const { doc: t } = e, { from: n, to: a } = typeof o == "number" ? { from: o, to: o } : o, s = Be.atStart(t).from, i = Be.atEnd(t).to, l = rt(n, s, i), c = rt(a, s, i), u = Be.create(t, l, c);
    e.setSelection(u);
  }
  return !0;
}, ST = (o) => ({ state: e, dispatch: r }) => {
  const t = lo(o, e.schema);
  return SC(t)(e, r);
};
function By(o, e) {
  const r = o.storedMarks || o.selection.$to.parentOffset && o.selection.$from.marks();
  if (r) {
    const t = r.filter((n) => e == null ? void 0 : e.includes(n.type.name));
    o.tr.ensureMarks(t);
  }
}
var AT = ({ keepMarks: o = !0 } = {}) => ({ tr: e, state: r, dispatch: t, editor: n }) => {
  const { selection: a, doc: s } = e, { $from: i, $to: l } = a, c = n.extensionManager.attributes, u = Gs(c, i.node().type.name, i.node().attrs);
  if (a instanceof me && a.node.isBlock)
    return !i.parentOffset || !pr(s, i.pos) ? !1 : (t && (o && By(r, n.extensionManager.splittableMarks), e.split(i.pos).scrollIntoView()), !0);
  if (!i.parent.isBlock)
    return !1;
  const f = l.parentOffset === l.parent.content.size, g = i.depth === 0 ? void 0 : uT(i.node(-1).contentMatchAt(i.indexAfter(-1)));
  let d = f && g ? [
    {
      type: g,
      attrs: u
    }
  ] : void 0, p = pr(e.doc, e.mapping.map(i.pos), 1, d);
  if (!d && !p && pr(e.doc, e.mapping.map(i.pos), 1, g ? [{ type: g }] : void 0) && (p = !0, d = g ? [
    {
      type: g,
      attrs: u
    }
  ] : void 0), t) {
    if (p && (a instanceof Be && e.deleteSelection(), e.split(e.mapping.map(i.pos), 1, d), g && !f && !i.parentOffset && i.parent.type !== g)) {
      const m = e.mapping.map(i.before()), y = e.doc.resolve(m);
      i.node(-1).canReplaceWith(y.index(), y.index() + 1, g) && e.setNodeMarkup(e.mapping.map(i.before()), g);
    }
    o && By(r, n.extensionManager.splittableMarks), e.scrollIntoView();
  }
  return p;
}, ET = (o, e = {}) => ({ tr: r, state: t, dispatch: n, editor: a }) => {
  var s;
  const i = lo(o, t.schema), { $from: l, $to: c } = t.selection, u = t.selection.node;
  if (u && u.isBlock || l.depth < 2 || !l.sameParent(c))
    return !1;
  const f = l.node(-1);
  if (f.type !== i)
    return !1;
  const g = a.extensionManager.attributes;
  if (l.parent.content.size === 0 && l.node(-1).childCount === l.indexAfter(-1)) {
    if (l.depth === 2 || l.node(-3).type !== i || l.index(-2) !== l.node(-2).childCount - 1)
      return !1;
    if (n) {
      let h = $.empty;
      const F = l.index(-1) ? 1 : l.index(-2) ? 2 : 3;
      for (let D = l.depth - F; D >= l.depth - 3; D -= 1)
        h = $.from(l.node(D).copy(h));
      const b = (
        // eslint-disable-next-line no-nested-ternary
        l.indexAfter(-1) < l.node(-2).childCount ? 1 : l.indexAfter(-2) < l.node(-3).childCount ? 2 : 3
      ), v = {
        ...Gs(g, l.node().type.name, l.node().attrs),
        ...e
      }, P = ((s = i.contentMatch.defaultType) == null ? void 0 : s.createAndFill(v)) || void 0;
      h = h.append($.from(i.createAndFill(null, P) || void 0));
      const E = l.before(l.depth - (F - 1));
      r.replace(E, l.after(-b), new te(h, 4 - F, 0));
      let S = -1;
      r.doc.nodesBetween(E, r.doc.content.size, (D, w) => {
        if (S > -1)
          return !1;
        D.isTextblock && D.content.size === 0 && (S = w + 1);
      }), S > -1 && r.setSelection(Be.near(r.doc.resolve(S))), r.scrollIntoView();
    }
    return !0;
  }
  const d = c.pos === l.end() ? f.contentMatchAt(0).defaultType : null, p = {
    ...Gs(g, f.type.name, f.attrs),
    ...e
  }, m = {
    ...Gs(g, l.node().type.name, l.node().attrs),
    ...e
  };
  r.delete(l.pos, c.pos);
  const y = d ? [
    { type: i, attrs: p },
    { type: d, attrs: m }
  ] : [{ type: i, attrs: p }];
  if (!pr(r.doc, l.pos, 2))
    return !1;
  if (n) {
    const { selection: h, storedMarks: F } = t, { splittableMarks: b } = a.extensionManager, v = F || h.$to.parentOffset && h.$from.marks();
    if (r.split(l.pos, 2, y).scrollIntoView(), !v || !n)
      return !0;
    const P = v.filter((E) => b.includes(E.type.name));
    r.ensureMarks(P);
  }
  return !0;
}, hc = (o, e) => {
  const r = gd((s) => s.type === e)(o.selection);
  if (!r)
    return !0;
  const t = o.doc.resolve(Math.max(0, r.pos - 1)).before(r.depth);
  if (t === void 0)
    return !0;
  const n = o.doc.nodeAt(t);
  return r.node.type === (n == null ? void 0 : n.type) && Ft(o.doc, r.pos) && o.join(r.pos), !0;
}, Fc = (o, e) => {
  const r = gd((s) => s.type === e)(o.selection);
  if (!r)
    return !0;
  const t = o.doc.resolve(r.start).after(r.depth);
  if (t === void 0)
    return !0;
  const n = o.doc.nodeAt(t);
  return r.node.type === (n == null ? void 0 : n.type) && Ft(o.doc, t) && o.join(t), !0;
}, xT = (o, e, r, t = {}) => ({ editor: n, tr: a, state: s, dispatch: i, chain: l, commands: c, can: u }) => {
  const { extensions: f, splittableMarks: g } = n.extensionManager, d = lo(o, s.schema), p = lo(e, s.schema), { selection: m, storedMarks: y } = s, { $from: h, $to: F } = m, b = h.blockRange(F), v = y || m.$to.parentOffset && m.$from.marks();
  if (!b)
    return !1;
  const P = gd((E) => vy(E.type.name, f))(m);
  if (b.depth >= 1 && P && b.depth - P.depth <= 1) {
    if (P.node.type === d)
      return c.liftListItem(p);
    if (vy(P.node.type.name, f) && d.validContent(P.node.content) && i)
      return l().command(() => (a.setNodeMarkup(P.pos, d), !0)).command(() => hc(a, d)).command(() => Fc(a, d)).run();
  }
  return !r || !v || !i ? l().command(() => u().wrapInList(d, t) ? !0 : c.clearNodes()).wrapInList(d, t).command(() => hc(a, d)).command(() => Fc(a, d)).run() : l().command(() => {
    const E = u().wrapInList(d, t), S = v.filter((D) => g.includes(D.type.name));
    return a.ensureMarks(S), E ? !0 : c.clearNodes();
  }).wrapInList(d, t).command(() => hc(a, d)).command(() => Fc(a, d)).run();
}, CT = (o, e = {}, r = {}) => ({ state: t, commands: n }) => {
  const { extendEmptyMarkRange: a = !1 } = r, s = Kr(o, t.schema);
  return bT(t, s, e) ? n.unsetMark(s, { extendEmptyMarkRange: a }) : n.setMark(s, e);
}, OT = (o, e, r = {}) => ({ state: t, commands: n }) => {
  const a = lo(o, t.schema), s = lo(e, t.schema), i = dd(t, a, r);
  let l;
  return t.selection.$anchor.sameParent(t.selection.$head) && (l = t.selection.$anchor.parent.attrs), i ? n.setNode(s, l) : n.setNode(a, { ...l, ...r });
}, TT = (o, e = {}) => ({ state: r, commands: t }) => {
  const n = lo(o, r.schema);
  return dd(r, n, e) ? t.lift(n) : t.wrapIn(n, e);
}, LT = () => ({ state: o, dispatch: e }) => {
  const r = o.plugins;
  for (let t = 0; t < r.length; t += 1) {
    const n = r[t];
    let a;
    if (n.spec.isInputRules && (a = n.getState(o))) {
      if (e) {
        const s = o.tr, i = a.transform;
        for (let l = i.steps.length - 1; l >= 0; l -= 1)
          s.step(i.steps[l].invert(i.docs[l]));
        if (a.text) {
          const l = s.doc.resolve(a.from).marks();
          s.replaceWith(a.from, a.to, o.schema.text(a.text, l));
        } else
          s.delete(a.from, a.to);
      }
      return !0;
    }
  }
  return !1;
}, jT = () => ({ tr: o, dispatch: e }) => {
  const { selection: r } = o, { empty: t, ranges: n } = r;
  return t || e && n.forEach((a) => {
    o.removeMark(a.$from.pos, a.$to.pos);
  }), !0;
}, MT = (o, e = {}) => ({ tr: r, state: t, dispatch: n }) => {
  var a;
  const { extendEmptyMarkRange: s = !1 } = e, { selection: i } = r, l = Kr(o, t.schema), { $from: c, empty: u, ranges: f } = i;
  if (!n)
    return !0;
  if (u && s) {
    let { from: g, to: d } = i;
    const p = (a = c.marks().find((y) => y.type === l)) == null ? void 0 : a.attrs, m = Bb(c, l, p);
    m && (g = m.from, d = m.to), r.removeMark(g, d, l);
  } else
    f.forEach((g) => {
      r.removeMark(g.$from.pos, g.$to.pos, l);
    });
  return r.removeStoredMark(l), !0;
}, WT = (o, e = {}) => ({ tr: r, state: t, dispatch: n }) => {
  let a = null, s = null;
  const i = Db(
    typeof o == "string" ? o : o.name,
    t.schema
  );
  return i ? (i === "node" && (a = lo(o, t.schema)), i === "mark" && (s = Kr(o, t.schema)), n && r.selection.ranges.forEach((l) => {
    const c = l.$from.pos, u = l.$to.pos;
    let f, g, d, p;
    r.selection.empty ? t.doc.nodesBetween(c, u, (m, y) => {
      a && a === m.type && (d = Math.max(y, c), p = Math.min(y + m.nodeSize, u), f = y, g = m);
    }) : t.doc.nodesBetween(c, u, (m, y) => {
      y < c && a && a === m.type && (d = Math.max(y, c), p = Math.min(y + m.nodeSize, u), f = y, g = m), y >= c && y <= u && (a && a === m.type && r.setNodeMarkup(y, void 0, {
        ...m.attrs,
        ...e
      }), s && m.marks.length && m.marks.forEach((h) => {
        if (s === h.type) {
          const F = Math.max(y, c), b = Math.min(y + m.nodeSize, u);
          r.addMark(
            F,
            b,
            s.create({
              ...h.attrs,
              ...e
            })
          );
        }
      }));
    }), g && (f !== void 0 && r.setNodeMarkup(f, void 0, {
      ...g.attrs,
      ...e
    }), s && g.marks.length && g.marks.forEach((m) => {
      s === m.type && r.addMark(
        d,
        p,
        s.create({
          ...m.attrs,
          ...e
        })
      );
    }));
  }), !0) : !1;
}, NT = (o, e = {}) => ({ state: r, dispatch: t }) => {
  const n = lo(o, r.schema);
  return bC(n, e)(r, t);
}, VT = (o, e = {}) => ({ state: r, dispatch: t }) => {
  const n = lo(o, r.schema);
  return vC(n, e)(r, t);
};
function zT(o) {
  return Object.prototype.toString.call(o).slice(8, -1);
}
function Ss(o) {
  return zT(o) !== "Object" ? !1 : o.constructor === Object && Object.getPrototypeOf(o) === Object.prototype;
}
function Ab(o, e) {
  const r = { ...o };
  return Ss(o) && Ss(e) && Object.keys(e).forEach((t) => {
    Ss(e[t]) && Ss(o[t]) ? r[t] = Ab(o[t], e[t]) : r[t] = e[t];
  }), r;
}
var IT = class {
  constructor(o = {}) {
    this.type = "extendable", this.parent = null, this.child = null, this.name = "", this.config = {
      name: this.name
    }, this.config = {
      ...this.config,
      ...o
    }, this.name = this.config.name;
  }
  get options() {
    return {
      ...Ku(
        Ma(this, "addOptions", {
          name: this.name
        })
      ) || {}
    };
  }
  get storage() {
    return {
      ...Ku(
        Ma(this, "addStorage", {
          name: this.name,
          options: this.options
        })
      ) || {}
    };
  }
  configure(o = {}) {
    const e = this.extend({
      ...this.config,
      addOptions: () => Ab(this.options, o)
    });
    return e.name = this.name, e.parent = this.parent, e;
  }
  extend(o = {}) {
    const e = new this.constructor({ ...this.config, ...o });
    return e.parent = this, this.child = e, e.name = "name" in o ? o.name : e.parent.name, e;
  }
}, RT = {};
ud(RT, {
  ClipboardTextSerializer: () => HT,
  Commands: () => YT,
  Delete: () => qT,
  Drop: () => GT,
  Editable: () => XT,
  FocusEvents: () => UT,
  Keymap: () => ZT,
  Paste: () => KT,
  Tabindex: () => QT,
  focusEventsPluginKey: () => xb
});
var Xo = class Eb extends IT {
  constructor() {
    super(...arguments), this.type = "extension";
  }
  /**
   * Create a new Extension instance
   * @param config - Extension configuration object or a function that returns a configuration object
   */
  static create(e = {}) {
    const r = typeof e == "function" ? e() : e;
    return new Eb(r);
  }
  configure(e) {
    return super.configure(e);
  }
  extend(e) {
    const r = typeof e == "function" ? e() : e;
    return super.extend(r);
  }
}, HT = Xo.create({
  name: "clipboardTextSerializer",
  addOptions() {
    return {
      blockSeparator: void 0
    };
  },
  addProseMirrorPlugins() {
    return [
      new Gr({
        key: new Xr("clipboardTextSerializer"),
        props: {
          clipboardTextSerializer: () => {
            const { editor: o } = this, { state: e, schema: r } = o, { doc: t, selection: n } = e, { ranges: a } = n, s = Math.min(...a.map((u) => u.$from.pos)), i = Math.max(...a.map((u) => u.$to.pos)), l = fT(r);
            return mT(t, { from: s, to: i }, {
              ...this.options.blockSeparator !== void 0 ? { blockSeparator: this.options.blockSeparator } : {},
              textSerializers: l
            });
          }
        }
      })
    ];
  }
}), YT = Xo.create({
  name: "commands",
  addCommands() {
    return {
      ...bb
    };
  }
}), qT = Xo.create({
  name: "delete",
  onUpdate({ transaction: o, appendedTransactions: e }) {
    var r, t, n;
    const a = () => {
      var s, i, l, c;
      if ((c = (l = (i = (s = this.editor.options.coreExtensionOptions) == null ? void 0 : s.delete) == null ? void 0 : i.filterTransaction) == null ? void 0 : l.call(i, o)) != null ? c : o.getMeta("y-sync$"))
        return;
      const u = cT(o.before, [o, ...e]);
      FT(u).forEach((d) => {
        u.mapping.mapResult(d.oldRange.from).deletedAfter && u.mapping.mapResult(d.oldRange.to).deletedBefore && u.before.nodesBetween(d.oldRange.from, d.oldRange.to, (p, m) => {
          const y = m + p.nodeSize - 2, h = d.oldRange.from <= m && y <= d.oldRange.to;
          this.editor.emit("delete", {
            type: "node",
            node: p,
            from: m,
            to: y,
            newFrom: u.mapping.map(m),
            newTo: u.mapping.map(y),
            deletedRange: d.oldRange,
            newRange: d.newRange,
            partial: !h,
            editor: this.editor,
            transaction: o,
            combinedTransform: u
          });
        });
      });
      const g = u.mapping;
      u.steps.forEach((d, p) => {
        var m, y;
        if (d instanceof Yo) {
          const h = g.slice(p).map(d.from, -1), F = g.slice(p).map(d.to), b = g.invert().map(h, -1), v = g.invert().map(F), P = (m = u.doc.nodeAt(h - 1)) == null ? void 0 : m.marks.some((S) => S.eq(d.mark)), E = (y = u.doc.nodeAt(F)) == null ? void 0 : y.marks.some((S) => S.eq(d.mark));
          this.editor.emit("delete", {
            type: "mark",
            mark: d.mark,
            from: d.from,
            to: d.to,
            deletedRange: {
              from: b,
              to: v
            },
            newRange: {
              from: h,
              to: F
            },
            partial: !!(E || P),
            editor: this.editor,
            transaction: o,
            combinedTransform: u
          });
        }
      });
    };
    (n = (t = (r = this.editor.options.coreExtensionOptions) == null ? void 0 : r.delete) == null ? void 0 : t.async) == null || n ? setTimeout(a, 0) : a();
  }
}), GT = Xo.create({
  name: "drop",
  addProseMirrorPlugins() {
    return [
      new Gr({
        key: new Xr("tiptapDrop"),
        props: {
          handleDrop: (o, e, r, t) => {
            this.editor.emit("drop", {
              editor: this.editor,
              event: e,
              slice: r,
              moved: t
            });
          }
        }
      })
    ];
  }
}), XT = Xo.create({
  name: "editable",
  addProseMirrorPlugins() {
    return [
      new Gr({
        key: new Xr("editable"),
        props: {
          editable: () => this.editor.options.editable
        }
      })
    ];
  }
}), xb = new Xr("focusEvents"), UT = Xo.create({
  name: "focusEvents",
  addProseMirrorPlugins() {
    const { editor: o } = this;
    return [
      new Gr({
        key: xb,
        props: {
          handleDOMEvents: {
            focus: (e, r) => {
              o.isFocused = !0;
              const t = o.state.tr.setMeta("focus", { event: r }).setMeta("addToHistory", !1);
              return e.dispatch(t), !1;
            },
            blur: (e, r) => {
              o.isFocused = !1;
              const t = o.state.tr.setMeta("blur", { event: r }).setMeta("addToHistory", !1);
              return e.dispatch(t), !1;
            }
          }
        }
      })
    ];
  }
}), ZT = Xo.create({
  name: "keymap",
  addKeyboardShortcuts() {
    const o = () => this.editor.commands.first(({ commands: s }) => [
      () => s.undoInputRule(),
      // maybe convert first text block node to default node
      () => s.command(({ tr: i }) => {
        const { selection: l, doc: c } = i, { empty: u, $anchor: f } = l, { pos: g, parent: d } = f, p = f.parent.isTextblock && g > 0 ? i.doc.resolve(g - 1) : f, m = p.parent.type.spec.isolating, y = f.pos - f.parentOffset, h = m && p.parent.childCount === 1 ? y === f.pos : we.atStart(c).from === g;
        return !u || !d.type.isTextblock || d.textContent.length || !h || h && f.parent.type.name === "paragraph" ? !1 : s.clearNodes();
      }),
      () => s.deleteSelection(),
      () => s.joinBackward(),
      () => s.selectNodeBackward()
    ]), e = () => this.editor.commands.first(({ commands: s }) => [
      () => s.deleteSelection(),
      () => s.deleteCurrentNode(),
      () => s.joinForward(),
      () => s.selectNodeForward()
    ]), t = {
      Enter: () => this.editor.commands.first(({ commands: s }) => [
        () => s.newlineInCode(),
        () => s.createParagraphNear(),
        () => s.liftEmptyBlock(),
        () => s.splitBlock()
      ]),
      "Mod-Enter": () => this.editor.commands.exitCode(),
      Backspace: o,
      "Mod-Backspace": o,
      "Shift-Backspace": o,
      Delete: e,
      "Mod-Delete": e,
      "Mod-a": () => this.editor.commands.selectAll()
    }, n = {
      ...t
    }, a = {
      ...t,
      "Ctrl-h": o,
      "Alt-Backspace": o,
      "Ctrl-d": e,
      "Ctrl-Alt-Backspace": e,
      "Alt-Delete": e,
      "Alt-d": e,
      "Ctrl-a": () => this.editor.commands.selectTextblockStart(),
      "Ctrl-e": () => this.editor.commands.selectTextblockEnd()
    };
    return pd() || kb() ? a : n;
  },
  addProseMirrorPlugins() {
    return [
      // With this plugin we check if the whole document was selected and deleted.
      // In this case we will additionally call `clearNodes()` to convert e.g. a heading
      // to a paragraph if necessary.
      // This is an alternative to ProseMirror's `AllSelection`, which doesn’t work well
      // with many other commands.
      new Gr({
        key: new Xr("clearDocument"),
        appendTransaction: (o, e, r) => {
          if (o.some((m) => m.getMeta("composition")))
            return;
          const t = o.some((m) => m.docChanged) && !e.doc.eq(r.doc), n = o.some((m) => m.getMeta("preventClearDocument"));
          if (!t || n)
            return;
          const { empty: a, from: s, to: i } = e.selection, l = we.atStart(e.doc).from, c = we.atEnd(e.doc).to;
          if (a || !(s === l && i === c) || !Sb(r.doc))
            return;
          const g = r.tr, d = Fb({
            state: r,
            transaction: g
          }), { commands: p } = new mO({
            editor: this.editor,
            state: d
          });
          if (p.clearNodes(), !!g.steps.length)
            return g;
        }
      })
    ];
  }
}), KT = Xo.create({
  name: "paste",
  addProseMirrorPlugins() {
    return [
      new Gr({
        key: new Xr("tiptapPaste"),
        props: {
          handlePaste: (o, e, r) => {
            this.editor.emit("paste", {
              editor: this.editor,
              event: e,
              slice: r
            });
          }
        }
      })
    ];
  }
}), QT = Xo.create({
  name: "tabindex",
  addProseMirrorPlugins() {
    return [
      new Gr({
        key: new Xr("tabindex"),
        props: {
          attributes: () => this.editor.isEditable ? { tabindex: "0" } : {}
        }
      })
    ];
  }
}), JT = {};
ud(JT, {
  createAtomBlockMarkdownSpec: () => _T,
  createBlockMarkdownSpec: () => $T,
  createInlineMarkdownSpec: () => rL,
  parseAttributes: () => md,
  parseIndentedBlocks: () => tL,
  renderNestedMarkdownContent: () => nL,
  serializeAttributes: () => fd
});
function md(o) {
  if (!(o != null && o.trim()))
    return {};
  const e = {}, r = [], t = o.replace(/["']([^"']*)["']/g, (c) => (r.push(c), `__QUOTED_${r.length - 1}__`)), n = t.match(/(?:^|\s)\.([a-zA-Z][\w-]*)/g);
  if (n) {
    const c = n.map((u) => u.trim().slice(1));
    e.class = c.join(" ");
  }
  const a = t.match(/(?:^|\s)#([a-zA-Z][\w-]*)/);
  a && (e.id = a[1]);
  const s = /([a-zA-Z][\w-]*)\s*=\s*(__QUOTED_\d+__)/g;
  Array.from(t.matchAll(s)).forEach(([, c, u]) => {
    var f;
    const g = parseInt(((f = u.match(/__QUOTED_(\d+)__/)) == null ? void 0 : f[1]) || "0", 10), d = r[g];
    d && (e[c] = d.slice(1, -1));
  });
  const l = t.replace(/(?:^|\s)\.([a-zA-Z][\w-]*)/g, "").replace(/(?:^|\s)#([a-zA-Z][\w-]*)/g, "").replace(/([a-zA-Z][\w-]*)\s*=\s*__QUOTED_\d+__/g, "").trim();
  return l && l.split(/\s+/).filter(Boolean).forEach((u) => {
    u.match(/^[a-zA-Z][\w-]*$/) && (e[u] = !0);
  }), e;
}
function fd(o) {
  if (!o || Object.keys(o).length === 0)
    return "";
  const e = [];
  return o.class && String(o.class).split(/\s+/).filter(Boolean).forEach((t) => e.push(`.${t}`)), o.id && e.push(`#${o.id}`), Object.entries(o).forEach(([r, t]) => {
    r === "class" || r === "id" || (t === !0 ? e.push(r) : t !== !1 && t != null && e.push(`${r}="${String(t)}"`));
  }), e.join(" ");
}
function _T(o) {
  const {
    nodeName: e,
    name: r,
    parseAttributes: t = md,
    serializeAttributes: n = fd,
    defaultAttributes: a = {},
    requiredAttributes: s = [],
    allowedAttributes: i
  } = o, l = r || e, c = (u) => {
    if (!i)
      return u;
    const f = {};
    return i.forEach((g) => {
      g in u && (f[g] = u[g]);
    }), f;
  };
  return {
    parseMarkdown: (u, f) => {
      const g = { ...a, ...u.attributes };
      return f.createNode(e, g, []);
    },
    markdownTokenizer: {
      name: e,
      level: "block",
      start(u) {
        var f;
        const g = new RegExp(`^:::${l}(?:\\s|$)`, "m"), d = (f = u.match(g)) == null ? void 0 : f.index;
        return d !== void 0 ? d : -1;
      },
      tokenize(u, f, g) {
        const d = new RegExp(`^:::${l}(?:\\s+\\{([^}]*)\\})?\\s*:::(?:\\n|$)`), p = u.match(d);
        if (!p)
          return;
        const m = p[1] || "", y = t(m);
        if (!s.find((F) => !(F in y)))
          return {
            type: e,
            raw: p[0],
            attributes: y
          };
      }
    },
    renderMarkdown: (u) => {
      const f = c(u.attrs || {}), g = n(f), d = g ? ` {${g}}` : "";
      return `:::${l}${d} :::`;
    }
  };
}
function $T(o) {
  const {
    nodeName: e,
    name: r,
    getContent: t,
    parseAttributes: n = md,
    serializeAttributes: a = fd,
    defaultAttributes: s = {},
    content: i = "block",
    allowedAttributes: l
  } = o, c = r || e, u = (f) => {
    if (!l)
      return f;
    const g = {};
    return l.forEach((d) => {
      d in f && (g[d] = f[d]);
    }), g;
  };
  return {
    parseMarkdown: (f, g) => {
      let d;
      if (t) {
        const m = t(f);
        d = typeof m == "string" ? [{ type: "text", text: m }] : m;
      } else i === "block" ? d = g.parseChildren(f.tokens || []) : d = g.parseInline(f.tokens || []);
      const p = { ...s, ...f.attributes };
      return g.createNode(e, p, d);
    },
    markdownTokenizer: {
      name: e,
      level: "block",
      start(f) {
        var g;
        const d = new RegExp(`^:::${c}`, "m"), p = (g = f.match(d)) == null ? void 0 : g.index;
        return p !== void 0 ? p : -1;
      },
      tokenize(f, g, d) {
        var p;
        const m = new RegExp(`^:::${c}(?:\\s+\\{([^}]*)\\})?\\s*\\n`), y = f.match(m);
        if (!y)
          return;
        const [h, F = ""] = y, b = n(F);
        let v = 1;
        const P = h.length;
        let E = "";
        const S = /^:::([\w-]*)(\s.*)?/gm, D = f.slice(P);
        for (S.lastIndex = 0; ; ) {
          const w = S.exec(D);
          if (w === null)
            break;
          const A = w.index, C = w[1];
          if (!((p = w[2]) != null && p.endsWith(":::"))) {
            if (C)
              v += 1;
            else if (v -= 1, v === 0) {
              const x = D.slice(0, A);
              E = x.trim();
              const T = f.slice(0, P + A + w[0].length);
              let M = [];
              if (E)
                if (i === "block")
                  for (M = d.blockTokens(x), M.forEach((V) => {
                    V.text && (!V.tokens || V.tokens.length === 0) && (V.tokens = d.inlineTokens(V.text));
                  }); M.length > 0; ) {
                    const V = M[M.length - 1];
                    if (V.type === "paragraph" && (!V.text || V.text.trim() === ""))
                      M.pop();
                    else
                      break;
                  }
                else
                  M = d.inlineTokens(E);
              return {
                type: e,
                raw: T,
                attributes: b,
                content: E,
                tokens: M
              };
            }
          }
        }
      }
    },
    renderMarkdown: (f, g) => {
      const d = u(f.attrs || {}), p = a(d), m = p ? ` {${p}}` : "", y = g.renderChildren(f.content || [], `

`);
      return `:::${c}${m}

${y}

:::`;
    }
  };
}
function eL(o) {
  if (!o.trim())
    return {};
  const e = {}, r = /(\w+)=(?:"([^"]*)"|'([^']*)')/g;
  let t = r.exec(o);
  for (; t !== null; ) {
    const [, n, a, s] = t;
    e[n] = a || s, t = r.exec(o);
  }
  return e;
}
function oL(o) {
  return Object.entries(o).filter(([, e]) => e != null).map(([e, r]) => `${e}="${r}"`).join(" ");
}
function rL(o) {
  const {
    nodeName: e,
    name: r,
    getContent: t,
    parseAttributes: n = eL,
    serializeAttributes: a = oL,
    defaultAttributes: s = {},
    selfClosing: i = !1,
    allowedAttributes: l
  } = o, c = r || e, u = (g) => {
    if (!l)
      return g;
    const d = {};
    return l.forEach((p) => {
      p in g && (d[p] = g[p]);
    }), d;
  }, f = c.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  return {
    parseMarkdown: (g, d) => {
      const p = { ...s, ...g.attributes };
      if (i)
        return d.createNode(e, p);
      const m = t ? t(g) : g.content || "";
      return m ? d.createNode(e, p, [d.createTextNode(m)]) : d.createNode(e, p, []);
    },
    markdownTokenizer: {
      name: e,
      level: "inline",
      start(g) {
        const d = i ? new RegExp(`\\[${f}\\s*[^\\]]*\\]`) : new RegExp(`\\[${f}\\s*[^\\]]*\\][\\s\\S]*?\\[\\/${f}\\]`), p = g.match(d), m = p == null ? void 0 : p.index;
        return m !== void 0 ? m : -1;
      },
      tokenize(g, d, p) {
        const m = i ? new RegExp(`^\\[${f}\\s*([^\\]]*)\\]`) : new RegExp(`^\\[${f}\\s*([^\\]]*)\\]([\\s\\S]*?)\\[\\/${f}\\]`), y = g.match(m);
        if (!y)
          return;
        let h = "", F = "";
        if (i) {
          const [, v] = y;
          F = v;
        } else {
          const [, v, P] = y;
          F = v, h = P || "";
        }
        const b = n(F.trim());
        return {
          type: e,
          raw: y[0],
          content: h.trim(),
          attributes: b
        };
      }
    },
    renderMarkdown: (g) => {
      let d = "";
      t ? d = t(g) : g.content && g.content.length > 0 && (d = g.content.filter((h) => h.type === "text").map((h) => h.text).join(""));
      const p = u(g.attrs || {}), m = a(p), y = m ? ` ${m}` : "";
      return i ? `[${c}${y}]` : `[${c}${y}]${d}[/${c}]`;
    }
  };
}
function tL(o, e, r) {
  var t, n, a, s;
  const i = o.split(`
`), l = [];
  let c = "", u = 0;
  const f = e.baseIndentSize || 2;
  for (; u < i.length; ) {
    const g = i[u], d = g.match(e.itemPattern);
    if (!d) {
      if (l.length > 0)
        break;
      if (g.trim() === "") {
        u += 1;
        continue;
      } else
        return;
    }
    const p = e.extractItemData(d), { indentLevel: m, mainContent: y } = p;
    c = `${c}${g}
`;
    const h = [y];
    for (u += 1; u < i.length; ) {
      const P = i[u];
      if (P.trim() === "") {
        const S = i.slice(u + 1).findIndex((A) => A.trim() !== "");
        if (S === -1)
          break;
        if ((((n = (t = i[u + 1 + S].match(/^(\s*)/)) == null ? void 0 : t[1]) == null ? void 0 : n.length) || 0) > m) {
          h.push(P), c = `${c}${P}
`, u += 1;
          continue;
        } else
          break;
      }
      if ((((s = (a = P.match(/^(\s*)/)) == null ? void 0 : a[1]) == null ? void 0 : s.length) || 0) > m)
        h.push(P), c = `${c}${P}
`, u += 1;
      else
        break;
    }
    let F;
    const b = h.slice(1);
    if (b.length > 0) {
      const P = b.map((E) => E.slice(m + f)).join(`
`);
      P.trim() && (e.customNestedParser ? F = e.customNestedParser(P) : F = r.blockTokens(P));
    }
    const v = e.createToken(p, F);
    l.push(v);
  }
  if (l.length !== 0)
    return {
      items: l,
      raw: c.trim()
    };
}
function nL(o, e, r, t) {
  if (!o || !Array.isArray(o.content))
    return "";
  const n = typeof r == "function" ? r(t) : r, [a, ...s] = o.content, i = e.renderChildren([a]), l = [`${n}${i}`];
  return s && s.length > 0 && s.forEach((c) => {
    const u = e.renderChildren([c]);
    if (u) {
      const f = u.split(`
`).map((g) => g ? e.indent(g) : "").join(`
`);
      l.push(f);
    }
  }), l.join(`
`);
}
const aL = Xo.create({
  name: "letterSpacing",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          letterSpacing: {
            default: null,
            parseHTML: (o) => o.style.letterSpacing || null,
            renderHTML: (o) => o.letterSpacing ? {
              style: `letter-spacing: ${o.letterSpacing}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setLetterSpacing: (o) => ({ chain: e }) => e().setMark("textStyle", { letterSpacing: o }).run(),
      unsetLetterSpacing: () => ({ chain: o }) => o().setMark("textStyle", { letterSpacing: null }).removeEmptyTextStyle().run()
    };
  }
}), sL = { class: "focus-within:outline focus-within:outline-offset-2 focus-within:outline-primary-500" }, LR = /* @__PURE__ */ H({
  __name: "InlineEditor",
  props: {
    modelValue: {}
  },
  emits: ["focus", "update:modelValue"],
  setup(o, { expose: e, emit: r }) {
    const t = o, n = r, a = ep({
      editorProps: {
        attributes: {
          class: "focus:outline-none"
        },
        handleDOMEvents: {
          focus: () => {
            n("focus");
          }
        }
      },
      content: t.modelValue,
      editable: !0,
      extensions: [
        rp,
        tp,
        np,
        ap,
        sp,
        ip,
        lp,
        w2,
        k2,
        aL,
        D2,
        S2,
        A2,
        E2.configure({
          multicolor: !0
        })
      ],
      onUpdate: () => {
        var s;
        n("update:modelValue", (s = a.value) == null ? void 0 : s.getJSON());
      }
    });
    return e({
      editor: a
    }), (s, i) => (k(), N("div", sL, [
      z(B(op), { editor: B(a) }, null, 8, ["editor"])
    ]));
  }
}), iL = { class: "relative" }, lL = ["id"], cL = {
  key: 0,
  role: "listbox"
}, uL = ["onClick"], pL = { class: "block truncate" }, jR = /* @__PURE__ */ H({
  inheritAttrs: !1,
  __name: "InputAddressSearch",
  props: {
    config: {},
    disabled: { type: Boolean },
    invalid: { type: Boolean },
    leadingIcon: {},
    modelValue: {},
    initialSearchQuery: {}
  },
  emits: ["update:modelValue"],
  setup(o, { emit: e }) {
    const r = o, t = fo(), n = e, { searchClient: a } = vi(r.config.hostUrl, r.config.apiKey), s = ue(r.initialSearchQuery ?? ""), [i, l] = Po(!!r.initialSearchQuery), c = ue();
    za(c, () => l(!1));
    const u = pt((d, p) => {
      l(!0), s.value = p, d(p);
    }, 300), f = pt((d) => {
      d();
    }, 500), g = (d) => {
      n("update:modelValue", d.barcode), s.value = d.single_line_address, l(!1);
    };
    return (d, p) => (k(), N("div", iL, [
      z(B(Ci), {
        "search-client": B(a),
        "index-name": "addresses:building_number:asc",
        "initial-ui-state": { "addresses:building_number:asc": { query: d.initialSearchQuery } },
        future: { preserveSharedStateOnUnmount: !0 }
      }, {
        default: j(() => [
          z(B(Za), null, {
            default: j(({ refine: m }) => [
              z(Ut, Ve({
                "model-value": s.value,
                type: "search",
                "leading-icon": d.leadingIcon,
                "aria-controls": B(t),
                "aria-expanded": B(i),
                autocomplete: "off"
              }, d.$attrs, {
                "onUpdate:modelValue": (y) => B(u)(m, y)
              }), null, 16, ["model-value", "leading-icon", "aria-controls", "aria-expanded", "onUpdate:modelValue"])
            ]),
            _: 1
          }),
          z(B(Oi), { "class-names": { "ais-InfiniteHits-loadMore": "hidden" } }, {
            default: j(({ items: m, refineNext: y, isLastPage: h }) => [
              z(Co, {
                "leave-active-class": "transition ease-in duration-100",
                "leave-from-class": "opacity-100",
                "leave-to-class": "opacity-0"
              }, {
                default: j(() => [
                  B(i) ? co((k(), N("div", {
                    key: 0,
                    id: B(t),
                    ref_key: "dropdown",
                    ref: c,
                    class: q([
                      "absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5",
                      "focus:outline-none",
                      "sm:text-sm"
                    ])
                  }, [
                    m.length ? (k(), N("ul", cL, [
                      (k(!0), N(ye, null, Oe(m, (F) => (k(), N("li", {
                        key: F.id,
                        class: q([
                          "relative cursor-default select-none py-2 pl-3 pr-9 text-default-900",
                          "hover:bg-primary-600 hover:text-white hover:outline-none"
                        ]),
                        role: "option",
                        onClick: (b) => g(F)
                      }, [
                        O("span", pL, [
                          z(B(Ua), {
                            hit: F,
                            attribute: "single_line_address",
                            "class-names": { "ais-Highlight-highlighted": "bg-transparent font-semibold text-inherit" }
                          }, null, 8, ["hit"])
                        ])
                      ], 8, uL))), 128))
                    ])) : K("", !0)
                  ], 8, lL)), [
                    [B(Ia), [() => B(f)(y), { distance: 10, canLoadMore: () => !h }]]
                  ]) : K("", !0)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["search-client", "initial-ui-state"])
    ]));
  }
}), dL = { class: "flex shadow-sm rounded-md" }, gL = { class: "-mr-px flex-1" }, mL = ["id", "value"], MR = /* @__PURE__ */ H({
  inheritAttrs: !1,
  __name: "InputCopyToClipboard",
  props: {
    value: {}
  },
  emits: ["copy"],
  setup(o, { emit: e }) {
    const r = o, t = e, { copy: n, copied: a } = Wh({
      legacy: !0,
      source: r.value.toString()
    });
    Bi(a, () => {
      t("copy");
    });
    const s = ce("field-id");
    return (i, l) => (k(), N("div", dL, [
      O("div", gL, [
        O("input", Ve({
          id: B(s),
          type: "url",
          readonly: "",
          class: [
            "text-base pointer-events-none block w-full rounded-l-md border-0 py-1.5 text-default-900 outline outline-1 -outline-offset-1 outline-default-300",
            "placeholder:text-default-400",
            "sm:text-sm sm:leading-6",
            "focus:ring-0 focus:shadow-none focus:relative focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-primary-600"
          ],
          value: i.value
        }, i.$attrs), null, 16, mL)
      ]),
      co((k(), N("button", {
        "aria-label": "Copy to clipboard",
        type: "button",
        class: q([
          "flex-none rounded-r-md bg-default-50 px-3 py-2 text-sm font-semibold text-default-900",
          "outline outline-1 -outline-offset-1 outline-default-300",
          "hover:bg-default-100",
          "focus:relative focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-primary-600"
        ]),
        onClick: l[0] || (l[0] = (c) => B(n)(i.value))
      }, [
        B(a) ? (k(), R(B(le), {
          key: 1,
          icon: B(NF),
          class: "size-4 text-emerald-800",
          "aria-hidden": "true"
        }, null, 8, ["icon"])) : (k(), R(B(le), {
          key: 0,
          icon: B(VF),
          class: "size-4",
          "aria-hidden": "true"
        }, null, 8, ["icon"]))
      ])), [
        [B(Up), B(a) ? "Copied" : "Copy to clipboard"]
      ])
    ]));
  }
}), fL = ["disabled", "aria-disabled", "aria-labelledby", "tabindex"], yL = {
  key: 0,
  class: "flex items-center space-x-base relative"
}, hL = { class: "flex-1 text-left" }, FL = { class: "text-sm text-default-500 pt-tiny" }, bL = {
  key: 1,
  class: "relative"
}, vL = { class: "block pt-sm" }, BL = { class: "text-sm text-default-500 pt-tiny" }, WR = /* @__PURE__ */ H({
  __name: "InputFileDropZone",
  props: {
    accept: { default: void 0 },
    disabled: { type: Boolean },
    maxFileSize: {},
    multiple: { type: Boolean },
    variant: { default: "horizontal" }
  },
  emits: ["change", "error"],
  setup(o, { emit: e }) {
    const r = o, t = ue(), { isOverDropZone: n } = y2(t, {
      dataTypes: r.accept,
      multiple: r.multiple,
      onDrop(g) {
        !g || r.disabled || c(g);
      }
    }), { open: a, onChange: s } = Nh({
      accept: r.accept ? r.accept.join(", ") : "*",
      multiple: r.multiple
    });
    s((g) => {
      g && c(Array.from(g));
    });
    const i = e, l = ol.object({
      ...r.accept && {
        type: ol.string().refine((g) => {
          var d;
          return (d = r.accept) == null ? void 0 : d.includes(g);
        }, {
          message: `The file must have one of the following extensions: ${r.accept.join(", ")}.`
        })
      },
      size: ol.number().max(r.maxFileSize * 1024, {
        message: `The file must not be greater than ${r.maxFileSize} kilobytes.`
      })
    }), c = (g) => {
      const d = [];
      g.forEach((p) => {
        const m = l.safeParse(p);
        m.success ? d.push(p) : i("error", m.error.errors[0].message);
      }), d.length === g.length && i("change", g);
    }, u = () => {
      a();
    }, f = ce("field-id");
    return (g, d) => (k(), N("button", {
      ref_key: "dropZone",
      ref: t,
      type: "button",
      disabled: g.disabled,
      "aria-disabled": g.disabled,
      "aria-labelledby": B(f),
      tabindex: g.disabled ? "-1" : 0,
      class: q([
        "w-full group text-center rounded-lg border border-dashed border-primary-600 relative p-base bg-primary-50",
        "focus-visible:outline-none focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600",
        (B(n) || g.disabled) && "opacity-50",
        g.disabled ? "pointer-events-none" : "cursor-pointer"
      ]),
      onClick: u
    }, [
      g.variant === "horizontal" ? (k(), N("span", yL, [
        z(B(le), {
          icon: B(kf),
          class: "w-5 h-5 text-default-400 flex-none",
          "aria-hidden": "true"
        }, null, 8, ["icon"]),
        O("span", hL, [
          O("span", {
            class: q([
              "cursor-pointer rounded-md font-medium text-primary-600",
              !g.disabled && "group-hover:text-primary-500"
            ])
          }, d[0] || (d[0] = [
            ne(" Click to upload "),
            O("span", { class: "text-default-700 block" }, " or drag and drop ", -1)
          ]), 2),
          O("span", FL, " Max file size: " + _(g.maxFileSize / 1024) + "mb ", 1)
        ])
      ])) : K("", !0),
      g.variant === "vertical" ? (k(), N("span", bL, [
        z(B(le), {
          icon: B(kf),
          class: "w-5 h-5 text-default-400 flex-none",
          "aria-hidden": "true"
        }, null, 8, ["icon"]),
        O("span", vL, [
          O("span", {
            class: q([
              "cursor-pointer rounded-md font-medium text-primary-600",
              !g.disabled && "group-hover:text-primary-500"
            ])
          }, d[1] || (d[1] = [
            ne(" Click to upload "),
            O("span", { class: "text-default-700 block" }, " or drag and drop ", -1)
          ]), 2)
        ]),
        O("span", BL, " Max file size: " + _(g.maxFileSize / 1024) + "mb ", 1)
      ])) : K("", !0)
    ], 10, fL));
  }
}), PL = {
  class: /* @__PURE__ */ q([
    "shrink-0",
    "focus-within:relative"
  ])
}, wL = ["aria-label", "disabled", "tabindex"], NR = /* @__PURE__ */ H({
  __name: "InputGroupSelect",
  props: /* @__PURE__ */ yr({
    ariaLabel: {}
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(o) {
    const e = hr(o, "modelValue"), r = ce("disabled");
    return (t, n) => (k(), N("div", PL, [
      co(O("select", {
        "onUpdate:modelValue": n[0] || (n[0] = (a) => e.value = a),
        "aria-label": t.ariaLabel,
        class: q([
          "w-full rounded-md bg-white py-1.5 pl-3 pr-7 border-0 text-base text-default-900",
          "sm:text-sm sm:leading-6",
          "focus:ring-0 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-primary-600",
          "disabled:opacity-100"
        ]),
        disabled: B(r),
        tabindex: B(r) ? "-1" : 0
      }, [
        I(t.$slots, "default")
      ], 8, wL), [
        [Ph, e.value]
      ])
    ]));
  }
}), kL = { class: "relative" }, DL = ["id"], SL = {
  key: 0,
  role: "listbox"
}, AL = ["onClick"], EL = { class: "block truncate" }, xL = {
  key: 0,
  class: "absolute inset-y-0 right-0 flex items-center pr-4 text-primary-600"
}, VR = /* @__PURE__ */ H({
  inheritAttrs: !1,
  __name: "InputMultiAddressSearch",
  props: {
    config: {},
    disabled: { type: Boolean },
    invalid: { type: Boolean },
    leadingIcon: {},
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(o, { emit: e }) {
    const r = o, t = fo(), n = e, { searchClient: a } = vi(r.config.hostUrl, r.config.apiKey), s = ue(""), [i, l] = Po(!1), c = ue();
    za(c, () => l(!1));
    const u = pt((d, p) => {
      l(!0), s.value = p, d(p);
    }, 300), f = pt((d) => {
      d();
    }, 500), g = (d) => {
      const p = [...r.modelValue], m = p.findIndex((y) => y.barcode === d.barcode);
      m === -1 ? p.push(d) : p.splice(m, 1), n("update:modelValue", p), s.value = "", l(!1);
    };
    return (d, p) => (k(), N("div", kL, [
      z(B(Ci), {
        "search-client": B(a),
        "index-name": "addresses:building_number:asc",
        future: { preserveSharedStateOnUnmount: !0 }
      }, {
        default: j(() => [
          z(B(Za), null, {
            default: j(({ refine: m }) => [
              z(Ut, Ve({
                "model-value": s.value,
                type: "search",
                "leading-icon": d.leadingIcon,
                "aria-controls": B(t),
                "aria-expanded": B(i)
              }, d.$attrs, {
                "onUpdate:modelValue": (y) => B(u)(m, y)
              }), null, 16, ["model-value", "leading-icon", "aria-controls", "aria-expanded", "onUpdate:modelValue"])
            ]),
            _: 1
          }),
          z(B(Oi), { "class-names": { "ais-InfiniteHits-loadMore": "hidden" } }, {
            default: j(({ items: m, refineNext: y, isLastPage: h }) => [
              z(Co, {
                "leave-active-class": "transition ease-in duration-100",
                "leave-from-class": "opacity-100",
                "leave-to-class": "opacity-0"
              }, {
                default: j(() => [
                  B(i) ? co((k(), N("div", {
                    key: 0,
                    id: B(t),
                    ref_key: "dropdown",
                    ref: c,
                    class: q([
                      "absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5",
                      "focus:outline-none",
                      "sm:text-sm"
                    ])
                  }, [
                    m.length ? (k(), N("ul", SL, [
                      (k(!0), N(ye, null, Oe(m, (F) => (k(), N("li", {
                        key: F.id,
                        class: q([
                          "relative cursor-default select-none py-2 pl-3 pr-9 text-default-900",
                          "hover:bg-primary-600 hover:text-white hover:outline-none",
                          d.modelValue.some((b) => b.barcode === F.barcode) ? "bg-primary-50" : ""
                        ]),
                        role: "option",
                        onClick: (b) => g(F)
                      }, [
                        O("span", EL, [
                          z(B(Ua), {
                            hit: F,
                            attribute: "single_line_address",
                            "class-names": { "ais-Highlight-highlighted": "bg-transparent font-semibold text-inherit" }
                          }, null, 8, ["hit"])
                        ]),
                        d.modelValue.some((b) => b.barcode === F.barcode) ? (k(), N("span", xL, [
                          z(B(le), {
                            icon: B(qa),
                            class: "h-5 w-5"
                          }, null, 8, ["icon"])
                        ])) : K("", !0)
                      ], 10, AL))), 128))
                    ])) : K("", !0)
                  ], 8, DL)), [
                    [B(Ia), [() => B(f)(y), { distance: 10, canLoadMore: () => !h }]]
                  ]) : K("", !0)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["search-client"])
    ]));
  }
}), CL = { class: "relative" }, OL = ["id"], TL = {
  key: 0,
  role: "listbox"
}, LL = ["onClick"], jL = { class: "block truncate" }, zR = /* @__PURE__ */ H({
  inheritAttrs: !1,
  __name: "InputOutcodeSearch",
  props: {
    config: {},
    disabled: { type: Boolean },
    invalid: { type: Boolean },
    leadingIcon: {},
    modelValue: {},
    initialSearchQuery: {}
  },
  emits: ["update:modelValue"],
  setup(o, { emit: e }) {
    const r = o, t = fo(), n = e, { searchClient: a } = vi(r.config.hostUrl, r.config.apiKey), [s, i] = Po(!1), l = {
      ...a,
      search: (...y) => a.search(...y).finally(() => {
        i(!0);
      })
    }, c = ue(r.initialSearchQuery ?? ""), [u, f] = Po(!!r.initialSearchQuery), g = ue();
    za(g, () => f(!1));
    const d = pt((y, h) => {
      f(!0), c.value = h, y(h);
    }, 300), p = pt((y) => {
      y();
    }, 500), m = (y) => {
      n("update:modelValue", y.name), c.value = y.name, f(!1);
    };
    return (y, h) => (k(), N("div", CL, [
      z(B(Ci), {
        "search-client": l,
        "index-name": "areas:display_name:asc",
        "initial-ui-state": { "areas:display_name:asc": { query: y.initialSearchQuery } },
        future: { preserveSharedStateOnUnmount: !0 },
        "stalled-search-delay": 200
      }, {
        default: j(() => [
          z(B(pF), {
            filters: "area_type = POSTCODE_OUTCODE",
            attributesToHighlight: ["name"],
            attributesToRetrieve: ["name"]
          }),
          B(s) ? K("", !0) : (k(), R(Ut, {
            key: 0,
            placeholder: "Loading...",
            disabled: ""
          })),
          z(B(Za), null, {
            default: j(({ refine: F, isSearchStalled: b }) => [
              b ? (k(), R(Yr, {
                key: 0,
                class: "size-4 text-gray-500 absolute end-10 top-2.5 z-10"
              })) : K("", !0),
              z(Ut, Ve({
                "model-value": c.value,
                type: "search",
                "leading-icon": y.leadingIcon,
                "aria-controls": B(t),
                "aria-expanded": B(u),
                autocomplete: "off"
              }, y.$attrs, {
                "onUpdate:modelValue": (v) => B(d)(F, v)
              }), null, 16, ["model-value", "leading-icon", "aria-controls", "aria-expanded", "onUpdate:modelValue"])
            ]),
            _: 1
          }),
          z(B(Oi), { "class-names": { "ais-InfiniteHits-loadMore": "hidden" } }, {
            default: j(({ items: F, refineNext: b, isLastPage: v }) => [
              z(Co, {
                "leave-active-class": "transition ease-in duration-100",
                "leave-from-class": "opacity-100",
                "leave-to-class": "opacity-0"
              }, {
                default: j(() => [
                  B(u) ? co((k(), N("div", {
                    key: 0,
                    id: B(t),
                    ref_key: "dropdown",
                    ref: g,
                    class: q([
                      "absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5",
                      "focus:outline-none",
                      "sm:text-sm"
                    ])
                  }, [
                    F.length ? (k(), N("ul", TL, [
                      (k(!0), N(ye, null, Oe(F, (P) => (k(), N("li", {
                        key: P.id,
                        class: q([
                          "relative cursor-default select-none py-2 pl-3 pr-9 text-default-900",
                          "hover:bg-primary-600 hover:text-white hover:outline-none"
                        ]),
                        role: "option",
                        onClick: (E) => m(P)
                      }, [
                        O("span", jL, [
                          z(B(Ua), {
                            hit: P,
                            attribute: "name",
                            "class-names": { "ais-Highlight-highlighted": "bg-transparent font-semibold text-inherit" }
                          }, null, 8, ["hit"])
                        ])
                      ], 8, LL))), 128))
                    ])) : K("", !0)
                  ], 8, OL)), [
                    [B(Ia), [() => B(p)(b), { distance: 10, canLoadMore: () => !v }]]
                  ]) : K("", !0)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["initial-ui-state"])
    ]));
  }
}), ML = ["id", "min", "max", "step", "disabled", "tabindex", "aria-disabled", "aria-invalid", "aria-describedby"], WL = /* @__PURE__ */ H({
  inheritAttrs: !1,
  __name: "InputRange",
  props: /* @__PURE__ */ yr({
    disabled: { type: Boolean },
    invalid: { type: Boolean },
    min: {},
    max: {},
    step: { default: 1 }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(o) {
    const e = hr(o, "modelValue"), r = ce("field-id");
    return (t, n) => {
      var a;
      return k(), N("div", {
        class: q([
          "inline-flex w-full",
          t.disabled && "opacity-50 pointer-events-none"
        ])
      }, [
        co(O("input", Ve({
          id: B(r),
          "onUpdate:modelValue": n[0] || (n[0] = (s) => e.value = s),
          type: "range",
          min: t.min,
          max: t.max,
          step: t.step,
          class: [
            "rounded-full bg-default-200 w-full appearance-none cursor-grab",
            "focus:outline-none focus:outline-primary-600 focus:outline-2 focus:outline-offset-2",
            "active:enabled:cursor-grabbing"
          ],
          style: {
            "--min": t.min,
            "--max": t.max,
            "--val": (a = e.value) == null ? void 0 : a.toString()
          },
          disabled: t.disabled,
          tabindex: t.disabled ? "-1" : 0,
          "aria-disabled": t.disabled,
          "aria-invalid": !!t.invalid,
          "aria-describedby": t.invalid ? `${B(r)}-error` : void 0
        }, t.$attrs), null, 16, ML), [
          [Ju, e.value]
        ])
      ], 2);
    };
  }
}), IR = /* @__PURE__ */ fe(WL, [["__scopeId", "data-v-a1e9e25f"]]), NL = {}, VL = { class: "text-xs p-xxs border-default-200 bg-white border rounded" };
function zL(o, e) {
  return k(), N("span", VL, [
    I(o.$slots, "default")
  ]);
}
const RR = /* @__PURE__ */ fe(NL, [["render", zL]]), IL = {
  class: /* @__PURE__ */ q([
    "rounded-md overflow-x-auto",
    "sm:text-sm sm:leading-6",
    "focus-within:ring-2 focus-within:ring-inset focus-within:ring-primary-600"
  ])
}, RL = /* @__PURE__ */ H({
  __name: "InputRichText",
  props: {
    ariaLabel: {},
    disabled: { type: Boolean, default: !1 },
    invalid: { type: Boolean },
    modelValue: { default: void 0 },
    placeholder: { default: void 0 }
  },
  emits: ["update:modelValue"],
  setup(o, { emit: e }) {
    const r = o, t = rp.extend({
      content: "inline*"
    }), n = Xo.create({
      name: "inlinePlaceholder",
      addOptions() {
        return {
          placeholder: ""
        };
      },
      addProseMirrorPlugins() {
        return [
          new Gr({
            key: new Xr("inlinePlaceholder"),
            props: {
              decorations: ({ doc: f }) => {
                if (!this.editor.isEmpty)
                  return null;
                const g = or.widget(0, () => {
                  const d = document.createElement("span");
                  return d.className = "is-editor-empty", d.setAttribute("data-placeholder", this.options.placeholder), d;
                });
                return Ze.create(f, [g]);
              }
            }
          })
        ];
      }
    }), a = e, s = ce("field-id", null), [i, l] = Po(!1), c = wh("target");
    za(c, () => l(!1));
    const u = ep({
      editorProps: {
        attributes: {
          class: "py-1.5 px-3 !whitespace-nowrap focus:outline-none"
        },
        handleDOMEvents: {
          focus: () => {
            r.disabled || l(!0);
          }
        }
      },
      content: r.modelValue,
      editable: !r.disabled,
      extensions: [
        t,
        tp,
        np,
        ap,
        sp,
        ip,
        lp,
        n.configure({
          placeholder: r.placeholder ?? ""
        })
      ],
      onUpdate: () => {
        var f;
        a("update:modelValue", (f = u.value) == null ? void 0 : f.getJSON());
      }
    });
    return (f, g) => (k(), R(B($t), {
      ref_key: "target",
      ref: c,
      as: "div",
      class: q([
        "relative rounded-md shadow-sm ring-1 ring-inset ring-default-300",
        f.disabled && "opacity-50 pointer-events-none"
      ])
    }, {
      default: j(() => [
        O("div", IL, [
          z(B(op), {
            editor: B(u),
            role: "textbox",
            "aria-label": f.ariaLabel,
            "aria-disabled": f.disabled,
            "aria-invalid": !!f.invalid,
            "aria-describedby": f.invalid ? `${B(s)}-error` : void 0
          }, null, 8, ["editor", "aria-label", "aria-disabled", "aria-invalid", "aria-describedby"])
        ]),
        z(Co, {
          "enter-active-class": "transition duration-200 ease-out",
          "enter-from-class": "translate-y-1 opacity-0",
          "enter-to-class": "translate-y-0 opacity-100",
          "leave-active-class": "transition duration-150 ease-in",
          "leave-from-class": "translate-y-0 opacity-100",
          "leave-to-class": "translate-y-1 opacity-0"
        }, {
          default: j(() => [
            B(i) ? (k(), R(B(en), {
              key: 0,
              static: "",
              class: "absolute z-10 mt-2 ml-3 rounded-md bg-white shadow-lg ring-1 ring-default-300 p-2 flex space-x-2"
            }, {
              default: j(() => {
                var d, p, m, y;
                return [
                  z(Re, {
                    icon: B(y1),
                    ariaLabel: "Toggle bold",
                    color: (d = B(u)) != null && d.isActive("bold") ? "primary" : "tertiary",
                    onClick: g[0] || (g[0] = (h) => {
                      var F;
                      return (F = B(u)) == null ? void 0 : F.chain().focus().toggleBold().run();
                    })
                  }, null, 8, ["icon", "color"]),
                  z(Re, {
                    icon: B(f1),
                    ariaLabel: "Toggle italic",
                    color: (p = B(u)) != null && p.isActive("italic") ? "primary" : "tertiary",
                    onClick: g[1] || (g[1] = (h) => {
                      var F;
                      return (F = B(u)) == null ? void 0 : F.chain().focus().toggleItalic().run();
                    })
                  }, null, 8, ["icon", "color"]),
                  z(Re, {
                    icon: B(h1),
                    ariaLabel: "Toggle underline",
                    color: (m = B(u)) != null && m.isActive("underline") ? "primary" : "tertiary",
                    onClick: g[2] || (g[2] = (h) => {
                      var F;
                      return (F = B(u)) == null ? void 0 : F.chain().focus().toggleUnderline().run();
                    })
                  }, null, 8, ["icon", "color"]),
                  z(Re, {
                    icon: B(b1),
                    ariaLabel: "Toggle strike through",
                    color: (y = B(u)) != null && y.isActive("strike") ? "primary" : "tertiary",
                    onClick: g[3] || (g[3] = (h) => {
                      var F;
                      return (F = B(u)) == null ? void 0 : F.chain().focus().toggleStrike().run();
                    })
                  }, null, 8, ["icon", "color"])
                ];
              }),
              _: 1
            })) : K("", !0)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["class"]));
  }
}), HR = /* @__PURE__ */ fe(RL, [["__scopeId", "data-v-20062d37"]]), HL = { class: "w-full rounded-md bg-white p-base" }, Py = /* @__PURE__ */ H({
  __name: "TextPreview",
  props: {
    fontFamily: {},
    fontWeight: {},
    fontSize: {},
    textColour: {}
  },
  setup(o) {
    const e = o;
    return (r, t) => (k(), N("div", HL, [
      O("h2", {
        style: qo({
          fontFamily: e.fontFamily,
          fontWeight: e.fontWeight,
          fontSize: `${e.fontSize}px`,
          color: e.textColour
        })
      }, " The Quick Brown Fox Jumps Over The Lazy Dog ", 4),
      z(oo, {
        color: "secondary",
        class: "mt-5"
      }, {
        default: j(() => [
          ne(_(r.fontFamily) + ", " + _(r.fontWeight) + ", " + _(r.fontSize) + "px, " + _(r.textColour), 1)
        ]),
        _: 1
      })
    ]));
  }
}), YL = { class: "flex size-full items-center justify-center rounded-md bg-white p-base" }, wy = /* @__PURE__ */ H({
  __name: "ButtonPreview",
  props: {
    fontFamily: {},
    fontWeight: {},
    textColour: {},
    textHoverColour: {},
    backgroundColour: {},
    backgroundHoverColour: {},
    text: {}
  },
  setup(o) {
    const e = o;
    return (r, t) => (k(), N("div", YL, [
      O("button", {
        class: "inline-flex items-center rounded-md px-3 py-2 text-sm transition duration-150 ease-in-out",
        style: qo({
          fontFamily: e.fontFamily,
          fontWeight: e.fontWeight,
          color: e.textColour,
          backgroundColor: e.backgroundColour
        })
      }, _(r.text ?? "Example button"), 5)
    ]));
  }
}), qL = { class: "mx-2 items-center justify-center text-center" }, GL = { class: "text-xs text-gray-700" }, ky = /* @__PURE__ */ H({
  __name: "ColourPreview",
  props: {
    colour: {}
  },
  setup(o) {
    return (e, r) => (k(), N("div", qL, [
      O("div", {
        class: "mx-auto flex size-14 shrink-0 items-center justify-center rounded-md",
        style: qo(`background-color: ${e.colour}`)
      }, null, 4),
      O("span", GL, _(e.colour), 1)
    ]));
  }
}), XL = { class: "space-y-3 rounded-md bg-default-200 p-base" }, UL = { class: "flex justify-end" }, ZL = /* @__PURE__ */ H({
  __name: "PreviewContainer",
  setup(o) {
    return (e, r) => (k(), N("div", XL, [
      O("div", UL, [
        z(Yp, { color: "blue" }, {
          default: j(() => r[0] || (r[0] = [
            ne(" Preview ")
          ])),
          _: 1
        })
      ]),
      O("div", null, [
        I(e.$slots, "default")
      ])
    ]));
  }
}), KL = { class: "max-w-2xl" }, QL = { class: "flex flex-row gap-base" }, JL = { class: "w-1/2" }, _L = { class: "w-1/2" }, $L = { class: "mt-base flex flex-col 2xl:flex-row gap-base" }, ej = { class: "w-full 2xl:w-2/12" }, oj = { class: "w-full 2xl:w-5/12" }, rj = { class: "flex h-full items-center rounded-md bg-white" }, tj = { class: "w-full 2xl:w-5/12" }, nj = { class: "flex justify-center rounded-md bg-white p-base" }, YR = /* @__PURE__ */ H({
  __name: "LargeBrandPreview",
  props: {
    rectangleLogoSrc: {},
    squareLogoSrc: {},
    headingFontFamily: {},
    headingFontWeight: {},
    headingFontSize: {},
    headingTextColour: {},
    bodyFontFamily: {},
    bodyFontWeight: {},
    bodyFontSize: {},
    bodyTextColour: {},
    primaryColour: {},
    secondaryColour: {},
    primaryButtonFontFamily: {},
    primaryButtonFontWeight: {},
    primaryButtonTextColour: {},
    primaryButtonTextHoverColour: {},
    primaryButtonBackgroundColour: {},
    primaryButtonBackgroundHoverColour: {},
    secondaryButtonFontFamily: {},
    secondaryButtonFontWeight: {},
    secondaryButtonTextColour: {},
    secondaryButtonTextHoverColour: {},
    secondaryButtonBackgroundColour: {},
    secondaryButtonBackgroundHoverColour: {}
  },
  setup(o) {
    return (e, r) => (k(), N("div", KL, [
      z(ZL, null, {
        default: j(() => [
          O("div", QL, [
            O("div", JL, [
              z(zf, {
                "image-url": e.rectangleLogoSrc,
                class: "size-full"
              }, null, 8, ["image-url"])
            ]),
            O("div", _L, [
              z(Py, {
                "font-family": e.headingFontFamily,
                "font-weight": e.headingFontWeight,
                "font-size": e.headingFontSize,
                "text-colour": e.headingTextColour
              }, null, 8, ["font-family", "font-weight", "font-size", "text-colour"]),
              z(Py, {
                "font-family": e.bodyFontFamily,
                "font-weight": e.bodyFontWeight,
                "font-size": e.bodyFontSize,
                "text-colour": e.bodyTextColour,
                class: "mt-base"
              }, null, 8, ["font-family", "font-weight", "font-size", "text-colour"])
            ])
          ]),
          O("div", $L, [
            O("div", ej, [
              z(zf, {
                "image-url": e.squareLogoSrc,
                class: "size-full"
              }, null, 8, ["image-url"])
            ]),
            O("div", oj, [
              O("div", rj, [
                z(wy, {
                  "font-family": e.primaryButtonFontFamily,
                  "font-weight": e.primaryButtonFontWeight,
                  "text-colour": e.primaryButtonTextColour,
                  "text-hover-colour": e.primaryButtonTextHoverColour,
                  "background-colour": e.primaryButtonBackgroundColour,
                  "background-hover-colour": e.primaryButtonBackgroundHoverColour,
                  text: "Primary"
                }, null, 8, ["font-family", "font-weight", "text-colour", "text-hover-colour", "background-colour", "background-hover-colour"]),
                z(wy, {
                  "font-family": e.secondaryButtonFontFamily,
                  "font-weight": e.secondaryButtonFontWeight,
                  "text-colour": e.secondaryButtonTextColour,
                  "text-hover-colour": e.secondaryButtonTextHoverColour,
                  "background-colour": e.secondaryButtonBackgroundColour,
                  "background-hover-colour": e.secondaryButtonBackgroundHoverColour,
                  text: "Secondary"
                }, null, 8, ["font-family", "font-weight", "text-colour", "text-hover-colour", "background-colour", "background-hover-colour"])
              ])
            ]),
            O("div", tj, [
              O("div", nj, [
                z(ky, { colour: e.primaryColour }, null, 8, ["colour"]),
                z(ky, { colour: e.secondaryColour }, null, 8, ["colour"])
              ])
            ])
          ])
        ]),
        _: 1
      })
    ]));
  }
}), aj = { class: "isolate flex justify-between items-center" }, sj = { class: "flex flex-1 justify-between sm:hidden" }, qR = /* @__PURE__ */ H({
  __name: "LengthAwarePagination",
  props: {
    as: { default: yo },
    paginator: {}
  },
  setup(o) {
    const e = o, r = ue(e.paginator);
    return he("paginator", r), he("as", e.as), Ir(() => e.paginator, (t) => {
      r.value = t;
    }), (t, n) => (k(), N("nav", aj, [
      O("div", sj, [
        z(eo, {
          as: r.value.prev_page_url ? t.as : "button",
          href: r.value.prev_page_url,
          color: "secondary",
          disabled: !r.value.prev_page_url
        }, {
          default: j(() => n[0] || (n[0] = [
            ne(" Previous ")
          ])),
          _: 1
        }, 8, ["as", "href", "disabled"]),
        z(eo, {
          as: r.value.next_page_url ? t.as : "button",
          href: r.value.next_page_url,
          color: "secondary",
          disabled: !r.value.next_page_url
        }, {
          default: j(() => n[1] || (n[1] = [
            ne(" Next ")
          ])),
          _: 1
        }, 8, ["as", "href", "disabled"])
      ]),
      I(t.$slots, "default")
    ]));
  }
});
var bc = {}, vc = {}, Bc = {}, Dy;
function Cb() {
  return Dy || (Dy = 1, function(o) {
    Object.defineProperty(o, "__esModule", {
      value: !0
    }), Object.defineProperty(o, "default", {
      enumerable: !0,
      get: function() {
        return e;
      }
    });
    function e(r) {
      if (r = `${r}`, r === "0")
        return "0";
      if (/^[+-]?(\d+|\d*\.\d+)(e[+-]?\d+)?(%|\w+)?$/.test(r))
        return r.replace(/^[+-]?/, (n) => n === "-" ? "" : "-");
      let t = [
        "var",
        "calc",
        "min",
        "max",
        "clamp"
      ];
      for (const n of t)
        if (r.includes(`${n}(`))
          return `calc(${r} * -1)`;
    }
  }(Bc)), Bc;
}
var Pc = {}, Sy;
function ij() {
  return Sy || (Sy = 1, function(o) {
    Object.defineProperty(o, "__esModule", {
      value: !0
    }), Object.defineProperty(o, "default", {
      enumerable: !0,
      get: function() {
        return e;
      }
    });
    const e = [
      "preflight",
      "container",
      "accessibility",
      "pointerEvents",
      "visibility",
      "position",
      "inset",
      "isolation",
      "zIndex",
      "order",
      "gridColumn",
      "gridColumnStart",
      "gridColumnEnd",
      "gridRow",
      "gridRowStart",
      "gridRowEnd",
      "float",
      "clear",
      "margin",
      "boxSizing",
      "lineClamp",
      "display",
      "aspectRatio",
      "size",
      "height",
      "maxHeight",
      "minHeight",
      "width",
      "minWidth",
      "maxWidth",
      "flex",
      "flexShrink",
      "flexGrow",
      "flexBasis",
      "tableLayout",
      "captionSide",
      "borderCollapse",
      "borderSpacing",
      "transformOrigin",
      "translate",
      "rotate",
      "skew",
      "scale",
      "transform",
      "animation",
      "cursor",
      "touchAction",
      "userSelect",
      "resize",
      "scrollSnapType",
      "scrollSnapAlign",
      "scrollSnapStop",
      "scrollMargin",
      "scrollPadding",
      "listStylePosition",
      "listStyleType",
      "listStyleImage",
      "appearance",
      "columns",
      "breakBefore",
      "breakInside",
      "breakAfter",
      "gridAutoColumns",
      "gridAutoFlow",
      "gridAutoRows",
      "gridTemplateColumns",
      "gridTemplateRows",
      "flexDirection",
      "flexWrap",
      "placeContent",
      "placeItems",
      "alignContent",
      "alignItems",
      "justifyContent",
      "justifyItems",
      "gap",
      "space",
      "divideWidth",
      "divideStyle",
      "divideColor",
      "divideOpacity",
      "placeSelf",
      "alignSelf",
      "justifySelf",
      "overflow",
      "overscrollBehavior",
      "scrollBehavior",
      "textOverflow",
      "hyphens",
      "whitespace",
      "textWrap",
      "wordBreak",
      "borderRadius",
      "borderWidth",
      "borderStyle",
      "borderColor",
      "borderOpacity",
      "backgroundColor",
      "backgroundOpacity",
      "backgroundImage",
      "gradientColorStops",
      "boxDecorationBreak",
      "backgroundSize",
      "backgroundAttachment",
      "backgroundClip",
      "backgroundPosition",
      "backgroundRepeat",
      "backgroundOrigin",
      "fill",
      "stroke",
      "strokeWidth",
      "objectFit",
      "objectPosition",
      "padding",
      "textAlign",
      "textIndent",
      "verticalAlign",
      "fontFamily",
      "fontSize",
      "fontWeight",
      "textTransform",
      "fontStyle",
      "fontVariantNumeric",
      "lineHeight",
      "letterSpacing",
      "textColor",
      "textOpacity",
      "textDecoration",
      "textDecorationColor",
      "textDecorationStyle",
      "textDecorationThickness",
      "textUnderlineOffset",
      "fontSmoothing",
      "placeholderColor",
      "placeholderOpacity",
      "caretColor",
      "accentColor",
      "opacity",
      "backgroundBlendMode",
      "mixBlendMode",
      "boxShadow",
      "boxShadowColor",
      "outlineStyle",
      "outlineWidth",
      "outlineOffset",
      "outlineColor",
      "ringWidth",
      "ringColor",
      "ringOpacity",
      "ringOffsetWidth",
      "ringOffsetColor",
      "blur",
      "brightness",
      "contrast",
      "dropShadow",
      "grayscale",
      "hueRotate",
      "invert",
      "saturate",
      "sepia",
      "filter",
      "backdropBlur",
      "backdropBrightness",
      "backdropContrast",
      "backdropGrayscale",
      "backdropHueRotate",
      "backdropInvert",
      "backdropOpacity",
      "backdropSaturate",
      "backdropSepia",
      "backdropFilter",
      "transitionProperty",
      "transitionDelay",
      "transitionDuration",
      "transitionTimingFunction",
      "willChange",
      "contain",
      "content",
      "forcedColorAdjust"
    ];
  }(Pc)), Pc;
}
var wc = {}, Ay;
function lj() {
  return Ay || (Ay = 1, function(o) {
    Object.defineProperty(o, "__esModule", {
      value: !0
    }), Object.defineProperty(o, "default", {
      enumerable: !0,
      get: function() {
        return e;
      }
    });
    function e(r, t) {
      return r === void 0 ? t : Array.isArray(r) ? r : [
        ...new Set(t.filter((a) => r !== !1 && r[a] !== !1).concat(Object.keys(r).filter((a) => r[a] !== !1)))
      ];
    }
  }(wc)), wc;
}
var kc = {}, Dc = {}, As = { exports: {} }, Ey;
function Ob() {
  if (Ey) return As.exports;
  Ey = 1;
  var o = String, e = function() {
    return { isColorSupported: !1, reset: o, bold: o, dim: o, italic: o, underline: o, inverse: o, hidden: o, strikethrough: o, black: o, red: o, green: o, yellow: o, blue: o, magenta: o, cyan: o, white: o, gray: o, bgBlack: o, bgRed: o, bgGreen: o, bgYellow: o, bgBlue: o, bgMagenta: o, bgCyan: o, bgWhite: o, blackBright: o, redBright: o, greenBright: o, yellowBright: o, blueBright: o, magentaBright: o, cyanBright: o, whiteBright: o, bgBlackBright: o, bgRedBright: o, bgGreenBright: o, bgYellowBright: o, bgBlueBright: o, bgMagentaBright: o, bgCyanBright: o, bgWhiteBright: o };
  };
  return As.exports = e(), As.exports.createColors = e, As.exports;
}
var xy;
function yd() {
  return xy || (xy = 1, function(o) {
    Object.defineProperty(o, "__esModule", {
      value: !0
    });
    function e(l, c) {
      for (var u in c) Object.defineProperty(l, u, {
        enumerable: !0,
        get: c[u]
      });
    }
    e(o, {
      dim: function() {
        return s;
      },
      default: function() {
        return i;
      }
    });
    const r = /* @__PURE__ */ t(/* @__PURE__ */ Ob());
    function t(l) {
      return l && l.__esModule ? l : {
        default: l
      };
    }
    let n = /* @__PURE__ */ new Set();
    function a(l, c, u) {
      typeof process < "u" && process.env.JEST_WORKER_ID || u && n.has(u) || (u && n.add(u), console.warn(""), c.forEach((f) => console.warn(l, "-", f)));
    }
    function s(l) {
      return r.default.dim(l);
    }
    const i = {
      info(l, c) {
        a(r.default.bold(r.default.cyan("info")), ...Array.isArray(l) ? [
          l
        ] : [
          c,
          l
        ]);
      },
      warn(l, c) {
        a(r.default.bold(r.default.yellow("warn")), ...Array.isArray(l) ? [
          l
        ] : [
          c,
          l
        ]);
      },
      risk(l, c) {
        a(r.default.bold(r.default.magenta("risk")), ...Array.isArray(l) ? [
          l
        ] : [
          c,
          l
        ]);
      }
    };
  }(Dc)), Dc;
}
var Cy;
function Tb() {
  return Cy || (Cy = 1, function(o) {
    Object.defineProperty(o, "__esModule", {
      value: !0
    }), Object.defineProperty(o, "default", {
      enumerable: !0,
      get: function() {
        return n;
      }
    });
    const e = /* @__PURE__ */ r(yd());
    function r(a) {
      return a && a.__esModule ? a : {
        default: a
      };
    }
    function t({ version: a, from: s, to: i }) {
      e.default.warn(`${s}-color-renamed`, [
        `As of Tailwind CSS ${a}, \`${s}\` has been renamed to \`${i}\`.`,
        "Update your configuration file to silence this warning."
      ]);
    }
    const n = {
      inherit: "inherit",
      current: "currentColor",
      transparent: "transparent",
      black: "#000",
      white: "#fff",
      slate: {
        50: "#f8fafc",
        100: "#f1f5f9",
        200: "#e2e8f0",
        300: "#cbd5e1",
        400: "#94a3b8",
        500: "#64748b",
        600: "#475569",
        700: "#334155",
        800: "#1e293b",
        900: "#0f172a",
        950: "#020617"
      },
      gray: {
        50: "#f9fafb",
        100: "#f3f4f6",
        200: "#e5e7eb",
        300: "#d1d5db",
        400: "#9ca3af",
        500: "#6b7280",
        600: "#4b5563",
        700: "#374151",
        800: "#1f2937",
        900: "#111827",
        950: "#030712"
      },
      zinc: {
        50: "#fafafa",
        100: "#f4f4f5",
        200: "#e4e4e7",
        300: "#d4d4d8",
        400: "#a1a1aa",
        500: "#71717a",
        600: "#52525b",
        700: "#3f3f46",
        800: "#27272a",
        900: "#18181b",
        950: "#09090b"
      },
      neutral: {
        50: "#fafafa",
        100: "#f5f5f5",
        200: "#e5e5e5",
        300: "#d4d4d4",
        400: "#a3a3a3",
        500: "#737373",
        600: "#525252",
        700: "#404040",
        800: "#262626",
        900: "#171717",
        950: "#0a0a0a"
      },
      stone: {
        50: "#fafaf9",
        100: "#f5f5f4",
        200: "#e7e5e4",
        300: "#d6d3d1",
        400: "#a8a29e",
        500: "#78716c",
        600: "#57534e",
        700: "#44403c",
        800: "#292524",
        900: "#1c1917",
        950: "#0c0a09"
      },
      red: {
        50: "#fef2f2",
        100: "#fee2e2",
        200: "#fecaca",
        300: "#fca5a5",
        400: "#f87171",
        500: "#ef4444",
        600: "#dc2626",
        700: "#b91c1c",
        800: "#991b1b",
        900: "#7f1d1d",
        950: "#450a0a"
      },
      orange: {
        50: "#fff7ed",
        100: "#ffedd5",
        200: "#fed7aa",
        300: "#fdba74",
        400: "#fb923c",
        500: "#f97316",
        600: "#ea580c",
        700: "#c2410c",
        800: "#9a3412",
        900: "#7c2d12",
        950: "#431407"
      },
      amber: {
        50: "#fffbeb",
        100: "#fef3c7",
        200: "#fde68a",
        300: "#fcd34d",
        400: "#fbbf24",
        500: "#f59e0b",
        600: "#d97706",
        700: "#b45309",
        800: "#92400e",
        900: "#78350f",
        950: "#451a03"
      },
      yellow: {
        50: "#fefce8",
        100: "#fef9c3",
        200: "#fef08a",
        300: "#fde047",
        400: "#facc15",
        500: "#eab308",
        600: "#ca8a04",
        700: "#a16207",
        800: "#854d0e",
        900: "#713f12",
        950: "#422006"
      },
      lime: {
        50: "#f7fee7",
        100: "#ecfccb",
        200: "#d9f99d",
        300: "#bef264",
        400: "#a3e635",
        500: "#84cc16",
        600: "#65a30d",
        700: "#4d7c0f",
        800: "#3f6212",
        900: "#365314",
        950: "#1a2e05"
      },
      green: {
        50: "#f0fdf4",
        100: "#dcfce7",
        200: "#bbf7d0",
        300: "#86efac",
        400: "#4ade80",
        500: "#22c55e",
        600: "#16a34a",
        700: "#15803d",
        800: "#166534",
        900: "#14532d",
        950: "#052e16"
      },
      emerald: {
        50: "#ecfdf5",
        100: "#d1fae5",
        200: "#a7f3d0",
        300: "#6ee7b7",
        400: "#34d399",
        500: "#10b981",
        600: "#059669",
        700: "#047857",
        800: "#065f46",
        900: "#064e3b",
        950: "#022c22"
      },
      teal: {
        50: "#f0fdfa",
        100: "#ccfbf1",
        200: "#99f6e4",
        300: "#5eead4",
        400: "#2dd4bf",
        500: "#14b8a6",
        600: "#0d9488",
        700: "#0f766e",
        800: "#115e59",
        900: "#134e4a",
        950: "#042f2e"
      },
      cyan: {
        50: "#ecfeff",
        100: "#cffafe",
        200: "#a5f3fc",
        300: "#67e8f9",
        400: "#22d3ee",
        500: "#06b6d4",
        600: "#0891b2",
        700: "#0e7490",
        800: "#155e75",
        900: "#164e63",
        950: "#083344"
      },
      sky: {
        50: "#f0f9ff",
        100: "#e0f2fe",
        200: "#bae6fd",
        300: "#7dd3fc",
        400: "#38bdf8",
        500: "#0ea5e9",
        600: "#0284c7",
        700: "#0369a1",
        800: "#075985",
        900: "#0c4a6e",
        950: "#082f49"
      },
      blue: {
        50: "#eff6ff",
        100: "#dbeafe",
        200: "#bfdbfe",
        300: "#93c5fd",
        400: "#60a5fa",
        500: "#3b82f6",
        600: "#2563eb",
        700: "#1d4ed8",
        800: "#1e40af",
        900: "#1e3a8a",
        950: "#172554"
      },
      indigo: {
        50: "#eef2ff",
        100: "#e0e7ff",
        200: "#c7d2fe",
        300: "#a5b4fc",
        400: "#818cf8",
        500: "#6366f1",
        600: "#4f46e5",
        700: "#4338ca",
        800: "#3730a3",
        900: "#312e81",
        950: "#1e1b4b"
      },
      violet: {
        50: "#f5f3ff",
        100: "#ede9fe",
        200: "#ddd6fe",
        300: "#c4b5fd",
        400: "#a78bfa",
        500: "#8b5cf6",
        600: "#7c3aed",
        700: "#6d28d9",
        800: "#5b21b6",
        900: "#4c1d95",
        950: "#2e1065"
      },
      purple: {
        50: "#faf5ff",
        100: "#f3e8ff",
        200: "#e9d5ff",
        300: "#d8b4fe",
        400: "#c084fc",
        500: "#a855f7",
        600: "#9333ea",
        700: "#7e22ce",
        800: "#6b21a8",
        900: "#581c87",
        950: "#3b0764"
      },
      fuchsia: {
        50: "#fdf4ff",
        100: "#fae8ff",
        200: "#f5d0fe",
        300: "#f0abfc",
        400: "#e879f9",
        500: "#d946ef",
        600: "#c026d3",
        700: "#a21caf",
        800: "#86198f",
        900: "#701a75",
        950: "#4a044e"
      },
      pink: {
        50: "#fdf2f8",
        100: "#fce7f3",
        200: "#fbcfe8",
        300: "#f9a8d4",
        400: "#f472b6",
        500: "#ec4899",
        600: "#db2777",
        700: "#be185d",
        800: "#9d174d",
        900: "#831843",
        950: "#500724"
      },
      rose: {
        50: "#fff1f2",
        100: "#ffe4e6",
        200: "#fecdd3",
        300: "#fda4af",
        400: "#fb7185",
        500: "#f43f5e",
        600: "#e11d48",
        700: "#be123c",
        800: "#9f1239",
        900: "#881337",
        950: "#4c0519"
      },
      get lightBlue() {
        return t({
          version: "v2.2",
          from: "lightBlue",
          to: "sky"
        }), this.sky;
      },
      get warmGray() {
        return t({
          version: "v3.0",
          from: "warmGray",
          to: "stone"
        }), this.stone;
      },
      get trueGray() {
        return t({
          version: "v3.0",
          from: "trueGray",
          to: "neutral"
        }), this.neutral;
      },
      get coolGray() {
        return t({
          version: "v3.0",
          from: "coolGray",
          to: "gray"
        }), this.gray;
      },
      get blueGray() {
        return t({
          version: "v3.0",
          from: "blueGray",
          to: "slate"
        }), this.slate;
      }
    };
  }(kc)), kc;
}
var Sc = {}, Oy;
function cj() {
  return Oy || (Oy = 1, function(o) {
    Object.defineProperty(o, "__esModule", {
      value: !0
    }), Object.defineProperty(o, "defaults", {
      enumerable: !0,
      get: function() {
        return e;
      }
    });
    function e(r, ...t) {
      for (let s of t) {
        for (let i in s) {
          var n;
          !(r == null || (n = r.hasOwnProperty) === null || n === void 0) && n.call(r, i) || (r[i] = s[i]);
        }
        for (let i of Object.getOwnPropertySymbols(s)) {
          var a;
          !(r == null || (a = r.hasOwnProperty) === null || a === void 0) && a.call(r, i) || (r[i] = s[i]);
        }
      }
      return r;
    }
  }(Sc)), Sc;
}
var Ac = {}, Ty;
function uj() {
  return Ty || (Ty = 1, function(o) {
    Object.defineProperty(o, "__esModule", {
      value: !0
    }), Object.defineProperty(o, "toPath", {
      enumerable: !0,
      get: function() {
        return e;
      }
    });
    function e(r) {
      if (Array.isArray(r)) return r;
      let t = r.split("[").length - 1, n = r.split("]").length - 1;
      if (t !== n)
        throw new Error(`Path is invalid. Has unbalanced brackets: ${r}`);
      return r.split(/\.(?![^\[]*\])|[\[\]]/g).filter(Boolean);
    }
  }(Ac)), Ac;
}
var Ec = {}, xc = {}, Ly;
function hd() {
  return Ly || (Ly = 1, function(o) {
    Object.defineProperty(o, "__esModule", {
      value: !0
    });
    function e(f, g) {
      for (var d in g) Object.defineProperty(f, d, {
        enumerable: !0,
        get: g[d]
      });
    }
    e(o, {
      flagEnabled: function() {
        return i;
      },
      issueFlagNotices: function() {
        return c;
      },
      default: function() {
        return u;
      }
    });
    const r = /* @__PURE__ */ n(/* @__PURE__ */ Ob()), t = /* @__PURE__ */ n(yd());
    function n(f) {
      return f && f.__esModule ? f : {
        default: f
      };
    }
    let a = {
      optimizeUniversalDefaults: !1,
      generalizedModifiers: !0,
      disableColorOpacityUtilitiesByDefault: !1,
      relativeContentPathsByDefault: !1
    }, s = {
      future: [
        "hoverOnlyWhenSupported",
        "respectDefaultRingColorOpacity",
        "disableColorOpacityUtilitiesByDefault",
        "relativeContentPathsByDefault"
      ],
      experimental: [
        "optimizeUniversalDefaults",
        "generalizedModifiers"
      ]
    };
    function i(f, g) {
      if (s.future.includes(g)) {
        var d, p, m;
        return f.future === "all" || ((m = (p = f == null || (d = f.future) === null || d === void 0 ? void 0 : d[g]) !== null && p !== void 0 ? p : a[g]) !== null && m !== void 0 ? m : !1);
      }
      if (s.experimental.includes(g)) {
        var y, h, F;
        return f.experimental === "all" || ((F = (h = f == null || (y = f.experimental) === null || y === void 0 ? void 0 : y[g]) !== null && h !== void 0 ? h : a[g]) !== null && F !== void 0 ? F : !1);
      }
      return !1;
    }
    function l(f) {
      if (f.experimental === "all")
        return s.experimental;
      var g;
      return Object.keys((g = f == null ? void 0 : f.experimental) !== null && g !== void 0 ? g : {}).filter((d) => s.experimental.includes(d) && f.experimental[d]);
    }
    function c(f) {
      if (process.env.JEST_WORKER_ID === void 0 && l(f).length > 0) {
        let g = l(f).map((d) => r.default.yellow(d)).join(", ");
        t.default.warn("experimental-flags-enabled", [
          `You have enabled experimental features: ${g}`,
          "Experimental features in Tailwind CSS are not covered by semver, may introduce breaking changes, and can change at any time."
        ]);
      }
    }
    const u = s;
  }(xc)), xc;
}
var jy;
function pj() {
  return jy || (jy = 1, function(o) {
    Object.defineProperty(o, "__esModule", {
      value: !0
    }), Object.defineProperty(o, "normalizeConfig", {
      enumerable: !0,
      get: function() {
        return a;
      }
    });
    const e = hd(), r = /* @__PURE__ */ n(yd());
    function t(s) {
      if (typeof WeakMap != "function") return null;
      var i = /* @__PURE__ */ new WeakMap(), l = /* @__PURE__ */ new WeakMap();
      return (t = function(c) {
        return c ? l : i;
      })(s);
    }
    function n(s, i) {
      if (s && s.__esModule)
        return s;
      if (s === null || typeof s != "object" && typeof s != "function")
        return {
          default: s
        };
      var l = t(i);
      if (l && l.has(s))
        return l.get(s);
      var c = {}, u = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var f in s)
        if (f !== "default" && Object.prototype.hasOwnProperty.call(s, f)) {
          var g = u ? Object.getOwnPropertyDescriptor(s, f) : null;
          g && (g.get || g.set) ? Object.defineProperty(c, f, g) : c[f] = s[f];
        }
      return c.default = s, l && l.set(s, c), c;
    }
    function a(s) {
      if ((() => {
        if (s.purge || !s.content || !Array.isArray(s.content) && !(typeof s.content == "object" && s.content !== null))
          return !1;
        if (Array.isArray(s.content))
          return s.content.every((c) => typeof c == "string" ? !0 : !(typeof (c == null ? void 0 : c.raw) != "string" || c != null && c.extension && typeof (c == null ? void 0 : c.extension) != "string"));
        if (typeof s.content == "object" && s.content !== null) {
          if (Object.keys(s.content).some((c) => ![
            "files",
            "relative",
            "extract",
            "transform"
          ].includes(c)))
            return !1;
          if (Array.isArray(s.content.files)) {
            if (!s.content.files.every((c) => typeof c == "string" ? !0 : !(typeof (c == null ? void 0 : c.raw) != "string" || c != null && c.extension && typeof (c == null ? void 0 : c.extension) != "string")))
              return !1;
            if (typeof s.content.extract == "object") {
              for (let c of Object.values(s.content.extract))
                if (typeof c != "function")
                  return !1;
            } else if (!(s.content.extract === void 0 || typeof s.content.extract == "function"))
              return !1;
            if (typeof s.content.transform == "object") {
              for (let c of Object.values(s.content.transform))
                if (typeof c != "function")
                  return !1;
            } else if (!(s.content.transform === void 0 || typeof s.content.transform == "function"))
              return !1;
            if (typeof s.content.relative != "boolean" && typeof s.content.relative < "u")
              return !1;
          }
          return !0;
        }
        return !1;
      })() || r.default.warn("purge-deprecation", [
        "The `purge`/`content` options have changed in Tailwind CSS v3.0.",
        "Update your configuration file to eliminate this warning.",
        "https://tailwindcss.com/docs/upgrade-guide#configure-content-sources"
      ]), s.safelist = (() => {
        var c;
        let { content: u, purge: f, safelist: g } = s;
        return Array.isArray(g) ? g : Array.isArray(u == null ? void 0 : u.safelist) ? u.safelist : Array.isArray(f == null ? void 0 : f.safelist) ? f.safelist : Array.isArray(f == null || (c = f.options) === null || c === void 0 ? void 0 : c.safelist) ? f.options.safelist : [];
      })(), s.blocklist = (() => {
        let { blocklist: c } = s;
        if (Array.isArray(c)) {
          if (c.every((u) => typeof u == "string"))
            return c;
          r.default.warn("blocklist-invalid", [
            "The `blocklist` option must be an array of strings.",
            "https://tailwindcss.com/docs/content-configuration#discarding-classes"
          ]);
        }
        return [];
      })(), typeof s.prefix == "function")
        r.default.warn("prefix-function", [
          "As of Tailwind CSS v3.0, `prefix` cannot be a function.",
          "Update `prefix` in your configuration to be a string to eliminate this warning.",
          "https://tailwindcss.com/docs/upgrade-guide#prefix-cannot-be-a-function"
        ]), s.prefix = "";
      else {
        var l;
        s.prefix = (l = s.prefix) !== null && l !== void 0 ? l : "";
      }
      s.content = {
        relative: (() => {
          let { content: c } = s;
          return c != null && c.relative ? c.relative : (0, e.flagEnabled)(s, "relativeContentPathsByDefault");
        })(),
        files: (() => {
          let { content: c, purge: u } = s;
          return Array.isArray(u) ? u : Array.isArray(u == null ? void 0 : u.content) ? u.content : Array.isArray(c) ? c : Array.isArray(c == null ? void 0 : c.content) ? c.content : Array.isArray(c == null ? void 0 : c.files) ? c.files : [];
        })(),
        extract: (() => {
          let c = (() => {
            var g, d, p, m, y, h, F, b, v, P;
            return !((g = s.purge) === null || g === void 0) && g.extract ? s.purge.extract : !((d = s.content) === null || d === void 0) && d.extract ? s.content.extract : !((p = s.purge) === null || p === void 0 || (m = p.extract) === null || m === void 0) && m.DEFAULT ? s.purge.extract.DEFAULT : !((y = s.content) === null || y === void 0 || (h = y.extract) === null || h === void 0) && h.DEFAULT ? s.content.extract.DEFAULT : !((F = s.purge) === null || F === void 0 || (b = F.options) === null || b === void 0) && b.extractors ? s.purge.options.extractors : !((v = s.content) === null || v === void 0 || (P = v.options) === null || P === void 0) && P.extractors ? s.content.options.extractors : {};
          })(), u = {}, f = (() => {
            var g, d, p, m;
            if (!((g = s.purge) === null || g === void 0 || (d = g.options) === null || d === void 0) && d.defaultExtractor)
              return s.purge.options.defaultExtractor;
            if (!((p = s.content) === null || p === void 0 || (m = p.options) === null || m === void 0) && m.defaultExtractor)
              return s.content.options.defaultExtractor;
          })();
          if (f !== void 0 && (u.DEFAULT = f), typeof c == "function")
            u.DEFAULT = c;
          else if (Array.isArray(c))
            for (let { extensions: g, extractor: d } of c ?? [])
              for (let p of g)
                u[p] = d;
          else typeof c == "object" && c !== null && Object.assign(u, c);
          return u;
        })(),
        transform: (() => {
          let c = (() => {
            var f, g, d, p, m, y;
            return !((f = s.purge) === null || f === void 0) && f.transform ? s.purge.transform : !((g = s.content) === null || g === void 0) && g.transform ? s.content.transform : !((d = s.purge) === null || d === void 0 || (p = d.transform) === null || p === void 0) && p.DEFAULT ? s.purge.transform.DEFAULT : !((m = s.content) === null || m === void 0 || (y = m.transform) === null || y === void 0) && y.DEFAULT ? s.content.transform.DEFAULT : {};
          })(), u = {};
          return typeof c == "function" ? u.DEFAULT = c : typeof c == "object" && c !== null && Object.assign(u, c), u;
        })()
      };
      for (let c of s.content.files)
        if (typeof c == "string" && /{([^,]*?)}/g.test(c)) {
          r.default.warn("invalid-glob-braces", [
            `The glob pattern ${(0, r.dim)(c)} in your Tailwind CSS configuration is invalid.`,
            `Update it to ${(0, r.dim)(c.replace(/{([^,]*?)}/g, "$1"))} to silence this warning.`
          ]);
          break;
        }
      return s;
    }
  }(Ec)), Ec;
}
var Cc = {}, My;
function dj() {
  return My || (My = 1, function(o) {
    Object.defineProperty(o, "__esModule", {
      value: !0
    }), Object.defineProperty(o, "default", {
      enumerable: !0,
      get: function() {
        return e;
      }
    });
    function e(r) {
      if (Object.prototype.toString.call(r) !== "[object Object]")
        return !1;
      const t = Object.getPrototypeOf(r);
      return t === null || Object.getPrototypeOf(t) === null;
    }
  }(Cc)), Cc;
}
var Oc = {}, Wy;
function Lb() {
  return Wy || (Wy = 1, function(o) {
    Object.defineProperty(o, "__esModule", {
      value: !0
    }), Object.defineProperty(o, "cloneDeep", {
      enumerable: !0,
      get: function() {
        return e;
      }
    });
    function e(r) {
      return Array.isArray(r) ? r.map((t) => e(t)) : typeof r == "object" && r !== null ? Object.fromEntries(Object.entries(r).map(([t, n]) => [
        t,
        e(n)
      ])) : r;
    }
  }(Oc)), Oc;
}
var Tc = {}, Lc = {}, Ny;
function gj() {
  return Ny || (Ny = 1, function(o) {
    Object.defineProperty(o, "__esModule", {
      value: !0
    }), Object.defineProperty(o, "default", {
      enumerable: !0,
      get: function() {
        return e;
      }
    });
    function e(r) {
      return r.replace(/\\,/g, "\\2c ");
    }
  }(Lc)), Lc;
}
var jc = {}, Mc = {}, Wc = {}, Vy;
function mj() {
  return Vy || (Vy = 1, function(o) {
    Object.defineProperty(o, "__esModule", {
      value: !0
    }), Object.defineProperty(o, "default", {
      enumerable: !0,
      get: function() {
        return e;
      }
    });
    const e = {
      aliceblue: [
        240,
        248,
        255
      ],
      antiquewhite: [
        250,
        235,
        215
      ],
      aqua: [
        0,
        255,
        255
      ],
      aquamarine: [
        127,
        255,
        212
      ],
      azure: [
        240,
        255,
        255
      ],
      beige: [
        245,
        245,
        220
      ],
      bisque: [
        255,
        228,
        196
      ],
      black: [
        0,
        0,
        0
      ],
      blanchedalmond: [
        255,
        235,
        205
      ],
      blue: [
        0,
        0,
        255
      ],
      blueviolet: [
        138,
        43,
        226
      ],
      brown: [
        165,
        42,
        42
      ],
      burlywood: [
        222,
        184,
        135
      ],
      cadetblue: [
        95,
        158,
        160
      ],
      chartreuse: [
        127,
        255,
        0
      ],
      chocolate: [
        210,
        105,
        30
      ],
      coral: [
        255,
        127,
        80
      ],
      cornflowerblue: [
        100,
        149,
        237
      ],
      cornsilk: [
        255,
        248,
        220
      ],
      crimson: [
        220,
        20,
        60
      ],
      cyan: [
        0,
        255,
        255
      ],
      darkblue: [
        0,
        0,
        139
      ],
      darkcyan: [
        0,
        139,
        139
      ],
      darkgoldenrod: [
        184,
        134,
        11
      ],
      darkgray: [
        169,
        169,
        169
      ],
      darkgreen: [
        0,
        100,
        0
      ],
      darkgrey: [
        169,
        169,
        169
      ],
      darkkhaki: [
        189,
        183,
        107
      ],
      darkmagenta: [
        139,
        0,
        139
      ],
      darkolivegreen: [
        85,
        107,
        47
      ],
      darkorange: [
        255,
        140,
        0
      ],
      darkorchid: [
        153,
        50,
        204
      ],
      darkred: [
        139,
        0,
        0
      ],
      darksalmon: [
        233,
        150,
        122
      ],
      darkseagreen: [
        143,
        188,
        143
      ],
      darkslateblue: [
        72,
        61,
        139
      ],
      darkslategray: [
        47,
        79,
        79
      ],
      darkslategrey: [
        47,
        79,
        79
      ],
      darkturquoise: [
        0,
        206,
        209
      ],
      darkviolet: [
        148,
        0,
        211
      ],
      deeppink: [
        255,
        20,
        147
      ],
      deepskyblue: [
        0,
        191,
        255
      ],
      dimgray: [
        105,
        105,
        105
      ],
      dimgrey: [
        105,
        105,
        105
      ],
      dodgerblue: [
        30,
        144,
        255
      ],
      firebrick: [
        178,
        34,
        34
      ],
      floralwhite: [
        255,
        250,
        240
      ],
      forestgreen: [
        34,
        139,
        34
      ],
      fuchsia: [
        255,
        0,
        255
      ],
      gainsboro: [
        220,
        220,
        220
      ],
      ghostwhite: [
        248,
        248,
        255
      ],
      gold: [
        255,
        215,
        0
      ],
      goldenrod: [
        218,
        165,
        32
      ],
      gray: [
        128,
        128,
        128
      ],
      green: [
        0,
        128,
        0
      ],
      greenyellow: [
        173,
        255,
        47
      ],
      grey: [
        128,
        128,
        128
      ],
      honeydew: [
        240,
        255,
        240
      ],
      hotpink: [
        255,
        105,
        180
      ],
      indianred: [
        205,
        92,
        92
      ],
      indigo: [
        75,
        0,
        130
      ],
      ivory: [
        255,
        255,
        240
      ],
      khaki: [
        240,
        230,
        140
      ],
      lavender: [
        230,
        230,
        250
      ],
      lavenderblush: [
        255,
        240,
        245
      ],
      lawngreen: [
        124,
        252,
        0
      ],
      lemonchiffon: [
        255,
        250,
        205
      ],
      lightblue: [
        173,
        216,
        230
      ],
      lightcoral: [
        240,
        128,
        128
      ],
      lightcyan: [
        224,
        255,
        255
      ],
      lightgoldenrodyellow: [
        250,
        250,
        210
      ],
      lightgray: [
        211,
        211,
        211
      ],
      lightgreen: [
        144,
        238,
        144
      ],
      lightgrey: [
        211,
        211,
        211
      ],
      lightpink: [
        255,
        182,
        193
      ],
      lightsalmon: [
        255,
        160,
        122
      ],
      lightseagreen: [
        32,
        178,
        170
      ],
      lightskyblue: [
        135,
        206,
        250
      ],
      lightslategray: [
        119,
        136,
        153
      ],
      lightslategrey: [
        119,
        136,
        153
      ],
      lightsteelblue: [
        176,
        196,
        222
      ],
      lightyellow: [
        255,
        255,
        224
      ],
      lime: [
        0,
        255,
        0
      ],
      limegreen: [
        50,
        205,
        50
      ],
      linen: [
        250,
        240,
        230
      ],
      magenta: [
        255,
        0,
        255
      ],
      maroon: [
        128,
        0,
        0
      ],
      mediumaquamarine: [
        102,
        205,
        170
      ],
      mediumblue: [
        0,
        0,
        205
      ],
      mediumorchid: [
        186,
        85,
        211
      ],
      mediumpurple: [
        147,
        112,
        219
      ],
      mediumseagreen: [
        60,
        179,
        113
      ],
      mediumslateblue: [
        123,
        104,
        238
      ],
      mediumspringgreen: [
        0,
        250,
        154
      ],
      mediumturquoise: [
        72,
        209,
        204
      ],
      mediumvioletred: [
        199,
        21,
        133
      ],
      midnightblue: [
        25,
        25,
        112
      ],
      mintcream: [
        245,
        255,
        250
      ],
      mistyrose: [
        255,
        228,
        225
      ],
      moccasin: [
        255,
        228,
        181
      ],
      navajowhite: [
        255,
        222,
        173
      ],
      navy: [
        0,
        0,
        128
      ],
      oldlace: [
        253,
        245,
        230
      ],
      olive: [
        128,
        128,
        0
      ],
      olivedrab: [
        107,
        142,
        35
      ],
      orange: [
        255,
        165,
        0
      ],
      orangered: [
        255,
        69,
        0
      ],
      orchid: [
        218,
        112,
        214
      ],
      palegoldenrod: [
        238,
        232,
        170
      ],
      palegreen: [
        152,
        251,
        152
      ],
      paleturquoise: [
        175,
        238,
        238
      ],
      palevioletred: [
        219,
        112,
        147
      ],
      papayawhip: [
        255,
        239,
        213
      ],
      peachpuff: [
        255,
        218,
        185
      ],
      peru: [
        205,
        133,
        63
      ],
      pink: [
        255,
        192,
        203
      ],
      plum: [
        221,
        160,
        221
      ],
      powderblue: [
        176,
        224,
        230
      ],
      purple: [
        128,
        0,
        128
      ],
      rebeccapurple: [
        102,
        51,
        153
      ],
      red: [
        255,
        0,
        0
      ],
      rosybrown: [
        188,
        143,
        143
      ],
      royalblue: [
        65,
        105,
        225
      ],
      saddlebrown: [
        139,
        69,
        19
      ],
      salmon: [
        250,
        128,
        114
      ],
      sandybrown: [
        244,
        164,
        96
      ],
      seagreen: [
        46,
        139,
        87
      ],
      seashell: [
        255,
        245,
        238
      ],
      sienna: [
        160,
        82,
        45
      ],
      silver: [
        192,
        192,
        192
      ],
      skyblue: [
        135,
        206,
        235
      ],
      slateblue: [
        106,
        90,
        205
      ],
      slategray: [
        112,
        128,
        144
      ],
      slategrey: [
        112,
        128,
        144
      ],
      snow: [
        255,
        250,
        250
      ],
      springgreen: [
        0,
        255,
        127
      ],
      steelblue: [
        70,
        130,
        180
      ],
      tan: [
        210,
        180,
        140
      ],
      teal: [
        0,
        128,
        128
      ],
      thistle: [
        216,
        191,
        216
      ],
      tomato: [
        255,
        99,
        71
      ],
      turquoise: [
        64,
        224,
        208
      ],
      violet: [
        238,
        130,
        238
      ],
      wheat: [
        245,
        222,
        179
      ],
      white: [
        255,
        255,
        255
      ],
      whitesmoke: [
        245,
        245,
        245
      ],
      yellow: [
        255,
        255,
        0
      ],
      yellowgreen: [
        154,
        205,
        50
      ]
    };
  }(Wc)), Wc;
}
var zy;
function jb() {
  return zy || (zy = 1, function(o) {
    Object.defineProperty(o, "__esModule", {
      value: !0
    });
    function e(p, m) {
      for (var y in m) Object.defineProperty(p, y, {
        enumerable: !0,
        get: m[y]
      });
    }
    e(o, {
      parseColor: function() {
        return g;
      },
      formatColor: function() {
        return d;
      }
    });
    const r = /* @__PURE__ */ t(mj());
    function t(p) {
      return p && p.__esModule ? p : {
        default: p
      };
    }
    let n = /^#([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})?$/i, a = /^#([a-f\d])([a-f\d])([a-f\d])([a-f\d])?$/i, s = /(?:\d+|\d*\.\d+)%?/, i = /(?:\s*,\s*|\s+)/, l = /\s*[,/]\s*/, c = /var\(--(?:[^ )]*?)(?:,(?:[^ )]*?|var\(--[^ )]*?\)))?\)/, u = new RegExp(`^(rgba?)\\(\\s*(${s.source}|${c.source})(?:${i.source}(${s.source}|${c.source}))?(?:${i.source}(${s.source}|${c.source}))?(?:${l.source}(${s.source}|${c.source}))?\\s*\\)$`), f = new RegExp(`^(hsla?)\\(\\s*((?:${s.source})(?:deg|rad|grad|turn)?|${c.source})(?:${i.source}(${s.source}|${c.source}))?(?:${i.source}(${s.source}|${c.source}))?(?:${l.source}(${s.source}|${c.source}))?\\s*\\)$`);
    function g(p, { loose: m = !1 } = {}) {
      var y, h;
      if (typeof p != "string")
        return null;
      if (p = p.trim(), p === "transparent")
        return {
          mode: "rgb",
          color: [
            "0",
            "0",
            "0"
          ],
          alpha: "0"
        };
      if (p in r.default)
        return {
          mode: "rgb",
          color: r.default[p].map((E) => E.toString())
        };
      let F = p.replace(a, (E, S, D, w, A) => [
        "#",
        S,
        S,
        D,
        D,
        w,
        w,
        A ? A + A : ""
      ].join("")).match(n);
      if (F !== null)
        return {
          mode: "rgb",
          color: [
            parseInt(F[1], 16),
            parseInt(F[2], 16),
            parseInt(F[3], 16)
          ].map((E) => E.toString()),
          alpha: F[4] ? (parseInt(F[4], 16) / 255).toString() : void 0
        };
      var b;
      let v = (b = p.match(u)) !== null && b !== void 0 ? b : p.match(f);
      if (v === null)
        return null;
      let P = [
        v[2],
        v[3],
        v[4]
      ].filter(Boolean).map((E) => E.toString());
      return P.length === 2 && P[0].startsWith("var(") ? {
        mode: v[1],
        color: [
          P[0]
        ],
        alpha: P[1]
      } : !m && P.length !== 3 || P.length < 3 && !P.some((E) => /^var\(.*?\)$/.test(E)) ? null : {
        mode: v[1],
        color: P,
        alpha: (y = v[5]) === null || y === void 0 || (h = y.toString) === null || h === void 0 ? void 0 : h.call(y)
      };
    }
    function d({ mode: p, color: m, alpha: y }) {
      let h = y !== void 0;
      return p === "rgba" || p === "hsla" ? `${p}(${m.join(", ")}${h ? `, ${y}` : ""})` : `${p}(${m.join(" ")}${h ? ` / ${y}` : ""})`;
    }
  }(Mc)), Mc;
}
var Iy;
function Mb() {
  return Iy || (Iy = 1, function(o) {
    Object.defineProperty(o, "__esModule", {
      value: !0
    });
    function e(a, s) {
      for (var i in s) Object.defineProperty(a, i, {
        enumerable: !0,
        get: s[i]
      });
    }
    e(o, {
      withAlphaValue: function() {
        return t;
      },
      default: function() {
        return n;
      }
    });
    const r = jb();
    function t(a, s, i) {
      if (typeof a == "function")
        return a({
          opacityValue: s
        });
      let l = (0, r.parseColor)(a, {
        loose: !0
      });
      return l === null ? i : (0, r.formatColor)({
        ...l,
        alpha: s
      });
    }
    function n({ color: a, property: s, variable: i }) {
      let l = [].concat(s);
      if (typeof a == "function")
        return {
          [i]: "1",
          ...Object.fromEntries(l.map((u) => [
            u,
            a({
              opacityVariable: i,
              opacityValue: `var(${i}, 1)`
            })
          ]))
        };
      const c = (0, r.parseColor)(a);
      return c === null ? Object.fromEntries(l.map((u) => [
        u,
        a
      ])) : c.alpha !== void 0 ? Object.fromEntries(l.map((u) => [
        u,
        a
      ])) : {
        [i]: "1",
        ...Object.fromEntries(l.map((u) => [
          u,
          (0, r.formatColor)({
            ...c,
            alpha: `var(${i}, 1)`
          })
        ]))
      };
    }
  }(jc)), jc;
}
var Nc = {}, Vc = {}, zc = {}, Ry;
function Fd() {
  return Ry || (Ry = 1, function(o) {
    Object.defineProperty(o, "__esModule", {
      value: !0
    }), Object.defineProperty(o, "splitAtTopLevelOnly", {
      enumerable: !0,
      get: function() {
        return e;
      }
    });
    function e(r, t) {
      let n = [], a = [], s = 0, i = !1;
      for (let l = 0; l < r.length; l++) {
        let c = r[l];
        n.length === 0 && c === t[0] && !i && (t.length === 1 || r.slice(l, l + t.length) === t) && (a.push(r.slice(s, l)), s = l + t.length), i = i ? !1 : c === "\\", c === "(" || c === "[" || c === "{" ? n.push(c) : (c === ")" && n[n.length - 1] === "(" || c === "]" && n[n.length - 1] === "[" || c === "}" && n[n.length - 1] === "{") && n.pop();
      }
      return a.push(r.slice(s)), a;
    }
  }(zc)), zc;
}
var Hy;
function fj() {
  return Hy || (Hy = 1, function(o) {
    Object.defineProperty(o, "__esModule", {
      value: !0
    });
    function e(l, c) {
      for (var u in c) Object.defineProperty(l, u, {
        enumerable: !0,
        get: c[u]
      });
    }
    e(o, {
      parseBoxShadowValue: function() {
        return s;
      },
      formatBoxShadowValue: function() {
        return i;
      }
    });
    const r = Fd();
    let t = /* @__PURE__ */ new Set([
      "inset",
      "inherit",
      "initial",
      "revert",
      "unset"
    ]), n = /\ +(?![^(]*\))/g, a = /^-?(\d+|\.\d+)(.*?)$/g;
    function s(l) {
      return (0, r.splitAtTopLevelOnly)(l, ",").map((u) => {
        let f = u.trim(), g = {
          raw: f
        }, d = f.split(n), p = /* @__PURE__ */ new Set();
        for (let m of d)
          a.lastIndex = 0, !p.has("KEYWORD") && t.has(m) ? (g.keyword = m, p.add("KEYWORD")) : a.test(m) ? p.has("X") ? p.has("Y") ? p.has("BLUR") ? p.has("SPREAD") || (g.spread = m, p.add("SPREAD")) : (g.blur = m, p.add("BLUR")) : (g.y = m, p.add("Y")) : (g.x = m, p.add("X")) : g.color ? (g.unknown || (g.unknown = []), g.unknown.push(m)) : g.color = m;
        return g.valid = g.x !== void 0 && g.y !== void 0, g;
      });
    }
    function i(l) {
      return l.map((c) => c.valid ? [
        c.keyword,
        c.x,
        c.y,
        c.blur,
        c.spread,
        c.color
      ].filter(Boolean).join(" ") : c.raw).join(", ");
    }
  }(Vc)), Vc;
}
var Yy;
function Wb() {
  return Yy || (Yy = 1, function(o) {
    Object.defineProperty(o, "__esModule", {
      value: !0
    });
    function e(L, W) {
      for (var Y in W) Object.defineProperty(L, Y, {
        enumerable: !0,
        get: W[Y]
      });
    }
    e(o, {
      normalize: function() {
        return l;
      },
      normalizeAttributeSelectors: function() {
        return c;
      },
      url: function() {
        return f;
      },
      number: function() {
        return g;
      },
      percentage: function() {
        return d;
      },
      length: function() {
        return y;
      },
      lineWidth: function() {
        return F;
      },
      shadow: function() {
        return b;
      },
      color: function() {
        return v;
      },
      image: function() {
        return P;
      },
      gradient: function() {
        return S;
      },
      position: function() {
        return w;
      },
      familyName: function() {
        return A;
      },
      genericName: function() {
        return x;
      },
      absoluteSize: function() {
        return M;
      },
      relativeSize: function() {
        return G;
      }
    });
    const r = jb(), t = fj(), n = Fd();
    let a = [
      "min",
      "max",
      "clamp",
      "calc"
    ];
    function s(L) {
      return a.some((W) => new RegExp(`^${W}\\(.*\\)`).test(L));
    }
    const i = /* @__PURE__ */ new Set([
      // Concrete properties
      "scroll-timeline-name",
      "timeline-scope",
      "view-timeline-name",
      "font-palette",
      "anchor-name",
      "anchor-scope",
      "position-anchor",
      "position-try-options",
      // Shorthand properties
      "scroll-timeline",
      "animation-timeline",
      "view-timeline",
      "position-try"
    ]);
    function l(L, W = null, Y = !0) {
      let X = W && i.has(W.property);
      return L.startsWith("--") && !X ? `var(${L})` : L.includes("url(") ? L.split(/(url\(.*?\))/g).filter(Boolean).map((J) => /^url\(.*?\)$/.test(J) ? J : l(J, W, !1)).join("") : (L = L.replace(/([^\\])_+/g, (J, ee) => ee + " ".repeat(J.length - 1)).replace(/^_/g, " ").replace(/\\_/g, "_"), Y && (L = L.trim()), L = u(L), L);
    }
    function c(L) {
      return L.includes("=") && (L = L.replace(/(=.*)/g, (W, Y) => {
        if (Y[1] === "'" || Y[1] === '"')
          return Y;
        if (Y.length > 2) {
          let X = Y[Y.length - 1];
          if (Y[Y.length - 2] === " " && (X === "i" || X === "I" || X === "s" || X === "S"))
            return `="${Y.slice(1, -2)}" ${Y[Y.length - 1]}`;
        }
        return `="${Y.slice(1)}"`;
      })), L;
    }
    function u(L) {
      let W = [
        "theme"
      ], Y = [
        "min-content",
        "max-content",
        "fit-content",
        // Env
        "safe-area-inset-top",
        "safe-area-inset-right",
        "safe-area-inset-bottom",
        "safe-area-inset-left",
        "titlebar-area-x",
        "titlebar-area-y",
        "titlebar-area-width",
        "titlebar-area-height",
        "keyboard-inset-top",
        "keyboard-inset-right",
        "keyboard-inset-bottom",
        "keyboard-inset-left",
        "keyboard-inset-width",
        "keyboard-inset-height",
        "radial-gradient",
        "linear-gradient",
        "conic-gradient",
        "repeating-radial-gradient",
        "repeating-linear-gradient",
        "repeating-conic-gradient",
        "anchor-size"
      ];
      return L.replace(/(calc|min|max|clamp)\(.+\)/g, (X) => {
        let J = "";
        function ee() {
          let re = J.trimEnd();
          return re[re.length - 1];
        }
        for (let re = 0; re < X.length; re++) {
          let pe = function(Q) {
            return Q.split("").every((oe, ge) => X[re + ge] === oe);
          }, U = function(Q) {
            let oe = 1 / 0;
            for (let Ae of Q) {
              let ke = X.indexOf(Ae, re);
              ke !== -1 && ke < oe && (oe = ke);
            }
            let ge = X.slice(re, oe);
            return re += ge.length - 1, ge;
          }, Z = X[re];
          if (pe("var"))
            J += U([
              ")",
              ","
            ]);
          else if (Y.some((Q) => pe(Q))) {
            let Q = Y.find((oe) => pe(oe));
            J += Q, re += Q.length - 1;
          } else W.some((Q) => pe(Q)) ? J += U([
            ")"
          ]) : pe("[") ? J += U([
            "]"
          ]) : [
            "+",
            "-",
            "*",
            "/"
          ].includes(Z) && ![
            "(",
            "+",
            "-",
            "*",
            "/",
            ","
          ].includes(ee()) ? J += ` ${Z} ` : J += Z;
        }
        return J.replace(/\s+/g, " ");
      });
    }
    function f(L) {
      return L.startsWith("url(");
    }
    function g(L) {
      return !isNaN(Number(L)) || s(L);
    }
    function d(L) {
      return L.endsWith("%") && g(L.slice(0, -1)) || s(L);
    }
    let m = `(?:${[
      "cm",
      "mm",
      "Q",
      "in",
      "pc",
      "pt",
      "px",
      "em",
      "ex",
      "ch",
      "rem",
      "lh",
      "rlh",
      "vw",
      "vh",
      "vmin",
      "vmax",
      "vb",
      "vi",
      "svw",
      "svh",
      "lvw",
      "lvh",
      "dvw",
      "dvh",
      "cqw",
      "cqh",
      "cqi",
      "cqb",
      "cqmin",
      "cqmax"
    ].join("|")})`;
    function y(L) {
      return L === "0" || new RegExp(`^[+-]?[0-9]*.?[0-9]+(?:[eE][+-]?[0-9]+)?${m}$`).test(L) || s(L);
    }
    let h = /* @__PURE__ */ new Set([
      "thin",
      "medium",
      "thick"
    ]);
    function F(L) {
      return h.has(L);
    }
    function b(L) {
      let W = (0, t.parseBoxShadowValue)(l(L));
      for (let Y of W)
        if (!Y.valid)
          return !1;
      return !0;
    }
    function v(L) {
      let W = 0;
      return (0, n.splitAtTopLevelOnly)(L, "_").every((X) => (X = l(X), X.startsWith("var(") ? !0 : (0, r.parseColor)(X, {
        loose: !0
      }) !== null ? (W++, !0) : !1)) ? W > 0 : !1;
    }
    function P(L) {
      let W = 0;
      return (0, n.splitAtTopLevelOnly)(L, ",").every((X) => (X = l(X), X.startsWith("var(") ? !0 : f(X) || S(X) || [
        "element(",
        "image(",
        "cross-fade(",
        "image-set("
      ].some((J) => X.startsWith(J)) ? (W++, !0) : !1)) ? W > 0 : !1;
    }
    let E = /* @__PURE__ */ new Set([
      "conic-gradient",
      "linear-gradient",
      "radial-gradient",
      "repeating-conic-gradient",
      "repeating-linear-gradient",
      "repeating-radial-gradient"
    ]);
    function S(L) {
      L = l(L);
      for (let W of E)
        if (L.startsWith(`${W}(`))
          return !0;
      return !1;
    }
    let D = /* @__PURE__ */ new Set([
      "center",
      "top",
      "right",
      "bottom",
      "left"
    ]);
    function w(L) {
      let W = 0;
      return (0, n.splitAtTopLevelOnly)(L, "_").every((X) => (X = l(X), X.startsWith("var(") ? !0 : D.has(X) || y(X) || d(X) ? (W++, !0) : !1)) ? W > 0 : !1;
    }
    function A(L) {
      let W = 0;
      return (0, n.splitAtTopLevelOnly)(L, ",").every((X) => (X = l(X), X.startsWith("var(") ? !0 : X.includes(" ") && !/(['"])([^"']+)\1/g.test(X) || /^\d/g.test(X) ? !1 : (W++, !0))) ? W > 0 : !1;
    }
    let C = /* @__PURE__ */ new Set([
      "serif",
      "sans-serif",
      "monospace",
      "cursive",
      "fantasy",
      "system-ui",
      "ui-serif",
      "ui-sans-serif",
      "ui-monospace",
      "ui-rounded",
      "math",
      "emoji",
      "fangsong"
    ]);
    function x(L) {
      return C.has(L);
    }
    let T = /* @__PURE__ */ new Set([
      "xx-small",
      "x-small",
      "small",
      "medium",
      "large",
      "x-large",
      "xx-large",
      "xxx-large"
    ]);
    function M(L) {
      return T.has(L);
    }
    let V = /* @__PURE__ */ new Set([
      "larger",
      "smaller"
    ]);
    function G(L) {
      return V.has(L);
    }
  }(Nc)), Nc;
}
var Ic = {}, qy;
function yj() {
  return qy || (qy = 1, function(o) {
    Object.defineProperty(o, "__esModule", {
      value: !0
    }), Object.defineProperty(o, "backgroundSize", {
      enumerable: !0,
      get: function() {
        return t;
      }
    });
    const e = Wb(), r = Fd();
    function t(n) {
      let a = [
        "cover",
        "contain"
      ];
      return (0, r.splitAtTopLevelOnly)(n, ",").every((s) => {
        let i = (0, r.splitAtTopLevelOnly)(s, "_").filter(Boolean);
        return i.length === 1 && a.includes(i[0]) ? !0 : i.length !== 1 && i.length !== 2 ? !1 : i.every((l) => (0, e.length)(l) || (0, e.percentage)(l) || l === "auto");
      });
    }
  }(Ic)), Ic;
}
var Gy;
function hj() {
  return Gy || (Gy = 1, function(o) {
    Object.defineProperty(o, "__esModule", {
      value: !0
    });
    function e(w, A) {
      for (var C in A) Object.defineProperty(w, C, {
        enumerable: !0,
        get: A[C]
      });
    }
    e(o, {
      updateAllClasses: function() {
        return c;
      },
      asValue: function() {
        return g;
      },
      parseColorFormat: function() {
        return m;
      },
      asColor: function() {
        return h;
      },
      asLookupValue: function() {
        return F;
      },
      typeMap: function() {
        return v;
      },
      coerceValue: function() {
        return S;
      },
      getMatchingTypes: function() {
        return D;
      }
    });
    const r = /* @__PURE__ */ l(gj()), t = Mb(), n = Wb(), a = /* @__PURE__ */ l(Cb()), s = yj(), i = hd();
    function l(w) {
      return w && w.__esModule ? w : {
        default: w
      };
    }
    function c(w, A) {
      w.walkClasses((C) => {
        C.value = A(C.value), C.raws && C.raws.value && (C.raws.value = (0, r.default)(C.raws.value));
      });
    }
    function u(w, A) {
      if (!d(w))
        return;
      let C = w.slice(1, -1);
      if (A(C))
        return (0, n.normalize)(C);
    }
    function f(w, A = {}, C) {
      let x = A[w];
      if (x !== void 0)
        return (0, a.default)(x);
      if (d(w)) {
        let T = u(w, C);
        return T === void 0 ? void 0 : (0, a.default)(T);
      }
    }
    function g(w, A = {}, { validate: C = () => !0 } = {}) {
      var x;
      let T = (x = A.values) === null || x === void 0 ? void 0 : x[w];
      return T !== void 0 ? T : A.supportsNegativeValues && w.startsWith("-") ? f(w.slice(1), A.values, C) : u(w, C);
    }
    function d(w) {
      return w.startsWith("[") && w.endsWith("]");
    }
    function p(w) {
      let A = w.lastIndexOf("/"), C = w.lastIndexOf("[", A), x = w.indexOf("]", A);
      return w[A - 1] === "]" || w[A + 1] === "[" || C !== -1 && x !== -1 && C < A && A < x && (A = w.lastIndexOf("/", C)), A === -1 || A === w.length - 1 ? [
        w,
        void 0
      ] : d(w) && !w.includes("]/[") ? [
        w,
        void 0
      ] : [
        w.slice(0, A),
        w.slice(A + 1)
      ];
    }
    function m(w) {
      if (typeof w == "string" && w.includes("<alpha-value>")) {
        let A = w;
        return ({ opacityValue: C = 1 }) => A.replace(/<alpha-value>/g, C);
      }
      return w;
    }
    function y(w) {
      return (0, n.normalize)(w.slice(1, -1));
    }
    function h(w, A = {}, { tailwindConfig: C = {} } = {}) {
      var x;
      if (((x = A.values) === null || x === void 0 ? void 0 : x[w]) !== void 0) {
        var T;
        return m((T = A.values) === null || T === void 0 ? void 0 : T[w]);
      }
      let [M, V] = p(w);
      if (V !== void 0) {
        var G, L, W, Y;
        let X = (Y = (G = A.values) === null || G === void 0 ? void 0 : G[M]) !== null && Y !== void 0 ? Y : d(M) ? M.slice(1, -1) : void 0;
        return X === void 0 ? void 0 : (X = m(X), d(V) ? (0, t.withAlphaValue)(X, y(V)) : ((L = C.theme) === null || L === void 0 || (W = L.opacity) === null || W === void 0 ? void 0 : W[V]) === void 0 ? void 0 : (0, t.withAlphaValue)(X, C.theme.opacity[V]));
      }
      return g(w, A, {
        validate: n.color
      });
    }
    function F(w, A = {}) {
      var C;
      return (C = A.values) === null || C === void 0 ? void 0 : C[w];
    }
    function b(w) {
      return (A, C) => g(A, C, {
        validate: w
      });
    }
    let v = {
      any: g,
      color: h,
      url: b(n.url),
      image: b(n.image),
      length: b(n.length),
      percentage: b(n.percentage),
      position: b(n.position),
      lookup: F,
      "generic-name": b(n.genericName),
      "family-name": b(n.familyName),
      number: b(n.number),
      "line-width": b(n.lineWidth),
      "absolute-size": b(n.absoluteSize),
      "relative-size": b(n.relativeSize),
      shadow: b(n.shadow),
      size: b(s.backgroundSize)
    }, P = Object.keys(v);
    function E(w, A) {
      let C = w.indexOf(A);
      return C === -1 ? [
        void 0,
        w
      ] : [
        w.slice(0, C),
        w.slice(C + 1)
      ];
    }
    function S(w, A, C, x) {
      if (C.values && A in C.values)
        for (let { type: M } of w ?? []) {
          let V = v[M](A, C, {
            tailwindConfig: x
          });
          if (V !== void 0)
            return [
              V,
              M,
              null
            ];
        }
      if (d(A)) {
        let M = A.slice(1, -1), [V, G] = E(M, ":");
        if (!/^[\w-_]+$/g.test(V))
          G = M;
        else if (V !== void 0 && !P.includes(V))
          return [];
        if (G.length > 0 && P.includes(V))
          return [
            g(`[${G}]`, C),
            V,
            null
          ];
      }
      let T = D(w, A, C, x);
      for (let M of T)
        return M;
      return [];
    }
    function* D(w, A, C, x) {
      let T = (0, i.flagEnabled)(x, "generalizedModifiers"), [M, V] = p(A);
      if (T && C.modifiers != null && (C.modifiers === "any" || typeof C.modifiers == "object" && (V && d(V) || V in C.modifiers)) || (M = A, V = void 0), V !== void 0 && M === "" && (M = "DEFAULT"), V !== void 0 && typeof C.modifiers == "object") {
        var L, W;
        let Y = (W = (L = C.modifiers) === null || L === void 0 ? void 0 : L[V]) !== null && W !== void 0 ? W : null;
        Y !== null ? V = Y : d(V) && (V = y(V));
      }
      for (let { type: Y } of w ?? []) {
        let X = v[Y](M, C, {
          tailwindConfig: x
        });
        X !== void 0 && (yield [
          X,
          Y,
          V ?? null
        ]);
      }
    }
  }(Tc)), Tc;
}
var Rc = {}, Xy;
function Fj() {
  return Xy || (Xy = 1, function(o) {
    Object.defineProperty(o, "__esModule", {
      value: !0
    }), Object.defineProperty(o, "default", {
      enumerable: !0,
      get: function() {
        return e;
      }
    });
    function e(r) {
      return typeof r == "function" ? r({}) : r;
    }
  }(Rc)), Rc;
}
var Uy;
function bj() {
  return Uy || (Uy = 1, function(o) {
    Object.defineProperty(o, "__esModule", {
      value: !0
    }), Object.defineProperty(o, "default", {
      enumerable: !0,
      get: function() {
        return C;
      }
    });
    const e = /* @__PURE__ */ d(Cb()), r = /* @__PURE__ */ d(ij()), t = /* @__PURE__ */ d(lj()), n = /* @__PURE__ */ d(Tb()), a = cj(), s = uj(), i = pj(), l = /* @__PURE__ */ d(dj()), c = Lb(), u = hj(), f = Mb(), g = /* @__PURE__ */ d(Fj());
    function d(x) {
      return x && x.__esModule ? x : {
        default: x
      };
    }
    function p(x) {
      return typeof x == "function";
    }
    function m(x, ...T) {
      let M = T.pop();
      for (let V of T)
        for (let G in V) {
          let L = M(x[G], V[G]);
          L === void 0 ? (0, l.default)(x[G]) && (0, l.default)(V[G]) ? x[G] = m({}, x[G], V[G], M) : x[G] = V[G] : x[G] = L;
        }
      return x;
    }
    const y = {
      colors: n.default,
      negative(x) {
        return Object.keys(x).filter((T) => x[T] !== "0").reduce((T, M) => {
          let V = (0, e.default)(x[M]);
          return V !== void 0 && (T[`-${M}`] = V), T;
        }, {});
      },
      breakpoints(x) {
        return Object.keys(x).filter((T) => typeof x[T] == "string").reduce((T, M) => ({
          ...T,
          [`screen-${M}`]: x[M]
        }), {});
      }
    };
    function h(x, ...T) {
      return p(x) ? x(...T) : x;
    }
    function F(x) {
      return x.reduce((T, { extend: M }) => m(T, M, (V, G) => V === void 0 ? [
        G
      ] : Array.isArray(V) ? [
        G,
        ...V
      ] : [
        G,
        V
      ]), {});
    }
    function b(x) {
      return {
        ...x.reduce((T, M) => (0, a.defaults)(T, M), {}),
        // In order to resolve n config objects, we combine all of their `extend` properties
        // into arrays instead of objects so they aren't overridden.
        extend: F(x)
      };
    }
    function v(x, T) {
      if (Array.isArray(x) && (0, l.default)(x[0]))
        return x.concat(T);
      if (Array.isArray(T) && (0, l.default)(T[0]) && (0, l.default)(x))
        return [
          x,
          ...T
        ];
      if (Array.isArray(T))
        return T;
    }
    function P({ extend: x, ...T }) {
      return m(T, x, (M, V) => !p(M) && !V.some(p) ? m({}, M, ...V, v) : (G, L) => m({}, ...[
        M,
        ...V
      ].map((W) => h(W, G, L)), v));
    }
    function* E(x) {
      let T = (0, s.toPath)(x);
      if (T.length === 0 || (yield T, Array.isArray(x)))
        return;
      let M = /^(.*?)\s*\/\s*([^/]+)$/, V = x.match(M);
      if (V !== null) {
        let [, G, L] = V, W = (0, s.toPath)(G);
        W.alpha = L, yield W;
      }
    }
    function S(x) {
      const T = (M, V) => {
        for (const G of E(M)) {
          let L = 0, W = x;
          for (; W != null && L < G.length; )
            W = W[G[L++]], W = p(W) && (G.alpha === void 0 || L <= G.length - 1) ? W(T, y) : W;
          if (W !== void 0) {
            if (G.alpha !== void 0) {
              let Y = (0, u.parseColorFormat)(W);
              return (0, f.withAlphaValue)(Y, G.alpha, (0, g.default)(Y));
            }
            return (0, l.default)(W) ? (0, c.cloneDeep)(W) : W;
          }
        }
        return V;
      };
      return Object.assign(T, {
        theme: T,
        ...y
      }), Object.keys(x).reduce((M, V) => (M[V] = p(x[V]) ? x[V](T, y) : x[V], M), {});
    }
    function D(x) {
      let T = [];
      return x.forEach((M) => {
        T = [
          ...T,
          M
        ];
        var V;
        const G = (V = M == null ? void 0 : M.plugins) !== null && V !== void 0 ? V : [];
        G.length !== 0 && G.forEach((L) => {
          L.__isOptionsFunction && (L = L());
          var W;
          T = [
            ...T,
            ...D([
              (W = L == null ? void 0 : L.config) !== null && W !== void 0 ? W : {}
            ])
          ];
        });
      }), T;
    }
    function w(x) {
      return [
        ...x
      ].reduceRight((M, V) => p(V) ? V({
        corePlugins: M
      }) : (0, t.default)(V, M), r.default);
    }
    function A(x) {
      return [
        ...x
      ].reduceRight((M, V) => [
        ...M,
        ...V
      ], []);
    }
    function C(x) {
      let T = [
        ...D(x),
        {
          prefix: "",
          important: !1,
          separator: ":"
        }
      ];
      var M, V;
      return (0, i.normalizeConfig)((0, a.defaults)({
        theme: S(P(b(T.map((G) => (M = G == null ? void 0 : G.theme) !== null && M !== void 0 ? M : {})))),
        corePlugins: w(T.map((G) => G.corePlugins)),
        plugins: A(x.map((G) => (V = G == null ? void 0 : G.plugins) !== null && V !== void 0 ? V : []))
      }, ...T));
    }
  }(vc)), vc;
}
var Hc = {}, Yc, Zy;
function Nb() {
  return Zy || (Zy = 1, Yc = {
    content: [],
    presets: [],
    darkMode: "media",
    // or 'class'
    theme: {
      accentColor: ({ theme: o }) => ({
        ...o("colors"),
        auto: "auto"
      }),
      animation: {
        none: "none",
        spin: "spin 1s linear infinite",
        ping: "ping 1s cubic-bezier(0, 0, 0.2, 1) infinite",
        pulse: "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite",
        bounce: "bounce 1s infinite"
      },
      aria: {
        busy: 'busy="true"',
        checked: 'checked="true"',
        disabled: 'disabled="true"',
        expanded: 'expanded="true"',
        hidden: 'hidden="true"',
        pressed: 'pressed="true"',
        readonly: 'readonly="true"',
        required: 'required="true"',
        selected: 'selected="true"'
      },
      aspectRatio: {
        auto: "auto",
        square: "1 / 1",
        video: "16 / 9"
      },
      backdropBlur: ({ theme: o }) => o("blur"),
      backdropBrightness: ({ theme: o }) => o("brightness"),
      backdropContrast: ({ theme: o }) => o("contrast"),
      backdropGrayscale: ({ theme: o }) => o("grayscale"),
      backdropHueRotate: ({ theme: o }) => o("hueRotate"),
      backdropInvert: ({ theme: o }) => o("invert"),
      backdropOpacity: ({ theme: o }) => o("opacity"),
      backdropSaturate: ({ theme: o }) => o("saturate"),
      backdropSepia: ({ theme: o }) => o("sepia"),
      backgroundColor: ({ theme: o }) => o("colors"),
      backgroundImage: {
        none: "none",
        "gradient-to-t": "linear-gradient(to top, var(--tw-gradient-stops))",
        "gradient-to-tr": "linear-gradient(to top right, var(--tw-gradient-stops))",
        "gradient-to-r": "linear-gradient(to right, var(--tw-gradient-stops))",
        "gradient-to-br": "linear-gradient(to bottom right, var(--tw-gradient-stops))",
        "gradient-to-b": "linear-gradient(to bottom, var(--tw-gradient-stops))",
        "gradient-to-bl": "linear-gradient(to bottom left, var(--tw-gradient-stops))",
        "gradient-to-l": "linear-gradient(to left, var(--tw-gradient-stops))",
        "gradient-to-tl": "linear-gradient(to top left, var(--tw-gradient-stops))"
      },
      backgroundOpacity: ({ theme: o }) => o("opacity"),
      backgroundPosition: {
        bottom: "bottom",
        center: "center",
        left: "left",
        "left-bottom": "left bottom",
        "left-top": "left top",
        right: "right",
        "right-bottom": "right bottom",
        "right-top": "right top",
        top: "top"
      },
      backgroundSize: {
        auto: "auto",
        cover: "cover",
        contain: "contain"
      },
      blur: {
        0: "0",
        none: "",
        sm: "4px",
        DEFAULT: "8px",
        md: "12px",
        lg: "16px",
        xl: "24px",
        "2xl": "40px",
        "3xl": "64px"
      },
      borderColor: ({ theme: o }) => ({
        ...o("colors"),
        DEFAULT: o("colors.gray.200", "currentColor")
      }),
      borderOpacity: ({ theme: o }) => o("opacity"),
      borderRadius: {
        none: "0px",
        sm: "0.125rem",
        DEFAULT: "0.25rem",
        md: "0.375rem",
        lg: "0.5rem",
        xl: "0.75rem",
        "2xl": "1rem",
        "3xl": "1.5rem",
        full: "9999px"
      },
      borderSpacing: ({ theme: o }) => ({
        ...o("spacing")
      }),
      borderWidth: {
        DEFAULT: "1px",
        0: "0px",
        2: "2px",
        4: "4px",
        8: "8px"
      },
      boxShadow: {
        sm: "0 1px 2px 0 rgb(0 0 0 / 0.05)",
        DEFAULT: "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
        md: "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
        lg: "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
        xl: "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
        "2xl": "0 25px 50px -12px rgb(0 0 0 / 0.25)",
        inner: "inset 0 2px 4px 0 rgb(0 0 0 / 0.05)",
        none: "none"
      },
      boxShadowColor: ({ theme: o }) => o("colors"),
      brightness: {
        0: "0",
        50: ".5",
        75: ".75",
        90: ".9",
        95: ".95",
        100: "1",
        105: "1.05",
        110: "1.1",
        125: "1.25",
        150: "1.5",
        200: "2"
      },
      caretColor: ({ theme: o }) => o("colors"),
      colors: ({ colors: o }) => ({
        inherit: o.inherit,
        current: o.current,
        transparent: o.transparent,
        black: o.black,
        white: o.white,
        slate: o.slate,
        gray: o.gray,
        zinc: o.zinc,
        neutral: o.neutral,
        stone: o.stone,
        red: o.red,
        orange: o.orange,
        amber: o.amber,
        yellow: o.yellow,
        lime: o.lime,
        green: o.green,
        emerald: o.emerald,
        teal: o.teal,
        cyan: o.cyan,
        sky: o.sky,
        blue: o.blue,
        indigo: o.indigo,
        violet: o.violet,
        purple: o.purple,
        fuchsia: o.fuchsia,
        pink: o.pink,
        rose: o.rose
      }),
      columns: {
        auto: "auto",
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        10: "10",
        11: "11",
        12: "12",
        "3xs": "16rem",
        "2xs": "18rem",
        xs: "20rem",
        sm: "24rem",
        md: "28rem",
        lg: "32rem",
        xl: "36rem",
        "2xl": "42rem",
        "3xl": "48rem",
        "4xl": "56rem",
        "5xl": "64rem",
        "6xl": "72rem",
        "7xl": "80rem"
      },
      container: {},
      content: {
        none: "none"
      },
      contrast: {
        0: "0",
        50: ".5",
        75: ".75",
        100: "1",
        125: "1.25",
        150: "1.5",
        200: "2"
      },
      cursor: {
        auto: "auto",
        default: "default",
        pointer: "pointer",
        wait: "wait",
        text: "text",
        move: "move",
        help: "help",
        "not-allowed": "not-allowed",
        none: "none",
        "context-menu": "context-menu",
        progress: "progress",
        cell: "cell",
        crosshair: "crosshair",
        "vertical-text": "vertical-text",
        alias: "alias",
        copy: "copy",
        "no-drop": "no-drop",
        grab: "grab",
        grabbing: "grabbing",
        "all-scroll": "all-scroll",
        "col-resize": "col-resize",
        "row-resize": "row-resize",
        "n-resize": "n-resize",
        "e-resize": "e-resize",
        "s-resize": "s-resize",
        "w-resize": "w-resize",
        "ne-resize": "ne-resize",
        "nw-resize": "nw-resize",
        "se-resize": "se-resize",
        "sw-resize": "sw-resize",
        "ew-resize": "ew-resize",
        "ns-resize": "ns-resize",
        "nesw-resize": "nesw-resize",
        "nwse-resize": "nwse-resize",
        "zoom-in": "zoom-in",
        "zoom-out": "zoom-out"
      },
      divideColor: ({ theme: o }) => o("borderColor"),
      divideOpacity: ({ theme: o }) => o("borderOpacity"),
      divideWidth: ({ theme: o }) => o("borderWidth"),
      dropShadow: {
        sm: "0 1px 1px rgb(0 0 0 / 0.05)",
        DEFAULT: ["0 1px 2px rgb(0 0 0 / 0.1)", "0 1px 1px rgb(0 0 0 / 0.06)"],
        md: ["0 4px 3px rgb(0 0 0 / 0.07)", "0 2px 2px rgb(0 0 0 / 0.06)"],
        lg: ["0 10px 8px rgb(0 0 0 / 0.04)", "0 4px 3px rgb(0 0 0 / 0.1)"],
        xl: ["0 20px 13px rgb(0 0 0 / 0.03)", "0 8px 5px rgb(0 0 0 / 0.08)"],
        "2xl": "0 25px 25px rgb(0 0 0 / 0.15)",
        none: "0 0 #0000"
      },
      fill: ({ theme: o }) => ({
        none: "none",
        ...o("colors")
      }),
      flex: {
        1: "1 1 0%",
        auto: "1 1 auto",
        initial: "0 1 auto",
        none: "none"
      },
      flexBasis: ({ theme: o }) => ({
        auto: "auto",
        ...o("spacing"),
        "1/2": "50%",
        "1/3": "33.333333%",
        "2/3": "66.666667%",
        "1/4": "25%",
        "2/4": "50%",
        "3/4": "75%",
        "1/5": "20%",
        "2/5": "40%",
        "3/5": "60%",
        "4/5": "80%",
        "1/6": "16.666667%",
        "2/6": "33.333333%",
        "3/6": "50%",
        "4/6": "66.666667%",
        "5/6": "83.333333%",
        "1/12": "8.333333%",
        "2/12": "16.666667%",
        "3/12": "25%",
        "4/12": "33.333333%",
        "5/12": "41.666667%",
        "6/12": "50%",
        "7/12": "58.333333%",
        "8/12": "66.666667%",
        "9/12": "75%",
        "10/12": "83.333333%",
        "11/12": "91.666667%",
        full: "100%"
      }),
      flexGrow: {
        0: "0",
        DEFAULT: "1"
      },
      flexShrink: {
        0: "0",
        DEFAULT: "1"
      },
      fontFamily: {
        sans: [
          "ui-sans-serif",
          "system-ui",
          "sans-serif",
          '"Apple Color Emoji"',
          '"Segoe UI Emoji"',
          '"Segoe UI Symbol"',
          '"Noto Color Emoji"'
        ],
        serif: ["ui-serif", "Georgia", "Cambria", '"Times New Roman"', "Times", "serif"],
        mono: [
          "ui-monospace",
          "SFMono-Regular",
          "Menlo",
          "Monaco",
          "Consolas",
          '"Liberation Mono"',
          '"Courier New"',
          "monospace"
        ]
      },
      fontSize: {
        xs: ["0.75rem", { lineHeight: "1rem" }],
        sm: ["0.875rem", { lineHeight: "1.25rem" }],
        base: ["1rem", { lineHeight: "1.5rem" }],
        lg: ["1.125rem", { lineHeight: "1.75rem" }],
        xl: ["1.25rem", { lineHeight: "1.75rem" }],
        "2xl": ["1.5rem", { lineHeight: "2rem" }],
        "3xl": ["1.875rem", { lineHeight: "2.25rem" }],
        "4xl": ["2.25rem", { lineHeight: "2.5rem" }],
        "5xl": ["3rem", { lineHeight: "1" }],
        "6xl": ["3.75rem", { lineHeight: "1" }],
        "7xl": ["4.5rem", { lineHeight: "1" }],
        "8xl": ["6rem", { lineHeight: "1" }],
        "9xl": ["8rem", { lineHeight: "1" }]
      },
      fontWeight: {
        thin: "100",
        extralight: "200",
        light: "300",
        normal: "400",
        medium: "500",
        semibold: "600",
        bold: "700",
        extrabold: "800",
        black: "900"
      },
      gap: ({ theme: o }) => o("spacing"),
      gradientColorStops: ({ theme: o }) => o("colors"),
      gradientColorStopPositions: {
        "0%": "0%",
        "5%": "5%",
        "10%": "10%",
        "15%": "15%",
        "20%": "20%",
        "25%": "25%",
        "30%": "30%",
        "35%": "35%",
        "40%": "40%",
        "45%": "45%",
        "50%": "50%",
        "55%": "55%",
        "60%": "60%",
        "65%": "65%",
        "70%": "70%",
        "75%": "75%",
        "80%": "80%",
        "85%": "85%",
        "90%": "90%",
        "95%": "95%",
        "100%": "100%"
      },
      grayscale: {
        0: "0",
        DEFAULT: "100%"
      },
      gridAutoColumns: {
        auto: "auto",
        min: "min-content",
        max: "max-content",
        fr: "minmax(0, 1fr)"
      },
      gridAutoRows: {
        auto: "auto",
        min: "min-content",
        max: "max-content",
        fr: "minmax(0, 1fr)"
      },
      gridColumn: {
        auto: "auto",
        "span-1": "span 1 / span 1",
        "span-2": "span 2 / span 2",
        "span-3": "span 3 / span 3",
        "span-4": "span 4 / span 4",
        "span-5": "span 5 / span 5",
        "span-6": "span 6 / span 6",
        "span-7": "span 7 / span 7",
        "span-8": "span 8 / span 8",
        "span-9": "span 9 / span 9",
        "span-10": "span 10 / span 10",
        "span-11": "span 11 / span 11",
        "span-12": "span 12 / span 12",
        "span-full": "1 / -1"
      },
      gridColumnEnd: {
        auto: "auto",
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        10: "10",
        11: "11",
        12: "12",
        13: "13"
      },
      gridColumnStart: {
        auto: "auto",
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        10: "10",
        11: "11",
        12: "12",
        13: "13"
      },
      gridRow: {
        auto: "auto",
        "span-1": "span 1 / span 1",
        "span-2": "span 2 / span 2",
        "span-3": "span 3 / span 3",
        "span-4": "span 4 / span 4",
        "span-5": "span 5 / span 5",
        "span-6": "span 6 / span 6",
        "span-7": "span 7 / span 7",
        "span-8": "span 8 / span 8",
        "span-9": "span 9 / span 9",
        "span-10": "span 10 / span 10",
        "span-11": "span 11 / span 11",
        "span-12": "span 12 / span 12",
        "span-full": "1 / -1"
      },
      gridRowEnd: {
        auto: "auto",
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        10: "10",
        11: "11",
        12: "12",
        13: "13"
      },
      gridRowStart: {
        auto: "auto",
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        10: "10",
        11: "11",
        12: "12",
        13: "13"
      },
      gridTemplateColumns: {
        none: "none",
        subgrid: "subgrid",
        1: "repeat(1, minmax(0, 1fr))",
        2: "repeat(2, minmax(0, 1fr))",
        3: "repeat(3, minmax(0, 1fr))",
        4: "repeat(4, minmax(0, 1fr))",
        5: "repeat(5, minmax(0, 1fr))",
        6: "repeat(6, minmax(0, 1fr))",
        7: "repeat(7, minmax(0, 1fr))",
        8: "repeat(8, minmax(0, 1fr))",
        9: "repeat(9, minmax(0, 1fr))",
        10: "repeat(10, minmax(0, 1fr))",
        11: "repeat(11, minmax(0, 1fr))",
        12: "repeat(12, minmax(0, 1fr))"
      },
      gridTemplateRows: {
        none: "none",
        subgrid: "subgrid",
        1: "repeat(1, minmax(0, 1fr))",
        2: "repeat(2, minmax(0, 1fr))",
        3: "repeat(3, minmax(0, 1fr))",
        4: "repeat(4, minmax(0, 1fr))",
        5: "repeat(5, minmax(0, 1fr))",
        6: "repeat(6, minmax(0, 1fr))",
        7: "repeat(7, minmax(0, 1fr))",
        8: "repeat(8, minmax(0, 1fr))",
        9: "repeat(9, minmax(0, 1fr))",
        10: "repeat(10, minmax(0, 1fr))",
        11: "repeat(11, minmax(0, 1fr))",
        12: "repeat(12, minmax(0, 1fr))"
      },
      height: ({ theme: o }) => ({
        auto: "auto",
        ...o("spacing"),
        "1/2": "50%",
        "1/3": "33.333333%",
        "2/3": "66.666667%",
        "1/4": "25%",
        "2/4": "50%",
        "3/4": "75%",
        "1/5": "20%",
        "2/5": "40%",
        "3/5": "60%",
        "4/5": "80%",
        "1/6": "16.666667%",
        "2/6": "33.333333%",
        "3/6": "50%",
        "4/6": "66.666667%",
        "5/6": "83.333333%",
        full: "100%",
        screen: "100vh",
        svh: "100svh",
        lvh: "100lvh",
        dvh: "100dvh",
        min: "min-content",
        max: "max-content",
        fit: "fit-content"
      }),
      hueRotate: {
        0: "0deg",
        15: "15deg",
        30: "30deg",
        60: "60deg",
        90: "90deg",
        180: "180deg"
      },
      inset: ({ theme: o }) => ({
        auto: "auto",
        ...o("spacing"),
        "1/2": "50%",
        "1/3": "33.333333%",
        "2/3": "66.666667%",
        "1/4": "25%",
        "2/4": "50%",
        "3/4": "75%",
        full: "100%"
      }),
      invert: {
        0: "0",
        DEFAULT: "100%"
      },
      keyframes: {
        spin: {
          to: {
            transform: "rotate(360deg)"
          }
        },
        ping: {
          "75%, 100%": {
            transform: "scale(2)",
            opacity: "0"
          }
        },
        pulse: {
          "50%": {
            opacity: ".5"
          }
        },
        bounce: {
          "0%, 100%": {
            transform: "translateY(-25%)",
            animationTimingFunction: "cubic-bezier(0.8,0,1,1)"
          },
          "50%": {
            transform: "none",
            animationTimingFunction: "cubic-bezier(0,0,0.2,1)"
          }
        }
      },
      letterSpacing: {
        tighter: "-0.05em",
        tight: "-0.025em",
        normal: "0em",
        wide: "0.025em",
        wider: "0.05em",
        widest: "0.1em"
      },
      lineHeight: {
        none: "1",
        tight: "1.25",
        snug: "1.375",
        normal: "1.5",
        relaxed: "1.625",
        loose: "2",
        3: ".75rem",
        4: "1rem",
        5: "1.25rem",
        6: "1.5rem",
        7: "1.75rem",
        8: "2rem",
        9: "2.25rem",
        10: "2.5rem"
      },
      listStyleType: {
        none: "none",
        disc: "disc",
        decimal: "decimal"
      },
      listStyleImage: {
        none: "none"
      },
      margin: ({ theme: o }) => ({
        auto: "auto",
        ...o("spacing")
      }),
      lineClamp: {
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6"
      },
      maxHeight: ({ theme: o }) => ({
        ...o("spacing"),
        none: "none",
        full: "100%",
        screen: "100vh",
        svh: "100svh",
        lvh: "100lvh",
        dvh: "100dvh",
        min: "min-content",
        max: "max-content",
        fit: "fit-content"
      }),
      maxWidth: ({ theme: o, breakpoints: e }) => ({
        ...o("spacing"),
        none: "none",
        xs: "20rem",
        sm: "24rem",
        md: "28rem",
        lg: "32rem",
        xl: "36rem",
        "2xl": "42rem",
        "3xl": "48rem",
        "4xl": "56rem",
        "5xl": "64rem",
        "6xl": "72rem",
        "7xl": "80rem",
        full: "100%",
        min: "min-content",
        max: "max-content",
        fit: "fit-content",
        prose: "65ch",
        ...e(o("screens"))
      }),
      minHeight: ({ theme: o }) => ({
        ...o("spacing"),
        full: "100%",
        screen: "100vh",
        svh: "100svh",
        lvh: "100lvh",
        dvh: "100dvh",
        min: "min-content",
        max: "max-content",
        fit: "fit-content"
      }),
      minWidth: ({ theme: o }) => ({
        ...o("spacing"),
        full: "100%",
        min: "min-content",
        max: "max-content",
        fit: "fit-content"
      }),
      objectPosition: {
        bottom: "bottom",
        center: "center",
        left: "left",
        "left-bottom": "left bottom",
        "left-top": "left top",
        right: "right",
        "right-bottom": "right bottom",
        "right-top": "right top",
        top: "top"
      },
      opacity: {
        0: "0",
        5: "0.05",
        10: "0.1",
        15: "0.15",
        20: "0.2",
        25: "0.25",
        30: "0.3",
        35: "0.35",
        40: "0.4",
        45: "0.45",
        50: "0.5",
        55: "0.55",
        60: "0.6",
        65: "0.65",
        70: "0.7",
        75: "0.75",
        80: "0.8",
        85: "0.85",
        90: "0.9",
        95: "0.95",
        100: "1"
      },
      order: {
        first: "-9999",
        last: "9999",
        none: "0",
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        10: "10",
        11: "11",
        12: "12"
      },
      outlineColor: ({ theme: o }) => o("colors"),
      outlineOffset: {
        0: "0px",
        1: "1px",
        2: "2px",
        4: "4px",
        8: "8px"
      },
      outlineWidth: {
        0: "0px",
        1: "1px",
        2: "2px",
        4: "4px",
        8: "8px"
      },
      padding: ({ theme: o }) => o("spacing"),
      placeholderColor: ({ theme: o }) => o("colors"),
      placeholderOpacity: ({ theme: o }) => o("opacity"),
      ringColor: ({ theme: o }) => ({
        DEFAULT: o("colors.blue.500", "#3b82f6"),
        ...o("colors")
      }),
      ringOffsetColor: ({ theme: o }) => o("colors"),
      ringOffsetWidth: {
        0: "0px",
        1: "1px",
        2: "2px",
        4: "4px",
        8: "8px"
      },
      ringOpacity: ({ theme: o }) => ({
        DEFAULT: "0.5",
        ...o("opacity")
      }),
      ringWidth: {
        DEFAULT: "3px",
        0: "0px",
        1: "1px",
        2: "2px",
        4: "4px",
        8: "8px"
      },
      rotate: {
        0: "0deg",
        1: "1deg",
        2: "2deg",
        3: "3deg",
        6: "6deg",
        12: "12deg",
        45: "45deg",
        90: "90deg",
        180: "180deg"
      },
      saturate: {
        0: "0",
        50: ".5",
        100: "1",
        150: "1.5",
        200: "2"
      },
      scale: {
        0: "0",
        50: ".5",
        75: ".75",
        90: ".9",
        95: ".95",
        100: "1",
        105: "1.05",
        110: "1.1",
        125: "1.25",
        150: "1.5"
      },
      screens: {
        sm: "640px",
        md: "768px",
        lg: "1024px",
        xl: "1280px",
        "2xl": "1536px"
      },
      scrollMargin: ({ theme: o }) => ({
        ...o("spacing")
      }),
      scrollPadding: ({ theme: o }) => o("spacing"),
      sepia: {
        0: "0",
        DEFAULT: "100%"
      },
      skew: {
        0: "0deg",
        1: "1deg",
        2: "2deg",
        3: "3deg",
        6: "6deg",
        12: "12deg"
      },
      space: ({ theme: o }) => ({
        ...o("spacing")
      }),
      spacing: {
        px: "1px",
        0: "0px",
        0.5: "0.125rem",
        1: "0.25rem",
        1.5: "0.375rem",
        2: "0.5rem",
        2.5: "0.625rem",
        3: "0.75rem",
        3.5: "0.875rem",
        4: "1rem",
        5: "1.25rem",
        6: "1.5rem",
        7: "1.75rem",
        8: "2rem",
        9: "2.25rem",
        10: "2.5rem",
        11: "2.75rem",
        12: "3rem",
        14: "3.5rem",
        16: "4rem",
        20: "5rem",
        24: "6rem",
        28: "7rem",
        32: "8rem",
        36: "9rem",
        40: "10rem",
        44: "11rem",
        48: "12rem",
        52: "13rem",
        56: "14rem",
        60: "15rem",
        64: "16rem",
        72: "18rem",
        80: "20rem",
        96: "24rem"
      },
      stroke: ({ theme: o }) => ({
        none: "none",
        ...o("colors")
      }),
      strokeWidth: {
        0: "0",
        1: "1",
        2: "2"
      },
      supports: {},
      data: {},
      textColor: ({ theme: o }) => o("colors"),
      textDecorationColor: ({ theme: o }) => o("colors"),
      textDecorationThickness: {
        auto: "auto",
        "from-font": "from-font",
        0: "0px",
        1: "1px",
        2: "2px",
        4: "4px",
        8: "8px"
      },
      textIndent: ({ theme: o }) => ({
        ...o("spacing")
      }),
      textOpacity: ({ theme: o }) => o("opacity"),
      textUnderlineOffset: {
        auto: "auto",
        0: "0px",
        1: "1px",
        2: "2px",
        4: "4px",
        8: "8px"
      },
      transformOrigin: {
        center: "center",
        top: "top",
        "top-right": "top right",
        right: "right",
        "bottom-right": "bottom right",
        bottom: "bottom",
        "bottom-left": "bottom left",
        left: "left",
        "top-left": "top left"
      },
      transitionDelay: {
        0: "0s",
        75: "75ms",
        100: "100ms",
        150: "150ms",
        200: "200ms",
        300: "300ms",
        500: "500ms",
        700: "700ms",
        1e3: "1000ms"
      },
      transitionDuration: {
        DEFAULT: "150ms",
        0: "0s",
        75: "75ms",
        100: "100ms",
        150: "150ms",
        200: "200ms",
        300: "300ms",
        500: "500ms",
        700: "700ms",
        1e3: "1000ms"
      },
      transitionProperty: {
        none: "none",
        all: "all",
        DEFAULT: "color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter",
        colors: "color, background-color, border-color, text-decoration-color, fill, stroke",
        opacity: "opacity",
        shadow: "box-shadow",
        transform: "transform"
      },
      transitionTimingFunction: {
        DEFAULT: "cubic-bezier(0.4, 0, 0.2, 1)",
        linear: "linear",
        in: "cubic-bezier(0.4, 0, 1, 1)",
        out: "cubic-bezier(0, 0, 0.2, 1)",
        "in-out": "cubic-bezier(0.4, 0, 0.2, 1)"
      },
      translate: ({ theme: o }) => ({
        ...o("spacing"),
        "1/2": "50%",
        "1/3": "33.333333%",
        "2/3": "66.666667%",
        "1/4": "25%",
        "2/4": "50%",
        "3/4": "75%",
        full: "100%"
      }),
      size: ({ theme: o }) => ({
        auto: "auto",
        ...o("spacing"),
        "1/2": "50%",
        "1/3": "33.333333%",
        "2/3": "66.666667%",
        "1/4": "25%",
        "2/4": "50%",
        "3/4": "75%",
        "1/5": "20%",
        "2/5": "40%",
        "3/5": "60%",
        "4/5": "80%",
        "1/6": "16.666667%",
        "2/6": "33.333333%",
        "3/6": "50%",
        "4/6": "66.666667%",
        "5/6": "83.333333%",
        "1/12": "8.333333%",
        "2/12": "16.666667%",
        "3/12": "25%",
        "4/12": "33.333333%",
        "5/12": "41.666667%",
        "6/12": "50%",
        "7/12": "58.333333%",
        "8/12": "66.666667%",
        "9/12": "75%",
        "10/12": "83.333333%",
        "11/12": "91.666667%",
        full: "100%",
        min: "min-content",
        max: "max-content",
        fit: "fit-content"
      }),
      width: ({ theme: o }) => ({
        auto: "auto",
        ...o("spacing"),
        "1/2": "50%",
        "1/3": "33.333333%",
        "2/3": "66.666667%",
        "1/4": "25%",
        "2/4": "50%",
        "3/4": "75%",
        "1/5": "20%",
        "2/5": "40%",
        "3/5": "60%",
        "4/5": "80%",
        "1/6": "16.666667%",
        "2/6": "33.333333%",
        "3/6": "50%",
        "4/6": "66.666667%",
        "5/6": "83.333333%",
        "1/12": "8.333333%",
        "2/12": "16.666667%",
        "3/12": "25%",
        "4/12": "33.333333%",
        "5/12": "41.666667%",
        "6/12": "50%",
        "7/12": "58.333333%",
        "8/12": "66.666667%",
        "9/12": "75%",
        "10/12": "83.333333%",
        "11/12": "91.666667%",
        full: "100%",
        screen: "100vw",
        svw: "100svw",
        lvw: "100lvw",
        dvw: "100dvw",
        min: "min-content",
        max: "max-content",
        fit: "fit-content"
      }),
      willChange: {
        auto: "auto",
        scroll: "scroll-position",
        contents: "contents",
        transform: "transform"
      },
      zIndex: {
        auto: "auto",
        0: "0",
        10: "10",
        20: "20",
        30: "30",
        40: "40",
        50: "50"
      }
    },
    plugins: []
  }), Yc;
}
var Ky;
function vj() {
  return Ky || (Ky = 1, function(o) {
    Object.defineProperty(o, "__esModule", {
      value: !0
    }), Object.defineProperty(o, "default", {
      enumerable: !0,
      get: function() {
        return n;
      }
    });
    const e = /* @__PURE__ */ t(Nb()), r = hd();
    function t(a) {
      return a && a.__esModule ? a : {
        default: a
      };
    }
    function n(a) {
      var s;
      const i = ((s = a == null ? void 0 : a.presets) !== null && s !== void 0 ? s : [
        e.default
      ]).slice().reverse().flatMap((u) => n(u instanceof Function ? u() : u)), l = {
        // Add experimental configs here...
        respectDefaultRingColorOpacity: {
          theme: {
            ringColor: ({ theme: u }) => ({
              DEFAULT: "#3b82f67f",
              ...u("colors")
            })
          }
        },
        disableColorOpacityUtilitiesByDefault: {
          corePlugins: {
            backgroundOpacity: !1,
            borderOpacity: !1,
            divideOpacity: !1,
            placeholderOpacity: !1,
            ringOpacity: !1,
            textOpacity: !1
          }
        }
      }, c = Object.keys(l).filter((u) => (0, r.flagEnabled)(a, u)).map((u) => l[u]);
      return [
        a,
        ...c,
        ...i
      ];
    }
  }(Hc)), Hc;
}
var Qy;
function Bj() {
  return Qy || (Qy = 1, function(o) {
    Object.defineProperty(o, "__esModule", {
      value: !0
    }), Object.defineProperty(o, "default", {
      enumerable: !0,
      get: function() {
        return n;
      }
    });
    const e = /* @__PURE__ */ t(bj()), r = /* @__PURE__ */ t(vj());
    function t(a) {
      return a && a.__esModule ? a : {
        default: a
      };
    }
    function n(...a) {
      let [, ...s] = (0, r.default)(a[0]);
      return (0, e.default)([
        ...a,
        ...s
      ]);
    }
  }(bc)), bc;
}
var qc, Jy;
function Pj() {
  if (Jy) return qc;
  Jy = 1;
  let o = Bj();
  return qc = (o.__esModule ? o : { default: o }).default, qc;
}
var wj = Pj();
const kj = /* @__PURE__ */ qr(wj);
var Gc = {}, _y;
function Dj() {
  return _y || (_y = 1, function(o) {
    Object.defineProperty(o, "__esModule", {
      value: !0
    }), Object.defineProperty(o, "default", {
      enumerable: !0,
      get: function() {
        return n;
      }
    });
    const e = Lb(), r = /* @__PURE__ */ t(Nb());
    function t(a) {
      return a && a.__esModule ? a : {
        default: a
      };
    }
    const n = (0, e.cloneDeep)(r.default.theme);
  }(Gc)), Gc;
}
var Xc, $y;
function Sj() {
  if ($y) return Xc;
  $y = 1;
  let o = Dj();
  return Xc = (o.__esModule ? o : { default: o }).default, Xc;
}
var Aj = Sj();
const eh = /* @__PURE__ */ qr(Aj);
var Uc, oh;
function Ej() {
  if (oh) return Uc;
  oh = 1;
  let o = Tb();
  return Uc = (o.__esModule ? o : { default: o }).default, Uc;
}
var xj = Ej();
const Xe = /* @__PURE__ */ qr(xj), Cj = {
  theme: {
    fontFamily: {
      sans: ["Inter", ...eh.fontFamily.sans],
      gilmer: ["Gilmer", ...eh.fontFamily.sans]
    },
    colors: {
      "spectre-purple": "rgba(var(--color-spectre-purple), <alpha-value>)",
      default: {
        50: "rgba(var(--color-default-50), <alpha-value>)",
        100: "rgba(var(--color-default-100), <alpha-value>)",
        200: "rgba(var(--color-default-200), <alpha-value>)",
        300: "rgba(var(--color-default-300), <alpha-value>)",
        400: "rgba(var(--color-default-400), <alpha-value>)",
        500: "rgba(var(--color-default-500), <alpha-value>)",
        600: "rgba(var(--color-default-600), <alpha-value>)",
        700: "rgba(var(--color-default-700), <alpha-value>)",
        800: "rgba(var(--color-default-800), <alpha-value>)",
        900: "rgba(var(--color-default-900), <alpha-value>)",
        950: "rgba(var(--color-default-950), <alpha-value>)"
      },
      primary: {
        50: "rgba(var(--color-primary-50), <alpha-value>)",
        100: "rgba(var(--color-primary-100), <alpha-value>)",
        200: "rgba(var(--color-primary-200), <alpha-value>)",
        300: "rgba(var(--color-primary-300), <alpha-value>)",
        400: "rgba(var(--color-primary-400), <alpha-value>)",
        500: "rgba(var(--color-primary-500), <alpha-value>)",
        600: "rgba(var(--color-primary-600), <alpha-value>)",
        700: "rgba(var(--color-primary-700), <alpha-value>)",
        800: "rgba(var(--color-primary-800), <alpha-value>)",
        900: "rgba(var(--color-primary-900), <alpha-value>)",
        950: "rgba(var(--color-primary-950), <alpha-value>)"
      },
      inherit: Xe.inherit,
      current: Xe.current,
      transparent: Xe.transparent,
      white: Xe.white,
      black: Xe.black,
      gray: Xe.gray,
      neutral: Xe.neutral,
      red: Xe.red,
      orange: Xe.orange,
      amber: Xe.amber,
      yellow: Xe.yellow,
      green: Xe.green,
      emerald: Xe.emerald,
      teal: Xe.teal,
      blue: Xe.blue,
      violet: Xe.violet,
      purple: Xe.purple,
      pink: Xe.pink
    },
    extend: {
      spacing: {
        tiny: "var(--spacing-tiny, 2px)",
        xxs: "var(--spacing-xxs, 4px)",
        xs: "var(--spacing-xs, 6px)",
        sm: "var(--spacing-sm, 8px)",
        md: "var(--spacing-md, 12px)",
        base: "var(--spacing-base, 16px)",
        lg: "var(--spacing-lg, 24px)",
        xl: "var(--spacing-xl, 32px)",
        xxl: "var(--spacing-xxl, 40px)",
        huge: "var(--spacing-huge, 48px)"
      }
    }
  },
  plugins: [N2]
}, GR = /* @__PURE__ */ H({
  __name: "LineChart",
  props: {
    aspectRatio: {},
    ariaLabel: {},
    data: {},
    prefix: {}
  },
  setup(o) {
    const { theme: e } = kj(Cj);
    C2.register(O2, T2, L2, j2, M2, W2);
    const r = o, t = ue(null), n = (i) => Intl.NumberFormat("en-GB", {
      notation: "compact",
      maximumFractionDigits: 1
    }).format(i), a = {
      responsive: !0,
      maintainAspectRatio: !0,
      aspectRatio: r.aspectRatio,
      animation: {
        duration: 0
      },
      plugins: {
        legend: {
          display: !1
        },
        tooltip: {
          backgroundColor: "black",
          bodyAlign: "center",
          displayColors: !1,
          padding: 12,
          titleAlign: "center",
          callbacks: {
            label: (i) => `${r.prefix ?? ""}${i.formattedValue}`
          }
        }
      },
      scales: {
        x: {
          display: !1
        },
        y: {
          beginAtZero: !1,
          border: {
            display: !1
          },
          grid: {
            color: e.colors.gray[200]
          },
          ticks: {
            callback: (i) => `${r.prefix ?? ""}${n(Number(i))}`
          }
        }
      }
    }, s = {
      labels: r.data[0].values.map((i) => i.label),
      datasets: r.data.map((i) => ({
        backgroundColor: "transparent",
        borderColor: i.color,
        borderWidth: 2,
        data: i.values.map((l) => l.value),
        label: i.label,
        pointBackgroundColor: "white",
        pointBorderWidth: 2,
        pointHoverBackgroundColor: i.color,
        pointHoverBorderColor: i.color,
        pointHoverRadius: 5,
        pointRadius: 5,
        pointStyle: "circle",
        tension: 0.3
      }))
    };
    return Mh(window, "resize", () => {
      var i, l;
      (l = (i = t.value) == null ? void 0 : i.chart) == null || l.resize();
    }), (i, l) => (k(), N("div", null, [
      z(B(x2), {
        ref_key: "chartRef",
        ref: t,
        ariaLabel: i.ariaLabel,
        options: a,
        data: s
      }, null, 8, ["ariaLabel"])
    ]));
  }
}), XR = /* @__PURE__ */ H({
  __name: "LinkTab",
  props: {
    badge: { default: void 0 },
    current: { type: Boolean, default: !1 },
    leadingIcon: { default: void 0 }
  },
  setup(o) {
    const e = ce("link-tab-group-as");
    return (r, t) => (k(), R(ve(B(e)), {
      class: q([
        r.current ? "border-primary-500 text-primary-600" : "border-transparent text-default-500 hover:border-default-300 hover:text-default-700",
        "whitespace-nowrap border-b-2 px-1 py-4 text-sm font-medium"
      ]),
      "aria-current": r.current ? "page" : void 0
    }, {
      default: j(() => [
        r.leadingIcon ? (k(), R(B(le), {
          key: 0,
          icon: r.leadingIcon,
          class: q([
            r.current ? "text-primary-500" : "text-default-400 group-hover:text-default-500",
            "-ml-0.5 mr-2 size-4"
          ]),
          "aria-hidden": "true"
        }, null, 8, ["icon", "class"])) : K("", !0),
        I(r.$slots, "default"),
        r.badge ? (k(), N("span", {
          key: 1,
          class: q([
            r.current ? "bg-primary-100 text-primary-600" : "bg-default-100 text-default-900",
            "ml-3 hidden rounded-full px-2.5 py-0.5 text-xs font-medium md:inline-block"
          ])
        }, _(r.badge), 3)) : K("", !0)
      ]),
      _: 3
    }, 8, ["class", "aria-current"]));
  }
}), Oj = { class: "overflow-x-auto" }, Tj = { class: "border-b border-default-200" }, Lj = { class: "-mb-px flex space-x-8" }, UR = /* @__PURE__ */ H({
  __name: "LinkTabGroup",
  props: {
    as: { default: yo }
  },
  setup(o) {
    return he("link-tab-group-as", o.as), (r, t) => (k(), N("div", Oj, [
      O("div", Tj, [
        O("nav", Lj, [
          I(r.$slots, "default")
        ])
      ])
    ]));
  }
}), bd = /* @__PURE__ */ H({
  __name: "Stack",
  props: {
    as: { default: "div" },
    direction: { default: "vertical" },
    divider: { type: Boolean, default: !1 },
    gap: { default: "base" }
  },
  setup(o) {
    const { verticalSpacingClasses: e, horizontalSpacingClasses: r } = Ni(), t = /* @__PURE__ */ new Map([
      ["tiny", "[&>*]:py-tiny"],
      ["xxs", "[&>*]:py-xxs"],
      ["xs", "[&>*]:py-xs"],
      ["sm", "[&>*]:py-sm"],
      ["base", "[&>*]:py-base"],
      ["lg", "[&>*]:py-lg"],
      ["xl", "[&>*]:py-xl"],
      ["xxl", "[&>*]:py-xxl"],
      ["huge", "[&>*]:py-huge"]
    ]), n = /* @__PURE__ */ new Map([
      ["tiny", "[&>*]:px-tiny"],
      ["xxs", "[&>*]:px-xxs"],
      ["xs", "[&>*]:px-xs"],
      ["sm", "[&>*]:px-sm"],
      ["base", "[&>*]:px-base"],
      ["lg", "[&>*]:px-lg"],
      ["xl", "[&>*]:px-xl"],
      ["xxl", "[&>*]:px-xxl"],
      ["huge", "[&>*]:px-huge"]
    ]);
    return (a, s) => (k(), R(ve(a.as), {
      class: q([
        a.direction === "vertical" && (a.divider ? [
          "divide-y divide-default-300 [&>*:first-child]:pt-0 [&>*:last-child]:pb-0",
          B(t).get(a.gap)
        ] : B(e).get(a.gap)),
        a.direction === "horizontal" && (a.divider ? [
          "divide-x divide-default-300 [&>*:first-child]:pl-0 [&>*:last-child]:pr-0",
          B(n).get(a.gap)
        ] : B(r).get(a.gap)),
        a.direction === "horizontal" && "flex"
      ])
    }, {
      default: j(() => [
        I(a.$slots, "default")
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), ZR = /* @__PURE__ */ H({
  __name: "List",
  props: {
    as: { default: "ul" }
  },
  setup(o) {
    return (e, r) => (k(), R(bd, {
      as: e.as,
      gap: "sm",
      role: "list",
      class: q([
        e.as === "ul" && "list-disc",
        e.as === "ol" && "list-decimal",
        "ml-base text-sm text-default-900",
        "[&>li>*]:mt-sm"
      ])
    }, {
      default: j(() => [
        I(e.$slots, "default")
      ]),
      _: 3
    }, 8, ["as", "class"]));
  }
}), jj = {};
function Mj(o, e) {
  return k(), N("li", null, [
    I(o.$slots, "default")
  ]);
}
const KR = /* @__PURE__ */ fe(jj, [["render", Mj]]), QR = /* @__PURE__ */ H({
  __name: "Listbox",
  props: /* @__PURE__ */ yr({
    disabled: { type: Boolean },
    multiple: { type: Boolean }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(o) {
    const e = o, r = hr(o, "modelValue"), t = ue(e.disabled);
    return Ir(
      () => e.disabled,
      (n) => {
        t.value = n;
      }
    ), he("disabled", t), he("modelValue", r), he("field-label-context", {
      as: r2
    }), (n, a) => (k(), R(B(t2), {
      modelValue: r.value,
      "onUpdate:modelValue": a[0] || (a[0] = (s) => r.value = s),
      disabled: n.disabled,
      multiple: n.multiple,
      by: "id"
    }, {
      default: j(({ open: s, disabled: i }) => [
        I(n.$slots, "default", {
          open: s,
          disabled: i
        })
      ]),
      _: 3
    }, 8, ["modelValue", "disabled", "multiple"]));
  }
}), JR = /* @__PURE__ */ H({
  __name: "ListboxBadges",
  emits: ["remove"],
  setup(o, { emit: e }) {
    const r = ce("modelValue"), t = e;
    return (n, a) => {
      var s;
      return (s = B(r)) != null && s.length ? (k(), R(Aa, {
        key: 0,
        gap: "sm",
        class: "pt-2"
      }, {
        default: j(() => [
          (k(!0), N(ye, null, Oe(B(r), (i) => (k(), R(Ea, {
            key: i.id
          }, {
            default: j(() => [
              z(Yp, { color: "blue" }, {
                default: j(() => [
                  ne(_(i.label) + " ", 1),
                  z(qF, {
                    icon: B(Hr),
                    onClick: (l) => t("remove", i)
                  }, null, 8, ["icon", "onClick"])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024))), 128))
        ]),
        _: 1
      })) : K("", !0);
    };
  }
}), Wj = { class: "relative" }, Nj = { class: "col-start-1 row-start-1 truncate pr-6 h-6" }, _R = /* @__PURE__ */ H({
  __name: "ListboxControl",
  props: {
    value: {}
  },
  setup(o) {
    const e = ce("modelValue"), r = ce("disabled");
    return (t, n) => (k(), N("div", Wj, [
      z(B(n2), {
        class: q([
          "grid w-full cursor-default grid-cols-1 rounded-md bg-white py-1.5 pl-3 pr-3 text-left text-default-900 outline outline-1 -outline-offset-1 outline-default-300",
          "focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-primary-600",
          "sm:text-sm/6",
          B(r) && "opacity-50 pointer-events-none"
        ]),
        disabled: B(r)
      }, {
        default: j(() => {
          var a;
          return [
            O("span", Nj, [
              t.$slots.value ? I(t.$slots, "value", {
                key: 0,
                selected: B(e)
              }) : t.value ? (k(), N(ye, { key: 1 }, [
                ne(_(t.value), 1)
              ], 64)) : (k(), N(ye, { key: 2 }, [
                Array.isArray(B(e)) ? (k(), N(ye, { key: 0 }, [
                  ne(_(B(e).map((s) => s.label).join(", ")), 1)
                ], 64)) : (k(), N(ye, { key: 1 }, [
                  ne(_((a = B(e)) == null ? void 0 : a.label), 1)
                ], 64))
              ], 64))
            ]),
            z(B(le), {
              icon: B(Sp),
              class: q([
                "col-start-1 row-start-1 size-4 self-center justify-self-end text-default-500",
                "sm:size-3"
              ]),
              "aria-hidden": "true"
            }, null, 8, ["icon"])
          ];
        }),
        _: 3
      }, 8, ["class", "disabled"]),
      I(t.$slots, "default")
    ]));
  }
}), $R = /* @__PURE__ */ H({
  __name: "ListboxOption",
  props: {
    disabled: { type: Boolean },
    value: {}
  },
  setup(o) {
    return (e, r) => (k(), R(B(a2), {
      as: "template",
      value: e.value,
      disabled: e.disabled
    }, {
      default: j(({ active: t, selected: n }) => [
        O("li", {
          class: q([
            "relative cursor-default select-none py-2 pl-3 pr-9",
            t ? "bg-primary-600 text-white outline-none" : "text-default-900",
            e.disabled && "opacity-50 pointer-events-none"
          ])
        }, [
          O("span", {
            class: q([
              n ? "font-semibold" : "font-normal",
              "block truncate"
            ])
          }, [
            I(e.$slots, "default")
          ], 2),
          n ? (k(), N("span", {
            key: 0,
            class: q([
              t ? "text-white" : "text-primary-600",
              "absolute inset-y-0 right-0 flex items-center pr-4"
            ])
          }, [
            z(B(le), {
              icon: B(qa),
              class: "size-4",
              "aria-hidden": "true"
            }, null, 8, ["icon"])
          ], 2)) : K("", !0)
        ], 2)
      ]),
      _: 3
    }, 8, ["value", "disabled"]));
  }
}), Vj = { key: 0 }, zj = { class: "flex justify-center items-center py-2" }, eH = /* @__PURE__ */ H({
  __name: "ListboxOptions",
  props: {
    endReached: { type: Boolean },
    loading: { type: Boolean }
  },
  emits: ["loadMore"],
  setup(o, { emit: e }) {
    const r = e;
    return (t, n) => (k(), R(Co, {
      "leave-active-class": "transition ease-in duration-100",
      "leave-from-class": "opacity-100",
      "leave-to-class": "opacity-0"
    }, {
      default: j(() => [
        co((k(), R(B(s2), {
          class: q([
            "absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5",
            "focus:outline-none",
            "sm:text-sm"
          ])
        }, {
          default: j(() => [
            I(t.$slots, "default"),
            t.loading ? (k(), N("li", Vj, [
              O("span", zj, [
                z(Yr, { class: "size-4 text-primary-600" })
              ])
            ])) : K("", !0)
          ]),
          _: 3
        })), [
          [B(Ia), [() => r("loadMore"), { distance: 10, canLoadMore: () => !t.loading && !t.endReached }]]
        ])
      ]),
      _: 3
    }));
  }
}), Ij = ["fill"], Rj = /* @__PURE__ */ H({
  __name: "SpectreLogo",
  props: {
    color: { default: "black" }
  },
  setup(o) {
    return (e, r) => (k(), N("svg", {
      viewBox: "0 0 763 100",
      fill: e.color,
      xmlns: "http://www.w3.org/2000/svg",
      role: "img",
      "aria-label": "Spectre logo"
    }, r[0] || (r[0] = [
      Rr('<path d="M757.24 19.4393V1.06225H697.727L707.823 19.4393H757.24Z"></path><path d="M707.844 97.4941H758.518V79.117H699.005L707.844 97.4941Z"></path><path d="M717.366 59.3802H749.295V40.9819H707.823L717.366 59.3802Z"></path><path d="M282.62 19.4393V1.06225H223.107L233.224 19.4393H282.62Z"></path><path d="M233.224 97.4939H283.898V79.1168H224.385L233.224 97.4939Z"></path><path d="M242.746 59.3802H274.696V40.9819H233.224L242.746 59.3802Z"></path><path d="M440.73 18.3983H473.746V97.409H492.17V18.3983H525.186V0.021286H440.73V18.3983Z"></path><path d="M376.894 81.4114C359.47 81.4114 345.305 67.2834 345.305 49.9049C345.305 32.5264 359.47 18.3983 376.894 18.3983C382.602 18.3983 388.183 19.928 393.039 22.8173L402.475 7.03218C394.765 2.44323 385.904 0.021286 376.894 0.021286C349.31 0.021286 326.881 22.3924 326.881 49.9049C326.881 77.4173 349.31 99.7885 376.894 99.7885C386.01 99.7885 394.956 97.3028 402.731 92.6289L393.21 76.9075C388.311 79.8393 382.666 81.4114 376.894 81.4114Z"></path><path d="M40.5771 40.4083C38.1488 39.8346 35.8271 39.4947 33.5906 39.1548C31.5031 38.8361 29.5009 38.5387 27.733 38.0925C23.7924 37.094 19.5537 33.7585 19.5537 28.7872C19.5537 23.051 25.2622 18.377 32.2913 18.377C34.7408 18.377 37.1264 18.9507 39.1713 20.0554C42.8349 22.01 45.0288 25.2817 45.0288 28.7872H63.4536C63.4536 18.5045 57.4682 8.94421 47.8405 3.82413C43.1331 1.3172 37.7441 0 32.27 0C15.0806 0 1.10762 12.917 1.10762 28.7872C1.10762 41.4493 10.1815 52.603 23.1747 55.896C25.8586 56.5758 28.3933 56.9582 30.8641 57.3194C32.8025 57.6168 34.6556 57.8718 36.317 58.2754C41.0883 59.4014 46.1365 63.5442 46.1365 68.983C46.1365 72.8284 43.7721 76.4188 39.8103 78.5433C37.5737 79.7543 34.9751 80.3916 32.2913 80.3916C24.6444 80.3916 18.4248 75.2715 18.4248 68.983H0C0 85.4055 14.4842 98.7687 32.2913 98.7687C38.0423 98.7687 43.6656 97.3665 48.586 94.7109C58.448 89.3996 64.5612 79.5418 64.5612 68.983C64.5825 55.726 54.4862 43.7013 40.5771 40.4083Z"></path><path d="M639.855 32.8237C639.855 15.3177 625.563 1.06225 608.012 1.06225H589.672V1.16847H572.376V96.8991H590.801V19.4393H607.99C615.381 19.4393 621.409 25.4304 621.409 32.8237C621.409 40.1958 615.403 46.2082 607.99 46.2082H602.452V64.5852L634.488 96.8354H660.474L623.987 60.145C633.423 54.6213 639.855 44.5086 639.855 32.8237Z"></path><path d="M148.696 46.2082H131.507V19.4393H148.696C156.087 19.4393 162.115 25.4304 162.115 32.8237C162.115 40.1958 156.087 46.2082 148.696 46.2082ZM148.696 1.06225H129.27V1.16847H113.082V96.8991H131.507V64.5852H148.696C166.247 64.5852 180.54 50.3297 180.54 32.8237C180.54 15.3177 166.269 1.06225 148.696 1.06225Z"></path>', 11)
    ]), 8, Ij));
  }
}), oH = /* @__PURE__ */ H({
  __name: "ModalDescription",
  setup(o) {
    return (e, r) => (k(), R(oo, {
      as: B(_u),
      color: "secondary"
    }, {
      default: j(() => [
        I(e.$slots, "default")
      ]),
      _: 3
    }, 8, ["as"]));
  }
}), Hj = {
  class: "grid grid-cols-2 gap-4 px-6 py-4",
  "data-slot": "modal-footer"
}, Yj = { class: "justify-self-start" }, qj = { class: "flex flex-row-reverse justify-start gap-2 justify-self-end" }, rH = /* @__PURE__ */ H({
  __name: "ModalFooter",
  props: {
    hideCancel: { type: Boolean, default: !1 }
  },
  setup(o) {
    const e = ce("emit");
    return (r, t) => (k(), N("div", Hj, [
      O("div", Yj, [
        I(r.$slots, "left")
      ]),
      O("div", qj, [
        I(r.$slots, "default"),
        r.hideCancel ? K("", !0) : (k(), R(eo, {
          key: 0,
          color: "secondary",
          type: "button",
          onClick: t[0] || (t[0] = (n) => B(e) && B(e)("close"))
        }, {
          default: j(() => t[1] || (t[1] = [
            ne(" Cancel ")
          ])),
          _: 1
        }))
      ])
    ]));
  }
}), Gj = {
  environmentBadge: null,
  salesLinks: null,
  lettingsLinks: null,
  emailLinks: null,
  socialLinks: null,
  websitesLinks: null,
  printAdminLinks: null,
  identityAdminLinks: null,
  insightsLinks: null,
  printSalesLinks: null,
  printLettingsLinks: null,
  mobileLinks: null,
  accountLinks: null,
  userLinks: null,
  credits: null,
  fullBranchName: null,
  userName: null,
  csrfToken: null,
  showSalesUpsellBanner: null,
  showLettingsUpsellBanner: null,
  applicationName: null,
  isAdmin: null
}, rh = ue("local"), Es = ue(null), th = {
  local: {
    baseUrl: "https://account.",
    topLevelDomain: "spectre.engineering.local"
  },
  uat: {
    baseUrl: "https://uat.id.",
    topLevelDomain: "spectre.internal.street.engineering"
  },
  production: {
    baseUrl: "https://account.",
    topLevelDomain: "spectre.uk.com"
  }
};
function an() {
  return { getIdsBaseUri: (t) => {
    if (Es.value !== null && Es.value !== void 0 && t === "local")
      return Es.value;
    const { baseUrl: n, topLevelDomain: a } = th[t];
    return `${n}${a}`;
  }, getTopLevelDomain: (t) => {
    const { topLevelDomain: n } = th[t];
    return n;
  }, initialiseEnvironment: (t, n) => {
    rh.value = t, Es.value = n;
  }, environment: rh };
}
const { getIdsBaseUri: Xj } = an();
function Uj() {
  return { client: async ({ env: e, route: r, method: t }) => {
    const n = Xj(e);
    return (await cp({
      url: n + r,
      method: t
    })).data;
  } };
}
var Qo = /* @__PURE__ */ ((o) => (o.Print = "print", o.Email = "email", o.Insights = "insights", o.Social = "social", o.Identity = "identity", o.Websites = "websites", o))(Qo || {});
const Zj = [
  { icon: "faHouse", title: "Dashboard", description: "Sales dashboard", link: null, subLinks: null, badge: null, isInertia: null },
  { icon: "faBolt", title: "Actions", description: "Contact vendors with a bespoke and relevant message at the right time.", link: null, subLinks: null, badge: null, isInertia: null },
  { icon: "faCalendarStar", title: "Anniversaries", description: "Automatically keep in touch with your past purchasers.", link: null, subLinks: null, badge: null, isInertia: null },
  { icon: "faHouse", title: "Properties", description: "Discover everything there is to know about a property, instantly.", link: null, subLinks: null, badge: null, isInertia: null },
  { icon: "faScaleBalanced", title: "Fee Recovery", description: "Reclaim fees you’re owed with Spectre’s easy-to-use Fee Recovery.", link: null, subLinks: null, badge: null, isInertia: null },
  { icon: "faGears", title: "Settings", description: "Setup templates configure triggers and manage your account.", link: null, subLinks: null, badge: null, isInertia: null }
], Kj = [
  { icon: "faHouse", title: "Dashboard", description: "Lettings dashboard", link: null, subLinks: null, badge: null, isInertia: null },
  { icon: "faBolt", title: "Actions", description: "Contact landlords with a bespoke and relevant message at the right time.", link: null, subLinks: null, badge: null, isInertia: null },
  { icon: "faPersonShelter", title: "Landlords", description: "Manage, add, update and nurture landlord relationships.", link: null, subLinks: null, badge: null, isInertia: null },
  { icon: "faHouse", title: "Properties", description: "Discover everything there is to know about a property, instantly.", link: null, subLinks: null, badge: null, isInertia: null },
  { icon: "faGears", title: "Settings", description: "Setup templates configure triggers and manage your account.", link: null, subLinks: null, badge: null, isInertia: null }
], Qj = [
  { icon: "faChartLine", title: "Email Dashboard", description: "View the performance of your emails and track overall engagement and delivery", link: null, subLinks: null, badge: null, isInertia: null },
  { icon: "faPaperPlaneTop", title: "Emails", description: "Create new emails and see the performance of sent emails", link: null, subLinks: null, badge: null, isInertia: null },
  { icon: "faArrowProgress", title: "Automated Journeys", description: "Set up and manage workflows and automate your email marketing", link: null, subLinks: null, badge: null, isInertia: null },
  { icon: "faUsers", title: "Audience", description: "View, manage and segment your audiences", link: null, subLinks: null, badge: null, isInertia: null },
  { icon: "faLayerGroup", title: "Templates", description: "Design your own branded templates with lego like blocks", link: null, subLinks: null, badge: null, isInertia: null },
  { icon: "faGears", title: "Settings", description: "Manage your email settings for your company and preferences", link: null, subLinks: null, badge: null, isInertia: null }
], Jj = [
  { icon: "faBuildingMagnifyingGlass", title: "Search and Create", description: "Explore, research, and create reports on millions of properties across the UK", link: null, subLinks: null, badge: null, isInertia: null },
  { icon: "faMemoCircleCheck", title: "Saved Property Reports", description: "View, edit, and share your previously created reports", link: null, subLinks: null, badge: null, isInertia: null },
  { icon: "faImageUser", title: "Leads", description: "View your leads generated by lead capture reports and landing pages", link: null, subLinks: null, badge: null, isInertia: null },
  { icon: "faBrowsers", title: "Landing Pages", description: "Create and manage your landing pages for instant valuations and more", link: null, subLinks: null, badge: null, isInertia: null }
], _j = [
  { icon: "faCalendarDays", title: "Social Dashboard", description: "Easily manage all your posts and automations in one calendar view", link: null, subLinks: null, badge: null, isInertia: null },
  { icon: "faBolt", title: "Automations", description: "Automatically post new properties, client reviews, and more", link: null, subLinks: null, badge: null, isInertia: null },
  { icon: "faLink", title: "Link In Bio", description: "Create a single link for your bio that includes important links and details", link: null, subLinks: null, badge: null, isInertia: null }
], $j = [
  { icon: "faGlobe", title: "Websites", description: "View, edit, and create your agency websites", link: null, subLinks: null, badge: null, isInertia: null }
], eM = "_SPECTRE_IMPERSONATED_BY", Gi = ue(null), Xi = ue(null), vd = ue(null), Bd = ue(null), Pd = ue(null), oM = se(() => Gi.value !== null && Xi.value !== null), Qu = () => {
  Gi.value = null, Xi.value = null, vd.value = null, Bd.value = null, Pd.value = null;
}, Vb = (o) => {
  if (o === null) {
    Qu();
    return;
  }
  const {
    currentUser: e,
    shadowedUser: r,
    shadowedAccount: t,
    shadowedCompany: n,
    endSessionUrl: a
  } = o;
  typeof e != "object" && typeof r != "object" && Qu(), Gi.value = typeof e == "object" ? e : null, Xi.value = typeof r == "object" ? r : null, Bd.value = typeof t == "object" ? t : null, vd.value = typeof n == "object" ? n : null, Pd.value = typeof a == "string" ? new URL(a) : a instanceof URL ? a : null;
}, rM = () => {
  if (typeof (document == null ? void 0 : document.cookie) != "string")
    return null;
  const o = document.cookie.split("; ").find((r) => r.startsWith(eM));
  if (o === void 0)
    return null;
  const e = window.atob(decodeURIComponent(o.split("=")[1]));
  return JSON.parse(e) ?? null;
}, tM = (o) => {
  Qu();
  const e = rM();
  Vb({
    ...e,
    ...typeof o == "object" ? o : {}
  });
};
function Ui() {
  return {
    currentUser: Gi,
    shadowedUser: Xi,
    shadowedAccount: Bd,
    shadowedCompany: vd,
    endSessionUrl: Pd,
    isShadowing: oM,
    update: Vb,
    initialiseShadowbar: tM
  };
}
const je = ue(Gj), Zc = ue(!1), Kc = ue(!1), Qc = ue(!1), nh = ue(!1), ah = ue(!1), sh = ue(!1), ih = ue(!1), { client: lh } = Uj(), { update: nM } = Ui();
function ir() {
  const o = (l) => {
    l != null && (window.location.href = l);
  }, e = se(() => {
    if (je.value.credits === null)
      return "0";
    const l = parseFloat(je.value.credits.branchCreditLimit), c = parseFloat(je.value.credits.branchCreditsUsedThisMonth);
    return (l - c).toFixed(2);
  }), r = se(() => je.value.userName === null ? "" : je.value.userName[0]), t = (l) => {
    je.value = l, Kc.value = l.showSalesUpsellBanner ?? !1, Qc.value = l.showLettingsUpsellBanner ?? !1;
  }, n = (l) => {
    var h, F, b, v, P;
    const {
      print: c,
      insights: u,
      email: f,
      social: g,
      identity: d,
      shadowbarData: p,
      isAdmin: m,
      websites: y
    } = l.data;
    return ((c == null ? void 0 : c.links.sales) === void 0 || (h = c == null ? void 0 : c.links.sales) != null && h.is_static) && (Kc.value = !0), ((c == null ? void 0 : c.links.lettings) === void 0 || (F = c == null ? void 0 : c.links.lettings) != null && F.is_static) && (Qc.value = !0), (u == null ? void 0 : u.links) === void 0 && (nh.value = !0), (f == null ? void 0 : f.links) === void 0 && (ah.value = !0), (g == null ? void 0 : g.links) === void 0 && (sh.value = !0), (y == null ? void 0 : y.links) === void 0 && (ih.value = !0), p !== null && typeof p == "object" && nM(p), {
      salesLinks: ((b = c == null ? void 0 : c.links.sales) == null ? void 0 : b.links) ?? Zj,
      lettingsLinks: ((v = c == null ? void 0 : c.links.lettings) == null ? void 0 : v.links) ?? Kj,
      insightsLinks: (u == null ? void 0 : u.links) ?? Jj,
      emailLinks: (f == null ? void 0 : f.links) ?? Qj,
      socialLinks: (g == null ? void 0 : g.links) ?? _j,
      websitesLinks: (y == null ? void 0 : y.links) ?? $j,
      mobileLinks: (c == null ? void 0 : c.links.mobile.links) ?? [],
      printAdminLinks: ((P = c == null ? void 0 : c.links.admin) == null ? void 0 : P.links) ?? [],
      identityAdminLinks: (d == null ? void 0 : d.links) ?? [],
      isAdmin: m
    };
  }, a = async (l, c, u, f = 5, g = 1e3) => {
    for (let d = 1; d <= f; d++)
      try {
        const p = u ? `/api/user/navigation/${c}?currentAccountId=${u}` : `/api/user/navigation/${c}`, m = await lh({
          env: l,
          route: p,
          method: "GET"
        }), {
          salesLinks: y,
          lettingsLinks: h,
          insightsLinks: F,
          emailLinks: b,
          socialLinks: v,
          websitesLinks: P,
          printAdminLinks: E,
          identityAdminLinks: S,
          mobileLinks: D,
          isAdmin: w
        } = n(m);
        je.value.isAdmin = w, je.value.applicationName !== Qo.Print && (je.value.salesLinks = y), je.value.applicationName !== Qo.Print && (je.value.lettingsLinks = h), je.value.applicationName !== Qo.Insights && (je.value.insightsLinks = F), je.value.applicationName !== Qo.Email && (je.value.emailLinks = b), je.value.applicationName !== Qo.Social && (je.value.socialLinks = v), je.value.applicationName !== Qo.Websites && (je.value.websitesLinks = P), je.value.applicationName !== Qo.Print && (je.value.mobileLinks = D), je.value.applicationName !== Qo.Print && (je.value.printAdminLinks = E), je.value.applicationName !== Qo.Identity && (je.value.identityAdminLinks = S);
        return;
      } catch (p) {
        if (console.error(`Attempt ${d} failed. Error fetching links:`, p), d === f) {
          console.error("All retry attempts failed. Exiting function.");
          return;
        }
        await new Promise((m) => setTimeout(m, d * g));
      }
  }, s = async (l, c, u) => await lh({
    env: l,
    route: `/api/request-access/${c}/${u}`,
    method: "POST"
  });
  return {
    initialiseNavigation: t,
    navigation: je,
    fetchLinks: async ({ env: l, userUUID: c, currentAccountId: u }) => {
      Zc.value = !0, await a(l, c, u), Zc.value = !1;
    },
    getUsernameAbbreviation: r,
    redirectToTarget: o,
    remainingCredits: e,
    showSalesUpsellBanner: cr(Kc),
    showLettingsUpsellBanner: cr(Qc),
    showInsightsUpsellBanner: cr(nh),
    showEmailUpsellBanner: cr(ah),
    showSocialUpsellBanner: cr(sh),
    showWebsitesUpsellBanner: cr(ih),
    linksLoading: Zc,
    requestAccess: s
  };
}
function Zi(o, e) {
  return k(), N("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    O("path", {
      "fill-rule": "evenodd",
      d: "M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function aM(o, e) {
  return k(), N("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    O("path", {
      "fill-rule": "evenodd",
      d: "M3.25 3A2.25 2.25 0 0 0 1 5.25v9.5A2.25 2.25 0 0 0 3.25 17h13.5A2.25 2.25 0 0 0 19 14.75v-9.5A2.25 2.25 0 0 0 16.75 3H3.25Zm.943 8.752a.75.75 0 0 1 .055-1.06L6.128 9l-1.88-1.693a.75.75 0 1 1 1.004-1.114l2.5 2.25a.75.75 0 0 1 0 1.114l-2.5 2.25a.75.75 0 0 1-1.06-.055ZM9.75 10.25a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5h-2.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function sM(o, e) {
  return k(), N("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    O("path", {
      "fill-rule": "evenodd",
      d: "M9 3.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11ZM2 9a7 7 0 1 1 12.452 4.391l3.328 3.329a.75.75 0 1 1-1.06 1.06l-3.329-3.328A7 7 0 0 1 2 9Z",
      "clip-rule": "evenodd"
    })
  ]);
}
const iM = ["onClick"], lM = {
  key: 0,
  class: "block text-black font-semibold px-3 py-2 leading-6 text-sm"
}, cM = ["action"], uM = ["value"], pM = {
  type: "submit",
  class: "block rounded-lg font-medium text-gray-500 hover:bg-primary-50 px-3 py-2 leading-6 text-sm w-full text-left"
}, dM = ["href", "target"], zb = /* @__PURE__ */ H({
  __name: "BasicPanel",
  props: {
    links: {},
    csrfToken: {}
  },
  emits: ["selected"],
  setup(o, { emit: e }) {
    const r = e;
    return (t, n) => (k(), R(B($t), { class: "relative" }, {
      default: j(({ open: a }) => [
        z(B(rr), {
          class: q(["flex items-center gap-x-2 text-sm font-medium leading-6 rounded-md text-white px-3 py-1 focus:outline-none focus:ring focus:ring-primary-600 hover:bg-primary-500 max-w-[300px]", a ? "bg-primary-600" : ""])
        }, {
          default: j(() => [
            I(t.$slots, "default"),
            z(B(Zi), {
              class: q(["h-5 w-5 flex-none text-gray-400", ["text-white", { "rotate-180 transform": a }]]),
              "aria-hidden": "true"
            }, null, 8, ["class"])
          ]),
          _: 2
        }, 1032, ["class"]),
        z(Co, {
          "enter-active-class": "transition ease-out duration-200",
          "enter-from-class": "opacity-0 translate-y-1",
          "enter-to-class": "opacity-100 translate-y-0",
          "leave-active-class": "transition ease-in duration-150",
          "leave-from-class": "opacity-100 translate-y-0",
          "leave-to-class": "opacity-0 translate-y-1"
        }, {
          default: j(() => [
            z(B(en), { class: "absolute right-1 top-full z-10 cursor-pointer mt-3 w-56 rounded-md bg-white p-2 shadow-lg ring-1 ring-gray-900/5" }, {
              default: j(() => [
                (k(!0), N(ye, null, Oe(t.links, (s) => (k(), N("div", {
                  key: s.name,
                  onClick: (i) => r("selected", s)
                }, [
                  s.isHeading ? (k(), N("span", lM, _(s.name), 1)) : s.isForm ? (k(), N("form", {
                    key: 1,
                    action: s.href,
                    method: "post"
                  }, [
                    O("input", {
                      type: "hidden",
                      name: "_token",
                      value: t.csrfToken
                    }, null, 8, uM),
                    O("button", pM, _(s.name), 1)
                  ], 8, cM)) : (k(), N("a", {
                    key: 2,
                    href: s.href,
                    target: s.target ? s.target : "",
                    class: "block rounded-lg font-medium text-gray-500 hover:bg-primary-50 px-3 py-2 leading-6 text-sm"
                  }, _(s.name), 9, dM))
                ], 8, iM))), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 3
    }));
  }
}), gM = { class: "inline-flex items-center px-3 h-9 text-sm rounded-md text-white bg-red-500 mr-3" }, mM = {
  __name: "EnvironmentBadge",
  setup(o) {
    const { navigation: e } = ir();
    return (r, t) => (k(), N("div", gM, [
      z(B(aM), { class: "w-4 h-4 mr-2" }),
      ne(" " + _(B(e).environmentBadge), 1)
    ]));
  }
}, ch = /* @__PURE__ */ H({
  __name: "Credits",
  props: {
    credits: {}
  },
  setup(o) {
    return (e, r) => (k(), N("span", null, [
      r[0] || (r[0] = O("span", null, "Company Credits", -1)),
      r[1] || (r[1] = O("span", { class: "mx-2" }, "|", -1)),
      O("span", null, _(e.credits), 1)
    ]));
  }
}), fM = {
  key: 0,
  class: "inline-flex place-items-center text-sm font-medium leading-6 text-white gap-x-4"
}, yM = {
  key: 0,
  class: "text-white"
}, hM = /* @__PURE__ */ H({
  __name: "PrintCredits",
  setup(o) {
    const { navigation: e, remainingCredits: r } = ir();
    return (t, n) => B(e).credits ? (k(), N("div", fM, [
      B(e).credits.branchCreditLimit ? (k(), N("span", yM, [
        n[0] || (n[0] = O("span", null, "Branch Credits", -1)),
        n[1] || (n[1] = O("span", { class: "mx-2" }, "|", -1)),
        O("span", null, _(B(r)) + " / " + _(B(e).credits.branchCreditLimit), 1)
      ])) : K("", !0),
      B(e).credits.canManageCredits ? (k(), R(zb, {
        key: 1,
        links: B(e).credits.links,
        "csrf-token": B(e).csrfToken
      }, {
        default: j(() => [
          z(ch, {
            credits: B(e).credits.credits
          }, null, 8, ["credits"])
        ]),
        _: 1
      }, 8, ["links", "csrf-token"])) : (k(), R(ch, {
        key: 2,
        credits: B(e).credits.credits
      }, null, 8, ["credits"]))
    ])) : K("", !0);
  }
});
function FM(o, e) {
  return k(), N("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    O("path", {
      "fill-rule": "evenodd",
      d: "M16.28 11.47a.75.75 0 0 1 0 1.06l-7.5 7.5a.75.75 0 0 1-1.06-1.06L14.69 12 7.72 5.03a.75.75 0 0 1 1.06-1.06l7.5 7.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
const bM = {
  faBuildingMagnifyingGlass: gS,
  faMemoCircleCheck: AS,
  faImageUser: wS,
  faBrowsers: RS,
  faGears: dS,
  faBolt: hS,
  faCalendarStar: TS,
  faScaleBalanced: pS,
  faPersonShelter: CS,
  faHouse: WF,
  faUsers: VS,
  faBadgeCheck: kS,
  faCommentsDollar: ES,
  faKey: NS,
  faCalendarDay: uS,
  faScrewdriverWrench: DS,
  faFileChartLine: MS,
  faGear: vS,
  faChartLine: SS,
  faPaperPlaneTop: OS,
  faArrowProgress: IS,
  faLayerGroup: xS,
  faPipe: FS,
  faEyeSlash: zF,
  faInfoCircle: PS,
  faCalendarDays: HS,
  faLink: yS,
  faGlobe: WS,
  faStar: LS
};
function wd() {
  return {
    resolveIcon: (e) => e === null ? null : bM[e]
  };
}
const vM = { class: "relative self-start" }, BM = {
  key: 1,
  class: "w-1.5 h-1.5 rounded-full bg-red-400 absolute -top-1.5 -right-1.5"
}, PM = { class: "block text-left" }, wM = { class: "flex justify-start items-center mb-1" }, kM = { class: "font-medium text-black text-sm block mr-3" }, DM = { class: "text-gray-400 text-xs block" }, SM = "border border-white w-full flex p-4 items-center gap-x-6 rounded-md bg-primary-50 border border-primary-200", AM = "border border-white w-full flex p-4 items-center gap-x-6 rounded-md", EM = /* @__PURE__ */ H({
  __name: "PanelButton",
  props: {
    link: {},
    hasSubLinks: { type: Boolean },
    isVerticalMovement: { type: Boolean }
  },
  emits: ["inertiaLinkClick"],
  setup(o, { emit: e }) {
    const { resolveIcon: r } = wd(), t = o, n = se(() => r(t.link.icon)), a = se(() => t.isVerticalMovement ? SM : AM), s = e, i = (l) => {
      l.link !== null && s("inertiaLinkClick", l);
    };
    return (l, c) => (k(), R(ve(l.link.isInertia ? B(rr) : "button"), {
      class: q(["border border-white w-full flex p-4 items-center gap-x-6 rounded-md", a.value]),
      onClick: c[0] || (c[0] = (u) => i(l.link))
    }, {
      default: j(() => [
        O("span", vM, [
          n.value ? (k(), R(B(le), {
            key: 0,
            icon: n.value,
            class: "size-8 text-gray-500"
          }, null, 8, ["icon"])) : K("", !0),
          l.link.badge ? (k(), N("span", BM)) : K("", !0)
        ]),
        O("span", PM, [
          O("span", wM, [
            O("span", kM, _(l.link.title), 1)
          ]),
          O("span", DM, _(l.link.description), 1)
        ]),
        l.hasSubLinks ? (k(), R(B(FM), {
          key: 0,
          class: "size-6 text-gray-500 shrink-0"
        })) : K("", !0)
      ]),
      _: 1
    }, 8, ["class"]));
  }
});
function xM() {
  const o = ue(0), e = ue(0), r = ue(!1);
  return {
    handleMouseOver: (n) => {
      const a = n.clientX - o.value, s = n.clientY - e.value;
      return o.value = n.clientX, e.value = n.clientY, r.value = Math.abs(s) > Math.abs(a), r.value;
    }
  };
}
const uh = "data:image/png;base64,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", CM = "data:image/png;base64,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", OM = "data:image/png;base64,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", TM = "data:image/png;base64,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", LM = "data:image/png;base64,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", jM = "data:image/png;base64,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", ph = ue(null);
function Ib() {
  const o = (e) => {
    ph.value = e;
  };
  return {
    userUUID: cr(ph),
    setUserUUID: o
  };
}
const MM = { class: "basis-[230px] bg-gray-50 text-black flex flex-col justify-center items-center" }, WM = {
  key: 0,
  class: "mt-4"
}, NM = ["src"], VM = {
  id: "upgrade-banner-title",
  class: "text-lg font-bold text-black mt-4 px-5 text-center flex justify-center items-center"
}, zM = {
  id: "upgrade-banner-description",
  class: "text-sm font-medium text-gray-400 mt-2 px-5 text-center flex justify-center items-center"
}, IM = { class: "p-5 flex flex-col justify-center items-center" }, RM = ["disabled"], HM = ["href"], YM = /* @__PURE__ */ H({
  __name: "UpgradeBanner",
  props: {
    product: {}
  },
  setup(o) {
    const { requestAccess: e } = ir(), { environment: r } = an(), { userUUID: t } = Ib(), n = ue(null), a = o, s = async (u) => {
      t.value !== null && (n.value = await e(r.value, u, t.value));
    }, i = {
      sales: {
        title: "Spectre Sales",
        description: "Direct mail prospecting for property instructions.",
        imagePath: uh,
        buttonText: "Unlock",
        idProductName: "print_sales",
        learnMore: "https://spectre.uk.com/product/sales"
      },
      lettings: {
        title: "Spectre Lettings",
        description: "Identify and target landlord leads to grow your portfolio.",
        imagePath: CM,
        buttonText: "Unlock",
        idProductName: "print_lettings",
        learnMore: "https://spectre.uk.com/product/lettings"
      },
      email: {
        title: "Email Marketing",
        description: "Deliver hyper-targeted emails automatically.",
        imagePath: TM,
        buttonText: "Unlock",
        idProductName: "spectre_email",
        learnMore: "https://spectre.uk.com/product/email-marketing"
      },
      insights: {
        title: "Property Reports",
        description: "Create and share data-driven reports.",
        imagePath: OM,
        buttonText: "Unlock",
        idProductName: "property_reports",
        learnMore: "https://spectre.uk.com/product/property-reports"
      },
      social: {
        title: "Spectre Social",
        description: "Create and automate your posts, stories and more.",
        imagePath: LM,
        buttonText: "Unlock",
        idProductName: "spectre_social_v2",
        learnMore: "https://spectre.uk.com/resources/social-showcase?utm_campaign=24806550-ss_showcase&utm_source=internal&utm_medium=display&utm_term=see_spectre_social&utm_content=dashboard_marketing_banner"
      },
      websites: {
        title: "Spectre Websites",
        description: "Create a beautiful, high-converting website.",
        imagePath: jM,
        buttonText: "Unlock",
        idProductName: "spectre_websites",
        learnMore: "https://spectre.uk.com/product/websites"
      }
    }, l = {
      title: "",
      description: "",
      imagePath: uh,
      buttonText: "",
      idProductName: "",
      learnMore: ""
    }, c = ue(i[a.product] ?? l);
    return (u, f) => {
      var g, d, p;
      return k(), N("div", MM, [
        c.value ? (k(), N("div", WM, [
          O("img", {
            src: c.value.imagePath,
            alt: "Lettings Upgrade",
            class: "w-full"
          }, null, 8, NM),
          O("p", VM, _(c.value.title), 1),
          O("p", zM, _(c.value.description), 1)
        ])) : K("", !0),
        O("div", IM, [
          O("button", {
            class: q([{
              "bg-primary-600 hover:bg-primary-700": n.value === null,
              "bg-green-500": ((g = n.value) == null ? void 0 : g.status) === "success",
              "bg-red-500": ((d = n.value) == null ? void 0 : d.status) === "error"
            }, "w-[189px] rounded-md px-4 py-2 text-white inline-block text-center cursor-pointer"]),
            disabled: n.value !== null,
            onClick: f[0] || (f[0] = (m) => s(c.value.idProductName))
          }, _(((p = n.value) == null ? void 0 : p.message) ?? c.value.buttonText), 11, RM),
          f[1] || (f[1] = O("div", { class: "relative my-3 w-full flex justify-center items-center" }, [
            O("div", {
              class: "absolute inset-0 flex items-center",
              "aria-hidden": "true"
            })
          ], -1)),
          O("a", {
            href: c.value.learnMore,
            target: "_blank",
            class: "text-blue-600 hover:text-blue-700 inline-block text-center"
          }, " Learn more ", 8, HM)
        ])
      ]);
    };
  }
});
function qM(o, e) {
  return k(), N("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    O("path", {
      "fill-rule": "evenodd",
      d: "M6.22 4.22a.75.75 0 0 1 1.06 0l3.25 3.25a.75.75 0 0 1 0 1.06l-3.25 3.25a.75.75 0 0 1-1.06-1.06L8.94 8 6.22 5.28a.75.75 0 0 1 0-1.06Z",
      "clip-rule": "evenodd"
    })
  ]);
}
const GM = {
  class: "border border-white cursor-not-allowed w-full flex p-4 items-center gap-x-6 rounded-md",
  disabled: ""
}, XM = { class: "relative self-start" }, UM = { class: "block text-left" }, ZM = { class: "flex justify-start items-center mb-1" }, KM = { class: "font-medium text-gray-300 text-sm block mr-3" }, QM = { class: "text-gray-300 text-xs block" }, JM = /* @__PURE__ */ H({
  __name: "DisabledPanelButton",
  props: {
    link: {},
    hasSubLinks: { type: Boolean }
  },
  setup(o) {
    const { resolveIcon: e } = wd(), r = o, t = se(() => e(r.link.icon));
    return (n, a) => (k(), N("button", GM, [
      O("span", XM, [
        t.value ? (k(), R(B(le), {
          key: 0,
          icon: t.value,
          class: "w-8 h-8 text-gray-300"
        }, null, 8, ["icon"])) : K("", !0)
      ]),
      O("span", UM, [
        O("span", ZM, [
          O("span", KM, _(n.link.title), 1)
        ]),
        O("span", QM, _(n.link.description), 1)
      ]),
      n.hasSubLinks ? (k(), R(B(qM), {
        key: 0,
        class: "w-4 h-4 text-gray-300"
      })) : K("", !0)
    ]));
  }
});
function kd(o) {
  const e = ue(null), r = ue(null), t = ue(!1), n = (l, c, u, f) => {
    const g = /* @__PURE__ */ new Date();
    g.setTime(g.getTime() + f * 24 * 60 * 60 * 1e3);
    const d = `; expires=${g.toUTCString()}`;
    document.cookie = `${l}=${encodeURIComponent(c)}; domain=${u}; path=/;${d}`;
  }, a = (l) => {
    const c = `${l}=`, u = document.cookie.split(";");
    for (let f = 0; f < u.length; f++) {
      let g = u[f];
      for (; g.charAt(0) === " "; ) g = g.substring(1, g.length);
      if (g.indexOf(c) === 0) return decodeURIComponent(g.substring(c.length, g.length));
    }
    return null;
  }, s = (l, c, u) => {
    n("storedLink", JSON.stringify({
      clickedLink: l,
      activeVerticalLink: c,
      product: u
    }), o, 7);
  };
  return {
    clickedLink: e,
    activeVerticalLink: r,
    isProductMatch: t,
    saveToCookieStorage: s,
    loadFromCookieStorage: (l) => {
      let c = a("storedLink");
      (c == null || c === "") && (s(null, null, l), c = a("storedLink"));
      try {
        const u = JSON.parse(c), f = (u == null ? void 0 : u.product) ?? null;
        t.value = f !== null && f === l, t.value ? (e.value = u.clickedLink ?? null, r.value = u.activeVerticalLink ?? null) : (e.value = null, r.value = null);
      } catch (u) {
        console.error("Error parsing storedLink:", u);
      }
    }
  };
}
const _M = { class: "basis-[370px] p-4 overflow-y-auto" }, $M = { key: 0 }, eW = { key: 1 }, oW = {
  key: 0,
  class: "basis-[230px] bg-gray-50 text-black px-4 py-8 overflow-y-auto"
}, rW = ["onClick"], tW = /* @__PURE__ */ H({
  __name: "NavigationPanel",
  props: {
    links: {},
    product: {},
    showUpsellBanner: { type: [Boolean, null] },
    open: { type: Boolean }
  },
  emits: ["inertiaLinkClick"],
  setup(o, { expose: e, emit: r }) {
    var P, E;
    const { isShadowing: t } = Ui(), { getTopLevelDomain: n, environment: a } = an(), s = se(() => n(a.value)), i = o, l = r, c = ue(((E = (P = i.links) == null ? void 0 : P[0]) == null ? void 0 : E.subLinks) ?? null), { clickedLink: u, activeVerticalLink: f, saveToCookieStorage: g, loadFromCookieStorage: d } = kd(s.value), p = se(() => c.value), { handleMouseOver: m } = xM(), y = (S, D) => {
      m(S) && D && (v(D.subLinks), f.value = D.title);
    }, h = (S) => {
      if (S.link !== null) {
        if (u.value = S.title, g(u.value, f.value, i.product), S.isInertia === !0) {
          l("inertiaLinkClick", S.link);
          return;
        }
        window.location.href = S.link;
      }
    };
    Fr(() => {
      F(), window.addEventListener("resize", F), d(i.product);
    }), Xb(() => {
      window.removeEventListener("resize", F);
    });
    const F = () => {
      const S = window.innerHeight;
      b.value = S - (t.value ? 144 : 72);
    }, b = ue(0), v = (S) => {
      c.value = S;
    };
    return Ir(() => i.open, F), e({ activeLinks: c }), (S, D) => (k(), R(B(en), null, {
      default: j(() => [
        O("div", {
          ref: "dropdownPanel",
          class: q(["flex absolute -left-8 top-full z-10 mt-3 w-screen overflow-hidden rounded-xl bg-white shadow-lg ring-1 ring-gray-900/5", p.value || S.showUpsellBanner ? "max-w-[600px]" : "max-w-[370px]"]),
          style: qo({ maxHeight: `${b.value}px` })
        }, [
          O("div", _M, [
            S.showUpsellBanner ? (k(), N("div", eW, [
              (k(!0), N(ye, null, Oe(S.links, (w, A) => (k(), R(JM, {
                key: `${A}-d-link`,
                link: w,
                "has-sub-links": !!w.subLinks
              }, null, 8, ["link", "has-sub-links"]))), 128))
            ])) : (k(), N("div", $M, [
              (k(!0), N(ye, null, Oe(S.links, (w, A) => (k(), R(EM, {
                key: `${A}-link`,
                link: w,
                "has-sub-links": !!w.subLinks,
                "is-vertical-movement": B(f) === w.title,
                onMouseover: (C) => y(C, w),
                onInertiaLinkClick: h
              }, null, 8, ["link", "has-sub-links", "is-vertical-movement", "onMouseover"]))), 128))
            ]))
          ]),
          p.value && !S.showUpsellBanner ? (k(), N("div", oW, [
            (k(!0), N(ye, null, Oe(c.value, (w) => (k(), N("button", {
              key: `${w.title}-link`,
              class: q([{
                "bg-primary-50": B(u) === w.title,
                "hover:bg-primary-50": B(u) !== w.title
              }, "text-sm rounded-md p-2 my-2 flex items-center justify-start gap-x-3 w-full"]),
              onClick: (A) => h(w)
            }, _(w.title), 11, rW))), 128))
          ])) : K("", !0),
          S.showUpsellBanner ? (k(), R(YM, {
            key: 1,
            product: S.product
          }, null, 8, ["product"])) : K("", !0)
        ], 6)
      ]),
      _: 1
    }));
  }
}), Sr = /* @__PURE__ */ H({
  __name: "NavigationLink",
  props: {
    links: {},
    product: {},
    showUpsellBanner: { type: [Boolean, null] }
  },
  emits: ["inertiaLinkClick"],
  setup(o, { emit: e }) {
    const { getTopLevelDomain: r, environment: t } = an(), n = se(() => r(t.value)), a = o, { isProductMatch: s, loadFromCookieStorage: i } = kd(n.value), l = e, c = (u) => {
      l("inertiaLinkClick", u);
    };
    return Fr(() => {
      i(a.product);
    }), (u, f) => (k(), R(B($t), { class: "relative" }, {
      default: j(({ open: g }) => [
        z(B(rr), {
          class: q(["flex items-center gap-x-2 text-sm font-medium leading-6 text-white rounded-md px-3 py-1 focus:outline-none focus:ring focus:ring-primary-600 hover:bg-primary-500", [g || B(s) && "bg-primary-500", g && "bg-primary-600"]])
        }, {
          default: j(() => [
            I(u.$slots, "default"),
            z(B(Zi), {
              class: q(["h-5 w-5 flex-none", ["text-white", { "rotate-180 transform": g }]]),
              "aria-hidden": "true"
            }, null, 8, ["class"])
          ]),
          _: 2
        }, 1032, ["class"]),
        z(Co, {
          "enter-active-class": "transition ease-out duration-200",
          "enter-from-class": "opacity-0 translate-y-1",
          "enter-to-class": "opacity-100 translate-y-0",
          "leave-active-class": "transition ease-in duration-150",
          "leave-from-class": "opacity-100 translate-y-0",
          "leave-to-class": "opacity-0 translate-y-1"
        }, {
          default: j(() => [
            z(tW, {
              links: u.links,
              product: u.product,
              open: g,
              "show-upsell-banner": u.showUpsellBanner,
              onInertiaLinkClick: c
            }, null, 8, ["links", "product", "open", "show-upsell-banner"])
          ]),
          _: 2
        }, 1024)
      ]),
      _: 3
    }));
  }
}), nW = {};
function aW(o, e) {
  return k(), N("svg", Ve(o.$attrs, {
    viewBox: "0 0 260 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), e[0] || (e[0] = [
    Rr('<g clip-path="url(#clip0_1429_30706)"><path d="M154.672 5.47436H164.481V28.9838H169.955V5.47436H179.765V0.00631714H154.672V5.47436Z"></path><path d="M99.9481 5.78412V0.316071H82.2659L85.272 5.78412H99.9481Z"></path><path d="M85.272 29.0091H100.328V23.541H82.6456L85.272 29.0091Z"></path><path d="M88.1009 17.6684H97.5939V12.1941H85.272L88.1009 17.6684Z"></path><path d="M258.879 5.78412V0.316071H241.197L244.197 5.78412H258.879Z"></path><path d="M244.203 29.0091H259.259V23.541H241.577L244.203 29.0091Z"></path><path d="M247.032 17.6684H256.519V12.1941H244.197L247.032 17.6684Z"></path><path d="M132.8 24.2237C127.623 24.2237 123.415 20.02 123.415 14.8491C123.415 9.67812 127.623 5.47436 132.8 5.47436C134.496 5.47436 136.154 5.9295 137.597 6.78922L140.401 2.09239C138.11 0.726961 135.477 0.00631714 132.8 0.00631714C124.605 0.00631714 117.94 6.66279 117.94 14.8491C117.94 23.0353 124.605 29.6918 132.8 29.6918C135.509 29.6918 138.167 28.9522 140.477 27.5615L137.648 22.8836C136.192 23.756 134.515 24.2237 132.8 24.2237Z"></path><path d="M12.056 12.0234C11.3346 11.8527 10.6448 11.7516 9.98026 11.6504C9.36005 11.5556 8.76516 11.4671 8.23988 11.3343C7.06909 11.0372 5.80969 10.0448 5.80969 8.56555C5.80969 6.85876 7.50576 5.46804 9.59421 5.46804C10.322 5.46804 11.0308 5.63872 11.6384 5.96744C12.7269 6.54901 13.3787 7.52251 13.3787 8.56555H18.853C18.853 5.50597 17.0747 2.66133 14.2141 1.13786C12.8155 0.391929 11.2143 0 9.58788 0C4.48067 0 0.329089 3.84343 0.329089 8.56555C0.329089 12.3331 3.02509 15.6519 6.88556 16.6317C7.68296 16.834 8.43607 16.9478 9.17019 17.0552C9.7461 17.1437 10.2967 17.2196 10.7903 17.3397C12.2079 17.6747 13.7078 18.9074 13.7078 20.5257C13.7078 21.6699 13.0053 22.7382 11.8282 23.3704C11.1637 23.7307 10.3916 23.9203 9.59421 23.9203C7.32223 23.9203 5.47427 22.3969 5.47427 20.5257H0C0 25.4122 4.30347 29.3884 9.59421 29.3884C11.3029 29.3884 12.9737 28.9712 14.4356 28.181C17.3658 26.6006 19.1821 23.6675 19.1821 20.5257C19.1884 16.5811 16.1886 13.0032 12.056 12.0234Z"></path><path d="M216.256 9.76662C216.256 4.55776 212.009 0.316071 206.794 0.316071H201.345V0.347678H196.207V28.8321H201.681V5.78411H206.788C208.984 5.78411 210.775 7.56676 210.775 9.76662C210.775 11.9602 208.99 13.7491 206.788 13.7491H205.143V19.2172L214.661 28.8131H222.382L211.541 17.896C214.345 16.2524 216.256 13.2434 216.256 9.76662Z"></path><path d="M50.9582 13.7491H45.851V5.78411H50.9582C53.1542 5.78411 54.9452 7.56676 54.9452 9.76662C54.9452 11.9602 53.1542 13.7491 50.9582 13.7491ZM50.9582 0.316071H45.1865V0.347678H40.3767V28.8321H45.851V19.2172H50.9582C56.173 19.2172 60.4195 14.9755 60.4195 9.76662C60.4195 4.55776 56.1793 0.316071 50.9582 0.316071Z"></path></g>', 1)
  ]), 16);
}
const sW = /* @__PURE__ */ fe(nW, [["render", aW]]), iW = {};
function lW(o, e) {
  return k(), N("svg", Ve(o.$attrs, {
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), e[0] || (e[0] = [
    O("path", {
      "fill-rule": "evenodd",
      "lip-rule": "evenodd",
      d: "M16.3232 11.5055C16.7293 11.567 17.15 11.6308 17.589 11.7344H17.5849C20.2485 12.3647 22.182 14.6664 22.182 17.2079C22.182 19.2289 21.0113 21.1158 19.1227 22.1324C18.1804 22.6407 17.1036 22.9091 16.0022 22.9091C12.5921 22.9091 9.81836 20.3513 9.81836 17.2079H13.3508C13.3508 18.4116 14.5419 19.3916 16.0063 19.3916C16.5203 19.3916 17.0179 19.2696 17.4462 19.0378C18.2049 18.6312 18.6577 17.9439 18.6577 17.2079C18.6577 16.1669 17.6909 15.3739 16.7772 15.1584C16.5045 15.0922 16.2048 15.0469 15.891 14.9994C15.8387 14.9915 15.786 14.9835 15.733 14.9754C15.2598 14.9063 14.7744 14.8331 14.2605 14.703C11.7722 14.0726 10.0345 11.9378 10.0345 9.51413C10.0345 6.47648 12.7104 4.00407 15.9981 4C17.0465 4 18.0785 4.25212 18.9799 4.73196C20.8237 5.71198 21.9699 7.5419 21.9699 9.51007H18.4415C18.4415 8.8391 18.0214 8.21286 17.3198 7.83875C16.9282 7.62729 16.4713 7.5175 16.0022 7.5175C14.6561 7.5175 13.5629 8.41212 13.5629 9.51007C13.5629 10.4616 14.3747 11.1001 15.1293 11.2912C15.4534 11.3729 15.8185 11.4286 16.1998 11.4867C16.2168 11.4893 16.2339 11.4919 16.251 11.4945C16.2751 11.4982 16.2991 11.5018 16.3232 11.5055ZM21.4547 24.3636V28H12.5433L10.5456 24.3636H21.4547Z"
    }, null, -1)
  ]), 16);
}
const Rb = /* @__PURE__ */ fe(iW, [["render", lW]]), cW = {
  id: "account-branch-name",
  class: "font-medium text-ellipsis overflow-hidden text-nowrap"
}, uW = { class: "flex items-center" }, pW = {
  class: "overflow-y-scroll overflow-x-hidden border-t border-solid border-gray-200 w-[300px]",
  style: { "max-height": "240px" }
}, dW = ["id", "onClick"], gW = /* @__PURE__ */ H({
  __name: "AccountSelector",
  props: {
    branchName: {},
    links: {}
  },
  emits: ["selected"],
  setup(o, { expose: e, emit: r }) {
    const t = r, n = o, a = ue(""), s = se(() => a.value === "" ? n.links : n.links.filter((i) => i.name.toLowerCase().includes(a.value.toLowerCase())));
    return e({ filteredLinks: s }), (i, l) => (k(), R(B($t), { class: "relative" }, {
      default: j(({ open: c }) => [
        z(B(rr), {
          class: q(["flex items-center gap-x-2 text-sm font-medium leading-6 rounded-md text-white px-3 py-1 focus:outline-none focus:ring focus:ring-primary-600 hover:bg-primary-500 max-w-[400px]", c ? "bg-primary-600" : ""])
        }, {
          default: j(() => [
            O("div", cW, _(i.branchName), 1),
            z(B(Zi), {
              class: q(["h-5 w-5 flex-none text-gray-400", ["text-white", { "rotate-180 transform": c }]]),
              "aria-hidden": "true"
            }, null, 8, ["class"])
          ]),
          _: 2
        }, 1032, ["class"]),
        z(Co, {
          "enter-active-class": "transition ease-out duration-200",
          "enter-from-class": "opacity-0 translate-y-1",
          "enter-to-class": "opacity-100 translate-y-0",
          "leave-active-class": "transition ease-in duration-150",
          "leave-from-class": "opacity-100 translate-y-0",
          "leave-to-class": "opacity-0 translate-y-1"
        }, {
          default: j(() => [
            z(B(en), { class: "absolute right-1 top-full z-10 cursor-pointer mt-3 rounded-md bg-white shadow-lg ring-1 ring-gray-900/5 overflow-hidden" }, {
              default: j(() => [
                O("div", uW, [
                  z(B(sM), { class: "h-5 w-5 text-gray-500 mx-4" }),
                  co(O("input", {
                    "onUpdate:modelValue": l[0] || (l[0] = (u) => a.value = u),
                    type: "search",
                    class: "w-full border-none h-12 py-2 pr-2 pl-0 text-gray-500 text-sm focus:outline-none focus:ring-0",
                    placeholder: "Search"
                  }, null, 512), [
                    [Ju, a.value]
                  ])
                ]),
                O("div", pW, [
                  l[1] || (l[1] = O("span", { class: "block text-gray-600 font-medium px-3 py-2 leading-6 text-sm mx-2 mt-2" }, "All Accounts", -1)),
                  (k(!0), N(ye, null, Oe(s.value, (u) => (k(), N("button", {
                    id: `account-button-${u.id}`,
                    key: u.name,
                    class: "block rounded-lg font-medium text-black hover:bg-primary-50 px-3 py-2 leading-6 text-sm w-full text-left mx-2",
                    onClick: (f) => t("selected", u)
                  }, _(u.name), 9, dW))), 128))
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }));
  }
}), mW = { class: "flex items-center gap-x-2 text-sm font-medium leading-6 text-white rounded-md px-3 py-1" }, mn = /* @__PURE__ */ H({
  __name: "PlaceholderLink",
  setup(o) {
    return (e, r) => (k(), N("span", mW, [
      I(e.$slots, "default"),
      z(B(Zi), { class: "h-5 w-5 flex-none text-white" })
    ]));
  }
}), fW = { class: "flex items-center" }, yW = { class: "flex items-center gap-x-2" }, hW = {
  id: "middle_section",
  class: "grow"
}, FW = { class: "flex items-center gap-x-2" }, bW = /* @__PURE__ */ H({
  __name: "DesktopNavigation",
  props: {
    config: {},
    logoutLink: {},
    dashboardLink: {},
    userLinks: {}
  },
  emits: ["selectedAccount", "inertiaLinkClick"],
  setup(o, { emit: e }) {
    const { showSalesUpsellBanner: r, showLettingsUpsellBanner: t, navigation: n, showInsightsUpsellBanner: a, showEmailUpsellBanner: s, showSocialUpsellBanner: i, linksLoading: l, showWebsitesUpsellBanner: c } = ir(), { getTopLevelDomain: u, environment: f } = an(), g = se(() => u(f.value)), { saveToCookieStorage: d } = kd(g.value), p = e, m = (b) => {
      p("selectedAccount", b);
    }, y = (b) => {
      p("inertiaLinkClick", b);
    }, h = o, F = () => {
      d(null, null, null), window.location.href = h.dashboardLink;
    };
    return (b, v) => (k(), N("nav", Ve(b.$attrs, { class: "w-full text-white h-16 flex items-center font-inter z-50 bg-spectre-purple" }), [
      z(B(Oh), { class: "flex items-center justify-between w-full mx-8" }, {
        default: j(() => {
          var P, E, S, D, w, A, C, x, T, M, V;
          return [
            O("section", fW, [
              O("button", {
                "aria-label": "Go to dashboard",
                onClick: F
              }, [
                z(sW, { class: "fill-white w-[150px] mr-5 hidden xl:block" }),
                z(Rb, { class: "fill-white w-8 mr-5 block xl:hidden" })
              ]),
              O("div", yW, [
                B(n).isAdmin ? K("", !0) : (k(), R(Sr, {
                  key: 0,
                  links: B(n).salesLinks,
                  product: "sales",
                  "show-upsell-banner": B(r),
                  onInertiaLinkClick: y
                }, {
                  default: j(() => v[0] || (v[0] = [
                    ne(" Sales ")
                  ])),
                  _: 1
                }, 8, ["links", "show-upsell-banner"])),
                B(n).isAdmin ? K("", !0) : (k(), R(Sr, {
                  key: 1,
                  links: B(n).lettingsLinks,
                  product: "lettings",
                  "show-upsell-banner": B(t),
                  onInertiaLinkClick: y
                }, {
                  default: j(() => v[1] || (v[1] = [
                    ne(" Lettings ")
                  ])),
                  _: 1
                }, 8, ["links", "show-upsell-banner"])),
                (P = B(n).emailLinks) != null && P.length ? (k(), R(Sr, {
                  key: 2,
                  links: B(n).emailLinks,
                  product: "email",
                  "show-upsell-banner": B(s),
                  onInertiaLinkClick: y
                }, {
                  default: j(() => v[2] || (v[2] = [
                    O("span", { class: "hidden 2xl:inline" }, "Email Marketing", -1),
                    O("span", { class: "2xl:hidden" }, "Email", -1)
                  ])),
                  _: 1
                }, 8, ["links", "show-upsell-banner"])) : K("", !0),
                !((E = B(n).emailLinks) != null && E.length) && !B(s) && B(l) ? (k(), R(mn, { key: 3 }, {
                  default: j(() => v[3] || (v[3] = [
                    ne(" Email Marketing ")
                  ])),
                  _: 1
                })) : K("", !0),
                (S = B(n).insightsLinks) != null && S.length ? (k(), R(Sr, {
                  key: 4,
                  links: B(n).insightsLinks,
                  product: "insights",
                  "show-upsell-banner": B(a),
                  onInertiaLinkClick: y
                }, {
                  default: j(() => v[4] || (v[4] = [
                    O("span", { class: "hidden 2xl:inline" }, "Property Reports", -1),
                    O("span", { class: "2xl:hidden" }, "Reports", -1)
                  ])),
                  _: 1
                }, 8, ["links", "show-upsell-banner"])) : K("", !0),
                !((D = B(n).insightsLinks) != null && D.length) && !B(a) && B(l) ? (k(), R(mn, { key: 5 }, {
                  default: j(() => v[5] || (v[5] = [
                    ne(" Property Reports ")
                  ])),
                  _: 1
                })) : K("", !0),
                (w = B(n).socialLinks) != null && w.length ? (k(), R(Sr, {
                  key: 6,
                  links: B(n).socialLinks,
                  product: "social",
                  "show-upsell-banner": B(i),
                  onInertiaLinkClick: y
                }, {
                  default: j(() => v[6] || (v[6] = [
                    O("span", { class: "hidden 2xl:inline" }, "Social Media", -1),
                    O("span", { class: "2xl:hidden" }, "Social", -1)
                  ])),
                  _: 1
                }, 8, ["links", "show-upsell-banner"])) : K("", !0),
                !((A = B(n).socialLinks) != null && A.length) && !B(i) && B(l) ? (k(), R(mn, { key: 7 }, {
                  default: j(() => v[7] || (v[7] = [
                    ne(" Social Media ")
                  ])),
                  _: 1
                })) : K("", !0),
                (C = B(n).websitesLinks) != null && C.length ? (k(), R(Sr, {
                  key: 8,
                  links: B(n).websitesLinks,
                  product: "websites",
                  "show-upsell-banner": B(c),
                  onInertiaLinkClick: y
                }, {
                  default: j(() => v[8] || (v[8] = [
                    ne(" Websites ")
                  ])),
                  _: 1
                }, 8, ["links", "show-upsell-banner"])) : K("", !0),
                !((x = B(n).websitesLinks) != null && x.length) && !B(c) && B(l) ? (k(), R(mn, { key: 9 }, {
                  default: j(() => v[9] || (v[9] = [
                    ne(" Websites ")
                  ])),
                  _: 1
                })) : K("", !0),
                B(n).isAdmin && ((T = B(n).printAdminLinks) != null && T.length) ? (k(), R(Sr, {
                  key: 10,
                  links: B(n).printAdminLinks,
                  product: "print",
                  "show-upsell-banner": B(n).showSalesUpsellBanner,
                  onInertiaLinkClick: y
                }, {
                  default: j(() => v[10] || (v[10] = [
                    ne(" Print ")
                  ])),
                  _: 1
                }, 8, ["links", "show-upsell-banner"])) : K("", !0),
                B(n).isAdmin && !((M = B(n).printAdminLinks) != null && M.length) && B(l) ? (k(), R(mn, { key: 11 }, {
                  default: j(() => v[11] || (v[11] = [
                    ne(" Print ")
                  ])),
                  _: 1
                })) : K("", !0)
              ])
            ]),
            O("section", hW, [
              I(b.$slots, "default")
            ]),
            O("section", FW, [
              B(n).environmentBadge ? (k(), R(mM, { key: 0 })) : K("", !0),
              B(n).credits ? (k(), R(hM, { key: 1 })) : K("", !0),
              B(n).accountLinks && B(n).fullBranchName ? (k(), R(gW, {
                key: 2,
                "branch-name": B(n).fullBranchName,
                links: B(n).accountLinks,
                onSelected: m
              }, null, 8, ["branch-name", "links"])) : K("", !0),
              (V = B(n).identityAdminLinks) != null && V.length ? (k(), R(Sr, {
                key: 3,
                links: B(n).identityAdminLinks,
                product: "identity",
                "show-upsell-banner": !1,
                onInertiaLinkClick: y
              }, {
                default: j(() => v[12] || (v[12] = [
                  ne(" Spectre Admin ")
                ])),
                _: 1
              }, 8, ["links"])) : K("", !0),
              v[13] || (v[13] = O("span", { class: "text-xl text-gray-300" }, "|", -1)),
              B(n).userName && b.userLinks ? (k(), R(zb, {
                key: 4,
                links: b.userLinks,
                "csrf-token": B(n).csrfToken
              }, {
                default: j(() => [
                  ne(_(B(n).userName), 1)
                ]),
                _: 1
              }, 8, ["links", "csrf-token"])) : K("", !0)
            ])
          ];
        }),
        _: 3
      })
    ], 16));
  }
}), { navigation: Jc } = ir(), Ot = Bh({
  label: "",
  links: null
}), dh = ue(!1);
function Ki() {
  const o = (a) => {
    dh.value = a;
  }, e = (a, s) => {
    Ot.label = s, Ot.links = a;
  }, r = () => {
    Ot.label = "", Ot.links = null;
  }, t = se(() => Ot.label !== ""), n = se(() => {
    if (Jc.value.mobileLinks === void 0 || Jc.value.mobileLinks === null)
      return [];
    const a = Jc.value.mobileLinks.find((s) => s.title === "MobileUserDropdownMenu");
    return a === void 0 ? [] : a.subLinks ?? [];
  });
  return {
    setMobileNavSlideOver: o,
    setMobileNavLinksInFocus: e,
    resetMobileNavLinksInFocus: r,
    isMobileLinksInFocus: t,
    mobileNavLinksInFocus: Ot,
    getMobileDropdownLinks: n,
    isMobileNavSlideoverOpen: cr(dh)
  };
}
const vW = { class: "py-1" }, BW = /* @__PURE__ */ H({
  __name: "MobileMenuDropdown",
  props: {
    dynamicMenuLinks: {}
  },
  setup(o) {
    const { redirectToTarget: e } = ir();
    return (r, t) => (k(), R(B(Ah), {
      as: "div",
      class: "relative z-50 inline-block text-left"
    }, {
      default: j(() => [
        O("div", null, [
          z(B(eu), { class: "inline-flex w-full justify-center gap-x-1.5 rounded-md py-2 text-sm font-semibold text-gray-900" }, {
            default: j(() => [
              I(r.$slots, "menu-button")
            ]),
            _: 3
          })
        ]),
        z(Co, {
          "enter-active-class": "transition ease-out duration-100",
          "enter-from-class": "transform opacity-0 scale-95",
          "enter-to-class": "transform opacity-100 scale-100",
          "leave-active-class": "transition ease-in duration-75",
          "leave-from-class": "transform opacity-100 scale-100",
          "leave-to-class": "transform opacity-0 scale-95"
        }, {
          default: j(() => [
            r.dynamicMenuLinks.length ? (k(), R(B(Eh), {
              key: 0,
              class: "absolute right-0 mr-4 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
            }, {
              default: j(() => [
                O("div", vW, [
                  t[0] || (t[0] = O("p", {
                    href: "#",
                    class: "px-4 py-2 text-sm text-black font-semibold"
                  }, " Account ", -1)),
                  (k(!0), N(ye, null, Oe(r.dynamicMenuLinks, (n, a) => (k(), R(B(xh), {
                    key: a,
                    onClick: (s) => B(e)(n.link)
                  }, {
                    default: j(({ active: s }) => [
                      O("a", {
                        href: "#",
                        class: q([s ? "bg-gray-100 text-gray-900" : "text-gray-700", "block px-4 py-2 text-sm"])
                      }, _(n.title), 3)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))), 128))
                ])
              ]),
              _: 1
            })) : K("", !0)
          ]),
          _: 1
        })
      ]),
      _: 3
    }));
  }
}), On = /* @__PURE__ */ H({
  __name: "NavigationLink",
  props: {
    icon: {},
    iconClasses: {},
    target: {}
  },
  setup(o) {
    const e = o, { redirectToTarget: r } = ir();
    return (t, n) => (k(), N("aside", {
      class: "flex gap-2 w-full relative items-center",
      onClick: n[0] || (n[0] = (a) => B(r)(e.target))
    }, [
      O("p", null, [
        I(t.$slots, "link-title")
      ]),
      I(t.$slots, "badge"),
      t.icon ? (k(), R(B(le), {
        key: 0,
        icon: t.icon,
        class: q(["w-6 w-6 text-black absolute right-0 animate duration-500", t.iconClasses])
      }, null, 8, ["icon", "class"])) : K("", !0)
    ]));
  }
}), PW = {}, wW = { class: "bg-red-400 text-xs px-1 py-0.5 flex items-center justify-center rounded text-white" };
function kW(o, e) {
  return k(), N("span", wW, [
    I(o.$slots, "default")
  ]);
}
const Hb = /* @__PURE__ */ fe(PW, [["render", kW]]), DW = {}, SW = { class: "bg-blue-100 text-xs px-1 py-0.5 flex items-center justify-center rounded text-blue-800" };
function AW(o, e) {
  return k(), N("span", SW, [
    I(o.$slots, "default")
  ]);
}
const gh = /* @__PURE__ */ fe(DW, [["render", AW]]), EW = { class: "flex flex-col gap-4" }, xW = { class: "mt-12 ml-2 text-sm space-y-6" }, CW = { class: "ml-2 text-sm space-y-6" }, OW = /* @__PURE__ */ H({
  __name: "NavigationLinkList",
  props: {
    dashboardLink: {}
  },
  setup(o) {
    const e = o, { navigation: r, redirectToTarget: t, remainingCredits: n } = ir(), { setMobileNavLinksInFocus: a } = Ki(), s = [
      { name: "Settings", href: "https://spectre.uk.com/portal/account/settings" },
      { name: "Help & Support", href: "https://support.spectre.uk.com/knowledge" }
    ], i = [
      {
        show: !0,
        title: "Dashboard",
        href: e.dashboardLink,
        badge: null,
        dispatchAction: () => {
          t(e.dashboardLink);
        }
      },
      {
        show: !0,
        title: "Sales",
        href: null,
        badge: null,
        dispatchAction: () => {
          if (r.value.salesLinks === null) {
            t("https://spectre.uk.com/account/switch-redirect?destination=https://spectre.uk.com/portal/dashboard&account_type=sales");
            return;
          }
          a(r.value.salesLinks, "Sales");
        }
      },
      {
        show: !0,
        title: "Lettings",
        href: null,
        badge: null,
        dispatchAction: () => {
          if (r.value.lettingsLinks === null) {
            t("https://spectre.uk.com/account/switch-redirect?destination=https://spectre.uk.com/portal/lettings/dashboard&account_type=lettings");
            return;
          }
          a(r.value.lettingsLinks, "Lettings");
        }
      },
      {
        show: r.value.emailLinks,
        title: "Email Marketing",
        href: null,
        badge: null,
        dispatchAction: () => {
          r.value.emailLinks !== null && a(r.value.emailLinks, "Email Marketing");
        }
      },
      {
        show: r.value.insightsLinks,
        title: "Property Reports",
        href: null,
        badge: null,
        dispatchAction: () => {
          r.value.insightsLinks !== null && a(r.value.insightsLinks, "Property Reports");
        }
      },
      {
        show: r.value.socialLinks,
        title: "Social Media",
        href: null,
        badge: null,
        dispatchAction: () => {
          r.value.socialLinks !== null && a(r.value.socialLinks, "Social Media");
        }
      },
      {
        show: r.value.websitesLinks,
        title: "Websites",
        href: null,
        badge: null,
        dispatchAction: () => {
          r.value.websitesLinks !== null && a(r.value.websitesLinks, "Websites");
        }
      }
    ], l = se(() => i.filter((c) => c.show));
    return (c, u) => (k(), N("aside", EW, [
      O("nav", xW, [
        (k(!0), N(ye, null, Oe(l.value, (f, g) => (k(), R(On, {
          key: g,
          icon: B(rg),
          onClick: f.dispatchAction
        }, bh({
          "link-title": j(() => [
            O("p", null, _(f.title), 1)
          ]),
          _: 2
        }, [
          f != null && f.badge ? {
            name: "badge",
            fn: j(() => [
              z(Hb, null, {
                default: j(() => [
                  O("p", null, _(f.badge), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            key: "0"
          } : void 0
        ]), 1032, ["icon", "onClick"]))), 128))
      ]),
      u[1] || (u[1] = O("div", { class: "h-[1px] bg-gray-200 w-full" }, null, -1)),
      O("nav", CW, [
        B(r).credits ? (k(), R(On, { key: 0 }, {
          "link-title": j(() => u[0] || (u[0] = [
            O("p", null, "Branch credits", -1)
          ])),
          badge: j(() => [
            B(r).credits.branchCreditLimit ? (k(), R(gh, { key: 0 }, {
              default: j(() => [
                O("p", null, _(B(n)) + " / " + _(B(r).credits.branchCreditLimit), 1)
              ]),
              _: 1
            })) : (k(), R(gh, { key: 1 }, {
              default: j(() => {
                var f;
                return [
                  ne(_((f = B(r).credits) == null ? void 0 : f.credits), 1)
                ];
              }),
              _: 1
            }))
          ]),
          _: 1
        })) : K("", !0),
        (k(), N(ye, null, Oe(s, (f, g) => z(On, {
          key: g,
          icon: B(rg),
          target: f.href
        }, {
          "link-title": j(() => [
            O("p", null, _(f.name), 1)
          ]),
          _: 2
        }, 1032, ["icon", "target"])), 64))
      ])
    ]));
  }
}), TW = { class: "mt-12 overflow-scroll max-h-[500px] ml-2 text-sm space-y-6" }, LW = { class: "text-base font-semibold" }, jW = { class: "w-full space-y-6" }, MW = /* @__PURE__ */ H({
  __name: "NavigationLinksInFocus",
  setup(o) {
    const { resetMobileNavLinksInFocus: e, mobileNavLinksInFocus: r } = Ki();
    return (t, n) => (k(), N("section", null, [
      O("nav", TW, [
        O("p", LW, _(B(r).label), 1),
        O("aside", {
          class: "flex items-center gap-2",
          onClick: n[0] || (n[0] = //@ts-ignore
          (...a) => B(e) && B(e)(...a))
        }, [
          z(B(le), {
            icon: B(z3),
            class: "w-6 w-6 text-black"
          }, null, 8, ["icon"]),
          n[1] || (n[1] = ne(" Back "))
        ]),
        O("div", jW, [
          (k(!0), N(ye, null, Oe(B(r).links, (a, s) => (k(), R(B(kh), {
            key: s,
            as: "div"
          }, {
            default: j(({ open: i }) => [
              z(B(Dh), { class: "flex w-full" }, {
                default: j(() => {
                  var l;
                  return [
                    z(On, {
                      "icon-classes": i ? "rotate-90" : "rotate-0",
                      icon: (l = a == null ? void 0 : a.subLinks) != null && l.length ? B(Si) : null,
                      target: a.link
                    }, {
                      "link-title": j(() => [
                        O("p", null, _(a.title), 1)
                      ]),
                      _: 2
                    }, 1032, ["icon-classes", "icon", "target"])
                  ];
                }),
                _: 2
              }, 1024),
              z(Co, {
                "enter-active-class": "transition duration-200 ease-out",
                "enter-from-class": "transform opacity-0",
                "enter-to-class": "transform opacity-100",
                "leave-active-class": "transition duration-200 ease-out",
                "leave-from-class": "transform opacity-100",
                "leave-to-class": "transform opacity-0"
              }, {
                default: j(() => {
                  var l;
                  return [
                    (l = a == null ? void 0 : a.subLinks) != null && l.length ? (k(), R(B(Sh), {
                      key: 0,
                      class: "pl-4 py-2 pt-4 space-y-6 text-sm"
                    }, {
                      default: j(() => [
                        (k(!0), N(ye, null, Oe(a.subLinks, (c, u) => (k(), R(On, {
                          key: u,
                          target: c.link
                        }, {
                          "link-title": j(() => [
                            O("p", null, _(c.title), 1)
                          ]),
                          badge: j(() => [
                            c != null && c.badge ? (k(), R(Hb, {
                              key: 0,
                              class: "absolute right-0"
                            }, {
                              default: j(() => [
                                O("p", null, _(c.badge), 1)
                              ]),
                              _: 2
                            }, 1024)) : K("", !0)
                          ]),
                          _: 2
                        }, 1032, ["target"]))), 128))
                      ]),
                      _: 2
                    }, 1024)) : K("", !0)
                  ];
                }),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024))), 128))
        ])
      ])
    ]));
  }
}), WW = { class: "fixed inset-0 overflow-hidden" }, NW = { class: "absolute inset-0 overflow-hidden" }, VW = { class: "pointer-events-none fixed inset-y-0 left-0 flex w-10/12" }, zW = { class: "flex h-full flex-col overflow-y-scroll bg-white py-6 shadow-xl" }, IW = { class: "px-4 sm:px-6" }, RW = /* @__PURE__ */ H({
  __name: "MobileMenuSlideover",
  props: {
    open: { type: Boolean },
    dashboardLink: {}
  },
  emits: ["close-slide-over"],
  setup(o, { emit: e }) {
    const { isMobileLinksInFocus: r } = Ki(), t = e;
    return (n, a) => (k(), R(B(Wa), {
      as: "template",
      show: n.open
    }, {
      default: j(() => [
        z(B(Na), {
          class: "relative z-50",
          onClose: a[1] || (a[1] = (s) => t("close-slide-over"))
        }, {
          default: j(() => [
            z(B(tr), {
              as: "template",
              enter: "ease-in-out duration-500",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "ease-in-out duration-500",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: j(() => a[2] || (a[2] = [
                O("div", { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" }, null, -1)
              ])),
              _: 1
            }),
            O("div", WW, [
              O("div", NW, [
                O("div", VW, [
                  z(B(tr), {
                    as: "template",
                    enter: "transform transition ease-in-out duration-500 sm:duration-700",
                    "enter-from": "-translate-x-full",
                    "enter-to": "translate-x-0",
                    leave: "transform transition ease-in-out duration-500 sm:duration-700",
                    "leave-from": "translate-x-0",
                    "leave-to": "-translate-x-full"
                  }, {
                    default: j(() => [
                      z(B(Va), { class: "pointer-events-auto relative w-screen max-w-md" }, {
                        default: j(() => [
                          O("div", zW, [
                            O("div", IW, [
                              z(B(le), {
                                icon: B(Hr),
                                class: "w-8 w-8 text-black",
                                onClick: a[0] || (a[0] = (s) => t("close-slide-over"))
                              }, null, 8, ["icon"]),
                              B(r) ? (k(), R(MW, { key: 0 })) : (k(), R(OW, {
                                key: 1,
                                "dashboard-link": n.dashboardLink
                              }, null, 8, ["dashboard-link"]))
                            ])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show"]));
  }
}), HW = { class: "fixed w-full z-50 text-white h-16 flex items-center border-b border-gray-200 font-inter z-49 bg-spectre-purple" }, YW = { class: "flex items-center" }, qW = ["href"], GW = { class: "w-4 h-4 text-xs font-semibold flex text-black p-4 items-center justify-center bg-gray-100 rounded-full" }, XW = /* @__PURE__ */ H({
  __name: "MobileNavigation",
  props: {
    config: {},
    logoutLink: {},
    dashboardLink: {}
  },
  setup(o) {
    const { getUsernameAbbreviation: e } = ir(), { isMobileNavSlideoverOpen: r, setMobileNavSlideOver: t, getMobileDropdownLinks: n } = Ki();
    return (a, s) => (k(), N("nav", HW, [
      z(B(Oh), { class: "flex items-center justify-between w-full mx-4" }, {
        default: j(() => [
          O("section", null, [
            z(B(le), {
              icon: B(R3),
              class: "w-6 w-6 text-white",
              onClick: s[0] || (s[0] = (i) => B(t)(!0))
            }, null, 8, ["icon"])
          ]),
          O("section", YW, [
            O("a", { href: a.dashboardLink }, [
              z(Rb, { class: "fill-white w-6" })
            ], 8, qW)
          ]),
          O("section", null, [
            z(BW, { "dynamic-menu-links": B(n) }, {
              "menu-button": j(() => [
                O("div", GW, [
                  O("p", null, _(B(e)), 1)
                ])
              ]),
              _: 1
            }, 8, ["dynamic-menu-links"])
          ])
        ]),
        _: 1
      }),
      z(RW, {
        open: B(r),
        "dashboard-link": a.dashboardLink,
        onCloseSlideOver: s[1] || (s[1] = (i) => B(t)(!B(r)))
      }, null, 8, ["open", "dashboard-link"])
    ]));
  }
}), UW = { class: "hidden lg:flex flex-initial items-center divide-x w-full" }, ZW = { class: "font-semibold" }, KW = { class: "font-semibold" }, QW = { class: "px-2" }, JW = { class: "font-semibold" }, _W = /* @__PURE__ */ H({
  __name: "ShadowBar",
  setup(o) {
    const { resolveIcon: e } = wd(), r = e("faPipe"), t = e("faEyeSlash"), n = e("faInfoCircle"), {
      currentUser: a,
      shadowedUser: s,
      shadowedAccount: i,
      shadowedCompany: l,
      endSessionUrl: c
    } = Ui(), u = async (g) => {
      await navigator.clipboard.writeText(g);
    }, f = () => {
      if (!(c.value instanceof URL))
        throw new Error("Trying to end shadowing but URL is missing");
      window.location.href = c.value.toString();
    };
    return (g, d) => (k(), N("div", Ve(g.$attrs, { class: "w-full text-sm text-primary-900 h-16 p-4 flex justify-between items-center font-inter z-50 bg-primary-100" }), [
      O("div", UW, [
        B(t) ? (k(), R(B(le), {
          key: 0,
          icon: B(t),
          class: "font-semibold"
        }, null, 8, ["icon"])) : K("", !0),
        B(s) && B(a) ? (k(), N("div", {
          key: 1,
          class: "px-2 cursor-copy",
          onClick: d[0] || (d[0] = (p) => u(B(s).id))
        }, [
          O("span", ZW, _(B(a).name), 1),
          d[4] || (d[4] = O("span", null, " you are currently shadowing ", -1)),
          O("span", KW, _(B(s).name), 1)
        ])) : K("", !0),
        B(r) && B(l) ? (k(), R(B(le), {
          key: 2,
          icon: B(r),
          class: "font-light text-center"
        }, null, 8, ["icon"])) : K("", !0),
        B(l) ? (k(), N("div", {
          key: 3,
          class: "px-2 cursor-copy",
          onClick: d[1] || (d[1] = (p) => u(B(l).id))
        }, [
          d[5] || (d[5] = O("span", { class: "font-semibold" }, "Company: ", -1)),
          O("span", null, _(B(l).name), 1)
        ])) : K("", !0),
        B(r) && B(i) ? (k(), R(B(le), {
          key: 4,
          icon: B(r),
          class: "font-light text-center"
        }, null, 8, ["icon"])) : K("", !0),
        B(i) ? (k(), N("div", {
          key: 5,
          class: "pl-2 cursor-copy",
          onClick: d[2] || (d[2] = (p) => u(B(i).id))
        }, [
          d[6] || (d[6] = O("span", { class: "font-semibold" }, "Account: ", -1)),
          O("span", null, _(B(i).name), 1)
        ])) : K("", !0)
      ]),
      B(a) && B(s) ? (k(), N("div", {
        key: 0,
        class: "lg:hidden flex flex-initial items-center divide-x w-full cursor-copy",
        onClick: d[3] || (d[3] = (p) => {
          var m, y;
          return u(`User: ${B(s).id}, Company: ${((m = B(l)) == null ? void 0 : m.id) ?? "N/A"}, Account: ${((y = B(i)) == null ? void 0 : y.id) ?? "N/A"}`);
        })
      }, [
        O("div", QW, [
          O("span", JW, _(B(a).name), 1),
          d[7] || (d[7] = O("span", null, " is shadowing", -1))
        ]),
        B(n) ? (k(), R(B(le), {
          key: 0,
          icon: B(n)
        }, null, 8, ["icon"])) : K("", !0)
      ])) : K("", !0),
      O("button", {
        class: "bg-primary-800 rounded text-white text-center text-xs font-normal leading-4 align-middle min-w-24 max-w-28 h-full w-full",
        onClick: f
      }, " End Session ")
    ], 16));
  }
}), $W = { class: "hidden lg:block" }, tH = /* @__PURE__ */ H({
  __name: "NavigationBar",
  props: {
    config: {},
    logoutLink: {},
    dashboardLink: { default: null },
    environment: { default: "production" },
    userUuid: {},
    accountServiceUrl: {},
    currentAccountId: { default: null }
  },
  emits: ["selectedAccount", "inertiaLinkClick"],
  setup(o, { emit: e }) {
    const { setUserUUID: r } = Ib(), { initialiseNavigation: t, navigation: n, fetchLinks: a } = ir(), { isShadowing: s, initialiseShadowbar: i } = Ui(), { initialiseEnvironment: l, getIdsBaseUri: c, environment: u } = an(), f = o, g = e, d = (v) => {
      g("inertiaLinkClick", v);
    }, p = se(() => f.dashboardLink ?? `${c(u.value)}/dashboard`), m = se(() => `${c(u.value)}/profile`), y = se(() => `${c(u.value)}/settings`), h = se(() => `${c(u.value)}/settings/users`), F = se(() => n.value.userLinks ?? [
      { name: "Support", isHeading: !0 },
      { name: "Help Centre", href: "https://support.spectre.uk.com/knowledge", target: "_blank" },
      { name: "Make a Suggestion", href: "https://info.spectre.uk.com/feature-request", target: "_blank" },
      { name: "Contact Us", href: "https://support.spectre.uk.com/knowledge/contact-us", target: "_blank" },
      { name: "Account", isHeading: !0 },
      { name: "Users", href: h.value },
      { name: "Profile", href: m.value },
      { name: "Settings", href: y.value },
      { name: "Log Out", href: f.logoutLink, isForm: !0 }
    ]);
    Fr(async () => {
      var v;
      t(f.config), i(((v = f.config) == null ? void 0 : v.shadowbarData) ?? null), l(f.environment, f.accountServiceUrl), f.userUuid !== null && (r(f.userUuid), await a({
        env: f.environment,
        userUUID: f.userUuid,
        currentAccountId: f.currentAccountId
      }));
    });
    const b = (v) => {
      g("selectedAccount", v);
    };
    return (v, P) => (k(), N("div", Ve(v.$attrs, { class: "w-full" }), [
      B(s) ? (k(), R(_W, { key: 0 })) : K("", !0),
      z(XW, {
        config: v.config,
        "dashboard-link": p.value,
        "logout-link": f.logoutLink,
        "insights-links": B(n).insightsLinks,
        class: "block lg:hidden"
      }, null, 8, ["config", "dashboard-link", "logout-link", "insights-links"]),
      O("div", $W, [
        z(bW, {
          config: v.config,
          "user-links": F.value,
          "dashboard-link": p.value,
          "logout-link": f.logoutLink,
          "insights-links": B(n).insightsLinks,
          onSelectedAccount: b,
          onInertiaLinkClick: d
        }, {
          default: j(() => [
            I(v.$slots, "default")
          ]),
          _: 3
        }, 8, ["config", "user-links", "dashboard-link", "logout-link", "insights-links"])
      ])
    ], 16));
  }
}), mh = (o) => {
  const e = Ub(o);
  return {
    url: h2(e)
  };
}, nH = /* @__PURE__ */ H({
  __name: "ObjectUrlPreview",
  props: {
    file: {}
  },
  setup(o) {
    const e = o, r = ue();
    return Ir(() => e.file, (t) => {
      if (t) {
        r.value = mh(t).url.value;
        return;
      }
      r.value = void 0;
    }), Fr(() => {
      r.value = mh(e.file).url.value;
    }), (t, n) => r.value ? I(t.$slots, "default", {
      key: 0,
      url: r.value
    }) : K("", !0);
  }
}), eN = {
  class: /* @__PURE__ */ q([
    "py-base border-b border-default-300 bg-white"
  ])
}, oN = { class: "flex items-center gap-base" }, aH = /* @__PURE__ */ H({
  __name: "PageHeading",
  setup(o) {
    return (e, r) => (k(), N("header", eN, [
      z(t0, { as: "div" }, {
        default: j(() => [
          O("div", oN, [
            I(e.$slots, "default")
          ])
        ]),
        _: 3
      })
    ]));
  }
}), sH = /* @__PURE__ */ H({
  __name: "PageHeadingColumn",
  props: {
    alignment: { default: "start" }
  },
  setup(o) {
    const e = /* @__PURE__ */ new Map([
      ["start", "justify-start"],
      ["center", "justify-center"],
      ["end", "justify-end"]
    ]);
    return (r, t) => (k(), N("div", {
      class: q([
        "flex gap-2 items-center flex-1",
        B(e).get(r.alignment)
      ])
    }, [
      I(r.$slots, "default")
    ], 2));
  }
}), iH = /* @__PURE__ */ H({
  __name: "PageHeadingTitle",
  props: {
    as: { default: "h1" }
  },
  setup(o) {
    return (e, r) => (k(), R(Vo, {
      as: e.as,
      size: "xl"
    }, {
      default: j(() => [
        I(e.$slots, "default")
      ]),
      _: 3
    }, 8, ["as"]));
  }
}), fh = /* @__PURE__ */ H({
  __name: "PaginationNextPreviousLink",
  props: {
    disabled: { type: Boolean },
    link: {}
  },
  setup(o) {
    const e = ce("as");
    return (r, t) => (k(), R(ve(r.disabled ? "button" : B(e)), {
      href: r.link.url,
      class: q([
        "bg-white relative inline-flex items-center px-4 py-2 text-sm font-semibold ring-1 ring-inset ring-default-300",
        "focus:z-20",
        r.disabled ? "opacity-50 pointer-events-none" : "hover:bg-default-50"
      ]),
      disabled: r.disabled,
      tabindex: r.disabled ? "-1" : 0,
      "aria-disabled": r.disabled
    }, {
      default: j(() => [
        I(r.$slots, "default")
      ]),
      _: 3
    }, 8, ["href", "class", "disabled", "tabindex", "aria-disabled"]));
  }
}), rN = { class: "sr-only" }, tN = { class: "sr-only" }, nN = /* @__PURE__ */ H({
  __name: "PaginationLink",
  props: {
    current: { type: Boolean },
    link: {}
  },
  setup(o) {
    const e = o, r = ce("as"), t = se(() => !e.link.url);
    return (n, a) => n.link.label === "Previous" ? (k(), R(fh, {
      key: 0,
      class: "rounded-l-md",
      link: n.link,
      disabled: t.value
    }, {
      default: j(() => [
        z(B(le), {
          icon: B(kp),
          class: "size-3",
          "aria-hidden": "true"
        }, null, 8, ["icon"]),
        O("span", rN, _(n.link.label), 1)
      ]),
      _: 1
    }, 8, ["link", "disabled"])) : n.link.label === "Next" ? (k(), R(fh, {
      key: 1,
      class: "rounded-r-md",
      link: n.link,
      disabled: t.value
    }, {
      default: j(() => [
        z(B(le), {
          icon: B(Si),
          class: "size-3",
          "aria-hidden": "true"
        }, null, 8, ["icon"]),
        O("span", tN, _(n.link.label), 1)
      ]),
      _: 1
    }, 8, ["link", "disabled"])) : (k(), R(ve(t.value ? "span" : B(r)), {
      key: 2,
      href: n.link.url,
      class: q([
        "relative inline-flex items-center py-2 px-4 text-sm font-medium ring-1 ring-inset",
        "focus:z-20",
        n.current ? "z-10 bg-primary-50 text-primary-600 ring-primary-500" : "text-default-700 bg-white ring-default-300",
        n.current && !t.value && "focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600",
        !n.current && !t.value && "hover:bg-default-50 hover:text-primary-600"
      ]),
      "aria-current": n.current
    }, {
      default: j(() => [
        ne(_(n.link.label), 1)
      ]),
      _: 1
    }, 8, ["href", "class", "aria-current"]));
  }
}), aN = { class: "-space-x-px hidden sm:flex" }, lH = /* @__PURE__ */ H({
  __name: "PaginationLinks",
  setup(o) {
    const e = ce("paginator");
    return (r, t) => {
      var n;
      return k(), N("div", aN, [
        (k(!0), N(ye, null, Oe((n = B(e)) == null ? void 0 : n.links, (a) => (k(), R(nN, {
          key: a.label,
          link: a,
          current: a.active
        }, null, 8, ["link", "current"]))), 128))
      ]);
    };
  }
}), sN = ["id", "disabled", "tabindex", "aria-disabled", "aria-invalid", "aria-describedby"], iN = /* @__PURE__ */ H({
  __name: "Select",
  props: /* @__PURE__ */ yr({
    disabled: { type: Boolean },
    invalid: { type: Boolean }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(o) {
    const e = hr(o, "modelValue"), r = ce("field-id");
    return (t, n) => co((k(), N("select", {
      id: B(r),
      "onUpdate:modelValue": n[0] || (n[0] = (a) => e.value = a),
      disabled: t.disabled,
      tabindex: t.disabled ? "-1" : 0,
      "aria-disabled": t.disabled,
      "aria-invalid": !!t.invalid,
      "aria-describedby": t.invalid ? `${B(r)}-error` : void 0,
      class: q([
        "w-full rounded-md bg-white py-1.5 pl-3 pr-7 border-0 shadow-sm text-base text-default-900 ring-1 ring-inset ring-default-300",
        "focus:ring-2 focus:ring-inset focus:ring-primary-600",
        "sm:text-sm sm:leading-6",
        t.disabled && "disabled:opacity-50 disabled:pointer-events-none"
      ])
    }, [
      I(t.$slots, "default")
    ], 10, sN)), [
      [Ph, e.value]
    ]);
  }
}), lN = {
  class: /* @__PURE__ */ q([
    "hidden",
    "sm:flex sm:space-x-3 sm:items-center"
  ])
}, cN = { key: 0 }, uN = { class: "hidden md:block text-sm text-default-700" }, pN = { class: "font-medium" }, dN = { class: "font-medium" }, gN = { class: "font-medium" }, cH = /* @__PURE__ */ H({
  __name: "PaginationMeta",
  props: {
    perPage: {}
  },
  emits: ["change"],
  setup(o, { emit: e }) {
    const r = ce("paginator"), t = e;
    return (n, a) => (k(), N("div", lN, [
      z(Xp, null, {
        default: j(() => [
          z(Sa, { class: "sr-only" }, {
            default: j(() => a[1] || (a[1] = [
              ne(" Results per page ")
            ])),
            _: 1
          }),
          z(iN, {
            "model-value": n.perPage,
            "onUpdate:modelValue": a[0] || (a[0] = (s) => t("change", s))
          }, {
            default: j(() => a[2] || (a[2] = [
              O("option", { value: 10 }, " 10 ", -1),
              O("option", { value: 25 }, " 25 ", -1),
              O("option", { value: 50 }, " 50 ", -1)
            ])),
            _: 1
          }, 8, ["model-value"])
        ]),
        _: 1
      }),
      B(r) && B(r).from && B(r).to && B(r).total ? (k(), N("div", cN, [
        O("p", uN, [
          a[3] || (a[3] = ne(" Showing " + _(" ") + " ")),
          O("span", pN, _(B(r).from), 1),
          a[4] || (a[4] = ne(" " + _(" ") + " to " + _(" ") + " ")),
          O("span", dN, _(B(r).to), 1),
          a[5] || (a[5] = ne(" " + _(" ") + " of " + _(" ") + " ")),
          O("span", gN, _(B(r).total), 1),
          a[6] || (a[6] = ne(" " + _(" ") + " results "))
        ])
      ])) : K("", !0)
    ]));
  }
}), mN = { class: "flex flex-col [&>dd]:order-first" }, uH = /* @__PURE__ */ H({
  __name: "Pair",
  props: {
    variant: { default: "default" }
  },
  setup(o) {
    return he("pair-variant", o.variant), (r, t) => (k(), N("dl", mN, [
      I(r.$slots, "default")
    ]));
  }
}), pH = /* @__PURE__ */ H({
  __name: "PairLabel",
  setup(o) {
    return (e, r) => (k(), R(oo, {
      as: "dt",
      color: "secondary",
      class: "inline-flex items-center [&>:first-child]:ml-1"
    }, {
      default: j(() => [
        I(e.$slots, "default")
      ]),
      _: 3
    }));
  }
}), fN = { class: "flex space-x-1 items-start" }, dH = /* @__PURE__ */ H({
  __name: "PairValue",
  props: {
    size: { default: "base" }
  },
  setup(o) {
    const e = ce("pair-variant", "default");
    return (r, t) => (k(), N("dd", fN, [
      r.size === "base" ? (k(), R(oo, {
        key: 0,
        as: "span",
        weight: "medium",
        color: "tertiary",
        size: "lg",
        class: "inline-flex items-center [&>:first-child]:ml-2"
      }, {
        default: j(() => [
          I(r.$slots, "default")
        ]),
        _: 3
      })) : K("", !0),
      r.size === "lg" ? (k(), R(Vo, {
        key: 1,
        as: "span",
        size: "2xl",
        class: "inline-flex items-center [&>:first-child]:ml-2"
      }, {
        default: j(() => [
          I(r.$slots, "default")
        ]),
        _: 3
      })) : K("", !0),
      B(e) === "ai" ? co((k(), R(B(le), {
        key: 2,
        icon: B(F1),
        class: "size-3 text-default-700",
        "aria-hidden": "true"
      }, null, 8, ["icon"])), [
        [B(Up), "This is AI predicted"]
      ]) : K("", !0)
    ]));
  }
}), yN = {}, hN = { class: "inline-block cursor-wait bg-current min-h-4 animate-pulse rounded" };
function FN(o, e) {
  return k(), N("span", hN);
}
const gH = /* @__PURE__ */ fe(yN, [["render", FN]]), bN = ["aria-valuenow"], mH = /* @__PURE__ */ H({
  __name: "Progress",
  props: {
    value: { default: 0 }
  },
  setup(o) {
    return (e, r) => (k(), N("div", {
      class: "overflow-hidden rounded-full bg-default-200 h-2",
      role: "progressbar",
      "aria-valuenow": e.value,
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }, [
      O("div", {
        class: "h-full rounded-full bg-gradient-to-r from-primary-800 to-primary-600 transition-all ease-in-out",
        style: qo({
          width: `${e.value}%`
        })
      }, null, 4)
    ], 8, bN));
  }
}), vN = {
  class: /* @__PURE__ */ q([
    "space-y-base",
    "lg:flex lg:gap-x-base lg:space-y-0"
  ])
}, BN = { "aria-hidden": "true" }, PN = { class: "inline-flex size-12 items-center justify-center rounded-full bg-default-100" }, wN = {
  class: /* @__PURE__ */ q([
    "flex-1 space-y-4",
    "lg:grid lg:space-y-1 lg:grid-cols-4 lg:gap-base lg:[&>div:first-child]:col-span-3 lg:[&>div:last-child]:text-right"
  ])
}, fH = /* @__PURE__ */ H({
  __name: "ProgressCard",
  props: {
    checked: { type: Boolean },
    disabled: { type: Boolean }
  },
  setup(o) {
    return (e, r) => (k(), R(Ti, {
      class: q(e.disabled && "opacity-60 pointer-events-none")
    }, {
      default: j(() => [
        z(Li, null, {
          default: j(() => [
            O("div", vN, [
              O("div", BN, [
                O("span", PN, [
                  O("span", {
                    class: q([
                      "inline-flex size-9 items-center justify-center rounded-full",
                      e.checked ? "bg-primary-600" : "bg-default-300"
                    ])
                  }, [
                    e.checked ? (k(), R(B(le), {
                      key: 0,
                      icon: B(y8),
                      class: "size-4 text-white"
                    }, null, 8, ["icon"])) : K("", !0)
                  ], 2)
                ])
              ]),
              O("div", wN, [
                I(e.$slots, "default")
              ])
            ])
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), yH = /* @__PURE__ */ H({
  __name: "ProgressCardDescription",
  setup(o) {
    return (e, r) => (k(), R(oo, null, {
      default: j(() => [
        I(e.$slots, "default")
      ]),
      _: 3
    }));
  }
}), kN = {}, DN = { class: "space-y-3 rounded-xl bg-default-100 p-3 shadow" };
function SN(o, e) {
  return k(), N("div", DN, [
    I(o.$slots, "default")
  ]);
}
const hH = /* @__PURE__ */ fe(kN, [["render", SN]]), FH = /* @__PURE__ */ H({
  __name: "ProgressCardTitle",
  props: {
    as: { default: "p" }
  },
  setup(o) {
    return (e, r) => (k(), R(Vo, {
      as: e.as,
      size: "lg"
    }, {
      default: j(() => [
        I(e.$slots, "default")
      ]),
      _: 3
    }, 8, ["as"]));
  }
}), AN = ["id", "value", "checked", "disabled", "tabindex", "aria-disabled"], EN = /* @__PURE__ */ H({
  __name: "Radio",
  props: /* @__PURE__ */ yr({
    checked: { type: Boolean },
    disabled: { type: Boolean },
    modelValue: {},
    value: {}
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(o) {
    const e = o, r = hr(o, "modelValue"), t = ce("field-id"), n = se(() => e.checked ? !0 : e.modelValue === e.value);
    return (a, s) => co((k(), N("input", {
      id: B(t),
      "onUpdate:modelValue": s[0] || (s[0] = (i) => r.value = i),
      type: "radio",
      class: q([
        "h-4 w-4 rounded-full border-default-300 text-primary-600 focus:ring-primary-600",
        "disabled:opacity-50 disabled:pointer-events-none"
      ]),
      value: a.value,
      checked: n.value,
      disabled: a.disabled,
      tabindex: a.disabled ? "-1" : 0,
      "aria-disabled": a.disabled
    }, null, 8, AN)), [
      [Zb, r.value]
    ]);
  }
}), xN = {
  class: /* @__PURE__ */ q([
    "grid grid-cols-[1rem_1fr] gap-x-4 gap-y-1",
    "[&>input]:col-start-1 [&>input]:row-start-1 [&>input]:mt-1",
    "[&>label]:col-start-2 [&>label]:row-start-1",
    "[&>p]:col-start-2 [&>p]:row-start-2"
  ])
}, bH = /* @__PURE__ */ H({
  __name: "RadioField",
  setup(o) {
    const e = fo();
    return he("field-id", e), (r, t) => (k(), N("div", xN, [
      I(r.$slots, "default")
    ]));
  }
}), vH = /* @__PURE__ */ H({
  __name: "RadioGroup",
  setup(o) {
    return (e, r) => (k(), R(bd, { gap: "sm" }, {
      default: j(() => [
        I(e.$slots, "default")
      ]),
      _: 3
    }));
  }
}), CN = ["for"], BH = /* @__PURE__ */ H({
  __name: "RadioGroupRadio",
  props: /* @__PURE__ */ yr({
    checked: { type: Boolean },
    disabled: { type: Boolean },
    modelValue: {},
    value: {},
    hidden: { type: Boolean }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(o) {
    const e = fo();
    he("field-id", e), he("field-label-context", {
      as: "span"
    });
    const r = hr(o, "modelValue");
    return (t, n) => (k(), N("label", {
      for: B(e),
      class: q([
        "bg-gray-50 flex items-center space-x-3 rounded-xl p-base min-h-[58px] cursor-pointer",
        "[&>*]:cursor-pointer",
        t.checked || o.modelValue === t.value ? "shadow-sm ring-2 ring-white ring-offset-2 ring-offset-primary-600" : ""
      ])
    }, [
      z(EN, {
        modelValue: r.value,
        "onUpdate:modelValue": n[0] || (n[0] = (a) => r.value = a),
        checked: t.checked,
        disabled: t.disabled,
        value: t.value,
        class: q({
          hidden: t.hidden
        })
      }, null, 8, ["modelValue", "checked", "disabled", "value", "class"]),
      I(t.$slots, "default")
    ], 10, CN));
  }
}), PH = /* @__PURE__ */ H({
  __name: "SegmentedButton",
  props: {
    color: { default: "blue" },
    value: {}
  },
  setup(o) {
    const e = /* @__PURE__ */ new Map([
      ["red", "bg-red-100 border-red-600"],
      ["yellow", "bg-yellow-100 border-yellow-600"],
      ["green", "bg-green-100 border-green-600"],
      ["blue", "bg-blue-100 border-blue-600"],
      ["primary", "bg-primary-100 border-primary-600"],
      ["purple", "bg-purple-100 border-purple-600"],
      ["pink", "bg-pink-100 border-pink-600"]
    ]);
    return (r, t) => (k(), R(B(bi), {
      as: "template",
      value: r.value
    }, {
      default: j(({ checked: n }) => [
        O("button", {
          type: "button",
          class: q([
            "rounded-full py-1.5 px-4 font-gilmer font-bold text-sm border text-default-700",
            "focus:outline-none",
            n ? B(e).get(r.color) : "border-default-300 bg-white"
          ])
        }, [
          I(r.$slots, "default")
        ], 2)
      ]),
      _: 3
    }, 8, ["value"]));
  }
}), ON = { class: "flex gap-base" }, wH = /* @__PURE__ */ H({
  __name: "SegmentedButtonGroup",
  props: {
    description: {},
    label: {}
  },
  setup(o) {
    return (e, r) => (k(), R(B(Fi), null, {
      default: j(() => [
        z(B(hi), { class: "sr-only" }, {
          default: j(() => [
            ne(_(e.label), 1)
          ]),
          _: 1
        }),
        e.description ? (k(), R(B(Ch), {
          key: 0,
          class: "sr-only"
        }, {
          default: j(() => [
            ne(_(e.description), 1)
          ]),
          _: 1
        })) : K("", !0),
        O("div", ON, [
          I(e.$slots, "default")
        ])
      ]),
      _: 3
    }));
  }
}), TN = /* @__PURE__ */ H({
  __name: "SettingCardButton",
  props: {
    as: { default: "button" }
  },
  setup(o) {
    return (e, r) => (k(), R(ve(e.as), { class: "underline font-medium text-default-700" }, {
      default: j(() => [
        I(e.$slots, "default")
      ]),
      _: 3
    }));
  }
}), LN = { key: 0 }, jN = {
  key: 1,
  class: "text-default-500 font-medium text-sm"
}, kH = /* @__PURE__ */ H({
  __name: "SettingCard",
  props: {
    showEdit: { type: Boolean }
  },
  emits: ["submit", "cancel", "edit"],
  setup(o, { emit: e }) {
    const r = e;
    return (t, n) => (k(), R(Ti, null, {
      default: j(() => [
        t.showEdit ? K("", !0) : (k(), R(E7, {
          key: 0,
          class: "flex justify-between items-center"
        }, {
          default: j(() => [
            O("div", null, [
              I(t.$slots, "default")
            ]),
            O("div", null, [
              t.$slots.button ? I(t.$slots, "button", { key: 0 }) : (k(), R(TN, {
                key: 1,
                onClick: n[0] || (n[0] = (a) => r("edit"))
              }, {
                default: j(() => n[3] || (n[3] = [
                  ne(" Edit ")
                ])),
                _: 1
              }))
            ])
          ]),
          _: 3
        })),
        O("form", {
          onSubmit: n[2] || (n[2] = _c((a) => r("submit"), ["prevent"]))
        }, [
          z(Li, null, {
            default: j(() => [
              t.showEdit ? (k(), N("div", LN, [
                I(t.$slots, "edit")
              ])) : (k(), N("div", jN, [
                I(t.$slots, "preview")
              ]))
            ]),
            _: 3
          }),
          t.showEdit ? (k(), R(A7, {
            key: 0,
            class: "flex flex-row-reverse gap-3"
          }, {
            default: j(() => [
              z(eo, { type: "submit" }, {
                default: j(() => n[4] || (n[4] = [
                  ne(" Save ")
                ])),
                _: 1
              }),
              z(eo, {
                type: "button",
                color: "secondary",
                onClick: n[1] || (n[1] = (a) => r("cancel"))
              }, {
                default: j(() => n[5] || (n[5] = [
                  ne(" Cancel ")
                ])),
                _: 1
              }),
              I(t.$slots, "footer-buttons")
            ]),
            _: 3
          })) : K("", !0)
        ], 32)
      ]),
      _: 3
    }));
  }
}), MN = { class: "grid grid-cols-9 gap-6" }, WN = { class: "col-span-9 lg:col-span-6" }, NN = {
  key: 0,
  class: /* @__PURE__ */ q([
    "col-span-3 hidden",
    "lg:block"
  ])
}, DH = /* @__PURE__ */ H({
  __name: "SettingCardGroup",
  props: {
    help: {}
  },
  setup(o) {
    return (e, r) => (k(), N("div", MN, [
      O("div", WN, [
        I(e.$slots, "default")
      ]),
      e.help ? (k(), N("div", NN, [
        z(ux, null, {
          default: j(() => [
            O("p", null, _(e.help), 1)
          ]),
          _: 1
        })
      ])) : K("", !0)
    ]));
  }
}), VN = {}, zN = { class: "bg-default-200 rounded-lg px-4 py-5 sm:p-6 space-y-5" };
function IN(o, e) {
  return k(), N("div", zN, [
    I(o.$slots, "default")
  ]);
}
const SH = /* @__PURE__ */ fe(VN, [["render", IN]]), AH = /* @__PURE__ */ H({
  __name: "SettingCardTitle",
  props: {
    as: { default: "h3" }
  },
  setup(o) {
    return (e, r) => (k(), R(ve(e.as), { class: "text-default-700 font-medium" }, {
      default: j(() => [
        I(e.$slots, "default")
      ]),
      _: 3
    }));
  }
}), RN = {};
function HN(o, e) {
  return k(), N("section", null, [
    I(o.$slots, "default")
  ]);
}
const EH = /* @__PURE__ */ fe(RN, [["render", HN]]), YN = {}, qN = { class: "space-y-base" };
function GN(o, e) {
  return k(), N("div", qN, [
    I(o.$slots, "default")
  ]);
}
const xH = /* @__PURE__ */ fe(YN, [["render", GN]]), CH = /* @__PURE__ */ H({
  __name: "SettingGroupTitle",
  props: {
    as: { default: "h2" }
  },
  setup(o) {
    return (e, r) => (k(), R(Vo, {
      as: e.as,
      size: "xl",
      class: "pb-md"
    }, {
      default: j(() => [
        I(e.$slots, "default")
      ]),
      _: 3
    }, 8, ["as"]));
  }
}), XN = { class: "grid grid-cols-12" }, OH = /* @__PURE__ */ H({
  __name: "SidebarLayout",
  setup(o) {
    return (e, r) => (k(), R(t0, {
      as: "div",
      class: "bg-default-50"
    }, {
      default: j(() => [
        O("div", XN, [
          I(e.$slots, "default")
        ])
      ]),
      _: 3
    }));
  }
}), UN = {}, ZN = { class: "col-span-9 p-lg" };
function KN(o, e) {
  return k(), N("div", ZN, [
    O("main", null, [
      I(o.$slots, "default")
    ])
  ]);
}
const TH = /* @__PURE__ */ fe(UN, [["render", KN]]), QN = {}, JN = { class: "col-span-3 bg-white px-base py-lg" };
function _N(o, e) {
  return k(), N("div", JN, [
    O("aside", null, [
      I(o.$slots, "default")
    ])
  ]);
}
const LH = /* @__PURE__ */ fe(QN, [["render", _N]]), $N = { class: "flex items-center justify-between" }, eV = { class: "flex flex-1 justify-between sm:justify-end space-x-3" }, jH = /* @__PURE__ */ H({
  __name: "SimplePagination",
  props: {
    as: { default: yo },
    paginator: {}
  },
  setup(o) {
    return he("paginator", o.paginator), (r, t) => (k(), N("nav", $N, [
      I(r.$slots, "default"),
      O("div", eV, [
        z(eo, {
          as: r.paginator.prev_page_url ? r.as : "button",
          href: r.paginator.prev_page_url,
          color: "secondary",
          disabled: !r.paginator.prev_page_url
        }, {
          default: j(() => t[0] || (t[0] = [
            ne(" Previous ")
          ])),
          _: 1
        }, 8, ["as", "href", "disabled"]),
        z(eo, {
          as: r.paginator.next_page_url ? r.as : "button",
          href: r.paginator.next_page_url,
          color: "secondary",
          disabled: !r.paginator.next_page_url
        }, {
          default: j(() => t[1] || (t[1] = [
            ne(" Next ")
          ])),
          _: 1
        }, 8, ["as", "href", "disabled"])
      ])
    ]));
  }
}), oV = {
  key: 0,
  class: "px-2 py-2.5 text-left text-xs font-medium text-default-500"
}, rV = { class: "space-y-base px-2.5 py-base" }, tV = { class: "flex justify-between space-x-2" }, nV = { class: "flex space-x-1" }, aV = { key: 0 }, sV = ["src"], MH = /* @__PURE__ */ H({
  __name: "SmallBrandPreview",
  props: {
    headingFontFamily: {},
    headingFontWeight: {},
    hideBorder: { type: Boolean, default: !1 },
    name: { default: void 0 },
    primaryColor: {},
    rectangleLogoUrl: { default: void 0 },
    secondaryColor: {}
  },
  setup(o) {
    return (e, r) => (k(), N("div", {
      class: q([
        "divide-y-2 divide-default-300 rounded-md bg-default-50",
        !e.hideBorder && "border-2 border-default-300"
      ])
    }, [
      e.name ? (k(), N("div", oV, _(e.name), 1)) : K("", !0),
      O("div", rV, [
        O("div", tV, [
          O("div", {
            style: qo({
              fontFamily: e.headingFontFamily,
              fontWeight: e.headingFontWeight
            }),
            class: "text-3xl text-black"
          }, " Aa ", 4),
          O("div", nV, [
            O("span", {
              class: "h-full w-14 rounded-sm",
              style: qo({ backgroundColor: e.primaryColor })
            }, null, 4),
            O("span", {
              class: "h-full w-14 rounded-sm",
              style: qo({ backgroundColor: e.secondaryColor })
            }, null, 4)
          ])
        ]),
        e.rectangleLogoUrl ? (k(), N("div", aV, [
          O("img", {
            src: e.rectangleLogoUrl,
            class: "h-6 object-contain",
            alt: ""
          }, null, 8, sV)
        ])) : K("", !0)
      ])
    ], 2));
  }
}), iV = { class: "flex gap-3 items-center" }, WH = /* @__PURE__ */ H({
  __name: "SmallCardsRadioGroup",
  setup(o) {
    return he("field-label-context", {
      as: hi
    }), (e, r) => (k(), R(B(Fi), null, {
      default: j(() => [
        O("div", iV, [
          I(e.$slots, "default")
        ])
      ]),
      _: 3
    }));
  }
}), NH = /* @__PURE__ */ H({
  __name: "SmallCardsRadioGroupOption",
  setup(o) {
    return (e, r) => (k(), R(B(bi), { as: "template" }, {
      default: j(({ checked: t, disabled: n }) => [
        O("button", {
          class: q([
            "font-medium shadow-sm text-sm px-3.5 py-2.5 cursor-pointer outline-none rounded-md overflow-hidden border",
            t ? "border-transparent bg-primary-600 text-white focus-visible:outline-primary-900" : "border-default-300 bg-white text-default-900 hover:bg-default-50",
            n && "opacity-50 pointer-events-none"
          ]),
          type: "button"
        }, [
          z(B(hi), { as: "span" }, {
            default: j(() => [
              I(e.$slots, "default", { checked: t })
            ]),
            _: 2
          }, 1024)
        ], 2)
      ]),
      _: 3
    }));
  }
}), lV = {}, cV = {
  class: /* @__PURE__ */ q([
    "px-4 py-5",
    "sm:p-6"
  ])
};
function uV(o, e) {
  return k(), N("div", cV, [
    I(o.$slots, "default")
  ]);
}
const VH = /* @__PURE__ */ fe(lV, [["render", uV]]), zH = /* @__PURE__ */ H({
  __name: "StatGroup",
  setup(o) {
    var n, a, s, i, l;
    const e = ((s = (a = (n = Sd()).default) == null ? void 0 : a.call(n)[0].children) == null ? void 0 : s.length) ?? ((l = (i = Sd()).default) == null ? void 0 : l.call(i).length), r = Math.min(e ?? 1, 5), t = /* @__PURE__ */ new Map([
      [1, "md:grid-cols-1"],
      [2, "md:grid-cols-2"],
      [3, "md:grid-cols-3"],
      [4, "md:grid-cols-4"],
      [5, "md:grid-cols-5"]
    ]);
    return (c, u) => (k(), N("dl", {
      class: q([
        "grid grid-cols-1 divide-y divide-default-200 overflow-hidden rounded-lg bg-white shadow",
        B(t).get(B(r)),
        "md:divide-x md:divide-y-0"
      ])
    }, [
      I(c.$slots, "default")
    ], 2));
  }
}), pV = {}, dV = { class: "ml-2 text-sm font-medium text-default-500" };
function gV(o, e) {
  return k(), N("span", dV, [
    I(o.$slots, "default")
  ]);
}
const IH = /* @__PURE__ */ fe(pV, [["render", gV]]), mV = {}, fV = { class: "text-base font-normal text-default-900" };
function yV(o, e) {
  return k(), N("dt", fV, [
    I(o.$slots, "default")
  ]);
}
const RH = /* @__PURE__ */ fe(mV, [["render", yV]]), hV = {}, FV = {
  class: /* @__PURE__ */ q([
    "mt-1 flex items-baseline justify-between",
    "md:block lg:flex"
  ])
}, bV = { class: "flex items-baseline text-2xl font-semibold text-primary-600" };
function vV(o, e) {
  return k(), N("dd", FV, [
    O("div", bV, [
      I(o.$slots, "default")
    ])
  ]);
}
const HH = /* @__PURE__ */ fe(hV, [["render", vV]]), BV = {
  key: 0,
  class: "flex space-x-2 items-center"
}, YH = /* @__PURE__ */ H({
  __name: "Status",
  props: {
    status: {},
    datetime: {}
  },
  setup(o) {
    return (e, r) => (k(), N(ye, null, [
      e.status === "success" ? (k(), N("span", BV, [
        z(B(le), {
          icon: B(Hp),
          class: "size-4 text-green-500",
          "aria-hidden": "true"
        }, null, 8, ["icon"]),
        z(oo, { as: "span" }, {
          default: j(() => r[0] || (r[0] = [
            ne(" Changes saved. ")
          ])),
          _: 1
        })
      ])) : K("", !0),
      e.status === "loading" ? (k(), R(Yr, {
        key: 1,
        class: "size-4 text-primary-500"
      })) : K("", !0),
      e.status === "idle" && e.datetime ? (k(), R(oo, {
        key: 2,
        as: "span"
      }, {
        default: j(() => [
          r[1] || (r[1] = ne(" Changes saved ")),
          z(B(v2), { time: e.datetime }, {
            default: j(({ timeAgo: t }) => [
              ne(_(t), 1)
            ]),
            _: 1
          }, 8, ["time"])
        ]),
        _: 1
      })) : K("", !0),
      e.status === "error" ? (k(), R(YE, {
        key: 3,
        as: "span"
      }, {
        default: j(() => r[2] || (r[2] = [
          ne(" Something went wrong. Please try again. ")
        ])),
        _: 1
      })) : K("", !0)
    ], 64));
  }
}), qH = /* @__PURE__ */ H({
  __name: "StatusCircle",
  props: {
    color: { default: "gray" }
  },
  setup(o) {
    const e = {
      default: "bg-default-200",
      green: "bg-green-200",
      yellow: "bg-yellow-200",
      gray: "bg-gray-200",
      red: "bg-red-200"
    }, r = {
      default: "bg-default-400",
      green: "bg-green-400",
      yellow: "bg-yellow-400",
      gray: "bg-gray-400",
      red: "bg-red-400"
    };
    return (t, n) => (k(), N("div", {
      class: q([
        "flex size-6 items-center justify-center rounded-full",
        e[t.color]
      ]),
      "aria-hidden": "true"
    }, [
      O("div", {
        class: q([
          "size-3 rounded-full",
          r[t.color]
        ])
      }, null, 2)
    ], 2));
  }
}), PV = { class: "flex gap-2 px-6 py-4 justify-between items-center" }, wV = { class: "flex flex-row-reverse gap-3" }, GH = /* @__PURE__ */ H({
  __name: "StepModal",
  props: {
    open: { type: Boolean, default: !1 },
    size: { default: "base" },
    scrollable: { type: Boolean, default: !1 },
    stepper: {},
    backButtonText: { default: "Back" },
    nextButtonText: { default: "Next" },
    finishButtonText: { default: "Finish" }
  },
  emits: ["close", "finish"],
  setup(o, { emit: e }) {
    const r = o, t = e, n = async () => {
      t("close"), await $u(300), xd(r.stepper.steps.value[0]) ? r.stepper.goTo(r.stepper.steps.value[0]) : r.stepper.goTo(Object.keys(r.stepper.steps.value)[0]);
    }, a = async () => {
      await n(), t("finish");
    }, s = (i) => xd(i) ? !0 : typeof (i == null ? void 0 : i.isValid) == "function" ? i.isValid() : !0;
    return (i, l) => (k(), R(IF, {
      open: i.open,
      size: i.size,
      scrollable: i.scrollable,
      onClose: n
    }, {
      default: j(() => [
        I(i.$slots, "default"),
        O("div", PV, [
          z(oo, { color: "secondary" }, {
            default: j(() => [
              ne(" Step " + _(i.stepper.index.value + 1) + " of " + _(i.stepper.stepNames.value.length), 1)
            ]),
            _: 1
          }),
          O("div", wV, [
            i.stepper.isLast.value ? K("", !0) : (k(), R(eo, {
              key: 0,
              disabled: !s(i.stepper.current.value),
              color: "primary",
              onClick: i.stepper.goToNext
            }, {
              default: j(() => [
                ne(_(i.nextButtonText), 1)
              ]),
              _: 1
            }, 8, ["disabled", "onClick"])),
            i.stepper.isLast.value ? (k(), R(eo, {
              key: 1,
              disabled: !s(i.stepper.current.value),
              onClick: a
            }, {
              default: j(() => [
                ne(_(i.finishButtonText), 1)
              ]),
              _: 1
            }, 8, ["disabled"])) : K("", !0),
            i.stepper.isFirst.value ? K("", !0) : (k(), R(eo, {
              key: 2,
              color: "secondary",
              onClick: i.stepper.goToPrevious
            }, {
              default: j(() => [
                ne(_(i.backButtonText), 1)
              ]),
              _: 1
            }, 8, ["onClick"]))
          ])
        ])
      ]),
      _: 3
    }, 8, ["open", "size", "scrollable"]));
  }
}), kV = ["aria-label"], DV = ["aria-label", "aria-current", "onClick"], XH = /* @__PURE__ */ H({
  __name: "StepperNavigation",
  props: {
    ariaLabel: {},
    stepper: {}
  },
  setup(o) {
    return (e, r) => (k(), N("nav", {
      "aria-label": e.ariaLabel,
      class: "flex justify-between items-center space-x-base"
    }, [
      z(Re, {
        as: "button",
        color: "tertiary",
        icon: B(kp),
        ariaLabel: "Go to previous",
        disabled: e.stepper.isFirst.value,
        onClick: e.stepper.goToPrevious
      }, null, 8, ["icon", "disabled", "onClick"]),
      z(Aa, {
        justify: "center",
        gap: "xs"
      }, {
        default: j(() => [
          (k(!0), N(ye, null, Oe(e.stepper.steps.value, (t, n) => (k(), R(Ea, { key: n }, {
            default: j(() => [
              O("button", {
                class: q([
                  "relative size-2 rounded-full",
                  e.stepper.isCurrent(t) ? "bg-primary-600" : "bg-default-200"
                ]),
                "aria-label": `Go to page ${n + 1}`,
                "aria-current": e.stepper.isCurrent(t) ? "page" : void 0,
                onClick: (a) => e.stepper.goTo(t)
              }, [
                z(vr)
              ], 10, DV)
            ]),
            _: 2
          }, 1024))), 128))
        ]),
        _: 1
      }),
      z(Re, {
        as: "button",
        color: "tertiary",
        icon: B(Si),
        ariaLabel: "Go to next",
        disabled: e.stepper.isLast.value,
        onClick: e.stepper.goToNext
      }, null, 8, ["icon", "disabled", "onClick"])
    ], 8, kV));
  }
}), SV = ["fill"], UH = /* @__PURE__ */ H({
  __name: "StreetLogo",
  props: {
    color: { default: "black" }
  },
  setup(o) {
    return (e, r) => (k(), N("svg", {
      viewBox: "0 0 780 117",
      fill: e.color,
      xmlns: "http://www.w3.org/2000/svg",
      role: "img",
      "aria-label": "Street logo"
    }, r[0] || (r[0] = [
      Rr('<path d="M724.075 32.1443C723.658 42.8779 714.651 51.0504 703.141 51.0504C688.839 51.0504 679.602 41.3384 679.602 26.2883C679.602 11.2383 688.839 1.41113 703.141 1.41113C714.507 1.41113 722.852 9.18076 724.147 19.6697C724.234 20.346 723.687 20.9215 722.996 20.9215L711.831 20.8927C711.284 20.8927 710.824 20.5043 710.709 19.9719C710.292 17.9144 708.738 14.231 703.126 14.231C696.781 14.231 693.573 18.2885 693.573 26.2739C693.573 34.2594 696.781 38.2593 703.126 38.2593C708.896 38.2593 710.536 34.5903 710.968 32.1731"></path><path d="M703.083 114.762C690.45 114.762 682.277 106.848 682.277 94.6039V66.8346C682.277 66.2016 682.795 65.6836 683.428 65.6836H694.939C695.572 65.6836 696.09 66.2016 696.09 66.8346V94.4744C696.09 99.7117 698.248 102.043 703.097 102.043C707.946 102.043 710.162 99.7836 710.162 94.4744V66.8346C710.162 66.2016 710.68 65.6836 711.313 65.6836H722.881C723.514 65.6836 724.032 66.2016 724.032 66.8346V94.6039C724.032 106.848 715.816 114.762 703.111 114.762H703.083Z"></path><path d="M755.67 51.0504C741.325 51.0504 732.059 41.3096 732.059 26.2308C732.059 11.1519 741.325 1.41113 755.67 1.41113C770.015 1.41113 779.281 11.1519 779.281 26.2308C779.281 41.3096 770.015 51.0504 755.67 51.0504ZM755.67 14.2454C749.281 14.2454 746.044 18.2741 746.044 26.2308C746.044 34.1874 749.281 38.2161 755.67 38.2161C762.058 38.2161 765.295 34.1874 765.295 26.2308C765.295 18.2741 762.058 14.2454 755.67 14.2454Z"></path><path d="M761.653 113.798L749.884 100.302C749.423 99.7836 748.574 100.1 748.574 100.791V113.035C748.574 113.668 748.056 114.186 747.423 114.186H735.913C735.28 114.186 734.762 113.668 734.762 113.035V66.8346C734.762 66.2016 735.28 65.6836 735.913 65.6836H747.423C748.056 65.6836 748.574 66.2016 748.574 66.8346V77.6977C748.574 78.3884 749.438 78.7337 749.898 78.2157L761.049 66.0577C761.265 65.8275 761.567 65.6836 761.898 65.6836H776.257C777.25 65.6836 777.768 66.8778 777.092 67.6116L757.984 88.3162C757.581 88.7479 757.581 89.4097 757.97 89.8557L777.811 112.301C778.459 113.035 777.941 114.201 776.948 114.201H762.517C762.186 114.201 761.869 114.057 761.653 113.812V113.798Z"></path><path d="M16.5199 79.8257C17.1386 79.8257 17.6278 80.2861 17.7141 80.8904C19.2968 92.4729 28.5772 99.7533 43.3251 99.7533C59.9147 99.7533 67.9864 94.1851 67.9864 82.7465C67.9864 74.315 62.634 69.5813 50.0875 66.9482L34.1598 63.5095C13.2538 59.0203 3.51295 49.0062 3.51295 32.0137C3.51295 11.971 18.4623 0 43.4977 0C66.6483 0 82.4609 12.0429 84.3602 33.1935C84.4177 33.8986 83.8566 34.5029 83.1516 34.5029L67.9433 34.4597C67.3246 34.4597 66.821 33.9705 66.749 33.3518C65.6555 23.2225 56.8356 16.5608 43.1956 16.5608C29.5556 16.5608 21.8147 21.7549 21.8147 32.0137C21.8147 36.546 23.5701 42.9631 38.7784 46.258L53.5982 49.3803C74.9791 53.8262 86.2882 65.3655 86.2882 82.7609C86.2882 103.379 69.8281 116.185 43.3538 116.185C16.8796 116.185 0.606535 103.681 0.00223074 81.1925C-0.0121575 80.5163 0.534594 79.9695 1.21084 79.9552L16.5343 79.8257H16.5199Z"></path><path d="M127.167 68.5752V19.1805C127.167 18.5043 126.62 17.9719 125.958 17.9719H106.074C105.398 17.9719 104.865 17.4252 104.865 16.7633V2.61974C104.865 1.9435 105.412 1.41113 106.074 1.41113H165.972C166.648 1.41113 167.18 1.95788 167.18 2.61974V16.7633C167.18 17.4396 166.634 17.9719 165.972 17.9719H146.203C145.526 17.9719 144.994 18.5187 144.994 19.1805V68.5752C144.994 69.2514 144.447 69.7838 143.785 69.7838H128.404C127.728 69.7838 127.196 69.2371 127.196 68.5752H127.167Z"></path><path d="M159.726 98.1436H113.972C113.288 98.1436 112.734 98.6976 112.734 99.3809V113.481C112.734 114.165 113.288 114.719 113.972 114.719H159.726C160.41 114.719 160.964 114.165 160.964 113.481V99.3809C160.964 98.6976 160.41 98.1436 159.726 98.1436Z"></path><path d="M266.285 114.761C265.867 114.761 265.479 114.56 265.249 114.215L236.89 71.5679L236.803 71.5248H214.689C213.998 71.5248 213.451 72.0859 213.451 72.7622V113.524C213.451 114.215 212.89 114.761 212.214 114.761H197.034C196.344 114.761 195.797 114.2 195.797 113.524V2.64852C195.797 1.95788 196.358 1.41113 197.034 1.41113H241.077C263.364 1.41113 277.766 15.0799 277.766 36.2305C277.766 51.1223 269.982 62.935 256.803 68.3162C256.069 68.6184 255.781 69.496 256.213 70.1579L284.601 112.848C285.148 113.668 284.558 114.776 283.565 114.776H266.27L266.285 114.761ZM240.3 54.9496C252.86 54.9496 259.493 48.5325 259.493 36.3888C259.493 24.2452 252.673 17.9719 240.3 17.9719H214.703C214.012 17.9719 213.466 18.5331 213.466 19.2093V53.7122C213.466 54.4028 214.027 54.9496 214.703 54.9496H240.3Z"></path><path d="M314.028 114.761H312.892C312.201 114.761 311.654 114.2 311.654 113.524V2.64852C311.654 1.95788 312.215 1.41113 312.892 1.41113H384.746C385.437 1.41113 385.984 1.97227 385.984 2.64852V16.7346C385.984 17.4252 385.423 17.9719 384.746 17.9719H330.56C329.87 17.9719 329.323 18.5331 329.323 19.2093V46.8346C329.323 47.5253 329.884 48.072 330.56 48.072H379.912C380.602 48.072 381.149 48.6332 381.149 49.3094V50.4461V62.2588V63.4098C381.149 64.0861 380.588 64.6472 379.897 64.6472H330.56C329.87 64.6472 329.323 65.2084 329.323 65.8846V97.107C329.323 97.7976 329.884 98.3444 330.56 98.3444H384.746C385.437 98.3444 385.984 98.9055 385.984 99.5817V113.51C385.984 114.2 385.423 114.747 384.746 114.747H314.028V114.761Z"></path><path d="M417.704 114.761H416.567C415.877 114.761 415.33 114.2 415.33 113.524V2.64852C415.33 1.95788 415.891 1.41113 416.567 1.41113H488.422C489.113 1.41113 489.659 1.97227 489.659 2.64852V16.7346C489.659 17.4252 489.098 17.9719 488.422 17.9719H434.236C433.545 17.9719 432.999 18.5331 432.999 19.2093V46.8346C432.999 47.5253 433.56 48.072 434.236 48.072H483.588C484.278 48.072 484.825 48.6332 484.825 49.3094V50.4461V62.2588V63.4098C484.825 64.0861 484.264 64.6472 483.573 64.6472H434.236C433.545 64.6472 432.999 65.2084 432.999 65.8846V97.107C432.999 97.7976 433.56 98.3444 434.236 98.3444H488.422C489.113 98.3444 489.659 98.9055 489.659 99.5817V113.51C489.659 114.2 489.098 114.747 488.422 114.747H417.704V114.761Z"></path><path d="M545.877 114.761H544.74C544.049 114.761 543.503 114.2 543.503 113.524V19.2093C543.503 18.5187 542.941 17.9719 542.265 17.9719H510.87C510.18 17.9719 509.633 17.4108 509.633 16.7346V2.64852C509.633 1.95788 510.194 1.41113 510.87 1.41113H593.962C594.653 1.41113 595.199 1.97227 595.199 2.64852V16.7346C595.199 17.4252 594.638 17.9719 593.962 17.9719H562.567C561.876 17.9719 561.33 18.5331 561.33 19.2093V113.524C561.33 114.215 560.768 114.761 560.092 114.761H545.891H545.877Z"></path><path d="M609.245 115.251C608.555 115.251 608.008 114.69 608.008 114.014V99.9278C608.008 99.2372 608.569 98.6904 609.245 98.6904H655C655.69 98.6904 656.237 99.2516 656.237 99.9278V114.014C656.237 114.704 655.676 115.251 655 115.251H609.245Z"></path>', 12)
    ]), 8, SV));
  }
}), ZH = /* @__PURE__ */ H({
  __name: "Switch",
  props: {
    checked: { type: Boolean },
    modelValue: { type: Boolean },
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(o, { emit: e }) {
    const r = o, t = se(() => r.checked ? !0 : r.modelValue), n = e;
    return Fr(() => {
      const a = Kb();
      a != null && a.id && console.error('Directly passing an "id" attribute to the Switch component is not recommended. Use the HeadlessUI SwitchGroup and SwitchLabel components to manage labels and accessibility instead.');
    }), (a, s) => (k(), R(B(i2), {
      "default-checked": t.value,
      class: q([
        "group relative inline-flex h-5 w-10 flex-shrink-0 cursor-pointer items-center justify-center rounded-full",
        "focus:outline-none focus:ring-2 focus:ring-primary-600 focus:ring-offset-2",
        "disabled:pointer-events-none disabled:opacity-50"
      ]),
      disabled: a.disabled,
      tabindex: a.disabled ? "-1" : 0,
      "aria-disabled": a.disabled,
      "onUpdate:modelValue": s[0] || (s[0] = (i) => n("update:modelValue", i))
    }, {
      default: j(() => [
        s[1] || (s[1] = O("span", {
          "aria-hidden": "true",
          class: "pointer-events-none absolute h-full w-full rounded-md"
        }, null, -1)),
        O("span", {
          "aria-hidden": "true",
          class: q([
            t.value ? "bg-primary-600" : "bg-default-200",
            a.disabled && "bg-default-200",
            "pointer-events-none absolute mx-auto h-4 w-9 rounded-full transition-colors duration-200 ease-in-out"
          ])
        }, null, 2),
        O("span", {
          "aria-hidden": "true",
          class: q([
            t.value ? "translate-x-5" : "translate-x-0",
            "pointer-events-none absolute left-0 inline-block h-5 w-5 transform rounded-full border border-default-200 bg-white shadow ring-0 transition-transform duration-200 ease-in-out"
          ])
        }, null, 2)
      ]),
      _: 1
    }, 8, ["default-checked", "disabled", "tabindex", "aria-disabled"]));
  }
}), KH = /* @__PURE__ */ H({
  __name: "SwitchField",
  setup(o) {
    const e = fo();
    return he("field-id", e), he("field-label-context", {
      as: Th
    }), (r, t) => (k(), R(B(Lh), {
      as: "div",
      class: q([
        "grid grid-cols-[1fr_auto] gap-x-4 gap-y-1",
        "[&>button]:col-start-2 [&>button]:self-start [&>button]:mt-0.5",
        "[&>label]:col-start-1 [&>label]:row-start-1",
        "[&>p]:col-start-1 [&>p]:row-start-2"
      ])
    }, {
      default: j(() => [
        I(r.$slots, "default")
      ]),
      _: 3
    }));
  }
}), QH = /* @__PURE__ */ H({
  __name: "SwitchGroup",
  setup(o) {
    return (e, r) => (k(), R(bd, { gap: "sm" }, {
      default: j(() => [
        I(e.$slots, "default")
      ]),
      _: 3
    }));
  }
}), JH = /* @__PURE__ */ H({
  __name: "SwitchGroupField",
  setup(o) {
    return he("field-label-context", {
      as: Th
    }), (e, r) => (k(), R(B(Lh), {
      as: "div",
      class: "bg-white flex items-center justify-between space-x-3 rounded-xl p-base ring-1 ring-default-200"
    }, {
      default: j(() => [
        I(e.$slots, "default")
      ]),
      _: 3
    }));
  }
}), AV = /* @__PURE__ */ H({
  __name: "DefaultTab",
  props: {
    icon: {}
  },
  setup(o) {
    return (e, r) => (k(), R(B(jh), { as: "template" }, {
      default: j(({ selected: t }) => [
        O("button", {
          class: q([
            t ? "border-primary-500 text-primary-600" : "border-transparent text-default-500 hover:border-default-300 hover:text-default-700",
            "whitespace-nowrap border-b-2 px-1 py-4 text-sm font-medium outline-none"
          ])
        }, [
          e.icon ? (k(), R(B(le), {
            key: 0,
            icon: e.icon,
            class: q([
              t ? "text-primary-500" : "text-default-400 group-hover:text-default-500",
              "-ml-0.5 mr-2 size-4"
            ]),
            "aria-hidden": "true"
          }, null, 8, ["icon", "class"])) : K("", !0),
          I(e.$slots, "default")
        ], 2)
      ]),
      _: 3
    }));
  }
}), EV = { class: "block" }, xV = /* @__PURE__ */ H({
  __name: "FullWidthTab",
  props: {
    icon: {}
  },
  setup(o) {
    const e = ce("size"), r = /* @__PURE__ */ new Map([
      ["sm", "py-base"],
      ["base", "py-lg"]
    ]);
    return (t, n) => (k(), R(B(jh), { as: "template" }, {
      default: j(({ selected: a }) => [
        B(e) ? (k(), N("button", {
          key: 0,
          class: q([
            "flex-1 text-sm font-medium text-default-500 border-b-2 outline-none px-base",
            a ? "border-primary-500" : "border-default-200",
            B(r).get(B(e))
          ])
        }, [
          t.icon ? (k(), R(B(le), {
            key: 0,
            icon: t.icon,
            class: "size-4 mb-2"
          }, null, 8, ["icon"])) : K("", !0),
          O("span", EV, [
            I(t.$slots, "default")
          ])
        ], 2)) : K("", !0)
      ]),
      _: 3
    }));
  }
}), _H = /* @__PURE__ */ H({
  __name: "Tab",
  props: {
    icon: {}
  },
  setup(o) {
    const e = ce("variant"), r = /* @__PURE__ */ new Map([
      ["default", AV],
      ["full-width", xV]
    ]);
    return (t, n) => (k(), R(ve(B(r).get(B(e) ?? "default")), { icon: t.icon }, {
      default: j(() => [
        I(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["icon"]));
  }
}), $H = /* @__PURE__ */ H({
  __name: "TabGroup",
  props: {
    as: { default: "template" },
    defaultIndex: { default: 0 },
    selectedIndex: { default: void 0 },
    size: { default: "base" },
    manual: { type: Boolean },
    variant: { default: "default" }
  },
  emits: ["change"],
  setup(o, { emit: e }) {
    const r = o;
    he("size", r.size), he("variant", r.variant);
    const t = e;
    return (n, a) => (k(), N("div", null, [
      z(B(l2), {
        as: n.as,
        "default-index": n.defaultIndex,
        "selected-index": n.selectedIndex,
        manual: n.manual,
        onChange: a[0] || (a[0] = (s) => t("change", s))
      }, {
        default: j(() => [
          I(n.$slots, "default")
        ]),
        _: 3
      }, 8, ["as", "default-index", "selected-index", "manual"])
    ]));
  }
}), CV = {}, OV = { class: "overflow-x-auto" }, TV = { class: "inline-block min-w-full align-middle p-px" }, LV = { class: "overflow-hidden shadow ring-1 ring-black/5 sm:rounded-lg" }, jV = { class: "min-w-full divide-y divide-default-300" };
function MV(o, e) {
  return k(), N("div", OV, [
    O("div", TV, [
      O("div", LV, [
        O("table", jV, [
          I(o.$slots, "default")
        ])
      ])
    ])
  ]);
}
const eY = /* @__PURE__ */ fe(CV, [["render", MV]]), WV = {}, NV = { class: "divide-y divide-default-200 bg-white" };
function VV(o, e) {
  return k(), N("tbody", NV, [
    I(o.$slots, "default")
  ]);
}
const oY = /* @__PURE__ */ fe(WV, [["render", VV]]), zV = {}, IV = { class: "px-6 py-4 whitespace-nowrap text-sm text-default-900" };
function RV(o, e) {
  return k(), N("td", IV, [
    I(o.$slots, "default")
  ]);
}
const rY = /* @__PURE__ */ fe(zV, [["render", RV]]), HV = {}, YV = { class: "bg-default-50" };
function qV(o, e) {
  return k(), N("thead", YV, [
    I(o.$slots, "default")
  ]);
}
const tY = /* @__PURE__ */ fe(HV, [["render", qV]]), GV = {}, XV = { class: "px-6 py-3 text-left text-xs font-medium text-default-500 uppercase tracking-wider" };
function UV(o, e) {
  return k(), N("th", XV, [
    I(o.$slots, "default")
  ]);
}
const nY = /* @__PURE__ */ fe(GV, [["render", UV]]), ZV = {};
function KV(o, e) {
  return k(), N("tr", null, [
    I(o.$slots, "default")
  ]);
}
const aY = /* @__PURE__ */ fe(ZV, [["render", KV]]), QV = { class: "overflow-x-auto" }, JV = { class: "border-b border-default-200" }, _V = { class: "-mb-px flex space-x-8" }, sY = /* @__PURE__ */ H({
  __name: "TabList",
  setup(o) {
    const e = ce("variant");
    return (r, t) => (k(), N(ye, null, [
      B(e) === "default" ? (k(), R(B(Ad), { key: 0 }, {
        default: j(() => [
          O("div", QV, [
            O("div", JV, [
              O("div", _V, [
                I(r.$slots, "default")
              ])
            ])
          ])
        ]),
        _: 3
      })) : K("", !0),
      B(e) === "full-width" ? (k(), R(B(Ad), {
        key: 1,
        class: "flex"
      }, {
        default: j(() => [
          I(r.$slots, "default")
        ]),
        _: 3
      })) : K("", !0)
    ], 64));
  }
}), iY = /* @__PURE__ */ H({
  __name: "TabPanel",
  setup(o) {
    return (e, r) => (k(), R(B(c2), null, {
      default: j(() => [
        I(e.$slots, "default")
      ]),
      _: 3
    }));
  }
}), $V = { class: "p-sm rounded-b-lg" }, lY = /* @__PURE__ */ H({
  __name: "TabPanels",
  props: {
    as: {}
  },
  setup(o) {
    return (e, r) => (k(), N("div", $V, [
      z(B(u2), { as: e.as }, {
        default: j(() => [
          I(e.$slots, "default")
        ]),
        _: 3
      }, 8, ["as"])
    ]));
  }
}), ez = {}, oz = { class: "p-lg bg-white rounded-md shadow" };
function rz(o, e) {
  return k(), N("section", oz, [
    I(o.$slots, "default")
  ]);
}
const cY = /* @__PURE__ */ fe(ez, [["render", rz]]), tz = ["id", "resize", "maxlength", "disabled", "tabindex", "aria-disabled", "aria-invalid", "aria-describedby"], uY = /* @__PURE__ */ H({
  inheritAttrs: !1,
  __name: "Textarea",
  props: {
    disabled: { type: Boolean },
    invalid: { type: Boolean },
    resize: { type: Boolean },
    maxLength: {},
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(o, { emit: e }) {
    const t = ue(o.modelValue ?? ""), n = e, a = ce("field-id");
    return (s, i) => (k(), N(ye, null, [
      co(O("textarea", Ve({
        id: B(a),
        "onUpdate:modelValue": i[0] || (i[0] = (l) => t.value = l),
        resize: s.resize,
        maxlength: s.maxLength,
        disabled: s.disabled,
        tabindex: s.disabled ? "-1" : 0,
        "aria-disabled": s.disabled,
        "aria-invalid": !!s.invalid,
        "aria-describedby": s.invalid ? `${B(a)}-error` : void 0,
        class: [
          "text-sm block w-full px-3 py-2 rounded-md border border-default-300 placeholder-default-400 outline-none relative",
          "focus-visible:ring-inset focus-visible:ring-primary-600",
          !s.resize && "resize-none",
          s.disabled && "disabled:opacity-50 disabled:pointer-events-none"
        ]
      }, s.$attrs, {
        onInput: i[1] || (i[1] = (l) => {
          var c;
          return n("update:modelValue", (c = l.target) == null ? void 0 : c.value);
        })
      }), null, 16, tz), [
        [Ju, t.value]
      ]),
      s.maxLength ? (k(), R(oo, {
        key: 0,
        color: "secondary",
        class: "pt-2"
      }, {
        default: j(() => {
          var l;
          return [
            ne(" Characters remaining: " + _(s.maxLength - (((l = t.value) == null ? void 0 : l.length) ?? 0)), 1)
          ];
        }),
        _: 1
      })) : K("", !0)
    ], 64));
  }
}), nz = { class: "rounded-md text-sm" }, az = /* @__PURE__ */ H({
  __name: "TextareaRichText",
  props: {
    ariaLabel: {},
    disabled: { type: Boolean, default: !1 },
    invalid: { type: Boolean },
    modelValue: { default: void 0 },
    placeholder: { default: void 0 },
    rows: { default: 3 }
  },
  emits: ["update:modelValue"],
  setup(o, { emit: e }) {
    const r = o, t = e, n = ce("field-id", null), [a, s] = Po(!1), i = wh("target");
    za(i, () => s(!1));
    const l = ep({
      editorProps: {
        attributes: {
          class: "py-2 px-3 overflow-y-auto focus:outline-none",
          style: `height: ${r.rows * 20}px`
        },
        handleDOMEvents: {
          focus: () => {
            r.disabled || s(!0);
          }
        }
      },
      content: r.modelValue,
      editable: !r.disabled,
      extensions: [
        rp,
        tp,
        np,
        ap,
        sp,
        ip,
        lp,
        V2.configure({
          placeholder: r.placeholder
        })
      ],
      onUpdate: () => {
        var c;
        t("update:modelValue", (c = l.value) == null ? void 0 : c.getJSON());
      }
    });
    return (c, u) => (k(), R(B($t), {
      ref_key: "target",
      ref: i,
      as: "div",
      class: q([
        "relative rounded-md ring-inset ring-1 ring-default-300",
        "focus-within:ring-2 focus-within:ring-inset focus-within:ring-primary-600",
        c.disabled && "opacity-50 pointer-events-none"
      ])
    }, {
      default: j(() => [
        O("div", nz, [
          z(B(op), {
            editor: B(l),
            role: "textbox",
            "aria-label": c.ariaLabel,
            "aria-disabled": c.disabled,
            "aria-invalid": !!c.invalid,
            "aria-describedby": c.invalid ? `${B(n)}-error` : void 0
          }, null, 8, ["editor", "aria-label", "aria-disabled", "aria-invalid", "aria-describedby"])
        ]),
        z(Co, {
          "enter-active-class": "transition duration-200 ease-out",
          "enter-from-class": "translate-y-1 opacity-0",
          "enter-to-class": "translate-y-0 opacity-100",
          "leave-active-class": "transition duration-150 ease-in",
          "leave-from-class": "translate-y-0 opacity-100",
          "leave-to-class": "translate-y-1 opacity-0"
        }, {
          default: j(() => [
            B(a) ? (k(), R(B(en), {
              key: 0,
              static: "",
              class: "absolute z-10 mt-2 ml-3 rounded-md bg-white shadow-lg ring-1 ring-default-300 p-2 flex space-x-2"
            }, {
              default: j(() => {
                var f, g, d, p;
                return [
                  z(Re, {
                    icon: B(y1),
                    ariaLabel: "Toggle bold",
                    color: (f = B(l)) != null && f.isActive("bold") ? "primary" : "tertiary",
                    onClick: u[0] || (u[0] = (m) => {
                      var y;
                      return (y = B(l)) == null ? void 0 : y.chain().focus().toggleBold().run();
                    })
                  }, null, 8, ["icon", "color"]),
                  z(Re, {
                    icon: B(f1),
                    ariaLabel: "Toggle italic",
                    color: (g = B(l)) != null && g.isActive("italic") ? "primary" : "tertiary",
                    onClick: u[1] || (u[1] = (m) => {
                      var y;
                      return (y = B(l)) == null ? void 0 : y.chain().focus().toggleItalic().run();
                    })
                  }, null, 8, ["icon", "color"]),
                  z(Re, {
                    icon: B(h1),
                    ariaLabel: "Toggle underline",
                    color: (d = B(l)) != null && d.isActive("underline") ? "primary" : "tertiary",
                    onClick: u[2] || (u[2] = (m) => {
                      var y;
                      return (y = B(l)) == null ? void 0 : y.chain().focus().toggleUnderline().run();
                    })
                  }, null, 8, ["icon", "color"]),
                  z(Re, {
                    icon: B(b1),
                    ariaLabel: "Toggle strike through",
                    color: (p = B(l)) != null && p.isActive("strike") ? "primary" : "tertiary",
                    onClick: u[3] || (u[3] = (m) => {
                      var y;
                      return (y = B(l)) == null ? void 0 : y.chain().focus().toggleStrike().run();
                    })
                  }, null, 8, ["icon", "color"])
                ];
              }),
              _: 1
            })) : K("", !0)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["class"]));
  }
}), pY = /* @__PURE__ */ fe(az, [["__scopeId", "data-v-6b37d986"]]), dY = /* @__PURE__ */ H({
  __name: "TextLink",
  props: {
    as: { default: yo },
    stretched: { type: Boolean }
  },
  setup(o) {
    return (e, r) => (k(), R(ve(e.as), {
      class: q([
        "text-primary-600",
        "hover:text-primary-700 hover:underline",
        e.stretched && "after:absolute after:inset-0"
      ])
    }, {
      default: j(() => [
        I(e.$slots, "default")
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), sz = {
  key: 0,
  class: "pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black/5"
}, iz = { class: "p-base" }, lz = { class: "flex items-start" }, cz = { class: "shrink-0" }, uz = { class: "ml-3 w-0 flex-1 space-y-2" }, pz = { class: "ml-4 flex shrink-0" }, dz = /* @__PURE__ */ H({
  __name: "Toast",
  props: {
    toast: {},
    show: { type: Boolean }
  },
  emits: ["close"],
  setup(o, { emit: e }) {
    const r = e;
    return (t, n) => t.show ? (k(), N("div", sz, [
      O("div", iz, [
        O("div", lz, [
          O("div", cz, [
            t.toast.type === "success" ? (k(), R(B(le), {
              key: 0,
              icon: B(Hp),
              class: "size-4 text-emerald-600",
              "aria-hidden": "true"
            }, null, 8, ["icon"])) : K("", !0),
            t.toast.type === "error" ? (k(), R(B(le), {
              key: 1,
              icon: B(f8),
              class: "size-4 text-red-600",
              "aria-hidden": "true"
            }, null, 8, ["icon"])) : K("", !0),
            t.toast.type === "warning" ? (k(), R(B(le), {
              key: 2,
              icon: B(RF),
              class: "size-4 text-amber-600",
              "aria-hidden": "true"
            }, null, 8, ["icon"])) : K("", !0),
            t.toast.type === "info" ? (k(), R(B(le), {
              key: 3,
              icon: B(YF),
              class: "size-4 text-blue-600",
              "aria-hidden": "true"
            }, null, 8, ["icon"])) : K("", !0)
          ]),
          O("div", uz, [
            z(oo, { weight: "medium" }, {
              default: j(() => [
                ne(_(t.toast.label), 1)
              ]),
              _: 1
            }),
            t.toast.description ? (k(), R(oo, {
              key: 0,
              class: "font-medium",
              color: "secondary"
            }, {
              default: j(() => [
                ne(_(t.toast.description), 1)
              ]),
              _: 1
            })) : K("", !0)
          ]),
          O("div", pz, [
            O("button", {
              class: q(["relative inline-flex rounded-md", "focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"]),
              onClick: n[0] || (n[0] = (a) => r("close"))
            }, [
              z(vr),
              z(B(le), {
                icon: B(Hr),
                class: "size-5 text-default-400",
                "aria-hidden": "true"
              }, null, 8, ["icon"]),
              n[1] || (n[1] = O("span", { class: "sr-only" }, " Close ", -1))
            ])
          ])
        ])
      ])
    ])) : K("", !0);
  }
}), xs = ue([]);
let gz = 0;
const Yb = () => ({
  enqueue: (t, n, a = "success") => {
    xs.value.push({
      id: `toasts-${gz += 1}`,
      label: t,
      type: a,
      description: n
    });
  },
  dequeue: () => {
    xs.value.length && xs.value.shift();
  },
  duration: 5e3,
  queue: xs
}), yh = 300, mz = /* @__PURE__ */ H({
  __name: "ToastTransition",
  setup(o) {
    const { dequeue: e, duration: r } = Yb(), [t] = Po(!1), n = () => {
      t.value = !1, Ed(() => {
        e();
      }, yh);
    }, { start: a, stop: s } = Ed(() => {
      n();
    }, r - yh);
    return Fr(() => {
      t.value = !0, a();
    }), (i, l) => (k(), R(Co, {
      "enter-active-class": "transform ease-out duration-300 transition",
      "enter-from-class": "translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2",
      "enter-to-class": "translate-y-0 opacity-100 sm:translate-x-0",
      "leave-active-class": "transition ease-in duration-300",
      "leave-from-class": "opacity-100",
      "leave-to-class": "opacity-0",
      onMouseover: B(s),
      onMouseleave: B(a)
    }, {
      default: j(() => [
        I(i.$slots, "default", {
          show: B(t),
          onClose: n
        })
      ]),
      _: 3
    }, 8, ["onMouseover", "onMouseleave"]));
  }
}), fz = {
  "aria-live": "assertive",
  class: /* @__PURE__ */ q([
    "z-[70] pointer-events-none fixed inset-0 flex items-end px-4 py-6",
    "sm:items-start sm:p-6"
  ])
}, yz = {
  class: /* @__PURE__ */ q([
    "flex w-full flex-col items-center space-y-4",
    "sm:items-end"
  ])
}, hz = /* @__PURE__ */ H({
  __name: "ToastGroup",
  props: {
    toasts: {}
  },
  setup(o) {
    return (e, r) => (k(), N("div", fz, [
      O("div", yz, [
        (k(!0), N(ye, null, Oe(e.toasts, (t) => (k(), R(mz, {
          key: t.id
        }, {
          default: j(({ show: n, onClose: a }) => [
            z(dz, {
              toast: t,
              show: n,
              onClose: a
            }, null, 8, ["toast", "show", "onClose"])
          ]),
          _: 2
        }, 1024))), 128))
      ])
    ]));
  }
}), gY = /* @__PURE__ */ H({
  __name: "ToggleButton",
  props: {
    ariaLabel: {},
    icon: {}
  },
  setup(o) {
    return (e, r) => (k(), R(B(bi), { as: "template" }, {
      default: j(({ checked: t }) => [
        (k(), R(ve(e.icon ? Re : eo), {
          type: "button",
          color: t ? "primary" : "tertiary",
          ariaLabel: e.icon && e.ariaLabel,
          icon: e.icon
        }, {
          default: j(() => [
            I(e.$slots, "default")
          ]),
          _: 2
        }, 1032, ["color", "ariaLabel", "icon"]))
      ]),
      _: 3
    }));
  }
}), Fz = { class: "border border-default-300 inline-flex bg-white rounded-lg p-px space-x-xxs" }, mY = /* @__PURE__ */ H({
  __name: "ToggleButtonGroup",
  props: {
    ariaLabel: {}
  },
  setup(o) {
    return (e, r) => (k(), R(B(Fi), { "aria-label": e.ariaLabel }, {
      default: j(() => [
        O("div", Fz, [
          I(e.$slots, "default")
        ])
      ]),
      _: 3
    }, 8, ["aria-label"]));
  }
}), bz = { class: "flex-1" }, fY = /* @__PURE__ */ H({
  __name: "VerticalNavigationLink",
  props: {
    as: { default: yo },
    current: { type: Boolean },
    href: {},
    trailingIcon: { default: void 0 }
  },
  setup(o) {
    return (e, r) => (k(), N("li", null, [
      (k(), R(ve(e.as), {
        href: e.href,
        class: q([
          "inline-flex space-x-3 w-full cursor-pointer px-base py-3 text-sm font-medium rounded-md",
          "hover:bg-primary-100 hover:text-primary-600",
          e.current ? "bg-primary-100 text-primary-600" : "text-default-900"
        ])
      }, {
        default: j(() => [
          O("span", bz, [
            I(e.$slots, "default")
          ]),
          e.trailingIcon ? (k(), R(B(le), {
            key: 0,
            icon: e.trailingIcon,
            class: "size-4",
            "aria-hidden": "true"
          }, null, 8, ["icon"])) : K("", !0)
        ]),
        _: 3
      }, 8, ["href", "class"]))
    ]));
  }
}), vz = {}, Bz = { class: "space-y-3" };
function Pz(o, e) {
  return k(), N("nav", null, [
    O("ul", Bz, [
      I(o.$slots, "default")
    ])
  ]);
}
const yY = /* @__PURE__ */ fe(vz, [["render", Pz]]), hY = (o) => {
  const e = ue(0), r = ue([]), [t, n] = Po(!1), [a, s] = Po(!1), i = ue(""), l = () => {
    i.value = "", e.value = 0, r.value = [], s(!1), n(!1);
  }, c = async () => {
    var m, y;
    if (a.value)
      return;
    const f = B(o.url);
    n(!0);
    const g = {};
    g[((m = o.parameters) == null ? void 0 : m.page) ?? "page"] = e.value += 1, g[((y = o.parameters) == null ? void 0 : y.query) ?? "query"] = i.value.length >= 3 ? i.value : void 0;
    const { data: d } = await cp.get(f, {
      params: g
    }), p = o.transform ? o.transform(d) : d;
    if (!p.length) {
      if (e.value -= 1, n(!1), i.value) {
        r.value = [];
        return;
      }
      s(!0);
      return;
    }
    i.value ? r.value = p : r.value = [
      ...r.value,
      ...p
    ], n(!1);
  };
  F2(i, async (f) => {
    e.value = 0, s(!1), f || (r.value = []), await c();
  }, { debounce: 500 });
  const u = se(() => r.value.length === 0 && i.value !== "");
  return Ir(
    () => B(o.url),
    async (f, g) => {
      f && f !== g && l();
    }
  ), {
    endReached: a,
    isEmpty: u,
    isLoading: t,
    fetch: c,
    options: r,
    query: i
  };
}, FY = (o) => {
  const e = ue(0), r = ue([]), [t, n] = Po(!1), [a, s] = Po(!1), i = () => {
    e.value = 0, r.value = [], s(!1);
  }, l = async () => {
    var d;
    if (a.value)
      return;
    const c = B(o.url);
    n(!0);
    const u = {};
    u[((d = o.parameters) == null ? void 0 : d.page) ?? "page"] = e.value += 1;
    const { data: f } = await cp.get(c, {
      params: u
    }), g = o.transform ? o.transform(f) : f;
    if (!g.length) {
      e.value -= 1, s(!0), n(!1);
      return;
    }
    r.value = [
      ...r.value,
      ...g
    ], n(!1);
  };
  return Ir(
    () => B(o.url),
    async (c, u) => {
      c && c !== u && i();
    }
  ), {
    endReached: a,
    isLoading: t,
    fetch: l,
    options: r
  };
}, bY = /* @__PURE__ */ H({
  __name: "UseFileDialog",
  props: {
    options: {}
  },
  emits: ["cancel", "change"],
  setup(o, { emit: e }) {
    const r = o, t = e, { open: n, onChange: a } = Nh(r.options);
    return a((s) => {
      t("change", s);
    }), (s, i) => I(s.$slots, "default", { open: B(n) });
  }
}), vY = /* @__PURE__ */ H({
  __name: "UseToggle",
  setup(o) {
    const [e, r] = Po(!1);
    return (t, n) => I(t.$slots, "default", {
      open: B(e),
      toggleOpen: () => B(r)(!B(e))
    });
  }
}), BY = /* @__PURE__ */ H({
  __name: "BlankLayout",
  props: {
    flash: {}
  },
  setup(o) {
    const { queue: e, enqueue: r } = Yb(), t = o;
    return Bi(() => t.flash.toasts, (n) => {
      n.forEach((a) => {
        r(a.label, a.description, a.type);
      });
    }), (n, a) => (k(), N(ye, null, [
      z(hz, { toasts: B(e) }, null, 8, ["toasts"]),
      I(n.$slots, "default")
    ], 64));
  }
}), wz = {
  class: /* @__PURE__ */ q([
    "flex min-h-screen flex-col items-center bg-default-900 pt-6",
    "sm:justify-center sm:pt-0"
  ])
}, kz = { class: "mt-6 w-full max-w-md" }, PY = /* @__PURE__ */ H({
  __name: "GuestLayout",
  setup(o) {
    return (e, r) => (k(), N("div", wz, [
      O("div", null, [
        z(B(yo), { href: "/" }, {
          default: j(() => [
            z(Rj, {
              class: "w-40",
              color: "white"
            })
          ]),
          _: 1
        })
      ]),
      O("div", kz, [
        z(Ti, null, {
          default: j(() => [
            z(Li, null, {
              default: j(() => [
                I(e.$slots, "default")
              ]),
              _: 3
            })
          ]),
          _: 3
        })
      ])
    ]));
  }
});
export {
  Jz as SpectreAccordion,
  _z as SpectreAccordionButton,
  $z as SpectreAccordionGroup,
  eI as SpectreAccordionPanel,
  oI as SpectreActionBanner,
  rI as SpectreActionBannerActions,
  tI as SpectreActionBannerDescription,
  nI as SpectreActionBannerTitle,
  aI as SpectreActionPanel,
  sI as SpectreActionPanelCloseButton,
  iI as SpectreActionPanelContent,
  lI as SpectreActionPanelDescription,
  cI as SpectreActionPanelTitle,
  uI as SpectreAddressSearchModal,
  Ai as SpectreAiGlow,
  pI as SpectreAiModal,
  dI as SpectreAiModalContent,
  gI as SpectreAiModalFooter,
  mI as SpectreAiModalHeader,
  fI as SpectreAiModalTitle,
  yI as SpectreAlert,
  hI as SpectreAlertDescription,
  FI as SpectreAlertLink,
  bI as SpectreAlertModal,
  vI as SpectreAlertModalDescription,
  BI as SpectreAlertModalFooter,
  PI as SpectreAlertModalHeader,
  wI as SpectreAlertModalTitle,
  kI as SpectreAlertTitle,
  DI as SpectreAvatar,
  Yp as SpectreBadge,
  qF as SpectreBadgeButton,
  BY as SpectreBlankLayout,
  SI as SpectreBreadcrumb,
  AI as SpectreBreadcrumbGroup,
  EI as SpectreBrowserWindow,
  eo as SpectreButton,
  xI as SpectreButtonGroup,
  CI as SpectreCalendarMonthView,
  OI as SpectreCalendarMonthViewDay,
  TI as SpectreCalendarNavigation,
  LI as SpectreCalendarNavigationTitle,
  jI as SpectreCalendarWeekView,
  MI as SpectreCalendarWeekViewGrid,
  WI as SpectreCalendarWeekViewGridItem,
  NI as SpectreCalendarWeekViewHeader,
  VI as SpectreCalendarWeekViewTimeIndicator,
  Ti as SpectreCard,
  Li as SpectreCardContent,
  A7 as SpectreCardFooter,
  E7 as SpectreCardHeader,
  zI as SpectreCarousel,
  II as SpectreCarouselSlide,
  RI as SpectreCheckbox,
  HI as SpectreCheckboxField,
  YI as SpectreCheckboxGroup,
  qI as SpectreCheckboxGroupField,
  GI as SpectreColorPicker,
  XI as SpectreCombobox,
  UI as SpectreComboboxBadges,
  ZI as SpectreComboboxControl,
  KI as SpectreComboboxOption,
  QI as SpectreComboboxOptions,
  t0 as SpectreContainer,
  JI as SpectreCopyToClipboard,
  _I as SpectreDescription,
  $I as SpectreDescriptionDetails,
  eR as SpectreDescriptionList,
  oR as SpectreDescriptionTerm,
  r0 as SpectreDivider,
  rR as SpectreDotPattern,
  tR as SpectreDrawer,
  nR as SpectreDrawerContent,
  aR as SpectreDrawerDescription,
  sR as SpectreDrawerFooter,
  iR as SpectreDrawerHeader,
  lR as SpectreDrawerTitle,
  cR as SpectreDropdown,
  TE as SpectreDropdownDivider,
  uR as SpectreDropdownHeader,
  pR as SpectreDropdownItem,
  dR as SpectreEmojiPicker,
  yR as SpectreEmptyStateButton,
  gR as SpectreEmptyStateCard,
  fR as SpectreEmptyStateCardDescription,
  mR as SpectreEmptyStateCardTitle,
  hR as SpectreEmptyStateIconButton,
  YE as SpectreErrorMessage,
  FR as SpectreExpandingButton,
  Xp as SpectreField,
  GE as SpectreFieldset,
  bR as SpectreFormatNumber,
  vR as SpectreGridCheckboxGroup,
  BR as SpectreGridCheckboxGroupDescription,
  PR as SpectreGridCheckboxGroupLegend,
  wR as SpectreGridCheckboxGroupOption,
  kR as SpectreGridCheckboxGroupOptions,
  DR as SpectreGridRadioGroup,
  SR as SpectreGridRadioGroupDescription,
  AR as SpectreGridRadioGroupOption,
  ER as SpectreGridRadioGroupOptions,
  PY as SpectreGuestLayout,
  Vo as SpectreHeading,
  xR as SpectreHoverActions,
  CR as SpectreHoverActionsContent,
  OR as SpectreHoverActionsTrigger,
  Re as SpectreIconButton,
  zf as SpectreImagePreview,
  ux as SpectreInfoBox,
  TR as SpectreInfoBoxTextLink,
  LR as SpectreInlineEditor,
  Ut as SpectreInput,
  jR as SpectreInputAddressSearch,
  MR as SpectreInputCopyToClipboard,
  WR as SpectreInputFileDropZone,
  z5 as SpectreInputGroup,
  Y5 as SpectreInputGroupAddon,
  U5 as SpectreInputGroupInput,
  NR as SpectreInputGroupSelect,
  VR as SpectreInputMultiAddressSearch,
  zR as SpectreInputOutcodeSearch,
  IR as SpectreInputRange,
  RR as SpectreInputRangeBadge,
  HR as SpectreInputRichText,
  Sa as SpectreLabel,
  YR as SpectreLargeBrandPreview,
  UE as SpectreLegend,
  qR as SpectreLengthAwarePagination,
  GR as SpectreLineChart,
  XR as SpectreLinkTab,
  UR as SpectreLinkTabGroup,
  ZR as SpectreList,
  KR as SpectreListItem,
  QR as SpectreListbox,
  JR as SpectreListboxBadges,
  _R as SpectreListboxControl,
  $R as SpectreListboxOption,
  eH as SpectreListboxOptions,
  Rj as SpectreLogo,
  IF as SpectreModal,
  e8 as SpectreModalContent,
  oH as SpectreModalDescription,
  rH as SpectreModalFooter,
  $S as SpectreModalHeader,
  ZS as SpectreModalTitle,
  tH as SpectreNavigationBar,
  nH as SpectreObjectUrlPreview,
  aH as SpectrePageHeading,
  sH as SpectrePageHeadingColumn,
  iH as SpectrePageHeadingTitle,
  lH as SpectrePaginationLinks,
  cH as SpectrePaginationMeta,
  uH as SpectrePair,
  pH as SpectrePairLabel,
  dH as SpectrePairValue,
  gH as SpectrePlaceholder,
  o0 as SpectrePopover,
  Cj as SpectrePreset,
  ZL as SpectrePreviewContainer,
  mH as SpectreProgress,
  fH as SpectreProgressCard,
  yH as SpectreProgressCardDescription,
  hH as SpectreProgressCardGroup,
  FH as SpectreProgressCardTitle,
  EN as SpectreRadio,
  bH as SpectreRadioField,
  vH as SpectreRadioGroup,
  BH as SpectreRadioGroupRadio,
  PH as SpectreSegmentedButton,
  wH as SpectreSegmentedButtonGroup,
  iN as SpectreSelect,
  kH as SpectreSettingCard,
  TN as SpectreSettingCardButton,
  DH as SpectreSettingCardGroup,
  SH as SpectreSettingCardPreview,
  AH as SpectreSettingCardTitle,
  EH as SpectreSettingGroup,
  xH as SpectreSettingGroupContent,
  CH as SpectreSettingGroupTitle,
  OH as SpectreSidebarLayout,
  TH as SpectreSidebarLayoutContent,
  LH as SpectreSidebarLayoutSidebar,
  jH as SpectreSimplePagination,
  MH as SpectreSmallBrandPreview,
  WH as SpectreSmallCardsRadioGroup,
  NH as SpectreSmallCardsRadioGroupOption,
  Yr as SpectreSpinner,
  bd as SpectreStack,
  VH as SpectreStat,
  zH as SpectreStatGroup,
  IH as SpectreStatPreviousValue,
  RH as SpectreStatTitle,
  HH as SpectreStatValue,
  YH as SpectreStatus,
  qH as SpectreStatusCircle,
  GH as SpectreStepModal,
  XH as SpectreStepperNavigation,
  UH as SpectreStreetLogo,
  ZH as SpectreSwitch,
  KH as SpectreSwitchField,
  QH as SpectreSwitchGroup,
  JH as SpectreSwitchGroupField,
  _H as SpectreTab,
  $H as SpectreTabGroup,
  sY as SpectreTabList,
  iY as SpectreTabPanel,
  lY as SpectreTabPanels,
  cY as SpectreTabSection,
  eY as SpectreTable,
  oY as SpectreTableBody,
  rY as SpectreTableData,
  tY as SpectreTableHead,
  nY as SpectreTableHeader,
  aY as SpectreTableRow,
  oo as SpectreText,
  dY as SpectreTextLink,
  uY as SpectreTextarea,
  pY as SpectreTextareaRichText,
  hz as SpectreToastGroup,
  gY as SpectreToggleButton,
  mY as SpectreToggleButtonGroup,
  vr as SpectreTouchTarget,
  bY as SpectreUseFileDialog,
  vY as SpectreUseToggle,
  fY as SpectreVerticalNavigationLink,
  yY as SpectreVerticalNavigationLinkGroup,
  Aa as SpectreWrap,
  Ea as SpectreWrapItem,
  hY as useCombobox,
  FY as useListbox,
  mh as useObjectUrlPreview,
  V8 as useStatus,
  Yb as useToasts,
  Up as vTooltip
};
